/**
 * Français.
 *
 * Les clés sont les phrases italiennes : voir `lingua.ts`. Une entrée
 * manquante retombe sur le texte italien, lisible — pas sur un identifiant.
 *
 * Traduction automatique initiale : à relire par un locuteur natif.
 */
export const fr: Record<string, string> = {
  // Inventario cloud/virtuale: titoli foglio e intestazioni colonna, via t().
  'Avviata': 'Démarrée',
  'Bilanciatori': 'Répartiteurs de charge',
  'Cifrata': 'Chiffrée',
  'Condiviso': 'Partagé',
  'DRS': 'DRS',
  'Firmware': 'Firmware',
  'Genere': 'Genre',
  'HA': 'HA',
  'HW': 'HW',
  'IP gestione': 'IP de gestion',
  'Libero (GB)': 'Libre (Go)',
  'NIC': 'NIC',
  'Provisioned (GB)': 'Provisionné (Go)',
  'Pubblica': 'Publique',
  'Pubblico': 'Public',
  'Security group': 'Groupe de sécurité',
  'Stato connessione': 'État de connexion',
  'Uplinks': 'Liens montants',
  'Vendor': 'Fournisseur',
  'Versioning': 'Gestion des versions',
  // Catalogo report (reports.py): titoli e descrizioni, via t().
  'Inventario per tipo e classe': 'Inventaire par type et classe',
  "Contenuto della CMDB, raggruppato per tipo e classe, con data dell'ultima rilevazione. Include gli host non gestiti, conteggiati separatamente.": 'Contenu de la CMDB, regroupé par type et classe, avec la date de la dernière détection. Inclut les hôtes non gérés, comptés séparément.',
  'Configuration item non registrati come beni': 'Configuration items non enregistrés comme biens',
  "Asset individuati dalla discovery e non ancora censiti nel registro dei beni. Gli host non gestiti sono esclusi perché classificati come rilevamenti. Rappresenta il backlog di riconciliazione dell'inventario.": 'Actifs détectés par la découverte et pas encore inscrits au registre des biens. Les hôtes non gérés sont exclus car classés comme relevés. Représente le backlog de réconciliation de l’inventaire.',
  'Registro dei beni': 'Registre des biens',
  'Beni censiti con proprietà, centro di costo, valore e stato della copertura contrattuale alla data corrente.': 'Biens enregistrés avec propriétaire, centre de coûts, valeur et état de la couverture contractuelle à la date courante.',
  'Beni senza contratto': 'Biens sans contrat',
  'Beni attivi o in manutenzione senza un contratto valido alla data corrente. Esclude i beni dismessi e alienati, non soggetti a copertura contrattuale.': 'Biens en service ou en maintenance sans contrat valide à la date courante. Exclut les biens retirés et aliénés, non soumis à la couverture contractuelle.',
  'Contratti in scadenza': 'Contrats arrivant à échéance',
  'Contratti in scadenza entro la finestra selezionata, inclusi quelli già scaduti. In caso di rinnovo tacito, considera come data rilevante il termine ultimo per la disdetta, non la scadenza contrattuale.': 'Contrats arrivant à échéance dans la fenêtre sélectionnée, y compris ceux déjà expirés. En cas de reconduction tacite, la date pertinente est la date limite de résiliation, pas l’échéance du contrat.',
  'Garanzie in scadenza': 'Garanties arrivant à échéance',
  'Beni con garanzia scaduta o in scadenza entro la finestra selezionata, esclusi quelli dismessi e alienati.': 'Biens dont la garantie est expirée ou arrive à échéance dans la fenêtre sélectionnée, hors biens retirés et aliénés.',
  'Valore per centro di costo': 'Valeur par centre de coûts',
  'Distribuzione del valore di acquisto per centro di costo, esclusi i beni alienati. I beni privi di centro di costo sono aggregati separatamente per mantenere la quadratura del totale.': 'Répartition de la valeur d’achat par centre de coûts, hors biens aliénés. Les biens sans centre de coûts sont agrégés séparément pour maintenir l’équilibre du total.',
  'Esito delle discovery': 'Résultat des découvertes',
  'Scansioni eseguite nella finestra selezionata, raggruppate per tipo, con esiti riusciti e falliti. Il tasso di successo è calcolato esclusivamente sui job conclusi.': 'Analyses exécutées dans la fenêtre sélectionnée, regroupées par type, avec les résultats réussis et échoués. Le taux de réussite est calculé uniquement sur les jobs terminés.',
  // Catalogo connettori (registry.catalog): etichette, help, reachability, placeholder, via t(variabile).
  'API Token': 'Jeton API',
  'API token (Cloud)': 'Jeton API (Cloud)',
  'Access token OAuth': 'Jeton d’accès OAuth',
  'Chiave tecnico': 'Clé du technicien',
  'Client ID OAuth': 'ID client OAuth',
  'Client secret OAuth': 'Secret client OAuth',
  "Email dell'utenza (Cloud)": 'E-mail du compte (Cloud)',
  'Installazione': 'Installation',
  'Modo di autenticazione': 'Mode d’authentification',
  'Percorso del servizio': 'Chemin du service',
  'Personal Access Token (Data Center)': 'Jeton d’accès personnel (Data Center)',
  'Schema di Assets gestito da CENSO': 'Schéma Assets géré par CENSO',
  'Stringa di autenticazione': 'Chaîne d’authentification',
  'Tipo di oggetto da creare': 'Type d’objet à créer',
  'Workspace di Assets (Cloud)': 'Espace de travail Assets (Cloud)',
  'SaaS: raggiungibile dal Control Plane senza aperture.': 'SaaS : joignable depuis le Control Plane sans ouverture de pare-feu.',
  'Esiste in versione cloud e in versione installata: nel secondo caso il Control Plane deve poterlo raggiungere.': 'Disponible en version cloud et installée : dans ce dernier cas, le Control Plane doit pouvoir l’atteindre.',
  'Spesso installato in azienda: il Control Plane deve poterlo raggiungere in HTTPS, oppure va pubblicato su un indirizzo esposto.': 'Souvent installé dans l’entreprise : le Control Plane doit pouvoir l’atteindre en HTTPS, ou il doit être publié sur une adresse exposée.',
  'Spesso installato in azienda: vale quanto detto per Matrix42.': 'Souvent installé dans l’entreprise : comme indiqué pour Matrix42.',
  'Jira Cloud è SaaS: raggiungibile dal Control Plane (anche api.atlassian.com, dove sta Assets). Jira Data Center è installato in azienda: il Control Plane deve poterlo raggiungere, oppure si passa da una sonda.': 'Jira Cloud est SaaS : joignable depuis le Control Plane (y compris api.atlassian.com, où se trouve Assets). Jira Data Center est installé dans l’entreprise : le Control Plane doit pouvoir l’atteindre, ou passer par une sonde.',
  'Da cambiare solo se in installazione è stato rinominato.': 'À modifier seulement s’il a été renommé lors de l’installation.',
  'Facoltativo: se vuoto si ricava dal sito. Serve solo se il sito ha più workspace.': 'Facultatif : si vide, il est déduit du site. Nécessaire uniquement si le site a plusieurs espaces de travail.',
  'I permessi della chiave sono quelli del tecnico che la possiede: una chiave di sola lettura fa fallire le scritture con un messaggio che parla di licenza, non di permessi.': 'Les droits de la clé sont ceux du technicien qui la détient : une clé en lecture seule fait échouer les écritures avec un message évoquant la licence, pas les droits.',
  'Il JWT generato in Amministrazione → Integrazioni → Web Services. Non è il token con cui si chiamano i dati: serve a ottenerlo.': 'Le JWT généré dans Administration → Intégrations → Web Services. Ce n’est pas le jeton avec lequel on appelle les données : il sert à l’obtenir.',
  'Il campo `authString` del login: serve solo con autenticazione esterna (LDAP/AD via AREA). Vuoto negli altri casi.': 'Le champ `authString` de la connexion : nécessaire uniquement avec une authentification externe (LDAP/AD via AREA). Vide sinon.',
  "Lo schema in cui CENSO scrive i CI: se non esiste lo crea (chiave uguale al nome, in maiuscolo), e dentro crea un tipo di oggetto per classe (Server, Switch, Virtual Machine…) con i suoi attributi. L'utenza deve poter amministrare gli schemi di Assets.": 'Le schéma où CENSO écrit les CI : s’il n’existe pas, il est créé (clé égale au nom, en majuscules), et à l’intérieur un type d’objet par classe (Server, Switch, Virtual Machine…) avec ses attributs. Le compte doit pouvoir administrer les schémas Assets.',
  "Serve solo per **creare**: in Matrix42 un asset è un oggetto di un tipo, composto da più frammenti, e i frammenti come `SPSAssetClassBase` da soli non si creano. Qui va il tipo, che dipende dall'istanza: CENSO crea l'oggetto di quel tipo con dentro il frammento a cui la corrispondenza punta. Lasciandolo vuoto si aggiornano gli oggetti esistenti e la creazione dice che cosa manca, invece di crearne del tipo sbagliato.": 'Nécessaire uniquement pour **créer** : dans Matrix42, un actif est un objet d’un type, composé de plusieurs fragments, et des fragments comme `SPSAssetClassBase` ne se créent pas seuls. Indiquez ici le type, qui dépend de l’instance : CENSO crée l’objet de ce type contenant le fragment visé par la correspondance. Laissé vide, les objets existants sont mis à jour et la création indique ce qui manque, au lieu d’en créer du mauvais type.',
  "Solo Cloud: l'email dell'utenza Atlassian che possiede il token. Deve avere accesso agli schemi di Assets da sincronizzare.": 'Cloud uniquement : l’e-mail du compte Atlassian qui détient le jeton. Il doit avoir accès aux schémas Assets à synchroniser.',
  'Solo Cloud: si crea su id.atlassian.com → Sicurezza → Crea e gestisci i token API.': 'Cloud uniquement : à créer sur id.atlassian.com → Sécurité → Créer et gérer les jetons API.',
  "Solo Data Center: Profilo → Personal Access Tokens. I permessi sono quelli dell'utenza che lo crea.": 'Data Center uniquement : Profil → Personal Access Tokens. Les droits sont ceux du compte qui le crée.',
  'Solo per il modo `basic`.': 'Uniquement pour le mode `basic`.',
  'Solo per la versione cloud (`Zoho-oauthtoken`).': 'Uniquement pour la version cloud (`Zoho-oauthtoken`).',
  "Solo se l'istanza impone OAuth. Lasciato vuoto, si usa l'autenticazione di base.": 'Uniquement si l’instance impose OAuth. Laissé vide, l’authentification de base est utilisée.',
  'Utenza AR System. Le serve il permesso di lettura sui moduli da sincronizzare; per scrivere, anche quello di modifica — che in Remedy si concede per **campo**, non per modulo.': 'Compte AR System. Il lui faut le droit de lecture sur les modules à synchroniser ; pour écrire, aussi le droit de modification — qui, dans Remedy, s’accorde par **champ**, pas par module.',
  'Utenza di integrazione. Le serve il ruolo di lettura sulle tabelle da sincronizzare, più `personalize_dictionary` o `admin` per leggere i metadati in `sys_dictionary`: senza, la scansione trova le tabelle e non i campi.': 'Compte d’intégration. Il lui faut le rôle de lecture sur les tables à synchroniser, plus `personalize_dictionary` ou `admin` pour lire les métadonnées dans `sys_dictionary` : sans cela, l’analyse trouve les tables mais pas les champs.',
  "`api_token` (consigliato dal produttore) oppure `basic`. Con `api_token` si incolla il token generato dall'amministrazione: CENSO lo scambia da sé con l'access token a ogni sessione.": '`api_token` (recommandé par l’éditeur) ou `basic`. Avec `api_token`, on colle le jeton généré dans l’administration : CENSO l’échange lui-même contre le jeton d’accès à chaque session.',
  '`cloud` per Jira Cloud (sito `…atlassian.net`), `datacenter` per Jira Data Center / Server installato in azienda.': '`cloud` pour Jira Cloud (site `…atlassian.net`), `datacenter` pour Jira Data Center / Server installé dans l’entreprise.',
  "`technician_key` per l'installazione on-premise (la chiave si genera dal profilo del tecnico), `oauth` per la versione cloud.": '`technician_key` pour l’installation sur site (la clé se génère depuis le profil du technicien), `oauth` pour la version cloud.',
  'CENSO': 'CENSO',
  'M42Services': 'M42Services',
  'SPSAssetTypeNetworkDevice': 'SPSAssetTypeNetworkDevice',
  'api_token': 'api_token',
  'technician_key': 'technician_key',
  // Metodi/parametri dei piani di discovery (discovery/steps.py), via t(label).
  'Ping (ICMP)': 'Ping (ICMP)',
  'Risoluzione DNS': 'Résolution DNS',
  'Scansione porte TCP': 'Analyse des ports TCP',
  'Interrogazione SNMP': 'Interrogation SNMP',
  'SNMP approfondito': 'SNMP approfondi',
  'Adiacenze CDP/LLDP': 'Adjacences CDP/LLDP',
  'Interrogazione SSH': 'Interrogation SSH',
  'Interrogazione Windows (WinRM)': 'Interrogation Windows (WinRM)',
  'Identità SMB': 'Identité SMB',
  'Scansione personalizzata': 'Analyse personnalisée',
  'Registro di sistema remoto': 'Registre système distant',
  'Interrogazione Windows (WMI/DCOM)': 'Interrogation Windows (WMI/DCOM)',
  'Attesa per porta (ms)': 'Délai par port (ms)',
  'Porte in parallelo': 'Ports en parallèle',
  'Cifratura TLS': 'Chiffrement TLS',
  'Identità del sistema': 'Identité du système',
  'Aggiornamenti installati': 'Mises à jour installées',
  'Stampanti collegate': 'Imprimantes connectées',
  'Utenti connessi': 'Utilisateurs connectés',
  // Etichette della tassonomia CI (classi e categorie), mostrate via t(label).
  'Calcolo': 'Calcul',
  'Archiviazione': 'Stockage',
  'Basi dati': 'Bases de données',
  'Cloud — calcolo': 'Cloud — calcul',
  'Cloud — archiviazione': 'Cloud — stockage',
  'Cloud — rete': 'Cloud — réseau',
  'Cloud — dati': 'Cloud — données',
  'Cloud — integrazione': 'Cloud — intégration',
  'Cloud — account': 'Cloud — compte',
  'Periferiche': 'Périphériques',
  'Parti': 'Pièces',
  'Switch': 'Commutateur',
  'Router': 'Routeur',
  'Controller wireless': 'Contrôleur sans fil',
  'Access point': "Point d'accès",
  'Trasporto ottico': 'Transport optique',
  'Sistema di storage': 'Système de stockage',
  'Subnet pubblica': 'Sous-réseau public',
  'Host hypervisor': 'Hyperviseur hôte',
  'Host non gestito': 'Hôte non géré',
  'Macchina virtuale': 'Machine virtuelle',
  'Port group': 'Groupe de ports',
  'Workload Kubernetes': 'Charge de travail Kubernetes',
  'Servizio Kubernetes': 'Service Kubernetes',
  'Ingress Kubernetes': 'Ingress Kubernetes',
  'Commutatore virtuale': 'Commutateur virtuel',
  'Servizio container': 'Service de conteneurs',
  'Gruppo di scalabilità': "Groupe de mise à l'échelle",
  'Archivio oggetti': "Stockage d'objets",
  'Volume a blocchi': 'Volume en mode bloc',
  'Condivisione file': 'Partage de fichiers',
  'Rete virtuale': 'Réseau virtuel',
  'Bilanciatore gestito': 'Répartiteur de charge géré',
  'Gateway': 'Passerelle',
  'Zona DNS': 'Zone DNS',
  'Istanza di base dati': 'Instance de base de données',
  'Base dati relazionale': 'Base de données relationnelle',
  'Base dati NoSQL': 'Base de données NoSQL',
  'Cache': 'Cache',
  'Coda': "File d'attente",
  'Topic di notifica': 'Rubrique de notification',
  'API gateway': 'Passerelle API',
  'Account cloud': 'Compte cloud',
  'Stampante': 'Imprimante',
  'Telecamera IP': 'Caméra IP',
  'Telefono VoIP': 'Téléphone VoIP',
  'Apparecchio elettromedicale': 'Dispositif médical',
  'Dominio Active Directory': 'Domaine Active Directory',
  'Monitor': 'Écran',
  'Non classificato': 'Non classé',
  'Temperature dai sensori dell’appliance': 'Températures des capteurs de l’appliance',
  'Temperature': 'Températures',
  'Appliance CensoOS: la sonda di cattura dal filo': 'Appliance CensoOS : la sonde de capture sur le fil',
  'Censo Appliance': 'Censo Appliance',
  'Il riepilogo compare quando c’è almeno un agente.': 'Le récapitulatif apparaît lorsqu’il y a au moins un agent.',
  'Percorsi software': 'Chemins logiciels',
  'La pagina apre con un riepilogo (agenti per stato e quante macchine hanno ciascuna feature) e con le personalizzazioni dei percorsi software in alto; l’elenco ha colonne filtrabili — OS e «Features attive» comprese — a pagine da 25 o 100. Selezionando più agenti (anche tutti i risultati filtrati) una barra applica in blocco le features e la manutenzione. Un agente nasce senza feature attive: SBOM, Runtime, eBPF e Ascolto DHCP si accendono quando servono.': 'La page s’ouvre sur un récapitulatif (agents par état et combien de machines ont chaque fonctionnalité) et sur les personnalisations des chemins logiciels en haut ; la liste a des colonnes filtrables — dont OS et «Features attive» — par pages de 25 ou 100. En sélectionnant plusieurs agents (même tous les résultats filtrés), une barre applique en masse les fonctionnalités et la maintenance. Un agent naît sans fonctionnalité active : SBOM, Runtime, eBPF et écoute DHCP s’activent au besoin.',
  '{n} agenti selezionati': '{n} agents sélectionnés',
  'disattiva': 'désactiver',
  'agenti': 'agents',
  'Ultima consegna rifiutata': 'Dernière remise refusée',
  'Seleziona tutti i risultati filtrati': 'Sélectionner tous les résultats filtrés',
  'Seleziona': 'Sélectionner',
  'Revocati': 'Révoqués',
  'Installati': 'Installés',
  'Features attive': 'Fonctionnalités actives',
  'Ambito di raccolta': 'Périmètre de collecte',
  'Filtri per colonna': "Filtres par colonne",
  // Réseau · composants et IP
  'Indirizzi IP': "Adresses IP",
  'IP pubblico': "IP publique",
  'Indirizzo aggiuntivo': "Adresse supplémentaire",
  'Nessun indirizzo': "Aucune adresse",
  'Gli indirizzi aggiuntivi e pubblici compaiono qui man mano che le scansioni li rilevano sugli apparati e sugli host.':
    "Les adresses supplémentaires et publiques apparaissent ici au fur et à mesure que les analyses les détectent sur les équipements et les hôtes.",
  'Transceiver, schede, alimentatori e ventole compaiono qui quando una scansione SNMP legge le parti inserite negli apparati.':
    "Les transceivers, cartes, alimentations et ventilateurs apparaissent ici lorsqu'une analyse SNMP lit les pièces installées dans les équipements.",
  // Liste CI · tableau de bord
  'CI totali': "CI au total",
  'nessun nuovo negli ultimi 7 giorni': "aucun nouveau au cours des 7 derniers jours",
  'Non classificati': "Non classés",
  'Filtra i non classificati': "Filtrer les non classés",
  'un connettore produce qualcosa di nuovo': "un connecteur produit quelque chose de nouveau",
  'CI con rischi aperti': "CI avec des constats ouverts",
  'Vai alla sicurezza': "Aller à la sécurité",
  'nessun rischio aperto': "aucun constat ouvert",
  'Non visti da 7 giorni': "Non vus depuis 7 jours",
  'candidati a una verifica: spenti, o non più raggiunti':
    "candidats à une vérification : éteints, ou plus atteints",
  'Per categoria': "Par catégorie",
  'Come sono stati scoperti': "Comment ils ont été découverts",
  'Nessun dato': "Aucune donnée",
  // Job · réessayer
  'Ritenta': "Réessayer",
  'Rilancio…': "Relance…",
  'Job rilanciato: riparte con la stessa configurazione.':
    "Job relancé : il redémarre avec la même configuration.",
  // Discovery · analyser et optimiser
  'Ottimizza discovery': "Optimiser la découverte",
  'Analizza e ottimizza discovery': "Analyser et optimiser la découverte",
  'Analisi…': "Analyse…",
  'Ancora niente da ottimizzare': "Rien à optimiser pour l’instant",
  'Servono asset già in CMDB con un indirizzo di gestione: fai una prima scansione, poi torna qui.':
    "Il faut des actifs déjà dans la CMDB avec une adresse de gestion : lancez une première analyse, puis revenez.",
  'Analizza la provenienza dei dati in CMDB per creare job puntuali sugli indirizzi già rilevati come attivi, raggruppati per origine. Evidenzia inoltre gli asset acquisiti da più scansioni, così da individuare sovrapposizioni nel perimetro di discovery.':
    "À partir de la provenance déjà dans la CMDB : au lieu de scanner tout un sous-réseau, un job ciblé sur les seules adresses qui répondent, regroupées par la façon dont elles ont été découvertes. Et les actifs vus par plusieurs analyses, ce qui est du travail en double.",
  'Nessun gruppo puntuale da proporre: gli asset non provengono da metodi di rete indirizzabili.':
    "Aucun groupe ciblé à proposer : les actifs ne proviennent pas de méthodes réseau adressables.",
  'Copia indirizzi': "Copier les adresses",
  'Copiati': "Copiées",
  // Discovery · balayage intelligent
  'Salta gli indirizzi già coperti da altre discovery':
    "Ignorer les adresses déjà couvertes par d’autres découvertes",
  'Gli indirizzi già in CMDB o già bersaglio di un altro job vengono verificati vivi ma non ri-scansionati a fondo, e il rapporto dice da dove sono coperti. Utile su una subnet larga che si sovrappone ad altri job.':
    "Les adresses déjà dans la CMDB ou déjà ciblées par un autre job sont vérifiées comme actives mais pas re-analysées en profondeur, et le rapport indique d’où elles sont couvertes. Utile sur un grand sous-réseau qui recoupe d’autres jobs.",
  // CI · onglet Provenance
  'Provenienza': "Provenance",
  'Ultima sonda': "Dernière sonde",
  'Ultimo job': "Dernier job",
  'Fonti': "Sources",
  'Fonte': "Source",
  'Job': "Job",
  'primaria': "primaire",
  'Nessuna fonte registrata': "Aucune source enregistrée",
  'CI creato a mano o prima che si tracciasse la provenienza.':
    "CI créé à la main, ou avant le suivi de la provenance.",
  'Job che l’hanno toccato': "Jobs qui l’ont touché",
  'Provenienza per attributo': "Provenance par attribut",
  'Mostra tutti': "Tout afficher",
  'in attesa': "en attente",
  'in cattura': "en capture",
  'non partita': "non démarrée",
  'Ciò che la raccolta non ha potuto leggere, dichiarato invece che taciuto: un campo assente qui è «non letto», non «non esiste». È l’ultima fotografia, non un registro — lo stesso dato non si accumula a ogni scansione.': "Ce que la collecte n’a pas pu lire, déclaré plutôt que passé sous silence : un champ absent ici est « non lu », non pas « inexistant ». C’est le dernier instantané, non un journal — la même donnée ne s’accumule pas à chaque analyse.",
  'Dati non letti': "Données non lues",
  'Sezione': "Section",
  '1 ogni 10': "1 sur 10",
  '1 ogni 100': "1 sur 100",
  '1 ogni 2': "1 sur 2",
  '1 ogni 30': "1 sur 30",
  'Campionamento di {ind}': "Échantillonnage de {ind}",
  'Non salvato': "Non enregistré",
  'tieni tutto': "tout conserver",
  '30 giorni': "30 jours",
  '7 giorni': "7 jours",
  '90 giorni': "90 jours",
  'Attivi': "Actifs",
  'Comparsi (7g)': "Apparus (7 j)",
  'Comparsi di recente': "Apparus récemment",
  'Comparsi e scomparsi per giorno': "Apparus et disparus par jour",
  'Cosa compare e cosa non si trova più, nel tempo': "Ce qui apparaît et ce qui ne se trouve plus, au fil du temps",
  'Nessun CI nuovo nel periodo.': "Aucun CI nouveau sur la période.",
  'Nessun cambiamento nel periodo.': "Aucun changement sur la période.",
  'Niente è sparito: buon segno.': "Rien n’a disparu : bon signe.",
  'Non più trovati': "Plus trouvés",
  'Non più trovati (7g)': "Plus trouvés (7 j)",
  'Periodo': "Période",
  'Silenti (stale)': "Silencieux (stale)",
  'Statistiche scansioni': "Statistiques des analyses",
  'dismesso': "mis hors service",
  'non trovato': "non trouvé",
  'Cerca ovunque': "Rechercher partout",
  'Cerca ovunque (⌘K)': "Rechercher partout (⌘K)",
  'Componenti (schede, moduli, seriali)': "Composants (cartes, modules, numéros de série)",
  'Nessun risultato per «{q}».': "Aucun résultat pour « {q} ».",
  'Rete (IP, MAC, porte)': "Réseau (IP, MAC, ports)",
  'Ricerca globale': "Recherche globale",
  'Software': "Logiciels",
  'altri…': "autres…",
  'Configura una sonda nella rete da monitorare.': 'Configurez une sonde dans le réseau à surveiller.',
  'Avvia il primo job di discovery: i Configuration Item rilevati vengono registrati nell’Inventario.': 'Lancez le premier job de découverte : les Configuration Items détectés sont enregistrés dans l’Inventaire.',
  'Benvenuto in CENSO': "Bienvenue dans CENSO",
  'CENSO rileva automaticamente gli asset presenti in rete, individua le funzionalità e mantiene aggiornate le informazioni.': 'CENSO détecte automatiquement les actifs présents sur le réseau, identifie leurs fonctions et tient les informations à jour.',
  'Comunicazioni tra asset, servizi esposti e dati scambiati (con NetFlow attivo).': 'Communications entre actifs, services exposés et données échangées (avec NetFlow activé).',
  'Configura un piano di discovery definendo target e modalità di scansione.': 'Configurez un plan de découverte en définissant les cibles et les modalités d’analyse.',
  'Centralizza Configuration Item, Asset e Contratti, consolida i dati tecnici acquisiti e li aggiorna mediante discovery.': 'Centralise les Configuration Items, Actifs et Contrats, consolide les données techniques recueillies et les met à jour par la découverte.',
  'Da dove si comincia': "Par où commencer",
  'Configurazione di sonde, credenziali, piani di discovery, job e relative pianificazioni.': 'Configuration des sondes, identifiants, plans de découverte, jobs et leurs planifications.',
  'Visualizza asset, interfacce di rete e topologia delle connessioni.': 'Affiche les actifs, les interfaces réseau et la topologie des connexions.',
  'Mappa i servizi, le dipendenze degli asset e ne evidenzia gli impatti in caso di indisponibilità.': 'Cartographie les services, les dépendances des actifs et met en évidence les impacts en cas d’indisponibilité.',
  'Configura le credenziali di accesso: SNMP, SSH e WinRM.': 'Configurez les identifiants d’accès : SNMP, SSH et WinRM.',
  'Integrazione e scambio dati con piattaforme ITSM come ServiceNow, Matrix42, Remedy e ManageEngine.': 'Intégration et échange de données avec des plateformes ITSM telles que ServiceNow, Matrix42, Remedy et ManageEngine.',
  'Postura di sicurezza degli host, conformità NIS2 e DORA, monitoraggio tramite Dobermann e Honeypot.': 'Posture de sécurité des hôtes, conformité NIS2 et DORA, surveillance via Dobermann et Honeypot.',
  'Rete e topologia': "Réseau et topologie",
  'Salta': "Passer",
  'Gestione utenti, impostazioni, riconoscimento degli asset e audit di accessi e modifiche.': 'Gestion des utilisateurs, paramètres, reconnaissance des actifs et audit des accès et des modifications.',
  'es. esca DMZ': "ex. leurre DMZ",
  'Dove l’agent consegna gli hit: il Control Plane (cloud) o una sonda che li inoltra. Il ritorno al Control Plane è automatico se la sonda non risponde.': "Où l’agent livre les hits : le Control Plane (cloud) ou une sonde qui les relaie. Le retour au Control Plane est automatique si la sonde ne répond pas.",
  'chi è entrato e chi ha cambiato cosa. Gli accessi (login riusciti e falliti, cambio tenant) e le operazioni (creazioni, modifiche, cancellazioni) in un elenco solo, filtrabile per tipo e testo. È la prima cosa da guardare dopo un sospetto, e la vista che un auditor chiede per prima.': "qui s’est connecté et qui a modifié quoi. Les accès (connexions réussies et échouées, changement de tenant) et les opérations (créations, modifications, suppressions) dans une seule liste, filtrable par type et par texte. C’est la première chose à regarder après un soupçon, et la vue qu’un auditeur demande en premier.",
  'Accessi': "Accès",
  'Audit / Log': "Audit / Journal",
  'Cerca negli eventi': "Rechercher dans les événements",
  'Cerca per email, IP, oggetto…': "Rechercher par e-mail, IP, objet…",
  'Chi': "Qui",
  'Registro attività: traccia gli accessi e le operazioni eseguite nel tenant.': 'Journal d’activité : trace les accès et les opérations effectuées dans le tenant.',
  'Eventi': "Événements",
  'Gli accessi e le operazioni compaiono qui man mano che avvengono.': "Les accès et les opérations apparaissent ici à mesure qu’ils se produisent.",
  'Operazioni': "Opérations",
  'Per pagina': "Par page",
  'Precedenti': "Précédents",
  'Registro accessi': "Journal des accès",
  'Successivi': "Suivants",
  'accesso': "accès",
  'accesso fallito': "accès échoué",
  'cambio tenant': "changement de tenant",
  'codice MFA errato': "code MFA erroné",
  'errore': "erreur",
  'ok': "ok",
  'operazione': "opération",
  'respinto': "rejeté",
  'sconosciuto': "inconnu",
  '{da}–{a} di {total}': "{da}–{a} sur {total}",
  'Honeypot': "Honeypot",
  'il guardiano di Censo: rileva gli oggetti non censiti nella tua rete correlando inventario, scansioni e netflow. Dichiari le subnet da proteggere e un giro periodico incrocia il traffico con la CMDB — un indirizzo attivo mai censito diventa un avvistamento, con «Ispeziona» per capire con chi parla. Quando l’indirizzo compare in inventario, l’avvistamento passa da solo a «censito». Se togli o restringi una subnet, i suoi avvistamenti escono dall’elenco; gli amministratori possono anche azzerare tutto l’elenco con «Azzera avvistamenti».':
    'le gardien de Censo : il détecte les objets non recensés dans votre réseau en corrélant inventaire, analyses et netflow. Vous déclarez les sous-réseaux à protéger et un cycle périodique croise le trafic avec la CMDB — une adresse active jamais recensée devient un signalement, avec « Inspecter » pour comprendre avec qui elle parle. Lorsque l’adresse apparaît dans l’inventaire, le signalement passe de lui-même à « recensé ». Si vous retirez ou réduisez un sous-réseau, ses observations sortent de la liste ; les administrateurs peuvent aussi vider toute la liste avec «Réinitialiser les observations».',
  'agent esca autonomi. Registri un agent, scegli i servizi da fingere (SSH, RDP, SMB…) e dove consegna; ne esce un file di configurazione col segreto, da mettere accanto al binario su una macchina dedicata. È isolato dalla discovery di proposito: chi compromette l’esca non trova le credenziali del parco. Ogni connessione a un servizio esca è, per costruzione, sospetta — e finisce negli hit, con il payload catturato.': "agents leurres autonomes. Vous enregistrez un agent, choisissez les services à simuler (SSH, RDP, SMB…) et l’endroit où il livre ; il en résulte un fichier de configuration avec le secret, à placer à côté du binaire sur une machine dédiée. Il est isolé de la découverte à dessein : qui compromet le leurre ne trouve pas les identifiants du parc. Toute connexion à un service leurre est, par construction, suspecte — et finit dans les hits, avec le payload capturé.",
  'Agent': "Agent",
  'Agent attivi': "Agents actifs",
  'Agent esca autonomi espongono servizi esca per rilevare tentativi di connessione inattesi o potenzialmente ostili.': 'Des agents leurres autonomes exposent des services leurres pour détecter les tentatives de connexion inattendues ou potentiellement hostiles.',
  'Agent honeypot': "Agent honeypot",
  'Agent «{nome}» registrato': "Agent « {nome} » enregistré",
  'Attiva {servizio}': "Activer {servizio}",
  'Banner di {servizio}': "Bannière de {servizio}",
  'Consegna ogni (minuti)': "Livraison toutes les (minutes)",
  'IP da ignorare (opzionale)': 'IP à ignorer (facultatif)',
  'sì': 'oui',
  'no': 'non',
  'Campione della sessione (per l’analisi)': 'Échantillon de la session (pour l’analyse)',
  'Scadenza predefinita salvata per i prossimi inviti.': 'Expiration par défaut enregistrée pour les prochaines invitations.',
  'Durata predefinita per il tenant: {ore} ore. Trascorso questo intervallo, il collegamento scade e non è più utilizzabile.':
    'Défaut du locataire : {ore} heures. Ensuite le lien ne fonctionne plus.',
  'Salva come predefinito': 'Enregistrer par défaut',
  'Come dare accesso': "Comment donner l'accès",
  'Invita via email (la password la sceglie lui)': 'Inviter par e-mail (il choisit le mot de passe)',
  'Imposta una password': 'Définir un mot de passe',
  'Scadenza invito (ore)': "Expiration de l'invitation (heures)",
  'Dopo, il collegamento non vale più e serve un nuovo invito.': 'Après quoi le lien ne fonctionne plus et une nouvelle invitation est nécessaire.',
  'Invita utente': "Inviter l'utilisateur",
  'Crea utente': "Créer l'utilisateur",
  'Attendere…': 'Veuillez patienter…',
  'Utenza creata.': 'Compte créé.',
  'Invito inviato a {email}.': 'Invitation envoyée à {email}.',
  'Eseguito da': 'Exécuté depuis',
  'Architettura CPU': 'Architecture CPU',
  'Raccolto da': 'Collecté par',
  'Raccolto via': 'Collecté via',
  'Virtualizzazione rilevata da': 'Virtualisation détectée par',
  'Pacchetti gestiti': 'Paquets gérés',
  'Edizione': 'Édition',
  'Livello di patch': 'Niveau de correctif',
  'Nome del database': 'Nom de la base de données',
  'Riferimento database': 'Référence de la base',
  'Info': 'Info',
  'Avviso': 'Avertissement',
  'Errore': 'Erreur',
  'CI ricevuti': 'CI reçus',
  'CI salvati': 'CI enregistrés',
  'Scartati senza chiave': 'Écartés sans clé',
  'Rifiutati per quota': 'Rejetés pour quota',
  'Relazioni ricevute': 'Relations reçues',
  'Relazioni risolte': 'Relations résolues',
  'Batch ricevuti': 'Lots reçus',
  'IP': 'IP',
  'passo': 'étape',
  'tipo': 'type',
  'indirizzi nell’ambito': 'adresses dans le périmètre',
  'eseguito su': 'exécuté sur',
  'riusciti': 'réussis',
  'falliti': 'échoués',
  'saltati per condizione': 'ignorés par condition',
  'passo sconosciuto alla sonda': 'étape inconnue de la sonde',
  'attributi raccolti': 'attributs collectés',
  'interfacce raccolte': 'interfaces collectées',
  'adiacenze raccolte': 'adjacences collectées',
  'indirizzi arricchiti': 'adresses enrichies',
  'oggetti raccolti': 'objets collectés',
  'nuovi': 'nouveaux',
  'già noti': 'déjà connus',
  'per classe': 'par classe',
  'prodotti software': 'produits logiciels',
  'schede macchina': 'cartes machine',
  'adiacenze': 'adjacences',
  'risponde al ping': 'répond au ping',
  'esito': 'résultat',
  'causa probabile': 'cause probable',
  'proprietà': 'propriétés',
  'proprietà per risorsa': 'propriétés par ressource',
  'interfacce': 'interfaces',
  'indirizzi IP': 'adresses IP',
  'vicinati': 'voisinages',
  'identificativi': 'identifiants',
  'non leggibili': 'illisibles',
  'credenziale': 'identifiant',
  'credenziali provate': 'identifiants essayés',
  'durata': 'durée',
  'approfondita': 'approfondie',
  'per tipo': 'par type',
  'senza nome': 'sans nom',
  'numero': 'numéro',
  'omessi': 'omis',
  'interrogazioni parallele': 'requêtes parallèles',
  'core della sonda': 'cœurs de la sonde',
  'deciso da': 'décidé par',
  'pacchetti/s richiesti': 'paquets/s demandés',
  'pacchetti/s effettivi': 'paquets/s effectifs',
  'attesa per interrogazione': 'attente par requête',
  'massimo per questa sonda': 'maximum pour cette sonde',
  'servirebbero': 'il faudrait',
  'dimensionamento automatico': 'dimensionnement automatique',
  'impostato nel job': 'défini dans le job',
  'tetto della sonda': 'plafond de la sonde',
  'Indirizzo mai censito': 'Adresse jamais inventoriée',
  "Connessione a un'esca": 'Connexion à un leurre',
  'es. 10.0.0.5, 192.168.1.0/24': 'ex. 10.0.0.5, 192.168.1.0/24',
  'Le connessioni da questi indirizzi non diventano hit: la sonda stessa, i sistemi di monitoraggio, gli scanner autorizzati. IP singoli o CIDR, separati da virgola o a capo.':
    "Les connexions depuis ces adresses ne deviennent jamais des hits : la sonde elle-même, les systèmes de supervision, les scanners autorisés. IP simples ou CIDR, séparés par une virgule ou un retour à la ligne.",
  'Copia il file': "Copier le fichier",
  'Copiato': "Copié",
  'Eliminare questo agent honeypot? Il segreto smette di valere e non consegnerà più.': "Supprimer cet agent honeypot ? Le secret cesse d’être valide et il ne livrera plus.",
  'Esche in ascolto': "Leurres à l’écoute",
  'Impostazioni e notifiche': "Paramètres et notifications",
  'Notifiche e marchio delle email': "Notifications et marque des e-mails",
  'Come si presentano le email che la piattaforma manda — avvisi honeypot e Dobermann, inviti, messaggi di prova. Il canale d’invio si configura sopra, in «Posta in uscita».': "L’apparence des e-mails que la plateforme envoie — alertes honeypot et Dobermann, invitations, messages de test. Le canal d’envoi se configure au-dessus, dans « Courrier sortant ».",
  'Nome del prodotto': "Nom du produit",
  'Colore del marchio': "Couleur de la marque",
  'Colore scuro (gradiente)': "Couleur sombre (dégradé)",
  'Payoff (sotto la firma)': "Slogan (sous la signature)",
  'Email di supporto (facoltativa)': "E-mail d’assistance (facultatif)",
  'Lingua delle email': "Langue des e-mails",
  'supporto@azienda.it': "support@entreprise.fr",
  'Per vedere il risultato, manda un messaggio di prova da «Posta in uscita».': "Pour voir le résultat, envoyez un message de test depuis « Courrier sortant ».",
  'Marchio salvato: vale per tutte le email.': "Marque enregistrée : elle s’applique à tous les e-mails.",
  'Statistiche': "Statistiques",
  'LUN': "LUN",
  'Dischi, pool e LUN con le capacità arrivano dall’inventario «Huawei OceanStor» (REST): lancia quella discovery su questo array.':
    "Les disques, pools et LUN avec leurs capacités proviennent de l'inventaire « Huawei OceanStor » (REST) : lancez cette découverte sur cette baie.",
  'Usata': "Utilisée",
  'Uso': "Utilisation",
  'Mappature (LUN → host)': "Mappages (LUN → hôte)",
  'Gruppo LUN': "Groupe de LUN",
  'Gruppo host': "Groupe d’hôtes",
  'Gruppo porte': "Groupe de ports",
  'Certificato PDF': "Certificat PDF",
  'Campionamento SNMP': "Échantillonnage SNMP",
  'La cattura dell’albero MIB serve a generare un driver di arricchimento.': "La capture de l’arbre MIB sert à générer un pilote d’enrichissement.",
  'Scarico…': "Téléchargement…",
  'Scarica cattura (JSON)': "Télécharger la capture (JSON)",
  'Cattura non ancora disponibile: il job deve completare il campionamento.': "Capture pas encore disponible : la tâche doit terminer l’échantillonnage.",
  'Pool di storage': "Pools de stockage",
  'Elenco dischi': "Liste des disques",
  'Elenco pool': "Liste des pools",
  'Elenco LUN': "Liste des LUN",
  'Un host (o IP) per istanza, separati da virgola. Aggiungi «:porta» per più istanze sullo stesso host — senza porta si usa quella standard del motore.': "Un hôte (ou IP) par instance, séparés par une virgule. Ajoutez « :port » pour plusieurs instances sur le même hôte — sans port, celui par défaut du moteur est utilisé.",
  'hit': "hits",
  'Hit nel periodo': "Hits sur la période",
  'Hit (7g)': "Hits (7 j)",
  'Con credenziali': "Avec identifiants",
  'Hit per giorno': "Hits par jour",
  'Per servizio esca': "Par service leurre",
  'Sorgenti più attive': "Sources les plus actives",
  'Nessun hit nel periodo.': "Aucun hit sur la période.",
  'Nessuna sorgente nel periodo.': "Aucune source sur la période.",
  'Avvisami via email quando qualcuno si connette a un’esca': "M’avertir par e-mail lorsque quelqu’un se connecte à un leurre",
  'Avvisa solo per gli hit che hanno catturato credenziali': "N’avertir que pour les hits ayant capturé des identifiants",
  'Taglia il rumore dei port scan che si connettono e non inviano niente. L’hit resta comunque registrato: cambia solo se parte la mail.': "Réduit le bruit des scans de ports qui se connectent sans rien envoyer. Le hit reste tout de même enregistré : seul l’envoi de l’e-mail change.",
  'Nessun destinatario configurato: aggiungilo in Impostazioni → Posta in uscita, o l’avviso non arriva a nessuno.': "Aucun destinataire configuré : ajoutez-le dans Paramètres → Courrier sortant, sans quoi l’alerte n’arrive à personne.",
  'Nuovi nel periodo': "Nouveaux sur la période",
  'Nuovi (7g)': "Nouveaux (7 j)",
  'Censiti': "Recensés",
  'Nuovi avvistamenti per giorno': "Nouveaux signalements par jour",
  'Nessun avvistamento nel periodo.': "Aucun signalement sur la période.",
  'Per subnet sorvegliata': "Par sous-réseau surveillé",
  'Nessun avvistamento.': "Aucun signalement.",
  'I più parlanti': "Les plus bavards",
  'Nessun avvistamento attivo.': "Aucun signalement actif.",
  'Avvisami via email sui nuovi avvistamenti': "M’avertir par e-mail des nouveaux signalements",
  'Avvisa solo sopra questa soglia di flussi': "N’avertir qu’au-dessus de ce seuil de flux",
  '0 = avvisa per tutti. Alzala per ignorare il pacchetto vagante singolo (un device mal configurato che sonda una volta). L’avvistamento resta comunque registrato.': "0 = avertir pour tous. Augmentez-le pour ignorer le paquet isolé et errant (un équipement mal configuré qui sonde une fois). Le signalement reste tout de même enregistré.",
  'cattura la connessione, non le credenziali (cifrate)': "capture la connexion, non les identifiants (chiffrés)",
  'Payload catturato': "Payload capturé",
  'Clic per il payload completo': "Cliquez pour le payload complet",
  '(vuoto: connessione senza dati inviati — spesso uno scanner di porte)': "(vide : connexion sans données envoyées — souvent un scanner de ports)",
  'Su Linux (root)': "Sous Linux (root)",
  'Scarica il binario, scrive la configurazione a 0600 e installa il servizio (systemd) che tiene l’esca in ascolto e la riavvia se cade.': "Télécharge le binaire, écrit la configuration en 0600 et installe le service (systemd) qui maintient le leurre à l’écoute et le redémarre s’il tombe.",
  'Copia il comando': "Copier la commande",
  'Le modifiche valgono al prossimo file scaricato: rigenera il segreto per prendere il file aggiornato, o modifica il file sulla macchina a mano.': "Les modifications s’appliquent au prochain fichier téléchargé : régénérez le secret pour obtenir le fichier à jour, ou modifiez le fichier sur la machine à la main.",
  'Nessun agent honeypot': "Aucun agent honeypot",
  'Nessuna esca in ascolto': "Aucun leurre à l’écoute",
  'Nuovo agent honeypot': "Nouvel agent honeypot",
  'Nuovo segreto per «{nome}»': "Nouveau secret pour « {nome} »",
  'Porta di {servizio}': "Port de {servizio}",
  'Registra e genera la configurazione': "Enregistrer et générer la configuration",
  'Registra un agent honeypot': "Enregistrer un agent honeypot",
  'Registra un agent, comparirà nell’elenco e inizierà a inviare i rilevamenti non appena installato.': 'Enregistrez un agent : il apparaîtra dans la liste et commencera à envoyer les détections dès son installation.',
  'Registra un altro agent': "Enregistrer un autre agent",
  'Rigenera segreto': "Régénérer le secret",
  'Tienilo acceso con un servizio di sistema (systemd, un servizio Windows): un’esca ha senso solo se è in ascolto.': "Gardez-le actif avec un service système (systemd, un service Windows) : un leurre n’a de sens que s’il est à l’écoute.",
  'Un agent Honeypot espone servizi esca (SSH, RDP, SMB…) su una macchina dedicata, isolata dalla discovery e priva delle credenziali degli asset gestiti. Registra i tentativi di connessione come Alert e li trasmette a una sonda per inoltro o direttamente al Control Plane.': 'Un agent Honeypot expose des services leurres (SSH, RDP, SMB…) sur une machine dédiée, isolée de la découverte et dépourvue des identifiants des actifs gérés. Il enregistre les tentatives de connexion comme Alertes et les transmet à une sonde pour relais ou directement au Control Plane.',
  'consegna: {dove}': "livraison : {dove}",
  'mai visto': "jamais vu",
  'silenzioso': "silencieux",
  'ultimo contatto {quando}': "dernier contact {quando}",
  '{listening}/{active} esche in ascolto': "{listening}/{active} leurres à l’écoute",
  'Porte non aperte (occupate?):': "Ports non ouverts (occupés ?) :",
  'L’agent non si fa più sentire: servizio fermo, o non raggiunge più il Control Plane.': "L’agent ne donne plus signe de vie : service arrêté, ou il n’atteint plus le Control Plane.",
  'revocato': "révoqué",
  'scaduto': "expiré",
  '{n} consegne': "{n} livraisons",
  '{n} esche': "{n} leurres",
  '{n} esche in ascolto': "{n} leurres à l’écoute",
  'Capacity': "Capacity",
  'Capacity plan': 'plan de capacité',
  'mostra capacità, spazio utilizzato e disponibilità delle risorse di storage — e di compute e porte — rilevate nell’inventario, per individuare saturazioni e capacità residua.': 'Affiche la capacité, l’espace utilisé et la disponibilité des ressources de stockage — ainsi que de compute et de ports — détectées dans l’inventaire, pour repérer les saturations et la capacité restante.',
  'Storage': "Stockage",
  'Nessun datastore': "Aucun datastore",
  'Compaiono qui i datastore raccolti dai connettori di virtualizzazione.': "Les datastores collectés par les connecteurs de virtualisation apparaissent ici.",
  'Capacità totale': "Capacité totale",
  'Usato': "Utilisé",
  'Datastore da tenere d’occhio': "Datastores à surveiller",
  'Ambiente': "Environnement",
  'Compute (overcommit)': "Compute (overcommit)",
  'Nessun host': "Aucun hôte",
  'Compaiono qui gli host raccolti dai connettori di virtualizzazione.': "Les hôtes collectés par les connecteurs de virtualisation apparaissent ici.",
  'vCPU allocate': "vCPU allouées",
  'Overcommit CPU': 'Surcharge du processeur',
  'Overcommit RAM': "Overcommit RAM",
  'L’overcommit è il rapporto fra risorse promesse alle VM e risorse fisiche: sopra 1× si conta sul fatto che non tutte tirino insieme.': "L’overcommit est le rapport entre les ressources promises aux VM et les ressources physiques : au-delà de 1×, on parie sur le fait qu’elles ne sollicitent pas tout en même temps.",
  'CPU (vCPU / core)': "CPU (vCPU / cœurs)",
  'RAM (alloc. / fisica)': "RAM (allouée / physique)",
  'Porte degli apparati': "Ports des équipements",
  'Nessun apparato con porte note': "Aucun équipement avec des ports connus",
  'Le porte si raccolgono con una discovery SNMP approfondita (deep).': "Les ports se collectent avec une découverte SNMP approfondie (deep).",
  'Porte totali': "Ports totaux",
  'In uso': "Utilisés",
  'Libere': "Libres",
  'In uso / totali': "Utilisés / total",
  'n/d': "n/d",
  'VM': "VM",
  'Mappa delle correlazioni dell’host': "Carte des corrélations de l’hôte",
  'Guest OS': "Guest OS",
  'Nessun datastore usato dalle VM di questo host.': "Aucun datastore utilisé par les VM de cet hôte.",
  'Nessuna VM su questo host.': "Aucune VM sur cet hôte.",
  'Nessuna rete usata dalle VM di questo host.': "Aucun réseau utilisé par les VM de cet hôte.",
  'RAM': "RAM",
  'RAM allocata': "RAM allouée",
  'colore = riempimento': "couleur = remplissage",
  'piena = accesa': "pleine = allumée",
  'Scegli un host per vederne VM, datastore e reti.': 'Choisissez un hôte pour voir ses VM, base de données et réseaux.',
  'Storage usato': "Stockage utilisé",
  'VM accese': "VM allumées",
  'accesa': "allumée",
  'spenta': "éteinte",
  'vCPU / core': "vCPU / cœurs",
  '{env} · cluster e host': "{env} · clusters et hôtes",
  '{n} cluster': "{n} clusters",
  'Aggiornata': "Mise à jour",
  'Asset coinvolti': "Assets concernés",
  'Asset considerati': "Assets pris en compte",
  'Autovalutazione': "Auto-évaluation",
  'Autovalutazione dell’organizzazione (non misurato dalla piattaforma)': "Auto-évaluation de l’organisation (non mesurée par la plateforme)",
  'Autovalutazione: cosa questa pagina non misura': "Auto-évaluation : ce que cette page ne mesure pas",
  'Controlli falliti': "Contrôles échoués",
  'Due righe di contesto: come è coperto, da quando, con quali limiti.': "Deux lignes de contexte : comment c’est couvert, depuis quand, avec quelles limites.",
  'Esempi': "Exemples",
  'Esporta CSV': "Exporter en CSV",
  'Generato il': "Généré le",
  'Azioni derivate dagli esiti dei controlli, raggruppate per causa e ordinate per priorità: prima gli interventi di remediation per i controlli falliti, in seguito le attività di misurazione per i dati mancanti.': 'Actions issues des résultats des contrôles, regroupées par cause et classées par priorité : d’abord la remédiation des contrôles en échec, puis les activités de mesure pour les données manquantes.',
  'Le fasce nascono dai soli controlli misurati; «da verificare» segnala asset per cui mancano i dati, non asset a posto.': "Les tranches sont établies à partir des seuls contrôles mesurés ; « à vérifier » signale des assets pour lesquels les données manquent, pas des assets conformes.",
  'Nessuna dichiarazione compilata.': "Aucune déclaration remplie.",
  'Niente da fare: tutti i controlli misurabili passano.': "Rien à faire : tous les contrôles mesurables réussissent.",
  'Nota metodologica: la parte misurata nasce dai dati raccolti dalla piattaforma (inventario, rischi di sicurezza, backup delle configurazioni) al momento della generazione. L’autovalutazione è dichiarata dall’organizzazione e non è verificata dalla piattaforma. Questo documento non costituisce una certificazione.': "Note méthodologique : la partie mesurée provient des données collectées par la plateforme (inventaire, éléments de sécurité, sauvegardes des configurations) au moment de la génération. L’auto-évaluation est déclarée par l’organisation et n’est pas vérifiée par la plateforme. Ce document ne constitue pas une certification.",
  'Organizzazione': "Organisation",
  'Per ogni requisito, indica come viene coperto dall’organizzazione: stato, riferimento al documento o alla procedura e responsabile. Nel report, queste evidenze sono identificate esplicitamente come dichiarate, non misurate.': 'Pour chaque exigence, indiquez comment l’organisation la couvre : état, référence au document ou à la procédure et responsable. Dans le rapport, ces preuves sont identifiées explicitement comme déclarées, non mesurées.',
  'Piano di lavoro': "Plan de travail",
  'Quanto segue è dichiarato dall’organizzazione, non misurato dai dati raccolti: le due cose restano separate di proposito.': "Ce qui suit est déclaré par l’organisation, non mesuré à partir des données collectées : les deux restent séparés à dessein.",
  'Report da stampare': "Rapport à imprimer",
  'Requisiti misurati dalla piattaforma': "Exigences mesurées par la plateforme",
  'Requisiti senza dichiarazione': "Exigences sans déclaration",
  'Requisito': "Exigence",
  'Riferimento (documento o procedura)': "Référence (document ou procédure)",
  'Salva dichiarazione': "Enregistrer la déclaration",
  'Salvata.': "Enregistrée.",
  'Sintesi': "Synthèse",
  'Stampa / salva PDF': "Imprimer / enregistrer en PDF",
  'Stato dichiarato': "Statut déclaré",
  'Ultimo aggiornamento: {quando} ({chi})': "Dernière mise à jour : {quando} ({chi})",
  'da dichiarare': "à déclarer",
  'es. CISO, Ufficio compliance': "ex. CISO, service conformité",
  'es. Procedura IR-01, registro fornitori, policy MFA': "ex. Procédure IR-01, registre des fournisseurs, politique MFA",
  'misurare': "mesurer",
  'motivo': "motif",
  'rimediare': "remédier",
  'scegli…': "choisir…",
  'parzialmente coperto': "partiellement couvert",
  'non coperto': "non couvert",
  'non applicabile': "non applicable",
  '(salvata: lascia vuoto per non cambiarla)': "(enregistrée : laissez vide pour ne pas la modifier)",
  'Notifica nuove rilevazioni da Dobermann.':
    "Alerter sur les nouveaux repérages du Dobermann",
  'Definisce il canale di invio degli avvisi Dobermann e i relativi destinatari. Il canale della piattaforma è adatto alla maggior parte degli scenari; un canale personalizzato consente di inviare le e-mail dal proprio dominio, applicando le relative policy.':
    "D’où partent les alertes du tenant (Dobermann) et à qui elles arrivent. Le canal de la plateforme convient à presque tout le monde ; le canal propre sert à ceux qui veulent que le courrier parte de leur propre domaine, avec leurs propres politiques.",
  'Destinatari degli avvisi (separati da virgola)': "Destinataires des alertes (séparés par une virgule)",
  'Host SMTP': "Hôte SMTP",
  'noc@azienda.it, sicurezza@azienda.it': "noc@entreprise.fr, securite@entreprise.fr",
  'Invia prova': "Envoyer un test",
  'Messaggio di prova consegnato al relay.': "Message de test remis au relais.",
  'Nome mittente': "Nom de l’expéditeur",
  'Posta in uscita e notifiche': "Courrier sortant et notifications",
  'Relay della piattaforma': "Relais de la plateforme",
  'SMTP del tenant': "SMTP du tenant",
  'Viene inviata una sola e-mail per ogni ciclo di controllo, solamente quando viene rilevato un indirizzo mai censito.':
    "Un e-mail par ronde de garde, uniquement quand apparaît une adresse jamais recensée.",
  'nessuna (relay interno)': "aucune (relais interne)",
  '1 indirizzo mai censito sta facendo traffico.': "1 adresse jamais recensée génère du trafic.",
  'Ispeziona': "Inspecter",
  'Nessun avvistamento: tutto ciò che parla nelle {n} subnet sorvegliate è censito.': "Aucun repérage : tout ce qui communique dans les {n} sous-réseaux surveillés est recensé.",
  '{n} indirizzi mai censiti stanno facendo traffico.': "{n} adresses jamais recensées génèrent du trafic.",
  'Dobermann confronta il traffico con l’inventario e segnala gli asset non censiti. Con «Ispeziona» ne esplori comunicazioni e porte; quando l’indirizzo entra nel CMDB, viene automaticamente considerato censito. In alternativa, puoi avviare una discovery, censirlo manualmente oppure «Ignora» specificandone il motivo.': 'Dobermann compare le trafic avec l’inventaire et signale les actifs non recensés. Avec «Ispeziona», vous explorez leurs communications et ports ; lorsque l’adresse entre dans la CMDB, elle est automatiquement considérée comme recensée. Vous pouvez aussi lancer une découverte, la recenser manuellement ou l’«Ignora» en précisant le motif.',
  'Con chi parla, su che porte, con che volumi — dai flussi raccolti.': "Avec qui elle communique, sur quels ports, avec quels volumes — d’après les flux collectés.",
  'Finestra temporale': "Fenêtre temporelle",
  'Interlocutori diretti (un livello). Per spingerti oltre:': "Interlocuteurs directs (un niveau). Pour aller plus loin :",
  'Ispezione dell’indirizzo': "Inspection de l’adresse",
  'Mappa degli interlocutori': "Carte des interlocuteurs",
  'Nessuna conversazione nella finestra scelta: l’indirizzo ha parlato prima, o il traffico non passa dagli esportatori.': "Aucune conversation dans la fenêtre choisie : l’adresse a communiqué avant, ou le trafic ne passe pas par les exportateurs.",
  'Ultime 24 ore': "Dernières 24 heures",
  'apri l’esplorazione completa': "ouvrir l’exploration complète",
  'da': "de",
  'il sospetto': "le suspect",
  'interlocutore censito': "interlocuteur recensé",
  'non censito': "non recensé",
  'spessore = volume': "épaisseur = volume",
  'verso': "vers",
  'Attiva la guardia': "Activer la garde",
  'Censiti (lieti fini)': "Recensés (fins heureuses)",
  'Chiudi import': "Fermer l’import",
  'Disattiva la guardia': "Désactiver la garde",
  'Dobermann attivo': "Dobermann actif",
  'Ignorati': "Ignorés",
  'Importa': "Importer",
  'Importa elenco': "Importer une liste",
  'Importate {a} subnet nuove, {m} aggiornate — {tot} sorvegliate in tutto.': "{a} nouveaux sous-réseaux importés, {m} mis à jour — {tot} surveillés au total.",
  'Nuovi avvistamenti': "Nouveaux repérages",
  'Ogni quanto fa il giro': "Fréquence de la ronde",
  'Tutte o nessuna: le righe storte vengono rifiutate col numero di riga.': "Tout ou rien : les lignes incorrectes sont rejetées avec leur numéro de ligne.",
  'Ultimo giro': "Dernière ronde",
  'Una rete per riga: 10.20.0.0/16, VLAN server — anche ; o TAB come separatore. Le righe con # sono commenti.': "Un réseau par ligne : 10.20.0.0/16, VLAN serveurs — aussi ; ou TAB comme séparateur. Les lignes avec # sont des commentaires.",
  'guardia disattivata': "garde désactivée",
  'ogni {n} h': "toutes les {n} h",
  'ogni {n} min': "toutes les {n} min",
  'Dipendenze': "Dépendances",
  'Archivia': "Archiver",
  'Notifica ogni connessione a un honeypot.':
    "Alerter quand quelqu’un se connecte à un leurre (honeypot)",
  'Banner (opzionale)': "Bannière (facultatif)",
  'Credenziali provate': "Identifiants essayés",
  'Esca': "Leurre",
  'Hit': "Hit",
  'Honeypot attivo': "Honeypot actif",
  'Indirizzi distinti': "Adresses distinctes",
  'Nessun hit': "Aucun hit",
  'Nessuno si è ancora connesso alle esche. Quando succede, comparirà qui con il payload catturato — e, se hai configurato le notifiche, arriverà una mail.': "Personne ne s’est encore connecté aux leurres. Le cas échéant, cela apparaîtra ici avec la charge utile capturée — et, si vous avez configuré les notifications, vous recevrez un e-mail.",
  'Nuovi hit': "Nouveaux hits",
  'Segna visto': "Marquer comme vu",
  'Tentativi': "Tentatives",
  'Ultimo tentativo': "Dernière tentative",
  'Un rilevamento indica una connessione a un servizio esca che per definizione è un evento sospetto. Utilizzare «Ispeziona» per analizzarne l’origine in Dobermann o ricercarla nei flussi per ricostruirne la provenienza.': 'Une détection indique une connexion à un service leurre, ce qui est par définition un événement suspect. Utilisez «Ispeziona» pour analyser son origine dans Dobermann ou la rechercher dans les flux pour reconstituer sa provenance.',
  'Non è previsto traffico legittimo verso questi sistemi. Ogni connessione viene considerata un allarme.':
    "Un leurre ne reçoit aucune connexion légitime : chaque connexion est une alerte.",
  'archiviato': "archivé",
  'es. OpenSSH_8.2p1 Ubuntu': "ex. OpenSSH_8.2p1 Ubuntu",
  'visto': "vu",
  'A riposo': "Au repos",
  'Dobermann in servizio': "Dobermann en service",
  'In servizio': "En service",
  '{n} nuovi avvistamenti': "{n} nouvelles détections",
  'Aggiungi': "Ajouter",
  'FQDN': "FQDN",
  'vip.azienda.it': "vip.entreprise.fr",
  'Indirizzi aggiuntivi': "Adresses supplémentaires",
  'FQDN aggiuntivi': "FQDN supplémentaires",
  'alias.azienda.it': "alias.entreprise.fr",
  'es. nome pubblico del servizio': "ex. nom public du service",
  'VIP, alias di servizio o indirizzi secondari di questo oggetto. Ognuno diventa un CI a sé, legato a questo: l’indirizzo e l’FQDN entrano nell’identità, così il traffico verso il VIP si riconcilia con l’oggetto giusto.': "VIP, alias de service ou adresses secondaires de cet objet. Chacun devient un CI à part entière, lié à celui-ci : l’adresse et le FQDN entrent dans l’identité, ainsi le trafic vers le VIP se réconcilie avec le bon objet.",
  'es. VIP del bilanciatore': "ex. VIP de l’équilibreur de charge",
  'Honeypot in ascolto': "Honeypot à l’écoute",
  'Niente che chieda attenzione.': "Rien qui demande votre attention.",
  'Notifiche': "Notifications",
  '{n} nuovi hit sulle esche': "{n} nouveaux hits sur les leurres",
  'Avvistamenti': "Détections",
  'Dobermann': "Dobermann",
  'Vai al CI': "Aller au CI",
  'individua gli asset non censiti correlando le evidenze raccolte da inventory, discovery e flussi NetFlow.': 'repère les actifs non recensés en corrélant les preuves recueillies depuis l’inventaire, la découverte et les flux NetFlow.',
  'Cos’è questo indirizzo? (la nota resta accanto alla decisione)': "Qu’est-ce que cette adresse ? (la note reste à côté de la décision)",
  'Dichiara qui sopra le reti da proteggere: il giro orario confronterà il traffico con l’inventario.': "Déclarez ci-dessus les réseaux à protéger : le tour horaire comparera le trafic avec l’inventaire.",
  'Fai il giro adesso': "Lancer le tour maintenant",
  'Interlocutori': "Interlocuteurs",
  'reti in cui ogni indirizzo attivo deve corrispondere a un asset censito. Vanno incluse solo le reti sotto controllo, escludendo ambienti come guest e NAT, dove la presenza di indirizzi sconosciuti è prevista e genererebbe segnalazioni non significative.': 'réseaux où chaque adresse active doit correspondre à un actif recensé. N’incluez que les réseaux sous contrôle, en excluant les environnements comme guest et NAT, où la présence d’adresses inconnues est attendue et générerait des signalements non significatifs.',
  'Lo conosco, ignora': "Je le connais, ignorer",
  'Nessun avvistamento': "Aucune détection",
  'Nessuna subnet sorvegliata': "Aucun sous-réseau surveillé",
  'Nome della subnet': "Nom du sous-réseau",
  'Primo traffico': "Premier trafic",
  'Riattiva': "Réactiver",
  'Rimuovi': "Retirer",
  'Sorveglia': "Surveiller",
  'Subnet': "Sous-réseau",
  'Subnet sorvegliate': "Sous-réseaux surveillés",
  'Tutto ciò che parla nelle subnet sorvegliate è censito. Il giro passa ogni ora sui flussi delle ultime 24.': "Tout ce qui dialogue dans les sous-réseaux surveillés est recensé. Le tour s’exécute chaque heure sur les flux des dernières 24 h.",
  'Ultimo traffico': "Dernier trafic",
  'Volume (24h)': "Volume (24 h)",
  'censito': "recensé",
  'ignorato': "ignoré",
  'nuovo': "nouveau",
  'es. VLAN server': "ex. VLAN serveurs",
  'Ambienti virtuali': "Environnements virtuels",
  'Cluster, host e macchine virtuali raccolti dai connettori di virtualizzazione': "Clusters, hôtes et machines virtuelles collectés par les connecteurs de virtualisation",
  'Nessun ambiente virtuale': "Aucun environnement virtuel",
  'Compaiono qui dopo una discovery con un connettore di virtualizzazione (VMware, Nutanix, Proxmox…).': "Ils apparaissent ici après une découverte avec un connecteur de virtualisation (VMware, Nutanix, Proxmox…).",
  'Ambienti': "Environnements",
  '{n} host': "{n} hôtes",
  'Cluster e host': "Clusters et hôtes",
  'Nessun host in questo ambiente.': "Aucun hôte dans cet environnement.",
  'Senza cluster': "Sans cluster",
  '{n} VM': "{n} VM",
  'Posizione': "Emplacement",
  'La sonda è un servizio systemd che si chiama {servizio}. I comandi vanno eseguiti sulla macchina che la ospita, come root o con sudo.': "La sonde est un service systemd nommé {servizio}. Les commandes doivent être exécutées sur la machine qui l’héberge, en tant que root ou avec sudo.",
  'Un riavvio non perde l’identità né i dati (stanno in /var/lib/{servizio}):': "Un redémarrage ne perd ni l’identité ni les données (elles se trouvent dans /var/lib/{servizio}) :",
  'L’installer lascia sulla macchina lo script di aggiornamento e un timer che lo esegue da sé. Per forzarlo adesso, scarica il binario nuovo dal Control Plane (con l’identità della sonda, nessun token) e riavvia il servizio:': "L’installateur laisse sur la machine le script de mise à jour et un timer qui l’exécute de lui-même. Pour le forcer maintenant, téléchargez le nouveau binaire depuis le Control Plane (avec l’identité de la sonde, sans jeton) et redémarrez le service :",
  'Se è già aggiornata non fa niente e lo dice; se il servizio non risale, rimette il binario precedente e riavvia. L’identità non si tocca: la sonda non si riarruola. Dopo, qui la «Versione della sonda» dice se l’aggiornamento è arrivato.': "Si elle est déjà à jour, elle ne fait rien et le signale ; si le service ne remonte pas, elle rétablit le binaire précédent et redémarre. L’identité n’est pas touchée : la sonde ne se réenrôle pas. Ensuite, la « Version de la sonde » indique ici si la mise à jour est bien arrivée.",
  'Guarda i log (journalctl) per l’errore di arruolamento o di certificato; verifica che la macchina raggiunga il canale delle sonde (porta 443) e che l’ora di sistema sia corretta — un orologio sfasato fa fallire il TLS con un errore che parla di certificato. Il servizio è /etc/systemd/system/{servizio}.service, l’identità e lo stato stanno in /var/lib/{servizio}.': "Consultez les logs (journalctl) pour l’erreur d’enrôlement ou de certificat ; vérifiez que la machine atteint le canal des sondes (port 443) et que l’heure système est correcte — une horloge décalée fait échouer le TLS avec une erreur évoquant un certificat. Le service est /etc/systemd/system/{servizio}.service, l’identité et l’état se trouvent dans /var/lib/{servizio}.",
  'Facoltativo, per l’inventario dei banchi di memoria: dmidecode si legge solo da root. Concedi a questo utente il permesso, senza password, per quel solo comando — e nient’altro:': "Facultatif, pour l’inventaire des barrettes de mémoire : dmidecode ne se lit qu’en tant que root. Accordez à cet utilisateur la permission, sans mot de passe, pour cette seule commande — et rien d’autre :",
  'Senza questa riga la discovery funziona lo stesso: i banchi di memoria restano vuoti e il rapporto lo dichiara. La sonda usa sudo solo per questo comando e solo se non entra già come root. Altri pochi dati (conteggio account senza password, config effettiva di sshd) richiedono root pieno e non li concediamo a un utente di sola lettura: se ti servono, usa una credenziale con privilegi di root.': "Sans cette ligne, la découverte fonctionne quand même : les barrettes de mémoire restent vides et le rapport le déclare. La sonde n’utilise sudo que pour cette commande et seulement si elle n’entre pas déjà en tant que root. Quelques autres données (nombre de comptes sans mot de passe, config effective de sshd) requièrent un root complet et nous ne les accordons pas à un utilisateur en lecture seule : si vous en avez besoin, utilisez un identifiant avec des privilèges root.",
  'Una chiave è una coppia di file: uno privato, che si incolla qui, e uno pubblico (.pub) che va sull’apparato da scansionare. Non riusare la chiave con cui entri a mano: creane una dedicata alla discovery. Ci sono due strade, a seconda di dove preferisci generarla.': "Une clé est une paire de fichiers : un privé, qui se colle ici, et un public (.pub) qui va sur l’appareil à scanner. Ne réutilisez pas la clé avec laquelle vous vous connectez manuellement : créez-en une dédiée à la découverte. Il y a deux voies, selon l’endroit où vous préférez la générer.",
  'A) Genero la chiave sul mio computer e installo la pubblica': "A) Je génère la clé sur mon ordinateur et j’installe la publique",
  'B) Creo utente e chiave sul server, poi copio la privata qui': "B) Je crée l’utilisateur et la clé sur le serveur, puis je copie la privée ici",
  'Utile quando preferisci preparare tutto sull’apparato Linux da scansionare. I comandi vanno eseguiti sul server, come root o con sudo.': "Utile lorsque vous préférez tout préparer sur l’appareil Linux à scanner. Les commandes doivent être exécutées sur le serveur, en tant que root ou avec sudo.",
  'Crea un utente dedicato, di sola lettura, senza password:': "Créez un utilisateur dédié, en lecture seule, sans mot de passe :",
  'Genera la coppia di chiavi nella home dell’utente:': "Générez la paire de clés dans le répertoire personnel de l’utilisateur :",
  'L’opzione -N con virgolette vuote crea la chiave senza passphrase; se ne metti una, riportala poi nel campo qui sotto.': "L’option -N avec des guillemets vides crée la clé sans phrase secrète ; si vous en définissez une, reportez-la ensuite dans le champ ci-dessous.",
  'Autorizza la chiave appena creata su questo stesso server:': "Autorisez la clé qui vient d’être créée sur ce même serveur :",
  'Mostra la chiave PRIVATA per copiarla — e incollala nel campo qui sotto:': "Affichez la clé PRIVÉE pour la copier — et collez-la dans le champ ci-dessous :",
  'Copia tutto, dalla riga -----BEGIN fino a -----END compresa. Su un parco di più server, la stessa chiave pubblica va messa in authorized_keys di censo-discovery su ognuno.': "Copiez tout, de la ligne -----BEGIN jusqu’à -----END incluse. Sur un parc de plusieurs serveurs, la même clé publique doit être placée dans authorized_keys de censo-discovery sur chacun.",
  'In entrambi i casi, verifica prima che la chiave funzioni: ssh -i censo-discovery censo-discovery@apparato deve entrare senza chiedere la password.': "Dans les deux cas, vérifiez d’abord que la clé fonctionne : ssh -i censo-discovery censo-discovery@appareil doit se connecter sans demander de mot de passe.",
  'Manutenzione della sonda': "Maintenance de la sonde",
  'Vedere i log': "Voir les logs",
  'In coda, solo le ultime righe (utile dopo un errore):': "En fin de fichier, seulement les dernières lignes (utile après une erreur) :",
  'Stato e riavvio': "État et redémarrage",
  'Forzare l’aggiornamento': "Forcer la mise à jour",
  'Versione attuale:': "Version actuelle :",
  'Se non torna online': "Si elle ne revient pas en ligne",
  'Come creo una chiave SSH?': "Comment créer une clé SSH ?",
  'Generala (su Linux o Mac, dal terminale):': "Générez-la (sous Linux ou Mac, depuis le terminal) :",
  'Ottieni due file nella cartella corrente: censo-discovery (privato) e censo-discovery.pub (pubblico). Se imposti una passphrase, mettila poi nel campo qui sotto.': "Vous obtenez deux fichiers dans le dossier courant : censo-discovery (privé) et censo-discovery.pub (public). Si vous définissez une phrase secrète, indiquez-la ensuite dans le champ ci-dessous.",
  'Installa la chiave pubblica sugli apparati da scansionare:': "Installez la clé publique sur les appareils à scanner :",
  'In alternativa, aggiungi il contenuto del file .pub in coda a ~/.ssh/authorized_keys sull’host.': "Vous pouvez aussi ajouter le contenu du fichier .pub à la fin de ~/.ssh/authorized_keys sur l’hôte.",
  'Incolla qui il contenuto del file privato (censo-discovery, quello senza .pub): tutto, dalla riga -----BEGIN fino a -----END compresa.': "Collez ici le contenu du fichier privé (censo-discovery, celui sans .pub) : tout, de la ligne -----BEGIN jusqu’à -----END incluse.",
  'Panoramica': "Vue d’ensemble",
  'Inventario': "Inventaire",
  'Asset': "Assets",
  'Topologia': "Topologie",
  'Traffico': "Trafic",
  'Raccolta': "Collecte",
  'Amministrazione': "Administration",
  'Servizi': "Services",
  'Pool di asset': "Portefeuilles d’assets",
  'Piani di discovery': "Plans de découverte",
  'Job scansioni': "Jobs de scan",
  'Scheduler': "Planificateur",
  'Sonde': "Sondes",
  'Gruppi di sonde': "Groupes de sondes",
  'Credenziali': "Identifiants",
  'Agenti d’inventario': "Agents d’inventaire",
  'Configurazioni apparati': "Configurations des appareils",
  'Utenti': "Utilisateurs",
  'Impostazioni': "Paramètres",
  'Utilizzo': "Utilisation",
  'Connettori': "Connecteurs",
  'Contratti': "Contrats",
  'Lingua della console': "Langue de la console",
  'Rete': "Réseau",
  'Analisi': "Analyse",
  'Report': "Rapports",
  'Integrazioni': "Intégrations",
  'Business service': "Business service",
  'Configuration Item': "Configuration Item",
  'La sincronizzazione verso l’ITSM richiede il modulo «ITSM Connector», che si aggiunge a qualunque piano. La prova a vuoto resta disponibile.':
    'La synchronisation vers l’ITSM nécessite le module « ITSM Connector », qui s’ajoute à n’importe quel plan. L’essai à blanc reste disponible.',
  'Mappa correlazione': "Carte de corrélation",
  'Riconoscimento': "Reconnaissance",
  'Esportatori': "Exportateurs",
  'Entry point': "Point d'entré",
  'Salva': "Enregistrer",
  'Salvataggio…': "Enregistrement…",
  'Chiudi': "Fermer",
  'Elimina': "Supprimer",
  'Copia': "Copier",
  'Copiata': "Copiée",
  'Scarica': "Télécharger",
  'Apri': "Ouvrir",
  'Storia': "Historique",
  'Apparati con configurazione salvata': "Appareils avec configuration enregistrée",
  'Cosa è cambiato': "Ce qui a changé",
  'Configurazione intera': "Configuration entière",
  'Politica di Retention dello storico':
    "Durée de conservation de l’historique",
  'Versioni per apparato': "Versions par appareil",
  'Giorni': "Jours",
  'Apparato': "Appareil",
  'Indirizzo': "Adresse",
  'Letto come': "Lu comme",
  'Letta come': "Lue comme",
  'Versioni': "Versions",
  'Ultima modifica': "Dernière modification",
  'Quando': "Quand",
  'Pulizia': "Nettoyage",
  'Dimensione': "Taille",
  'tutte': "toutes",
  'per sempre': "pour toujours",
  'Storia di {nome}': "Historique de {nome}",
  'configurazioni salvate: {salvate} su {totali}, di cui cambiate {cambiate}': "configurations enregistrées : {salvate} sur {totali}, dont {cambiate} modifiées",
  "{falliti} apparati non hanno risposto: la configurazione precedente resta l'ultima conosciuta": "{falliti} appareils n’ont pas répondu : la configuration précédente reste la dernière connue",
  'famiglia non riconosciuta: nessun comando da mandare a {apparato}': "famille non reconnue : aucune commande à envoyer à {apparato}",
  'nessuna credenziale ha aperto la sessione su {apparato}': "aucun identifiant n’a ouvert la session sur {apparato}",
  'configurazione di {apparato} non letta': "configuration de {apparato} non lue",
  'la lettura di {apparato} è tornata vuota: non si salva': "la lecture de {apparato} est revenue vide : rien n’est enregistré",
  'configurazione di {apparato} letta ma non consegnata': "configuration de {apparato} lue mais non livrée",
  'configurazione di {apparato} cambiata': "configuration de {apparato} modifiée",
  'nessun apparato da salvare: il job ha girato a vuoto': "aucun appareil à enregistrer : le job a tourné à vide",
  'nessuna credenziale SSH utilizzabile': "aucun identifiant SSH utilisable",
  'credenziale non risolta': "identifiant non résolu",
  'Su quale tenant vuoi operare?': "Sur quel tenant souhaitez-vous opérer ?",
  'Accedi': "Se connecter",
  'Accesso in corso…': "Connexion en cours…",
  'Entra con {provider}': "Se connecter avec {provider}",
  'Assegnato': "Attribué",
  'Attiva': "Active",
  'Criticità alta': "Criticité haute",
  'Criticità bassa': "Criticité basse",
  'Criticità media': "Criticité moyenne",
  'Critico': "Critique",
  'Degradata': "Dégradée",
  'Fallito': "Échoué",
  'In attesa': "En attente",
  'In esecuzione': "En cours d’exécution",
  'Offline': "Hors ligne",
  'Online': "En ligne",
  'Parziale': "Partiel",
  'Preso in carico': "Pris en charge",
  'Revocata': "Révoquée",
  'Riuscito': "Réussi",
  'Sospesa': "Suspendue",
  'Backup della configurazione': "Sauvegarde de la configuration",
  'Backup attivo': "Sauvegarde active",
  'Backup in ritardo': "Sauvegarde en retard",
  'Backup fermo': "Sauvegarde arrêtée",
  'Mai salvata': "Jamais sauvegardée",
  '{n} versioni': "{n} versions",
  'controllato {quando}': "vérifié {quando}",
  'mai cambiata da quando è sotto backup': "jamais modifiée depuis qu’elle est sauvegardée",
  'Letto con successo di recente.': "Lu avec succès récemment.",
  'Nessuna lettura riuscita da più di una settimana: il job potrebbe non essere più in pianificazione, o non riuscire ad accedere all’apparato.': "Aucune lecture réussie depuis plus d’une semaine : le job n’est peut-être plus planifié, ou n’arrive plus à accéder à l’équipement.",
  'Nessuna lettura riuscita da oltre un mese: la copia che c’è non descrive più l’apparato con abbastanza fiducia da ripristinarla senza guardarla.': "Aucune lecture réussie depuis plus d’un mois : la copie existante ne décrit plus l’équipement avec assez de fiabilité pour la restaurer sans la vérifier.",
  'Questo apparato non è mai stato letto con successo.': "Cet équipement n’a jamais été lu avec succès.",
  'Nessuna copia della configurazione. Di solito perché non c’è ancora un job di tipo «Backup configurazioni» che comprenda questo apparato — non perché il salvataggio sia fallito: in quel caso il rapporto del job lo direbbe.': "Aucune copie de la configuration. Généralement parce qu’il n’existe pas encore de job de type «Sauvegarde des configurations» qui inclut cet équipement — et non parce que la sauvegarde a échoué : dans ce cas, le rapport du job l’indiquerait.",
  'a (ora)': "à (heure)",
  'A che domanda risponde': "À quelle question il répond",
  'A cosa corrisponde': "À quoi il correspond",
  'A cosa corrisponde, per chi lo troverà fra sei mesi': "À quoi il correspond, pour celui qui le retrouvera dans six mois",
  'A cosa risponde': "À quoi il répond",
  'A quale macchina corrisponde, per chi lo troverà fra sei mesi': "À quelle machine il correspond, pour celui qui le retrouvera dans six mois",
  'Abilita la capability NetFlow su una sonda e configura gli apparati per esportare i flussi verso il suo indirizzo. La porta si sceglie nella scheda della sonda, sotto «Sorgenti dei flussi»: per difetto è la 2055.': "Activez la capability NetFlow sur une sonde et configurez les équipements pour exporter les flux vers son adresse. Le port se choisit dans la fiche de la sonde, sous «Sources des flux» : par défaut c’est le 2055.",
  'Abilitato il': "Activé le",
  'Accesso': "Accès",
  'Accesso con il provider aziendale (OpenID Connect)': "Connexion avec le fournisseur d’entreprise (OpenID Connect)",
  "Accorciare la finestra non libera spazio all'istante: ClickHouse elimina i dati scaduti alla merge successiva della parte che li contiene, quindi nel giro di ore. Se il disco non cala subito non è un guasto.": "Raccourcir la fenêtre ne libère pas d’espace immédiatement : ClickHouse supprime les données expirées lors du prochain merge de la partie qui les contient, donc en l’espace de quelques heures. Si le disque ne diminue pas tout de suite, ce n’est pas une panne.",
  'Acquisto': "Achat",
  'censo-amministratori': "censo-amministratori",
  "Agenti d'inventario": "Agents d’inventaire",
  'Aggiorna quelli che ci sono già': "Mettre à jour ceux qui existent déjà",
  'Aggiornamento': "Mise à jour",
  'Aggiornate': "Mises à jour",
  'Aggiornati': "Mis à jour",
  'Aggiornato': "Mis à jour",
  'Aggiunge il nome DNS ai CI trovati.': "Ajoute le nom DNS aux CI trouvés.",
  'Aggiungi…': "Ajouter…",
  'Aggiungi credenziale': "Ajouter une identité",
  'Aggiungi un passo': "Ajouter une étape",
  'Alcune sonde non hanno completato l’aggiornamento.': 'Certaines sondes n’ont pas terminé la mise à jour.',
  'Alcuni provider lo richiedono': "Certains fournisseurs l’exigent",
  'almeno una': "au moins une",
  'Alta': "Haute",
  'Altri attributi': "Autres attributs",
  'Altri parametri (JSON)': "Autres paramètres (JSON)",
  'Ambiti': "Périmètres",
  'Ambiti predefiniti': "Périmètres prédéfinis",
  'Ambito': "Périmètre",
  'Ambito da scansionare': "Périmètre à scanner",
  'Amministrazione della piattaforma': "Administration de la plateforme",
  'Anagrafica': "Fiche signalétique",
  'Anche ciò che sta dietro i vicini': "Aussi ce qui se trouve derrière les voisins",
  'Apparati': "Équipements",
  'Apparati che inviano flussi alle sonde': "Équipements qui envoient des flux aux sondes",
  'Apri la scheda del CI →': "Ouvrir la fiche du CI →",
  'Archi mostrati': "Arêtes affichées",
  "Arrivano alla macchina con la prossima consegna: nessuno deve tornarci sopra, e il segreto non cambia — rigenerarlo per cambiare un'impostazione invaliderebbe l'agente che sta funzionando.": "Ils arrivent à la machine lors de la prochaine livraison : personne n’a besoin d’y revenir, et le secret ne change pas — le régénérer pour modifier un réglage invaliderait l’agent qui fonctionne.",
  'Arrivata con il prodotto; modificabile come le altre': "Fournie avec le produit ; modifiable comme les autres",
  'Arruolata il': "Enrôlée le",
  'Ascolto…': "Écoute…",
  'Assegna': "Attribuer",
  'Assegnazione': "Attribution",
  'Assegnazione dei job, recupero dei lease scaduti e controllo di salute delle sonde. Gira da sé; qui si forza un giro e si vede che cosa ha fatto.': "Attribution des jobs, récupération des leases expirés et contrôle de santé des sondes. Il tourne tout seul ; ici on force un cycle et on voit ce qu’il a fait.",
  'Asset Discovery & Baseline System': "Asset Discovery & Baseline System",
  'Attesa fra i tentativi (min)': "Attente entre les tentatives (min)",
  'attivo': "actif",
  'attributo': "attribut",
  'Attributo': "Attribut",
  'Autenticazione': "Authentification",
  'automatico': "automatique",
  'Avvia comunque': "Démarrer quand même",
  'Avvia la prima scansione dai riquadri qui sopra.': "Lancez le premier scan depuis les cadres ci-dessus.",
  'Avvia una discovery dalla sezione Discovery per popolare la CMDB.': "Lancez une découverte depuis la section Découverte pour peupler la CMDB.",
  'Avvia la discovery associando al job un piano e un Pool di asset. La sonda esegue la sequenza configurata sui target del pool, acquisisce i risultati e aggiorna i Configuration Item. Titolo e descrizione identificano finalità e contesto.':
    'Lancez la découverte en associant un plan et un portefeuille d’actifs au job : la sonde exécute la séquence prévue sur les cibles du pool, recueille les résultats et met à jour les Configuration Items. Le titre et la description identifient la finalité et le contexte du job et peuvent être modifiés par la suite.',
  'Avviato': "Démarré",
  'azienda.it, azienda.com': "entreprise.fr, entreprise.com",
  'Azione': "Action",
  'Azioni': "Actions",
  'Bassa': "Basse",
  'Bene': "Bien",
  'Beni': "Biens",
  'Beni registrati': "Biens enregistrés",
  'Beni scoperti': "Biens découverts",
  'Byte minimi': "Octets minimum",
  'Cambiandolo servono i campi del nuovo metodo: quelli del precedente restano salvati ma non vengono più usati.': "En le changeant, les champs de la nouvelle méthode sont requis : ceux de la précédente restent enregistrés mais ne sont plus utilisés.",
  'Campi osservati per questa classe: nessuno li ha dichiarati in anticipo.': "Champs observés pour cette classe : personne ne les a déclarés à l’avance.",
  'Campionamento della cattura': "Échantillonnage de la capture",
  'Campo': "Champ",
  'Campo CENSO': "Champ CENSO",
  'Campo di destinazione': "Champ de destination",
  'Canale delle sonde': "Canal des sondes",
  'Capability operative': "Capabilities opérationnelles",
  'Capacità': "Capacité",
  'Cartellino': "Badge",
  'cartellino, nome o matricola': "badge, nom ou matricule",
  'Catalogo': "Catalogue",
  'Catalogo prodotti': "Catalogue de produits",
  'Catalogo vuoto': "Catalogue vide",
  'Categoria': "Catégorie",
  'Cattura diretta dal filo': "Capture directe sur le câble",
  'Cattura di prova (10s)': "Capture d'essai (10 s)",
  'Porte (opzionale)': 'Ports (facultatif)',
  'es. 2055, 6343': 'ex. 2055, 6343',
  'Con le porte indicate tiene solo quei pacchetti — utile per vedere se su una porta arriva NetFlow/sFlow.':
    "Avec les ports indiqués, ne garde que ces paquets — utile pour voir si NetFlow/sFlow arrive sur un port.",
  'Usa le porte dei flussi': 'Utiliser les ports des flux',
  'Diagnosi flussi': 'Diagnostic des flux',
  'Diagnosi in corso…': 'Diagnostic en cours…',
  'Ascolta qualche secondo la porta dei flussi e riferisce se e a chi arrivano — la risposta a «sembra arrivi NetFlow ma la sonda non lo rileva».':
    "Écoute quelques secondes le port des flux et indique si — et à qui — les flux arrivent : la réponse à « NetFlow semble arriver mais la sonde ne le détecte pas ».",
  'Cattura in corso…': 'Capture en cours…',
  'Interfaccia da campionare': 'Interface à échantillonner',
  'Predefinita della sonda': 'Par défaut de la sonde',
  'La cattura non è riuscita.': "La capture a échoué.",
  'Cattura scaricata. Aprila in Wireshark. Puoi rilanciarla quando vuoi.':
    'Capture téléchargée. Ouvrez-la dans Wireshark. Vous pouvez la relancer quand vous voulez.',
  'Registra circa 10 secondi di traffico sull’interfaccia e scarica un file .pcap da aprire in Wireshark. Non modifica la raccolta continua.':
    "Enregistre environ 10 secondes de trafic sur l'interface et télécharge un fichier .pcap à ouvrir dans Wireshark. N'affecte pas la collecte continue.",
  'Cattura non avviata.': "Capture non démarrée.",
  'Cattura su': "Capture sur",
  'Centro di costo': "Centre de coût",
  'Cerca': "Rechercher",
  'Cerca in tutte le colonne…': "Rechercher dans toutes les colonnes…",
  'Cerca nome o indirizzo…': "Rechercher un nom ou une adresse…",
  'Cerca un apparato nella mappa': "Rechercher un équipement sur la carte",
  'Certificato': "Certificat",
  'Certificato (PEM)': "Certificat (PEM)",
  'Certificato applicato.': "Certificat appliqué.",
  'Certificato autofirmato.': "Certificat auto-signé.",
  'Certificato client': "Certificat client",
  'Certificato scritto, ma non ancora servito.': "Certificat écrit, mais pas encore servi.",
  'Che cosa contiene': "Ce qu’il contient",
  'Che cosa fa': "Ce qu’il fait",
  "Che fare se il sistema era fermo all'orario previsto. Di un inventario interessa quasi sempre lo stato attuale.": "Que faire si le système était arrêté à l’heure prévue. Pour un inventaire, c’est presque toujours l’état actuel qui importe.",
  'Chi accede lo fa con indirizzo e password. Collegando un IdP, gli utenti già abilitati entrano con le credenziali aziendali.': "Ceux qui se connectent le font avec une adresse et un mot de passe. En connectant un IdP, les utilisateurs déjà habilités entrent avec les identifiants d’entreprise.",
  'analizza le comunicazioni tra asset e i relativi volumi di traffico.': 'analyse les communications entre actifs et leurs volumes de trafic.',
  'Chi può entrare in questa console, con quale ruolo e da dove': "Qui peut accéder à cette console, avec quel rôle et d’où",
  'Chi vince sui campi senza direzione': "Qui l’emporte sur les champs sans direction",
  'Chiave': "Clé",
  'Chiave CENSO': "Clé CENSO",
  'Chiave di destinazione': "Clé de destination",
  'Chiave naturale': "Clé naturelle",
  'Chiave privata (PEM)': "Clé privée (PEM)",
  'Chiedi a un amministratore del tenant di modificare gli accessi.': "Demandez à un administrateur du tenant de modifier les accès.",
  "Chiedi un certificato a Let's Encrypt": "Demander un certificat à Let’s Encrypt",
  'CI agganciati': "CI rattachés",
  'CI compresi': "CI inclus",
  'CI da registrare': "CI à enregistrer",
  'CI gestiti': "CI gérés",
  'CI inventariati': "CI inventoriés",
  'Ciò che i passi precedenti hanno scoperto': "Ce que les étapes précédentes ont découvert",
  'Classe': "Classe",
  'Classificazione': "Classification",
  'Client ID': "Client ID",
  'Client secret': "Client secret",
  'Cliente': "Client",
  'cloud': "cloud",
  'CMDB, asset, contratti, diagnostica dei job': "CMDB, asset, contrats, diagnostic des jobs",
  'Codice': "Code",
  'Genera un token di registrazione e installa una sonda nella rete da sottoporre a discovery. In ambienti multisede, configura una sonda per sede e raggruppale per consentire l’assegnazione automatica dei job alla sonda disponibile. Verifica periodicamente versione, capability operative e stato; dopo ogni aggiornamento della piattaforma, controlla l’allineamento delle versioni, perché le nuove funzionalità di raccolta richiedono una versione compatibile della sonda.': 'Générez un jeton d’enrôlement et installez une sonde dans le réseau à soumettre à la découverte. Dans les environnements multi-sites, configurez une sonde par site et regroupez-les pour que les jobs soient attribués automatiquement à une sonde disponible. Vérifiez périodiquement la version, les capacités opérationnelles et l’état ; après chaque mise à jour de la plateforme, contrôlez l’alignement des versions, car les nouvelles fonctions de collecte exigent une version de sonde compatible.',
  'Collegamenti configurati': "Connexions configurées",
  'Collegamenti verso i sistemi di destinazione. Il flusso segue una sequenza controllata: configurazione dell’accesso, scansione del sistema, definizione del mapping, dry-run, sincronizzazione e pianificazione.': 'Liaisons vers les systèmes de destination. Le flux suit une séquence contrôlée : configuration de l’accès, analyse du système, définition du mapping, dry-run, synchronisation et planification.',
  'Collegamento': "Liaison",
  'Collegamento selezionato': "Liaison sélectionnée",
  'Collegato a': "Relié à",
  'Collocazione': "Emplacement",
  'Classificazione degli oggetti e associazione ai prodotti':
    "Comment la plateforme comprend ce qu'est un objet et à quel produit il correspond",
  'Come lo chiamano le due parti: è quello che si cita in una richiesta di intervento, e senza il fornitore non trova nulla.': "Comment les deux parties l'appellent : c'est ce que l'on cite dans une demande d'intervention, et sans le fournisseur on ne trouve rien.",
  'Come si chiama davvero: è ciò che vedrà il cliente.': "Comment il s'appelle vraiment : c'est ce que verra le client.",
  'come si rinnova, chi lo rinnova': "comment il se renouvelle, qui le renouvelle",
  'Completato': "Terminé",
  'Completo': "Complet",
  'Completo + software': "Complet + logiciel",
  'Completo + software installato': "Complet + logiciel installé",
  'Componenti': "Composants",
  'Comprese:': "Y compris :",
  'Con una sola credenziale per tipo non serve: creane uno quando gli apparati non rispondono tutti alla stessa.': "Avec une seule identification par type, ce n'est pas nécessaire : créez-en un lorsque les équipements ne répondent pas tous à la même.",
  'Concluso': "Achevé",
  'Condizioni': "Conditions",
  'Conferma': "Confirmer",
  'Configura un collegamento qui sopra: dopo averne verificato la connettività, potrai eseguire la scansione del sistema di destinazione.': 'Configurez une liaison ci-dessus : après en avoir vérifié la connectivité, vous pourrez analyser le système de destination.',
  'Configuration item': "Configuration item",
  'Mostra gli asset nuovi, non più rilevati, attivi e silenti.':
    "Configuration Item collectés dans la CMDB",
  'Configurazione': "Configuration",
  'Connessioni': "Connexions",
  'Consegna a': "Livraison à",
  'Consegne': "Livraisons",
  'Conservazione del traffico': "Conservation du trafic",
  'Console server': "Serveur console",
  'Console server Lantronix': "Serveur console Lantronix",
  'console_server': "console_server",
  'console.esempio.it, api.esempio.it': "console.exemple.fr, api.exemple.fr",
  'Consumo': "Consommation",
  'Conta nei gruppi in failover: le riserve ricevono lavoro solo se le attive mancano.': "Compte dans les groupes en failover : les réserves ne reçoivent du travail que si les actives font défaut.",
  'Contatto del fornitore': "Contact du fournisseur",
  'Contenuto': "Contenu",
  'Contratto': "Contrat",
  'Control Plane': "Control Plane",
  'Conversazioni': "Conversations",
  'coperto': "couvert",
  'Coperto da': "Couvert par",
  'Coperto fino a': "Couvert jusqu'au",
  'Copertura contrattuale': "Couverture contractuelle",
  'Cosa non torna': "Ce qui ne colle pas",
  'Cosa sincronizzare': "Quoi synchroniser",
  "Così com'è, una scansione che usa questo pool non avrebbe niente da guardare — e riuscirebbe senza fare niente.": "En l'état, une analyse utilisant ce pool n'aurait rien à examiner — et réussirait sans rien faire.",
  'Costruttore': "Fabricant",
  'Crea gli oggetti che nella destinazione non ci sono': "Crée les objets absents de la destination",
  'Crea prima una credenziale nella sezione Credenziali.': "Créez d'abord une identification dans la section Identifications.",
  'creane una': "créez-en une",
  'Creane una per poter avviare una discovery.': "Créez-en une pour pouvoir lancer une découverte.",
  'Creane uno': "Créez-en un",
  'Creata': "Créée",
  'Creati': "Créés",
  'Creato': "Créé",
  'Credenziale': "Identification",
  'Credenziale singola': "Identification unique",
  'Credenziali configurate': "Identifications configurées",
  'Criticità': "Criticité",
  'Da dove': "D'où",
  'Da dove partire': "Par où commencer",
  "Da dove si entra nel servizio: il VIP del bilanciatore, il front-end, l'indirizzo pubblicato. È l'unica cosa da dichiarare a mano — dai flussi si vede che due macchine parlano, non quale delle due è l'ingresso. Il resto della mappa si ricava seguendo il traffico da qui.": "Par où l'on entre dans le service : le VIP du répartiteur, le front-end, l'adresse publiée. C'est la seule chose à déclarer à la main — les flux montrent que deux machines communiquent, mais pas laquelle des deux est l'entrée. Le reste de la carte se déduit en suivant le trafic à partir d'ici.",
  'Da dove si parla': "D'où l'on communique",
  'Da guardare': "À examiner",
  "Da qui deriva l'indirizzo del cliente e non si potrà più cambiare: l'indirizzo sì, l'identificativo no.": "L'adresse du client en découle et ne pourra plus être modifiée : l'adresse oui, l'identifiant non.",
  'Da un indirizzo: chi gli ha parlato, con chi ha parlato, e il vicinato dei suoi vicini': "À partir d'une adresse : qui lui a parlé, avec qui elle a parlé, et le voisinage de ses voisins",
  'Da una sonda': "Depuis une sonde",
  'da verificare': "à vérifier",
  'Dal cloud': "Depuis le cloud",
  'Dashboard': "Tableau de bord",
  'Data che conta': "Date qui compte",
  'Data di acquisto': "Date d'achat",
  'Database': "Base de données",
  'Database (PostgreSQL)': "Base de données (PostgreSQL)",
  'Dati grezzi': "Données brutes",
  'Decorrenza': "Prise d'effet",
  'Dedotto dalle relazioni, non dichiarato: sparisce da solo quando sparisce il fatto.': "Déduit des relations, non déclaré : disparaît de lui-même lorsque le fait disparaît.",
  'Flussi identificati dal punto di ingresso e ricostruiti dall’analisi del traffico di rete osservato.': 'Flux identifiés à partir du point d’entrée et reconstruits par l’analyse du trafic réseau observé.',
  'derivato dal nome': "dérivé du nom",
  'Descrizione': "Description",
  'Descrizione breve': "Description brève",
  'Destinazione': "Destination",
  'Distance': 'Distance',
  'VRF/VPN-INSTANCE': 'VRF/VPN-INSTANCE',
  'Nell’elenco delle subnet, accanto a descrizione, sezione e VLAN, c’è anche la VRF/VPN-INSTANCE di phpIPAM.': 'Dans la liste des sous-réseaux, à côté de la description, de la section et du VLAN, figure aussi la VRF/VPN-INSTANCE de phpIPAM.',
  'globale': 'globale',
  'Nelle interfacce del tab Rete, accanto all’IP compaiono l’FQDN e la VRF/VPN-INSTANCE: l’FQDN lo risolve la sonda (reverse DNS) quando la scansione SNMP ha l’opzione «Risoluzione DNS inversa» accesa; la VRF si deduce dalle rotte connesse (l’IP d’interfaccia è la rotta /32 locale nella tabella della sua VRF, es. 10.21.170.10 → management). Le due colonne appaiono solo quando c’è il dato.': 'Dans les interfaces de l’onglet Rete, à côté de l’IP apparaissent le FQDN et la VRF/VPN-INSTANCE : la sonde résout le FQDN (reverse DNS) quand l’analyse SNMP a l’option «Risoluzione DNS inversa» activée ; la VRF est déduite des routes connectées (l’IP d’interface est la route /32 locale dans la table de sa VRF, ex. 10.21.170.10 → management). Les deux colonnes n’apparaissent que lorsque la donnée existe.',
  'Negli elenchi di rete, IPAM e routing non si mostrano le reti di servizio 127.0.0.0/8 (loopback) e 255.0.0.0/8 (broadcast/riservato): sono rumore, non apparati né rotte utili.': 'Dans les listes réseau, IPAM et routage, les réseaux de service 127.0.0.0/8 (loopback) et 255.0.0.0/8 (broadcast/réservé) ne sont pas affichés : ce sont du bruit, ni des équipements ni des routes utiles.',
  'Sui dispositivi con più tabelle, l’inventario SSH legge anche le rotte per VRF (Cisco: show ip vrf → show ip route vrf …) e vpn-instance (Huawei: display ip routing-table all-routes, o per i 5732 una lettura per vpn-instance): la colonna «VRF/VPN-INSTANCE» appare quando c’è più di una tabella, con «globale» per quella pubblica.': 'Sur les équipements à plusieurs tables, l’inventaire SSH lit aussi les routes par VRF (Cisco : show ip vrf → show ip route vrf …) et vpn-instance (Huawei : display ip routing-table all-routes, ou par vpn-instance sur les 5732) : la colonne «VRF/VPN-INSTANCE» apparaît quand il y a plus d’une table, avec «globale» pour la publique.',
  'dettaglio': "détail",
  'Dettaglio (giorni)': "Détail (jours)",
  "Deve essere raggiungibile dalle macchine che consegnano, e da nessun altro: è l'unica porta che una sonda apre in ingresso.": "Elle doit être accessible depuis les machines qui livrent, et depuis aucune autre : c'est le seul port qu'une sonde ouvre en entrée.",
  'Direzione': "Direction",
  'Disattivandola smette di ricevere job ma resta arruolata e continua a mandare heartbeat: serve a metterla da parte durante una manutenzione senza doverla rimuovere e riarruolare.': "En la désactivant, elle cesse de recevoir des jobs mais reste enrôlée et continue d'envoyer des heartbeats : cela permet de la mettre de côté pendant une maintenance sans avoir à la retirer et la réenrôler.",
  "Disattivarlo ferma l'accesso con il provider senza perdere la configurazione: è il gesto giusto mentre l'IdP è in manutenzione.": "Le désactiver interrompt l'accès via le fournisseur sans perdre la configuration : c'est le bon geste pendant que l'IdP est en maintenance.",
  'Disattivata': "Désactivée",
  'Discovery approfondita': "Découverte approfondie",
  'Dispositivo': "Équipement",
  'Dispositivo collegato': "Équipement relié",
  'Distanza dal seme': "Distance depuis la graine",
  "Distribuisce l'avvio quando più pianificazioni hanno lo stesso orario.": "Répartit le démarrage lorsque plusieurs planifications ont le même horaire.",
  'Diversa dalla garanzia: quella dice fino a quando qualcuno lo ripara, questa fino a quando lo si vuole tenere.': "Différente de la garantie : celle-ci indique jusqu'à quand quelqu'un le répare, celle-là jusqu'à quand on souhaite le conserver.",
  'Dizionario indirizzo → CI': "Dictionnaire adresse → CI",
  'Report predefiniti su inventario, asset, contratti e discovery, con ambito ed esclusioni espliciti per evitare risultati fuorvianti.': 'Rapports prédéfinis sur l’inventaire, les actifs, les contrats et la découverte, avec périmètre et exclusions explicites pour éviter des résultats trompeurs.',
  'Domini': "Domaines",
  'Domini di posta': "Domaines de messagerie",
  'Dominio di base': "Domaine de base",
  'Dominio e hostname di servizio': "Domaine et nom d'hôte de service",
  'dopo la compressione': "après compression",
  'Due bastano per «front-end → applicativo → database». Su una rete piatta alzarla include mezza infrastruttura.': "Deux suffisent pour « front-end → applicatif → base de données ». Sur un réseau plat, l'augmenter englobe la moitié de l'infrastructure.",
  'Due oggetti in CMDB per lo stesso indirizzo.': "Deux objets dans la CMDB pour la même adresse.",
  'Durata': "Durée",
  'Inizio': "Début",
  'è ciò che cresce': "c'est ce qui croît",
  'è fallito': "a échoué",
  'e il campo': "et le champ",
  'È il primo passo: non c’è ancora niente su cui condizionare, quindi parte sempre.': "C'est la première étape : il n'y a encore rien sur quoi conditionner, elle démarre donc toujours.",
  "È il volume che si riempie per primo: il traffico cresce di continuo, l'inventario no. Se si avvicina al pieno, le leve sono due — accorciare la retention dei flussi o allargare il volume.": "C'est le volume qui se remplit en premier : le trafic croît en continu, pas l'inventaire. S'il approche de la saturation, il y a deux leviers — raccourcir la rétention des flux ou agrandir le volume.",
  'È quella che il fornitore usa per decidere se un apparato è in garanzia: meglio vuota che sbagliata.': "C'est celle que le fournisseur utilise pour décider si un équipement est sous garantie : mieux vaut vide qu'erronée.",
  'È quella che verrà provata su ogni apparato': "C'est celle qui sera essayée sur chaque équipement",
  'È quello che compare sul pulsante: «Entra con…».': "C'est ce qui apparaît sur le bouton : « Se connecter avec… ».",
  'è riuscito': "a réussi",
  'è stato saltato': "a été ignoré",
  'Definisce il perimetro di discovery raggruppando subnet, sedi e ambienti. Ogni scansione utilizza il pool associato per determinare segmenti e target da acquisire; le modifiche al pool si applicano automaticamente alle pianificazioni collegate.':
    'Regroupe des sous-réseaux, des sites et des environnements pour définir le périmètre réseau sur lequel exécuter la découverte. Chaque analyse utilise le pool associé pour déterminer quels segments et cibles inclure ; les modifications du pool s’appliquent automatiquement aux planifications qui l’utilisent.',
  'Elimina questa vista': "Supprimer cette vue",
  'Eliminazione irreversibile.': "Suppression irréversible.",
  'Email': "E-mail",
  'Emesso da': "Émis par",
  'es. Portale clienti': "ex. Portail clients",
  'es. Sede di Milano': "ex. Site de Milan",
  'es. sonda-milano-dc1': "ex. sonde-milan-dc1",
  'es. Team Digital': "ex. Équipe Digital",
  'es. VIP portale': "ex. VIP portail",
  'Esaminati': "Examinés",
  'esclusi gli alienati': "hors biens aliénés",
  'Esecuzioni perse': "Exécutions manquées",
  'Esegui questo comando sulla macchina, dentro la rete da inventariare. Scarica la sonda, la installa come servizio e la arruola.': "Exécutez cette commande sur la machine, à l'intérieur du réseau à inventorier. Elle télécharge la sonde, l'installe comme service et l'enrôle.",
  'Esegui questo passo': "Exécuter cette étape",
  'Esegui su': "Exécuter sur",
  'Eseguito su': "Exécuté sur",
  'Esito': "Résultat",
  'Esito di un passo precedente': "Résultat d'une étape précédente",
  'Espressione cron': "Expression cron",
  'Etichetta': "Étiquette",
  'Evento': "Événement",
  'fallita': "échouée",
  'Fallite': "Échouées",
  'Falliti': "Échoués",
  'falso': "faux",
  'Famiglia': "Famille",
  'Fase': "Phase",
  'Filtra': "Filtrer",
  'Filtra per fase': "Filtrer par phase",
  'Filtra per porta': "Filtrer par port",
  'Filtri': "Filtres",
  'Fine vita prevista': "Fin de vie prévue",
  'Finestra': "Fenêtre",
  'Finestra da (ora)': "Fenêtre à partir de (heure)",
  'Flussi': "Flux",
  'Flussi prodotti': "Flux produits",
  'Fornitore': "Fournisseur",
  'Frequenza': "Fréquence",
  'Frequenza (cron)': "Fréquence (cron)",
  'Funzione': "Fonction",
  'Fuori banda': "Hors bande",
  'Fuso orario': "Fuseau horaire",
  'Garanzia': "Garantie",
  'Garanzia fino al': "Garantie jusqu'au",
  'Genera un token di arruolamento e avvia un collector nella rete da inventariare.': "Génère un jeton d'enrôlement et démarre un collector dans le réseau à inventorier.",
  'Gestione riservata agli amministratori': "Gestion réservée aux administrateurs",
  'Già scaduti': "Déjà expirés",
  'giallo': "jaune",
  'Giorni di preavviso': "Jours de préavis",
  'Gli apparati inviano i flussi alla sonda: nessuno li ha ancora inviati.': "Les équipements envoient les flux à la sonde : aucun ne les a encore envoyés.",
  'Google Workspace:': "Google Workspace :",
  'Gruppi': "Groupes",
  'Gruppi (provati in ordine)': "Groupes (essayés dans l'ordre)",
  'Gruppi configurati': "Groupes configurés",
  'Gruppi del provider → ruolo (facoltativo)': "Groupes du fournisseur → rôle (facultatif)",
  'Gruppo': "Groupe",
  'host': "hôte",
  'Host non gestiti': "Hôtes non gérés",
  'I campi contrassegnati arrivano dalla discovery: correggili solo se sono sbagliati. Proprietario e centro di costo li sa solo una persona.': "Les champs marqués proviennent de la découverte : ne les corrigez que s'ils sont erronés. Le propriétaire et le centre de coûts, seule une personne les connaît.",
  'I nomi dei campi non si somigliano abbastanza. Non è un guasto: significa che il mapping va costruito a mano.': "Les noms des champs ne se ressemblent pas assez. Ce n'est pas une panne : cela signifie que le mapping doit être construit à la main.",
  'I più voluminosi. Massimo 50.': "Les plus volumineux. Maximum 50.",
  'I tipi di CI si nascondono e si rimettono cliccandoli. Un clic su un nodo mette a fuoco il suo intorno; un altro clic lo rilascia.': "Les types de CI se masquent et se réaffichent en cliquant dessus. Un clic sur un nœud met en évidence son voisinage ; un autre clic le relâche.",
  'I volumi sono riportati in scala: sono stime.': "Les volumes sont rapportés à l'échelle : ce sont des estimations.",
  'ID interno': "ID interne",
  'Identificativo': "Identifiant",
  'Identificativo (facoltativo)': "Identifiant (facultatif)",
  'Il certificato è scaduto.': "Le certificat a expiré.",
  'Il certificato non è ancora valido.': "Le certificat n'est pas encore valide.",
  'Il Control Plane (cloud)': "Le Control Plane (cloud)",
  'Il database non risponde.': "La base de données ne répond pas.",
  'Il dizionario indirizzo → CI non è caricato': "Le dictionnaire adresse → CI n'est pas chargé",
  'Il job è terminato con errore:': "Le job s'est terminé avec une erreur :",
  'il limite che si raggiunge per primo aggiungendo repliche': "la limite atteinte en premier en ajoutant des réplicas",
  "Il piano non è stato caricato: non è stato modificato niente. Ricarica la pagina; se l'errore resta, il piano potrebbe essere stato eliminato.": "Le plan n'a pas été chargé : rien n'a été modifié. Rechargez la page ; si l'erreur persiste, le plan a peut-être été supprimé.",
  'Il rinnovo automatico non sta riuscendo.': "Le renouvellement automatique échoue.",
  'Filtra il traffico non rilevante per discovery, identificazione degli entry point e correlazione degli asset. I dati esclusi non vengono trasmessi né archiviati, riducendo traffico di rete e spazio occupato.':
    "Le trafic est la donnée qui croît sans fin, et la plupart ne sert à aucun des trois objectifs pour lesquels on le collecte — trouver des assets inconnus, reconnaître les points d'entrée, corréler les assets entre eux. Ce que l'on écarte ici ne traverse pas le réseau et n'occupe pas d'espace.",
  'illimitate': "illimitées",
  'illimitati': "illimités",
  'Immagina un host con questi fatti e guarda quali passi partirebbero. Non tocca la rete: usa la stessa valutazione che userà la sonda.': "Imaginez un hôte avec ces caractéristiques et observez quelles étapes se lanceraient. Cela ne touche pas au réseau : cela utilise la même évaluation que celle qu'emploiera la sonde.",
  'Impronta SHA-256': "Empreinte SHA-256",
  'In aggiornamento': "En cours de mise à jour",
  'In esecuzione da': "En exécution depuis",
  'In scadenza (90 g)': "Expiration proche (90 j)",
  'Incolla un elenco': "Collez une liste",
  'Indietro': "Retour",
  'Indirizzi': "Adresses",
  'Indirizzi da escludere': "Adresses à exclure",
  'Indirizzo per gli avvisi di scadenza': "Adresse pour les alertes d'expiration",
  'Installa la sonda': "Installez la sonde",
  'Integrazione': "Intégration",
  'Interfaccia': "Interface",
  'Interlocutore': "Interlocuteur",
  'Interrogazioni parallele': "Requêtes parallèles",
  'Intestatario': "Titulaire",
  'Invariati': "Inchangés",
  'inventario + traffico': "inventaire + trafic",
  'Inventario e traffico utilizzano volumi distinti: lo spazio totale occupato è la somma di entrambi.': 'L’inventaire et le trafic utilisent des volumes distincts : l’espace total occupé est la somme des deux.',
  'Issuer': "Issuer",
  'ITSM di produzione': "ITSM de production",
  'Pianifica l’esecuzione ricorrente dei job di discovery, definendo frequenza e periodicità, per mantenere automaticamente aggiornati i Configuration Item.': 'Planifiez l’exécution récurrente des jobs de découverte, en définissant la fréquence et la périodicité, pour tenir les Configuration Items automatiquement à jour.',
  'Job eseguiti': "Jobs exécutés",
  'Job falliti': "Jobs échoués",
  'Job recenti': "Jobs récents",
  'Keycloak:': "Keycloak :",
  "L'interfaccia collegata alla porta mirror (SPAN) dello switch. Vede solo il traffico che arriva lì: senza un mirror configurato, vedrà quasi soltanto il traffico della sonda stessa.": "L'interface reliée au port miroir (SPAN) du switch. Elle ne voit que le trafic qui y arrive : sans un miroir configuré, elle ne verra presque que le trafic de la sonde elle-même.",
  "L'inventario copre l'intero account o piattaforma: l'endpoint e l'ambito provengono dalla credenziale.": "L'inventaire couvre l'ensemble du compte ou de la plateforme : l'endpoint et le périmètre proviennent de l'identifiant.",
  "L'orario è interpretato in questo fuso: «alle 02:00» sono le 02:00 qui, anche quando cambia l'ora legale.": "L'horaire est interprété dans ce fuseau : « à 02h00 », c'est 02h00 ici, même lors du changement d'heure d'été.",
  "L'unica cosa che non sta nel certificato, e quindi l'unica che ha senso scrivere a mano.": "La seule chose qui ne figure pas dans le certificat, et donc la seule qu'il ait du sens de saisir à la main.",
  'L’utenza continua ad accedere con le proprie credenziali e può ora selezionare anche questo tenant.':
    "L'utilisateur continue de se connecter avec ses propres identifiants : désormais, il pourra aussi choisir ce tenant.",
  'La condizione non era soddisfatta su questi indirizzi.': "La condition n'était pas satisfaite sur ces adresses.",
  "La finestra limita l'orario in cui le scansioni possono partire: utile per evitare gli orari di lavoro. Lasciala vuota per non porre limiti.": "La fenêtre limite les horaires auxquels les scans peuvent démarrer : utile pour éviter les heures de travail. Laissez-la vide pour ne poser aucune limite.",
  'La mia password': "Mon mot de passe",
  'La piattaforma': "La plateforme",
  'La scansione chiede al sistema quali tipi di oggetto esistono davvero su questa istanza.': "Le scan demande au système quels types d'objet existent réellement sur cette instance.",
  'La sequenza di passi che la sonda esegue su ogni indirizzo dell’ambito. Ogni passo può dipendere da ciò che i precedenti hanno scoperto.': "La séquence d'étapes que la sonde exécute sur chaque adresse du périmètre. Chaque étape peut dépendre de ce que les précédentes ont découvert.",
  'La sonda non riesce a leggere la configurazione dei flussi.': "La sonde ne parvient pas à lire la configuration des flux.",
  'Lantronix SLC 8000, 16 porte': "Lantronix SLC 8000, 16 ports",
  'Le adiacenze si popolano con una discovery che raccoglie CDP/LLDP, con i connettori di virtualizzazione o con NetFlow.': "Les adjacences se remplissent avec une découverte qui collecte CDP/LLDP, avec les connecteurs de virtualisation ou avec NetFlow.",
  'Le chiamate partono dal cloud.': "Les appels partent du cloud.",
  'Le classi predefinite della piattaforma non possono essere ridefinite. Classi con la stessa chiave e definizioni diverse comprometterebbero la coerenza di classificazione e filtraggio.':
    "Les classes de la plateforme ne peuvent pas être redéfinies : deux classes avec la même clé et deux libellés différents rendraient les filtres incohérents.",
  'Le condizioni degli altri passi lo citano con questo nome.': "Les conditions des autres étapes le désignent par ce nom.",
  'Le discovery vanno avviate a mano finché non ne crei una.': "Les découverte doivent être lancées à la main tant que vous n'en créez pas une.",
  'Le interfacce si popolano con una discovery approfondita (deep).': "Les interfaces se remplissent avec une découverte approfondie (deep).",
  'Le licenze si assegnano ai clienti: creane uno nella sezione Tenant.': "Les licences s'attribuent aux clients : créez-en un dans la section Tenant.",
  'Le porte alte con un solo mittente sono quasi sempre la direzione di ritorno di una connessione in uscita, non un servizio. Sono nascoste perché in un elenco di servizi esposti sarebbero la maggioranza delle righe.': "Les ports hauts avec un seul émetteur sont presque toujours le sens retour d'une connexion sortante, non un service. Ils sont masqués car, dans une liste de services exposés, ils constitueraient la majorité des lignes.",
  'Le porte arrivano dalla IF-MIB: uno sweep SNMP non le legge, serve una discovery approfondita.': "Les ports proviennent de l'IF-MIB : un balayage SNMP ne les lit pas, une découverte approfondie est nécessaire.",
  'Le relazioni compaiono con una discovery che raccoglie CDP/LLDP, con i connettori di virtualizzazione o con NetFlow.': "Les relations apparaissent avec une découverte qui collecte CDP/LLDP, avec les connecteurs de virtualisation ou avec NetFlow.",
  "Le sonde marcate «non disponibile» non hanno il ricevitore acceso: si accende dalla scheda della sonda, sezione «Consegne degli agenti d'inventario». È spento di default perché è l'unica porta che una sonda apre in ingresso.": "Les sondes marquées « non disponible » n'ont pas leur récepteur activé : il s'active depuis la fiche de la sonde, section « Livraisons des agents d'inventaire ». Il est désactivé par défaut car c'est le seul port qu'une sonde ouvre en entrée.",
  'Le sonde precedenti alla raccolta della telemetria non le inviano.': "Les sondes antérieures à la collecte de la télémétrie ne les envoient pas.",
  'Legge gli indirizzi fisici imparati dalle porte dello switch e li correla con i CI già in inventario: vede anche ciò che non parla CDP/LLDP.': "Lit les adresses physiques apprises depuis les ports du switch et les corrèle avec les CI déjà en inventaire : voit aussi ce qui ne parle pas CDP/LLDP.",
  'Licenza': "Licence",
  'Licenza scaduta.': "Licence expirée.",
  'Licenze': "Licences",
  'Limiti del piano': "Limites du plan",
  'Listino': "Tarif",
  'Livelli': "Niveaux",
  'Livello': "Niveau",
  'Livello di servizio': "Niveau de service",
  "Lo pretende Let's Encrypt.": "Let's Encrypt l'exige.",
  'Lo spazio è una stima.': "L'espace est une estimation.",
  "Lo stesso parco, a colpo d'occhio: un punto per CI, i rossi verso il centro. Nessuna scena da guardare — si legge e si chiude.": "Le même parc, en un coup d'œil : un point par CI, les rouges vers le centre. Aucune scène à contempler — on le lit et on le ferme.",
  'Lo store dei flussi non risponde.': "Le store des flux ne répond pas.",
  'Lo store del traffico non risponde.': "Le store du trafic ne répond pas.",
  'Macchina': "Machine",
  'mai': "jamais",
  'mai eseguita': "jamais exécutée",
  'mai provato': "jamais essayé",
  'Mai provato': "Jamais essayé",
  'Manca': "Manquant",
  'Manca dal registro degli enti: importalo': "Absent du registre des entités : importez-le",
  'mantenuto dal Control Plane': "maintenu par le Control Plane",
  'mantenuto dal database (materialized view)': "maintenu par la base de données (materialized view)",
  'Mappa delle relazioni fra configuration item': "Carte des relations entre configuration items",
  'Mappa di correlazione': "Carte de corrélation",
  'Mappatura': "Mappage",
  'mappatura di partenza pronta': "mappage de départ prêt",
  'Mappature': "Mappages",
  'Media': "Moyenne",
  'Memoria': "Mémoire",
  'Memoria in uso dal processo': "Mémoire utilisée par le processus",
  'Menu di navigazione': "Menu de navigation",
  'Metodo di autenticazione': "Méthode d'authentification",
  'Mette la sonda in ascolto sulla porta UDP indicata qui sotto. Si può chiudere solo se la cattura diretta è attiva: senza nessuna delle due, la sonda sembrerebbe raccogliere senza raccogliere nulla.': "Met la sonde à l'écoute sur le port UDP indiqué ci-dessous. On ne peut le fermer que si la capture directe est active : sans aucune des deux, la sonde semblerait collecter sans rien collecter.",
  'Cataloga i modelli utilizzati nel parco asset. Le informazioni associate, come codice di ordinazione e costo, vengono applicate automaticamente quando un CI diventa un asset.':
    "Mettez au catalogue les modèles qui reviennent dans votre parc : quand un CI devient un asset, le code de commande et le coût sont déjà là, au lieu d'être à saisir pour le quarantième équipement identique.",
  'Microsoft Entra ID': "Microsoft Entra ID",
  'Microsoft Entra ID:': "Microsoft Entra ID :",
  'minuto ora giorno mese giorno-settimana': "minute heure jour mois jour-semaine",
  'Modalità': "Mode",
  'Modello': "Modèle",
  'Modifiche salvate.': "Modifications enregistrées.",
  'Modo': "Mode",
  'Molto più rapida su ambiti ampi: interroga solo gli host che rispondono.': "Bien plus rapide sur de larges périmètres : n'interroge que les hôtes qui répondent.",
  'Motivo': "Motif",
  'name, open_tcp_ports, os_family…': "name, open_tcp_ports, os_family…",
  'Navigazione principale': "Navigation principale",
  'NBD, 4h lavorative…': "NBD, 4h ouvrées…",
  'Negli ultimi 7 giorni': "Au cours des 7 derniers jours",
  'Nei MIB': "Dans les MIB",
  'Nessun accostamento proposto': "Aucun rapprochement proposé",
  'Nessun agente': "Aucun agent",
  'Nessun apparato di rete': "Aucun équipement réseau",
  'Nessun bene trovato': "Aucun bien trouvé",
  "Nessun calcolo lo rimette attivo e nessuna scansione lo annulla. Se l'apparato risponde ancora, il motivo qui sopra lo dice.": "Aucun calcul ne le réactive et aucun scan ne l'annule. Si l'équipement répond encore, le motif ci-dessus l'indique.",
  'Nessun collegamento': "Aucune liaison",
  'Nessun collegamento noto': "Aucune liaison connue",
  'Nessun configuration item trovato': "Aucun configuration item trouvé",
  'Nessun connettore': "Aucun connecteur",
  'Nessun contratto': "Aucun contrat",
  'Nessun dato in questa finestra.': "Aucune donnée dans cette fenêtre.",
  'Nessun evento': "Aucun événement",
  'Nessun evento da segnalare.': "Aucun événement à signaler.",
  'Nessun exporter': "Aucun exporter",
  'Nessun gruppo': "Aucun groupe",
  "Nessun ingresso corrisponde a un CI noto: non c'è un punto da cui misurare.": "Aucune entrée ne correspond à un CI connu : il n'y a aucun point de départ pour mesurer.",
  'Nessun job': "Aucun job",
  'Nessun job eseguito': "Aucun job exécuté",
  'Nessun job eseguito.': "Aucun job exécuté.",
  'nessun limite di CPU sul container': "aucune limite de CPU sur le conteneur",
  'Nessun oggetto con questo nome o indirizzo partecipa a una relazione. I CI senza collegamenti non compaiono in mappa: cercali in Inventario.': "Aucun objet portant ce nom ou cette adresse ne participe à une relation. Les CI sans liens n'apparaissent pas sur la carte : cherchez-les dans l'Inventaire.",
  'Nessun piano': "Aucun plan",
  'Nessun pool': "Aucun pool",
  'Nessun provider collegato': "Aucun fournisseur connecté",
  'Nessun servizio definito': "Aucun service défini",
  'Nessun servizio osservato': "Aucun service observé",
  'Nessun tenant': "Aucun tenant",
  'Nessun traffico osservato': "Aucun trafic observé",
  'Nessun traffico osservato in questa finestra.': "Aucun trafic observé dans cette fenêtre.",
  'Nessun utente': "Aucun utilisateur",
  'nessuna': "aucune",
  'Nessuna': "Aucune",
  "Nessuna azione: non c'era niente da assegnare né da recuperare. È l'esito normale su un sistema in pari, non un fallimento.": "Aucune action : il n'y avait rien à attribuer ni à récupérer. C'est le résultat normal sur un système à jour, pas un échec.",
  'Nessuna classe in questa categoria': "Aucune classe dans cette catégorie",
  'Nessuna configurazione salvata. Si comincia con un job di tipo «Backup configurazioni» sugli apparati di rete.': "Aucune configuration enregistrée. On commence par un job de type «Sauvegarde des configurations» sur les équipements réseau.",
  'Nessuna conversazione in questa finestra': "Aucune conversation dans cette fenêtre",
  "Nessuna corrispondenza: controlla il nome dell'attributo. Lo trovi in fondo alla scheda di un CI, sotto «Altri attributi».": "Aucune correspondance : vérifiez le nom de l'attribut. Vous le trouverez en bas de la fiche d'un CI, sous «Autres attributs».",
  'Nessuna credenziale': "Aucun identifiant",
  'Nessuna credenziale configurata': "Aucun identifiant configuré",
  'Nessuna esecuzione': "Aucune exécution",
  'Nessuna interfaccia': "Aucune interface",
  'Nessuna interfaccia riportata': "Aucune interface signalée",
  'nessuna licenza': "aucune licence",
  'Nessuna licenza registrata.': "Aucune licence enregistrée.",
  'Nessuna mappatura': "Aucun mappage",
  'Nessuna modifica registrata': "Aucune modification enregistrée",
  'Nessuna pianificazione': "Aucune planification",
  'Nessuna porta o protocollo su questo collegamento. Le adiacenze di rete (CDP, LLDP) e le relazioni di virtualizzazione non ne hanno: non è un dato mancante, è un tipo di collegamento che non ne prevede.': "Aucun port ni protocole sur ce lien. Les adjacences réseau (CDP, LLDP) et les relations de virtualisation n'en ont pas : ce n'est pas une donnée manquante, c'est un type de lien qui n'en prévoit aucun.",
  'Nessuna porta raccolta': "Aucun port collecté",
  'Nessuna regola': "Aucune règle",
  'Nessuna relazione della famiglia scelta collega due tipi di CI visibili.': "Aucune relation de la famille choisie ne relie deux types de CI visibles.",
  'Nessuna relazione rilevata': "Aucune relation détectée",
  'Nessuna riga': "Aucune ligne",
  'nessuna sonda': "aucune sonde",
  'Nessuna sonda arruolata': "Aucune sonde enrôlée",
  'Nessuna sonda arruolata.': "Aucune sonde enrôlée.",
  'Nessuno': "Aucun",
  'nessuno: la mappa sarà vuota': "aucun : la carte sera vide",
  'Niente da mostrare con questi filtri': "Rien à afficher avec ces filtres",
  'Nome': "Nom",
  'Nome Cognome': "Nom Prénom",
  'Nome del cliente': "Nom du client",
  'Nome del gruppo': "Nom du groupe",
  'Nome della mappatura': "Nom du mappage",
  'Nome della pianificazione': "Nom de la planification",
  'Nome della vista…': "Nom de la vue…",
  'Nome della vista da salvare': "Nom de la vue à enregistrer",
  'Nome o chiave naturale': "Nom ou clé naturelle",
  'Nomi coperti': "Noms couverts",
  'Nomi da coprire': "Noms à couvrir",
  'Non ancora scandito': "Pas encore analysé",
  'Non comprese:': "Non comprises :",
  'non dichiarata': "non déclarée",
  'non disponibile': "non disponible",
  "non esporta da oltre un'ora": "n'exporte plus depuis plus d'une heure",
  'non hanno ancora dichiarato una versione': "n'ont pas encore déclaré de version",
  'Non inventariato': "Non inventorié",
  'non lette': "non lues",
  'non misurato': "non mesuré",
  'non pianificata': "non planifiée",
  'non raccolto': "non collecté",
  'non riconosciuto': "non reconnu",
  'Non riportata: questa sonda è precedente alla raccolta dei dati sulla macchina. Aggiornala per vedere host e interfacce.': "Non signalée : cette sonde est antérieure à la collecte des données sur la machine. Mettez-la à jour pour voir les hôtes et les interfaces.",
  'Non risponde.': "Ne répond pas.",
  'Non riuscita.': "Échec.",
  "Non viene salvata nel database e non è più leggibile da nessuna pagina: finisce solo nel file che il bilanciatore usa. Se è protetta da passphrase, toglila prima — il bilanciatore non può chiederla a nessuno all'avvio.": "Elle n'est pas enregistrée dans la base de données et n'est plus lisible depuis aucune page : elle finit uniquement dans le fichier utilisé par le répartiteur de charge. Si elle est protégée par une phrase secrète, retirez-la d'abord — le répartiteur de charge ne peut la demander à personne au démarrage.",
  'Nota': "Note",
  'Note': "Notes",
  'Nuova categoria': "Nouvelle catégorie",
  'Nuova classe': "Nouvelle classe",
  'Nuova credenziale': "Nouvel identifiant",
  'nuova etichetta': "nouvelle étiquette",
  'Nuova password': "Nouveau mot de passe",
  'Nuova sonda': "Nouvelle sonde",
  'Nuovo agente': "Nouvel agent",
  'Nuovo connettore': "Nouveau connecteur",
  'Nuovo contratto': "Nouveau contrat",
  'Nuovo gruppo': "Nouveau groupe",
  'Nuovo gruppo di credenziali': "Nouveau groupe d'identifiants",
  'Nuovo pool': "Nouveau pool",
  'Nuovo tenant': "Nouveau tenant",
  'Nuovo utente': "Nouvel utilisateur",
  'Occorrenze': "Occurrences",
  'Oggetti trovati': "Objets trouvés",
  'Oggetto': "Objet",
  '«Ogni notte alle 2:00» significa le 2:00 qui, non le 2:00 UTC.': "«Chaque nuit à 2h00» signifie 2h00 ici, pas 2h00 UTC.",
  'Ogni quanti minuti': "Toutes les combien de minutes",
  'Ogni quanto consegna (minuti)': "Fréquence de livraison (minutes)",
  'OID costruttore': "OID constructeur",
  'Okta:': "Okta :",
  "Oltre il terzo è quasi sempre l'intera rete.": "Au-delà du troisième, c'est presque toujours le réseau entier.",
  'oob': "oob",
  'Operatore': "Opérateur",
  'Opererà su tutte le capability che dichiara.': "Il opérera sur toutes les capacités qu'il déclare.",
  'oppure indirizzo': "ou adresse",
  'Orchestratore': "Orchestrateur",
  'Ordine': "Ordre",
  'Origine': "Origine",
  'Pacchetti minimi': "Paquets minimum",
  'Pacchetti osservati': "Paquets observés",
  'Parametri': "Paramètres",
  'Parte?': "Démarre ?",
  'Partizioni del dettaglio': "Partitions du détail",
  'parziale': "partiel",
  'Passi': "Étapes",
  'Passo': "Étape",
  'Passo di 1 ora. Predefinito: 400.': "Pas de 1 heure. Par défaut : 400.",
  'Passo di 5 minuti. Predefinito: 7.': "Pas de 5 minutes. Par défaut : 7.",
  'Password': "Mot de passe",
  'Password aggiornata.': "Mot de passe mis à jour.",
  'Password attuale': "Mot de passe actuel",
  'Password iniziale': "Mot de passe initial",
  'Payload': "Payload",
  'Per gli asset non raggiungibili da alcuna sonda, l’inventario viene acquisito localmente e inviato in modo sicuro':
    "Pour les machines qu'aucune sonde n'atteint : elles collectent leur propre inventaire et le livrent scellé",
  'Per riferimento: una subnet aggiunta al pool entra nella scansione successiva.': "Pour référence : un sous-réseau ajouté au pool entre dans l'analyse suivante.",
  'Perché': "Pourquoi",
  'Perché è stato dismesso': "Pourquoi il a été mis hors service",
  'Percorso': "Chemin",
  'Periodicità': "Périodicité",
  'Piani a listino': "Plans tarifaires",
  'Piani di discovery di rete': "Plans de découverte réseau",
  'pianificata': "planifiée",
  'Pianificazioni attive': "Planifications actives",
  'Piano': "Plan",
  'Piano da eseguire': "Plan à exécuter",
  'Politica di assegnazione': "Politique d'attribution",
  'Porta': "Port",
  'Porta…': "Port…",
  'Porta di ascolto (UDP)': "Port d'écoute (UDP)",
  'In ascolto sulla porta {port}.': "À l'écoute sur le port {port}.",
  '{n} pacchetti ricevuti.': '{n} paquets reçus.',
  '{n} flussi decodificati.': "{n} flux décodés.",
  'Arrivano pacchetti ma nessun flusso viene decodificato: probabile un template non ancora ricevuto o un formato che la sonda non interpreta.':
    "Des paquets arrivent mais aucun flux n'est décodé : probablement un modèle pas encore reçu ou un format que la sonde n'interprète pas.",
  'Nessun flusso ricevuto ancora: verifica che un apparato esporti su questa porta.':
    "Aucun flux reçu pour l'instant : vérifiez qu'un équipement exporte vers ce port.",
  'Ricezione dei flussi esportati (collector)': 'Réception des flux exportés (collecteur)',
  'Ricevi i flussi esportati dagli apparati': 'Recevoir les flux exportés par les équipements',
  'Soglie (valgono per entrambe le sorgenti)': 'Seuils (valables pour les deux sources)',
  'Non in ascolto: {err}': "Pas à l'écoute : {err}",
  'Non ancora in ascolto: la sonda applica la scelta al prossimo giro di configurazione, entro un minuto.':
    "Pas encore à l'écoute : la sonde applique le choix au prochain cycle de configuration, sous une minute.",
  'Porta dichiarata': "Port déclaré",
  'Porta locale': "Port local",
  'Porta remota': "Port distant",
  'Porte': "Ports",
  'Porte e protocolli': "Ports et protocoles",
  'Porte, timeout, cartelle in cui cercare, comandi della scansione personalizzata. Vuoto significa «usa i valori predefiniti».': "Ports, délais d'expiration, dossiers où chercher, commandes de l'analyse personnalisée. Vide signifie «utiliser les valeurs par défaut».",
  'PostgreSQL': "PostgreSQL",
  'predefinito': "par défaut",
  'Prima serve un collegamento riuscito.': "Il faut d'abord une connexion réussie.",
  'Prima serve una scansione: il mapping si costruisce sui campi che il sistema di destinazione ha davvero, non su un elenco teorico.': "Il faut d'abord une analyse : le mappage se construit sur les champs que le système de destination possède réellement, pas sur une liste théorique.",
  'Primo passo, sul tuo provider.': "Première étape, sur votre fournisseur.",
  'Primo rilevamento': "Première détection",
  'Priorità': "Priorité",
  'Processore': "Processeur",
  'Prodotto': "Produit",
  'Prodotto a catalogo': "Produit au catalogue",
  'Produttore': "Fabricant",
  'Profondità': "Profondeur",
  'Profondità della mappa': "Profondeur de la carte",
  'pronto': "prêt",
  'Proprietario': "Propriétaire",
  'Prossima': "Prochaine",
  'Protocollo': "Protocole",
  'Prova a secco': "Essai à blanc",
  'prova a vuoto': "essai à blanc",
  'Prova a vuoto: sul sistema di destinazione non è stato scritto niente. I payload qui sotto sono quelli che sarebbero stati inviati.': "Essai à blanc : rien n'a été écrit sur le système de destination. Les payloads ci-dessous sont ceux qui auraient été envoyés.",
  'Provala dopo': "Essayez-la après",
  'Provala prima': "Essayez-la avant",
  'Prove a vuoto comprese.': "Essais à vide compris.",
  'Pulizia dello store del traffico': "Nettoyage du magasin de trafic",
  'Punti di ingresso': "Points d'entrée",
  'Quale insieme di sonde può eseguire una discovery, e con quale criterio': "Quel ensemble de sondes peut exécuter une découverte, et selon quel critère",
  'Qualsiasi': "N'importe lequel",
  'Qualunque sonda idonea': "N'importe quelle sonde éligible",
  'Quando una conversazione è interna': "Quand une conversation est interne",
  'Quanto raccogliere': "Combien collecter",
  'Spazio occupato dai dati del tenant e capacità residua rispetto ai limiti del piano.': 'Espace occupé par les données du tenant et capacité restante par rapport aux limites du forfait.',
  'Quello che la piattaforma ha sotto di sé, e ogni pesce è un CI. In verde ciò che ha riconosciuto e catalogato; in rosso, lampeggiante, ciò che non ha ancora riconosciuto — o che è comparso adesso.': "Ce que la plateforme a sous elle, et chaque poisson est un CI. En vert ce qu'elle a reconnu et catalogué ; en rouge, clignotant, ce qu'elle n'a pas encore reconnu — ou qui vient d'apparaître.",
  'Questa console non è aggiornata.': "Cette console n'est pas à jour.",
  'Questa sonda non ha ancora ricevuto lavoro: verifica che sia online e che abbia una capability abilitata.': "Cette sonde n'a pas encore reçu de travail : vérifiez qu'elle est en ligne et qu'une capability est activée.",
  'Questa sonda non riceve job:': "Cette sonde ne reçoit pas de job :",
  'Questa sonda non sa eseguire il passo.': "Cette sonde ne sait pas exécuter cette étape.",
  'Questi vicini sono stati raccolti, ma la porta che dichiarano non corrisponde a nessuna interfaccia letta: succede quando CDP o LLDP usano una convenzione di nomi che non si riconosce, o quando la IF-MIB non è stata raccolta.': "Ces voisins ont été collectés, mais le port qu'ils déclarent ne correspond à aucune interface lue : cela arrive quand CDP ou LLDP utilisent une convention de noms qui n'est pas reconnue, ou quand la IF-MIB n'a pas été collectée.",
  "Questo backend non riporta lo spazio libero del proprio volume. Con ClickHouse il dato c'è, perché ClickHouse lo espone.": "Ce backend ne remonte pas l'espace libre de son volume. Avec ClickHouse la donnée est présente, car ClickHouse l'expose.",
  'Questo Control Plane non conosce la propria versione.': "Ce Control Plane ne connaît pas sa propre version.",
  'Questo tenant': "Ce tenant",
  'Quota CI': "Quota CI",
  'Raccoglie i vicinati CDP e LLDP per la mappa delle adiacenze. Richiede la discovery approfondita.': "Collecte les voisinages CDP et LLDP pour la carte des adjacences. Nécessite la découverte approfondie.",
  'Raccoglie interfacce, seriali e numeri di modello oltre ai dati di base.': "Collecte les interfaces, les numéros de série et les numéros de modèle en plus des données de base.",
  'Raccolto': "Collecté",
  'Radar': "Radar",
  'Raddoppia a ogni tentativo successivo.': "Double à chaque tentative suivante.",
  'Raggiungibile': "Joignable",
  'Rapido': "Rapide",
  'Rapido — identità, sistema, rete': "Rapide — identité, système, réseau",
  'Rapido + software': "Rapide + logiciel",
  'Rapido + software installato': "Rapide + logiciel installé",
  'Record': "Enregistrement",
  'Recupera quelle saltate': "Récupère celles qui ont été sautées",
  'Registra anche i dispositivi senza SNMP': "Enregistre aussi les appareils sans SNMP",
  'Registra come bene': "Enregistrer comme bien",
  'Registrato il': "Enregistré le",
  'Registro dei costruttori': "Registre des constructeurs",
  'Regole di riconoscimento': "Règles de reconnaissance",
  'Stampanti Kyocera': 'Imprimantes Kyocera',
  'Stampanti Brother': 'Imprimantes Brother',
  'Stampanti Ricoh': 'Imprimantes Ricoh',
  'Stampanti Lexmark': 'Imprimantes Lexmark',
  "L'ente 1.3.6.1.4.1.244 è Lantronix, che fa console server. Senza questa regola risultano switch, perché commutano fra porte seriali e sysServices non distingue le due cose.":
    "L'entreprise 1.3.6.1.4.1.244 est Lantronix, qui fabrique des serveurs console. Sans cette règle ils apparaissent comme des commutateurs, car ils commutent entre ports série et sysServices ne distingue pas les deux.",
  "L'ente 1.3.6.1.4.1.1347 è Kyocera, che fa solo stampanti. Senza questa regola le multifunzione risultano router: dichiarano il bit di instradamento e la descrizione non nomina la stampa.":
    "L'entreprise 1.3.6.1.4.1.1347 est Kyocera, qui ne fabrique que des imprimantes. Sans cette règle les multifonctions apparaissent comme des routeurs : elles déclarent le bit de routage et la description ne nomme pas l'impression.",
  "L'ente 1.3.6.1.4.1.2435 è Brother, che fa solo stampanti. Senza questa regola le multifunzione risultano router: dichiarano il bit di instradamento e la descrizione non nomina la stampa.":
    "L'entreprise 1.3.6.1.4.1.2435 est Brother, qui ne fabrique que des imprimantes. Sans cette règle les multifonctions apparaissent comme des routeurs : elles déclarent le bit de routage et la description ne nomme pas l'impression.",
  "L'ente 1.3.6.1.4.1.367 è Ricoh, che fa solo stampanti. Senza questa regola le multifunzione risultano router: dichiarano il bit di instradamento e la descrizione non nomina la stampa.":
    "L'entreprise 1.3.6.1.4.1.367 est Ricoh, qui ne fabrique que des imprimantes. Sans cette règle les multifonctions apparaissent comme des routeurs : elles déclarent le bit de routage et la description ne nomme pas l'impression.",
  "L'ente 1.3.6.1.4.1.641 è Lexmark, che fa solo stampanti. Senza questa regola le multifunzione risultano router: dichiarano il bit di instradamento e la descrizione non nomina la stampa.":
    "L'entreprise 1.3.6.1.4.1.641 est Lexmark, qui ne fabrique que des imprimantes. Sans cette règle les multifonctions apparaissent comme des routeurs : elles déclarent le bit de routage et la description ne nomme pas l'impression.",
  "L'ente 1.3.6.1.4.1.7745 è Aethra Telecommunications, che fa router e gateway d'accesso. Senza questa regola un SV6044 resta non classificato e va assegnato a mano, perché la sua descrizione nomina «Aethra», non «router».":
    "L'entreprise 1.3.6.1.4.1.7745 est Aethra Telecommunications, qui fabrique des routeurs et des passerelles d'accès. Sans cette règle un SV6044 reste non classé et doit être assigné à la main, car sa description nomme « Aethra », non « routeur ».",
  'Report disponibili': "Rapports disponibles",
  'Responsabile': "Responsable",
  'Reti interne': "Réseaux internes",
  '«Riapplica» serve dopo un rinnovo fatto fuori da qui — certbot da cron, per esempio — che aggiorna il file senza avvisare il bilanciatore: altrimenti continuerebbe a servire il precedente fino al riavvio, e il browser mostrerebbe ancora quello scaduto.': "«Réappliquer» sert après un renouvellement effectué hors d'ici — certbot depuis cron, par exemple — qui met à jour le fichier sans prévenir l'équilibreur : sinon il continuerait à servir le précédent jusqu'au redémarrage, et le navigateur afficherait encore celui qui a expiré.",
  'Ricerca': "Recherche",
  'Ricevono solo le discovery che non hanno scelto un gruppo. Si assegnano a un gruppo dalla scheda della singola sonda.': "Elles ne reçoivent que les découverte qui n'ont pas choisi de groupe. On les affecte à un groupe depuis la fiche de chaque sonde.",
  'Ricevuti': "Reçus",
  'Uso CPU': "Utilisation CPU",
  'Uso memoria': "Utilisation mémoire",
  'Uso disco': "Utilisation disque",
  'Riferimento': "Référence",
  'Righe': "Lignes",
  'Righe non valide:': "Lignes non valides :",
  'Rileva i collegamenti tra apparati (CDP/LLDP)': "Détecte les liaisons entre équipements (CDP/LLDP)",
  'Rilevato tramite': "Détecté via",
  'Rimuovi il traffico più vecchio di (giorni)': "Supprimer le trafic plus ancien que (jours)",
  'Ripartizione per servizio': "Répartition par service",
  'Riserva': "Réserve",
  'Risoluzione DNS inversa': "Résolution DNS inverse",
  'Risorse': "Ressources",
  'Ritardo casuale (s)': "Délai aléatoire (s)",
  'Ritentativi': "Nouvelles tentatives",
  'Riusciti': "Réussis",
  'Rivedi i piani': "Revoir les forfaits",
  'Rollup (giorni)': "Rollup (jours)",
  'Rollup orario': "Rollup horaire",
  'Ruolo': "Rôle",
  'Ruolo nel gruppo': "Rôle dans le groupe",
  'Ruolo su questo tenant': "Rôle sur ce tenant",
  'Salta e riparti dalla prossima': "Sauter et repartir de la suivante",
  'Salta questo turno': "Sauter ce tour",
  'Saltati': "Sautés",
  'Salva in CMDB gli host raggiungibili ma non inventariabili. Richiede la verifica di raggiungibilità.': "Enregistre dans le CMDB les hôtes joignables mais non inventoriables. Nécessite la vérification de joignabilité.",
  'Scadenza': "Échéance",
  'Scansione': "Analyse",
  'Scansione notturna sede': "Analyse nocturne du site",
  'Esclude sempre il traffico indicato, in entrambe le direzioni, anche tra asset interni.':
    "Toujours écartés, dans les deux sens, même s'ils sont internes — c'est le seul moyen d'exclure la sauvegarde nocturne, qui est interne par définition.",
  'Scegli…': "Choisir…",
  'scegli o scrivi': "choisir ou saisir",
  'scegli o scrivi il nome': "choisir ou saisir le nom",
  "Scegliere la sonda è scegliere la rete da cui guardare: da un'altra rete la stessa scansione non fallisce, restituisce un inventario vuoto.": "Choisir la sonde, c'est choisir le réseau depuis lequel observer : depuis un autre réseau la même analyse n'échoue pas, elle renvoie un inventaire vide.",
  'Scelta da una persona: le regole non la toccano': "Choisie par une personne : les règles n'y touchent pas",
  'Scheda del bene': "Fiche du bien",
  'scheda di un CI': "fiche d'un CI",
  'Sconosciute': "Inconnues",
  'Sconsigliata.': "Déconseillée.",
  'scoperto': "découvert",
  'Scrivi anche il software installato': "Écrire aussi le logiciel installé",
  'Se la precedente è ancora in corso': "Si la précédente est encore en cours",
  'Se lo lasci vuoto la sonda userà il proprio hostname.': "Si vous le laissez vide, la sonde utilisera son propre hostname.",
  "Se quella sonda non risponde, l'agente consegna al Control Plane e lo dichiara nel proprio log: l'inventario non si ferma, e la sonda da riparare resta visibile.": "Si cette sonde ne répond pas, l'agent transmet au Control Plane et le déclare dans son log : l'inventaire ne s'arrête pas, et la sonde à réparer reste visible.",
  'Sede di Bergamo': "Site de Bergame",
  'Seleziona…': "Sélectionner…",
  "Seleziona una riga per vedere le porte dell'apparato.": "Sélectionnez une ligne pour voir les ports de l'équipement.",
  'Sembra un dettaglio da rubrica, ed è la prima cosa che si cerca alle tre di notte.': "Cela semble un détail de carnet d'adresses, et c'est la première chose que l'on cherche à trois heures du matin.",
  'sempre': "toujours",
  'Senza contratto': "Sans contrat",
  'Senza limiti la sonda esegue tutto ciò che il suo binario sa fare. Limitarle serve a dedicarne una a una funzione sola — per esempio una sonda al solo NetFlow.': "Sans limites, la sonde exécute tout ce que son binaire sait faire. Les limiter sert à en dédier une à une seule fonction — par exemple une sonde au seul NetFlow.",
  'Senza questo dato la data mostrata coincide con la scadenza, e si crede di avere tempo fino a quel giorno.': "Sans cette donnée, la date affichée coïncide avec l'échéance, et l'on croit avoir du temps jusqu'à ce jour-là.",
  'senza scadenza': "sans échéance",
  "Senza, un valore di 12.000 non dice se è il canone dell'anno o del mese.": "Sans cela, une valeur de 12 000 ne dit pas s'il s'agit du montant de l'année ou du mois.",
  'Senza, una sola riga sbagliata annulla tutto: un pool a metà sembra completo.': "Sans cela, une seule ligne erronée annule tout : un pool à moitié semble complet.",
  'separati da virgola': "séparés par une virgule",
  'Serial Number': "Serial Number",
  'Serie temporali del traffico': "Séries temporelles du trafic",
  'Serve il MIB di prodotto di questo costruttore': "Il faut le MIB produit de ce constructeur",
  'Serve per le macchine che la sonda non riesce a interrogare: un server in cloud, un host dietro un firewall.': "Utile pour les machines que la sonde n'arrive pas à interroger : un serveur dans le cloud, un hôte derrière un firewall.",
  'Server ERP in cloud': "Serveur ERP dans le cloud",
  'Servizi definiti': "Services définis",
  'Servizi di business': "Services métier",
  'Servizi osservati': "Services observés",
  'Servizio': "Service",
  'Servono quando le sonde sono più di una e non vedono la stessa rete: un gruppo dice «una qualunque di queste va bene». Con una sonda sola non serve a niente.': "Ils servent quand il y a plusieurs sondes qui ne voient pas le même réseau : un groupe dit «n'importe laquelle de celles-ci convient». Avec une seule sonde, cela ne sert à rien.",
  'Sezioni': "Sections",
  "Si applica alla cattura diretta: scegli prima un'interfaccia.": "S'applique à la capture directe : choisissez d'abord une interface.",
  'Si eseguono nell’ordine, su ogni indirizzo separatamente.': "Elles s'exécutent dans l'ordre, sur chaque adresse séparément.",
  'Si popola con una discovery SNMP. Compaiono anche gli apparati non ancora classificati: sono quelli che più spesso si vogliono guardare.': "Se remplit avec une découverte SNMP. Apparaissent aussi les équipements pas encore classés : ce sont ceux que l'on veut le plus souvent examiner.",
  'Si registrano solo i cambiamenti di valore: un CI appena scoperto non ne ha, e una discovery che riscrive gli stessi dati non ne produce.': "On n'enregistre que les changements de valeur : un CI qui vient d'être découvert n'en a pas, et une découverte qui réécrit les mêmes données n'en produit pas.",
  'Sistema': "Système",
  'Sistema operativo della sonda': "Système d'exploitation de la sonde",
  'SLC8016': "SLC8016",
  'SNMP standard': "SNMP standard",
  'snmp-readonly-sede': "snmp-readonly-sede",
  'Solo ciò che è collegato direttamente': "Seulement ce qui est connecté directement",
  'solo dove il prodotto lo distingue': "seulement là où le produit le distingue",
  'Sonar': "Sonar",
  'Sonda': "Sonde",
  'sonde': "sondes",
  'Sonde comprese': "Sondes comprises",
  'Sonde registrate': "Sondes enregistrées",
  'Sorgenti dei flussi': "Sources des flux",
  'Sospendi dopo N fallimenti': "Suspendre après N échecs",
  'sospesa': "suspendue",
  'sostituito, restituito al noleggio, rottamato…': "remplacé, restitué à la location, mis au rebut…",
  'Spazio': "Espace",
  'Spazio occupato': "Espace occupé",
  'Spazio totale': "Espace total",
  'Spente da un amministratore': "Éteintes par un administrateur",
  'Sposta la messa a fuoco su questo nodo': "Déplace la mise au point sur ce nœud",
  'Stato': "État",
  'Stato nel tempo': "État dans le temps",
  'Store attivo': "Magasin actif",
  'Su Linux o macOS': "Sur Linux ou macOS",
  'Su Windows (PowerShell come amministratore)': "Sur Windows (PowerShell en administrateur)",
  'Tabella': "Tableau",
  'tecnici@esempio.it': "tecnici@esempio.it",
  'Telemetria': "Télémétrie",
  'Tema della console': "Thème de la console",
  'Tenant': "Tenant",
  'Tenant su cui operare': "Tenant sur lequel opérer",
  'Tipo': "Type",
  'Tipo dell’oggetto da creare': "Type de l’objet à créer",
  'Tipo di scansione': "Type d’analyse",
  'Togli la condizione': "Retirer la condition",
  'Togliere dalla CMDB': "Retirer de la CMDB",
  'Totale': "Total",
  'Tracciabilità': "Traçabilité",
  'Traffico da conservare': "Trafic à conserver",
  'Trasmessi': "Transmis",
  'Tutte': "Toutes",
  'tutte le condizioni': "toutes les conditions",
  'Tutte le fasi': "Toutes les phases",
  'Tutte le relazioni insieme': "Toutes les relations ensemble",
  'tutti': "tous",
  'Tutti': "Tous",
  'tutti i connettori': "tous les connecteurs",
  'Tutti i pacchetti': "Tous les paquets",
  'Ultima': "Dernière",
  'Ultima consegna': "Dernière livraison",
  'Ultima esecuzione': "Dernière exécution",
  'Ultime discovery': "Dernières découverte",
  'Ultimi 30 giorni': "30 derniers jours",
  'Ultimi 7 giorni': "7 derniers jours",
  'Ultimi 90 giorni': "90 derniers jours",
  'Ultimo anno': "Dernière année",
  'Ultimo esito': "Dernier résultat",
  'Ultimo heartbeat': "Dernier heartbeat",
  'Ultimo rilevamento': "Dernière détection",
  'Un blocco senza condizioni corrisponderebbe a ogni apparato: aggiungine almeno una, o togli il blocco.': "Un bloc sans conditions correspondrait à chaque équipement : ajoutez-en au moins une, ou retirez le bloc.",
  'Un gruppo vuoto non servirebbe a niente: una discovery che lo usasse non avrebbe nulla da provare, e ogni apparato risulterebbe irraggiungibile — che si legge come un problema di rete.': "Un groupe vide ne servirait à rien : une découverte qui l’utiliserait n’aurait rien à sonder, et chaque équipement apparaîtrait comme injoignable — ce qui se lit comme un problème de réseau.",
  'Un indirizzo, non un nome: nei flussi i nomi non compaiono, e cercarli darebbe sempre un risultato vuoto — che si legge come «non parla con nessuno».': "Une adresse, pas un nom : dans les flux les noms n’apparaissent pas, et les chercher donnerait toujours un résultat vide — ce qui se lit comme « ne communique avec personne ».",
  'Configura il piano di discovery definendo metodi di scansione, credenziali e sequenza di esecuzione. Il job associa il piano al Pool di asset e avvia la discovery sui target compresi nel perimetro configurato.':
    'Définissez comment exécuter la découverte sur le périmètre configuré dans le portefeuille d’actifs : choisissez les méthodes, les identifiants et l’ordre d’exécution ; puis associez le plan et le pool au job pour lancer l’analyse des cibles incluses.',
  'Un piano senza passi non raccoglierebbe niente. Aggiungine uno qui sotto.': "Un plan sans étapes ne collecterait rien. Ajoutez-en une ci-dessous.",
  'Un pool raccoglie le subnet di una sede o di un ambiente: si scrive una volta e lo richiamano tutte le scansioni.': "Un pool regroupe les sous-réseaux d’un site ou d’un environnement : il s’écrit une fois et toutes les analyses le réutilisent.",
  'Una mappatura dice cosa sincronizzare, in quale direzione e ogni quanto.': "Un mappage indique quoi synchroniser, dans quel sens et à quelle fréquence.",
  'Una sonda del gruppo, scelta con la politica di assegnazione del gruppo.': "Une sonde du groupe, choisie selon la politique d’affectation du groupe.",
  'Uptime': "Uptime",
  'Utenti abilitati su questo tenant': "Utilisateurs autorisés sur ce tenant",
  'Configura le credenziali SNMP, SSH e WinRM utilizzate dalle sonde per interrogare gli asset. Associa a ogni rete o zona il relativo gruppo di credenziali e definisci l’ordine di verifica: la sonda le prova in sequenza fino alla prima autenticazione riuscita e il report indica quella utilizzata. Le credenziali delle piattaforme infrastrutturali, come vCenter, NexaVM e OceanStor, sono gestite in questa sezione; quelle dei sistemi interrogati in tempo reale nelle rispettive Connessioni, mentre ntopng è configurato in Integrazioni → Sorgenti dati.': 'Configurez les identifiants SNMP, SSH et WinRM utilisés par les sondes pour interroger les actifs. Associez à chaque réseau ou zone son groupe d’identifiants et définissez l’ordre de vérification : la sonde les essaie l’un après l’autre jusqu’à la première authentification réussie, et le rapport indique celui utilisé. Les identifiants des plateformes d’infrastructure, comme vCenter, NexaVM et OceanStor, sont gérés dans cette section ; ceux des systèmes interrogés en temps réel dans leurs Connexions respectives, tandis que ntopng se configure dans Intégrations → Sources de données.',
  'Vai al registro dei beni →': "Aller au registre des biens →",
  'Vale per i report che guardano un periodo; gli altri la ignorano.': "Vaut pour les rapports qui portent sur une période ; les autres l’ignorent.",
  'Validità del segreto (giorni)': "Validité du secret (jours)",
  'valore': "valeur",
  'Valore': "Valeur",
  'Valore di acquisto': "Valeur d’acquisition",
  'Velocità': "Vitesse",
  'Verifica raggiungibilità prima di interrogare': "Vérifier l’accessibilité avant d’interroger",
  'Verifica sessione…': "Vérification de la session…",
  'vero': "vrai",
  'Versione': "Version",
  'API': "API",
  'Build': "Build",
  'Gestore': "Gestionnaire",
  '{env} · versioni': "{env} · versions",
  'Versione della sonda': "Version de la sonde",
  'Versione delle sonde': "Version des sondes",
  'Verso': "Sens",
  'Verso quale oggetto': "Vers quel objet",
  'Vicini per nodo': "Voisins par nœud",
  'Vista': "Vue",
  'Viste salvate': "Vues enregistrées",
  'Visto': "Vu",
  'VLAN stampanti': "VLAN imprimantes",
  'Volume': "Volume",
  'volume del Control Plane': "volume du Control Plane",
  'Volume totale': "Volume total",
  'Vuoto: la sonda si dimensiona sui propri core.': "Vide : la sonde se dimensionne sur ses propres cœurs.",
  'Annulla': "Annuler",
  'Annulla la scelta': "Annuler le choix",
  'assegnata a mano': "affectée à la main",
  'Nome con cui è identificato il collegamento, utile per distinguere ambienti diversi, ad esempio produzione e collaudo.': 'Nom qui identifie la liaison, utile pour distinguer différents environnements, par exemple production et recette.',
  'Completo — dischi, servizi, account, sicurezza': "Complet — disques, services, comptes, sécurité",
  'Configurato. Non torna indietro dal Control Plane: per sostituirlo premi «Cambia», altrimenti resta quello.': "Configuré. Il ne revient pas depuis le Control Plane : pour le remplacer, appuyez sur « Changer », sinon il reste tel quel.",
  'Elimina il pool': "Supprimer le pool",
  'Elimina registrazione': "Supprimer l’enregistrement",
  'È il campo con cui si riconosce «lo stesso oggetto». Sbagliarlo non dà un errore: dà un doppione a ogni esecuzione, e il conteggio resta plausibile.': "C’est le champ qui permet de reconnaître « le même objet ». Se tromper ne produit pas d’erreur : cela crée un doublon à chaque exécution, et le décompte reste plausible.",
  'Esci': "Quitter",
  'Ho finito': "J’ai terminé",
  'Ho finito, chiudi': "J’ai terminé, fermer",
  'Firma del pacchetto (GPG)': 'Signature du paquet (GPG)',
  'Gli RPM sono firmati: importa la chiave pubblica e verifica la firma prima di installare. Per un repository, metti la chiave e gpgcheck=1.':
    "Les RPM sont signés : importez la clé publique et vérifiez la signature avant d’installer. Pour un dépôt, ajoutez la clé et gpgcheck=1.",
  'Scarica la chiave pubblica': 'Télécharger la clé publique',
  'Opzioni della riga di comando (censo-inventory)': 'Options de la ligne de commande (censo-inventory)',
  'Gli stessi flag su Windows, Linux e macOS. Di norma non servono — il comando qui sopra li imposta già.':
    'Les mêmes options sous Windows, Linux et macOS. En général inutiles — la commande ci-dessus les définit déjà.',
  'Stampa la versione ed esce.': 'Affiche la version et quitte.',
  'File di configurazione da usare (predefinito: accanto all’eseguibile).':
    "Fichier de configuration à utiliser (par défaut : à côté de l’exécutable).",
  'Quanto raccogliere (vuoto = quello scelto qui).': 'Quantité à collecter (vide = le choix fait ici).',
  'Resta in esecuzione: keep-alive ogni minuto, inventario all’intervallo scelto.':
    "Reste en exécution : keep-alive chaque minute, inventaire à l’intervalle choisi.",
  'Non registra il sorvegliante (su Windows l’attività pianificata): lo avvia un supervisore esterno. Come la variabile CENSO_NO_WATCHDOG.':
    "N’enregistre pas le surveillant (sous Windows la tâche planifiée) : un superviseur externe le démarre. Comme la variable CENSO_NO_WATCHDOG.",
  'Raccoglie e mostra l’inventario senza sigillarlo né consegnarlo.':
    "Collecte et affiche l’inventaire sans le sceller ni le livrer.",
  'Scrive la busta sigillata su file invece di consegnarla (per reti senza uscita).':
    "Écrit l’enveloppe scellée dans un fichier au lieu de la livrer (pour les réseaux sans sortie).",
  'Quanto attendere la consegna (predefinito 30 secondi).': 'Combien de temps attendre la livraison (par défaut 30 secondes).',
  'Elenca a video ogni dato non letto.': 'Liste à l’écran chaque donnée non lue.',
  'L’agente si installa da solo (accetta -config, -force, -no-watchdog).':
    "L’agent s’installe tout seul (accepte -config, -force, -no-watchdog).",
  'Disinstalla l’agente (lo usa anche l’MSI di Windows in rimozione).':
    "Désinstalle l’agent (utilisé aussi par le MSI Windows lors de la suppression).",
  'ignoto': "inconnu",
  'Il numero è quanti ne ha questo cliente adesso: è ciò che dice se il filtro sta per prendere l’insieme che hai in mente o un decimo.': "Le nombre est celui que ce client possède actuellement : c’est ce qui indique si le filtre va prendre l’ensemble que vous avez en tête ou un dixième.",
  'Il piano non è eseguibile: gli errori qui sopra vanno risolti. Gli avvisi no — un ordine costoso è una scelta.': "Le plan n’est pas exécutable : les erreurs ci-dessus doivent être résolues. Les avertissements non — un ordre coûteux est un choix.",
  'La credenziale del sistema di destinazione passerà da questa sonda: cifrata in transito, mai su disco, mai nei log.': "L’identifiant du système de destination passera par cette sonde : chiffré en transit, jamais sur disque, jamais dans les logs.",
  'Le azioni di questa pagina valgono per tutti i clienti': "Les actions de cette page valent pour tous les clients",
  'manca': "manque",
  'Mostra il JSON completo — serve quando un attributo nuovo non ha ancora una resa dedicata': "Afficher le JSON complet — utile quand un nouvel attribut n’a pas encore de rendu dédié",
  'Nessuna vista salvata.': "Aucune vue enregistrée.",
  'Non dichiarata da questa sonda: il suo binario non la implementa. Aggiornala per renderla disponibile.': "Non déclarée par cette sonde : son binaire ne l’implémente pas. Mettez-la à jour pour la rendre disponible.",
  'Andamento dello storage usato con proiezione': "Évolution du stockage utilisé avec projection",
  'Crescita al giorno': "Croissance par jour",
  'Crescita/giorno': "Croissance/jour",
  'Giorni al pieno': "Jours avant saturation",
  'La serie storica si sta riempiendo: un campione al giorno per datastore. Il grafico compare con i primi punti, la proiezione dopo una settimana.': "La série historique se remplit : un échantillon par jour et par datastore. Le graphique apparaît avec les premiers points, la projection après une semaine.",
  'Pieno fra': "Saturé dans",
  'Proiezione': "Projection",
  'pieno · {d}': "saturé · {d}",
  '~{n} giorni': "~{n} jours",
  'ospite': "invité",
  'Prova': "Test",
  'provata per prima': "testée en premier",
  'Riapplica quello sul disco': "Réappliquer celui sur le disque",
  'Rimuovi sonda': "Retirer la sonde",
  'Salva le condizioni': "Enregistrer les conditions",
  'Salva nota': "Enregistrer la note",
  'sconsigliata': "déconseillée",
  'senza segreto': "sans secret",
  'Sono un suggerimento: chi avvia la scansione può sostituirli, ed è il motivo per cui lo stesso piano si riusa su reti diverse.': "Ce sont des suggestions : qui lance l’analyse peut les remplacer, et c’est la raison pour laquelle le même plan se réutilise sur des réseaux différents.",
  'spegni il radar': "éteindre le radar",
  'spegni il sonar': "éteindre le sonar",
  'togli': "retirer",
  'Un fatto lasciato vuoto è «non raccolto», e non soddisfa nessuna condizione.': "Un fait laissé vide est « non collecté », et ne satisfait aucune condition.",
  'Per i sistemi raggiungibili solo dalla rete interna, le chiamate devono essere eseguite tramite una sonda con accesso alla rete di destinazione.': 'Pour les systèmes joignables uniquement depuis le réseau interne, les appels doivent être effectués via une sonde ayant accès au réseau de destination.',
  'Vale per quel bersaglio soltanto: su una scansione di rete il fallimento su un indirizzo è il caso normale.': "Vaut pour cette cible uniquement : lors d’une analyse réseau, l’échec sur une adresse est le cas normal.",
  'Vale solo dopo la prima sincronizzazione riuscita: la pianificazione si accende in un secondo momento.': "Vaut seulement après la première synchronisation réussie : la planification s’active dans un second temps.",
  'Verifica il certificato TLS del sistema. Disabilitala solo se il certificato interno non può essere validato tramite una CA attendibile.': 'Vérifie le certificat TLS du système. Ne la désactivez que si le certificat interne ne peut pas être validé par une AC de confiance.',
  '(centra)': "(centrer)",
  '+ condizione': "+ condition",
  'Aggiorna': "Actualiser",
  'Aggiungi al pool': "Ajouter au pool",
  'Aggiungi ambito': "Ajouter un périmètre",
  'Aggiungi categoria': "Ajouter une catégorie",
  'Aggiungi classe': "Ajouter une classe",
  'Aggiungi condizione': "Ajouter une condition",
  'Aggiungi ingresso': "Ajouter une entrée",
  'Aggiungi la coppia': "Ajouter la paire",
  'Aggiungi un blocco (oppure)': "Ajouter un bloc (ou)",
  'Aggiungi un gruppo': "Ajouter un groupe",
  'Aggiungi una condizione (e)': "Ajouter une condition (et)",
  'Applica': "Appliquer",
  'Avvia ora': "Lancer maintenant",
  'Azzera': "Réinitialiser",
  'Azzera filtri': "Effacer les filtres",
  'filtra…': "filtrer…",
  'Wazuh': "Wazuh",
  'Stato dell’agente e conformità, chiesti a Wazuh al momento tramite la sonda.':
    "État de l'agent et conformité, demandés à Wazuh à l'instant via la sonde.",
  'Wazuh non è interrogabile.': "Wazuh n'est pas interrogeable.",
  'Nessun agente Wazuh su questo host': "Aucun agent Wazuh sur cet hôte",
  'Ultimo log ricevuto da Wazuh: {quando}': "Dernier log reçu par Wazuh : {quando}",
  'Clicca una CVE per gli host colpiti e i pacchetti da aggiornare.':
    "Cliquez sur une CVE pour les hôtes touchés et les paquets à mettre à jour.",
  'Nessun host trovato per questa CVE.': "Aucun hôte trouvé pour cette CVE.",
  'Pacchetti da aggiornare': "Paquets à mettre à jour",
  'Wazuh non ha un agente per questo host, né allarmi da log inviati via syslog a suo nome.':
    "Wazuh n'a pas d'agent pour cet hôte, ni d'alertes issues de logs transmis par syslog à son nom.",
  'Questo apparato non ha un agente Wazuh, ma invia i suoi log a Wazuh (syslog): qui sotto gli allarmi generati da quei log. Conformità (SCA) e vulnerabilità richiedono un agente installato e non sono disponibili.':
    "Cet équipement n'a pas d'agent Wazuh, mais transmet ses logs à Wazuh (syslog) : ci-dessous les alertes que ces logs ont déclenchées. La conformité (SCA) et les vulnérabilités nécessitent un agent installé et ne sont pas disponibles.",
  'Agente': "Agent",
  'Ultimo keep-alive': "Dernier keep-alive",
  'Conformità (SCA / CIS)': "Conformité (SCA / CIS)",
  'Nessuna policy SCA valutata su questo agente.': "Aucune politique SCA évaluée sur cet agent.",
  'Policy': "Politique",
  'Superati': "Réussis",
  'Ultima scansione': "Dernière analyse",
  'disconnesso': "déconnecté",
  'mai connesso': "jamais connecté",
  'Allarmi rilevanti': "Alertes pertinentes",
  'Allarmi e vulnerabilità richiedono l’Indexer di Wazuh, non configurato in questa credenziale.':
    "Les alertes et vulnérabilités nécessitent l'Indexer Wazuh, non configuré dans ces identifiants.",
  'Nessun allarme di livello ≥ 7 negli ultimi 7 giorni.': "Aucune alerte de niveau ≥ 7 au cours des 7 derniers jours.",
  'Ultimo': "Dernier",
  'Vulnerabilità': "Vulnérabilités",
  '(+{n} pacchetti)': "(+{n} paquets)",
  'La prima idonea': "La première éligible",
  '{n} configurati': "{n} configurés",
  'Firewall': "Pare-feu",
  'Firewall non interrogabile.': "Pare-feu non interrogeable.",
  'Traffico che il firewall ha bloccato da/verso questo host, dai log in Wazuh (ultimi 7 giorni).':
    "Trafic que le pare-feu a bloqué vers/depuis cet hôte, à partir des logs dans Wazuh (7 derniers jours).",
  'Niente bloccato dal firewall': "Rien bloqué par le pare-feu",
  'Nessun traffico da/verso questo host risulta bloccato dal firewall negli ultimi 7 giorni.':
    "Aucun trafic vers/depuis cet hôte n'a été bloqué par le pare-feu ces 7 derniers jours.",
  'Bloccati (7g)': "Bloqués (7 j)",
  'Traffico dal firewall': "Trafic du pare-feu",
  'Bloccato dal firewall': "Bloqué par le pare-feu",
  'Ultimo traffico che il firewall ha visto da/verso questo host, letto in tempo reale via sonda.':
    'Dernier trafic que le pare-feu a vu vers/depuis cet hôte, lu en temps réel via la sonde.',
  'Scegli un firewall…': "Choisir un pare-feu…",
  'Solo bloccato': "Bloqué uniquement",
  'Scegli quale firewall': "Choisir quel pare-feu",
  'Sono configurati più firewall: scegline uno qui sopra per vedere il traffico di questo host.':
    "Plusieurs pare-feu sont configurés : choisissez-en un ci-dessus pour voir le trafic de cet hôte.",
  'Nessun traffico sul firewall': "Aucun trafic sur le pare-feu",
  'Il firewall non ha righe recenti per gli indirizzi di questo host.':
    "Le pare-feu n'a aucune entrée récente pour les adresses de cet hôte.",
  'Ora': "Heure",
  'Cruscotto firewall': "Tableau de bord du pare-feu",
  'Attivo da': "Actif depuis",
  'Client GlobalProtect': "Client GlobalProtect",
  'Sessioni e traffico': "Sessions et trafic",
  'Sessioni attive': "Sessions actives",
  'Nuove sessioni/s': "Nouvelles sessions/s",
  'Utenti VPN connessi': "Utilisateurs VPN connectés",
  'Nessun utente VPN connesso.': "Aucun utilisateur VPN connecté.",
  'IP virtuale': "IP virtuelle",
  'Dal': "Depuis",
  'Amministratori collegati': "Administrateurs connectés",
  'Nessun amministratore collegato.': "Aucun administrateur connecté.",
  'Amministratore': "Administrateur",
  'Inattivo da': "Inactif depuis",
  'tu': "vous",
  'Applicazioni più usate': "Applications les plus utilisées",
  'Le applicazioni con più sessioni nelle ultime 24 ore.':
    "Les applications avec le plus de sessions ces dernières 24 heures.",
  'Nessun dato applicativo.': "Aucune donnée applicative.",
  'Sessioni': "Sessions",
  'Byte': "Octets",
  'Minacce recenti': "Menaces récentes",
  'Le ultime minacce rilevate dal firewall (antivirus, anti-spyware, IPS).':
    "Les dernières menaces détectées par le pare-feu (antivirus, anti-spyware, IPS).",
  'Nessuna minaccia recente': "Aucune menace récente",
  'Il firewall non ha minacce recenti da mostrare.':
    "Le pare-feu n'a aucune menace récente à afficher.",
  'Minaccia': "Menace",
  'URL filtering': "Filtrage d'URL",
  'Firewall configurati': "Pare-feu configurés",
  'Firewall configurati e interrogazione in tempo reale dei relativi log tramite sonda.': 'Pare-feu configurés et interrogation en temps réel de leurs journaux via la sonde.',
  'Nessun firewall configurato': "Aucun pare-feu configuré",
  'Log Query': "Requête de journaux",
  'Interroga un firewall per IP sorgente e/o destinazione e mostra il traffico rilevato, consentito o bloccato. L’opzione «Solo bloccato» limita i risultati al traffico negato.': 'Interroge un pare-feu par IP source et/ou destination et affiche le trafic vu, autorisé ou bloqué. L’option «Solo bloccato» limite les résultats au trafic refusé.',
  'IP sorgente': "IP source",
  'IP destinazione': "IP destination",
  'Interroga': "Interroger",
  'Scegli quale firewall interrogare.': "Choisissez quel pare-feu interroger.",
  'Nessun traffico': "Aucun trafic",
  'Il firewall non ha righe recenti per gli IP indicati.':
    "Le pare-feu n'a aucune entrée récente pour les IP indiquées.",
  'Accessi VPN falliti': "Connexions VPN échouées",
  'Accessi al sistema falliti': "Connexions au système échouées",
  'Gateway/Portale': "Passerelle/Portail",
  'Messaggio': "Message",
  'Gli ultimi tentativi di accesso VPN non riusciti (GlobalProtect, SSL VPN, IPsec).':
    'Les dernières tentatives de connexion VPN échouées (GlobalProtect, SSL VPN, IPsec).',
  'Gli ultimi accessi amministrativi al firewall non riusciti (autenticazione fallita).':
    "Les dernières connexions administratives au pare-feu échouées (authentification échouée).",
  'Nessun accesso VPN fallito': "Aucune connexion VPN échouée",
  'Nessun tentativo VPN fallito di recente.': "Aucune tentative VPN échouée récemment.",
  'Nessun accesso al sistema fallito': "Aucune connexion au système échouée",
  'Nessuna autenticazione amministrativa fallita di recente.':
    "Aucune authentification administrative échouée récemment.",
  'Inventario virtuale': "Inventaire virtuel",
  'censisce VM, host, cluster, datastore e reti rilevati dai connettori di virtualizzazione, consultabili a video o esportabili in Excel, con un livello di dettaglio analogo a RVTools.': 'Recense les VM, hôtes, clusters, datastores et réseaux détectés par les connecteurs de virtualisation, consultables à l’écran ou exportables vers Excel, avec un niveau de détail comparable à RVTools.',
  'Tutto l’ambiente virtuale': "Tout l'environnement virtuel",
  'Esporta Excel': "Exporter Excel",
  'Esporta PDF': "Exporter PDF",
  'Elenco dei software, Scadenze, Licenze e Application Maintenance si esportano con i pulsanti «Esporta Excel» e «Esporta PDF» in alto: scaricano la tabella corrente rispettando il filtro in uso (il PDF è il report, con intestazione CENSO; Application Maintenance produce un file con un foglio per Applicazioni, Componenti e Vulnerabilità).':
    "La liste des logiciels, les Échéances, les Licences et Application Maintenance s’exportent avec les boutons « Exporter Excel » et « Exporter PDF » en haut : elles téléchargent le tableau courant en respectant le filtre actif (le PDF est le rapport, avec l’en-tête CENSO ; Application Maintenance produit un fichier avec une feuille pour Applications, Composants et Vulnérabilités).",
  'Esporto…': "Exportation…",
  'Nessun oggetto virtuale': "Aucun objet virtuel",
  'Configura un connettore di virtualizzazione (VMware, Nutanix, Proxmox…) e lancia una raccolta.':
    "Configurez un connecteur de virtualisation (VMware, Nutanix, Proxmox…) et lancez une collecte.",
  'Nessuna riga in questo foglio.': "Aucune ligne dans cette feuille.",
  'Zone': "Zones",
  'Interrogo il DNS…': "Interrogation du DNS…",
  'DNS non interrogabile.': "DNS non interrogeable.",
  'Nessuna zona': "Aucune zone",
  'Il DNS non ha zone, oppure la chiave API non ha i permessi.':
    "Le DNS n'a aucune zone, ou la clé API n'a pas les permissions.",
  'Nessun record': "Aucun enregistrement",
  'disabilitato': "désactivé",
  'Cruscotto': "Tableau de bord",
  'Il cruscotto del firewall selezionato, in tempo reale via sonda.': "Le tableau de bord du pare-feu sélectionné, en temps réel via la sonde.",
  'Scegli un firewall qui sopra per vederne il cruscotto.': "Choisissez un pare-feu ci-dessus pour voir son tableau de bord.",
  'Backup non interrogabile.': "Sauvegarde non interrogeable.",
  'Interrogo il backup…':
    'Interrogation de la sauvegarde…',
  'Job di backup': "Tâches de sauvegarde",
  'Libero': "Libre",
  'Nessun oggetto protetto': "Aucun objet protégé",
  'Nessuna repository': "Aucun référentiel",
  'Oggetti protetti': "Objets protégés",
  'Punti di ripristino': "Points de restauration",
  'Repository': "Référentiel",
  'Successo': "Succès",
  'Il sistema di backup non ha job, oppure l’utenza non ha i permessi.':
    'Le système de sauvegarde n’a aucune tâche, ou le compte n’a pas les droits.',
  'Il sistema di backup non ha oggetti protetti da mostrare.':
    'Le système de sauvegarde n’a aucun objet protégé à afficher.',
  'Job con problemi': "Tâches en anomalie",
  'La copertura di backup di questo oggetto, chiesta al sistema di backup al momento tramite la sonda e abbinata per nome.':
    'La couverture de sauvegarde de cet objet, demandée au système de sauvegarde à l’instant via la sonde et appariée par nom.',
  'Nessun backup per questo oggetto':
    'Aucune sauvegarde pour cet objet',
  'Oggetti di backup': "Objets de sauvegarde",
  'Protetto': "Protégé",
  'Protezione dati': "Protection des données",
  'Nessun sistema di backup ha un oggetto che corrisponde al nome di questo CI: potrebbe non essere protetto, o avere nel backup un nome diverso.':
    'Aucun système de sauvegarde n’a d’objet correspondant au nom de ce CI : il n’est peut-être pas protégé, ou porte un autre nom dans la sauvegarde.',
  '{n} falliti': "{n} échouées",
  'Ultimo backup': "Dernière sauvegarde",
  'Analizzatore di percorso': "Analyseur de chemin",
  'Analizzo il percorso… (aggiorno le rotte dei firewall)':
    "Analyse du chemin… (actualisation des routes des pare-feu)",
  'Interrogo il firewall…': "Interrogation du pare-feu…",
  'Grafo del percorso': "Graphe du chemin",
  'esterno': "extérieur",
  'anello': "boucle",
  'nessuna rotta': "aucune route",
  'ricostruisce il percorso che un pacchetto effettua tra un IP sorgente e uno di destinazione, utilizzando le tabelle di routing acquisite dagli asset di rete.': 'reconstruit le chemin qu’un paquet emprunte entre une IP source et une IP de destination, à partir des tables de routage recueillies auprès des actifs réseau.',
  'Ricostruzione del percorso di routing: calcola il percorso previsto tra sorgente e destinazione dalle tabelle di routing presenti nell’inventario. Riflette l’ultima scansione, non il traffico in tempo reale, e non considera ECMP, policy-based routing, VRF o NAT.': 'Reconstruction du chemin de routage : calcule le chemin prévu entre source et destination à partir des tables de routage présentes dans l’inventaire. Il reflète la dernière analyse, pas le trafic en temps réel, et ne tient pas compte d’ECMP, du policy-based routing, des VRF ni du NAT.',
  'Analizza': "Analyser",
  'Analizzo…': "Analyse…",
  'Riproduci': "Rejouer",
  'Destinazione raggiunta': "Destination atteinte",
  'Esce verso l’esterno': "Sort vers l'extérieur",
  'Stessa rete': "Même réseau",
  'Nessuna rotta': "Aucune route",
  'Anello di routing': "Boucle de routage",
  'Sorgente sconosciuta': "Source inconnue",
  'Nessun salto da mostrare': "Aucun saut à afficher",
  'rotta': "route",
  'uscita': "sortie",
  'connessa': "connectée",
  'Stato sessione': "État de session",
  'Byte inviati': "Octets envoyés",
  'Byte ricevuti': "Octets reçus",
  'Pacchetti': "Paquets",
  'ID sessione': "ID de session",
  'Comprimi': "Réduire",
  'Espandi': "Développer",
  'Cosa significano gli stati di sessione': "Ce que signifient les états de session",
  'Routing': "Routage",
  'Sincronizza dal firewall': "Synchroniser depuis le pare-feu",
  'Sincronizzo…': "Synchronisation…",
  '{n} rotte sincronizzate dal firewall.': "{n} routes synchronisées depuis le pare-feu.",
  'Metrica': "Métrique",
  'Next hop': "Saut suivant",
  'Aggiorno…': "Actualisation…",
  'Nessuna rotta raccolta': "Aucune route collectée",
  '{n} rotte': "{n} routes",
  'Tabelle di routing (L3)': "Tables de routage (L3)",
  'Nessun risultato per i filtri impostati.': "Aucun résultat pour les filtres appliqués.",
  'Lancia una discovery SNMP approfondita con l’opzione «Tabelle di routing» su questo apparato.':
    "Lancez une découverte SNMP approfondie avec l'option « Tables de routage » sur cet appareil.",
  'Raccoglie la tabella di routing dell’apparato via SNMP (inetCidrRoute/ipCidrRoute/ipRoute), mostrata nella sezione «Routing» del CI. Richiede la discovery approfondita. Su un router con molte rotte è voluminosa: è troncata a un tetto.':
    "Collecte la table de routage de l'appareil via SNMP (inetCidrRoute/ipCidrRoute/ipRoute), affichée dans la section « Routage » du CI. Nécessite la découverte approfondie. Sur un routeur avec de nombreuses routes, elle est volumineuse : elle est plafonnée.",
  'Applicazioni più bloccate': "Applications les plus bloquées",
  'Le applicazioni più negate dalle regole nelle ultime 24 ore.':
    "Les applications les plus refusées par les règles ces dernières 24 heures.",
  'Minacce più frequenti': "Menaces les plus fréquentes",
  'Le minacce con più occorrenze nelle ultime 24 ore.':
    "Les menaces avec le plus d'occurrences ces dernières 24 heures.",
  'Nessuna minaccia nel periodo.': "Aucune menace sur la période.",
  'Genera la chiave dalla password…': "Générer la clé à partir du mot de passe…",
  'Inserisci un amministratore del firewall: la sonda scelta genera la chiave API e la incolla qui sopra. Servono prima l’endpoint e la sonda; la password non viene salvata.':
    "Saisissez un administrateur du pare-feu : la sonde choisie génère la clé API et la remplit ci-dessus. L'endpoint et la sonde sont requis au préalable ; le mot de passe n'est pas enregistré.",
  'Chiave generata e inserita nel campo «Chiave API».':
    "Clé générée et insérée dans le champ « Clé API ».",
  'Genero…': "Génération…",
  'Genera chiave': "Générer la clé",
  'Compila prima l’endpoint del firewall qui sopra.':
    "Renseignez d'abord l'endpoint du pare-feu ci-dessus.",
  'Le ultime richieste web con categoria ed esito (permesse o bloccate).':
    "Les dernières requêtes web avec catégorie et résultat (autorisées ou bloquées).",
  'Nessuna richiesta web recente': "Aucune requête web récente",
  'Il firewall non ha righe di URL filtering da mostrare.':
    "Le pare-feu n'a aucune entrée de filtrage d'URL à afficher.",
  'Bloccato in ingresso': "Bloqué en entrée",
  'Bloccato in uscita': "Bloqué en sortie",
  'Sorgente': "Source",
  'Applicazione': "Application",
  'Bloccati': "Bloqués",
  'Inventario componenti (SFP, schede, alimentatori)': "Inventaire des composants (SFP, cartes, alimentations)",
  'Legge dalla ENTITY-MIB i componenti fisici con il loro seriale. Richiede la discovery approfondita. Le SFP di terze parti spesso non hanno seriale in SNMP: per quelle è più completo l’inventario avanzato via SSH.':
    "Lit les composants physiques avec leur numéro de série depuis ENTITY-MIB. Nécessite la découverte approfondie. Les SFP tierces n'ont souvent pas de série en SNMP : pour celles-ci, l'inventaire avancé via SSH est plus complet.",
  'Sorgenti dati': "Sources de données",
  'Nessuna sorgente disponibile.': "Aucune source disponible.",
  'Le sorgenti live (Wazuh, ntopng…) compaiono qui appena il catalogo le prevede.':
    "Les sources live (Wazuh, ntopng…) apparaissent ici dès que le catalogue les prévoit.",
  'configurato': "configuré",
  'da configurare': "à configurer",
  'Configura': "Configurer",
  'Agenti per stato': "Agents par état",
  'CVE': "CVE",
  'Nome del cluster': "Nom du cluster",
  'FQDN del cluster': "FQDN du cluster",
  'Tipo di cluster': "Type de cluster",
  'Nodi del cluster': "Nœuds du cluster",
  'Indirizzi VIP': "Adresses VIP",
  'Testimone': "Témoin",
  'Quorum': "Quorum",
  'Nessun agente registrato.': "Aucun agent enregistré.",
  'totali': "total",
  'vulnerabilità': "vulnérabilités",
  'Sonda utilizzata come punto di origine della query in tempo reale. L’elenco include solo le sonde con capability abilitata. La sonda deve essere raggiungibile dal sistema.': 'Sonde utilisée comme point d’origine de la requête en temps réel. La liste n’inclut que les sondes dont la capability est activée. La sonde doit pouvoir joindre le système.',
  'Nessuna sonda ha questa capability abilitata: abilitala dalla scheda della sonda che raggiunge il servizio.':
    "Aucune sonde n'a cette capacité activée : activez-la depuis la fiche de la sonde qui joint le service.",
  'Come creo le credenziali Wazuh, e dove?': "Comment créer les identifiants Wazuh, et où ?",
  'Wazuh usa due accessi distinti, entrambi da creare dedicati e in sola lettura: l’utente della API del manager (porta 55000: agenti e conformità SCA) e — se vuoi anche allarmi e vulnerabilità — l’utente dell’Indexer (porta 9200), che è un’utenza separata. Le credenziali di default wazuh/wazuh vanno cambiate, non usate qui.':
    "Wazuh utilise deux accès distincts, tous deux à créer dédiés et en lecture seule : l’utilisateur de l’API du manager (port 55000 : agents et conformité SCA) et — si vous voulez aussi les alertes et les vulnérabilités — l’utilisateur de l’Indexer (port 9200), qui est un compte séparé. Les identifiants par défaut wazuh/wazuh doivent être changés, pas utilisés ici.",
  'A) Utente della Wazuh API (manager, porta 55000)': "A) Utilisateur de l’API Wazuh (manager, port 55000)",
  'Dà accesso ad agenti e SCA. Si crea nella sicurezza della Wazuh API (RBAC), che è separata da quella dell’Indexer.':
    "Donne accès aux agents et au SCA. Il se crée dans la sécurité de l’API Wazuh (RBAC), séparée de celle de l’Indexer.",
  'Dal Wazuh dashboard: menu → Server management → Security (la sicurezza della Wazuh API). Il nome esatto della voce cambia con la versione.':
    "Depuis le tableau de bord Wazuh : menu → Server management → Security (la sécurité de l’API Wazuh). Le nom exact du menu change selon la version.",
  'Crea un utente dedicato e assegnagli un ruolo di sola lettura (va bene la policy di lettura predefinita): deve poter leggere agenti e SCA, niente di più.':
    "Créez un utilisateur dédié et attribuez-lui un rôle en lecture seule (la politique de lecture par défaut convient) : il doit pouvoir lire les agents et le SCA, rien de plus.",
  'In alternativa, dalla riga di comando (cambia password amministrativa e valori del nuovo utente):':
    "Sinon, en ligne de commande (changez le mot de passe administrateur et les valeurs du nouvel utilisateur) :",
  'Metti quell’utente e la sua password nei campi «Utente API» e «Password API», e l’URL del manager (di norma https://indirizzo:55000) in «Endpoint API». La dashboard sta su un’altra porta: qui va l’API.':
    "Mettez cet utilisateur et son mot de passe dans les champs « Utilisateur API » et « Mot de passe API », et l’URL du manager (en général https://adresse:55000) dans « Endpoint API ». Le tableau de bord est sur un autre port : ici, c’est l’API.",
  'B) Utente dell’Indexer (porta 9200) — per allarmi e vulnerabilità':
    "B) Utilisateur de l’Indexer (port 9200) — pour les alertes et les vulnérabilités",
  'Opzionale: senza, la scheda mostra agente e SCA ma non allarmi né vulnerabilità (dalla 4.8 stanno nell’Indexer, non nella API). È un’utenza separata da quella della API.':
    "Facultatif : sans lui, la fiche montre l’agent et le SCA mais ni alertes ni vulnérabilités (depuis la 4.8, elles sont dans l’Indexer, pas dans l’API). C’est un compte séparé de celui de l’API.",
  'Dal Wazuh dashboard: menu → Indexer management → Security → Internal users (la sicurezza di OpenSearch). Crea un utente interno dedicato.':
    "Depuis le tableau de bord Wazuh : menu → Indexer management → Security → Internal users (la sécurité d’OpenSearch). Créez un utilisateur interne dédié.",
  'Assegnagli un ruolo con permesso di LETTURA sugli indici wazuh-alerts-* e wazuh-states-vulnerabilities-*. Non serve il monitoraggio del cluster: la sola lettura dei dati basta.':
    "Attribuez-lui un rôle avec la permission de LECTURE sur les index wazuh-alerts-* et wazuh-states-vulnerabilities-*. La supervision du cluster n’est pas nécessaire : la seule lecture des données suffit.",
  'Metti quell’utente e la sua password nei campi «Utente Indexer» e «Password Indexer», e l’URL dell’Indexer (di norma https://indirizzo:9200) in «Endpoint Indexer». Lascia vuoti questi campi se non ti servono allarmi e vulnerabilità.':
    "Mettez cet utilisateur et son mot de passe dans les champs « Utilisateur Indexer » et « Mot de passe Indexer », et l’URL de l’Indexer (en général https://adresse:9200) dans « Endpoint Indexer ». Laissez ces champs vides si vous n’avez pas besoin des alertes et des vulnérabilités.",
  'C) La sonda che raggiunge Wazuh': "C) La sonde qui joint Wazuh",
  'La query esce in tempo reale da una sonda, non dal cloud: Wazuh vive sulla rete del cliente. La sonda deve raggiungere sia la 55000 sia la 9200 e avere la capability «Wazuh (SIEM/XDR)» abilitata (dalla sua scheda in Sonde). Poi scegli proprio quella nel campo «Sonda»: se ne indichi una che non la raggiunge, ottieni un errore chiaro invece di una risposta sbagliata.':
    "La requête part en temps réel d’une sonde, pas du cloud : Wazuh vit sur le réseau du client. La sonde doit joindre à la fois le 55000 et le 9200 et avoir la capacité « Wazuh (SIEM/XDR) » activée (depuis sa fiche dans Sondes). Choisissez ensuite précisément celle-ci dans le champ « Sonde » : si vous en indiquez une qui ne la joint pas, vous obtenez une erreur claire au lieu d’une mauvaise réponse.",
  'Il certificato di Wazuh è spesso autofirmato: usa il certificato della CA o l’impronta SHA-256; «accetta qualunque certificato» solo se non hai alternative. Un endpoint scritto senza schema riceve https.':
    "Le certificat de Wazuh est souvent auto-signé : utilisez le certificat de la CA ou l’empreinte SHA-256 ; « accepter n’importe quel certificat » seulement si vous n’avez pas d’alternative. Un endpoint écrit sans schéma reçoit https.",
  'Pacchetto': "Paquet",
  'Nessuna vulnerabilità rilevata da Wazuh su questo host.': "Aucune vulnérabilité détectée par Wazuh sur cet hôte.",
  'Agenti, allarmi e vulnerabilità degli asset, sincronizzati in tempo reale con Wazuh.': 'Agents, alertes et vulnérabilités des actifs, synchronisés en temps réel avec Wazuh.',
  'Agenti con allarmi': "Agents avec alertes",
  'Allarmi (ultimi {giorni} giorni)': "Alertes (derniers {giorni} jours)",
  'Allarmi ({giorni}g)': "Alertes ({giorni}j)",
  'Allarmi al giorno': "Alertes par jour",
  'Andamento': "Tendance",
  'CVE più diffuse': "CVE les plus répandues",
  'Critiche e alte': "Critiques et élevées",
  'Host colpiti': "Hôtes touchés",
  'Host più colpiti': "Hôtes les plus touchés",
  'Nessun allarme di livello ≥ 7 nella finestra scelta.': "Aucune alerte de niveau ≥ 7 dans la fenêtre choisie.",
  'Per gravità': "Par gravité",
  'Per livello': "Par niveau",
  'Regole più frequenti': "Règles les plus fréquentes",
  '{n}g': "{n}j",
  'Nessuna vulnerabilità rilevata da Wazuh sul parco.': "Aucune vulnérabilité détectée par Wazuh sur le parc.",
  'Dati in tempo reale da ntopng, chiesti alla sonda al momento: non sono salvati.':
    "Données en temps réel d'ntopng, demandées à la sonde à l'instant : non enregistrées.",
  'Interrogo…': "Interrogation…",
  'ntopng non è interrogabile.': "ntopng n'est pas interrogeable.",
  'ntopng non conosce questo host': "ntopng ne connaît pas cet hôte",
  'Nessun traffico osservato di recente per {ip}.': "Aucun trafic observé récemment pour {ip}.",
  'Score': "Score",
  'Allarmi': "Alertes",
  'Throughput': "Débit",
  'In blacklist': "Sur liste noire",
  'Con chi parla fuori': "Avec qui il parle dehors",
  'Nessun interlocutore critico (verso l’esterno o in blacklist) al momento.':
    "Aucun interlocuteur critique (vers l'extérieur ou sur liste noire) pour le moment.",
  '{n} conversazioni interne non mostrate.': "{n} conversations internes non affichées.",
  'Dove': "Où",
  'dentro': "dedans",
  'fuori': "dehors",
  'entrante': "entrant",
  'uscente': "sortant",
  'blacklist': "liste noire",
  'Interrogato: {quando}': "Interrogé : {quando}",
  'È un indirizzo di…': "C’est une adresse de…",
  'Scegli il CI di cui questo indirizzo fa parte: lo aggiungo ai suoi indirizzi aggiuntivi e l’avvistamento diventa «censito».':
    "Choisissez le CI auquel appartient cette adresse : elle est ajoutée à ses adresses supplémentaires et le signalement devient « inventorié ».",
  'Cerca un CI per nome o chiave naturale…': "Rechercher un CI par nom ou clé naturelle…",
  'Scrivi almeno due caratteri per cercare.': "Saisissez au moins deux caractères pour rechercher.",
  'Nessun CI trovato.': "Aucun CI trouvé.",
  'Associo…': "Association…",
  'Campi personalizzati': "Champs personnalisés",
  'Campi definiti': "Champs définis",
  'Definisce campi personalizzati per l’inventario, oltre a quelli raccolti dalla discovery. Possono essere associati a una specifica classe di CI, a una categoria di asset oppure resi disponibili in tutte le schede.':
    "Des champs propres à votre inventaire, au-delà de ceux collectés par la découverte. Vous pouvez les limiter à une classe (CI) ou catégorie (Asset), ou les laisser valables pour toutes les fiches.",
  'Nuovo campo': "Nouveau champ",
  'Modifica campo': "Modifier le champ",
  'Crea campo': "Créer le champ",
  'Salva modifiche': "Enregistrer les modifications",
  'Valori ammessi (uno per riga)': "Valeurs autorisées (une par ligne)",
  'Tutte le classi': "Toutes les classes",
  'Tutte le categorie': "Toutes les catégories",
  'Obbligatorio': "Obligatoire",
  'Aiuto (facoltativo)': "Aide (facultatif)",
  'Nessun campo personalizzato': "Aucun champ personnalisé",
  'Crea un nuovo campo dal pannello di configurazione: sarà immediatamente disponibile nelle schede a cui è associato.':
    "Créez-en un avec le formulaire à côté : il apparaîtra sur cette fiche, prêt à remplir.",
  'Eliminare il campo «{label}»? I valori già scritti restano nei dati.':
    "Supprimer le champ « {label} » ? Les valeurs déjà saisies restent dans les données.",
  'Salvo…': "Enregistrement…",
  'Salvato': "Enregistré",
  'Sì': "Oui",
  'No': "Non",
  'Cambia classe': "Changer de classe",
  'Cambia comunque': "Changer quand même",
  'cambia indirizzo': "changer d’adresse",
  'Carica': "Charger",
  'Collega un provider': "Connecter un fournisseur",
  "Condizioni sull'inventario": "Conditions sur l’inventaire",
  'dalla baseline': "depuis la baseline",
  'Di solito significa che la porta 80 non è più raggiungibile da internet, o che il DNS di uno dei nomi è stato spostato. Finché non si rimedia, il certificato scade e i clienti non accedono più.': "Cela signifie généralement que le port 80 n’est plus joignable depuis internet, ou que le DNS de l’un des noms a été déplacé. Tant que ce n’est pas corrigé, le certificat expire et les clients n’accèdent plus.",
  'Dichiara dismesso': "Déclarer mis hors service",
  "Dov'è l'issuer?": "Où est l’émetteur ?",
  "È il primo salvataggio di questo apparato: non c'è un «prima», e tutto risulta aggiunto.": "C’est le premier enregistrement de cet équipement : il n’y a pas d’« avant », et tout apparaît comme ajouté.",
  "È normale in sviluppo, dove non c'è un bilanciatore. Su un'installazione reale significa che la cartella dei certificati non è montata su questo processo, e da qui non si potrà sostituirlo.": "C’est normal en développement, où il n’y a pas de répartiteur de charge. Sur une installation réelle, cela signifie que le dossier des certificats n’est pas monté sur ce processus, et il ne sera pas possible de le remplacer d’ici.",
  'elimina': "supprimer",
  'Elimina definitivamente': "Supprimer définitivement",
  'Elimina gruppo': "Supprimer le groupe",
  'Esegui ora': "Exécuter maintenant",
  'Esplora': "Explorer",
  "Fra gli ingressi scelti c'è del traffico di ritorno: è la porta effimera di una connessione in uscita, non un servizio esposto. Se è voluto va bene, ma la mappa del servizio cambierà a ogni finestra.": "Parmi les entrées choisies figure du trafic de retour : c’est le port éphémère d’une connexion sortante, non un service exposé. Si c’est voulu, très bien, mais la carte du service changera à chaque fenêtre.",
  'I segreti sono cifrati e non sono mai più visualizzabili. Vengono consegnati a una sonda solo quando le è stato assegnato un job che li utilizza.': "Les secrets sont chiffrés et ne sont plus jamais consultables. Ils ne sont livrés à une sonde que lorsqu’un job qui les utilise lui a été assigné.",
  "Il confronto è troppo lungo ed è stato tagliato: quello che vedi è l'inizio. La configurazione intera è nell'altra scheda.": "La comparaison est trop longue et a été tronquée : ce que vous voyez est le début. La configuration entière se trouve dans l’autre onglet.",
  'La macchina non raggiunge il Control Plane: metto il file a mano': "La machine n’atteint pas le Control Plane : je place le fichier à la main",
  "La sonda è in contatto ma non ha ancora letto la configurazione dei flussi: succede nei primi secondi dopo l'avvio. Se resta così, l'errore comparirà qui al prossimo tentativo.": "La sonde est en contact mais n’a pas encore lu la configuration des flux : cela se produit dans les premières secondes après le démarrage. Si cela persiste, l’erreur apparaîtra ici à la prochaine tentative.",
  'La verifica è passata: togli la spunta a «Prima una prova» e rilancia per il certificato vero.': "La vérification est passée : décochez « D’abord un test » et relancez pour le vrai certificat.",
  'Le sonde continuano a raccogliere e a consegnare, ma il traffico consegnato adesso è perso: non si accoda in attesa che il servizio torni.': "Les sondes continuent de collecter et de livrer, mais le trafic livré maintenant est perdu : il ne se met pas en file d’attente jusqu’au retour du service.",
  'Linux': "Linux",
  'Modifica': "Modifier",
  'Mostra tutto il traffico': "Afficher tout le trafic",
  "Nessun costruttore caricato: il produttore si ricava solo per le marche più diffuse. Di norma il registro arriva con l'immagine — se manca, questa installazione è stata costruita senza uscita verso Internet.": "Aucun constructeur chargé : le fabricant n'est déterminé que pour les marques les plus répandues. En principe, le registre est fourni avec l'image — s'il manque, cette installation a été construite sans accès à Internet.",
  'Nessuna capability abilitata: la sonda resterà ferma.': "Aucune capability activée : la sonde restera inactive.",
  'Nessuna capability selezionata: la sonda si arruolerà ma non riceverà alcun job.': "Aucune capability sélectionnée : la sonde s'enrôlera mais ne recevra aucun job.",
  "Nessuna credenziale configurata: creane una nella sezione Credenziali, altrimenti non c'è modo di interrogare nulla.": "Aucun identifiant configuré : créez-en un dans la section Identifiants, sinon il n'y a aucun moyen d'interroger quoi que ce soit.",
  'nessuna in linea: i job resteranno in attesa': "aucune en ligne : les jobs resteront en attente",
  'Nuova regola': "Nouvelle règle",
  'Nuovo piano': "Nouveau plan",
  'Nuovo prodotto': "Nouveau produit",
  'passo costoso senza un filtro davanti: verrebbe provato su ogni indirizzo dell’ambito, compresi quelli spenti.': "étape coûteuse sans filtre en amont : elle serait tentée sur chaque adresse du périmètre, y compris celles qui sont éteintes.",
  'Pianifica': "Planifier",
  'Proponi questo piano per primo': "Proposer ce plan en premier",
  'Questa non è la console di un cliente: da qui si creano ed eliminano tenant e si assegnano licenze.': "Ce n'est pas la console d'un client : c'est ici que l'on crée et supprime des tenants et que l'on attribue des licences.",
  'Questa sonda non dichiara interfacce adatte alla cattura: servono una scheda attiva e non di loopback, di norma collegata alla porta mirror. Verifica che sia aggiornata e che la scheda sia su.': "Cette sonde ne déclare aucune interface adaptée à la capture : il faut une carte active, non loopback, généralement reliée au port miroir. Vérifiez qu'elle est à jour et que la carte est activée.",
  'Questo bene non è collegato ad alcun configuration item: la rete non lo conferma. È normale per un ricambio, un bene in magazzino o una licenza; per un apparato in servizio significa che la discovery non lo vede.': "Ce bien n'est rattaché à aucun configuration item : le réseau ne le confirme pas. C'est normal pour une pièce de rechange, un bien en stock ou une licence ; pour un équipement en service, cela signifie que la découverte ne le voit pas.",
  'Questo gruppo non ha più credenziali: probabilmente sono state eliminate. Una discovery che lo usasse verrebbe rifiutata.': "Ce groupe n'a plus d'identifiants : ils ont probablement été supprimés. Une découverte qui l'utiliserait serait rejetée.",
  'Quota esaurita: i nuovi CI non verranno registrati finché il piano non viene ampliato. Quelli già noti continuano ad aggiornarsi.': "Quota épuisé : les nouveaux CI ne seront pas enregistrés tant que le plan n'est pas étendu. Ceux déjà connus continuent d'être mis à jour.",
  'Reti e indirizzi che scrivo io': "Réseaux et adresses que je saisis moi-même",
  'Riapplica ai clienti': "Réappliquer aux clients",
  'Valori di serie': "Valeurs par défaut",
  'Riporta il piano ai valori di serie del prodotto': "Rétablir le plan aux valeurs par défaut du produit",
  'Ricarica': "Recharger",
  'Rimuovi i dati più vecchi': "Supprimer les données les plus anciennes",
  'rinnovo tacito': "reconduction tacite",
  'Scollega': "Dissocier",
  'Scrivo io reti e indirizzi': "Je saisis moi-même les réseaux et adresses",
  'Sincronizza': "Synchroniser",
  "Stai modificando una pianificazione che gira già. Il tipo non si cambia; le credenziali restano quelle attuali se non ne scegli un'altra. Lo storico delle esecuzioni resta.": "Vous modifiez une planification déjà en cours d'exécution. Le type ne peut pas être changé ; les identifiants restent ceux actuels si vous n'en choisissez pas d'autres. L'historique des exécutions est conservé.",
  'su un periodo': "sur une période",
  'Togli': "Retirer",
  'Togli il blocco': "Retirer le verrou",
  'Torna all’elenco': "Retour à la liste",
  'Tutto': "Tout",
  'Uso un pool': "J'utilise un pool",
  'vuoto = illimitati': "vide = illimité",
  'Windows': "Windows",
  'Prova a vuoto': "Test à vide",
  "Abilita un'utenza esistente": "Activer un compte existant",
  "Che cosa contiene l'inventario": "Ce que contient l'inventaire",
  "Consegne degli agenti d'inventario": "Livraisons des agents d'inventaire",
  "Creane uno qui sopra: riceverà il proprio indirizzo derivato dall'identificativo.": "Créez-en un ci-dessus : il recevra sa propre adresse dérivée de l'identifiant.",
  "Definisci un servizio indicando il suo punto di ingresso — il VIP del bilanciatore, il front-end, l'indirizzo pubblicato — e la sua mappa si costruirà dal traffico osservato.": "Définissez un service en indiquant son point d'entrée — la VIP du répartiteur de charge, le front-end, l'adresse publiée — et sa carte se construira à partir du trafic observé.",
  "L'indirizzo non compare nel traffico osservato nel periodo scelto. Prova una finestra più ampia, o verifica che il filtro del traffico non lo stia scartando: in Impostazioni → Traffico da conservare.": "L'adresse n'apparaît pas dans le trafic observé sur la période choisie. Essayez une fenêtre plus large, ou vérifiez que le filtre de trafic ne l'écarte pas : dans Paramètres → Trafic à conserver.",
  "L'utenza appartiene a un altro tenant": "Le compte appartient à un autre tenant",
  "La prova dice anche chi risulti essere dall'altra parte: utenza e istanza. Un connettore puntato sull'ambiente di collaudo funziona benissimo, ed è proprio quello il problema.": "Le test indique aussi qui se trouve de l'autre côté : compte et instance. Un connecteur pointé sur l'environnement de recette fonctionne très bien, et c'est précisément là le problème.",
  "Le regole servono quando la piattaforma classifica male un apparato che tu riconosci a colpo d'occhio — per esempio dal sysObjectID del costruttore.": "Les règles sont utiles lorsque la plateforme classe mal un équipement que vous reconnaissez au premier coup d'œil — par exemple d'après le sysObjectID du constructeur.",
  "Nessuno spazio attribuito: l'inventario è vuoto.": "Aucun espace attribué : l'inventaire est vide.",
  "Non è un errore: con questi criteri non c'è nulla da riportare. È spesso la risposta che si spera.": "Ce n'est pas une erreur : avec ces critères, il n'y a rien à signaler. C'est souvent la réponse que l'on espère.",
  "Non è un errore: in questa finestra non c'è nulla da riportare.": "Ce n'est pas une erreur : sur cette fenêtre, il n'y a rien à signaler.",
  "Ripartizione del traffico all'ingresso": "Répartition du trafic à l'entrée",
  "Servono flussi nella finestra scelta. Se il traffico c'è ma qui non compare nulla, allarga la finestra: un servizio si riconosce anche dal fatto che ricorre.": "Il faut des flux sur la fenêtre choisie. Si le trafic existe mais que rien n'apparaît ici, élargissez la fenêtre : un service se reconnaît aussi au fait qu'il est récurrent.",
  "Traffico all'ingresso": "Trafic à l'entrée",
  "Traffico verso l'ingresso del servizio": "Trafic vers l'entrée du service",
  'esegui': "exécuter",
  'modifica': "modifier",
  'Rigenera': "Régénérer",
  'Verifica': "Vérifier",
  '{quanti} costruttori caricati.': "{quanti} constructeurs chargés.",
  '{persi} CI raccolti dalla sonda non sono finiti in CMDB. Il motivo è negli eventi di fase «ingest» qui sotto.': "{persi} CI collectés par la sonde ne sont pas arrivés dans le CMDB. La raison figure dans les événements de la phase «ingest» ci-dessous.",
  'da riconoscere': "à reconnaître",
  'catalogati': "catalogués",
  ' e ': " et ",
  ' oppure ': " ou bien ",
  'Accessibile': "Accessible",
  'Accessibile pubblicamente': "Accessible publiquement",
  'Aggiorn. hardware': "Mise à jour matérielle",
  'Aggiornamento hardware': "Mise à jour matérielle",
  'Aggiunta CPU a caldo': "Ajout de CPU à chaud",
  'Aggiunta memoria a caldo': "Ajout de mémoire à chaud",
  'Architettura': "Architecture",
  'Blocco CIDR': "Bloc CIDR",
  'Build ESXi': "Build ESXi",
  'CD-ROM collegati': "CD-ROM connectés",
  'Capacità (GB)': "Capacité (Go)",
  'Capacità GB': "Capacité Go",
  'Capacità fisica': "Capacité physique",
  'Capacità fisica (GB)': "Capacité physique (Go)",
  'Chassis ID': "Chassis ID",
  'Chiaro': "Clair",
  'Cifrato': "Chiffré",
  'Classe di istanza': "Classe d'instance",
  'Cluster': "Cluster",
  'Cluster (riferimento)': "Cluster (référence)",
  'Cluster collegati': "Clusters associés",
  'Collegata': "Connectée",
  'Commutatore': "Commutateur",
  'Computer': "Ordinateur",
  'Condiviso fra host': "Partagé entre hôtes",
  'Connessione': "Connexion",
  'Contatto': "Contact",
  'Core fisici': "Cœurs physiques",
  'Core per socket': "Cœurs par socket",
  'DRS attivo': "DRS actif",
  'Datastore': "Datastore",
  'Dimensione (GB)': "Taille (Go)",
  'Dischi': "Disques",
  'Disco': "Disque",
  'Dominio DNS': "Domaine DNS",
  'Endpoint': "Endpoint",
  'Export NFS': "Export NFS",
  'Famiglia del sistema': "Famille du système",
  'Famiglia di API': "Famille d'API",
  'File': "Fichier",
  'File system': "Système de fichiers",
  'Firmware di avvio': "Firmware de démarrage",
  'Foresta': "Forêt",
  'Formato': "Format",
  'HA attivo': "HA actif",
  'Hardware': "Matériel",
  'Host': "Hôte",
  'Hypervisor': "Hyperviseur",
  'Indirizzo IP': "Adresse IP",
  'Indirizzo del controller di gestione': "Adresse du contrôleur de gestion",
  'Indirizzo di gestione': "Adresse de gestion",
  'Libero GB': "Libre Go",
  'MAC': "MAC",
  'MTU': "MTU",
  'Macchine virtuali ospitate': "Machines virtuelles hébergées",
  'Memoria (GB)': "Mémoire (Go)",
  'Memoria (MB)': "Mémoire (Mo)",
  'Memoria (MiB)': "Mémoire (Mio)",
  'Memoria MB': "Mémoire Mo",
  'Memoria MiB': "Mémoire Mio",
  'Modello CPU': "Modèle CPU",
  'Modo VLAN': "Mode VLAN",
  'Motore': "Moteur",
  'Nome DNS': "Nom DNS",
  'Nome host': "Nom d'hôte",
  'Numero di uplink': "Nombre d'uplinks",
  'Piattaforma': "Plateforme",
  'Piattaforma ospite': "Plateforme invitée",
  'Porte TCP aperte': "Ports TCP ouverts",
  'Porte in ascolto': "Ports en écoute",
  'Prefisso': "Préfixe",
  'Presente su host': "Présent sur l'hôte",
  'Produttore scheda': "Fabricant de la carte",
  'Provider': "Provider",
  'Provisionato GB': "Provisionné Go",
  'Provisioning': "Provisioning",
  'Punto di mount': "Point de montage",
  'Raccolto tramite': "Collecté via",
  'Regione': "Région",
  'Regole': "Règles",
  'Reti': "Réseaux",
  'Riferimento vCenter': "Référence vCenter",
  'Rilevato il': "Détecté le",
  'Runtime': "Runtime",
  'Runtime container': "Runtime de conteneur",
  'Schede di rete': "Cartes réseau",
  'Schema': "Schéma",
  'Scuro': "Sombre",
  'Seriale del telaio': "Numéro de série du châssis",
  'Server NFS': "Serveur NFS",
  'Sistema operativo': "Système d'exploitation",
  'Socket': "Socket",
  'Spazio fisico libero': "Espace physique libre",
  'Spazio fisico libero (GB)': "Espace physique libre (Go)",
  'Spazio fisico usato (%)': "Espace physique utilisé (%)",
  'Spazio libero': "Espace libre",
  'Spazio libero (GB)': "Espace libre (Go)",
  'Spazio occupato (GB)': "Espace occupé (Go)",
  'Spazio provisionato': "Espace provisionné",
  'Spazio provisionato (GB)': "Espace provisionné (Go)",
  'Spazio usato (%)': "Espace utilisé (%)",
  'Stato di alimentazione': "État d'alimentation",
  'Stato di connessione': "État de connexion",
  'Stato osservato': "État observé",
  'Supporto': "Support",
  'Thread': "Thread",
  'Timeout (s)': "Délai d'expiration (s)",
  'Tipo di MAC': "Type de MAC",
  'Tipo di archiviazione': "Type de stockage",
  'Tipo di commutatore': "Type de commutateur",
  'Tipo di disco': "Type de disque",
  'Tipo di istanza': "Type d'instance",
  'Tipo di rete': "Type de réseau",
  'Tipo di risorsa': "Type de ressource",
  'Tipo di scheda': "Type de carte",
  'Tipo rete': "Type de réseau",
  'Tipo switch': "Type de commutateur",
  'UUID BIOS': "UUID BIOS",
  'Ubicazione': "Emplacement",
  'Uplink': "Uplink",
  'Usato %': "Utilisé %",
  'VLAN': "VLAN",
  'VLAN del trunk': "VLAN du trunk",
  'VMFS': "VMFS",
  'Versionamento': "Gestion des versions",
  'Versione ESXi': "Version ESXi",
  'Versione OS': "Version de l'OS",
  'Versione VMFS': "Version VMFS",
  'Versione firmware': "Version du firmware",
  'Versione hardware virtuale': "Version du matériel virtuel",
  'Versione motore': "Version du moteur",
  'Versione software': "Version du logiciel",
  'WinRM attivo': "WinRM actif",
  'Zona': "Zone",
  'Zona di disponibilità': "Zone de disponibilité",
  'comparso nelle ultime 24 ore': "apparu au cours des dernières 24 heures",
  'condizione non leggibile': "condition illisible",
  'host non gestito: vivo in rete ma non interrogabile': "hôte non géré : actif sur le réseau mais non interrogeable",
  'la condizione guarda l’esito di se stesso, che non esiste ancora': "la condition examine son propre résultat, qui n’existe pas encore",
  'la condizione guarda l’esito di «{passo}», che viene dopo o non c’è': "la condition examine le résultat de «{passo}», qui vient après ou n’existe pas",
  'nessun oggetto': "aucun objet",
  'non classificato: la piattaforma non sa cosa sia': "non classifié : la plateforme ne sait pas de quoi il s'agit",
  'non è': "n'est pas",
  'parte sempre': "démarre toujours",
  'riconosciuto e classificato': "reconnu et classifié",
  'serve un numero intero': "un nombre entier est requis",
  'vCPU': "vCPU",
  '{campo} contiene {valore}': "{campo} contient {valore}",
  '{campo} non è presente': "{campo} n'est pas présent",
  '{campo} è maggiore di {valore}': "{campo} est supérieur à {valore}",
  '{campo} è minore di {valore}': "{campo} est inférieur à {valore}",
  '{campo} è presente': "{campo} est présent",
  'è': "est",
  'è diverso da': "est différent de",
  'è maggiore di': "est supérieur à",
  'è minore di': "est inférieur à",
  'è presente': "est présent",
  'è uguale a': "est égal à",
  'Alimentazione in uso': "Alimentation utilisée",
  'Stato della batteria': "État de la batterie",
  'Carica della batteria': "Charge de la batterie",
  'Autonomia stimata': "Autonomie estimée",
  'Tensione della batteria': "Tension de la batterie",
  'Temperatura della batteria': "Température de la batterie",
  'Da quanto è a batteria': "Durée sur batterie",
  'Tensione in ingresso': "Tension d'entrée",
  'Frequenza in ingresso': "Fréquence d'entrée",
  'Mancanze di rete': "Coupures de secteur",
  'Tensione in uscita': "Tension de sortie",
  'Frequenza in uscita': "Fréquence de sortie",
  'Potenza in uscita': "Puissance de sortie",
  'Carico in uscita': "Charge de sortie",
  'Potenza nominale': "Puissance nominale",
  'Allarmi attivi': "Alarmes actives",
  'Apparati collegati': "Équipements connectés",
  'Batterie sostituite il': "Batteries remplacées le",
  'Età delle batterie': "Âge des batteries",
  'Data di fabbricazione': "Date de fabrication",
  'Ultimo autotest': "Dernier autotest",
  'Pacchi batteria': "Blocs batterie",
  'Pacchi batteria guasti': "Blocs batterie défaillants",
  'Tensione nominale della batteria': "Tension nominale de la batterie",
  'Corrente della batteria': "Courant de la batterie",
  'Temperatura ambiente': "Température ambiante",
  'Punteggio ntopng': "Score ntopng",
  'Allarmi su ntopng': "Alarmes sur ntopng",
  'In blacklist secondo ntopng': "En liste noire selon ntopng",
  'Segnalato da ntopng': "Signalé par ntopng",
  'Perché è segnalato': "Motif du signalement",
  'Visto da ntopng': "Vu par ntopng",
  'Protocolli applicativi': "Protocoles applicatifs",
  'Come è stato rilevato': "Mode de détection",
  'ntopng': "ntopng",
  'Rilevazione e classificazione degli host effettuata mediante la sola analisi del traffico di rete.': 'Détection et classification des hôtes effectuées uniquement par l’analyse du trafic réseau.',
  'Active Directory': "Active Directory",
  'Adiacenze CDP': "Adjacences CDP",
  'Adiacenze LLDP': "Adjacences LLDP",
  'Amazon Web Services': "Amazon Web Services",
  'Backup configurazioni': "Sauvegarde des configurations",
  'Inventario avanzato apparati': "Inventaire avancé des équipements",
  'Wireless': "Sans fil",
  'Nessun access point censito': "Aucun point d'accès recensé",
  'Lancia una discovery «Inventario avanzato apparati» su questo controller.':
    "Lancez une découverte « Inventaire avancé des équipements » sur ce contrôleur.",
  '{ap} access point, {ssid} SSID, {client} client': "{ap} points d'accès, {ssid} SSID, {client} clients",
  'Host registrati': "Hôtes enregistrés",
  'Porte ethernet': "Ports Ethernet",
  'Initiator': "Initiateurs",
  'Host serviti': "Hôtes desservis",
  'array': "baie",
  'Wireless (client, SSID)': "Sans fil (clients, SSID)",
  'Controller': "Contrôleur",
  'Postazione': "Poste",
  'Collegato da': "Connecté depuis",
  'Utente collegato': "Utilisateur connecté",
  'Presenza': "Présence",
  'Wi-Fi': "Wi-Fi",
  'VPN':
    'VPN',
  'PC': "PC",
  'Dove risulta collegata questa persona, per sorgente: Wi-Fi e PC dall’ultimo inventario, VPN chiesta al firewall adesso.':
    "Où cette personne apparaît connectée, par source : Wi-Fi et PC du dernier inventaire, VPN demandé au pare-feu à l'instant.",
  'Nessun client Wi-Fi con questa login': "Aucun client Wi-Fi avec ce login",
  'Le login arrivano dalle reti a 802.1X/Portal, con l’inventario avanzato dei controller wireless.':
    "Les logins proviennent des réseaux 802.1X/Portal, via l'inventaire avancé des contrôleurs sans fil.",
  'Nessuna sessione VPN attiva per questa login': "Aucune session VPN active pour ce login",
  'Nessun firewall interrogabile': "Aucun pare-feu interrogeable",
  'Firewall non raggiunti: {elenco}': "Pare-feux non joints : {elenco}",
  'Il firewall non ha risposto adesso: sessioni dall’ultima sincronizzazione (al più 5 minuti fa).':
    "Le pare-feu n'a pas répondu à l'instant : sessions de la dernière synchronisation (il y a 5 minutes au plus).",
  'Nessun PC dichiara questa login': "Aucun PC ne déclare ce login",
  'Serve l’attributo «Utente collegato» dall’inventario degli host: arriverà con l’agent e con WinRM.':
    "Il faut l'attribut « Utilisateur connecté » de l'inventaire des hôtes : il arrivera avec l'agent et WinRM.",
  'MAC casuale': "MAC aléatoire",
  'MAC randomizzato dal dispositivo (privacy)': "MAC randomisé par l'appareil (confidentialité)",
  'Reti diffuse': "Réseaux diffusés",
  'Client connessi': "Clients connectés",
  'Client per banda': "Clients par bande",
  'Qualità del segnale': "Qualité du signal",
  'Client per SSID': "Clients par SSID",
  'Client per access point': "Clients par point d'accès",
  'client': "clients",
  'ottimo': "excellent",
  'buono': "bon",
  'debole': "faible",
  'Dal RSSI dei client: ottimo ≥ −55 dBm, buono ≥ −65, debole ≥ −75, critico sotto.':
    "D'après le RSSI des clients : excellent ≥ −55 dBm, bon ≥ −65, faible ≥ −75, critique en dessous.",
  'normale': "normal",
  'Acceso da': "Allumé depuis",
  'Radio': "Radio",
  'Banda': "Bande",
  'Client': "Clients",
  'Transceiver (SFP)': "Transceiver (SFP)",
  'Transceiver': "Transceiver",
  'Vai al dettaglio del transceiver': "Aller au détail du transceiver",
  'Scheda': "Carte",
  'Alimentatore': "Alimentation",
  'Ventola': "Ventilateur",
  'Modulo': "Module",
  'Telaio': "Châssis",
  'Membro dello stack': "Membre du stack",
  'Cloud': "Cloud",
  'Directory': "Annuaire",
  'Google Cloud': "Google Cloud",
  'Host ESXi e macchine virtuali del vCenter indicato nella credenziale.': "Hôtes ESXi et machines virtuelles du vCenter indiqué dans l'identifiant.",
  'Host e macchine virtuali del management node ZStack.': "Hôtes et machines virtuelles du management node ZStack.",
  'Host e macchine virtuali della piattaforma Sangfor.': "Hôtes et machines virtuelles de la plateforme Sangfor.",
  'Host e macchine virtuali di NexaSphere (API ZStack).': "Hôtes et machines virtuelles de NexaSphere (API ZStack).",
  'Host e macchine virtuali di NexaVM Cloud (API ZStack).': "Hôtes et machines virtuelles de NexaVM Cloud (API ZStack).",
  'Host e macchine virtuali di Prism Central.': "Hôtes et machines virtuelles de Prism Central.",
  'I computer del dominio letti dal Domain Controller via LDAP: nome, sistema operativo, collocazione nelle OU e ultimo accesso. Non tocca le workstation, quindi vede anche quelle spente.': "Les ordinateurs du domaine lus depuis le Domain Controller via LDAP : nom, système d'exploitation, placement dans les OU et dernière connexion. Il ne touche pas les postes de travail, il voit donc aussi ceux qui sont éteints.",
  'Interroga solo i vicinati CDP degli apparati indicati.': "Interroge uniquement les voisinages CDP des équipements indiqués.",
  'Interroga solo i vicinati LLDP degli apparati indicati.': "Interroge uniquement les voisinages LLDP des équipements indiqués.",
  'Inventario della regione indicata nella credenziale: EC2 e VPC, S3, Lambda, RDS, load balancer, volumi EBS, security group e cluster/servizi ECS.':
    "Inventaire de la région indiquée dans l’identifiant : EC2 et VPC, S3, Lambda, RDS, répartiteurs de charge, volumes EBS, groupes de sécurité et clusters/services ECS.",
  'Istanze e reti del progetto indicato nella credenziale.': "Instances et réseaux du projet indiqué dans l'identifiant.",
  'Istanze, VCN e subnet del compartimento indicato nella credenziale.': "Instances, VCN et sous-réseaux du compartiment indiqué dans l'identifiant.",
  'Macchine virtuali e reti della sottoscrizione indicata nella credenziale.': "Machines virtuelles et réseaux de l'abonnement indiqué dans l'identifiant.",
  'Microsoft Azure': "Microsoft Azure",
  'NexaSphere': "NexaSphere",
  'NexaVM Cloud': "NexaVM Cloud",
  "Nodi, macchine virtuali e container del cluster. Gli indirizzi IP degli ospiti non sono esposti dall'API: li conosce il sistema ospite e richiedono il QEMU guest agent.": "Nœuds, machines virtuelles et conteneurs du cluster. Les adresses IP des invités ne sont pas exposées par l'API : elles sont connues du système invité et nécessitent le QEMU guest agent.",
  'Nutanix': "Nutanix",
  'Oracle Cloud': "Oracle Cloud",
  'Proxmox VE': "Proxmox VE",
  'Rete (SNMP)': "Réseau (SNMP)",
  "Legge da switch e router i componenti che l'SNMP non vede — SFP, schede, alimentatori — con i loro seriali; sui controller wireless censisce anche gli access point (che diventano CI collegati al controller), gli SSID diffusi e i client associati. Huawei (compresi gli AirEngine), Cisco, Juniper, Fortinet ed Extreme; gli altri vendor si aggiungono nel tempo.": "Lit sur les switches et routeurs les composants que le SNMP ne voit pas — SFP, cartes, alimentations — avec leurs numéros de série ; sur les contrôleurs sans fil, recense aussi les points d'accès (qui deviennent des CI liés au contrôleur), les SSID diffusés et les clients associés. Huawei (y compris AirEngine), Cisco, Juniper, Fortinet et Extreme ; les autres fournisseurs s'ajoutent au fil du temps.",
  'Salva la configurazione di switch, router e firewall e ne conserva la storia: Cisco, Huawei (compresi i NetEngine), Aruba, HP Comware, Extreme, Juniper, Fortinet, MikroTik, Palo Alto, Lantronix. Le configurazioni identiche alla precedente non creano una revisione.': "Enregistre la configuration des switches, routeurs et firewalls et en conserve l'historique : Cisco, Huawei (NetEngine compris), Aruba, HP Comware, Extreme, Juniper, Fortinet, MikroTik, Palo Alto, Lantronix. Les configurations identiques à la précédente ne créent pas de révision.",
  'Sangfor aCloud': "Sangfor aCloud",
  'Scansiona subnet e indirizzi via SNMP; con le opzioni dedicate raccoglie anche le adiacenze CDP/LLDP e gli indirizzi fisici imparati dalle porte.': "Analyse les sous-réseaux et adresses via SNMP ; avec les options dédiées, elle collecte aussi les adjacences CDP/LLDP et les adresses physiques apprises sur les ports.",
  "Sequenza di passi disegnata da chi amministra la rete: ping, DNS, porte, SNMP, adiacenze, SSH, Windows. Ogni passo può dipendere dall'esito dei precedenti.": "Séquence d'étapes conçue par l'administrateur du réseau : ping, DNS, ports, SNMP, adjacences, SSH, Windows. Chaque étape peut dépendre du résultat des précédentes.",
  'VMware vSphere': "VMware vSphere",
  'Virtualizzazione': "Virtualisation",
  'ZStack': "ZStack",
  'Security health': 'État de sécurité',
  "Sta impiegando più del solito: il Control Plane potrebbe essere in riavvio. Riprovo da solo…": "Cela prend plus de temps que d’habitude : le Control Plane redémarre peut-être. Je réessaie tout seul…",
  "quali servizi AI esterni (ChatGPT, Claude, Copilot…) vengono usati in rete e da quali asset, per la governance (shadow AI). Il dato viene dal nome TLS (SNI) che la sonda vede in ascolto passivo, confrontato con un catalogo di servizi AI: esce solo l’uso delle AI, mai l’intera navigazione. Il rapporto per asset può essere anonimizzato (PC e utente come pseudonimi) e due chiavi di disoffuscamento rivelano la macchina (livello 1) o anche l’utente (livello 2), dalla sezione Privacy. Add-on «Utilizzo AI».":
    "quels services IA externes (ChatGPT, Claude, Copilot…) sont utilisés sur le réseau et par quels actifs, pour la gouvernance (shadow AI). La donnée provient du nom TLS (SNI) que la sonde voit en écoute passive, comparé à un catalogue de services IA : seule l’utilisation de l’IA sort de la sonde, jamais toute la navigation. Le rapport par actif peut être anonymisé (PC et utilisateur en pseudonymes) et deux clés de désanonymisation révèlent la machine (niveau 1) ou aussi l’utilisateur (niveau 2), depuis la section Confidentialité. Option « Utilisation de l’IA ».",
  'Aggiungi un servizio qui sopra.': "Ajoute un service ci-dessus.",
  'Anonimizza il rapporto (PC e utente come pseudonimi)': "Anonymiser le rapport (PC et utilisateur en pseudonymes)",
  'Assistente di codice': "Assistant de code",
  'Carico…': "Chargement…",
  'Catalogo AI': "Catalogue IA",
  'Chat generativa': "Chat génératif",
  'Chi usa le AI': "Qui utilise l’IA",
  'Chiave PC (facoltativa)': "Clé PC (facultative)",
  'Chiave PC (livello 1)': "Clé PC (niveau 1)",
  'Chiave utente (facoltativa)': "Clé utilisateur (facultative)",
  'Chiave utente (livello 2)': "Clé utilisateur (niveau 2)",
  'Generazione immagini': "Génération d’images",
  'I nomi (SNI) con cui le sonde riconoscono i servizi AI esterni — per il modulo Utilizzo AI': "Les noms (SNI) avec lesquels les sondes reconnaissent les services IA externes — pour le module Utilisation de l’IA",
  'I nomi (SNI) con cui le sonde riconoscono i servizi AI esterni. Vale per tutti i clienti. Il confronto è per dominio: «openai.com» riconosce anche «chat.openai.com».': "Les noms (SNI) avec lesquels les sondes reconnaissent les services IA externes. Vaut pour tous les clients. La correspondance se fait par domaine : « openai.com » reconnaît aussi « chat.openai.com ».",
  'Nessun asset': "Aucun actif",
  'Nessun traffico verso i servizi AI del catalogo nel periodo scelto.': "Aucun trafic vers les services IA du catalogue sur la période choisie.",
  'Nessun uso di AI nel periodo scelto.': "Aucune utilisation d’IA sur la période choisie.",
  'Nessun uso di AI rilevato': "Aucune utilisation d’IA détectée",
  'PC in chiaro, utente anonimizzato: serve la chiave utente per il livello 2.': "PC en clair, utilisateur anonymisé : la clé utilisateur est nécessaire pour le niveau 2.",
  'Pattern (dominio)': "Motif (domaine)",
  'Per asset. Se il rapporto è anonimizzato, PC e utente sono pseudonimi: inserisci la chiave di disoffuscamento per rivelare la macchina (livello 1) o anche l’utente (livello 2).': "Par actif. Si le rapport est anonymisé, PC et utilisateur sont des pseudonymes : saisis la clé de désanonymisation pour révéler la machine (niveau 1) ou aussi l’utilisateur (niveau 2).",
  'Privacy': "Confidentialité",
  'Quali servizi AI esterni vengono usati in rete e da quali asset, da ciò che vedono sonde, agenti e flussi. Solo metadati: nessun contenuto, nessuna decrittazione.':
    'Quels services d’IA externes sont utilisés sur le réseau et par quels actifs, d’après ce que voient sondes, agents et flux. Métadonnées seulement : aucun contenu, aucun déchiffrement.',
  'Rapporto anonimizzato: PC e utente sono pseudonimi. Inserisci una chiave per rivelarli.': "Rapport anonymisé : PC et utilisateur sont des pseudonymes. Saisis une clé pour les révéler.",
  'Ricerca / risposte': "Recherche / réponses",
  'Salva le chiavi': "Enregistrer les clés",
  'Servizi AI usati': "Services IA utilisés",
  'Servizi nel catalogo ({n})': "Services dans le catalogue ({n})",
  'Solo un amministratore del tenant può cambiare le chiavi.': "Seul un administrateur du locataire peut changer les clés.",
  'Togli le chiavi': "Retirer les clés",
  'Usi': "Utilisations",
  'Utilizzo AI': "Utilisation de l’IA",
  'aggiunto': "ajouté",
  'di serie': "d’origine",
  'impostata — lascia vuoto per non cambiarla': "définie — laisser vide pour la conserver",
  '«Chi usa le AI» sfiora la sorveglianza dei lavoratori: puoi anonimizzare il rapporto e tenere due chiavi per rivelare chi serve. La chiave PC (livello 1) svela la macchina, la chiave utente (livello 2) anche l’utente. Le chiavi non si rileggono mai in chiaro.': "« Qui utilise l’IA » frôle la surveillance des salariés : tu peux anonymiser le rapport et garder deux clés pour révéler qui est nécessaire. La clé PC (niveau 1) révèle la machine, la clé utilisateur (niveau 2) aussi l’utilisateur. Les clés ne sont jamais relues en clair.",
  'Sicurezza': "Sécurité",
  'Sorgenti': "Sources",
  'Asset segnalati': "Actifs signalés",
  'Nessun asset segnalato': "Aucun actif signalé",
  'Nessuna sorgente di sicurezza': "Aucune source de sécurité",
  'aggrega gli asset segnalati dalle sorgenti di sicurezza e le evidenze che ne determinano la segnalazione.': 'agrège les actifs signalés par les sources de sécurité et les preuves qui déclenchent le signalement.',
  'Il piano in uso non comprende nessuna sorgente di questo tipo.': "Le forfait actuel ne comprend aucune source de ce type.",
  'Nessuna evidenza rilevata dalle sorgenti di sicurezza, l’assenza di segnalazioni non indica assenza di rischi.': 'Aucune preuve détectée par les sources de sécurité ; l’absence de signalements n’indique pas l’absence de risques.',
  'motivo non riportato': "motif non indiqué",
  'indirizzo in blacklist secondo ntopng': "adresse en liste noire selon ntopng",
  'ha allarmi aperti su ntopng': "a des alarmes ouvertes sur ntopng",
  'Nessun rischio': "Aucune constatation",
  'Nessuna raccolta ha ancora prodotto rischi. Il rapporto di ogni job dice se la valutazione è stata eseguita e con quale conoscenza: un elenco vuoto vale quanto vale quel rapporto.': "Aucune collecte n'a encore produit de constatations. Le rapport de chaque job indique si l'évaluation a été effectuée et avec quelle connaissance : une liste vide vaut ce que vaut ce rapport.",
  'Gravità': "Gravité",
  'Cosa': "Quoi",
  'Aperto dal': "Ouvert le",
  'Nascondi': "Masquer",
  'Da quale fatto': "À partir de quel fait",
  'Regola': "Règle",
  'Rimedio': "Remède",
  'Mostra anche i rischi accettati': "Afficher aussi les risques acceptés",
  'rischio accettato': "risque accepté",
  'Rischio accettato: {motivo}': "Risque accepté : {motivo}",
  'torna visibile il {quando}': "redevient visible le {quando}",
  'Revoca': "Révoquer",
  'Accetta': "Accepter",
  'Accetta il rischio, perché': "Accepter le risque, parce que",
  'Per quanti giorni': "Pour combien de jours",
  'es. apparato del fornitore, sostituzione già pianificata': "ex. équipement du fournisseur, remplacement déjà planifié",
  'critica': "critique",
  'alta': "élevée",
  'media': "moyenne",
  'bassa': "faible",
  'telnet in ascolto': "telnet à l’écoute",
  'FTP in ascolto': "FTP à l’écoute",
  'rlogin in ascolto': "rlogin à l’écoute",
  'rsh in ascolto': "rsh à l’écoute",
  'VNC in ascolto': "VNC à l’écoute",
  'Amministrazione web senza cifratura': "Administration web sans chiffrement",
  '{valutati} asset valutati, {reperti} reperti': "{valutati} actifs évalués, {reperti} constats",
  'Esegui valutazione': "Lancer l’évaluation",
  'Valutazione in corso…': "Évaluation en cours…",
  'La valutazione è stata affidata a una sonda: i rischi compariranno qui appena la prende in carico.': "L’évaluation a été confiée à une sonde : les constats apparaîtront ici dès qu’elle la prendra en charge.",
  'Valutato su {assessed} asset: {findings} rischi aperti, {closed} non più validi.': "Évalué sur {assessed} actifs : {findings} constats ouverts, {closed} qui ne sont plus valides.",
  'Tutti i rischi del parco': "Tous les constats du parc",
  'Catalogo delle vulnerabilità': "Catalogue des vulnérabilités",
  'Le vulnerabilità note con cui si confronta il software inventariato. Le scarica il Control Plane una volta per tutte le sonde: una sonda in una rete chiusa non ha uscita verso Internet, e proprio lì questa funzione serve di più.': "Les vulnérabilités connues auxquelles est confronté le logiciel inventorié. C’est le Control Plane qui les télécharge une fois pour toutes les sondes : une sonde sur un réseau fermé n’a pas de sortie vers Internet, et c’est justement là que cette fonction est la plus utile.",
  'Il catalogo non è mai stato importato: il confronto con i CVE non produce niente, e «nessuna vulnerabilità» non vorrebbe dire «nessun problema».': "Le catalogue n’a jamais été importé : la comparaison avec les CVE ne produit rien, et «aucune vulnérabilité» ne voudrait pas dire «aucun problème».",
  'Aggiornato al': "Mis à jour le",
  'Voci nel catalogo': "Entrées du catalogue",
  'L’ultima importazione è fallita: {errore}': "La dernière importation a échoué : {errore}",
  'Importazione in corso. Sono centinaia di megabyte da scaricare: dura qualche minuto, e questa pagina si aggiorna da sola.': "Importation en cours. Ce sont des centaines de mégaoctets à télécharger : cela dure quelques minutes, et cette page se met à jour toute seule.",
  'Aggiorna il catalogo': "Mettre à jour le catalogue",
  'Importa il catalogo': "Importer le catalogue",
  'Avviata.': "Lancée.",
  'pacchetto senza nome': "paquet sans nom",
  'senza una versione che corregge (non ancora corretta nella distribuzione)': "sans version qui corrige (pas encore corrigée dans la distribution)",
  'senza la release della distribuzione': "sans la version de la distribution",
  'Scartate': "Écartées",
  'avviso di manutenzione, non di sicurezza': "avis de maintenance, non de sécurité",
  '{cve} — {pacchetto}': "{cve} — {pacchetto}",
  '{cve} — {pacchetto} e altri {altri_pacchetti}': "{cve} — {pacchetto} et {altri_pacchetti} autres",
  'Mostrati i {mostrati} più gravi su {totale}.': "Affichés les {mostrati} plus graves sur {totale}.",
  'Vedili tutti': "Voir tout",
  'su {asset} asset': "sur {asset} actifs",
  'Cosa fare': "Que faire",
  'Dettagli': "Détails",
  '— chiude {chiude} rischi': "— clôt {chiude} constats",
  'Aggiorna {n} pacchetti': "Mettre à jour {n} paquets",
  'Da valutare a mano: non c’è un rimedio unico': "À évaluer manuellement : il n’y a pas de remède unique",
  'I rischi, per chi vuole controllare': "Les constats, pour qui veut vérifier",
  '{cve} — {pacchetto} · sfruttata attivamente (CISA KEV)': "{cve} — {pacchetto} · activement exploitée (CISA KEV)",
  '{cve} — {pacchetto} e altri {altri_pacchetti} · sfruttata attivamente (CISA KEV)': "{cve} — {pacchetto} et {altri_pacchetti} autres · activement exploitée (CISA KEV)",
  'Aggiorna {n} pacchetti con vulnerabilità già sfruttate': "Mettre à jour {n} paquets avec des vulnérabilités déjà exploitées",
  'catalogo delle vulnerabilità sfruttate non scaricato': "catalogue des vulnérabilités exploitées non téléchargé",
  'sfruttate (KEV)': "exploitées (KEV)",
  'Per ecosistema': "Par écosystème",
  'debian': "debian",
  'ubuntu': "ubuntu",
  'alma': "alma",
  'rocky': "rocky",
  'alpine': "alpine",
  'Rischio': "Risque",
  'Fascia': "Niveau",
  'Valutato': "Évalué",
  'critico': "critique",
  'alto': "élevé",
  'medio': "moyen",
  'basso': "faible",
  'nessun rilievo': "aucune remarque",
  '{n} vulnerabilità già sfruttate attivamente (CISA KEV)': "{n} vulnérabilités déjà activement exploitées (CISA KEV)",
  'sistema fuori supporto con servizi in ascolto': "système hors support avec des services à l’écoute",
  '{c} vulnerabilità critiche': "{c} vulnérabilités critiques",
  'sistema fuori supporto': "système hors support",
  '{a} vulnerabilità gravi': "{a} vulnérabilités graves",
  '{p} servizi con credenziali in chiaro': "{p} services avec identifiants en clair",
  '{x} rischi di gravità minore': "{x} constats de gravité mineure",
  'Fuori supporto': "Hors support",
  'Prodotti senza più disponibilità di aggiornamenti di sicurezza, da sostituire.': 'Produits qui ne reçoivent plus de mises à jour de sécurité, à remplacer.',
  'Ciclo': "Cycle",
  'Fuori supporto dal': "Hors support depuis le",
  'Su quanti asset': "Sur combien d’actifs",
  'sistema': "système",
  'e altri {altri}': "et {altri} autres",
  '{pacchetto} {ciclo} è fuori supporto': "{pacchetto} {ciclo} est hors support",
  'Il ciclo {ciclo} non riceve più correzioni dal {fine_leggibile}: le vulnerabilità scoperte da allora restano aperte, e non arriverà un aggiornamento che le chiuda': "Le cycle {ciclo} ne reçoit plus de correctifs depuis le {fine_leggibile} : les vulnérabilités découvertes depuis restent ouvertes, et aucune mise à jour ne viendra les clore",
  'Passare a un ciclo ancora supportato': "Passer à un cycle encore pris en charge",
  'cicli di vita del software': "cycles de vie du logiciel",
  'ciclo di vita non scaricato': "cycle de vie non téléchargé",
  'cicli di vita del software non scaricati': "cycles de vie du logiciel non téléchargés",
  'Correzioni di Windows': "Correctifs Windows",
  'Il bollettino mensile di Microsoft: per ogni versione di Windows, a che livello va portata e con quale KB. Su Windows il sistema non è un pacchetto, quindi il confronto sui pacchetti non lo raggiunge — senza questo catalogo, di un Windows non si può dire se è aggiornato.': "Le bulletin mensuel de Microsoft : pour chaque version de Windows, à quel niveau la porter et avec quel KB. Sous Windows, le système n’est pas un paquet, la comparaison des paquets ne l’atteint donc pas — sans ce catalogue, on ne peut pas dire d’un Windows s’il est à jour.",
  'Mai importato: di ogni macchina Windows il rapporto dichiara la lacuna invece di dire che è aggiornata.': "Jamais importé : pour chaque machine Windows, le rapport signale la lacune au lieu de dire qu’elle est à jour.",
  'Livelli di build': "Niveaux de build",
  'dal bollettino {mese}': "du bulletin {mese}",
  'Importazione in corso: due anni di bollettini sono qualche centinaio di megabyte. Questa pagina si aggiorna da sola.': "Importation en cours : deux ans de bulletins représentent quelques centaines de mégaoctets. Cette page se met à jour toute seule.",
  'Aggiorna le correzioni di Windows': "Mettre à jour les correctifs Windows",
  'Importa le correzioni di Windows': "Importer les correctifs Windows",
  'Valuta e controlla i servizi': "Évaluer et contrôler les services",
  'Controllo dei servizi in corso…': "Contrôle des services en cours…",
  'Apre una connessione TLS verso le porte cifrate di questo asset: certificati scaduti, TLS obsoleto, cifrari deboli. Nessuna credenziale provata, nessun dato inviato.': "Ouvre une connexion TLS vers les ports chiffrés de cet actif : certificats expirés, TLS obsolète, chiffrements faibles. Aucun identifiant testé, aucune donnée envoyée.",
  'Valutazione con i controlli sui servizi affidata a una sonda — è l’unica che arriva su quella rete. I rischi compariranno qui appena la prende in carico.': "Évaluation avec les contrôles sur les services confiée à une sonde — c’est la seule qui atteigne ce réseau. Les constats apparaîtront ici dès qu’elle la prendra en charge.",
  '{pacchetto} è fuori supporto': "{pacchetto} est hors support",
  '{pacchetto} è indietro di {indietro} versioni': "{pacchetto} est en retard de {indietro} versions",
  'Prodotti senza voci': "Produits sans entrées",
  'Un prodotto a zero voci non vuol dire «nessuna vulnerabilità»: può voler dire che l’identificativo con cui lo cerchiamo non è più quello giusto.': "Un produit à zéro entrée ne signifie pas «aucune vulnérabilité» : cela peut vouloir dire que l’identifiant avec lequel nous le cherchons n’est plus le bon.",
  'Importazione in corso. Il NVD limita le richieste, quindi ci vuole qualche minuto: questa pagina si aggiorna da sola.': "Importation en cours. Le NVD limite les requêtes, cela prend donc quelques minutes : cette page se met à jour toute seule.",
  'Vulnerabilità dal NVD: software di terzi e apparati': "Vulnérabilités du NVD : logiciels tiers et équipements",
  'Due cose in una fonte sola: i difetti noti dei programmi di terzi che girano su Windows — 7-Zip, VLC, PuTTY, Adobe Reader — e il firmware degli apparati di rete, FortiOS, PAN-OS, Fireware. Né il catalogo delle distribuzioni Linux né il bollettino Microsoft li coprono.': "Deux choses dans une seule source : les failles connues des programmes tiers qui tournent sous Windows — 7-Zip, VLC, PuTTY, Adobe Reader — et le firmware des équipements réseau, FortiOS, PAN-OS, Fireware. Ni le catalogue des distributions Linux ni le bulletin Microsoft ne les couvrent.",
  'Mai importato: né dei programmi di terzi su Windows né del firmware degli apparati si può dire se hanno vulnerabilità note.': "Jamais importé : ni pour les programmes tiers sous Windows ni pour le firmware des équipements on ne peut dire s’ils présentent des vulnérabilités connues.",
  '{software} per il software, {apparati} per il firmware degli apparati': "{software} pour le logiciel, {apparati} pour le firmware des équipements",
  'Aggiorna le vulnerabilità dal NVD': "Mettre à jour les vulnérabilités du NVD",
  'Importa le vulnerabilità dal NVD': "Importer les vulnérabilités du NVD",
  'Filtra il menu': "Filtrer le menu",
  'Nessuna voce del menu corrisponde.': "Aucune entrée du menu ne correspond.",
  'Sezioni della pagina': "Sections de la page",
  'Backup': "Backup",
  'Ciclo di vita': "Cycle de vie",
  'Attributi': "Attributs",
  'Collegamenti': "Liens",
  'Attività': "Activité",
  'Agenti': "Agents",
  'Utenti abilitati': "Utilisateurs habilités",
  'Abilita utenza': "Activer le compte",
  'Accesso aziendale': "Accès entreprise",
  'Oggetti': "Objets",
  'Esecuzioni': "Exécutions",
  'Discovery': "Découverte",
  'Esclusi dalla mappa:': "Exclus de la carte :",
  'Riporta sulla mappa': "Réintégrer à la carte",
  'Ripristina tutti': "Tout rétablir",
  'Escludi dalla mappa': "Exclure de la carte",
  'Crea un business service da questa mappa': "Créer un business service à partir de cette carte",
  'Gli ingressi saranno i {quanti} nodi visibili, ognuno con il suo indirizzo e la porta su cui riceve più traffico.': "Les entrées seront les {quanti} nœuds visibles, chacun avec son adresse et le port sur lequel il reçoit le plus de trafic.",
  'I {esclusi} nodi esclusi restano fuori.': "Les {esclusi} nœuds exclus restent en dehors.",
  'Il servizio resta modificabile in ogni momento dalla pagina Business service.': "Le service reste modifiable à tout moment depuis la page Business service.",
  'Creato dalla mappa di correlazione di {seed} (finestra {finestra})': "Créé à partir de la carte de corrélation de {seed} (fenêtre {finestra})",
  'Crea il business service': "Créer le business service",
  'Creazione…': "Création…",
  'Business service creato': "Business service créé",
  'Aprilo in Business service per modificarlo →': "Ouvrez-le dans Business service pour le modifier →",
  'Critica': "Critique",
  'La mappa ha {quanti} nodi e un servizio ne accetta al massimo {massimo}: escludi quelli che non c’entrano (Maiusc+clic), o riduci livelli e vicini per nodo.': "La carte compte {quanti} nœuds et un service en accepte au maximum {massimo} : excluez ceux qui n’ont pas leur place (Maj+clic), ou réduisez les niveaux et voisins par nœud.",
  'Personalizza': "Personnaliser",
  'Fine': "Terminé",
  'Nessun apparato di rete in CMDB.': "Aucun équipement réseau dans le CMDB.",
  'Backup recente (≤{giorni} gg)': "Backup récent (≤{giorni} j)",
  'Senza backup': "Sans backup",
  'Nessuna valutazione di sicurezza ancora eseguita.': "Aucune évaluation de sécurité encore réalisée.",
  'Coperti da contratto': "Couverts par contrat",
  'Senza copertura': "Sans couverture",
  '{quanti} CI osservati non sono ancora registrati come beni.': "{quanti} CI observés ne sont pas encore enregistrés comme biens.",
  'Comunicazione scelta:': "Communication choisie :",
  'Escludi la comunicazione': "Exclure la communication",
  'Escludi': "Exclure",
  'Deseleziona': "Désélectionner",
  'Da': "De",
  'A': "À",
  'Mappa': "Carte",
  'Apri la mappa di correlazione partendo da questo indirizzo': "Ouvrir la carte de corrélation à partir de cette adresse",
  'Dettaglio': "Détail",
  'Esplora da qui': "Explorer à partir d’ici",
  '{quante} comunicazioni selezionate.': "{quante} communications sélectionnées.",
  'Escludi le selezionate': "Exclure les sélectionnées",
  'Annulla la selezione': "Annuler la sélection",
  'Mostra in mappa:': "Afficher sur la carte :",
  'Una mappa per indirizzo: la correlazione parte da un seme solo.': "Une carte par adresse : la corrélation part d’une seule graine.",
  'Guida': "Aide",
  'Come funziona questa pagina': "Comment fonctionne cette page",
  'Che cosa fa ogni area della console, e in che ordine si usa': "Ce que fait chaque zone de la console, et dans quel ordre l’utiliser",
  'Primi passi': "Premiers pas",
  'CENSO esegue discovery e aggiornamento automatico dell’inventario tramite sonde distribuite nella rete; il cambio tenant mantiene la sezione corrente, azzera i filtri e chiude l’eventuale oggetto aperto oppure, se la sezione non è disponibile, reindirizza alla Home.': 'CENSO exécute la découverte et met à jour l’inventaire automatiquement via des sondes réparties sur le réseau ; le changement de tenant conserve la section courante, réinitialise les filtres et ferme l’objet éventuellement ouvert ou, si la section n’est pas disponible, redirige vers l’accueil.',
  'genera un token di arruolamento e installa la prima sonda nella rete da osservare.': "générez un jeton d’enrôlement et installez la première sonde dans le réseau à observer.",
  'inserisci le credenziali SNMP, SSH o WinRM con cui le sonde possono interrogare gli apparati.': "saisissez les identifiants SNMP, SSH ou WinRM avec lesquels les sondes peuvent interroger les équipements.",
  'avvia la prima discovery su una subnet. I risultati compaiono in Configuration Item.': "lancez la première découverte sur un sous-réseau. Les résultats apparaissent dans Configuration Item.",
  'pianifica le scansioni ricorrenti: l’inventario resta aggiornato senza che nessuno lo rilanci.': "planifiez les analyses récurrentes : l’inventaire reste à jour sans que personne ait à le relancer.",
  'Ogni cosa scoperta diventa un Configuration Item: server, apparato, stampante, macchina virtuale. La scheda di un CI raccoglie tutto quello che se ne sa — anagrafica, interfacce, software, sicurezza, storico — con un indice in alto per saltare alla sezione.': "Chaque élément découvert devient un Configuration Item : serveur, équipement, imprimante, machine virtuelle. La fiche d’un CI rassemble tout ce que l’on en sait — identité, interfaces, logiciels, sécurité, historique — avec un index en haut pour sauter à la section.",
  'l’elenco completo, filtrabile. È la fotografia tecnica: la scrivono le scansioni. Seleziona più righe per agire in blocco: tag, «Dichiara dismesso», classe, «Togli dalla CMDB». Gli amministratori hanno «Trova doppioni»: l’anteprima dei CI che sono lo stesso oggetto, con la prova, e l’unione dei gruppi scelti. Con «Colonne» scegli quali colonne vedere e ne aggiungi altre (modello, seriale, sistema operativo…); quando la tabella non entra, frecce e ombre ai bordi dicono che continua.':
    'la liste complète, filtrable. C’est la photographie technique : ce sont les analyses qui l’écrivent. Sélectionnez plusieurs lignes pour agir en bloc : tags, «Déclarer hors service», classe, «Retirer de la CMDB». Les administrateurs disposent de «Trouver les doublons» : l’aperçu des CI qui sont le même objet, avec la preuve, et la fusion des groupes choisis. Avec «Colonnes», vous choisissez les colonnes à afficher et en ajoutez d’autres (modèle, numéro de série, système d’exploitation…) ; quand le tableau ne tient pas, des flèches et des ombres sur les bords indiquent qu’il continue.',
  'il registro dei beni: valore, stato, centro di costo. Si popola dai CI («Registra come bene») e vive anche quando la macchina viene spenta.': "le registre des biens : valeur, état, centre de coûts. Il se remplit à partir des CI (« Enregistrer comme bien ») et subsiste même lorsque la machine est éteinte.",
  'la mappa dei collegamenti fisici e logici. Centrata su un nodo, ogni linea dice le porte su cui si parlano; i nodi si trascinano, la rotella ingrandisce.': "la carte des liens physiques et logiques. Centrée sur un nœud, chaque ligne indique les ports par lesquels ils communiquent ; les nœuds se déplacent par glissement, la molette zoome.",
  'Le sonde raccolgono i flussi di rete (NetFlow/IPFIX): chi parla con chi, su quale porta, con quanto volume. Tre viste, per tre domande diverse.': "Les sondes collectent les flux réseau (NetFlow/IPFIX) : qui parle avec qui, sur quel port, avec quel volume. Trois vues, pour trois questions différentes.",
  'il registro del traffico, filtrabile. La domanda di tutti i giorni.': "le registre du trafic, filtrable. La question de tous les jours.",
  'gli indirizzi e le porte che ricevono connessioni — i servizi esposti della rete.': "les adresses et les ports qui reçoivent des connexions — les services exposés du réseau.",
  'Un business service è un gruppo di macchine e porte che insieme erogano qualcosa: «il gestionale», «la posta». Il flusso consigliato parte dal traffico:': "Un business service est un groupe de machines et de ports qui, ensemble, fournissent un service : « l’ERP », « la messagerie ». Le flux recommandé part du trafic :",
  'La valutazione rilegge quello che è già in inventario — porte, sistema, software — e lo confronta con i cataloghi pubblici: vulnerabilità note, aggiornamenti Windows mancanti, software a fine vita, firmware degli apparati.': "L’évaluation relit ce qui figure déjà dans l’inventaire — ports, système, logiciels — et le compare aux catalogues publics : vulnérabilités connues, mises à jour Windows manquantes, logiciels en fin de vie, firmwares des équipements.",
  'Sulla scheda di un CI: «Esegui valutazione» rilegge l’inventario; «Valuta e controlla i servizi» apre anche connessioni TLS verso l’asset — va a una sonda, perché dalla cloud la rete non risponde.': "Sur la fiche d’un CI : « Exécuter l’évaluation » relit l’inventaire ; « Évaluer et contrôler les services » ouvre en plus des connexions TLS vers l’asset — cela passe par une sonde, car depuis le cloud le réseau ne répond pas.",
  'I cataloghi si importano una volta e per tutti i clienti, dalla console di amministrazione: OSV per Linux, il bollettino Microsoft per Windows, il NVD per software di terzi e firmware.': "Les catalogues s’importent une seule fois et pour tous les clients, depuis la console d’administration : OSV pour Linux, le bulletin Microsoft pour Windows, le NVD pour les logiciels tiers et les firmwares.",
  'la copia delle configurazioni di switch e firewall, salvata a ogni scansione quando cambia. La domanda a cui risponde è «cosa è cambiato stanotte» — e il widget in dashboard dice chi non ha nessun backup.': "la copie des configurations des switchs et firewalls, enregistrée à chaque analyse lorsqu’elle change. La question à laquelle elle répond est « qu’est-ce qui a changé cette nuit » — et le widget du tableau de bord indique qui n’a aucun backup.",
  'per le macchine che nessuna scansione raggiunge — un server in una cloud altrui, un portatile. L’agente si installa con un comando, consegna l’inventario a intervalli e si aggiorna da solo.': "pour les machines qu’aucune analyse n’atteint — un serveur dans un cloud tiers, un portable. L’agent s’installe avec une commande, remet l’inventaire à intervalles réguliers et se met à jour de lui-même.",
  'le regole con cui la piattaforma classifica gli oggetti. Una correzione fatta a mano su un CI resiste alle scansioni successive.': "les règles selon lesquelles la plateforme classe les objets. Une correction effectuée manuellement sur un CI résiste aux analyses suivantes.",
  'licenza, filtri del traffico, password.': "licence, filtres du trafic, mots de passe.",
  'Quadro': "Vue d’ensemble",
  'Rischio del parco': "Risque du parc",
  'Sfruttate attivamente (CISA KEV)': "Activement exploitées (CISA KEV)",
  'Vulnerabilità che qualcuno sta già usando: prima di tutto il resto': "Vulnérabilités que quelqu’un est déjà en train d’utiliser : avant tout le reste",
  'Rischi critici e alti': "Constats critiques et élevés",
  'Su {totale} rischi aperti': "Sur {totale} constats ouverts",
  'Ultima valutazione': "Dernière évaluation",
  'Il silenzio vale quanto è fresco': "Le silence ne vaut que par sa fraîcheur",
  'Da dove cominciare': "Par où commencer",
  'Azioni correttive, da applicare per risolvere i rischi rilevati per singolo asset, ordinate per priorità.': 'Actions correctives à appliquer pour résoudre les risques détectés, par actif, classées par priorité.',
  'Nessun rischio corrisponde al filtro.': "Aucun constat ne correspond au filtre.",
  'Con più sedi conviene una sonda per sede, riunite in un gruppo (Gruppi di sonde): i job si assegnano al gruppo, e la sonda giusta se li prende da sola.': "Avec plusieurs sites, il vaut mieux une sonde par site, réunies dans un groupe (Groupes de sondes) : les job s’assignent au groupe, et la bonne sonde les prend d’elle-même.",
  'Se le credenziali cambiano da zona a zona, componi un gruppo di credenziali: la sonda le prova in ordine finché una risponde, e il rapporto dice quale ha funzionato.': "Si les identifiants changent d’une zone à l’autre, composez un groupe d’identifiants : la sonde les essaie dans l’ordre jusqu’à ce que l’un réponde, et le rapport indique lequel a fonctionné.",
  'definisci le zone su cui lavorare — subnet, sedi, ambienti. Sono il «dove», e si preparano prima di decidere il «come».': "définissez les zones sur lesquelles travailler — sous-réseaux, sites, environnements. Elles constituent le « où », et se préparent avant de décider le « comment ».",
  'componi i passi di una scansione: cosa provare, in che ordine, con quali credenziali. Un job si avvia da un piano.': "composez les étapes d’une analyse : quoi tester, dans quel ordre, avec quels identifiants. Un job se lance à partir d’un plan.",
  'Il rapporto di ogni job è la prima cosa da leggere quando qualcosa non torna: dice cosa ha trovato, cosa ha scartato e perché — comprese le cose che non ha potuto guardare. Un risultato vuoto senza leggere il rapporto non è un risultato: è un’assenza di risposta.': "Le rapport de chaque job est la première chose à lire lorsque quelque chose cloche : il indique ce qu’il a trouvé, ce qu’il a écarté et pourquoi — y compris ce qu’il n’a pas pu examiner. Un résultat vide sans lire le rapport n’est pas un résultat : c’est une absence de réponse.",
  'Un CI non si «chiude» a mano: se il fatto sparisce dalla rete, sparisce dalla scheda alla scansione successiva. Quello che invece si decide a mano — la classe, per esempio — resiste alle scansioni.': "Un CI ne se « ferme » pas à la main : si l’élément disparaît du réseau, il disparaît de la fiche à l’analyse suivante. Ce qui, en revanche, se décide manuellement — la classe, par exemple — résiste aux analyses.",
  'Sulla scheda di un CI: «Cambia classe» corregge una classificazione sbagliata, e la correzione dichiara chi l’ha fatta e perché; lo «Storico delle modifiche» dice cosa è cambiato scansione dopo scansione — è la risposta a «da quando è così?».': "Sur la fiche d’un CI : « Changer de classe » corrige une classification erronée, et la correction indique qui l’a faite et pourquoi ; l’« Historique des modifications » indique ce qui a changé d’une analyse à l’autre — c’est la réponse à « depuis quand est-ce ainsi ? ».",
  'La differenza è il ciclo di vita: il CI è ciò che si osserva, l’asset è ciò che si possiede. Un portatile rubato non è più un CI, ma resta un asset con uno stato.': "La différence tient au cycle de vie : le CI est ce que l’on observe, l’asset est ce que l’on possède. Un portable volé n’est plus un CI, mais reste un asset avec un état.",
  'gli estratti pronti da consegnare — attraversano inventario, beni, contratti e discovery.': "les extraits prêts à être remis — ils traversent l’inventaire, les biens, les contrats et la découverte.",
  'La tabella MAC dice chi è collegato dove: è la domanda che la mappa non sa raccontare.': "La table MAC indique qui est connecté où : c’est la question à laquelle la carte ne sait pas répondre.",
  'I gesti sulla mappa della topologia:': "Les gestes sur la carte de topologie :",
  'clic su un nodo: lo mette al centro e mostra solo il suo intorno, con la profondità scelta;': "clic sur un nœud : il le place au centre et n’affiche que son environnement, avec la profondeur choisie ;",
  'trascinare un nodo lo fissa dove l’hai messo — il contorno tratteggiato lo dichiara — e la disposizione automatica non lo sposta più;': "glisser un nœud le fixe là où vous l’avez placé — le contour en pointillés le signale — et la disposition automatique ne le déplace plus ;",
  'clic su una linea: la scheda del collegamento, con porte, protocolli e volumi;': "clic sur une ligne : la fiche du lien, avec ports, protocoles et volumes ;",
  'i filtri sopra la mappa restringono per famiglia di relazione, tipo di CI, porta e protocollo: «chi parla su 445» è un filtro, non una ricerca a occhio.': "les filtres au-dessus de la carte restreignent par famille de relation, type de CI, port et protocole : « qui parle sur 445 » est un filtre, non une recherche à l’œil.",
  'Le porte alte con un solo mittente sono nascoste: sono quasi sempre il ritorno di una connessione in uscita, non un servizio.': "Les ports hauts avec un seul émetteur sont masqués : ce sont presque toujours le retour d’une connexion sortante, non un service.",
  'chi sta mandando i flussi e quanto: la pagina da aprire quando i numeri sembrano sbagliati. Nella stessa tabella ci sono anche le sonde che catturano dal filo, con protocollo «Sonda».':
    'qui envoie les flux et en quelle quantité : la page à ouvrir quand les chiffres semblent faux. Le même tableau liste aussi les sondes qui capturent sur le câble, avec le protocole «Sonde».',
  'Sulla mappa di correlazione, tre parametri decidono cosa vedi:': "Sur la carte de corrélation, trois paramètres déterminent ce que vous voyez :",
  'Livelli: quanti salti dal seme. Uno sono i vicini, due i vicini dei vicini; oltre il terzo è quasi sempre l’intera rete.': "Niveaux : combien de sauts depuis la graine. Un, ce sont les voisins ; deux, les voisins des voisins ; au-delà du troisième, c’est presque toujours le réseau entier.",
  'Vicini per nodo: il tetto per non affogare — si mostrano i più voluminosi, e il segno ⁺ dichiara che c’è dell’altro. Una mappa che tronca in silenzio non è incompleta: è falsa.': "Voisins par nœud : le plafond pour ne pas être submergé — on affiche les plus volumineux, et le signe ⁺ indique qu’il y en a d’autres. Une carte qui tronque en silence n’est pas incomplète : elle est fausse.",
  'Verso: chi gli ha parlato (i suoi client), con chi ha parlato (le sue dipendenze), o entrambi.': "Sens : qui lui a parlé (ses clients), avec qui il a parlé (ses dépendances), ou les deux.",
  'In giallo gli indirizzi che la CMDB non conosce. Non è un difetto della mappa: trovarli è uno dei motivi per cui il traffico si raccoglie.': "En jaune, les adresses que la CMDB ne connaît pas. Ce n’est pas un défaut de la carte : les trouver est l’une des raisons pour lesquelles le trafic est collecté.",
  'Il servizio si definisce dai suoi punti di ingresso; la mappa si ricava dal traffico osservato, seguendo i salti fino alla profondità scelta (max depth). Due salti bastano per «front-end → applicativo → database»; su una rete piatta alzarlo include mezza infrastruttura.': "Le service se définit par ses points d’entrée ; la carte se déduit du trafic observé, en suivant les sauts jusqu’à la profondeur choisie (max depth). Deux sauts suffisent pour « front-end → applicatif → base de données » ; sur un réseau plat, l’augmenter inclut la moitié de l’infrastructure.",
  'La criticità serve a ordinare le cure: quando un asset compare in più servizi, vale il più critico dei due.': "La criticité sert à hiérarchiser les traitements : lorsqu’un asset apparaît dans plusieurs services, c’est le plus critique des deux qui prévaut.",
  'si apre con il quadro — la ruota del rischio e le vulnerabilità già sfruttate attivamente (CISA KEV) — poi «Cosa fare», gli asset da cui cominciare, e i rischi uno per uno con la prova.': "s’ouvre sur la vue d’ensemble — la roue du risque et les vulnérabilités déjà activement exploitées (CISA KEV) — puis « Que faire », les asset par lesquels commencer, et les constats un par un avec la preuve.",
  'I controlli sui servizi sono una stretta di mano e basta: nessuna credenziale provata, nessun dato inviato.': "Les contrôles sur les services se limitent à une poignée de main : aucun identifiant essayé, aucune donnée envoyée.",
  'Come leggere quello che vedi:': "Comment lire ce que vous voyez :",
  '«Sfruttata attivamente (CISA KEV)» batte qualunque punteggio: non è una previsione di gravità, è che qualcuno la sta usando adesso. È il rischio di stanotte, non di prima o poi.': "« Activement exploitée (CISA KEV) » l’emporte sur n’importe quel score : ce n’est pas une prévision de gravité, c’est que quelqu’un est en train de l’utiliser maintenant. C’est le constat de cette nuit, pas d’un jour ou l’autre.",
  'Ogni rischio porta la prova: da quale fatto viene, con quali numeri. Un rischio che non si può verificare è un’opinione — e si può controllare in un minuto invece di crederci.': "Chaque constat apporte sa preuve : de quel fait il provient, avec quels chiffres. Un constat que l’on ne peut pas vérifier est une opinion — et on peut le contrôler en une minute au lieu d’y croire.",
  'Un rischio si può accettare, con un motivo e una scadenza obbligatoria: senza scadenza sarebbe un modo di nascondere le cose per sempre. Alla scadenza il rischio ricompare.': "Un risque peut être accepté, avec un motif et une échéance obligatoire : sans échéance, ce serait une façon de masquer les choses pour toujours. À l’échéance, le constat réapparaît.",
  'Le lacune si dichiarano: «di questa macchina non conosco il livello di aggiornamento» vale più di un silenzio che sembra un via libera. Un elenco vuoto vale quanto il rapporto che lo accompagna.': "Les lacunes se déclarent : « de cette machine je ne connais pas le niveau de mise à jour » vaut mieux qu’un silence qui ressemble à un feu vert. Une liste vide ne vaut que par le rapport qui l’accompagne.",
  'Ogni apparato ha la sua storia di revisioni: si vede cosa è cambiato fra due salvataggi, e quando. Una configurazione che cambia senza che nessuno l’abbia toccata è la prima cosa da guardare.': "Chaque équipement possède son historique de révisions : on voit ce qui a changé entre deux enregistrements, et quand. Une configuration qui change sans que personne n’y ait touché est la première chose à examiner.",
  'Si salva solo quando cambia: cento notti uguali sono una revisione, non cento.': "On n’enregistre que lorsque cela change : cent nuits identiques font une révision, pas cent.",
  'Sulla scheda del CI di un apparato, il riquadro del backup dice subito se è recente e quante versioni esistono: verde se fresco.': "Sur la fiche du CI d’un équipement, l’encadré du backup indique aussitôt s’il est récent et combien de versions existent : vert s’il est frais.",
  'L’installazione è un comando da copiare, valido per una finestra di tempo: scaduta quella, se ne genera un altro. Il comando contiene già l’identità dell’agente.': "L’installation est une commande à copier, valable pendant une fenêtre de temps : passé ce délai, on en génère une autre. La commande contient déjà l’identité de l’agent.",
  'L’aggiornamento è automatico e avviene a fine consegna: se fallisce, l’inventario è già arrivato. Si può spegnere per agente, dalla console.': "La mise à jour est automatique et intervient à la fin de la remise : si elle échoue, l’inventaire est déjà arrivé. On peut la désactiver par agent, depuis la console.",
  'Su Windows l’agente legge anche il livello di aggiornamento del sistema dal registro: è il dato che nessuna CMDB esterna può portare, e che serve alla valutazione di sicurezza.': "Sous Windows, l’agent lit également le niveau de mise à jour du système dans le registre : c’est la donnée qu’aucune CMDB externe ne peut apporter, et qui sert à l’évaluation de sécurité.",
  'Il widget dei backup ha la fetta che conta: gli apparati senza nessun backup, che nella pagina delle configurazioni sono invisibili per definizione.': "Le widget des backup possède la part qui compte : les équipements sans aucun backup, qui, dans la page des configurations, sont invisibles par définition.",
  'Sonar e radar sono due modi di guardare il parco a colpo d’occhio: si accendono a mano, perché una cosa che lampeggia non deve essere il primo saluto della giornata.': "Sonar et radar sont deux façons de regarder le parc d’un coup d’œil : ils s’activent à la main, car une chose qui clignote ne doit pas être le premier salut de la journée.",
  'Su ogni pagina, accanto al percorso in alto, «Come funziona questa pagina» apre questa guida alla sezione giusta.': "Sur chaque page, à côté du chemin en haut, « Comment fonctionne cette page » ouvre ce guide à la bonne section.",
  'Tre ruoli: l’amministratore gestisce utenti, credenziali e sonde; l’operatore avvia le discovery e lavora sui dati; la sola lettura consulta e basta.': "Trois rôles : l’administrateur gère les utilisateurs, les identifiants et les sondes ; l’opérateur lance les découverte et travaille sur les données ; la lecture seule ne fait que consulter.",
  'Prima di salvare una regola, l’anteprima dice quanti CI cambierebbero classe: una regola scritta male riscrive l’inventario di tutti.': "Avant d’enregistrer une règle, l’aperçu indique combien de CI changeraient de classe : une règle mal écrite réécrit l’inventaire de tout le monde.",
  'lo scambio con gli altri sistemi — l’ITSM, una CMDB esistente: cosa sincronizzare, in che direzione, ogni quanto. Ogni esecuzione lascia il suo rapporto.': "l’échange avec les autres systèmes — l’ITSM, une CMDB existante : quoi synchroniser, dans quelle direction, à quelle fréquence. Chaque exécution laisse son rapport.",
  'quanto si sta consumando rispetto alla licenza, prima che lo dica un limite.': "ce qui est consommé par rapport à la licence, avant qu’une limite ne le signale.",
  'I filtri del traffico decidono cosa si conserva dei flussi: si impostano una volta e valgono per tutta l’organizzazione.': "Les filtres du trafic déterminent ce qui est conservé des flux : ils se configurent une seule fois et valent pour toute l’organisation.",
  'CENSO è un prodotto DiscoveryGuard': "CENSO est un produit DiscoveryGuard",
  'DORA Compliance': "Conformité DORA",
  'Conformità al Regolamento UE 2022/2554 (DORA), valutata sui dati raccolti, con evidenza esplicita dei requisiti non misurabili.': 'Conformité au règlement UE 2022/2554 (DORA), évaluée sur les données recueillies, avec mise en évidence explicite des exigences non mesurables.',
  'I requisiti DORA non verificabili tramite l’inventario richiedono evidenze organizzative, tra cui gestione degli incidenti ICT, test di resilienza e registro dei fornitori. Il report li distingue dai controlli misurati, evitando di attribuire conformità in assenza di evidenze.': 'Les exigences DORA non vérifiables via l’inventaire nécessitent des preuves organisationnelles, dont la gestion des incidents TIC, les tests de résilience et le registre des fournisseurs. Le rapport les distingue des contrôles mesurés, évitant d’attribuer une conformité en l’absence de preuves.',
  'lo stesso motore, sul regolamento UE 2022/2554 per le entità finanziarie. Cambiano gli articoli citati e pesa di più il «non misurato»: incidenti, test di resilienza e registro dei fornitori vanno coperti altrove, e la pagina lo dichiara.': "le même moteur, appliqué au règlement UE 2022/2554 pour les entités financières. Les articles cités changent et le « non mesuré » pèse davantage : incidents, tests de résilience et registre des fournisseurs doivent être couverts ailleurs, et la page le déclare.",
  'Governance e organizzazione interna': "Gouvernance et organisation interne",
  'Quadro documentato di gestione del rischio ICT': "Cadre documenté de gestion du risque TIC",
  'Continuità operativa ICT e piani di risposta': "Continuité opérationnelle TIC et plans de réponse",
  'Apprendimento dagli incidenti e revisioni': "Apprentissage tiré des incidents et révisions",
  'Gestione e segnalazione degli incidenti ICT': "Gestion et notification des incidents TIC",
  'Test di resilienza operativa digitale (incluso il TLPT)': "Tests de résilience opérationnelle numérique (y compris le TLPT)",
  'Rischio ICT da terze parti e registro dei contratti': "Risque TIC lié aux tiers et registre des contrats",
  'Condivisione delle informazioni sulle minacce': "Partage des informations sur les menaces",
  'Dettaglio reputazione': "Détail de la réputation",
  'Reputazione controllata al': "Réputation vérifiée le",
  '«Nuovo CI» crea a mano la macchina che nessuna scansione raggiunge. Dichiara seriale, indirizzo o nome host: sono le chiavi con cui la discovery, quando arriverà, riconoscerà l’oggetto invece di duplicarlo.': "« Nouveau CI » crée manuellement la machine qu’aucune analyse n’atteint. Déclarez numéro de série, adresse ou nom d’hôte : ce sont les clés avec lesquelles la découverte, lorsqu’elle arrivera, reconnaîtra l’objet au lieu de le dupliquer.",
  'Indirizzo MAC': "Adresse MAC",
  'Indizio di virtualizzazione': "Indice de virtualisation",
  'Account': "Compte",
  'Costo del mese': 'Coût mensuel',
  'Valuta dei costi': "Devise des coûts",
  'Costi per servizio': "Coûts par service",
  'Costi: inizio periodo': "Coûts : début de période",
  'Costi: fine periodo': "Coûts : fin de période",
  'indirizzo della piattaforma': "adresse de la plateforme",
  'assegna un indirizzo dedicato': "attribuer une adresse dédiée",
  'Prerequisiti: DNS wildcard del dominio base verso il control plane, e certificato da riemettere includendo il nome nuovo (Amministrazione → Piattaforma).': "Prérequis : DNS wildcard du domaine de base vers le control plane, et certificat à réémettre en incluant le nouveau nom (Administration → Plateforme).",
  'Primo utente': "Premier utilisateur",
  'Il primo amministratore del tenant.': "Le premier administrateur du tenant.",
  'email': "e-mail",
  'nome (facoltativo)': "nom (facultatif)",
  'Crea amministratore': "Créer l’administrateur",
  'Posta in uscita (SMTP)': "Courrier sortant (SMTP)",
  'Da qui escono inviti e avvisi. Si usa il relay dell’organizzazione: la posta parte dal vostro dominio, con le vostre policy.': "C’est d’ici que partent les invitations et les alertes. On utilise le relais de l’organisation : le courrier part de votre domaine, avec vos policy.",
  'Relay SMTP': "Relais SMTP",
  'Cifratura': "Chiffrement",
  'nessuna — solo relay interni': "aucun — uniquement relais internes",
  'Utente': "Utilisateur",
  'salvata — lascia vuoto per non cambiarla': "enregistré — laissez vide pour ne pas le changer",
  'Mittente': "Expéditeur",
  'Nome del mittente': "Nom de l’expéditeur",
  'indirizzo per la prova': "adresse pour le test",
  'Invia messaggio di prova': "Envoyer un message de test",
  'Prima salva la configurazione': "Enregistrez d’abord la configuration",
  'Configurazione salvata.': "Configuration enregistrée.",
  'Messaggio di prova consegnato al relay: controlla la casella.': "Message de test remis au relais : vérifiez la boîte de réception.",
  'smtp.azienda.it': "smtp.azienda.it",
  'censo@azienda.it': "censo@azienda.it",
  'Indirizzi o subnet (CIDR), separati da virgola': "Adresses ou sous-réseaux (CIDR), séparés par une virgule",
  '{creati} indirizzi creati, {esistenti} già presenti.': "{creati} adresses créées, {esistenti} déjà présentes.",
  'Una subnet diventa UN CI, con la tabella dei suoi indirizzi sulla scheda (fino a una /24): la verifica di reputazione la riempie indirizzo per indirizzo. Un indirizzo scritto da solo diventa un CI suo.': "Un sous-réseau devient UN CI, avec la table de ses adresses sur la fiche (jusqu’à un /24) : la vérification de réputation la remplit adresse par adresse. Une adresse saisie seule devient un CI à part entière.",
  'Dichiara': "Déclarer",
  'Togli dalla CMDB': "Retirer de la CMDB",
  '{tolti} voci tolte dalla CMDB.': "{tolti} entrées retirées de la CMDB.",
  'Indirizzi della subnet': "Adresses du sous-réseau",
  'La reputazione si verifica indirizzo per indirizzo, su più fonti; il rischio — se qualcosa è segnalato — è uno, su questa subnet.': "La réputation se vérifie adresse par adresse, sur plusieurs sources ; le constat — si quelque chose est signalé — est unique, pour ce sous-réseau.",
  'Mai verificata: premi «Verifica reputazione» per riempire la tabella.': "Jamais vérifiée : appuyez sur « Vérifier la réputation » pour remplir la table.",
  'Subnet (CIDR)': "Sous-réseau (CIDR)",
  'Indirizzi contenuti': "Adresses contenues",
  'Reputazione per indirizzo': "Réputation par adresse",
  'Reputazione IP (AbuseIPDB)': "Réputation IP (AbuseIPDB)",
  'chiave API di AbuseIPDB': "clé API AbuseIPDB",
  'configurata — incolla una chiave per sostituirla': "configurée — collez une clé pour la remplacer",
  'Togli la chiave': "Retirer la clé",
  'es. Uffici Milano': "ex. Bureaux Milan",
  'a cosa serve, chi la gestisce…': "à quoi elle sert, qui la gère…",
  'Gli IP pubblici: dalla scheda di un CI si dichiarano gli indirizzi che lo espongono; da «Nuovo CI» → «IP pubblico» si dichiarano indirizzi e subnet dell’organizzazione — una subnet è un CI solo, con la tabella dei suoi indirizzi sulla scheda. «Verifica reputazione» interroga più fonti (tre DNSBL, più AbuseIPDB con la chiave): segnalato se almeno una segnala, e una query senza risposta è «non verificabile», non un pulito.': "Les IP publiques : depuis la fiche d’un CI, on déclare les adresses qui l’exposent ; depuis « Nouveau CI » → « IP publique », on déclare les adresses et sous-réseaux de l’organisation — un sous-réseau est un seul CI, avec la table de ses adresses sur la fiche. « Vérifier la réputation » interroge plusieurs sources (trois DNSBL, plus AbuseIPDB avec la clé) : signalé si au moins une signale, et une requête sans réponse est « non vérifiable », non un blanc-seing.",
  'Amministratori della piattaforma': "Administrateurs de la plateforme",
  'reimposta password': "réinitialiser le mot de passe",
  'Reimposta': "Réinitialiser",
  'nuova password (min 10)': "nouveau mot de passe (min 10)",
  'password attuale': "mot de passe actuel",
  'Cambia la mia password': "Changer mon mot de passe",
  'La tua password. Serve quella attuale: un token rubato non deve bastare a sostituirla.': "Votre mot de passe. Le mot de passe actuel est requis : un jeton volé ne doit pas suffire à le remplacer.",
  'Password cambiata.': "Mot de passe modifié.",
  'Password reimpostata: comunicala di persona, non per iscritto dove resta.': "Mot de passe réinitialisé : communiquez-le de vive voix, pas par écrit où il subsiste.",
  'rinomina': "renommer",
  'Abilitazioni': "Autorisations",
  'abilita su un tenant': "activer sur un tenant",
  'Abilita': "Activer",
  'Abilita subito su': "Activer immédiatement sur",
  'nessun tenant (per ora)': "aucun tenant (pour l’instant)",
  'nessun tenant: non può entrare': "aucun tenant : ne peut pas se connecter",
  'piattaforma': "plateforme",
  'tenant…': "tenant…",
  'Con una chiave API, la verifica della reputazione degli IP pubblici utilizza anche AbuseIPDB, oltre alle tre DNSBL. La chiave e la relativa quota sono associate al contratto. Il piano gratuito prevede 1000 verifiche giornaliere.':
    "Avec une clé API, la vérification de réputation des IP publiques interroge aussi AbuseIPDB en plus des trois DNSBL. La clé est la vôtre : votre quota, votre contrat — le plan gratuit suffit (mille vérifications par jour).",
  'Scegli la tua password': "Choisissez votre mot de passe",
  'Nuova password (almeno 10 caratteri)': "Nouveau mot de passe (au moins 10 caractères)",
  'Ripetila': "Répétez-le",
  'Imposta la password': "Définir le mot de passe",
  'Le due password non coincidono.': "Les deux mots de passe ne correspondent pas.",
  'Password impostata: puoi entrare.': "Mot de passe défini : vous pouvez vous connecter.",
  'Vai all’accesso': "Aller à la connexion",
  'Questo collegamento è incompleto: apri quello ricevuto per email.': "Ce lien est incomplet : ouvrez celui reçu par e-mail.",
  'Nessuna password da scegliere: la persona riceve un’email con un collegamento a scadenza (72 ore) e la imposta da sola. Serve la posta in uscita configurata.': "Aucun mot de passe à choisir : la personne reçoit un e-mail avec un lien à échéance (72 heures) et le définit elle-même. Le courrier sortant doit être configuré.",
  'Nessuna password da scegliere: la persona riceve un’email con un collegamento a scadenza e la imposta da sola. Un’email già esistente viene abilitata senza toccarne le credenziali.': "Aucun mot de passe à choisir : la personne reçoit un e-mail avec un lien à échéance et le définit elle-même. Un e-mail déjà existant est activé sans toucher à ses identifiants.",
  'Attiva la verifica': "Activer la vérification",
  'Verifica in due passaggi': "Vérification en deux étapes",
  'Protegge l’accesso con un ulteriore fattore di autenticazione (Google Authenticator, Aegis, 1Password…)':
    "Un code issu de l’application d’authentification (Google Authenticator, Aegis, 1Password…) en plus du mot de passe. Le code réside sur votre téléphone, hors ligne : rien n’est envoyé à personne.",
  'attiva': "activer",
  'Disattiva': "Désactiver",
  'codice per disattivare': "code pour désactiver",
  '1. Aggiungi la chiave all’app di autenticazione (inserimento manuale, o apri il collegamento dal telefono):': "1. Ajoutez la clé à l’application d’authentification (saisie manuelle, ou ouvrez le lien depuis le téléphone) :",
  'apri nell’app di autenticazione': "ouvrir dans l’application d’authentification",
  '2. Conferma con il codice che l’app mostra adesso:': "2. Confirmez avec le code que l’application affiche maintenant :",
  'Conferma e attiva': "Confirmer et activer",
  'Verifica in due passaggi attiva: dal prossimo accesso servirà il codice.': "Vérification en deux étapes active : dès la prochaine connexion, le code sera requis.",
  'Verifica in due passaggi disattivata.': "Vérification en deux étapes désactivée.",
  'Il codice dell’app di autenticazione': "Le code de l’application d’authentification",
  'Codice a 6 cifre': "Code à 6 chiffres",
  'Verifica…': "Vérification…",
  'eliminare definitivamente?': "supprimer définitivement ?",
  'Chiavi per il riconoscimento': "Clés pour la reconnaissance",
  'Indirizzi da dichiarare': "Adresses à déclarer",
  'es. srv-sede-nord': "ex. srv-sede-nord",
  'e altre {quante} voci': "et {quante} autres entrées",
  'srv-nord-01': "srv-nord-01",
  'Registro': "Journal",
  'Per problema': "Par problème",
  'Nessun problema': "Aucun problème",
  'Nessun errore o avviso in questa scansione.': "Aucune erreur ni avertissement dans cette analyse.",
  'Salva anche le configurazioni degli apparati (backup)': "Enregistrer aussi les configurations des équipements (sauvegarde)",
  'Alla conferma parte un secondo job di backup sugli stessi bersagli, con la credenziale SSH scelta qui sotto: due job e due rapporti, così il backup può fallire senza sporcare la scansione.': "À la confirmation, un second job de sauvegarde démarre sur les mêmes cibles, avec l’identifiant SSH choisi ci-dessous : deux jobs et deux rapports, ainsi la sauvegarde peut échouer sans altérer l’analyse.",
  'Credenziale SSH per il backup': "Identifiant SSH pour la sauvegarde",
  'Imposta backup': "Configurer la sauvegarde",
  'credenziale SSH…': "identifiant SSH…",
  'Salva ora': "Enregistrer maintenant",
  'Avvio…': "Démarrage…",
  'Backup avviato (job {id}…): l’esito compare qui sopra e nel rapporto del job.': "Sauvegarde démarrée (job {id}…) : le résultat apparaît ci-dessus et dans le rapport du job.",
  'Per avviare un backup da qui serve l’indirizzo di gestione, che questo CI non ha.': "Pour démarrer une sauvegarde d’ici, il faut l’adresse de gestion, que ce CI n’a pas.",
  'Nessun componente': "Aucun composant",
  'Nessun traffico osservato dagli ingressi nella finestra scelta.': "Aucun trafic observé depuis les entrées dans la fenêtre choisie.",
  'Vale per OGNI apparato di rete — switch, router, firewall, bilanciatori, controller wireless: se la scheda ha il riquadro Backup, si può salvare.': "Vaut pour CHAQUE équipement réseau — switchs, routeurs, pare-feux, répartiteurs de charge, contrôleurs sans fil : si la fiche comporte l’encadré Sauvegarde, on peut l’enregistrer.",
  'Due modi per avviarlo: il flag «Salva anche le configurazioni» sulla scansione o sulla pianificazione di rete (parte un secondo job, con la sua credenziale SSH e il suo rapporto); oppure «Imposta backup» sulla scheda dell’apparato — credenziale SSH, «Salva ora», e vale solo per lui.': "Deux façons de le lancer : la case «Enregistrer aussi les configurations» sur l’analyse ou sur la planification réseau (un second job démarre, avec son identifiant SSH et son rapport) ; ou «Configurer la sauvegarde» sur la fiche de l’équipement — identifiant SSH, «Enregistrer maintenant», et cela ne vaut que pour lui.",
  'Quanto raccogliere si sceglie una volta, dalla console, e vale per tutte le esecuzioni: «fast» (identità, sistema, rete), «full» (dischi, servizi, account, sicurezza — ma NON il software), «software» (rapida più software), «all» (tutto: è il predefinito). Se il modo esclude il software, l’agente lo dichiara fra i non letti.': "Ce qu’il faut collecter se choisit une fois, depuis la console, et vaut pour toutes les exécutions : «fast» (identité, système, réseau), «full» (disques, services, comptes, sécurité — mais PAS le logiciel), «software» (rapide plus logiciel), «all» (tout : c’est la valeur par défaut). Si le mode exclut le logiciel, l’agent le déclare parmi les éléments non lus.",
  'Oltre al comando c’è il download diretto del binario — su Windows il .exe — per chi non può eseguire script scaricati: il file va accompagnato dalla configurazione, che lo script scriverebbe da solo.': "Outre la commande, il y a le téléchargement direct du binaire — sous Windows le .exe — pour ceux qui ne peuvent pas exécuter de scripts téléchargés : le fichier doit être accompagné de la configuration, que le script écrirait lui-même.",
  'Il rapporto di una scansione ha due viste: il registro cronologico e «Per problema», che raggruppa errori e avvisi per causa e dice quali host colpisce — su una /24 è la vista con cui si capisce cosa non è andato.': "Le rapport d’une analyse a deux vues : le journal chronologique et «Par problème», qui regroupe erreurs et avertissements par cause et indique quels hôtes sont touchés — sur un /24, c’est la vue avec laquelle on comprend ce qui n’a pas fonctionné.",
  'Pacchetto RPM (Linux: RHEL, Rocky, AlmaLinux, Oracle, SUSE…)': "Paquet RPM (Linux : RHEL, Rocky, AlmaLinux, Oracle, SUSE…)",
  'L’RPM contiene il binario e il servizio systemd «censo-inventory», ma non la configurazione: lo stesso pacchetto va su molti host, mentre il file con il segreto è diverso per ciascuno. Lo installa la tua piattaforma (Ansible) e lo avvia systemd, non il cron.': "Le RPM contient le binaire et le service systemd « censo-inventory », mais pas la configuration : le même paquet va sur de nombreux hôtes, tandis que le fichier contenant le secret diffère pour chacun. C’est votre plateforme (Ansible) qui l’installe et systemd qui le lance — pas cron.",
  'Da Ansible: ansible.builtin.dnf per il pacchetto, un template per /etc/censo/inventory.json (0600), ansible.builtin.systemd con enabled e state=started. La configurazione di questo host è il file qui sotto (oppure rigenera il comando per averne una nuova).': "Depuis Ansible : ansible.builtin.dnf pour le paquet, un template pour /etc/censo/inventory.json (0600), ansible.builtin.systemd avec enabled et state=started. La configuration de cet hôte est le fichier ci-dessous (ou régénérez la commande pour en obtenir une nouvelle).",
  'Oppure scarica il binario e configura a mano': "Ou téléchargez le binaire et configurez à la main",
  'Il file scaricato va accompagnato dal file di configurazione: senza, l’agente non sa a chi consegnare. Lo script lo scrive da solo; a mano, chiedi la configurazione rigenerando il comando.': "Le fichier téléchargé doit être accompagné du fichier de configuration : sans lui, l’agent ne sait pas à qui remettre les données. Le script l’écrit lui-même ; à la main, demandez la configuration en régénérant la commande.",
  'Come si salva': "Comment on enregistre",
  'Prova NETCONF prima della CLI': "Essayer NETCONF avant la CLI",
  'Quando disponibile, acquisisce la configurazione in formato strutturato e senza paginazione; in caso contrario, utilizza automaticamente la CLI. Disabilita questa modalità solo se il dispositivo presenta problemi durante il tentativo di acquisizione.':
    "Là où il est présent, la configuration arrive structurée et sans pagination. Là où il ne l’est pas, on passe seul à la CLI : le désactiver ne sert que si un équipement réagit mal à la tentative.",
  'Escludi le credenziali dall’archiviazione':
    "Masquer les secrets avant d’enregistrer",
  'Password, chiavi e community vengono escluse dall’archiviazione per evitare la conservazione permanente delle credenziali. Una configurazione salvata potrà essere ripristinata unicamente reinserendo manualmente le credenziali.':
    "Mots de passe, clés et community ne se retrouvent pas dans l’archive — qui les conserverait pour toujours. Le prix à payer est que la configuration enregistrée ne peut pas être restaurée sans ressaisir les identifiants à la main : on choisit en connaissance de cause.",
  'Vale per tutti i salvataggi, dei job e delle pianificazioni: una scelta sola, un archivio coerente.': "Vaut pour tous les enregistrements, des jobs et des planifications : un seul choix, une archive cohérente.",
  'Gestisci utenti': "Gérer les utilisateurs",
  'Abilitati': "Activés",
  'Non abilitati': "Non activés",
  'Rimuovi selezionati': "Supprimer la sélection",
  'Abilita selezionati': "Activer la sélection",
  'Rimossi.': "Supprimés.",
  'Abilitati.': "Activés.",
  'Rifiutati:': "Refusés :",
  'amministratore': "administrateur",
  'operatore': "opérateur",
  'sola lettura': "lecture seule",
  'togli (torna all’indirizzo della piattaforma)': "retirer (revenir à l’adresse de la plateforme)",
  'Salva i nomi di servizio': "Enregistrer les noms de service",
  'Un nome nuovo va prima pubblicato nel DNS e incluso nel certificato. Il canale delle sonde deve restare fuori da qualunque proxy TLS (le sonde si autenticano in mTLS): dietro un proxy prendono 403.': "Un nouveau nom doit d’abord être publié dans le DNS et inclus dans le certificat. Le canal des sondes doit rester hors de tout proxy TLS (les sondes s’authentifient en mTLS) : derrière un proxy, elles reçoivent une erreur 403.",
  'Avanti': "Suivant",
  'Controllo…': "Contrôle…",
  'oppure con la password': "ou avec le mot de passe",
  'Ti sto portando su {provider}…': "Redirection vers {provider}…",
  'Nuovo CI': "Nouveau CI",
  'Crea': "Créer",
  'Numero di serie': "Numéro de série",
  'Per la macchina che nessuna scansione raggiunge: la sede staccata, l’apparato ordinato e non ancora in rete. Le chiavi qui sotto permettono alla discovery, quando arriverà, di riconoscerlo invece di duplicarlo.': "Pour la machine qu’aucune analyse n’atteint : le site isolé, l’équipement commandé et pas encore en réseau. Les clés ci-dessous permettent à la découverte, quand elle arrivera, de le reconnaître au lieu de le dupliquer.",
  'Senza seriale, indirizzo o nome host il CI si crea lo stesso, ma la discovery non avrà modo di riconoscerlo: se la macchina verrà scandita, diventerà un doppione.': "Sans numéro de série, adresse ou nom d’hôte, le CI se crée quand même, mais la découverte n’aura aucun moyen de le reconnaître : si la machine est analysée, elle deviendra un doublon.",
  'Nessun contratto collegato a questo bene.': "Aucun contrat lié à ce bien.",
  'Valido oggi': "Valide aujourd’hui",
  'valido': "valide",
  'non valido': "non valide",
  'Copertura': "Couverture",
  'Aggancia a un contratto…': "Rattacher à un contrat…",
  'Aggancia': "Rattacher",
  'Aggancio…': "Rattachement…",
  'Sgancia': "Détacher",
  'IP pubblici': "IP publiques",
  'Indirizzi, separati da virgola': "Adresses, séparées par des virgules",
  'Prima dichiara e salva almeno un indirizzo': "Déclarez et enregistrez d’abord au moins une adresse",
  'Verifica reputazione': "Vérifier la réputation",
  'Verifica in corso…': "Vérification en cours…",
  'Reputazione': "Réputation",
  'Controllato': "Contrôlé",
  'mai verificata': "jamais vérifiée",
  'pulito': "propre",
  'segnalato': "signalé",
  'non verificabile': "non vérifiable",
  'NIS2 Compliance': "Conformité NIS2",
  'Conformità alla Direttiva UE 2022/2555 (NIS2), valutata sui dati raccolti, con evidenza esplicita dei requisiti non misurabili.': 'Conformité à la directive UE 2022/2555 (NIS2), évaluée sur les données recueillies, avec mise en évidence explicite des exigences non mesurables.',
  'Requisiti': "Exigences",
  'Nessun asset in inventario': "Aucun actif à l’inventaire",
  'La conformità si misura su quello che c’è: avvia una discovery.': "La conformité se mesure sur ce qui existe : lancez une découverte.",
  'Conformità del parco': "Conformité du parc",
  'Asset critici': "Actifs critiques",
  'Vulnerabilità sfruttate attivamente (CISA KEV) o sistemi fuori supporto': "Vulnérabilités activement exploitées (CISA KEV) ou systèmes hors support",
  'Da verificare': "À vérifier",
  'Mancano dati per giudicare: agente o controlli sui servizi': "Données manquantes pour juger : agent ou contrôles sur les services",
  'Generato': "Généré",
  'Sui rischi aperti e sull’inventario di adesso': "Sur les constats ouverts et l’inventaire actuel",
  'Requisiti misurati': "Exigences mesurées",
  'Ogni controllo è associato all’articolo della direttiva di riferimento. Le barre mostrano gli asset conformi, non conformi e quelli per cui mancano dati sufficienti alla valutazione.': 'Chaque contrôle est associé à l’article de la directive de référence. Les barres montrent les actifs conformes, non conformes et ceux pour lesquels les données sont insuffisantes pour l’évaluation.',
  'Controllo': "Contrôle",
  'Articolo': "Article",
  'Esiti': "Résultats",
  'Superato da': "Réussi par",
  'Punteggio': "Score",
  'Passa sopra un pallino per il motivo: ● superato o fallito, ◐ non valutabile (il motivo dice come procurarsi il dato), — non applicabile.': "Survolez une pastille pour le motif : ● réussi ou échoué, ◐ non évaluable (le motif indique comment obtenir la donnée), — non applicable.",
  'La NIS2 include requisiti non verificabili attraverso i soli dati tecnici. Questi devono essere coperti da processi, procedure o contratti e dichiarati esplicitamente, per evitare che l’assenza di evidenze venga interpretata come conformità.': 'NIS2 comprend des exigences non vérifiables par les seules données techniques. Elles doivent être couvertes par des processus, procédures ou contrats et déclarées explicitement, afin d’éviter que l’absence de preuves soit interprétée comme une conformité.',
  'Superato': "Réussi",
  'Non valutabile': "Non évaluable",
  'Non applicabile': "Non applicable",
  'conforme': "conforme",
  'Sistema operativo supportato': "Système d’exploitation pris en charge",
  'Vulnerabilità critiche gestite': "Vulnérabilités critiques gérées",
  'Aggiornamenti applicati': "Mises à jour appliquées",
  'Software nel ciclo di vita': "Logiciel dans son cycle de vie",
  'Cifratura dei servizi esposti': "Chiffrement des services exposés",
  "Protezione dell'endpoint": "Protection de l’endpoint",
  'Inventario aggiornato': "Inventaire à jour",
  'Gestione degli incidenti': "Gestion des incidents",
  'Piani di continuità e gestione delle crisi': "Plans de continuité et gestion des crises",
  'Sicurezza della catena di fornitura': "Sécurité de la chaîne d’approvisionnement",
  'Verifica dell’efficacia delle misure': "Vérification de l’efficacité des mesures",
  'Formazione e consapevolezza': "Formation et sensibilisation",
  'Cifratura dei dati a riposo': "Chiffrement des données au repos",
  'Autenticazione a più fattori': "Authentification à plusieurs facteurs",
  'la direttiva misurata sui dati raccolti, asset per asset. Ogni controllo cita l’articolo, ha quattro esiti — e i «non valutabili» dicono come procurarsi il dato. La pagina dichiara anche gli obblighi che la piattaforma non misura.': "la directive mesurée sur les données collectées, actif par actif. Chaque contrôle cite l’article, a quatre résultats — et les «non évaluables» indiquent comment obtenir la donnée. La page déclare aussi les obligations que la plateforme ne mesure pas.",

  // Amministrazione · Regole di riconoscimento del prodotto
  'Sono le regole del prodotto, valide per tutti i clienti. Una regola guarda gli attributi di un CI (l’ente SNMP, la descrizione) e gli assegna una classe. Valgono dopo le regole scritte dal cliente e prima dell’euristica.':
    "Ce sont les règles du produit, valables pour tous les clients. Une règle examine les attributs d’un CI (l’entreprise SNMP, la description) et lui attribue une classe. Elles s’appliquent après les règles écrites par le client et avant l’heuristique.",
  'Aggiungine una con «Nuova regola».': "Ajoutez-en une avec « Nouvelle règle ».",
  'Modifica regola': "Modifier la règle",
  'disattivata': "désactivée",
  'eliminare?': "supprimer ?",
  'La chiave identifica la regola e non si cambia.':
    "La clé identifie la règle et ne se modifie pas.",
  'Un identificativo stabile, minuscolo, es. «aethra-router».':
    "Un identifiant stable, en minuscules, p. ex. « aethra-router ».",
  'Più bassa vince prima.': "La plus basse l’emporte en premier.",
  'Router Aethra': "Routeur Aethra",
  'Devono essere vere tutte. Il confronto non distingue maiuscole e minuscole.':
    "Elles doivent toutes être vraies. La comparaison ne distingue pas les majuscules des minuscules.",
  'La chiave di una classe (es. «router», «switch», «console_server»). La categoria si deduce dalla classe se la lasci vuota.':
    "La clé d’une classe (p. ex. « router », « switch », « console_server »). La catégorie est déduite de la classe si vous la laissez vide.",
  '(dedotta dalla classe)': "(déduite de la classe)",
  'Serve almeno una condizione: una regola senza condizioni corrisponderebbe a ogni CI.':
    "Au moins une condition est requise : une règle sans condition correspondrait à chaque CI.",
  // --- Guida ---
  'Cosa fare, in ordine':
    "Que faire, dans l’ordre",
  'La scheda di ogni sonda dice versione, capability e salute: dopo un aggiornamento della piattaforma controlla che le sonde siano alla stessa versione — molte funzioni nuove vivono nel binario della sonda, e una sonda vecchia semplicemente non le esegue.':
    "La fiche de chaque sonde indique sa version, ses capacités et son état : après une mise à jour de la plateforme, vérifiez que les sondes sont à la même version — beaucoup de nouvelles fonctions vivent dans le binaire de la sonde, et une sonde ancienne ne les exécute tout simplement pas.",
  'il catalogo delle sorgenti dati per categoria — rete, virtualizzazione, storage, sicurezza, backup, DNS. Dice cosa è collegato, cosa manca e con quale credenziale.':
    "le catalogue des sources de données par catégorie — réseau, virtualisation, stockage, sécurité, sauvegarde, DNS. Il indique ce qui est connecté, ce qui manque et avec quel identifiant.",
  'Leggere il rapporto di un job':
    "Lire le rapport d’un job",
  'Una riga «sezione non raccolta» non è un fallimento della scansione: dice che una parte (un permesso mancante, una tabella che quella versione non ha) non è arrivata, e che il resto è arrivato lo stesso.':
    "Une ligne « section non collectée » n’est pas un échec du scan : elle indique qu’une partie (une permission manquante, une table absente de cette version) n’est pas arrivée, et que le reste est arrivé quand même.",
  '«Ritenta» nell’elenco dei job rilancia la stessa configurazione in un job nuovo: il vecchio resta come verbale di ciò che è successo.':
    "« Réessayer » dans la liste des jobs relance la même configuration dans un nouveau job : l’ancien reste comme procès-verbal de ce qui s’est passé.",
  'Dopo un aggiornamento della piattaforma':
    "Après une mise à jour de la plateforme",
  'Durante l’aggiornamento la console mostra la pagina «Platform upgrade in progress», che si ricarica da sola: quando la piattaforma torna, si rientra senza fare niente.':
    "Pendant la mise à jour, la console affiche la page « Platform upgrade in progress », qui se recharge d’elle-même : quand la plateforme revient, on se retrouve connecté sans rien faire.",
  'Le novità che dipendono dalla raccolta (nuovi comandi, nuovi campi) compaiono al primo giro di scansione successivo, e solo con le sonde aggiornate: una scheda che non mostra ancora un dato nuovo di solito aspetta la scansione, non è rotta.':
    "Les nouveautés qui dépendent de la collecte (nouvelles commandes, nouveaux champs) apparaissent au scan suivant, et seulement avec des sondes à jour : une fiche qui n’affiche pas encore une nouvelle donnée attend généralement le scan, elle n’est pas cassée.",
  'La lente in alto (o ⌘K / Ctrl+K) cerca ovunque e porta dove sta la risposta: i risultati sono raggruppati per tipo, e ogni riga apre il posto giusto.':
    "La loupe en haut (ou ⌘K / Ctrl+K) cherche partout et mène là où se trouve la réponse : les résultats sont groupés par type, et chaque ligne ouvre le bon endroit.",
  'Cosa trovi':
    "Ce que vous trouvez",
  'Configuration Item: per nome, identificativo, produttore e per tutte le chiavi con cui il CI è stato riconosciuto — indirizzi, MAC, seriali, nomi — non solo quella principale.':
    "Éléments de configuration : par nom, identifiant, fabricant et par toutes les clés avec lesquelles le CI a été reconnu — adresses, MAC, numéros de série, noms — pas seulement la principale.",
  'Rete: indirizzi IP, MAC, nomi e descrizioni delle porte degli apparati.':
    "Réseau : adresses IP, MAC, noms et descriptions des ports des équipements.",
  'Wireless: un client Wi-Fi per MAC, indirizzo o login, e un SSID o un BSSID. La riga apre la sezione Wireless del controller che lo serve.':
    "Sans fil : un client Wi-Fi par MAC, adresse ou login, et un SSID ou un BSSID. La ligne ouvre la section Sans fil du contrôleur qui le dessert.",
  'Utenti: una persona, per login — vista sul Wi-Fi, in VPN o collegata a un PC. La riga apre la sua pagina di presenza.':
    "Utilisateurs : une personne, par login — vue sur le Wi-Fi, en VPN ou connectée à un PC. La ligne ouvre sa page de présence.",
  'Software, componenti (seriali di schede e SFP), asset, business service e contratti.':
    "Logiciels, composants (numéros de série des cartes et des SFP), actifs, business services et contrats.",
  'Da sapere':
    "À savoir",
  'Un MAC si incolla come lo si ha davanti: DC-EF-80-03-2B-40 (Windows), dcef.8003.2b40 (Cisco), dcef-8003-2b40 (Huawei) e dc:ef:80:03:2b:40 trovano la stessa cosa.':
    "Collez un MAC tel que vous l’avez : DC-EF-80-03-2B-40 (Windows), dcef.8003.2b40 (Cisco), dcef-8003-2b40 (Huawei) et dc:ef:80:03:2b:40 trouvent la même chose.",
  'Servono almeno due caratteri, e ogni gruppo mostra i primi risultati: il segno che ce ne sono altri rimanda alla pagina dedicata, che ha i filtri.':
    "Il faut au moins deux caractères, et chaque groupe montre les premiers résultats : le signe qu’il y en a d’autres renvoie à la page dédiée, qui a les filtres.",
  'Chi è collegato solo in VPN si trova con qualche minuto di ritardo: le sessioni si leggono dai firewall ogni cinque minuti.':
    "Une personne connectée uniquement en VPN est trouvée avec quelques minutes de retard : les sessions sont lues sur les pare-feux toutes les cinq minutes.",
  'Anche l’elenco dei Configuration Item ha la sua casella di ricerca, con le stesse regole per MAC e chiavi, più i filtri per colonna.':
    "La liste des éléments de configuration a aussi sa propre recherche, avec les mêmes règles pour les MAC et les clés, plus les filtres par colonne.",
  'La pagina di presenza risponde a «dov’è collegata questa persona, adesso?». Ci si arriva dalla ricerca: si digita la login e si apre il risultato nel gruppo Utenti.':
    "La page de présence répond à « où cette personne est-elle connectée, maintenant ? ». On y arrive par la recherche : tapez le login et ouvrez le résultat dans le groupe Utilisateurs.",
  'Wi-Fi: i dispositivi associati con quella login (reti 802.1X), con access point, SSID, banda, segnale e controller. Il MAC porta al CI del dispositivo quando è in inventario.':
    "Wi-Fi : les appareils associés à ce login (réseaux 802.1X), avec point d’accès, SSID, bande, signal et contrôleur. Le MAC mène au CI de l’appareil quand il est inventorié.",
  'PC: le macchine su cui la persona risulta collegata all’ultimo inventario.':
    "PC : les machines sur lesquelles la personne était connectée au dernier inventaire.",
  'La stessa persona si riconosce anche se ogni sorgente la scrive a modo suo: il nome con il dominio davanti, con il dominio dopo la chiocciola o senza dominio è la stessa login.':
    "La même personne est reconnue même si chaque source l’écrit à sa façon : le nom avec le domaine devant, avec le domaine après l’arobase ou sans domaine est le même login.",
  'Se i firewall non rispondono, la VPN si mostra dall’ultima sincronizzazione (al più cinque minuti fa), e la pagina lo dice.':
    "Si les pare-feux ne répondent pas, le VPN est affiché depuis la dernière synchronisation (il y a cinq minutes au plus), et la page le dit.",
  'Sulle reti a chiave condivisa una login non esiste: quei dispositivi si vedono nella sezione Wireless del controller, non qui.':
    "Sur les réseaux à clé partagée, il n’y a pas de login : ces appareils sont visibles dans la section Sans fil du contrôleur, pas ici.",
  'In cima all’elenco il cruscotto: CI totali e nuovi, non classificati, con rischi di sicurezza, non visti da una settimana, e le ruote per categoria e per origine. I riquadri numerici filtrano l’elenco con un clic.':
    "En haut de la liste, le tableau de bord : CI totaux et nouveaux, non classés, avec constats de sécurité, non vus depuis une semaine, et les anneaux par catégorie et par origine. Les tuiles chiffrées filtrent la liste d’un clic.",
  'I filtri per colonna si sommano: «nome contiene srv» e «produttore è Dell» restringono insieme, come in un foglio di calcolo.':
    "Les filtres par colonne se cumulent : « le nom contient srv » et « le fabricant est Dell » restreignent ensemble, comme dans un tableur.",
  'cosa compare e cosa non si trova più, giorno per giorno: la risposta a «è cambiato qualcosa nel parco?».':
    "ce qui apparaît et ce qu’on ne trouve plus, jour après jour : la réponse à « quelque chose a-t-il changé dans le parc ? ».",
  'La scheda di un CI':
    "La fiche d’un CI",
  'Le sezioni in alto portano a ciò che quel CI ha: anagrafica, attributi, classificazione, sicurezza, backup, rete, collegamenti, ciclo di vita e tracciabilità — e, a seconda di cosa è, routing, wireless, storage, firewall o Wazuh.':
    "Les sections en haut mènent à ce que ce CI possède : fiche, attributs, classification, sécurité, sauvegarde, réseau, liens, cycle de vie et traçabilité — et, selon sa nature, routage, sans fil, stockage, pare-feu ou Wazuh.",
  'Collegamenti: le relazioni con gli altri oggetti — a quale switch è attaccato, in quale cluster sta, su quale storage tiene i dati, chi lo usa.':
    "Liens : les relations avec les autres objets — à quel commutateur il est branché, dans quel cluster il se trouve, sur quel stockage sont ses données, qui l’utilise.",
  'Tracciabilità: per ogni attributo, chi l’ha scritto e quando, col valore di prima e quello di dopo. È la risposta a «questo valore da dove viene?».':
    "Traçabilité : pour chaque attribut, qui l’a écrit et quand, avec l’ancienne et la nouvelle valeur. C’est la réponse à « d’où vient cette valeur ? ».",
  'Duplicati e identità':
    "Doublons et identité",
  'Lo stesso oggetto visto da due strade (una scansione SNMP e un connettore, per esempio) si riconosce dalle chiavi che hanno in comune — seriale, MAC, indirizzo — e diventa un CI solo. Quando due CI si scoprono lo stesso, si fondono alla scansione successiva e il rapporto lo scrive.':
    "Le même objet vu par deux chemins (un scan SNMP et un connecteur, par exemple) est reconnu par les clés qu’ils partagent — numéro de série, MAC, adresse — et devient un seul CI. Quand deux CI s’avèrent identiques, ils fusionnent au scan suivant et le rapport l’indique.",
  'Se vedi due CI che dovrebbero essere uno, confronta la chiave sotto il nome: se non hanno niente in comune, nessuna scansione può sapere che sono lo stesso oggetto. Segnalalo — di solito basta insegnare alla piattaforma una chiave in più.':
    "Si vous voyez deux CI qui devraient n’en faire qu’un, comparez la clé sous le nom : s’ils n’ont rien en commun, aucun scan ne peut savoir qu’il s’agit du même objet. Signalez-le — il suffit généralement d’apprendre une clé de plus à la plateforme.",
  'Beni, contratti e report':
    "Actifs, contrats et rapports",
  'Gli apparati di rete si raccontano in tre modi: l’SNMP dice porte, vicini e rotte; l’inventario avanzato via SSH dice schede, ottiche e seriali; il traffico dice chi parla con chi.':
    "Les équipements réseau se décrivent de trois façons : le SNMP donne ports, voisins et routes ; l’inventaire avancé via SSH donne cartes, optiques et numéros de série ; le trafic dit qui parle à qui.",
  'tre viste: Apparati (colonne filtrabili — produttore, modello, indirizzo, stato delle porte), Componenti (schede, SFP, alimentatori e ventole di tutti gli apparati, cercabili per seriale) e IP (gli indirizzi aggiuntivi e pubblici).':
    "trois vues : Équipements (colonnes filtrables — fabricant, modèle, adresse, état des ports), Composants (cartes, SFP, alimentations et ventilateurs de tous les équipements, cherchables par numéro de série) et IP (les adresses supplémentaires et publiques).",
  'Per ottiche, schede e seriali lancia l’«Inventario avanzato apparati» con una credenziale SSH. Su Cisco IOS le ottiche arrivano da «show inventory», sui Nexus da «show interface transceiver», su Huawei da «display transceiver» e dall’etichetta elettronica.':
    "Pour les optiques, les cartes et les numéros de série, lancez l’« Inventaire avancé des équipements » avec un identifiant SSH. Sur Cisco IOS, les optiques viennent de « show inventory », sur les Nexus de « show interface transceiver », sur Huawei de « display transceiver » et de l’étiquette électronique.",
  'La stessa scansione, quando incontra un controller wireless, legge anche access point, SSID e client: non serve un job a parte.':
    "Le même scan, quand il rencontre un contrôleur sans fil, lit aussi les points d’accès, les SSID et les clients : pas besoin d’un job séparé.",
  'La sezione Wireless compare sulla scheda dei controller wireless: raccoglie gli access point che il controller gestisce, le reti che diffonde e i dispositivi collegati.':
    "La section Sans fil apparaît sur la fiche des contrôleurs sans fil : elle réunit les points d’accès gérés par le contrôleur, les réseaux qu’il diffuse et les appareils connectés.",
  'Verifica che il controller sia classificato «Controller wireless»: se risulta uno switch, correggi la classe dalla scheda.':
    "Vérifiez que le contrôleur est classé « Contrôleur sans fil » : s’il apparaît comme un commutateur, corrigez la classe depuis sa fiche.",
  'Dagli una credenziale SSH e includilo nell’Inventario avanzato apparati: al primo giro la sezione si popola, ai giri successivi si aggiorna.':
    "Donnez-lui un identifiant SSH et incluez-le dans l’Inventaire avancé des équipements : la section se remplit au premier passage et se met à jour aux suivants.",
  'Grafici: client per banda (2.4/5/6 GHz), qualità del segnale (dal RSSI: ottimo, buono, debole, critico), client per SSID e per access point.':
    "Graphiques : clients par bande (2,4/5/6 GHz), qualité du signal (d’après le RSSI : excellent, bon, faible, critique), clients par SSID et par point d’accès.",
  'Access point: ogni AP è un CI a sé, collegato al controller, con modello, indirizzo, MAC, gruppo, stato e da quanto è acceso. Il nome apre la sua scheda.':
    "Points d’accès : chaque AP est un CI à part entière, lié au contrôleur, avec modèle, adresse, MAC, groupe, état et durée de fonctionnement. Le nom ouvre sa fiche.",
  'Reti diffuse: ogni SSID su ogni radio, con BSSID, autenticazione e quanti client ha.':
    "Réseaux diffusés : chaque SSID sur chaque radio, avec BSSID, authentification et nombre de clients.",
  'Client connessi: MAC, dispositivo (il costruttore ricavato dal MAC), utente (la login sulle reti 802.1X), indirizzo, SSID, AP, banda, protocollo, velocità, RSSI e VLAN.':
    "Clients connectés : MAC, appareil (le fabricant déduit du MAC), utilisateur (le login sur les réseaux 802.1X), adresse, SSID, AP, bande, protocole, débit, RSSI et VLAN.",
  '«MAC casuale» nella colonna Dispositivo è la privacy dei telefoni: il MAC l’ha inventato il dispositivo, e un costruttore non esiste.':
    "« MAC aléatoire » dans la colonne Appareil, c’est la confidentialité des téléphones : l’appareil a inventé le MAC, et il n’y a pas de fabricant.",
  'Il MAC di un client diventa un link quando lo stesso dispositivo è già in inventario (un portatile, un telefono visto da una scansione).':
    "Le MAC d’un client devient un lien quand le même appareil est déjà inventorié (un portable, un téléphone vu par un scan).",
  'Client e SSID sono la fotografia dell’ultima lettura: un telefono che cambia stanza cambia AP. Una lettura fallita non cancella la fotografia precedente.':
    "Clients et SSID sont l’instantané de la dernière lecture : un téléphone qui change de pièce change d’AP. Une lecture échouée n’efface pas l’instantané précédent.",
  'Oggi il driver legge i controller Huawei AirEngine; gli altri costruttori si aggiungono nel tempo.':
    "Aujourd’hui, le pilote lit les contrôleurs Huawei AirEngine ; les autres fabricants s’ajouteront au fil du temps.",
  'Crea la credenziale della piattaforma e lancia il job del connettore: gli oggetti compaiono in Configuration Item già legati fra loro — VM sull’host, host nel cluster, dischi sul datastore.':
    "Créez l’identifiant de la plateforme et lancez le job du connecteur : les objets apparaissent dans les éléments de configuration déjà liés entre eux — VM sur l’hôte, hôte dans le cluster, disques sur le datastore.",
  'Pianificalo: le macchine virtuali nascono e muoiono più in fretta di tutto il resto, e un inventario virtuale vecchio di un mese racconta un altro ambiente.':
    "Planifiez-le : les machines virtuelles naissent et disparaissent plus vite que tout le reste, et un inventaire virtuel vieux d’un mois décrit un autre environnement.",
  'Mappa virtuale':
    "Carte virtuelle",
  'cluster, host e macchine virtuali in un colpo d’occhio, per ambiente.':
    "clusters, hôtes et machines virtuelles d’un coup d’œil, par environnement.",
  'l’inventario dell’ambiente a fogli, come RVTools — VM, host, cluster, datastore, reti — a video, in Excel o in PDF.':
    "l’inventaire de l’environnement en feuilles, comme RVTools — VM, hôtes, clusters, datastores, réseaux — à l’écran, en Excel ou en PDF.",
  'Un host si lega al suo cluster da solo quando il cluster esiste come CI. Se un cluster non compare, il rapporto del job del connettore dice perché.':
    "Un hôte se lie à son cluster tout seul dès que le cluster existe comme CI. Si un cluster n’apparaît pas, le rapport du job du connecteur dit pourquoi.",
  'Un array di storage si inventaria da due strade che diventano un CI solo: l’SNMP dà anagrafica e mappature, il connettore REST del costruttore (Huawei OceanStor) dà pool, LUN, dischi, host e porte.':
    "Une baie de stockage est inventoriée par deux chemins qui deviennent un seul CI : le SNMP donne la fiche et les mappages, le connecteur REST du constructeur (Huawei OceanStor) donne pools, LUN, disques, hôtes et ports.",
  'Crea una credenziale DeviceManager e lancia l’inventario «Huawei OceanStor» sull’array; pianificalo, perché ogni giro riporta capacità e mappature aggiornate e alimenta il capacity plan.':
    "Créez un identifiant DeviceManager et lancez l’inventaire « Huawei OceanStor » sur la baie ; planifiez-le, car chaque passage rapporte la capacité et les mappages à jour et alimente le capacity plan.",
  'Cosa trovi nella sezione Storage':
    "Ce que vous trouvez dans la section Stockage",
  'In cima: mappature, dischi, pool, LUN e host registrati, con la capacità totale e quanta è usata.':
    "En haut : mappages, disques, pools, LUN et hôtes enregistrés, avec la capacité totale et la part utilisée.",
  'Pool di storage: capacità, usata e percentuale d’uso — il buffer reale dell’array.':
    "Pools de stockage : capacité, utilisée et pourcentage d’utilisation — la marge réelle de la baie.",
  'Host registrati e initiator: chi monta le LUN, con il sistema operativo e gli IQN o i WWPN.':
    "Hôtes enregistrés et initiateurs : qui monte les LUN, avec le système d’exploitation et les IQN ou WWPN.",
  'Dischi: modello, seriale e capacità di ogni disco fisico. Le porte dell’array stanno fra le interfacce di rete del CI.':
    "Disques : modèle, numéro de série et capacité de chaque disque physique. Les ports de la baie figurent parmi les interfaces réseau du CI.",
  'Le correlazioni':
    "Les corrélations",
  'Con gli switch: i MAC delle porte dell’array risolvono le tabelle MAC degli switch, e nei Collegamenti si vede a quale switch e porta è attaccato. Serve una scansione SNMP degli switch dopo quella dell’array.':
    "Avec les commutateurs : les MAC des ports de la baie résolvent les tables MAC des commutateurs, et les Liens montrent à quel commutateur et quel port elle est branchée. Il faut un scan SNMP des commutateurs après celui de la baie.",
  'Il capacity plan dice quanto spazio c’è ancora, quanto cresce e quando finisce — su datastore e array insieme, dai dati in inventario.':
    "Le capacity plan indique l’espace restant, sa croissance et quand il sera épuisé — pour les datastores et les baies ensemble, à partir des données d’inventaire.",
  'in cima i totali — capacità, usato, libero, crescita al giorno e fra quanto è pieno — e sotto l’andamento con la proiezione.':
    "en haut les totaux — capacité, utilisé, libre, croissance quotidienne et délai avant saturation — et en dessous la tendance avec la projection.",
  'La tabella: per ogni datastore e array (con l’etichetta «array») l’ambiente, gli host serviti, la capacità, lo spazio libero, l’utilizzo, la crescita al giorno e i giorni al pieno.':
    "Le tableau : pour chaque datastore et baie (étiquetée « baie ») l’environnement, les hôtes desservis, la capacité, l’espace libre, l’utilisation, la croissance quotidienne et les jours avant saturation.",
  '«Host serviti» sugli array è il numero che trasforma «si riempie» in «chi si ferma»: quanti host hanno i dati lì.':
    "« Hôtes desservis » sur les baies est le chiffre qui transforme « elle se remplit » en « qui s’arrête » : combien d’hôtes y ont leurs données.",
  'Compute e porte: l’occupazione degli host di virtualizzazione e delle porte degli apparati.':
    "Calcul et ports : la charge des hôtes de virtualisation et l’occupation des ports des équipements.",
  'Crescita e giorni al pieno si calcolano sulla storia: servono almeno sette giorni di campioni, e fino ad allora la colonna mostra un trattino.':
    "La croissance et les jours avant saturation se calculent sur l’historique : il faut au moins sept jours d’échantillons, et d’ici là la colonne affiche un tiret.",
  'Il campione si prende una volta al giorno. Una crescita negativa è spazio liberato, non un errore.':
    "Un échantillon est pris une fois par jour. Une croissance négative, c’est de l’espace libéré, pas une erreur.",
  'Configura router e firewall perché mandino NetFlow/IPFIX alla sonda: la pagina Esportatori conferma che arrivano. Se i numeri non tornano, la diagnosi dei flussi dalla scheda della sonda dice se e da chi arrivano i pacchetti.':
    "Configurez routeurs et pare-feux pour qu’ils envoient du NetFlow/IPFIX à la sonde : la page Exportateurs confirme qu’ils arrivent. Si les chiffres semblent faux, le diagnostic des flux sur la fiche de la sonde indique si et de qui arrivent les paquets.",
  'Sorgenti in tempo reale':
    "Sources en temps réel",
  'Alcuni sistemi del cliente non si inventariano: si interrogano quando serve, attraverso la sonda che li raggiunge. Queste pagine leggono adesso, non da una copia.':
    "Certains systèmes du client ne sont pas inventoriés : on les interroge au besoin, via la sonde qui les atteint. Ces pages lisent maintenant, pas depuis une copie.",
  'agenti, allarmi e vulnerabilità del parco; sulla scheda di un CI, lo stato del suo agente.':
    "agents, alertes et vulnérabilités du parc ; sur la fiche d’un CI, l’état de son agent.",
  'DNS':
    "DNS",
  'job, repository e oggetti protetti del backup (Veeam, Vinchin, Commvault, Rubrik); sulla scheda di una VM o di un server, la sua protezione.':
    'tâches, dépôts et objets protégés de la sauvegarde (Veeam, Vinchin, Commvault, Rubrik) ; sur la fiche d’une VM ou d’un serveur, sa protection.',
  'Crea la connessione nel modulo del sistema (sezione «Connessioni» di Backup, IPAM, Wazuh o Firewall; per il DNS in Sorgenti dati) scegliendo la sonda che lo raggiunge, e assicurati che quella sonda sia aggiornata: è lei che parla col sistema.':
    'Créez la connexion dans le module du système (section «Connexions» de Backup, IPAM, Wazuh ou Pare-feu ; pour le DNS dans les Sources de données) en choisissant la sonde qui l’atteint, et assurez-vous que cette sonde est à jour : c’est elle qui parle au système.',
  '«Non interrogabile» vuol dire che la sonda non ha raggiunto il sistema: il messaggio dice perché — credenziale, rete o certificato.':
    "« Non interrogeable » signifie que la sonde n’a pas atteint le système : le message dit pourquoi — identifiant, réseau ou certificat.",
  'Nei Collegamenti di un datastore: gli host che lo montano («collegato a»), le VM che ci tengono i dischi («archiviato su») e l’array che lo serve.':
    "Dans les Liens d’un datastore : les hôtes qui le montent (« connecté à »), les VM qui y gardent leurs disques (« stocké sur ») et la baie qui le sert.",
  'Layer storage':
    "Couche stockage",
  'Layer network':
    "Couche réseau",
  'Layer fisico':
    "Couche physique",
  'Altre relazioni':
    "Autres relations",
  'Sulla mappa ogni relazione ha il colore e il tratto del suo layer: blu pieno la rete, verde a puntini il fisico (VM sull’host, host nel cluster), arancio tratteggiato lo storage (archiviato su, host che monta un datastore). Più relazioni fra gli stessi due oggetti si aprono a ventaglio e restano distinguibili.':
    "Sur la carte, chaque relation a la couleur et le trait de sa couche : bleu plein pour le réseau, vert pointillé pour le physique (VM sur l’hôte, hôte dans le cluster), orange tireté pour le stockage (stocké sur, hôte qui monte un datastore). Plusieurs relations entre les deux mêmes objets s’ouvrent en éventail et restent distinguables.",
  '1 salto':
    '1 saut',
  '{n} salti':
    '{n} sauts',
  'Adatta alla finestra (0)':
    'Ajuster à la fenêtre (0)',
  'Anelli attorno al centro: la distanza in salti':
    'Anneaux autour du centre : la distance en sauts',
  'Ciò che è collegato si avvicina, restando nella sua fascia':
    'Ce qui est relié se rapproche, en restant dans sa bande',
  'Comunicazione (spessore = volume)':
    'Communication (épaisseur = volume)',
  'Disposizione':
    'Disposition',
  'Fasce per livello, dall’alto in basso: il criterio della pagina':
    'Bandes par niveau, de haut en bas : le critère de la page',
  'Gerarchica':
    'Hiérarchique',
  'Radiale':
    'Radiale',
  'Organica':
    'Organique',
  'Host e dispositivi':
    'Hôtes et équipements',
  'Macchine virtuali':
    'Machines virtuelles',
  'Perimetro':
    'Périmètre',
  'Switching':
    'Commutation',
  'Ingrandisci (+)':
    'Agrandir (+)',
  'Riduci (−)':
    'Réduire (−)',
  'Schermo intero':
    'Plein écran',
  'Livello {n}':
    'Niveau {n}',
  'Nella CMDB':
    'Dans la CMDB',
  'Non censito':
    'Non inventorié',
  'Seme':
    'Graine',
  'Rotella o pizzico per ingrandire, trascinamento della tela per spostare, trascinamento di un nodo per fissarlo (contorno tratteggiato). Passando su un nodo si accendono i suoi collegamenti; un clic lo mette a fuoco. Tasti: + − e 0 per adattare.':
    'Molette ou pincement pour zoomer, glisser le fond pour se déplacer, glisser un nœud pour le fixer (contour en pointillés). Survoler un nœud allume ses liens ; un clic le met au premier plan. Touches : + − et 0 pour ajuster.',
  'La mappa di correlazione e quella del servizio sono la stessa della topologia, con le stesse tre viste e gli stessi comandi: qui il livello è la distanza dal seme (Seme, Livello 1, Livello 2…) e lo spessore della linea è il volume scambiato.':
    'La carte de corrélation et celle du service sont les mêmes que celle de la topologie, avec les mêmes trois vues et les mêmes commandes : ici le niveau est la distance à la graine (Graine, Niveau 1, Niveau 2…) et l\'épaisseur du trait est le volume échangé.',
  'passando sopra un nodo si accendono le sue linee e i suoi vicini, il resto si spegne: è il modo più veloce per leggere un nodo affollato senza cliccarlo. I nomi lunghi si accorciano per non sovrapporsi e si allungano ingrandendo;':
    'survoler un nœud allume ses liens et ses voisins et estompe le reste : le moyen le plus rapide de lire un nœud chargé sans cliquer. Les noms longs se raccourcissent pour ne jamais se chevaucher et s\'allongent quand on agrandit ;',
  'rotella o pizzico ingrandiscono verso il puntatore senza far scorrere la pagina; trascinando lo sfondo ti sposti. In alto a destra: + e − per lo zoom, «Adatta» per rivedere tutto, «Schermo intero» per le reti grandi. Con la tastiera: + − e 0. La minimappa in basso a destra dice dove sei quando hai ingrandito;':
    'la molette ou le pincement zooment vers le pointeur sans faire défiler la page ; glisser le fond déplace la vue. En haut à droite : + et − pour le zoom, « Ajuster » pour tout revoir, « Plein écran » pour les grands réseaux. Au clavier : + − et 0. La mini-carte en bas à droite indique où vous êtes une fois agrandi ;',
  'tre viste, in alto a sinistra, e la scelta si ricorda: Gerarchica (fasce per ruolo, dal perimetro in alto allo storage in basso, con il nome della fascia a sinistra), Radiale (anelli per ruolo; con un nodo scelto, anelli per distanza in salti da lui, al centro — ogni cluster ha il suo spicchio) e Organica (ciò che è collegato si avvicina, restando vicino alla sua fascia). Cambiando vista i nodi scivolano al posto nuovo: segui con l’occhio dove va ciascuno;':
    'trois vues, en haut à gauche, et le choix est mémorisé : Hiérarchique (bandes par rôle, du périmètre en haut au stockage en bas, avec le nom de la bande à gauche), Radiale (anneaux par rôle ; avec un nœud choisi, anneaux par distance en sauts depuis lui, au centre — chaque cluster a sa part) et Organique (ce qui est relié se rapproche en restant près de sa bande). En changeant de vue les nœuds glissent vers leur nouvelle place : suivez chacun des yeux ;',
  'Sulla scheda di un datastore: capacità, spazio libero e i WWN dei dischi sotto — dai pool SharedBlock di NexaVM/ZStack e dagli extent dei VMFS di VMware (il disco naa.) — che lo legano alla LUN dell’array che lo serve. Su VMware servono utente e password nella credenziale: gli extent si leggono solo dalla SOAP di vCenter, non con un token.':
    'Sur la fiche d\'un datastore : capacité, espace libre et les WWN des disques sous-jacents — des pools SharedBlock de NexaVM/ZStack et des extents VMFS de VMware (le disque naa.) — qui le relient à la LUN de la baie qui le sert. Sur VMware, l\'identifiant doit contenir un utilisateur et un mot de passe : les extents ne se lisent que par l\'API SOAP de vCenter, pas avec un jeton.',
  'Con i datastore: un datastore si lega all’array per WWN quando la piattaforma di virtualizzazione dichiara i dischi che ha sotto (NexaVM/ZStack e VMware); altrimenti per nome, quando si chiama come la LUN.':
    'Avec les datastores : un datastore est relié à la baie par WWN quand la plateforme de virtualisation déclare les disques sous-jacents (NexaVM/ZStack et VMware) ; sinon par nom, quand il porte le nom de la LUN.',
  'Aggiungi il salto':
    'Ajouter le saut',
  'Apri il servizio →':
    'Ouvrir le service →',
  'Archiviato su':
    'Stocké sur',
  'Chiama':
    'Appelle',
  'Chiama altri {n} oggetti oltre quelli mostrati (i più voluminosi sono in mappa).':
    'Il appelle {n} autres objets au-delà de ceux affichés (les plus volumineux sont sur la carte).',
  'Chiamata (spessore = volume)':
    'Appel (épaisseur = volume)',
  'Chiamate per nodo':
    'Appels par nœud',
  'Chiamate · livello {n}':
    'Appels · niveau {n}',
  'Chiamato da':
    'Appelé par',
  'Collegato a (rete)':
    'Relié à (réseau)',
  'Componente':
    'Composant',
  'Componi':
    'Composer',
  'Composizione del servizio':
    'Composition du service',
  'Composizione del servizio dietro {seed}':
    'Composition du service derrière {seed}',
  'Crea un business service da questa composizione':
    'Créer un business service à partir de cette composition',
  'Creato dalla composizione di {seed}':
    'Créé à partir de la composition de {seed}',
  'Da quale ingresso':
    'Depuis quelle entrée',
  'partendo da un punto di ingresso, mostra la sequenza delle chiamate tra i componenti e, per ciascuno, dove viene eseguito.': 'à partir d’un point d’entrée, montre la séquence des appels entre les composants et, pour chacun, où il s’exécute.',
  'Dall’ingresso non esce nessuna chiamata nel traffico osservato. Se è il VIP di un bilanciatore che verso i server esce da indirizzi non inventariati (o non esporta flussi), dichiara il salto a mano qui sotto: da lì la catena riprende da sola.':
    'Aucun appel ne sort de l\'entrée dans le trafic observé. S\'il s\'agit du VIP d\'un équilibreur qui joint les serveurs depuis des adresses non inventoriées (ou n\'exporte pas de flux), déclarez le saut à la main ci-dessous : à partir de là la chaîne reprend toute seule.',
  'Esplora il vicinato':
    'Explorer le voisinage',
  'Gira su / membro di':
    'S\'exécute sur / membre de',
  'Il VIP del bilanciatore, il front-end, l’indirizzo pubblicato: da qui si seguono le chiamate verso ciò che il servizio usa.':
    'Le VIP de l\'équilibreur, le front-end, l\'adresse publiée : à partir d\'ici on suit les appels vers ce que le service utilise.',
  'Il salto che il traffico non vede — il VIP verso i server del pool, un’applicazione verso un sistema che non esporta flussi — si dichiara qui. La catena lo segue come un salto osservato e da lì riprende a seguire il traffico.':
    'Le saut que le trafic ne montre pas — le VIP vers les serveurs du pool, une application vers un système qui n\'exporte pas de flux — se déclare ici. La chaîne le suit comme un saut observé et reprend ensuite le trafic.',
  'Indirizzo dell’ingresso':
    'Adresse de l\'entrée',
  'Indirizzo non inventariato in CMDB.':
    'Adresse non inventoriée dans la CMDB.',
  'Infrastruttura (host, cluster, datastore, rete)':
    'Infrastructure (hôtes, clusters, datastores, réseau)',
  'Ingresso':
    'Entrée',
  'La catena del servizio':
    'La chaîne du service',
  'Le più voluminose. Massimo 40.':
    'Les plus volumineux. Maximum 40.',
  'Lo usano anche {n} oggetti fuori da questo servizio: se lo tocchi, se ne accorgono anche loro.':
    '{n} objets en dehors de ce service l\'utilisent aussi : si vous y touchez, ils s\'en apercevront aussi.',
  'L’indirizzo di partenza non compare né in CMDB né nel traffico della finestra scelta.':
    'L\'adresse de départ n\'apparaît ni dans la CMDB ni dans le trafic de la fenêtre choisie.',
  'Nascosti perché parlano con tutti:':
    'Masqués car ils parlent avec tout le monde :',
  'Nessun ingresso riconosciuto':
    'Aucune entrée reconnue',
  'Salti a mano':
    'Sauts manuels',
  'Salti di chiamata dall’ingresso.':
    'Sauts d\'appel depuis l\'entrée.',
  'Salto a mano':
    'Saut manuel',
  'Scegli un oggetto dall’elenco o scrivi un indirizzo IP.':
    'Choisissez un objet dans la liste ou saisissez une adresse IP.',
  'Servizi comuni (DNS, NTP, AD, monitoraggio, backup)':
    'Services communs (DNS, NTP, AD, supervision, sauvegarde)',
  'Spunta «Servizi comuni» per vederli.':
    'Cochez « Services communs » pour les voir.',
  'Ultima ora':
    'Dernière heure',
  'Verso (oggetto o indirizzo IP)':
    'Vers (objet ou adresse IP)',
  'a mano':
    'manuel',
  'entro {n} salti':
    'en {n} sauts maximum',
  'es. pool web del VIP':
    'ex. pool web du VIP',
  'es. web-01 oppure 10.0.2.11':
    'ex. web-01 ou 10.0.2.11',
  'salto a mano':
    'saut manuel',
  '{n} client':
    '{n} clients',
  '{n} client chiamano l’ingresso; i principali per volume:':
    '{n} clients appellent l\'entrée ; les principaux par volume :',
  '{n} componenti nella catena':
    '{n} composants dans la chaîne',
  'due viste. «Composizione del servizio» (la predefinita, quella che si apre da Entry point): dall’ingresso la catena delle chiamate — il balancer verso i web, i web verso l’app, l’app verso il database, con le porte — e sotto dove sta ogni pezzo: host, cluster, datastore, array, rete. «Esplora il vicinato»: da un indirizzo, chi gli parla e con chi parla; tasto destro per escludere un nodo o una comunicazione, spunte in tabella per escludere in blocco.':
    'deux vues. « Composition du service » (celle par défaut, ouverte depuis les Entry points) : depuis l\'entrée, la chaîne des appels — l\'équilibreur vers les serveurs web, les web vers l\'application, l\'application vers la base de données, avec les ports — et en dessous où se trouve chaque élément : hôtes, clusters, datastores, baies, réseau. « Explorer le voisinage » : depuis une adresse, qui lui parle et avec qui elle parle ; clic droit pour exclure un nœud ou une communication, cases du tableau pour exclure en bloc.',
  'individua il servizio in Entry point, selezionalo e premi «Mostra in mappa»: si apre la composizione del servizio dietro quell’ingresso;':
    'repérez le service dans Entry points, sélectionnez-le et appuyez sur « Afficher sur la carte » : la composition du service derrière cette entrée s\'ouvre ;',
  'controlla la catena nella tabella e, se manca il salto dopo il bilanciatore, aggiungilo a mano;':
    'vérifiez la chaîne dans le tableau et, s\'il manque le saut après l\'équilibreur, ajoutez-le à la main ;',
  'premi «Crea il business service»: l’ingresso, la profondità e i salti a mano passano nel servizio, e la catena si ricalcola dal traffico a ogni apertura.':
    'appuyez sur « Créer le business service » : l\'entrée, la profondeur et les sauts manuels passent dans le service, et la chaîne est recalculée à partir du trafic à chaque ouverture.',
  'l’elenco, la composizione di ciascun servizio ricostruita dal traffico (la stessa vista della mappa di correlazione, con i salti a mano salvati sul servizio), e la modifica in ogni momento.':
    'la liste, la composition de chaque service reconstruite à partir du trafic (la même vue que la carte de corrélation, avec les sauts manuels enregistrés sur le service), et la modification à tout moment.',
  'Come si legge la composizione di un servizio:':
    'Comment lire la composition d\'un service :',
  'i nodi sono oggetti della CMDB, con tutti i loro indirizzi: il VIP e gli indirizzi interni del bilanciatore sono lo stesso nodo, così la catena non si spezza al primo salto. Un indirizzo che la CMDB non conosce resta un nodo a sé, in giallo;':
    'les nœuds sont des objets de la CMDB avec toutes leurs adresses : le VIP et les adresses internes de l\'équilibreur sont le même nœud, la chaîne ne se casse donc pas au premier saut. Une adresse que la CMDB ne connaît pas reste un nœud à part, en jaune ;',
  'si seguono solo le chiamate, non le risposte: il verso di una conversazione è quello verso la porta più bassa, la porta del servizio. I client dell’ingresso stanno in un nodo solo («214 client»), con i principali nel dettaglio;':
    'on suit seulement les appels, pas les réponses : le sens d\'une conversation est celui vers le port le plus bas, le port du service. Les clients de l\'entrée sont regroupés dans un seul nœud (« 214 clients »), avec les principaux dans le détail ;',
  'DNS, NTP, SNMP, syslog, monitoraggio, backup e controller di dominio parlano con tutti: sono nascosti, e sopra la mappa trovi cosa è stato nascosto e quante chiamate. «Servizi comuni» li rimette; «Infrastruttura» accende o spegne le fasce sotto la catena;':
    'DNS, NTP, SNMP, syslog, supervision, sauvegarde et contrôleurs de domaine parlent avec tout le monde : ils sont masqués, et au-dessus de la carte vous trouvez ce qui a été masqué et combien d\'appels. « Services communs » les remet ; « Infrastructure » allume ou éteint les bandes sous la chaîne ;',
  'la tabella «La catena del servizio» dice la stessa cosa a parole, una riga per componente: chi lo chiama e su che porta, cosa chiama, su quale host, cluster, datastore (con l’array sotto) e rete sta. Un clic su un nodo apre il dettaglio, compreso quanti oggetti fuori dal servizio lo usano;':
    'le tableau « La chaîne du service » dit la même chose en mots, une ligne par composant : qui l\'appelle et sur quel port, ce qu\'il appelle, sur quel hôte, cluster, datastore (avec la baie en dessous) et réseau il se trouve. Un clic sur un nœud ouvre le détail, y compris combien d\'objets hors du service l\'utilisent ;',
  'se dall’ingresso non esce niente — un bilanciatore che verso i server esce da indirizzi non inventariati, o che non esporta flussi — aggiungi un «salto a mano»: da un nodo a un oggetto o a un indirizzo, con la porta. È l’arco viola tratteggiato, e da lì la catena riprende a seguire il traffico.':
    'si rien ne sort de l\'entrée — un équilibreur qui joint les serveurs depuis des adresses non inventoriées, ou qui n\'exporte pas de flux — ajoutez un « saut manuel » : d\'un nœud vers un objet ou une adresse, avec le port. C\'est l\'arc violet en pointillés, et à partir de là la chaîne reprend le trafic.',
  'per pulire il risultato: tasto destro su un nodo («Togli dalla composizione») o su una chiamata («Togli questa chiamata», oppure «Togli la porta … ovunque»), Maiusc+clic su un nodo, o «Togli» nella tabella. Togliendo un oggetto sparisce anche ciò che si raggiungeva solo passando da lui. Quello che hai tolto resta elencato sopra la mappa («Tolti da te»): un clic sulla ✕ lo rimette. Nel business service le esclusioni si salvano sul servizio e valgono anche alle aperture successive; dalla mappa di correlazione passano nel servizio quando lo crei.':
    'pour nettoyer le résultat : clic droit sur un nœud (« Retirer de la composition ») ou sur un appel (« Retirer cet appel », ou « Retirer le port … partout »), Maj+clic sur un nœud, ou « Retirer » dans le tableau. En retirant un objet disparaît aussi ce qui n\'était atteint qu\'en passant par lui. Ce que vous avez retiré reste listé au-dessus de la carte (« Retirés par vous ») : un clic sur la ✕ le remet. Dans un business service les exclusions sont enregistrées sur le service et valent aussi aux ouvertures suivantes ; depuis la carte de corrélation elles passent dans le service à sa création.',
  'Per pulire: tasto destro su un nodo o su una chiamata (anche «togli la porta ovunque»), Maiusc+clic su un nodo, o «Togli» nella tabella. Togliendo un oggetto sparisce anche ciò che si raggiungeva solo passando da lui.':
    'Pour nettoyer : clic droit sur un nœud ou sur un appel (y compris « retirer le port partout »), Maj+clic sur un nœud, ou « Retirer » dans le tableau. En retirant un objet disparaît aussi ce qui n\'était atteint qu\'en passant par lui.',
  'Tolti da te:':
    'Retirés par vous :',
  'Rimetti':
    'Remettre',
  'Rimetti tutto':
    'Tout remettre',
  'porta {n}':
    'port {n}',
  'Togli dalla composizione':
    'Retirer de la composition',
  'Togli {nome}':
    'Retirer {nome}',
  'Togli questa chiamata':
    'Retirer cet appel',
  'Togli la porta {porta} ovunque':
    'Retirer le port {porta} partout',
  'togli la chiamata':
    'retirer l’appel',
  'L’ingresso sarà {seed}, con la profondità scelta, i {n} salti a mano e ciò che hai tolto. La catena non si copia: il servizio la ricalcola dal traffico a ogni apertura, con le stesse esclusioni.':
    'L\'entrée sera {seed}, avec la profondeur choisie, les {n} sauts manuels et ce que vous avez retiré. La chaîne n\'est pas copiée : le service la recalcule à partir du trafic à chaque ouverture, avec les mêmes exclusions.',
  "Cattura l'albero MIB del costruttore di un apparato (OID, tipo, valore) per generare un driver di arricchimento. Non modifica l'inventario; la cattura si scarica dal rapporto del job. Indica un solo apparato.":
    'Capture l\'arbre MIB constructeur d\'un équipement (OID, type, valeur) pour générer un pilote d\'enrichissement. Ne modifie pas l\'inventaire ; la capture se télécharge depuis le rapport du job. Indiquez un seul équipement.',
  'Censisce i database (PostgreSQL, MySQL/MariaDB, Microsoft SQL Server, Oracle) come CI: versione, istanza, elenco e dimensione dei database. Un utente di sola lettura per motore; niente dati dentro le tabelle.':
    'Inventorie les bases de données (PostgreSQL, MySQL/MariaDB, Microsoft SQL Server, Oracle) comme CI : version, instance, liste et taille des bases. Un utilisateur en lecture seule par moteur ; aucune donnée des tables.',
  'Il server non ha zone, oppure l’utente non ha i permessi di lettura sul DNS.':
    'Le serveur n\'a pas de zones, ou l\'utilisateur n\'a pas les droits de lecture sur le DNS.',
  'Inventario database':
    'Inventaire des bases de données',
  "Inventario via REST DeviceManager: dischi, pool, LUN e capacità di un array OceanStor/Dorado. L'array si riconosce da uno sweep SNMP; qui si indica il suo indirizzo di gestione e una credenziale DeviceManager.":
    'Inventaire via l\'API REST DeviceManager : disques, pools, LUN et capacité d\'une baie OceanStor/Dorado. La baie est reconnue par un balayage SNMP ; ici on indique son adresse de gestion et un identifiant DeviceManager.',
  'La zona è troppo grande per una lettura sola: gli ultimi record sono stati tagliati. Quelli mostrati sono corretti, ma non sono tutti.':
    'La zone est trop grande pour une seule lecture : les derniers enregistrements ont été coupés. Ceux affichés sont corrects, mais ce ne sont pas tous.',
  "Rivaluta la postura di sicurezza degli asset utilizzando i dati inventariati nell'ultima scansione effettuata.": 'Réévalue la posture de sécurité des actifs à partir des données inventoriées lors de la dernière analyse effectuée.',
  'Server DNS':
    'Serveur DNS',
  'Storage Huawei OceanStor (REST)':
    'Stockage Huawei OceanStor (REST)',
  'Valutazione di sicurezza':
    'Évaluation de sécurité',
  'Zone ({n})':
    'Zones ({n})',
  'statico':
    'statique',
  'le zone e i record dei DNS del cliente: PowerDNS (via la sua REST API) e Microsoft DNS (via WinRM sul domain controller). Con più server configurati si sceglie quale guardare. Di Microsoft DNS vedi anche se la zona è integrata in Active Directory, l’aggiornamento dinamico e, sui record registrati dai client, la data di registrazione: un record vecchio è un client che non si registra più.':
    'les zones et enregistrements des serveurs DNS du client : PowerDNS (via son API REST) et Microsoft DNS (via WinRM sur le contrôleur de domaine). Avec plusieurs serveurs configurés on choisit lequel regarder. Pour Microsoft DNS vous voyez aussi si la zone est intégrée à Active Directory, la mise à jour dynamique et, sur les enregistrements inscrits par les clients, la date d\'inscription : un enregistrement ancien est un client qui ne s\'inscrit plus.',
  'Qui si inseriscono anche le credenziali delle piattaforme (vCenter, NexaVM, OceanStor…). Quelle dei sistemi letti in tempo reale (backup, IPAM, DNS, Wazuh, firewall) stanno nel loro modulo, sezione «Connessioni»; ntopng in Integrazioni → Sorgenti dati.':
    'Les identifiants des plateformes (vCenter, NexaVM, OceanStor…) se saisissent aussi ici. Ceux des systèmes lus en temps réel (sauvegarde, IPAM, DNS, Wazuh, pare-feu) se trouvent dans leur module, section «Connexions» ; ntopng dans Intégrations → Sources de données.',
  'Per Microsoft DNS crea una credenziale «Microsoft DNS (WinRM)» con il nome del server DNS e un utente che possa leggere il DNS (per esempio del gruppo DnsAdmins): non serve un amministratore di dominio. La sonda esegue sul server solo due letture predefinite — l’elenco delle zone e i record di una zona — e nient’altro. Serve la sonda aggiornata.':
    'Pour Microsoft DNS créez un identifiant « Microsoft DNS (WinRM) » avec le nom du serveur DNS et un utilisateur pouvant lire le DNS (par exemple membre de DnsAdmins) : pas besoin d\'un administrateur de domaine. La sonde n\'exécute sur le serveur que deux lectures prédéfinies — la liste des zones et les enregistrements d\'une zone — et rien d\'autre. Une sonde à jour est nécessaire.',
  'Il riquadro PC si popola dall’inventario dei Windows: la scansione (passo WMI o WinRM del piano) e l’agente d’inventario leggono chi siede alla console. È l’utente davanti al PC — le sessioni RDP non contano — e quando nessuno è collegato il PC si svuota, così una persona non resta su una macchina che ha lasciato. Il dato è quello dell’ultimo inventario: per averlo fresco, pianifica la scansione dei PC di frequente.':
    'L\'encadré PC se remplit à partir de l\'inventaire des postes Windows : l\'analyse (étape WMI ou WinRM du plan) et l\'agent d\'inventaire lisent qui est assis à la console. C\'est l\'utilisateur devant le PC — les sessions RDP ne comptent pas — et quand personne n\'est connecté le PC se vide, ainsi une personne ne reste pas sur une machine qu\'elle a quittée. La donnée est celle du dernier inventaire : pour l\'avoir à jour, planifiez souvent l\'analyse des PC.',
  '5986 (HTTPS) se lasci vuoto; 5985 se usi WinRM in chiaro.':
    '5986 (HTTPS) si vous laissez vide ; 5985 si vous utilisez WinRM en clair.',
  'A scadenza breve, ma va rinnovato a mano: poco adatto a discovery pianificate.':
    'Courte durée de validité, mais à renouveler à la main : peu adapté aux découvertes planifiées.',
  'ARN del ruolo':
    'ARN du rôle',
  'AccessKey ID e Secret':
    'AccessKey ID et Secret',
  'Accetta qualunque certificato':
    'Accepter n\'importe quel certificat',
  'Active Directory (LDAP)':
    'Active Directory (LDAP)',
  'Algoritmo di autenticazione':
    'Algorithme d\'authentification',
  'Algoritmo di cifratura':
    'Algorithme de chiffrement',
  "Consente il certificate pinning in alternativa alla CA: viene accettato solo il certificato con l'impronta SHA-256 configurata.": "Active le certificate pinning en alternative à l'AC : seul le certificat avec l'empreinte SHA-256 configurée est accepté.",
  'Assunzione di ruolo (STS)':
    'Assomption de rôle (STS)',
  'Autenticata':
    'Authentifié',
  'Autenticata e cifrata':
    'Authentifié et chiffré',
  'Backup (Veeam, Vinchin, Commvault, Rubrik)':
    'Backup (Veeam, Vinchin, Commvault, Rubrik)',
  'Basic (utente locale)':
    'Basic (utilisateur local)',
  'Bind semplice (UPN o DN)':
    'Bind simple (UPN ou DN)',
  'CA interna che ha firmato il certificato del sistema: mantiene la verifica TLS completa utilizzando la CA specificata come radice di attendibilità.': "AC interne qui a signé le certificat du système : conserve la vérification TLS complète en utilisant l'AC spécifiée comme racine de confiance.",
  'Certificato del service principal':
    'Certificat du service principal',
  'Certificato della CA':
    'Certificat de la CA',
  'Chiave **non cifrata**: una chiave protetta da passphrase non è utilizzabile da un processo non presidiato.':
    'Clé **non chiffrée** : une clé protégée par une passphrase n\'est pas utilisable par un processus sans surveillance.',
  'Chiave API':
    'Clé API',
  'Chiave del service account':
    'Clé du compte de service',
  'Chiave privata':
    'Clé privée',
  'Chiave privata di sessione (PEM)':
    'Clé privée de session (PEM)',
  'Chiavi statiche':
    'Clés statiques',
  'Chiavi temporanee (STS)':
    'Clés temporaires (STS)',
  'Community':
    'Communauté',
  "Consigliato: impedisce che il ruolo venga assunto da chi ne conosce l'ARN per conto di un altro cliente.":
    'Recommandé : empêche que le rôle soit assumé pour le compte d\'un autre client par quiconque en connaît l\'ARN.',
  'Credenziali già temporanee, da rinnovare alla scadenza.':
    'Identifiants déjà temporaires, à renouveler à leur expiration.',
  'DNS (PowerDNS, Microsoft DNS)':
    'DNS (PowerDNS, Microsoft DNS)',
  'Database di connessione':
    'Base de données de connexion',
  'Endpoint API':
    'Endpoint API',
  'Cynet (EDR/XDR)':
    'Cynet (EDR/XDR)',
  'Client ID, Access Key e Secret Key': 'Client ID, Access Key et Secret Key',
  'Client ID (Site ID)': 'Client ID (Site ID)',
  'Access Key': 'Access Key',
  'Secret Key': 'Secret Key',
  "Le credenziali dell'utente API di Cynet (Settings → API Management → Create API User): Access Key e Secret Key, più il Client ID (Site ID) del sito. CENSO le scambia con un token a scadenza e non le riusa a ogni chiamata. Restano cifrate con la chiave del tenant.":
    'Les identifiants de l’utilisateur API de Cynet (Settings → API Management → Create API User) : Access Key et Secret Key, plus le Client ID (Site ID) du site. CENSO les échange contre un jeton à expiration et ne les réutilise pas à chaque appel. Ils restent chiffrés avec la clé du tenant.',
  'https://<istanza>.api.cynet.com':
    'https://<instance>.api.cynet.com',
  "L'indirizzo dell'API di Cynet, nella forma https://<istanza>.api.cynet.com (l'istanza si ricava dall'indirizzo della console). In assenza di schema si usa HTTPS. Se è in cloud scegli «Control Plane» in «Da dove si parla»; se è on-premise nella rete del cliente, scegli una sonda.":
    'L’adresse de l’API Cynet, sous la forme https://<instance>.api.cynet.com (l’instance se déduit de l’adresse de la console). Sans schéma, HTTPS est utilisé. Si elle est dans le cloud, choisis «Control Plane» dans «D’où l’on parle» ; si elle est on-premise dans le réseau du client, choisis une sonde.',
  'Cynet': 'Cynet',
  'online': 'en ligne',
  'Chiavi API': 'Clés API',
  'Chiave creata': 'Clé créée',
  'Chiavi esistenti': 'Clés existantes',
  'Nuova chiave API': 'Nouvelle clé API',
  'Crea chiave': 'Créer la clé',
  'Creo…': 'Création…',
  'Nessuna chiave API.': 'Aucune clé API.',
  'Creane una qui sopra per far accedere un sistema esterno.': 'Créez-en une ci-dessus pour laisser entrer un système externe.',
  'Chiavi per far leggere e scrivere i dati di questo tenant a un sistema esterno (SIEM, SOC, automazione), con il profilo per modulo che decidi tu. Il segreto si mostra una volta sola.':
    'Des clés pour qu’un système externe (SIEM, SOC, automatisation) lise et écrive les données de ce tenant via API, avec le profil par module que tu décides. Le secret ne s’affiche qu’une seule fois.',
  'Copiala adesso: non sarà più visibile dopo aver lasciato questa pagina.':
    'Copie-la maintenant : elle ne sera plus visible après avoir quitté cette page.',
  'Il profilo può solo restringere rispetto al ruolo di partenza: non concede mai più di quello.':
    'Le profil ne peut que restreindre par rapport au rôle de départ : il n’accorde jamais plus.',
  'Profilo: cosa può vedere e fare la chiave': 'Profil : ce que la clé peut voir et faire',
  'Revocare questa chiave? Chi la usa perde subito l’accesso.':
    'Révoquer cette clé ? Qui l’utilise perd aussitôt l’accès.',
  'Scadenza (facoltativa)': 'Expiration (facultative)',
  'Tutti i moduli (predefinito)': 'Tous les modules (par défaut)',
  'es. SIEM, export notturno': 'ex. SIEM, export nocturne',
  'chiavi con cui un sistema esterno (SIEM, SOC, automazione) legge e scrive i dati del tenant via API, con il profilo per modulo che scegli — come un ruolo, e mai più potente di chi la crea. Il segreto si vede una volta sola. Alcune superfici restano off-limits per qualunque chiave: segreti delle credenziali, utenti e ruoli, altre chiavi, amministrazione di piattaforma. È una funzione del piano enterprise, con un freno sulla frequenza delle chiamate; ogni chiave si revoca con un clic e può avere una scadenza.':
    'des clés avec lesquelles un système externe (SIEM, SOC, automatisation) lit et écrit les données du tenant via API, avec le profil par module que tu choisis — comme un rôle, et jamais plus puissant que celui qui la crée. Le secret ne s’affiche qu’une fois. Certaines surfaces restent interdites à toute clé : secrets des identifiants, utilisateurs et rôles, autres clés, administration de la plateforme. C’est une fonction du plan enterprise, avec un frein sur la fréquence des appels ; chaque clé se révoque d’un clic et peut avoir une expiration.',
  'La copertura dell’EDR Cynet sul parco: quali asset sono protetti, quali no, più allarmi e vulnerabilità sui CI.':
    'La couverture de l’EDR Cynet sur le parc : quels actifs sont protégés, lesquels non, plus alertes et vulnérabilités sur les CI.',
  'Cynet non è interrogabile.': 'Cynet n’est pas interrogeable.',
  'Sincronizzati {h} host, {f} reperti scritti, {c} chiusi.':
    '{h} hôtes synchronisés, {f} constats écrits, {c} fermés.',
  'Host con l’agente': 'Hôtes avec l’agent',
  'Copertura EDR': 'Couverture EDR',
  'Degli asset di CENSO che possono portare un agente (PC, server), quanti Cynet li protegge. Gli apparecchi che non possono averlo (medicali, rete, stampanti) sono «non applicabili».':
    'Parmi les actifs de CENSO qui peuvent porter un agent (PC, serveurs), combien Cynet protège. Les appareils qui ne peuvent pas en avoir (médicaux, réseau, imprimantes) sont « non applicables ».',
  'Protetti': 'Protégés',
  'Non protetti': 'Non protégés',
  'Non applicabili': 'Non applicables',
  'Solo in Cynet': 'Seulement dans Cynet',
  'Asset non protetti dall’EDR': 'Actifs non protégés par l’EDR',
  'Endpoint che CENSO conosce ma su cui Cynet non vede l’agente: da coprire o da verificare.':
    'Terminaux que CENSO connaît mais où Cynet ne voit pas l’agent : à couvrir ou à vérifier.',
  'Host solo in Cynet': 'Hôtes seulement dans Cynet',
  'Host che Cynet protegge ma CENSO non ha ancora in inventario: la sincronizzazione li aggiunge.':
    'Hôtes que Cynet protège mais que CENSO n’a pas encore en inventaire : la synchronisation les ajoute.',
  'Interrogato': 'Interrogé',
  'la copertura dell’EDR Cynet: quali asset dell’inventario non hanno l’agente (un controllo NIS2/DORA), più host, allarmi e vulnerabilità. La console è spesso in cloud, quindi la si interroga dal Control Plane; gli allarmi e le vulnerabilità diventano reperti sui CI, gli host con l’agente diventano CI che si fondono con quelli già noti.':
    'la couverture de l’EDR Cynet : quels actifs de l’inventaire n’ont pas l’agent (un contrôle NIS2/DORA), plus hôtes, alertes et vulnérabilités. La console est souvent dans le cloud, on l’interroge donc depuis le Control Plane ; les alertes et vulnérabilités deviennent des constats sur les CI, les hôtes avec l’agent deviennent des CI qui fusionnent avec ceux déjà connus.',
  'Endpoint Indexer':
    'Endpoint Indexer',
  'Equivale a una community in chiaro.':
    'Équivaut à une communauté en clair.',
  'Firewall (Palo Alto)':
    'Pare-feu (Palo Alto)',
  'Firma asimmetrica su ogni richiesta: nessun segreto condiviso viaggia sulla rete. La chiave è revocabile singolarmente dalla console Oracle.':
    'Signature asymétrique de chaque requête : aucun secret partagé ne circule sur le réseau. La clé est révocable individuellement depuis la console Oracle.',
  'Identificativo della regione, non il nome esteso.':
    'Identifiant de la région, pas son nom complet.',
  "Il bind LDAP classico: l'utente è un UPN («utente@dominio») o un DN completo. Da usare **solo su TLS** — in chiaro manda la password leggibile in rete.":
    'Le bind LDAP classique : l\'utilisateur est un UPN (« utilisateur@domaine ») ou un DN complet. À utiliser **uniquement sur TLS** — en clair, le mot de passe circule lisible sur le réseau.',
  'Il campo private_key del file JSON del service account.':
    'Le champ private_key du fichier JSON du compte de service.',
  "Il segreto non lascia mai la sonda: si invia un'asserzione firmata, valida pochi minuti e solo per l'endpoint del token.":
    'Le secret ne quitte jamais la sonde : on envoie une assertion signée, valable quelques minutes et uniquement pour l\'endpoint du jeton.',
  'Il segreto viene inviato a ogni autenticazione e vale fino alla sua scadenza.':
    'Le secret est envoyé à chaque authentification et reste valable jusqu\'à son expiration.',
  'Il server DNS Windows (di norma un domain controller), per nome o indirizzo, raggiungibile in WinRM dalla sonda scelta.':
    'Le serveur DNS Windows (en général un contrôleur de domaine), par nom ou adresse, joignable en WinRM depuis la sonde choisie.',
  'Impersonificazione di un service account':
    'Emprunt d\'identité d\'un compte de service',
  'Impronta SHA-256 del certificato':
    'Empreinte SHA-256 du certificat',
  'Impronta della chiave':
    'Empreinte de la clé',
  "In ntopng si genera da Impostazioni → Utenti, sull'utente che si vuole usare. Revocabile da solo, senza toccare la password.":
    'Dans ntopng, il se génère dans Paramètres → Utilisateurs, sur l\'utilisateur à employer. Révocable seul, sans toucher au mot de passe.',
  'Interfaccia (ifid)':
    'Interface (ifid)',
  'Interrogazione in tempo reale del backup del cliente via REST API — Veeam Backup & Replication, Vinchin Backup & Recovery, Commvault, Rubrik: stato dei job, repository (capacità e spazio) e oggetti protetti. Non apre porte e non avvia job — la query esce da questa sonda attraverso il relay. Abilitala dove la sonda raggiunge il server di backup.':
    'Interrogation en temps réel de la sauvegarde du client via API REST — Veeam Backup & Replication, Vinchin Backup & Recovery, Commvault, Rubrik : état des tâches, dépôts (capacité et espace) et objets protégés. N’ouvre aucun port et ne lance aucune tâche — la requête sort de cette sonde à travers le relais. Activez-la là où la sonde atteint le serveur de sauvegarde.',
  "Interrogazione in tempo reale di un Wazuh sulla rete del cliente: stato degli agenti, conformità SCA, allarmi e vulnerabilità, letti al momento dalla API del manager e dall'Indexer. Non apre porte e non avvia job — la query esce da questa sonda attraverso il relay. Abilitala solo dove la sonda raggiunge davvero Wazuh: è la sonda che il connettore userà.":
    'Interrogation en temps réel d\'un Wazuh sur le réseau du client : état des agents, conformité SCA, alertes et vulnérabilités, lus à la demande depuis l\'API du manager et l\'Indexer. N\'ouvre aucun port et ne lance aucun job — la requête part de cette sonde via le relais. Activez-la uniquement là où la sonde joint réellement Wazuh : c\'est la sonde que le connecteur utilisera.',
  "Interrogazione in tempo reale di un firewall Palo Alto via XML API: il traffico visto da/verso un host (anche «solo bloccato») e il cruscotto dell'apparato (sistema, sessioni, utenti VPN, amministratori). Non apre porte e non avvia job — la query esce da questa sonda attraverso il relay. Abilitala dove la sonda raggiunge la gestione del firewall.":
    'Interrogation en temps réel d\'un pare-feu Palo Alto via l\'API XML : le trafic vu depuis/vers un hôte (y compris « bloqué uniquement ») et le tableau de bord de l\'équipement (système, sessions, utilisateurs VPN, administrateurs). N\'ouvre aucun port et ne lance aucun job — la requête part de cette sonde via le relais. Activez-la là où la sonde joint l\'administration du pare-feu.',
  'La revisione dell’header `x-api-version`, legata alla build di VBR. «Automatica» la sceglie CENSO dalla build del server: scegline una solo per forzarla.':
    'La révision de l’en-tête `x-api-version`, liée au build de VBR. «Automatique» laisse CENSO la choisir d’après le build du serveur : n’en choisissez une que pour la forcer.',
  "Identificativo dell'istanza PowerDNS usato nell'endpoint /servers/<id>. Se non specificato, viene utilizzato localhost.": "Identifiant de l'instance PowerDNS utilisé dans l'endpoint /servers/<id>. S'il n'est pas spécifié, localhost est utilisé.",
  "Vuota: l'inventario copre tutte le regioni abilitate dell'account (serve il permesso ec2:DescribeRegions). Un valore: solo quella regione.":
    "Vide : l'inventaire couvre toutes les régions activées du compte (nécessite l'autorisation ec2:DescribeRegions). Une valeur : seulement cette région.",
  "L'unico livello che protegge anche il contenuto delle risposte.":
    'Le seul niveau qui protège aussi le contenu des réponses.',
  "L'utente può essere di dominio («DOMINIO\\\\utente») o locale. L'autenticazione è Basic: su HTTPS è protetta dal TLS, in chiaro no — per questo il passo usa la 5986 se non gli si dice altro.":
    'L\'utilisateur peut être de domaine (« DOMAINE\\\\utilisateur ») ou local. L\'authentification est Basic : sur HTTPS elle est protégée par TLS, en clair non — c\'est pourquoi cette étape utilise le 5986 sauf indication contraire.',
  "L'utente si scrive «DOMINIO\\\\utente» o «utente@dominio». Basta un account di sola lettura del dominio: leggere gli oggetti non richiede privilegi. Su ldaps (default) il bind è protetto dal TLS.":
    'L\'utilisateur s\'écrit « DOMAINE\\\\utilisateur » ou « utilisateur@domaine ». Un compte de domaine en lecture seule suffit : lire les objets ne requiert aucun privilège. Sur ldaps (par défaut), le bind est protégé par TLS.',
  "La `api-key` configurata in PowerDNS (`api-key=` nel config). Viaggia nell'header `X-API-Key`. Revocabile cambiandola nel config. Vale anche per scrivere: CENSO scrive solo se accendi «Consenti la scrittura».":
    'La `api-key` configurée dans PowerDNS (`api-key=` dans la config). Elle voyage dans l’en-tête `X-API-Key`. Révocable en la changeant dans la config. Elle vaut aussi pour écrire : CENSO n’écrit que si vous activez «Autoriser l’écriture».',
  'La chiave API di PAN-OS, generata per un amministratore dedicato in **sola lettura** (Device → Admin Roles, con la scheda XML API abilitata). Si ottiene una volta da «/api/?type=keygen&user=…&password=…» e si incolla qui: è revocabile da sola e non coincide con la password interattiva.':
    'La clé API PAN-OS, générée pour un administrateur dédié en **lecture seule** (Device → Admin Roles, avec l\'onglet XML API activé). Elle s\'obtient une fois via « /api/?type=keygen&user=…&password=… » et se colle ici : révocable seule, elle ne coïncide pas avec le mot de passe interactif.',
  "La chiave distribuita appartiene a un'identità che può solo impersonare: revocare l'accesso non richiede di ruotarla sulle sonde.":
    'La clé distribuée appartient à une identité qui peut seulement emprunter une identité : révoquer l\'accès n\'oblige pas à la renouveler sur les sondes.',
  'La chiave vale finché non viene eliminata dal progetto.':
    'La clé reste valable tant qu\'elle n\'est pas supprimée du projet.',
  'La chiave è preferibile: una password riusata su molti host è un solo segreto che apre tutto il parco.':
    'La clé est préférable : un mot de passe réutilisé sur de nombreux hôtes est un secret unique qui ouvre tout le parc.',
  'La community viaggia in chiaro sulla rete: preferire SNMP v3 dove gli apparati lo supportano.':
    'La communauté circule en clair sur le réseau : préférez SNMP v3 là où les équipements le prennent en charge.',
  'La coppia che NexaSphere/NexaVM mostrano in «AccessKey». Il segreto non viene mai inviato: firma ogni richiesta. Revocabile da sola e indipendente dalle credenziali interattive di un amministratore.':
    'La paire que NexaSphere/NexaVM affichent sous « AccessKey ». Le secret n\'est jamais envoyé : il signe chaque requête. Révocable seule et indépendante des identifiants interactifs d\'un administrateur.',
  "La sonda ottiene la chiave API dal firewall a ogni interrogazione (keygen). Usare un'utenza **locale** dedicata in sola lettura con la XML API abilitata: un account RADIUS/TACACS+ non genera la chiave.":
    'La sonde obtient la clé API du pare-feu à chaque interrogation (keygen). Utilisez un compte **local** dédié en lecture seule avec l\'API XML activée : un compte RADIUS/TACACS+ ne génère pas la clé.',
  "Le chiavi salvate servono solo a chiedere credenziali temporanee, che scadono da sole dopo un'ora.":
    'Les clés enregistrées servent uniquement à demander des identifiants temporaires, qui expirent d\'eux-mêmes au bout d\'une heure.',
  "Le credenziali con cui si entra nella console Veeam: un'utenza di dominio «DOMINIO\\utente» o un account locale «SERVER\\utente». Meglio un'utenza dedicata in sola lettura (ruolo Veeam Backup Operator/Viewer). La sonda fa il login OAuth2 a ogni interrogazione e ottiene un token a scadenza.":
    'Les identifiants de connexion à la console Veeam : un compte de domaine « DOMAINE\\utilisateur » ou un compte local « SERVEUR\\utilisateur ». De préférence un compte dédié en lecture seule (rôle Veeam Backup Operator/Viewer). La sonde effectue la connexion OAuth2 à chaque interrogation et obtient un jeton à durée limitée.',
  'Le risposte viaggiano in chiaro.':
    'Les réponses circulent en clair.',
  'Lettura di zone e record dei DNS del cliente in tempo reale attraverso la sonda: PowerDNS via REST API, Microsoft DNS via WinRM (solo gli script di lettura del catalogo della sonda). Non apre porte e non avvia job. Abilitala dove la sonda raggiunge il server DNS.':
    'Lecture en temps réel des zones et enregistrements DNS du client via la sonde : PowerDNS via l\'API REST, Microsoft DNS via WinRM (uniquement les scripts de lecture du catalogue de la sonde). N\'ouvre aucun port et ne lance aucun job. Activez-la là où la sonde joint le serveur DNS.',
  'Microsoft DNS (WinRM)':
    'Microsoft DNS (WinRM)',
  'NTLM (utente e password)':
    'NTLM (utilisateur et mot de passe)',
  'Nessuna autenticazione':
    'Aucune authentification',
  'Nome sessione':
    'Nom de session',
  'OCID del compartimento':
    'OCID du compartiment',
  "OCID dell'utente":
    'OCID de l\'utilisateur',
  'OCID della tenancy':
    'OCID de la tenancy',
  'Osservazione del traffico, in due modi che questa sola funzione abilita entrambi: ricevere i flussi esportati dagli apparati (NetFlow/IPFIX/sFlow — apre una porta in ascolto), oppure catturarli da una porta mirror (nessuna porta in ingresso). Una sonda che fa solo cattura abilita comunque questa: quale sorgente usare si sceglie nella sua configurazione dei flussi, non con una capability diversa.':
    'Observation du trafic, de deux façons que cette seule fonction active ensemble : recevoir les flux exportés par les équipements (NetFlow/IPFIX/sFlow — ouvre un port d\'écoute), ou les capturer depuis un port miroir (aucun port entrant). Une sonde qui fait uniquement de la capture active tout de même celle-ci : la source à utiliser se choisit dans sa configuration des flux, pas avec une autre capability.',
  'Palo Alto (firewall)':
    'Palo Alto (pare-feu)',
  'Passphrase della chiave':
    'Passphrase de la clé',
  'Passphrase di autenticazione':
    'Passphrase d\'authentification',
  'Passphrase di cifratura':
    'Passphrase de chiffrement',
  'Password API':
    'Mot de passe API',
  'Password Indexer':
    'Mot de passe Indexer',
  'Porta DeviceManager':
    'Port DeviceManager',
  'Porta REST del DeviceManager. Predefinita 8088.':
    'Port REST du DeviceManager. Par défaut 8088.',
  'Porta WinRM':
    'Port WinRM',
  'Project ID':
    'ID du projet',
  'Protocollo obsoleto: usarlo solo con apparati che non offrono altro.':
    'Protocole obsolète : à n\'utiliser qu\'avec des équipements qui ne proposent rien d\'autre.',
  "Quale interfaccia di ntopng leggere. Vuoto significa la prima, che su quasi tutte le installazioni è l'unica. Si legge una sola interfaccia per volta: sommarne due che vedono lo stesso segmento produrrebbe lo stesso host due volte.":
    'Quelle interface ntopng lire. Vide signifie la première, qui est la seule sur presque toutes les installations. Une seule interface est lue à la fois : en additionner deux qui voient le même segment produirait deux fois le même hôte.',
  'Quella mostrata da Oracle accanto alla chiave API caricata.':
    'Celle qu\'Oracle affiche à côté de la clé API téléversée.',
  'Restano valide finché non vengono revocate: usare un utente IAM dedicato con i soli permessi di lettura.':
    'Elles restent valables jusqu\'à leur révocation : utilisez un utilisateur IAM dédié avec uniquement des droits de lecture.',
  'Revocabile da solo e spesso a scadenza, senza coincidere con le credenziali interattive di un amministratore.':
    'Révocable seul et souvent à durée limitée, sans coïncider avec les identifiants interactifs d\'un administrateur.',
  'SERVER\\utente':
    'SERVEUR\\utilisateur',
  'SSH con chiave':
    'SSH avec clé',
  'SSH con password':
    'SSH avec mot de passe',
  "Sconsigliato: disabilita la verifica dell'identità del server ed espone ad attacchi. Consigliata una CA attendibile o l'impronta SHA-256 del certificato.": "Déconseillé : désactive la vérification de l'identité du serveur et expose à des attaques. Une AC de confiance ou l'empreinte SHA-256 du certificat est conseillée.",
  'Scope pieno (serve a Cloud Functions e Cloud SQL)':
    'Scope complet (nécessaire pour Cloud Functions et Cloud SQL)',
  "Senza, il token legge solo Compute e Storage — che è il grosso dell'inventario — e i due servizi vengono saltati con la ragione scritta nel rapporto. Con, il token porta anche cloud-platform: da quel momento la sola lettura la garantisce il ruolo IAM del service account, che va tenuto a roles/viewer.":
    'Sans, le jeton lit uniquement Compute et Storage — l\'essentiel de l\'inventaire — et les deux services sont ignorés, avec la raison indiquée dans le rapport. Avec, le jeton inclut aussi cloud-platform : dès lors, la lecture seule n\'est garantie que par le rôle IAM du compte de service, à maintenir à roles/viewer.',
  'Server':
    'Serveur',
  'Service account':
    'Compte de service',
  'Service account da impersonare':
    'Compte de service à emprunter',
  'Service account della sonda':
    'Compte de service de la sonde',
  'Service name':
    'Nom du service',
  'Session token':
    'Jeton de session',
  "Solo se sul server è abilitata l'autenticazione Basic di WinRM, e solo su HTTPS: in chiaro manderebbe la password leggibile.":
    'Uniquement si l\'authentification Basic de WinRM est activée sur le serveur, et uniquement sur HTTPS : en clair, le mot de passe circulerait lisible.',
  'Solo su un segmento fidato: con NTLM la password non viaggia, ma il contenuto sì. Il default è HTTPS sulla 5986.':
    'Uniquement sur un segment de confiance : avec NTLM le mot de passe ne circule pas, mais le contenu oui. Par défaut, HTTPS sur le 5986.',
  'Spento di default: WinRM usa quasi sempre il certificato autofirmato di `winrm quickconfig`. Accendilo se il server ha un certificato della tua PKI.':
    'Désactivé par défaut : WinRM utilise presque toujours le certificat auto-signé de `winrm quickconfig`. Activez-le si le serveur possède un certificat de votre PKI.',
  'Subscription ID':
    'ID d\'abonnement',
  'Tenant ID':
    'ID du tenant',
  'Token':
    'Jeton',
  'Token API':
    'Jeton API',
  'Token di sessione':
    'Jeton de session',
  'Traffico (NetFlow e cattura)':
    'Trafic (NetFlow et capture)',
  "URL del Wazuh Indexer (OpenSearch), porta predefinita 9200. Da Wazuh 4.8 è necessario per acquisire vulnerabilità e allarmi, non più disponibili tramite l'API sulla porta 55000. Se non configurato, vulnerabilità e allarmi non vengono acquisiti.": "URL du Wazuh Indexer (OpenSearch), port par défaut 9200. Depuis Wazuh 4.8, il est nécessaire pour recueillir les vulnérabilités et les alertes, qui ne sont plus disponibles via l'API sur le port 55000. S'il n'est pas configuré, les vulnérabilités et les alertes ne sont pas recueillies.",
  'URL del vCenter.':
    'URL du vCenter.',
  'Endpoint della REST API di PowerDNS Authoritative Server, porta predefinita 8081 e schema HTTP se omesso. Richiede api=yes e webserver=yes nella configurazione del server.': "Endpoint de l'API REST de PowerDNS Authoritative Server, port par défaut 8081 et schéma HTTP si omis. Nécessite api=yes et webserver=yes dans la configuration du serveur.",
  'URL della REST API di Veeam Backup & Replication (VBR), porta predefinita 9419. Se lo schema è omesso, viene usato HTTPS. La documentazione Swagger è disponibile in /swagger/index.html.': "URL de l'API REST de Veeam Backup & Replication (VBR), port par défaut 9419. Si le schéma est omis, HTTPS est utilisé. La documentation Swagger est disponible sur /swagger/index.html.",
  "URL della Wazuh API, porta predefinita 55000. In assenza di schema viene utilizzato HTTPS. La sonda interroga questo endpoint per acquisire agenti e risultati SCA; per l'utenza API dedicata, consulta la guida qui sopra.": "URL de l'API Wazuh, port par défaut 55000. HTTPS est utilisé en l'absence de schéma. La sonde interroge cet endpoint pour recueillir les agents et les résultats SCA ; pour l'utilisateur API dédié, consultez le guide ci-dessus.",
  'URL della console aCloud.':
    'URL de la console aCloud.',
  'URL della console di ntopng. La porta predefinita è la 3000. Se manca lo schema si assume «https».':
    'URL de la console ntopng. Le port par défaut est 3000. Si le schéma manque, « https » est supposé.',
  'URL della gestione del firewall (o di Panorama): la XML API risponde sulla stessa porta della console, di norma la 443. Senza schema si assume «https».':
    'URL d\'administration du pare-feu (ou de Panorama) : l\'API XML répond sur le même port que la console, en général le 443. Sans schéma, « https » est supposé.',
  "URL delle **API** del management node, con lo schema per esteso: di norma «http://indirizzo:8080», spesso in chiaro — non l'indirizzo della console web, che risponde in HTTPS su un'altra porta. Stesse API di ZStack: l'utente può essere un account o un sub-account («utente@account»).":
    'URL de l\'**API** du management node, avec le schéma complet : en général « http://adresse:8080 », souvent en clair — pas l\'adresse de la console web, qui répond en HTTPS sur un autre port. Même API que ZStack : l\'utilisateur peut être un compte ou un sous-compte (« utilisateur@compte »).',
  "URL delle **API** del management node, con lo schema per esteso: di norma «http://indirizzo:8080», spesso in chiaro. La console web risponde in HTTPS su un'altra porta e alle API restituisce la propria pagina, quindi puntarla non dà un errore ma una risposta HTML. L'utente può essere un account («admin») o un sub-account («utente@account»).":
    'URL de l\'**API** du management node, avec le schéma complet : en général « http://adresse:8080 », souvent en clair. La console web répond en HTTPS sur un autre port et renvoie sa propre page aux appels API ; la cibler ne produit donc pas d\'erreur mais une réponse HTML. L\'utilisateur peut être un compte (« admin ») ou un sous-compte (« utilisateur@compte »).',
  'URL di Prism Central (porta 9440 se non standard).':
    'URL de Prism Central (port 9440 s\'il n\'est pas standard).',
  "URL di un nodo o del cluster, di norma sulla porta 8006. Con il token API serve la forma completa «utente@realm!nome=segreto»; con utente e password il realm è obbligatorio («root@pam»). Serve il ruolo **PVEAuditor su «/» con propagazione**: senza, Proxmox non dà errore — risponde con meno dati, e l'inventario esce con i nomi e senza le misure. Attenzione ai token API: nascono con la separazione dei privilegi attiva, quindi hanno solo i ruoli assegnati **al token**, non quelli dell'utente che lo possiede.":
    'URL d\'un nœud ou du cluster, en général sur le port 8006. Avec le jeton API, la forme complète « utilisateur@realm!nom=secret » est requise ; avec utilisateur et mot de passe, le realm est obligatoire (« root@pam »). Le rôle **PVEAuditor sur « / » avec propagation** est nécessaire : sans lui, Proxmox ne renvoie pas d\'erreur — il répond avec moins de données, et l\'inventaire sort avec les noms mais sans les mesures. Attention aux jetons API : ils naissent avec la séparation des privilèges active et n\'ont donc que les rôles attribués **au jeton**, pas ceux de l\'utilisateur qui le possède.',
  "Un login di sola lettura basta: l'inventario legge solo le viste di sistema (versione, elenco e dimensione dei database).":
    'Un login en lecture seule suffit : l\'inventaire lit uniquement les vues système (version, liste et taille des bases de données).',
  "Un ruolo di sola lettura basta: l'inventario interroga solo i cataloghi di sistema (versione, elenco e dimensione dei database). Il database a cui connettersi di default è «postgres».":
    'Un rôle en lecture seule suffit : l\'inventaire interroge uniquement les catalogues système (version, liste et taille des bases de données). La base de connexion par défaut est « postgres ».',
  "Un utente di sola lettura basta: l'inventario legge solo `information_schema` (versione, schemi e loro dimensione).":
    'Un utilisateur en lecture seule suffit : l\'inventaire lit uniquement `information_schema` (version, schémas et leur taille).',
  "Un utente di sola lettura basta: l'inventario legge solo le viste di sistema (versione, PDB e loro dimensione). Il «service name» è il servizio a cui connettersi (default «XE»).":
    'Un utilisateur en lecture seule suffit : l\'inventaire lit uniquement les vues système (version, PDB et leur taille). Le « service name » est le service auquel se connecter (par défaut « XE »).',
  'Utenza API Wazuh dedicata e in sola lettura, gestita tramite RBAC. La sonda si autentica via API e utilizza un token JWT a scadenza. Le credenziali predefinite devono essere cambiate.': "Utilisateur API Wazuh dédié en lecture seule, géré via RBAC. La sonde s'authentifie via l'API et utilise un jeton JWT à expiration. Les identifiants par défaut doivent être changés.",
  'Una chiave dedicata alla discovery, con `command=` o una shell ristretta sul lato host. Non riusare la chiave con cui gli amministratori entrano a mano.':
    'Une clé dédiée à la découverte, avec `command=` ou un shell restreint côté hôte. Ne réutilisez pas la clé avec laquelle les administrateurs se connectent à la main.',
  "Usare un'utenza dedicata in sola lettura, non quella di un amministratore.":
    'Utilisez un compte dédié en lecture seule, pas celui d\'un administrateur.',
  "Usare un'utenza dedicata in sola lettura. ntopng risponde alla chiamata REST con una pagina di login HTML quando l'utenza non è accettata, e la sonda lo dice invece di leggerla come «nessun host».":
    'Utilisez un compte dédié en lecture seule. ntopng répond à l\'appel REST par une page de connexion HTML quand le compte n\'est pas accepté, et la sonde le signale au lieu de l\'interpréter comme « aucun hôte ».',
  'Utente API':
    'Utilisateur API',
  'Utente Indexer':
    'Utilisateur Indexer',
  'Utente e password':
    'Utilisateur et mot de passe',
  "Utente interno del Wazuh Indexer, separato dall'utenza API, con permessi di sola lettura sugli indici wazuh-alerts-* e wazuh-states-vulnerabilities-*. Si configura nella dashboard in Indexer management → Security → Internal users.": "Utilisateur interne du Wazuh Indexer, distinct de l'utilisateur API, avec des permissions en lecture seule sur les index wazuh-alerts-* et wazuh-states-vulnerabilities-*. Se configure dans le dashboard sous Indexer management → Security → Internal users.",
  'Verifica il certificato':
    'Vérifier le certificat',
  'Versione API':
    'Version de l\'API',
  "Vuoto: si interroga l'intera tenancy, che ne è la radice.":
    'Vide : on interroge toute la tenancy, qui en est la racine.',
  'Wazuh (SIEM/XDR)':
    'Wazuh (SIEM/XDR)',
  'WinRM in chiaro (HTTP)':
    'WinRM en clair (HTTP)',
  'Windows (WinRM)':
    'Windows (WinRM)',
  'censo@progetto.iam.gserviceaccount.com':
    'censo@projet.iam.gserviceaccount.com',
  'dc01.dominio.local':
    'dc01.domaine.local',
  'inventario@progetto.iam.gserviceaccount.com':
    'inventaire@projet.iam.gserviceaccount.com',
  '«DOMINIO\\utente». Per leggere basta un utente con lettura sul server DNS; per scrivere (se accendi «Consenti la scrittura») serve la scrittura sulle zone, per esempio un membro di «DnsAdmins»: non serve un amministratore di dominio.':
    '«DOMAINE\\utilisateur». Pour lire, un utilisateur avec lecture sur le serveur DNS suffit ; pour écrire (si vous activez «Autoriser l’écriture») il faut l’écriture sur les zones, par exemple un membre de «DnsAdmins» : pas besoin d’un administrateur de domaine.',
  'Esportazione non riuscita (HTTP {status})':
    'Échec de l’export (HTTP {status})',
  '180 giorni':
    '180 jours',
  '1 anno':
    '1 an',
  '{n} riga · generato il {quando}':
    '{n} ligne · générée le {quando}',
  '{n} righe · generato il {quando}':
    '{n} lignes · générées le {quando}',
  'CPU (ultimi {s}s)':
    'CPU ({s} dernières s)',
  '{n} core':
    '{n} cœurs',
  'nessun limite impostato':
    'aucune limite définie',
  'Memoria letta da {fonte}: dentro un container /proc/meminfo mostra la memoria dell’host, e un servizio con 512 MB di limite su una macchina da 64 GB risulterebbe al 3% un istante prima di essere ucciso.':
    'Mémoire lue depuis {fonte} : dans un conteneur, /proc/meminfo affiche la mémoire de l’hôte, et un service limité à 512 Mo sur une machine de 64 Go apparaîtrait à 3 % un instant avant d’être tué.',
  'Carico della macchina (non del servizio): {carico} su {cpu} CPU visibili.':
    'Charge de la machine (pas du service) : {carico} sur {cpu} CPU visibles.',
  'Disco {percorso}':
    'Disque {percorso}',
  'Store del traffico ({backend})':
    'Stockage du trafic ({backend})',
  'Store del traffico':
    'Stockage du trafic',
  'Non è possibile sapere quanto spazio occupa il traffico né quanto ne resta sul suo volume.':
    'Impossible de savoir combien d’espace occupe le trafic ni combien il en reste sur son volume.',
  'Volume {nome}':
    'Volume {nome}',
  'Misurato il {quando}. I numeri non si aggiornano da soli: la pagina resta ferma finché non si preme «Aggiorna».':
    'Mesuré le {quando}. Les chiffres ne se mettent pas à jour tout seuls : la page reste figée tant qu’on n’appuie pas sur « Actualiser ».',
  'sonda mancante':
    'sonde manquante',
  'riuscito':
    'réussi',
  'fallito':
    'échoué',
  'Contiene':
    'Contient',
  'Non contiene':
    'Ne contient pas',
  'È uguale a':
    'Est égal à',
  'Inizia con':
    'Commence par',
  '{n} righe':
    '{n} lignes',
  '{n} di {tot} righe':
    '{n} sur {tot} lignes',
  'Copia {cosa}':
    'Copier {cosa}',
  'copiato':
    'copié',
  'copia':
    'copier',
  'Ospita macchine virtuali':
    'Héberge des machines virtuelles',
  'Gestito fuori banda':
    'Géré hors bande',
  'Membro di un cluster':
    'Membre d’un cluster',
  'Attivo':
    'Actif',
  'Silente':
    'Silencieux',
  'Scomparso':
    'Disparu',
  'Dismesso':
    'Retiré',
  'Caricamento…':
    'Chargement…',
  '{n}s fa':
    'il y a {n} s',
  '{n} min fa':
    'il y a {n} min',
  '{n} h fa':
    'il y a {n} h',
  '{n} g fa':
    'il y a {n} j',
  'Creare, sospendere, eliminare, assegnare indirizzi':
    'Créer, suspendre, supprimer, attribuer des adresses',
  'Creare utenze e abilitarle sui tenant, con i ruoli':
    'Créer des comptes et les autoriser sur les tenants, avec leurs rôles',
  'Piano assegnato, consumo rispetto alle quote, scadenze':
    'Plan attribué, consommation par rapport aux quotas, échéances',
  'Spazio e oggetti per tenant, dal più ingombrante':
    'Espace et objets par tenant, du plus volumineux au plus petit',
  'CPU, memoria, dischi: se e quando scalare':
    'CPU, mémoire, disques : faut-il faire évoluer, et quand',
  'Dominio, hostname di servizio, certificato':
    'Domaine, nom d’hôte du service, certificat',
  'Riconoscimento del prodotto: un ente SNMP → una classe, per tutti i clienti':
    'Reconnaissance du produit : une entreprise SNMP → une classe, pour tous les clients',
  'Numeri di tutti i clienti insieme, esportabili':
    'Chiffres de tous les clients réunis, exportables',
  'Chi è entrato, su quale tenant, con che esito — e i login falliti':
    'Qui s’est connecté, sur quel tenant, avec quel résultat — et les connexions échouées',
  'Accesso non riuscito: riprova':
    'Échec de la connexion : réessayez',
  'Questa utenza non ha il ruolo provider_admin: per l’amministrazione serve un’utenza di piattaforma':
    'Ce compte n’a pas le rôle provider_admin : l’administration requiert un compte de plateforme',
  'Accesso…':
    'Connexion…',
  'Entra':
    'Se connecter',
  'Job di discovery':
    'Jobs de découverte',
  'Eventi dei job':
    'Événements des jobs',
  'L’identificativo corrisponde al nome breve del tenant presente nell’URL; l’ID interno è l’identificativo univoco utilizzato dal supporto per individuare il tenant interessato.': 'L’identifiant correspond au nom court du tenant présent dans l’URL ; l’ID interne est l’identifiant unique utilisé par le support pour localiser le tenant concerné.',
  'Si applicano i valori di prova del piano «{piano}»: i limiti qui sotto sono quelli, e le funzioni oltre la rete — cloud, virtualizzazione, inventario degli host — restano negate. Le discovery di rete funzionano.':
    'Les valeurs d’essai du plan « {piano} » s’appliquent : les limites ci-dessous sont celles-là, et les fonctions au-delà du réseau — cloud, virtualisation, inventaire des hôtes — restent refusées. Les découvertes réseau fonctionnent.',
  'Era valida fino al {data}.':
    'Elle était valable jusqu’au {data}.',
  'Fino al rinnovo valgono i limiti di prova, che sono quelli mostrati qui sotto.':
    'Jusqu’au renouvellement, les limites d’essai s’appliquent : ce sont celles affichées ci-dessous.',
  'scade il {data}':
    'expire le {data}',
  'il piano non pone un limite':
    'le plan ne fixe aucune limite',
  'nessun piano assegnato':
    'aucun plan attribué',
  'Questi conteggi sono esatti. Sono anche quelli confrontati con le quote della licenza.':
    'Ces décomptes sont exacts. Ce sont aussi ceux comparés aux quotas de la licence.',
  'lo store del traffico non risponde':
    'le stockage du trafic ne répond pas',
  'Viene ripartito fra i tenant in proporzione alle righe: né PostgreSQL né ClickHouse sanno attribuire i byte a un tenant senza rileggere tutti i dati, e farlo a ogni apertura di questa pagina rallenterebbe l’inventario di tutti. Serve a capire dove cresce, non a fatturare a byte — per quello ci sono i conteggi, che sono esatti.':
    'Il est réparti entre les tenants au prorata des lignes : ni PostgreSQL ni ClickHouse ne savent attribuer les octets à un tenant sans relire toutes les données, et le faire à chaque ouverture de cette page ralentirait l’inventaire de tous. Il sert à comprendre où ça grandit, pas à facturer à l’octet — pour cela il y a les décomptes, qui sont exacts.',
  'Tenant ({n})':
    'Tenants ({n})',
  'Crea tenant':
    'Créer le tenant',
  '+ {n} alias ancora valido':
    '+ {n} alias encore valide',
  '+ {n} alias ancora validi':
    '+ {n} alias encore valides',
  'sospeso':
    'suspendu',
  '{n} sonde':
    '{n} sondes',
  'Sospendi':
    'Suspendre',
  'Verranno cancellati CMDB, flussi, credenziali, sonde, integrazioni, OpenID, licenza e ordini di «{nome}» ({ci} CI, {sonde} sonde). Gli utenti che appartengono anche ad altri tenant restano. Per procedere scrivi {slug}.':
    "La CMDB, les flux, les identifiants, les sondes, les intégrations, OpenID, la licence et les commandes de « {nome} » ({ci} CI, {sonde} sondes) seront supprimés. Les utilisateurs appartenant aussi à d'autres tenants restent. Pour continuer, saisissez {slug}.",
  'Utenti di {tenant}':
    'Utilisateurs de {tenant}',
  'Licenze ({n})':
    'Licences ({n})',
  'Fra 1 e 3650 giorni.':
    'Entre 1 et 3650 jours.',
  'listino: illimitato':
    'catalogue : illimité',
  'listino: {valore}':
    'catalogue : {valore}',
  'Riapplicare «{piano}» a tutti i clienti che ce l’hanno?':
    'Réappliquer « {piano} » à tous les clients qui l’ont ?',
  '«{piano}» riapplicato a {n} clienti.':
    '« {piano} » réappliqué à {n} clients.',
  'Riportare «{piano}» ai valori di serie del prodotto?':
    'Rétablir « {piano} » aux valeurs par défaut du produit ?',
  'Rimette le funzioni e le quote come nascono di serie. Le licenze già emesse non cambiano: per allinearle usa «Riapplica ai clienti».':
    'Cela remet les fonctions et les quotas tels qu’ils sont livrés par défaut. Les licences déjà émises ne changent pas : pour les aligner, utilisez « Réappliquer aux clients ».',
  '«{piano}» riportato ai valori di serie.':
    '« {piano} » rétabli aux valeurs par défaut.',
  '{funzione} in {piano}':
    '{funzione} dans {piano}',
  'Il job non è ancora stato eseguito da una sonda.':
    'Le job n’a pas encore été exécuté par une sonde.',
  'La sonda che ha eseguito questo job non produce ancora un rapporto: aggiornala.':
    'La sonde qui a exécuté ce job ne produit pas encore de rapport : mettez-la à jour.',
  'Mostrati {n} eventi su {tot}: usa i filtri per restringere.':
    '{n} événements affichés sur {tot} : utilisez les filtres pour affiner.',
  'Eseguito, con dati raccolti.':
    'Exécuté, avec des données collectées.',
  'A vuoto':
    'À vide',
  'Eseguito e non ha raccolto niente: gli host hanno risposto e non avevano quel dato, oppure il passo cerca qualcosa che lì non c’è.':
    'Exécuté sans rien collecter : les hôtes ont répondu mais n’avaient pas cette donnée, ou l’étape cherche quelque chose qui n’y est pas.',
  'Mai partito':
    'Jamais démarré',
  'Non è partito su nessun indirizzo: la condizione non è mai stata soddisfatta. La scansione risulta riuscita e i dati di questo passo non ci sono.':
    'Il n’a démarré sur aucune adresse : la condition n’a jamais été remplie. L’analyse apparaît comme réussie et les données de cette étape sont absentes.',
  'Sconosciuto alla sonda':
    'Inconnu de la sonde',
  'Questa sonda non sa eseguire il passo: va aggiornata.':
    'Cette sonde ne sait pas exécuter l’étape : elle doit être mise à jour.',
  '{n} oggetti raccolti ({tipi})':
    '{n} objets collectés ({tipi})',
  '{n} interfacce':
    '{n} interfaces',
  '{n} adiacenze':
    '{n} adjacences',
  '{n} prodotti software':
    '{n} produits logiciels',
  '{n} schede macchina':
    '{n} fiches machine',
  'in CMDB: {nuovi} nuovi, {noti} già noti':
    'dans la CMDB : {nuovi} nouveaux, {noti} déjà connus',
  '{n} non salvati, vedi la fase «ingest»':
    '{n} non enregistrés, voir la phase « ingest »',
  '{n} per condizione':
    '{n} par condition',
  '{n} passo ignoto':
    '{n} étape inconnue',
  '{n} attributi su {m} indirizzi':
    '{n} attributs sur {m} adresses',
  'Il comando vale un’ora (fino alle {ora}), e contiene il segreto di questo agent: è l’unica volta in cui compare. Passata la finestra si rigenera — ma rigenerare invalida il segreto vecchio, quindi se l’esca era già installata smette di consegnare finché non la reinstalli.':
    'La commande est valable une heure (jusqu’à {ora}) et contient le secret de cet agent : c’est la seule fois où il apparaît. Passé ce délai, on la régénère — mais régénérer invalide l’ancien secret, donc si le leurre était déjà installé il cesse de livrer tant que vous ne le réinstallez pas.',
  'Il comando vale un’ora, e contiene il segreto di questo agent: è l’unica volta in cui compare. Passata la finestra si rigenera — ma rigenerare invalida il segreto vecchio, quindi se l’esca era già installata smette di consegnare finché non la reinstalli.':
    'La commande est valable une heure et contient le secret de cet agent : c’est la seule fois où il apparaît. Passé ce délai, on la régénère — mais régénérer invalide l’ancien secret, donc si le leurre était déjà installé il cesse de livrer tant que vous ne le réinstallez pas.',
  'Copia il binario {binario} sulla macchina dedicata, e questo file in {percorso} con permessi {permessi}.':
    'Copiez le binaire {binario} sur la machine dédiée, et ce fichier dans {percorso} avec les permissions {permessi}.',
  '{spazio} liberi':
    '{spazio} libres',
  'risposta di accesso senza token':
    'réponse de connexion sans jeton',
  'risposta di cambio tenant senza token':
    'réponse de changement de tenant sans jeton',
  'Il tenant più grande è {nome} con {spazio}, il {percento}% del totale.':
    'Le plus grand tenant est {nome} avec {spazio}, soit {percento} % du total.',
  'Sopra la metà del totale conviene agire su questo cliente — retention del traffico, o piano — prima di allargare il sistema.':
    'Au-delà de la moitié du total, mieux vaut agir sur ce client — rétention du trafic ou offre — avant d’agrandir le système.',
  'Il consumo è distribuito: se lo spazio scarseggia, va allargato il sistema, non un singolo cliente.':
    'La consommation est répartie : si l’espace manque, il faut agrandir le système, pas un client en particulier.',
  'Le colonne del traffico sono vuote perché non è stato possibile interrogarlo, non perché non ci sia traffico.':
    'Les colonnes du trafic sont vides parce qu’il n’a pas pu être interrogé, et non parce qu’il n’y a pas de trafic.',
  'Entrambi interni':
    'Les deux internes',
  'Conserva solo il traffico tra indirizzi appartenenti al perimetro, riducendo al minimo i dati raccolti. Il traffico da e verso Internet viene escluso, quindi i servizi utilizzati esclusivamente dall’esterno non vengono rilevati come entry point.':
    'Seul le trafic entre deux adresses du périmètre est conservé. C’est l’économie maximale, mais le trafic vers et depuis Internet est aussi écarté : un service utilisé uniquement depuis l’extérieur n’apparaîtra pas parmi les entry points.',
  'Almeno uno interno':
    'Au moins un interne',
  'Include il traffico da e verso Internet, mantenendo visibilità sui mittenti che accedono ai servizi pubblicati. Il volume di dati raccolti è maggiore.':
    'Le trafic vers et depuis Internet est aussi conservé. C’est le choix de ceux qui publient des services et veulent en voir les émetteurs. L’économie est bien moindre.',
  'Nessun perimetro':
    'Aucun périmètre',
  'Acquisisce tutto il traffico, mantenendo attive le esclusioni e le soglie definite sulle sonde.':
    'Tout est conservé. Les exclusions et les seuils des sondes restent en vigueur.',
  'Filtro salvato.':
    'Filtre enregistré.',
  'Salva filtro':
    'Enregistrer le filtre',
  'Inserisci un indirizzo per riga; per gli indirizzi singoli /32 è facoltativo. Se l’elenco è vuoto, il filtro viene disabilitato e tutto il traffico resta acquisito, evitando esclusioni involontarie.':
    'Une par ligne. Une adresse seule convient sans {suffisso}.',
  "Se svuoti l'elenco il filtro si spegne invece di scartare tutto: un elenco vuoto che buttasse via ogni cosa farebbe sparire il traffico senza alcun errore.":
    'Si vous videz la liste, le filtre se désactive au lieu de tout écarter : une liste vide qui jetterait tout ferait disparaître le trafic sans la moindre erreur.',
  'Vale dal prossimo giro di configurazione delle sonde e non tocca i dati già raccolti: filtrare a posteriori sarebbe una cancellazione di massa innescata da una modifica di configurazione. Per lo spazio già occupato c’è la conservazione, che è una decisione separata.':
    'S’applique à partir du prochain cycle de configuration des sondes et ne touche pas aux données déjà collectées : filtrer a posteriori serait une suppression massive déclenchée par un changement de configuration. Pour l’espace déjà occupé, il y a la rétention, qui est une décision distincte.',
  '{n} di {tot} già registrati':
    '{n} sur {tot} déjà enregistrés',
  '{n} coperti oggi':
    '{n} couverts aujourd’hui',
  'Solo i beni senza contratto':
    'Uniquement les biens sans contrat',
  'Beni ({n})':
    'Biens ({n})',
  '(senza nome)':
    '(sans nom)',
  'CI collegato':
    'CI lié',
  'scaduta da {n} g':
    'expirée depuis {n} j',
  'fra {n} g':
    'dans {n} j',
  'Nuovo servizio':
    'Nouveau service',
  'Modifica servizio':
    'Modifier le service',
  '— indica un indirizzo —':
    '— indiquer une adresse —',
  'es. {esempio}':
    'ex. {esempio}',
  'Crea servizio':
    'Créer le service',
  'Eliminare il piano «{nome}»? Le scansioni già eseguite restano.':
    'Supprimer le plan « {nome} » ? Les analyses déjà exécutées sont conservées.',
  'Creandone uno si parte da una sequenza già sensata: ping, poi il nome, poi le porte, e i passi cari solo dove il servizio c’è.':
    'En créer un part d’une séquence déjà sensée : ping, puis le nom, puis les ports, et les étapes coûteuses seulement là où le service existe.',
  '{n} avvisi':
    '{n} avertissements',
  'Il piano non ha passi: la scansione riuscirebbe senza guardare niente.':
    'Le plan n’a aucune étape : l’analyse réussirait sans rien examiner.',
  '«{nome}»: job {job}… avviato su {ambito}.':
    '« {nome} » : job {job}… lancé sur {ambito}.',
  'Vuoto: si usano gli ambiti predefiniti del piano — {ambiti}.':
    'Vide : les périmètres par défaut du plan sont utilisés — {ambiti}.',
  'Il piano non ha ambiti predefiniti: senza un ambito qui la scansione non avrebbe indirizzi su cui girare.':
    'Le plan n’a pas de périmètre par défaut : sans périmètre ici, l’analyse n’aurait aucune adresse à parcourir.',
  'non in linea':
    'hors ligne',
  'Avvia adesso':
    'Lancer maintenant',
  '1 errore':
    '1 erreur',
  '{n} errori':
    '{n} erreurs',
  '1 avviso':
    '1 avertissement',
  'Avvia: {tipo}':
    'Lancer : {tipo}',
  'Pianifica: {tipo}':
    'Planifier : {tipo}',
  'Rapporto':
    'Rapport',
  'Pianifica come questa':
    'Planifier à l’identique',
  'Il tipo {tipo} non è più fra quelli disponibili: questa scansione non si può ripianificare così com’è.':
    'Le type {tipo} ne fait plus partie des types disponibles : cette analyse ne peut pas être replanifiée telle quelle.',
  'Pianifica come: {nome}':
    'Planifier comme : {nome}',
  'Questa scansione è nata dalla pianificazione «{nome}». Crearne un’altra uguale raddoppia il carico sulle sonde: ha senso solo se vuoi una ricorrenza diversa.':
    'Cette analyse provient de la planification « {nome} ». En créer une identique double la charge sur les sondes : cela n’a de sens que pour une récurrence différente.',
  'Ripresi da questa scansione: ambito, credenziali, sonda, opzioni e ritmo di interrogazione ({pps} pacchetti al secondo). Resta da decidere quando.':
    'Repris de cette analyse : périmètre, identifiants, sonde, options et cadence d’interrogation ({pps} paquets par seconde). Reste à décider quand.',
  'I pool si riprendono per riferimento: la pianificazione seguirà le reti che verranno aggiunte.':
    'Les pools sont repris par référence : la planification suivra les réseaux qui seront ajoutés.',
  '{n} asset indirizzabili in CMDB.':
    '{n} assets adressables dans la CMDB.',
  '{n} visti da più fonti (lavoro doppio).':
    '{n} vus par plusieurs sources (travail en double).',
  '(primi {n})':
    '({n} premiers)',
  'Valida fino al {data}.':
    'Valide jusqu’au {data}.',
  'Il piano {piano} comprende {funzioni}, ma la licenza è stata emessa prima che questa funzione esistesse e non la concede. Chiedi al fornitore di riassegnare lo stesso piano per attivarla.':
    'L’offre {piano} comprend {funzioni}, mais la licence a été émise avant que cette fonction existe et ne l’accorde pas. Demandez au fournisseur de réattribuer la même offre pour l’activer.',
  'La nuova password e la conferma non coincidono':
    'Le nouveau mot de passe et la confirmation ne correspondent pas',
  'Almeno {n} caratteri.':
    'Au moins {n} caractères.',
  'Aggiornamento…':
    'Mise à jour…',
  'Cambia password':
    'Changer le mot de passe',
  'Classi e categorie':
    'Classes et catégories',
  'Catalogo prodotti (SKU)':
    'Catalogue produits (SKU)',
  'Hanno precedenza sulle regole della piattaforma e vengono applicate in ordine di priorità. La prima regola corrispondente viene utilizzata; le classificazioni manuali non vengono sovrascritte.':
    'Évaluées avant les règles de la plateforme, par ordre de priorité : la première qui correspond l’emporte. La classe choisie à la main sur un CI reste de toute façon intacte.',
  'Il prodotto ha {n} voci di riconoscimento che questo tenant non ha ancora. Applicarle non modifica né cancella niente di ciò che hai già.':
    'Le produit comporte {n} entrées de reconnaissance que ce tenant n’a pas encore. Les appliquer ne modifie ni ne supprime rien de ce que vous avez déjà.',
  '— nessuna —':
    '— aucune —',
  '— nessuno —':
    '— aucun —',
  '— scegli —':
    '— choisir —',
  'Corrisponde a {n} CI, di cui {cambi} cambierebbero classe — {manuali} hanno la classe scelta a mano e non verrebbero toccati.':
    'Correspond à {n} CI, dont {cambi} changeraient de classe — {manuali} ont une classe choisie à la main et ne seraient pas touchés.',
  'Corrisponde a {n} CI, di cui {cambi} cambierebbero classe.':
    'Correspond à {n} CI, dont {cambi} changeraient de classe.',
  'non classificato':
    'non classé',
  'scelta a mano':
    'choisie à la main',
  '…e altri.':
    '…et d’autres.',
  'Provo…':
    'Test en cours…',
  'Prova senza salvare':
    'Tester sans enregistrer',
  '{categoria} · personalizzata':
    '{categoria} · personnalisée',
  'personalizzata':
    'personnalisée',
  'della piattaforma':
    'de la plateforme',
  'Lo SKU identifica il prodotto associato a un oggetto. Viene assegnato ai CI tramite regole di riconoscimento e ne accompagna la trasformazione in asset.':
    'Le SKU indique quel produit est un objet : le code de commande, le prix catalogue, la fin de support. Il se rattache aux CI par une règle de reconnaissance, et quand un CI devient un asset, ces données sont déjà là.',
  'nessuna regola lo aggancia?':
    'aucune règle ne le rattache ?',
  'Testo':
    'Texte',
  'Numero':
    'Nombre',
  'Data':
    'Date',
  'Sì/No':
    'Oui/Non',
  'Elenco a scelta':
    'Liste de choix',
  'Entrambi i versi':
    'Les deux sens',
  'Tutto ciò che tocca il nodo.':
    'Tout ce qui touche le nœud.',
  'Chi ha parlato al nodo':
    'Qui a parlé au nœud',
  'I suoi client: chi apre verso di lui.':
    'Ses clients : qui ouvre des connexions vers lui.',
  'Con chi ha parlato il nodo':
    'À qui le nœud a parlé',
  'Le sue dipendenze: verso chi apre lui.':
    'Ses dépendances : vers qui il ouvre des connexions.',
  '1 — i vicini':
    '1 — les voisins',
  '2 — e i loro':
    '2 — et les leurs',
  '3 — oltre':
    '3 — au-delà',
  '1 nodo ha altri interlocutori oltre il tetto di {tetto} per nodo (segnati con ⁺). Quello che vedi è la parte più voluminosa del vicinato, non tutto il vicinato.':
    '1 nœud a d’autres interlocuteurs au-delà du plafond de {tetto} par nœud (marqués ⁺). Ce que vous voyez est la partie la plus volumineuse du voisinage, pas tout le voisinage.',
  '{n} nodi hanno altri interlocutori oltre il tetto di {tetto} per nodo (segnati con ⁺). Quello che vedi è la parte più voluminosa del vicinato, non tutto il vicinato.':
    '{n} nœuds ont d’autres interlocuteurs au-delà du plafond de {tetto} par nœud (marqués ⁺). Ce que vous voyez est la partie la plus volumineuse du voisinage, pas tout le voisinage.',
  'Attorno a {seed}':
    'Autour de {seed}',
  'Mappa di correlazione di {seed}: {n} nodi':
    'Carte de corrélation de {seed} : {n} nœuds',
  'Un clic su un nodo mostra il dettaglio, un doppio clic riparte da lì, e un nodo si trascina dove serve. Un clic su una linea sceglie la comunicazione — qui e nella tabella sotto. Maiusc+clic esclude un nodo; rotella per ingrandire, trascinamento della tela per spostare.':
    'Un clic sur un nœud affiche le détail, un double clic repart de là, et un nœud se déplace par glisser. Un clic sur une ligne sélectionne la communication — ici et dans le tableau ci-dessous. Maj+clic exclut un nœud ; molette pour zoomer, glisser le fond pour se déplacer.',
  'In {giallo} gli indirizzi che la CMDB non conosce: non è un difetto della mappa, è la risposta — e trovarli è uno dei motivi per cui questo traffico si raccoglie.':
    'En {giallo}, les adresses que la CMDB ne connaît pas : ce n’est pas un défaut de la carte, c’est la réponse — et les trouver est l’une des raisons pour lesquelles ce trafic est collecté.',
  'Comunicazioni ({n})':
    'Communications ({n})',
  'I vicini di questo nodo non sono stati cercati: è al bordo dei livelli richiesti. Doppio clic per ripartire da qui.':
    'Les voisins de ce nœud n’ont pas été recherchés : il se trouve à la limite des niveaux demandés. Double-cliquez pour repartir d’ici.',
  '→ verso':
    '→ vers',
  '← da':
    '← de',
  '{n} ingressi dalla mappa.':
    '{n} entrées depuis la carte.',
  'es. Servizio attorno a {seed}':
    'ex. Service autour de {seed}',
  'Cancellare tutta la storia di «{nome}»?':
    'Supprimer tout l’historique de « {nome} » ?',
  'Sono {n} versioni, e non si recuperano. Serve quando un apparato è stato dismesso: la sua configurazione non interessa più, e tenerla in elenco fa cercare fra apparati che non esistono.':
    'Cela représente {n} versions, irrécupérables. À utiliser quand un équipement a été retiré : sa configuration n’a plus d’intérêt, et la garder dans la liste oblige à chercher parmi des équipements qui n’existent plus.',
  'È lo stesso apparato visto due volte: la configurazione si salva una volta sola, ma finché restano separati la scheda mostra due storie.':
    'C’est le même équipement vu deux fois : la configuration n’est enregistrée qu’une fois, mais tant qu’ils restent séparés la fiche affiche deux historiques.',
  'Le regole di retention sono cumulative: una versione viene eliminata solo quando non soddisfa più alcun criterio di conservazione. L’ultima versione della configurazione di ogni asset è sempre esclusa dalla cancellazione, indipendentemente dalle regole configurate.':
    'Champs vides = tout est conservé, c’est le réglage par défaut : supprimer l’historique est irréversible. Les deux règles s’additionnent — une version est gardée si au moins l’une le demande — ainsi activer la seconde ne supprime pas ce que la première conservait.',
  'L’ultima versione di ogni apparato non si cancella mai, qualunque cosa dicano le regole: un archivio senza la configurazione corrente è un backup senza backup.':
    'La dernière version de chaque équipement n’est jamais supprimée, quelles que soient les règles : une archive sans la configuration actuelle est une sauvegarde sans sauvegarde.',
  'Con questa politica verranno tolte {n} versioni al prossimo giro dell’orchestratore. Non succede al salvataggio: c’è il tempo di accorgersi di aver scritto 3 dove si voleva 30.':
    'Avec cette politique, {n} versions seront supprimées au prochain passage de l’orchestrateur. Cela ne se produit pas à l’enregistrement : on a le temps de remarquer qu’on a saisi 3 au lieu de 30.',
  'Cancellare la versione del {data}?':
    'Supprimer la version du {data} ?',
  'Non si recupera. Il confronto delle versioni rimaste continuerà a funzionare, ma salterà quello che è successo in mezzo.':
    'Elle est irrécupérable. La comparaison des versions restantes continuera de fonctionner, mais sautera ce qui s’est passé entre-temps.',
  '{righe} righe volatili · {segreti} segreti':
    '{righe} lignes volatiles · {segreti} secrets',
  '+{aggiunte} righe aggiunte, −{tolte} tolte':
    '+{aggiunte} lignes ajoutées, −{tolte} supprimées',
  'Le credenziali sono state mascherate prima di conservarla: per ripristinare da qui vanno rimesse a mano.':
    'Les identifiants ont été masqués avant l’archivage : pour restaurer à partir d’ici, il faut les remettre à la main.',
  'Fuori supporto ({n})':
    'Hors support ({n})',
  '(ultima: {versione})':
    '(dernière : {versione})',
  'Asset segnalati ({n})':
    'Actifs signalés ({n})',
  '(facoltativo)':
    '(facultatif)',
  '(stato: {stato}).':
    '(état : {stato}).',
  '+{n} negli ultimi 7 giorni':
    '+{n} au cours des 7 derniers jours',
  '+{n} senza indirizzo':
    '+{n} sans adresse',
  '0':
    '0',
  '0 = mai.':
    '0 = jamais.',
  '0 = nessuna soglia.':
    '0 = aucun seuil.',
  '0 = nessuna soglia. 5120 = 5 KB.':
    '0 = aucun seuil. 5120 = 5 Ko.',
  '0 = senza scadenza. Con la scadenza il caso peggiore è un inventario che manca — e si vede — invece di un permesso che sopravvive alla macchina.':
    '0 = sans expiration. Avec une expiration, le pire des cas est un inventaire manquant — et cela se voit — plutôt qu’une autorisation qui survit à la machine.',
  '0 nodi corrispondono a «{q}» — potrebbero essere nascosti da un filtro.':
    '0 nœud ne correspond à « {q} » — ils sont peut-être masqués par un filtre.',
  '1 pacchetto su {n}':
    '1 paquet sur {n}',
  '1 su 10 (predefinito)':
    '1 sur 10 (par défaut)',
  '1 su {n}':
    '1 sur {n}',
  '1. Collegamento':
    '1. Connexion',
  '12:34:ab:cd:…':
    '12:34:ab:cd:…',
  '2 salti':
    '2 sauts',
  '2. Cosa contiene il sistema di destinazione':
    '2. Ce que contient le système cible',
  '2055 è la più diffusa. NetFlow v9 di Cisco usa spesso 9995 o 9996, IPFIX 4739, sFlow 6343. Deve corrispondere a dove gli apparati esportano già.':
    '2055 est le plus répandu. NetFlow v9 de Cisco utilise souvent 9995 ou 9996, IPFIX 4739, sFlow 6343. Il doit correspondre à la destination vers laquelle les équipements exportent déjà.',
  '24 ore':
    '24 heures',
  '3. Mappature, direzione e frequenza':
    '3. Mappages, sens et fréquence',
  '4. Cosa è successo':
    '4. Ce qui s’est passé',
  '5986':
    '5986',
  '6 ore':
    '6 heures',
  '8088':
    '8088',
  'A rotazione':
    'À tour de rôle',
  'A turno, senza guardare il carico.':
    'À tour de rôle, sans tenir compte de la charge.',
  'AB:12:CD:34:…':
    'AB:12:CD:34:…',
  'ABCDEFGHIJKLMNOPQRST':
    'ABCDEFGHIJKLMNOPQRST',
  'Abilitazione…':
    'Activation…',
  'Access key ID':
    'Access key ID',
  'AccessKey ID':
    'AccessKey ID',
  'AccessKey Secret':
    'AccessKey Secret',
  'Adiacenze fisiche annunciate da CDP e LLDP':
    'Adjacences physiques annoncées par CDP et LLDP',
  'Aggiorna le sonde indietro':
    'Mettre à jour les sondes en retard',
  'Aggiorna l’agente da sé':
    'Mise à jour automatique de l’agent',
  'Alcuni CI hanno una classe non prevista dal catalogo: {classi}. È il segnale che un connettore produce qualcosa di nuovo.':
    'Certains CI ont une classe absente du catalogue : {classi}. C’est le signe qu’un connecteur produit quelque chose de nouveau.',
  'Alcuni provider lo richiedono, altri no.':
    'Certains fournisseurs l’exigent, d’autres non.',
  'Allegato: asset non conformi ({n})':
    'Pièce jointe : actifs non conformes ({n})',
  'Alleggerisci ingest':
    'Alléger l’ingestion',
  'Altri {n} eventi non sono mostrati: questo elenco è parziale.':
    '{n} autres événements ne sont pas affichés : cette liste est partielle.',
  'Ambiti predefiniti — subnet, intervalli o indirizzi, uno per riga':
    'Périmètres par défaut — sous-réseaux, plages ou adresses, un par ligne',
  'Andamento del traffico complessivo':
    'Évolution du trafic global',
  'Andamento della conversazione':
    'Évolution de la conversation',
  'Apparati ({n})':
    'Équipements ({n})',
  'Apri il registro dei contratti →':
    'Ouvrir le registre des contrats →',
  'Arruola nuova sonda':
    'Enrôler une nouvelle sonde',
  'Avrebbe dovuto rileggerla entro un minuto: se non cambia, la sonda non sta più riuscendo a interrogare il Control Plane.':
    'Elle aurait dû la relire dans la minute : si rien ne change, la sonde ne parvient plus à interroger le Control Plane.',
  'Avvia discovery e consulta i dati':
    'Lancer la découverte et consulter les données',
  'Avviate {n} sonde ({elenco}).':
    '{n} sondes lancées ({elenco}).',
  'Avviate {n} sonde ({elenco}). Altre {coda} in coda: partiranno man mano che queste tornano con la versione nuova.':
    '{n} sondes lancées ({elenco}). {coda} autres en file d’attente : elles partiront au fur et à mesure que celles-ci reviennent avec la nouvelle version.',
  'Avvistamenti ({n})':
    'Signalements ({n})',
  'Basta superarne una: «20 pacchetti o 5 KB» descrive due modi di essere interessante, non due condizioni insieme. In AND si butterebbero via proprio le conversazioni grosse e brevi — pochi pacchetti, molti byte, cioè un trasferimento. Con entrambe a zero non si scarta nulla.':
    'Il suffit d’en dépasser un : « 20 paquets ou 5 Ko » décrit deux façons d’être intéressant, pas deux conditions cumulées. En ET, on jetterait justement les conversations volumineuses et brèves — peu de paquets, beaucoup d’octets, c’est-à-dire un transfert. Avec les deux à zéro, rien n’est écarté.',
  'Bilanciato':
    'Équilibré',
  'Bloccata da una regola di sicurezza.':
    'Bloquée par une règle de sécurité.',
  'Build della console: {sha}':
    'Build de la console : {sha}',
  'CENSO → destinazione':
    'CENSO → cible',
  'Cambia':
    'Modifier',
  'Cambia il significato della scadenza: con il rinnovo automatico quella data è l’ultimo giorno per disdire, non quello in cui si resta scoperti.':
    'Change le sens de l’échéance : avec le renouvellement automatique, cette date est le dernier jour pour résilier, pas celui où l’on se retrouve sans couverture.',
  'Cambiare i campi, la chiave o l’oggetto azzera la prova a vuoto e la pianificazione: la prova è ciò che autorizza a scrivere, e vale per la mappatura che è stata provata — non per quella che diventa dopo.':
    'Modifier les champs, la clé ou l’objet réinitialise l’essai à blanc et la planification : l’essai est ce qui autorise l’écriture, et il vaut pour le mappage qui a été testé — pas pour ce qu’il devient ensuite.',
  'Campionamento':
    'Échantillonnage',
  'Capability abilitate all’arruolamento:':
    'Capacités activées à l’enrôlement :',
  'Centra su {nome}':
    'Centrer sur {nome}',
  'Cerca «{q}» in tutta la topologia':
    'Rechercher « {q} » dans toute la topologie',
  'Cerco…':
    'Recherche…',
  'Chiave proposta: {motivo}':
    'Clé proposée : {motivo}',
  'Chiedi e installa':
    'Demander et installer',
  'Chiusa in fase di decrypt SSL: validazione del certificato non riuscita.':
    'Fermée pendant le déchiffrement SSL : échec de la validation du certificat.',
  'Chiusa per esaurimento di risorse sul firewall.':
    'Fermée par épuisement des ressources sur le pare-feu.',
  'Chiusa per un errore durante il decrypt SSL.':
    'Fermée à cause d’une erreur pendant le déchiffrement SSL.',
  'Chiusa perché è stata rilevata una minaccia.':
    'Fermée car une menace a été détectée.',
  'Chiusura regolare TCP: entrambe le parti hanno terminato con un FIN.':
    'Fermeture TCP normale : les deux parties ont terminé par un FIN.',
  'Clicca per nasconderlo':
    'Cliquez pour le masquer',
  'Collega':
    'Relier',
  'Collegamenti di {nome}':
    'Liens de {nome}',
  'Componenti ({n})':
    'Composants ({n})',
  'Comunicazioni osservate sul filo o via NetFlow':
    'Communications observées sur le réseau ou via NetFlow',
  'Configuration Item ({n})':
    'Configuration Items ({n})',
  'Consegna rifiutata':
    'Livraison refusée',
  'Contratti ({n})':
    'Contrats ({n})',
  'Control Plane non raggiungibile':
    'Control Plane injoignable',
  'Conversazioni ({n})':
    'Conversations ({n})',
  'Conviene che dica dove guardano queste sonde: è la cosa che si deve sapere quando si sceglie un gruppo per una scansione.':
    'Il vaut mieux indiquer où regardent ces sondes : c’est ce qu’il faut savoir au moment de choisir un groupe pour une analyse.',
  'Copia il binario censo-inventory sulla macchina, e questo file in /etc/censo/inventory.json con permessi 600. Se non c’è rete in uscita affatto, l’agente scrive la busta su file con -out: è sigillata, quindi può viaggiare su una chiavetta.':
    'Copiez le binaire censo-inventory sur la machine, et ce fichier dans /etc/censo/inventory.json avec les permissions 600. S’il n’y a aucun accès réseau sortant, l’agent écrit l’enveloppe dans un fichier avec -out : elle est scellée, elle peut donc voyager sur une clé USB.',
  'Copia l’indirizzo di ritorno':
    'Copier l’adresse de retour',
  'Copiati nel job: resta il verbale di ciò che è stato guardato oggi.':
    'Copiés dans le job : il reste le procès-verbal de ce qui a été examiné aujourd’hui.',
  'Corrisponde se…':
    'Correspond si…',
  'Crea business service':
    'Créer un service métier',
  'Crea connettore':
    'Créer un connecteur',
  'Crea credenziale':
    'Créer un identifiant',
  'Crea e genera la configurazione':
    'Créer et générer la configuration',
  'Crea gruppo':
    'Créer un groupe',
  'Crea il piano':
    'Créer le plan',
  'Crea pianificazione':
    'Créer une planification',
  'C’è già. Lascialo vuoto per non cambiarlo.':
    'Déjà défini. Laissez vide pour ne pas le modifier.',
  'Da qui si leggono da soli gli indirizzi del provider — non serve copiarli. Viene verificato al salvataggio: se non risponde, non si salva.':
    'Les adresses du fournisseur sont lues automatiquement à partir d’ici — inutile de les copier. C’est vérifié à l’enregistrement : s’il ne répond pas, rien n’est enregistré.',
  'Da riconoscere ({n})':
    'À identifier ({n})',
  'Da usare solo per una registrazione sbagliata. Un bene venduto o rottamato va messo in stato «alienato»: la storia di cosa si è posseduto e per quanto serve all’inventario e a chi lo verifica.':
    'À utiliser uniquement pour un enregistrement erroné. Un bien vendu ou mis au rebut doit passer à l’état « cédé » : l’historique de ce qu’on a possédé et pendant combien de temps sert à l’inventaire et à qui le vérifie.',
  'Dedotto dalla descrizione di sistema o dai bit di sysServices':
    'Déduit de la description système ou des bits sysServices',
  'Degradate':
    'Dégradées',
  'Deve corrispondere esattamente, anche nello slash finale: uno diverso fa fallire l’accesso con «redirect_uri mismatch». Poi torna qui con issuer, client ID e client secret.':
    'Elle doit correspondre exactement, y compris la barre oblique finale : une valeur différente fait échouer la connexion avec « redirect_uri mismatch ». Revenez ensuite ici avec l’issuer, le client ID et le client secret.',
  'Deve essere un numero fra 1 e 65535.':
    'Doit être un nombre entre 1 et 65535.',
  'Di norma significa che l’orologio di questa macchina è indietro rispetto a chi lo ha emesso.':
    'Cela signifie généralement que l’horloge de cette machine est en retard sur celle de l’émetteur.',
  'Di {totale} tipi dichiarati dal sistema sono elencati i {n} che CENSO sa riempire: per questi la mappatura arriva proposta e verificata. Gli altri esistono ancora — se ti serve un tipo personalizzato, scrivine il nome a mano nella mappatura.':
    'Sur les {totale} types déclarés par le système, les {n} que CENSO sait remplir sont listés : pour ceux-ci, le mappage est proposé et vérifié. Les autres existent toujours — si vous avez besoin d’un type personnalisé, saisissez son nom à la main dans le mappage.',
  'Dice dove cercare, e funziona anche la prima volta: è l’unico tipo utile quando in CMDB non c’è ancora niente.':
    'Il indique où chercher, et il fonctionne dès la première fois : c’est le seul type utile quand la CMDB est encore vide.',
  'Dice quali macchine già note riguardare — «quelle con la 22 aperta», «quelle che si chiamano SRV-*». Non può decidere la prima scansione: una porta aperta si sa dopo averla guardata.':
    'Il indique quelles machines déjà connues revoir — « celles avec le 22 ouvert », « celles qui s’appellent SRV-* ». Il ne peut pas décider de la première analyse : on ne sait qu’un port est ouvert qu’après l’avoir examiné.',
  'Dichiarata dalla sonda ma non a catalogo: la sonda è più recente del Control Plane.':
    'Déclarée par la sonde mais absente du catalogue : la sonde est plus récente que le Control Plane.',
  'Dinamico':
    'Dynamique',
  'Disabilita':
    'Désactiver',
  'Disattivato':
    'Désactivé',
  'Discovery di rete':
    'Découverte réseau',
  'Dopo il':
    'Après le',
  'Dopo una consegna riuscita, se il Control Plane distribuisce una versione più recente. Il binario scaricato viene eseguito prima di essere installato, e il precedente resta accanto: un aggiornamento difettoso non spegne la macchina. Toglilo dove esistono finestre di manutenzione.':
    'Après une livraison réussie, si le Control Plane distribue une version plus récente. Le binaire téléchargé est exécuté avant d’être installé, et le précédent est conservé à côté : une mise à jour défectueuse n’arrête pas la machine. Désactivez-la là où existent des fenêtres de maintenance.',
  'Dove gira una VM, su quale storage vive, a quale cluster appartiene':
    'Où tourne une VM, sur quel stockage elle réside, à quel cluster elle appartient',
  'Elimina la vista {nome}':
    'Supprimer la vue {nome}',
  'Eliminare il pool «{nome}»?':
    'Supprimer le pool « {nome} » ?',
  'Eliminare il servizio «{nome}»?':
    'Supprimer le service « {nome} » ?',
  'Eliminare la registrazione di {tag}?':
    'Supprimer l’enregistrement de {tag} ?',
  'Eliminare l’agente «{nome}»?\n\nSparisce anche la sua storia: quante consegne ha fatto e quando ha parlato l’ultima volta. Per fermarlo senza perderla, usa Revoca.':
    'Supprimer l’agent « {nome} » ?\n\nSon historique disparaît aussi : combien de livraisons il a effectuées et quand il s’est manifesté pour la dernière fois. Pour l’arrêter sans le perdre, utilisez Révoquer.',
  'Eliminare «{nome}»?':
    'Supprimer « {nome} » ?',
  'Eliminare «{nome}»? Le {n} sonde restano arruolate e tornano assegnabili a qualunque discovery del tenant. Le pianificazioni che nominavano il gruppo perdono il vincolo.':
    'Supprimer « {nome} » ? Les {n} sondes restent enrôlées et redeviennent attribuables à n’importe quelle découverte du tenant. Les planifications qui citaient le groupe perdent cette contrainte.',
  'Entrambe':
    'Les deux',
  'Errore {stato}':
    'Erreur {stato}',
  'Errore {stato}: {dettaglio}':
    'Erreur {stato} : {dettaglio}',
  'Esegui un giro adesso':
    'Lancer un cycle maintenant',
  'Espressione cron personalizzata':
    'Expression cron personnalisée',
  'Evidenzia questo collegamento sulla mappa e portacisi sopra':
    'Mettre en évidence ce lien sur la carte et s’y rendre',
  'External ID':
    'External ID',
  'Fai prima una prova a vuoto: mostra cosa verrebbe scritto, e nessuna scrittura si annulla':
    'Faites d’abord un essai à blanc : il montre ce qui serait écrit, et aucune écriture ne s’annule',
  'Failover':
    'Basculement',
  'Filtrato su {sorgente} → {destinazione} ({servizio}/{protocollo}).':
    'Filtré sur {sorgente} → {destinazione} ({servizio}/{protocollo}).',
  'Filtri e ordinamento agiscono sui {n} servizi caricati per questa finestra, ordinati dal server per numero di mittenti.':
    'Les filtres et le tri s’appliquent aux {n} services chargés pour cette fenêtre, classés par le serveur selon le nombre d’émetteurs.',
  'Filtri e ordinamento agiscono sulle {n} conversazioni caricate per questa finestra, che il server sceglie per volume.':
    'Les filtres et le tri s’appliquent aux {n} conversations chargées pour cette fenêtre, que le serveur sélectionne par volume.',
  'Finché tace non riceve nemmeno la configurazione, quindi la cattura non può partire e quello che si vede qui non è aggiornato. Verifica che il processo sia in esecuzione e che raggiunga il Control Plane.':
    'Tant qu’elle reste muette, elle ne reçoit même pas la configuration : la capture ne peut donc pas démarrer et ce que vous voyez ici n’est pas à jour. Vérifiez que le processus est en cours d’exécution et qu’il atteint le Control Plane.',
  'Flussi ricevuti':
    'Flux reçus',
  'Formati: subnet {subnet} (fino a /16), indirizzo singolo {indirizzo}, intervallo {intervallo}. Solo IPv4, come la scansione di rete.':
    'Formats : sous-réseau {subnet} (jusqu’à /16), adresse unique {indirizzo}, plage {intervallo}. IPv4 uniquement, comme l’analyse réseau.',
  'Funzionale':
    'Fonctionnel',
  'Genera token di arruolamento':
    'Générer un jeton d’enrôlement',
  'Generazione…':
    'Génération…',
  'Gestisce utenti, credenziali e sonde':
    'Gère les utilisateurs, les identifiants et les sondes',
  'Gli ambiti vengono copiati nel job: resta il verbale di ciò che è stato guardato oggi.':
    'Les périmètres sont copiés dans le job : il reste le procès-verbal de ce qui a été examiné aujourd’hui.',
  'Gli indirizzi dei clienti nascono qui sotto: {esempio} diventa {indirizzo}. Serve un record DNS wildcard e un certificato per {wildcard}.':
    'Les adresses des clients sont créées ici : {esempio} devient {indirizzo}. Il faut un enregistrement DNS wildcard et un certificat pour {wildcard}.',
  'Gli utenti restano: sono abilitati per invito, e il provider diceva solo chi fossero. Chi ha una password continua a entrare; chi non ce l’ha dovrà farsene dare una.':
    'Les utilisateurs restent : ils sont activés sur invitation, et le fournisseur ne faisait que dire qui ils étaient. Ceux qui ont un mot de passe continuent à se connecter ; ceux qui n’en ont pas devront s’en faire attribuer un.',
  'Gratuito e automatico, senza credenziali del DNS. Serve che la porta 80 sia raggiungibile da internet: l’autorità ci manda una richiesta per verificare che il dominio sia davvero tuo.':
    'Gratuit et automatique, sans identifiants DNS. Le port 80 doit être joignable depuis Internet : l’autorité envoie une requête pour vérifier que le domaine vous appartient bien.',
  'Gruppi ({n})':
    'Groupes ({n})',
  'Ha consegnato, e l’ultima consegna è andata a buon fine.':
    'Il a livré, et la dernière livraison a réussi.',
  'Ha parlato e non è stato accettato. Il motivo è qui sotto: è un guasto diverso dal silenzio.':
    'Il s’est manifesté et n’a pas été accepté. La raison est ci-dessous : c’est une panne différente du silence.',
  'Hash costante':
    'Hachage constant',
  'Host ({n})':
    'Hôtes ({n})',
  'Huawei OceanStor (DeviceManager)':
    'Huawei OceanStor (DeviceManager)',
  'I campi {campi} partono vuoti: i segreti non sono leggibili. Lasciandoli vuoti restano quelli salvati; si cambiano solo scrivendoci sopra.':
    'Les champs {campi} sont vides au départ : les secrets ne sont pas lisibles. Laissés vides, ils conservent les valeurs enregistrées ; ils ne changent que si vous les ressaisissez.',
  'I job si distribuiscono fra tutte le sonde del gruppo.':
    'Les jobs sont répartis entre toutes les sondes du groupe.',
  'I passi vengono copiati nel job: il piano è il modello, il job è il verbale di ciò che è stato fatto. Le credenziali stanno sui singoli passi del piano. {link}.':
    'Les étapes sont copiées dans le job : le plan est le modèle, le job est le procès-verbal de ce qui a été fait. Les identifiants se trouvent sur les étapes individuelles du plan. {link}.',
  'I primi {n} sono i tipi che CENSO sa già riempire: per questi la mappatura arriva proposta e verificata.':
    'Les {n} premiers sont les types que CENSO sait déjà remplir : pour ceux-ci, le mappage est proposé et vérifié.',
  'I punti più vicini al centro sono quelli da riconoscere: è dove va l’occhio per primo. Il quadro mostra fino a 300 CI.':
    'Les points les plus proches du centre sont ceux à identifier : c’est là que l’œil se pose en premier. Le graphique affiche jusqu’à 300 CI.',
  'I tipi di oggetto sono ciò che si crea e si aggiorna: un oggetto è composto da più definizioni di dato, e i suoi campi si indirizzano come {forma}.':
    'Les types d’objet sont ce qui est créé et mis à jour : un objet est composé de plusieurs définitions de données, et ses champs s’adressent sous la forme {forma}.',
  'I volumi del traffico restano corretti, ma senza attribuzione: il traffico di un asset inventariato compare come traffico verso un indirizzo sconosciuto. Sembra una CMDB incompleta, e non lo è.':
    'Les volumes de trafic restent corrects, mais sans attribution : le trafic d’un actif inventorié apparaît comme du trafic vers une adresse inconnue. Cela ressemble à une CMDB incomplète, et ce n’en est pas une.',
  'I volumi vengono riportati in scala, quindi restano confrontabili — a differenza dei pacchetti che il kernel scarta, dove il fattore non si conosce. Su reti tranquille scendi a 1.':
    'Les volumes sont remis à l’échelle, ils restent donc comparables — contrairement aux paquets rejetés par le noyau, dont le facteur est inconnu. Sur les réseaux calmes, descendez à 1.',
  'Il Dobermann non è di guardia: dichiara le subnet da proteggere nella sua pagina.':
    'Le Dobermann n’est pas de garde : déclarez les sous-réseaux à protéger sur sa page.',
  'Il bilanciatore lo serve da adesso, senza riavvio: nessuna connessione è caduta, comprese quelle delle sonde.':
    'L’équilibreur de charge le sert dès maintenant, sans redémarrage : aucune connexion n’a été coupée, y compris celles des sondes.',
  'Il campo {campi} parte vuoto: i segreti non sono leggibili. Lasciandolo vuoto resta quello salvato; si cambia solo scrivendoci sopra.':
    'Le champ {campi} est vide au départ : les secrets ne sont pas lisibles. Laissé vide, il conserve la valeur enregistrée ; il ne change que si vous le ressaisissez.',
  'Il certificato scade fra {n} giorni. Un wildcard scaduto rende inaccessibili tutti i clienti nello stesso istante.':
    'Le certificat expire dans {n} jours. Un wildcard expiré rend tous les clients inaccessibles au même instant.',
  'Il client ha inviato un reset (RST): sessione chiusa dal suo lato.':
    'Le client a envoyé un reset (RST) : session fermée de son côté.',
  'Il comando contiene l’impronta del certificato di questo server, perché il certificato è ancora autofirmato: è una verifica esatta, non un «fidati di chiunque». Sostituendo il certificato con uno vero il comando tornerà a essere un download normale, e le sonde già installate continueranno a funzionare.':
    'La commande contient l’empreinte du certificat de ce serveur, car le certificat est encore auto-signé : c’est une vérification exacte, pas un « faire confiance à n’importe qui ». En remplaçant le certificat par un vrai, la commande redeviendra un téléchargement normal, et les sondes déjà installées continueront de fonctionner.',
  'Il comando contiene l’impronta della chiave pubblica di questo server, perché il certificato è ancora autofirmato: è una verifica esatta, non un «fidati di chiunque». Sostituendo il certificato con uno vero il comando tornerà a essere un download normale, e le sonde già installate continueranno a funzionare.':
    'La commande contient l’empreinte de la clé publique de ce serveur, car le certificat est encore auto-signé : c’est une vérification exacte, pas un « faire confiance à n’importe qui ». En remplaçant le certificat par un vrai, la commande redeviendra un téléchargement normal, et les sondes déjà installées continueront de fonctionner.',
  'Il comando vale un’ora (fino alle {ora}), e contiene il segreto di questo agente: è l’unica volta in cui compare. Passata la finestra si rigenera — ma rigenerare invalida il segreto vecchio, quindi se l’agente era già installato smette di consegnare finché non lo reinstalli.':
    'La commande est valable une heure (jusqu’à {ora}) et contient le secret de cet agent : c’est la seule fois qu’il apparaît. Passé ce délai, on la régénère — mais régénérer invalide l’ancien secret : si l’agent était déjà installé, il cesse de livrer jusqu’à ce que vous le réinstalliez.',
  'Il comando vale un’ora, e contiene il segreto di questo agente: è l’unica volta in cui compare. Passata la finestra si rigenera — ma rigenerare invalida il segreto vecchio, quindi se l’agente era già installato smette di consegnare finché non lo reinstalli.':
    'La commande est valable une heure et contient le secret de cet agent : c’est la seule fois qu’il apparaît. Passé ce délai, on la régénère — mais régénérer invalide l’ancien secret : si l’agent était déjà installé, il cesse de livrer jusqu’à ce que vous le réinstalliez.',
  'Il dizionario è caricato ma vuoto: la CMDB non contiene ancora interfacce né indirizzi di gestione, quindi nessun flusso risulterà attribuito a un configuration item. Non è un guasto dello store — è una discovery che non è ancora passata.':
    'Le dictionnaire est chargé mais vide : la CMDB ne contient encore ni interfaces ni adresses de gestion, aucun flux ne sera donc attribué à un configuration item. Ce n’est pas une panne du store — c’est une découverte qui n’est pas encore passée.',
  'Il piano ha raggiunto il massimo di {n} passi. Oltre quel numero nessuno lo rilegge prima di lanciarlo su una rete di produzione.':
    'Le plan a atteint le maximum de {n} étapes. Au-delà, personne ne le relit avant de le lancer sur un réseau de production.',
  'Il primo del mese all’1:00':
    'Le premier du mois à 1 h 00',
  'Il provider verifica chi è chi entra, non se può entrare: chi si autentica accede solo se il suo indirizzo è già fra gli utenti qui sopra. Collegare l’IdP non apre la console a tutta l’azienda.':
    'Le fournisseur vérifie qui se connecte, pas s’il en a le droit : celui qui s’authentifie n’accède que si son adresse figure déjà parmi les utilisateurs ci-dessus. Relier l’IdP n’ouvre pas la console à toute l’entreprise.',
  'Il segreto non vale più. Rigeneralo e rimetti la configurazione sulla macchina.':
    'Le secret n’est plus valide. Régénérez-le et remettez la configuration sur la machine.',
  'Il server ha inviato un reset (RST): sessione chiusa dal suo lato.':
    'Le serveur a envoyé un reset (RST) : session fermée de son côté.',
  'Il server ne serve una versione più recente, ma il browser sta ancora eseguendo la build {sha}. Quello che vedi può non riflettere lo stato attuale del sistema.':
    'Le serveur en propose une version plus récente, mais le navigateur exécute encore la build {sha}. Ce que vous voyez peut ne pas refléter l’état actuel du système.',
  'Importa comunque le righe valide':
    'Importer quand même les lignes valides',
  'Importati {n} ambiti.':
    '{n} périmètres importés.',
  'In ascolto sulla porta {port} ({indirizzi}).':
    'En écoute sur le port {port} ({indirizzi}).',
  'In corso':
    'En cours',
  'In corso…':
    'En cours…',
  'In entrata':
    'Entrant',
  'In generale è l’indirizzo a cui, aggiungendo {percorso}, si ottiene un documento JSON.':
    'En général, c’est l’adresse à laquelle, en ajoutant {percorso}, on obtient un document JSON.',
  'In linea':
    'En ligne',
  'In tutto {n} indirizzi.':
    '{n} adresses au total.',
  'In uscita':
    'Sortant',
  'Incolla il certificato (con la catena, se ce l’hai: prima il tuo, poi gli intermedi) e la sua chiave privata. La coppia viene verificata prima di essere scritta — una chiave che non corrisponde impedirebbe al bilanciatore di ripartire, e l’installazione resterebbe irraggiungibile, questa pagina compresa.':
    'Collez le certificat (avec la chaîne, si vous l’avez : d’abord le vôtre, puis les intermédiaires) et sa clé privée. La paire est vérifiée avant d’être écrite — une clé qui ne correspond pas empêcherait l’équilibreur de charge de redémarrer, et l’installation deviendrait injoignable, cette page comprise.',
  'Indirizzi IP ({n})':
    'Adresses IP ({n})',
  'identifica gli endpoint di rete in ascolto, con indirizzi, porte e servizi associati.': 'identifie les points d’accès réseau en écoute, avec adresses, ports et services associés.',
  'Installa certificato':
    'Installer le certificat',
  'Installa «{nome}»':
    'Installer « {nome} »',
  'Interfacce di rete ({n})':
    'Interfaces réseau ({n})',
  'JSON non ancora valido':
    'JSON pas encore valide',
  'La capability {nome} è spenta su questa sonda: la cattura non partirà, per quanto si aspetti. Riattivala fra le capability qui sopra.':
    'La capacité {nome} est désactivée sur cette sonde : la capture ne démarrera pas, quel que soit le temps d’attente. Réactivez-la parmi les capacités ci-dessus.',
  'La configurazione ricevuta dalla sonda {tempo} fa non abilita la raccolta di flussi, pur essendo la capability attiva in console. Di norma significa che la licenza del tenant non comprende i flussi: controlla gli entitlement.':
    'La configuration reçue par la sonde il y a {tempo} n’active pas la collecte de flux, bien que la capacité soit active dans la console. Cela signifie généralement que la licence du tenant n’inclut pas les flux : vérifiez les droits.',
  'La discovery verrà eseguita solo da questa sonda. Se non è disponibile resta in attesa e non passa a un’altra: scegliere la sonda è scegliere la rete da cui guardare, e un’altra rete darebbe un inventario vuoto che sembra completo.':
    'La découverte sera exécutée uniquement par cette sonde. Si elle n’est pas disponible, elle reste en attente et ne passe pas à une autre : choisir la sonde, c’est choisir le réseau d’où l’on regarde, et un autre réseau donnerait un inventaire vide qui semble complet.',
  'La freccia è il verso: {sorgente} apre la connessione verso {destinazione}. Le porte qui sotto sono quelle di destinazione.':
    'La flèche indique le sens : {sorgente} ouvre la connexion vers {destinazione}. Les ports ci-dessous sont ceux de destination.',
  'La mappa mostra 1 oggetto che corrisponde a «{q}» e ciò a cui è collegato. Svuota la ricerca per rivedere tutto.':
    'La carte affiche 1 objet correspondant à « {q} » et ce à quoi il est relié. Videz la recherche pour tout revoir.',
  'La mappa mostra {n} oggetti che corrispondono a «{q}» e ciò a cui sono collegati. Svuota la ricerca per rivedere tutto.':
    'La carte affiche {n} objets correspondant à « {q} » et ce à quoi ils sont reliés. Videz la recherche pour tout revoir.',
  'La richiesta è stata bloccata prima di arrivare all’applicazione (Errore {stato}).':
    'La requête a été bloquée avant d’atteindre l’application (Erreur {stato}).',
  'La richiesta è stata bloccata prima di arrivare all’applicazione (WAF). Se l’operazione è legittima, cerca l’id della regola nei log del servizio waf e aggiungi un’eccezione mirata.':
    'La requête a été bloquée avant d’atteindre l’application (WAF). Si l’opération est légitime, cherchez l’identifiant de la règle dans les journaux du service waf et ajoutez une exception ciblée.',
  'La richiesta è stata bloccata prima di arrivare all’applicazione (bilanciatore o WAF): il servizio a valle non ha risposto.':
    'La requête a été bloquée avant d’atteindre l’application (équilibreur de charge ou WAF) : le service en aval n’a pas répondu.',
  'La rilegge ogni minuto: la cattura parte al prossimo giro.':
    'Elle la relit toutes les minutes : la capture démarre au prochain cycle.',
  'La sceglie il Control Plane fra quelle online che dichiarano la capability necessaria. Va bene quando le sonde vedono la stessa rete.':
    'Le Control Plane la choisit parmi les sondes en ligne qui déclarent la capability requise. Convient lorsque les sondes voient le même réseau.',
  'La sonda ha applicato la cattura su {interfaccia} ({tempo} fa) ma non riporta alcuno stato di cattura. È una combinazione che non dovrebbe verificarsi: raccogli i log della sonda («cattura diretta») prima di riavviarla, altrimenti la causa si perde.':
    'La sonde a appliqué la capture sur {interfaccia} (il y a {tempo}) mais ne signale aucun état de capture. Cette combinaison ne devrait pas se produire : récupérez les journaux de la sonde (« capture directe ») avant de la redémarrer, sinon la cause est perdue.',
  'La sonda ha riferito {tempo} fa ma non riporta nulla sulla raccolta di flussi: è una versione precedente alla cattura diretta. Aggiornala — le versioni che sanno catturare riportano questo stato anche quando non stanno catturando.':
    'La sonde s’est manifestée il y a {tempo} mais n’indique rien sur la collecte de flux : c’est une version antérieure à la capture directe. Mettez-la à jour — les versions capables de capturer signalent cet état même lorsqu’elles ne capturent pas.',
  'La sonda ha una configurazione di {tempo} fa che chiede la cattura su {ha}, non su {voluta}.':
    'La sonde a une configuration datant d’il y a {tempo} qui demande la capture sur {ha}, et non sur {voluta}.',
  'La sonda ha una configurazione di {tempo} fa che non chiede alcuna cattura.':
    'La sonde a une configuration datant d’il y a {tempo} qui ne demande aucune capture.',
  'La sonda le prova in ordine e si ferma alla prima che risponde. La sequenza conta: ogni tentativo fallito costa un timeout per ogni apparato, e con SNMPv3 un’autenticazione fallita resta tale — alcuni apparati bloccano l’utenza dopo qualche tentativo.':
    'La sonde les essaie dans l’ordre et s’arrête au premier qui répond. L’ordre compte : chaque tentative échouée coûte un délai d’attente par équipement, et avec SNMPv3 une authentification échouée le reste — certains équipements bloquent le compte après quelques tentatives.',
  'La sonda le prova in ordine e si ferma alla prima che risponde. Su una pianificazione il costo si ripete a ogni esecuzione: una credenziale sbagliata in cima aggiunge un timeout per ogni apparato, ogni notte.':
    'La sonde les essaie dans l’ordre et s’arrête au premier qui répond. Sur une planification, le coût se répète à chaque exécution : un identifiant erroné en tête ajoute un délai d’attente par équipement, chaque nuit.',
  'La sonda non si fa sentire da {tempo}.':
    'La sonde ne s’est pas manifestée depuis {tempo}.',
  'La sonda parla col Control Plane solo in uscita, su 443: non aprire niente in ingresso.':
    'La sonde communique avec le Control Plane uniquement en sortie, sur le 443 : n’ouvrez rien en entrée.',
  'La sonda prova le credenziali in ordine e si ferma alla prima che risponde. Serve quando gli apparati non hanno tutti la stessa community o lo stesso utente — tipicamente dopo una migrazione, o fra sedi acquisite in momenti diversi.':
    'La sonde essaie les identifiants dans l’ordre et s’arrête au premier qui répond. Utile lorsque les équipements n’ont pas tous la même communauté ou le même utilisateur — typiquement après une migration, ou entre des sites acquis à des moments différents.',
  'La sonda è avviata con {variabile}, ma le capability effettive sono {effettive}. Vale quest’ultima: la variabile imposta solo la politica iniziale all’arruolamento, così una scelta fatta da qui non viene riscritta dal prossimo heartbeat. Puoi rimuoverla dalla riga di comando della sonda senza cambiare nulla.':
    'La sonde est lancée avec {variabile}, mais les capabilities effectives sont {effettive}. C’est cette dernière qui s’applique : la variable ne fixe que la politique initiale à l’enrôlement, ainsi un choix fait ici n’est pas réécrit par le prochain heartbeat. Vous pouvez la retirer de la ligne de commande de la sonde sans rien changer.',
  'La stessa coppia porta/indirizzi è stata riusata per una nuova sessione.':
    'La même paire port/adresses a été réutilisée pour une nouvelle session.',
  'Lascia quelle attuali':
    'Conserver les actuels',
  'Le capability abilitate qui possono solo restringere ciò che la sonda dichiara di saper fare: non aggiungono funzioni che il suo binario non ha.':
    'Les capabilities activées ici ne peuvent que restreindre ce que la sonde déclare savoir faire : elles n’ajoutent pas de fonctions absentes de son binaire.',
  'Le capability {elenco} sono abilitate ma il binario della sonda non le implementa: aggiorna la sonda o avviala senza CENSO_CAPABILITIES che le esclude.':
    'Les capabilities {elenco} sont activées mais le binaire de la sonde ne les implémente pas : mettez à jour la sonde ou lancez-la sans la variable CENSO_CAPABILITIES qui les exclut.',
  'Le chiamate escono da una sonda che non esiste più — riassegnala qui sotto, altrimenti non parte niente.':
    'Les appels partent d’une sonde qui n’existe plus — réaffectez-la ci-dessous, sinon rien ne part.',
  'Le chiamate escono da {sonda}.':
    'Les appels partent de {sonda}.',
  'Le macchine che nessuna sonda raggiunge raccolgono il proprio inventario e lo consegnano da sé. Quelle che nemmeno raggiungono il Control Plane — una DMZ senza uscita — possono consegnarlo a questa sonda, che lo inoltra senza aprirlo: il carico è sigillato.':
    'Les machines qu’aucune sonde n’atteint collectent leur propre inventaire et le livrent elles-mêmes. Celles qui n’atteignent même pas le Control Plane — une DMZ sans sortie — peuvent le livrer à cette sonde, qui le transmet sans l’ouvrir : le contenu est scellé.',
  'L’aggiornamento potrebbe non iniziare subito. Le sonde verificano periodicamente la disponibilità della nuova versione. Se l’aggiornamento impedisce alla sonda di ripartire correttamente, viene ripristinata automaticamente la versione precedente.': 'La mise à jour peut ne pas démarrer immédiatement. Les sondes vérifient périodiquement la disponibilité de la nouvelle version. Si la mise à jour empêche la sonde de redémarrer correctement, la version précédente est restaurée automatiquement.',
  'Legge gli indirizzi fisici imparati dalle porte dello switch e li correla con i CI già in inventario. Vede anche ciò che non parla CDP/LLDP — stampanti, PC, macchine virtuali. Le porte con troppi indirizzi sono dorsali e vengono escluse: «raggiungibile attraverso» non è «attaccato a».':
    'Lit les adresses physiques apprises par les ports du commutateur et les met en corrélation avec les CI déjà inventoriés. Voit aussi ce qui ne parle pas CDP/LLDP — imprimantes, PC, machines virtuelles. Les ports avec trop d’adresses sont des dorsales et sont exclus : « joignable à travers » n’est pas « raccordé à ».',
  'Letti da {colonna} su un campione di {n} record (ce ne sono altri): l’elenco dice quali tipi esistono, non quanti oggetti hanno.':
    'Lus depuis {colonna} sur un échantillon de {n} enregistrements (il y en a d’autres) : la liste indique quels types existent, pas combien d’objets ils comptent.',
  'Letti da {colonna} su un campione di {n} record: l’elenco dice quali tipi esistono, non quanti oggetti hanno.':
    'Lus depuis {colonna} sur un échantillon de {n} enregistrements : la liste indique quels types existent, pas combien d’objets ils comptent.',
  'Libera {n} nodi fissati':
    'Libérer {n} nœuds épinglés',
  'Limita le capability':
    'Limiter les capabilities',
  'Limita le capability di questa sonda':
    'Limiter les capabilities de cette sonde',
  'Lo stesso ambito finisce sempre sulla stessa sonda: utile per confronti nel tempo.':
    'Le même périmètre aboutit toujours sur la même sonde : utile pour les comparaisons dans le temps.',
  'Lo stesso documento che la sonda produce entrando via SSH o WinRM, così i due inventari della stessa macchina si riconciliano invece di affiancarsi.':
    'Le même document que la sonde produit en se connectant via SSH ou WinRM, ainsi les deux inventaires de la même machine se réconcilient au lieu de se juxtaposer.',
  'L’elenco dei prodotti interroga il gestore di pacchetti o il registro: secondi, non millisecondi.':
    'La liste des produits interroge le gestionnaire de paquets ou le registre : des secondes, pas des millisecondes.',
  'Mai consegnato':
    'Jamais livré',
  'Massimo {n}':
    'Maximum {n}',
  'Meno carica':
    'La moins chargée',
  'Microsoft SQL Server':
    'Microsoft SQL Server',
  'Mittenti':
    'Émetteurs',
  'Modifica «{nome}»':
    'Modifier « {nome} »',
  'Mostra anche il traffico di ritorno':
    'Afficher aussi le trafic de retour',
  'Mostra anche le {n} porte spente e senza descrizione':
    'Afficher aussi les {n} ports éteints et sans description',
  'MySQL / MariaDB':
    'MySQL / MariaDB',
  'Nasce spenta: il passo successivo è la prova a vuoto, che calcola tutto e non scrive niente.':
    'Elle naît désactivée : l’étape suivante est l’essai à blanc, qui calcule tout et n’écrit rien.',
  'Nascosto: clicca per rimetterlo':
    'Masqué : cliquez pour le rétablir',
  'Nella scena ne nuotano {n}: gli altri {nascosti} ci sono, ma disegnarli tutti farebbe muovere l’immagine a scatti. I nuovi non vengono mai nascosti per primi.':
    '{n} nagent dans la scène : les {nascosti} autres sont là, mais les dessiner tous rendrait l’image saccadée. Les nouveaux ne sont jamais masqués en premier.',
  'Nessun CI. Avvia una discovery per popolare la CMDB.':
    'Aucun CI. Lancez une découverte pour alimenter la CMDB.',
  'Nessun cambiamento: le regole attuali danno lo stesso esito di prima.':
    'Aucun changement : les règles actuelles donnent le même résultat qu’auparavant.',
  'Nessun certificato leggibile da qui.':
    'Aucun certificat lisible d’ici.',
  'Nessun cliente può accedere: ogni browser rifiuta la connessione prima ancora di mostrare la pagina.':
    'Aucun client ne peut accéder : chaque navigateur refuse la connexion avant même d’afficher la page.',
  'Nessun contratto valido copre questo bene oggi. Se dovrebbe essere coperto, verifica dal registro dei contratti: un contratto cessato, o una copertura con data di fine passata, non conta.':
    'Aucun contrat valide ne couvre ce bien aujourd’hui. S’il devrait être couvert, vérifiez dans le registre des contrats : un contrat résilié, ou une couverture dont la date de fin est passée, ne compte pas.',
  'Nessun dato da mostrare.':
    'Aucune donnée à afficher.',
  'Nessun dato nel periodo.':
    'Aucune donnée sur la période.',
  'Nessun flusso da {n} pacchetti: sull’interfaccia arriva traffico ma non è IP. Verifica che la porta mirror stia replicando le VLAN giuste.':
    'Aucun flux sur {n} paquets : du trafic arrive sur l’interface mais ce n’est pas de l’IP. Vérifiez que le port miroir réplique les bons VLAN.',
  'Nessun piano. Una discovery di rete è la sequenza di passi che qualcuno ha disegnato — ping, DNS, porte, SNMP, SSH, Windows — e senza non c’è niente da eseguire. {link}.':
    'Aucun plan. Une découverte réseau est la séquence d’étapes que quelqu’un a conçue — ping, DNS, ports, SNMP, SSH, Windows — et sans elle il n’y a rien à exécuter. {link}.',
  'Nessun pool ancora. {link}: le reti si scrivono una volta e le richiamano tutte le scansioni.':
    'Aucun pool pour l’instant. {link} : les réseaux s’écrivent une fois et toutes les analyses les réutilisent.',
  'Nessun pool. {link} per scrivere gli ambiti una volta sola.':
    'Aucun pool. {link} pour écrire les périmètres une seule fois.',
  'Nessuna capability abilitata: si arruolerà e resterà ferma finché non ne abiliti almeno una dalla sua scheda.':
    'Aucune capability activée : elle s’enrôlera et restera inactive tant que vous n’en activez pas au moins une depuis sa fiche.',
  'Nessuna corrispondenza fra i collegamenti caricati, che sono solo una parte.':
    'Aucune correspondance parmi les liens chargés, qui ne sont qu’une partie.',
  'Nessuna corrispondenza fra i collegamenti caricati.':
    'Aucune correspondance parmi les liens chargés.',
  'Nessuna credenziale da scegliere qui: questo tipo di discovery usa quelle dichiarate sui singoli passi del piano, perché ne servono di tipi diversi — SNMP per gli apparati, SSH per i server Unix, Windows per gli altri — e un elenco unico non saprebbe quale dare a chi.':
    'Aucun identifiant à choisir ici : ce type de découverte utilise ceux déclarés sur chaque étape du plan, car il en faut de différents types — SNMP pour les équipements, SSH pour les serveurs Unix, Windows pour les autres — et une liste unique ne saurait pas lequel donner à qui.',
  'Nessuna credenziale di tipo {tipi}.':
    'Aucun identifiant de type {tipi}.',
  'Nessuna credenziale di tipo {tipi}: creala nella sezione Credenziali.':
    'Aucun identifiant de type {tipi} : créez-le dans la section Identifiants.',
  'Nessuna partizione pronta per il dettaglio: il prossimo batch di flussi fallirà. Le crea la manutenzione periodica, e l’ingest ne crea una al volo — se restano zero, la manutenzione non sta girando.':
    'Aucune partition prête pour le détail : le prochain lot de flux échouera. Elles sont créées par la maintenance périodique, et l’ingestion en crée une à la volée — si elles restent à zéro, la maintenance ne tourne pas.',
  'Nessuna regola ha riconosciuto questo CI':
    'Aucune règle n’a reconnu ce CI',
  'Nessuna sonda avviata: ce ne sono già {n} in aggiornamento. Il lotto successivo parte quando queste tornano.':
    'Aucune sonde lancée : {n} sont déjà en cours de mise à jour. Le lot suivant démarre quand elles reviennent.',
  'Nessuna sonda da aggiornare.':
    'Aucune sonde à mettre à jour.',
  'Nessuna sonda online ha la capability {capability} abilitata: il job resterebbe in attesa. Verifica la scheda della sonda.':
    'Aucune sonde en ligne n’a la capability {capability} activée : le job resterait en attente. Vérifiez la fiche de la sonde.',
  'Niente da mostrare.':
    'Rien à afficher.',
  'Non applicabile: sessione ancora aperta o protocollo senza stato (UDP/ICMP).':
    'Non applicable : session encore ouverte ou protocole sans état (UDP/ICMP).',
  'Non concede l’accesso — quello resta l’invito — ma propone un ruolo quando abiliti un’utenza che il provider conosce già.':
    'Il n’accorde pas l’accès — cela reste l’invitation — mais propose un rôle lorsque vous activez un utilisateur que le fournisseur connaît déjà.',
  'Non in ascolto.':
    'Pas en écoute.',
  'Non raggiungibili':
    'Injoignables',
  'Non si rilegge mai: se lo perdi, ne generi un altro sul provider.':
    'Il ne s’affiche plus jamais : si vous le perdez, générez-en un autre chez le fournisseur.',
  'Per evitare tentativi ripetuti senza esito, dopo due fallimenti il sistema sospende l’aggiornamento. Se una sonda completa l’operazione in seguito, il suo stato viene aggiornato automaticamente.': 'Pour éviter des tentatives répétées sans résultat, après deux échecs le système suspend la mise à jour. Si une sonde termine l’opération plus tard, son état est mis à jour automatiquement.',
  'Non valutabile: {motivo}':
    'Non évaluable : {motivo}',
  'Non verificabile da qui, si vede solo a un accesso vero: {elenco}.':
    'Invérifiable d’ici, visible seulement lors d’une vraie connexion : {elenco}.',
  'Nuova mappatura':
    'Nouveau mapping',
  'Nuova pianificazione':
    'Nouvelle planification',
  'Nuovo business service da {n} ingressi':
    'Nouveau business service à partir de {n} entrées',
  'Nuovo piano di discovery':
    'Nouveau plan de découverte',
  'OPZIONI':
    'OPTIONS',
  'Ogni 15 minuti':
    'Toutes les 15 minutes',
  'Ogni 6 ore':
    'Toutes les 6 heures',
  'Ogni credenziale sbagliata prima di quella giusta costa un timeout per ogni apparato dell’ambito: metti per prima quella che copre più apparati.':
    'Chaque identifiant erroné avant le bon coûte un délai d’attente par équipement du périmètre : placez en premier celui qui couvre le plus d’équipements.',
  'Ogni domenica alle 03:00':
    'Chaque dimanche à 03:00',
  'Ogni domenica alle 3:00':
    'Chaque dimanche à 3:00',
  'Ogni giorno alle 02:00':
    'Chaque jour à 02:00',
  'Ogni notte alle 2:00':
    'Chaque nuit à 2:00',
  'Ogni ora':
    'Toutes les heures',
  'Oracle Database':
    'Oracle Database',
  'Passi ({n} su {max})':
    'Étapes ({n} sur {max})',
  'Per creare in Matrix42 serve il tipo di oggetto, non il frammento: un asset è un oggetto di un tipo, composto da più frammenti. Qui sotto i tipi trovati su questa istanza, da incollare nella configurazione del connettore.':
    'Pour créer dans Matrix42, il faut le type d’objet, pas le fragment : un asset est un objet d’un type, composé de plusieurs fragments. Ci-dessous, les types trouvés sur cette instance, à coller dans la configuration du connecteur.',
  'La {guida} descrive funzioni e sequenza operativa di ogni area. Il tab «Come funziona questa pagina» fornisce indicazioni contestuali.': 'Le {guida} décrit les fonctions et la séquence opérationnelle de chaque zone. L’onglet «Comment fonctionne cette page» fournit des indications contextuelles.',
  'Per riferimento: una subnet aggiunta al pool entra nella scansione della notte successiva.':
    'Pour information : un sous-réseau ajouté au pool entre dans l’analyse de la nuit suivante.',
  'Pianificazione «{nome}» aggiornata.':
    'Planification « {nome} » mise à jour.',
  'Pianificazione «{nome}» creata.':
    'Planification « {nome} » créée.',
  'Pianificazioni «{nome}» e «{backup}» create.':
    'Planifications « {nome} » et « {backup} » créées.',
  'Piano di lavoro ({n})':
    'Plan de travail ({n})',
  'Piano predefinito':
    'Plan par défaut',
  'Piano «{nome}»':
    'Plan « {nome} »',
  'Pool: {nome}':
    'Pool : {nome}',
  'PowerDNS':
    'PowerDNS',
  'Prezzo ({valuta})':
    'Prix ({valuta})',
  'Prima del':
    'Avant le',
  'Prima le attive':
    'Actives d’abord',
  'Prima una prova':
    'D’abord un essai',
  'Primo flusso ricevuto il {data}.':
    'Premier flux reçu le {data}.',
  'Privilegia le sonde in ruolo attivo rispetto alle passive.':
    'Privilégie les sondes en rôle actif par rapport aux passives.',
  'Proponi il mapping':
    'Proposer le mapping',
  'Prova il collegamento':
    'Tester la connexion',
  'Prova la richiesta':
    'Tester la requête',
  'Prova le condizioni':
    'Tester les conditions',
  'Provate in ordine: la sonda si ferma alla prima che risponde. Ogni tentativo fallito costa un timeout per ogni bersaglio.':
    'Essayés dans l’ordre : la sonde s’arrête au premier qui répond. Chaque tentative échouée coûte un délai d’attente par cible.',
  'Può solo consultare':
    'Consultation seule',
  'Qualcuno gli ha tolto il permesso di consegnare.':
    'Quelqu’un lui a retiré l’autorisation de livrer.',
  'Questa sonda non ha ancora inviato un heartbeat.':
    'Cette sonde n’a pas encore envoyé de heartbeat.',
  'Questo certificato non copre {wildcard}: senza wildcard ogni nuovo cliente richiede un certificato nuovo, e finché non c’è il suo indirizzo si apre con un avviso.':
    'Ce certificat ne couvre pas {wildcard} : sans wildcard, chaque nouveau client nécessite un nouveau certificat, et tant qu’il n’existe pas, son adresse s’ouvre avec un avertissement.',
  'Raggruppamento per ruolo o competenza, senza distribuzione.':
    'Regroupement par rôle ou compétence, sans distribution.',
  'Registra contratto':
    'Enregistrer un contrat',
  'Registra un’applicazione web e incolla questo come indirizzo di ritorno (redirect URI, callback URL):':
    'Enregistrez une application web et collez ceci comme adresse de retour (redirect URI, callback URL) :',
  'Registrato ma non ha ancora parlato: la configurazione non è ancora sulla macchina, o l’esecuzione periodica non è stata impostata.':
    'Enregistré mais ne s’est pas encore manifesté : la configuration n’est pas encore sur la machine, ou l’exécution périodique n’a pas été configurée.',
  'Registro dei costruttori non caricato: il produttore si ricava solo per le marche più diffuse. Di norma arriva con l’immagine; se manca, si carica con un pulsante dalla console di amministrazione, in «Piattaforma → Registro dei costruttori». Da lì il produttore c’è per qualunque apparato SNMP, anche di marche mai viste.':
    'Registre des constructeurs non chargé : le fabricant n’est déduit que pour les marques les plus courantes. Il est normalement fourni avec l’image ; s’il manque, il se charge d’un bouton depuis la console d’administration, dans « Plateforme → Registre des constructeurs ». Dès lors, le fabricant est connu pour tout équipement SNMP, même de marques jamais vues.',
  'Regole del prodotto ({n})':
    'Règles du produit ({n})',
  'Restano scritti a mano {ambiti}, e con il pool non vengono inclusi. Torna su «Scrivo io» per usarli.':
    '{ambiti} restent saisis à la main, et ne sont pas inclus avec le pool. Revenez à « Je les saisis » pour les utiliser.',
  'Revoca accesso':
    'Révoquer l’accès',
  'Revocato':
    'Révoqué',
  'Ricevi le consegne su questa sonda':
    'Recevoir les livraisons sur cette sonde',
  'Richiesta in corso…':
    'Requête en cours…',
  'Riclassifica':
    'Reclasser',
  'Riclassificati {n} CI, {invariati} invariati.':
    '{n} CI reclassés, {invariati} inchangés.',
  'Riclassifico…':
    'Reclassement…',
  'Rileva cosa è attaccato a ogni porta':
    'Détecter ce qui est raccordé à chaque port',
  'Rileva i collegamenti tra apparati':
    'Détecter les liaisons entre équipements',
  'Rimuovere la sonda «{nome}»? I CI che ha inventariato restano; le discovery in corso vanno concluse prima.':
    'Supprimer la sonde « {nome} » ? Les CI qu’elle a inventoriés sont conservés ; les discoveries en cours doivent d’abord être terminées.',
  'Rinnovo tacito':
    'Reconduction tacite',
  'Rosso è ciò che la piattaforma non ha ancora riconosciuto — non classificato, non gestito, o comparso nelle ultime 24 ore. La scena legge fino a 300 CI.':
    'Le rouge est ce que la plateforme n’a pas encore reconnu — non classé, non géré, ou apparu au cours des dernières 24 heures. La scène lit jusqu’à 300 CI.',
  'Ruolo e accesso valgono su questo tenant: la stessa utenza può averne altri altrove. L’ultimo amministratore attivo non può essere rimosso o disabilitato, perché il tenant resterebbe senza nessuno in grado di gestirlo.':
    'Le rôle et l’accès valent pour ce tenant : le même utilisateur peut en avoir d’autres ailleurs. Le dernier administrateur actif ne peut pas être supprimé ni désactivé, car le tenant resterait sans personne capable de le gérer.',
  'SNMP v1':
    'SNMP v1',
  'SNMP v2c':
    'SNMP v2c',
  'SNMP v3':
    'SNMP v3',
  'Salva dominio':
    'Enregistrer le domaine',
  'Salva gli ambiti':
    'Enregistrer les périmètres',
  'Salva la mappatura':
    'Enregistrer le mapping',
  'Salva le modifiche':
    'Enregistrer les modifications',
  'Salva sorgenti':
    'Enregistrer les sources',
  'Salva vista':
    'Enregistrer la vue',
  'Salvato: {ambiti} ambiti, {indirizzi} indirizzi.':
    'Enregistré : {ambiti} périmètres, {indirizzi} adresses.',
  'Salvato: {n} apparati corrispondono, {conIndirizzo} con un indirizzo da scansionare.':
    'Enregistré : {n} équipements correspondent, {conIndirizzo} avec une adresse à analyser.',
  'Scade il {quando} ed è per una sonda sola. Finché non è stato usato vale quanto una credenziale: non inoltrarlo su canali che non controlli.':
    'Il expire le {quando} et ne vaut que pour une seule sonde. Tant qu’il n’a pas été utilisé, il vaut un identifiant : ne le transmettez pas par des canaux que vous ne maîtrisez pas.',
  'Scandisci':
    'Analyser',
  'Scansione del {quando}: {n} tipi di oggetto trovati. Rilanciala per rivederne l’elenco.':
    'Analyse du {quando} : {n} types d’objet trouvés. Relancez-la pour revoir la liste.',
  'Scansione…':
    'Analyse…',
  'Scarica il binario, scrive la configurazione, prova a raccogliere e mette l’esecuzione periodica. Quello che stampa dice anche cosa non è riuscito a leggere: senza privilegi mancano numero di serie e modello.':
    'Télécharge le binaire, écrit la configuration, tente une collecte et met en place l’exécution périodique. Ce qu’il affiche indique aussi ce qu’il n’a pas pu lire : sans privilèges, le numéro de série et le modèle manquent.',
  'Scegli {indirizzo} {servizio}':
    'Choisir {indirizzo} {servizio}',
  'Scheda di {nome}':
    'Fiche de {nome}',
  'Scollegare «{nome}»?':
    'Déconnecter « {nome} » ?',
  'Sconosciuto: spesso una sessione ancora attiva o non TCP.':
    'Inconnu : souvent une session encore active ou non TCP.',
  'Se fallisce, prosegui con i passi successivi':
    'En cas d’échec, poursuivre avec les étapes suivantes',
  'Se il tipo che cerchi non è nell’elenco, scrivine il nome: su installazioni personalizzate è la norma.':
    'Si le type que vous cherchez n’est pas dans la liste, saisissez son nom : sur les installations personnalisées, c’est la norme.',
  'Se manca {cap}: in Docker servono {opzione} e la rete dell’host. La ricezione dei flussi esportati non dipende da questo e continua a funzionare.':
    'Si {cap} manque : sous Docker, il faut {opzione} et le réseau de l’hôte. La réception des flux exportés n’en dépend pas et continue de fonctionner.',
  'Secret access key':
    'Secret access key',
  'Segnalato {tempo} fa. La cattura non partirà finché non riesce a leggerla: la configurazione dell’ascolto vive nel cloud, non sulla macchina.':
    'Signalé il y a {tempo}. La capture ne démarrera pas tant qu’elle ne parvient pas à la lire : la configuration de l’écoute vit dans le cloud, pas sur la machine.',
  'Segreto scaduto':
    'Secret expiré',
  'Senza limiti la sonda esegue tutto ciò che dichiara ({elenco}).':
    'Sans limites, la sonde exécute tout ce qu’elle déclare ({elenco}).',
  'Separati da virgola, senza la chiocciola. Chi scrive un indirizzo con uno di questi domini vede comparire il pulsante nella pagina di accesso. Un dominio può appartenere a un solo provider.':
    'Séparés par des virgules, sans l’arobase. Quiconque saisit une adresse avec l’un de ces domaines voit apparaître le bouton sur la page de connexion. Un domaine ne peut appartenir qu’à un seul fournisseur.',
  'Separati da virgola. Il certificato copre questi e nient’altro: quando aggiungi un cliente con un nome nuovo va riemesso, altrimenti quel cliente apre la propria console e trova un avviso.':
    'Séparés par des virgules. Le certificat couvre ceux-ci et rien d’autre : quand vous ajoutez un client avec un nouveau nom, il doit être réémis, sinon ce client ouvre sa console et trouve un avertissement.',
  'Serie per giorno':
    'Séries par jour',
  'Serve Linux, curl e i permessi di root.':
    'Nécessite Linux, curl et les droits root.',
  'Serve Windows x64 e i privilegi di amministratore. La sonda si registra come servizio, riparte da sola dopo un riavvio, e non fa la cattura diretta dal filo: quella usa un’interfaccia del kernel Linux. Tutto il resto — SNMP, porte, SSH, WinRM, NetFlow ricevuto, connettori — funziona uguale.':
    'Nécessite Windows x64 et les privilèges administrateur. La sonde s’enregistre comme service, redémarre d’elle-même après un redémarrage, et n’effectue pas la capture directe sur le fil : celle-ci utilise une interface du noyau Linux. Tout le reste — SNMP, ports, SSH, WinRM, NetFlow reçu, connecteurs — fonctionne de la même façon.',
  'Serve prima mettere a fuoco un oggetto: la direzione è rispetto a lui':
    'Mettez d’abord un objet au premier plan : la direction est relative à lui',
  'Sessione scaduta per inattività (timeout), non chiusa esplicitamente.':
    'Session expirée pour inactivité (timeout), non fermée explicitement.',
  'Sessione scaduta: effettua di nuovo l’accesso':
    'Session expirée : veuillez vous reconnecter',
  'Si aggiunge ai pool scelti.':
    'S’ajoute aux pools choisis.',
  'Sistema: {sistema} — non modificabile. Per un altro sistema serve una credenziale nuova.':
    'Système : {sistema} — non modifiable. Pour un autre système, il faut un nouvel identifiant.',
  'Sola lettura':
    'Lecture seule',
  'Solo {cosa}':
    'Seulement {cosa}',
  'Sonda attiva':
    'Sonde active',
  'Sonde fuori da ogni gruppo ({n})':
    'Sondes hors de tout groupe ({n})',
  'Sono {n} indirizzi e una scansione ne espande al massimo {tetto}: la sonda rifiuterebbe il job intero. Scegli meno pool, o dividili.':
    'Cela fait {n} adresses et une analyse en développe au maximum {tetto} : la sonde refuserait le job entier. Choisissez moins de pools, ou divisez-les.',
  'Sotto 1024 servono privilegi che la sonda non ha: scegli una porta più alta.':
    'En dessous de 1024, il faut des privilèges que la sonde n’a pas : choisissez un port plus élevé.',
  'Sposta {nome} più in alto':
    'Monter {nome}',
  'Sposta {nome} più in basso':
    'Descendre {nome}',
  'Statico':
    'Statique',
  'Su {n} CI sono stati ricavati modello o versione dalla descrizione di sistema.':
    'Le modèle ou la version a été déduit de la description système sur {n} CI.',
  'Subnet CIDR (max /16), indirizzi singoli o intervalli, separati da virgola.':
    'Sous-réseaux CIDR (max /16), adresses individuelles ou plages, séparés par des virgules.',
  'Subnet, indirizzi o intervalli, separati da virgola.':
    'Sous-réseaux, adresses ou plages, séparés par des virgules.',
  'Sul sistema di destinazione il software installato alimenta il riconoscimento dei prodotti e il fabbisogno di licenze: accendilo solo se l’inventario software di questo parco è completo. Due cose da sapere: le righe si scrivono alla creazione dell’oggetto — su uno che esiste già si possono aggiornare e togliere, non aggiungere — e ciò che non si riesce ad aggiungere compare nel rapporto della corsa invece di essere taciuto.':
    'Sur le système cible, les logiciels installés alimentent la reconnaissance des produits et les besoins en licences : activez-le seulement si l’inventaire logiciel de ce parc est complet. Deux choses à savoir : les lignes s’écrivent à la création de l’objet — sur un objet existant, on peut les mettre à jour et les retirer, pas en ajouter — et ce qui ne peut pas être ajouté apparaît dans le rapport de l’exécution au lieu d’être passé sous silence.',
  'Tipi ammessi: {tipi}. Senza, il passo fallirebbe su ogni bersaglio — e il rapporto direbbe «accesso negato», che manda a controllare le credenziali invece di aggiungerne una.':
    'Types admis : {tipi}. Sans eux, l’étape échouerait sur chaque cible — et le rapport indiquerait « accès refusé », ce qui pousse à vérifier les identifiants au lieu d’en ajouter un.',
  'Tipi di {tipo}':
    'Types de {tipo}',
  'Tipi non ancora classificati in una famiglia':
    'Types pas encore classés dans une famille',
  'Tipo dichiarato dalla sorgente o riconoscimento inequivocabile':
    'Type déclaré par la source ou reconnaissance sans ambiguïté',
  'Togli l’evidenza dalla mappa':
    'Retirer la mise en évidence de la carte',
  'Togli {nome} dal gruppo':
    'Retirer {nome} du groupe',
  'Topologia (CDP/LLDP)':
    'Topologie (CDP/LLDP)',
  'Traffico osservato: {n} intervalli, massimo {max}':
    'Trafic observé : {n} intervalles, maximum {max}',
  'Troppi tentativi: riprova fra qualche minuto.':
    'Trop de tentatives : réessayez dans quelques minutes.',
  'Ultima osservazione':
    'Dernière observation',
  'Ultimo invio':
    'Dernier envoi',
  'Un ambito per riga. Dopo il separatore — «;», tabulazione o «,» — la nota, se la vuoi.':
    'Un périmètre par ligne. Après le séparateur — « ; », tabulation ou « , » — la note, si vous le souhaitez.',
  'Un apparato esporta un campione del traffico. I volumi sono riportati in scala, quindi restano confrontabili — ma sono stime, e su volumi bassi la stima è grossolana.':
    'Un équipement exporte un échantillon du trafic. Les volumes sont rapportés à l’échelle, ils restent donc comparables — mais ce sont des estimations, et sur de faibles volumes l’estimation est grossière.',
  'Un apparato non esporta da oltre un’ora. Il traffico che passava di lì non compare più nei grafici: è un buco nei dati, non una rete diventata silenziosa.':
    'Un équipement n’exporte plus depuis plus d’une heure. Le trafic qui y passait n’apparaît plus dans les graphiques : c’est un trou dans les données, pas un réseau devenu silencieux.',
  'Aggiornamento in corso: le sonde vengono aggiornate gradualmente in funzione del gruppo di appartenenza. Tra un gruppo e il successivo possono trascorrere alcuni minuti.': 'Mise à jour en cours : les sondes sont mises à jour progressivement selon leur groupe. Quelques minutes peuvent s’écouler entre un groupe et le suivant.',
  'Un secondo di lavoro. Le sezioni non raccolte vengono dichiarate: un inventario magro non si legge come una macchina povera.':
    'Une seconde de travail. Les sections non collectées sont signalées : un inventaire maigre ne se lit pas comme une machine pauvre.',
  'Un servizio accetta al massimo {max} ingressi, e ne hai scelti {n}. Toglierne qualcuno non è una limitazione tecnica da aggirare: un servizio con quaranta porte di ingresso non è un servizio, è una rete — e la sua mappa lo mostrerebbe.':
    'Un service accepte au maximum {max} points d’entrée, et vous en avez choisi {n}. En retirer quelques-uns n’est pas une limitation technique à contourner : un service avec quarante points d’entrée n’est pas un service, c’est un réseau — et sa carte le montrerait.',
  'Una sonda lavora, le altre subentrano se cade.':
    'Une sonde travaille, les autres prennent le relais si elle tombe.',
  'Una sonda serve solo se la macchina non raggiunge il Control Plane ma raggiunge lei. Chi inoltra non legge: il carico è sigillato.':
    'Une sonde n’est utile que si la machine n’atteint pas le Control Plane mais atteint la sonde. Celui qui relaie ne lit pas : le contenu est scellé.',
  'Utenti ({n})':
    'Utilisateurs ({n})',
  'Va alla sonda con meno job in corso. È il default e va bene quasi sempre.':
    'Va à la sonde qui a le moins de jobs en cours. C’est le réglage par défaut et il convient presque toujours.',
  'Veeam Backup & Replication':
    'Veeam Backup & Replication',
  'Verifica che la richiesta arrivi, senza consumare uno dei cinque tentativi a settimana che l’autorità concede. Il certificato di prova non è valido e non viene installato.':
    'Vérifie que la requête aboutit, sans consommer l’une des cinq tentatives par semaine accordées par l’autorité. Le certificat de test n’est pas valide et n’est pas installé.',
  'Verifica del provider…':
    'Vérification du fournisseur…',
  'Verifica e installazione…':
    'Vérification et installation…',
  'Verrà scelto in fase di discovery: un nome che dica dove o quando si applica («Filiali», «Apparati pre-2020») si riconosce fra sei mesi.':
    'Il sera choisi lors de la découverte : un nom qui dit où ou quand il s’applique (« Agences », « Équipements pré-2020 ») se reconnaît encore dans six mois.',
  'Versione distribuita da questa installazione:':
    'Version distribuée par cette installation :',
  'Versione {v}':
    'Version {v}',
  'Vicini':
    'Voisins',
  'Vista «{nome}» salvata con {n} nodi fissati.':
    'Vue « {nome} » enregistrée avec {n} nœuds fixés.',
  'Visto anche da: {fonti}':
    'Vu aussi par : {fonti}',
  'Vuoto: si usano gli ambiti predefiniti del piano.':
    'Vide : les périmètres par défaut du plan sont utilisés.',
  'XE':
    'XE',
  'abilitate ma non disponibili: {elenco}':
    'activées mais indisponibles : {elenco}',
  'accettabile':
    'acceptable',
  'altri {n}':
    '{n} autres',
  'archiviato su':
    'stocké sur',
  'arn:aws:iam::123456789012:role/CensoDiscovery':
    'arn:aws:iam::123456789012:role/CensoDiscovery',
  'catena di {n}':
    'chaîne de {n}',
  'chiave':
    'clé',
  'chiudi':
    'fermer',
  'collegato a':
    'connecté à',
  'configurata':
    'configurée',
  'configuration item collegato':
    'configuration item lié',
  'connettore inesistente':
    'connecteur inexistant',
  'consigliata':
    'recommandée',
  'contiene':
    'contient',
  'corrisponde all’espressione':
    'correspond à l’expression',
  'costo {c}':
    'coût {c}',
  'da confermare':
    'à confirmer',
  'dall’inizio':
    'depuis le début',
  'destinazione → CENSO':
    'destination → CENSO',
  'dipende da':
    'dépend de',
  'disabilitata':
    'désactivée',
  'disabilitate: {elenco}':
    'désactivées : {elenco}',
  'dominio':
    'domaine',
  'doppio senso':
    'double sens',
  'e altri {n}':
    'et {n} autres',
  'es. 10.0.0.10':
    'ex. 10.0.0.10',
  'eu-frankfurt-1':
    'eu-frankfurt-1',
  'eu-west-1':
    'eu-west-1',
  'fermata':
    'arrêtée',
  'fermo':
    'à l’arrêt',
  'finisce con':
    'se termine par',
  'fino alla scadenza':
    'jusqu’à l’échéance',
  'fra {n} giorni':
    'dans {n} jours',
  'fra {n} giorni · {motivo}':
    'dans {n} jours · {motivo}',
  'gira su':
    'tourne sur',
  'già nella mappatura':
    'déjà dans le mappage',
  'giù (livello inferiore)':
    'down (couche inférieure)',
  'gruppo {nome}':
    'groupe {nome}',
  'http://dns.example.com:8081':
    'http://dns.example.com:8081',
  'https://192.0.2.1':
    'https://192.0.2.1',
  'https://ntopng.example.com:3000':
    'https://ntopng.example.com:3000',
  'https://vcenter.example.com':
    'https://vcenter.example.com',
  'https://veeam.example.com:9419':
    'https://veeam.example.com:9419',
  'https://wazuh.example.com:55000':
    'https://wazuh.example.com:55000',
  'https://wazuh.example.com:9200':
    'https://wazuh.example.com:9200',
  'il passo «{id}»':
    'l’étape « {id} »',
  'il primo':
    'le premier',
  'il secondo':
    'le second',
  'in corso':
    'en cours',
  'in ritentativo':
    'nouvelle tentative',
  'indietro':
    'en retard',
  'inizia per':
    'commence par',
  'instrada verso':
    'route vers',
  'kernel {v}':
    'noyau {v}',
  'la condizione usa «{fatto}», che a questo punto del piano non esiste ancora: il passo non partirebbe mai':
    'la condition utilise « {fatto} », qui n’existe pas encore à ce stade du plan : l’étape ne démarrerait jamais',
  'localhost':
    'localhost',
  'l’elenco contiene':
    'la liste contient',
  'membro di':
    'membre de',
  'meno di 1 MB':
    'moins de 1 Mo',
  'modello':
    'modèle',
  'mostra in mappa':
    'afficher sur la carte',
  'nascondi':
    'masquer',
  'nelle ultime {n} ore':
    'au cours des {n} dernières heures',
  'nessun fallimento':
    'aucun échec',
  'nessun ruolo':
    'aucun rôle',
  'non ({condizione})':
    'non ({condizione})',
  'non contiene':
    'ne contient pas',
  'non ha capability abilitate':
    'n’a aucune capability activée',
  'non ha dichiarato alcuna capability':
    'n’a déclaré aucune capability',
  'non serve':
    'inutile',
  'non si riprova da sé':
    'ne réessaie pas d’elle-même',
  'non è online (stato: {stato})':
    'n’est pas en ligne (état : {stato})',
  'non è online (stato: {stato}, {motivo})':
    'n’est pas en ligne (état : {stato}, {motivo})',
  'noto':
    'connu',
  'nulla':
    'rien',
  'ogni flusso':
    'chaque flux',
  'ogni {n} g':
    'tous les {n} j',
  'parla con':
    'communique avec',
  'passata da {n} giorni':
    'dépassée depuis {n} jours',
  'postgres':
    'postgres',
  'predefinito: {v}':
    'par défaut : {v}',
  'prossima: {quando}':
    'prochaine : {quando}',
  'protocollo {protocollo}':
    'protocole {protocollo}',
  'provider non disponibile':
    'fournisseur indisponible',
  'richiesta':
    'requête',
  'riga {n}':
    'ligne {n}',
  'rilevato tramite {fonte}':
    'détecté via {fonte}',
  'riuscita':
    'réussie',
  'scelto a mano':
    'choisi manuellement',
  'sconosciuta':
    'inconnue',
  'se':
    'si',
  'senza indirizzo':
    'sans adresse',
  'servizio':
    'service',
  'snmp':
    'snmp',
  'su':
    'up',
  'traffico di ritorno':
    'trafic de retour',
  'ultime {n} ore':
    '{n} dernières heures',
  'valore non valido':
    'valeur non valide',
  'versione':
    'version',
  'versione {v}':
    'version {v}',
  '{a} su {v} fisici':
    '{a} sur {v} physiques',
  '{campo} non è falso':
    '{campo} n’est pas faux',
  '{campo} non è vero':
    '{campo} n’est pas vrai',
  '{campo} non è {valore}':
    '{campo} n’est pas {valore}',
  '{campo} è falso':
    '{campo} est faux',
  '{campo} è vero':
    '{campo} est vrai',
  '{campo} è {valore}':
    '{campo} est {valore}',
  '{d} g {h} h':
    '{d} j {h} h',
  '{id}… — non esiste più':
    '{id}… — n’existe plus',
  '{nome} (1 sonda)':
    '{nome} (1 sonde)',
  '{nome} (non disponibile)':
    '{nome} (indisponible)',
  '{nome} ({n} passi)':
    '{nome} ({n} étapes)',
  '{nome} ({n} sonde)':
    '{nome} ({n} sondes)',
  '{nome} e altri {n}':
    '{nome} et {n} autres',
  '{nome} · {n} ambiti':
    '{nome} · {n} périmètres',
  '{nome} — backup configurazioni':
    '{nome} — sauvegarde des configurations',
  '{nome} — gruppo':
    '{nome} — groupe',
  '{nome} — non in linea':
    '{nome} — hors ligne',
  '{nome} — predefinito ({n} passi)':
    '{nome} — par défaut ({n} étapes)',
  '{nome} — {n} credenziali':
    '{nome} — {n} identifiants',
  '{nomi} è un wildcard: non si può convalidare con questa strada, perché dimostrare il controllo di {esempio} richiede di scrivere un record DNS. Per il wildcard servono le credenziali del provider e lo script {script}.':
    '{nomi} est un wildcard : il ne peut pas être validé par cette voie, car prouver le contrôle de {esempio} exige d’écrire un enregistrement DNS. Pour le wildcard, il faut les identifiants du fournisseur et le script {script}.',
  '{n} CI non sono stati riconosciuti da alcuna regola. Restano consultabili e classificati come «non classificati»: attribuirli a caso sarebbe peggio, perché l’errore si noterebbe solo a valle.':
    '{n} CI n’ont été reconnus par aucune règle. Ils restent consultables et sont marqués « non classés » : les attribuer au hasard serait pire, car l’erreur ne se remarquerait qu’en aval.',
  '{n} ambiti · {indirizzi} indirizzi':
    '{n} périmètres · {indirizzi} adresses',
  '{n} apparati adesso — dalle condizioni':
    '{n} équipements actuellement — d’après les conditions',
  '{n} apparati corrispondono, {conIndirizzo} con un indirizzo da scansionare.':
    '{n} équipements correspondent, dont {conIndirizzo} avec une adresse à analyser.',
  '{n} apparati esportano un campione del traffico. I volumi sono riportati in scala, quindi restano confrontabili — ma sono stime, e su volumi bassi la stima è grossolana.':
    '{n} équipements exportent un échantillon du trafic. Les volumes sont extrapolés, ils restent donc comparables — mais ce sont des estimations, et sur de faibles volumes l’estimation est grossière.',
  '{n} apparati non esportano da oltre un’ora. Il traffico che passava di lì non compare più nei grafici: è un buco nei dati, non una rete diventata silenziosa.':
    '{n} équipements n’exportent plus depuis plus d’une heure. Le trafic qui y passait n’apparaît plus dans les graphiques : c’est un trou dans les données, pas un réseau devenu silencieux.',
  '{n} campi':
    '{n} champs',
  '{n} campi non proposti, di proposito — vedi perché':
    '{n} champs volontairement non proposés — voir pourquoi',
  '{n} corrispondono alle condizioni ma non hanno un indirizzo di gestione: non si possono scansionare.':
    '{n} correspondent aux conditions mais n’ont pas d’adresse de gestion : ils ne peuvent pas être analysés.',
  '{n} corrispondono ma non hanno un indirizzo di gestione, quindi non si possono scansionare':
    '{n} correspondent mais n’ont pas d’adresse de gestion, ils ne peuvent donc pas être analysés',
  '{n} corrispondono ma non hanno un indirizzo di gestione, quindi non si possono scansionare: {esempi}…':
    '{n} correspondent mais n’ont pas d’adresse de gestion, ils ne peuvent donc pas être analysés : {esempi}…',
  '{n} credenziale':
    '{n} identifiant',
  '{n} credenziali':
    '{n} identifiants',
  '{n} di fila':
    '{n} d’affilée',
  '{n} di {tot} coperti':
    '{n} sur {tot} couverts',
  '{n} disabilitate':
    '{n} désactivées',
  '{n} flussi':
    '{n} flux',
  '{n} g':
    '{n} j',
  '{n} già presenti nel file.':
    '{n} déjà présents dans le fichier.',
  '{n} in corso':
    '{n} en cours',
  '{n} nodi corrispondono a «{q}».':
    '{n} nœuds correspondent à « {q} ».',
  '{n} nodi fissati.':
    '{n} nœuds fixés.',
  '{n} nodi fuori dall’intorno non sono mostrati.':
    '{n} nœuds hors du voisinage ne sont pas affichés.',
  '{n} nodi, {m} collegamenti':
    '{n} nœuds, {m} liens',
  '{n} non IP (ARP, STP, LLDP)':
    '{n} non IP (ARP, STP, LLDP)',
  '{n} oggetti':
    '{n} objets',
  '{n} pacchetti':
    '{n} paquets',
  '{n} record':
    '{n} enregistrements',
  '{n} registrazioni di prodotto caricate dai MIB. Le righe qui sotto con un OID e senza corrispondenza sono quelle per cui manca il MIB di quel costruttore.':
    '{n} enregistrements de produit chargés depuis les MIB. Les lignes ci-dessous avec un OID et sans correspondance sont celles pour lesquelles le MIB de ce constructeur manque.',
  '{n} righe lasciate indietro.':
    '{n} lignes laissées de côté.',
  '{n} su {campione} letti':
    '{n} sur {campione} lus',
  '{n} volte':
    '{n} fois',
  '{n} volte, l’ultima {quando}':
    '{n} fois, la dernière {quando}',
  '{ok} ok, {ko} ko, {nv} non valutabili':
    '{ok} ok, {ko} en échec, {nv} non évaluables',
  '{rate} medi su {min} min':
    '{rate} en moyenne sur {min} min',
  '{stato} · {n} indirizzi noti':
    '{stato} · {n} adresses connues',
  '{tipo} — ricorrente':
    '{tipo} — récurrent',
  '{tipo}: job {id}… avviato, con il backup configurazioni a seguire.':
    '{tipo} : job {id}… lancé, suivi de la sauvegarde des configurations.',
  '{tipo}: job {id}… avviato. Verrà assegnato a una sonda online.':
    '{tipo} : job {id}… lancé. Il sera attribué à une sonde en ligne.',
  '{vcpu} vCPU · {n} core':
    '{vcpu} vCPU · {n} cœurs',
  '{volume} in totale':
    '{volume} au total',
  '{volume} in {n} intervalli da {risoluzione}.':
    '{volume} en {n} intervalles de {risoluzione}.',
  '{v} di RAM':
    '{v} de RAM',
  '«{fatto}» non è disponibile a questo punto del piano':
    '« {fatto} » n’est pas disponible à ce stade du plan',
  '«{nome}» avviata ora (job {job}…). La prossima esecuzione programmata resta invariata.':
    '« {nome} » lancée maintenant (job {job}…). La prochaine exécution planifiée reste inchangée.',
  '«{nome}»: la configurazione risponde.':
    '« {nome} » : la configuration répond.',
  '«{nome}»: qualcosa non torna.':
    '« {nome} » : quelque chose ne va pas.',
  '«{passo}» è fallito':
    '« {passo} » a échoué',
  '«{passo}» è riuscito':
    '« {passo} » a réussi',
  '«{passo}» è stato saltato':
    '« {passo} » a été ignoré',
  '«{valore}» non è un numero':
    '« {valore} » n’est pas un nombre',
  '«{valore}» non è una porta (1-65535)':
    '« {valore} » n’est pas un port (1-65535)',
  'È quello generato all’installazione: il servizio funziona, ma ogni browser mostrerà un avviso di sicurezza e i clienti dovranno accettarlo a mano. Sostituiscilo qui sotto quando ne hai uno emesso da una CA pubblica.':
    'C’est celui généré à l’installation : le service fonctionne, mais chaque navigateur affichera un avertissement de sécurité et les clients devront l’accepter manuellement. Remplacez-le ci-dessous dès que vous en avez un émis par une CA publique.',
  'È stato costruito senza {variabile}, quindi non c’è nulla con cui confrontare le sonde e nessun aggiornamento può essere richiesto.':
    'Il a été construit sans {variabile} : il n’y a donc rien à quoi comparer les sondes et aucune mise à jour ne peut être demandée.',
  'è assente':
    'est absent',
  'è disattivata dalla console':
    'est désactivée depuis la console',
  'è uno di':
    'est l’un de',
  '•••••• (invariato)':
    '•••••• (inchangé)',
  '…oppure carica un CSV':
    '…ou importez un CSV',
  '…oppure incolla un certificato che hai già':
    '…ou collez un certificat que vous avez déjà',
  '…oppure se…':
    '…ou si…',
  '← Torna ai beni':
    '← Retour aux biens',
  '← Torna ai servizi':
    '← Retour aux services',
  '← Torna alle sonde':
    '← Retour aux sondes',
  'Annulla la dismissione':
    'Annuler la mise hors service',
  'Annullamento…':
    'Annulation…',
  'Collegamenti ({n})':
    'Liens ({n})',
  'Comunica con':
    'Communique avec',
  'Conferma registrazione':
    'Confirmer l’enregistrement',
  'Dipende da':
    'Dépend de',
  'Gira su':
    'S’exécute sur',
  'Membri dello stack':
    'Membres de la pile',
  'Membro di':
    'Membre de',
  'Ospita':
    'Héberge',
  'Parte di':
    'Fait partie de',
  'Preparazione…':
    'Préparation…',
  'Questo configuration item è già registrato come bene: {bene}.':
    'Ce configuration item est déjà enregistré comme bien : {bene}.',
  'Questo oggetto era registrato più di una volta. L’identificativo {id} è stato unito a questo e continua a portare qui: i collegamenti salvati restano validi.':
    'Cet objet était enregistré plusieurs fois. L’identifiant {id} a été fusionné avec celui-ci et continue de mener ici : les liens enregistrés restent valides.',
  'Registrazione…':
    'Enregistrement…',
  'Rimozione…':
    'Suppression…',
  'Sicurezza ({n})':
    'Sécurité ({n})',
  'Storico delle modifiche ({n})':
    'Historique des modifications ({n})',
  'Togliere {nome} dalla CMDB?\n\nSe questo apparato esiste ancora in rete, la prossima scansione lo riporta come oggetto nuovo, senza la sua storia: per una macchina dismessa usa «Dichiara dismesso», più in alto in questa pagina, non la cancellazione.\n\nSpariscono interfacce, software, relazioni e storico. Il bene eventualmente registrato resta, e perde solo il collegamento a questo CI.':
    'Retirer {nome} de la CMDB ?\n\nSi cet équipement existe encore sur le réseau, la prochaine analyse le ramènera comme un nouvel objet, sans son historique : pour une machine mise hors service, utilisez « Déclarer mis hors service », plus haut sur cette page, et non la suppression.\n\nLes interfaces, logiciels, relations et l’historique disparaissent. Le bien éventuellement enregistré reste, et perd seulement son lien avec ce CI.',
  'Torna all’automatico':
    'Revenir à l’automatique',
  'Ultima verifica: {quando}.':
    'Dernière vérification : {quando}.',
  'da questo CI':
    'depuis ce CI',
  'dalla discovery':
    'issu de la découverte',
  'nessun job: conclusione del Control Plane':
    'aucun job : conclusion du Control Plane',
  'verso questo CI':
    'vers ce CI',
  'Exporter':
    'Exportateur',
  'IP VPN':
    'IP VPN',
  'Accorcia la storia una tantum, senza cambiare la regola. Non si annulla.':
    'Raccourcit l’historique une seule fois, sans changer la règle. Irréversible.',
  'Aggiorna dalla IANA':
    'Mettre à jour depuis l’IANA',
  'Applica la conservazione adesso':
    'Appliquer la conservation maintenant',
  'Applicata alle tabelle esistenti. {nota}':
    'Appliquée aux tables existantes. {nota}',
  'Applicazione…':
    'Application…',
  'Carica un file':
    'Charger un fichier',
  'ClickHouse elimina i dati scaduti alla merge successiva della parte che li contiene: dopo aver accorciato la conservazione lo spazio si libera nel giro di ore, non subito. Questo comando non aspetta.':
    'ClickHouse supprime les données expirées lors de la prochaine fusion de la partie qui les contient : après avoir raccourci la conservation, l’espace se libère en quelques heures, pas immédiatement. Cette commande n’attend pas.',
  'Il dettaglio a cinque minuti risponde a «cos’è successo l’altro ieri alle 15» ed è la tabella che cresce: ogni giorno in più costa circa quanto dodici giorni di rollup. Il rollup orario risponde a «come è cambiato l’anno», e tredici mesi coprono il confronto con lo stesso periodo dell’anno prima.':
    'Le détail à cinq minutes répond à « que s’est-il passé avant-hier à 15 h » et c’est la table qui grossit : chaque jour supplémentaire coûte à peu près autant que douze jours de rollup. Le rollup horaire répond à « comment l’année a-t-elle évolué », et treize mois couvrent la comparaison avec la même période de l’année précédente.',
  'Incolla il contenuto di {file}, scaricato da una macchina che ha rete':
    'Collez le contenu de {file}, téléchargé depuis une machine qui a accès au réseau',
  'Non applicata alle tabelle: {motivo}':
    'Non appliquée aux tables : {motivo}',
  'Ogni sysObjectID contiene il numero che la IANA ha assegnato a un’organizzazione: è da lì che si ricava il produttore di un apparato, anche di una marca mai vista. L’elenco è pubblico e conta circa sessantamila voci.':
    'Chaque sysObjectID contient le numéro que l’IANA a attribué à une organisation : c’est de là qu’on déduit le fabricant d’un équipement, même d’une marque jamais vue. La liste est publique et compte environ soixante mille entrées.',
  'Retention salvata: {dettaglio} giorni di dettaglio, {rollup} di rollup.':
    'Conservation enregistrée : {dettaglio} jours de détail, {rollup} de rollup.',
  'Rimuovere tutto il traffico precedente a {giorni} giorni fa? L’operazione non si annulla: quei dati non sono altrove.':
    'Supprimer tout le trafic antérieur à {giorni} jours ? L’opération est irréversible : ces données n’existent nulle part ailleurs.',
  'Salva e applica':
    'Enregistrer et appliquer',
  'Scarica il registro':
    'Télécharger le registre',
  'Tabelle interessate: {tabelle}.':
    'Tables concernées : {tabelle}.',
  'Misurare: {motivo}':
    'Mesurer : {motivo}',
  'Rimediare: {motivo}':
    'Corriger : {motivo}',
  'Pool':
    'Pool',
  'Allocazione':
    'Allocation',
  'Allocata':
    'Allouée',
  'LUN: nome, WWN, pool, thin o thick, capacità e spazio allocato. Su una LUN thin la capacità è una promessa: lo spazio che prende davvero dal pool è l’«Allocata», con la percentuale. Il WWN è l’identità con cui gli host vedono la LUN (il dispositivo naa seguito dal WWN).':
    "LUN : nom, WWN, pool, thin ou thick, capacité et espace alloué. Sur une LUN thin la capacité est une promesse : l'espace réellement pris au pool est « Allouée », avec le pourcentage. Le WWN est l'identité sous laquelle les hôtes voient la LUN (le périphérique naa suivi du WWN).",
  '{n} aggiunti':
    '{n} ajoutés',
  '{n} tolti':
    '{n} retirés',
  'aggiunto {campo}':
    '{campo} ajouté',
  'tolto {campo}':
    '{campo} retiré',
  'cambiato {campo}':
    '{campo} modifié',
  '{n} elementi: {come}':
    '{n} éléments : {come}',
  'stesso contenuto, in altro ordine':
    'même contenu, dans un autre ordre',
  'Aggiornamento automatico':
    'Mise à jour automatique',
  'aggiornamento automatico':
    'mise à jour automatique',
  'Quando il Control Plane passa a una versione nuova, la sonda si aggiorna da sola in un momento a caso (entro 3 minuti fino a cinque sonde, entro 10 fino a venti, entro 20 oltre), senza premere «Aggiorna»: così una fleet non si riavvia tutta insieme. Se è l’unica sonda del suo gruppo pesca nella seconda metà della finestra. Il freno resta: se gli aggiornamenti falliscono, le sonde non ancora partite si fermano, e non c’è mai un nuovo tentativo automatico su una sonda che ha già rifiutato quella versione. La sonda si riavvia: per qualche istante la sua rete resta senza raccolta.':
    'Quand le Control Plane passe à une nouvelle version, la sonde se met à jour seule à un moment aléatoire (en 3 minutes jusqu’à cinq sondes, en 10 jusqu’à vingt, en 20 au-delà), sans appuyer sur « Mettre à jour » : ainsi une flotte ne redémarre pas d’un coup. Si c’est la seule sonde de son groupe, elle tire dans la seconde moitié de la fenêtre. Le frein reste : si les mises à jour échouent, les sondes pas encore parties s’arrêtent, et il n’y a jamais de nouvelle tentative automatique sur une sonde qui a déjà refusé cette version. La sonde redémarre : pendant un instant son réseau reste sans collecte.',
  'Le sonde nuove nascono con «Aggiornamento automatico» acceso (per quelle già arruolate si accende nella scheda): quando la piattaforma cambia versione, ognuna si aggiorna da sola in un momento a caso, così la fleet non si riavvia tutta insieme: entro 3 minuti fino a cinque sonde, entro 10 fino a venti, entro 20 oltre. Nell’elenco delle sonde, sotto la versione, compare «aggiornamento automatico» dove è acceso.':
    'Les nouvelles sondes naissent avec « Mise à jour automatique » activée (pour celles déjà enrôlées elle s’active dans leur fiche) : quand la plateforme change de version, chacune se met à jour seule à un moment aléatoire, pour que la flotte ne redémarre pas d’un coup : en 3 minutes jusqu’à cinq sondes, en 10 jusqu’à vingt, en 20 au-delà. Dans la liste des sondes, sous la version, « mise à jour automatique » apparaît là où elle est activée.',
  'IQN (initiator iSCSI)':
    'IQN (initiateur iSCSI)',
  'WWPN (porte FC)':
    'WWPN (ports FC)',
  'Con gli host: dagli host registrati e dagli initiator nasce la relazione «archiviato su» host → array. La prova più forte è l’IQN o il WWPN: gli host li dichiarano da sé (ESXi dalla vCenter, Linux e Windows dall’inventario SSH/WinRM e dall’agente) e l’initiator dell’array che ha lo stesso valore aggancia l’host giusto anche senza nome, in qualunque ordine arrivino le scansioni. In mancanza, il nome registrato sull’array o gli indizi nell’IQN (VMware, Microsoft, open-iscsi).':
    "Avec les hôtes : les hôtes enregistrés et les initiateurs produisent la relation « stocké sur » hôte → baie. La preuve la plus forte est l'IQN ou le WWPN : les hôtes les déclarent eux-mêmes (ESXi depuis vCenter, Linux et Windows depuis l'inventaire SSH/WinRM et l'agent), et l'initiateur de la baie qui a la même valeur accroche le bon hôte même sans nom, quel que soit l'ordre des analyses. À défaut, le nom enregistré sur la baie ou les indices contenus dans l'IQN (VMware, Microsoft, open-iscsi).",
  'Ruotare la chiave dei segreti di «{nome}»? I segreti esistenti si ricifrano da soli nei minuti successivi; fino ad allora restano leggibili con la chiave precedente.':
    "Faire tourner la clé des secrets de « {nome} » ? Les secrets existants sont rechiffrés automatiquement dans les minutes qui suivent ; d'ici là ils restent lisibles avec la clé précédente.",
  'Chiavi dei segreti per cliente':
    'Clés des secrets par client',
  'Ogni cliente cifra le proprie credenziali e i segreti dei connettori con una chiave sua, conservata cifrata dalla chiave master della piattaforma: una chiave esposta riguarda un cliente solo, e cancellare un cliente rende illeggibili i suoi segreti anche in un vecchio backup. I segreti di prima migrano da soli, a lotti, a ogni giro dell’orchestratore.':
    "Chaque client chiffre ses identifiants et les secrets de ses connecteurs avec sa propre clé, conservée chiffrée par la clé maîtresse de la plateforme : une clé exposée ne concerne qu'un seul client, et supprimer un client rend ses secrets illisibles même dans une ancienne sauvegarde. Les secrets plus anciens migrent d'eux-mêmes, par lots, à chaque cycle de l'orchestrateur.",
  'Versione della chiave':
    'Version de la clé',
  'Segreti':
    'Secrets',
  'Da migrare':
    'À migrer',
  'non ancora creata':
    'pas encore créée',
  'Rotazione…':
    'Rotation…',
  'Ruota la chiave':
    'Faire tourner la clé',
  'Altri indirizzi di gestione':
    'Autres adresses de gestion',
  'Il Control Plane ha rifiutato i risultati della sonda (vedi l’errore sopra), e il rapporto viaggiava con loro. Non è la sonda: ritenta il job quando il problema del Control Plane è risolto.':
    "Le Control Plane a refusé les résultats de la sonde (voir l'erreur ci-dessus), et le rapport voyageait avec eux. Ce n'est pas la sonde : relancez le job une fois le problème du Control Plane résolu.",
  'Tabella di routing mancante':
    'Table de routage manquante',
  'tabella di routing non raccolta: il percorso si conosce fin qui':
    "table de routage non collectée : le chemin est connu jusqu'ici",
  'senza tabella':
    'sans table',
  'da un IP sorgente a uno di destinazione, il giro che il pacchetto farebbe attraverso le tabelle di routing raccolte — salto per salto, con l’interfaccia di uscita. Il next-hop si riconosce anche quando è un indirizzo secondario, un IP di gestione o il VIP VRRP/HSRP di una coppia di core (il salto dedotto lo dice). Se il percorso si ferma su «Tabella di routing mancante», il next-hop è un apparato noto di cui non hai raccolto le rotte: accendi l’opzione «Tabelle di routing» nella sua scansione e riprova.':
    "d'une IP source à une IP de destination, le chemin qu'un paquet emprunterait à travers les tables de routage collectées — saut par saut, avec l'interface de sortie. Le next-hop est reconnu même lorsqu'il s'agit d'une adresse secondaire, d'une IP de gestion ou du VIP VRRP/HSRP d'une paire de cœurs (le saut déduit l'indique). Si le chemin s'arrête sur « Table de routage manquante », le next-hop est un équipement connu dont vous n'avez pas collecté les routes : activez l'option « Tables de routage » dans son analyse et réessayez.",
  'Un controller di gestione (iDRAC, iLO) e il suo server restano due CI, legati da «Parte di»: il legame si fa dal service tag che il controller dichiara (Seriale del telaio) e che il server porta come seriale, in qualunque ordine arrivino le scansioni. Il server prende il ruolo «Gestito fuori banda», e in testa alla sua scheda compare in evidenza «IP di Management»: l’indirizzo del controller (si apre la sua console) e il nome, che porta alla scheda del controller; sulla scheda del controller, viceversa, «Controller di gestione di» porta al server. Se il legame manca, guarda nella scheda del controller il Seriale del telaio: se è vuoto, la sonda non l’ha letto via SNMP (credenziale o versione della sonda).':
    'Un contrôleur de gestion (iDRAC, iLO) et son serveur restent deux CI, liés par « Fait partie de » : le lien se fait à partir du service tag que le contrôleur déclare (Numéro de série du châssis) et que le serveur porte comme numéro de série, quel que soit l\'ordre des analyses. Le serveur reçoit le rôle « Géré hors bande », et « IP de management » apparaît en évidence en haut de sa fiche : l\'adresse du contrôleur (ouvre sa console) et son nom, qui mène à la fiche du contrôleur ; sur la fiche du contrôleur, « Contrôleur de gestion de » ramène au serveur. Si le lien manque, vérifiez le Numéro de série du châssis dans la fiche du contrôleur : s\'il est vide, la sonde ne l\'a pas lu via SNMP (identifiant ou version de la sonde).',
  'IP di Management': 'IP de management',
  'Controller di gestione': 'Contrôleur de gestion',
  'Controller di gestione di': 'Contrôleur de gestion de',
  'Apri la console del controller di gestione': 'Ouvrir la console du contrôleur de gestion',
  'Canale attuale: {come}':
    'Canal actuel : {come}',
  "Come all'installazione (CENSO_PROXY, altrimenti diretta)":
    "Comme à l'installation (CENSO_PROXY, sinon directe)",
  'Comunicazione con il Control Plane':
    'Communication avec le Control Plane',
  'Destinazioni che escono dirette':
    'Destinations qui sortent en direct',
  'Diretta, senza proxy':
    'Directe, sans proxy',
  'Il proxy HTTP che questa sonda usa per uscire. Serve per la comunicazione con il Control Plane, se lo scegli qui sotto, e per i connettori che nella loro scheda scelgono «proxy della sonda».':
    'Le proxy HTTP que cette sonde utilise pour sortir. Il sert à la communication avec le Control Plane, si vous le choisissez ci-dessous, et aux connecteurs qui choisissent « proxy de la sonde » dans leur fiche.',
  'Il proxy si configura nella scheda della sonda (sezione Proxy).':
    'Le proxy se configure dans la fiche de la sonde (section Proxy).',
  'Indirizzo del proxy':
    'Adresse du proxy',
  'La sonda prova il nuovo modo prima di adottarlo: se il Control Plane non risponde così, resta sul modo che funziona e l’errore compare qui. Un proxy che ispeziona il TLS rompe l’identità mTLS della sonda: va escluso dall’ispezione.':
    "La sonde teste le nouveau mode avant de l'adopter : si le Control Plane ne répond pas ainsi, elle reste sur le mode qui fonctionne et l'erreur s'affiche ici. Un proxy qui inspecte le TLS casse l'identité mTLS de la sonde : il faut l'exclure de l'inspection.",
  'La sonda scelta non ha un proxy configurato: le chiamate falliranno finché non lo imposti nella sua scheda.':
    "La sonde choisie n'a pas de proxy configuré : les appels échoueront tant que vous ne l'aurez pas défini dans sa fiche.",
  'Nessun proxy':
    'Aucun proxy',
  'Applicato alle connessioni originate dalla sonda verso questo sistema.': 'Appliqué aux connexions issues de la sonde vers ce système.',
  'Proxy':
    'Proxy',
  'Proxy della sonda':
    'Proxy de la sonde',
  'Proxy specificato':
    'Proxy spécifié',
  'Togli la password salvata':
    'Supprimer le mot de passe enregistré',
  'Tramite questo proxy':
    'Via ce proxy',
  'Una per riga: host, domini (.azienda.local), IP o reti (10.0.0.0/8). Proposte le reti private: vCenter, iDRAC e storage in LAN non passano dal proxy.':
    'Une par ligne : hôtes, domaines (.entreprise.local), IP ou réseaux (10.0.0.0/8). Les réseaux privés sont proposés : vCenter, iDRAC et stockage du LAN ne passent pas par le proxy.',
  'Userà {url}, configurato nella scheda della sonda.':
    'Utilisera {url}, configuré dans la fiche de la sonde.',
  'Utente (facoltativo)':
    'Utilisateur (facultatif)',
  "come all'installazione":
    "comme à l'installation",
  'diretto':
    'direct',
  'http, https o socks5. Vuoto = la sonda non ha un proxy.':
    "http, https ou socks5. Vide = la sonde n'a pas de proxy.",
  'in applicazione: {come}':
    "en cours d'application : {come}",
  'proxy di installazione: {p}':
    "proxy d'installation : {p}",
  'tramite il proxy':
    'via le proxy',
  'Una sonda dietro un proxy':
    'Une sonde derrière un proxy',
  'Se la sonda esce solo da un proxy, installala con CENSO_PROXY=http://proxy:porta davanti al comando: lo script scarica attraverso il proxy e lo lascia nel servizio. Poi, nella scheda della sonda (sezione Proxy), il proxy si governa dalla console: indirizzo, utente, password, destinazioni dirette e come parlare con il Control Plane (come all’installazione, diretta, tramite il proxy).':
    "Si la sonde ne peut sortir que par un proxy, installez-la avec CENSO_PROXY=http://proxy:port devant la commande : le script télécharge via le proxy et le laisse dans le service. Ensuite, dans la fiche de la sonde (section Proxy), le proxy se gère depuis la console : adresse, utilisateur, mot de passe, destinations directes et manière de parler au Control Plane (comme à l'installation, directe, via le proxy).",
  'Un cambio del canale verso il Control Plane la sonda lo prova prima di adottarlo: se con il nuovo proxy il Control Plane non risponde, resta su quello che funziona e la scheda mostra l’errore. Un proxy sbagliato non stacca la sonda.':
    "La sonde teste un changement du canal vers le Control Plane avant de l'adopter : si le Control Plane ne répond pas via le nouveau proxy, elle reste sur celui qui fonctionne et la fiche affiche l'erreur. Un mauvais proxy ne déconnecte pas la sonde.",
  'Ogni connettore che esce da una sonda (ITSM «da una sonda», Wazuh, firewall, DNS, Veeam, Vinchin, ntopng) sceglie accanto alla sonda il proprio proxy: nessuno, uno specificato lì, o il proxy della sonda. Se sceglie quello della sonda e la sonda non ne ha uno, la chiamata fallisce dicendolo invece di uscire diretta.':
    "Chaque connecteur qui sort d'une sonde (ITSM « depuis une sonde », Wazuh, pare-feu, DNS, Veeam, Vinchin, ntopng) choisit à côté de la sonde son propre proxy : aucun, un proxy spécifié là, ou le proxy de la sonde. S'il choisit celui de la sonde et que la sonde n'en a pas, l'appel échoue en le disant au lieu de sortir en direct.",
  'Anche la sonda è una macchina della rete: una volta installata fa l’inventario di sé stessa, come un agente (sistema, dischi, software, porte), e ne nasce un CI. Dalla scheda della sonda «CI della macchina» porta al CI; nella scheda del CI la targhetta «Sonda CENSO» porta alla sonda. Si ripete ogni 12 ore. In un container non si fa: descriverebbe il container, non la macchina.':
    "La sonde est elle aussi une machine du réseau : une fois installée, elle fait son propre inventaire, comme un agent (système, disques, logiciels, ports), et un CI est créé. Dans la fiche de la sonde, « CI de la machine » mène au CI ; dans la fiche du CI, l'étiquette « Sonde CENSO » mène à la sonde. Cela se répète toutes les 12 heures. Pas dans un conteneur : cela décrirait le conteneur, pas la machine.",
  'Sonda CENSO':
    'Sonde CENSO',
  'CI della macchina':
    'CI de la machine',
  'Autoinventario non eseguito: la sonda gira in un container, e l’inventario descriverebbe il container invece della macchina.':
    "Auto-inventaire non exécuté : la sonde tourne dans un conteneur, et l'inventaire décrirait le conteneur au lieu de la machine.",
  'Autoinventario non consegnato: {errore}':
    'Auto-inventaire non livré : {errore}',
  'Autoinventario della macchina: {quando}':
    'Auto-inventaire de la machine : {quando}',
  'Le sonde, gli agenti e gli honeypot installati quando il prodotto si chiamava ADABS continuano a funzionare con i nomi di allora (per esempio il servizio adabs-agent) e si aggiornano normalmente; la scheda della sonda mostra i comandi con il nome vero di quella macchina. Reinstallandoli prendono i nomi nuovi (censo-agent) e quelli vecchi vengono tolti.':
    "Les sondes, agents et honeypots installés lorsque le produit s'appelait ADABS continuent de fonctionner avec leurs anciens noms (par exemple le service adabs-agent) et se mettent à jour normalement ; la fiche de la sonde affiche les commandes avec le nom réel de cette machine. En les réinstallant, ils prennent les nouveaux noms (censo-agent) et les anciens sont supprimés.",
  'Allineati':
    'Alignés',
  'App ID':
    'App ID',
  'CI trovato':
    'CI trouvé',
  'Che cosa è documentato in phpIPAM per gli indirizzi di questo oggetto, chiesto al momento.':
    'Ce que phpIPAM documente pour les adresses de cet objet, demandé sur le moment.',
  "Codice dell'app":
    "Code de l'app",
  'Confronto':
    'Comparaison',
  'Confronto: {cidr}':
    'Comparaison : {cidr}',
  'Da una sonda se il sistema sta nella rete del cliente; dal Control Plane se è raggiungibile da Internet (con un certificato valido).':
    "Depuis une sonde si le système est dans le réseau du client ; depuis le Control Plane s'il est joignable depuis Internet (avec un certificat valide).",
  'Dal Control Plane':
    'Depuis le Control Plane',
  'Documentati':
    'Documentées',
  'Documentati e trovati. «nome diverso» segnala che phpIPAM e la CMDB chiamano la macchina in due modi.':
    'Documentées et trouvées. « nom différent » signale que phpIPAM et la CMDB appellent la machine de deux façons.',
  'Documentati ma non trovati':
    'Documentées mais non trouvées',
  'IPAM (phpIPAM)':
    'IPAM (phpIPAM)',
  "Identificativo dell'API app di phpIPAM, configurata in Administration → API, con privilegi di lettura o di lettura/scrittura in base all'opzione «Consenti la scrittura».": "Identifiant de l'API app de phpIPAM, configurée sous Administration → API, avec des privilèges de lecture ou de lecture/écriture selon l'option «Consenti la scrittura».",
  'In uso ma non documentati':
    'Utilisées mais non documentées',
  'Indirizzi che la discovery ha trovato in questa subnet e che phpIPAM non conosce: documentali, o sono il prossimo conflitto di indirizzo.':
    "Adresses que la découverte a trouvées dans ce sous-réseau et que phpIPAM ne connaît pas : documentez-les, ou ce sera le prochain conflit d'adresse.",
  'Indirizzi che phpIPAM dà in uso e che nessuna scansione ha visto: da liberare, oppure apparati spenti o fuori dal perimetro delle scansioni.':
    "Adresses que phpIPAM indique comme utilisées et qu'aucune analyse n'a vues : à libérer, ou équipements éteints ou hors du périmètre des analyses.",
  'Indirizzi documentati':
    'Adresses documentées',
  'Indirizzi riservati o del DHCP in phpIPAM: non assegnati a una macchina, non ci si aspetta di trovarli.':
    "Adresses réservées ou DHCP dans phpIPAM : non attribuées à une machine, on ne s'attend pas à les trouver.",
  'Indirizzo di phpIPAM':
    'Adresse de phpIPAM',
  'Interrogo phpIPAM…':
    'Interrogation de phpIPAM…',
  "L'app con sicurezza «SSL with App code token»: il codice mostrato da phpIPAM viaggia nell'header `token` a ogni richiesta. Nessun utente coinvolto, revocabile disattivando l'app.":
    "L'app avec la sécurité « SSL with App code token » : le code affiché par phpIPAM voyage dans l'en-tête `token` à chaque requête. Aucun utilisateur impliqué, révocable en désactivant l'app.",
  "L'app con sicurezza «SSL with User token»: CENSO fa il login (`POST /api/<App ID>/user/`) e usa il token a scadenza che ne riceve. Meglio un utente dedicato, in sola lettura sulle sezioni da vedere (o con scrittura, se accendi «Consenti la scrittura»).":
    'L’app avec la sécurité «SSL with User token» : CENSO se connecte (`POST /api/<App ID>/user/`) et utilise le jeton à durée limitée qu’il reçoit. De préférence un utilisateur dédié, en lecture seule sur les sections à voir (ou avec écriture, si vous activez «Autoriser l’écriture»).',
  "URL base dell'istanza phpIPAM, senza /api. L'endpoint API è /api/<App ID>/; in assenza di schema viene utilizzato HTTPS, richiesto per l'autenticazione tramite token.": "URL de base de l'instance phpIPAM, sans /api. L'endpoint API est /api/<App ID>/ ; HTTPS est utilisé en l'absence de schéma, requis pour l'authentification par token.",
  "Lettura in tempo reale dell'IPAM del cliente (phpIPAM via REST API): subnet, indirizzi e VLAN documentati, da confrontare con ciò che la discovery ha trovato. Non apre porte e non avvia job — la query esce da questa sonda attraverso il relay. Abilitala dove la sonda raggiunge phpIPAM.":
    "Lecture en temps réel de l'IPAM du client (phpIPAM via API REST) : sous-réseaux, adresses et VLAN documentés, à comparer avec ce que la découverte a trouvé. N'ouvre aucun port et ne lance aucun job — la requête sort de cette sonde via le relais. Activez-la là où la sonde joint phpIPAM.",
  'Spazio di indirizzamento IP letto da phpIPAM e confrontato con gli asset rilevati dalla discovery: la pagina si apre con l’ultima lettura e si aggiorna in sottofondo, il confronto è sempre con la CMDB di adesso.': 'Espace d’adressage IP lu dans phpIPAM et comparé aux assets trouvés par la découverte : la page s’ouvre avec la dernière lecture et se met à jour en arrière-plan, la comparaison est toujours avec la CMDB actuelle.',
  'Nessun indirizzo documentato':
    'Aucune adresse documentée',
  'Nessun indirizzo in questo gruppo.':
    'Aucune adresse dans ce groupe.',
  'Nessuna subnet':
    'Aucun sous-réseau',
  'Nessuno: tutto ciò che è in uso è documentato.':
    'Aucune : tout ce qui est utilisé est documenté.',
  'Nome in phpIPAM':
    'Nom dans phpIPAM',
  'Nomi diversi':
    'Noms différents',
  'Non documentati':
    'Non documentées',
  'Non trovati':
    'Non trouvées',
  'Occupazione':
    'Occupation',
  'Per le chiamate verso questo sistema, fatte dal Control Plane.':
    'Pour les appels vers ce système, effectués par le Control Plane.',
  'Riservati e DHCP':
    'Réservées et DHCP',
  'Seleziona una subnet per confrontare ogni indirizzo IP documentato in phpIPAM con i rilevamenti della discovery.': 'Sélectionnez un sous-réseau pour comparer chaque adresse IP documentée dans phpIPAM avec les relevés de la découverte.',
  'Stato in phpIPAM':
    'État dans phpIPAM',
  'Subnet documentate':
    'Sous-réseaux documentés',
  'Ultima vista (phpIPAM)':
    'Vue pour la dernière fois (phpIPAM)',
  'censo':
    'censo',
  'https://ipam.example.com':
    'https://ipam.example.com',
  'nome diverso':
    'nom différent',
  'phpIPAM':
    'phpIPAM',
  'phpIPAM non conosce nessuno degli indirizzi di questo oggetto.':
    'phpIPAM ne connaît aucune des adresses de cet objet.',
  'phpIPAM non ha subnet, oppure l’app non ha i permessi di lettura sulle sezioni.':
    "phpIPAM n'a pas de sous-réseaux, ou l'app n'a pas les droits de lecture sur les sections.",
  'il confronto fra lo spazio IP documentato in phpIPAM e quello trovato dalla discovery, subnet per subnet: indirizzi allineati, in uso ma non documentati (il prossimo conflitto di indirizzo), documentati ma non trovati (da liberare o spenti), e dove phpIPAM e la CMDB chiamano la stessa macchina con nomi diversi. Sulla scheda di un CI, che cosa phpIPAM documenta per i suoi indirizzi.':
    "la comparaison entre l'espace IP documenté dans phpIPAM et celui trouvé par la découverte, sous-réseau par sous-réseau : adresses alignées, utilisées mais non documentées (le prochain conflit d'adresse), documentées mais non trouvées (à libérer ou éteintes), et là où phpIPAM et la CMDB appellent la même machine par des noms différents. Dans la fiche d'un CI, ce que phpIPAM documente pour ses adresses.",
  'Per phpIPAM crea in phpIPAM un’«API app» in sola lettura (Administration → API) e poi una credenziale «phpIPAM» con l’indirizzo e l’App ID: codice dell’app (sicurezza «SSL with App code token») oppure utente e password. Scegli da dove si parla: da una sonda, se phpIPAM sta nella rete del cliente, o dal Control Plane, se è raggiungibile da Internet con un certificato valido. Gli indirizzi riservati o del DHCP non contano come «non trovati».':
    "Pour phpIPAM, créez dans phpIPAM une « API app » en lecture seule (Administration → API) puis un identifiant « phpIPAM » avec l'adresse et l'App ID : code de l'app (sécurité « SSL with App code token ») ou utilisateur et mot de passe. Choisissez d'où parler : depuis une sonde, si phpIPAM est dans le réseau du client, ou depuis le Control Plane, s'il est joignable depuis Internet avec un certificat valide. Les adresses réservées ou DHCP ne comptent pas comme « non trouvées ».",
  'inclusa nel piano':
    'incluse dans le plan',
  'I loro add-on si conservano. Chi ha una licenza più vecchia si allinea a quello che il piano comprende adesso.':
    "Leurs add-ons sont conservés. Ceux qui ont une licence plus ancienne s'alignent sur ce que le plan comprend maintenant.",
  'Modificare un piano cambia le assegnazioni future. Le licenze già emesse restano com’erano — un cliente non si vede togliere una funzione perché qualcuno ha corretto il listino — e per allinearle c’è «Riapplica ai clienti», che conserva i loro add-on.':
    "Modifier un plan change les attributions futures. Les licences déjà émises restent telles quelles — un client ne perd pas une fonction parce que quelqu'un a corrigé le catalogue — et pour les aligner il y a « Réappliquer aux clients », qui conserve leurs add-ons.",
  'CI massimi':
    'CI maximum',
  'La fine deve seguire l’inizio.':
    'La fin doit suivre le début.',
  'Sonde massime':
    'Sondes maximum',
  'con una data':
    'par une date',
  'in giorni':
    'en jours',
  'Accesso al tenant interrotto finché la licenza non viene estesa.':
    "Accès au tenant interrompu tant que la licence n'est pas prolongée.",
  'Da eliminare dal {data}':
    'À supprimer depuis le {data}',
  'Estendi +{n} gg':
    'Prolonger +{n} j',
  'Il periodo di prova è terminato':
    "La période d'essai est terminée",
  'La licenza è scaduta':
    'La licence a expiré',
  'Licenza scaduta da oltre 15 giorni senza estensioni. Estendendola, il segno sparisce.':
    'Licence expirée depuis plus de 15 jours sans prolongation. En la prolongeant, la marque disparaît.',
  'Per continuare a usare CENSO contatta il tuo fornitore: i dati sono conservati e tornano disponibili appena la licenza viene estesa.':
    'Pour continuer à utiliser CENSO, contactez votre fournisseur : les données sont conservées et redeviennent disponibles dès que la licence est prolongée.',
  'Per continuare a usare CENSO contatta il tuo fornitore: i dati sono conservati e tornano disponibili appena la licenza viene rinnovata.':
    'Pour continuer à utiliser CENSO, contactez votre fournisseur : les données sont conservées et redeviennent disponibles dès que la licence est renouvelée.',
  'Scaduta il {data}.':
    'Expirée le {data}.',
  'Sposta la scadenza della prova di {n} giorni (da oggi se è già scaduta).':
    "Repousse l'expiration de l'essai de {n} jours (à partir d'aujourd'hui si elle est déjà expirée).",
  'Vai a un altro tenant':
    'Aller à un autre tenant',
  'prova terminata':
    'essai terminé',
  'scaduta':
    'expirée',
  '+{n} giorni':
    '+{n} jours',
  'Approva':
    'Approuver',
  'Estendi la prova di {n} giorni':
    "Prolonger l'essai de {n} jours",
  'La prima estensione è immediata.':
    'La première prolongation est immédiate.',
  'Le estensioni successive le approva il fornitore: riceverai l’accesso appena approvata.':
    "Les prolongations suivantes sont approuvées par le fournisseur : vous retrouverez l'accès dès son approbation.",
  'L’ultima richiesta di estensione non è stata approvata.':
    "La dernière demande de prolongation n'a pas été approuvée.",
  'Puoi farne un’altra dal {data}.':
    'Vous pourrez en faire une autre à partir du {data}.',
  'Richiedi altri {n} giorni':
    'Demander {n} jours de plus',
  'Richiesta di {n} giorni inviata il {data}: in attesa di approvazione del fornitore.':
    "Demande de {n} jours envoyée le {data} : en attente de l'approbation du fournisseur.",
  'Richieste di estensione della prova ({n})':
    "Demandes de prolongation d'essai ({n})",
  'Rifiuta':
    'Refuser',
  'A questo tenant non è assegnata una licenza: contatta il tuo fornitore.':
    "Aucune licence n'est attribuée à ce tenant : contactez votre fournisseur.",
  'Nessuna licenza assegnata':
    'Aucune licence attribuée',
  'Ogni tenant nasce con una licenza. La trial comprende tutti i moduli fino alla scadenza.':
    "Chaque tenant naît avec une licence. L'essai comprend tous les modules jusqu'à son expiration.",
  'Un tenant non ha una licenza. Ogni tenant deve averne una: entro pochi secondi riceve da solo una trial di 30 giorni, che puoi cambiare qui.':
    "Un tenant n'a pas de licence. Chaque tenant doit en avoir une : d'ici quelques secondes il reçoit automatiquement un essai de 30 jours, que vous pouvez modifier ici.",
  'Vuota = 30 giorni. Alla scadenza l’accesso al tenant si interrompe.':
    "Vide = 30 jours. À l'expiration, l'accès au tenant est interrompu.",
  'Vuota = senza scadenza.':
    'Vide = sans expiration.',
  '{n} tenant non hanno una licenza. Ogni tenant deve averne una: entro pochi secondi ricevono da soli una trial di 30 giorni, che puoi cambiare qui.':
    "{n} tenants n'ont pas de licence. Chaque tenant doit en avoir une : d'ici quelques secondes ils reçoivent automatiquement un essai de 30 jours, que vous pouvez modifier ici.",
  'Nessuna VM in questo gruppo.':
    'Aucune VM dans ce groupe.',
  'Nessuna macchina virtuale in CMDB.':
    'Aucune machine virtuelle dans la CMDB.',
  'Oggetto di backup':
    'Objet de sauvegarde',
  'Protette':
    'Protégées',
  'VM protette da backup':
    'VM protégées par sauvegarde',
  'VM senza backup':
    'VM sans sauvegarde',
  '«VM protette da backup» confronta le macchine virtuali della CMDB con gli oggetti protetti letti dal backup (Veeam, Vinchin, Commvault, Rubrik) in tempo reale: un clic su una fetta elenca quali VM sono protette (con l’oggetto di backup che le copre) e quali no, ognuna con il collegamento alla scheda.':
    "« VM protégées par sauvegarde » compare les machines virtuelles de la CMDB aux objets protégés lus dans la sauvegarde (Veeam, Vinchin, Commvault, Rubrik) en temps réel : un clic sur une part liste quelles VM sont protégées (avec l'objet de sauvegarde qui les couvre) et lesquelles ne le sont pas, chacune avec le lien vers sa fiche.",
  'Add-on':
    'Options',
  'CI':
    'CI',
  'Funzioni che il piano scelto non comprende, concesse in più a questo cliente.':
    'Fonctions que le plan choisi ne comprend pas, accordées en plus à ce client.',
  'Il numero di asset venduto al cliente: fissalo e resta così a prescindere dal piano. Non fissato = segue il listino del piano.':
    "Le nombre d'actifs vendu au client : fixez-le et il reste tel quel quel que soit le plan. Non fixé = suit le tarif du plan.",
  'Le quote sono numeri interi non negativi (vuoto = illimitati).':
    'Les quotas sont des entiers non négatifs (vide = illimité).',
  'Nessun ordine registrato. Una licenza a pagamento si attiva con «Nuovo ordine» sulla riga del cliente.':
    "Aucune commande enregistrée. Une licence payante s'active avec « Nouvelle commande » sur la ligne du client.",
  'Nessun ordine registrato: la licenza di questo cliente è una prova o è stata assegnata a mano.':
    'Aucune commande enregistrée : la licence de ce client est un essai ou a été attribuée à la main.',
  'Nessun piano a pagamento nel listino.':
    'Aucun plan payant dans le tarif.',
  'Nessuna modifica registrata.':
    'Aucune modification enregistrée.',
  'Nuovo ordine':
    'Nouvelle commande',
  'Ordini':
    'Commandes',
  'Ordini ({n})':
    'Commandes ({n})',
  'Ordini e storico':
    'Commandes et historique',
  'Quote':
    'Quotas',
  'Registra ciò che il cliente ha comprato e attiva la licenza a pagamento. L’ordine resta in archivio, legato al cliente; quello precedente viene segnato come sostituito. Add-on e quote scritti qui restano fissi a prescindere dal piano.':
    'Enregistre ce que le client a acheté et active la licence payante. La commande reste archivée, liée au client ; la précédente est marquée comme remplacée. Options et quotas écrits ici restent fixes quel que soit le plan.',
  'Registra l’ordine e attiva la licenza':
    'Enregistrer la commande et activer la licence',
  'Registra una scheda ordine: piano, add-on, quote e validità così come venduti. Attiva la licenza a pagamento.':
    'Enregistre une fiche de commande : plan, options, quotas et validité tels que vendus. Active la licence payante.',
  'Registrato da':
    'Enregistré par',
  'Registro delle modifiche':
    'Journal des modifications',
  'Registro…':
    'Enregistrement…',
  'Riferimento cliente':
    'Référence client',
  'Riferimento cliente: {rif}':
    'Référence client : {rif}',
  'Scheda ordine — {cliente}':
    'Fiche de commande — {cliente}',
  'Ultimo giorno':
    'Dernier jour',
  'numero d’ordine, contratto, offerta':
    'numéro de commande, contrat, devis',
  'Validità':
    'Validité',
  'dal {data}':
    'du {data}',
  'sostituito':
    'remplacé',
  'annullato':
    'annulé',
  'ordine':
    'commande',
  'modifica a mano':
    'modification manuelle',
  'estensione della prova':
    "prolongation de l'essai",
  'trial automatica':
    'essai automatique',
  'creazione del tenant':
    'création du tenant',
  'riapplica ai clienti':
    'réappliquer aux clients',
  'revoca':
    'révocation',
  'di listino':
    'du tarif',
  'La prima estensione (7 giorni) si approva da sola; queste sono le successive, di 15 giorni ciascuna. Approvando, la scadenza si sposta di 15 giorni (da oggi se è già passata).':
    "La première prolongation (7 jours) est approuvée automatiquement ; celles-ci sont les suivantes, de 15 jours chacune. En approuvant, l'échéance est repoussée de 15 jours (à partir d'aujourd'hui si elle est déjà passée).",
  'Ordini e storico — {cliente}':
    'Commandes et historique — {cliente}',
  'Scegli il cliente e compila la scheda: piano, add-on, quote e validità così come venduti. Registrarla attiva la licenza a pagamento e sostituisce l’ordine precedente, che resta in archivio.':
    "Choisissez le client et remplissez la fiche : plan, options, quotas et validité tels que vendus. L'enregistrer active la licence payante et remplace la commande précédente, qui reste archivée.",
  'Scheda ordine che attiva la licenza a pagamento; ordini e storico per cliente':
    'Fiche de commande qui active la licence payante ; commandes et historique par client',
  'Aggiungi amministratore':
    'Ajouter un administrateur',
  'Chiave «{nome}» generata. Copiala ora: non si rivede.':
    'Clé « {nome} » générée. Copiez-la maintenant : elle ne sera plus affichée.',
  'Chiavi API della piattaforma':
    'Clés API de la plateforme',
  'L’ho copiata':
    "Je l'ai copiée",
  'Nessuna chiave.':
    'Aucune clé.',
  'Per collegare plugin e sistemi esterni (il plugin WordPress, un CRM) alle API di amministrazione: licenze, ordini, clienti. Chi presenta la chiave opera come amministratore di piattaforma, solo sulle API di amministrazione. Si manda come «Authorization: Bearer <chiave>».':
    "Pour connecter des plugins et des systèmes externes (le plugin WordPress, un CRM) aux API d'administration : licences, commandes, clients. Qui présente la clé agit comme administrateur de plateforme, uniquement sur les API d'administration. Elle s'envoie en « Authorization: Bearer <clé> ».",
  'Revocare la chiave «{nome}»? Da questo istante non apre più niente.':
    "Révoquer la clé « {nome} » ? Dès cet instant elle n'ouvre plus rien.",
  'Scade':
    'Expire',
  'Togliere a {email} il ruolo di amministratore di piattaforma? L’utenza resta.':
    "Retirer à {email} le rôle d'administrateur de plateforme ? Le compte reste.",
  'Ultimo uso':
    'Dernière utilisation',
  'Utenza esistente promossa ad amministratore di piattaforma.':
    'Compte existant promu administrateur de plateforme.',
  'mai usata':
    'jamais utilisée',
  'nome (es. plugin WordPress)':
    'nom (ex. plugin WordPress)',
  'nota (facoltativa)':
    'note (facultative)',
  'password (vuota = invito via email)':
    'mot de passe (vide = invitation par e-mail)',
  'revocata':
    'révoquée',
  'scade fra N giorni (vuoto = mai)':
    'expire dans N jours (vide = jamais)',
  'togli il ruolo':
    'retirer le rôle',
  'Aggiungi un amministratore di piattaforma. Un’email nuova crea l’utenza: senza password parte l’invito via posta con il collegamento alla console di amministrazione; con la password scritta qui parte un benvenuto con l’indirizzo della console (la password comunicala di persona). Un’email esistente viene promossa. «Reinvia invito» rimanda il collegamento.':
    "Ajoutez un administrateur de plateforme. Un nouvel e-mail crée le compte : sans mot de passe, une invitation part par e-mail avec le lien vers la console d'administration ; avec le mot de passe saisi ici, un message de bienvenue part avec l'adresse de la console (communiquez le mot de passe en personne). Un e-mail existant est promu. « Renvoyer l'invitation » renvoie le lien.",
  'Amministratore creato: gli è partita un’email con l’indirizzo della console; la password comunicagliela di persona.':
    "Administrateur créé : un e-mail avec l'adresse de la console est parti ; communiquez-lui le mot de passe en personne.",
  'Amministratore creato: riceverà un invito via email con il collegamento alla console di amministrazione per scegliere la password.':
    "Administrateur créé : il recevra une invitation par e-mail avec le lien vers la console d'administration pour choisir son mot de passe.",
  'Invito inviato di nuovo a {email}: collegamento alla console di amministrazione, valido per la durata degli inviti.':
    "Invitation renvoyée à {email} : lien vers la console d'administration, valable pendant la durée des invitations.",
  'Manda di nuovo l’email con il collegamento per impostare la password.':
    "Renvoyer l'e-mail avec le lien pour définir le mot de passe.",
  'reinvia invito':
    "renvoyer l'invitation",
  'Email di benvenuto':
    'E-mail de bienvenue',
  'Manda «Il tuo ambiente è pronto» agli amministratori del tenant: indirizzo, piano e date, primi passi, certificato di licenza allegato.':
    'Envoie « Votre environnement est prêt » aux administrateurs du tenant : adresse, plan et dates, premiers pas, certificat de licence en pièce jointe.',
  'Email di benvenuto inviata a: {chi}':
    'E-mail de bienvenue envoyé à : {chi}',
  'Legge dal DNS SPF, DKIM e DMARC del dominio del mittente: sono ciò che decide se la posta finisce nella posta indesiderata.':
    "Lit dans le DNS le SPF, le DKIM et le DMARC du domaine de l'expéditeur : ce sont eux qui décident si le courrier finit dans les indésirables.",
  'Verifica recapito (SPF/DKIM/DMARC)':
    "Vérifier la délivrabilité (SPF/DKIM/DMARC)",
  'Recapito per {dominio}':
    "Délivrabilité pour {dominio}",
  'da migliorare':
    "à améliorer",
  'Conta anche che il mittente della busta (envelope-from) sia sullo stesso dominio del mittente visibile: con il relay autenticato della piattaforma lo è; con mail() del server web non lo era (SPF none).':
    "L'expéditeur de l'enveloppe (envelope-from) doit aussi être sur le même domaine que l'expéditeur visible : avec le relais authentifié de la plateforme c'est le cas ; avec mail() du serveur web ce ne l'était pas (SPF none).",
  'Banco di memoria':
    "Barrette mémoire",
  'Scheda di rete':
    "Carte réseau",
  'Controller RAID':
    "Contrôleur RAID",
  'Nella scansione SNMP approfondita l’iDRAC descrive anche il server in cui sta, come un controller wireless descrive i suoi access point: modello, BIOS, sistema operativo, salute, e i componenti — processori, banchi di memoria, dischi, schede di rete, alimentatori, controller RAID — con i loro seriali, nella sezione Componenti della scheda del server. Il server nasce in CMDB anche se spento o senza agente, e quando poi lo si vede via SSH o da vCenter è lo stesso CI.':
    "Lors du balayage SNMP approfondi, l’iDRAC décrit aussi le serveur dans lequel il se trouve, comme un contrôleur sans fil décrit ses points d’accès : modèle, BIOS, système d’exploitation, santé, et les composants — processeurs, barrettes mémoire, disques, cartes réseau, alimentations, contrôleurs RAID — avec leurs numéros de série, dans la section Composants de la fiche du serveur. Le serveur naît dans la CMDB même éteint ou sans agent, et lorsqu’il est ensuite vu via SSH ou depuis vCenter, c’est le même CI.",
  "L'indirizzo della console Vinchin (la stessa porta 443 del web): l'API sta sotto `/api/`. Senza schema si assume https.":
    "L'adresse de la console Vinchin (le même port 443 que le web) : l'API se trouve sous `/api/`. Sans schéma, https est supposé.",
  "Un'utenza della console Vinchin che **veda tutte le risorse** (Vinchin mostra a ogni utente solo ciò che gli è assegnato: un'utenza senza risorse legge zero job senza errori), meglio se di sola lettura. La sonda entra a ogni interrogazione e chiude la sessione alla fine; il primo accesso e il cambio password vanno fatti prima dalla console.":
    'Un compte de la console Vinchin qui **voit toutes les ressources** (Vinchin ne montre à chaque utilisateur que ce qui lui est attribué : un compte sans ressources lit zéro job sans erreur), de préférence en lecture seule. La sonde se connecte à chaque interrogation et ferme la session à la fin ; la première connexion et le changement de mot de passe se font d’abord depuis la console.',
  'Chiave API (non verificata)':
    'Clé API (non vérifiée)',
  'Una chiave di Sistema → Impostazioni di sistema → API Key Management, mandata al posto del token di sessione. Come Vinchin la accetti non è documentato: se la pagina Backup dà errore, usa utente e password.':
    'Une clé de Système → Paramètres système → API Key Management, envoyée à la place du jeton de session. La manière dont Vinchin l’accepte n’est pas documentée : si la page Backup affiche une erreur, utilisez nom d’utilisateur et mot de passe.',
  'Per Vinchin crea una credenziale «Vinchin Backup & Recovery» con l’indirizzo della console e un’utenza che veda tutte le risorse (per esempio un amministratore in sola lettura): Vinchin mostra a ogni utente solo ciò che gli è assegnato, e un’utenza senza risorse legge zero job senza errori. Il primo accesso e il cambio password falli prima dalla console; dopo tre login sbagliati Vinchin chiede il captcha e il collegamento si ferma finché non entri a mano.':
    'Pour Vinchin, créez un identifiant «Vinchin Backup & Recovery» avec l’adresse de la console et un compte qui voit toutes les ressources (par exemple un administrateur en lecture seule) : Vinchin ne montre à chaque utilisateur que ce qui lui est attribué, et un compte sans ressources lit zéro job sans erreur. Faites d’abord la première connexion et le changement de mot de passe depuis la console ; après trois connexions erronées, Vinchin demande un captcha et la liaison s’arrête jusqu’à ce que vous vous connectiez à la main.',
  'Annullato':
    'Annulé',
  'Collo di bottiglia':
    'Goulot d’étranglement',
  'Dati dell’ultima esecuzione':
    'Données de la dernière exécution',
  'Durata media':
    'Durée moyenne',
  'Elaborati':
    'Traités',
  'Il grafico compare con almeno due esecuzioni di cui il prodotto dà dati elaborati e durata.':
    'Le graphique apparaît avec au moins deux exécutions dont le produit fournit les données traitées et la durée.',
  'Il prodotto non ha esecuzioni recenti di questo job, oppure l’utenza non le vede.':
    'Le produit n’a pas d’exécutions récentes de ce job, ou le compte ne les voit pas.',
  'Il prodotto non ha righe di log per questa esecuzione.':
    'Le produit n’a pas de lignes de journal pour cette exécution.',
  'Leggo il log…':
    'Lecture du journal…',
  'Log':
    'Journal',
  'Log non disponibile.':
    'Journal non disponible.',
  'Non protette':
    'Non protégées',
  'Oggetti dell’esecuzione':
    'Objets de l’exécution',
  'Riuscite':
    'Réussies',
  'Trasferiti':
    'Transférés',
  'Tutte le VM sono protette':
    'Toutes les VM sont protégées',
  'Una VM risulta protetta quando un oggetto di backup di qualunque fornitore porta il suo nome (intero o corto). Una VM con nomi diversi nel backup e nella CMDB appare qui anche se è protetta.':
    'Une VM est considérée comme protégée lorsqu’un objet de sauvegarde de n’importe quel fournisseur porte son nom (complet ou court). Une VM qui porte des noms différents dans la sauvegarde et dans la CMDB apparaît ici même si elle est protégée.',
  'VM nella CMDB':
    'VM dans la CMDB',
  'VM non protette':
    'VM non protégées',
  'Velocità media':
    'Vitesse moyenne',
  'Velocità per esecuzione (GB/h)':
    'Vitesse par exécution (GB/h)',
  'max {v}':
    'max {v}',
  '{n} su {tot}':
    '{n} sur {tot}',
  'Nella pagina Backup il nome di un job apre la sua pagina: le ultime esecuzioni con esito, durata, dati elaborati e trasferiti, velocità in GB/h e il grafico del suo andamento; aprendo un’esecuzione si vedono gli oggetti (su Veeam, VM per VM, con il collo di bottiglia) e il log. La sezione «VM non protette» elenca le macchine virtuali della CMDB che nessun backup copre, ognuna con il collegamento alla scheda.':
    'Dans la page Backup, le nom d’un job ouvre sa page : les dernières exécutions avec résultat, durée, données traitées et transférées, vitesse en GB/h et le graphique de son évolution ; en ouvrant une exécution on voit ses objets (sur Veeam, VM par VM, avec le goulot d’étranglement) et le journal. La section «VM non protégées» liste les machines virtuelles de la CMDB qu’aucune sauvegarde ne couvre, chacune avec le lien vers sa fiche.',
  'Commvault':
    'Commvault',
  'Rubrik':
    'Rubrik',
  'Indirizzo del Web Server':
    'Adresse du Web Server',
  "L'indirizzo dell'API del Web Server o del Command Center. Con il solo host si assume `/commandcenter/api`; va bene anche `…/webconsole/api`. Senza schema si assume https.":
    'L’adresse de l’API du Web Server ou du Command Center. Avec le seul hôte, `/commandcenter/api` est supposé ; `…/webconsole/api` convient aussi. Sans schéma, https est supposé.',
  'https://commserve.example.com/commandcenter/api':
    'https://commserve.example.com/commandcenter/api',
  "Un'utenza Commvault che veda client, job e storage, meglio in sola lettura (ruolo View). Utente di dominio nella forma `DOMINIO\\utente`. Si entra a ogni interrogazione e si esce alla fine.":
    "Un compte Commvault qui voit clients, jobs et stockage, de préférence en lecture seule (rôle View). Utilisateur de domaine sous la forme `DOMAINE\\utilisateur`. Il se connecte à chaque interrogation et se déconnecte à la fin.",
  "Per Rubrik Security Cloud l'indirizzo dell'account (`https://<account>.my.rubrik.com`), da interrogare dal Control Plane; per un cluster CDM l'indirizzo del cluster, da una sonda.":
    'Pour Rubrik Security Cloud l’adresse du compte (`https://<account>.my.rubrik.com`), interrogée depuis le Control Plane ; pour un cluster CDM l’adresse du cluster, depuis une sonde.',
  'https://account.my.rubrik.com':
    'https://account.my.rubrik.com',
  'Rubrik Security Cloud — service account':
    'Rubrik Security Cloud — compte de service',
  'Un service account creato in RSC (Impostazioni → Utenti e accessi → Service account) con un ruolo in sola lettura: client ID e secret si leggono dal file JSON scaricato alla creazione.':
    'Un compte de service créé dans RSC (Paramètres → Utilisateurs et accès → Comptes de service) avec un rôle en lecture seule : client ID et secret se trouvent dans le fichier JSON téléchargé à la création.',
  'Cluster CDM — service account':
    'Cluster CDM — compte de service',
  'ID del service account':
    'ID du compte de service',
  'Secret':
    'Secret',
  'Un service account del cluster (Impostazioni → Utenti → Service account) con un ruolo in sola lettura.':
    'Un compte de service du cluster (Paramètres → Utilisateurs → Comptes de service) avec un rôle en lecture seule.',
  'Cluster CDM — utente e password':
    'Cluster CDM — utilisateur et mot de passe',
  "Un'utenza locale o di dominio del cluster, meglio in sola lettura.":
    'Un compte local ou de domaine du cluster, de préférence en lecture seule.',
  'Per Commvault crea una credenziale «Commvault» con l’indirizzo del Web Server o del Command Center e un’utenza in sola lettura; si interroga da una sonda o, se il Web Server è pubblicato, dal Control Plane. Per Rubrik crea una credenziale «Rubrik»: con Rubrik Security Cloud usa un service account di RSC e scegli di parlare dal Control Plane; con un cluster CDM in sede usa un service account del cluster (o utente e password) e una sonda. In Commvault ogni riga dei job è un subclient; in Rubrik è un oggetto protetto, con il suo SLA Domain.':
    'Pour Commvault, créez un identifiant «Commvault» avec l’adresse du Web Server ou du Command Center et un compte en lecture seule ; il est interrogé depuis une sonde ou, si le Web Server est publié, depuis le Control Plane. Pour Rubrik, créez un identifiant «Rubrik» : avec Rubrik Security Cloud, utilisez un compte de service RSC et choisissez de parler depuis le Control Plane ; avec un cluster CDM sur site, utilisez un compte de service du cluster (ou utilisateur et mot de passe) et une sonde. Dans Commvault chaque ligne de job est un subclient ; dans Rubrik c’est un objet protégé, avec son SLA Domain.',
  'Dettagli tecnici':
    'Détails techniques',
  '{n} di {tot} {nome}':
    '{n} sur {tot} {nome}',
  '{tot} {nome}':
    '{tot} {nome}',
  'oggetti protetti':
    'objets protégés',
  'Aggiungi un firewall «Palo Alto (firewall)» o «Fortinet FortiGate (firewall)» qui sotto, in «Connessioni».':
    'Ajoutez un pare-feu «Palo Alto (firewall)» ou «Fortinet FortiGate (firewall)» ci-dessous, dans «Connexions».',
  'Sistemi interrogati in tempo reale dal modulo. Le credenziali di accesso sono cifrate e non sono più visualizzabili dopo il salvataggio.': 'Systèmes interrogés en temps réel par le module. Les identifiants d’accès sont chiffrés et ne sont plus visualisables après l’enregistrement.',
  'Le credenziali dei sistemi letti in tempo reale (backup, IPAM, DNS, Wazuh, firewall, ntopng) si gestiscono nel loro modulo, sezione «Connessioni».':
    'Les identifiants des systèmes lus en temps réel (sauvegarde, IPAM, DNS, Wazuh, pare-feu, ntopng) se gèrent dans leur module, section «Connexions».',
  'Catalogo centralizzato delle sorgenti dati per rete, virtualizzazione, storage, sicurezza, backup e DNS. Mostra per ciascuna sorgente lo stato operativo, connessa, non configurata o in errore, e le credenziali associate.': 'Catalogue centralisé des sources de données pour le réseau, la virtualisation, le stockage, la sécurité, la sauvegarde et le DNS. Pour chaque source, il affiche l’état opérationnel — connectée, non configurée ou en erreur — et les identifiants associés.',
  'Nuova connessione':
    'Nouvelle connexion',
  'Dati elaborati':
    'Données traitées',
  'Durata media per job':
    'Durée moyenne par job',
  'Esito dell’ultima esecuzione':
    'Résultat de la dernière exécution',
  'Il sistema di backup non ha esecuzioni negli ultimi giorni, oppure l’utenza non le vede.':
    'Le système de sauvegarde n’a pas d’exécutions ces derniers jours, ou le compte ne les voit pas.',
  'Nessun dato da confrontare.':
    'Aucune donnée à comparer.',
  'Nessun job con un esito.':
    'Aucun job avec un résultat.',
  'Nessuna VM da confrontare.':
    'Aucune VM à comparer.',
  'Nessuna esecuzione recente':
    'Aucune exécution récente',
  'Nessuna repository con la capacità nota.':
    'Aucun dépôt avec une capacité connue.',
  'Occupazione delle repository':
    'Occupation des dépôts',
  'Prestazioni':
    'Performances',
  'Prestazioni dei job':
    'Performances des jobs',
  'Ultima durata':
    'Dernière durée',
  'VM della CMDB protette':
    'VM de la CMDB protégées',
  'Velocità media per job (GB/h)':
    'Vitesse moyenne par job (GB/h)',
  'job':
    'jobs',
  '{n} job senza un esito (mai eseguiti, in corso o senza storico).':
    '{n} jobs sans résultat (jamais exécutés, en cours ou sans historique).',
  'Il cruscotto del Backup mostra, oltre ai numeri, l’esito dell’ultima esecuzione di ogni job, la ruota delle VM della CMDB protette e l’occupazione di ogni repository. La sezione «Prestazioni» riassume le esecuzioni recenti di tutti i fornitori job per job: quante, quante riuscite, durata media e ultima, velocità media in GB/h e dati elaborati, con il confronto fra job su velocità e durata; il nome di un job apre la sua pagina.':
    'Outre les chiffres, le tableau de bord Backup montre le résultat de la dernière exécution de chaque job, la roue des VM de la CMDB protégées et l’occupation de chaque dépôt. La section «Performances» résume les exécutions récentes de tous les fournisseurs job par job : combien, combien réussies, durée moyenne et dernière, vitesse moyenne en GB/h et données traitées, avec la comparaison entre jobs sur vitesse et durée ; le nom d’un job ouvre sa page.',
  'Prodotti supportati: ServiceNow, Matrix42 ESM, BMC Remedy, ManageEngine ServiceDesk Plus e Jira Service Management Assets (la CMDB di Jira, Cloud o Data Center): per Jira Cloud servono l’email dell’utenza e un API token, per Data Center un Personal Access Token; i tipi di oggetto sono quelli degli schemi di Assets.':
    'Produits pris en charge : ServiceNow, Matrix42 ESM, BMC Remedy, ManageEngine ServiceDesk Plus et Jira Service Management Assets (la CMDB de Jira, Cloud ou Data Center) : Jira Cloud demande l’email du compte et un jeton API, Data Center un Personal Access Token ; les types d’objet sont ceux des schémas Assets.',
  'A) Jira Cloud':
    'A) Jira Cloud',
  'B) Jira Data Center':
    'B) Jira Data Center',
  'C) Dove trovare le cose in Assets':
    'C) Où trouver les éléments dans Assets',
  'Come collego Jira, e dove trovo le cose?':
    'Comment connecter Jira, et où trouver les éléments ?',
  'Il connettore scrive nella CMDB di Jira, cioè Jira Service Management Assets, non nei ticket. Servono Jira Service Management con Assets attivo e un’utenza che veda gli schemi da sincronizzare.':
    'Le connecteur écrit dans la CMDB de Jira, c’est-à-dire Jira Service Management Assets, pas dans les tickets. Il faut Jira Service Management avec Assets activé et un compte qui voit les schémas à synchroniser.',
  'Indirizzo: il sito, per esempio https://azienda.atlassian.net, senza percorsi. Installazione: cloud.':
    'Adresse : le site, par exemple https://azienda.atlassian.net, sans chemin. Installation : cloud.',
  'Utenza: meglio una dedicata, con licenza agente di Jira Service Management. In Assets apri lo schema → Impostazioni dello schema → Ruoli e dalle il ruolo «Object Schema Users» per leggere, o «Object Schema Managers» per scrivere.':
    'Compte : de préférence un compte dédié, avec une licence agent Jira Service Management. Dans Assets, ouvrez le schéma → Paramètres du schéma → Rôles et donnez-lui le rôle «Object Schema Users» pour lire, ou «Object Schema Managers» pour écrire.',
  'API token: entra con quell’utenza su id.atlassian.com/manage-profile/security/api-tokens → «Crea token API», dagli un nome (per esempio CENSO) e una scadenza, e copialo subito: non si rivede. Nel connettore vanno l’email dell’utenza e il token.':
    'Jeton API : connectez-vous avec ce compte sur id.atlassian.com/manage-profile/security/api-tokens → «Créer un jeton API», donnez-lui un nom (par exemple CENSO) et une échéance, et copiez-le aussitôt : il ne se réaffiche pas. Le connecteur demande l’email du compte et le jeton.',
  'Workspace: di norma lascialo vuoto, CENSO lo ricava dal sito. Se il sito ne ha più d’uno, lo trovi aprendo nel browser https://azienda.atlassian.net/rest/servicedeskapi/assets/workspace (campo workspaceId).':
    'Workspace : laissez-le normalement vide, CENSO le déduit du site. Si le site en a plusieurs, ouvrez https://azienda.atlassian.net/rest/servicedeskapi/assets/workspace dans le navigateur (champ workspaceId).',
  'Indirizzo: quello di Jira, per esempio https://jira.azienda.local. Installazione: datacenter.':
    'Adresse : celle de Jira, par exemple https://jira.azienda.local. Installation : datacenter.',
  'Utenza: con un ruolo sugli schemi di Assets, come per Cloud («Object Schema Users» o «Object Schema Managers»).':
    'Compte : avec un rôle sur les schémas Assets, comme pour Cloud («Object Schema Users» ou «Object Schema Managers»).',
  'Personal Access Token: con quell’utenza, avatar in alto a destra → Profilo → Personal Access Tokens → «Create token»; imposta una scadenza e copialo subito. Serve Jira 8.14 o successivo.':
    'Personal Access Token : avec ce compte, avatar en haut à droite → Profil → Personal Access Tokens → «Create token» ; définissez une échéance et copiez-le aussitôt. Il faut Jira 8.14 ou ultérieur.',
  'Se Jira non è raggiungibile dal Control Plane, scegli qui sopra di passare da una sonda che lo raggiunge.':
    'Si Jira n’est pas joignable depuis le Control Plane, choisissez ci-dessus de passer par une sonde qui le joint.',
  'Schemi e tipi di oggetto: menu Assets → Schemi di oggetti; dentro uno schema, a sinistra, l’albero dei tipi (Server, Computer…). Nella scansione del connettore compaiono come «Schema / Tipo».':
    'Schémas et types d’objet : menu Assets → Schémas d’objets ; dans un schéma, à gauche, l’arbre des types (Server, Computer…). Dans le scan du connecteur ils apparaissent comme «Schéma / Type».',
  'L’ID di un tipo: aprendo il tipo, nell’indirizzo della pagina compare typeId=23. È la chiave con cui il connettore lo indica.':
    'L’ID d’un type : en ouvrant le type, l’adresse de la page affiche typeId=23. C’est la clé que le connecteur utilise.',
  'Gli attributi: nel tipo di oggetto, scheda Attributi. Sono i campi del mapping; «Name» è l’etichetta dell’oggetto, «Key» (per esempio CMDB-12) la assegna Jira e non si scrive.':
    'Les attributs : dans le type d’objet, onglet Attributs. Ce sont les champs du mapping ; «Name» est l’étiquette de l’objet, «Key» (par exemple CMDB-12) est attribuée par Jira et ne s’écrit pas.',
  'Chiave di corrispondenza: scegli un attributo univoco e sempre valorizzato, come il numero di serie o l’hostname. Se lo stesso valore compare in due oggetti, il connettore si ferma invece di aggiornarne uno a caso.':
    'Clé de correspondance : choisissez un attribut unique et toujours renseigné, comme le numéro de série ou le nom d’hôte. Si la même valeur apparaît dans deux objets, le connecteur s’arrête au lieu d’en mettre un à jour au hasard.',
  'Prima verifica: «Prova il collegamento» mostra l’utenza e quanti schemi vede. Zero schemi vuol dire che all’utenza manca un ruolo in Assets.':
    'Première vérification : «Tester la connexion» montre le compte et combien de schémas il voit. Zéro schéma signifie qu’il manque un rôle au compte dans Assets.',
  'Per collegare Jira, nel modulo del connettore scegli Jira e apri il riquadro «Come collego Jira, e dove trovo le cose?»: spiega passo passo utenza, ruoli sugli schemi di Assets, API token o Personal Access Token, e dove trovare workspace, schemi, tipi e attributi.':
    'Pour connecter Jira, choisissez Jira dans le formulaire du connecteur et ouvrez l’encadré «Comment connecter Jira, et où trouver les éléments ?» : il explique pas à pas le compte, les rôles sur les schémas Assets, le jeton API ou le Personal Access Token, et où trouver workspace, schémas, types et attributs.',
  'Token con o senza ambiti: vanno bene entrambi. Il più semplice è «Crea token API» (senza ambiti). Se usi «Crea token API con ambiti», scegli l’app Jira e dagli almeno read:jira-user e gli ambiti di Assets read:cmdb-schema:jira, read:cmdb-type:jira, read:cmdb-attribute:jira, read:cmdb-object:jira (più write:cmdb-object:jira per scrivere): CENSO lo usa passando da api.atlassian.com.':
    'Jeton avec ou sans portées : les deux fonctionnent. Le plus simple est «Créer un jeton API» (sans portées). Si vous utilisez «Créer un jeton API avec des portées», choisissez l’app Jira et donnez-lui au moins read:jira-user et les portées Assets read:cmdb-schema:jira, read:cmdb-type:jira, read:cmdb-attribute:jira, read:cmdb-object:jira (plus write:cmdb-object:jira pour écrire) : CENSO l’utilise en passant par api.atlassian.com.',
  'Attenzione a non confondere il token personale, che comincia con ATATT e si crea su id.atlassian.com, con le API key dell’organizzazione, che cominciano con ATCTT e si creano in admin.atlassian.com: queste non valgono per Jira né per Assets, e CENSO lo dice subito.':
    'Attention à ne pas confondre le jeton personnel, qui commence par ATATT et se crée sur id.atlassian.com, avec les clés API de l’organisation, qui commencent par ATCTT et se créent sur admin.atlassian.com : celles-ci ne valent ni pour Jira ni pour Assets, et CENSO le signale tout de suite.',
  'I tipi di oggetto sono ciò che si crea e si aggiorna su questa istanza: scegline uno nella mappatura.':
    'Les types d’objet sont ce qui se crée et se met à jour sur cette instance : choisissez-en un dans le mapping.',
  'Su {prodotto} il contenitore su cui si scrive e il tipo dell’oggetto che nasce sono due cose diverse: scegli qui il tipo. Il pulsante «Tipi di …» nella scansione qui sopra elenca quelli di questa istanza.':
    'Sur {prodotto}, le conteneur sur lequel on écrit et le type de l’objet créé sont deux choses différentes : choisissez ici le type. Le bouton «Types de …» dans le scan ci-dessus liste ceux de cette instance.',
  'Schema gestito da CENSO (automatico): il tipo di oggetto lo decide la classe di ogni CI':
    'Schéma géré par CENSO (automatique) : le type d’objet est décidé par la classe de chaque CI',
  'Un tipo di oggetto a scelta (mappatura personalizzata)':
    'Un type d’objet au choix (mapping personnalisé)',
  'Schema gestito da CENSO (la scelta automatica della mappatura): indica nel connettore il nome dello schema. Se è uno schema che esiste già, CENSO riusa i suoi tipi (Server, Virtual Machines, Network Devices…) e i suoi attributi con nomi equivalenti, e crea solo quelli che mancano; se non esiste, lo crea. Creare uno schema richiede un amministratore di Jira o di Assets; se lo crei tu a mano, a CENSO basta il ruolo «Object Schema Managers» su quello schema.':
    'Schéma géré par CENSO (le choix automatique du mapping) : indiquez le nom du schéma dans le connecteur. Si le schéma existe déjà, CENSO réutilise ses types (Servers, Virtual Machines, Network Devices…) et ses attributs aux noms équivalents, et ne crée que ceux qui manquent ; s’il n’existe pas, il le crée. Créer un schéma demande un administrateur Jira ou Assets ; si vous le créez à la main, CENSO n’a besoin que du rôle «Object Schema Managers» sur ce schéma.',
  'Esecuzione in corso: i contatori si aggiornano da soli, e alla fine se ne apre il dettaglio.':
    'Exécution en cours : les compteurs se mettent à jour d’eux-mêmes, et son détail s’ouvre à la fin.',
  'CMDB per classe (automatico): ogni CI nella tabella standard della sua classe':
    'CMDB par classe (automatique) : chaque CI dans la table standard de sa classe',
  'Per ServiceNow la destinazione di partenza della mappatura è «CMDB per classe»: ogni CI va nella tabella standard della sua classe (cmdb_ci_server, cmdb_ci_ip_switch, cmdb_ci_ip_router…), una VM come server virtuale, e la corrispondenza si fa su correlation_id con l’identificativo permanente di CENSO, così niente duplicati. Resta possibile scegliere una tabella a mano. Per avere il link alla scheda in CENSO crea sulla tabella cmdb_ci un campo u_censo_url di tipo URL.':
    'Pour ServiceNow, la destination de départ du mapping est «CMDB par classe» : chaque CI va dans la table standard de sa classe (cmdb_ci_server, cmdb_ci_ip_switch, cmdb_ci_ip_router…), une VM comme serveur virtuel, et la correspondance se fait sur correlation_id avec l’identifiant permanent de CENSO, donc pas de doublons. Il reste possible de choisir une table à la main. Pour avoir le lien vers la fiche CENSO, créez sur la table cmdb_ci un champ u_censo_url de type URL.',
  'Per ManageEngine ServiceDesk Plus la destinazione di partenza è «Moduli per classe»: i computer (server, VM, workstation) nel modulo Workstations, gli apparati negli Asset, con il prodotto della loro classe (cercato per produttore e modello, o creato). Prima serve creare una volta, per Workstations e per Asset, un campo aggiuntivo di testo «CENSO ID»: è la chiave che evita i duplicati; un campo «CENSO URL» facoltativo riceve il link alla scheda in CENSO.':
    'Pour ManageEngine ServiceDesk Plus, la destination de départ est «Modules par classe» : les ordinateurs (serveurs, VM, postes) dans le module Workstations, les équipements dans Assets, avec le produit de leur classe (recherché par fabricant et modèle, ou créé). Créez d’abord une fois, pour Workstations et pour Assets, un champ supplémentaire texte «CENSO ID» : c’est la clé qui évite les doublons ; un champ «CENSO URL» facultatif reçoit le lien vers la fiche CENSO.',
  'Moduli per classe (automatico): i computer in Workstations, gli apparati negli Asset':
    'Modules par classe (automatique) : les ordinateurs dans Workstations, les équipements dans Assets',
  'Come preparo AWS per CENSO, compreso il software delle EC2?':
    'Comment préparer AWS pour CENSO, y compris les logiciels des EC2 ?',
  'CENSO legge AWS con permessi di sola lettura, meglio assumendo un ruolo dedicato: EC2, VPC, volumi, gruppi di sicurezza, S3, Lambda, RDS, bilanciatori e i costi del mese. Il software installato sulle EC2 arriva da AWS Systems Manager Inventory: CENSO interroga AWS, non le macchine.':
    'CENSO lit AWS avec des permissions en lecture seule, de préférence en assumant un rôle dédié : EC2, VPC, volumes, groupes de sécurité, S3, Lambda, RDS, répartiteurs et les coûts du mois. Les logiciels installés sur les EC2 viennent d’AWS Systems Manager Inventory : CENSO interroge AWS, pas les machines.',
  'A) La policy del ruolo':
    'A) La politique du rôle',
  'Crea un ruolo IAM per CENSO con la policy di sola lettura della guida dei permessi AWS: comprende ssm:DescribeInstanceInformation, ssm:ListInventoryEntries e ssm:DescribeInstancePatchStates, le sole tre azioni di Systems Manager, tutte in lettura (niente ssm:SendCommand, nessuna esecuzione sulle istanze).':
    'Créez un rôle IAM pour CENSO avec la politique en lecture seule du guide des permissions AWS : elle comprend ssm:DescribeInstanceInformation, ssm:ListInventoryEntries et ssm:DescribeInstancePatchStates, les trois seules actions de Systems Manager, toutes en lecture (pas de ssm:SendCommand, aucune exécution sur les instances).',
  'Nella fiducia del ruolo indica l’account o l’utenza che lo assume e un External ID; qui metti l’ARN del ruolo e lo stesso External ID.':
    'Dans la relation d’approbation du rôle, indiquez le compte ou l’utilisateur qui l’assume et un External ID ; ici saisissez l’ARN du rôle et le même External ID.',
  'B) Il software delle EC2 (Systems Manager Inventory)':
    'B) Les logiciels des EC2 (Systems Manager Inventory)',
  'Sulle EC2 serve l’agente SSM (già presente sulle immagini Amazon Linux, Ubuntu e Windows di AWS) e un profilo d’istanza con la policy AmazonSSMManagedInstanceCore.':
    'Les EC2 ont besoin de l’agent SSM (déjà présent sur les images Amazon Linux, Ubuntu et Windows d’AWS) et d’un profil d’instance avec la politique AmazonSSMManagedInstanceCore.',
  'Attiva la raccolta: console AWS → Systems Manager → Inventory → «Setup Inventory» (oppure Quick Setup → Host Management), per tutte le istanze o per tag. Di default raccoglie ogni 30 minuti.':
    'Activez la collecte : console AWS → Systems Manager → Inventory → «Setup Inventory» (ou Quick Setup → Host Management), pour toutes les instances ou par tag. Par défaut, elle collecte toutes les 30 minutes.',
  'Al job successivo, sulla scheda di ogni EC2 gestita compaiono il software installato (fonte «ssm»), il sistema operativo reale, gli aggiornamenti Windows e i servizi in esecuzione. Il rapporto del job elenca le EC2 non gestite da SSM o gestite senza Inventory: sono i buchi da chiudere.':
    'Au job suivant, la fiche de chaque EC2 gérée montre les logiciels installés (source «ssm»), le système d’exploitation réel, les mises à jour Windows et les services en cours. Le rapport du job liste les EC2 non gérées par SSM ou gérées sans Inventory : ce sont les trous à combler.',
  'Vinchin Backup & Recovery':
    'Vinchin Backup & Recovery',
  'Risposta parziale: {motivi}':
    'Réponse partielle : {motivi}',
  'https://vinchin.example.com':
    'https://vinchin.example.com',
  // Import avanzato dei connettori cloud
  'Cloud (AWS, Azure, Google Cloud, Oracle Cloud): con la casella «Attiva import avanzato» nella credenziale, CENSO legge dal servizio di gestione del fornitore il software installato sulle macchine, il sistema operativo reale e gli aggiornamenti, senza collegarsi alle macchine: AWS Systems Manager Inventory (fonte «ssm»), Azure Change Tracking e Update Manager («azure_inventory»), Google Cloud VM Manager («gcp_osconfig»), Oracle OS Management Hub («oci_osmh»). «Cosa fa?» accanto alla casella spiega servizi e permessi da concedere; il rapporto del job elenca le macchine rimaste senza dati e perché.':
    'Cloud (AWS, Azure, Google Cloud, Oracle Cloud) : avec la case «Activer l’import avancé» dans l’identifiant, CENSO lit depuis le service de gestion du fournisseur les logiciels installés sur les machines, le vrai système d’exploitation et les mises à jour, sans se connecter aux machines : AWS Systems Manager Inventory (source «ssm»), Azure Change Tracking et Update Manager («azure_inventory»), Google Cloud VM Manager («gcp_osconfig»), Oracle OS Management Hub («oci_osmh»). «Que fait-il ?» à côté de la case explique les services et les permissions à accorder ; le rapport du job liste les machines restées sans données et pourquoi.',
  'Nella credenziale AWS accendi «Attiva import avanzato»: senza, CENSO non interroga Systems Manager e il rapporto del job lo ricorda.':
    'Dans l’identifiant AWS, activez «Activer l’import avancé» : sans cela, CENSO n’interroge pas Systems Manager et le rapport du job le rappelle.',
  '00000000-0000-0000-0000-000000000000':
    '00000000-0000-0000-0000-000000000000',
  'Attiva import avanzato':
    'Activer l’import avancé',
  'Cosa fa?':
    'Que fait-il ?',
  'ID del workspace di Log Analytics':
    'ID de l’espace de travail Log Analytics',
  'Software installato, sistema operativo reale e aggiornamenti delle macchine, letti dal servizio di gestione del fornitore e non dalle macchine. Servono permessi in più: vedi «Cosa fa?».':
    'Logiciels installés, vrai système d’exploitation et mises à jour des machines, lus depuis le service de gestion du fournisseur et non depuis les machines. Des permissions supplémentaires sont nécessaires : voir «Que fait-il ?».',
  "Solo per l'import avanzato. Vuoto: si interroga tutta la sottoscrizione.":
    'Uniquement pour l’import avancé. Vide : tout l’abonnement est interrogé.',
  "Legge AWS Systems Manager Inventory: per ogni EC2 gestita da SSM il software installato (fonte «ssm»), il sistema operativo vero (per esempio Windows Server 2022 Datacenter invece di «windows»), l'hostname, gli aggiornamenti Windows installati e i servizi in esecuzione.":
    'Lit AWS Systems Manager Inventory : pour chaque EC2 gérée par SSM, les logiciels installés (source «ssm»), le vrai système d’exploitation (par exemple Windows Server 2022 Datacenter au lieu de «windows»), le nom d’hôte, les mises à jour Windows installées et les services en cours d’exécution.',
  "Serve che sulle EC2 giri l'agente SSM (già presente nelle AMI Amazon) e che esista un'associazione di Inventory (Systems Manager → Inventory → «Setup Inventory»). Alla policy di CENSO vanno aggiunte tre sole letture: ssm:DescribeInstanceInformation, ssm:ListInventoryEntries e ssm:DescribeInstancePatchStates (quest'ultima per gli aggiornamenti mancanti, se Patch Manager fa le scansioni).":
    "L’agent SSM doit tourner sur les EC2 (déjà présent dans les AMI Amazon) et une association d’Inventory doit exister (Systems Manager → Inventory → «Setup Inventory»). Trois lectures seulement sont à ajouter à la politique de CENSO : ssm:DescribeInstanceInformation, ssm:ListInventoryEntries et ssm:DescribeInstancePatchStates (la dernière pour les mises à jour manquantes, si Patch Manager effectue des analyses).",
  "Legge due servizi di Azure. Da Azure Resource Graph: il sistema operativo visto dall'agente della VM e, se Azure Update Manager valuta le patch, quanti aggiornamenti mancano (critici e di sicurezza a parte) e se serve un riavvio. Da Log Analytics (Change Tracking and Inventory): il software installato (fonte «azure_inventory») e i servizi in esecuzione.":
    'Lit deux services Azure. Depuis Azure Resource Graph : le système d’exploitation vu par l’agent de la VM et, si Azure Update Manager évalue les correctifs, combien de mises à jour manquent (critiques et de sécurité à part) et si un redémarrage est nécessaire. Depuis Log Analytics (Change Tracking and Inventory) : les logiciels installés (source «azure_inventory») et les services en cours d’exécution.',
  "Serve il ruolo Reader sulla sottoscrizione (che già basta all'inventario) e, per il software, Change Tracking and Inventory attivo sulle VM e il ruolo Log Analytics Reader sul workspace. Se indichi l'ID del workspace, CENSO interroga quello; se lo lasci vuoto, tutta la sottoscrizione.":
    'Il faut le rôle Reader sur l’abonnement (qui suffit déjà à l’inventaire) et, pour les logiciels, Change Tracking and Inventory actif sur les VM et le rôle Log Analytics Reader sur l’espace de travail. Si vous indiquez l’ID de l’espace de travail, CENSO interroge celui-ci ; si vous le laissez vide, tout l’abonnement.',
  'Legge Google Cloud VM Manager (OS Config): per ogni VM il software installato (fonte «gcp_osconfig»), il sistema operativo vero, il kernel, gli aggiornamenti Windows installati e quanti pacchetti hanno un aggiornamento disponibile.':
    'Lit Google Cloud VM Manager (OS Config) : pour chaque VM les logiciels installés (source «gcp_osconfig»), le vrai système d’exploitation, le noyau, les mises à jour Windows installées et combien de paquets ont une mise à jour disponible.',
  "Servono l'API OS Config attiva nel progetto, VM Manager abilitato (l'agente è già nelle immagini Google recenti) e il ruolo roles/osconfig.inventoryViewer al service account, compreso in roles/viewer. Attenzione: l'API di OS Config accetta solo lo scope cloud-platform, quindi accendendo l'import avanzato il token lo porta, come con lo scope pieno: la sola lettura la garantisce il ruolo IAM, che va tenuto a roles/viewer.":
    'Il faut l’API OS Config activée dans le projet, VM Manager activé (l’agent est déjà dans les images Google récentes) et le rôle roles/osconfig.inventoryViewer pour le compte de service, inclus dans roles/viewer. Attention : l’API OS Config n’accepte que le scope cloud-platform, donc en activant l’import avancé le jeton le porte, comme avec le scope complet : la lecture seule est alors garantie par le rôle IAM, qui doit rester roles/viewer.',
  'Legge Oracle OS Management Hub: per ogni istanza registrata i pacchetti installati (fonte «oci_osmh»), il sistema operativo e il kernel, gli aggiornamenti disponibili (di sicurezza a parte), se serve un riavvio e, su Windows, gli aggiornamenti installati.':
    'Lit Oracle OS Management Hub : pour chaque instance enregistrée les paquets installés (source «oci_osmh»), le système d’exploitation et le noyau, les mises à jour disponibles (de sécurité à part), si un redémarrage est nécessaire et, sous Windows, les mises à jour installées.',
  "Servono il plugin OS Management Hub dell'Oracle Cloud Agent attivo sulle istanze e, per il gruppo dell'utente di CENSO, la policy «Allow group <gruppo> to read osmh-family in compartment <compartimento>». Il job fa qualche chiamata in più per istanza: su tenancy molto grandi dura di più.":
    'Il faut le plugin OS Management Hub de l’Oracle Cloud Agent actif sur les instances et, pour le groupe de l’utilisateur CENSO, la politique «Allow group <groupe> to read osmh-family in compartment <compartiment>». Le job fait quelques appels de plus par instance : sur de très grandes tenancies il dure plus longtemps.',
  "Solo letture: CENSO non esegue comandi sulle macchine, non installa agenti e non cambia configurazioni. Se un permesso manca o il servizio non è attivo, l'inventario di base arriva lo stesso e il rapporto del job dice che cosa manca e perché, macchina per macchina.":
    'Lectures uniquement : CENSO n’exécute pas de commandes sur les machines, n’installe pas d’agents et ne modifie pas de configurations. Si une permission manque ou si le service n’est pas actif, l’inventaire de base arrive quand même et le rapport du job indique ce qui manque et pourquoi, machine par machine.',
  'Spenta, il rapporto del job lo ricorda con una riga: così chi si chiede perché non vede il software delle macchine cloud trova la risposta.':
    'Désactivée, le rapport du job le rappelle en une ligne : ainsi, qui se demande pourquoi il ne voit pas les logiciels des machines cloud trouve la réponse.',
  // Ruoli personalizzati
  'A chi serve e perché':
    'À qui il sert et pourquoi',
  'Anteprima del menu':
    'Aperçu du menu',
  'Assegnato a {n} utenti: assegna loro un altro ruolo prima.':
    'Attribué à {n} utilisateurs : attribuez-leur d’abord un autre rôle.',
  'Colore':
    'Couleur',
  'Con questi permessi il menu è vuoto: chi ha il ruolo non vedrà nulla.':
    'Avec ces permissions le menu est vide : qui a ce rôle ne verra rien.',
  'Crea ruolo':
    'Créer le rôle',
  'Disattivato per il tuo ruolo':
    'Désactivé pour votre rôle',
  'Duplica':
    'Dupliquer',
  'Eliminare il ruolo «{nome}»?':
    'Supprimer le rôle «{nome}» ?',
  'Help desk':
    'Help desk',
  'I ruoli predefiniti costituiscono la base per configurare autorizzazioni specifiche.':
    'Les modèles à gauche sont un point de départ à ajuster.',
  'Il livello delle sezioni che arriveranno con i prossimi aggiornamenti.':
    'Le niveau des sections qui arriveront avec les prochaines mises à jour.',
  'Il ruolo che ti è stato assegnato non dà accesso a questa sezione. Se ti serve, chiedi a chi amministra gli utenti del tenant.':
    'Le rôle qui vous a été attribué ne donne pas accès à cette section. Si vous en avez besoin, demandez à qui administre les utilisateurs du tenant.',
  'Il ruolo di partenza è in sola lettura':
    'Le rôle de départ est en lecture seule',
  'La voce non compare nel menu e le sue API sono chiuse.':
    'L’entrée n’apparaît pas dans le menu et ses API sont fermées.',
  'La voce si vede in grigio con il lucchetto, ma non si apre.':
    'L’entrée apparaît en gris avec un cadenas, mais ne s’ouvre pas.',
  'Le modifiche ai permessi valgono entro pochi secondi per chi ha il ruolo; un cambio del ruolo di partenza vale dal prossimo accesso.':
    'Les modifications des permissions s’appliquent en quelques secondes à qui a le rôle ; un changement du rôle de départ s’applique à la prochaine connexion.',
  'Lettura':
    'Lecture',
  'Modelli':
    'Modèles',
  'Moduli futuri':
    'Modules futurs',
  'Modulo disattivato per il tuo ruolo':
    'Module désactivé pour votre rôle',
  'Modulo non disponibile':
    'Module non disponible',
  'Nascosto':
    'Masqué',
  'Nome del ruolo':
    'Nom du rôle',
  'Nuovo ruolo':
    'Nouveau rôle',
  'Permessi per modulo':
    'Permissions par module',
  'Ruoli del prodotto':
    'Rôles du produit',
  'Ruoli e permessi':
    'Rôles et permissions',
  'Ruoli personalizzati':
    'Rôles personnalisés',
  'Ruolo di partenza':
    'Rôle de départ',
  'Ruolo personalizzato':
    'Rôle personnalisé',
  'Seleziona un ruolo o creane uno personalizzato':
    'Choisissez un rôle ou créez-en un',
  'Scrittura':
    'Écriture',
  'Si consulta tutto, senza poter modificare.':
    'Tout se consulte, sans pouvoir modifier.',
  'Sola lettura: con il tuo ruolo puoi consultare questo modulo ma non modificarlo.':
    'Lecture seule : avec votre rôle vous pouvez consulter ce module mais pas le modifier.',
  'Team rete':
    'Équipe réseau',
  'Team sicurezza':
    'Équipe sécurité',
  'Tutto quello che il ruolo di partenza consente.':
    'Tout ce que le rôle de départ permet.',
  'Tutto: {livello}':
    'Tout : {livello}',
  'Un ruolo personalizzato deriva da un ruolo predefinito e definisce, per ciascuna voce di menu, il relativo livello di accesso. Le autorizzazioni possono essere esclusivamente limitate rispetto al ruolo predefinito e non possono essere estese.':
    'Un rôle personnalisé part d’un rôle du produit et décide, entrée par entrée du menu, si le module est masqué, désactivé, en lecture ou en écriture. Il ne peut que retirer : il ne donne jamais plus que le rôle de départ.',
  'Vai a una sezione disponibile':
    'Aller à une section disponible',
  'misto':
    'mixte',
  '{nome} (copia)':
    '{nome} (copie)',
  '{n} utenti':
    '{n} utilisateurs',
  'Ruoli personalizzati: in Utenti → «Ruoli e permessi» crei un ruolo che parte da uno dei tre e decide, voce per voce del menu, se il modulo è nascosto, disattivato (in grigio con il lucchetto), in lettura o in scrittura; a destra l’anteprima mostra il menu come lo vedrà chi ha quel ruolo. Un ruolo può solo togliere: non dà mai più del ruolo di partenza, e le API dei moduli chiusi rispondono comunque «non consentito». Si assegna dal selettore del ruolo nell’elenco degli utenti; non si può togliere all’ultimo amministratore la gestione degli utenti.':
    'Rôles personnalisés : dans Utilisateurs → «Rôles et permissions» vous créez un rôle qui part de l’un des trois et décide, entrée par entrée du menu, si le module est masqué, désactivé (en gris avec un cadenas), en lecture ou en écriture ; à droite l’aperçu montre le menu tel que le verra qui a ce rôle. Un rôle ne peut que retirer : il ne donne jamais plus que le rôle de départ, et les API des modules fermés répondent de toute façon «non autorisé». Il s’attribue depuis le sélecteur du rôle dans la liste des utilisateurs ; on ne peut pas retirer au dernier administrateur la gestion des utilisateurs.',
  'Torna alla porta':
    'Revenir au port',
  nessuno: 'aucun',
  // Diagnosi dei connettori cloud
  'Cosa fare:':
    'Que faire :',
  'Diagnosi {fornitore}':
    'Diagnostic {fornitore}',
  '{n} a posto':
    '{n} en ordre',
  '{n} da sistemare':
    '{n} à corriger',
  // Coûts cloud
  'Aggiornato: {quando}':
    'Mis à jour : {quando}',
  'Ancora nessun costo':
    'Pas encore de coûts',
  'Andamento giornaliero':
    'Évolution quotidienne',
  'Costi Cloud':
    'Coûts cloud',
  'Costi effettivi come li riporta il fornitore; i giorni più recenti possono ancora cambiare, e il job successivo li corregge.':
    'Coûts effectifs tels que rapportés par le fournisseur ; les jours les plus récents peuvent encore changer, et le job suivant les corrige.',
  'Costo nel periodo':
    'Coût sur la période',
  'Gli account usano più valute: gli importi sono in {valuta}; le altre si scelgono dal filtro «Valuta».':
    'Les comptes utilisent plusieurs devises : les montants sont en {valuta} ; les autres se choisissent dans le filtre «Devise».',
  'I costi arrivano con i job di discovery cloud. Su AWS servono il permesso ce:GetCostAndUsage e Cost Explorer abilitato sull’account; su Azure il ruolo Cost Management Reader sulla sottoscrizione. La diagnosi nel rapporto del job dice cosa manca.':
    'Les coûts arrivent avec les jobs de découverte cloud. Sur AWS il faut la permission ce:GetCostAndUsage et Cost Explorer activé sur le compte ; sur Azure le rôle Cost Management Reader sur l’abonnement. Le diagnostic dans le rapport du job indique ce qui manque.',
  'Mese in corso':
    'Mois en cours',
  'Mese scorso':
    'Mois dernier',
  'Mese scorso e mese in corso':
    'Mois dernier et mois en cours',
  'Nessun costo nel periodo.':
    'Aucun coût sur la période.',
  'Per account':
    'Par compte',
  'Per regione':
    'Par région',
  'Per servizio':
    'Par service',
  'Quanto costano gli account cloud, giorno per giorno: per servizio, regione e account':
    'Combien coûtent les comptes cloud, jour après jour : par service, région et compte',
  'Quota':
    'Part',
  'Stima di fine mese':
    'Estimation de fin de mois',
  'Totale del periodo':
    'Total de la période',
  'Tutti gli account':
    'Tous les comptes',
  'Valuta':
    'Devise',
  'i costi degli account cloud (AWS, Azure) giorno per giorno, per servizio, regione e account: mese in corso, confronto con il mese scorso allo stesso giorno e stima lineare di fine mese. Arrivano con i job di discovery cloud, che rileggono ogni volta dal primo del mese scorso così le correzioni del provider entrano da sole. Servono ce:GetCostAndUsage con Cost Explorer abilitato su AWS, il ruolo Cost Management Reader su Azure.':
    'les coûts des comptes cloud (AWS, Azure) jour après jour, par service, région et compte : mois en cours, comparaison avec le mois dernier au même jour et estimation linéaire de fin de mois. Ils arrivent avec les jobs de découverte cloud, qui relisent à chaque fois depuis le premier du mois dernier, ainsi les corrections du fournisseur entrent d’elles-mêmes. Il faut ce:GetCostAndUsage avec Cost Explorer activé sur AWS, le rôle Cost Management Reader sur Azure.',
  'massimo {importo}':
    'maximum {importo}',
  'media dei giorni trascorsi × giorni del mese: non una previsione':
    'moyenne des jours écoulés × jours du mois : pas une prévision',
  'rispetto al mese scorso allo stesso giorno ({importo})':
    'par rapport au mois dernier au même jour ({importo})',
  'senza regione':
    'sans région',
  // Chiave dei segreti del tenant
  'Chiave dei segreti':
    'Clé des secrets',
  'Conferma la rotazione':
    'Confirmer la rotation',
  'La rotazione precedente è ancora in corso: aspetta che tutti i segreti siano ricifrati.':
    'La rotation précédente est encore en cours : attendez que tous les secrets soient rechiffrés.',
  'Le credenziali di discovery e dei connettori del tenant sono cifrate con una chiave privata dedicata. Il rinnovo della chiave genera una nuova chiave di cifratura, utilizzata immediatamente per le nuove credenziali. Le credenziali già archiviate vengono ricifrate automaticamente in background, senza interruzioni del servizio o perdita di accesso.':
    'Les identifiants de découverte et des connecteurs de ce tenant sont chiffrés avec une clé qui n’appartient qu’à vous, différente de celle des autres clients. La faire tourner génère une nouvelle clé : les nouveaux secrets l’utilisent tout de suite, les existants sont rechiffrés en arrière-plan sans rien interrompre.',
  'Ricifratura in corso: {fatti} di {totale} segreti sulla chiave nuova':
    'Rechiffrement en cours : {fatti} sur {totale} secrets sur la nouvelle clé',
  'Segreti cifrati':
    'Secrets chiffrés',
  'Storia delle chiavi ({n})':
    'Historique des clés ({n})',
  'Ultima rotazione':
    'Dernière rotation',
  'Versione attiva':
    'Version active',
  'Versione {n}':
    'Version {n}',
  'Viene creata la versione {n} della chiave. Nessun servizio si ferma e nessuna credenziale va reinserita; la chiave precedente resta finché serve a leggere i segreti non ancora ricifrati. L’operazione resta nell’audit.':
    'La version {n} de la clé va être créée. Aucun service ne s’arrête et aucun identifiant n’est à ressaisir ; la clé précédente reste tant qu’elle sert à lire les secrets pas encore rechiffrés. L’opération reste dans l’audit.',
  'Chi amministra il tenant trova qui anche la «Chiave dei segreti»: la chiave, solo vostra, che cifra credenziali e connettori. Si ruota con un clic, senza fermare nulla: i segreti esistenti vengono ricifrati in background e l’avanzamento si vede nella stessa scheda.':
    'Les administrateurs du tenant y trouvent aussi la «Clé des secrets» : la clé, qui n’appartient qu’à vous, qui chiffre identifiants et connecteurs. Elle se fait tourner d’un clic, sans rien arrêter : les secrets existants sont rechiffrés en arrière-plan et l’avancement se voit dans la même fiche.',
  // Scrittura verso DNS e IPAM
  'Allinea nome':
    'Aligner le nom',
  'Allineo…':
    'Alignement…',
  'Consenti la scrittura':
    'Autoriser l’écriture',
  'Documenta':
    'Documenter',
  'Documenta tutti in phpIPAM ({n})':
    'Tout documenter dans phpIPAM ({n})',
  'Documentati in phpIPAM: {n} indirizzi.':
    'Documentées dans phpIPAM : {n} adresses.',
  'Documento…':
    'Documentation…',
  'Modifica record':
    'Modifier l’enregistrement',
  'Nome di {ip} in phpIPAM: «{prima}» → «{dopo}».':
    'Nom de {ip} dans phpIPAM : «{prima}» → «{dopo}».',
  'Nuovo record in {zona}':
    'Nouvel enregistrement dans {zona}',
  'Scrivo sul DNS…':
    'Écriture sur le DNS…',
  'Togli da phpIPAM':
    'Retirer de phpIPAM',
  'Togliere {ip} ({nome}) da phpIPAM?':
    'Retirer {ip} ({nome}) de phpIPAM ?',
  'Tolgo…':
    'Suppression…',
  'Tolto da phpIPAM: {ip}.':
    'Retiré de phpIPAM : {ip}.',
  'www, oppure @ per la zona':
    'www, ou @ pour la zone',
  'Scrittura verso DNS e IPAM: si accende nella credenziale di ciascuna connessione, con «Consenti la scrittura» (spenta di default), dalla sezione «Connessioni» della pagina IPAM e, per il DNS, di Sorgenti dati. Accesa, sul DNS si aggiungono, modificano e tolgono record dalla scheda della zona; in IPAM, dal confronto, si documentano in phpIPAM gli indirizzi trovati (con il nome del CI), si allineano i nomi e si tolgono gli indirizzi non più usati. Ogni scrittura resta nell’audit, e la credenziale deve avere i permessi di scrittura sul sistema.':
    'Écriture vers DNS et IPAM : elle s’active dans l’identifiant de chaque connexion, avec «Autoriser l’écriture» (désactivée par défaut), depuis la section «Connexions» de la page IPAM et, pour le DNS, des Sources de données. Activée, on ajoute, modifie et supprime des enregistrements DNS depuis la fiche de la zone ; dans IPAM, depuis la comparaison, on documente dans phpIPAM les adresses trouvées (avec le nom du CI), on aligne les noms et on retire les adresses plus utilisées. Chaque écriture reste dans l’audit, et l’identifiant doit avoir les permissions d’écriture sur le système.',
  // Tabella a pagine e job
  'Nella finestra ci sono più di {n} job: sono mostrati i {n} più recenti. Restringi la finestra per vedere il resto.':
    'Il y a plus de {n} jobs dans la fenêtre : les {n} plus récents sont affichés. Réduisez la fenêtre pour voir le reste.',
  'Pagina precedente':
    'Page précédente',
  'Pagina successiva':
    'Page suivante',
  'Pagina {n} di {tot}':
    'Page {n} sur {tot}',
  'Prima pagina':
    'Première page',
  'Ultima pagina':
    'Dernière page',
  '{da}–{a} di {tot}':
    '{da}–{a} sur {tot}',
  // Storia della configurazione nel CI
  'Cosa cambia più spesso':
    'Ce qui change le plus souvent',
  'Intervallo medio fra due modifiche':
    'Intervalle moyen entre deux modifications',
  'Le prime parole delle righe cambiate (interface, ip route, snmp-server…): dicono di cosa si parla.':
    'Les premiers mots des lignes modifiées (interface, ip route, snmp-server…) : ils disent de quoi il s’agit.',
  'Letta via':
    'Lue via',
  'Modifiche negli ultimi 30 giorni':
    'Modifications des 30 derniers jours',
  'Modifiche per mese':
    'Modifications par mois',
  'Nessuna modifica negli ultimi 12 mesi.':
    'Aucune modification au cours des 12 derniers mois.',
  'Righe aggiunte e tolte a ogni modifica':
    'Lignes ajoutées et supprimées à chaque modification',
  'Righe cambiate':
    'Lignes modifiées',
  'Righe della configurazione attuale':
    'Lignes de la configuration actuelle',
  'Salvata il':
    'Enregistrée le',
  'Statistiche e versioni sulle ultime {n} di {tot}.':
    'Statistiques et versions sur les {n} dernières sur {tot}.',
  'Una sola versione: ancora nessuna modifica da confrontare.':
    'Une seule version : aucune modification à comparer pour l’instant.',
  'primo salvataggio':
    'premier enregistrement',
  '{n} giorni':
    '{n} jours',
  // Guida: aggiornamenti del 26/09
  'In alto una riga di categorie (Rete, Cloud, Virtualizzazione, Storage…) filtra il catalogo dei tipi di scansione: scegline una per vedere solo i suoi job e scorrere meno; «Tutte» le rimette tutte.': 'En haut, une rangée de catégories (Réseau, Cloud, Virtualisation, Stockage…) filtre le catalogue des types d’analyse : choisissez-en une pour ne voir que ses jobs et faire défiler moins ; «Tutte» les rétablit toutes.',
  'In Job scansioni, «Job recenti» è una tabella con un filtro per ogni colonna (tipo, stato, ambito, esito, date): si sceglie la finestra (24 ore, 7 giorni, 30 giorni) e quante righe per pagina. Da ogni riga si apre il rapporto, si ripianifica la stessa scansione o la si ritenta. La spunta «Mostra solo job scansioni», attiva di default, nasconde le consegne degli agent, l’autoinventario della sonda e i job di servizio.':
    'Dans Jobs de scan, «Jobs récents» est un tableau avec un filtre sur chaque colonne (type, état, périmètre, résultat, dates) : on choisit la fenêtre (24 heures, 7 jours, 30 jours) et combien de lignes par page. Depuis chaque ligne on ouvre le rapport, on replanifie le même scan ou on le relance. La case «Afficher uniquement les jobs de scan», cochée par défaut, masque les envois des agents, l’auto-inventaire de la sonde et les jobs de service.',
  'Sulla scheda di un apparato, la sezione Backup mostra la sua storia senza cambiare pagina: quante versioni, quante modifiche nell’ultimo mese, righe aggiunte e tolte, ogni quanto cambia, i grafici delle modifiche per mese e per modifica, che cosa cambia più spesso, e ogni versione con il confronto e il testo intero da copiare o scaricare.':
    'Sur la fiche d’un équipement, la section Sauvegarde montre son historique sans changer de page : combien de versions, combien de modifications le mois dernier, lignes ajoutées et supprimées, à quelle fréquence il change, les graphiques des modifications par mois et par modification, ce qui change le plus souvent, et chaque version avec la comparaison et le texte complet à copier ou télécharger.',
  'Diagnosi AWS: in cima al rapporto di ogni job AWS un riquadro elenca i controlli (credenziali, account, EC2, ogni servizio, Systems Manager, Cost Explorer) con ciò che è a posto e, per ciò che non lo è, cosa fare: il permesso esatto da aggiungere, il servizio da abilitare, le EC2 da registrare in Systems Manager.':
    'Diagnostic AWS : en haut du rapport de chaque job AWS, un encadré liste les contrôles (identifiants, compte, EC2, chaque service, Systems Manager, Cost Explorer) avec ce qui est en ordre et, pour ce qui ne l’est pas, que faire : la permission exacte à ajouter, le service à activer, les EC2 à enregistrer dans Systems Manager.',
  'Un ruolo personalizzato vale anche fuori dalle pagine del modulo: le sezioni della scheda di un CI (sicurezza, backup, IPAM, routing, firewall, Wazuh…), i widget della dashboard e i distintivi in alto seguono i permessi del modulo da cui vengono i dati — nascosto o disattivato non si vedono, in lettura si vedono senza i comandi.':
    'Un rôle personnalisé vaut aussi en dehors des pages du module : les sections de la fiche d’un CI (sécurité, sauvegarde, IPAM, routage, pare-feu, Wazuh…), les widgets du tableau de bord et les badges en haut suivent les permissions du module d’où viennent les données — masqué ou désactivé ils ne se voient pas, en lecture ils se voient sans les commandes.',
  // Scrittura nella credenziale
  'Accesa, dal confronto di una subnet nella pagina IPAM si documentano in phpIPAM gli indirizzi trovati dalla discovery (con il nome del CI), si allineano i nomi a quelli dei CI e si tolgono gli indirizzi documentati che nessuna scansione trova. I valori li decide CENSO dalla CMDB.':
    'Activée, depuis la comparaison d’un sous-réseau dans la page IPAM on documente dans phpIPAM les adresses trouvées par la découverte (avec le nom du CI), on aligne les noms sur ceux des CI et on retire les adresses documentées qu’aucun scan ne trouve. CENSO décide les valeurs depuis la CMDB.',
  'Accesa, dalla pagina DNS si aggiungono, modificano e tolgono record (A, AAAA, CNAME, MX, NS, PTR, SRV, TXT) nelle zone di questo server, con il valore controllato per tipo prima di mandarlo.':
    'Activée, depuis la page DNS on ajoute, modifie et supprime des enregistrements (A, AAAA, CNAME, MX, NS, PTR, SRV, TXT) dans les zones de ce serveur, avec la valeur contrôlée selon le type avant de l’envoyer.',
  "L'app di phpIPAM (Administration → API) deve avere i permessi di lettura e scrittura, e l'utente, se accedi con utente e password, la scrittura sulle sezioni interessate.":
    'L’app phpIPAM (Administration → API) doit avoir les permissions de lecture et d’écriture, et l’utilisateur, si vous vous connectez avec utilisateur et mot de passe, l’écriture sur les sections concernées.',
  'Questa connessione è in sola lettura: la scrittura si accende nella sua credenziale, in «Connessioni» → «Consenti la scrittura».':
    'Cette connexion est en lecture seule : l’écriture s’active dans son identifiant, dans «Connexions» → «Autoriser l’écriture».',
  "Scrive chi opera sul modulo (operatori e amministratori; nei ruoli personalizzati chi ha «Scrittura» sul modulo), e ogni scrittura finisce nell'audit del tenant con il dettaglio: che cosa, dove, prima e dopo. Con più connessioni la scelta è per ciascuna: si può scrivere sul laboratorio e lasciare la produzione in sola lettura.":
    'Écrit qui travaille sur le module (opérateurs et administrateurs ; dans les rôles personnalisés qui a «Écriture» sur le module), et chaque écriture va dans l’audit du tenant avec le détail : quoi, où, avant et après. Avec plusieurs connexions le choix est propre à chacune : on peut écrire sur le labo et laisser la production en lecture seule.',
  "Servono i permessi di scrittura sul server: per PowerDNS la chiave API vale già anche per scrivere; per Microsoft DNS l'utente deve poter modificare le zone, per esempio un membro di «DnsAdmins», e la sonda deve essere aggiornata.":
    'Il faut les permissions d’écriture sur le serveur : pour PowerDNS la clé API vaut déjà aussi pour écrire ; pour Microsoft DNS l’utilisateur doit pouvoir modifier les zones, par exemple un membre de «DnsAdmins», et la sonde doit être mise à jour.',
  'Con autorizzazione disabilitata, CENSO opera in sola lettura; se abilitata, consente agli operatori del modulo di eseguire anche operazioni di scrittura: vedi «Cosa fa?».':
    'Désactivée, CENSO ne fait que lire. Activée, qui travaille sur le module peut aussi écrire sur ce système : voir «Que fait-il ?».',
  // Categorie delle credenziali
  'Decide chi la vede: nei ruoli personalizzati ogni categoria si concede a parte.':
    'Décide qui le voit : dans les rôles personnalisés chaque catégorie s’accorde à part.',
  'Le credenziali, categoria per categoria: chi vede quali.':
    'Les identifiants, catégorie par catégorie : qui voit lesquels.',
  'Le credenziali di discovery hanno una categoria (Rete, Server, Virtualizzazione, Cloud, Storage, Database) che si sceglie creandole: nei ruoli personalizzati ogni categoria si concede a parte sotto «Credenziali», così il team di rete vede solo le credenziali di rete e quello cloud solo le sue. Le credenziali delle connessioni (DNS, IPAM, backup…) seguono invece il loro modulo.':
    'Les identifiants de découverte ont une catégorie (Réseau, Serveur, Virtualisation, Cloud, Stockage, Base de données) choisie à leur création : dans les rôles personnalisés chaque catégorie s’accorde à part sous «Identifiants», ainsi l’équipe réseau ne voit que les identifiants réseau et l’équipe cloud que les siens. Les identifiants des connexions (DNS, IPAM, sauvegarde…) suivent en revanche leur module.',
  // Tag
  'Aggiungi un tag':
    'Ajouter un tag',
  'Allora metti il tag':
    'Alors ajouter le tag',
  'Applica ora':
    'Appliquer maintenant',
  'Applicata: {matched} oggetti con il tag, {added} aggiunti, {removed} tolti.':
    'Appliquée : {matched} objets avec le tag, {added} ajoutés, {removed} retirés.',
  'Assegnatario':
    'Attributaire',
  'Attributo…':
    'Attribut…',
  'Catalogo dei tag':
    'Catalogue des tags',
  'Crea tag':
    'Créer le tag',
  'Crea un tag qui, oppure scrivilo direttamente su un oggetto («ambiente:produzione») o con una regola.':
    'Créez un tag ici, ou écrivez-le directement sur un objet («environnement:production») ou avec une règle.',
  'Dove è usato':
    'Où il est utilisé',
  'Eliminare il tag «{tag}»? Viene tolto da {n} oggetti.':
    'Supprimer le tag «{tag}» ? Il est retiré de {n} objets.',
  'Eliminare la regola «{nome}»? I tag che aveva messo vengono tolti.':
    'Supprimer la règle «{nome}» ? Les tags qu’elle avait ajoutés sont retirés.',
  'classificano CI, asset, servizi, contratti, credenziali, pool, piani e sonde tramite coppie chiave: valore, assegnate manualmente o automaticamente tramite regole.': 'Classent les CI, actifs, services, contrats, identifiants, pools, plans et sondes via des paires clé : valeur, attribuées manuellement ou automatiquement par des règles.',
  'Filtra per tag (chiave:valore)':
    'Filtrer par tag (clé:valeur)',
  'Il valore può prendere un dato dell’oggetto: {vendor}, {ci_class}, {attr:tag_Environment} (i tag cloud). Se il dato manca, il tag non si mette.':
    'La valeur peut prendre une donnée de l’objet : {vendor}, {ci_class}, {attr:tag_Environment} (les tags cloud). Si la donnée manque, le tag n’est pas ajouté.',
  'Messo da una regola: se lo togli, la regola lo rimette finché l’oggetto la soddisfa.':
    'Ajouté par une règle : si vous le retirez, la règle le remet tant que l’objet la satisfait.',
  'Metti il tag':
    'Ajouter le tag',
  'Modifica i tag':
    'Modifier les tags',
  'Nessun tag':
    'Aucun tag',
  'Nome della regola':
    'Nom de la règle',
  'Per esempio: i CI nella subnet 10.1.0.0/16 → sede:Milano; classe firewall → criticità:alta; il tag cloud Environment → ambiente:{attr:tag_Environment}.':
    'Par exemple : les CI du sous-réseau 10.1.0.0/16 → site:Milan ; classe pare-feu → criticité:haute ; le tag cloud Environment → environnement:{attr:tag_Environment}.',
  'Piani':
    'Plans',
  'Qualunque indirizzo IP':
    'N’importe quelle adresse IP',
  'Quando (tutte le condizioni)':
    'Quand (toutes les conditions)',
  'Rinominare o ricolorare un tag vale ovunque è assegnato.':
    'Renommer ou recolorer un tag vaut partout où il est attribué.',
  'Sede di Milano':
    'Site de Milan',
  'Seleziona la pagina':
    'Sélectionner la page',
  'Seleziona {nome}':
    'Sélectionner {nome}',
  'Si applica a':
    'S’applique à',
  'Tag':
    'Tags',
  'Tag da mettere o togliere':
    'Tag à ajouter ou retirer',
  'Togli il tag':
    'Retirer le tag',
  'Ultima applicazione: {quando}':
    'Dernière application : {quando}',
  'Una regola mette il tag sugli oggetti che soddisfano tutte le condizioni: subito, e sui CI a ogni raccolta. Chi smette di soddisfarla perde il tag della regola; i tag messi a mano restano.':
    'Une règle ajoute le tag aux objets qui satisfont toutes les conditions : tout de suite, et sur les CI à chaque collecte. Ceux qui cessent de la satisfaire perdent le tag de la règle ; les tags ajoutés à la main restent.',
  'chiave (es. ambiente)':
    'clé (ex. environnement)',
  'chiave:valore':
    'clé:valeur',
  'chiave:valore, poi Invio':
    'clé:valeur, puis Entrée',
  'espressione regolare':
    'expression régulière',
  'inizia con':
    'commence par',
  'nome attributo':
    'nom de l’attribut',
  'tag':
    'tags',
  'valore (facoltativo)':
    'valeur (facultative)',
  '{n} CI selezionati':
    '{n} CI sélectionnés',
  '{n} oggetti riceverebbero il tag':
    '{n} objets recevraient le tag',
  'è nella subnet':
    'est dans le sous-réseau',
  'è valorizzato':
    'est renseigné',
  'i tag chiave:valore (ambiente:produzione, sede:Milano) su CI, asset, servizi, contratti, credenziali, pool, piani e sonde: si mettono dalla scheda o dalla colonna «Tag» degli elenchi — sui CI anche in blocco sui selezionati — e si filtra per tag. Le regole li mettono da sole, anche sui CI che arrivano con le scansioni: per esempio i CI nella 10.1.0.0/16 → sede:Milano, o il tag cloud Environment → ambiente.':
    'les tags clé:valeur (environnement:production, site:Milan) sur CI, actifs, services, contrats, identifiants, pools, plans et sondes : on les ajoute depuis la fiche ou depuis la colonne «Tag» des listes — sur les CI aussi en masse sur la sélection — et on filtre par tag. Les règles les ajoutent automatiquement, y compris sur les CI qui arrivent avec les scans : par exemple les CI de 10.1.0.0/16 → site:Milan, ou le tag cloud Environment → environnement.',
  'A) Il profilo in sola lettura':
    'A) Le profil en lecture seule',
  'Alta affidabilità':
    'Haute disponibilité',
  'B) L’utente API e la chiave':
    'B) L’utilisateur API et la clé',
  'Bloccata per il limite di connessioni per indirizzo IP.':
    'Bloquée par la limite de connexions par adresse IP.',
  'C) I log che CENSO legge':
    'C) Les journaux que CENSO lit',
  'CENSO interroga il FortiGate in tempo reale con la REST API di FortiOS, attraverso una sonda che raggiunge la sua interfaccia di gestione. Serve un amministratore «REST API Admin» in sola lettura: CENSO non cambia nulla sul firewall.':
    'CENSO interroge le FortiGate en temps réel avec l’API REST de FortiOS, via une sonde qui atteint son interface d’administration. Il faut un administrateur «REST API Admin» en lecture seule : CENSO ne modifie rien sur le pare-feu.',
  "CENSO legge i log attraverso il FortiGate stesso (la REST API «/api/v2/log/<dispositivo>/…»): anche con FortiAnalyzer non serve una credenziale a parte, è il firewall che interroga l'analyzer.":
    'CENSO lit les journaux via le FortiGate lui-même (l’API REST «/api/v2/log/<dispositif>/…») : même avec FortiAnalyzer, aucune identité à part n’est nécessaire, c’est le pare-feu qui interroge l’analyzer.',
  'CPU':
    'CPU',
  'Calcolata sulle ultime {n} righe di log del firewall.':
    'Calculé sur les {n} dernières lignes de journal du pare-feu.',
  'Chiave API (REST API Admin)':
    'Clé API (REST API Admin)',
  'Chiusura regolare: la sessione è terminata normalmente.':
    'Fermeture normale : la session s’est terminée normalement.',
  'Come preparo il FortiGate per CENSO (utente API e log)?':
    'Comment préparer le FortiGate pour CENSO (utilisateur API et journaux) ?',
  'D) La sonda':
    'D) La sonde',
  "Da dove leggere traffico e minacce. Vuoto: CENSO lo ricava (FortiAnalyzer se attivo, altrimenti il disco se c'è, altrimenti la memoria).":
    'Où lire le trafic et les menaces. Vide : CENSO le déduit (FortiAnalyzer s’il est actif, sinon le disque s’il existe, sinon la mémoire).',
  'Dalla riga di comando è lo stesso: «config system api-user», poi «edit censoapi», «set accprofile censo-readonly», «config trusthost» con l’IP della sonda, e infine «execute api-user generate-key censoapi».':
    'En ligne de commande, c’est pareil : «config system api-user», puis «edit censoapi», «set accprofile censo-readonly», «config trusthost» avec l’IP de la sonde, et enfin «execute api-user generate-key censoapi».',
  'Disattiva «PKI Group» e, se non serve, «CORS». Conferma: FortiOS mostra la chiave una volta sola. Copiala qui, nel campo «Chiave API».':
    'Désactivez «PKI Group» et, si inutile, «CORS». Confirmez : FortiOS n’affiche la clé qu’une seule fois. Copiez-la ici, dans le champ «Clé API».',
  'Dove sono i log':
    'Emplacement des journaux',
  'Fortinet FortiGate (firewall)':
    'Fortinet FortiGate (pare-feu)',
  "Il FortiGate conserva i log dove glielo si dice (Log & Report → Log Settings): in memoria (pochi, si perdono al riavvio), sul disco locale se il modello ce l'ha, su un FortiAnalyzer o su FortiCloud.":
    'Le FortiGate conserve les journaux là où on le lui indique (Log & Report → Log Settings) : en mémoire (peu, perdus au redémarrage), sur le disque local si le modèle en a un, sur un FortiAnalyzer ou sur FortiCloud.',
  "Il VDOM da interrogare, se il firewall ne ha più d'uno. Vuoto: quello predefinito dell'amministratore API.":
    'Le VDOM à interroger, si le pare-feu en a plusieurs. Vide : celui par défaut de l’administrateur API.',
  'Il certificato della console di solito è autofirmato: incolla la CA o l’impronta SHA-256 nei campi TLS, invece di disattivare la verifica.':
    'Le certificat de la console est généralement auto-signé : collez l’AC ou l’empreinte SHA-256 dans les champs TLS plutôt que de désactiver la vérification.',
  'In «Trusted Hosts» metti l’IP della sonda che interroga il firewall (o la sua rete, per esempio 10.0.12.5/32): la chiave vale solo da lì.':
    'Dans «Trusted Hosts», mettez l’IP de la sonde qui interroge le pare-feu (ou son réseau, par exemple 10.0.12.5/32) : la clé ne vaut que depuis là.',
  'Indirizzo della gestione del FortiGate: la REST API risponde sulla porta HTTPS della console (443, o quella impostata in «admin-sport»). Senza schema si assume «https».':
    'Adresse d’administration du FortiGate : l’API REST répond sur le port HTTPS de la console (443, ou celui défini dans «admin-sport»). Sans schéma, «https» est supposé.',
  "La chiave di un «REST API Admin» con un profilo in **sola lettura** e, come Trusted Host, l'IP della sonda: si genera in System → Administrators → Create New → REST API Admin. FortiOS la mostra una volta sola.":
    'La clé d’un «REST API Admin» avec un profil en **lecture seule** et l’IP de la sonde comme Trusted Host : elle se génère dans System → Administrators → Create New → REST API Admin. FortiOS ne l’affiche qu’une seule fois.',
  'Lascia vuoto per la scelta automatica; indica «memory», «disk», «fortianalyzer» o «forticloud» per forzarla.':
    'Laissez vide pour le choix automatique ; indiquez «memory», «disk», «fortianalyzer» ou «forticloud» pour le forcer.',
  'Log & Report → Log Settings: dove tieni i log (memoria, disco, FortiAnalyzer o FortiCloud). CENSO lo ricava da solo; se vuoi forzarlo, compila «Dove sono i log». In memoria i log sono pochi e si perdono al riavvio: per una storia utile usa disco o FortiAnalyzer.':
    'Log & Report → Log Settings : où vous gardez les journaux (mémoire, disque, FortiAnalyzer ou FortiCloud). CENSO le déduit seul ; pour le forcer, remplissez «Emplacement des journaux». En mémoire, les journaux sont peu nombreux et perdus au redémarrage : pour un historique utile, utilisez le disque ou FortiAnalyzer.',
  'Nelle policy di cui vuoi vedere il traffico imposta «Log Allowed Traffic» su «All Sessions» (oppure «Security Events» per i soli eventi UTM). Il traffico negato si registra con «Log Violation Traffic», attivo di default sulla policy implicita.':
    'Sur les policies dont vous voulez voir le trafic, réglez «Log Allowed Traffic» sur «All Sessions» (ou «Security Events» pour les seuls événements UTM). Le trafic refusé est journalisé avec «Log Violation Traffic», actif par défaut sur la policy implicite.',
  'Nessuna voce in «Read/Write»: a CENSO basta leggere.':
    'Aucune entrée en «Read/Write» : CENSO n’a besoin que de lire.',
  'Per minacce e web filter servono i profili di sicurezza (IPS, antivirus, web filter, application control) applicati alle policy: senza, quelle viste restano vuote.':
    'Les menaces et le filtrage web nécessitent des profils de sécurité (IPS, antivirus, filtrage web, contrôle applicatif) appliqués aux policies : sans eux, ces vues restent vides.',
  'Permessa dalla policy; la sessione era ancora aperta al momento del log.':
    'Autorisée par la policy ; la session était encore ouverte au moment du journal.',
  'Sulla scheda della sonda che raggiunge la gestione del firewall abilita la capability «Firewall» e scegli quella sonda qui sotto: le richieste escono solo da lì.':
    'Sur la fiche de la sonde qui atteint l’administration du pare-feu, activez la capacité «Firewall» et choisissez cette sonde ci-dessous : les requêtes ne partent que de là.',
  'System → Admin Profiles → Create New: un nome (per esempio «censo-readonly») e «Read» su tutte le voci; in particolare «Log & Report» (per traffico, minacce e web filter), «System» (stato, sessioni, amministratori), «Network» (rotte) e «VPN».':
    'System → Admin Profiles → Create New : un nom (par exemple «censo-readonly») et «Read» sur toutes les entrées ; en particulier «Log & Report» (trafic, menaces et filtrage web), «System» (état, sessions, administrateurs), «Network» (routes) et «VPN».',
  'System → Administrators → Create New → REST API Admin: un nome (per esempio «censoapi»), il profilo del passo A e, con più VDOM, il VDOM da leggere.':
    'System → Administrators → Create New → REST API Admin : un nom (par exemple «censoapi»), le profil de l’étape A et, avec plusieurs VDOM, le VDOM à lire.',
  'VDOM':
    'VDOM',
  'memory | disk | fortianalyzer | forticloud':
    'memory | disk | fortianalyzer | forticloud',
  'nessuna (standalone)':
    'aucune (standalone)',
  'root':
    'root',
  '{n} peer':
    '{n} pairs',
  'Azzera avvistamenti':
    'Réinitialiser les observations',
  'Azzero…':
    'Réinitialisation…',
  'Azzerare tutti gli avvistamenti, anche quelli ignorati e censiti con le loro note? Le subnet sorvegliate restano; il prossimo giro ripropone ciò che è ancora non censito.':
    'Réinitialiser toutes les observations, y compris celles ignorées et inventoriées avec leurs notes ? Les sous-réseaux surveillés restent ; le prochain passage repropose ce qui n’est toujours pas inventorié.',
  'Autoinventario sonda':
    'Auto-inventaire de la sonde',
  'Mostra solo job scansioni':
    'Afficher uniquement les jobs de scan',
  '{n} job che non sono scansioni sono nascosti: togli la spunta «Mostra solo job scansioni» per vederli.':
    '{n} jobs qui ne sont pas des scans sont masqués : décochez «Afficher uniquement les jobs de scan» pour les voir.',
  'Gestisce licenza, sicurezza dell’accesso e configurazione del tenant':
    'Licence, sécurité de votre accès et paramètres du tenant',
  'Annulla dismissione':
    'Annuler la mise hors service',
  'Applica classe':
    'Appliquer la classe',
  'Automatica (dalle regole)':
    'Automatique (selon les règles)',
  'Cambia classe…':
    'Changer de classe…',
  'Classe da assegnare':
    'Classe à attribuer',
  'Dichiarare dismessi {n} CI? Lo stato resiste alle scansioni. Motivo (facoltativo):':
    'Déclarer {n} CI hors service ? L’état résiste aux scans. Motif (facultatif) :',
  'Togliere {n} CI dalla CMDB?\n\nSe questi apparati esistono ancora in rete, la prossima scansione li riporta come oggetti nuovi, senza la loro storia: per macchine dismesse usa «Dichiara dismesso». Spariscono interfacce, software, relazioni e storico.':
    'Retirer {n} CI de la CMDB ?\n\nSi ces équipements existent encore sur le réseau, le prochain scan les ramène comme nouveaux objets, sans leur historique : pour des machines hors service, utilisez «Déclarer hors service». Interfaces, logiciels, relations et historique disparaissent.',
  '{n} CI aggiornati.':
    '{n} CI mis à jour.',
  'Cosa dice phpIPAM':
    'Ce que dit phpIPAM',
  'Di chi è questo indirizzo':
    'À qui appartient cette adresse',
  'Indirizzo dichiarato a mano sulla scheda del proprietario.':
    'Adresse déclarée à la main sur la fiche du propriétaire.',
  'Indirizzo trovato dalla scansione fra quelli dell’apparato: chi lo raggiunge o ci fa traffico viene attribuito al proprietario.':
    'Adresse trouvée par le scan parmi celles de l’équipement : qui l’atteint ou y envoie du trafic est attribué au propriétaire.',
  'Legato dal {da}, ultima conferma {quando}':
    'Lié depuis le {da}, dernière confirmation {quando}',
  'Nessun CI espone più questo indirizzo: il legame è stato tolto o l’oggetto che lo portava non c’è più.':
    'Aucun CI n’expose plus cette adresse : le lien a été retiré ou l’objet qui la portait n’existe plus.',
  'Nome dal DNS inverso':
    'Nom depuis le DNS inverse',
  'Proprietario in IPAM':
    'Propriétaire dans l’IPAM',
  'gateway VLAN 31, VIP del bilanciatore…':
    'passerelle VLAN 31, VIP du répartiteur…',
  'non indicata':
    'non indiquée',
  'phpIPAM non documenta questo indirizzo: è in uso ma non registrato.':
    'phpIPAM ne documente pas cette adresse : elle est utilisée mais non enregistrée.',
  'phpIPAM non interrogabile.':
    'phpIPAM ne peut pas être interrogé.',
  'Network Security (ntopng)':
    'Sécurité réseau (ntopng)',
  'nome.dominio':
    'nom.domaine',
  'Assorbito':
    'Absorbé',
  'CI che risultano lo stesso oggetto: per ogni gruppo, quello che resta e quelli che verrebbero assorbiti, con la prova (le chiavi in comune). Niente cambia finché non premi «Unisci». Togli la spunta ai gruppi che non ti convincono.':
    'CI qui s’avèrent être le même objet : pour chaque groupe, celui qui reste et ceux qui seraient absorbés, avec la preuve (les clés en commun). Rien ne change tant que vous n’appuyez pas sur «Fusionner». Décochez les groupes qui ne vous convainquent pas.',
  'Cerco i doppioni…':
    'Recherche des doublons…',
  'Doppioni':
    'Doublons',
  'Host visto dallo sweep su un indirizzo aggiuntivo già in CMDB.':
    'Hôte vu par le balayage sur une adresse supplémentaire déjà dans la CMDB.',
  'Nessun doppione':
    'Aucun doublon',
  'Ogni oggetto compare una volta sola.':
    'Chaque objet n’apparaît qu’une seule fois.',
  'Resta':
    'Reste',
  'Trova doppioni':
    'Trouver les doublons',
  'Unire {g} gruppi? {n} CI verranno assorbiti nel CI che resta di ciascun gruppo; i loro identificativi continueranno a portare lì.':
    'Fusionner {g} groupes ? {n} CI seront absorbés dans le CI qui reste de chaque groupe ; leurs identifiants continueront d’y mener.',
  'Unisci {n} gruppi':
    'Fusionner {n} groupes',
  'Unisco…':
    'Fusion…',
  'Uniti {g} gruppi, {n} CI assorbiti.':
    '{g} groupes fusionnés, {n} CI absorbés.',
  'visto {quando}':
    'vu {quando}',
  'Condividono i MAC virtuali del cluster ma hanno seriali diversi: sono due apparati in HA, non doppioni, e non vengono uniti.':
    'Ils partagent les MAC virtuelles du cluster mais ont des numéros de série différents : ce sont deux équipements en HA, pas des doublons, et ils ne sont pas fusionnés.',
  'Coppie in alta affidabilità ({n})':
    'Paires en haute disponibilité ({n})',
  'Registra come coppie HA':
    'Enregistrer comme paires HA',
  'Registrate {n} coppie in alta affidabilità.':
    '{n} paires en haute disponibilité enregistrées.',
  'in alta affidabilità con':
    'en haute disponibilité avec',
  'Colonne a sinistra':
    'Colonnes à gauche',
  'Altre colonne a destra':
    'Autres colonnes à droite',
  'Attributi della classe':
    'Attributs de la classe',
  'Colonne':
    'Colonnes',
  'Colonne mostrate':
    'Colonnes affichées',
  'Colonne in più':
    'Colonnes supplémentaires',
  'Ripristina le colonne predefinite':
    'Rétablir les colonnes par défaut',
  'Versione del sistema':
    'Version du système',
  'In HA con':
    'En HA avec',
  'Coppia in alta affidabilità: i due apparati condividono i MAC virtuali del cluster.':
    'Paire en haute disponibilité : les deux équipements partagent les MAC virtuelles du cluster.',
  'Flussi ricavati dalla sonda osservando il traffico su una porta mirror, non ricevuti da un apparato.':
    'Flux déduits par la sonde en observant le trafic sur un port miroir, et non reçus d’un équipement.',
  'Interfaccia in cattura':
    'Interface de capture',
  "L'elenco è completo: gli apparati che hanno esportato almeno un flusso e le sonde che catturano dal filo (protocollo «Sonda»).":
    'La liste est complète : les équipements qui ont exporté au moins un flux et les sondes qui capturent sur le câble (protocole «Sonde»).',
  'Pacchetti buttati dal kernel perché la sonda non teneva il passo: i volumi sono incompleti.':
    'Paquets rejetés par le noyau parce que la sonde ne suivait pas : les volumes sont incomplets.',
  'Sorgenti di flussi ({n})':
    'Sources de flux ({n})',
  "non si sente da oltre un'ora":
    'silencieuse depuis plus d’une heure',
  '{n} scartati':
    '{n} rejetés',
  'tra {n}s':
    'dans {n} s',
  'tra {n} min':
    'dans {n} min',
  'tra {n} h':
    'dans {n} h',
  'tra {n} g':
    'dans {n} j',
  'interno':
    'interne',
  'origine':
    'origine',
  'Altri indirizzi del cluster':
    'Autres adresses du cluster',
  'Cosa gira sul cluster e su quale nodo adesso: il nodo proprietario cambia a ogni failover.':
    'Ce qui tourne sur le cluster et sur quel nœud en ce moment : le nœud propriétaire change à chaque basculement.',
  'Dominio':
    'Domaine',
  'I nodi compaiono quando l’inventario di almeno un membro (agente o scansione WinRM) arriva al Control Plane.':
    'Les nœuds apparaissent lorsque l’inventaire d’au moins un membre (agent ou scan WinRM) arrive au Control Plane.',
  'Il nodo non è ancora in CMDB: installa l’agente o scansionalo via WinRM.':
    'Le nœud n’est pas encore dans la CMDB : installez l’agent ou scannez-le via WinRM.',
  'Livello funzionale':
    'Niveau fonctionnel',
  'Nessun nodo noto':
    'Aucun nœud connu',
  'Nodi':
    'Nœuds',
  'Nodi ({n})':
    'Nœuds ({n})',
  'Nodi non attivi: {nodi}. I ruoli girano sugli altri nodi, ma il cluster ha meno margine per un altro guasto.':
    'Nœuds inactifs : {nodi}. Les rôles tournent sur les autres nœuds, mais le cluster a moins de marge pour une autre panne.',
  'Nodo':
    'Nœud',
  'Nodo attivo':
    'Nœud actif',
  'Ruoli ({n})':
    'Rôles ({n})',
  'Ruoli ospitati':
    'Rôles hébergés',
  'Ultimo inventario':
    'Dernier inventaire',
  'VIP':
    'VIP',
  'VIP del cluster non associati a un ruolo nell’ultimo inventario (dagli inventari precedenti al dettaglio dei ruoli).':
    'VIP du cluster non associées à un rôle dans le dernier inventaire (inventaires antérieurs au détail des rôles).',
  'non in CMDB':
    'pas dans la CMDB',
  '{su} attivi su {tot}':
    '{su} actifs sur {tot}',
  'Si installa dalla sonda «{sonda}» ({indirizzo}), in HTTPS con il certificato della sonda verificato: la macchina non deve raggiungere il Control Plane.':
    'S’installe depuis la sonde «{sonda}» ({indirizzo}), en HTTPS avec le certificat de la sonde vérifié : la machine n’a pas besoin d’atteindre le Control Plane.',
  'Apri PowerShell come amministratore e incolla le due righe: la prima scarica l’installer in un file ({file}) con curl.exe, che verifica il certificato del server per impronta; la seconda lo esegue. Prima che parta puoi aprire il file e leggerlo: è un normale file su disco, non codice che gira al volo. curl.exe c’è da Windows 10 e da Windows Server 2019; per Windows Server 2016 usa la variante qui sopra.':
    'Ouvrez PowerShell en administrateur et collez les deux lignes : la première télécharge l’installateur dans un fichier ({file}) avec curl.exe, qui vérifie le certificat du serveur par empreinte ; la seconde l’exécute. Avant le lancement vous pouvez ouvrir le fichier et le lire : c’est un fichier normal sur disque, pas du code exécuté à la volée. curl.exe est présent depuis Windows 10 et Windows Server 2019 ; pour Windows Server 2016, utilisez la variante ci-dessus.',
  'Windows Server 2016 o senza curl.exe':
    'Windows Server 2016 ou sans curl.exe',
  'Stesso risultato senza curl.exe: il certificato si verifica in PowerShell. Incolla tutte le righe insieme.':
    'Même résultat sans curl.exe : le certificat est vérifié dans PowerShell. Collez toutes les lignes ensemble.',
  'Al riavvio successivo (o con gpupdate /force e un riavvio) ogni macchina installa l’agente come SYSTEM, registra l’attività «CENSO inventory» e fa la prima consegna.':
    'Au redémarrage suivant (ou avec gpupdate /force et un redémarrage) chaque machine installe l’agent en tant que SYSTEM, enregistre la tâche «CENSO inventory» et fait son premier envoi.',
  'Come si distribuisce il pacchetto?':
    'Comment déployer le paquet ?',
  'Con Ansible: un task «unarchive» dell’archivio seguito da un task «command: sh /tmp/censo-inventory/install.sh» con become: true.':
    'Avec Ansible : une tâche «unarchive» de l’archive suivie d’une tâche «command: sh /tmp/censo-inventory/install.sh» avec become: true.',
  'Copia l’archivio sulle macchine ed estrailo: tar xzf censo-inventory-*-linux.tar.gz.':
    'Copiez l’archive sur les machines et extrayez-la : tar xzf censo-inventory-*-linux.tar.gz.',
  'Da root: sh censo-inventory/install.sh. Sceglie da solo il binario amd64 o arm64, scrive la configurazione in /etc/censo e il cron in /etc/cron.d/censo-inventory.':
    'En root : sh censo-inventory/install.sh. Il choisit seul le binaire amd64 ou arm64, écrit la configuration dans /etc/censo et le cron dans /etc/cron.d/censo-inventory.',
  'Distribuzione di massa':
    'Déploiement de masse',
  'Estrai lo zip in una cartella condivisa leggibile dai computer del dominio (per esempio \\\\dominio\\NETLOGON\\censo-inventory o una share con permesso di lettura per «Domain Computers»).':
    'Extrayez le zip dans un dossier partagé lisible par les ordinateurs du domaine (par exemple \\\\domaine\\NETLOGON\\censo-inventory ou un partage avec droit de lecture pour «Domain Computers»).',
  'Gestione Criteri di gruppo → un GPO collegato alle OU dei server → Configurazione computer → Criteri → Impostazioni di Windows → Script → Avvio → Aggiungi: install.cmd dalla share.':
    'Gestion des stratégies de groupe → une GPO liée aux OU des serveurs → Configuration ordinateur → Stratégies → Paramètres Windows → Scripts → Démarrage → Ajouter : install.cmd depuis le partage.',
  'In questa pagina, su questo agente, «Consegne» sale e «Ultima consegna» mostra l’IP interno delle macchine; ogni macchina compare fra i Configuration Item con origine «Agente d’inventario».':
    'Sur cette page, pour cet agent, «Envois» augmente et «Dernier envoi» affiche l’IP interne des machines ; chaque machine apparaît parmi les Configuration Items avec l’origine «Agent d’inventaire».',
  'Intune: impacchetta la cartella come app Win32 (IntuneWinAppUtil) con comando di installazione «install.cmd», contesto di sistema; rilevamento: il file C:\\ProgramData\\CENSO\\censo-inventory.exe.':
    'Intune : empaquetez le dossier comme application Win32 (IntuneWinAppUtil) avec la commande d’installation «install.cmd», contexte système ; détection : le fichier C:\\ProgramData\\CENSO\\censo-inventory.exe.',
  'Le macchine consegnano a':
    'Les machines envoient à',
  'Linux — Ansible o script':
    'Linux — Ansible ou script',
  'Lo stesso pacchetto va bene per tutte le macchine: ognuna si presenta con il proprio seriale e nome e diventa un CI a sé.':
    'Le même paquet convient à toutes les machines : chacune se présente avec son numéro de série et son nom et devient son propre CI.',
  'Prima di iniziare':
    'Avant de commencer',
  'SCCM / Configuration Manager: applicazione o pacchetto con programma «install.cmd», eseguito con diritti amministrativi, che l’utente sia connesso o no.':
    'SCCM / Configuration Manager : application ou paquet avec le programme «install.cmd», exécuté avec des droits administratifs, qu’un utilisateur soit connecté ou non.',
  'Scarica pacchetto Linux (.tar.gz)':
    'Télécharger le paquet Linux (.tar.gz)',
  'Scarica pacchetto Windows (.zip)':
    'Télécharger le paquet Windows (.zip)',
  'Scegli qui sopra dove consegnano le macchine: il Control Plane se lo raggiungono (HTTPS, porta 443), oppure una sonda della loro rete se il cloud non lo vedono (porta del ricevitore della sonda, di norma 8899). Se la sonda non risponde, l’agente riprova sul Control Plane.':
    'Choisissez ci-dessus où les machines envoient : le Control Plane si elles l’atteignent (HTTPS, port 443), ou une sonde de leur réseau si elles ne voient pas le cloud (port du récepteur de la sonde, en général 8899). Si la sonde ne répond pas, l’agent réessaie sur le Control Plane.',
  'Se l’agente è già installato il pacchetto non fa niente: puoi lanciarlo a ogni avvio senza doppioni. Per reinstallare (per esempio dopo aver rigenerato il segreto) usa /force su Windows, --force su Linux.':
    'Si l’agent est déjà installé, le paquet ne fait rien : vous pouvez le lancer à chaque démarrage sans doublons. Pour réinstaller (par exemple après avoir régénéré le secret), utilisez /force sous Windows, --force sous Linux.',
  'Windows — Intune o SCCM':
    'Windows — Intune ou SCCM',
  'Windows — criterio di gruppo':
    'Windows — stratégie de groupe',
  '1 ora':
    '1 heure',
  'Definisce il periodo massimo di inattività prima della richiesta di una nuova autenticazione. La sessione viene rinnovata automaticamente durante l’utilizzo, è condivisa tra schede e finestre del browser e si applica a tutti gli utenti del tenant dal successivo rinnovo della sessione.':
    'Au bout de combien de temps sans activité la console demande de se reconnecter. Tant qu’elle est utilisée, la session se renouvelle seule, et elle est partagée entre les onglets et fenêtres du navigateur. S’applique à tous les utilisateurs de ce tenant, dès le prochain renouvellement de leur session.',
  'Salvato.':
    'Enregistré.',
  'Scade dopo un’inattività di':
    'Expire après une inactivité de',
  'Sessione':
    'Session',
  '{n} minuti':
    '{n} minutes',
  '{n} ore':
    '{n} heures',
  'Togli il filtro':
    'Retirer le filtre',
  '5986 (HTTPS) se lasci vuoto; 5985 se usi WinRM in chiaro. Ignorata in modalità WMI.':
    '5986 (HTTPS) si vide ; 5985 si vous utilisez WinRM en clair. Ignoré en mode WMI.',
  'Di default, se un host è in un cluster di failover, la sonda interroga anche gli altri nodi (ognuno ospita solo le sue VM). Accendilo per limitarti agli host scritti sopra.':
    'Par défaut, si un hôte fait partie d’un cluster de basculement, la sonde interroge aussi les autres nœuds (chacun n’héberge que ses propres VM). Activez-le pour vous limiter aux hôtes indiqués ci-dessus.',
  "Host, cluster di failover, macchine virtuali, commutatori virtuali e volumi (anche CSV). Via WinRM o WMI sugli host, oppure dal server SCVMM. Gli indirizzi delle VM richiedono i servizi d'integrazione nell'ospite.":
    'Hôtes, clusters de basculement, machines virtuelles, commutateurs virtuels et volumes (CSV compris). Via WinRM ou WMI sur les hôtes, ou depuis le serveur SCVMM. Les adresses des VM nécessitent les services d’intégration dans l’invité.',
  'Host, cluster o server SCVMM':
    'Hôtes, cluster ou serveur SCVMM',
  'Microsoft Hyper-V':
    'Microsoft Hyper-V',
  "Per host fuori dominio con l'autenticazione Basic di WinRM abilitata, e solo su HTTPS: in chiaro manderebbe la password leggibile, e la sonda lo rifiuta.":
    'Pour les hôtes hors domaine avec l’authentification Basic de WinRM activée, et uniquement en HTTPS : en clair, le mot de passe circulerait lisible, et la sonde le refuse.',
  'Quando WinRM non è attivo: porta 135 più le porte RPC dinamiche verso ogni host. Solo letture WMI da un elenco chiuso. Non dà le dimensioni dei dischi virtuali (servirebbe invocare metodi).':
    'Quand WinRM n’est pas actif : port 135 plus les ports RPC dynamiques vers chaque hôte. Uniquement des lectures WMI d’une liste fermée. Ne donne pas la taille des disques virtuels (il faudrait invoquer des méthodes).',
  'Solo gli host indicati':
    'Uniquement les hôtes indiqués',
  'Solo su un segmento fidato e solo con NTLM: la password non viaggia, il contenuto sì. Il default è HTTPS sulla 5986.':
    'Uniquement sur un segment de confiance et uniquement avec NTLM : le mot de passe ne circule pas, le contenu oui. Par défaut : HTTPS sur le 5986.',
  'Spento di default: WinRM usa quasi sempre il certificato autofirmato di `winrm quickconfig`. Accendilo se gli host hanno un certificato della tua PKI.':
    'Désactivé par défaut : WinRM utilise presque toujours le certificat auto-signé de `winrm quickconfig`. Activez-le si les hôtes ont un certificat de votre PKI.',
  'System Center VMM':
    'System Center VMM',
  'Un solo punto di contatto: WinRM verso il server VMM, che risponde per tutti gli host e i cluster che gestisce. Serve un utente con ruolo VMM di sola lettura («Read-Only Administrator»). Le VM vSphere gestite da VMM si saltano: le legge il connettore VMware.':
    'Un seul point de contact : WinRM vers le serveur VMM, qui répond pour tous les hôtes et clusters qu’il gère. Il faut un utilisateur avec un rôle VMM en lecture seule (« Read-Only Administrator »). Les VM vSphere gérées par VMM sont ignorées : c’est le connecteur VMware qui les lit.',
  'Uno o più host Hyper-V (separati da virgola o a capo), oppure il nome del cluster di failover: i nodi del cluster si trovano da soli. In modalità SCVMM: il server VMM.':
    'Un ou plusieurs hôtes Hyper-V (séparés par une virgule ou un retour à la ligne), ou le nom du cluster de basculement : les nœuds du cluster sont trouvés automatiquement. En mode SCVMM : le serveur VMM.',
  'WMI (DCOM), senza WinRM':
    'WMI (DCOM), sans WinRM',
  'WinRM (PowerShell) con Basic':
    'WinRM (PowerShell) avec Basic',
  'WinRM (PowerShell) con NTLM':
    'WinRM (PowerShell) avec NTLM',
  'hv01.dominio.local, hv02.dominio.local':
    'hv01.domaine.local, hv02.domaine.local',
  "«DOMINIO\\utente» membro di «Hyper-V Administrators» e di «Remote Management Users» su ogni host (in cluster: anche lettura sul cluster). Dà l'inventario più completo, dimensioni dei dischi virtuali comprese.":
    '« DOMAINE\\utilisateur » membre de « Hyper-V Administrators » et de « Remote Management Users » sur chaque hôte (en cluster : aussi la lecture sur le cluster). Donne l’inventaire le plus complet, taille des disques virtuels comprise.',
  'A) L’utente':
    'A) L’utilisateur',
  'B) WinRM (consigliata)':
    'B) WinRM (recommandé)',
  'C) WMI, senza WinRM':
    'C) WMI, sans WinRM',
  'CENSO legge Hyper-V senza installare nulla sugli host: la sonda si collega con la modalità scelta nella credenziale ed esegue soltanto letture. Scegli una modalità: WinRM se è attivo (la più completa), WMI se WinRM è spento, SCVMM se hai System Center Virtual Machine Manager.':
    'CENSO lit Hyper-V sans rien installer sur les hôtes : la sonde se connecte avec le mode choisi dans l’identifiant et n’effectue que des lectures. Choisissez un mode : WinRM s’il est actif (le plus complet), WMI si WinRM est désactivé, SCVMM si vous avez System Center Virtual Machine Manager.',
  'Come preparo Hyper-V per CENSO (WinRM, WMI o SCVMM)?':
    'Comment préparer Hyper-V pour CENSO (WinRM, WMI ou SCVMM) ?',
  'D) System Center VMM':
    'D) System Center VMM',
  'Da un PC Windows: «Enter-PSSession hv01 -Credential DOMINIO\\censo-hyperv», poi «Get-VM». Se risponde, risponde anche a CENSO.':
    'Depuis un PC Windows : « Enter-PSSession hv01 -Credential DOMAINE\\censo-hyperv », puis « Get-VM ». S’il répond, il répond aussi à CENSO.',
  'Dopo il job, in Ambienti virtuali trovi l’ambiente Hyper-V: host, cluster, VM (generazione, memoria dinamica, dischi, schede con VLAN e indirizzi), commutatori virtuali e volumi/CSV come datastore.':
    'Après le job, Environnements virtuels affiche l’environnement Hyper-V : hôtes, clusters, VM (génération, mémoire dynamique, disques, cartes avec VLAN et adresses), commutateurs virtuels et volumes/CSV comme datastores.',
  'E) La prova e cosa trovi':
    'E) Le test et ce que vous obtenez',
  'Firewall: dalla sonda verso ogni host, TCP 135 e le porte RPC dinamiche (49152–65535); sugli host le regole «Windows Management Instrumentation (DCOM-In)» e «(WMI-In)».':
    'Pare-feu : de la sonde vers chaque hôte, TCP 135 et les ports RPC dynamiques (49152–65535) ; sur les hôtes les règles « Windows Management Instrumentation (DCOM-In) » et « (WMI-In) ».',
  'Firewall: dalla sonda verso ogni host, TCP 5986 (o 5985 se scegli «WinRM in chiaro»).':
    'Pare-feu : de la sonde vers chaque hôte, TCP 5986 (ou 5985 si vous choisissez « WinRM en clair »).',
  'Gli indirizzi IP delle VM li dà il servizio d’integrazione «Scambio dati (KVP)» dentro l’ospite: se è spento, la VM si riconosce solo per MAC, e il rapporto del job lo dice.':
    'Les adresses IP des VM proviennent du service d’intégration « Échange de données (KVP) » dans l’invité : s’il est désactivé, la VM n’est reconnue que par son MAC, et le rapport du job l’indique.',
  'Host e VM vSphere gestiti da VMM vengono saltati: li legge il connettore VMware, così non compaiono due volte.':
    'Les hôtes et VM vSphere gérés par VMM sont ignorés : le connecteur VMware les lit, ils n’apparaissent donc pas deux fois.',
  'Hyper-V non ha una API REST: nella credenziale «Microsoft Hyper-V» scegli come collegarti. WinRM con NTLM (consigliata, la più completa), WinRM con Basic (host fuori dominio, solo HTTPS), WMI senza WinRM (porta 135 e RPC dinamiche) oppure il server System Center VMM, che risponde per tutti gli host che gestisce. Con WinRM e WMI basta indicare il cluster o un nodo: la sonda trova gli altri nodi e si collega a ciascuno. La guida «Come preparo Hyper-V per CENSO» accanto alla credenziale spiega utente, gruppi e porte per ogni modalità.':
    'Hyper-V n’a pas d’API REST : dans l’identifiant « Microsoft Hyper-V », choisissez comment vous connecter. WinRM avec NTLM (recommandé, le plus complet), WinRM avec Basic (hôtes hors domaine, HTTPS uniquement), WMI sans WinRM (port 135 et RPC dynamiques) ou le serveur System Center VMM, qui répond pour tous les hôtes qu’il gère. Avec WinRM et WMI, il suffit d’indiquer le cluster ou un nœud : la sonde trouve les autres nœuds et se connecte à chacun. Le guide « Comment préparer Hyper-V pour CENSO » à côté de l’identifiant explique utilisateur, groupes et ports pour chaque mode.',
  'In VMM (Settings → User Roles) dai all’utente il ruolo «Read-Only Administrator», con ambito sui gruppi host da inventariare.':
    'Dans VMM (Settings → User Roles), donnez à l’utilisateur le rôle « Read-Only Administrator », avec une portée sur les groupes d’hôtes à inventorier.',
  'L’utente, oltre ai gruppi del passo A, va in «Distributed COM Users» e deve avere «Enable Account» e «Remote Enable» sui namespace root\\virtualization\\v2, root\\cimv2 e root\\MSCluster (wmimgmt.msc → Proprietà → Sicurezza).':
    'En plus des groupes de l’étape A, l’utilisateur rejoint « Distributed COM Users » et doit avoir « Enable Account » et « Remote Enable » sur les espaces de noms root\\virtualization\\v2, root\\cimv2 et root\\MSCluster (wmimgmt.msc → Propriétés → Sécurité).',
  'Nella credenziale scrivi il nome del cluster o uno qualunque dei nodi: la sonda chiede al cluster l’elenco dei nodi e si collega a ciascuno direttamente (ogni nodo conosce solo le VM che ospita). «Solo gli host indicati» disattiva questo passo.':
    'Dans l’identifiant, indiquez le nom du cluster ou l’un quelconque des nœuds : la sonde demande au cluster la liste des nœuds et se connecte directement à chacun (chaque nœud ne connaît que les VM qu’il héberge). « Uniquement les hôtes indiqués » désactive cette étape.',
  'Nella credenziale scrivi il server VMM: la sonda apre WinRM verso di lui (passo B, ma solo verso il server VMM).':
    'Dans l’identifiant, indiquez le serveur VMM : la sonde ouvre WinRM vers lui (étape B, mais uniquement vers le serveur VMM).',
  'Se gli host sono in cluster: lettura sul cluster, con «Grant-ClusterAccess -User DOMINIO\\censo-hyperv -ReadOnly» su un nodo.':
    'Si les hôtes sont en cluster : lecture sur le cluster, avec « Grant-ClusterAccess -User DOMAINE\\censo-hyperv -ReadOnly » sur un nœud.',
  'Su ogni host WinRM deve rispondere: «Enable-PSRemoting» (HTTP 5985) oppure un listener HTTPS sulla 5986 («winrm quickconfig -transport:https» con un certificato del server).':
    'WinRM doit répondre sur chaque hôte : « Enable-PSRemoting » (HTTP 5985) ou un listener HTTPS sur le 5986 (« winrm quickconfig -transport:https » avec un certificat serveur).',
  'Su ogni host: membro di «Hyper-V Administrators» (per leggere le VM) e di «Remote Management Users» (per aprire la sessione WinRM).':
    'Sur chaque hôte : membre de « Hyper-V Administrators » (pour lire les VM) et de « Remote Management Users » (pour ouvrir la session WinRM).',
  'Un utente di dominio dedicato (per esempio «censo-hyperv»), non un amministratore di dominio.':
    'Un utilisateur de domaine dédié (par exemple « censo-hyperv »), pas un administrateur de domaine.',
  'Via WMI mancano le dimensioni dei dischi virtuali: per leggerle servirebbe invocare metodi, e CENSO si limita a interrogare.':
    'Via WMI, la taille des disques virtuels manque : la lire exigerait d’invoquer des méthodes, et CENSO se limite à interroger.',
  'Accessibile da Internet':
    'Accessible depuis Internet',
  'account, regioni, reti e risorse rilevati dai connettori cloud, con una mappa delle relazioni e dei collegamenti tra le risorse.': 'Comptes, régions, réseaux et ressources détectés par les connecteurs cloud, avec une carte des relations et des liens entre les ressources.',
  'Alimentazione':
    'Alimentation',
  'Altro':
    'Autre',
  'Ambienti cloud':
    'Environnements cloud',
  'Ambienti cloud è lo specchio di Ambienti virtuali per AWS, Azure, Google Cloud e Oracle Cloud: un ambiente è un account (sottoscrizione Azure, progetto Google, compartimento Oracle), con le sue regioni, reti e risorse.':
    'Environnements cloud est le miroir d’Environnements virtuels pour AWS, Azure, Google Cloud et Oracle Cloud : un environnement est un compte (abonnement Azure, projet Google, compartiment Oracle), avec ses régions, réseaux et ressources.',
  'Apri la scheda del CI':
    'Ouvrir la fiche du CI',
  'Base dati':
    'Base de données',
  'Bilanciatore':
    'Équilibreur de charge',
  'CIDR':
    'CIDR',
  'Cerca nella mappa…':
    'Rechercher dans la carte…',
  'Ciò che il provider non lega a una rete (i bucket, le VM di Azure, le funzioni fuori da una VPC) sta sotto la sua regione: non sparisce, ma non ha collegamenti di rete.':
    'Ce que le fournisseur ne rattache pas à un réseau (les buckets, les VM Azure, les fonctions hors d’un VPC) se trouve sous sa région : cela ne disparaît pas, mais n’a pas de liens réseau.',
  'Compaiono qui dopo una discovery con un connettore cloud (AWS, Azure, Google Cloud, Oracle Cloud).':
    'Ils apparaissent ici après une découverte avec un connecteur cloud (AWS, Azure, Google Cloud, Oracle Cloud).',
  'Con molte risorse i volumi non si disegnano: si contano sull’istanza a cui sono collegati, per tenere la mappa leggibile.':
    'Avec beaucoup de ressources, les volumes ne sont pas dessinés : ils sont comptés sur l’instance à laquelle ils sont attachés, pour garder la carte lisible.',
  'Configura un connettore cloud (AWS, Azure, Google Cloud, Oracle Cloud) e lancia una raccolta.':
    'Configurez un connecteur cloud (AWS, Azure, Google Cloud, Oracle Cloud) et lancez une collecte.',
  'Esposta a Internet':
    'Exposée à Internet',
  'Esposte a Internet':
    'Exposées à Internet',
  'Gruppo di risorse':
    'Groupe de ressources',
  'Gruppo di sicurezza':
    'Groupe de sécurité',
  'IP privato':
    'IP privée',
  'Inventario cloud':
    'Inventaire cloud',
  'Istanza':
    'Instance',
  'Istanze accese':
    'Instances allumées',
  'La mappa dinamica dell’account scelto: account → regioni → reti (VPC, VNet, VCN) → subnet → istanze, basi dati, bilanciatori, funzioni e gruppi di sicurezza, con i volumi collegati alle loro istanze. Tre viste (gerarchica, radiale, organica), zoom con la rotella, filtro per regione e per genere, ricerca; un clic su un nodo apre i suoi dati e la scheda del CI. Il 🌐 segna ciò che è raggiungibile da Internet; le istanze spente sono sbiadite.':
    'La carte dynamique du compte choisi : compte → régions → réseaux (VPC, VNet, VCN) → sous-réseaux → instances, bases de données, équilibreurs, fonctions et groupes de sécurité, avec les volumes attachés à leurs instances. Trois vues (hiérarchique, radiale, organique), zoom à la molette, filtre par région et par genre, recherche ; un clic sur un nœud ouvre ses données et la fiche du CI. Le 🌐 marque ce qui est joignable depuis Internet ; les instances éteintes sont estompées.',
  'vista completa degli account e delle relative risorse, tra cui istanze, volumi, reti, security group, bilanciatori, database, storage e funzioni, rilevate dai connettori cloud. Consultabile a video o esportabile in Excel e PDF, con un livello di dettaglio analogo a RVTools.': 'Vue complète des comptes et de leurs ressources — instances, volumes, réseaux, security groups, équilibreurs, bases de données, stockage et fonctions — détectées par les connecteurs cloud. Consultable à l’écran ou exportable vers Excel et PDF, avec un niveau de détail comparable à RVTools.',
  'Mappa cloud di {account}: {n} nodi':
    'Carte cloud de {account} : {n} nœuds',
  'Molte risorse: i volumi sono contati sulla loro istanza invece che disegnati.':
    'Beaucoup de ressources : les volumes sont comptés sur leur instance au lieu d’être dessinés.',
  'Mostra':
    'Afficher',
  'Nessun ambiente cloud':
    'Aucun environnement cloud',
  'Nessuna risorsa cloud':
    'Aucune ressource cloud',
  'Nessuna risorsa da mostrare con questi filtri.':
    'Aucune ressource à afficher avec ces filtres.',
  'Regioni':
    'Régions',
  'Regole aperte a Internet':
    'Règles ouvertes à Internet',
  'Rete (VPC/VNet)':
    'Réseau (VPC/VNet)',
  'Scegli un nodo sulla mappa: qui compaiono i suoi dati. La rotella ingrandisce, il trascinamento sposta, il passaggio sopra un nodo accende i suoi collegamenti.':
    "Choisissez un nœud sur la carte : ses données apparaissent ici. La molette pour zoomer, cliquer sur l'objet pour le déplacer, le survol d’un nœud allume ses liens.",
  'Spenta':
    'Éteinte',
  'Taglia':
    'Taille',
  'Tutte le regioni':
    'Toutes les régions',
  'Tutto il cloud':
    'Tout le cloud',
  'Volumi':
    'Volumes',
  'costi non raccolti':
    'coûts non collectés',
  'in cima i totali (account, istanze accese, risorse esposte a Internet, gruppi di sicurezza aperti, costo del mese); sotto una card per account con i suoi numeri e il costo, che porta al Costi Cloud.':
    'en haut les totaux (comptes, instances allumées, ressources exposées à Internet, groupes de sécurité ouverts, coût du mois) ; en dessous une carte par compte avec ses chiffres et son coût, qui mène au Coûts cloud.',
  'l’inventario a fogli come RVTools — istanze, volumi, reti, security group, bilanciatori, basi dati, storage, funzioni — per un account o per tutto il cloud, a video, in Excel o in PDF.':
    'l’inventaire en feuilles comme RVTools — instances, volumes, réseaux, security groups, équilibreurs, bases de données, stockage, fonctions — pour un compte ou tout le cloud, à l’écran, en Excel ou en PDF.',
  'volume collegato':
    'volume attaché',
  '{account} · mappa':
    '{account} · carte',
  '{c} questo mese':
    '{c} ce mois-ci',
  '{n} SG aperti':
    '{n} SG ouverts',
  '{n} basi dati':
    '{n} bases de données',
  '{n} bilanciatori':
    '{n} équilibreurs',
  '{n} esposte':
    '{n} exposées',
  '{n} funzioni':
    '{n} fonctions',
  '{n} provider':
    '{n} fournisseurs',
  '{n} risorse':
    '{n} ressources',
  '{n} storage':
    '{n} stockages',
  '{n} volumi':
    '{n} volumes',
  '{n} volumi ({gb} GB)':
    '{n} volumes ({gb} Go)',
  'Con regole in ingresso da qualunque origine':
    'Avec des règles entrantes depuis n’importe quelle origine',
  'Istanze':
    'Instances',
  'Istanze, basi dati e bilanciatori con indirizzo pubblico':
    'Instances, bases de données et équilibreurs avec une adresse publique',
  'Security group aperti':
    'Groupes de sécurité ouverts',
  'aperti a tutti':
    'ouverts à tous',
  'con indirizzo pubblico':
    'avec une adresse publique',
  'dal primo del mese':
    'depuis le premier du mois',
  'API {piattaforma}':
    'API {piattaforma}',
  'Agente d’inventario':
    'Agent d’inventaire',
  'Apparato di rete':
    'Équipement réseau',
  'Apri un CI in Inventario → Configuration Item, vai alla sezione Eagle e scegli il profilo predefinito o i parametri da monitorare.':
    'Ouvrez un CI dans Inventaire → Configuration Items, allez à la section Eagle et choisissez le profil par défaut ou les paramètres à surveiller.',
  'Attenzione':
    'Attention',
  'Attiva il monitoraggio':
    'Activer la surveillance',
  'Attivazione':
    'Activation',
  'Attivo con il profilo «{profilo}»':
    'Actif avec le profil « {profilo} »',
  'Attivo con una scelta manuale':
    'Actif avec une sélection manuelle',
  'Attivo dal':
    'Actif depuis',
  'Attivo…':
    'Activation…',
  'Autonomia':
    'Autonomie',
  'Base':
    'Base',
  'CI monitorati':
    'CI surveillés',
  'CI monitorati ({n})':
    'CI surveillés ({n})',
  'CI monitorati in questo tenant: {n}':
    'CI surveillés dans ce tenant : {n}',
  'Carico':
    'Charge',
  'Come attivare il monitoraggio':
    'Comment activer la surveillance',
  'Connessione TCP dalla sonda':
    'Connexion TCP depuis la sonde',
  'Disponibilità':
    'Disponibilité',
  'Eagle · monitoraggio':
    'Eagle · surveillance',
  'Frequenza di {parametro}':
    'Fréquence de {parametro}',
  'Gruppo di continuità':
    'Onduleur',
  'Il monitoraggio si abilita dalla scheda del singolo CI, nella sezione Eagle.':
    'Les CI surveillés. La surveillance s’active depuis la fiche de chaque CI, section Eagle.',
  'Il CI non ha un indirizzo da interrogare.':
    'Le CI n’a pas d’adresse à interroger.',
  'Il profilo non ha parametri leggibili su questo CI: usa «Scelgo io» per vedere perché.':
    'Le profil n’a aucun paramètre lisible sur ce CI : utilisez « Je choisis » pour voir pourquoi.',
  'Il tuo ruolo può vedere Eagle ma non attivarlo.':
    'Votre rôle peut voir Eagle mais pas l’activer.',
  'Interfacce':
    'Interfaces',
  'La lettura via {metodo} arriva con un prossimo aggiornamento: puoi già sceglierlo, la scelta resta salvata.':
    'La lecture via {metodo} arrive avec une prochaine mise à jour : vous pouvez déjà la choisir, le choix est conservé.',
  'Metodo':
    'Méthode',
  'Monitora questo CI con le credenziali e i dati che CENSO ha già: scegli il profilo predefinito della sua classe oppure spunta tu i parametri e la frequenza.':
    'Surveillez ce CI avec les identifiants et les données que CENSO possède déjà : choisissez le profil par défaut de sa classe ou cochez vous-même les paramètres et la fréquence.',
  'Mostra tutti i parametri monitorabili ({n})':
    'Afficher tous les paramètres surveillables ({n})',
  'Nessun CI monitorato':
    'Aucun CI surveillé',
  'Nessuna fonte dell’inventario legge questo dato su questo CI: aggiungi una credenziale SNMP, SSH o WinRM, oppure installa l’agente d’inventario.':
    'Aucune source de l’inventaire ne lit cette donnée sur ce CI : ajoutez un identifiant SNMP, SSH ou WinRM, ou installez l’agent d’inventaire.',
  'Non più in inventario':
    'Plus dans l’inventaire',
  'Non più in inventario: la scelta resta finché non la togli.':
    'Plus dans l’inventaire : le choix reste jusqu’à ce que vous le retiriez.',
  'Pagina non disponibile':
    'Page non disponible',
  'Parametro':
    'Paramètre',
  'Parti dal profilo':
    'Partir du profil',
  'Ping dalla sonda':
    'Ping depuis la sonde',
  'Ping e interfacce attive.':
    'Ping et interfaces actives.',
  'Ping, CPU, memoria e le interfacce attive che portano un collegamento documentato o un uplink.':
    'Ping, CPU, mémoire et les interfaces actives portant un lien documenté ou un uplink.',
  'Ping, CPU, memoria, tutti i volumi, i servizi noti in ascolto e le interfacce attive.':
    'Ping, CPU, mémoire, tous les volumes, les services connus en écoute et les interfaces actives.',
  'Ping, carica della batteria, autonomia e carico.':
    'Ping, charge de la batterie, autonomie et charge.',
  'Ping.':
    'Ping.',
  'Profilo predefinito':
    'Profil par défaut',
  'Profilo predefinito: {profilo}':
    'Profil par défaut : {profilo}',
  'Quella predefinita di ogni parametro':
    'Celle par défaut de chaque paramètre',
  'Questa funzione non è attiva per il tuo spazio.':
    'Cette fonction n’est pas active pour votre espace.',
  'Raggiungibilità (ping)':
    'Joignabilité (ping)',
  'Scelgo io':
    'Je choisis',
  'Scelta manuale':
    'Sélection manuelle',
  'Scelto':
    'Choisi',
  'Servizio {porta}/tcp':
    'Service {porta}/tcp',
  'Soglia critica di {parametro}':
    'Seuil critique de {parametro}',
  'Soglia di attenzione di {parametro}':
    'Seuil d’attention de {parametro}',
  'Specifici della classe':
    'Spécifiques à la classe',
  'Spunta i parametri da monitorare e imposta la frequenza di ciascuno.':
    'Cochez les paramètres à surveiller et réglez la fréquence de chacun.',
  'Togli tutto':
    'Tout retirer',
  'Volume {mount}':
    'Volume {mount}',
  'dal {quando}':
    'depuis le {quando}',
  'in attesa dei primi dati':
    'en attente des premières données',
  'non monitorato':
    'non surveillé',
  'perdita di pacchetti':
    'perte de paquets',
  'sopra {v}':
    'au-dessus de {v}',
  'sotto {v}':
    'en dessous de {v}',
  'spazio usato':
    'espace utilisé',
  'tempo di risposta':
    'temps de réponse',
  'utilizzo':
    'utilisation',
  'utilizzo di banda, errori e stato':
    'utilisation de la bande passante, erreurs et état',
  '{n} parametri monitorati':
    '{n} paramètres surveillés',
  '{n} parametri su questo CI':
    '{n} paramètres sur ce CI',
  'Inventario adesso':
    'Inventaire maintenant',
  'L’agente raccoglie e consegna subito, entro un minuto, senza aspettare il suo intervallo.':
    'L’agent collecte et livre tout de suite, en moins d’une minute, sans attendre son intervalle.',
  'Questo agente non è ancora residente: consegna solo al suo intervallo. Con l’aggiornamento automatico diventa residente da solo.':
    'Cet agent n’est pas encore résident : il ne livre qu’à son intervalle. Avec la mise à jour automatique, il devient résident tout seul.',
  'Ultimo contatto':
    'Dernier contact',
  'in linea':
    'en ligne',
  'non residente':
    'non résident',
  'prossimo inventario {quando}':
    'prochain inventaire {quando}',
  'Mostra le ultime 24 ore':
    'Afficher les dernières 24 heures',
  'Servono almeno due misure per disegnare l’andamento.':
    'Il faut au moins deux mesures pour tracer l’évolution.',
  'attenzione':
    'attention',
  'non risponde':
    'ne répond pas',
  'Se un EDR (per esempio Cynet) blocca il comando, usa il pacchetto Windows qui sotto anche per una macchina sola: si estrae lo zip e si lancia install.cmd da amministratore. Non c’è nessuno script PowerShell e nessuno scaricamento, perché l’agente si installa da solo.':
    'Si un EDR (par exemple Cynet) bloque la commande, utilisez le paquet Windows ci-dessous même pour une seule machine : extrayez le zip et lancez install.cmd en administrateur. Il n’y a aucun script PowerShell ni téléchargement, car l’agent s’installe tout seul.',
  'Un pacchetto con l’agente e la sua configurazione che non scarica niente: su Windows install.cmd lancia l’agente, che si installa da solo senza script PowerShell (la strada che gli EDR non bloccano). Si mette su una share o in Intune/SCCM e si installa su quante macchine vuoi, ognuna diventa il suo CI. Contiene il segreto dell’agente: trattalo come una credenziale. Si scarica solo adesso (finestra d’installazione); una volta scaricato non scade, e lo invalidi rigenerando o revocando l’agente.':
    'Un paquet avec l’agent et sa configuration qui ne télécharge rien : sous Windows, install.cmd lance l’agent, qui s’installe tout seul sans script PowerShell (la voie que les EDR ne bloquent pas). Placez-le sur un partage ou dans Intune/SCCM et installez-le sur autant de machines que vous voulez ; chacune devient son propre CI. Il contient le secret de l’agent : traitez-le comme un identifiant. Il ne se télécharge que maintenant (fenêtre d’installation) ; une fois téléchargé il n’expire pas, et vous l’invalidez en régénérant ou en révoquant l’agent.',
  '{p} principali · {s} secondari':
    '{p} principaux · {s} secondaires',
  'Aggiungi una sonda':
    'Ajouter une sonde',
  'CI letti':
    'CI lus',
  'dedicata':
    'dédiée',
  'Dedicata al monitoraggio':
    'Dédiée à la supervision',
  'Esclusa da Eagle':
    'Exclue d’Eagle',
  'La prima sonda legge tutti i parametri; le altre solo ping e porte, così l’oggetto risulta giù solo se non risponde a nessuna.':
    'La première sonde lit tous les paramètres ; les autres seulement ping et ports, ainsi l’objet n’est en panne que s’il ne répond à aucune.',
  'nessuna sonda attiva può leggerlo adesso':
    'aucune sonde active ne peut le lire maintenant',
  'non attiva':
    'inactive',
  'Normale: legge i CI che ha scoperto':
    'Normale : lit les CI qu’elle a découverts',
  'Osservato da':
    'Observé depuis',
  'principale':
    'principale',
  'rendi principale':
    'rendre principale',
  'Rendi principale {sonda}':
    'Rendre {sonda} principale',
  'Reti di {sonda}':
    'Réseaux de {sonda}',
  'Ruolo di {sonda}':
    'Rôle de {sonda}',
  'scelta automatica':
    'choix automatique',
  'Scelta automatica: una sonda dedicata al monitoraggio che copre l’indirizzo, altrimenti quella che ha scoperto il CI.':
    'Choix automatique : une sonde dédiée à la supervision qui couvre l’adresse, sinon celle qui a découvert le CI.',
  'scelta manuale':
    'choix manuel',
  'solo raggiungibilità':
    'joignabilité seulement',
  'Togli {sonda}':
    'Retirer {sonda}',
  'Torna alla scelta automatica':
    'Revenir au choix automatique',
  'Seleziona la sonda da dedicare al monitoraggio Eagle. Indica le reti da monitorare; se non ne specifichi nessuna, la sonda monitora tutti i CI. La sonda di origine resta disponibile per la discovery. La sonda esclusa da Eagle non acquisisce dati di monitoraggio.':
    'Une sonde dédiée à la supervision lit les CI des réseaux indiqués (vide = tous) à la place de la sonde qui les a découverts, qui reste libre pour la découverte. Une sonde exclue ne lit rien pour Eagle.',
  'Togli il tetto':
    'Retirer le plafond',
  '{n}% in ritardo':
    '{n} % en retard',
  'Tetto: {n} parametri':
    'Plafond : {n} paramètres',
  'fissato: {n} letture su {m} in ritardo':
    'fixé : {n} lectures sur {m} en retard',
  'allentato: nessun ritardo':
    'assoupli : aucun retard',
  '{n} parametri':
    '{n} paramètres',
  'Servizi automatici':
    'Services automatiques',
  'Servizio {nome}':
    'Service {nome}',
  'quanti servizi ad avvio automatico sono fermi (su Linux: unità in errore)':
    'combien de services à démarrage automatique sont arrêtés (sous Linux : unités en échec)',
  'in esecuzione':
    'en cours d’exécution',
  'Aggiungi un gruppo di servizi':
    'Ajouter un groupe de services',
  'Aggiungi un processo':
    'Ajouter un processus',
  'Almeno':
    'Au moins',
  'almeno {n} attivi fra: {regola}':
    'au moins {n} actifs parmi : {regola}',
  'Almeno un certo numero attivi':
    'Au moins un certain nombre actifs',
  'Cerca un servizio':
    'Rechercher un service',
  'Comprende ogni servizio il cui nome corrisponde, anche quelli installati dopo.':
    'Inclut tout service dont le nom correspond, y compris ceux installés plus tard.',
  'es. SQL Server':
    'ex. SQL Server',
  'Giù se non ce n’è nessuno in esecuzione; il valore è quante istanze girano.':
    'En panne si aucun ne tourne ; la valeur est le nombre d’instances en cours.',
  'Gruppo di servizi «{nome}»':
    'Groupe de services « {nome} »',
  'istanze in esecuzione':
    'instances en cours',
  'Modello (facoltativo)':
    'Modèle (facultatif)',
  'Nome del processo':
    'Nom du processus',
  'Nuovo gruppo di servizi':
    'Nouveau groupe de services',
  'Nuovo processo':
    'Nouveau processus',
  'Processi':
    'Processus',
  'Processo {nome}':
    'Processus {nome}',
  'Quando è a posto':
    'Quand tout va bien',
  'Servizi scelti ({n})':
    'Services choisis ({n})',
  'tutti attivi: {regola}':
    'tous actifs : {regola}',
  'Tutti i servizi del gruppo attivi':
    'Tous les services du groupe actifs',
  'Tempo dall’avvio':
    'Temps depuis le démarrage',
  'ore dall’avvio: sotto la soglia la macchina è ripartita da poco':
    'heures depuis le démarrage : sous le seuil la machine a redémarré récemment',
  'Salute del disco {nome}':
    'Santé du disque {nome}',
  'Aggiornamenti in sospeso':
    'Mises à jour en attente',
  'Riavvio richiesto':
    'Redémarrage requis',
  'guasto previsto (SMART); sulle macchine virtuali non è disponibile':
    'panne prévue (SMART) ; non disponible sur les machines virtuelles',
  'dall’ultima ricerca del sistema, senza andare in rete':
    'depuis la dernière recherche du système, sans aller sur le réseau',
  'il sistema chiede un riavvio per completare gli aggiornamenti':
    'le système demande un redémarrage pour terminer les mises à jour',
  '{n} critici':
    '{n} critiques',
  '{n} in attenzione':
    '{n} en avertissement',
  '{n} non rispondono':
    '{n} ne répondent pas',
  '{n} ok':
    '{n} ok',
  '95° pct {v}':
    '95e pct {v}',
  'Andamento di {parametro} nelle ultime {ore} ore':
    'Évolution de {parametro} sur les {ore} dernières heures',
  'Cerca un CI':
    'Rechercher un CI',
  'da {quando}':
    'depuis {quando}',
  'Finestra di tempo':
    'Fenêtre de temps',
  'la fascia è il minimo–massimo di ogni intervallo; la linea la media':
    'la bande est le minimum–maximum de chaque intervalle ; la ligne la moyenne',
  'Le sonde viste da Eagle: chi legge che cosa, e con quale carico.':
    'Les sondes vues par Eagle : qui lit quoi, et avec quelle charge.',
  'min {min} · max {max}':
    'min {min} · max {max}',
  'nessun parametro in allarme nel periodo':
    'aucun paramètre en alarme sur la période',
  'Nessun parametro in attenzione, critico o che non risponde.':
    'Aucun paramètre en avertissement, critique ou sans réponse.',
  'Nessuna misura nel periodo.':
    'Aucune mesure sur la période.',
  'Parametro in allarme':
    'Paramètre en alarme',
  'Parametri in allarme nel tempo':
    'Paramètres en alarme dans le temps',
  'Parametri in allarme per intervallo nelle ultime {ore} ore':
    'Paramètres en alarme par intervalle sur les {ore} dernières heures',
  'solo con problemi':
    'seulement avec problèmes',
  'stato':
    'état',
  'tutto regolare':
    'tout est normal',
  'Eagle è il monitoraggio: legge nel tempo i parametri dei CI che scegli — raggiungibilità, porte, CPU, memoria, dischi, servizi, processi, interfacce — con le credenziali e i dati che CENSO ha già. È un modulo a parte: se non lo vedi nel menu, non è attivo per il tuo spazio.':
    'Eagle est la supervision : il lit dans le temps les paramètres des CI que vous choisissez — joignabilité, ports, CPU, mémoire, disques, services, processus, interfaces — avec les identifiants et les données que CENSO a déjà. C’est un module à part : si vous ne le voyez pas dans le menu, il n’est pas actif pour votre espace.',
  'l’elenco di ciò che Eagle legge, con quanti parametri e da quando.':
    'la liste de ce qu’Eagle lit, avec le nombre de paramètres et depuis quand.',
  'chi legge che cosa: il ruolo di ogni sonda (normale, dedicata al monitoraggio con le sue reti, esclusa), quanti CI legge e con quale carico.':
    'qui lit quoi : le rôle de chaque sonde (normale, dédiée à la supervision avec ses réseaux, exclue), combien de CI elle lit et avec quelle charge.',
  'Nella scheda di un CI, la sezione Eagle: l’attivazione (profilo della classe o scelta manuale), i parametri con frequenza, soglie e stato, «Osservato da» per scegliere le sonde, e in fondo i gruppi di servizi e i processi da aggiungere a mano.':
    'Dans la fiche d’un CI, la section Eagle : l’activation (profil de la classe ou choix manuel), les paramètres avec fréquence, seuils et état, « Observé depuis » pour choisir les sondes, et en bas les groupes de services et processus à ajouter à la main.',
  'Apri un CI, sezione Eagle, e attiva il monitoraggio con il profilo predefinito: accende ciò che si può leggere su quella classe. «Scelgo io» per spuntare i parametri uno a uno.':
    'Ouvrez un CI, section Eagle, et activez la supervision avec le profil par défaut : il allume ce qui peut être lu sur cette classe. « Je choisis » pour cocher les paramètres un à un.',
  'Sul grafico di un parametro scegli la finestra (1 ora, 6 ore, 24 ore, 7 giorni): la linea è il valore, la fascia il minimo–massimo di ogni intervallo, sotto la striscia di stato minuto per minuto.':
    'Sur le graphique d’un paramètre, choisissez la fenêtre (1 heure, 6 heures, 24 heures, 7 jours) : la ligne est la valeur, la bande le minimum–maximum de chaque intervalle, en dessous la bande d’état minute par minute.',
  'Per vedere un oggetto da più sedi, «Osservato da» → «Cambia»: la prima sonda legge tutto, le altre solo ping e porte, e l’oggetto è giù solo se non risponde a nessuna.':
    'Pour observer un objet depuis plusieurs sites, « Observé depuis » → « Changer » : la première sonde lit tout, les autres seulement ping et ports, et l’objet n’est en panne que s’il ne répond à aucune.',
  'Un parametro «non disponibile» non è un guasto: l’apparato non espone quel dato (una VM non ha il SMART dei dischi). «In attesa» aspetta la prima lettura.':
    'Un paramètre « indisponible » n’est pas une panne : l’équipement n’expose pas cette donnée (une VM n’a pas de SMART disque). « En attente » attend la première lecture.',
  'CPU, memoria, dischi, servizi e processi dei server con l’agente li legge l’agente stesso, con il keep-alive di ogni minuto; gli apparati di rete si leggono via SNMP con la credenziale che ha risposto in discovery.':
    'CPU, mémoire, disques, services et processus des serveurs avec l’agent sont lus par l’agent lui-même, avec le keep-alive de chaque minute ; les équipements réseau sont lus via SNMP avec l’identifiant qui a répondu en découverte.',
  'Le sonde elaborano sul posto e mandano al Control Plane i cambi di stato subito e le medie ogni cinque minuti: se una resta indietro, il cruscotto delle sonde lo mostra e il carico passa a un’altra che vede gli stessi CI.':
    'Les sondes traitent sur place et envoient au Control Plane les changements d’état aussitôt et les moyennes toutes les cinq minutes : si l’une prend du retard, la vue des sondes le montre et la charge passe à une autre qui voit les mêmes CI.',
  '{n} min':
    '{n} min',
  'Aggiungi una fascia':
    'Ajouter une plage',
  'Alle':
    'Jusqu’à',
  'Attesa':
    'Attente',
  'Attesa prima di avvisare (minuti)':
    'Attente avant d’alerter (minutes)',
  'Avvisa':
    'Alerter',
  'avvisa comunque':
    'alerter quand même',
  'Campanella in console':
    'Cloche de la console',
  'Canali':
    'Canaux',
  'Configura destinatari, livelli di gravità, canali e orari delle notifiche. Il gruppo viene associato a ciascun CI monitorato nella sezione Eagle.':
    'Qui alerter pour quelles gravités, par quels canaux, à quelles heures. Chaque CI supervisé choisit son groupe dans la section Eagle.',
  'Gestione delle notifiche: contatti, orari di reperibilità, gruppi di notifica e SLA.':
    'Qui alerter, à quelles heures, avec quel engagement : contacts, horaires de travail, groupes de notification, SLA.',
  'Contatti':
    'Contacts',
  'Contatti ({n})':
    'Contacts ({n})',
  'Crea prima un contatto.':
    'Créez d’abord un contact.',
  'Dalle':
    'De',
  'Disponibilità attesa (%)':
    'Disponibilité attendue (%)',
  'dom':
    'dim',
  'Eagle → Notifiche':
    'Eagle → Notifications',
  'Fasce':
    'Plages',
  'Festività':
    'Jours fériés',
  'Festività (una data per riga, AAAA-MM-GG)':
    'Jours fériés (une date par ligne, AAAA-MM-JJ)',
  'Fuori orario':
    'Hors horaires',
  'gio':
    'jeu',
  'Giorno':
    'Jour',
  'Gruppi di notifica ({n})':
    'Groupes de notification ({n})',
  'Gruppi e SLA si definiscono in':
    'Les groupes et SLA se définissent dans',
  'Gruppo di notifica':
    'Groupe de notification',
  'i contatti (le persone da avvisare), gli orari di lavoro (fasce e festività in un fuso), i gruppi di notifica (chi, per quali gravità, con quali canali, cosa fare fuori orario, quanto aspettare prima di avvisare) e gli SLA (disponibilità attesa, presa in carico e risoluzione). Ogni CI sceglie il suo gruppo e il suo SLA nella sezione Eagle.':
    'les contacts (les personnes à alerter), les horaires de travail (plages et jours fériés dans un fuseau), les groupes de notification (qui, pour quelles gravités, par quels canaux, que faire hors horaires, combien attendre avant d’alerter) et les SLA (disponibilité attendue, prise en charge et résolution). Chaque CI choisit son groupe et son SLA dans la section Eagle.',
  'Definisce i livelli di servizio: disponibilità mensile attesa, tempi di presa in carico e risoluzione e relative fasce di validità. Ogni CI monitorato utilizza lo SLA assegnato nella sezione Eagle; lo stesso SLA è il riferimento per i report di disponibilità.':
    'L’engagement : la disponibilité attendue dans le mois, sous quel délai quelqu’un prend en charge et résout, et à quelles heures il s’applique. Chaque CI supervisé choisit son SLA dans la section Eagle ; les rapports de disponibilité se mesurent dessus.',
  'lun':
    'lun',
  'mar':
    'mar',
  'mer':
    'mer',
  'Nessun calendario configurato: le notifiche sono sempre attive.':
    'Aucun calendrier : sans, les groupes alertent à toute heure.',
  'Nessun contatto ancora.':
    'Aucun contact pour l’instant.',
  'Nessun gruppo configurato: le notifiche non vengono inviate.':
    'Aucun groupe pour l’instant : sans, personne n’est alerté.',
  'Nessuno SLA ancora.':
    'Aucun SLA pour l’instant.',
  'niente, si vede al rientro':
    'rien, on verra au retour',
  'Nuovo calendario':
    'Nouveau calendrier',
  'Nuovo contatto':
    'Nouveau contact',
  'Nuovo SLA':
    'Nouveau SLA',
  'Orari di lavoro':
    'Horaires de travail',
  'Orari di lavoro ({n})':
    'Horaires de travail ({n})',
  'Presa in carico':
    'Prise en charge',
  'Presa in carico entro (minuti)':
    'Prise en charge sous (minutes)',
  'Definisce giorni, fasce orarie e festività in cui il servizio è attivo. Gli SLA si applicano durante l’orario di servizio; fuori orario, il comportamento dipende dal gruppo di notifica.':
    'Quand on est en service : les plages par jour de la semaine dans le fuseau indiqué, et les jours fériés. Les groupes de notification décident quoi faire hors de ces horaires ; les SLA s’appliquent dedans.',
  'ripete ogni {n} min':
    'répète toutes les {n} min',
  'Ripeti ogni (minuti, 0 = mai)':
    'Répéter toutes les (minutes, 0 = jamais)',
  'Risoluzione':
    'Résolution',
  'Risoluzione entro (minuti)':
    'Résolution sous (minutes)',
  'sab':
    'sam',
  'Sempre (24 ore su 24, 7 giorni su 7)':
    'Toujours (24 h sur 24, 7 jours sur 7)',
  'SLA':
    'SLA',
  'SLA ({n})':
    'SLA ({n})',
  'solo critico e non risponde':
    'seulement critique et sans réponse',
  'spento':
    'désactivé',
  'Telefono':
    'Téléphone',
  'Togliere questa voce?':
    'Retirer cette entrée ?',
  'Un problema che rientra da solo entro l’attesa non avvisa nessuno.':
    'Un problème qui se résout seul pendant l’attente n’alerte personne.',
  'Vale negli orari':
    'S’applique aux horaires',
  'ven':
    'ven',
  '← Report':
    '← Rapports',
  '{h} h {m} min':
    '{h} h {m} min',
  '{n} CI scelti':
    '{n} CI choisis',
  '{n} s':
    '{n} s',
  'Aggiungi almeno un blocco.':
    'Ajoutez au moins un bloc.',
  'Aggiungi un blocco':
    'Ajouter un bloc',
  'Al massimo (righe)':
    'Au plus (lignes)',
  'Anteprima':
    'Aperçu',
  'Blocchi':
    'Blocs',
  'Blocchi, nell’ordine del report':
    'Blocs, dans l’ordre du rapport',
  'CI nel report':
    'CI dans le rapport',
  'CI o parametro non trovato.':
    'CI ou paramètre introuvable.',
  'CI scelti':
    'CI choisis',
  'CI, disponibilità media, incidenti, tempo giù, SLA rispettati, il peggiore.':
    'CI, disponibilité moyenne, incidents, temps d’arrêt, SLA respectés, le pire.',
  'classi: {classi}':
    'classes : {classi}',
  'Crea il primo report: seleziona il periodo, i CI e i blocchi da includere, come riepilogo, disponibilità, incidenti, grafici e SLA; verifica l’anteprima e salva.':
    'Composez le premier : choisissez la période, les CI et les blocs (résumé, disponibilité, incidents, graphiques, SLA), regardez l’aperçu et enregistrez.',
  'Composizione del report':
    'Composition du rapport',
  'disponibilità media':
    'disponibilité moyenne',
  'Disponibilità per CI':
    'Disponibilité par CI',
  'es. Disponibilità mensile':
    'ex. Disponibilité mensuelle',
  'Eseguo…':
    'Exécution…',
  'generato {quando}':
    'généré {quando}',
  'Giù':
    'Arrêt',
  'Grafico di un parametro':
    'Graphique d’un paramètre',
  'I parametri di un tipo con la media più alta: CPU, memoria, volumi, interfacce.':
    'Les paramètres d’un type avec la moyenne la plus élevée : CPU, mémoire, volumes, interfaces.',
  'I tratti in cui un CI non rispondeva: da, a, durata.':
    'Les périodes où un CI ne répondait pas : de, à, durée.',
  'Il mese scorso':
    'Le mois dernier',
  'il peggiore: {p}':
    'le pire : {p}',
  'incidenti':
    'incidents',
  'Incidenti':
    'Incidents',
  'Incidenti ({n})':
    'Incidents ({n})',
  'La copertura dice quanta parte del periodo era davvero osservata: una disponibilità su poche misure vale poco.':
    'La couverture indique quelle part de la période a réellement été observée : une disponibilité sur peu de mesures vaut peu.',
  'La disponibilità di un CI si misura sulla sua raggiungibilità (il ping, o la prima porta monitorata) e, con uno SLA che vale in certi orari, solo dentro quegli orari. La copertura dice quanta parte del periodo era davvero osservata: una disponibilità su poche misure vale poco. Nel PDF i grafici diventano tabelle.':
    'La disponibilité d’un CI se mesure sur sa joignabilité (le ping, ou le premier port supervisé) et, avec un SLA valable à certaines heures, seulement dans ces heures. La couverture indique quelle part de la période a réellement été observée : une disponibilité sur peu de mesures vaut peu. Dans le PDF, les graphiques deviennent des tableaux.',
  'L’andamento degli allarmi intervallo per intervallo.':
    'L’évolution des alarmes intervalle par intervalle.',
  'L’andamento di un parametro di un CI nel periodo.':
    'L’évolution d’un paramètre d’un CI sur la période.',
  'Mancati':
    'Manqués',
  'mancato':
    'manqué',
  'Massimo':
    'Maximum',
  'Misure':
    'Mesures',
  'Nessun CI del report ha uno SLA.':
    'Aucun CI du rapport n’a de SLA.',
  'Nessun incidente nel periodo.':
    'Aucun incident sur la période.',
  'Nessun report ancora':
    'Aucun rapport pour l’instant',
  'Nuovo report':
    'Nouveau rapport',
  'Parametri più alti':
    'Paramètres les plus élevés',
  'Parametri più alti ({tipo})':
    'Paramètres les plus élevés ({tipo})',
  'Peggiore':
    'Pire',
  'Per classe':
    'Par classe',
  'Per ogni CI: disponibilità, tempo giù, incidenti, copertura, SLA.':
    'Pour chaque CI : disponibilité, temps d’arrêt, incidents, couverture, SLA.',
  'Per ogni SLA: quanti CI lo rispettano e quanti no.':
    'Pour chaque SLA : combien de CI le respectent et combien non.',
  'Periodo: {da} – {a} · {n} CI':
    'Période : {da} – {a} · {n} CI',
  'Ping':
    'Ping',
  'Porte TCP':
    'Ports TCP',
  'Quanti':
    'Combien',
  'Questo mese':
    'Ce mois-ci',
  'Report ({n})':
    'Rapports ({n})',
  'Crea report configurabili per periodo, CI e contenuti. I report vengono generati sui dati correnti e possono essere esportati in PDF o Excel.':
    'Des rapports que l’on compose : période, CI et blocs au choix ; ils s’exécutent sur les données du moment et se téléchargent en PDF ou Excel.',
  'report che si compongono: scegli il periodo (ultime 24 ore, 7 o 30 giorni, questo mese, il mese scorso), l’ambito (tutti i CI, per classe, CI scelti) e i blocchi in ordine — riepilogo, disponibilità per CI, incidenti, andamento degli allarmi, parametri più alti, grafico di un parametro, rispetto degli SLA, testo — guarda l’anteprima, salva, scarica in PDF o Excel.':
    'des rapports que l’on compose : choisissez la période (dernières 24 heures, 7 ou 30 jours, ce mois-ci, le mois dernier), le périmètre (tous les CI, par classe, CI choisis) et les blocs dans l’ordre — résumé, disponibilité par CI, incidents, évolution des alarmes, paramètres les plus élevés, graphique d’un paramètre, respect des SLA, texte — regardez l’aperçu, enregistrez, téléchargez en PDF ou Excel.',
  'Riepilogo':
    'Résumé',
  'Rispettati':
    'Respectés',
  'rispettato':
    'respecté',
  'Rispetto degli SLA':
    'Respect des SLA',
  'Scarica Excel':
    'Télécharger Excel',
  'Scarica PDF':
    'Télécharger le PDF',
  'Senza dati':
    'Sans données',
  'SLA rispettati':
    'SLA respectés',
  'Sposta giù':
    'Descendre',
  'Sposta su':
    'Monter',
  'tempo giù {d}':
    'temps d’arrêt {d}',
  'Tipo di parametro':
    'Type de paramètre',
  'Titolo':
    'Titre',
  'Togliere questo report?':
    'Retirer ce rapport ?',
  'tutti i CI monitorati':
    'tous les CI supervisés',
  'Tutti i CI monitorati':
    'Tous les CI supervisés',
  'Un titolo e un testo libero: una premessa, una conclusione.':
    'Un titre et un texte libre : une introduction, une conclusion.',
  'Nessuna credenziale SNMP nel tuo spazio: aggiungine una in Credenziali e Eagle la proverà al primo giro.':
    'Aucun identifiant SNMP dans votre espace : ajoutez-en un dans Identifiants et Eagle l’essaiera au premier tour.',
  'La discovery non ha ancora detto quale credenziale SNMP risponde: Eagle prova quelle del tuo spazio al primo giro e ricorda la buona.':
    'La découverte n’a pas encore dit quel identifiant SNMP répond : Eagle essaie ceux de votre espace au premier tour et retient le bon.',
  '{a} sorgenti · {b} con credenziali':
    '{a} sources · {b} avec identifiants',
  '{d}% rispetto allo stesso giorno del mese scorso':
    '{d} % par rapport au même jour du mois dernier',
  '{libero} liberi su {tot}':
    '{libero} libres sur {tot}',
  '{n} in attenzione · {m} CI monitorati':
    '{n} en avertissement · {m} CI supervisés',
  '{n} in tutto':
    '{n} au total',
  '{n} silenziosi':
    '{n} silencieux',
  '{v} nella finestra':
    '{v} dans la fenêtre',
  '+ sezione':
    '+ section',
  'Aggiungi widget':
    'Ajouter un widget',
  'apparati che mandano flussi':
    'équipements envoyant des flux',
  'Apparati con backup recente, fermo, o senza.':
    'Équipements avec sauvegarde récente, bloquée, ou sans.',
  'apri':
    'ouvrir',
  'Asset e contratti':
    'Actifs et contrats',
  'Backup delle configurazioni':
    'Sauvegardes des configurations',
  'Capacità e costi':
    'Capacité et coûts',
  'Catalogo dei widget':
    'Catalogue des widgets',
  'Chi fa più traffico':
    'Qui génère le plus de trafic',
  'CI per tipo':
    'CI par type',
  'Compute':
    'Calcul',
  'Conversazioni principali':
    'Conversations principales',
  'Coperti da contratto e scoperti.':
    'Couverts par contrat et non couverts.',
  'Costi cloud del mese':
    'Coûts cloud du mois',
  'CPU allocata {x}× · memoria {y}×':
    'CPU allouée {x}× · mémoire {y}×',
  'critici o che non rispondono':
    'critiques ou sans réponse',
  'da classificare':
    'à classer',
  'dall’inizio del mese':
    'depuis le début du mois',
  'Dashboard del tenant':
    'Tableau de bord du tenant',
  'Dashboard predefinita: personalizzala e diventa tua.':
    'Tableau de bord par défaut : personnalisez-le et il devient le vôtre.',
  'Dati non disponibili al momento.':
    'Données indisponibles pour le moment.',
  'Dove vanno i soldi.':
    'Où va l’argent.',
  'Eagle · parametri in allarme nel tempo':
    'Eagle · paramètres en alarme dans le temps',
  'Eagle · parametri per stato':
    'Eagle · paramètres par état',
  'Eagle · problemi aperti':
    'Eagle · problèmes ouverts',
  'Eagle · problemi gravi':
    'Eagle · problèmes graves',
  'Esc per uscire':
    'Échap pour quitter',
  'Esportatori di flussi':
    'Exportateurs de flux',
  'Ferma':
    'Pause',
  'Gli agenti per stato e le vulnerabilità.':
    'Les agents par état et les vulnérabilités.',
  'Gli apparati che mandano flussi, e quelli silenziosi.':
    'Les équipements qui envoient des flux, et ceux qui sont silencieux.',
  'Gli asset per fascia di rischio.':
    'Les actifs par niveau de risque.',
  'Gli avvistamenti di chi parla senza essere censito.':
    'Les détections de ceux qui parlent sans être recensés.',
  'Gli indirizzi e i CI con più byte, in entrata e in uscita.':
    'Les adresses et CI avec le plus d’octets, entrants et sortants.',
  'Gli indirizzi non censiti con più traffico.':
    'Les adresses non recensées avec le plus de trafic.',
  'I job di discovery terminati con errore.':
    'Les jobs de découverte terminés en erreur.',
  'I parametri in attenzione, critici o giù.':
    'Les paramètres en avertissement, critiques ou en panne.',
  'I prodotti a fine supporto in inventario.':
    'Les produits en fin de support dans l’inventaire.',
  'I rischi per gravità.':
    'Les constats par gravité.',
  'I tocchi sulle esche e chi li fa.':
    'Les touches sur les leurres et leurs auteurs.',
  'Il numero che conta: critici e non risponde.':
    'Le chiffre qui compte : critiques et sans réponse.',
  'Il traffico per protocollo.':
    'Le trafic par protocole.',
  'Il traffico per servizio (porta).':
    'Le trafic par service (port).',
  'in linea su totali':
    'en ligne sur le total',
  'In linea, degradate, non raggiungibili.':
    'En ligne, dégradées, injoignables.',
  'indirizzi e porte che ricevono connessioni':
    'adresses et ports recevant des connexions',
  'Indirizzi e porte che ricevono connessioni.':
    'Adresses et ports recevant des connexions.',
  'Job per stato':
    'Job par état',
  'La composizione del parco.':
    'La composition du parc.',
  'La mia dashboard':
    'Mon tableau de bord',
  'La tua dashboard':
    'Votre tableau de bord',
  'L’andamento degli allarmi.':
    'L’évolution des alarmes.',
  'L’andamento del traffico nella finestra.':
    'L’évolution du trafic dans la fenêtre.',
  'Le coppie che si parlano di più.':
    'Les paires qui se parlent le plus.',
  'Le sonde che rispondono, sul totale.':
    'Les sondes qui répondent, sur le total.',
  'Le VM con e senza backup.':
    'Les VM avec et sans sauvegarde.',
  'Misura del widget':
    'Taille du widget',
  'Movimenti dell’inventario':
    'Mouvements de l’inventaire',
  'Nessun CI monitorato.':
    'Aucun CI supervisé.',
  'Nessun rischio.':
    'Aucun constat.',
  'Nome della dashboard':
    'Nom du tableau de bord',
  'non più visti':
    'plus vus',
  'Nuova sezione':
    'Nouvelle section',
  'Nuovi, non più visti, da classificare negli ultimi 7 giorni.':
    'Nouveaux, plus vus, à classer sur les 7 derniers jours.',
  'Ok, attenzione, critico, non risponde.':
    'Ok, avertissement, critique, sans réponse.',
  'Predefinita':
    'Par défaut',
  'prodotti a fine supporto in inventario':
    'produits en fin de support dans l’inventaire',
  'Protezione':
    'Protection',
  'Protezione e capacità':
    'Protection et capacité',
  'Protocolli':
    'Protocoles',
  'Quanti CI sono riconosciuti da almeno una fonte.':
    'Combien de CI sont reconnus par au moins une source.',
  'Quanto si scopre nel tempo: nuovi e scomparsi.':
    'Ce qui se découvre dans le temps : nouveaux et disparus.',
  'Quanto storage è usato e quanto ne resta.':
    'Combien de stockage est utilisé et combien il en reste.',
  'Questa sezione è vuota.':
    'Cette section est vide.',
  'Questo widget non esiste più: toglilo dalla dashboard.':
    'Ce widget n’existe plus : retirez-le du tableau de bord.',
  'registro':
    'journal',
  'Rischi sui CI':
    'Constats sur les CI',
  'riconosciuti da almeno una fonte':
    'reconnus par au moins une source',
  'Riprendi':
    'Reprendre',
  'Rischio degli asset':
    'Risque des actifs',
  'Riusciti, in corso, in attesa, falliti.':
    'Réussis, en cours, en attente, échoués.',
  'Salva come mia':
    'Enregistrer comme le mien',
  'Salva per il tenant':
    'Enregistrer pour le tenant',
  'Scansioni':
    'Analyses',
  'Sconosciuti che parlano di più':
    'Inconnus qui parlent le plus',
  'Servizi esposti':
    'Services exposés',
  'Servizi più usati':
    'Services les plus utilisés',
  'Sezione vuota: aggiungi un widget dal catalogo.':
    'Section vide : ajoutez un widget depuis le catalogue.',
  'Sinottico':
    'Synoptique',
  'Sinottico: cambia sezione ogni':
    'Synoptique : changer de section toutes les',
  'Sonde in linea':
    'Sondes en ligne',
  'Sonde per stato':
    'Sondes par état',
  'Spazio per fermare o riprendere la rotazione':
    'Espace pour arrêter ou reprendre la rotation',
  'Speso finora, confronto e stima a fine mese.':
    'Dépensé jusqu’ici, comparaison et estimation de fin de mois.',
  'stima a fine mese {v}':
    'estimation de fin de mois {v}',
  'su {n} CI':
    'sur {n} CI',
  'su {n} job':
    'sur {n} jobs',
  'Titolo della sezione':
    'Titre de la section',
  'tocchi sulle esche':
    'touches sur les leurres',
  'togli sezione':
    'retirer la section',
  'Togliere la sezione «{s}» con i suoi widget?':
    'Retirer la section « {s} » avec ses widgets ?',
  'Tornare alla dashboard predefinita? La tua personalizzazione va persa.':
    'Revenir au tableau de bord par défaut ? Votre personnalisation sera perdue.',
  'Trascina per spostare':
    'Glisser pour déplacer',
  'ultimi {n} giorni':
    '{n} derniers jours',
  'ultimi 7 giorni':
    '7 derniers jours',
  'usato':
    'utilisé',
  'visti in rete senza accesso':
    'vus sur le réseau sans accès',
  'Visti in rete senza accesso: la coda di lavoro.':
    'Vus sur le réseau sans accès : la file de travail.',
  'VM su {n} host':
    'VM sur {n} hôtes',
  'VM, host e allocazione.':
    'VM, hôtes et allocation.',
  'Volume di traffico':
    'Volume de trafic',
  'Nel sinottico le frecce cambiano sezione, spazio ferma la rotazione, Esc esce; «Schermo intero» toglie anche la cornice del browser. Ogni widget si aggiorna da sé senza lampeggiare: si può lasciare acceso.':
    'Dans le synoptique les flèches changent de section, espace arrête la rotation, Échap quitte ; « Plein écran » retire aussi le cadre du navigateur. Chaque widget se rafraîchit seul sans clignoter : on peut le laisser allumé.',
  'chi entra, con quale ruolo, e l’accesso con il provider aziendale.': "qui se connecte, avec quel rôle, et l’accès via le fournisseur d’identité de l’entreprise.",
  'gravi':
    'graves',
  'il monitoraggio su un monitor: la parete dei CI colorati dal loro stato peggiore, i problemi prima e in rosso pieno con il parametro e da quanto, a lato i problemi aperti e l’andamento degli allarmi; si aggiorna ogni 30 secondi, Esc esce.':
    'la supervision sur un écran mural : le mur des CI colorés selon leur pire état, les problèmes d’abord en rouge plein avec le paramètre et depuis quand, sur le côté les problèmes ouverts et l’évolution des alarmes ; il se rafraîchit toutes les 30 secondes, Échap quitte.',
  'Sinottico a parete':
    'Synoptique mural',
  'Anche chi li riceve soltanto':
    'Aussi ceux qui ne font que les recevoir',
  'Chi conta come «parla»':
    'Qui compte comme « parle »',
  'Le regole valgono dal prossimo giro; gli avvistamenti già registrati restano finché non li azzeri.':
    'Les règles s’appliquent dès la prochaine ronde ; les détections déjà enregistrées restent tant que vous ne les effacez pas.',
  'Porte di destinazione da non contare':
    'Ports de destination à ne pas compter',
  'Protocolli da non contare':
    'Protocoles à ne pas compter',
  'Salva le regole':
    'Enregistrer les règles',
  'Separate da virgola. Un flusso verso una di queste porte non fa di nessuno un avvistamento.':
    'Séparés par des virgules. Un flux vers l’un de ces ports ne fait de personne une détection.',
  'Solo chi manda pacchetti (consigliato)':
    'Seulement ceux qui envoient des paquets (recommandé)',
  'un IP è considerato attivo quando viene osservato come sorgente di traffico. Se compare solo come destinazione nei flussi non dimostra la presenza di un asset.': 'une IP est considérée active lorsqu’elle est observée comme source de trafic. Si elle n’apparaît que comme destination dans les flux, cela ne prouve pas la présence d’un actif.',
  'Altri protocolli, per numero':
    'Autres protocoles, par numéro',
  'Il numero del protocollo IP come lo mostra la scheda dell’avvistamento (per esempio 249 su certi firewall).':
    'Le numéro de protocole IP tel qu’affiché dans la fiche de la détection (par exemple 249 sur certains pare-feu).',
  'Nessun agente è ancora legato a questo CI: l’agente si lega alla prossima consegna d’inventario (Agenti d’inventario → «Inventario adesso»).':
    'Aucun agent n’est encore lié à ce CI : l’agent se lie à la prochaine livraison d’inventaire (Agents d’inventaire → « Inventaire maintenant »).',
  'L’agente «{nome}» non si fa sentire da {quando}: le letture arrivano con il keep-alive di ogni minuto. Controlla che sia residente e aggiornato.':
    'L’agent « {nome} » ne s’est pas manifesté depuis {quando} : les lectures arrivent avec le keep-alive de chaque minute. Vérifiez qu’il est résident et à jour.',
  'L’agente «{nome}» è in linea (versione {v}): le prime letture arrivano entro un paio di minuti. Se non arrivano, l’agente va aggiornato a una versione con Eagle.':
    'L’agent « {nome} » est en ligne (version {v}) : les premières lectures arrivent en deux minutes environ. Sinon, l’agent doit être mis à jour vers une version avec Eagle.',
  '{tipo} più alti':
    '{tipo} les plus élevés',
  'Chi legge, con quale ruolo e quale carico.':
    'Qui lit, avec quel rôle et quelle charge.',
  'Stato operativo degli oggetti monitorati, configurabile in base alle specifiche esigenze.':
    'L’état des objets supervisés, maintenant et ces dernières heures. Personnalisez-le et il devient le vôtre.',
  'Come stanno le cose':
    'Où en sont les choses',
  'Cruscotto del tenant':
    'Tableau de bord du tenant',
  'Cruscotto di Eagle':
    'Tableau de bord Eagle',
  'Disponibilità più bassa':
    'Disponibilité la plus basse',
  'Eagle · come stanno le cose':
    'Eagle · où en sont les choses',
  'esclusa':
    'exclue',
  'Il tuo cruscotto':
    'Votre tableau de bord',
  'Incidenti recenti':
    'Incidents récents',
  'Nessun CI ha uno SLA.':
    'Aucun CI n’a de SLA.',
  'Nessuna misura ancora.':
    'Aucune mesure pour l’instant.',
  'Parete dei CI':
    'Mur des CI',
  'Per ogni SLA quanti CI lo rispettano, negli ultimi 30 giorni.':
    'Pour chaque SLA combien de CI le respectent, sur les 30 derniers jours.',
  'report':
    'rapports',
  'Scegli un CI e un parametro in «Personalizza».':
    'Choisissez un CI et un paramètre dans « Personnaliser ».',
  'sinottico':
    'synoptique',
  'Sonde di Eagle':
    'Sondes Eagle',
  'tetto {n}':
    'plafond {n}',
  'tutti i CI':
    'tous les CI',
  'ultimi 30 giorni':
    '30 derniers jours',
  'esclusa da Eagle':
    'exclue d’Eagle',
  'Definisce i centri di costo a cui imputare le spese di contratti e asset':
    'À qui la dépense est imputée : contrats et actifs choisissent ici.',
  'Aggiungi la prima voce, o importa l’elenco da testo.':
    'Ajoutez la première entrée, ou importez la liste depuis un texte.',
  'Anagrafiche':
    'Référentiels',
  'Budget annuo':
    'Budget annuel',
  'CAP':
    'Code postal',
  'Centri di costo':
    'Centres de coût',
  'Città':
    'Ville',
  'Definisce direzioni, reparti e team per identificare le unità responsabili e utilizzatrici di contratti e asset':
    'Directions, services, équipes : qui possède et qui utilise.',
  'Definisce la collocazione fisica degli asset per sede, edificio, piano e sala':
    'Où se trouvent les choses : site, bâtiment, étage, salle.',
  'Importa da testo':
    'Importer depuis un texte',
  'Importo…':
    'Import en cours…',
  'In uso: si disattiva, non si toglie':
    'Utilisée : on la désactive, on ne la supprime pas',
  'Definisce le anagrafiche di riferimento della piattaforma, come centri di costo, unità organizzative e sedi. Contratti e asset utilizzano questi valori.':
    'Les référentiels de la plateforme : centres de coût, unités organisationnelles, sites. Contrats et actifs choisissent ici au lieu de saisir du texte libre.',
  'Nessuna voce ancora':
    "Aucune entrée pour l'instant",
  'Nuova voce':
    'Nouvelle entrée',
  'Paese':
    'Pays',
  'Sede':
    'Site',
  'Sedi':
    'Sites',
  'Sta sotto':
    'Rattachée à',
  'Togliere «{n}»?':
    'Supprimer « {n} » ?',
  'Una voce per riga: codice; nome; codice del genitore (facoltativo)':
    'Une entrée par ligne : code ; nom ; code du parent (facultatif)',
  'Unità organizzativa':
    'Unité organisationnelle',
  'Unità organizzative':
    'Unités organisationnelles',
  'i centri di costo, le unità organizzative e le sedi della tua organizzazione, ad albero, con importazione da testo. Contratti e asset le scelgono da un menu invece di scrivere testi liberi; una voce in uso non si toglie, si disattiva.':
    'les centres de coût, unités organisationnelles et sites de votre organisation, en arborescence, avec import depuis un texte. Contrats et actifs les choisissent dans un menu au lieu de saisir du texte libre ; une entrée utilisée ne se supprime pas, elle se désactive.',
  'nessuna (primo livello)':
    'aucune (premier niveau)',
  'testo libero precedente: {v}':
    'texte libre précédent : {v}',
  'voce non più in anagrafica':
    'entrée absente du référentiel',
  'vuoto = il nome':
    'vide = le nom',
  '{a} create, {b} aggiornate':
    '{a} créées, {b} mises à jour',
  '{n} asset':
    '{n} actifs',
  '{n} contratti':
    '{n} contrats',
  '30 gg d.f.f.m., anticipato…':
    "30 jours fin de mois, d'avance…",
  'Abbonamento a servizio':
    'Abonnement à un service',
  'Aggiungi beni':
    'Ajouter des actifs',
  'Aggiungi una voce':
    'Ajouter une ligne',
  'Allegato SLA':
    'Annexe SLA',
  'Annuale':
    'Annuel',
  'Avvisa sulle scadenze dei contratti':
    'Prévenir des échéances des contrats',
  'Azzera i filtri':
    'Effacer les filtres',
  'Beni coperti':
    'Actifs couverts',
  'Bozza':
    'Brouillon',
  'Cerca nei beni':
    'Rechercher dans les actifs',
  'Cessa':
    'Résilier',
  'Cessa il contratto':
    'Résilier le contrat',
  'Cessato':
    'Résilié',
  'Cessato il':
    'Résilié le',
  'Chiude il cerchio fra ciò che si è comprato e ciò che Eagle misura.':
    "Boucle la boucle entre ce qui a été acheté et ce qu'Eagle mesure.",
  'Cloud (IaaS/PaaS)':
    'Cloud (IaaS/PaaS)',
  'Collegamenti, non file: il contratto firmato sta nel sistema documentale dell’organizzazione, e copiarlo qui farebbe due versioni.':
    "Des liens, pas des fichiers : le contrat signé vit dans la GED de l'organisation, et le copier ici ferait deux versions.",
  'Connettività e telecomunicazioni':
    'Connectivité et télécommunications',
  'Consulenza':
    'Conseil',
  'Contratto firmato':
    'Contrat signé',
  'Contratto in scadenza':
    'Contrat bientôt à échéance',
  'Contratto scaduto':
    'Contrat expiré',
  'Copertura ({n})':
    'Couverture ({n})',
  'Copri {n} beni':
    'Couvrir {n} actifs',
  'Date':
    'Dates',
  'Date che contano nei prossimi 12 mesi':
    'Dates qui comptent dans les 12 prochains mois',
  'Dati':
    'Données',
  'Documenti':
    'Documents',
  'Documenti ({n})':
    'Documents ({n})',
  'Duplica il contratto':
    'Dupliquer le contrat',
  'Duplicato da':
    'Dupliqué depuis',
  'Durata del rinnovo (mesi)':
    'Durée du renouvellement (mois)',
  'Eliminare il contratto «{ref}» con la sua copertura e il suo storico? Per un contratto finito è meglio la cessazione.':
    'Supprimer le contrat « {ref} » avec sa couverture et son historique ? Pour un contrat terminé, la résiliation vaut mieux.',
  'Email del responsabile':
    'E-mail du responsable',
  'Fattura':
    'Facture',
  'Garanzia estesa':
    'Garantie étendue',
  'Giorni residui':
    'Jours restants',
  'Il pulsante «Rinnova» la usa per proporre la nuova scadenza; con il rinnovo tacito la scadenza avanza da sola.':
    "Le bouton « Renouveler » s'en sert pour proposer la nouvelle échéance ; avec la tacite reconduction, l'échéance avance toute seule.",
  'Importo':
    'Montant',
  'Imputazione':
    'Imputation',
  'In scadenza (90 g), compresi gli scaduti':
    'À échéance (90 j), expirés compris',
  'In vigore':
    'En vigueur',
  'La copertura dei beni si chiude a quella data e resta visibile: «quel guasto di marzo era coperto?» avrà ancora una risposta.':
    'La couverture des actifs se clôt à cette date et reste visible : « cette panne de mars était-elle couverte ? » aura encore une réponse.',
  'Le righe del contratto (canoni, giornate, licenze per utente): il totale senza le righe non si verifica contro la fattura.':
    'Les lignes du contrat (redevances, journées, licences par utilisateur) : un total sans lignes ne se vérifie pas contre la facture.',
  'Licenza software':
    'Licence logicielle',
  'Manutenzione hardware':
    'Maintenance matérielle',
  'Mensile':
    'Mensuel',
  'Modifica del contratto':
    'Modification du contrat',
  'Modifica le voci':
    'Modifier les lignes',
  'Modificato':
    'Modifié',
  'Nasce un contratto nuovo con le stesse condizioni e gli stessi beni (quelli ancora coperti); questo resta «rinnovato», collegato al nuovo. Vuoto = la scadenza si calcola dalla durata del rinnovo, il riferimento diventa «{ref}/R1».':
    "Un nouveau contrat naît avec les mêmes conditions et les mêmes actifs (ceux encore couverts) ; celui-ci reste « renouvelé », lié au nouveau. Vide = l'échéance se calcule d'après la durée du renouvellement, la référence devient « {ref}/R1 ».",
  'Nessun bene coperto':
    'Aucun actif couvert',
  'Nessun contratto con questi filtri':
    'Aucun contrat avec ces filtres',
  'Nessun documento collegato':
    'Aucun document lié',
  'Nessuna voce':
    'Aucune ligne',
  'Noleggio o leasing':
    'Location ou leasing',
  'Nuova nota':
    'Nouvelle note',
  'Nuovo riferimento':
    'Nouvelle référence',
  'Offerta':
    'Offre',
  'Per centro di costo':
    'Par centre de coût',
  'Per fornitore':
    'Par fournisseur',
  'Per tipo':
    'Par type',
  'Prezzo unitario':
    'Prix unitaire',
  'Promemoria (giorni prima)':
    'Rappels (jours avant)',
  'Promemoria inviato':
    'Rappel envoyé',
  'Quantità':
    'Quantité',
  'Riceve i promemoria di scadenza oltre ai destinatari del tenant.':
    "Reçoit les rappels d'échéance en plus des destinataires du tenant.",
  'Riferimento esterno':
    'Référence externe',
  'Rinnova':
    'Renouveler',
  'Rinnova il contratto':
    'Renouveler le contrat',
  'Rinnovato':
    'Renouvelé',
  'Rinnovo di':
    'Renouvellement de',
  'Rinnovo tacito: la scadenza è avanzata da {a} a {b}.':
    "Tacite reconduction : l'échéance est passée de {a} à {b}.",
  'SLA di Eagle':
    'SLA Eagle',
  'Scaduto':
    'Expiré',
  'Servizio gestito':
    'Service managé',
  'Sganciare «{tag}»? Per un bene uscito a una certa data è meglio impostare la fine della copertura.':
    'Détacher « {tag} » ? Pour un actif sorti à une date donnée, mieux vaut fixer la fin de couverture.',
  'Software come servizio (SaaS)':
    'Logiciel en tant que service (SaaS)',
  'Sospeso':
    'Suspendu',
  'Spesa e scadenze':
    'Dépenses et échéances',
  'Storico':
    'Historique',
  'Supporto e assistenza':
    'Support et assistance',
  'Termini di pagamento':
    'Conditions de paiement',
  'Totale delle voci':
    'Total des lignes',
  'Trimestrale':
    'Trimestriel',
  'Un contratto senza beni non protegge nulla: aggiungili da qui o dalla scheda del bene.':
    "Un contrat sans actifs ne protège rien : ajoutez-les ici ou depuis la fiche de l'actif.",
  'Notifica le scadenze dei contratti alle soglie previste, ad esempio 90, 30 e 7 giorni prima della data di riferimento o secondo le soglie configurate nel contratto. Gli avvisi possono essere inviati anche al responsabile del contratto.':
    'Un rappel par seuil (90, 30 et 7 jours avant la date qui compte, ou ceux du contrat), aussi au responsable du contrat.',
  'Una bozza con le stesse condizioni, voci e documenti, senza beni: per il contratto gemello con un altro fornitore o un altro reparto.':
    'Un brouillon avec les mêmes conditions, lignes et documents, sans actifs : pour le contrat jumeau avec un autre fournisseur ou un autre service.',
  'Una tantum':
    'Forfait unique',
  'Valore annuo':
    'Valeur annuelle',
  'Valore dichiarato':
    'Valeur déclarée',
  'Voci':
    'Lignes',
  'Voci e costi':
    'Lignes et coûts',
  'Vuoto = {giorni}. Un avviso per soglia, prima della data che conta.':
    'Vide = {giorni}. Un avis par seuil, avant la date qui compte.',
  'anno, mese, una tantum':
    'an, mois, forfait',
  'cambio fornitore, bene dismesso, recesso…':
    'changement de fournisseur, actif retiré, résiliation…',
  'cartellino, nome, matricola':
    'étiquette, nom, numéro de série',
  'contratto inesistente':
    'contrat inexistant',
  'cosa ha detto il fornitore, cosa si è deciso…':
    'ce que le fournisseur a dit, ce qui a été décidé…',
  'date di copertura aggiornate':
    'dates de couverture mises à jour',
  'modificato':
    'modifié',
  'nessuno definito':
    'aucun défini',
  'nome, telefono, email del supporto':
    'nom, téléphone, e-mail du support',
  'ordine, pratica acquisti, id nel gestionale':
    "commande, dossier achats, id dans l'ERP",
  'predefiniti':
    'par défaut',
  'riferimento, nome, fornitore, responsabile…':
    'référence, nom, fournisseur, responsable…',
  'scadenza':
    'échéance',
  'scaduto da {n} giorni':
    'expiré depuis {n} jours',
  'scarto {v} rispetto al valore dichiarato':
    'écart de {v} par rapport à la valeur déclarée',
  'scritto: {s}':
    'saisi : {s}',
  'senza centro di costo':
    'sans centre de coût',
  'si rinnova tacitamente a questa data':
    'se reconduit tacitement à cette date',
  'ultimo giorno per disdire ({n} giorni di preavviso)':
    'dernier jour pour résilier ({n} jours de préavis)',
  'un bene sganciato':
    'un actif détaché',
  '{n} a rinnovo tacito':
    '{n} en tacite reconduction',
  '{n} beni aggiunti':
    '{n} actifs ajoutés',
  '{n} beni portati':
    '{n} actifs repris',
  '{n} destinatari':
    '{n} destinataires',
  '{n} giorni alla data che conta':
    '{n} jours avant la date qui compte',
  '{n} giorni di preavviso':
    '{n} jours de préavis',
  '{n} in tutto, {b} bozze':
    '{n} au total, {b} brouillons',
  '{n} mesi':
    '{n} mois',
  '{n} validi oggi':
    "{n} valides aujourd'hui",
  '«Scaduto» lo decidono le date; rinnovo e cessazione hanno i loro pulsanti, che scrivono lo storico.':
    "« Expiré » est décidé par les dates ; renouvellement et résiliation ont leurs boutons, qui écrivent l'historique.",
  '← contratto precedente':
    '← contrat précédent',
  'il registro dei contratti (manutenzione, supporto, licenze, SaaS, cloud, connettività…) con i beni che coprono, la spesa annualizzata per tipo, centro di costo e fornitore, e la «data che conta»: su un rinnovo tacito è l’ultimo giorno per disdire, non la scadenza. Dalla scheda si rinnova (nasce il contratto successivo, il vecchio resta collegato), si cessa, si duplica; voci, documenti e storico hanno le loro schede. I promemoria di scadenza arrivano per email e in campanella, una volta per soglia.':
    "le registre des contrats (maintenance, support, licences, SaaS, cloud, connectivité…) avec les actifs qu'ils couvrent, la dépense annualisée par type, centre de coût et fournisseur, et la « date qui compte » : en tacite reconduction c'est le dernier jour pour résilier, pas l'échéance. Depuis la fiche on renouvelle (le contrat suivant naît, l'ancien reste lié), on résilie, on duplique ; lignes, documents et historique ont leurs onglets. Les rappels d'échéance arrivent par e-mail et dans la cloche, une fois par seuil.",
  'Avvistamenti per stato':
    'Observations par état',
  'Come stanno oggi':
    "Où elles en sont aujourd'hui",
  'Da decidere':
    'À décider',
  'Gli avvistamenti «nuovi» che hanno mosso più flussi nell’ultimo giro: chi merita un’occhiata per primo.':
    "Les observations « nouvelles » ayant généré le plus de flux au dernier tour : qui mérite un premier coup d'œil.",
  'Un avvistamento «nuovo» aspetta una decisione: censirlo o ignorarlo.':
    "Une observation « nouvelle » attend une décision : la recenser ou l'ignorer.",
  'ancora «nuovi»':
    'encore « nouvelles »',
  '{n} giorni con avvistamenti su {tot}':
    '{n} jours avec observations sur {tot}',
  '{n} subnet sorvegliate':
    '{n} sous-réseaux surveillés',
  '{tot} in {g} giorni, in media {m} al giorno; il picco il {data} con {n}.':
    '{tot} en {g} jours, {m} par jour en moyenne ; le pic le {data} avec {n}.',
  'Eagle non è attivo per questo tenant':
    "Eagle n'est pas actif pour ce tenant",
  'Metti in monitoraggio':
    'Mettre sous surveillance',
  'Seleziona tutti i {n} CI del filtro':
    'Sélectionner les {n} CI du filtre',
  'Seleziono…':
    'Sélection…',
  'Togli dal monitoraggio':
    'Retirer de la surveillance',
  'Seleziona fino a 1.000 CI alla volta; per selezioni più mirate, restringi il filtro, ad esempio tramite tag.': 'Sélectionnez jusqu’à 1 000 CI à la fois ; pour des sélections plus ciblées, restreignez le filtre, par exemple avec un tag.',
  '{m} saltati: {elenco}':
    '{m} ignorés : {elenco}',
  '{n} CI messi in monitoraggio.':
    '{n} CI mis sous surveillance.',
  '{n} CI tolti dal monitoraggio.':
    '{n} CI retirés de la surveillance.',
  'Trova anche i tag: «produzione» mostra il tag ambiente:produzione con quanti CI lo portano, e apre l’elenco già filtrato.':
    'Elle trouve aussi les tags : « production » affiche le tag environnement:production avec le nombre de CI qui le portent, et ouvre la liste déjà filtrée.',
  'Entrata':
    'Entrée',
  'Errori':
    'Erreurs',
  'Errori e scarti nell’intervallo':
    'Erreurs et rejets par intervalle',
  'Scarti':
    'Rejets',
  'Traffico (Mbit/s)':
    'Trafic (Mbit/s)',
  'Uscita':
    'Sortie',
  'Utilizzo ({unita}), con le soglie':
    'Utilisation ({unita}), avec les seuils',
  'picco {v}':
    'pic {v}',
  'Aggiungi un utente della console':
    'Ajouter un utilisateur de la console',
  'Aggiungi un utente della console…':
    'Ajouter un utilisateur de la console…',
  'I contatti da notificare possono essere utenti CENSO o esterni al sistema. Per gli utenti della console, nome ed e-mail vengono acquisiti automaticamente.':
    "Les personnes à prévenir : qui vous voulez, même sans accès à CENSO. Un utilisateur de la console s'ajoute d'un choix, et nom et e-mail suivent son compte.",
  'utente':
    'utilisateur',
  'È l’email con cui l’utente entra in CENSO: si cambia dalla pagina Utenti.':
    "C'est l'e-mail avec lequel l'utilisateur se connecte à CENSO : il se modifie depuis la page Utilisateurs.",
  'Un contatto può essere un utente della console: lo aggiungi con una scelta, e nome ed email seguono la sua utenza.':
    "Un contact peut être un utilisateur de la console : vous l'ajoutez d'un choix, et nom et e-mail suivent son compte.",
  'Dati raccolti il {quando}: premi «Aggiorna» per interrogare di nuovo.':
    'Données recueillies le {quando} : appuyez sur « Actualiser » pour interroger à nouveau.',
  'La pagina si apre con i dati dell’ultima lettura, con la data: «Aggiorna» interroga di nuovo i sistemi di backup attraverso la sonda.':
    "La page s'ouvre avec les données de la dernière lecture, datées : « Actualiser » interroge à nouveau les systèmes de sauvegarde via la sonde.",
  'Lo stato del backup del cliente (Veeam, Vinchin, Commvault, Rubrik), letto attraverso la sonda. La pagina si apre con i dati dell’ultima lettura; «Aggiorna» interroga di nuovo.':
    "L'état de la sauvegarde du client (Veeam, Vinchin, Commvault, Rubrik), lu via la sonde. La page s'ouvre avec les données de la dernière lecture ; « Actualiser » interroge à nouveau.",
  'L’ultimo aggiornamento non è riuscito ({motivo}): questi sono i dati raccolti il {quando}.':
    'La dernière actualisation a échoué ({motivo}) : voici les données recueillies le {quando}.',
  'piano {p}':
    'plan {p}',
  'Interrogo i sistemi in sottofondo: la pagina si aggiorna da sola appena arrivano i dati nuovi.':
    "Interrogation des systèmes en arrière-plan : la page se met à jour d'elle-même dès l'arrivée des nouvelles données.",
  'Intanto vedi i dati raccolti il {quando}.':
    'En attendant, vous voyez les données recueillies le {quando}.',
  'Leggi le ottiche dal firewall':
    'Lire les optiques depuis le pare-feu',
  'Leggo…':
    'Lecture…',
  'Nella tabella di routing del CI, accanto alla metrica c’è la «Distance»: la distanza amministrativa (Cisco/Palo Alto) o la preference (Huawei), con cui si sceglie fra due rotte per la stessa destinazione.': 'Dans la table de routage du CI, à côté de la métrique figure «Distance» : la distance administrative (Cisco/Palo Alto) ou la preference (Huawei), qui départage deux routes vers la même destination.',
  'Sui router e switch Cisco e Huawei l’inventario SSH legge anche la tabella di routing dalla CLI (show ip route, display ip routing-table): utile dove SNMP non la dà.':
    "Sur les routeurs et commutateurs Cisco et Huawei, l'inventaire SSH lit aussi la table de routage depuis la CLI (show ip route, display ip routing-table) : utile là où SNMP ne la fournit pas.",
  '{n} ottiche lette dal firewall, {c} CI creati.':
    '{n} optiques lues depuis le pare-feu, {c} CI créés.',
  'Pool rinominato in «{nome}».':
    'Pool renommé en « {nome} ».',
  'Salva il nome':
    'Enregistrer le nom',
  'Rinomina':
    'Renommer',
  'Le pianificazioni e i job che usano questo pool lo seguono per identità: il nome nuovo compare dalla prossima esecuzione.':
    'Les planifications et les jobs qui utilisent ce pool le suivent par identité : le nouveau nom apparaît à la prochaine exécution.',
  'Dalla scheda di un pool lo rinomini e ne cambi la descrizione: le pianificazioni che lo usano lo seguono.':
    "Depuis la fiche d'un pool vous le renommez et changez sa description : les planifications qui l'utilisent suivent.",
  'seriale {s}':
    'numéro de série {s}',
  'Nessun firewall corrisponde a questo CI: scegli quale.':
    'Aucun pare-feu ne correspond à ce CI : choisissez lequel.',
  'Il CI ha seriale {s} e si presenta come {ids}.':
    'Le CI a le numéro de série {s} et se présente comme {ids}.',
  'Il CI non ha un seriale in inventario e si presenta come {ids}.':
    "Le CI n'a pas de numéro de série dans l'inventaire et se présente comme {ids}.",
  '— scegli il firewall —':
    '— choisissez le pare-feu —',
  'Dai al job un titolo e una descrizione: con decine di job al giorno, tipo e ambito non dicono perché è stato lanciato. Si correggono anche dopo, dal rapporto.':
    'Donnez au job un titre et une description : avec des dizaines de jobs par jour, le type et le périmètre ne disent pas pourquoi il a été lancé. On les corrige aussi après, depuis le rapport.',
  'Modifica titolo':
    'Modifier le titre',
  'Senza titolo':
    'Sans titre',
  'facoltativo: per riconoscere il job nell’elenco':
    'facultatif : pour reconnaître le job dans la liste',
  'facoltativo: perché, per chi, cosa aspettarsi':
    "facultatif : pourquoi, pour qui, à quoi s'attendre",
  'nativa {n}':
    'native {n}',
  'trunk':
    'trunk',
  'Fra le interfacce di un apparato di rete la colonna VLAN dice quali VLAN passano su ogni porta: il numero per una porta d’accesso, «trunk» con l’elenco e la nativa per un trunk. La legge la scansione SNMP approfondita.':
    "Parmi les interfaces d'un équipement réseau, la colonne VLAN indique quels VLAN passent sur chaque port : le numéro pour un port d'accès, « trunk » avec la liste et le VLAN natif pour un trunk. C'est l'analyse SNMP approfondie qui le lit.",
  'Abilita Cost Explorer sull’account: console AWS → Billing and Cost Management → Cost Explorer. La prima attivazione richiede fino a 24 ore, e ogni lettura costa circa 0,01 $.':
    "Activez Cost Explorer sur le compte : console AWS → Billing and Cost Management → Cost Explorer. La première activation prend jusqu'à 24 heures, et chaque lecture coûte environ 0,01 $.",
  'Aggiungi il permesso ce:GetCostAndUsage alla policy del ruolo o dell’utenza che CENSO usa (la policy completa è nella scheda della credenziale AWS e in docs/operations/aws-permessi.md).':
    "Ajoutez la permission ce:GetCostAndUsage à la policy du rôle ou de l'utilisateur que CENSO utilise (la policy complète est dans la fiche de l'identifiant AWS et dans docs/operations/aws-permessi.md).",
  'Apri il rapporto del job: la «Diagnosi AWS» in cima dice se il permesso o Cost Explorer mancano, e cosa fare.':
    'Ouvrez le rapport du job : le « Diagnostic AWS » en haut indique si la permission ou Cost Explorer manque, et quoi faire.',
  'Assegna al service principal di CENSO il ruolo «Cost Management Reader» sulla sottoscrizione (Access control (IAM) → Add role assignment).':
    "Attribuez le rôle « Cost Management Reader » au service principal de CENSO sur l'abonnement (Access control (IAM) → Add role assignment).",
  'Come si attiva':
    "Comment l'activer",
  'Google Cloud e Oracle Cloud non sono ancora coperti: su Google i costi reali passano dall’export della fatturazione in BigQuery, su Oracle dalla Usage API.':
    "Google Cloud et Oracle Cloud ne sont pas encore couverts : sur Google les coûts réels passent par l'export de facturation vers BigQuery, sur Oracle par l'Usage API.",
  'A ogni job rilegge dal primo del mese scorso a oggi e sostituisce i giorni riletti, così le correzioni del provider entrano da sole. Un job senza costi (permesso mancante, servizio spento) non cancella la storia.':
    "À chaque job, relit du premier du mois dernier à aujourd'hui et remplace les jours relus, ainsi les corrections du fournisseur entrent d'elles-mêmes. Un job sans coûts (permission manquante, service désactivé) n'efface pas l'historique.",
  'Accendi «Recupera costi» nella credenziale AWS, poi lancia il job di discovery cloud dell’account o aspetta la pianificazione: rilegge dal primo del mese scorso a oggi, così le correzioni del provider entrano da sole.':
    "Activez « Récupérer les coûts » dans l'identifiant AWS, puis lancez le job de découverte cloud du compte ou attendez la planification : il relit du premier du mois dernier à aujourd'hui, ainsi les corrections du fournisseur entrent d'elles-mêmes.",
  'Accendi «Recupera costi» nella credenziale Azure e lancia il job di discovery cloud della sottoscrizione: i costi entrano con l’inventario. Se il ruolo manca, il rapporto del job lo dice.':
    "Activez « Récupérer les coûts » dans l'identifiant Azure et lancez le job de découverte cloud de l'abonnement : les coûts entrent avec l'inventaire. Si le rôle manque, le rapport du job le dit.",
  'Crea la credenziale del provider e lancia il job cloud: l’account compare da solo. Per il costo del mese accendi «Recupera costi» nella credenziale e fai in modo che il provider lasci leggere i costi (Cost Explorer abilitato e ce:GetCostAndUsage su AWS, ruolo Cost Management Reader su Azure). La pagina Costi Cloud spiega i passi.':
    "Créez l'identifiant du fournisseur et lancez le job cloud : le compte apparaît tout seul. Pour le coût du mois, activez « Récupérer les coûts » dans l'identifiant et faites en sorte que le fournisseur laisse lire les coûts (Cost Explorer activé et ce:GetCostAndUsage sur AWS, rôle Cost Management Reader sur Azure). La page Coûts cloud explique les étapes.",
  'I costi arrivano con i job di discovery cloud della credenziale che ha la spunta «Recupera costi», e serve che il provider li lasci leggere.':
    "Les coûts arrivent avec les jobs de découverte cloud de l'identifiant qui a la case « Récupérer les coûts » cochée, et le fournisseur doit les laisser lire.",
  "I costi dell'account per giorno, servizio e regione, nella pagina Costi Cloud. Serve un permesso in più: vedi «Cosa fa?».":
    'Les coûts du compte par jour, service et région, dans la page Coûts cloud. Une permission de plus est nécessaire : voir « Que fait-il ? ».',
  'Legge AWS Cost Explorer (GetCostAndUsage): il costo non miscelato per giorno, servizio e regione.':
    'Lit AWS Cost Explorer (GetCostAndUsage) : le coût non mixé par jour, service et région.',
  'Legge Azure Cost Management (query dei costi effettivi): il costo per giorno, servizio e regione della sottoscrizione.':
    "Lit Azure Cost Management (requête des coûts réels) : le coût par jour, service et région de l'abonnement.",
  'Per attivarlo: accendi «Recupera costi» nella credenziale cloud; su AWS abilita Cost Explorer da Billing (la prima volta fino a 24 ore) e aggiungi il permesso alla policy di CENSO, su Azure assegna il ruolo al service principal; poi lancia il job cloud. La scheda «Come si attiva» in cima alla pagina ha i passi, e la Diagnosi AWS nel rapporto del job dice cosa manca.':
    "Pour l'activer : activez « Récupérer les coûts » dans l'identifiant cloud ; sur AWS activez Cost Explorer depuis Billing (jusqu'à 24 heures la première fois) et ajoutez la permission à la policy de CENSO, sur Azure attribuez le rôle au service principal ; puis lancez le job cloud. La carte « Comment l'activer » en haut de la page donne les étapes, et le Diagnostic AWS du rapport du job dit ce qui manque.",
  'Recupera costi':
    'Récupérer les coûts',
  "Serve Cost Explorer abilitato sull'account (Billing and Cost Management → Cost Explorer; la prima attivazione richiede fino a 24 ore) e il permesso ce:GetCostAndUsage nella policy di CENSO. Ogni lettura costa circa 0,01 $: una o poche per job.":
    "Cost Explorer doit être activé sur le compte (Billing and Cost Management → Cost Explorer ; la première activation prend jusqu'à 24 heures) et la permission ce:GetCostAndUsage doit être dans la policy de CENSO. Chaque lecture coûte environ 0,01 $ : une ou quelques-unes par job.",
  'Serve il ruolo «Cost Management Reader» al service principal sulla sottoscrizione (Access control (IAM) → Add role assignment).':
    "Le service principal a besoin du rôle « Cost Management Reader » sur l'abonnement (Access control (IAM) → Add role assignment).",
  'Spenta, il rapporto del job lo ricorda con una riga e la pagina Costi Cloud resta senza questo account.':
    'Désactivée, le rapport du job le rappelle en une ligne et la page Coûts cloud reste sans ce compte.',
  'CENSO, l’assistente':
    "CENSO, l'assistant",
  'Chiedi a CENSO':
    'Demandez à CENSO',
  'Ciao, sono CENSO. Cerchi un apparato, un indirizzo o un seriale?':
    'Bonjour, je suis CENSO. Vous cherchez un équipement, une adresse ou un numéro de série ?',
  'Ciao, sono CENSO. Cerchi un rischio, una vulnerabilità o una macchina esposta?':
    'Bonjour, je suis CENSO. Vous cherchez un constat, une vulnérabilité ou une machine exposée ?',
  'Ciao, sono CENSO. Cosa vuoi sapere del tuo inventario?':
    'Bonjour, je suis CENSO. Que voulez-vous savoir de votre inventaire ?',
  'Ciao, sono CENSO. Vuoi sapere cosa non sta rispondendo?':
    'Bonjour, je suis CENSO. Vous voulez savoir ce qui ne répond pas ?',
  'Ho trovato {n} cose. Scegli, o scrivi ancora.':
    "J'ai trouvé {n} éléments. Choisissez, ou continuez d'écrire.",
  'La tua domanda':
    'Votre question',
  'Non trovo niente con «{q}». Prova con un nome, un indirizzo, un MAC o un seriale.':
    'Rien trouvé avec « {q} ». Essayez un nom, une adresse, une MAC ou un numéro de série.',
  'Per ora rispondo cercando nell’inventario. Con il modulo IA capirò le domande in italiano.':
    "Pour l'instant je réponds en cherchant dans l'inventaire. Avec le module IA je comprendrai les questions en langage courant.",
  'Scrivi qui…':
    'Écrivez ici…',
  'Un attimo, guardo nell’inventario…':
    "Un instant, je regarde dans l'inventaire…",
  'firewall':
    'pare-feu',
  'switch':
    'switch',
  'uplink':
    'uplink',
  'windows server':
    'windows server',
  '… e altri: apri l’elenco per vederli tutti':
    "… et d'autres : ouvrez la liste pour tous les voir",
  'Chiedi a CENSO (trascina per spostarlo)':
    'Demandez à CENSO (glissez pour le déplacer)',
  'Carica l’ambiente di esempio':
    "Charger l'environnement d'exemple",
  'Caricato il {quando}.':
    'Chargé le {quando}.',
  'Dati di esempio':
    "Données d'exemple",
  'I dati di esempio si caricano solo in un tenant senza CI: qui ci sono già dati veri.':
    "Les données d'exemple ne se chargent que dans un tenant sans CI : il y a déjà des données réelles ici.",
  'Il tenant è vuoto. Puoi caricare l’ambiente di esempio per vedere la piattaforma popolata: una sede, i suoi server, un account cloud, rischi e contratti.':
    "Le tenant est vide. Vous pouvez charger l'environnement d'exemple pour voir la plateforme remplie : un site, ses serveurs, un compte cloud, des constats et des contrats.",
  'Passa all’ambiente vuoto':
    "Passer à l'environnement vide",
  'Quando sei pronto a collegare le tue sonde, passa all’ambiente vuoto: si toglie tutto ciò che è di esempio e solo quello. Non si torna indietro, ma i dati veri arrivano con la prima scansione.':
    "Quand vous êtes prêt à connecter vos sondes, passez à l'environnement vide : tout ce qui est d'exemple est retiré, et seulement cela. Pas de retour en arrière, mais les données réelles arrivent avec la première analyse.",
  'Stai guardando l’ambiente di esempio di CENSO: una sede con la sua rete, due host VMware con le macchine virtuali, un server fisico, stampanti, UPS, storage, un account AWS con i costi, rischi di sicurezza e contratti.':
    "Vous regardez l'environnement d'exemple de CENSO : un site avec son réseau, deux hôtes VMware avec des machines virtuelles, un serveur physique, des imprimantes, un onduleur, du stockage, un compte AWS avec ses coûts, des constats de sécurité et des contrats.",
  'Stai guardando l’ambiente di esempio di CENSO: una sede, i suoi server e un account cloud inventati per capire la piattaforma.':
    "Vous regardez l'environnement d'exemple de CENSO : un site, ses serveurs et un compte cloud inventés pour comprendre la plateforme.",
  'Togliere tutti i dati di esempio? I dati veri, se ci sono, restano.':
    "Retirer toutes les données d'exemple ? Les données réelles, s'il y en a, restent.",
  'Un attimo…':
    'Un instant…',
  'Un tenant in prova nasce con l’ambiente di esempio: una sede con rete, server, VM, stampanti, UPS, storage, un account AWS con i costi, rischi e contratti, passati dalla stessa strada dei dati veri. Il banner in cima lo ricorda; da «Dati di esempio» in Impostazioni si passa all’ambiente vuoto quando si collegano le sonde: via tutto ciò che è di esempio, e solo quello.':
    "Un tenant d'essai naît avec l'environnement d'exemple : un site avec réseau, serveurs, VM, imprimantes, onduleur, stockage, un compte AWS avec ses coûts, constats et contrats, entrés par le même chemin que les données réelles. Le bandeau en haut le rappelle ; depuis « Données d'exemple » dans Paramètres on passe à l'environnement vide quand on connecte les sondes : tout ce qui est d'exemple disparaît, et seulement cela.",
  '{n} CI di esempio su {tot}.':
    "{n} CI d'exemple sur {tot}.",
  'Assistente «Chiedi a CENSO»':
    'Assistant « Demandez à CENSO »',
  "CENSO chiama POST <indirizzo>/v1/chat/completions con gli strumenti (function calling): il modello deve saperli usare. Vanno bene Qwen3 32B e Mistral Small 3.2 su una GPU da 24–48 GB per spiegazioni e domande semplici; gpt-oss-120b o Qwen3 235B su 80 GB per l'assistente completo.":
    "CENSO appelle POST <adresse>/v1/chat/completions avec les outils (function calling) : le modèle doit savoir les utiliser. Qwen3 32B et Mistral Small 3.2 sur un GPU de 24–48 Go conviennent pour les explications et les questions simples ; gpt-oss-120b ou Qwen3 235B sur 80 Go pour l'assistant complet.",
  'Ci sto guardando…':
    'Je regarde…',
  'Claude (Anthropic) — assistente':
    'Claude (Anthropic) — assistant',
  'Claude via API':
    'Claude via API',
  'Con vLLM: --enable-auto-tool-choice e il parser degli strumenti del modello. Con Ollama: un modello che dichiara «tools».':
    "Avec vLLM : --enable-auto-tool-choice et le parseur d'outils du modèle. Avec Ollama : un modèle qui déclare « tools ».",
  'Cosa non sta rispondendo adesso?':
    "Qu'est-ce qui ne répond pas en ce moment ?",
  'Cosa stacco se spengo il core?':
    "Que vais-je couper si j'éteins le cœur de réseau ?",
  'Cosa è esposto su Internet?':
    "Qu'est-ce qui est exposé sur Internet ?",
  'Ecco. Vuoi sapere altro?':
    'Voilà. Autre chose ?',
  'Fai una domanda sul tuo inventario…':
    'Posez une question sur votre inventaire…',
  'Ho guardato: {cosa}':
    "J'ai regardé : {cosa}",
  'Il modello da usare. Vuoto: claude-sonnet-5, il punto di equilibrio fra qualità e costo per un assistente con gli strumenti. claude-haiku-4-5-20251001 costa meno e basta per le domande semplici; claude-fable-5-1 è il più capace.':
    "Le modèle à utiliser. Vide : claude-sonnet-5, l'équilibre entre qualité et coût pour un assistant avec des outils. claude-haiku-4-5-20251001 coûte moins et suffit pour les questions simples ; claude-fable-5-1 est le plus capable.",
  'Il modello non ha risposto: {perche}':
    "Le modèle n'a pas répondu : {perche}",
  'L’assistente può utilizzare Claude (Anthropic) tramite API oppure Modello interno tramite endpoint compatibile OpenAI, anche ospitato nella rete del cliente e raggiungibile tramite sonda. Accede ai dati in sola lettura e nel rispetto delle autorizzazioni dell’utente. Non può modificare configurazioni, eseguire operazioni amministrative o accedere alle credenziali archiviate.':
    "Le modèle se choisit parmi les identifiants : « Claude (Anthropic) » via API, ou « Modèle interne » pour un service compatible OpenAI (vLLM, Ollama…) même dans le réseau du client, via une sonde. L'assistant ne fait que lire : les outils sont des lectures avec les permissions de celui qui demande, jamais le déchiffrement des identifiants.",
  'Il nome del modello come lo conosce il servizio (per esempio «qwen3:32b» su Ollama, il nome del repository su vLLM).':
    'Le nom du modèle tel que le service le connaît (par exemple « qwen3:32b » sur Ollama, le nom du dépôt sur vLLM).',
  'Impostazioni salvate.':
    'Paramètres enregistrés.',
  'In basso a destra c’è la faccina di CENSO: aprila e fa una domanda. Con il modulo «Assistente» e un modello configurato risponde in italiano leggendo il tuo inventario — «cosa stacco se spengo il core?», «quali contratti scadono?» — e ogni risposta porta i link per verificare e dice cosa ha guardato. Senza, cerca nell’inventario: un nome, un indirizzo, un MAC, un seriale. Si trascina dove non dà fastidio.':
    "En bas à droite se trouve le visage de CENSO : ouvrez-le et il pose une question. Avec le module « Assistant » et un modèle configuré, il répond en langage courant en lisant votre inventaire — « que vais-je couper si j'éteins le cœur ? », « quels contrats expirent ? » — et chaque réponse porte les liens pour vérifier et dit ce qu'il a regardé. Sinon, il cherche dans l'inventaire : un nom, une adresse, une MAC, un numéro de série. Glissez-le là où il ne gêne pas.",
  'Indirizzo del servizio':
    'Adresse du service',
  "Indirizzo dell'API":
    "Adresse de l'API",
  "L'indirizzo di vLLM, Ollama (porta 11434), LM Studio, LocalAI o di un servizio ospitato che parla /v1/chat/completions. Se sta nella rete del cliente, scegli la sonda in «Da dove si parla».":
    "L'adresse de vLLM, Ollama (port 11434), LM Studio, LocalAI ou d'un service hébergé qui parle /v1/chat/completions. S'il est dans le réseau du client, choisissez la sonde dans « D'où parler ».",
  "La chiave API di Anthropic (console.anthropic.com → API keys). Resta cifrata con la chiave del tenant e non lascia mai il Control Plane se non verso l'API.":
    "La clé API d'Anthropic (console.anthropic.com → API keys). Elle reste chiffrée avec la clé du tenant et ne quitte jamais le Control Plane sauf vers l'API.",
  "La chiave che il servizio si aspetta nell'header Authorization: Bearer.":
    "La clé que le service attend dans l'en-tête Authorization: Bearer.",
  'La quota di oggi è finita: riprova domani, o alza la quota nelle impostazioni.':
    'Le quota du jour est épuisé : réessayez demain, ou augmentez le quota dans les paramètres.',
  'L’assistente si configura fra le credenziali: «Claude (Anthropic)» con la chiave API, oppure «Modello interno» per un servizio OpenAI-compatibile (vLLM, Ollama…), anche nella rete del cliente attraverso una sonda. Nella card «Assistente» di Impostazioni si vede con cosa risponde, quanti token ha usato oggi, la quota e il mascheramento degli indirizzi verso un fornitore esterno. Legge soltanto, con i permessi di chi chiede: mai le credenziali.':
    "L'assistant se configure parmi les identifiants : « Claude (Anthropic) » avec la clé API, ou « Modèle interne » pour un service compatible OpenAI (vLLM, Ollama…), même dans le réseau du client via une sonde. La carte « Assistant » des Paramètres montre avec quoi il répond, combien de jetons il a utilisés aujourd'hui, le quota et le masquage des adresses vers un fournisseur externe. Il ne fait que lire, avec les permissions de celui qui demande : jamais les identifiants.",
  'Con modelli esterni, gli indirizzi IP vengono anonimizzati prima dell’elaborazione. Le informazioni originali non lasciano il tenant e vengono ripristinate dal sistema solo al momento della presentazione della risposta.':
    'Masquer les adresses IP vers un fournisseur externe (Claude) : le modèle voit des espaces réservés, la réponse revient avec les vraies adresses.',
  'Modello interno (OpenAI-compatibile) — assistente':
    'Modèle interne (compatible OpenAI) — assistant',
  'Nessun modello configurato: l’assistente risponde utilizzando esclusivamente la ricerca nell’inventario.':
    "Aucun modèle configuré : le visage répond avec la recherche dans l'inventaire.",
  'Nessun modello configurato: serve una credenziale «Claude» o «Modello interno».':
    'Aucun modèle configuré : il faut un identifiant « Claude » ou « Modèle interne ».',
  'Non posso rispondere adesso.':
    'Je ne peux pas répondre maintenant.',
  'Per ora rispondo cercando nell’inventario. Le domande in italiano sono nel modulo aggiuntivo «Assistente».':
    "Pour l'instant je réponds en cherchant dans l'inventaire. Les questions en langage courant sont dans le module additionnel « Assistant ».",
  'Per ora rispondo cercando nell’inventario. Per le domande in italiano aggiungi una credenziale «Claude» o «Modello interno» fra le credenziali.':
    "Pour l'instant je réponds en cherchant dans l'inventaire. Pour les questions en langage courant, ajoutez un identifiant « Claude » ou « Modèle interne » parmi les identifiants.",
  'Per ora rispondo cercando nell’inventario. Per le domande in italiano serve che chi amministra il tenant configuri un modello.':
    "Pour l'instant je réponds en cherchant dans l'inventaire. Pour les questions en langage courant, l'administrateur du tenant doit configurer un modèle.",
  'Quali CI hanno la CPU in attenzione?':
    'Quels CI ont le CPU en alerte ?',
  'Quali contratti scadono entro 90 giorni?':
    'Quels contrats expirent dans les 90 jours ?',
  'Quali rischi critici ho aperti?':
    'Quels constats critiques sont ouverts ?',
  'Quanti server Windows ho e quali?':
    'Combien de serveurs Windows ai-je, et lesquels ?',
  'Quanto mi costa il cloud questo mese?':
    'Combien me coûte le cloud ce mois-ci ?',
  'Quota di token al giorno':
    'Quota de jetons par jour',
  'Risponde con «{nome}» ({fornitore}). Oggi ha usato {usati} token su {quota}.':
    "Il répond avec « {nome} » ({fornitore}). Aujourd'hui il a utilisé {usati} jetons sur {quota}.",
  'Rispondo con ciò che leggo nel tuo inventario, con i link per verificare. Modello: {m}.':
    'Je réponds avec ce que je lis dans votre inventaire, avec les liens pour vérifier. Modèle : {m}.',
  'Senza chiave':
    'Sans clé',
  'Spenta solo per un servizio interno con certificato autofirmato.':
    'Désactivée seulement pour un service interne avec un certificat auto-signé.',
  'Un servizio interno che non chiede chiavi: lo protegge la rete, non CENSO.':
    "Un service interne qui ne demande pas de clé : c'est le réseau qui le protège, pas CENSO.",
  'Verifica il certificato TLS':
    'Vérifier le certificat TLS',
  "Vuoto: l'API di Anthropic. Si cambia solo con un gateway aziendale che la rilancia con lo stesso dialetto.":
    "Vide : l'API d'Anthropic. À changer seulement avec une passerelle d'entreprise qui la relaie avec le même dialecte.",
  'claude-sonnet-5':
    'claude-sonnet-5',
  'http://10.0.0.5:8000':
    'http://10.0.0.5:8000',
  'https://api.anthropic.com':
    'https://api.anthropic.com',
  'modello interno':
    'modèle interne',
  'qwen3:32b':
    'qwen3:32b',
  'Filtra gli host':
    'Filtrer les hôtes',
  'Versione non rilevata':
    'Version non détectée',
  'filtra host per nome o indirizzo…':
    'filtrer les hôtes par nom ou adresse…',
  '{n} host in {c} cluster: apri un cluster o filtra':
    '{n} hôtes dans {c} clusters : ouvrez un cluster ou filtrez',
  '{n} host su {tot}':
    '{n} hôtes sur {tot}',
  'Vuota: 22. Vale per gli apparati senza porta nell’indirizzo.':
    "Vide : 22. S'applique aux équipements sans port dans l'adresse.",
  'Excel':
    'Excel',
  'PDF':
    'PDF',
  'Ordina per questa colonna':
    'Trier par cette colonne',
  'Scarica l’elenco con i filtri in vigore in Excel':
    'Télécharger la liste avec les filtres en vigueur en Excel',
  'Scarica l’elenco con i filtri in vigore in PDF':
    'Télécharger la liste avec les filtres en vigueur en PDF',
  'Con «Excel» e «PDF» scarichi l’elenco così com’è filtrato, con le colonne scelte e nell’ordine che vedi; cliccando l’intestazione di una colonna ordini per quella, di nuovo per invertire, su tutte le pagine.':
    "Avec « Excel » et « PDF » vous téléchargez la liste telle qu'elle est filtrée, avec les colonnes choisies et dans l'ordre affiché ; un clic sur l'en-tête d'une colonne trie selon celle-ci, un second clic inverse, sur toutes les pages.",
  'Chi amministra il tenant può passare all’ambiente vuoto.':
    "L'administrateur du tenant peut passer à l'environnement vide.",
  'L’ambiente è vuoto. Vuoi vedere la piattaforma popolata? Carica l’ambiente di esempio: una sede con rete, server, VM, un account cloud, rischi e contratti. Si toglie con un clic quando colleghi le tue sonde.':
    "L'environnement est vide. Vous voulez voir la plateforme remplie ? Chargez l'environnement d'exemple : un site avec réseau, serveurs, VM, un compte cloud, des constats et des contrats. Un clic le retire quand vous connectez vos sondes.",
  'No, parto vuoto':
    'Non, je pars à vide',
  'L’ambiente di esempio è riservato ai tenant in prova.':
    "L'environnement d'exemple est réservé aux tenants en essai.",
  '192.0.2.1:4118':
    '192.0.2.1:4118',
  'status':
    'status',
  'WatchGuard Firebox (firewall)':
    'WatchGuard Firebox (pare-feu)',
  'Indirizzo della CLI (SSH)':
    'Adresse de la CLI (SSH)',
  'Utente e password della CLI':
    'Utilisateur et mot de passe de la CLI',
  'Indirizzo della gestione del Firebox e porta della Fireware CLI (4118 di serie; senza porta si assume 4118). La policy «WatchGuard» del firewall deve ammettere la sonda.':
    'Adresse d’administration du Firebox et port de la Fireware CLI (4118 par défaut ; sans port, 4118 est supposé). La politique «WatchGuard» du pare-feu doit admettre la sonde.',
  'CENSO parla con il Firebox come farebbe un amministratore dalla riga di comando (SSH): «sysinfo», «who», «show connection count», «show vpn-status», «show log-cache» per il Traffic Monitor. Solo comandi di lettura, scelti da un elenco fisso nella sonda: nessun comando arriva dal Control Plane come testo.':
    'CENSO parle au Firebox comme le ferait un administrateur en ligne de commande (SSH) : «sysinfo», «who», «show connection count», «show vpn-status», «show log-cache» pour le Traffic Monitor. Uniquement des commandes de lecture, choisies dans une liste fixe de la sonde : aucune commande n’arrive du Control Plane sous forme de texte.',
  "Sul Firebox: Fireware Web UI → System → Global Settings → «Enable command line interface (SSH)»; la policy «WatchGuard» (porta 4118) deve accettare l'indirizzo della sonda.":
    'Sur le Firebox : Fireware Web UI → System → Global Settings → «Enable command line interface (SSH)» ; la politique «WatchGuard» (port 4118) doit accepter l’adresse de la sonde.',
  "Per il backup della configurazione la sonda fa eseguire «export config» verso un ricevitore FTP che apre su una porta alta per pochi secondi: il Firebox deve poter aprire una connessione verso la sonda, e il comando richiede un'utenza in lettura/scrittura (ruolo Device Administrator). Per la sola lettura basta l'utenza «status» (Device Monitor).":
    'Pour la sauvegarde de la configuration, la sonde fait exécuter «export config» vers un récepteur FTP qu’elle ouvre sur un port haut pendant quelques secondes : le Firebox doit pouvoir ouvrir une connexion vers la sonde, et la commande exige un utilisateur en lecture/écriture (rôle Device Administrator). Pour la seule lecture, l’utilisateur «status» (Device Monitor) suffit.',
  "«status» (Device Monitor, sola lettura) per interrogare; «admin» o un utente Device Administrator solo se serve il backup della configurazione (l'export non è concesso in sola lettura).":
    '«status» (Device Monitor, lecture seule) pour interroger ; «admin» ou un utilisateur Device Administrator seulement si la sauvegarde de la configuration est nécessaire (l’export n’est pas permis en lecture seule).',
  'La VPN si legge in tempo reale dai firewall Palo Alto, FortiGate e WatchGuard configurati in Integrazioni.':
    'Le VPN est lu en temps réel depuis les pare-feu Palo Alto, FortiGate et WatchGuard configurés dans Intégrations.',
  'La tabella di routing dell’apparato. Dai firewall Palo Alto, FortiGate e WatchGuard si legge dal firewall con «Sincronizza dal firewall» (Palo Alto non la espone via SNMP).':
    'La table de routage de l’équipement. Sur les pare-feu Palo Alto, FortiGate et WatchGuard, elle se lit depuis le pare-feu avec «Synchroniser depuis le pare-feu» (Palo Alto ne l’expose pas via SNMP).',
  'Nessun componente ancora: le ottiche di un firewall Palo Alto o FortiGate si leggono via API con il pulsante qui sopra (la CLI del WatchGuard non le elenca).':
    'Aucun composant pour l’instant : les optiques d’un pare-feu Palo Alto ou FortiGate se lisent via l’API avec le bouton ci-dessus (la CLI du WatchGuard ne les liste pas).',
  'Per porte e vicini scansiona gli apparati via SNMP; per le rotte accendi l’opzione «Tabelle di routing» sulla scansione. Per i firewall Palo Alto (che le rotte non le danno via SNMP), FortiGate e WatchGuard, sulla sezione Routing del CI c’è «Sincronizza dal firewall».':
    'Pour les ports et les voisins, scannez les équipements via SNMP ; pour les routes, activez l’option «Tables de routage» sur le scan. Pour les pare-feu Palo Alto (qui ne donnent pas les routes via SNMP), FortiGate et WatchGuard, la section Routage de la CI propose «Synchroniser depuis le pare-feu».',
  'VPN: le sessioni aperte (GlobalProtect sui Palo Alto, SSL VPN e IPsec sui FortiGate, Mobile VPN L2TP sui WatchGuard), chieste ai firewall al momento dell’apertura — postazione, IP assegnato, IP pubblico e da quando.':
    'VPN : les sessions ouvertes (GlobalProtect sur Palo Alto, SSL VPN et IPsec sur FortiGate, Mobile VPN L2TP sur WatchGuard), demandées aux pare-feu à l’ouverture — poste, IP attribuée, IP publique et depuis quand.',
  'i firewall Palo Alto, Fortinet FortiGate e WatchGuard Firebox configurati, anche insieme: cruscotto (sistema, sessioni, utenti VPN, amministratori collegati), minacce, web filter, classifiche e interrogazione dei log. Sulla scheda di un CI, il traffico da e verso quell’host visto dal firewall. La guida per preparare il FortiGate (utente API in sola lettura, log) e il WatchGuard (CLI SSH sulla 4118, utenza «status» per leggere, «admin» solo per il backup) è nel modulo della credenziale.':
    'les pare-feu Palo Alto, Fortinet FortiGate et WatchGuard Firebox configurés, même ensemble : tableau de bord (système, sessions, utilisateurs VPN, administrateurs connectés), menaces, filtrage web, classements et interrogation des journaux. Sur la fiche d’une CI, le trafic depuis et vers cet hôte vu par le pare-feu. Le guide pour préparer le FortiGate (utilisateur API en lecture seule, journaux) et le WatchGuard (CLI SSH sur 4118, utilisateur «status» pour lire, «admin» seulement pour la sauvegarde) est dans le formulaire de l’identité.',
  'Il WatchGuard non ha una REST API: CENSO legge la Fireware CLI dalla sonda con comandi di sola lettura scelti da un elenco fisso (sysinfo, who, show log-cache…), e il Traffic Monitor in memoria fa da registro del traffico. Il backup della configurazione lo esporta il Firebox stesso via FTP verso la sonda, su una porta alta aperta per pochi secondi: serve un utente Device Administrator e che il firewall raggiunga la sonda.':
    'Le WatchGuard n’a pas d’API REST : CENSO lit la Fireware CLI depuis la sonde avec des commandes en lecture seule choisies dans une liste fixe (sysinfo, who, show log-cache…), et le Traffic Monitor en mémoire sert de journal du trafic. La sauvegarde de la configuration est exportée par le Firebox lui-même via FTP vers la sonde, sur un port haut ouvert quelques secondes : il faut un utilisateur Device Administrator et que le pare-feu atteigne la sonde.',
  'Famiglie: Cisco, Huawei, Aruba/ProCurve, HP Comware, Extreme, Juniper, MikroTik, Fortinet, Palo Alto, Lantronix, Aethra e WatchGuard (il Firebox esporta la configurazione via FTP verso la sonda).':
    'Familles : Cisco, Huawei, Aruba/ProCurve, HP Comware, Extreme, Juniper, MikroTik, Fortinet, Palo Alto, Lantronix, Aethra et WatchGuard (le Firebox exporte sa configuration via FTP vers la sonde).',
  'questo nodo: {ruolo}':
    'ce nœud : {ruolo}',
  'Apri la finestra della porta':
    'Ouvrir la fenêtre du port',
  'Cataloga':
    'Cataloguer',
  'Cataloga una segnalazione o aggiungi una voce a mano.':
    'Cataloguez un signalement ou ajoutez une entrée à la main.',
  'Cataloga {mac}':
    'Cataloguer {mac}',
  'Catalogo MAC':
    'Catalogue MAC',
  'Costruttore (IEEE)':
    'Constructeur (IEEE)',
  'Eliminare la voce {p}?':
    'Supprimer l’entrée {p} ?',
  'I clienti segnalano un MAC dalla finestra della porta di uno switch.':
    'Les clients signalent un MAC depuis la fenêtre du port d’un commutateur.',
  'Il catalogo di CENSO integra il registro IEEE: un prefisso MAC (OUI, blocco o indirizzo intero) → costruttore, modello, categoria. Vale per tutti i clienti. Le segnalazioni arrivano dalla finestra della porta di uno switch: catalogarle chiude la segnalazione e insegna il riconoscimento a tutti.':
    'Le catalogue de CENSO complète le registre IEEE : un préfixe MAC (OUI, bloc ou adresse entière) → constructeur, modèle, catégorie. Il vaut pour tous les clients. Les signalements viennent de la fenêtre du port d’un commutateur : les cataloguer ferme le signalement et enseigne la reconnaissance à tous.',
  'Il costruttore produce apparecchi elettromedicali: è un indizio sul costruttore, non sul dispositivo.':
    'Le constructeur fabrique des appareils électromédicaux : c’est un indice sur le constructeur, pas sur l’appareil.',
  'Indirizzi MAC visti sulla porta':
    'Adresses MAC vues sur le port',
  'Invia la segnalazione':
    'Envoyer le signalement',
  'Invio…':
    'Envoi…',
  'Modifica {p}':
    'Modifier {p}',
  'Nessun indirizzo.':
    'Aucune adresse.',
  'Nessuna segnalazione':
    'Aucun signalement',
  'Non vista all’ultima scansione':
    'Non vue au dernier scan',
  'Nota di chi segnala':
    'Note du signaleur',
  'Nuova voce del catalogo':
    'Nouvelle entrée du catalogue',
  'OUI (6 esadecimali) per tutta la linea, blocco MA-M (7) o MA-S (9), oppure l’indirizzo intero (12) per quel solo dispositivo. Vince il prefisso più lungo.':
    'OUI (6 hexadécimaux) pour toute la gamme, bloc MA-M (7) ou MA-S (9), ou l’adresse entière (12) pour ce seul appareil. Le préfixe le plus long l’emporte.',
  'Porta {p}':
    'Port {p}',
  'Porta {p}: cosa vede':
    'Port {p} : ce qu’il voit',
  'Porte degli switch (dove si vede il MAC)':
    'Ports des commutateurs (où le MAC est vu)',
  'Prefissi MAC → costruttore, modello, categoria; le segnalazioni dei clienti da catalogare':
    'Préfixes MAC → constructeur, modèle, catégorie ; les signalements des clients à cataloguer',
  'Prefisso MAC':
    'Préfixe MAC',
  'Scarta':
    'Écarter',
  'Scrivi che cos’è, se lo sai (marca, modello, reparto): chi cataloga non vede la tua rete. Una volta catalogato, CENSO lo riconoscerà ovunque.':
    'Écrivez ce que c’est, si vous le savez (marque, modèle, service) : la personne qui catalogue ne voit pas votre réseau. Une fois catalogué, CENSO le reconnaîtra partout.',
  'Segnala':
    'Signaler',
  'Segnala {mac} all’amministrazione di CENSO':
    'Signaler {mac} à l’administration de CENSO',
  'Segnalazione inviata: quando l’amministrazione di CENSO la cataloga, il riconoscimento vale per tutti.':
    'Signalement envoyé : dès que l’administration de CENSO le catalogue, la reconnaissance vaut pour tous.',
  'Segnalazioni ({n})':
    'Signalements ({n})',
  'Ultima vista':
    'Dernière vue',
  'Voci del catalogo ({n})':
    'Entrées du catalogue ({n})',
  'aperta':
    'ouvert',
  'aperte':
    'ouverts',
  'catalogata':
    'catalogué',
  'catalogate':
    'catalogués',
  'catalogo CENSO':
    'catalogue CENSO',
  'da segnalazione':
    'depuis un signalement',
  'elettromedicale':
    'électromédical',
  'es. elettromedicale (monitor paziente), stampante, telefono IP':
    'ex. électromédical (moniteur patient), imprimante, téléphone IP',
  'es. pompa di infusione B. Braun Infusomat, sala 2':
    'ex. pompe à perfusion B. Braun Infusomat, salle 2',
  'non più vista':
    'plus vue',
  'scartata':
    'écarté',
  'scartate':
    'écartés',
  'usa l’indirizzo intero {mac}':
    'utiliser l’adresse entière {mac}',
  '{n} indirizzi all’ultima scansione, {m} in tutto (le voci non più viste restano per novanta giorni).':
    '{n} adresses au dernier scan, {m} en tout (les entrées plus vues restent quatre-vingt-dix jours).',
  'È un apparecchio elettromedicale':
    'C’est un appareil électromédical',
  'Sugli switch letti con l’opzione «Tabella MAC», nelle interfacce la colonna «Dispositivi collegati» dice quanti indirizzi ogni porta ha imparato e apre la finestra della porta (un puntino giallo accanto al numero = sulla porta c’è almeno un elettromedicale): MAC, IP se in CMDB, costruttore (registro IEEE e catalogo CENSO), CI abbinato con modello, VLAN, ultima vista; i costruttori di elettromedicali sono evidenziati. Un MAC che CENSO non riconosce si segnala da lì con «Segnala»: l’amministrazione di CENSO lo cataloga e da allora lo riconoscono tutti.':
    'Sur les commutateurs scannés avec l’option «Table MAC», la colonne «Dispositifs connectés» des interfaces indique combien d’adresses chaque port a apprises et ouvre la fenêtre du port (un point jaune à côté du nombre = au moins un dispositif médical sur le port) : MAC, IP si dans la CMDB, constructeur (registre IEEE et catalogue CENSO), CI associée avec modèle, VLAN, dernière vue ; les constructeurs d’électromédical sont mis en évidence. Un MAC que CENSO ne reconnaît pas se signale de là avec «Signaler» : l’administration de CENSO le catalogue et dès lors tout le monde le reconnaît.',
  'Un indirizzo MAC, in qualunque grafia (aa:bb:cc, AA-BB-CC, aabb.ccdd) e anche solo il prefisso, trova su quale switch e su quale porta lo si vede: il gruppo «Porte» apre lo switch sulla porta.':
    'Une adresse MAC, sous n’importe quelle graphie (aa:bb:cc, AA-BB-CC, aabb.ccdd) et même seulement le préfixe, trouve sur quel commutateur et quel port on la voit : le groupe «Ports» ouvre le commutateur sur le port.',
  'es. Philips':
    'ex. Philips',
  'es. IntelliVue MX800':
    'ex. IntelliVue MX800',
  'Ascolto passivo (ARP, DHCP, mDNS, SSDP, NetBIOS, LLDP)':
    'Écoute passive (ARP, DHCP, mDNS, SSDP, NetBIOS, LLDP)',
  'Chiede a Fingerbank gli indirizzi che il catalogo CENSO non conosce (al massimo cento) e salva le risposte con la classe.':
    'Demande à Fingerbank les adresses que le catalogue CENSO ne connaît pas (cent au plus) et enregistre les réponses avec la classe.',
  'Classe CI':
    'Classe de CI',
  'Fingerbank (riconoscimento dispositivi)':
    'Fingerbank (reconnaissance des appareils)',
  "Fingerbank classifica un dispositivo dalle sue impronte di rete: il MAC, la lista delle opzioni DHCP che chiede, la classe vendor DHCP, l'hostname. Risponde con il dispositivo («Printer or Scanner/HP/HP LaserJet»), il sistema operativo e un punteggio.":
    'Fingerbank classe un appareil d’après ses empreintes réseau : le MAC, la liste des options DHCP qu’il demande, la classe vendor DHCP, le nom d’hôte. Il répond avec l’appareil («Printer or Scanner/HP/HP LaserJet»), le système d’exploitation et un score.',
  'Fingerbank: {n} chiesti, {r} riconosciuti, poi: {e}':
    'Fingerbank : {n} demandés, {r} reconnus, puis : {e}',
  'Fingerbank: {n} chiesti, {r} riconosciuti, {c} CI classificati. Le risposte sono nel catalogo CENSO.':
    'Fingerbank : {n} demandés, {r} reconnus, {c} CI classées. Les réponses sont dans le catalogue CENSO.',
  'Fonti dell’ascolto passivo':
    'Sources de l’écoute passive',
  'La chiave del tuo account Fingerbank (api.fingerbank.org → API key).':
    'La clé de votre compte Fingerbank (api.fingerbank.org → API key).',
  'La chiave della classe CENSO (es. medical_device, printer, voip_phone, workstation): un CI ancora «unknown» dietro il MAC la eredita alla prossima scansione.':
    'La clé de classe CENSO (ex. medical_device, printer, voip_phone, workstation) : une CI encore «unknown» derrière le MAC l’hérite au prochain scan.',
  "La sonda ascolta dalla propria scheda gli annunci dei dispositivi sul segmento — ARP (chi ha quale IP, anche statico), le richieste DHCP (l'impronta del sistema operativo), mDNS e SSDP (stampanti, TV, apparecchi Apple, spesso con il modello), NetBIOS (il nome Windows), LLDP (telefoni IP, access point). Non manda pacchetti e non apre porte in ingresso. Alimenta la finestra della porta degli switch, il riconoscimento del tipo di dispositivo e Fingerbank.":
    'La sonde écoute depuis sa propre carte ce que les appareils annoncent sur le segment — ARP (qui a quelle IP, même statique), les requêtes DHCP (l’empreinte du système d’exploitation), mDNS et SSDP (imprimantes, TV, appareils Apple, souvent avec le modèle), NetBIOS (le nom Windows), LLDP (téléphones IP, points d’accès). Elle n’envoie aucun paquet et n’ouvre aucun port entrant. Elle alimente la fenêtre du port des commutateurs, la reconnaissance du type d’appareil et Fingerbank.',
  "Le impronte escono verso Fingerbank (Akamai). Con l'ascolto passivo acceso sulla sonda le impronte DHCP rendono il verdetto molto più preciso che con il solo MAC.":
    'Les empreintes partent vers Fingerbank (Akamai). Avec l’écoute passive activée sur la sonde, les empreintes DHCP rendent le verdict bien plus précis que le seul MAC.',
  'Ogni risposta si scrive nel catalogo di CENSO con la classe: la volta dopo quel MAC si riconosce senza chiedere a nessuno, in ogni tenant. Il piano gratuito ha un tetto di richieste: CENSO chiede al massimo cento indirizzi per azione e ricorda sei ore le risposte vuote.':
    'Chaque réponse est écrite dans le catalogue de CENSO avec la classe : la fois suivante, ce MAC est reconnu sans demander à personne, dans chaque tenant. Le plan gratuit a un plafond de requêtes : CENSO demande au plus cent adresses par action et retient six heures les réponses vides.',
  'Riconosci con Fingerbank':
    'Reconnaître avec Fingerbank',
  'Riconosciuto da ciò che il dispositivo annuncia in rete (mDNS, DHCP, LLDP, SSDP).':
    'Reconnu d’après ce que l’appareil annonce sur le réseau (mDNS, DHCP, LLDP, SSDP).',
  'Riconosco…':
    'Reconnaissance…',
  'Vuoto: il servizio Fingerbank in cloud. Si cambia solo con un gateway aziendale che lo rilancia.':
    'Vide : le service Fingerbank en cloud. À changer seulement avec une passerelle d’entreprise qui le relaie.',
  'annunciato':
    'annoncé',
  'https://api.fingerbank.org':
    'https://api.fingerbank.org',
  'stessa impronta':
    'même empreinte',
  'Ascolta ma non sente nulla: sulla scheda della sonda non passano annunci. In una VM controlla che la porta del vSwitch sia sullo stesso segmento dei dispositivi; in container serve la rete dell’host.':
    'Elle écoute mais n’entend rien : aucune annonce ne passe sur la carte de la sonde. Dans une VM, vérifiez que le port du vSwitch est sur le même segment que les appareils ; en conteneur, le réseau de l’hôte est requis.',
  'Ascolto passivo':
    'Écoute passive',
  'Dispositivi consegnati':
    'Appareils livrés',
  'La sonda non riporta ancora lo stato dell’ascolto: aspetta il prossimo heartbeat, o aggiornala se è una versione precedente.':
    'La sonde ne rapporte pas encore l’état de l’écoute : attendez le prochain battement, ou mettez-la à jour si c’est une version antérieure.',
  'La sonda sente dalla propria scheda gli annunci dei dispositivi sul segmento (ARP, DHCP, mDNS, SSDP, NetBIOS, LLDP) e consegna un riassunto per MAC ogni due minuti. Qui vedi se ascolta e chi ha sentito: un dispositivo in tabella è la prova che intercetta.':
    'La sonde entend depuis sa propre carte ce que les appareils annoncent sur le segment (ARP, DHCP, mDNS, SSDP, NetBIOS, LLDP) et livre un résumé par MAC toutes les deux minutes. Ici vous voyez si elle écoute et qui elle a entendu : un appareil dans le tableau prouve qu’elle intercepte.',
  'Pacchetti utili sentiti':
    'Paquets utiles entendus',
  'Schede':
    'Cartes',
  'in ascolto':
    'en écoute',
  'non in ascolto':
    'pas en écoute',
  'ultima consegna {q}':
    'dernière livraison {q}',
  'Annunci sentiti (ascolto passivo)':
    'Annonces entendues (écoute passive)',
  'Cattura':
    'Capture',
  'Catturati dal filo':
    'Capturés sur le fil',
  'Collector':
    'Collecteur',
  'Con costruttore':
    'Avec constructeur',
  'Costruttori più frequenti':
    'Constructeurs les plus fréquents',
  'Dispositivi individuati':
    'Appareils identifiés',
  'Dispositivi individuati e identificati': 'Appareils détectés et identifiés',
  'Dispositivi sentiti':
    'Appareils entendus',
  'Elettromedicali':
    'Électromédicaux',
  'Flussi attivi':
    'Flux actifs',
  'Flussi decodificati dalle sonde':
    'Flux décodés par les sondes',
  'Flussi nella finestra':
    'Flux dans la fenêtre',
  'mostra gli indirizzi fisici (MAC) rilevati sulle porte degli switch e tramite ascolto passivo, arricchiti con le informazioni disponibili: produttore, tipo di dispositivo e identificazioni ottenute dal catalogo CENSO, Fingerbank e impronte di riconoscimento.': 'affiche les adresses physiques (MAC) détectées sur les ports des switchs et par écoute passive, enrichies des informations disponibles : fabricant, type d’appareil et identifications obtenues du catalogue CENSO, Fingerbank et empreintes de reconnaissance.',
  'Host visti':
    'Hôtes vus',
  'mostra, per ogni sonda, il traffico acquisito da una porta mirror e i dispositivi rilevati tramite protocolli di rete locali come ARP, DHCP, mDNS, SSDP, NetBIOS e LLDP.': 'affiche, pour chaque sonde, le trafic capturé depuis un port miroir et les appareils détectés via des protocoles réseau locaux comme ARP, DHCP, mDNS, SSDP, NetBIOS et LLDP.',
  'Nel catalogo CENSO':
    'Dans le catalogue CENSO',
  'Nessun dispositivo: lancia una scansione SNMP con «Tabella MAC» sugli switch.':
    'Aucun appareil : lancez un scan SNMP avec «Table MAC» sur les commutateurs.',
  'Nessun tipo riconosciuto: accendi l’ascolto passivo sulla sonda.':
    'Aucun type reconnu : activez l’écoute passive sur la sonde.',
  'Pacchetti intercettati':
    'Paquets interceptés',
  'Pacchetti nella finestra':
    'Paquets dans la fenêtre',
  'Pacchetti ricevuti dalle sonde':
    'Paquets reçus par les sondes',
  'Mostra il volume di traffico rilevato, la percentuale decodificata e il numero di dispositivi identificati.': 'Affiche le volume de trafic détecté, le pourcentage décodé et le nombre d’appareils identifiés.',
  'confronta i flussi registrati nel periodo selezionato con il traffico che le sonde dichiarano di aver ricevuto e decodificato dall’avvio, tramite NetFlow, IPFIX, sFlow e cattura di rete.': 'compare les flux enregistrés sur la période sélectionnée avec le trafic que les sondes déclarent avoir reçu et décodé depuis le démarrage, via NetFlow, IPFIX, sFlow et la capture réseau.',
  'Registro dei flussi non leggibile: {e}':
    'Journal des flux illisible : {e}',
  'Riconosciuti dagli annunci':
    'Reconnus d’après les annonces',
  'Copertura rispetto all’inventario di riferimento':
    'Couverture par rapport à l’inventaire de référence',
  'La scala del riconoscimento giorno per giorno, misurata sui {n} dispositivi dell’inventario di riferimento (Armis, Medigate…): scoperto, identificato come tipo, riconosciuto, fino allo stesso modello.':
    'L’échelle de la reconnaissance jour après jour, mesurée sur les {n} appareils de l’inventaire de référence (Armis, Medigate…) : découvert, identifié par type, reconnu, jusqu’au même modèle.',
  'Scoperti sulla rete':
    'Découverts sur le réseau',
  'Identificati (almeno il tipo)':
    'Identifiés (au moins le type)',
  'Riconosciuti (modello o elettromedicale)':
    'Reconnus (modèle ou médical)',
  'Stesso modello del riferimento':
    'Même modèle que la référence',
  "Un grafico d’andamento mostra, giorno per giorno, quanti dispositivi si vedono, quanti si riconoscono dagli annunci e quanti sono elettromedicali: così si capisce se il riconoscimento migliora man mano che si imparano firme, si estende lo SPAN o si mettono agenti sulle postazioni.":
    "Un graphique d’évolution montre, jour après jour, combien d’appareils sont vus, combien sont reconnus d’après leurs annonces et combien sont médicaux : on voit ainsi si la reconnaissance s’améliore en apprenant des signatures, en étendant le SPAN ou en déployant des agents sur les postes.",
  'Se c’è un inventario di riferimento, un secondo gruppo di grafici mostra la stessa scala misurata su quello: quanti dei dispositivi attesi sono scoperti sulla rete, quanti identificati almeno come tipo, quanti riconosciuti e per quanti CENSO dice lo stesso modello — l’evidenza giorno per giorno di quanto l’ospedale è coperto senza fonti esterne.':
    'Si un inventaire de référence existe, un second groupe de graphiques montre la même échelle mesurée sur celui-ci : combien des appareils attendus sont découverts sur le réseau, combien identifiés au moins par type, combien reconnus et pour combien CENSO donne le même modèle — la preuve jour après jour de la couverture de l’hôpital sans sources externes.',
  'Andamento del riconoscimento (30 giorni)':
    'Évolution de la reconnaissance (30 jours)',
  'Un punto al giorno: così si vede se il riconoscimento migliora imparando firme, estendendo lo SPAN o mettendo agenti sulle postazioni.':
    'Un point par jour : on voit ainsi si la reconnaissance s’améliore en apprenant des signatures, en étendant le SPAN ou en déployant des agents sur les postes.',
  'Scartati dal kernel':
    'Rejetés par le noyau',
  'Segnalazioni aperte':
    'Signalements ouverts',
  'Sistemi operativi (host locali)':
    'Systèmes d’exploitation (hôtes locaux)',
  'Tipi di dispositivo (ntopng)':
    'Types d’appareil (ntopng)',
  'Tipi riconosciuti':
    'Types reconnus',
  'Top talker locali':
    'Top talkers locaux',
  'Traffic Analysis':
    'Analyse du trafic',
  'Traffico decodificato':
    'Trafic décodé',
  'Volume nella finestra':
    'Volume dans la fenêtre',
  'dall’avvio':
    'depuis le démarrage',
  'dall’avvio, tutti i collector':
    'depuis le démarrage, tous les collecteurs',
  'ferma':
    'arrêtée',
  'la sonda non teneva il passo: i volumi sono incompleti':
    'la sonde ne suivait pas : les volumes sont incomplets',
  'ntopng non ha ancora riconosciuto sistemi operativi.':
    'ntopng n’a encore reconnu aucun système d’exploitation.',
  'ntopng non riporta tipi di dispositivo.':
    'ntopng ne rapporte aucun type d’appareil.',
  'ntopng non risponde':
    'ntopng ne répond pas',
  'quanto traffico vediamo e quanto ne capiamo: volume, pacchetti e flussi decodificati nella finestra scelta e dall’avvio delle sonde; pacchetti catturati dal filo e annunci sentiti dall’ascolto passivo, sonda per sonda; dispositivi individuati sulle porte degli switch e nell’ascolto, con costruttore, tipo riconosciuto, voci nel catalogo CENSO ed elettromedicali. Se ntopng è configurato, anche host attivi, sistemi operativi, tipi di dispositivo e top talker visti da lì.':
    'combien de trafic nous voyons et combien nous comprenons : volume, paquets et flux décodés dans la fenêtre choisie et depuis le démarrage des sondes ; paquets capturés sur le fil et annonces entendues par l’écoute passive, sonde par sonde ; appareils identifiés sur les ports des commutateurs et à l’écoute, avec constructeur, type reconnu, entrées du catalogue CENSO et électromédicaux. Avec ntopng configuré, aussi hôtes actifs, systèmes d’exploitation, types d’appareil et top talkers vus de là.',
  'silenziosa':
    'silencieuse',
  'silenziosi':
    'silencieux',
  'ultima ora':
    'dernière heure',
  'ultime 24 ore':
    'dernières 24 heures',
  '{a} sulle porte, {b} sentiti, {c} nelle ultime 24 ore':
    '{a} sur les ports, {b} entendus, {c} dans les dernières 24 heures',
  '{c} catalogate, {s} scartate':
    '{c} cataloguées, {s} écartées',
  '{n} annunci, {m} dispositivi':
    '{n} annonces, {m} appareils',
  '{n} locali':
    '{n} locaux',
  '{n} pacchetti, {m} flussi':
    '{n} paquets, {m} flux',
  '{n} pacchetti, {m} flussi, {d} scartati':
    '{n} paquets, {m} flux, {d} rejetés',
  'Elettromedicali su questa porta':
    'Dispositifs médicaux sur ce port',
  '{n} elettromedicali su questa porta':
    '{n} dispositifs médicaux sur ce port',
  'Ascolto DHCP':
    'Écoute DHCP',
  'Ascolta le richieste DHCP e leggi i lease (solo sul server DHCP di Windows)':
    'Écouter les requêtes DHCP et lire les baux (uniquement sur le serveur DHCP Windows)',
  'Con gli ip helper sui gateway il server DHCP riceve le richieste di tutte le VLAN: l’agente ne legge MAC, nome, impronta del sistema operativo e VLAN di provenienza, più i lease del servizio, e li consegna col keep-alive come l’ascolto passivo della sonda.':
    'Avec les ip helper sur les passerelles, le serveur DHCP reçoit les requêtes de tous les VLAN : l’agent en lit le MAC, le nom, l’empreinte du système et le VLAN d’origine, plus les baux du service, et les livre avec le keep-alive comme l’écoute passive de la sonde.',
  'In ascolto su {n} indirizzi: {p} richieste sentite, {l} lease letti, {q} da consegnare.':
    'À l’écoute sur {n} adresses : {p} requêtes entendues, {l} baux lus, {q} à livrer.',
  'Acceso ma non in ascolto: l’agente non ha ancora aperto le prese o non può (serve Windows e i diritti di amministratore).':
    'Activé mais pas à l’écoute : l’agent n’a pas encore ouvert les prises ou ne le peut pas (Windows et droits d’administrateur requis).',
  'Spento.':
    'Éteint.',
  'Lease':
    'Baux',
  'Dispositivi collegati':
    'Dispositifs connectés',
  'Gli stessi avvistamenti arrivano anche dall’agente installato sul server DHCP di Windows (spunta «Ascolto DHCP» nella sua scheda: con gli ip helper vede le richieste di tutte le VLAN, con l’impronta del sistema operativo e la VLAN di provenienza, più i lease) e dai firewall ogni cinque minuti: il device inventory del FortiGate (tipo, sistema operativo, costruttore) e ARP e lease DHCP del Palo Alto (MAC↔IP).':
    'Les mêmes observations arrivent aussi de l’agent installé sur le serveur DHCP Windows (case « Écoute DHCP » sur sa fiche : avec les ip helper il voit les requêtes de tous les VLAN, avec l’empreinte du système et le VLAN d’origine, plus les baux) et des pare-feu toutes les cinq minutes : l’inventaire des appareils du FortiGate (type, système, constructeur) et l’ARP et les baux DHCP du Palo Alto (MAC↔IP).',
  'Installato sul server DHCP di Windows, con «Ascolto DHCP» acceso diventa anche una fonte di dispositivi: le richieste DHCP di tutte le VLAN e i lease del servizio finiscono fra gli avvistamenti (finestra della porta, Traffic Analysis); la scheda dice se è in ascolto e quante richieste ha sentito.':
    'Installé sur le serveur DHCP Windows, avec « Écoute DHCP » activée il devient aussi une source d’appareils : les requêtes DHCP de tous les VLAN et les baux du service rejoignent les observations (fenêtre du port, Traffic Analysis) ; la fiche dit s’il écoute et combien de requêtes il a entendues.',
  '{n} dispositivi (i primi {n}: restringi con il filtro).':
    '{n} appareils (les {n} premiers : affinez avec le filtre).',
  '{n} dispositivi':
    '{n} appareils',
  'Switch · porta':
    'Commutateur · port',
  'Segnalazione aperta':
    'Signalement ouvert',
  'Voce del catalogo CENSO':
    'Entrée du catalogue CENSO',
  'catalogo':
    'catalogue',
  'Nessun dispositivo per questo filtro.':
    'Aucun appareil pour ce filtre.',
  'Sulle porte degli switch':
    'Sur les ports des commutateurs',
  'Sentiti (ascolto, DHCP, firewall)':
    'Entendus (écoute, DHCP, pare-feu)',
  '{c} nelle ultime 24 ore':
    '{c} dans les dernières 24 heures',
  'Ogni valore identifica il numero dei dispositivi rilevati associati al CI e, dove disponibile, lo switch e la porta su cui sono stati rilevati.': 'Chaque valeur identifie le nombre d’appareils détectés associés au CI et, lorsque disponible, le switch et le port sur lesquels ils ont été détectés.',
  'Per fonte':
    'Par source',
  'Nessun avvistamento: accendi l’ascolto passivo sulla sonda, l’ascolto DHCP sull’agente del server DHCP o un firewall.':
    'Aucune observation : activez l’écoute passive sur la sonde, l’écoute DHCP sur l’agent du serveur DHCP ou un pare-feu.',
  'Dai firewall':
    'Depuis les pare-feu',
  'ogni cinque minuti acquisisce le informazioni sui dispositivi rilevati dai firewall. Rileva le associazioni MAC-IP per VLAN tramite ARP e DHCP, acquisisce tipo di dispositivo, sistema operativo e produttore. Ogni valore corrisponde all’elenco dei dispositivi rilevati.': 'toutes les cinq minutes, il recueille les informations sur les appareils détectés par les pare-feu. Il relève les associations MAC-IP par VLAN via ARP et DHCP et recueille le type d’appareil, le système d’exploitation et le fabricant. Chaque valeur correspond à la liste des appareils détectés.',
  'Nessun dispositivo dai firewall':
    'Aucun appareil depuis les pare-feu',
  'Serve una credenziale Palo Alto o FortiGate in Integrazioni: la lettura parte da sola al primo giro.':
    'Il faut un identifiant Palo Alto ou FortiGate dans Intégrations : la lecture démarre seule au premier tour.',
  'ARP':
    'ARP',
  'Lease DHCP':
    'Baux DHCP',
  'Device inventory':
    'Inventaire des appareils',
  'ARP di {f}':
    'ARP de {f}',
  'Lease DHCP di {f}':
    'Baux DHCP de {f}',
  'Device inventory di {f}':
    'Inventaire des appareils de {f}',
  'ARP (sonda)':
    'ARP (sonde)',
  'DHCP (sonda)':
    'DHCP (sonde)',
  'Richieste DHCP (agente sul server DHCP)':
    'Requêtes DHCP (agent sur le serveur DHCP)',
  'Lease DHCP (agente sul server DHCP)':
    'Baux DHCP (agent sur le serveur DHCP)',
  'ARP del firewall Palo Alto':
    'ARP du pare-feu Palo Alto',
  'Lease DHCP del firewall Palo Alto':
    'Baux DHCP du pare-feu Palo Alto',
  'Device inventory FortiGate':
    'Inventaire des appareils FortiGate',
  'Apri la lista':
    'Ouvrir la liste',
  'Ogni numero si apre su un popup con la lista che lo compone (MAC, IP, nome, costruttore, tipo, CI abbinato, switch e porta), e dalla lista si va al CI o alla finestra della porta; anche i tipi, i costruttori e le fonti sono cliccabili. La card «Dai firewall» dice, firewall per firewall, quanti dispositivi vengono da ARP, lease DHCP e device inventory.':
    'Chaque nombre ouvre une fenêtre avec la liste qui le compose (MAC, IP, nom, constructeur, type, CI associé, commutateur et port), et depuis la liste on va au CI ou à la fenêtre du port ; les types, les constructeurs et les sources sont aussi cliquables. La carte « Depuis les pare-feu » dit, pare-feu par pare-feu, combien d’appareils viennent de l’ARP, des baux DHCP et de l’inventaire des appareils.',
  'Per sentire più VLAN porta alla sonda una porta trunk con tutte le VLAN consentite: legge il tag 802.1Q di ogni frame e segna la VLAN in tabella, senza sottointerfacce sulla macchina.':
    'Pour entendre plusieurs VLAN, amenez à la sonde un port trunk avec tous les VLAN autorisés : elle lit le tag 802.1Q de chaque trame et note le VLAN dans le tableau, sans sous-interfaces sur la machine.',
  'Per sentire più VLAN con una sonda sola, porta alla sonda una porta trunk con tutte le VLAN consentite: la sonda legge il tag 802.1Q di ogni frame e segna la VLAN dell’avvistamento, senza una sottointerfaccia per VLAN sulla macchina (se è una VM, il port group deve lasciare passare i tag).':
    'Pour entendre plusieurs VLAN avec une seule sonde, amenez-lui un port trunk avec tous les VLAN autorisés : la sonde lit le tag 802.1Q de chaque trame et note le VLAN de l’observation, sans sous-interface par VLAN sur la machine (sur une VM, le port group doit laisser passer les tags).',
  'Servizi virtuali in servizio':
    'Services virtuels en service',
  'Server reali in servizio':
    'Serveurs réels en service',
  'Certificati':
    'Certificats',
  'Certificati scaduti':
    'Certificats expirés',
  'Bilanciamento':
    'Répartition de charge',
  'Servizi virtuali':
    'Services virtuels',
  'Persistenza':
    'Persistance',
  'Server reali':
    'Serveurs réels',
  'sotto-servizio':
    'sous-service',
  'peso':
    'poids',
  'Emittente':
    'Émetteur',
  'Valido dal':
    'Valide à partir du',
  'Seriale':
    'Numéro de série',
  'Su un bilanciatore (Kemp LoadMaster via SNMP) la scheda ha la card «Bilanciamento»: i servizi virtuali con VIP, porta, protocollo, bilanciamento, persistenza, stato e connessioni, sotto ognuno i server reali con peso e stato, e i certificati con la scadenza evidenziata; i VIP sono anche indirizzi aggiuntivi del CI, quindi la composizione di servizio da un VIP arriva al bilanciatore.':
    'Sur un répartiteur de charge (Kemp LoadMaster via SNMP) la fiche a la carte « Répartition de charge » : les services virtuels avec VIP, port, protocole, répartition, persistance, état et connexions, sous chacun les serveurs réels avec poids et état, et les certificats avec l’expiration mise en évidence ; les VIP sont aussi des adresses supplémentaires du CI, donc la composition de service depuis un VIP atteint le répartiteur.',
  'Azzerare tutti gli avvistamenti di questo spazio? Nomi, impronte e fonti sentite ripartono da zero; la sonda, l’agente DHCP e i firewall li ricostruiscono nei minuti successivi. Il catalogo MAC e le impronte imparate restano.':
    'Effacer toutes les observations de cet espace ? Noms, empreintes et sources entendues repartent de zéro ; la sonde, l’agent DHCP et les pare-feu les reconstruisent dans les minutes suivantes. Le catalogue MAC et les empreintes apprises restent.',
  'Azzerati {n} avvistamenti. Le fonti li ricostruiscono da sole: sonda ogni due minuti, agente DHCP ogni minuto, firewall ogni cinque.':
    '{n} observations effacées. Les sources les reconstruisent seules : sonde toutes les deux minutes, agent DHCP chaque minute, pare-feu toutes les cinq.',
  'Cancella gli avvistamenti dell’ascolto passivo, dell’agente DHCP e dei firewall: da usare dopo una correzione, si ricostruiscono da soli.':
    'Supprime les observations de l’écoute passive, de l’agent DHCP et des pare-feu : à utiliser après une correction, elles se reconstruisent seules.',
  '«Azzera avvistamenti» (amministratori) cancella tutto ciò che è stato sentito e lascia che sonda, agente DHCP e firewall lo ricostruiscano: serve dopo una correzione dell’ascolto; catalogo MAC e impronte imparate restano.':
    '« Effacer les observations » (administrateurs) supprime tout ce qui a été entendu et laisse la sonde, l’agent DHCP et les pare-feu le reconstruire : utile après une correction de l’écoute ; le catalogue MAC et les empreintes apprises restent.',
  'certificato':
    'certificat',
  'Cosa ha detto sul filo':
    'Ce qu’il a dit sur le fil',
  'medicale':
    'médical',
  'Nessun host per questo filtro.':
    'Aucun hôte pour ce filtre.',
  'Protocolli sul filo':
    'Protocoles sur le fil',
  'Analisi passiva del traffico: la sonda analizza il traffico acquisito da porta mirror o in modalità promiscua per identificare sistemi, servizi e applicazioni tramite HTTP, TLS, SSH, SMB, DICOM, HL7, SIP e WS-Discovery. I rilevamenti sono associati per IP al relativo CI e ogni valore apre l’elenco di dettaglio.': 'Analyse passive du trafic : la sonde analyse le trafic capturé depuis un port miroir ou en mode promiscuité pour identifier systèmes, services et applications via HTTP, TLS, SSH, SMB, DICOM, HL7, SIP et WS-Découverte. Les détections sont associées par IP au CI correspondant, et chaque valeur ouvre la liste de détail.',
  'Host con fatti sul filo':
    'Hôtes avec des faits du fil',
  'ultimo: {q}':
    'dernier : {q}',
  'Riconosciuti dal filo':
    'Reconnus depuis le fil',
  'Medicali (DICOM / HL7)':
    'Médicaux (DICOM / HL7)',
  'Con certificato TLS':
    'Avec certificat TLS',
  'Host per protocollo':
    'Hôtes par protocole',
  'Niente ancora: serve una porta mirror o una scheda in promiscuo con l’ascolto passivo acceso.':
    'Rien encore : il faut un port miroir ou une carte en promiscuité avec l’écoute passive activée.',
  'Dai protocolli sul filo (mirror/promiscuo)':
    'Depuis les protocoles sur le fil (miroir/promiscuité)',
  'filo':
    'fil',
  'Visto sul filo':
    'Vu sur le fil',
  'Ciò che questa macchina ha detto di sé nel traffico visto dalla sonda (porta mirror o promiscuo): protocolli unicast, per indirizzo.':
    'Ce que cette machine a dit d’elle-même dans le trafic vu par la sonde (port miroir ou promiscuité) : protocoles unicast, par adresse.',
  'Tipo riconosciuto':
    'Type reconnu',
  'Parla DICOM o HL7: è un’apparecchiatura o un sistema sanitario.':
    'Il parle DICOM ou HL7 : c’est un dispositif ou un système de santé.',
  'La card «Protocolli sul filo» è ciò che la sonda capisce dal traffico unicast su una porta mirror o in promiscuo: User-Agent e Server HTTP, certificati e nomi TLS, banner SSH, nome/dominio/versione Windows da SMB, AE title DICOM e applicazioni HL7 (segnati medicali), telefoni SIP, telecamere e stampanti WS-Discovery; per IP, con il CI che ha quell’indirizzo. Nella scheda di un CI gli stessi fatti stanno nella card «Visto sul filo», e nella finestra della porta nella riga «filo».':
    'La carte « Protocoles sur le fil » est ce que la sonde comprend du trafic unicast sur un port miroir ou en promiscuité : User-Agent et Server HTTP, certificats et noms TLS, bannières SSH, nom/domaine/version Windows via SMB, AE title DICOM et applications HL7 (marqués médicaux), téléphones SIP, caméras et imprimantes WS-Découverte ; par IP, avec le CI qui a cette adresse. Sur la fiche d’un CI les mêmes faits sont dans la carte « Vu sur le fil », et dans la fenêtre du port dans la ligne « fil ».',
  'Con la cattura dal filo configurata l’ascolto è acceso da solo, senza spunta: la cattura produce le conversazioni (chi parla con chi, volumi), l’analisi l’identità dei dispositivi, sugli stessi pacchetti letti una volta sola («(cattura)» accanto al nome della scheda). La capability «Ascolto passivo» serve solo per ascoltare schede senza cattura (management, trunk).':
    'Avec la capture sur le fil configurée, l’écoute est active d’elle-même, sans case : la capture produit les conversations (qui parle à qui, volumes), l’analyse l’identité des appareils, sur les mêmes paquets lus une seule fois (« (capture) » à côté du nom de la carte). La capability « Écoute passive » ne sert qu’à écouter des cartes sans capture (management, trunk).',
  'L’ascolto è spento: configura la cattura dal filo (lo accende da sé) oppure attiva la capability «Ascolto passivo» fra le capability qui sopra.':
    'L’écoute est éteinte : configurez la capture sur le fil (elle l’active d’elle-même) ou activez la capability « Écoute passive » parmi les capabilities ci-dessus.',
  'Con la cattura dal filo configurata sulla sonda (o la capability «Ascolto passivo» accesa, per le schede senza cattura), la finestra mostra anche nome, IP (da ARP, anche per chi ha l’indirizzo statico) e il tipo annunciato in rete (mDNS, DHCP, SSDP, NetBIOS, LLDP: stampante, telefono IP, PC Windows, apparecchio Apple…). Con una credenziale Fingerbank in Integrazioni, «Riconosci con Fingerbank» chiede il dispositivo per gli indirizzi ancora senza nome e salva la risposta nel catalogo CENSO con la classe: un CI «unknown» dietro quel MAC la eredita.':
    'Avec la capture sur le fil configurée sur la sonde (ou la capability « Écoute passive » activée, pour les cartes sans capture), la fenêtre montre aussi le nom, l’IP (par ARP, même pour les adresses statiques) et le type annoncé sur le réseau (mDNS, DHCP, SSDP, NetBIOS, LLDP : imprimante, téléphone IP, PC Windows, appareil Apple…). Avec un identifiant Fingerbank dans Intégrations, « Reconnaître avec Fingerbank » demande l’appareil pour les adresses encore sans nom et enregistre la réponse dans le catalogue CENSO avec la classe : un CI « unknown » derrière ce MAC en hérite.',
  'Il kernel ha scartato {n} pacchetti: la sonda non sta al passo con il traffico e i volumi riportati sono incompleti. Le perdite del kernel, a differenza del campionamento, non si possono correggere: il fattore non si conosce. Il campionamento non le riduce, perché la sonda legge comunque ogni pacchetto: copia meno traffico nello SPAN (solo le VLAN dei dispositivi, non storage e backup) oppure usa una sonda con più core.':
    'Le noyau a rejeté {n} paquets : la sonde ne suit pas le trafic et les volumes rapportés sont incomplets. Les pertes du noyau, contrairement à l’échantillonnage, ne se corrigent pas : le facteur est inconnu. L’échantillonnage ne les réduit pas, car la sonde lit quand même chaque paquet : copiez moins de trafic dans le SPAN (seulement les VLAN des appareils, pas le stockage ni la sauvegarde) ou utilisez une sonde avec plus de cœurs.',
  'anello del kernel · {n} lettori in parallelo':
    'anneau du noyau · {n} lecteurs en parallèle',
  'classica, un pacchetto per chiamata: il kernel non ha concesso l’anello':
    'classique, un paquet par appel : le noyau n’a pas accordé l’anneau',
  'Ingegneria Clinica':
    'Ingénierie biomédicale',
  'stesso modello':
    'même modèle',
  'modello diverso':
    'modèle différent',
  'riconosciuto medicale':
    'reconnu comme médical',
  'tipo generico':
    'type générique',
  'visto, non riconosciuto':
    'vu, non reconnu',
  'non visto':
    'non vu',
  'porta switch':
    'port de switch',
  'ascolto':
    'écoute',
  'Lettura del file…':
    'Lecture du fichier…',
  'Nel file non c’è un foglio con una colonna di MAC o di IP.':
    'Le fichier n’a aucune feuille avec une colonne MAC ou IP.',
  'Importare {n} righe dal foglio «{foglio}» come inventario {fonte}? Sostituisce l’import precedente della stessa fonte.':
    'Importer {n} lignes de la feuille « {foglio} » comme inventaire {fonte} ? Cela remplace l’import précédent de la même source.',
  'Import in corso…':
    'Import en cours…',
  'Importati {n} dispositivi ({s} righe saltate: senza MAC né IP o ripetute). Colonne riconosciute: {c}.':
    '{n} appareils importés ({s} lignes ignorées : sans MAC ni IP, ou répétées). Colonnes reconnues : {c}.',
  'Eliminare l’inventario {fonte} importato? Il catalogo CENSO e ciò che ha già imparato restano.':
    'Supprimer l’inventaire {fonte} importé ? Le catalogue CENSO et ce qu’il a déjà appris restent.',
  'Confronto con un inventario di riferimento':
    'Comparaison avec un inventaire de référence',
  'Importa da Armis, Medigate o dall’Ingegneria Clinica un elenco Excel o CSV con MAC o IP. CENSO verifica per ogni dispositivo se è presente nella rete e se viene riconosciuto, confrontando i dati raccolti da switch, ascolto passivo, CMDB e traffico di rete. I dispositivi identificati contribuiscono inoltre a creare firme utili a riconoscere automaticamente gli stessi modelli.': 'Importez depuis Armis, Medigate ou l’Ingénierie Clinique une liste Excel ou CSV avec des MAC ou des IP. Pour chaque appareil, CENSO vérifie s’il est présent sur le réseau et s’il est reconnu, en comparant les données recueillies auprès des switchs, de l’écoute passive, de la CMDB et du trafic réseau. Les appareils identifiés contribuent en outre à créer des signatures utiles pour reconnaître automatiquement les mêmes modèles.',
  'Importa file':
    'Importer un fichier',
  'Nessun inventario importato.':
    'Aucun inventaire importé.',
  'Nell’inventario':
    'Dans l’inventaire',
  'Visti da CENSO':
    'Vus par CENSO',
  'Riconosciuti':
    'Reconnus',
  '{p} · stesso modello o elettromedicale':
    '{p} · même modèle ou médical',
  'Con lo stesso modello':
    'Avec le même modèle',
  'Non visti':
    'Non vus',
  'Dispositivi':
    'Appareils',
  'Visti':
    'Vus',
  'Stesso modello':
    'Même modèle',
  'Firme da imparare':
    'Signatures à apprendre',
  'Visto da':
    'Vu par',
  'CENSO dice':
    'CENSO dit',
  'prefisso → modello':
    'préfixe → modèle',
  'prefisso → tipo':
    'préfixe → type',
  'impronta DHCP → modello':
    'empreinte DHCP → modèle',
  'Scritte nel catalogo: {p} prefissi, {f} impronte; {a} dispositivi riconosciuti subito dalle impronte.':
    'Écrit dans le catalogue : {p} préfixes, {f} empreintes ; {a} appareils reconnus aussitôt par les empreintes.',
  '{n} proposte, {s} selezionate':
    '{n} propositions, {s} sélectionnées',
  'Impara nel catalogo CENSO':
    'Apprendre dans le catalogue CENSO',
  'Firma':
    'Signature',
  'Insegna':
    'Enseigne',
  'prefisso di {v}':
    'préfixe de {v}',
  'già nel catalogo: {v}':
    'déjà dans le catalogue : {v}',
  'Nessuna firma da proporre.':
    'Aucune signature à proposer.',
  'Dove il prefisso non basta ({n})':
    'Là où le préfixe ne suffit pas ({n})',
  'Tipi e modelli':
    'Types et modèles',
  'PC o server di marca generica: servono altri segnali':
    'PC ou serveur de marque générique : d’autres signaux sont nécessaires',
  'tipi o modelli diversi con la stessa firma':
    'types ou modèles différents avec la même signature',
  'Non è un file Excel (.xlsx) valido: salvalo di nuovo da Excel, oppure come CSV.':
    'Ce n’est pas un fichier Excel (.xlsx) valide : enregistrez-le à nouveau depuis Excel, ou en CSV.',
  'Compressione del file Excel non supportata ({m}): salvalo come CSV.':
    'Compression du fichier Excel non prise en charge ({m}) : enregistrez-le en CSV.',
  'Questo browser non sa aprire i file Excel: salva il file come CSV.':
    'Ce navigateur ne sait pas ouvrir les fichiers Excel : enregistrez le fichier en CSV.',
  'La sonda ne guarda al massimo {tetto} per job: la scansione si divide da sé in {k} job, uno per parte, che le sonde eseguono come gli altri.':
    'La sonde en traite au plus {tetto} par job : le scan se divise de lui-même en {k} jobs, un par partie, que les sondes exécutent comme les autres.',
  'Una scansione di rete guarda al massimo {max} indirizzi per job: con questo pool si divide da sé in {k} job, uno per parte.':
    'Un scan réseau traite au plus {max} adresses par job : avec ce pool, il se divise de lui-même en {k} jobs, un par partie.',
  '{k} job':
    '{k} jobs',
  'Gli access point gestiti, gli SSID diffusi e i client associati: da un controller con l’inventario avanzato apparati (via SSH), o dall’access point stesso con il driver SNMP (Aerohive / Extreme). I client si contano anche fra i dispositivi di Traffic Analysis.':
    'Les points d’accès gérés, les SSID diffusés et les clients associés : depuis un contrôleur avec l’inventaire avancé des équipements (via SSH), ou depuis le point d’accès lui-même avec le driver SNMP (Aerohive / Extreme). Les clients sont aussi comptés parmi les appareils de Traffic Analysis.',
  'Client Wi-Fi (dagli access point)':
    'Clients Wi-Fi (depuis les points d’accès)',
  'Anche gli access point Aerohive / Extreme (IQ Engine) hanno la sezione Wireless sulla propria scheda: con la scansione SNMP il driver legge modello, seriale, firmware, CPU e memoria, gli SSID di ogni radio e i client associati con nome, indirizzo, SSID e VLAN. I client entrano anche fra i dispositivi di Traffic Analysis (fonte «Client Wi-Fi»), quindi un elettromedicale in Wi-Fi risulta visto.':
    'Les points d’accès Aerohive / Extreme (IQ Engine) ont aussi la section Sans fil sur leur propre fiche : avec le scan SNMP, le driver lit modèle, numéro de série, firmware, CPU et mémoire, les SSID de chaque radio et les clients associés avec nom, adresse, SSID et VLAN. Les clients rejoignent aussi les appareils de Traffic Analysis (source « Clients Wi-Fi »), donc un appareil médical en Wi-Fi est compté comme vu.',
  'Riconosciuti dal prodotto':
    'Reconnus par le produit',
  'dal nome con cui il dispositivo si presenta':
    'par le nom sous lequel l’appareil se présente',
  'riconosciuto da «{e}»':
    'reconnu par « {e} »',
  'nome del prodotto → modello':
    'nom du produit → modèle',
  'da inventario di riferimento':
    'd’un inventaire de référence',
  'Conoscenza dispositivi':
    'Connaissance des appareils',
  'Firme imparate dagli inventari di riferimento di tutti i clienti: nome del prodotto, impronte DHCP, prefissi':
    'Signatures apprises des inventaires de référence de tous les clients : nom du produit, empreintes DHCP, préfixes',
  'Proposte da tutti gli ospedali ({n})':
    'Propositions de tous les hôpitaux ({n})',
  'Impara le selezionate':
    'Apprendre la sélection',
  'Tenant con un inventario: {n}.':
    'Tenants avec un inventaire : {n}.',
  'Nessuna proposta':
    'Aucune proposition',
  'Importa un inventario di riferimento in un tenant (Traffic Analysis).':
    'Importez un inventaire de référence dans un tenant (Traffic Analysis).',
  'Ospedali':
    'Hôpitaux',
  'in disaccordo':
    'en désaccord',
  'Il numero «Riconosciuti dal prodotto» conta i dispositivi riconosciuti dal nome con cui si presentano (nome DHCP o NetBIOS, nome del CI, modello mDNS, certificato): molti elettromedicali hanno un MAC di scheda generica, e il nome del prodotto (EarlyVue VS30, PIC iX, MiSeq, Alinity…) è ciò che li distingue. CENSO conosce di suo le principali linee di prodotto medicali, e impara dagli inventari di riferimento di tutti gli ospedali i nomi che ancora non conosce.':
    'Le nombre « Reconnus par le produit » compte les appareils reconnus par le nom sous lequel ils se présentent (nom DHCP ou NetBIOS, nom du CI, modèle mDNS, certificat) : beaucoup d’appareils médicaux ont un MAC de carte générique, et le nom du produit (EarlyVue VS30, PIC iX, MiSeq, Alinity…) est ce qui les distingue. CENSO connaît de lui-même les principales gammes de produits médicaux, et apprend des inventaires de référence de tous les hôpitaux les noms qu’il ne connaît pas encore.',
  'nome locale':
    'nom local',
  'Inventario passivo':
    'Inventaire passif',
  'Rileva e registra come CI i dispositivi riconosciuti passivamente, senza contattarli o sottoporli a scansione. Utilizza le informazioni raccolte da switch, traffico di rete, DHCP, firewall e identificazione del prodotto per determinarne costruttore, modello, IP, VLAN, switch e porta. Il rilevamento viene aggiornato ogni ora o su richiesta con «Esegui adesso». I CI già presenti da una scansione non vengono modificati; quelli non più rilevati seguono il normale ciclo di vita dei CI.': 'Détecte et enregistre comme CI les appareils reconnus passivement, sans les contacter ni les analyser. Il utilise les informations recueillies auprès des switchs, du trafic réseau, du DHCP, des pare-feu et de l’identification produit pour déterminer leur fabricant, modèle, IP, VLAN, switch et port. La détection est actualisée chaque heure ou à la demande avec «Esegui adesso». Les CI déjà présents issus d’une analyse ne sont pas modifiés ; ceux qui ne sont plus détectés suivent le cycle de vie normal des CI.',
  'Cosa registrare':
    'Quoi enregistrer',
  'Solo gli elettromedicali':
    'Seulement les appareils médicaux',
  'Tutti i dispositivi riconosciuti':
    'Tous les appareils reconnus',
  'Spento':
    'Désactivé',
  'Visti negli ultimi giorni':
    'Vus ces derniers jours',
  'Esegui adesso':
    'Exécuter maintenant',
  '{p} dispositivi registrati o aggiornati come CI su {c} idonei; {k} già nel CMDB da una scansione, lasciati com’erano.':
    '{p} appareils enregistrés ou mis à jour comme CI sur {c} éligibles ; {k} déjà dans la CMDB par un scan, laissés tels quels.',
  'Ultimo giro: {q} · {p} registrati o aggiornati, {c} idonei, {k} già nel CMDB.':
    'Dernier passage : {q} · {p} enregistrés ou mis à jour, {c} éligibles, {k} déjà dans la CMDB.',
  'Gli elettromedicali non si scansionano: la card «Inventario passivo» li registra come CI senza contattarli, dai dati che CENSO già raccoglie (porte degli switch, ascolto, agente DHCP, firewall, nome del prodotto), ogni ora o con «Esegui adesso». Si sceglie se registrare solo gli elettromedicali (predefinito) o tutti i dispositivi riconosciuti, e da quanti giorni devono essere stati visti. Un dispositivo già nel CMDB da una scansione resta com’è.':
    'Les appareils médicaux ne se scannent pas : la carte « Inventaire passif » les enregistre comme CI sans les contacter, à partir des données que CENSO collecte déjà (ports des switchs, écoute, agent DHCP, pare-feu, nom du produit), toutes les heures ou avec « Exécuter maintenant ». On choisit d’enregistrer seulement les appareils médicaux (par défaut) ou tous les appareils reconnus, et depuis combien de jours ils doivent avoir été vus. Un appareil déjà dans la CMDB par un scan reste tel quel.',
  'CENSO MED':
    'CENSO MED',
  'Avvisi di sicurezza per i dispositivi medici':
    'Avis de sécurité pour les dispositifs médicaux',
  'Aggiorna ora':
    'Actualiser maintenant',
  'Gli avvisi CISA ICS Medical (ICSMA), scaricati ogni notte dal feed CSAF pubblico di CISA: per ogni prodotto CVE, gravità, versioni interessate e rimedio, con il segno «sfruttata attivamente (CISA KEV)» dal catalogo KEV. Si abbinano ai CI elettromedicali dei tenant con CENSO MED per costruttore e famiglia di prodotto; la versione del firmware va verificata.':
    'Les avis CISA ICS Medical (ICSMA), téléchargés chaque nuit depuis le flux CSAF public de la CISA : pour chaque produit CVE, gravité, versions concernées et remède, avec l’indication « activement exploitée (CISA KEV) » du catalogue KEV. Ils sont associés aux CI médicaux des tenants avec CENSO MED par fabricant et famille de produits ; la version du firmware est à vérifier.',
  'In catalogo: {a} avvisi, {p} prodotti; ultimo aggiornamento {q}.':
    'Au catalogue : {a} avis, {p} produits ; dernière mise à jour {q}.',
  'Tutte le funzioni per gli elettromedicali (riconoscimento dal prodotto, inventario passivo, confronto con gli inventari di riferimento, vulnerabilità dagli avvisi CISA per i dispositivi medici) sono la licenza CENSO MED: senza, al loro posto compare una riga che lo spiega. Le vulnerabilità arrivano fra i rischi di sicurezza dei CI elettromedicali, con «versione da verificare» quando la versione del firmware non è nota.':
    'Toutes les fonctions pour les appareils médicaux (reconnaissance par le produit, inventaire passif, comparaison avec les inventaires de référence, vulnérabilités issues des avis CISA pour les dispositifs médicaux) sont la licence CENSO MED : sans elle, une ligne l’explique à leur place. Les vulnérabilités apparaissent parmi les constats de sécurité des CI médicaux, avec « version à vérifier » quand la version du firmware n’est pas connue.',
  'Connesso su':
    'Connecté sur',
  'porta {p}':
    'port {p}',
  'dalla tabella MAC dello switch':
    'depuis la table MAC du switch',
  'ARP dei router (SNMP)':
    'ARP des routeurs (SNMP)',
  'Come li scrive l’inventario di riferimento':
    'Tels que les écrit l’inventaire de référence',
  'MAC / IP dell’inventario':
    'MAC / IP de l’inventaire',
  'Con la stessa opzione, sugli apparati che instradano (core, switch di livello 3, router) la scansione legge anche la tabella ARP: dà l’IP di ogni dispositivo delle VLAN instradate, anche di quelli che stanno solo sulla porta di uno switch e non si annunciano (fonte «ARP dei router»).':
    'Avec la même option, sur les équipements qui routent (cœur, switchs de niveau 3, routeurs), le scan lit aussi la table ARP : elle donne l’IP de chaque appareil des VLAN routés, y compris ceux qui sont seulement sur un port de switch et ne s’annoncent pas (source « ARP des routeurs »).',
  'Base di riconoscimento ({n})':
    'Base de reconnaissance ({n})',
  'Coperti dalle proposte':
    'Couverts par les propositions',
  'Copertura senza fonti esterne':
    'Couverture sans sources externes',
  'Cosa c’è dietro':
    'Ce qu’il y a derrière',
  'Imparare {n} firme? Quelle globali valgono subito in tutti i tenant, le altre solo negli ospedali che le hanno insegnate. Verifica che i contratti con i fornitori degli inventari consentano di usarne le classificazioni.':
    'Apprendre {n} signatures ? Les globales s’appliquent tout de suite dans tous les tenants, les autres seulement dans les hôpitaux qui les ont enseignées. Vérifiez que les contrats avec les fournisseurs des inventaires permettent d’utiliser leurs classifications.',
  'Informatici':
    'Informatiques',
  'Nessun caso ambiguo':
    'Aucun cas ambigu',
  'Nessun inventario di riferimento':
    'Aucun inventaire de référence',
  'Ospedale':
    'Hôpital',
  'Per ogni elettromedicale degli inventari di riferimento: CENSO lo ritroverebbe da solo, con la sua base di riconoscimento e senza Armis, Medigate o file? L’inventario serve solo da metro: ciò che CENSO dice viene dalle sue osservazioni (porte degli switch, ascolto, CMDB, filo).':
    'Pour chaque dispositif médical des inventaires de référence : CENSO le retrouverait-il seul, avec sa base de reconnaissance et sans Armis, Medigate ni fichiers ? L’inventaire ne sert que d’étalon : ce que dit CENSO vient de ses propres observations (ports des commutateurs, écoute, CMDB, fil).',
  'Per tipo: {v}.':
    'Par type : {v}.',
  'Riconosciuti da CENSO':
    'Reconnus par CENSO',
  'Senza segnali':
    'Sans signaux',
  'Togliere questa voce? Smette subito di riconoscere {s}.':
    'Retirer cette entrée ? Elle cesse aussitôt de reconnaître {s}.',
  'Un’unica base per riconoscere i dispositivi in ogni tenant: prefissi MAC, impronte DHCP, nomi di prodotto imparati, regole di prodotto e porte degli annunci in rete. Una voce vale in tutti i tenant, oppure solo nell’ospedale indicato; a parità di firma vince quella dell’ospedale. Modifiche ed eliminazioni valgono entro un minuto.':
    'Une base unique pour reconnaître les dispositifs dans chaque tenant : préfixes MAC, empreintes DHCP, noms de produit appris, règles de produit et ports des annonces réseau. Une entrée vaut dans tous les tenants, ou seulement dans l’hôpital indiqué ; à signature égale, celle de l’hôpital l’emporte. Modifications et suppressions s’appliquent en une minute.',
  'di CENSO':
    'de CENSO',
  'già nella base: {v}':
    'déjà dans la base : {v}',
  'impronta DHCP':
    'empreinte DHCP',
  'in tutti i tenant':
    'dans tous les tenants',
  'in {h}':
    'dans {h}',
  'informatica generica':
    'informatique générique',
  'nome dato dall’ospedale, non dal costruttore':
    'nom donné par l’hôpital, pas par le fabricant',
  'nome imparato':
    'nom appris',
  'prefisso MAC':
    'préfixe MAC',
  'regola di prodotto':
    'règle de produit',
  'solo':
    'seulement',
  'solo elettromedicali':
    'dispositifs médicaux seulement',
  'tipi diversi':
    'types différents',
  'tutti i tenant':
    'tous les tenants',
  'un solo ospedale':
    'un seul hôpital',
  '{d} dispositivi, {h} ospedali':
    '{d} dispositifs, {h} hôpitaux',
  '«Coperti dalle proposte»: diventano riconosciuti imparando le proposte qui sotto. «Informatici»: postazioni e server, si riconoscono con la scansione o l’agente, mai dal prefisso. «Senza segnali»: CENSO li vede ma nulla di ciò che raccoglie dice cosa sono. «Non visti»: lì manca una sonda o una porta in SPAN.':
    '« Couverts par les propositions » : ils deviennent reconnus en apprenant les propositions ci-dessous. « Informatiques » : postes et serveurs, reconnus par le scan ou l’agent, jamais par le préfixe. « Sans signaux » : CENSO les voit mais rien de ce qu’il collecte ne dit ce qu’ils sont. « Non vus » : il y manque une sonde ou un port en SPAN.',
  'Le firme le scrive nella base di riconoscimento l’amministrazione della piattaforma, perché la base è condivisa fra i tenant.':
    'Les signatures sont écrites dans la base de reconnaissance par l’administration de la plateforme, car la base est partagée entre les tenants.',
  'si impara solo per questo ospedale':
    'appris seulement pour cet hôpital',
  'Annunci in broadcast/multicast (sonda)':
    'Annonces broadcast/multicast (sonde)',
  'annuncio in rete → modello':
    'annonce réseau → modèle',
  'annuncio in rete':
    'annonce réseau',
  'Molti elettromedicali si annunciano sulla rete con un protocollo del costruttore, in broadcast o multicast: un monitor che cerca la sua centrale, una pompa che cerca il suo server. La sonda che ascolta la VLAN li sente anche senza porta mirror e ne tiene la porta UDP e i nomi di prodotto in chiaro; il resto del contenuto non si conserva. La porta è una firma: CENSO conosce di suo quella dei monitor Philips IntelliVue e impara le altre dagli inventari di riferimento («annuncio in rete → modello»).':
    'Beaucoup de dispositifs médicaux s’annoncent sur le réseau avec un protocole du fabricant, en broadcast ou multicast : un moniteur qui cherche sa centrale, une pompe qui cherche son serveur. La sonde qui écoute le VLAN les entend même sans port miroir et en garde le port UDP et les noms de produit en clair ; le reste du contenu n’est pas conservé. Le port est une signature : CENSO connaît de lui-même celui des moniteurs Philips IntelliVue et apprend les autres des inventaires de référence (« annonce réseau → modèle »).',
  'Carica MIB':
    'Charger des MIB',
  'Caricati {n} MIB.':
    '{n} MIB chargés.',
  'Caricati {n} MIB; non letti: {s}.':
    '{n} MIB chargés ; non lus : {s}.',
  'Caricato':
    'Chargé',
  'Carico {f}…':
    'Chargement de {f}…',
  'Da caricare: {m}.':
    'À charger : {m}.',
  'Dai MIB dei costruttori CENSO prende solo le registrazioni di prodotto: un OID per modello, quello che l’apparato dichiara in sysObjectID. Riconoscono subito gli apparati di questo tenant e vengono proposte all’amministrazione della piattaforma per tutti i tenant. Commenti e descrizioni si tolgono prima dell’invio; del file si conservano solo le definizioni degli OID. Si scaricano dal portale di supporto del costruttore: servono i MIB «…-PRODUCTS-MIB» o «…-SMI» e quello che li importa.':
    'Des MIB des fabricants, CENSO ne prend que les enregistrements de produit : un OID par modèle, celui que l’équipement déclare dans sysObjectID. Ils reconnaissent tout de suite les équipements de ce tenant et sont proposés à l’administration de la plateforme pour tous les tenants. Commentaires et descriptions sont retirés avant l’envoi ; du fichier on ne garde que les définitions des OID. Téléchargez-les depuis le portail de support du fabricant : il faut les MIB « …-PRODUCTS-MIB » ou « …-SMI » et celui qu’ils importent.',
  'Impara tutte quelle nuove':
    'Apprendre toutes les nouvelles',
  'Le registrazioni di prodotto (sysObjectID → modello) dei MIB che i tenant caricano nella pagina Rete. Valgono subito nel tenant che le ha caricate; imparandole valgono in tutti. Elencate le nuove che danno già il modello ad apparati in CMDB.':
    'Les enregistrements de produit (sysObjectID → modèle) des MIB que les tenants chargent dans la page Réseau. Ils valent tout de suite dans le tenant qui les a chargés ; en les apprenant ils valent partout. Listés : les nouveaux qui nomment déjà des équipements de la CMDB.',
  'MIB caricati dai tenant ({n})':
    'MIB chargés par les tenants ({n})',
  'MIB di prodotto ({n})':
    'MIB de produit ({n})',
  'Modelli riconoscibili dai MIB caricati: {n}.':
    'Modèles reconnaissables grâce aux MIB chargés : {n}.',
  'OID':
    'OID',
  'Registrazioni: {r}; già globali {e}, nuove {n}, in disaccordo {c}, con apparati visti {d}.':
    'Enregistrements : {r} ; déjà globaux {e}, nouveaux {n}, en désaccord {c}, avec équipements vus {d}.',
  'Rendere globali tutte le registrazioni nuove su cui i MIB dei tenant concordano?':
    'Rendre globaux tous les nouveaux enregistrements sur lesquels les MIB des tenants s’accordent ?',
  'Rese globali {n} registrazioni.':
    '{n} enregistrements rendus globaux.',
  'Scegli i file MIB':
    'Choisir les fichiers MIB',
  'Togliere il MIB {m}? I modelli che dava non si riconoscono più in questo tenant.':
    'Retirer le MIB {m} ? Les modèles qu’il donnait ne sont plus reconnus dans ce tenant.',
  'identità SNMP (MIB)':
    'identité SNMP (MIB)',
  'modulo ignoto':
    'module inconnu',
  '{n} definizioni restano senza OID perché manca il MIB che definisce il loro nodo padre.':
    '{n} définitions restent sans OID car il manque le MIB qui définit leur nœud parent.',
  'Sotto gli apparati, «MIB di prodotto» carica i MIB dei costruttori (amministratori del tenant): CENSO ne tiene solo le registrazioni di prodotto, un OID per modello, e da lì il modello degli apparati che dichiarano quell’identità in SNMP si ricava subito, anche per marche mai viste. La card dice quali MIB mancano ancora per risolvere il resto; le registrazioni vengono proposte all’amministrazione della piattaforma per valere in tutti i tenant.':
    'Sous les équipements, « MIB de produit » charge les MIB des fabricants (administrateurs du tenant) : CENSO n’en garde que les enregistrements de produit, un OID par modèle, et de là le modèle des équipements qui déclarent cette identité en SNMP se déduit tout de suite, même pour des marques jamais vues. La carte dit quels MIB manquent encore pour résoudre le reste ; les enregistrements sont proposés à l’administration de la plateforme pour valoir dans tous les tenants.',
  'Approvare il driver? Arriva a tutte le sonde entro pochi minuti.':
    'Approuver le driver ? Il arrive sur toutes les sondes en quelques minutes.',
  'Con i MIB del costruttore caricati nella pagina Rete, CENSO genera dalla cattura una bozza di driver con i nomi veri: tabelle, stati decodificati, numero di serie e versione, CPU e memoria per Eagle. La approva l’amministrazione della piattaforma, poi vale su tutte le sonde.':
    'Avec les MIB du fabricant chargés dans la page Réseau, CENSO génère à partir de la capture un brouillon de driver avec les vrais noms : tables, états décodés, numéro de série et version, CPU et mémoire pour Eagle. L’administration de la plateforme l’approuve, puis il vaut sur toutes les sondes.',
  'Driver':
    'Driver',
  'Driver SNMP ({n})':
    'Drivers SNMP ({n})',
  'Eliminare il driver?':
    'Supprimer le driver ?',
  'Genera bozza di driver':
    'Générer un brouillon de driver',
  'Il JSON del driver non è valido.':
    'Le JSON du driver n’est pas valide.',
  'JSON del driver':
    'JSON du driver',
  'Le bozze che i tenant generano da un campionamento SNMP con i MIB del costruttore. Controlla il resoconto e il JSON (nomi, ampiezza del match), poi approva: il driver arriva a tutte le sonde, per la discovery e per le metriche di Eagle, senza aggiornarle. Un driver non contiene codice, solo OID e nomi di attributo.':
    'Les brouillons que les tenants génèrent à partir d’un échantillonnage SNMP avec les MIB du fabricant. Vérifiez le compte rendu et le JSON (noms, étendue du match), puis approuvez : le driver arrive sur toutes les sondes, pour la découverte et pour les métriques d’Eagle, sans les mettre à jour. Un driver ne contient pas de code, seulement des OID et des noms d’attribut.',
  'Nessun driver':
    'Aucun driver',
  'Rigenera la bozza di driver':
    'Régénérer le brouillon de driver',
  'Salva il JSON':
    'Enregistrer le JSON',
  'Si generano dal rapporto di un job di campionamento SNMP.':
    'Ils se génèrent depuis le rapport d’un job d’échantillonnage SNMP.',
  'approvato':
    'approuvé',
  'approvato da {a}':
    'approuvé par {a}',
  'approvato: in uso su tutte le sonde':
    'approuvé : utilisé sur toutes les sondes',
  'bozza':
    'brouillon',
  'disattivato':
    'désactivé',
  'in attesa di approvazione dall’amministrazione della piattaforma':
    'en attente d’approbation par l’administration de la plateforme',
  'Con gli stessi MIB, il rapporto di un job di campionamento SNMP genera una bozza di driver: tabelle con i nomi veri, stati decodificati, numero di serie e versione, CPU e memoria per Eagle. L’amministrazione della piattaforma la controlla e la approva; da lì il driver arriva a tutte le sonde senza aggiornarle.':
    'Avec les mêmes MIB, le rapport d’un job d’échantillonnage SNMP génère un brouillon de driver : tables avec les vrais noms, états décodés, numéro de série et version, CPU et mémoire pour Eagle. L’administration de la plateforme le vérifie et l’approuve ; dès lors le driver arrive sur toutes les sondes sans les mettre à jour.',
  'Alias e CNAME identificano i nomi DNS alternativi associati all’oggetto, utilizzabili per la risoluzione e l’accesso oltre al nome DNS principale.':
    'Les alias et CNAME identifient les noms DNS alternatifs associés à l’objet, utilisables pour la résolution et l’accès en plus du nom DNS principal.',
  'Apparati di rete, porte e collegamenti':
    'Équipements réseau, ports et liaisons',
  'Apparati raggiungibili e presenti nel CMDB di cui non tutte le informazioni necessarie sono state rilevate. Gli apparati della stessa serie sono raggruppati in una riga.':
    'Équipements joignables et présents dans la CMDB dont toutes les informations nécessaires n’ont pas été relevées. Les équipements d’une même série sont regroupés sur une ligne.',
  'Da usare per rimuovere record errati, duplicati o relativi ad asset di test; se l’asset è ancora rilevabile in rete, verrà acquisito nuovamente alla scansione successiva.':
    'À utiliser pour supprimer des enregistrements erronés, en double ou de test ; si l’actif est encore détectable sur le réseau, il sera de nouveau acquis au prochain scan.',
  'Descrive le relazioni tra CI, incluse adiacenze di rete, virtualizzazione e dipendenze rilevate.':
    'Décrit les relations entre CI, y compris les adjacences réseau, la virtualisation et les dépendances détectées.',
  'Dettaglio rischio':
    'Détail du risque',
  'Dettaglio rischio ({n})':
    'Détail du risque ({n})',
  "Dismette definitivamente l'asset. Il CI e il relativo storico rimangono nel CMDB.":
    'Retire définitivement l’actif. Le CI et son historique restent dans la CMDB.',
  'Filtra i CI non visti da 7 giorni':
    'Filtrer les CI non vus depuis 7 jours',
  'Gestisce contratti di manutenzione, supporto, noleggio e licenza, associandoli agli asset coperti per garantirne la continuità indipendentemente dal CI.':
    'Gère les contrats de maintenance, support, location et licence, en les associant aux actifs couverts pour en garantir la continuité indépendamment du CI.',
  'Gli asset con contratto cessato o copertura scaduta sono considerati non coperti.':
    'Les actifs dont le contrat a pris fin ou dont la couverture a expiré sont considérés comme non couverts.',
  'Gli indirizzi attraverso cui l’asset è raggiungibile da Internet: NAT, VIP o indirizzo della sede. Ogni indirizzo è gestito come un CI distinto e può essere condiviso da più asset. La verifica ne controlla la reputazione nelle liste di abuso.':
    'Les adresses par lesquelles l’actif est joignable depuis Internet : NAT, VIP ou adresse du site. Chaque adresse est gérée comme un CI distinct et peut être partagée par plusieurs actifs. La vérification contrôle sa réputation dans les listes d’abus.',
  'Indica la fonte di ciascun attributo del CI, gestendo le priorità in caso di dati provenienti da fonti diverse o discordanti.':
    'Indique la source de chaque attribut du CI, en gérant les priorités quand les données viennent de sources différentes ou discordantes.',
  'Indica le fonti che hanno rilevato il CI e il numero di attributi attualmente gestiti da ciascuna fonte, evidenziandone il livello di conoscenza.':
    'Indique les sources qui ont détecté le CI et le nombre d’attributs actuellement gérés par chaque source, en mettant en évidence leur niveau de connaissance.',
  "La classe del dispositivo viene rilevata in automatico. Se non è corretta, scegli quella giusta nel menu Classe: la scelta resta anche nelle scansioni successive, finché non si torna all'automatico.":
    'La classe de l’équipement est détectée automatiquement. Si elle est incorrecte, choisissez la bonne dans le menu Classe : le choix reste aussi lors des scans suivants, jusqu’au retour à l’automatique.',
  'La mappa rappresenta la topologia di rete; {n} collegamenti di traffico nascosti sono visualizzabili selezionando un asset o la vista {dipendenze}.':
    'La carte représente la topologie du réseau ; {n} liaisons de trafic masquées sont visibles en sélectionnant un actif ou la vue {dipendenze}.',
  'La mappa visualizza un sottoinsieme delle relazioni rilevate: i {n} collegamenti più osservati su {totale}, {nascosti} collegamenti di traffico nascosti. Applica i filtri per tipologia di relazione, seleziona «Dipendenze» o un nodo per analizzarne la topologia locale.':
    'La carte affiche un sous-ensemble des relations détectées : les {n} liaisons les plus observées sur {totale}, {nascosti} liaisons de trafic masquées. Appliquez les filtres par type de relation, sélectionnez « Dépendances » ou un nœud pour en analyser la topologie locale.',
  'La mappa visualizza un sottoinsieme delle relazioni rilevate: i {n} collegamenti più osservati su {totale}. Applica i filtri per tipologia di relazione, seleziona «Dipendenze» o un nodo per analizzarne la topologia locale.':
    'La carte affiche un sous-ensemble des relations détectées : les {n} liaisons les plus observées sur {totale}. Appliquez les filtres par type de relation, sélectionnez « Dépendances » ou un nœud pour en analyser la topologie locale.',
  'La tabella di routing L3 dell’asset viene acquisita via SNMP e popolata tramite una discovery SNMP con l’opzione «Tabelle di routing» abilitata.':
    'La table de routage L3 de l’actif est acquise via SNMP et remplie par une découverte SNMP avec l’option « Tables de routage » activée.',
  'Nessun MIB di prodotto importato: il sistema non può ricavare il modello dall’OID che l’apparato dichiara in {campo}. Scaricali dal portale di supporto del costruttore e caricali qui sotto, in «MIB di prodotto».':
    'Aucun MIB de produit importé : le système ne peut pas déduire le modèle de l’OID que l’équipement déclare dans {campo}. Téléchargez-les depuis le portail de support du fabricant et chargez-les ci-dessous, dans « MIB de produit ».',
  'Nessun contratto da esportare':
    'Aucun contrat à exporter',
  'Nessun elemento di sicurezza rilevato. L’ultima valutazione è ancora valida: per aggiornarla con i dati attuali dell’inventario, premi «Esegui valutazione».':
    'Aucun élément de sécurité relevé. La dernière évaluation est toujours valable : pour la mettre à jour avec les données actuelles de l’inventaire, appuyez sur « Lancer l’évaluation ».',
  'Porte up':
    'Ports up',
  'Raccoglie gli asset posseduti e amministrati, integrando i dati della discovery con informazioni gestionali non rilevabili dalla rete, come proprietà, costi e contratti.':
    'Rassemble les actifs possédés et administrés, en complétant les données de la découverte par des informations de gestion non détectables par le réseau, comme la propriété, les coûts et les contrats.',
  'Registra l’asset come bene per integrarlo con le informazioni amministrative e contabili non rilevabili dalla rete: proprietà, costo, centro di costo e contratto associato.':
    'Enregistre l’actif comme bien pour le compléter par les informations administratives et comptables non détectables par le réseau : propriété, coût, centre de coût et contrat associé.',
  'Registra un CI come asset dalla relativa scheda oppure modifica i filtri per ampliare i risultati.':
    'Enregistrez un CI comme actif depuis sa fiche ou modifiez les filtres pour élargir les résultats.',
  'Registra un contratto per monitorare scadenze, asset coperti e costi.':
    'Enregistrez un contrat pour suivre les échéances, les actifs couverts et les coûts.',
  'Salva filtri e posizioni dei nodi in una vista condivisa con tutti gli utenti del tenant autorizzati.':
    'Enregistre les filtres et les positions des nœuds dans une vue partagée avec tous les utilisateurs autorisés du tenant.',
  '{n} CI non ancora registrati come asset. Dalla {scheda} se ne consente la registrazione, precompilando i dati già acquisiti dalla discovery (matricola, costruttore, modello e collocazione).':
    '{n} CI pas encore enregistrés comme actifs. Depuis la {scheda} on peut les enregistrer, avec les données déjà acquises par la découverte préremplies (numéro de série, fabricant, modèle et emplacement).',
  '«Indirizzo aggiuntivo»: un indirizzo di un apparato oltre quello di gestione, come le interfacce VLAN, le loopback e i VIP. «IP pubblico»: un indirizzo con cui un asset è raggiungibile da Internet.':
    '« Adresse supplémentaire » : une adresse d’un équipement en plus de celle de gestion, comme les interfaces VLAN, les loopbacks et les VIP. « IP publique » : une adresse par laquelle un actif est joignable depuis Internet.',
  '«Segnalato» indica la presenza di un rischio associato all’indirizzo. «Non verificabile» indica che la verifica non ha prodotto un risultato. Gli indirizzi non più associati ad alcun CI vengono rimossi dall’inventario.':
    '« Signalé » indique la présence d’un risque associé à l’adresse. « Non vérifiable » indique que la vérification n’a pas produit de résultat. Les adresses qui ne sont plus associées à aucun CI sont retirées de l’inventaire.',
  'Solo i CI non visti da {n} giorni, esclusi i dismessi.':
    'Seulement les CI non vus depuis {n} jours, hors CI retirés.',
  'Solo i CI non ancora registrati come asset.':
    'Seulement les CI pas encore enregistrés comme actifs.',
  'Mostra le porte con un vicino':
    'Afficher les ports avec un voisin',
  'Mostra tutte le porte':
    'Afficher tous les ports',
  'Porte di {nome} con un vicino':
    'Ports de {nome} avec un voisin',
  'Porte di {nome} ({su}/{totale} up)':
    'Ports de {nome} ({su}/{totale} up)',
  'Anche l’infrastruttura (host, cluster, datastore, rete, storage) eredita la criticità dei servizi che sostiene. Vale per tutti i servizi del tenant.':
    'L’infrastructure aussi (hôtes, clusters, datastores, réseau, stockage) hérite de la criticité des services qu’elle soutient. Vaut pour tous les services du tenant.',
  'Business service ({n})':
    'Services métier ({n})',
  'Criticità ereditata':
    'Criticité héritée',
  'Da quando':
    'Depuis',
  'Dipendenze ({n})':
    'Dépendances ({n})',
  'Dipendenze ricalcolate: {n} ({a} nuove, {r} uscite).':
    'Dépendances recalculées : {n} ({a} nouvelles, {r} sorties).',
  'I CI che compongono il servizio, salvati dalla composizione ogni ora: ingressi, componenti della catena delle chiamate e l’infrastruttura sotto. Ogni CI li vede nella sua sezione «Business service» e ne eredita la criticità.':
    'Les CI qui composent le service, enregistrés depuis la composition chaque heure : entrées, composants de la chaîne d’appels et l’infrastructure dessous. Chaque CI les voit dans sa section « Services métier » et en hérite la criticité.',
  'I servizi di business di cui questo CI fa parte, ricavati dalla composizione di ciascun servizio (ingressi, catena delle chiamate, infrastruttura sotto) e aggiornati ogni ora.':
    'Les services métier dont ce CI fait partie, déduits de la composition de chaque service (entrées, chaîne d’appels, infrastructure dessous) et mis à jour chaque heure.',
  'Il CI eredita la criticità più alta fra i servizi di cui è ingresso o componente; come infrastruttura li sostiene senza ereditarla, perché è condivisa da molti servizi.':
    'Le CI hérite de la criticité la plus élevée parmi les services dont il est entrée ou composant ; en tant qu’infrastructure il les soutient sans en hériter, car elle est partagée par de nombreux services.',
  'Il CI eredita la criticità più alta fra i suoi servizi, anche come infrastruttura.':
    'Le CI hérite de la criticité la plus élevée parmi ses services, y compris en tant qu’infrastructure.',
  'Metti il tag a tutte quelle elencate ({n})':
    'Mettre le tag à toutes celles listées ({n})',
  'Metti il tag alle {n} scelte':
    'Mettre le tag aux {n} choisies',
  'Nessuna dipendenza salvata':
    'Aucune dépendance enregistrée',
  'Porte, processo':
    'Ports, processus',
  'Ricalcola ora':
    'Recalculer maintenant',
  'Si calcolano entro un’ora dalla creazione del servizio, oppure subito con «Ricalcola ora».':
    'Elles se calculent dans l’heure suivant la création du service, ou tout de suite avec « Recalculer maintenant ».',
  'Tag da mettere':
    'Tags à mettre',
  'Tag messi su {n} dipendenze ({a} nuove assegnazioni).':
    'Tags mis sur {n} dépendances ({a} nouvelles affectations).',
  'Ultimo calcolo: {q}.':
    'Dernier calcul : {q}.',
  'chiave:valore, separati da virgola':
    'clé:valeur, séparés par une virgule',
  'componente':
    'composant',
  'infrastruttura':
    'infrastructure',
  'ingresso':
    'entrée',
  'livello {n}':
    'niveau {n}',
  'non ereditata':
    'non héritée',
  'processo non noto':
    'processus inconnu',
  'Ogni ora CENSO salva le dipendenze di ciascun servizio (ingressi, componenti della catena delle chiamate, infrastruttura sotto): nella pagina del servizio la card «Dipendenze» le elenca, le ricalcola subito con «Ricalcola ora» e mette un tag a tutte o a quelle scelte. Ogni CI che ne fa parte ha la sezione «Business service» nella sua scheda, con il ruolo, le porte su cui viene chiamato, il processo in ascolto (se c’è l’inventario avanzato) e la criticità che eredita: la più alta fra i servizi di cui è ingresso o componente. L’infrastruttura condivisa li sostiene senza ereditarla, salvo attivarlo nella stessa card. Nell’elenco dei CI la criticità ereditata è un filtro e una colonna.':
    'Chaque heure CENSO enregistre les dépendances de chaque service (entrées, composants de la chaîne d’appels, infrastructure dessous) : sur la page du service la carte « Dépendances » les liste, les recalcule tout de suite avec « Recalculer maintenant » et met un tag à toutes ou à celles choisies. Chaque CI qui en fait partie a la section « Services métier » sur sa fiche, avec le rôle, les ports sur lesquels il est appelé, le processus en écoute (s’il y a l’inventaire avancé) et la criticité qu’il hérite : la plus élevée parmi les services dont il est entrée ou composant. L’infrastructure partagée les soutient sans en hériter, sauf activation dans la même carte. Dans la liste des CI la criticité héritée est un filtre et une colonne.',
  'Dichiarato dall’eseguibile, non trovato nell’inventario software del CI':
    'Déclaré par l’exécutable, introuvable dans l’inventaire logiciel du CI',
  'Gli asset a supporto di funzioni critiche o importanti sono identificati tramite i business service. Per ciascun servizio sono indicati il numero di componenti e quelli con conformità critica o parziale. Nella tabella degli host, a parità di fascia di conformità, hanno priorità i componenti dei servizi più critici.': 'Les actifs qui soutiennent des fonctions critiques ou importantes sont identifiés via les business services. Pour chaque service, le nombre de composants et ceux en conformité critique ou partielle sont indiqués. Dans le tableau des hôtes, à niveau de conformité égal, les composants des services les plus critiques sont prioritaires.',
  'Asset ordinati per livello di rischio, con priorità rivolta ai Business Service più critici.': 'Actifs classés par niveau de risque, en priorité ceux des Business Services les plus critiques.',
  'Il processo in ascolto su una porta e il software a cui appartiene arrivano dall’inventario avanzato (SSH o WinRM): su Linux il pacchetto che contiene l’eseguibile, su Windows il prodotto dichiarato dall’eseguibile, abbinati all’inventario software del CI. Sugli apparati senza inventario avanzato non sono noti.':
    'Le processus en écoute sur un port et le logiciel auquel il appartient proviennent de l’inventaire avancé (SSH ou WinRM) : sous Linux le paquet qui contient l’exécutable, sous Windows le produit déclaré par l’exécutable, rapprochés de l’inventaire logiciel du CI. Sur les équipements sans inventaire avancé ils ne sont pas connus.',
  'Infrastruttura':
    'Infrastructure',
  'Non conformi':
    'Non conformes',
  'dall’eseguibile':
    'de l’exécutable',
  'Accanto al processo compare il software a cui appartiene: su Linux il pacchetto che contiene l’eseguibile, su Windows il prodotto dichiarato dall’eseguibile, abbinati all’inventario software del CI. La criticità ereditata ordina anche Security health («Da dove cominciare»: a parità di fascia prima i componenti dei servizi più critici) e i rapporti NIS2 e DORA, che hanno una tabella dei business service con i componenti non conformi.':
    'À côté du processus apparaît le logiciel auquel il appartient : sous Linux le paquet qui contient l’exécutable, sous Windows le produit déclaré par l’exécutable, rapprochés de l’inventaire logiciel du CI. La criticité héritée ordonne aussi Security health (« Par où commencer » : à classe égale d’abord les composants des services les plus critiques) et les rapports NIS2 et DORA, qui ont un tableau des services métier avec leurs composants non conformes.',
  'L’elenco si esporta con i pulsanti «Esporta Excel» e «Esporta PDF» in alto (il PDF è il report, con intestazione CENSO): servizio, criticità effettiva e dichiarata, responsabile, punti di ingresso, profondità e Business App collegate.':
    'La liste s’exporte avec les boutons « Exporter Excel » et « Exporter PDF » en haut (le PDF est le rapport, avec l’en-tête CENSO) : service, criticité effective et déclarée, responsable, points d’entrée, profondeur et Business Apps liées.',
  'L’elenco si esporta con i pulsanti «Esporta Excel» e «Esporta PDF» in alto (il PDF è il report, con intestazione CENSO): applicazione, criticità, numero di funzionalità, elementi e CI, i Business Service che la usano e il responsabile.':
    'La liste s’exporte avec les boutons « Exporter Excel » et « Exporter PDF » en haut (le PDF est le rapport, avec l’en-tête CENSO) : application, criticité, nombre de fonctionnalités, éléments et CI, les Business Services qui l’utilisent et le responsable.',
  'comportamento nei flussi':
    'comportement dans les flux',
  'chiama {p}':
    'appelle {p}',
  'risponde su {p}':
    'répond sur {p}',
  'Accendi «SBOM» negli agenti CENSO dei server (Discovery → Agenti d’inventario → Impostazioni): alla consegna successiva le applicazioni compaiono qui. In alternativa importa un documento CycloneDX o SPDX dalla sezione «Software (SBOM)» di un CI.':
    'Activez «SBOM» dans les agents CENSO des serveurs (Découverte → Agents d’inventaire → Paramètres) : à la livraison suivante les applications apparaissent ici. Vous pouvez aussi importer un document CycloneDX ou SPDX depuis la section «Software (SBOM)» d’un CI.',
  'Accendi «SBOM» nelle impostazioni dell’agente CENSO di questa macchina, oppure importa un documento CycloneDX o SPDX.':
    'Activez «SBOM» dans les paramètres de l’agent CENSO de cette machine, ou importez un document CycloneDX ou SPDX.',
  'Applicazioni':
    'Applications',
  'Avvisi':
    'Avis',
  'Corretta in':
    'Corrigée en',
  'Ecosistema':
    'Écosystème',
  'Ecosistemi':
    'Écosystèmes',
  'Elimina l’importazione':
    'Supprimer l’importation',
  'Eseguibile':
    'Exécutable',
  'Importa un documento CycloneDX o SPDX (JSON)':
    'Importer un document CycloneDX ou SPDX (JSON)',
  'Importata':
    'Importée',
  'importata':
    'importée',
  'Importata «{a}» ({f}): {n} componenti, {v} vulnerabili.':
    '«{a}» importée ({f}) : {n} composants, {v} vulnérables.',
  'Importazione…':
    'Importation…',
  'La software bill of materials di ogni server: tutto il software installato e le librerie che contiene, con versione, licenza e vulnerabilità note; porte e processi legano ogni applicazione alle chiamate e al traffico. È l’add-on CENSO SBOM, e serve al registro DORA delle dipendenze ICT e a rispondere in pochi minuti a «dove abbiamo questa libreria?» quando esce una vulnerabilità.':
    'La nomenclature logicielle (SBOM) de chaque serveur : tous les logiciels installés et les bibliothèques qu’ils contiennent, avec version, licence et vulnérabilités connues ; ports et processus relient chaque application aux appels et au trafic. C’est le module CENSO SBOM ; il sert au registre DORA des dépendances TIC et répond en quelques minutes à «où avons-nous cette bibliothèque ?» quand une vulnérabilité sort.',
  'Il software installato su questo CI con le librerie che contiene, letto dall’agente CENSO (cartelle di installazione, processi, servizi, siti IIS), più quello importato da documenti CycloneDX o SPDX (fornitori, pipeline di build). Porte e processo, quando ci sono, legano l’applicazione alle chiamate e al traffico. Le vulnerabilità vengono dal catalogo OSV e finiscono anche fra i rischi di sicurezza del CI.':
    'Les logiciels installés sur ce CI avec les bibliothèques qu’ils contiennent, lus par l’agent CENSO (dossiers d’installation, processus, services, sites IIS), plus ceux importés de documents CycloneDX ou SPDX (fournisseurs, pipelines de build). Ports et processus, quand ils existent, relient l’application aux appels et au trafic. Les vulnérabilités viennent du catalogue OSV et figurent aussi parmi les risques de sécurité du CI.',
  'censisce software, componenti e librerie installati sui server tramite agenti CENSO o importazione CycloneDX/SPDX. Processi, porte in ascolto e traffico osservato correlano i componenti software alle dipendenze applicative, supportando il registro DORA e l’identificazione degli asset interessati da una vulnerabilità.': 'Recense les logiciels, composants et bibliothèques installés sur les serveurs via les agents CENSO ou l’import CycloneDX/SPDX. Les processus, les ports en écoute et le trafic observé corrèlent les composants logiciels aux dépendances applicatives, en appui au registre DORA et à l’identification des actifs concernés par une vulnérabilité.',
  'Le vulnerabilità vengono dal catalogo OSV (lo stesso dei pacchetti di sistema, aggiornato da Sicurezza → catalogo) e diventano rischi «Libreria vulnerabile» sul CI, con la versione che le corregge e il segno «sfruttata attivamente (CISA KEV)» dal catalogo CISA KEV. Una versione sconosciuta non è considerata vulnerabile.':
    'Les vulnérabilités viennent du catalogue OSV (le même que pour les paquets système, mis à jour depuis Sécurité → catalogue) et deviennent des risques «Bibliothèque vulnérable» sur le CI, avec la version qui les corrige et l’indication «exploitée activement» du catalogue CISA KEV. Une version inconnue n’est pas considérée comme vulnérable.',
  'Leggi il software installato e le sue librerie (CENSO SBOM)':
    'Lire les logiciels installés et leurs bibliothèques (CENSO SBOM)',
  'Letta dall’agente CENSO':
    'Lue par l’agent CENSO',
  'Librerie vulnerabili':
    'Bibliothèques vulnérables',
  'Licenze più usate':
    'Licences les plus utilisées',
  'L’agente legge tutto il software installato — cartelle di installazione (Program Files e le cartelle in radice dei dischi, /opt, /srv, /usr/local, /var/www), processi in esecuzione, servizi anche fermi, siti IIS, librerie globali di pip e npm, più i percorsi personalizzati — e ne legge i componenti (Java, Node.js, Python, .NET, PHP, Ruby, Go) a bassa priorità e con un tempo massimo. Le porte in ascolto servono a legare le applicazioni a chiamate e traffico. Il risultato va nella Mappa software e nella sezione SBOM del CI. Richiede la licenza CENSO SBOM.':
    'L’agent lit tous les logiciels installés — dossiers d’installation (Program Files et les dossiers à la racine des disques, /opt, /srv, /usr/local, /var/www), processus en cours, services même arrêtés, sites IIS, bibliothèques globales pip et npm, plus les chemins personnalisés — et en lit les composants (Java, Node.js, Python, .NET, PHP, Ruby, Go) en basse priorité et avec une durée maximale. Les ports à l’écoute relient les applications aux appels et au trafic. Le résultat va dans la Cartographie logicielle et dans la section SBOM du CI. Nécessite la licence CENSO SBOM.',
  'Nella pagina di un business service la card «Software del servizio (SBOM)»: per ogni componente, le applicazioni in ascolto sulle porte su cui il servizio lo chiama; si scarica in CycloneDX per il registro DORA.':
    'Sur la page d’un business service, la carte «Logiciels du service (SBOM)» : pour chaque composant, les applications à l’écoute sur les ports sur lesquels le service l’appelle ; elle se télécharge en CycloneDX pour le registre DORA.',
  'Nessun componente riconosciuto in questa applicazione.':
    'Aucun composant reconnu dans cette application.',
  'Nessuna applicazione':
    'Aucune application',
  'Nessuna applicazione ancora':
    'Aucune application pour l’instant',
  'Nessuno SBOM sui componenti del servizio: accendi «SBOM» negli agenti CENSO dei server, o importa i documenti dei fornitori nella sezione «Software (SBOM)» dei CI.':
    'Aucun SBOM sur les composants du service : activez «SBOM» dans les agents CENSO des serveurs, ou importez les documents des fournisseurs dans la section «Software (SBOM)» des CI.',
  'Non dichiarata':
    'Non déclarée',
  'Ogni consegna dell’agente sostituisce le applicazioni lette prima; un documento importato sostituisce quello con lo stesso nome di applicazione. Se l’elenco è troppo grande per una consegna si omettono prima i percorsi e poi i componenti in eccesso, e l’applicazione risulta «troncata».':
    'Chaque livraison de l’agent remplace les applications lues auparavant ; un document importé remplace celui qui porte le même nom d’application. Si la liste est trop grande pour une livraison, on omet d’abord les chemins puis les composants en excès, et l’application apparaît «tronquée».',
  'Per ogni componente del servizio, le applicazioni in ascolto sulle porte su cui il servizio lo chiama, con le loro librerie: la distinta del software del servizio, da allegare al registro DORA.':
    'Pour chaque composant du service, les applications à l’écoute sur les ports sur lesquels le service l’appelle, avec leurs bibliothèques : la nomenclature logicielle du service, à joindre au registre DORA.',
  'SBOM':
    'SBOM',
  'Scarica CycloneDX':
    'Télécharger CycloneDX',
  'Senza la licenza CENSO SBOM la pagina lo spiega e l’agente non legge nulla anche con l’opzione accesa.':
    'Sans la licence CENSO SBOM la page l’indique et l’agent ne lit rien même avec l’option activée.',
  'Software (SBOM)':
    'Logiciels (SBOM)',
  'Software del servizio (SBOM)':
    'Logiciels du service (SBOM)',
  'Solo i componenti vulnerabili':
    'Seulement les composants vulnérables',
  'Un documento con lo stesso nome di applicazione sostituisce quello importato prima.':
    'Un document portant le même nom d’application remplace celui importé auparavant.',
  'Vulnerabili':
    'Vulnérables',
  'alla consegna successiva l’agente legge tutto il software installato: le cartelle di installazione (Program Files e le cartelle in radice dei dischi su Windows; /opt, /srv, /usr/local, /var/www e Tomcat su Linux), i processi in esecuzione, i servizi anche fermi, i siti IIS, le librerie globali di pip e npm e i percorsi personalizzati; ne legge i componenti — Java (jar, war, ear, anche annidati), Node.js, Python, .NET, PHP (Composer), Ruby (Bundler), eseguibili Go — a bassa priorità e con un tempo massimo; le porte in ascolto e i processi si legano all’applicazione a cui appartengono;':
    'à la livraison suivante l’agent lit tous les logiciels installés : les dossiers d’installation (Program Files et les dossiers à la racine des disques sous Windows ; /opt, /srv, /usr/local, /var/www et Tomcat sous Linux), les processus en cours, les services même arrêtés, les sites IIS, les bibliothèques globales pip et npm et les chemins personnalisés ; il en lit les composants — Java (jar, war, ear, même imbriqués), Node.js, Python, .NET, PHP (Composer), Ruby (Bundler), exécutables Go — en basse priorité et avec une durée maximale ; les ports à l’écoute et les processus sont reliés à l’application à laquelle ils appartiennent ;',
  'corretta in {v}':
    'corrigée en {v}',
  'elenco troncato (limiti di lettura)':
    'liste tronquée (limites de lecture)',
  'installa l’agente CENSO sui server (Discovery → Agenti d’inventario) e nelle sue impostazioni accendi «SBOM»;':
    'installez l’agent CENSO sur les serveurs (Découverte → Agents d’inventaire) et activez «SBOM» dans ses paramètres ;',
  'per il software che l’agente non può leggere (appliance, prodotti chiusi) importa il documento CycloneDX o SPDX del fornitore o della vostra pipeline di build dalla sezione «Software (SBOM)» del CI.':
    'pour les logiciels que l’agent ne peut pas lire (appliances, produits fermés), importez le document CycloneDX ou SPDX du fournisseur ou de votre pipeline de build depuis la section «Software (SBOM)» du CI.',
  'porte':
    'ports',
  'sfruttata attivamente (CISA KEV)':
    'activement exploitée (CISA KEV)',
  '{a} applicazioni, {c} componenti, {v} vulnerabili.':
    '{a} applications, {c} composants, {v} vulnérables.',
  '{c} componenti, {v} vulnerabili.':
    '{c} composants, {v} vulnérables.',
  '{n} componenti':
    '{n} composants',
  '{n} vulnerabili':
    '{n} vulnérables',
  '{n} vulnerabilità':
    '{n} vulnérabilités',
  'Aggiungi una regola':
    'Ajouter une règle',
  'Cartella':
    'Dossier',
  'Cartella come applicazione (SBOM)':
    'Dossier comme application (SBOM)',
  'Contenuto del file':
    'Contenu du fichier',
  'Cosa leggere':
    'Quoi lire',
  'Definisce percorsi aggiuntivi in cui l’agente ricerca software installato. Per ogni regola specifica percorso, pattern di file o cartelle e dati da acquisire; un’espressione regolare può estrarre nome, versione e produttore. Le regole valgono per tutti gli agenti del tenant e per gli inventari software. Le cartelle classificate come applicazione vengono incluse nello SBOM, se abilitato.':
    'Où l’agent cherche des logiciels installés en plus des emplacements qu’il connaît déjà : un dossier (aussi avec * et des variables comme %ProgramFiles% ou $HOME), un modèle pour les noms des fichiers ou dossiers à examiner (ex. *.jar, version.txt, app-*) et quoi lire. L’expression régulière extrait le produit avec les groupes (?P<name>…), (?P<version>…) et (?P<vendor>…). Elles valent pour tous les agents du tenant, à chaque inventaire incluant les logiciels (Rapide + logiciels, Complet + logiciels) ; les dossiers «comme application» vont dans le SBOM s’il est activé.',
  'Espressione regolare':
    'Expression régulière',
  'Modello dei nomi':
    'Modèle des noms',
  'Nessuna regola: l’agente usa solo la ricerca integrata.':
    'Aucune règle : l’agent utilise seulement sa recherche intégrée.',
  'Nome del file':
    'Nom du fichier',
  'Nome del prodotto (fisso)':
    'Nom du produit (fixe)',
  'Nome della cartella':
    'Nom du dossier',
  'Percorsi software personalizzati':
    'Chemins logiciels personnalisés',
  'Produttore (fisso)':
    'Éditeur (fixe)',
  'Salvate: gli agenti le ricevono al prossimo contatto.':
    'Enregistrées : les agents les reçoivent au prochain contact.',
  'Togli la regola':
    'Retirer la règle',
  'es. Gestionale Acme':
    'ex. ERP Acme',
  '«Percorsi software personalizzati», in fondo alla pagina: per il software che l’agente non trova da solo (un applicativo interno in /opt, un prodotto scompattato in una cartella di Windows) si indicano la cartella, il modello dei nomi e cosa leggere — il nome del file, il contenuto di un file di testo (es. version.txt), il nome della cartella, oppure la cartella come applicazione per lo SBOM (se contiene più programmi, ognuno nella sua sottocartella diventa un’applicazione con il suo nome) — con un’espressione regolare che estrae nome, versione e produttore. Valgono per tutti gli agenti del tenant, anche solo per Windows o Linux, e arrivano al prossimo contatto; i prodotti trovati compaiono nell’inventario software del CI con origine «custom_path» e sono valutati come gli altri.':
    '«Chemins logiciels personnalisés», en bas de la page : pour les logiciels que l’agent ne trouve pas seul (une application interne dans /opt, un produit décompressé dans un dossier Windows) on indique le dossier, le modèle des noms et quoi lire — le nom du fichier, le contenu d’un fichier texte (ex. version.txt), le nom du dossier, ou le dossier comme application pour le SBOM (s’il contient plusieurs programmes, chacun dans son sous-dossier devient une application avec son nom) — avec une expression régulière qui extrait nom, version et éditeur. Elles valent pour tous les agents du tenant, éventuellement seulement Windows ou Linux, et arrivent au prochain contact ; les produits trouvés apparaissent dans l’inventaire logiciel du CI avec l’origine «custom_path» et sont évalués comme les autres.',
  'Dipendenza':
    'Dépendance',
  'Diretta: dichiarata dall’applicazione. Transitiva: arriva tramite un’altra libreria.':
    'Directe : déclarée par l’application. Transitive : arrive via une autre bibliothèque.',
  'Dirette e transitive':
    'Directes et transitives',
  'Ogni componente è «diretto» se l’applicazione lo dichiara (package.json, il pom.xml dentro il war o il jar eseguibile, il progetto nel deps.json, composer.json, Gemfile.lock; per Python i pacchetti che nessun altro richiede) o «transitivo» se arriva tramite un’altra libreria; per gli eseguibili Go non si sa. Dai documenti importati lo dice il grafo delle dipendenze. Il rischio di una libreria transitiva suggerisce di aggiornare quella che la porta o di forzarne la versione.':
    'Chaque composant est «direct» si l’application le déclare (package.json, le pom.xml dans le war ou le jar exécutable, le projet dans deps.json, composer.json, Gemfile.lock ; pour Python les paquets qu’aucun autre ne requiert) ou «transitif» s’il arrive via une autre bibliothèque ; pour les exécutables Go on ne le sait pas. Pour les documents importés, c’est le graphe des dépendances qui le dit. Le risque d’une bibliothèque transitive suggère de mettre à jour celle qui l’apporte ou d’en forcer la version.',
  'Ogni libreria vulnerabile è anche un rischio di sicurezza sul CI che la contiene («Libreria vulnerabile»), con la versione che la corregge. Una dipendenza transitiva non è dichiarata dall’applicazione: si corregge aggiornando la libreria che la porta o forzandone la versione.':
    'Chaque bibliothèque vulnérable est aussi un risque de sécurité sur le CI qui la contient («Bibliothèque vulnérable»), avec la version qui la corrige. Une dépendance transitive n’est pas déclarée par l’application : on la corrige en mettant à jour la bibliothèque qui l’apporte ou en forçant sa version.',
  'Solo dirette':
    'Directes seulement',
  'Solo transitive':
    'Transitives seulement',
  'diretta':
    'directe',
  'transitiva':
    'transitive',
  '{d} dirette, {tr} transitive':
    '{d} directes, {tr} transitives',
  'Installata':
    'Installée',
  'Percorso personalizzato':
    'Chemin personnalisé',
  'Mostra come albero delle dipendenze':
    'Afficher comme arbre des dépendances',
  'Per ogni libreria CENSO sa anche da quali altre dipende (l’albero): «Mostra come albero delle dipendenze» lo apre a partire dalle librerie dirette, e sotto ogni libreria transitiva compare la catena che la porta («tramite spring-boot-starter-web → spring-webmvc»). Il rischio di una libreria vulnerabile transitiva nomina la libreria diretta da aggiornare. L’albero si legge dai manifest delle librerie installate (pom.xml, package.json, METADATA, deps.json, composer.lock, Gemfile.lock) e, nei documenti importati, dal grafo CycloneDX o dalle relazioni SPDX.':
    'Pour chaque bibliothèque, CENSO sait aussi de quelles autres elle dépend (l’arbre) : «Afficher comme arbre des dépendances» l’ouvre à partir des bibliothèques directes, et sous chaque bibliothèque transitive apparaît la chaîne qui l’apporte («via spring-boot-starter-web → spring-webmvc»). Le risque d’une bibliothèque transitive vulnérable nomme la bibliothèque directe à mettre à jour. L’arbre se lit dans les manifestes des bibliothèques installées (pom.xml, package.json, METADATA, deps.json, composer.lock, Gemfile.lock) et, dans les documents importés, dans le graphe CycloneDX ou les relations SPDX.',
  'già sopra':
    'déjà au-dessus',
  'tramite':
    'via',
  'Acceso ma non in ascolto.':
    'Activé mais pas à l’écoute.',
  'Chiamate':
    'Appels',
  'Chiamate in uscita':
    'Appels sortants',
  'Ciò che le applicazioni di questo server fanno davvero, dalle loro tracce OpenTelemetry raccolte dall’agente CENSO: le operazioni che ricevono, le chiamate che fanno (servizi, database, code) con il CI che le riceve, e quali servizi chiamano quali. Le tracce restano sul server: arrivano solo conteggi, errori e tempi riassunti ogni cinque minuti.':
    'Ce que font réellement les applications de ce serveur, d’après leurs traces OpenTelemetry collectées par l’agent CENSO : les opérations reçues, les appels effectués (services, bases de données, files) avec le CI qui les reçoit, et quels services appellent lesquels. Les traces restent sur le serveur : seuls arrivent des comptages, erreurs et temps résumés toutes les cinq minutes.',
  'Il valore più alto fra i 95° percentili di cinque minuti: un limite superiore.':
    'La plus haute des valeurs du 95e centile sur cinq minutes : une borne supérieure.',
  'In ascolto su {a}.':
    'À l’écoute sur {a}.',
  'L’agente apre un ricevitore OTLP/HTTP solo su 127.0.0.1:4318, la porta predefinita degli SDK e del Collector: nelle applicazioni basta OTEL_EXPORTER_OTLP_ENDPOINT=http://127.0.0.1:4318 (protocollo http/protobuf o http/json); un OpenTelemetry Collector già presente sulla macchina vi esporta con otlphttp. Le tracce restano sul server: ogni cinque minuti l’agente manda solo operazioni, chiamate e legami fra servizi con conteggi, errori e tempi, senza query, SQL, header o contenuti. Serve l’agente residente; gRPC non è ancora supportato.':
    'L’agent ouvre un récepteur OTLP/HTTP uniquement sur 127.0.0.1:4318, le port par défaut des SDK et du Collector : dans les applications OTEL_EXPORTER_OTLP_ENDPOINT=http://127.0.0.1:4318 suffit (protocole http/protobuf ou http/json) ; un OpenTelemetry Collector déjà présent sur la machine y exporte avec otlphttp. Les traces restent sur le serveur : toutes les cinq minutes l’agent n’envoie que les opérations, appels et liens entre services avec comptages, erreurs et temps, sans requêtes, SQL, en-têtes ni contenus. Nécessite l’agent résident ; gRPC n’est pas encore pris en charge.',
  'L’agente consegna e basta: non apre porte verso la rete, non accetta comandi. La direzione è una sola, da dentro verso la piattaforma. L’unica porta che può aprire, se accendi «Runtime», è il ricevitore OpenTelemetry su 127.0.0.1:4318, raggiungibile solo dalla macchina stessa.':
    'L’agent ne fait que livrer : il n’ouvre aucun port vers le réseau et n’accepte aucune commande. Une seule direction, de l’intérieur vers la plateforme. Le seul port qu’il peut ouvrir, si vous activez «Runtime», est le récepteur OpenTelemetry sur 127.0.0.1:4318, joignable uniquement depuis la machine elle-même.',
  'Media ms':
    'Moy. ms',
  'Nessuna traccia OpenTelemetry dai componenti del servizio: accendi «Runtime» negli agenti CENSO dei server e manda le tracce delle applicazioni a 127.0.0.1:4318.':
    'Aucune trace OpenTelemetry des composants du service : activez «Runtime» dans les agents CENSO des serveurs et envoyez les traces des applications à 127.0.0.1:4318.',
  'Nessuna traccia nel periodo scelto.':
    'Aucune trace dans la période choisie.',
  'Operazione':
    'Opération',
  'Operazioni ricevute':
    'Opérations reçues',
  'Porta, applicazione':
    'Port, application',
  'Ricevi le tracce OpenTelemetry delle applicazioni (CENSO SBOM)':
    'Recevoir les traces OpenTelemetry des applications (CENSO SBOM)',
  'Runtime (OpenTelemetry)':
    'Runtime (OpenTelemetry)',
  'Runtime: con «Runtime» acceso nelle impostazioni dell’agente, le applicazioni del server mandano le loro tracce OpenTelemetry a 127.0.0.1:4318 (OTEL_EXPORTER_OTLP_ENDPOINT, oppure un Collector con otlphttp). Le tracce restano sul server: ogni cinque minuti arrivano a CENSO le operazioni ricevute, le chiamate in uscita (servizi, database, code, con il CI che le riceve) e quali servizi chiamano quali, con conteggi, errori e tempi. Le vedi nella sezione «Runtime» del CI e nella vista «Runtime» del business service, accanto a «Struttura» (lo SBOM): lì solo le operazioni sulle porte su cui il servizio chiama quel componente e ciò che quei servizi chiamano dopo.':
    'Runtime : avec «Runtime» activé dans les paramètres de l’agent, les applications du serveur envoient leurs traces OpenTelemetry à 127.0.0.1:4318 (OTEL_EXPORTER_OTLP_ENDPOINT, ou un Collector avec otlphttp). Les traces restent sur le serveur : toutes les cinq minutes CENSO reçoit les opérations reçues, les appels sortants (services, bases de données, files, avec le CI qui les reçoit) et quels services appellent lesquels, avec comptages, erreurs et temps. Vous les voyez dans la section «Runtime» du CI et dans la vue «Runtime» du business service, à côté de «Structure» (le SBOM) : là seulement les opérations sur les ports sur lesquels le service appelle ce composant, et ce que ces services appellent ensuite.',
  'Servizi che chiamano servizi':
    'Services qui appellent des services',
  'Struttura':
    'Structure',
  'p95 ms':
    'p95 ms',
  'I pacchetti del sistema operativo, pubblicati dalla distribuzione (o da Microsoft su Windows), dall’inventario software del CI. Le loro vulnerabilità sono nella sezione Sicurezza del CI.':
    'Les paquets du système d’exploitation, publiés par la distribution (ou par Microsoft sous Windows), depuis l’inventaire logiciel du CI. Leurs vulnérabilités sont dans la section Sécurité du CI.',
  'Il software installato che non è del sistema operativo: pacchetti di terze parti anche se installati con rpm/deb, programmi di altri produttori, prodotti scompattati, percorsi personalizzati. Dall’inventario software del CI; le vulnerabilità sono nella sezione Sicurezza.':
    'Les logiciels installés qui ne font pas partie du système d’exploitation : paquets tiers même installés avec rpm/deb, programmes d’autres éditeurs, produits décompressés, chemins personnalisés. Depuis l’inventaire logiciel du CI ; les vulnérabilités sont dans la section Sécurité.',
  'Lo SBOM di un server comprende anche l’inventario software del CI, separato in due: «Software di sistema» (i pacchetti rpm, deb, apk pubblicati dalla distribuzione, e su Windows i programmi Microsoft) e «Software extra sistema» (pacchetti di terze parti anche se installati con rpm/deb, programmi di altri produttori, prodotti scompattati, percorsi personalizzati), con i loro purl, anche nell’export CycloneDX; le loro vulnerabilità restano nella sezione Sicurezza del CI. La distinzione si fa dal produttore dichiarato dal pacchetto: un pacchetto senza produttore conta come di sistema. I programmi della distribuzione (sotto /usr, /etc, /lib…) e gli eseguibili senza librerie né porte non sono applicazioni. Un’applicazione Node senza node_modules si legge dai lock file (package-lock.json, yarn.lock, pnpm-lock.yaml); un’applicazione impacchettata senza manifest viene segnalata fra le lacune dell’inventario: in quel caso servono i percorsi personalizzati o lo SBOM della build.':
    'Le SBOM d’un serveur comprend aussi l’inventaire logiciel du CI, séparé en deux : «Logiciels système» (les paquets rpm, deb, apk publiés par la distribution, et sous Windows les programmes Microsoft) et «Logiciels hors système» (paquets tiers même installés avec rpm/deb, programmes d’autres éditeurs, produits décompressés, chemins personnalisés), avec leurs purl, y compris dans l’export CycloneDX ; leurs vulnérabilités restent dans la section Sécurité du CI. La distinction vient de l’éditeur déclaré par le paquet : un paquet sans éditeur compte comme système. Les programmes de la distribution (sous /usr, /etc, /lib…) et les exécutables sans bibliothèques ni ports ne sont pas des applications. Une application Node sans node_modules se lit dans ses fichiers lock (package-lock.json, yarn.lock, pnpm-lock.yaml) ; une application empaquetée sans manifeste est signalée parmi les lacunes de l’inventaire : il faut alors les chemins personnalisés ou le SBOM du build.',
  'Software di sistema':
    'Logiciels système',
  'Software extra sistema':
    'Logiciels hors système',
  'Mostra il dettaglio':
    'Afficher le détail',
  'Nascondi il dettaglio':
    'Masquer le détail',
  'Non è dichiarata dall’applicazione: arriva tramite {catena}. Si corregge aggiornando {prima} o forzando la versione di {nome}.':
    'Elle n’est pas déclarée par l’application : elle arrive via {catena}. On la corrige en mettant à jour {prima} ou en forçant la version de {nome}.',
  'Per chiudere tutti gli avvisi: almeno la versione {v}.':
    'Pour fermer tous les avis : au moins la version {v}.',
  'Su':
    'Sur',
  'nessuna correzione indicata':
    'aucune correction indiquée',
  'prodotto o variante non confrontabile':
    'produit ou variante non comparable',
  'pacchetto di debug':
    'paquet de débogage',
  'ciclo di vita del sistema non scaricato':
    'cycle de vie du système non téléchargé',
  'cicli di vita dei sistemi':
    'cycles de vie des systèmes',
  'Nel catalogo KEV della CISA: ci sono prove che venga già usata negli attacchi. Va corretta prima delle altre, qualunque sia il punteggio.':
    'Dans le catalogue KEV de la CISA : il existe des preuves qu’elle est déjà utilisée dans des attaques. À corriger avant les autres, quel que soit son score.',
  'Nessun server con librerie vulnerabili.':
    'Aucun serveur avec des bibliothèques vulnérables.',
  'non note':
    'inconnues',
  'Solo vulnerabili':
    'Vulnérables seulement',
  'Librerie vulnerabili per gravità':
    'Bibliothèques vulnérables par gravité',
  'ultimo aggiornamento {quando}':
    'dernière mise à jour {quando}',
  'Applicazioni per tipo':
    'Applications par type',
  'Cerca una libreria in tutti i server (es. log4j, openssl, lodash)':
    'Chercher une bibliothèque sur tous les serveurs (ex. log4j, openssl, lodash)',
  'Dipendenze dirette e transitive':
    'Dépendances directes et transitives',
  'Processo':
    'Processus',
  'applicazioni':
    'applications',
  'Licenze diverse':
    'Licences distinctes',
  'Librerie diverse':
    'Bibliothèques distinctes',
  'componenti':
    'composants',
  'terze parti, scompattati, percorsi personalizzati':
    'tiers, décompressés, chemins personnalisés',
  'licenze':
    'licences',
  '{n} librerie diverse':
    '{n} bibliothèques distinctes',
  'Mostrati i primi {m} di {n}, per numero di server: cerca per nome per restringere.':
    'Affichés les {m} premiers sur {n}, par nombre de serveurs : cherchez par nom pour affiner.',
  'pacchetti della distribuzione':
    'paquets de la distribution',
  'transitive':
    'transitives',
  'Nessuna libreria vulnerabile.':
    'Aucune bibliothèque vulnérable.',
  'server':
    'serveurs',
  'dirette':
    'directes',
  'Server con più librerie vulnerabili':
    'Serveurs avec le plus de bibliothèques vulnérables',
  'librerie':
    'bibliothèques',
  'a schede: «Panoramica» con contatori (server, applicazioni, componenti, librerie vulnerabili, sfruttate attivamente, licenze, software di sistema ed extra sistema) e grafici (gravità, dirette e transitive, ecosistemi, licenze, tipi di applicazione, server più esposti); «Applicazioni», «Componenti» (ogni libreria per versione, con dove si trova), «Librerie vulnerabili» (con gli avvisi) e «Licenze». Le tabelle si filtrano e ordinano per colonna.':
    'à onglets : «Vue d’ensemble» avec compteurs (serveurs, applications, composants, bibliothèques vulnérables, activement exploitées, licences, logiciels système et hors système) et graphiques (gravité, directes et transitives, écosystèmes, licences, types d’application, serveurs les plus exposés) ; «Applications», «Composants» (chaque bibliothèque par version, avec où elle se trouve), «Bibliothèques vulnérables» (avec les avis) et «Licences». Les tableaux se filtrent et se trient par colonne.',
  'Componenti vulnerabili':
    'Composants vulnérables',
  'Compose':
    'Compose',
  'Con contenuto letto':
    'Avec contenu lu',
  'Container':
    'Conteneurs',
  'Container ({n})':
    'Conteneurs ({n})',
  'Container con pacchetti vulnerabili':
    'Conteneurs avec paquets vulnérables',
  'I container di questo host letti dall’agente CENSO':
    'Les conteneurs de cet hôte lus par l’agent CENSO',
  'I container si leggono dall’agente CENSO installato sugli host che li eseguono, come root: alla prossima raccolta completa compaiono qui. Il contenuto delle immagini richiede l’opzione «SBOM» dell’agente.':
    'Les conteneurs sont lus par l’agent CENSO installé sur les hôtes qui les exécutent, en root : à la prochaine collecte complète ils apparaissent ici. Le contenu des images nécessite l’option «SBOM» de l’agent.',
  'inventario rilevato dagli agenti CENSO sui runtime Docker, Podman, containerd e CRI-O, inclusi cluster Kubernetes, k3s e RKE2, con immagine, stato, porte, pod e namespace. L’analisi SBOM identifica distribuzione, pacchetti di sistema e librerie delle immagini in esecuzione e ne valuta le vulnerabilità, escludendo dalla raccolta variabili d’ambiente e command line.': 'Inventaire détecté par les agents CENSO sur les runtimes Docker, Podman, containerd et CRI-O, y compris les clusters Kubernetes, k3s et RKE2, avec image, état, ports, pods et namespaces. L’analyse SBOM identifie la distribution, les paquets système et les bibliothèques des images en cours d’exécution et en évalue les vulnérabilités, en excluant de la collecte les variables d’environnement et les lignes de commande.',
  'Il contenuto (pacchetti di sistema e librerie) si legge una volta per immagine con l’opzione SBOM e sta nella sezione «Software (SBOM)».':
    'Le contenu (paquets système et bibliothèques) se lit une fois par image avec l’option SBOM et se trouve dans la section «Logiciels (SBOM)».',
  'Il contenuto si legge con l’opzione SBOM dell’agente, solo per i container in esecuzione.':
    'Le contenu se lit avec l’option SBOM de l’agent, seulement pour les conteneurs en exécution.',
  'Immagine':
    'Image',
  'Immagini':
    'Images',
  'Inventario container':
    'Inventaire des conteneurs',
  'Kubernetes':
    'Kubernetes',
  'Namespace':
    'Namespace',
  'Namespace Kubernetes':
    'Namespaces Kubernetes',
  'Namespace con più container':
    'Namespaces avec le plus de conteneurs',
  'Nessun container Kubernetes.':
    'Aucun conteneur Kubernetes.',
  'Nessun container ancora':
    'Aucun conteneur pour l’instant',
  'Pod':
    'Pods',
  'Progetti Compose':
    'Projets Compose',
  'Runtime per host':
    'Runtimes par hôte',
  'Sistemi nelle immagini':
    'Systèmes dans les images',
  'Stato dei container':
    'État des conteneurs',
  'Sui nodi Kubernetes, k3s o RKE2 l’agente legge i container tramite crictl.':
    'Sur les nœuds Kubernetes, k3s ou RKE2 l’agent lit les conteneurs via crictl.',
  'container':
    'conteneurs',
  'fermi':
    'arrêtés',
  'immagini':
    'images',
  'namespace':
    'namespaces',
  'non letto':
    'non lu',
  'non usata':
    'inutilisée',
  'richiede l’opzione SBOM':
    'nécessite l’option SBOM',
  '{a} in esecuzione, {b} fermi':
    '{a} en exécution, {b} arrêtés',
  '{n} non usate':
    '{n} inutilisées',
  '{n} pod':
    '{n} pods',
  'i container trovati dagli agenti CENSO sugli host (Docker, Podman, containerd, CRI-O: anche Kubernetes, k3s, RKE2), a schede — Panoramica, Container, Immagini, Kubernetes — con immagine, stato, porte, pod, namespace e progetto Compose. Con l’opzione SBOM dell’agente si legge anche il contenuto di ogni immagine in esecuzione, una volta per immagine e senza eseguire niente dentro: distribuzione, pacchetti di sistema e librerie; i pacchetti vulnerabili diventano rischi «Pacchetto vulnerabile nel container» con il rimedio di ricostruire l’immagine. Variabili d’ambiente e righe di comando non si leggono mai: contengono segreti. Ogni host ha anche la sezione «Container» nella sua scheda.':
    'les conteneurs trouvés par les agents CENSO sur les hôtes (Docker, Podman, containerd, CRI-O : aussi Kubernetes, k3s, RKE2), à onglets — Vue d’ensemble, Conteneurs, Images, Kubernetes — avec image, état, ports, pod, namespace et projet Compose. Avec l’option SBOM de l’agent on lit aussi le contenu de chaque image en exécution, une fois par image et sans rien exécuter dedans : distribution, paquets système et bibliothèques ; les paquets vulnérables deviennent des risques «Paquet vulnérable dans le conteneur» avec le remède de reconstruire l’image. Les variables d’environnement et les lignes de commande ne sont jamais lues : elles contiennent des secrets. Chaque hôte a aussi la section «Conteneurs» sur sa fiche.',
  'Altra o proprietaria':
    'Autre ou propriétaire',
  'Application Maintenance':
    'Application Maintenance',
  'Che cosa vuol dire':
    'Ce que cela signifie',
  'Componenti per famiglia di licenza':
    'Composants par famille de licence',
  'Copyleft debole':
    'Copyleft faible',
  'Copyleft forte':
    'Copyleft fort',
  'Di sistema':
    'Système',
  'Elenco dei software':
    'Liste des logiciels',
  'Extra sistema':
    'Hors système',
  'Fine supporto':
    'Fin de support',
  'Il componente non dichiara una licenza: da verificare.':
    'Le composant ne déclare aucune licence : à vérifier.',
  'In scadenza entro 6 mesi':
    'Expire dans les 6 mois',
  'Inventario Software':
    'Inventaire logiciel',
  'monitora il ciclo di vita di software e sistemi operativi installati, identificando i prodotti già fuori supporto, quelli a rilascio continuo non aggiornati e quelli che termineranno il supporto nei prossimi sei mesi. Ogni elemento viene registrato anche come rischio nella sezione Sicurezza del CI e aggiornato a ogni valutazione.': 'Surveille le cycle de vie des logiciels et systèmes d’exploitation installés, en identifiant les produits déjà hors support, les produits en rolling-release en retard et ceux dont le support se termine dans les six prochains mois. Chaque élément est aussi enregistré comme risque dans la section Sécurité du CI et mis à jour à chaque évaluation.',
  'analizza dallo SBOM le licenze delle librerie presenti sui server e le classifica come permissive, copyleft debole, copyleft forte, proprietarie, altre o non dichiarate. Permette di individuare dove sono presenti componenti con obblighi di redistribuzione prima che diventino un rischio.': 'Analyse, à partir du SBOM, les licences des bibliothèques présentes sur les serveurs et les classe en permissives, copyleft faible, copyleft fort, propriétaires, autres ou non déclarées. Il permet de repérer les composants soumis à des obligations de redistribution avant qu’ils ne deviennent un risque.',
  'Le modifiche alla libreria vanno condivise, il resto dell’applicazione no (LGPL, MPL, EPL…).':
    'Les modifications de la bibliothèque doivent être partagées, le reste de l’application non (LGPL, MPL, EPL…).',
  'Le scadenze compaiono dopo una valutazione di sicurezza dei CI con l’inventario software.':
    'Les échéances apparaissent après une évaluation de sécurité des CI avec inventaire logiciel.',
  'Libreria':
    'Bibliothèque',
  'Licenza non classificata o proprietaria: da verificare.':
    'Licence non classée ou propriétaire : à vérifier.',
  'Licenze dei software':
    'Licences des logiciels',
  'Nessuna scadenza':
    'Aucune échéance',
  'Non aggiornati':
    'Non mis à jour',
  'Permissiva':
    'Permissive',
  'Scadenze dei software':
    'Échéances des logiciels',
  'Se l’applicazione è distribuita, va distribuita con la stessa licenza: da verificare con l’ufficio legale (GPL, AGPL…).':
    'Si l’application est distribuée, elle doit l’être sous la même licence : à vérifier avec le service juridique (GPL, AGPL…).',
  'Si usa e si ridistribuisce citando l’autore (MIT, Apache, BSD…).':
    'Elle s’utilise et se redistribue en citant l’auteur (MIT, Apache, BSD…).',
  'Software installati (nome e versione)':
    'Logiciels installés (nom et version)',
  'inventario di tutto il software rilevato sui CI del tenant, identificato per nome e versione tramite package manager, programmi Windows, prodotti scompattati e percorsi personalizzati. Distingue il software di sistema da quello aggiuntivo e, per ogni prodotto, mostra i CI su cui è installato.': 'Inventaire de tous les logiciels détectés sur les CI du tenant, identifiés par nom et version via les gestionnaires de paquets, les programmes Windows, les produits décompressés et les chemins personnalisés. Il distingue les logiciels système des logiciels additionnels et, pour chaque produit, montre les CI sur lesquels il est installé.',
  'da {n} giorni':
    'depuis {n} jours',
  'fuori supporto':
    'hors support',
  'in scadenza':
    'en échéance',
  'non aggiornato':
    'non mis à jour',
  'scadenze':
    'échéances',
  'software':
    'logiciels',
  'su {n} host':
    'sur {n} hôtes',
  '{pacchetto} {ciclo} esce dal supporto il {fine_leggibile}':
    '{pacchetto} {ciclo} sort du support le {fine_leggibile}',
  '{pacchetto} esce dal supporto il {fine_leggibile}':
    '{pacchetto} sort du support le {fine_leggibile}',
  'Il ciclo {ciclo} smette di ricevere correzioni il {fine_leggibile}: conviene pianificare adesso il passaggio a un ciclo supportato':
    'Le cycle {ciclo} cesse de recevoir des corrections le {fine_leggibile} : planifiez dès maintenant le passage à un cycle supporté',
  'Pianificare il passaggio a un ciclo ancora supportato prima della scadenza':
    'Planifier le passage à un cycle encore supporté avant l’échéance',
  'tutto il software installato nel tenant per nome e versione, dall’inventario dei CI, con il software di sistema separato da quello extra sistema; ogni riga si apre sugli host che lo hanno.':
    'tous les logiciels installés dans le tenant par nom et version, depuis l’inventaire des CI, avec les logiciels système séparés des logiciels hors système ; chaque ligne s’ouvre sur les hôtes qui les ont.',
  'la fine del supporto del software e dei sistemi operativi: già fuori supporto (rischio alto), prodotti a rilascio continuo rimasti indietro, e ciò che esce dal supporto nei prossimi sei mesi (rischio basso per il software, medio per i sistemi) da pianificare.':
    'la fin de support des logiciels et des systèmes d’exploitation : déjà hors support (risque élevé), produits à publication continue restés en arrière, et ce qui sort du support dans les six prochains mois (risque faible pour les logiciels, moyen pour les systèmes) à planifier.',
  'le licenze delle librerie per famiglia — permissive, copyleft debole, copyleft forte, altre, non dichiarate — con quali librerie e server le usano.':
    'les licences des bibliothèques par famille — permissives, copyleft faible, copyleft fort, autres, non déclarées — avec quelles bibliothèques et quels serveurs les utilisent.',
  'Aggiungi a una Business App…':
    'Ajouter à une Business App…',
  'Aggiungi funzionalità':
    'Ajouter une fonctionnalité',
  'Apri la Mappa Software':
    'Ouvrir la carte logicielle',
  'Business App':
    'Business App',
  'Business App ({n})':
    'Business Apps ({n})',
  'Business service che la usano ({n})':
    'Services métier qui l’utilisent ({n})',
  'CI al centro':
    'CI au centre',
  'CI da cui partire':
    'CI de départ',
  'Cerca un server per nome o indirizzo':
    'Rechercher un serveur par nom ou adresse',
  'Cerca un server per nome o indirizzo: la mappa parte da lì e segue le chiamate dei suoi programmi.':
    'Recherchez un serveur par nom ou adresse : la carte part de là et suit les appels de ses programmes.',
  'Che cosa fa l’applicazione per chi la usa, ciascuna con la sua criticità. La criticità dell’app è la più alta fra le sue funzionalità e passa ai Business Service che la usano.':
    'Ce que l’application fait pour ses utilisateurs, chacune avec sa criticité. La criticité de l’app est la plus élevée de ses fonctionnalités et passe aux services métier qui l’utilisent.',
  'Chiamate dai flussi di rete':
    'Appels issus des flux réseau',
  'Clic su un programma per sceglierlo, sul nome di un server per metterlo al centro; ⁺ indica altre chiamate oltre la profondità.':
    'Cliquez sur un programme pour le choisir, sur le nom d’un serveur pour le centrer ; ⁺ indique d’autres appels au-delà de la profondeur.',
  'Connessioni stabilite':
    'Connexions établies',
  'Crea Business App':
    'Créer la Business App',
  'Crea un servizio':
    'Créer un service',
  'Creare una Business App richiede il ruolo di amministratore del tenant.':
    'Créer une Business App nécessite le rôle d’administrateur du tenant.',
  'Descrizione (facoltativa)':
    'Description (facultative)',
  'Elementi':
    'Éléments',
  'Elementi ({n})':
    'Éléments ({n})',
  'Eliminare la Business App «{nome}»?':
    'Supprimer la Business App « {nome} » ?',
  'Eliminare la funzionalità «{nome}»?':
    'Supprimer la fonctionnalité « {nome} » ?',
  'Escludi il programma che chiama':
    'Exclure le programme appelant',
  'Esclusi':
    'Exclus',
  'Fatto':
    'Fait',
  'Funzionalità':
    'Fonctionnalités',
  'Funzionalità ({n})':
    'Fonctionnalités ({n})',
  'Gli elementi si aggiungono dalla Mappa Software: si sceglie un CI, si cliccano i programmi e si aggiungono all’app.':
    'Les éléments s’ajoutent depuis la carte logicielle : choisissez un CI, cliquez sur les programmes et ajoutez-les à l’app.',
  'I programmi che compongono l’app, sui loro CI. Si aggiungono dalla Mappa Software.':
    'Les programmes qui composent l’app, sur leurs CI. Ils s’ajoutent depuis la carte logicielle.',
  'rappresenta le dipendenze applicative di un CI a partire dai programmi in esecuzione, dalle porte in ascolto e dalle comunicazioni locali e remote. Distingue le dipendenze in ingresso e in uscita e consente di filtrare i componenti rilevanti per costruire una Business App.': 'Représente les dépendances applicatives d’un CI à partir des programmes en cours d’exécution, des ports en écoute et des communications locales et distantes. Il distingue les dépendances entrantes et sortantes et permet de filtrer les composants pertinents pour construire une Business App.',
  'Ingrandisci':
    'Agrandir',
  'Applicazioni: descrivono i servizi dal punto di vista degli utenti, specificando i software che li compongono, le funzionalità e la criticità. La criticità più alta viene ereditata dai Business Service che li utilizzano e dai CI che li eseguono.': 'Applications : décrivent les services du point de vue des utilisateurs, en précisant les logiciels qui les composent, les fonctionnalités et la criticité. La criticité la plus élevée est héritée par les Business Services qui les utilisent et par les CI qui les exécutent.',
  'Le applicazioni di cui il servizio è fatto. Il servizio eredita la criticità più alta fra le loro funzionalità, se è più alta di quella dichiarata, e i CI che eseguono i loro elementi diventano suoi componenti.':
    'Les applications dont le service est fait. Le service hérite la criticité la plus élevée de leurs fonctionnalités si elle dépasse celle déclarée, et les CI qui exécutent leurs éléments deviennent ses composants.',
  'Le chiamate per processo arrivano dalle connessioni stabilite lette dall’inventario avanzato (SSH o WinRM) e dall’agente CENSO, quelle OpenTelemetry dall’agente, le altre dai flussi di rete (tratteggiate, con il processo che chiama non noto). Il nome di un server lo mette al centro; × esclude un server o un programma; DNS, NTP, monitoraggio e controller di dominio sono nascosti salvo chiederli. Cliccando i programmi li si sceglie e se ne fa una Business App, o li si aggiunge a una esistente. Non richiede l’add-on SBOM: con lo SBOM i programmi hanno anche il nome dell’applicazione.':
    'Les appels par processus proviennent des connexions établies lues par l’inventaire avancé (SSH ou WinRM) et par l’agent CENSO, les appels OpenTelemetry de l’agent, les autres des flux réseau (en pointillés, processus appelant inconnu). Le nom d’un serveur le centre ; × exclut un serveur ou un programme ; DNS, NTP, supervision et contrôleurs de domaine sont masqués sauf demande. En cliquant sur les programmes on les choisit pour en faire une Business App ou les ajouter à une existante. L’add-on SBOM n’est pas requis : avec le SBOM, les programmes portent aussi le nom de l’application.',
  'L’app non ha ancora elementi.':
    'L’app n’a pas encore d’éléments.',
  'Mappa Software':
    'Carte logiciels',
  'Metti questo CI al centro della mappa':
    'Placer ce CI au centre de la carte',
  'Nascosti':
    'Masqués',
  'Nella pagina del servizio, la card «Business App» sceglie le applicazioni di cui il servizio è fatto: il servizio eredita la loro criticità se è più alta di quella dichiarata (la card «Criticità» dice quando succede), e i CI che eseguono i loro elementi diventano componenti con ruolo «Business App» ed ereditano a loro volta. La criticità dichiarata resta quella che si modifica nel servizio.':
    'Sur la page du service, la carte « Business App » choisit les applications dont le service est fait : le service hérite leur criticité si elle dépasse celle déclarée (la carte « Criticité » l’indique), et les CI qui exécutent leurs éléments deviennent des composants de rôle « Business App » et en héritent à leur tour. La criticité déclarée reste celle que l’on modifie sur le service.',
  'Nessun elemento':
    'Aucun élément',
  'Nessuna Business App':
    'Aucune Business App',
  'Nessuna Business App collegata.':
    'Aucune Business App liée.',
  'Nessuna chiamata trovata. Le chiamate per processo arrivano dall’inventario avanzato (SSH o WinRM) e dall’agente CENSO, che leggono le connessioni stabilite; quelle OpenTelemetry dall’agente; le altre dai flussi di rete.':
    'Aucun appel trouvé. Les appels par processus proviennent de l’inventaire avancé (SSH ou WinRM) et de l’agent CENSO, qui lisent les connexions établies ; les appels OpenTelemetry de l’agent ; les autres des flux réseau.',
  'Nessuna funzionalità ancora.':
    'Aucune fonctionnalité pour l’instant.',
  'Nome della nuova Business App':
    'Nom de la nouvelle Business App',
  'Non ci sono ancora Business App: si creano dalla Mappa Software o dalla pagina Business App.':
    'Il n’y a pas encore de Business App : créez-les depuis la carte logicielle ou la page Business App.',
  'Non ci sono ancora Business Service.':
    'Il n’y a pas encore de services métier.',
  'Nuova Business App':
    'Nouvelle Business App',
  'Nuova funzionalità (es. Emissione fatture)':
    'Nouvelle fonctionnalité (ex. Émission des factures)',
  'Ognuno eredita la criticità dell’app se è più alta di quella dichiarata, e i CI degli elementi diventano suoi componenti.':
    'Chacun hérite la criticité de l’app si elle dépasse celle déclarée, et les CI des éléments deviennent ses composants.',
  'OpenTelemetry':
    'OpenTelemetry',
  'Programma':
    'Programme',
  'Realizzata da':
    'Réalisée par',
  'Riduci':
    'Réduire',
  'Rimetti sulla mappa':
    'Remettre sur la carte',
  'Scegli le Business App':
    'Choisir les Business Apps',
  'Scegli per una Business App':
    'Choisir pour une Business App',
  'Scegli un CI':
    'Choisissez un CI',
  'Servizi comuni (DNS, NTP, monitoraggio…)':
    'Services communs (DNS, NTP, supervision…)',
  'Si creano dalla Mappa Software scegliendo i programmi che compongono un’applicazione, oppure da qui con «Nuova Business App».':
    'Créez-les depuis la carte logicielle en choisissant les programmes qui composent une application, ou d’ici avec « Nouvelle Business App ».',
  'Solo i programmi con chiamate':
    'Uniquement les programmes avec appels',
  'Sulla Mappa Software si sceglie un CI, si cliccano i programmi e si aggiungono a questa app.':
    'Sur la carte logicielle, choisissez un CI, cliquez sur les programmes et ajoutez-les à cette app.',
  'apri la scheda':
    'ouvrir la fiche',
  'con errori':
    'avec erreurs',
  'connessione per processo':
    'connexion par processus',
  'connessioni':
    'connexions',
  'connessioni stabilite (per processo)':
    'connexions établies (par processus)',
  'criticità effettiva':
    'criticité effective',
  'dichiarata {a}, ereditata dalle Business App':
    'déclarée {a}, héritée des Business Apps',
  'flussi di rete':
    'flux réseau',
  'il flusso applicativo attorno a un CI, come la Topologia ma fra programmi: si sceglie un server e la mappa mostra i suoi programmi con le porte su cui ascoltano, chi li chiama (a sinistra) e cosa chiamano (a destra), fino alla profondità scelta. Le frecce collegano il programma che chiama a quello che risponde, anche sulla stessa macchina (un proxy davanti al suo application server).':
    'le flux applicatif autour d’un CI, comme la Topologie mais entre programmes : choisissez un serveur et la carte montre ses programmes avec les ports sur lesquels ils écoutent, qui les appelle (à gauche) et ce qu’ils appellent (à droite), jusqu’à la profondeur choisie. Les flèches relient le programme appelant à celui qui répond, y compris sur la même machine (un proxy devant son serveur d’applications).',
  'indirizzo non in CMDB':
    'adresse absente de la CMDB',
  'le applicazioni come le chiama chi le usa. Si creano dalla Mappa Software scegliendo i programmi che le compongono (o da qui, aggiungendo poi gli elementi dalla mappa); dentro si elencano le funzionalità, ognuna con la sua criticità. La criticità dell’app è la più alta fra le sue funzionalità.':
    'les applications telles que leurs utilisateurs les nomment. Créez-les depuis la carte logicielle en choisissant les programmes qui les composent (ou d’ici, en ajoutant ensuite les éléments depuis la carte) ; à l’intérieur, listez les fonctionnalités, chacune avec sa criticité. La criticité de l’app est la plus élevée de ses fonctionnalités.',
  'nessun processo noto in ascolto':
    'aucun processus connu en écoute',
  'nessun programma noto':
    'aucun programme connu',
  'nessuna funzionalità':
    'aucune fonctionnalité',
  'oppure':
    'ou',
  '{h} server, {p} programmi, {c} chiamate':
    '{h} serveurs, {p} programmes, {c} appels',
  '{n} connessioni o chiamate':
    '{n} connexions ou appels',
  '{n} programmi scelti':
    '{n} programmes choisis',
  '← Torna alle Business App':
    '← Retour aux Business Apps',
  'Appena installato, in qualunque modo (comando, pacchetto, dalla sonda, a mano), l’agente si annuncia: in elenco compare con il nome della macchina, il sistema e lo stato «Installato» ancora prima del primo inventario. Il nome dell’agente è facoltativo: vuoto, prende quello della macchina.':
    'Dès son installation, quelle qu’en soit la méthode (commande, paquet, depuis la sonde, à la main), l’agent s’annonce : il apparaît dans la liste avec le nom de la machine, son système et l’état « Installé » avant même le premier inventaire. Le nom de l’agent est facultatif : vide, il prend celui de la machine.',
  'Chiave d’installazione':
    'Clé d’installation',
  'Chiave d’installazione per più macchine':
    'Clé d’installation pour plusieurs machines',
  'Facoltativo: vuoto, l’agente prende il nome della macchina quando si installa e si annuncia.':
    'Facultatif : vide, l’agent prend le nom de la machine lorsqu’il s’installe et s’annonce.',
  'Gli agenti hanno i tag (colonna «Tag», ✎ per modificarli) e l’elenco si filtra per nome, macchina o tag.':
    'Les agents ont des tags (colonne « Tag », ✎ pour les modifier) et la liste se filtre par nom, machine ou tag.',
  'Il nome della chiave (es. «Server Milano»): ogni macchina compare poi in elenco con il proprio nome.':
    'Le nom de la clé (ex. « Serveurs Milan ») : chaque machine apparaît ensuite dans la liste avec son propre nom.',
  'Installato':
    'Installé',
  'La macchina si è annunciata: l’agente è installato e il primo inventario sta arrivando.':
    'La machine s’est annoncée : l’agent est installé et le premier inventaire arrive.',
  'La stessa configurazione (o lo stesso pacchetto) si installa su tutte le macchine, anche con GPO, SCCM o Ansible: al primo avvio ognuna si registra come agente a sé, con il nome della macchina, le impostazioni e i tag della chiave, e un segreto suo generato sulla macchina. Revocare la chiave ferma le nuove registrazioni, non gli agenti già registrati.':
    'La même configuration (ou le même paquet) s’installe sur toutes les machines, y compris via GPO, SCCM ou Ansible : au premier démarrage chacune s’enregistre comme agent à part entière, avec le nom de la machine, les réglages et les tags de la clé, et son propre secret généré sur la machine. Révoquer la clé arrête les nouveaux enregistrements, pas les agents déjà enregistrés.',
  'Per installare lo stesso pacchetto su molte macchine (GPO, SCCM, Ansible) si crea una «Chiave d’installazione per più macchine»: al primo avvio ogni macchina si registra come agente a sé, con il suo nome, le impostazioni e i tag della chiave e un segreto generato sulla macchina. La chiave mostra quante macchine si sono registrate; revocarla ferma le nuove registrazioni, non gli agenti già registrati.':
    'Pour installer le même paquet sur de nombreuses machines (GPO, SCCM, Ansible), créez une « Clé d’installation pour plusieurs machines » : au premier démarrage chaque machine s’enregistre comme agent à part entière, avec son nom, les réglages et les tags de la clé et un secret généré sur la machine. La clé indique combien de machines se sont enregistrées ; la révoquer arrête les nouveaux enregistrements, pas les agents déjà enregistrés.',
  'Per il mondo Linux aziendale c’è il pacchetto RPM (RHEL, Rocky, AlmaLinux, Oracle, SUSE…), che si scarica dalla finestra d’installazione con le istruzioni sempre accanto. È generico: contiene il binario e il servizio systemd «censo-inventory», non la configurazione — lo stesso pacchetto va su molti host, mentre il file con il segreto è diverso per ciascuno. Lo installa la tua piattaforma (Ansible: dnf, il template di /etc/censo/inventory.json, systemctl enable --now) e a tenerlo in piedi è systemd, non un cron.':
    'Pour le monde Linux en entreprise, il y a le paquet RPM (RHEL, Rocky, AlmaLinux, Oracle, SUSE…), téléchargé depuis la fenêtre d’installation avec les instructions toujours à côté. Il est générique : il contient le binaire et le service systemd « censo-inventory », pas la configuration — le même paquet va sur de nombreux hôtes, tandis que le fichier contenant le secret diffère pour chacun. C’est votre plateforme qui l’installe (Ansible : dnf, le template de /etc/censo/inventory.json, systemctl enable --now) et systemd, pas cron, qui le maintient en marche.',
  'Questa è una chiave d’installazione: lo stesso comando o lo stesso pacchetto vale per tutte le macchine. Ognuna, al primo avvio, si registra come agente a sé con il nome della macchina e un segreto generato lì; rigenerare la chiave non tocca le macchine già registrate. Serve l’agente nella versione corrente.':
    'Ceci est une clé d’installation : la même commande ou le même paquet vaut pour toutes les machines. Au premier démarrage chacune s’enregistre comme agent à part entière avec le nom de la machine et un secret généré sur place ; régénérer la clé ne touche pas les machines déjà enregistrées. Il faut l’agent dans sa version actuelle.',
  'Una configurazione da installare su più macchine: ognuna, al primo avvio, si registra come agente a sé con il proprio nome.':
    'Une configuration à installer sur plusieurs machines : au premier démarrage chacune s’enregistre comme agent à part entière, avec son propre nom.',
  'chiave d’installazione · {n} macchine registrate':
    'clé d’installation · {n} machines enregistrées',
  'dalla chiave «{nome}»':
    'depuis la clé « {nome} »',
  'in attesa dell’installazione':
    'en attente d’installation',
  'macchina':
    'machine',
  'nuovo agente':
    'nouvel agent',
  'Dentro la macchina':
    'Dans la machine',
  'Dentro la macchina: i servizi e le chiamate interne':
    'Dans la machine : ses services et les appels internes',
  'Nessuna chiamata interna rilevata: servono l’inventario avanzato aggiornato o l’agente CENSO, che leggono le connessioni in loopback e i socket Unix.':
    'Aucun appel interne trouvé : il faut l’inventaire avancé à jour ou l’agent CENSO, qui lisent les connexions loopback et les sockets Unix.',
  'Socket Unix in ascolto':
    'Sockets Unix en écoute',
  'da fuori':
    'de l’extérieur',
  'Dentro una macchina conta anche ciò che non passa dalla rete: le chiamate in loopback e attraverso i socket Unix (nginx → php-fpm, PHP → database locale) sono disegnate, e «dentro ⤢» sul riquadro di un server apre la vista della macchina, a livelli dall’ingresso al database. Due servizi dello stesso programma — due JVM, due app Node, due pool php-fpm — sono distinti da ciò su cui ascoltano («java :8080», «java :8081»): ognuno si mette nella sua Business App, uno critico e l’altro no, anche se usano lo stesso database.':
    'Dans une machine, ce qui ne passe pas par le réseau compte aussi : les appels en loopback et par sockets Unix (nginx → php-fpm, PHP → base locale) sont dessinés, et « dedans ⤢ » sur le cadre d’un serveur ouvre la vue de la machine, par niveaux de l’entrée à la base de données. Deux services du même programme — deux JVM, deux apps Node, deux pools php-fpm — se distinguent par ce sur quoi ils écoutent (« java :8080 », « java :8081 ») : chacun va dans sa Business App, l’un critique et l’autre non, même s’ils partagent la même base.',
  'Agente installato. Compare in Agenti d’inventario e consegna il primo inventario entro pochi minuti.':
    'Agent installé. Il apparaît dans Agents d’inventaire et livre son premier inventaire en quelques minutes.',
  'Apri gli agenti':
    'Ouvrir les agents',
  'Dalla scheda di un server o di una VM, «Installa agente» fa installare l’agente a una sonda: si sceglie la sonda, il sistema e la credenziale (SSH per Linux — root o sudo senza password —, WinRM per Windows con un amministratore), e la sonda si collega e installa. L’agente nasce legato al CI e la finestra mostra l’avanzamento e, se va male, l’uscita dell’installer.':
    'Depuis la fiche d’un serveur ou d’une VM, « Installer l’agent » fait installer l’agent par une sonde : on choisit la sonde, le système et l’identifiant (SSH pour Linux — root ou sudo sans mot de passe —, WinRM pour Windows avec un administrateur), et la sonde se connecte et installe. L’agent est lié au CI et la fenêtre montre l’avancement et, en cas d’échec, la sortie de l’installeur.',
  'Gestisci le credenziali':
    'Gérer les identifiants',
  'Il CI non ha un indirizzo di gestione: la sonda non saprebbe a cosa collegarsi.':
    'Le CI n’a pas d’adresse de gestion : la sonde ne saurait pas à quoi se connecter.',
  'Il sistema del CI non è noto: sceglilo.':
    'Le système du CI n’est pas connu : choisissez-le.',
  'Installa':
    'Installer',
  'Installa agente':
    'Installer l’agent',
  'Installa l’agente CENSO':
    'Installer l’agent CENSO',
  'Installazione avviata: agente «{nome}».':
    'Installation lancée : agent « {nome} ».',
  'Installazione non riuscita: {motivo}':
    'Installation échouée : {motivo}',
  'La sonda scelta si collega alla macchina — SSH su Linux, WinRM su Windows — e installa l’agente, lo stesso installer che si incollerebbe a mano. L’agente nasce legato a questo CI e si annuncia appena parte.':
    'La sonde choisie se connecte à la machine — SSH sous Linux, WinRM sous Windows — et installe l’agent, le même installeur que l’on collerait à la main. L’agent est lié à ce CI et s’annonce dès son démarrage.',
  'La sonda si collega alla macchina e installa l’agente CENSO':
    'La sonde se connecte à la machine et installe l’agent CENSO',
  'La sonda sta installando… (stato: {s})':
    'La sonde installe… (état : {s})',
  'Reinstalla comunque':
    'Réinstaller quand même',
  'Se la sonda ha il ricevitore delle consegne acceso, la macchina scarica l’installer da lei e le consegna l’inventario; altrimenti usa il Control Plane.':
    'Si le récepteur de livraisons de la sonde est actif, la machine télécharge l’installeur chez elle et lui livre l’inventaire ; sinon elle utilise le Control Plane.',
  'Sonda che installa':
    'Sonde qui installe',
  'Su questo CI c’è già un agente attivo: «{nome}».':
    'Ce CI a déjà un agent actif : « {nome} ».',
  'Un amministratore della macchina. WinRM deve essere attivo (HTTPS sulla 5986, o HTTP sulla 5985).':
    'Un administrateur de la machine. WinRM doit être actif (HTTPS sur 5986, ou HTTP sur 5985).',
  'WinRM in HTTPS (5986)':
    'WinRM en HTTPS (5986)',
  'da aggiornare':
    'à mettre à jour',
  'ha scoperto il CI':
    'a découvert le CI',
  'l’agente consegnerà a questa sonda':
    'l’agent livrera à cette sonde',
  'root, oppure un utente con sudo senza password: l’installazione non può rispondere a una richiesta di password.':
    'root, ou un utilisateur avec sudo sans mot de passe : l’installation ne peut pas répondre à une demande de mot de passe.',
  'Linux (SSH)':
    'Linux (SSH)',
  'API server':
    'API server',
  'Apache CloudStack':
    'Apache CloudStack',
  'Application credential':
    'Application credential',
  'Default':
    'Default',
  'ID':
    'ID',
  'Keystone':
    'Keystone',
  'KVM / libvirt':
    'KVM / libvirt',
  'OpenStack':
    'OpenStack',
  'RegionOne':
    'RegionOne',
  'admin':
    'admin',
  'https://cloudstack.example.com/client/api':
    'https://cloudstack.example.com/client/api',
  'https://k8s.example.com:6443':
    'https://k8s.example.com:6443',
  'https://keystone.example.com:5000/v3':
    'https://keystone.example.com:5000/v3',
  'public':
    'public',
  'Chiave API e chiave segreta':
    'Clé API et clé secrète',
  'Chiave segreta':
    'Clé secrète',
  'Classe ingress':
    'Classe d’ingress',
  'Cluster Kubernetes':
    'Cluster Kubernetes',
  "Come chiamare il cluster in CMDB; vuoto: l'indirizzo dell'API server.":
    'Nom du cluster dans la CMDB ; vide : l’adresse de l’API server.',
  "Da «Accounts → utente → Generate keys». Una chiave di amministratore (root o di dominio) legge tutta l'installazione; quella di un utente, il suo account. La chiave segreta firma le richieste e non viene mai inviata.":
    'Depuis « Accounts → utilisateur → Generate keys ». Une clé d’administrateur (root ou de domaine) lit toute l’installation ; celle d’un utilisateur, son compte. La clé secrète signe les requêtes et n’est jamais envoyée.',
  'Dominio del progetto':
    'Domaine du projet',
  "Dominio dell'utente":
    'Domaine de l’utilisateur',
  'Host KVM senza piattaforma sopra, via SSH con soli comandi «virsh» in lettura: macchine virtuali (UUID, vCPU, memoria, dischi, interfacce), stato e pool di archiviazione. I bersagli sono gli indirizzi degli host.':
    'Hôtes KVM sans plateforme au-dessus, via SSH avec uniquement des commandes « virsh » en lecture : machines virtuelles (UUID, vCPU, mémoire, disques, interfaces), état et pools de stockage. Les cibles sont les adresses des hôtes.',
  'IP del cluster':
    'IP du cluster',
  'Il certificato e la chiave di un utente del kubeconfig («client-certificate-data» e «client-key-data», decodificati). Meglio un service account dedicato: un certificato client non si revoca da solo.':
    'Le certificat et la clé d’un utilisateur du kubeconfig (« client-certificate-data » et « client-key-data », décodés). Mieux vaut un service account dédié : un certificat client ne se révoque pas seul.',
  "Il cluster dall'API server (anche k3s, RKE2, OpenShift): nodi, workload (Deployment, StatefulSet, DaemonSet, CronJob) con immagini e repliche, servizi e ingress. I pod non diventano CI: si contano sui loro workload.":
    'Le cluster depuis l’API server (aussi k3s, RKE2, OpenShift) : nœuds, workloads (Deployment, StatefulSet, DaemonSet, CronJob) avec images et répliques, services et ingress. Les pods ne deviennent pas des CI : ils sont comptés sur leurs workloads.',
  'Indirizzi esterni':
    'Adresses externes',
  'Interfaccia degli endpoint':
    'Interface des endpoints',
  'Istanze (con flavor, immagine, progetto, indirizzi fissi e floating, volumi), hypervisor, reti e bilanciatori Octavia di un cloud OpenStack, via Keystone v3 in sola lettura. Hypervisor e «tutti i progetti» richiedono un ruolo di amministratore.':
    'Instances (avec flavor, image, projet, adresses fixes et flottantes, volumes), hyperviseurs, réseaux et répartiteurs Octavia d’un cloud OpenStack, via Keystone v3 en lecture seule. Hyperviseurs et « tous les projets » nécessitent un rôle d’administrateur.',
  "L'indirizzo dell'API server (quello di «server:» nel kubeconfig).":
    'L’adresse de l’API server (celle de « server: » dans le kubeconfig).',
  'La regione da leggere; vuota: la prima del catalogo.':
    'La région à lire ; vide : la première du catalogue.',
  'Legge istanze, volumi e IP di tutti i progetti: serve un ruolo di amministratore (o «reader» di sistema). Spenta: il solo progetto della credenziale.':
    'Lit instances, volumes et IP de tous les projets : nécessite un rôle d’administrateur (ou « reader » système). Désactivé : le seul projet de l’identifiant.',
  'Progetto':
    'Projet',
  'Repliche previste':
    'Répliques prévues',
  'Repliche pronte':
    'Répliques prêtes',
  'Revocabile da sola, legata a un progetto e con i ruoli scelti alla creazione («openstack application credential create --role reader»).':
    'Révocable seule, liée à un projet et avec les rôles choisis à la création (« openstack application credential create --role reader »).',
  'Segreto':
    'Secret',
  'Tipo di servizio':
    'Type de service',
  'Tipo di workload':
    'Type de workload',
  'Token di un service account':
    'Jeton d’un service account',
  'Tutti i progetti':
    'Tous les projets',
  'URL del management server; «/client/api» si aggiunge da sé se manca.':
    'URL du management server ; « /client/api » est ajouté s’il manque.',
  'URL di Keystone (identity v3); «/v3» si aggiunge da sé se manca.':
    'URL de Keystone (identity v3) ; « /v3 » est ajouté s’il manque.',
  'Un service account con un ClusterRole in sola lettura (get, list su nodes, namespaces, pods, services, replicasets, deployments, statefulsets, daemonsets, cronjobs, ingresses). Il certificato della CA va in «Certificato della CA» («certificate-authority-data» del kubeconfig, decodificato).':
    'Un service account avec un ClusterRole en lecture seule (get, list sur nodes, namespaces, pods, services, replicasets, deployments, statefulsets, daemonsets, cronjobs, ingresses). Le certificat de la CA va dans « Certificat de la CA » (« certificate-authority-data » du kubeconfig, décodé).',
  'Un utente con il ruolo «reader» basta per leggere; per gli hypervisor serve «admin».':
    'Un utilisateur avec le rôle « reader » suffit pour lire ; les hyperviseurs nécessitent « admin ».',
  'Zone, cluster, host, macchine virtuali (offerta, template, account, NIC, volumi, IP pubblici), reti e regole di bilanciamento, con richieste firmate in sola lettura.':
    'Zones, clusters, hôtes, machines virtuelles (offre, template, compte, NIC, volumes, IP publiques), réseaux et règles de répartition, avec des requêtes signées en lecture seule.',
  'produzione':
    'production',
  'public (predefinita), internal o admin: quella che la sonda raggiunge.':
    'public (par défaut), internal ou admin : celle que la sonde atteint.',
  'I connettori di virtualizzazione (VMware, Microsoft Hyper-V, Nutanix, Proxmox, Sangfor, NexaVM, NexaSphere, ZStack, OpenStack, Apache CloudStack, KVM, Oracle Linux Virtualization Manager) leggono cluster, host, macchine virtuali, datastore e reti direttamente dalla piattaforma; il connettore Kubernetes legge il cluster: nodi, workload, servizi e ingress.':
    'Les connecteurs de virtualisation (VMware, Microsoft Hyper-V, Nutanix, Proxmox, Sangfor, NexaVM, NexaSphere, ZStack, OpenStack, Apache CloudStack, KVM, Oracle Linux Virtualization Manager) lisent clusters, hôtes, machines virtuelles, datastores et réseaux directement depuis la plateforme ; le connecteur Kubernetes lit le cluster : nœuds, workloads, services et ingress.',
  'OpenStack: credenziale con l’indirizzo di Keystone e un’application credential (o utente, password e progetto); con «Tutti i progetti» e un ruolo di amministratore legge anche gli hypervisor e le istanze di ogni progetto. Apache CloudStack: chiave API e chiave segreta di un amministratore; si leggono zone, cluster, host, VM (anche quelle dentro i progetti), router virtuali e VM di sistema, volumi, datastore primari e secondari, reti di progetto e reti fisiche. KVM senza piattaforma: i bersagli sono gli host e la credenziale è quella SSH; la sonda usa solo comandi «virsh» in lettura. OLVM (e oVirt, Red Hat Virtualization): indirizzo dell’engine e un utente in sola lettura scritto con il profilo («lettore@internal»), o un token SSO; gli indirizzi delle VM arrivano solo se sull’ospite c’è il guest agent. Kubernetes: indirizzo dell’API server e token di un service account con un ClusterRole in sola lettura (il modello pronto è nella documentazione); i pod non diventano CI, si contano sui workload.':
    'OpenStack : identifiant avec l’adresse de Keystone et une application credential (ou utilisateur, mot de passe et projet) ; avec «Tous les projets» et un rôle d’administrateur, il lit aussi les hyperviseurs et les instances de chaque projet. Apache CloudStack : clé API et clé secrète d’un administrateur ; on lit zones, clusters, hôtes, VM (y compris celles des projets), routeurs virtuels et VM système, volumes, datastores primaires et secondaires, réseaux de projet et réseaux physiques. KVM sans plateforme : les cibles sont les hôtes et l’identifiant est celui SSH ; la sonde n’utilise que des commandes «virsh» en lecture. OLVM (et oVirt, Red Hat Virtualization) : adresse du moteur et un utilisateur en lecture seule écrit avec son profil («lecteur@internal»), ou un jeton SSO ; les adresses des VM n’arrivent que si l’agent invité tourne sur l’invité. Kubernetes : adresse de l’API server et jeton d’un service account avec un ClusterRole en lecture seule (le modèle prêt à l’emploi est dans la documentation) ; les pods ne deviennent pas des CI, ils sont comptés sur les workloads.',
  'Accesa ma non attiva.':
    'Activée mais pas active.',
  'Attiva.':
    'Active.',
  'Osserva le richieste HTTP di tutte le applicazioni con eBPF, senza toccarle (Linux, CENSO SBOM)':
    'Observer les requêtes HTTP de toutes les applications avec eBPF, sans les toucher (Linux, CENSO SBOM)',
  'Osservazione applicativa':
    'Observation applicative',
  'Spenta.':
    'Désactivée.',
  'Un programma eBPF guarda le chiamate di sistema e riconosce le richieste e le risposte HTTP di ogni processo, lato server e lato client: metodo, percorso, codice di stato e tempo di risposta, senza agenti nelle applicazioni né riavvii. Escono dal kernel solo la riga della richiesta e il codice di stato, mai header o contenuti; i parametri della richiesta si scartano. Il risultato va nella sezione Runtime del CI e nella Mappa Software, insieme a OpenTelemetry. Serve Linux 5.8 o successivo con BTF e l’agente residente come root; l’HTTPS è cifrato a quel livello e non si vede ancora.':
    'Un programme eBPF observe les appels système et reconnaît les requêtes et réponses HTTP de chaque processus, côté serveur et côté client : méthode, chemin, code d’état et temps de réponse, sans agent dans les applications ni redémarrage. Seules la ligne de requête et le code d’état sortent du noyau, jamais les en-têtes ni le contenu ; les paramètres de la requête sont écartés. Le résultat va dans la section Runtime du CI et sur la carte logicielle, avec OpenTelemetry. Nécessite Linux 5.8 ou ultérieur avec BTF et l’agent résident en root ; le HTTPS est chiffré à ce niveau et n’est pas encore visible.',
  'Adatta':
    'Ajuster',
  'Certificati TLS esposti':
    'Certificats TLS exposés',
  'Certificati TLS esposti ({n})':
    'Certificats TLS exposés ({n})',
  'Certificati TLS esposti: l’agente CENSO fa una stretta di mano TLS verso ogni porta in ascolto della macchina — anche quelle raggiungibili solo in locale — e ne legge il certificato: soggetto, nomi alternativi, emittente, scadenza, chiave, firma, impronta, autofirmato. Li trovi nella sezione «Certificati» del CI, ordinati per scadenza.':
    'Certificats TLS exposés : l’agent CENSO effectue une poignée de main TLS vers chaque port en écoute de la machine — y compris ceux accessibles seulement en local — et en lit le certificat : sujet, noms alternatifs, émetteur, expiration, clé, signature, empreinte, auto-signé. Vous les trouvez dans la section « Certificats » du CI, triés par expiration.',
  'Chi chiama':
    'Appelant',
  'Chi risponde':
    'Répondant',
  'Chiamate o flussi':
    'Appels ou flux',
  'Chiave e protocollo':
    'Clé et protocole',
  'Cifrata (TLS)':
    'Chiffré (TLS)',
  'Cifratura non nota':
    'Chiffrement inconnu',
  'Clic su una chiamata o su un programma.':
    'Cliquez sur un appel ou un programme.',
  'Clic su un’altra chiamata o su un programma per cambiare; clic sullo stesso per togliere.':
    'Cliquez sur un autre appel ou programme pour changer ; sur le même pour effacer.',
  'Come lo sappiamo':
    'Comment nous le savons',
  'Coppie in chiaro':
    'Paires en clair',
  'Esci dallo schermo intero (Esc)':
    'Quitter le plein écran (Échap)',
  'l’agente CENSO esegue un handshake TLS verso le porte in ascolto dell’asset per rilevare i certificati esposti dai servizi e verificarne caratteristiche, validità e scadenza.': 'l’agent CENSO effectue un handshake TLS vers les ports en écoute de l’actif pour détecter les certificats exposés par les services et en vérifier les caractéristiques, la validité et l’expiration.',
  'I servizi della macchina e le chiamate fra loro (loopback, indirizzi della macchina, socket Unix), con chi chiama da fuori a sinistra e dove si esce a destra. Passa sopra un servizio per vederne le chiamate; cliccalo per i dettagli.':
    'Les services de la machine et les appels entre eux (loopback, adresses de la machine, sockets Unix), avec les appelants extérieurs à gauche et les sorties à droite. Survolez un service pour voir ses appels ; cliquez pour les détails.',
  'In ascolto':
    'En écoute',
  'In chiaro fra due macchine':
    'En clair entre deux machines',
  'In entrata ({n})':
    'Entrants ({n})',
  'In uscita ({n})':
    'Sortants ({n})',
  'Le chiamate sono colorate per tipo (web, database, code, infrastruttura, socket locali); la linea spessa è misurata dal runtime, quella tratteggiata viene solo dai flussi. «Segui il percorso» accende tutto il giro di una chiamata o di un programma — da dove parte a dove arriva, con un’animazione nel verso delle chiamate — e «Schermo intero» allarga la mappa. «Dentro la macchina» si apre in una finestra: colonne da chi chiama da fuori a dove si esce, passaggio del mouse per le chiamate di un servizio, clic per i suoi dettagli.':
    'Les appels sont colorés par type (web, base de données, files, infrastructure, sockets locaux) ; une ligne épaisse est mesurée par le runtime, une ligne pointillée vient seulement des flux. « Suivre le parcours » illumine tout le trajet d’un appel ou d’un programme — d’où il part à où il arrive, animé dans le sens des appels — et « Plein écran » agrandit la carte. « Dans la machine » s’ouvre dans une fenêtre : colonnes des appelants extérieurs aux sorties, survol pour les appels d’un service, clic pour ses détails.',
  'Individua le coppie di asset che comunicano in chiaro, esponendo potenzialmente dati e credenziali a chi può osservare il traffico. Le evidenze sono ordinate per affidabilità: traffico HTTP non cifrato osservato a livello applicativo, processi associati a protocolli intrinsecamente non cifrati e flussi di rete sulle relative porte. I protocolli che possono usare TLS sulla stessa porta vengono segnalati solo quando il traffico in chiaro è stato effettivamente osservato. Le comunicazioni interne allo stesso host sono escluse.': 'Repère les paires d’actifs qui communiquent en clair, exposant potentiellement données et identifiants à quiconque peut observer le trafic. Les preuves sont classées par fiabilité : trafic HTTP non chiffré observé au niveau applicatif, processus associés à des protocoles intrinsèquement non chiffrés et flux réseau sur les ports correspondants. Les protocoles pouvant utiliser TLS sur le même port ne sont signalés que lorsque du trafic en clair a été réellement observé. Les communications internes au même hôte sont exclues.',
  'Le prove arrivano dalle connessioni lette dall’agente CENSO e dall’inventario avanzato, dall’osservazione applicativa (eBPF) e dai flussi di rete.':
    'Les preuves viennent des connexions lues par l’agent CENSO et l’inventaire avancé, de l’observation applicative (eBPF) et des flux réseau.',
  'Macchine che chiamano in chiaro':
    'Machines appelant en clair',
  'Nessun traffico in chiaro trovato':
    'Aucun trafic en clair trouvé',
  'Osservazione applicativa (eBPF): con l’interruttore acceso nelle impostazioni di un agente Linux, l’agente vede le richieste e le risposte HTTP di tutte le applicazioni del server — lato server e lato client — direttamente dal kernel, senza toccarle né riavviarle: metodo, percorso, codice di stato e tempo di risposta. Finiscono nella stessa sezione «Runtime» e nella Mappa Software, insieme a OpenTelemetry. Serve Linux 5.8 o successivo con BTF. Anche l’HTTPS si vede, per le applicazioni che usano OpenSSL (nginx, Apache, PHP, Python, curl…): l’agente legge la richiesta prima della cifratura; il TLS proprio di Go e Java non ancora.':
    'Observation applicative (eBPF) : avec l’interrupteur activé dans les réglages d’un agent Linux, l’agent voit les requêtes et réponses HTTP de toutes les applications du serveur — côté serveur et côté client — directement depuis le noyau, sans les toucher ni les redémarrer : méthode, chemin, code d’état et temps de réponse. Elles vont dans la même section « Runtime » et sur la carte logicielle, avec OpenTelemetry. Nécessite Linux 5.8 ou ultérieur avec BTF. Le HTTPS est visible aussi, pour les applications utilisant OpenSSL (nginx, Apache, PHP, Python, curl…) : l’agent lit la requête avant le chiffrement ; le TLS propre à Go et Java pas encore.',
  'Per protocollo':
    'Par protocole',
  'Scegli una chiamata o un programma: si illumina tutto il giro, da dove parte a dove arriva':
    'Choisissez un appel ou un programme : tout son trajet s’illumine, d’où il part à où il arrive',
  'Segui il percorso':
    'Suivre le parcours',
  'Server che rispondono in chiaro':
    'Serveurs répondant en clair',
  'Soggetto':
    'Sujet',
  'Togli dalla scelta':
    'Retirer de la sélection',
  'Traffico in chiaro':
    'Trafic en clair',
  'altro':
    'autre',
  'autofirmato':
    'auto-signé',
  'chiama da fuori':
    'appelle depuis l’extérieur',
  'cifrata':
    'chiffré',
  'code e messaggi':
    'files et messages',
  'coppie':
    'paires',
  'database':
    'base de données',
  'fuori dalla macchina':
    'hors de la machine',
  'in chiaro':
    'en clair',
  'in chiaro fra macchine':
    'en clair entre machines',
  'linea spessa: misurata dal runtime (eBPF, OpenTelemetry)':
    'ligne épaisse : mesurée par le runtime (eBPF, OpenTelemetry)',
  'scade fra {n} giorni':
    'expire dans {n} jours',
  'servizi d’infrastruttura':
    'services d’infrastructure',
  'socket locali':
    'sockets locaux',
  'solo dai flussi di rete':
    'uniquement depuis les flux réseau',
  'valido ancora {n} giorni':
    'valide encore {n} jours',
  'verso fuori':
    'vers l’extérieur',
  'visto dal runtime':
    'vu par le runtime',
  'web (HTTP/HTTPS)':
    'web (HTTP/HTTPS)',
  '{i} in entrata · {u} in uscita':
    '{i} entrants · {u} sortants',
  'Apri il CI':
    'Ouvrir le CI',
  'Il pacchetto {pacchetto} ({n} CVE aperte)':
    'Le paquet {pacchetto} ({n} CVE ouvertes)',
  'Le librerie dell’applicazione confrontate con il catalogo OSV. «Portata da» è la catena di dipendenze che la fa entrare: si corregge aggiornando la prima della catena.':
    'Les bibliothèques de l’application confrontées au catalogue OSV. « Apportée par » est la chaîne de dépendances qui l’introduit : on la corrige en mettant à jour la première de la chaîne.',
  'Librerie vulnerabili ({n} su {totale})':
    'Bibliothèques vulnérables ({n} sur {totale})',
  'Nessuna CVE aperta sul pacchetto':
    'Aucune CVE ouverte sur le paquet',
  'Nessuna libreria vulnerabile':
    'Aucune bibliothèque vulnérable',
  'Per questo programma non ci sono librerie né pacchetto noti.':
    'Aucune bibliothèque ni paquet connus pour ce programme.',
  'Si chiudono aggiornando il pacchetto':
    'Elles se ferment en mettant à jour le paquet',
  'Sulla Mappa Software un programma con librerie vulnerabili o con CVE aperte sul proprio pacchetto ha un badge ⚠ con il numero — rosso se una è sfruttata attivamente o critica. Cliccandolo si apre l’elenco: per ogni libreria la versione, se è diretta o transitiva, da quale dipendenza è portata dentro, la versione che la corregge e gli avvisi uno per uno; sotto, le CVE del pacchetto con il comando per aggiornarlo.':
    'Sur la carte logicielle, un programme avec des bibliothèques vulnérables ou des CVE ouvertes sur son propre paquet porte un badge ⚠ avec le nombre — rouge si l’une est activement exploitée ou critique. Un clic ouvre la liste : pour chaque bibliothèque la version, si elle est directe ou transitive, quelle dépendance l’apporte, la version qui la corrige et les avis un par un ; en dessous, les CVE du paquet avec la commande pour le mettre à jour.',
  'Vulnerabilità del programma':
    'Vulnérabilités du programme',
  'Vulnerabilità di {programma}':
    'Vulnérabilités de {programma}',
  'clic per il dettaglio':
    'cliquez pour le détail',
  'corretta in':
    'corrigée en',
  'installata':
    'installée',
  'portata da':
    'apportée par',
  'sfruttata attivamente':
    'activement exploitée',
  '{n} CVE del pacchetto':
    '{n} CVE du paquet',
  '{n} librerie vulnerabili':
    '{n} bibliothèques vulnérables',
  'Finestra breve: i flussi di rete sono quelli degli ultimi minuti, le chiamate misurate dal runtime sono contate per ora (si vede l’ora in corso) e le connessioni sono quelle dell’ultimo inventario.':
    'Fenêtre courte : les flux réseau sont ceux des dernières minutes, les appels mesurés par le runtime sont comptés par heure (l’heure en cours est affichée) et les connexions sont celles du dernier inventaire.',
  'Sulla Mappa Software il selettore «Traffico» scende fino agli ultimi 5 minuti, per vedere chi sta chiamando chi adesso. Su finestre sotto l’ora i flussi di rete sono quelli esatti, mentre le chiamate misurate dal runtime sono contate per ora e le connessioni sono quelle dell’ultimo inventario.':
    'Sur la carte logicielle, le sélecteur « Trafic » descend jusqu’aux 5 dernières minutes, pour voir qui appelle qui en ce moment. Sur les fenêtres de moins d’une heure, les flux réseau sont exacts, tandis que les appels mesurés par le runtime sont comptés par heure et les connexions sont celles du dernier inventaire.',
  'ultime 6 ore':
    '6 dernières heures',
  'ultimi 15 minuti':
    '15 dernières minutes',
  'ultimi 5 minuti':
    '5 dernières minutes',
  'Dove si trova':
    'Où elle se trouve',
  'Dove si trova ({n} file)':
    'Où elle se trouve ({n} fichiers)',
  'JAR dentro l’archivio':
    'JAR dans l’archive',
  'La libreria è impacchettata dentro l’applicazione: va ricostruito e ridistribuito l’archivio con la versione nuova.':
    'La bibliothèque est empaquetée dans l’application : il faut reconstruire et redéployer l’archive avec la nouvelle version.',
  'Nella scheda di ogni server la sezione «Software (SBOM)»: le applicazioni con i loro componenti, il filtro «Solo i componenti vulnerabili», l’importazione e il download in CycloneDX, di tutto il CI oppure di una sola applicazione («Scarica CycloneDX» dentro l’applicazione, e su ogni riga della vista «Applicazioni» di Application Maintenance). Per ogni libreria si legge dove si trova e cos’è quel file (un eseguibile Go che la contiene compilata, un JAR, una cartella di node_modules…) e come si corregge; se la stessa versione è in più file, è una riga sola con l’elenco dei file. Nella vista ad albero un pallino pieno segna le librerie vulnerabili e uno vuoto le dipendenze che le portano dentro; «Solo le catene che portano a una libreria vulnerabile» lascia aperti solo quei rami.':
    'Dans la fiche de chaque serveur, la section « Logiciels (SBOM) » : les applications avec leurs composants, le filtre « Seulement les composants vulnérables », l’import et le téléchargement CycloneDX, de tout le CI ou d’une seule application (« Télécharger CycloneDX » dans l’application, et sur chaque ligne de la vue « Applications » d’Application Maintenance). Pour chaque bibliothèque on lit où elle se trouve et ce qu’est ce fichier (un exécutable Go qui la contient compilée, un JAR, un dossier node_modules…) et comment la corriger ; si la même version est dans plusieurs fichiers, c’est une seule ligne avec la liste des fichiers. Dans la vue en arbre, un point plein marque les bibliothèques vulnérables et un point vide les dépendances qui les apportent ; « Seulement les chaînes menant à une bibliothèque vulnérable » ne garde ouvertes que ces branches.',
  'Non è un file a parte: va ricompilato il programma con la versione nuova del modulo (o installata la sua versione aggiornata).':
    'Ce n’est pas un fichier séparé : il faut recompiler le programme avec la nouvelle version du module (ou installer sa version mise à jour).',
  'Si aggiorna con bundler nella cartella del progetto.':
    'Mettez-la à jour avec bundler dans le dossier du projet.',
  'Si aggiorna con composer nella cartella del progetto.':
    'Mettez-la à jour avec composer dans le dossier du projet.',
  'Si aggiorna con pip nell’ambiente che contiene questa cartella (virtualenv o Python di sistema).':
    'Mettez-la à jour avec pip dans l’environnement contenant ce dossier (virtualenv ou Python système).',
  'Si aggiorna il pacchetto NuGet nel progetto e si ripubblica l’applicazione.':
    'Mettez à jour le paquet NuGet dans le projet et republiez l’application.',
  'Si aggiorna la dipendenza nel progetto e si reinstalla (npm, yarn o pnpm).':
    'Mettez à jour la dépendance dans le projet et réinstallez (npm, yarn ou pnpm).',
  'Si sostituisce il JAR con la versione nuova, o si aggiorna la dipendenza e si ridistribuisce l’applicazione.':
    'Remplacez le JAR par la nouvelle version, ou mettez à jour la dépendance et redéployez l’application.',
  'Solo le catene che portano a una libreria vulnerabile':
    'Seulement les chaînes menant à une bibliothèque vulnérable',
  'cartella del pacchetto in node_modules':
    'dossier du paquet dans node_modules',
  'compilata dentro l’eseguibile':
    'compilée dans l’exécutable',
  'elencata nel file dei pacchetti .NET':
    'listée dans le fichier des paquets .NET',
  'elencata nel file delle dipendenze':
    'listée dans le fichier des dépendances',
  'elencata nel file delle dipendenze PHP':
    'listée dans le fichier des dépendances PHP',
  'elencata nel file delle dipendenze Ruby':
    'listée dans le fichier des dépendances Ruby',
  'elencata nel manifesto delle dipendenze .NET':
    'listée dans le manifeste des dépendances .NET',
  'file JAR':
    'fichier JAR',
  'in {n} file':
    'dans {n} fichiers',
  'pacchetto Python installato':
    'paquet Python installé',
  'porta dentro {n} librerie vulnerabili':
    'apporte {n} bibliothèques vulnérables',
  'trovata in':
    'trouvée dans',
  'vulnerabile':
    'vulnérable',
  '● vulnerabile · ○ porta dentro una libreria vulnerabile':
    '● vulnérable · ○ apporte une bibliothèque vulnérable',
  'Asset che sostengono funzioni critiche o importanti, monitorati':
    'Actifs supportant des fonctions critiques ou importantes, surveillés',
  'Asset con distinta dei componenti (SBOM)':
    'Actifs avec nomenclature logicielle (SBOM)',
  'CENSO Eagle non è in uso: il monitoraggio va dimostrato con lo strumento adottato.':
    'CENSO Eagle n’est pas utilisé : la surveillance doit être démontrée avec l’outil adopté.',
  'Certificati TLS letti dall’agente':
    'Certificats TLS lus par l’agent',
  'Componenti software di terze parti':
    'Composants logiciels tiers',
  'Concentrazione':
    'Concentration',
  'Cosa vede la piattaforma':
    'Ce que voit la plateforme',
  'Da sistemare':
    'À corriger',
  'Evidenze':
    'Preuves',
  'Evidenze dalla piattaforma':
    'Preuves issues de la plateforme',
  'Fornitori ICT terzi e concentrazione (artt. 28–29)':
    'Prestataires tiers de TIC et concentration (art. 28–29)',
  'Funzioni':
    'Fonctions',
  'Funzioni critiche o importanti (art. 8)':
    'Fonctions critiques ou importantes (art. 8)',
  'Funzioni e fornitori':
    'Fonctions et prestataires',
  'In più, la sezione «Funzioni e fornitori»: le Business App con le loro funzioni critiche e quanti asset che le sostengono non sono conformi (art. 8), e i fornitori ICT dai contratti attivi e dai provider cloud dell’inventario, con gli asset critici che dipendono da ciascuno e la concentrazione (artt. 28–29). Accanto alle voci non misurate, ciò che la piattaforma vede su di esse.':
    'En plus, la section « Fonctions et prestataires » : les Business Apps avec leurs fonctions critiques et combien des actifs qui les supportent ne sont pas conformes (art. 8), et les prestataires TIC issus des contrats actifs et des fournisseurs cloud de l’inventaire, avec les actifs critiques qui dépendent de chacun et la concentration (art. 28–29). À côté des éléments non mesurés, ce que la plateforme en voit.',
  'Business App, funzioni associate, criticità dichiarata e asset ICT che le supportano, con evidenza degli asset conformi e non conformi. Gli asset dei Business Service critici o alti sono {n}, di cui {k} non conformi.': 'Business Apps, fonctions associées, criticité déclarée et actifs ICT qui les soutiennent, avec la mise en évidence des actifs conformes et non conformes. Les actifs des Business Services critiques ou élevés sont {n}, dont {k} non conformes.',
  'Librerie di terze parti senza vulnerabilità gravi':
    'Bibliothèques tierces sans vulnérabilités graves',
  'Monitoraggio':
    'Surveillance',
  'Monitoraggio degli asset che sostengono funzioni critiche':
    'Surveillance des actifs supportant des fonctions critiques',
  'Nessun contratto registrato e nessun provider cloud nell’inventario.':
    'Aucun contrat enregistré et aucun fournisseur cloud dans l’inventaire.',
  'Nessuna Business App definita.':
    'Aucune Business App définie.',
  'Se non sono definite Business App, devono essere create dalla Mappa Software, selezionando i programmi che compongono ciascuna applicazione.': 'Si aucune Business App n’est définie, elles doivent être créées depuis la Carte Logicielle, en sélectionnant les programmes qui composent chaque application.',
  'Servizi chiamati in chiaro da altre macchine':
    'Services appelés en clair par d’autres machines',
  'asset con distinta dei componenti (SBOM)':
    'actifs avec nomenclature logicielle (SBOM)',
  'asset monitorati da CENSO Eagle':
    'actifs surveillés par CENSO Eagle',
  'autofirmati':
    'auto-signés',
  'certificati TLS su {n} asset':
    'certificats TLS sur {n} actifs',
  'concentrazione massima {p}%':
    'concentration maximale {p} %',
  'dall’inventario cloud':
    'issu de l’inventaire cloud',
  'in scadenza entro 30 giorni':
    'expirant sous 30 jours',
  'librerie vulnerabili su {n} asset':
    'bibliothèques vulnérables sur {n} actifs',
  'scade il {d}':
    'expire le {d}',
  'scaduti':
    'expirés',
  'servizi chiamati in chiaro su {n} server':
    'services appelés en clair sur {n} serveurs',
  'sfruttate attivamente (CISA KEV)':
    'activement exploitées (CISA KEV)',
  '{c} contratti attivi':
    '{c} contrats actifs',
  '{n} fornitori senza contratto registrato':
    '{n} prestataires sans contrat enregistré',
  'I percorsi dei componenti non sono arrivati: la distinta di questa macchina superava lo spazio di una consegna e l’agente li ha tolti. Con l’agente CENSO aggiornato ogni file viaggia una volta sola e i percorsi restano; al prossimo inventario compaiono.':
    'Les chemins des composants ne sont pas arrivés : la nomenclature de cette machine dépassait l’espace d’une livraison et l’agent les a retirés. Avec l’agent CENSO mis à jour, chaque fichier ne voyage qu’une fois et les chemins sont conservés ; ils apparaîtront au prochain inventaire.',
  'Anagrafica dei certificati':
    'Registre des certificats',
  'Apri il flusso applicativo del CI':
    'Ouvrir le flux applicatif du CI',
  'Autofirmati ({e} raggiungibili da altre macchine)':
    'Auto-signés ({e} accessibles depuis d’autres machines)',
  'CI e servizio':
    'CI et service',
  'Catena presentata':
    'Chaîne présentée',
  'Certificati autofirmati':
    'Certificats auto-signés',
  'Certificati su {h} host ({u} diversi)':
    'Certificats sur {h} hôtes ({u} distincts)',
  'Con chiave, firma o protocollo deboli':
    'Avec clé, signature ou protocole faibles',
  'Crittografia':
    'Cryptographie',
  'Debolezze':
    'Faiblesses',
  'Dettaglio del certificato':
    'Détail du certificat',
  'Dove è esposto':
    'Où il est exposé',
  'Emittente (CA)':
    'Émetteur (AC)',
  'Entro 30 giorni':
    'Sous 30 jours',
  'Entro 90 giorni':
    'Sous 90 jours',
  'I certificati li legge l’agente CENSO, con una stretta di mano TLS verso ogni porta in ascolto della sua macchina.':
    'Les certificats sont lus par l’agent CENSO, avec une poignée de main TLS vers chaque port en écoute de sa machine.',
  'Individua le comunicazioni non cifrate tra gli asset e analizza i certificati TLS presentati dai loro servizi, indicando chi li espone, chi li ha emessi, quando scadono e quali sono autofirmati o utilizzano configurazioni deboli.': 'Repère les communications non chiffrées entre les actifs et analyse les certificats TLS présentés par leurs services, en indiquant qui les expose, qui les a émis, quand ils expirent et lesquels sont auto-signés ou utilisent des configurations faibles.',
  'Installazioni':
    'Installations',
  'Lo stesso certificato altrove':
    'Le même certificat ailleurs',
  'Macchina che chiama':
    'Machine appelante',
  'Nessun certificato autofirmato':
    'Aucun certificat auto-signé',
  'Nessun certificato in questa fascia':
    'Aucun certificat dans cette tranche',
  'Nessun certificato letto':
    'Aucun certificat lu',
  'Nomi alternativi (SAN)':
    'Noms alternatifs (SAN)',
  'Protocollo e cifrario':
    'Protocole et chiffrement',
  'Raggiungibili da altre macchine':
    'Accessibles depuis d’autres machines',
  'Scadenze e certificati scaduti':
    'Échéances et certificats expirés',
  'Scadono entro 30 giorni':
    'Expirent sous 30 jours',
  'Scaduti':
    'Expirés',
  'Servizi chiamati in chiaro':
    'Services appelés en clair',
  'Servizi in chiaro':
    'Services en clair',
  'Servizio che lo espone':
    'Service qui l’expose',
  'Solo in locale':
    'Local uniquement',
  'Tutti, per scadenza':
    'Tous, par échéance',
  'Certificati autofirmati: non sono verificati da una CA attendibile, quindi non garantiscono l’identità del servizio. Sui servizi raggiungibili dalla rete è consigliato sostituirli con certificati emessi da una CA interna o pubblica; sui servizi accessibili solo localmente il rischio è inferiore.': 'Certificats auto-signés : ils ne sont pas vérifiés par une AC de confiance, donc ils ne garantissent pas l’identité du service. Sur les services joignables depuis le réseau, il est conseillé de les remplacer par des certificats émis par une AC interne ou publique ; sur les services accessibles uniquement localement, le risque est moindre.',
  'Valido fino al':
    'Valide jusqu’au',
  'Vedi le coppie':
    'Voir les paires',
  'autofirmato: l’emittente è il certificato stesso':
    'auto-signé : l’émetteur est le certificat lui-même',
  'certificati':
    'certificats',
  'criticità':
    'criticité',
  'in ascolto solo in locale':
    'en écoute uniquement en local',
  'nessun certificato intermedio inviato dal server':
    'aucun certificat intermédiaire envoyé par le serveur',
  'cinque schede. «Traffico in chiaro»: le coppie di macchine che si parlano senza cifratura, con la prova (HTTP visto senza TLS dall’osservazione applicativa o da OpenTelemetry, un processo collegato a un protocollo sempre in chiaro, i flussi di rete); i numeri in alto sono viste — le coppie, i server che rispondono in chiaro, le macchine che chiamano — e i protocolli filtrano. «Anagrafica dei certificati»: tutti i certificati che i servizi presentano, letti dall’agente CENSO. «Scadenze e certificati scaduti»: scaduti, entro 30 e 90 giorni. «Certificati autofirmati»: quelli raggiungibili da altre macchine prima. Cliccando un certificato si apre il dettaglio: il CI e il servizio che lo espone (porta, processo, software), i Business Service, dove è installato lo stesso certificato, e il certificato stesso — soggetto, nomi alternativi, CA emittente e catena, numero di serie, validità, chiave, firma, protocollo e impronta.':
    'cinq onglets. « Trafic en clair » : les paires de machines qui communiquent sans chiffrement, avec la preuve (HTTP vu sans TLS par l’observation applicative ou OpenTelemetry, un processus connecté à un protocole toujours en clair, les flux réseau) ; les nombres en haut sont des vues — les paires, les serveurs qui répondent en clair, les machines appelantes — et les protocoles filtrent. « Registre des certificats » : tous les certificats que présentent les services, lus par l’agent CENSO. « Échéances et certificats expirés » : expirés, sous 30 et 90 jours. « Certificats auto-signés » : d’abord ceux accessibles depuis d’autres machines. Un clic sur un certificat ouvre le détail : le CI et le service qui l’expose (port, processus, logiciel), les Business Services, où le même certificat est installé, et le certificat lui-même — sujet, noms alternatifs, AC émettrice et chaîne, numéro de série, validité, clé, signature, protocole et empreinte.',
  'scadenza non letta':
    'échéance non lue',
  '1. CA e modello':
    '1. AC et modèle',
  '3. Incolla la CSR e invia':
    '3. Collez la CSR et envoyez',
  'Aggiungi una connessione «CA Microsoft (AD CS)» nella scheda «Connessioni» — WinRM verso un server Windows del dominio oppure il sito Web Enrollment (/certsrv) — e abilita la capability «PKI (CA Microsoft)» sulla sonda che raggiunge la CA.':
    'Ajoutez une connexion « AC Microsoft (AD CS) » dans l’onglet « Connexions » — WinRM vers un serveur Windows du domaine ou le site Web Enrollment (/certsrv) — et activez la capacité « PKI (AC Microsoft) » sur la sonde qui atteint l’AC.',
  'Autorità di certificazione':
    'Autorités de certification',
  'CA':
    'AC',
  'CA e modelli':
    'AC et modèles',
  'CA e modello':
    'AC et modèle',
  'CSR (-----BEGIN CERTIFICATE REQUEST-----)':
    'CSR (-----BEGIN CERTIFICATE REQUEST-----)',
  'Certificato richiesto':
    'Certificat demandé',
  'Crea e invia alla CA':
    'Créer et envoyer à l’AC',
  'Dal database della CA, con la connessione WinRM: i certificati emessi che scadono da 30 giorni fa in poi. Serve la lettura sulla CA (per esempio «Responsabile certificati»).':
    'Depuis la base de l’AC, via la connexion WinRM : les certificats émis expirant à partir d’il y a 30 jours. Il faut la lecture sur l’AC (par exemple « Gestionnaire de certificats »).',
  'Eliminare la richiesta?':
    'Supprimer la demande ?',
  'Entrano da sé quando la CA emette una richiesta fatta da qui; si importano con «Importa certificato» o si leggono dal database della CA (connessione WinRM).':
    'Ils arrivent d’eux-mêmes quand l’AC émet une demande faite ici ; on les importe avec « Importer un certificat » ou on les lit depuis la base de l’AC (connexion WinRM).',
  'Gestione':
    'Gestion',
  'Gestione certificati':
    'Gestion des certificats',
  'Importa certificato':
    'Importer un certificat',
  'Impronta SHA-1':
    'Empreinte SHA-1',
  'Installato su':
    'Installé sur',
  'Invia alla CA':
    'Envoyer à l’AC',
  'Invia subito alla CA':
    'Envoyer tout de suite à l’AC',
  'Invio in corso…':
    'Envoi en cours…',
  'La connessione non consente di inviare richieste: la richiesta resta in bozza finché un amministratore non accende «Consenti la scrittura» nella credenziale.':
    'La connexion ne permet pas d’envoyer des demandes : la demande reste en brouillon tant qu’un administrateur n’active pas « Autoriser l’écriture » dans l’identifiant.',
  'Le richieste si preparano in «Nuova richiesta», o con «Rinnova con la CA» da un certificato del repository o di Cifratura.':
    'Les demandes se préparent dans « Nouvelle demande », ou avec « Renouveler avec l’AC » depuis un certificat du référentiel ou de Chiffrement.',
  'Leggi':
    'Lire',
  'Leggi i certificati emessi dalla CA':
    'Lire les certificats émis par l’AC',
  'Lettura in corso…':
    'Lecture en cours…',
  'Linux e altri (OpenSSL)':
    'Linux et autres (OpenSSL)',
  'Modelli di certificato':
    'Modèles de certificats',
  'Modelli pubblicati':
    'Modèles publiés',
  'Nel repository':
    'Dans le référentiel',
  'Nessun certificato nel repository':
    'Aucun certificat dans le référentiel',
  'Nessuna CA aziendale trovata in Active Directory':
    'Aucune AC d’entreprise trouvée dans Active Directory',
  'Nessuna connessione a una CA Microsoft':
    'Aucune connexion à une AC Microsoft',
  'Nessuna richiesta':
    'Aucune demande',
  'Nome comune (CN)':
    'Nom commun (CN)',
  'Nomi alternativi (separati da virgola)':
    'Noms alternatifs (séparés par des virgules)',
  'Nuova richiesta':
    'Nouvelle demande',
  'Oppure incolla il testo':
    'Ou collez le texte',
  'Prepara i comandi':
    'Préparer les commandes',
  'Pubblicato da':
    'Publié par',
  'Quando il certificato è emesso, scaricalo dal repository e completa sul server con:':
    'Quand le certificat est émis, téléchargez-le depuis le référentiel et terminez sur le serveur avec :',
  'Questo modello costruisce il soggetto da Active Directory: i nomi della CSR vengono ignorati. Per un server web scegli un modello in cui il richiedente fornisce il soggetto (come «Server Web»).':
    'Ce modèle construit le sujet depuis Active Directory : les noms de la CSR sont ignorés. Pour un serveur web choisissez un modèle où le demandeur fournit le sujet (comme « Serveur Web »).',
  'Repository certificati':
    'Référentiel des certificats',
  'Richiedente':
    'Demandeur',
  'Richieste':
    'Demandes',
  'Ricontrolla':
    'Revérifier',
  'Rinnova con la CA':
    'Renouveler avec l’AC',
  'Salva il file .inf sul server, poi in un prompt da amministratore:':
    'Enregistrez le fichier .inf sur le serveur, puis dans une invite administrateur :',
  'Salva la richiesta':
    'Enregistrer la demande',
  'Scarica il file .inf':
    'Télécharger le fichier .inf',
  'Soggetto dalla richiesta':
    'Sujet issu de la demande',
  'Sostituisce il certificato con impronta {s}…':
    'Remplace le certificat d’empreinte {s}…',
  'Sostituzione':
    'Remplacement',
  'Togli dal repository':
    'Retirer du référentiel',
  'Togliere il certificato dal repository? Non viene revocato sulla CA.':
    'Retirer le certificat du référentiel ? Il n’est pas révoqué sur l’AC.',
  'Visti installati dall’agente':
    'Vus installés par l’agent',
  'Windows (certreq)':
    'Windows (certreq)',
  'dal database della CA':
    'depuis la base de l’AC',
  'elenco troncato: alza il limite o leggi più spesso':
    'liste tronquée : augmentez la limite ou lisez plus souvent',
  'emesso':
    'émis',
  'emesso tramite CENSO':
    'émis via CENSO',
  'importato':
    'importé',
  'in attesa di approvazione':
    'en attente d’approbation',
  'l’agente CENSO non lo vede esposto da nessuna parte':
    'l’agent CENSO ne le voit exposé nulle part',
  'non riuscito':
    'échoué',
  'richiesta n. {n}':
    'demande n° {n}',
  'rifiutato':
    'refusé',
  'valido fino al {d}':
    'valide jusqu’au {d}',
  '{a} nuovi, {u} già presenti':
    '{a} nouveaux, {u} déjà présents',
  'Accendilo se WinRM o il sito /certsrv hanno un certificato della tua PKI che la sonda riconosce.':
    'Activez-le si WinRM ou le site /certsrv ont un certificat de votre PKI que la sonde reconnaît.',
  'Accesa, dalla Gestione certificati si inviano a questa CA le richieste di certificato (CSR) con il modello scelto e se ne ritira il certificato emesso. La chiave privata non passa mai da CENSO: la CSR si genera sulla macchina che userà il certificato.':
    'Activée, la Gestion des certificats envoie à cette AC les demandes de certificat (CSR) avec le modèle choisi et en récupère le certificat émis. La clé privée ne passe jamais par CENSO : la CSR est générée sur la machine qui utilisera le certificat.',
  'CA (server\\nome)':
    'AC (serveur\\nom)',
  'CA Microsoft (AD CS)':
    'AC Microsoft (AD CS)',
  'Gestione dei certificati con la CA Microsoft (AD CS) attraverso la sonda: CA e modelli pubblicati, invio delle richieste (CSR) e ritiro dei certificati, via WinRM (solo gli script AD CS del catalogo della sonda) o via il sito Web Enrollment. Non apre porte e non avvia job. Abilitala dove la sonda raggiunge la CA.':
    'Gestion des certificats avec l’AC Microsoft (AD CS) via la sonde : AC et modèles publiés, envoi des demandes (CSR) et récupération des certificats, par WinRM (seulement les scripts AD CS du catalogue de la sonde) ou par le site Web Enrollment. N’ouvre pas de ports et ne lance pas de tâches. Activez-la là où la sonde atteint l’AC.',
  "Il sito di registrazione web della CA, con l'autenticazione di Windows (NTLM; Basic solo in HTTPS). Richieste e ritiro sì, elenco dei certificati emessi no.":
    'Le site d’inscription web de l’AC, avec l’authentification Windows (NTLM ; Basic seulement en HTTPS). Demandes et récupération oui, liste des certificats émis non.',
  'Indirizzo di Web Enrollment':
    'Adresse de Web Enrollment',
  "L'utente deve avere il permesso «Registra» (Enroll) sui modelli che vuoi usare. Per leggere i certificati emessi dal database della CA (il Repository) serve anche la lettura sulla CA, per esempio il ruolo di «Responsabile certificati»; solo in modalità WinRM. Le richieste che il modello mette in attesa di approvazione restano in attesa finché un responsabile non le approva sulla CA.":
    'L’utilisateur doit avoir l’autorisation « Inscrire » (Enroll) sur les modèles que vous voulez utiliser. Pour lire les certificats émis depuis la base de l’AC (le Référentiel) il faut aussi la lecture sur l’AC, par exemple le rôle « Gestionnaire de certificats » ; mode WinRM uniquement. Les demandes que le modèle met en attente d’approbation restent en attente tant qu’un gestionnaire ne les approuve pas sur l’AC.',
  'Modalità Web Enrollment: il sito /certsrv della CA. Con questa modalità non si legge il database della CA.':
    'Mode Web Enrollment : le site /certsrv de l’AC. Dans ce mode la base de l’AC n’est pas lue.',
  'Modalità WinRM: la CA a cui mandare le richieste. Vuoto: si sceglie fra le CA pubblicate in Active Directory.':
    'Mode WinRM : l’AC à laquelle envoyer les demandes. Vide : on choisit parmi les AC publiées dans Active Directory.',
  'Modalità WinRM: un server Windows del dominio raggiungibile dalla sonda, di norma la CA stessa. Le CA aziendali e i modelli si leggono da Active Directory.':
    'Mode WinRM : un serveur Windows du domaine accessible depuis la sonde, en général l’AC elle-même. Les AC d’entreprise et les modèles sont lus dans Active Directory.',
  'PKI (CA Microsoft)':
    'PKI (AC Microsoft)',
  'Server Windows (WinRM)':
    'Serveur Windows (WinRM)',
  'Solo su un segmento fidato. Il default è HTTPS sulla 5986.':
    'Seulement sur un segment de confiance. Par défaut HTTPS sur 5986.',
  'Web Enrollment (/certsrv)':
    'Web Enrollment (/certsrv)',
  'WinRM (NTLM)':
    'WinRM (NTLM)',
  'ca01.dominio.local':
    'ca01.domaine.local',
  'ca01.dominio.local\\DOMINIO Issuing CA':
    'ca01.domaine.local\\DOMAINE Issuing CA',
  'es. portale.dominio.local':
    'ex. portail.domaine.local',
  'es. www.dominio.local, 10.0.0.5':
    'ex. www.domaine.local, 10.0.0.5',
  'https://ca01.dominio.local/certsrv':
    'https://ca01.domaine.local/certsrv',
  '«DOMINIO\\utente» con il permesso Enroll sui modelli; per il Repository anche la lettura sulla CA. Le interfacce della CA non dipendono dalla lingua di Windows.':
    '« DOMAINE\\utilisateur » avec l’autorisation Enroll sur les modèles ; pour le Référentiel aussi la lecture sur l’AC. Les interfaces de l’AC ne dépendent pas de la langue de Windows.',
  'Nota: CA e modelli sono letti dalla CA installata sul server, perché dalla sessione WinRM Active Directory non è raggiungibile (con NTLM le credenziali non fanno il secondo salto verso il domain controller). Richieste, ritiro e certificati emessi funzionano normalmente; dei modelli si conosce solo il nome, senza durata né l’indicazione se il soggetto viene dalla richiesta.':
    'Remarque : AC et modèles sont lus depuis l’AC installée sur le serveur, car Active Directory n’est pas joignable depuis la session WinRM (avec NTLM les identifiants ne font pas le second saut vers le contrôleur de domaine). Demandes, récupération et certificats émis fonctionnent normalement ; des modèles on ne connaît que le nom, sans durée ni l’indication si le sujet vient de la demande.',
  "1. Il certificato. Se nel dominio c'è l'autoregistrazione dei certificati computer, di solito c'è già: deve comparire il nome completo del server. Se manca, chiedilo dalla Gestione certificati con il modello «Computer» o «Server Web». Annota l'impronta (Thumbprint).":
    '1. Le certificat. Si le domaine a l’inscription automatique des certificats ordinateur, il est en général déjà là : le nom complet du serveur doit apparaître. S’il manque, demandez-le depuis la Gestion des certificats avec le modèle « Ordinateur » ou « Serveur Web ». Notez l’empreinte (Thumbprint).',
  "2. Il listener HTTPS, con l'impronta del passo 1. Usa l'impronta e non cercare il certificato per nome: sul server di una CA il certificato della CA ha lo stesso nome ma non serve all'autenticazione server, e WinRM lo rifiuta («The Enhanced Key Usage (EKU) field of the certificate is not set to Server Authentication»).":
    '2. Le listener HTTPS, avec l’empreinte de l’étape 1. Utilisez l’empreinte et ne cherchez pas le certificat par nom : sur le serveur d’une AC, le certificat de l’AC a le même nom mais ne sert pas à l’authentification serveur, et WinRM le refuse (« The Enhanced Key Usage (EKU) field of the certificate is not set to Server Authentication »).',
  "3. La porta 5986 nel firewall, meglio se aperta solo all'indirizzo della sonda.":
    '3. Le port 5986 dans le pare-feu, de préférence ouvert seulement à l’adresse de la sonde.',
  "Nella connessione: nel campo del server il nome completo (lo stesso del certificato), porta vuota (5986), questa casella spenta. «Verifica il certificato» accesa solo se la sonda si fida della CA che l'ha emesso.":
    'Dans la connexion : le nom complet dans le champ du serveur (le même que le certificat), port vide (5986), cette case désactivée. « Vérifier le certificat » activée seulement si la sonde fait confiance à l’AC qui l’a émis.',
  'Per attivare WinRM in HTTPS sul server Windows servono tre cose: un certificato per il nome completo del server con uso «Autenticazione server», un listener HTTPS di WinRM e la porta 5986 aperta. I comandi vanno in PowerShell da amministratore, sul server.':
    'Pour activer WinRM en HTTPS sur le serveur Windows il faut trois choses : un certificat pour le nom complet du serveur avec l’usage « Authentification du serveur », un listener HTTPS de WinRM et le port 5986 ouvert. Les commandes se lancent dans PowerShell en administrateur, sur le serveur.',
  "Quando il certificato viene rinnovato il listener resta sull'impronta vecchia e WinRM in HTTPS smette di rispondere: aggiornalo con l'impronta nuova. La scadenza la vedi in Sicurezza → Cifratura, perché l'agente CENSO legge anche il certificato esposto sulla 5986.":
    'Quand le certificat est renouvelé, le listener reste sur l’ancienne empreinte et WinRM en HTTPS cesse de répondre : mettez-le à jour avec la nouvelle empreinte. L’échéance se voit dans Sécurité → Chiffrement, car l’agent CENSO lit aussi le certificat exposé sur 5986.',
  'Senza una CA (solo in laboratorio) puoi crearne uno autofirmato; in quel caso lascia spenta «Verifica il certificato».':
    'Sans AC (en laboratoire seulement) vous pouvez en créer un auto-signé ; dans ce cas laissez « Vérifier le certificat » désactivée.',
  'Spenta (consigliato), CENSO usa WinRM in HTTPS sulla porta 5986: utente e contenuto viaggiano cifrati. Accesa, usa HTTP sulla 5985: con NTLM la password non passa in chiaro, ma i dati sì — solo su un segmento di rete fidato.':
    'Désactivée (recommandé), CENSO utilise WinRM en HTTPS sur le port 5986 : utilisateur et contenu voyagent chiffrés. Activée, il utilise HTTP sur 5985 : avec NTLM le mot de passe ne passe pas en clair, mais les données si — seulement sur un segment de réseau de confiance.',
  'Su molti server conviene una GPO: autoregistrazione dei certificati computer, «Allow remote server management through WinRM» (Componenti di Windows → Gestione remota Windows → Servizio WinRM) e la regola del firewall; il listener HTTPS si crea con il comando del passo 2, per esempio in uno script di avvio.':
    'Sur de nombreux serveurs, utilisez une GPO : inscription automatique des certificats ordinateur, « Allow remote server management through WinRM » (Composants Windows → Gestion à distance de Windows → Service WinRM) et la règle de pare-feu ; le listener HTTPS se crée avec la commande de l’étape 2, par exemple dans un script de démarrage.',
  "Verifica: il comando seguente deve mostrare un listener «Transport = HTTPS», «Port = 5986» con l'impronta del certificato. Da un altro Windows, «Test-WSMan <server> -UseSSL» deve rispondere senza errori.":
    'Vérification : la commande suivante doit montrer un listener « Transport = HTTPS », « Port = 5986 » avec l’empreinte du certificat. Depuis un autre Windows, « Test-WSMan <serveur> -UseSSL » doit répondre sans erreur.',
  'Altri certificati':
    'Autres certificats',
  'Altri certificati ({n})':
    'Autres certificats ({n})',
  'Certificati web':
    'Certificats web',
  'Certificati web ({n})':
    'Certificats web ({n})',
  'Più parole: tutte. a|b: l’una o l’altra. !x: esclude. =x: valore esatto. Sui numeri: >30, <=7, 10..20.':
    'Plusieurs mots : tous. a|b : l’un ou l’autre. !x : exclut. =x : valeur exacte. Sur les nombres : >30, <=7, 10..20.',
  'computer':
    'ordinateur',
  'firma del codice':
    'signature de code',
  'web':
    'web',
  'Nel filtro: più parole devono esserci tutte, «a|b» è l’una o l’altra, «!x» esclude, «=x» è il valore esatto, e sui numeri «>30», «<=7», «10..20». Le colonne con pochi valori che si ripetono (tipo, stato, origine) si filtrano da un menu; «Azzera filtri» li toglie tutti.':
    'Dans le filtre : plusieurs mots doivent tous être présents, « a|b » est l’un ou l’autre, « !x » exclut, « =x » est la valeur exacte, et sur les nombres « >30 », « <=7 », « 10..20 ». Les colonnes avec peu de valeurs qui se répètent (type, état, origine) se filtrent depuis un menu ; « Effacer les filtres » les retire tous.',
  '2. Nomi e chiave':
    '2. Noms et clé',
  '3. Genera e invia':
    '3. Générer et envoyer',
  'CENSO genera chiave e CSR e tiene la chiave nello store, cifrata con la chiave del tenant: quando la CA emette il certificato, un amministratore lo scarica in PFX con la catena, pronto da installare.':
    'CENSO génère la clé et la CSR et garde la clé dans le magasin, chiffrée avec la clé du tenant : quand l’AC émet le certificat, un administrateur le télécharge en PFX avec la chaîne, prêt à installer.',
  'Carica un certificato in qualsiasi formato — PEM, .cer/.crt/.der, .p7b, .pfx/.p12 — e scaricalo in un altro. Non salva niente nel repository né nello store: legge, converte e restituisce il file.':
    'Chargez un certificat dans n’importe quel format — PEM, .cer/.crt/.der, .p7b, .pfx/.p12 — et téléchargez-le dans un autre. Rien n’est enregistré dans le référentiel ni dans le magasin : il lit, convertit et renvoie le fichier.',
  'Catena':
    'Chaîne',
  'Catena .p7b (PKCS#7)':
    'Chaîne .p7b (PKCS#7)',
  'Catena incompleta: apri «CA e modelli» per far entrare il certificato della CA, o importalo.':
    'Chaîne incomplète : ouvrez « AC et modèles » pour faire entrer le certificat de l’AC, ou importez-le.',
  'Certificato .cer (DER)':
    'Certificat .cer (DER)',
  'Certificato .pem':
    'Certificat .pem',
  'Chiave .pem cifrata (PKCS#8)':
    'Clé .pem chiffrée (PKCS#8)',
  'Chiave generata in CENSO':
    'Clé générée dans CENSO',
  'Chiave sul server':
    'Clé sur le serveur',
  'Chiavi':
    'Clés',
  'Con la catena .pem':
    'Avec la chaîne .pem',
  'Con la catena delle CA':
    'Avec la chaîne des AC',
  'Con la chiave privata':
    'Avec la clé privée',
  'Converti e scarica':
    'Convertir et télécharger',
  'Converti in':
    'Convertir en',
  'Convertitore':
    'Convertisseur',
  'Convertitore di certificati':
    'Convertisseur de certificats',
  'Dove nasce la chiave':
    'Où naît la clé',
  'Eliminare la chiave dallo store? I certificati restano, ma senza chiave non si potranno più esportare in PFX da qui.':
    'Supprimer la clé du magasin ? Les certificats restent, mais sans clé ils ne pourront plus être exportés en PFX d’ici.',
  'Esporta':
    'Exporter',
  'Esportazioni':
    'Exportations',
  'gestisce l’intero ciclo di richiesta dei certificati tramite Microsoft AD CS, dalla preparazione alla generazione e al download. La chiave privata può essere generata sulla macchina di destinazione o conservata cifrata in CENSO.': 'gère tout le cycle de demande des certificats via Microsoft AD CS, de la préparation à la génération et au téléchargement. La clé privée peut être générée sur la machine cible ou conservée chiffrée dans CENSO.',
  'Indica i nomi del certificato: CENSO prepara i comandi da eseguire sul server. La chiave privata resta lì; qui torna solo la CSR. È la strada più sicura.':
    'Indiquez les noms du certificat : CENSO prépare les commandes à exécuter sur le serveur. La clé privée y reste ; seule la CSR revient ici. C’est la voie la plus sûre.',
  'La chiave privata è nello store, cifrata':
    'La clé privée est dans le magasin, chiffrée',
  'La chiave privata è nello store: la può esportare (PFX o PEM cifrata) un amministratore del tenant.':
    'La clé privée est dans le magasin : un administrateur du tenant peut l’exporter (PFX ou PEM chiffré).',
  'Chiavi private archiviate nello store cifrato con la chiave del tenant e protette dal relativo ciclo di rotazione. Non sono mai esposte in chiaro; l’esportazione è consentita solo agli amministratori insieme al certificato, in PFX o PEM protetto da password.': 'Clés privées conservées dans le coffre chiffré avec la clé du tenant et protégées par son cycle de rotation. Elles ne sont jamais exposées en clair ; l’exportation n’est permise qu’aux administrateurs, avec le certificat, au format PFX ou PEM protégé par mot de passe.',
  'Nessuna chiave nello store':
    'Aucune clé dans le magasin',
  'Ogni esportazione finisce nell’audit del tenant e nel conteggio della chiave. Conserva la password a parte: senza, il file non si apre.':
    'Chaque exportation va dans l’audit du tenant et dans le compteur de la clé. Conservez le mot de passe à part : sans lui le fichier ne s’ouvre pas.',
  'PEM, .cer/.crt/.der, .p7b, oppure .pfx/.p12 con la sua password: i certificati vanno nel repository, la chiave privata (se c’è) nello store, cifrata con la chiave del tenant.':
    'PEM, .cer/.crt/.der, .p7b, ou .pfx/.p12 avec son mot de passe : les certificats vont dans le référentiel, la clé privée (s’il y en a une) dans le magasin, chiffrée avec la clé du tenant.',
  'PFX / P12 (AES)':
    'PFX / P12 (AES)',
  'PFX compatibile (3DES, Windows prima del 2019)':
    'PFX compatible (3DES, Windows avant 2019)',
  'Password (almeno 8 caratteri)':
    'Mot de passe (au moins 8 caractères)',
  'Password del file (PFX o chiave cifrata)':
    'Mot de passe du fichier (PFX ou clé chiffrée)',
  'Password del file (se PFX o chiave cifrata)':
    'Mot de passe du fichier (si PFX ou clé chiffrée)',
  'Password del nuovo PFX':
    'Mot de passe du nouveau PFX',
  'Password della chiave (vuota: in chiaro)':
    'Mot de passe de la clé (vide : en clair)',
  'Ripeti la password':
    'Répétez le mot de passe',
  'Solo la chiave .pem':
    'Clé seule .pem',
  'Solo le CA .pem':
    'AC seulement .pem',
  'chiavi':
    'clés',
  'generata in CENSO':
    'générée dans CENSO',
  'nello store':
    'dans le magasin',
  'nessun certificato della CA nel repository':
    'aucun certificat d’AC dans le référentiel',
  '{n} certificati importati, {k} chiavi nello store':
    '{n} certificats importés, {k} clés dans le magasin',
  '«Con la catena» è quello che vuole un server (nginx, Apache, HAProxy); «Solo le CA» è il bundle da dare ai client; il .p7b si importa così in Windows.':
    '« Avec la chaîne » est ce que veut un serveur (nginx, Apache, HAProxy) ; « AC seulement » est le bundle à donner aux clients ; le .p7b s’importe tel quel dans Windows.',
  'i certificati dell’organizzazione e le richieste alla CA Microsoft (AD CS). «Repository certificati»: quelli emessi tramite CENSO, importati (anche PFX con la chiave) o letti dal database della CA, con scadenza, catena, responsabile e dove l’agente li vede installati; si scaricano in .pem, .cer, con la catena, solo le CA, .p7b e — per gli amministratori, con una password — in .pfx o chiave .pem. «Chiavi»: lo store delle chiavi private, cifrate con la chiave del tenant e mai mostrate. «Nuova richiesta»: scegli connessione, CA e modello, indica i nomi e la chiave; la chiave nasce sul server (CENSO prepara i comandi certreq o openssl e tu incolli la CSR) oppure in CENSO, nello store. «Richieste»: lo stato che la CA ha dato, con «Ricontrolla» per quelle in attesa di approvazione. «Convertitore»: un certificato da un formato all’altro, senza salvarlo. «CA e modelli»: cosa raggiunge ogni connessione. Serve una connessione «CA Microsoft (AD CS)» — WinRM verso un server del dominio oppure il sito Web Enrollment /certsrv —, con «Consenti la scrittura» per inviare, e la capability «PKI» sulla sonda che raggiunge la CA.':
    'les certificats de l’organisation et les demandes à l’AC Microsoft (AD CS). « Référentiel des certificats » : ceux émis via CENSO, importés (aussi PFX avec la clé) ou lus depuis la base de l’AC, avec échéance, chaîne, responsable et où l’agent les voit installés ; ils se téléchargent en .pem, .cer, avec la chaîne, AC seulement, .p7b et — pour les administrateurs, avec un mot de passe — en .pfx ou clé .pem. « Clés » : le magasin des clés privées, chiffrées avec la clé du tenant et jamais affichées. « Nouvelle demande » : choisissez connexion, AC et modèle, indiquez les noms et la clé ; la clé naît sur le serveur (CENSO prépare les commandes certreq ou openssl et vous collez la CSR) ou dans CENSO, dans le magasin. « Demandes » : l’état donné par l’AC, avec « Revérifier » pour celles en attente d’approbation. « Convertisseur » : un certificat d’un format à l’autre, sans l’enregistrer. « AC et modèles » : ce que chaque connexion atteint. Il faut une connexion « AC Microsoft (AD CS) » — WinRM vers un serveur du domaine ou le site Web Enrollment /certsrv —, avec « Autoriser l’écriture » pour envoyer, et la capacité « PKI » sur la sonde qui atteint l’AC.',
  'AES':
    'AES',
  'SHA':
    'SHA',
  'AES (128, predefinito), AES192, AES256, DES. Sugli apparati Cisco configurati con «priv aes 192/256» usa AES192C o AES256C: Cisco allunga la chiave in un altro modo e con AES256 semplice non si capirebbero.':
    'AES (128, par défaut), AES192, AES256, DES. Sur les équipements Cisco configurés avec « priv aes 192/256 » utilisez AES192C ou AES256C : Cisco allonge la clé autrement et avec AES256 simple ils ne se comprendraient pas.',
  'SHA (predefinito), SHA224, SHA256, SHA384, SHA512, MD5.':
    'SHA (par défaut), SHA224, SHA256, SHA384, SHA512, MD5.',
  'Altro ({n})':
    'Plus ({n})',
  'Altre sezioni ({n})':
    'Autres sections ({n})',
  'Certificato con la catena':
    'Certificat avec la chaîne',
  'Installa sul server':
    'Installer sur le serveur',
  'L’agente CENSO della macchina ritira certificato, catena e chiave cifrati per lui al prossimo contatto (entro un minuto) e li installa. Fa solo quello che scegli qui: nessun comando arriva da fuori.':
    'L’agent CENSO de la machine récupère certificat, chaîne et clé, chiffrés pour lui, à son prochain contact (dans la minute) et les installe. Il ne fait que ce que vous choisissez ici : aucune commande ne vient de l’extérieur.',
  'Nessun CI con un agente CENSO attivo su Windows o Linux.':
    'Aucun CI avec un agent CENSO actif sous Windows ou Linux.',
  'Oppure file unico (HAProxy)':
    'Ou fichier unique (HAProxy)',
  'Poi ricarica':
    'Puis recharger',
  'Porta HTTPS':
    'Port HTTPS',
  'Ripeti':
    'Réessayer',
  'Sempre: importazione nell’archivio certificati del computer (LocalMachine\\My), chiave non esportabile.':
    'Toujours : importation dans le magasin de certificats de l’ordinateur (LocalMachine\\My), clé non exportable.',
  'Sito IIS (facoltativo)':
    'Site IIS (facultatif)',
  'Solo sotto /etc/ssl, /etc/pki, /etc/nginx, /etc/apache2, /etc/httpd, /etc/haproxy, /etc/censo, /opt, /srv; i file che c’erano restano con il suffisso .censo-bak; la chiave è leggibile solo da root.':
    'Seulement sous /etc/ssl, /etc/pki, /etc/nginx, /etc/apache2, /etc/httpd, /etc/haproxy, /etc/censo, /opt, /srv ; les fichiers existants restent avec le suffixe .censo-bak ; la clé n’est lisible que par root.',
  'Usalo per il listener WinRM HTTPS':
    'L’utiliser pour le listener WinRM HTTPS',
  'consegnato all’agente':
    'remis à l’agent',
  'in attesa dell’agente':
    'en attente de l’agent',
  'installato':
    'installé',
  'niente':
    'rien',
  'Un certificato con la chiave nello store si installa sul server dal suo dettaglio, «Installa sul server»: l’agente CENSO della macchina lo ritira cifrato e su Windows lo importa nell’archivio del computer (e, se scegli, nel binding HTTPS di IIS e nel listener WinRM), su Linux scrive certificato e chiave nei percorsi indicati e ricarica nginx, Apache o HAProxy; l’esito compare sotto, con «Ripeti».':
    'Un certificat avec sa clé dans le magasin s’installe sur le serveur depuis son détail, « Installer sur le serveur » : l’agent CENSO de la machine le récupère chiffré et sous Windows l’importe dans le magasin de l’ordinateur (et, si vous le choisissez, dans le binding HTTPS d’IIS et le listener WinRM), sous Linux écrit certificat et clé aux chemins indiqués et recharge nginx, Apache ou HAProxy ; le résultat s’affiche dessous, avec « Réessayer ».',
  'es. Default Web Site':
    'ex. Default Web Site',
  'es. /etc/haproxy/certs/sito.pem':
    'ex. /etc/haproxy/certs/site.pem',
  'Scarica MSI Windows (.msi)':
    'Télécharger le MSI Windows (.msi)',
  'Scarica pacchetto GPO (.zip)':
    'Télécharger le paquet GPO (.zip)',
  'Per Windows aziendale: l’MSI compare in «App installate», si disinstalla pulito e si assegna con GPO «Installazione software», Intune o SCCM; il pacchetto GPO è lo zip con in più uno script di avvio del computer pronto da indicare nei Criteri di gruppo.':
    'Pour Windows en entreprise : le MSI apparaît dans « Applications installées », se désinstalle proprement et se déploie via GPO « Installation de logiciel », Intune ou SCCM ; le paquet GPO est le zip avec en plus un script de démarrage de l’ordinateur prêt à indiquer dans la stratégie de groupe.',
  'Windows — MSI (App installate, GPO «Installazione software»)':
    'Windows — MSI (Applications installées, GPO « Installation de logiciel »)',
  'Scarica l’MSI: è specifico di questo agente (porta dentro la configurazione e il segreto) e aggiorna in loco se reinstalli lo stesso agente.':
    'Téléchargez le MSI : il est propre à cet agent (il embarque la configuration et le secret) et se met à jour sur place si vous réinstallez le même agent.',
  'A mano o in automazione: msiexec /i censo-inventory-*.msi /qn (installazione silenziosa, come SYSTEM). Compare in «App installate» come «CENSO · Agente d’inventario»; la disinstallazione toglie attività e file.':
    'À la main ou automatisé : msiexec /i censo-inventory-*.msi /qn (installation silencieuse, en tant que SYSTEM). Il apparaît dans « Applications installées » sous « CENSO · Agente d’inventario » ; la désinstallation supprime la tâche et les fichiers.',
  'GPO: Configurazione computer → Criteri → Impostazioni software → Installazione software → Nuovo pacchetto → l’MSI dalla share, modalità «Assegnato». Si installa al riavvio.':
    'GPO : Configuration ordinateur → Stratégies → Paramètres du logiciel → Installation de logiciel → Nouveau paquet → le MSI depuis le partage, mode « Attribué ». S’installe au redémarrage.',
  'Intune: carica l’MSI come app «Riga di comando» o LOB; SCCM: applicazione di tipo Windows Installer. Rilevamento: il prodotto MSI o C:\\ProgramData\\CENSO\\censo-inventory.exe.':
    'Intune : importez le MSI comme app « Ligne de commande » ou LOB ; SCCM : application de type Windows Installer. Détection : le produit MSI ou C:\\ProgramData\\CENSO\\censo-inventory.exe.',
  'Windows — script di avvio GPO (pacchetto GPO)':
    'Windows — script de démarrage GPO (paquet GPO)',
  'Estrai lo zip del pacchetto GPO su una share letta dai computer (es. \\\\dominio\\NETLOGON\\censo-inventory).':
    'Extrayez le zip du paquet GPO sur un partage lisible par les ordinateurs (ex. \\\\domaine\\NETLOGON\\censo-inventory).',
  'GPO → Configurazione computer → Criteri → Impostazioni di Windows → Script (avvio/arresto) → Avvio → Aggiungi: avvio-gpo.cmd dalla share.':
    'GPO → Configuration ordinateur → Stratégies → Paramètres Windows → Scripts (démarrage/arrêt) → Démarrage → Ajouter : avvio-gpo.cmd depuis le partage.',
  'Al riavvio installa solo dove manca (idempotente) e traccia in C:\\ProgramData\\CENSO\\gpo-avvio.log.':
    'Au redémarrage, il installe uniquement là où il manque (idempotent) et journalise dans C:\\ProgramData\\CENSO\\gpo-avvio.log.',
  'Per Windows aziendale la «Distribuzione di massa» offre, oltre allo zip, un MSI e un pacchetto GPO. L’MSI compare in «App installate», si disinstalla pulito (toglie attività e file) e si assegna con la GPO «Installazione software», Intune o SCCM; è legato a questo agente e, reinstallandolo, aggiorna in loco. Il pacchetto GPO è lo zip con in più uno script di avvio del computer (avvio-gpo.cmd) da indicare nei Criteri di gruppo: al riavvio installa solo dove manca.':
    'Pour Windows en entreprise, « Distribution de masse » propose, en plus du zip, un MSI et un paquet GPO. Le MSI apparaît dans « Applications installées », se désinstalle proprement (il supprime la tâche et les fichiers) et se déploie via la GPO « Installation de logiciel », Intune ou SCCM ; il est lié à cet agent et, réinstallé, se met à jour sur place. Le paquet GPO est le zip avec en plus un script de démarrage de l’ordinateur (avvio-gpo.cmd) à indiquer dans la stratégie de groupe : au redémarrage, il installe uniquement là où il manque.',
  'Oppure il playbook già pronto nel pacchetto: dalla cartella estratta, ansible-playbook -i <inventario> install.yml (copia il pacchetto sugli host e installa come root, idempotente; -e force=true per reinstallare).':
    'Ou le playbook déjà prêt dans le paquet : depuis le dossier extrait, ansible-playbook -i <inventaire> install.yml (copie le paquet sur les hôtes et installe en tant que root, idempotent ; -e force=true pour réinstaller).',
  'Togliere «{nome}» dal catalogo? Le sonde lo rimuoveranno.':
    'Retirer « {nome} » du catalogue ? Les sondes le supprimeront.',
  'Firmware (TFTP)':
    'Firmware (TFTP)',
  'carica il file e scegli le sonde che lo renderanno disponibile agli asset tramite TFTP. Prima della distribuzione, ogni sonda scarica il file dal Control Plane e ne verifica l’integrità. TFTP è utilizzato esclusivamente dalla sonda verso gli asset.': 'téléversez le fichier et choisissez les sondes qui le mettront à disposition des actifs via TFTP. Avant la distribution, chaque sonde télécharge le fichier depuis le Control Plane et en vérifie l’intégrité. TFTP est utilisé exclusivement de la sonde vers les actifs.',
  'Spazio del catalogo':
    'Espace du catalogue',
  '{usato} di {tetto} usati':
    '{usato} sur {tetto} utilisés',
  'Caricamento… {pct}%':
    'Téléversement… {pct}%',
  'Carica un firmware':
    'Importer un firmware',
  'Il caricamento avviene a blocchi per gestire anche file di grandi dimensioni; in caso di interruzione della rete, riprende automaticamente.': 'Le téléversement se fait par blocs pour gérer aussi les fichiers volumineux ; en cas de coupure réseau, il reprend automatiquement.',
  'Nessun firmware nel catalogo. Carica il primo file qui sopra.':
    'Aucun firmware dans le catalogue. Importez le premier fichier ci-dessus.',
  'Quali sonde servono «{nome}»':
    'Quelles sondes servent « {nome} »',
  'Solo le sonde con la capability «Firmware (TFTP)» attiva. Attivala nella pagina Sonde, scheda capability.':
    'Seules les sondes avec la capacité « Firmware (TFTP) » activée. Activez-la sur la page Sondes, onglet capacités.',
  'Nessuna sonda ha la capability «Firmware (TFTP)» attiva.':
    'Aucune sonde n’a la capacité « Firmware (TFTP) » activée.',
  '(sonda disattivata)':
    '(sonde désactivée)',
  'La sonda fa da server TFTP (sola lettura, UDP/69) per i firmware che la console carica e le assegna: gli apparati li scaricano da lì. I file arrivano alla sonda solo dal Control Plane, mai via TFTP. Si abilita dove la sonda raggiunge gli apparati da aggiornare. Non richiede licenza.':
    'La sonde fait office de serveur TFTP (lecture seule, UDP/69) pour les firmwares que la console importe et lui assigne : les équipements les téléchargent depuis là. Les fichiers n’arrivent à la sonde que depuis le Control Plane, jamais via TFTP. Activez-la là où la sonde atteint les équipements à mettre à jour. Aucune licence requise.',
  'il catalogo dei firmware che le sonde servono in TFTP agli apparati (per aggiornarli). Carichi un file — a blocchi, con ripresa — e scegli le sonde che lo serviranno; la sonda lo scarica dal Control Plane, verifica lo SHA-256 e lo serve in sola lettura su UDP/69. Serve la capability «Firmware (TFTP)» sulla sonda (senza licenza); lo spazio del catalogo ha un tetto di 4 GB. Da un apparato: copy tftp://<ip-sonda>/<file> flash:.':
    'le catalogue des firmwares que les sondes servent en TFTP aux équipements (pour les mettre à jour). Importez un fichier — par blocs, avec reprise — et choisissez les sondes qui le serviront ; la sonde le télécharge depuis le Control Plane, vérifie le SHA-256 et le sert en lecture seule sur UDP/69. Nécessite la capacité « Firmware (TFTP) » sur la sonde (sans licence) ; l’espace du catalogue est plafonné à 4 Go. Depuis un équipement : copy tftp://<ip-sonde>/<fichier> flash:.',
  'Obbligatori':
    'Obligatoires',
  'Chiavi obbligatorie e valori ammessi':
    'Clés obligatoires et valeurs admises',
  'Le chiavi qui elencate devono stare su ogni CI; se una chiave ha dei valori ammessi, solo quelli si possono usare. Esempio tipico: «ambiente» con produzione/collaudo/sviluppo. L’obbligo si sorveglia (copertura qui sotto) e il patching lo pretende, ma non blocca la scoperta.':
    'Les clés listées ici doivent être présentes sur chaque CI ; si une clé a des valeurs admises, seules celles-ci sont utilisables. Exemple typique : « environnement » avec production/recette/développement. L’obligation est surveillée (couverture ci-dessous) et le patching l’exige, mais elle ne bloque pas la découverte.',
  'Attiva «ambiente» standard':
    'Activer « environnement » standard',
  'qualunque valore (nessun vocabolario)':
    'n’importe quelle valeur (pas de vocabulaire)',
  'aggiungi un valore ammesso e premi Invio':
    'ajoutez une valeur admise et appuyez sur Entrée',
  'Aggiungi una chiave obbligatoria':
    'Ajouter une clé obligatoire',
  'Copertura sui CI':
    'Couverture sur les CI',
  'Nessuna chiave obbligatoria definita.':
    'Aucune clé obligatoire définie.',
  '{con} di {tot} CI hanno «{chiave}»; {mancano} mancanti.':
    '{con} CI sur {tot} ont « {chiave} » ; {mancano} manquants.',
  'Assegna «{val}» ai {n} CI senza':
    'Attribuer « {val} » aux {n} CI sans',
  'Nessuna attività registrata.':
    'Aucune activité enregistrée.',
  'Cosa è stato fatto su questo CI nel tempo: i cambi tecnici rilevati e le azioni eseguite. Dalla più recente.':
    'Ce qui a été fait sur ce CI au fil du temps : les changements techniques détectés et les actions effectuées. Du plus récent.',
  'azione':
    'action',
  'Patching':
    'Patching',
  'Finestre di manutenzione':
    'Fenêtres de maintenance',
  'Software installato':
    "Logiciel installé",
  'Critiche': 'Critiques',
  'Sfruttate attivamente': 'Activement exploitées',
  'Sfruttate': 'Exploitées',
  'subito':
    'maintenant',
  'Rollback':
    'Rollback',
  'Nuova finestra':
    'Nouvelle fenêtre',
  'Nessuna finestra definita.':
    'Aucune fenêtre définie.',
  'Lun':
    'Lun',
  'Mar':
    'Mar',
  'Mer':
    'Mer',
  'Gio':
    'Jeu',
  'Ven':
    'Ven',
  'Sab':
    'Sam',
  'Dom':
    'Dim',
  'una volta':
    'une fois',
  'ogni giorno':
    'chaque jour',
  'KB Windows':
    'KB Windows',
  'In uso ma non documentati in phpIPAM:':
    'Utilisés mais non documentés dans phpIPAM :',
  'Documenta in phpIPAM':
    'Documenter dans phpIPAM',
  'es. openai.com':
    'ex. openai.com',
  'es. ChatGPT':
    'ex. ChatGPT',
  'Diagnostica':
    'Diagnostic',
  'catalogo {n} servizi':
    'catalogue {n} services',
  'catalogo AI non ricevuto (add-on non attivo o sonda da aggiornare)':
    'catalogue IA non reçu (add-on inactif ou sonde à mettre à jour)',
  'non attivo':
    'non actif',
  'Servizi nel catalogo':
    'Services du catalogue',
  'IP riconosciuti (NetFlow)':
    'IP reconnues (NetFlow)',
  'certi':
    'certaines',
  'Ultimo avvistamento':
    'Dernière détection',
  'Righe d’uso':
    'Lignes d’usage',
  'Il catalogo è vuoto: il modulo non può riconoscere nulla. Di solito è una migrazione non applicata — riavvia il Control Plane.':
    'Le catalogue est vide : le module ne peut rien reconnaître. En général une migration non appliquée — redémarrez le Control Plane.',
  'Nessun IP ancora in mappa: il riconoscimento dai flussi NetFlow parte quando un mirror vede l’SNI (o dopo la risoluzione DNS del catalogo). Con un mirror attivo l’SNI rileva già da solo.':
    'Aucune IP encore dans la carte : la reconnaissance depuis NetFlow démarre quand un miroir voit le SNI (ou après la résolution DNS du catalogue). Avec un miroir actif, le SNI détecte déjà seul.',
  'Quando un oggetto non risponde perché è giù ciò che gli sta a monte (lo switch, l’host, il controller), Eagle non manda una mail per ciascun oggetto dietro: riconosce la causa dalle dipendenze e avvisa una volta sola, sulla radice, scrivendo l’impatto (quanti oggetti trascina e quali business service colpiti) e alzando la gravità se ne trascina altri. Un oggetto si può osservare da più punti (anche solo per il ping): è giù davvero solo se è giù da tutti.':
    'Quand un objet ne répond pas parce que ce qui est en amont est en panne (le commutateur, l’hôte, le contrôleur), Eagle n’envoie pas un e-mail par objet derrière lui : il reconnaît la cause à partir des dépendances et alerte une seule fois, sur la racine, en indiquant l’impact (combien d’objets il entraîne et quels services métier sont touchés) et en augmentant la gravité quand il en entraîne d’autres. Un objet peut être surveillé depuis plusieurs points (même seulement pour le ping) : il n’est vraiment en panne que s’il l’est depuis tous.',
  'Area clinica':
    'Zone clinique',
  'Catalogo elettromedicali ({n})':
    'Catalogue des dispositifs médicaux ({n})',
  'Classe di rischio':
    'Classe de risque',
  'Collegato al paziente':
    'Connecté au patient',
  'Condizioni (tutte)':
    'Conditions (toutes)',
  'DICOM':
    'DICOM',
  'Dati curati':
    'Données saisies',
  'Falsi positivi':
    'Faux positifs',
  'Fine vita':
    'Fin de vie',
  'HL7':
    'HL7',
  'Hardware (mai una VM)':
    'Matériel (jamais une VM)',
  'In più':
    'En plus',
  'LLDP':
    'LLDP',
  'Nessuna proprietà, da sola o in coppia, distingue questo modello dagli altri con precisione sufficiente: servono altri segnali (filo, annunci, flussi).':
    'Aucune propriété, seule ou en paire, ne distingue ce modèle des autres avec une précision suffisante : il faut d’autres signaux (filaire, annonces, flux).',
  'OEM':
    'OEM',
  'OUI':
    'OUI',
  'Precisione':
    'Précision',
  'Proprietà osservate':
    'Propriétés observées',
  'Recall':
    'Rappel',
  'Regole di riconoscimento ({n})':
    'Règles de reconnaissance ({n})',
  'Ricostruire il catalogo e le regole dagli inventari di riferimento di tutti gli ospedali? I dati curati e le regole sospese restano.':
    'Reconstruire le catalogue et les règles à partir des inventaires de référence de tous les hôpitaux ? Les données saisies et les règles suspendues sont conservées.',
  'Ricostruisci dal metro':
    'Reconstruire à partir de la référence',
  'Ricostruiscilo dal metro: servono inventari di riferimento importati nei tenant.':
    'Reconstruisez-le à partir de la référence : il faut des inventaires de référence importés dans les tenants.',
  'Ricostruzione…':
    'Reconstruction…',
  'Rivisto':
    'Revu',
  'SIP':
    'SIP',
  'SMB':
    'SMB',
  'SSDP':
    'SSDP',
  'SSH':
    'SSH',
  'Scheda MDS2 (URL)':
    'Fiche MDS2 (URL)',
  'Un modello per riga, con le proprietà che CENSO osserva sui suoi dispositivi (prefissi, impronta DHCP, annunci, filo, flussi) e i dati che nessuna rete mostra. Per ogni modello le regole di riconoscimento: combinazioni di proprietà che lo distinguono dagli altri in tutti gli ospedali, mai un prefisso MAC da solo, e mai valide se toccano una macchina informatica (VM, agente CENSO). Gli inventari di riferimento sono il metro: «in più» sono dispositivi che nessun inventario elenca e che una regola riconosce — da rivedere, non errori.':
    'Un modèle par ligne, avec les propriétés que CENSO observe sur ses dispositifs (préfixes, empreinte DHCP, annonces, filaire, flux) et les données qu’aucun réseau ne montre. Pour chaque modèle, les règles de reconnaissance : des combinaisons de propriétés qui le distinguent des autres dans tous les hôpitaux, jamais un préfixe MAC seul, et jamais valides si elles touchent une machine informatique (VM, agent CENSO). Les inventaires de référence servent de mesure : « en plus » sont des dispositifs qu’aucun inventaire ne liste et qu’une règle reconnaît — à revoir, pas des erreurs.',
  'User-Agent':
    'User-Agent',
  'WS-Discovery':
    'WS-Discovery',
  'candidata':
    'candidate',
  'classe vendor DHCP':
    'classe fournisseur DHCP',
  'elettromedicali negli inventari':
    'dispositifs médicaux dans les inventaires',
  'firmware':
    'firmware',
  'flussi: chiama':
    'flux : appelle',
  'flussi: risponde':
    'flux : répond',
  'flusso':
    'flux',
  'in più, da rivedere':
    'en plus, à revoir',
  'manuale':
    'manuelle',
  'modello mDNS':
    'modèle mDNS',
  'porta d’annuncio':
    'port d’annonce',
  'precisione ({n} falsi positivi)':
    'précision ({n} faux positifs)',
  'rivisto':
    'revu',
  'server HTTP':
    'serveur HTTP',
  'servizio mDNS':
    'service mDNS',
  'sistema operativo':
    'système d’exploitation',
  'validata':
    'validée',
  'visti da CENSO':
    'vus par CENSO',
  'Regole: {m} di modello, {f} di famiglia, {ti} di tipo, {v} di elettromedicale; validate in 2+ ospedali: {val}. Un dispositivo è riconosciuto al livello più preciso che una regola raggiunge; i valori sono cumulativi.':
    'Règles : {m} de modèle, {f} de famille, {ti} de type, {v} de dispositif médical ; validées dans 2+ hôpitaux : {val}. Un dispositif est reconnu au niveau le plus précis qu’une règle atteint ; les valeurs sont cumulatives.',
  'Riconosciuti (mod · fam · tipo · medic.)':
    'Reconnus (modèle · famille · type · médical)',
  'Ricostruzioni precedenti':
    'Reconstructions précédentes',
  'famiglia':
    'famille',
  'modello · famiglia · tipo · elettromedicale':
    'modèle · famille · type · dispositif médical',
  'riconosciuti come {livello}':
    'reconnus comme {livello}',
  '{n} dispositivi riconosciuti a un livello con il valore sbagliato (es. il tipo).':
    '{n} dispositifs reconnus à un niveau avec la mauvaise valeur (ex. le type).',
  'Applica le selezionate ({n})':
    'Appliquer la sélection ({n})',
  'Applicare {n} correzioni alla base? Le voci eliminate smettono subito di riconoscere, quelle ristrette valgono solo nell’ospedale indicato.':
    'Appliquer {n} corrections à la base ? Les entrées supprimées cessent aussitôt de reconnaître, celles restreintes ne valent que dans l’hôpital indiqué.',
  'Correzione':
    'Correction',
  'Dove si vedono solo i flussi (NetFlow, IPFIX, sFlow) e nessun nome, CENSO riconosce un dispositivo da come si comporta: su quale porta chiama gli altri (un analizzatore che manda i risultati al middleware del laboratorio, una modalità che manda immagini al PACS) e su quale viene chiamato. Ogni sei ore ricava questi comportamenti dagli ultimi sette giorni di flussi, togliendo le porte generiche; una porta da sola però non dice il modello (la usano anche server e PC), quindi vale solo come indizio e il catalogo elettromedicali la usa insieme ad altre proprietà. I flussi vedono il traffico che passa da un router: un monitor che parla con la sua centrale nella stessa VLAN non compare.':
    'Là où l’on ne voit que les flux (NetFlow, IPFIX, sFlow) et aucun nom, CENSO reconnaît un appareil à son comportement : sur quel port il appelle les autres (un analyseur qui envoie les résultats au middleware du laboratoire, une modalité qui envoie des images au PACS) et sur quel port il est appelé. Toutes les six heures il déduit ces comportements des sept derniers jours de flux, en écartant les ports génériques ; un port seul ne dit pourtant pas le modèle (serveurs et PC l’utilisent aussi), il ne vaut donc que comme indice et le catalogue des dispositifs médicaux l’utilise avec d’autres propriétés. Les flux voient le trafic qui passe par un routeur : un moniteur qui parle à sa centrale dans le même VLAN n’apparaît pas.',
  'Eliminate {d} voci, {r} ristrette a un ospedale.':
    '{d} entrées supprimées, {r} restreintes à un hôpital.',
  'Imparate: {p} prefissi, {f} impronte, {h} nomi di prodotto, {a} annunci in rete; {o} solo per l’ospedale che le ha insegnate.':
    'Appris : {p} préfixes, {f} empreintes, {h} noms de produit, {a} annonces réseau ; {o} seulement pour l’hôpital qui les a enseignés.',
  'La base passa i controlli':
    'La base passe les contrôles',
  'La card «Confronto con un inventario di riferimento» importa l’elenco dei dispositivi di Armis, di Medigate o dell’Ingegneria Clinica (Excel o CSV con una colonna di MAC o di IP; solo amministratori) e dice per ognuno se CENSO lo vede e se lo riconosce: stesso modello, elettromedicale, tipo generico, visto ma non riconosciuto, non visto. La tabella per tipo dà la copertura e ogni riga apre la lista. «Firme da imparare» propone le regole per la base di riconoscimento di CENSO (prefisso MAC, impronta DHCP o nome che portano sempre lo stesso modello o tipo); le scrive l’amministrazione della piattaforma. Le firme sicure valgono per tutti i tenant; un nome dato dall’ospedale vale solo per l’ospedale che l’ha insegnato. Una volta imparate restano anche se l’inventario di riferimento si cancella: è così che CENSO ritrova da solo gli elettromedicali. Non diventano mai una regola i PC e i server di marca generica, il prefisso di chi fa la scheda o il PC (OEM), l’impronta DHCP di Windows o Linux e la sola porta vista nei flussi: dicono chi ha fatto la scheda o che sistema gira, non quale dispositivo è.':
    'La carte «Comparaison avec un inventaire de référence» importe la liste des appareils d’Armis, de Medigate ou du génie biomédical (Excel ou CSV avec une colonne de MAC ou d’IP ; administrateurs seulement) et indique pour chacun si CENSO le voit et le reconnaît : même modèle, dispositif médical, type générique, vu mais non reconnu, non vu. Le tableau par type donne la couverture et chaque ligne ouvre la liste. «Signatures à apprendre» propose les règles pour la base de reconnaissance de CENSO (préfixe MAC, empreinte DHCP ou nom qui portent toujours le même modèle ou type) ; l’administration de la plateforme les écrit. Les signatures sûres valent pour tous les tenants ; un nom donné par l’hôpital ne vaut que pour l’hôpital qui l’a enseigné. Une fois apprises, elles restent même si l’inventaire de référence est supprimé : c’est ainsi que CENSO retrouve seul les dispositifs médicaux. Les PC et serveurs de marque générique, le préfixe de celui qui fabrique la carte ou le PC (OEM), l’empreinte DHCP de Windows ou de Linux et un port vu seul dans les flux ne deviennent jamais une règle : ils disent qui a fabriqué la carte ou quel système tourne, pas quel appareil c’est.',
  'Le firme che gli inventari di riferimento caricati nei tenant insegnano, unite. Quelle sicure si imparano per tutti i tenant; un nome dato dall’ospedale o un modello su cui gli ospedali non concordano si imparano solo per gli ospedali che li hanno insegnati, ognuno con il suo modello. Il prefisso di chi fa la scheda o il PC (OEM), l’impronta DHCP di Windows o Linux e la sola porta vista nei flussi non arrivano più qui: il catalogo elettromedicali li usa solo insieme ad altre proprietà. Arrivano qui solo la firma e i conteggi, mai MAC, nomi o indirizzi dei clienti.':
    'Les signatures qu’enseignent les inventaires de référence chargés dans les tenants, réunies. Les sûres s’apprennent pour tous les tenants ; un nom donné par l’hôpital ou un modèle sur lequel les hôpitaux ne s’accordent pas s’apprend seulement pour les hôpitaux qui l’ont enseigné, chacun avec son modèle. Le préfixe de celui qui fabrique la carte ou le PC (OEM), l’empreinte DHCP de Windows ou de Linux et un port vu seul dans les flux n’arrivent plus ici : le catalogue des dispositifs médicaux ne les utilise qu’avec d’autres propriétés. Seuls la signature et les décomptes arrivent ici, jamais les MAC, noms ou adresses des clients.',
  'Ogni voce della base passa dagli stessi controlli delle regole del catalogo elettromedicali. Si eliminano le impronte DHCP di Windows o Linux, i prefissi di chi fa la scheda o il PC (OEM), gli indirizzi dati «per stessa impronta» che l’inventario non conferma, le porte dei flussi insegnate da un solo ospedale e le parole comuni; i nomi che un ospedale dà ai suoi dispositivi restano solo per quell’ospedale. Le voci scritte a mano non si toccano. Nulla cambia finché non applichi.':
    'Chaque entrée de la base passe par les mêmes contrôles que les règles du catalogue des dispositifs médicaux. Sont supprimés : les empreintes DHCP de Windows ou de Linux, les préfixes de celui qui fabrique la carte ou le PC (OEM), les adresses données «par même empreinte» que l’inventaire ne confirme pas, les ports des flux enseignés par un seul hôpital et les mots courants ; les noms qu’un hôpital donne à ses appareils restent pour cet hôpital seulement. Les entrées écrites à la main ne sont pas touchées. Rien ne change tant que vous n’appliquez pas.',
  'Prefissi e impronte DHCP dietro cui gli inventari mettono tipi o modelli diversi, postazioni e server di marca generica, prefissi di chi fa la scheda o il PC (OEM) e impronte DHCP di Windows o Linux: nessuna regola possibile da soli. Questi dispositivi si riconoscono dal nome che annunciano, dai protocolli sul filo, con la scansione o con le regole congiunte del catalogo elettromedicali.':
    'Préfixes et empreintes DHCP derrière lesquels les inventaires mettent des types ou modèles différents, postes et serveurs de marque générique, préfixes de celui qui fabrique la carte ou le PC (OEM) et empreintes DHCP de Windows ou de Linux : aucune règle possible à eux seuls. Ces appareils se reconnaissent au nom qu’ils annoncent, aux protocoles sur le fil, par le scan ou par les règles combinées du catalogue des dispositifs médicaux.',
  'Scrivere {n} firme nella base di riconoscimento CENSO? I nomi dati dall’ospedale valgono solo per questo ospedale, le altre per tutti i tenant. Verifica che il contratto con il fornitore dell’inventario consenta di usarne le classificazioni.':
    'Écrire {n} signatures dans la base de reconnaissance CENSO ? Les noms donnés par l’hôpital ne valent que pour cet hôpital, les autres pour tous les tenants. Vérifiez que le contrat avec le fournisseur de l’inventaire permet d’en utiliser les classifications.',
  'Un prefisso MAC del costruttore del dispositivo che nell’inventario porta sempre lo stesso modello (o lo stesso tipo e marca), un’impronta DHCP o un nome che portano sempre lo stesso modello; i nomi dati dall’ospedale si imparano solo per questo ospedale. Non diventano mai una regola il prefisso di chi fa la scheda o il PC (OEM), l’impronta DHCP di Windows o Linux, la sola porta vista nei flussi e i PC o server di marca generica: dicono chi ha fatto la scheda o che sistema gira, non quale dispositivo è.':
    'Un préfixe MAC du fabricant de l’appareil qui porte toujours le même modèle (ou le même type et la même marque) dans l’inventaire, une empreinte DHCP ou un nom qui portent toujours le même modèle ; les noms donnés par l’hôpital ne s’apprennent que pour cet hôpital. Le préfixe de celui qui fabrique la carte ou le PC (OEM), l’empreinte DHCP de Windows ou de Linux, un port vu seul dans les flux et les PC ou serveurs de marque générique ne deviennent jamais une règle : ils disent qui a fabriqué la carte ou quel système tourne, pas quel appareil c’est.',
  'Verifica della base':
    'Vérification de la base',
  'impronta DHCP del sistema operativo (Windows, Linux): uguale su ogni PC con quella scheda':
    'empreinte DHCP du système d’exploitation (Windows, Linux) : la même sur chaque PC avec cette carte',
  'impronta DHCP di Windows o Linux, non del prodotto':
    'empreinte DHCP de Windows ou de Linux, pas du produit',
  'impronta DHCP su una scheda o un PC di un OEM':
    'empreinte DHCP sur une carte ou un PC d’un OEM',
  'impronta del sistema operativo':
    'empreinte du système d’exploitation',
  'indirizzo dato «per stessa impronta» su una scheda OEM, che l’inventario non conferma':
    'adresse donnée «par même empreinte» sur une carte OEM, que l’inventaire ne confirme pas',
  'indirizzo intero valido in tutti i tenant: è il dispositivo di un cliente':
    'adresse complète valable dans tous les tenants : c’est l’appareil d’un client',
  'l’inventario dell’ospedale lo elenca come un altro modello':
    'l’inventaire de l’hôpital le liste comme un autre modèle',
  'nome dato da un ospedale ai suoi dispositivi, non dal costruttore':
    'nom qu’un hôpital donne à ses appareils, pas celui du fabricant',
  'parola comune, non il nome di un prodotto':
    'mot courant, pas un nom de produit',
  'porta generica nei flussi':
    'port générique dans les flux',
  'porta vista nei flussi di un solo ospedale: da sola non distingue il modello':
    'port vu dans les flux d’un seul hôpital : à lui seul il ne distingue pas le modèle',
  'prefisso OEM':
    'préfixe OEM',
  'prefisso di chi fa la scheda o il PC ({v}), non del costruttore del dispositivo':
    'préfixe de celui qui fabrique la carte ou le PC ({v}), pas du fabricant de l’appareil',
  'prefisso di chi fa la scheda o il PC, non del costruttore del dispositivo':
    'préfixe de celui qui fabrique la carte ou le PC, pas du fabricant de l’appareil',
  '{n} voci verificate, {f} da correggere: {v}.':
    '{n} entrées vérifiées, {f} à corriger : {v}.',
  '{n} voci verificate.':
    '{n} entrées vérifiées.',
  'Agenti che leggono i nomi':
    'Agents qui lisent les noms',
  'Catalogo ricevuto, lettura in avvio.':
    'Catalogue reçu, lecture en démarrage.',
  'Dai flussi sì: {s}.':
    'Les flux voient : {s}.',
  'Dai soli flussi NetFlow non si riconoscono: {s}. Stanno su indirizzi condivisi (Cloudflare, Google, Microsoft, Akamai) con migliaia di altri siti, quindi un flusso verso di loro non dice quale sito. Li riconoscono l’ascolto passivo della sonda (il nome TLS, anche in HTTP/3, e le domande DNS) e l’agente CENSO sulla macchina, che vede i nomi che risolve.':
    'Les seuls flux NetFlow ne reconnaissent pas : {s}. Ils sont sur des adresses partagées (Cloudflare, Google, Microsoft, Akamai) avec des milliers d’autres sites, donc un flux vers eux ne dit pas quel site. L’écoute passive de la sonde (le nom TLS, HTTP/3 compris, et les requêtes DNS) et l’agent CENSO sur la machine, qui voit les noms qu’elle résout, les reconnaissent.',
  'Legge i nomi che la macchina risolve ({m}): {n} servizi nel catalogo, {r} usi riconosciuti dall’avvio.':
    'Lit les noms que la machine résout ({m}) : {n} services dans le catalogue, {r} usages reconnus depuis le démarrage.',
  'Lettura dei nomi non attiva':
    'Lecture des noms inactive',
  'Tre fonti, indicate nella colonna «Fonte»: la sonda (SNI in ascolto passivo), l’agente CENSO sulla macchina — che confronta con il catalogo i nomi che la macchina risolve (cache DNS su Windows, risposte DNS su Linux) e manda solo quelli dei servizi AI — e i flussi NetFlow verso gli IP propri di un servizio (imparati dall’SNI o risolti dal DNS del catalogo). ChatGPT, l’API di OpenAI, Copilot e Gemini stanno su indirizzi condivisi (Cloudflare, Google) con migliaia di altri siti: dai soli flussi non si possono distinguere, e per loro servono la sonda con un mirror o l’agente. La scheda Diagnostica dice quali servizi i flussi vedono e quali no, quanti agenti leggono i nomi e quando è arrivato l’ultimo uso.':
    'Trois sources, indiquées dans la colonne «Source» : la sonde (SNI en écoute passive), l’agent CENSO sur la machine — qui compare au catalogue les noms que la machine résout (cache DNS sous Windows, réponses DNS sous Linux) et n’envoie que ceux des services d’IA — et les flux NetFlow vers les IP propres d’un service (apprises du SNI ou résolues par le DNS du catalogue). ChatGPT, l’API d’OpenAI, Copilot et Gemini sont sur des adresses partagées (Cloudflare, Google) avec des milliers d’autres sites : les flux seuls ne peuvent pas les distinguer, et pour eux il faut la sonde avec un miroir ou l’agent. La carte Diagnostic indique quels services les flux voient et lesquels non, combien d’agents lisent les noms et quand est arrivé le dernier usage.',
  'agente':
    'agent',
  'cache DNS di Windows':
    'cache DNS de Windows',
  'flussi NetFlow':
    'flux NetFlow',
  'risposte DNS':
    'réponses DNS',
  'sonda (SNI)':
    'sonde (SNI)',
  'Adozione':
    'Adoption',
  'Andamento nel tempo':
    'Évolution dans le temps',
  'Asset alla prima volta':
    'Actifs pour la première fois',
  'Asset che usano un’AI per la prima volta, giorno per giorno. In tutto {n} asset l’hanno usata almeno una volta.':
    'Actifs qui utilisent une IA pour la première fois, jour par jour. Au total, {n} actifs en ont utilisé une au moins une fois.',
  'Da dove arriva il dato':
    'D’où vient la donnée',
  'Giorni con uso':
    'Jours avec usage',
  'I primi quattro servizi hanno una tinta propria, gli altri sono sommati in «altri servizi».':
    'Les quatre premiers services ont leur propre couleur, les autres sont additionnés dans «autres services».',
  'Le statistiche, sempre senza nomi: usi, asset e servizi con il confronto rispetto al periodo precedente della stessa durata; l’andamento per giorno per servizio (i primi quattro, gli altri sommati) o per tipo (chat, codice, immagini, ricerca); la mappa giorno della settimana × ora nell’ora locale, con la quota d’uso fuori orario e nel fine settimana; l’adozione (asset che usano un’AI per la prima volta); da quali fonti arriva il dato; la concentrazione (quanta parte degli usi fa il 10% degli asset più attivi); i servizi nuovi nel periodo e, per ogni servizio, giorni d’uso, volume, prima e ultima volta.':
    'Les statistiques, toujours sans noms : usages, actifs et services comparés à la période précédente de même durée ; l’évolution par jour par service (les quatre premiers, les autres additionnés) ou par type (chat, code, images, recherche) ; la carte jour de la semaine × heure en heure locale, avec la part d’usage hors horaires et le week-end ; l’adoption (actifs qui utilisent une IA pour la première fois) ; de quelles sources vient la donnée ; la concentration (quelle part des usages font les 10 % d’actifs les plus actifs) ; les nouveaux services de la période et, pour chaque service, jours d’usage, volume, première et dernière fois.',
  'Nessun asset nuovo nel periodo.':
    'Aucun nouvel actif sur la période.',
  'Nessuna fonte nel periodo.':
    'Aucune source sur la période.',
  'Prima volta':
    'Première fois',
  'Raggruppa per':
    'Regrouper par',
  'Rispetto a prima':
    'Par rapport à avant',
  'Servizi nel dettaglio':
    'Services en détail',
  'Servizi nuovi nel periodo':
    'Nouveaux services sur la période',
  'Ultima volta':
    'Dernière fois',
  'Un uso visto da due fonti conta per entrambe. Il {p}% degli asset più attivi ({n} su {m}) fa il {q}% degli usi.':
    'Un usage vu par deux sources compte pour les deux. Les {p} % d’actifs les plus actifs ({n} sur {m}) font {q} % des usages.',
  'Usi per giorno':
    'Usages par jour',
  'Usi per giorno della settimana e ora, nell’ora locale. Fuori orario (prima delle 8, dalle 19 o nel fine settimana): {f}% · nel fine settimana: {w}% · ora più intensa: {h}.':
    'Usages par jour de la semaine et heure, en heure locale. Hors horaires (avant 8 h, dès 19 h ou le week-end) : {f} % · le week-end : {w} % · heure la plus chargée : {h}.',
  'Usi per giorno, dal {da} al {a}.':
    'Usages par jour, du {da} au {a}.',
  'Uso per giorno della settimana e ora':
    'Usage par jour de la semaine et heure',
  'altri servizi':
    'autres services',
  'meno':
    'moins',
  'per servizio':
    'par service',
  'più':
    'plus',
  'rispetto al periodo precedente della stessa durata':
    'par rapport à la période précédente de même durée',
  'usi':
    'usages',
  '{v} rispetto al periodo precedente ({p})':
    '{v} par rapport à la période précédente ({p})',
  'Alta disponibilità':
    'Haute disponibilité',
  'Appliance':
    'Appliances',
  'Archiviazione del database':
    'Stockage de la base',
  'Classe del database':
    'Classe de la base',
  'Componenti da aggiornare':
    'Composants à mettre à jour',
  'Contenitore (CDB)':
    'Conteneur (CDB)',
  'DB home':
    'DB home',
  'Data center':
    'Data center',
  "Data center, cluster, host KVM (con modello, seriale e UUID dell'hardware), macchine virtuali (CPU, memoria, sistema ospite, indirizzi dal guest agent, dischi, reti), domini di storage e reti logiche di un engine OLVM, via REST API v4 in sola lettura. Funziona anche con oVirt e Red Hat Virtualization.":
    "Data centers, clusters, hôtes KVM (avec modèle, numéro de série et UUID du matériel), machines virtuelles (CPU, mémoire, système invité, adresses de l’agent invité, disques, réseaux), domaines de stockage et réseaux logiques d’un moteur OLVM, via l’API REST v4 en lecture seule. Fonctionne aussi avec oVirt et Red Hat Virtualization.",
  'Database appliance':
    'Appliance de base de données',
  'Dischi assegnati (GB)':
    'Disques alloués (Go)',
  'Dischi occupati (GB)':
    'Disques occupés (Go)',
  'Famiglia CPU del cluster':
    'Famille CPU du cluster',
  'Forma del database':
    'Forme de la base',
  'Frequenza CPU (MHz)':
    'Fréquence CPU (MHz)',
  'Gestito da':
    'Géré par',
  'Id OLVM':
    'Id OLVM',
  "L'appliance (modello, versione, edizione, componenti installati e aggiornabili, DB home), i nodi con seriale e UUID dell'hardware, i database (versione, edizione, ruolo, SI/RAC, CDB/PDB, home, storage) e le VM/DB system KVM. Bersagli: gli indirizzi dei nodi (in un HA bastano entrambi, l'appliance resta una). Credenziale SSH di root, o di un utente con sudo senza password per odacli: si eseguono solo comandi di lettura.":
    "L’appliance (modèle, version, édition, composants installés et à mettre à jour, DB homes), les nœuds avec numéro de série et UUID du matériel, les bases (version, édition, rôle, SI/RAC, CDB/PDB, home, stockage) et les VM/DB systems KVM. Cibles : les adresses des nœuds (en HA, indiquez les deux, l’appliance reste une). Identifiant SSH de root, ou d’un utilisateur avec sudo sans mot de passe pour odacli : seules des commandes de lecture sont exécutées.",
  'Livello di compatibilità':
    'Niveau de compatibilité',
  'Modello ODA':
    'Modèle ODA',
  'Nome univoco del database':
    'Nom unique de la base',
  'Oracle Database Appliance (ODA)':
    'Oracle Database Appliance (ODA)',
  'Oracle Linux Virtualization Manager (OLVM)':
    'Oracle Linux Virtualization Manager (OLVM)',
  'PDB':
    'PDB',
  'Percorso della DB home':
    'Chemin de la DB home',
  'Ruolo del database':
    'Rôle de la base',
  'Senza stato':
    'Sans état',
  'Set di caratteri':
    'Jeu de caractères',
  'Sistema operativo dichiarato':
    'Système d’exploitation déclaré',
  'Spazio promesso alle VM':
    'Espace promis aux VM',
  'Tipo di VM':
    'Type de VM',
  'Tipo di database':
    'Type de base',
  'Tipo di dominio':
    'Type de domaine',
  'Tipo di host':
    'Type d’hôte',
  "URL dell'engine («https://olvm.example.com»; «/ovirt-engine/api» si può omettere). Con utente e password l'utente va scritto con il profilo: «admin@internal» o «lettore@dominio». Basta un ruolo in sola lettura sul sistema (ReadOnlyAdmin, o UserRole con visibilità su tutti i data center). Il token è un token SSO dell'engine (Bearer). Vale anche per oVirt e Red Hat Virtualization.":
    "URL du moteur («https://olvm.example.com» ; «/ovirt-engine/api» peut être omis). Avec utilisateur et mot de passe, écrivez l’utilisateur avec son profil : «admin@internal» ou «lecteur@domaine». Un rôle en lecture seule sur le système suffit (ReadOnlyAdmin, ou UserRole avec visibilité sur tous les data centers). Le jeton est un jeton SSO du moteur (Bearer). Valable aussi pour oVirt et Red Hat Virtualization.",
  'Versione ODA':
    'Version ODA',
  'Versione libvirt':
    'Version libvirt',
  'Crea una credenziale SSH di root (o di un utente con sudo senza password per odacli) e lancia il job «Oracle Database Appliance (ODA)» con gli indirizzi dei nodi come bersagli: in un ODA HA indica entrambi i nodi, l’appliance resta una sola.':
    'Créez un identifiant SSH de root (ou d’un utilisateur avec sudo sans mot de passe pour odacli) et lancez le job «Oracle Database Appliance (ODA)» avec les adresses des nœuds comme cibles : dans un ODA HA indiquez les deux nœuds, l’appliance reste une seule.',
  'I sistemi integrati hardware e software, che si comprano e si aggiornano come un oggetto solo. Oggi Oracle Database Appliance (ODA): la sonda entra in SSH sui nodi ed esegue solo comandi di lettura di odacli, e in Configuration Item compaiono l’appliance (modello, versione, edizione, componenti installati e aggiornabili, DB home), i nodi come server con seriale e UUID dell’hardware, i database con versione, edizione, ruolo, tipo (singola istanza o RAC), CDB/PDB e home, e le VM o DB system KVM.':
    'Les systèmes intégrés matériel et logiciel, achetés et mis à jour comme un seul objet. Aujourd’hui Oracle Database Appliance (ODA) : la sonde se connecte en SSH aux nœuds et n’exécute que des commandes de lecture d’odacli, et les Configuration Items montrent l’appliance (modèle, version, édition, composants installés et à mettre à jour, DB homes), les nœuds comme serveurs avec numéro de série et UUID du matériel, les bases avec version, édition, rôle, type (instance unique ou RAC), CDB/PDB et home, et les VM ou DB systems KVM.',
  'Come preparo gli apparati per CENSO con SNMP v3?':
    'Comment préparer les équipements pour CENSO avec SNMP v3 ?',
  'SNMP v3 authPriv (SHA-2 e AES) è il modo consigliato: autentica e cifra. CENSO legge in sola lettura dalla sonda, sulla porta UDP 161.':
    'SNMP v3 authPriv (SHA-2 et AES) est la méthode recommandée : il authentifie et chiffre. CENSO lit en lecture seule depuis la sonde, sur le port UDP 161.',
  'A) Utente v3 su una vista in sola lettura':
    'A) Un utilisateur v3 sur une vue en lecture seule',
  'Crea una vista, un gruppo v3 in lettura su quella vista e un utente con autenticazione e cifratura; limita il gruppo all’indirizzo della sonda con un’ACL.':
    'Créez une vue, un groupe v3 en lecture sur cette vue et un utilisateur avec authentification et chiffrement ; limitez le groupe à l’adresse de la sonde avec une ACL.',
  'In CENSO scegli gli stessi protocolli: SHA o SHA-256 per l’autenticazione, AES per la cifratura (sui Cisco con «aes 192/256» usa AES192C o AES256C).':
    'Dans CENSO, choisissez les mêmes protocoles : SHA ou SHA-256 pour l’authentification, AES pour le chiffrement (sur les Cisco avec «aes 192/256», utilisez AES192C ou AES256C).',
  'B) Il percorso di rete':
    'B) Le chemin réseau',
  'Dalla sonda agli apparati deve passare UDP 161: verificalo con un firewall in mezzo.':
    'L’UDP 161 doit passer de la sonde vers les équipements : vérifiez-le s’il y a un pare-feu entre les deux.',
  'Come preparo gli apparati per CENSO con SNMP v2c?':
    'Comment préparer les équipements pour CENSO avec SNMP v2c ?',
  'CENSO legge gli apparati (switch, router, firewall, UPS, iDRAC/iLO, storage) in SNMP in sola lettura dalla sonda, sulla porta UDP 161. Dove l’apparato lo supporta, preferisci SNMP v3 authPriv.':
    'CENSO lit les équipements (switchs, routeurs, pare-feu, onduleurs, iDRAC/iLO, stockage) en SNMP, en lecture seule, depuis la sonde sur le port UDP 161. Quand l’équipement le permet, préférez SNMP v3 authPriv.',
  'A) Una community in sola lettura, limitata alla sonda':
    'A) Une community en lecture seule, limitée à la sonde',
  'Crea una community dedicata in sola lettura (mai «public»), legata a un’ACL che ammette solo l’indirizzo della sonda.':
    'Créez une community dédiée en lecture seule (jamais «public»), liée à une ACL qui n’autorise que l’adresse de la sonde.',
  'Non dare mai una community in scrittura: a CENSO basta leggere.':
    'Ne donnez jamais une community en écriture : CENSO n’a besoin que de lire.',
  'In CENSO puoi raggruppare più credenziali SNMP: la sonda le prova in ordine finché una risponde.':
    'Dans CENSO, vous pouvez regrouper plusieurs identifiants SNMP : la sonde les essaie dans l’ordre jusqu’à ce que l’un réponde.',
  'Come preparo gli apparati per CENSO con SNMP v1?':
    'Comment préparer les équipements pour CENSO avec SNMP v1 ?',
  'Come preparo Microsoft Azure per CENSO (app in sola lettura)?':
    'Comment préparer Microsoft Azure pour CENSO (application en lecture seule) ?',
  'CENSO legge le risorse delle sottoscrizioni con un’app registrata in Entra ID (service principal) che ha il ruolo Reader: nessuna scrittura.':
    'CENSO lit les ressources des abonnements avec une application inscrite dans Entra ID (principal de service) qui a le rôle Reader : aucune écriture.',
  'A) L’app e il suo segreto':
    'A) L’application et son secret',
  'Entra ID → Registrazioni app → Nuova registrazione: un nome (per esempio «censo-inventory»). Annota ID tenant (directory) e ID applicazione (client).':
    'Entra ID → Inscriptions d’applications → Nouvelle inscription : un nom (par exemple «censo-inventory»). Notez l’ID du tenant (annuaire) et l’ID d’application (client).',
  'Certificati e segreti: carica un certificato (consigliato: il segreto non lascia mai la sonda) oppure crea un segreto client e copialo subito.':
    'Certificats et secrets : chargez un certificat (recommandé : le secret ne quitte jamais la sonde) ou créez un secret client et copiez-le immédiatement.',
  'B) I ruoli':
    'B) Les rôles',
  'Su ogni sottoscrizione da inventariare: Controllo di accesso (IAM) → Aggiungi assegnazione di ruolo → «Reader» all’app.':
    'Sur chaque abonnement à inventorier : Contrôle d’accès (IAM) → Ajouter une attribution de rôle → «Reader» à l’application.',
  'Per i costi mensili aggiungi «Cost Management Reader»; per l’import avanzato «Log Analytics Reader» sul workspace.':
    'Pour les coûts mensuels, ajoutez «Cost Management Reader» ; pour l’import avancé, «Log Analytics Reader» sur l’espace de travail.',
  'Come preparo Google Cloud per CENSO (service account in sola lettura)?':
    'Comment préparer Google Cloud pour CENSO (compte de service en lecture seule) ?',
  'CENSO legge i progetti con un service account che ha il ruolo Viewer. Il modo consigliato è l’impersonazione: la chiave distribuita può solo impersonare, e revocare l’accesso non richiede di ruotarla.':
    'CENSO lit les projets avec un compte de service qui a le rôle Viewer. La méthode recommandée est l’emprunt d’identité : la clé distribuée ne peut qu’emprunter l’identité, et révoquer l’accès ne demande pas de la changer.',
  'A) Il service account':
    'A) Le compte de service',
  'IAM e amministrazione → Service account → Crea: un nome (per esempio «censo-inventory») e il ruolo «Viewer» (roles/viewer) sul progetto o sulla cartella.':
    'IAM et administration → Comptes de service → Créer : un nom (par exemple «censo-inventory») et le rôle «Viewer» (roles/viewer) sur le projet ou le dossier.',
  'Abilita l’API «IAM Service Account Credentials» nel progetto.':
    'Activez l’API «IAM Service Account Credentials» dans le projet.',
  'B) L’accesso':
    'B) L’accès',
  'Impersonazione (consigliata): all’identità che CENSO usa concedi «Service Account Token Creator» (roles/iam.serviceAccountTokenCreator) sul service account di inventario, non sul progetto.':
    'Emprunt d’identité (recommandé) : accordez à l’identité utilisée par CENSO «Service Account Token Creator» (roles/iam.serviceAccountTokenCreator) sur le compte de service d’inventaire, pas sur le projet.',
  'In alternativa: Chiavi → Aggiungi chiave → JSON, e incolla qui i campi del file.':
    'Sinon : Clés → Ajouter une clé → JSON, et collez ici les champs du fichier.',
  'Come preparo Oracle Cloud per CENSO (chiave API in sola lettura)?':
    'Comment préparer Oracle Cloud pour CENSO (clé API en lecture seule) ?',
  'CENSO legge la tenancy (o un compartimento) con la chiave API di un utente che sta in un gruppo con policy di sola lettura.':
    'CENSO lit la tenancy (ou un compartiment) avec la clé API d’un utilisateur membre d’un groupe aux politiques en lecture seule.',
  'A) Utente, gruppo e policy':
    'A) Utilisateur, groupe et politique',
  'Identity → Users: crea l’utente «censo»; Groups: crea «CensoReaders» e mettici l’utente.':
    'Identity → Users : créez l’utilisateur «censo» ; Groups : créez «CensoReaders» et ajoutez-y l’utilisateur.',
  'Policies: una policy di sola lettura sul compartimento (o sulla tenancy).':
    'Policies : une politique en lecture seule sur le compartiment (ou la tenancy).',
  'B) La chiave API':
    'B) La clé API',
  'Sull’utente: API Keys → Add API Key. Genera la coppia (chiave **senza passphrase**: un processo non presidiato non può digitarla) e annota l’impronta che Oracle mostra.':
    'Sur l’utilisateur : API Keys → Add API Key. Générez la paire (clé **sans phrase secrète** : un processus sans surveillance ne peut pas la saisir) et notez l’empreinte affichée par Oracle.',
  'Qui servono OCID della tenancy e dell’utente, impronta, regione (identificativo, per esempio «eu-milan-1») e la chiave privata.':
    'Ici il faut les OCID de la tenancy et de l’utilisateur, l’empreinte, la région (identifiant, par exemple «eu-milan-1») et la clé privée.',
  'Come preparo ntopng per CENSO (utente o token in lettura)?':
    'Comment préparer ntopng pour CENSO (utilisateur ou jeton en lecture) ?',
  'CENSO interroga ntopng in tempo reale attraverso una sonda, sulla porta della console (di norma 3000).':
    'CENSO interroge ntopng en temps réel via une sonde, sur le port de la console (en général 3000).',
  'Impostazioni → Gestisci utenti → Aggiungi: un utente non privilegiato dedicato (per esempio «censo»), con le reti che deve vedere.':
    'Paramètres → Gérer les utilisateurs → Ajouter : un utilisateur non privilégié dédié (par exemple «censo»), avec les réseaux qu’il doit voir.',
  'Sull’utente genera il token API (consigliato): si revoca da solo, senza toccare la password.':
    'Sur l’utilisateur, générez le jeton API (recommandé) : il se révoque seul, sans toucher au mot de passe.',
  'B) La sonda':
    'B) La sonde',
  'Scegli qui sotto la sonda che raggiunge ntopng: le richieste escono solo da lì.':
    'Choisissez ci-dessous la sonde qui atteint ntopng : les requêtes ne partent que de là.',
  'Il certificato della console di solito è interno o autofirmato: incolla la CA o l’impronta SHA-256 nei campi TLS, invece di disattivare la verifica.':
    'Le certificat de la console est souvent interne ou auto-signé : collez la CA ou l’empreinte SHA-256 dans les champs TLS, au lieu de désactiver la vérification.',
  'Come preparo Cynet per CENSO (utente API)?':
    'Comment préparer Cynet pour CENSO (utilisateur API) ?',
  'CENSO legge da Cynet la copertura degli endpoint (chi ha l’agente e chi no) e gli allarmi, in sola lettura.':
    'CENSO lit dans Cynet la couverture des postes (qui a l’agent et qui ne l’a pas) et les alertes, en lecture seule.',
  'A) L’utente API':
    'A) L’utilisateur API',
  'Console Cynet → Settings → API Management → Create API User, con permessi di sola lettura.':
    'Console Cynet → Settings → API Management → Create API User, avec des permissions en lecture seule.',
  'Copia Access Key e Secret Key (Cynet le mostra una volta sola) e il Client ID (Site ID) del sito.':
    'Copiez Access Key et Secret Key (Cynet ne les affiche qu’une fois) et le Client ID (Site ID) du site.',
  'B) Da dove si parla':
    'B) D’où on interroge',
  'Cynet in cloud: scegli «Control Plane» in «Da dove si parla». On-premise: la sonda che raggiunge la console.':
    'Cynet dans le cloud : choisissez «Control Plane» dans «D\'où l\'on communique». Sur site : la sonde qui atteint la console.',
  'Come preparo il Palo Alto per CENSO (amministratore in sola lettura)?':
    'Comment préparer le Palo Alto pour CENSO (administrateur en lecture seule) ?',
  'CENSO interroga il firewall (o Panorama) con la XML API di PAN-OS, attraverso una sonda: legge stato, sessioni, log e configurazione, non cambia nulla.':
    'CENSO interroge le pare-feu (ou Panorama) avec l’API XML de PAN-OS, via une sonde : il lit état, sessions, journaux et configuration, il ne modifie rien.',
  'A) Il ruolo in sola lettura':
    'A) Le rôle en lecture seule',
  'Device → Admin Roles → Add: un profilo (per esempio «censo-readonly») con la Web UI disattivata e, nella scheda XML API, abilitati Report, Log, Configuration e Operational Requests; nessuna scrittura (Commit disattivato).':
    'Device → Admin Roles → Add : un profil (par exemple «censo-readonly») avec la Web UI désactivée et, dans l’onglet XML API, Report, Log, Configuration et Operational Requests activés ; aucune écriture (Commit désactivé).',
  'B) L’amministratore e la chiave':
    'B) L’administrateur et la clé',
  'Device → Administrators → Add: un amministratore **locale** (RADIUS/TACACS+ non generano la chiave) con il profilo del passo A.':
    'Device → Administrators → Add : un administrateur **local** (RADIUS/TACACS+ ne génèrent pas la clé) avec le profil de l’étape A.',
  'Ottieni la chiave API una volta e incollala qui (consigliato), oppure lascia che la sonda la generi a ogni interrogazione con utente e password.':
    'Obtenez la clé API une fois et collez-la ici (recommandé), ou laissez la sonde la générer à chaque interrogation avec utilisateur et mot de passe.',
  'C) La sonda':
    'C) La sonde',
  'Abilita la capability «Firewall» sulla sonda che raggiunge la gestione (HTTPS 443) e sceglila qui sotto.':
    'Activez la capability «Firewall» sur la sonde qui atteint l’interface de gestion (HTTPS 443) et choisissez-la ci-dessous.',
  'Come preparo il WatchGuard Firebox per CENSO (Fireware CLI)?':
    'Comment préparer le WatchGuard Firebox pour CENSO (Fireware CLI) ?',
  'CENSO legge il Firebox dalla Fireware CLI in SSH sulla porta 4118, attraverso una sonda.':
    'CENSO lit le Firebox depuis la Fireware CLI en SSH sur le port 4118, via une sonde.',
  'A) L’account':
    'A) Le compte',
  'Per interrogare basta l’account «status» (Device Monitor, sola lettura): cambiane la password di serie.':
    'Pour interroger, le compte «status» suffit (Device Monitor, lecture seule) : changez son mot de passe par défaut.',
  'Solo se vuoi anche il backup della configurazione serve «admin» o un Device Administrator: l’export non è concesso in sola lettura.':
    'Seulement si vous voulez aussi la sauvegarde de la configuration, il faut «admin» ou un Device Administrator : l’export n’est pas permis en lecture seule.',
  'B) La policy di gestione':
    'B) La politique de gestion',
  'La policy «WatchGuard» del Firebox deve ammettere l’indirizzo della sonda sulla 4118.':
    'La politique «WatchGuard» du Firebox doit autoriser l’adresse de la sonde sur le 4118.',
  'Abilita la capability «Firewall» sulla sonda e sceglila qui sotto.':
    'Activez la capability «Firewall» sur la sonde et choisissez-la ci-dessous.',
  'Come preparo PowerDNS per CENSO (REST API)?':
    'Comment préparer PowerDNS pour CENSO (API REST) ?',
  'CENSO legge zone e record di PowerDNS Authoritative Server dalla REST API, in sola lettura finché non accendi «Consenti la scrittura».':
    'CENSO lit les zones et enregistrements de PowerDNS Authoritative Server depuis l’API REST, en lecture seule tant que vous n’activez pas «Autoriser l’écriture».',
  'A) La REST API':
    'A) L’API REST',
  'Nel file di configurazione abilita API e web server, con una chiave lunga e casuale e il solo indirizzo della sonda fra quelli ammessi; poi riavvia PowerDNS.':
    'Dans le fichier de configuration, activez l’API et le serveur web, avec une clé longue et aléatoire et seulement l’adresse de la sonde parmi celles autorisées ; puis redémarrez PowerDNS.',
  'La sonda deve raggiungere la porta 8081. Copia qui la stessa «api-key».':
    'La sonde doit atteindre le port 8081. Copiez ici la même «api-key».',
  'Come preparo Veeam Backup & Replication per CENSO (utente Backup Viewer)?':
    'Comment préparer Veeam Backup & Replication pour CENSO (utilisateur Backup Viewer) ?',
  'CENSO legge job, sessioni, repository e macchine protette dalla REST API di VBR (porta 9419), in sola lettura.':
    'CENSO lit jobs, sessions, référentiels et machines protégées depuis l’API REST de VBR (port 9419), en lecture seule.',
  'Crea un’utenza dedicata, di dominio («DOMINIO\\utente») o locale del server VBR («SERVER\\utente»).':
    'Créez un compte dédié, de domaine («DOMINIO\\utente») ou local au serveur VBR («SERVER\\utente»).',
  'Console Veeam → Users and Roles → Add: assegnale il ruolo «Veeam Backup Viewer».':
    'Console Veeam → Users and Roles → Add : attribuez-lui le rôle «Veeam Backup Viewer».',
  'B) La sonda e la versione':
    'B) La sonde et la version',
  'La sonda deve raggiungere la 9419 del server VBR.':
    'La sonde doit atteindre le port 9419 du serveur VBR.',
  'Lascia «Automatica» nella versione API: CENSO la sceglie dalla build del server (12.x e 13). Scegline una solo per forzarla.':
    'Laissez la version d’API sur «Automatique» : CENSO la choisit d’après le build du serveur (12.x et 13). N’en choisissez une que pour la forcer.',
  'Come preparo Vinchin Backup & Recovery per CENSO?':
    'Comment préparer Vinchin Backup & Recovery pour CENSO ?',
  'CENSO legge job, risorse protette e storage dalla console Vinchin (API sotto /api/ sulla 443).':
    'CENSO lit jobs, ressources protégées et stockage depuis la console Vinchin (API sous /api/ sur le 443).',
  'Crea un’utenza dedicata che **veda tutte le risorse**: Vinchin mostra a ogni utente solo ciò che gli è assegnato, e un’utenza senza risorse legge zero job senza errori.':
    'Créez un compte dédié qui **voit toutes les ressources** : Vinchin ne montre à chaque utilisateur que ce qui lui est attribué, et un compte sans ressources lit zéro job sans erreur.',
  'Meglio se in sola lettura. La chiave API (Sistema → Impostazioni di sistema → API Key Management) è un’alternativa: se la pagina Backup dà errore, torna a utente e password.':
    'De préférence en lecture seule. La clé API (Système → Paramètres système → API Key Management) est une alternative : si la page Sauvegarde échoue, revenez à utilisateur et mot de passe.',
  'La sonda deve raggiungere la console sulla 443.':
    'La sonde doit atteindre la console sur le 443.',
  'Come preparo Commvault per CENSO (utente con ruolo View)?':
    'Comment préparer Commvault pour CENSO (utilisateur avec le rôle View) ?',
  'CENSO legge client, job e storage dall’API del Command Center o del Web Server, in sola lettura.':
    'CENSO lit clients, jobs et stockage depuis l’API du Command Center ou du Web Server, en lecture seule.',
  'Command Center → Manage → Security → Users → Add: un’utenza dedicata (di dominio nella forma «DOMINIO\\utente»).':
    'Command Center → Manage → Security → Users → Add : un compte dédié (de domaine, sous la forme «DOMINIO\\utente»).',
  'Associazioni: il ruolo «View» sulla CommCell (o sulle entità da vedere).':
    'Associations : le rôle «View» sur la CommCell (ou sur les entités à voir).',
  'La sonda deve raggiungere l’API («https://<server>/commandcenter/api», oppure «…/webconsole/api»).':
    'La sonde doit atteindre l’API («https://<server>/commandcenter/api», ou «…/webconsole/api»).',
  'Come preparo Rubrik per CENSO (service account in sola lettura)?':
    'Comment préparer Rubrik pour CENSO (compte de service en lecture seule) ?',
  'CENSO legge da Rubrik Security Cloud (dal Control Plane) o da un cluster CDM (da una sonda) oggetti protetti, SLA e job, in sola lettura.':
    'CENSO lit objets protégés, SLA et jobs depuis Rubrik Security Cloud (depuis le Control Plane) ou depuis un cluster CDM (depuis une sonde), en lecture seule.',
  'A) Rubrik Security Cloud':
    'A) Rubrik Security Cloud',
  'Impostazioni → Utenti e accessi → Service account → Aggiungi: un ruolo in sola lettura.':
    'Paramètres → Utilisateurs et accès → Comptes de service → Ajouter : un rôle en lecture seule.',
  'Scarica il file JSON: qui servono client ID e secret. L’endpoint è «https://<account>.my.rubrik.com».':
    'Téléchargez le fichier JSON : ici il faut le client ID et le secret. Le point d’accès est «https://<account>.my.rubrik.com».',
  'B) Cluster CDM':
    'B) Cluster CDM',
  'Impostazioni → Utenti → Service account sul cluster, con un ruolo in sola lettura; in alternativa un’utenza locale o di dominio in sola lettura.':
    'Paramètres → Utilisateurs → Comptes de service sur le cluster, avec un rôle en lecture seule ; sinon un compte local ou de domaine en lecture seule.',
  'La sonda deve raggiungere l’indirizzo del cluster sulla 443.':
    'La sonde doit atteindre l’adresse du cluster sur le 443.',
  'Come preparo phpIPAM per CENSO (API app)?':
    'Comment préparer phpIPAM pour CENSO (application API) ?',
  'CENSO legge sezioni, subnet e indirizzi di phpIPAM dalla sua API, in sola lettura finché non accendi «Consenti la scrittura».':
    'CENSO lit sections, sous-réseaux et adresses de phpIPAM depuis son API, en lecture seule tant que vous n’activez pas «Autoriser l’écriture».',
  'A) L’API app':
    'A) L’application API',
  'Administration → phpIPAM settings: attiva «API».':
    'Administration → phpIPAM settings : activez «API».',
  'Administration → API → Create API key: un App ID (per esempio «censo»), permessi «Read» («Read / Write» solo se userai la scrittura) e sicurezza «SSL with App code token» (consigliata) oppure «SSL with User token».':
    'Administration → API → Create API key : un App ID (par exemple «censo»), les permissions «Read» («Read / Write» seulement si vous utiliserez l’écriture) et la sécurité «SSL with App code token» (recommandée) ou «SSL with User token».',
  'Serve HTTPS: con il token in chiaro phpIPAM rifiuta l’accesso. La sonda deve raggiungere il sito.':
    'HTTPS est requis : avec le jeton en clair, phpIPAM refuse l’accès. La sonde doit atteindre le site.',
  'Come preparo il DNS Microsoft per CENSO (WinRM)?':
    'Comment préparer le DNS Microsoft pour CENSO (WinRM) ?',
  'CENSO legge zone e record del DNS di Windows con PowerShell via WinRM sul server DNS (di norma un domain controller).':
    'CENSO lit les zones et enregistrements du DNS Windows avec PowerShell via WinRM sur le serveur DNS (en général un contrôleur de domaine).',
  'A) WinRM sul server DNS':
    'A) WinRM sur le serveur DNS',
  'Attiva WinRM con il listener HTTPS (5986) e una regola firewall che ammetta la sonda; la guida «WinRM HTTPS» nella documentazione ha i comandi.':
    'Activez WinRM avec l’écouteur HTTPS (5986) et une règle de pare-feu qui autorise la sonde ; le guide «WinRM HTTPS» de la documentation contient les commandes.',
  'B) L’account':
    'B) Le compte',
  'Un account di dominio dedicato, membro di «Remote Management Users» sul server e con la lettura delle zone DNS (in molte installazioni significa «DnsAdmins»).':
    'Un compte de domaine dédié, membre de «Remote Management Users» sur le serveur et avec la lecture des zones DNS (dans beaucoup d’installations, cela signifie «DnsAdmins»).',
  'Per la scrittura (solo se accendi «Consenti la scrittura») serve la scrittura sulle zone.':
    'Pour l’écriture (seulement si vous activez «Autoriser l’écriture»), il faut l’écriture sur les zones.',
  'Come preparo la CA Microsoft (AD CS) per CENSO?':
    'Comment préparer l’AC Microsoft (AD CS) pour CENSO ?',
  'CENSO legge le CA aziendali e i modelli da Active Directory e, via WinRM, il database dei certificati emessi; può anche richiedere certificati se lo consenti.':
    'CENSO lit les AC d’entreprise et les modèles depuis Active Directory et, via WinRM, la base des certificats émis ; il peut aussi demander des certificats si vous l’autorisez.',
  'Un account di dominio dedicato, membro di «Remote Management Users» sulla CA.':
    'Un compte de domaine dédié, membre de «Remote Management Users» sur l’AC.',
  'Per elencare i certificati emessi: sulla CA (certsrv.msc → Proprietà → Sicurezza) il permesso di lettura e, dove richiesto, «Rilascio e gestione certificati»; per richiederne, «Registrazione» sui modelli da usare.':
    'Pour lister les certificats émis : sur l’AC (certsrv.msc → Propriétés → Sécurité) l’autorisation de lecture et, si nécessaire, «Délivrer et gérer des certificats» ; pour en demander, «Inscrire» sur les modèles à utiliser.',
  'B) Il collegamento':
    'B) La connexion',
  'WinRM (consigliato): HTTPS 5986 dalla sonda alla CA.':
    'WinRM (recommandé) : HTTPS 5986 de la sonde vers l’AC.',
  'Web Enrollment: il sito /certsrv della CA; con questa modalità non si legge il database della CA.':
    'Web Enrollment : le site /certsrv de l’AC ; dans ce mode, la base de l’AC n’est pas lue.',
  'Come preparo vCenter per CENSO (utente in sola lettura)?':
    'Comment préparer vCenter pour CENSO (utilisateur en lecture seule) ?',
  'CENSO legge cluster, host, VM, datastore e reti dal vCenter con un’utenza dedicata in sola lettura, sulla porta 443.':
    'CENSO lit clusters, hôtes, VM, datastores et réseaux depuis vCenter avec un compte dédié en lecture seule, sur le port 443.',
  'vSphere Client → Amministrazione → Single Sign-On → Utenti e gruppi: crea l’utente (per esempio «censo@vsphere.local») oppure usa un account di dominio dedicato.':
    'vSphere Client → Administration → Single Sign-On → Utilisateurs et groupes : créez l’utilisateur (par exemple «censo@vsphere.local») ou utilisez un compte de domaine dédié.',
  'B) Il ruolo':
    'B) Le rôle',
  'Amministrazione → Autorizzazioni globali (o la radice del vCenter) → Aggiungi: l’utente con il ruolo predefinito «Sola lettura» e «Propaga agli oggetti figli» spuntato.':
    'Administration → Autorisations globales (ou la racine du vCenter) → Ajouter : l’utilisateur avec le rôle prédéfini «Lecture seule» et «Propager aux objets enfants» coché.',
  'La sonda deve raggiungere il vCenter in HTTPS 443.':
    'La sonde doit atteindre vCenter en HTTPS 443.',
  'Come preparo Nutanix per CENSO (utente Viewer)?':
    'Comment préparer Nutanix pour CENSO (utilisateur Viewer) ?',
  'CENSO legge cluster, host e VM da Prism Central (porta 9440) in sola lettura.':
    'CENSO lit clusters, hôtes et VM depuis Prism Central (port 9440), en lecture seule.',
  'Prism Central → Admin Center → IAM (o Gestione utenti locali): crea un’utenza dedicata, locale o da directory.':
    'Prism Central → Admin Center → IAM (ou Gestion des utilisateurs locaux) : créez un compte dédié, local ou de l’annuaire.',
  'Assegnale il ruolo «Prism Viewer» (o «Viewer»), non uno di amministrazione.':
    'Attribuez-lui le rôle «Prism Viewer» (ou «Viewer»), pas un rôle d’administration.',
  'La sonda deve raggiungere Prism Central sulla 9440.':
    'La sonde doit atteindre Prism Central sur le 9440.',
  'Come preparo Sangfor aCloud per CENSO?':
    'Comment préparer Sangfor aCloud pour CENSO ?',
  'CENSO legge host e macchine virtuali dalla console aCloud, in sola lettura.':
    'CENSO lit hôtes et machines virtuelles depuis la console aCloud, en lecture seule.',
  'Nella console aCloud, fra gli amministratori, crea un’utenza dedicata con permessi di sola visualizzazione su tutte le risorse da inventariare.':
    'Dans la console aCloud, parmi les administrateurs, créez un compte dédié avec des permissions en consultation seule sur toutes les ressources à inventorier.',
  'Se la versione lo consente, usa un token API invece della password.':
    'Si la version le permet, utilisez un jeton API au lieu du mot de passe.',
  'La sonda deve raggiungere la console aCloud in HTTPS.':
    'La sonde doit atteindre la console aCloud en HTTPS.',
  'Come preparo OLVM per CENSO (utente ReadOnlyAdmin)?':
    'Comment préparer OLVM pour CENSO (utilisateur ReadOnlyAdmin) ?',
  'CENSO legge data center, cluster, host, VM, domini di storage e reti dall’API REST dell’engine OLVM (vale anche per oVirt e Red Hat Virtualization), in sola lettura sulla 443.':
    'CENSO lit data centers, clusters, hôtes, VM, domaines de stockage et réseaux depuis l’API REST du moteur OLVM (valable aussi pour oVirt et Red Hat Virtualization), en lecture seule sur le 443.',
  'Sull’engine crea un utente del profilo interno (oppure usa un utente di dominio già collegato all’engine).':
    'Sur le moteur, créez un utilisateur du profil interne (ou utilisez un utilisateur de domaine déjà relié au moteur).',
  'Nella credenziale l’utente va scritto con il profilo: «censo@internal» o «utente@dominio».':
    'Dans l’identifiant, écrivez l’utilisateur avec son profil : «censo@internal» ou «utente@dominio».',
  'Amministrazione → Configura → Permessi di sistema → Aggiungi: l’utente con il ruolo «ReadOnlyAdmin».':
    'Administration → Configurer → Autorisations système → Ajouter : l’utilisateur avec le rôle «ReadOnlyAdmin».',
  'La sonda deve raggiungere l’engine in HTTPS 443.':
    'La sonde doit atteindre le moteur en HTTPS 443.',
  'Gli indirizzi IP delle VM arrivano solo se sugli ospiti gira il guest agent (qemu-guest-agent).':
    'Les adresses IP des VM n’arrivent que si l’agent invité tourne sur les invités (qemu-guest-agent).',
  'Come preparo Proxmox VE per CENSO (token PVEAuditor)?':
    'Comment préparer Proxmox VE pour CENSO (jeton PVEAuditor) ?',
  'CENSO legge nodi, VM, container, storage e reti di un nodo o del cluster (porta 8006) in sola lettura.':
    'CENSO lit nœuds, VM, conteneurs, stockage et réseaux d’un nœud ou du cluster (port 8006), en lecture seule.',
  'A) Utente e token':
    'A) Utilisateur et jeton',
  'Crea un utente dedicato e un token API; assegna il ruolo «PVEAuditor» su «/» con propagazione **al token**: con la separazione dei privilegi il token non eredita i diritti dell’utente, e senza il ruolo Proxmox risponde con meno dati invece di dare errore.':
    'Créez un utilisateur dédié et un jeton API ; attribuez le rôle «PVEAuditor» sur «/» avec propagation **au jeton** : avec la séparation des privilèges, le jeton n’hérite pas des droits de l’utilisateur, et sans le rôle Proxmox répond avec moins de données au lieu d’une erreur.',
  'Nel campo token serve la forma completa «utente@realm!nome=segreto».':
    'Le champ jeton demande la forme complète «utilisateur@realm!nom=secret».',
  'La sonda deve raggiungere la 8006 di un nodo.':
    'La sonde doit atteindre le port 8006 d’un nœud.',
  'Come preparo ZStack per CENSO (AccessKey in sola lettura)?':
    'Comment préparer ZStack pour CENSO (AccessKey en lecture seule) ?',
  'CENSO legge host, macchine virtuali, storage e reti di ZStack dalle API del management node, in sola lettura.':
    'CENSO lit hôtes, machines virtuelles, stockage et réseaux de ZStack depuis les API du management node, en lecture seule.',
  'A) L’account e la chiave':
    'A) Le compte et la clé',
  'Crea (o scegli) un account o sub-account dedicato con i soli permessi di lettura sulle risorse da inventariare.':
    'Créez (ou choisissez) un compte ou sous-compte dédié avec des permissions de lecture seule sur les ressources à inventorier.',
  'Per quell’account genera un’AccessKey (consigliata): il segreto firma le richieste e non viaggia mai. Copia AccessKey ID e segreto nei campi qui sotto.':
    'Pour ce compte, générez une AccessKey (recommandée) : le secret signe les requêtes et ne circule jamais. Copiez l’AccessKey ID et le secret dans les champs ci-dessous.',
  'B) L’indirizzo giusto':
    'B) La bonne adresse',
  'L’endpoint è quello delle API del management node, di norma «http://indirizzo:8080», non quello della console web (che risponde in HTTPS su un’altra porta).':
    'Le point d’accès est celui des API du management node, en général «http://adresse:8080», pas celui de la console web (qui répond en HTTPS sur un autre port).',
  'La sonda deve raggiungere quella porta.':
    'La sonde doit atteindre ce port.',
  'Come preparo NexaVM Cloud per CENSO (AccessKey in sola lettura)?':
    'Comment préparer NexaVM Cloud pour CENSO (AccessKey en lecture seule) ?',
  'CENSO legge host, macchine virtuali, storage e reti di NexaVM Cloud dalle API del management node, in sola lettura.':
    'CENSO lit hôtes, machines virtuelles, stockage et réseaux de NexaVM Cloud depuis les API du management node, en lecture seule.',
  'Come preparo NexaSphere per CENSO (AccessKey in sola lettura)?':
    'Comment préparer NexaSphere pour CENSO (AccessKey en lecture seule) ?',
  'CENSO legge host, macchine virtuali, storage e reti di NexaSphere dalle API del management node, in sola lettura.':
    'CENSO lit hôtes, machines virtuelles, stockage et réseaux de NexaSphere depuis les API du management node, en lecture seule.',
  'Come preparo OpenStack per CENSO (application credential reader)?':
    'Comment préparer OpenStack pour CENSO (application credential reader) ?',
  'CENSO legge istanze, volumi, reti, IP e bilanciatori via Keystone v3 e il catalogo dei servizi, in sola lettura.':
    'CENSO lit instances, volumes, réseaux, IP et répartiteurs via Keystone v3 et le catalogue de services, en lecture seule.',
  'A) L’application credential':
    'A) L’application credential',
  'Con un utente che ha il ruolo «reader» sul progetto crea un’application credential con il solo ruolo reader: è revocabile da sola e non porta la password dell’utente.':
    'Avec un utilisateur qui a le rôle «reader» sur le projet, créez une application credential avec le seul rôle reader : elle se révoque seule et ne porte pas le mot de passe de l’utilisateur.',
  'Per tutti i progetti e per gli hypervisor serve un ruolo di amministratore (o «reader» di sistema): accendi allora «Tutti i progetti».':
    'Pour tous les projets et pour les hyperviseurs, il faut un rôle d’administrateur (ou «reader» système) : activez alors «Tous les projets».',
  'La sonda deve raggiungere Keystone e gli endpoint del catalogo (Nova, Neutron, Cinder, Octavia) dell’interfaccia scelta (public, internal o admin).':
    'La sonde doit atteindre Keystone et les points d’accès du catalogue (Nova, Neutron, Cinder, Octavia) de l’interface choisie (public, internal ou admin).',
  'Come preparo Apache CloudStack per CENSO (chiavi API)?':
    'Comment préparer Apache CloudStack pour CENSO (clés API) ?',
  'CENSO legge zone, cluster, host, VM, volumi e reti con richieste firmate, in sola lettura.':
    'CENSO lit zones, clusters, hôtes, VM, volumes et réseaux avec des requêtes signées, en lecture seule.',
  'A) L’utente e le chiavi':
    'A) L’utilisateur et les clés',
  'Crea un utente dedicato con il ruolo «Read-Only Admin» (CloudStack 4.15+) per leggere tutta l’installazione, o un ruolo utente per il solo account.':
    'Créez un utilisateur dédié avec le rôle «Read-Only Admin» (CloudStack 4.15+) pour lire toute l’installation, ou un rôle utilisateur pour son seul compte.',
  'Accounts → utente → Generate keys: copia chiave API e chiave segreta (la segreta firma le richieste e non viaggia).':
    'Accounts → utilisateur → Generate keys : copiez la clé API et la clé secrète (la secrète signe les requêtes et ne circule pas).',
  'La sonda deve raggiungere il management server («…/client/api»).':
    'La sonde doit atteindre le management server («…/client/api»).',
  'Come preparo Kubernetes per CENSO (service account in sola lettura)?':
    'Comment préparer Kubernetes pour CENSO (compte de service en lecture seule) ?',
  'CENSO legge nodi, workload, servizi e ingress dall’API server (di norma 6443) con un service account e un ClusterRole in sola lettura.':
    'CENSO lit nœuds, workloads, services et ingress depuis l’API server (en général 6443) avec un compte de service et un ClusterRole en lecture seule.',
  'A) Service account e permessi':
    'A) Compte de service et permissions',
  'Crea il service account, un ClusterRole con «get» e «list» sulle risorse lette e il ClusterRoleBinding.':
    'Créez le compte de service, un ClusterRole avec «get» et «list» sur les ressources lues, et le ClusterRoleBinding.',
  'Copia qui il token e il certificato della CA del cluster (dal kubeconfig, «certificate-authority-data» decodificato).':
    'Copiez ici le jeton et le certificat de l’AC du cluster (depuis le kubeconfig, «certificate-authority-data» décodé).',
  'La sonda deve raggiungere l’API server (l’indirizzo «server:» del kubeconfig).':
    'La sonde doit atteindre l’API server (l’adresse «server:» du kubeconfig).',
  'Come preparo Huawei OceanStor per CENSO (utente in sola lettura)?':
    'Comment préparer Huawei OceanStor pour CENSO (utilisateur en lecture seule) ?',
  'CENSO legge array, pool, LUN, host e porte dalla REST del DeviceManager (porta 8088), in sola lettura.':
    'CENSO lit baies, pools, LUN, hôtes et ports depuis le REST du DeviceManager (port 8088), en lecture seule.',
  'DeviceManager → Impostazioni → Utenti e sicurezza → Crea: un’utenza locale dedicata con ruolo di sola lettura (monitor), mai quella di amministrazione.':
    'DeviceManager → Paramètres → Utilisateurs et sécurité → Créer : un compte local dédié avec un rôle en lecture seule (monitor), jamais celui d’administration.',
  'La sonda deve raggiungere l’indirizzo di gestione dell’array sulla 8088.':
    'La sonde doit atteindre l’adresse de gestion de la baie sur le 8088.',
  'Come preparo i sistemi per CENSO con SSH (utente dedicato)?':
    'Comment préparer les systèmes pour CENSO avec SSH (utilisateur dédié) ?',
  'Con SSH CENSO legge server Linux/Unix, apparati di rete (backup della configurazione, moduli, SFP), host KVM e Oracle Database Appliance. Usa un utente dedicato alla discovery, mai quello con cui gli amministratori entrano a mano.':
    'Avec SSH, CENSO lit les serveurs Linux/Unix, les équipements réseau (sauvegarde de la configuration, modules, SFP), les hôtes KVM et Oracle Database Appliance. Utilisez un utilisateur dédié à la découverte, jamais celui avec lequel les administrateurs se connectent à la main.',
  'A) Server Linux e Unix':
    'A) Serveurs Linux et Unix',
  'Crea l’utente «censo» e mettigli la chiave pubblica generata per CENSO (la guida «Come creo una chiave SSH?» qui accanto spiega come).':
    'Créez l’utilisateur «censo» et donnez-lui la clé publique générée pour CENSO (le guide «Comment créer une clé SSH ?» à côté explique comment).',
  'Senza root l’inventario funziona: ciò che richiede root (seriali, moduli di memoria) compare nel rapporto come lacuna dichiarata. Per averlo basta sudo per il solo dmidecode.':
    'Sans root, l’inventaire fonctionne : ce qui demande root (numéros de série, modules mémoire) apparaît dans le rapport comme lacune déclarée. Pour l’obtenir, sudo pour le seul dmidecode suffit.',
  'B) Apparati di rete':
    'B) Équipements réseau',
  'Un account locale o AAA che arrivi direttamente al livello che esegue i comandi di lettura («show running-config», «show inventory», «display current-configuration»): CENSO non manda mai «enable». Su Cisco: privilege level 15 o un livello personalizzato con quei comandi.':
    'Un compte local ou AAA qui arrive directement au niveau qui exécute les commandes de lecture («show running-config», «show inventory», «display current-configuration») : CENSO n’envoie jamais «enable». Sur Cisco : privilege level 15 ou un niveau personnalisé avec ces commandes.',
  'Dove la piattaforma lo consente, limita l’account all’indirizzo della sonda.':
    'Quand la plateforme le permet, limitez le compte à l’adresse de la sonde.',
  'C) Host KVM e Oracle Database Appliance':
    'C) Hôtes KVM et Oracle Database Appliance',
  'KVM senza piattaforma: l’utente nel gruppo «libvirt» basta; in alternativa root o sudo senza password per «virsh». La sonda esegue solo comandi di lettura.':
    'KVM sans plateforme : l’utilisateur dans le groupe «libvirt» suffit ; sinon root ou sudo sans mot de passe pour «virsh». La sonde n’exécute que des commandes de lecture.',
  'Oracle Database Appliance: «odacli» vuole root. Usa root o un utente con sudo senza password per odacli; la sonda esegue solo «describe-…» e «list-…», mai comandi che cambiano qualcosa.':
    'Oracle Database Appliance : «odacli» veut root. Utilisez root ou un utilisateur avec sudo sans mot de passe pour odacli ; la sonde n’exécute que «describe-…» et «list-…», jamais de commandes qui modifient quoi que ce soit.',
  'D) La rete':
    'D) Le réseau',
  'Dalla sonda ai sistemi deve passare TCP 22 (o la porta SSH indicata nel job).':
    'Le TCP 22 (ou le port SSH indiqué dans le job) doit passer de la sonde vers les systèmes.',
  'Come preparo Windows per CENSO (WinRM)?':
    'Comment préparer Windows pour CENSO (WinRM) ?',
  'CENSO inventaria server e postazioni Windows con PowerShell via WinRM, di norma in HTTPS sulla 5986 e NTLM. Le macchine senza WinRM possono usare l’agente d’inventario.':
    'CENSO inventorie serveurs et postes Windows avec PowerShell via WinRM, en général en HTTPS sur le 5986 avec NTLM. Les machines sans WinRM peuvent utiliser l’agent d’inventaire.',
  'A) WinRM sugli host (o da GPO)':
    'A) WinRM sur les hôtes (ou par GPO)',
  'Attiva WinRM con il listener HTTPS (serve un certificato di autenticazione server) e una regola firewall che ammetta solo la sonda.':
    'Activez WinRM avec l’écouteur HTTPS (il faut un certificat d’authentification serveur) et une règle de pare-feu qui n’autorise que la sonde.',
  'Il minimo: un account di dominio dedicato, membro di «Remote Management Users» e con «Abilita account» e «Abilitazione remota» sullo spazio WMI root\\cimv2 (wmimgmt.msc → Controllo WMI → Sicurezza). Ciò che non si legge compare nel rapporto.':
    'Le minimum : un compte de domaine dédié, membre de «Remote Management Users» et avec «Activer le compte» et «Appel à distance autorisé» sur l’espace de noms WMI root\\cimv2 (wmimgmt.msc → Contrôle WMI → Sécurité). Ce qui ne se lit pas apparaît dans le rapport.',
  'L’inventario più completo: amministratore locale sugli host.':
    'L’inventaire le plus complet : administrateur local sur les hôtes.',
  'Come preparo Active Directory per CENSO (LDAP)?':
    'Comment préparer Active Directory pour CENSO (LDAP) ?',
  'CENSO legge da un domain controller computer, sistemi operativi e struttura del dominio: basta un utente normale, mai un account amministrativo.':
    'CENSO lit ordinateurs, systèmes d’exploitation et structure du domaine depuis un contrôleur de domaine : un utilisateur normal suffit, jamais un compte d’administration.',
  'Un utente di dominio dedicato: l’appartenenza a «Domain Users» basta per leggere gli oggetti computer.':
    'Un utilisateur de domaine dédié : l’appartenance à «Domain Users» suffit pour lire les objets ordinateur.',
  'Nella credenziale «DOMINIO\\utente» o «utente@dominio».':
    'Dans l’identifiant, «DOMINIO\\utente» ou «utente@dominio».',
  'LDAPS (636) consigliato: il domain controller deve avere un certificato. In alternativa LDAP 389 con StartTLS; il bind semplice solo su TLS.':
    'LDAPS (636) recommandé : le contrôleur de domaine doit avoir un certificat. Sinon LDAP 389 avec StartTLS ; le bind simple seulement sur TLS.',
  'Come preparo PostgreSQL per CENSO (ruolo di sola lettura)?':
    'Comment préparer PostgreSQL pour CENSO (rôle en lecture seule) ?',
  'CENSO legge solo versione, elenco e dimensione dei database dai cataloghi di sistema: mai i dati nelle tabelle.':
    'CENSO ne lit que la version, la liste et la taille des bases depuis les catalogues système : jamais les données des tables.',
  'A) Il ruolo':
    'A) Le rôle',
  'Crea un ruolo dedicato; «pg_read_all_stats» dà le dimensioni anche dei database a cui non si connette.':
    'Créez un rôle dédié ; «pg_read_all_stats» donne aussi la taille des bases auxquelles il ne se connecte pas.',
  'In pg_hba.conf ammetti la sonda; la porta di default è 5432 (indicala nel bersaglio se è un’altra).':
    'Dans pg_hba.conf, autorisez la sonde ; le port par défaut est 5432 (indiquez-le dans la cible s’il est différent).',
  'Come preparo Oracle Database per CENSO (utente di sola lettura)?':
    'Comment préparer Oracle Database pour CENSO (utilisateur en lecture seule) ?',
  'CENSO legge solo versione, PDB e loro dimensione dalle viste di sistema: mai i dati.':
    'CENSO ne lit que la version, les PDB et leur taille depuis les vues système : jamais les données.',
  'A) L’utente comune (multitenant)':
    'A) L’utilisateur commun (multitenant)',
  'Crea un utente comune con sessione e catalogo di sistema; CONTAINER_DATA serve a vedere le dimensioni dei PDB.':
    'Créez un utilisateur commun avec session et catalogue système ; CONTAINER_DATA sert à voir la taille des PDB.',
  'La sonda deve raggiungere il listener (di norma 1521); il «service name» è quello del CDB.':
    'La sonde doit atteindre le listener (en général 1521) ; le «service name» est celui du CDB.',
  'Come preparo SQL Server per CENSO (login di sola lettura)?':
    'Comment préparer SQL Server pour CENSO (login en lecture seule) ?',
  'CENSO legge solo versione, elenco e dimensione dei database dalle viste di sistema: mai i dati.':
    'CENSO ne lit que la version, la liste et la taille des bases depuis les vues système : jamais les données.',
  'A) Il login':
    'A) Le login',
  'Un login SQL dedicato; VIEW ANY DEFINITION serve alle dimensioni (sys.master_files).':
    'Un login SQL dédié ; VIEW ANY DEFINITION sert aux tailles (sys.master_files).',
  'L’autenticazione SQL deve essere attiva; la sonda deve raggiungere la 1433 (o la porta dell’istanza). Le istanze con nome si scrivono «SERVER\\ISTANZA».':
    'L’authentification SQL doit être active ; la sonde doit atteindre le 1433 (ou le port de l’instance). Les instances nommées s’écrivent «SERVER\\ISTANZA».',
  'Come preparo MySQL o MariaDB per CENSO (utente di sola lettura)?':
    'Comment préparer MySQL ou MariaDB pour CENSO (utilisateur en lecture seule) ?',
  'CENSO legge solo versione, schemi e loro dimensione da information_schema: mai i dati.':
    'CENSO ne lit que la version, les schémas et leur taille depuis information_schema : jamais les données.',
  'Un utente dedicato, legato all’indirizzo della sonda, che veda l’elenco dei database.':
    'Un utilisateur dédié, lié à l’adresse de la sonde, qui voit la liste des bases.',
  'Le dimensioni vengono da information_schema.tables, che mostra solo le tabelle su cui l’utente ha un privilegio: senza, le dimensioni restano a zero.':
    'Les tailles viennent de information_schema.tables, qui ne montre que les tables sur lesquelles l’utilisateur a un privilège : sans cela, les tailles restent à zéro.',
  'La sonda deve raggiungere la 3306 (o la porta indicata nel bersaglio).':
    'La sonde doit atteindre le 3306 (ou le port indiqué dans la cible).',
  'Come ottengo la chiave Fingerbank per CENSO?':
    'Comment obtenir la clé Fingerbank pour CENSO ?',
  'Fingerbank riconosce i dispositivi dall’impronta DHCP e dal nome: CENSO gli manda solo impronte, mai dati dei clienti.':
    'Fingerbank reconnaît les appareils à partir de l’empreinte DHCP et du nom : CENSO ne lui envoie que des empreintes, jamais des données des clients.',
  'A) La chiave':
    'A) La clé',
  'Crea un account su fingerbank.org e copia la chiave dal profilo (API key).':
    'Créez un compte sur fingerbank.org et copiez la clé depuis le profil (API key).',
  'Il piano gratuito ha un limite di richieste: CENSO memorizza le risposte e non richiede due volte la stessa impronta.':
    'L’offre gratuite a une limite de requêtes : CENSO mémorise les réponses et ne demande pas deux fois la même empreinte.',
  'Come ottengo la chiave Anthropic per l’assistente?':
    'Comment obtenir la clé Anthropic pour l’assistant ?',
  'L’assistente usa Claude con una chiave API del tuo account Anthropic; la chiave resta cifrata nel tenant.':
    'L’assistant utilise Claude avec une clé API de votre compte Anthropic ; la clé reste chiffrée dans le tenant.',
  'console.anthropic.com → API keys → Create key, in un workspace dedicato a CENSO.':
    'console.anthropic.com → API keys → Create key, dans un espace de travail dédié à CENSO.',
  'Nel workspace puoi fissare un limite di spesa mensile.':
    'Dans l’espace de travail, vous pouvez fixer une limite de dépense mensuelle.',
  'Come collego un modello interno per l’assistente?':
    'Comment relier un modèle interne pour l’assistant ?',
  'L’assistente può usare un modello ospitato in casa che parla l’API OpenAI (/v1/chat/completions): vLLM, Ollama, LM Studio, LocalAI.':
    'L’assistant peut utiliser un modèle hébergé en interne qui parle l’API OpenAI (/v1/chat/completions) : vLLM, Ollama, LM Studio, LocalAI.',
  'A) Il servizio':
    'A) Le service',
  'Esponi il servizio sulla rete (Ollama: variabile OLLAMA_HOST=0.0.0.0, porta 11434; vLLM: opzione --api-key per chiedere una chiave).':
    'Exposez le service sur le réseau (Ollama : variable OLLAMA_HOST=0.0.0.0, port 11434 ; vLLM : option --api-key pour exiger une clé).',
  'Il modello deve supportare le chiamate agli strumenti (tool calling).':
    'Le modèle doit prendre en charge les appels d’outils (tool calling).',
  'Se il servizio sta nella rete del cliente, scegli la sonda che lo raggiunge in «Da dove si parla».':
    'Si le service est dans le réseau du client, choisissez la sonde qui l’atteint dans «D\'où l\'on communique».',
  'Ogni tipo di credenziale ha accanto la sua guida «Come preparo … per CENSO?»: quale utente creare sul sistema, con quale ruolo in sola lettura, da quale porta deve passare la sonda, con i comandi pronti da copiare dove servono.':
    'Chaque type d’identifiant a son guide «Comment préparer … pour CENSO ?» à côté : quel utilisateur créer sur le système, avec quel rôle en lecture seule, par quel port doit passer la sonde, avec des commandes prêtes à copier quand il le faut.',
  'Al':
    'Au',
  'Il periodo può essere al massimo di 366 giorni.':
    'La période peut durer au plus 366 jours.',
  'Il periodo si sceglie fra 7, 30, 90 giorni e un anno, oppure dal… al…; il confronto è sempre con il periodo precedente della stessa durata. L’export PDF comincia con una pagina di grafici (gli stessi della pagina, con la mappa giorno × ora nel fuso di chi lo scarica) e prosegue con le tabelle; l’Excel ha le stesse tabelle, un foglio per ciascuna.':
    'La période se choisit parmi 7, 30, 90 jours et un an, ou du… au… ; la comparaison se fait toujours avec la période précédente de même durée. L’export PDF commence par une page de graphiques (les mêmes que la page, avec la carte jour × heure dans le fuseau de qui le télécharge) et continue avec les tableaux ; l’Excel a les mêmes tableaux, une feuille chacun.',
  'Indica la data d’inizio e quella di fine.':
    'Indiquez la date de début et celle de fin.',
  'L’inizio viene dopo la fine.':
    'Le début vient après la fin.',
  'Personalizzato…':
    'Personnalisé…',
  'Un anno':
    'Un an',
  'IP AI tenuti dal filtro flussi':
    'IP IA conservées par le filtre de flux',
  'Il filtro dei flussi tiene sempre il traffico verso questi {n} indirizzi di servizi AI, anche con il perimetro «entrambi interni»: le sonde li ricevono con la configurazione dei flussi, così il volume e il riconoscimento dai flussi non si perdono.':
    'Le filtre de flux conserve toujours le trafic vers ces {n} adresses de services IA, même avec le périmètre «les deux internes» : les sondes les reçoivent avec la configuration des flux, ainsi le volume et la reconnaissance par les flux ne sont pas perdus.',
  'La sonda legge il nome anche quando il ClientHello è spezzato su più segmenti, in HTTP/3 (QUIC) e in IPv6, e dalle domande DNS dei client: è l’unico modo quando il browser cifra il nome (Encrypted ClientHello, che Chrome e Firefox usano verso Cloudflare). Un uso si conta al più una volta al minuto per asset e servizio («minuti d’uso»), come per l’agente. Il filtro dei flussi tiene sempre il traffico verso gli indirizzi dei servizi AI, anche con il perimetro «entrambi interni».':
    'La sonde lit le nom même quand le ClientHello est coupé sur plusieurs segments, en HTTP/3 (QUIC) et en IPv6, et depuis les requêtes DNS des clients : c’est le seul moyen quand le navigateur chiffre le nom (Encrypted ClientHello, que Chrome et Firefox utilisent vers Cloudflare). Une utilisation est comptée au plus une fois par minute par asset et service («minutes d’utilisation»), comme pour l’agent. Le filtre de flux conserve toujours le trafic vers les adresses des services IA, même avec le périmètre «les deux internes».',
  'Automatica (consigliata)':
    'Automatique (recommandée)',
  '{v} (valore salvato)':
    '{v} (valeur enregistrée)',
  '1.3-rev1 · VBR 13':
    '1.3-rev1 · VBR 13',
  '1.3-rev0 · VBR 13':
    '1.3-rev0 · VBR 13',
  '1.2-rev1 · VBR 12.3':
    '1.2-rev1 · VBR 12.3',
  '1.2-rev0 · VBR 12.2':
    '1.2-rev0 · VBR 12.2',
  '1.1-rev2 · VBR 12.1':
    '1.1-rev2 · VBR 12.1',
  '1.1-rev1 · VBR 12.0':
    '1.1-rev1 · VBR 12.0',
  '1.1-rev0 · VBR 12.0':
    '1.1-rev0 · VBR 12.0',
  '{n} minuti d’uso riconosciuti':
    '{n} minutes d’utilisation reconnues',
  'Nomi letti dal filo':
    'Noms lus sur le fil',
  'TLS {a} · QUIC {b} · DNS {c}':
    'TLS {a} · QUIC {b} · DNS {c}',
  '{n} con il nome cifrato (ECH)':
    '{n} avec le nom chiffré (ECH)',
  'Il lettore AI non vede nessun nome sul filo: il mirror non porta il traffico dei client verso Internet né le loro domande DNS. Controlla che la porta mirror copi entrambe le direzioni del collegamento verso il firewall (o del core), non solo un segmento di server.':
    'Le lecteur IA ne voit aucun nom sur le fil : le miroir ne transporte ni le trafic des clients vers Internet ni leurs requêtes DNS. Vérifiez que le port miroir copie les deux sens du lien vers le pare-feu (ou du cœur), pas seulement un segment de serveurs.',
  '{n} nomi chiesti da indirizzi fuori dalle reti interne sono stati scartati. Se la rete usa indirizzi pubblici propri, o il mirror sta dopo il NAT, aggiungili alle reti interne in Impostazioni → Traffico da conservare.':
    '{n} noms demandés par des adresses hors des réseaux internes ont été écartés. Si le réseau utilise ses propres adresses publiques, ou si le miroir est après le NAT, ajoutez-les aux réseaux internes dans Paramètres → Trafic à conserver.',
  'Nella scheda della sonda, «Nomi letti dal filo» dice quanti nomi la sonda legge (TLS, QUIC, DNS) prima del confronto con il catalogo: a zero, il mirror non porta il traffico dei client verso Internet. I client sono gli indirizzi privati e quelli nelle reti interne di «Traffico da conservare»: chi ha indirizzi pubblici propri, o un mirror dopo il NAT, li aggiunge lì.':
    'Dans la fiche de la sonde, «Noms lus sur le fil» indique combien de noms la sonde lit (TLS, QUIC, DNS) avant de les comparer au catalogue : à zéro, le miroir ne transporte pas le trafic des clients vers Internet. Les clients sont les adresses privées et celles des réseaux internes de «Trafic à conserver» : un réseau avec ses propres adresses publiques, ou un miroir après le NAT, les y ajoute.',
  'Le zone e i record dei DNS del cliente (PowerDNS, Microsoft DNS), letti attraverso la sonda: la pagina si apre con l’ultima lettura e si aggiorna in sottofondo.':
    'Les zones et enregistrements DNS du client (PowerDNS, Microsoft DNS), lus via la sonde : la page s’ouvre avec la dernière lecture et se met à jour en arrière-plan.',
  'Scegli una zona':
    'Choisissez une zone',
  'A sinistra le zone del server: dirette in alto, inverse (i PTR) sotto. Oppure cerca un nome o un indirizzo in tutte le zone.':
    'À gauche, les zones du serveur : directes en haut, inverses (les PTR) en dessous. Ou cherchez un nom ou une adresse dans toutes les zones.',
  'Nuovo record':
    'Nouvel enregistrement',
  'Filtra le zone':
    'Filtrer les zones',
  'Dirette':
    'Directes',
  'Inverse':
    'Inverses',
  'in pausa':
    'en pause',
  'integrata in AD ({replica})':
    'intégrée à AD ({replica})',
  'aggiornamento dinamico: {modo}':
    'mise à jour dynamique : {modo}',
  'serial {n}':
    'serial {n}',
  'Il CI della CMDB con questo indirizzo':
    'Le CI de la CMDB avec cette adresse',
  'Mostra i record del nome a cui punta':
    'Afficher les enregistrements du nom ciblé',
  'vai':
    'aller',
  '{n} secondi':
    '{n} secondes',
  'Registrato':
    'Enregistré',
  'vecchio':
    'ancien',
  'Filtra per nome, valore o CI…':
    'Filtrer par nom, valeur ou CI…',
  'Filtra i record':
    'Filtrer les enregistrements',
  'Registrazione':
    'Enregistrement',
  'Statici e dinamici':
    'Statiques et dynamiques',
  'Solo dinamici (registrati dai client)':
    'Dynamiques seulement (enregistrés par les clients)',
  'Solo statici':
    'Statiques seulement',
  'Dinamici vecchi: oltre 30 giorni ({n})':
    'Dynamiques anciens : plus de 30 jours ({n})',
  'Mostra SOA e NS della zona':
    'Afficher SOA et NS de la zone',
  'record':
    'enregistrements',
  'Nessun record con questi filtri.':
    'Aucun enregistrement avec ces filtres.',
  'Cerca un nome o un indirizzo in tutte le zone…':
    'Chercher un nom ou une adresse dans toutes les zones…',
  'Cerca in tutte le zone':
    'Chercher dans toutes les zones',
  '{n} risultati in {cercate} zone su {totali}':
    '{n} résultats dans {cercate} zones sur {totali}',
  'le altre non sono ancora state lette: lo fa il giro in sottofondo':
    'les autres n’ont pas encore été lues : le passage en arrière-plan s’en charge',
  'mostrati i primi':
    'premiers affichés',
  'L’indirizzo non appartiene alla zona inversa {zona}.':
    'L’adresse n’appartient pas à la zone inverse {zona}.',
  'Scrivi il nome (o @ per la zona stessa).':
    'Saisissez le nom (ou @ pour la zone elle-même).',
  'Passo 1 di 2: il record. Prima di scrivere, CENSO controlla sul server che cosa c’è già.':
    'Étape 1 sur 2 : l’enregistrement. Avant d’écrire, CENSO vérifie sur le serveur ce qui existe déjà.',
  'Passo 2 di 2: che cosa succede sul server. Niente è ancora stato scritto.':
    'Étape 2 sur 2 : ce qui se passe sur le serveur. Rien n’a encore été écrit.',
  '{tipo}: {descrizione}':
    '{tipo} : {descrizione}',
  'per esempio 10.0.0.5':
    'par exemple 10.0.0.5',
  'Scrivi l’indirizzo: il nome del PTR nella zona si calcola da solo.':
    'Saisissez l’adresse : le nom du PTR dans la zone se calcule tout seul.',
  'Per un SRV il nome è servizio e protocollo, per esempio «_ldap._tcp» o «_sip._udp».':
    'Pour un SRV le nom est service et protocole, par exemple «_ldap._tcp» ou «_sip._udp».',
  'Indirizzo IPv4':
    'Adresse IPv4',
  'Indirizzo IPv6':
    'Adresse IPv6',
  'Peso':
    'Poids',
  'Alias di':
    'Alias de',
  'Server di posta':
    'Serveur de messagerie',
  'Server dei nomi':
    'Serveur de noms',
  'Senza virgolette: le mette il server se servono.':
    'Sans guillemets : le serveur les ajoute si besoin.',
  'Altro…':
    'Autre…',
  'Secondi':
    'Secondes',
  'Controllo sul server…':
    'Vérification sur le serveur…',
  'Continua':
    'Continuer',
  '{nome} ha già altri record ({tipi}): un CNAME deve essere l’unico record del suo nome. Togli prima gli altri, o scegli un altro nome.':
    '{nome} a déjà d’autres enregistrements ({tipi}) : un CNAME doit être le seul enregistrement de son nom. Retirez d’abord les autres, ou choisissez un autre nom.',
  '{nome} è un alias (CNAME): non può avere altri record. Scrivi il record sul nome a cui punta, o togli prima il CNAME.':
    '{nome} est un alias (CNAME) : il ne peut pas avoir d’autres enregistrements. Écrivez l’enregistrement sur le nom ciblé, ou retirez d’abord le CNAME.',
  '{nome} ha già un record {tipo} con questo valore.':
    '{nome} a déjà un enregistrement {tipo} avec cette valeur.',
  'Il record {nome} {tipo} {valore} esiste già: non c’è niente da aggiungere.':
    'L’enregistrement {nome} {tipo} {valore} existe déjà : rien à ajouter.',
  '{nome} ha già {n} record {tipo}':
    '{nome} a déjà {n} enregistrements {tipo}',
  'Aggiorna: sostituisci con {valore}':
    'Mettre à jour : remplacer par {valore}',
  'Aggiungi accanto (il nome avrà {n} valori)':
    'Ajouter à côté (le nom aura {n} valeurs)',
  'Il vecchio indirizzo':
    'L’ancienne adresse',
  'Togli il PTR di {ip} (punta a questo nome, nella zona {zona})':
    'Retirer le PTR de {ip} (il pointe vers ce nom, dans la zone {zona})',
  'Scrivi sul DNS':
    'Écrire sur le DNS',
  'Il PTR di {ip}':
    'Le PTR de {ip}',
  'Punta già a {nome}: niente da fare.':
    'Il pointe déjà vers {nome} : rien à faire.',
  'Il server non ha una zona inversa per {ip}: il PTR non si può creare qui.':
    'Le serveur n’a pas de zone inverse pour {ip} : le PTR ne peut pas être créé ici.',
  'Non riesco a leggere il PTR ({motivo}): lo lascio com’è.':
    'Impossible de lire le PTR ({motivo}) : je le laisse tel quel.',
  'Crea il PTR {ip} → {nome} nella zona {zona}':
    'Créer le PTR {ip} → {nome} dans la zone {zona}',
  'Oggi punta a: {valori}':
    'Aujourd’hui il pointe vers : {valori}',
  'Aggiorna il PTR: {ip} → {nome}':
    'Mettre à jour le PTR : {ip} → {nome}',
  'Aggiungi un secondo PTR, lasciando quello di oggi':
    'Ajouter un second PTR, en gardant celui d’aujourd’hui',
  'Lascia il PTR com’è':
    'Laisser le PTR tel quel',
  'PTR di {ip} non scritto: {motivo}':
    'PTR de {ip} non écrit : {motivo}',
  'tolto il PTR di {ip}':
    'PTR de {ip} retiré',
  'PTR {ip} scritto in {zona}':
    'PTR {ip} écrit dans {zona}',
  'Record modificato: {nome} {tipo} {valore}':
    'Enregistrement modifié : {nome} {tipo} {valore}',
  'Record aggiunto: {nome} {tipo} {valore}':
    'Enregistrement ajouté : {nome} {tipo} {valore}',
  'sostituiti: {valori}':
    'remplacés : {valori}',
  'Record tolto: {nome} {tipo} {valore}':
    'Enregistrement retiré : {nome} {tipo} {valore}',
  'Togli il record':
    'Retirer l’enregistrement',
  'Dalla zona {zona}. Non si annulla: per rimetterlo va riscritto.':
    'De la zone {zona}. Irréversible : pour le remettre il faut le réécrire.',
  'Controllo il PTR sul server…':
    'Vérification du PTR sur le serveur…',
  'Togli anche il PTR di {ip}, che punta a questo nome (zona {zona})':
    'Retirer aussi le PTR de {ip}, qui pointe vers ce nom (zone {zona})',
  'Il PTR di {ip} punta a un altro nome: resta com’è.':
    'Le PTR de {ip} pointe vers un autre nom : il reste tel quel.',
  'Nome → indirizzo IPv4':
    'Nom → adresse IPv4',
  'Nome → indirizzo IPv6':
    'Nom → adresse IPv6',
  'Alias di un altro nome':
    'Alias d’un autre nom',
  'Server di posta del dominio':
    'Serveur de messagerie du domaine',
  'Server dei nomi (delega)':
    'Serveur de noms (délégation)',
  'Indirizzo → nome (zona inversa)':
    'Adresse → nom (zone inverse)',
  'Servizio: priorità, peso, porta e destinazione':
    'Service : priorité, poids, port et destination',
  'Testo (SPF, verifiche di dominio…)':
    'Texte (SPF, vérifications de domaine…)',
  '{n} h':
    '{n} h',
  'Il nome contiene caratteri che il DNS non accetta.':
    'Le nom contient des caractères que le DNS n’accepte pas.',
  'Il TTL deve essere un numero di secondi.':
    'Le TTL doit être un nombre de secondes.',
  'Serve un indirizzo IPv4, per esempio 10.0.0.5.':
    'Il faut une adresse IPv4, par exemple 10.0.0.5.',
  'Serve un indirizzo IPv6, per esempio 2001:db8::5.':
    'Il faut une adresse IPv6, par exemple 2001:db8::5.',
  'Serve un nome host, per esempio server1.esempio.it.':
    'Il faut un nom d’hôte, par exemple server1.esempio.it.',
  'La priorità è un numero da 0 a 65535.':
    'La priorité est un nombre de 0 à 65535.',
  'Serve il nome del server di posta.':
    'Il faut le nom du serveur de messagerie.',
  'Priorità, peso e porta sono numeri da 0 a 65535.':
    'Priorité, poids et port sont des nombres de 0 à 65535.',
  'Serve il nome host di destinazione.':
    'Il faut le nom d’hôte de destination.',
  'Il testo è vuoto.':
    'Le texte est vide.',
  'Il testo deve stare su una riga sola.':
    'Le texte doit tenir sur une seule ligne.',
  'La pagina si apre con l’ultima lettura (la data è accanto) e «Aggiorna» rilegge in sottofondo; un giro ogni mezz’ora tiene fresche tutte le zone, e la ricerca in alto trova un nome o un indirizzo in tutte. A sinistra le zone, dirette e inverse; a destra i record della zona scelta, con i filtri per tipo, i record dinamici vecchi (oltre 30 giorni) segnati e l’indirizzo che porta al CI della CMDB. Se la connessione consente la scrittura, «Nuovo record» guida in due passi: il record, con i campi del suo tipo e l’anteprima, poi che cosa succede sul server — se il nome ha già un valore (aggiornarlo o aggiungere accanto), i conflitti (un CNAME vuole il nome tutto per sé) e il PTR dell’indirizzo, da creare o aggiornare; modificando o togliendo un A si toglie anche il PTR vecchio.':
    'La page s’ouvre avec la dernière lecture (la date est à côté) et «Aggiorna» relit en arrière-plan ; un passage toutes les demi-heures garde toutes les zones à jour, et la recherche en haut trouve un nom ou une adresse dans toutes. À gauche les zones, directes et inverses ; à droite les enregistrements de la zone choisie, avec les filtres par type, les enregistrements dynamiques anciens (plus de 30 jours) signalés et l’adresse qui mène au CI de la CMDB. Si la connexion autorise l’écriture, «Nuovo record» guide en deux étapes : l’enregistrement, avec les champs de son type et un aperçu, puis ce qui se passe sur le serveur — si le nom a déjà une valeur (la mettre à jour ou ajouter à côté), les conflits (un CNAME veut le nom pour lui seul) et le PTR de l’adresse, à créer ou mettre à jour ; modifier ou retirer un A retire aussi l’ancien PTR.',
  'server1.esempio.it':
    'server1.exemple.fr',
  'v=spf1 include:esempio.it -all':
    'v=spf1 include:exemple.fr -all',
  'Le connessioni DNS si configurano in Sorgenti dati.':
    'Les connexions DNS se configurent dans les Sources de données.',
  'Filtra per nome o rete…':
    'Filtrer par nom ou réseau…',
  '{da}–{a} di {n}':
    '{da}–{a} sur {n}',
  'informativa':
    'informative',
  'aperto':
    'ouvert',
  'in lavorazione':
    'en cours',
  'chiuso':
    'fermé',
  'Allarmi ({n})':
    'Alertes ({n})',
  'Vulnerabilità ({n})':
    'Vulnérabilités ({n})',
  'isolati':
    'isolés',
  'Allarmi aperti':
    'Alertes ouvertes',
  '{n} host×CVE':
    '{n} hôte×CVE',
  'asset':
    'assets',
  'Gli allarmi di Cynet degli ultimi 30 giorni (i più recenti, fino a 500 di {n}); quelli aperti diventano reperti sul CI.':
    'Les alertes Cynet des 30 derniers jours (les plus récentes, jusqu’à 500 sur {n}) ; celles ouvertes deviennent des constats sur le CI.',
  'Solo aperti o in lavorazione':
    'Ouvertes ou en cours seulement',
  'allarmi':
    'alertes',
  'Nessun allarme aperto.':
    'Aucune alerte ouverte.',
  'Nessun allarme.':
    'Aucune alerte.',
  'Allarme':
    'Alerte',
  'Le vulnerabilità che Cynet trova sugli endpoint (modulo ESPM), raggruppate per CVE, le più gravi prima: apri una riga per vedere gli host colpiti. Diventano reperti sui CI.':
    'Les vulnérabilités que Cynet trouve sur les endpoints (module ESPM), regroupées par CVE, les plus graves d’abord : ouvrez une ligne pour voir les hôtes touchés. Elles deviennent des constats sur les CI.',
  'Nessuna vulnerabilità aperta (o il Site GUID non è configurato: senza, Cynet non dà le vulnerabilità).':
    'Aucune vulnérabilité ouverte (ou le Site GUID n’est pas configuré : sans lui, Cynet ne donne pas les vulnérabilités).',
  'offline':
    'hors ligne',
  'isolato':
    'isolé',
  'Ultimo utente':
    'Dernier utilisateur',
  'Host in Cynet':
    'Hôtes dans Cynet',
  'Gli endpoint con l’agente Cynet, con quello che Cynet sa di loro e il CI corrispondente in CENSO. Gruppo, dominio e ultimo utente compaiono se la console li fornisce.':
    'Les endpoints avec l’agent Cynet, avec ce que Cynet sait d’eux et le CI correspondant dans CENSO. Groupe, domaine et dernier utilisateur apparaissent si la console les fournit.',
  'Nessun host.':
    'Aucun hôte.',
  'La pagina si apre con l’ultima lettura e si aggiorna in sottofondo; è divisa in sezioni: la panoramica con la copertura, gli allarmi recenti (gravità, tipo, utente, file, stato, con il CI dell’host), le vulnerabilità raggruppate per CVE con gli host colpiti, e tutti gli host di Cynet con agente, ultima scansione, gruppo, dominio, ultimo utente e isolamento quando la console li fornisce.':
    'La page s’ouvre avec la dernière lecture et se met à jour en arrière-plan ; elle est divisée en sections : la vue d’ensemble avec la couverture, les alertes récentes (gravité, type, utilisateur, fichier, état, avec le CI de l’hôte), les vulnérabilités regroupées par CVE avec les hôtes touchés, et tous les hôtes Cynet avec agent, dernier scan, groupe, domaine, dernier utilisateur et isolement quand la console les fournit.',

  // Patching: fleet, patch catalog, jobs, guided job (patch_jobs_service).
  'Agente da aggiornare':
    'Agent à mettre à jour',
  'Agente non in linea':
    'Agent hors ligne',
  'Aggiornabile':
    'Corrigeable',
  'Aggiornamenti di sicurezza':
    'Mises à jour de sécurité',
  'Aggiornamenti di sicurezza mancanti':
    'Mises à jour de sécurité manquantes',
  'Al riavvio':
    'Au redémarrage',
  'Anche quelli non di sicurezza (correzioni, nuove versioni minori). Da preferire in collaudo prima della produzione.':
    'Y compris celles hors sécurité (correctifs, nouvelles versions mineures). À préférer en recette avant la production.',
  'Ancora mancante':
    'Toujours manquant',
  'Ancora mancanti dopo l’installazione: {p}':
    'Toujours manquants après l’installation : {p}',
  'Annulla l’intervento':
    'Annuler l’intervention',
  'Annullare l’intervento? Ciò che non è ancora partito non partirà.':
    'Annuler l’intervention ? Ce qui n’a pas encore démarré ne démarrera pas.',
  'Annullata':
    'Annulée',
  'Approva e avvia':
    'Approuver et lancer',
  'Approva il rollback':
    'Approuver le rollback',
  'Approvata':
    'Approuvée',
  'Approvato da {u} il {d}':
    'Approuvée par {u} le {d}',
  'Avanzamento':
    'Avancement',
  'Bloccata':
    'Bloquée',
  'Bloccato':
    'Bloquée',
  'Calcolo cosa succederà su ogni macchina…':
    'Calcul de ce qui se passera sur chaque machine…',
  'Chiesto':
    'Demandé',
  'Completato con errori':
    'Terminée avec des erreurs',
  'Completato, da riavviare':
    'Terminée, redémarrage requis',
  'Cosa farà':
    'Ce qu’elle fera',
  'Cosa installare?':
    'Que faut-il installer ?',
  'Cosa installerebbe (prova) ({n})':
    'Ce qu’elle installerait (essai) ({n})',
  'Cosa è cambiato ({n})':
    'Ce qui a changé ({n})',
  'Crea da approvare':
    'Créer à approuver',
  'Crea e approva':
    'Créer et approuver',
  'Crea l’intervento da approvare: niente parte prima.':
    'Crée l’intervention à approuver : rien ne démarre avant.',
  'Da aggiornare':
    'À corriger',
  'Da approvare':
    'À approuver',
  'Da approvare: lo fa un amministratore del tenant. Intanto «Prova prima» mostra cosa installerebbe ogni macchina.':
    'À approuver : c’est un administrateur du tenant qui le fait. En attendant, « Essayer d’abord » montre ce que chaque machine installerait.',
  'Da installare per prime':
    'À installer en premier',
  'Da riavviare':
    'À redémarrer',
  'Data e ora':
    'Date et heure',
  'Durata (minuti)':
    'Durée (minutes)',
  'Eliminare la finestra «{n}»?':
    'Supprimer la fenêtre « {n} » ?',
  'Entro SLA':
    'Dans le SLA',
  'Entro i tempi (SLA)':
    'Dans les délais (SLA)',
  'Esempio: «Sabato notte», sabato dalle 22:00 per 4 ore.':
    'Exemple : « Samedi soir », le samedi à partir de 22:00 pendant 4 heures.',
  'Filtro':
    'Filtre',
  'Finestre':
    'Fenêtres',
  'Finita':
    'Terminée',
  'Fuori SLA':
    'Hors SLA',
  'Fuso':
    'Fuseau',
  'Giorni e orari in cui un intervento programmato «in finestra» può partire. Fuori dalla finestra aspetta la prossima apertura.':
    'Jours et heures pendant lesquels une intervention planifiée « dans une fenêtre » peut démarrer. En dehors, elle attend la prochaine ouverture.',
  'Il riavvio è programmato: si completa quando la macchina riparte.':
    'Le redémarrage est planifié : elle se termine quand la machine redémarre.',
  'Imposta il tag dalla scheda della macchina: l’approvazione lo pretende.':
    'Définissez le tag depuis la fiche de la machine : l’approbation l’exige.',
  'In coda':
    'En file',
  'In installazione':
    'Installation en cours',
  'In una data e ora':
    'À une date et une heure',
  'In una finestra di manutenzione':
    'Dans une fenêtre de maintenance',
  'Iniziata':
    'Commencée',
  'Installa le patch scelte':
    'Installer les correctifs choisis',
  'Installa le {n} scelte':
    'Installer les {n} choisis',
  'Installa l’agente dalla scheda della macchina: il patching passa da lì.':
    'Installez l’agent depuis la fiche de la machine : le patching passe par lui.',
  'Installa tutte le patch di sicurezza':
    'Installer tous les correctifs de sécurité',
  'Installa {p}':
    'Installer {p}',
  'Installata, ancora mancante':
    'Installée, toujours manquante',
  'Installata: si completa al riavvio, che non è stato concesso.':
    'Installée : elle se termine au redémarrage, qui n’a pas été autorisé.',
  'Installazione in corso':
    'Installation en cours',
  'Installazioni singole':
    'Installations individuelles',
  'Interventi':
    'Interventions',
  'Interventi in corso':
    'Interventions en cours',
  'Intervento':
    'Intervention',
  'KB scelte':
    'KB choisies',
  'La prova dice: niente da installare, la macchina è già aggiornata.':
    'L’essai indique : rien à installer, la machine est à jour.',
  'Le bloccate restano nell’intervento: sistemato il motivo (agente, tag), «Riprova le bloccate» le fa partire. Agente spento o da aggiornare non blocca: parte appena può.':
    'Les machines bloquées restent dans l’intervention : une fois la cause réglée (agent, tag), « Relancer les bloquées » les démarre. Un agent éteint ou à mettre à jour ne bloque pas : il démarre dès qu’il le peut.',
  'Le macchine compaiono qui quando hanno l’agente CENSO o quando la valutazione di sicurezza trova patch mancanti. Installa l’agente dalla scheda di una macchina, o da Inventario → Agenti.':
    'Les machines apparaissent ici dès qu’elles ont l’agent CENSO ou que l’évaluation de sécurité trouve des correctifs manquants. Installez l’agent depuis la fiche d’une machine, ou depuis Inventaire → Agents.',
  'Le patch mancanti di tutte le macchine e la loro installazione tramite l’agente CENSO: scegli cosa, dove e quando, un amministratore approva, e dopo l’installazione CENSO verifica che le patch non risultino più mancanti. Nessun riavvio senza il tuo consenso.':
    'Les correctifs manquants de toutes les machines et leur installation via l’agent CENSO : choisissez quoi, où et quand, un administrateur approuve, et après l’installation CENSO vérifie que les correctifs ne manquent plus. Aucun redémarrage sans votre accord.',
  'L’agente si aggiorna da solo; poi l’intervento parte.':
    'L’agent se met à jour tout seul ; ensuite l’intervention démarre.',
  'L’agente sta installando.':
    'L’agent est en train d’installer.',
  'L’andamento si costruisce da oggi: un punto al giorno.':
    'La tendance se construit à partir d’aujourd’hui : un point par jour.',
  'L’intervento parte appena l’agente torna in linea.':
    'L’intervention démarre dès que l’agent revient en ligne.',
  'Macchine':
    'Machines',
  'Macchine a cui manca ({n})':
    'Machines où il manque ({n})',
  'Macchine aggiornate':
    'Machines à jour',
  'Macchine con il tag «{t}»':
    'Machines avec le tag « {t} »',
  'Macchine fuori SLA':
    'Machines hors SLA',
  'Manca il tag obbligatorio':
    'Tag obligatoire manquant',
  'Manca il tag {k}':
    'Tag {k} manquant',
  'Mostra il log completo':
    'Afficher le journal complet',
  'Nascondi il log':
    'Masquer le journal',
  'Nessun intervento in corso.':
    'Aucune intervention en cours.',
  'Nessun intervento.':
    'Aucune intervention.',
  'Nessun inventario arrivato dopo l’installazione: verifica non fatta':
    'Aucun inventaire reçu après l’installation : vérification non faite',
  'Nessuna delle patch scelte manca qui':
    'Aucun des correctifs choisis ne manque ici',
  'Nessuna finestra: creala nella sezione «Finestre».':
    'Aucune fenêtre : créez-en une dans la section « Fenêtres ».',
  'Nessuna installazione prima dell’approvazione.':
    'Rien n’est installé avant l’approbation.',
  'Nessuna installazione su questa macchina.':
    'Aucune installation sur cette machine.',
  'Nessuna macchina con questo filtro.':
    'Aucune machine avec ce filtre.',
  'Nessuna macchina da aggiornare, per ora.':
    'Aucune machine à corriger, pour l’instant.',
  'Nessuna macchina.':
    'Aucune machine.',
  'Nessuna patch con questo filtro.':
    'Aucun correctif avec ce filtre.',
  'Nessuna patch mancante trovata su questa macchina.':
    'Aucun correctif manquant trouvé sur cette machine.',
  'Nessuna patch mancante.':
    'Aucun correctif manquant.',
  'Nome (facoltativo)':
    'Nom (facultatif)',
  'Non aggiornabili':
    'Non corrigeables',
  'Non pronte':
    'Pas prêtes',
  'Non riavviare':
    'Ne pas redémarrer',
  'Non riceve niente da questo intervento.':
    'Ne reçoit rien de cette intervention.',
  'Non riuscita':
    'Échouée',
  'Non verificabile qui: manca il motore di valutazione':
    'Non vérifiable ici : le moteur d’évaluation manque',
  'Non verificata':
    'Non vérifiée',
  'Nuovo intervento':
    'Nouvelle intervention',
  'Nuovo intervento su queste':
    'Nouvelle intervention sur celles-ci',
  'Ogni macchina dice cosa installerebbe, senza toccare niente.':
    'Chaque machine indique ce qu’elle installerait, sans rien toucher.',
  'Ogni macchina parte al primo contatto dell’agente (circa un minuto); quelle spente partono quando tornano.':
    'Chaque machine démarre au prochain contact de l’agent (environ une minute) ; celles qui sont éteintes démarrent à leur retour.',
  'Pacchetti Linux':
    'Paquets Linux',
  'Pacchetti scelti':
    'Paquets choisis',
  'Pacchetto Linux':
    'Paquet Linux',
  'Parte al prossimo contatto dell’agente (circa un minuto).':
    'Démarre au prochain contact de l’agent (environ une minute).',
  'Parte all’apertura della finestra di manutenzione.':
    'Démarre à l’ouverture de la fenêtre de maintenance.',
  'Parte dopo l’aggiornamento dell’agente.':
    'Démarre après la mise à jour de l’agent.',
  'Parte il {d}':
    'Démarre le {d}',
  'Parte quando l’agente torna in linea.':
    'Démarre quand l’agent revient en ligne.',
  'Parte solo dentro la finestra (giorni e orari), ogni volta che si apre finché non ha finito.':
    'Démarre uniquement dans la fenêtre (jours et heures), à chaque ouverture jusqu’à ce qu’elle soit terminée.',
  'Patch':
    'Correctifs',
  'Patch di sistema mancanti ({n})':
    'Correctifs système manquants ({n})',
  'Patch mancanti':
    'Correctifs manquants',
  'Patch scelte':
    'Correctifs choisis',
  'Per ambiente':
    'Par environnement',
  'Per tag (es. ambiente)':
    'Par tag (par ex. environnement)',
  'Preavviso':
    'Préavis',
  'Programmata':
    'Planifiée',
  'Programmato':
    'Planifiée',
  'Pronta':
    'Prête',
  'Proposte dalla scheda di una macchina, fuori da un intervento.':
    'Proposées depuis la fiche d’une machine, hors intervention.',
  'Prova prima':
    'Essayer d’abord',
  'Quando?':
    'Quand ?',
  'Riavvia':
    'Redémarrer',
  'Riavvia le macchine che aspettano un riavvio per completare un’installazione, con preavviso agli utenti collegati.':
    'Redémarre les machines qui attendent un redémarrage pour terminer une installation, avec un préavis aux utilisateurs connectés.',
  'Riavvia se serve':
    'Redémarrer si nécessaire',
  'Riavviata':
    'Redémarrée',
  'Riavvio':
    'Redémarrage',
  'Riprova le bloccate':
    'Relancer les bloquées',
  'Riprova le non riuscite':
    'Relancer les échouées',
  'Rollback eseguito':
    'Rollback effectué',
  'Scegli':
    'Choisir',
  'Scelgo le macchine':
    'Je choisis les machines',
  'Se una macchina deve riavviarsi resta «Da riavviare»; il riavvio lo fai tu, o con un intervento «Solo riavvio».':
    'Une machine qui doit redémarrer reste « À redémarrer » ; c’est vous qui la redémarrez, ou avec une intervention « Redémarrage seul ».',
  'Senza agente CENSO':
    'Sans agent CENSO',
  'Serve un inventario dall’interno (agente o WinRM/SSH) che dica Windows o Linux.':
    'Il faut un inventaire de l’intérieur (agent ou WinRM/SSH) qui indique Windows ou Linux.',
  'Sfruttata':
    'Exploitée',
  'Sfruttata attivamente: è nel catalogo CISA KEV delle vulnerabilità usate negli attacchi.':
    'Activement exploitée : elle figure dans le catalogue CISA KEV des vulnérabilités utilisées dans des attaques.',
  'Si completa al riavvio':
    'Se termine au redémarrage',
  'Sistema operativo non riconosciuto':
    'Système d’exploitation non reconnu',
  'Software installato da aggiornare ({n})':
    'Logiciels installés à mettre à jour ({n})',
  'Sola lettura: per installare serve il permesso di scrittura sul modulo «Patching».':
    'Lecture seule : pour installer, il faut le droit d’écriture sur le module « Patching ».',
  'Solo le macchine che lo chiedono, con un messaggio agli utenti collegati e un preavviso.':
    'Uniquement les machines qui le demandent, avec un message aux utilisateurs connectés et un préavis.',
  'Solo riavvio':
    'Redémarrage seul',
  'Su Windows gli aggiornamenti di sicurezza da Windows Update o dal WSUS dell’azienda; su Linux i pacchetti con correzioni di sicurezza (apt, dnf, yum, zypper, apk). È la scelta di ogni mese.':
    'Sous Windows les mises à jour de sécurité de Windows Update ou du WSUS de l’entreprise ; sous Linux les paquets avec correctifs de sécurité (apt, dnf, yum, zypper, apk). Le choix de chaque mois.',
  'Su quali macchine?':
    'Sur quelles machines ?',
  'Subito dopo l’approvazione':
    'Dès l’approbation',
  'Tempi di installazione (SLA): critiche entro {c} giorni, alte {a}, medie {m}, basse {b}. Una patch oltre i tempi conta «fuori SLA».':
    'Délais d’installation (SLA) : critiques sous {c} jours, élevées {a}, moyennes {m}, faibles {b}. Un correctif hors délai compte « hors SLA ».',
  'Tutte le macchine con questo tag al momento della creazione.':
    'Toutes les machines portant ce tag au moment de la création.',
  'Tutte le macchine e gli interventi in Patching':
    'Toutes les machines et interventions dans Patching',
  'Tutte le patch':
    'Tous les correctifs',
  'Tutti gli aggiornamenti':
    'Toutes les mises à jour',
  'Tutti gli aggiornamenti disponibili':
    'Toutes les mises à jour disponibles',
  'Tutti gli ambienti':
    'Tous les environnements',
  'Tutti gli interventi':
    'Toutes les interventions',
  'Tutti i tipi':
    'Tous les types',
  'Ultima installazione':
    'Dernière installation',
  'Un intervento installa le patch su più macchine insieme: si sceglie cosa, dove e quando, un amministratore lo approva, e CENSO verifica che le patch siano davvero installate.':
    'Une intervention installe des correctifs sur plusieurs machines à la fois : on choisit quoi, où et quand, un administrateur l’approuve, et CENSO vérifie que les correctifs sont vraiment installés.',
  'Una installazione alla volta: questa parte dopo.':
    'Une installation à la fois : celle-ci démarre ensuite.',
  'Una riga per patch, con le macchine a cui manca. La priorità unisce gravità, sfruttamento attivo (CISA KEV), tempi superati e numero di macchine. Le vulnerabilità di applicazioni e librerie restano in SBOM: si chiudono aggiornando l’applicazione.':
    'Une ligne par correctif, avec les machines où il manque. La priorité combine gravité, exploitation active (CISA KEV), délais dépassés et nombre de machines. Les vulnérabilités des applications et bibliothèques restent dans SBOM : on les ferme en mettant à jour l’application.',
  'Una volta sola, dall’ora indicata.':
    'Une seule fois, à partir de l’heure indiquée.',
  'Urgente':
    'Urgent',
  'Urgenti':
    'Urgents',
  'Verifica in corso':
    'Vérification en cours',
  'Verifica: in attesa dell’inventario dopo l’installazione':
    'Vérification : en attente de l’inventaire après l’installation',
  'Verificata':
    'Vérifiée',
  'Verificata: le patch non risultano più mancanti':
    'Vérifiée : les correctifs ne manquent plus',
  'Verificate':
    'Vérifiées',
  'agente da aggiornare':
    'agent à mettre à jour',
  'agente non in linea':
    'agent hors ligne',
  'agente sentito {d}':
    'agent contacté {d}',
  'bloccate finché non si sistema':
    'bloquées jusqu’à correction',
  'da riavviare':
    'à redémarrer',
  'es. Aggiornamenti di ottobre — collaudo':
    'par ex. Mises à jour d’octobre — recette',
  'es. Sabato notte':
    'par ex. Samedi soir',
  'es. {k}:collaudo':
    'par ex. {k}:recette',
  'escluse':
    'exclues',
  'gravità {s}, vista per la prima volta il {d}, tempi: {n} giorni':
    'gravité {s}, vue pour la première fois le {d}, délai : {n} jours',
  'il {d}':
    'le {d}',
  'installate':
    'installées',
  'installazione in corso: dettagli':
    'installation en cours : détails',
  'macchine':
    'machines',
  'macchine fuori SLA':
    'machines hors SLA',
  'minuti':
    'minutes',
  'nella finestra «{w}»':
    'dans la fenêtre « {w} »',
  'nessun riavvio: lo segnala soltanto':
    'aucun redémarrage : seulement signalé',
  'non cambiato':
    'inchangé',
  'non riuscite':
    'échouées',
  'oltre SLA':
    'hors SLA',
  'partiranno':
    'démarreront',
  'patch':
    'correctifs',
  'patch mancanti':
    'correctifs manquants',
  'patch per vulnerabilità usate negli attacchi (CISA KEV)':
    'correctifs pour des vulnérabilités utilisées dans des attaques (CISA KEV)',
  'prova chiesta, in attesa dell’agente':
    'essai demandé, en attente de l’agent',
  'riavvio se serve':
    'redémarrer si nécessaire',
  'riavvio se serve, con {n} minuti di preavviso':
    'redémarrage si nécessaire, avec {n} minutes de préavis',
  'scegli la finestra…':
    'choisissez la fenêtre…',
  'senza «{k}»':
    'sans « {k} »',
  'sicurezza':
    'sécurité',
  'subito dopo l’approvazione':
    'dès l’approbation',
  'versione corretta {v}':
    'version corrigée {v}',
  '{a} senza agente, {g} senza tag obbligatorio':
    '{a} sans agent, {g} sans tag obligatoire',
  '{f} non riuscite, {r} da riavviare (ultimi 30 giorni)':
    '{f} échouées, {r} à redémarrer (30 derniers jours)',
  '{n} KB':
    '{n} KB',
  '{n} macchine con patch oltre i tempi':
    '{n} machines avec des correctifs hors délai',
  '{n} macchine escluse':
    '{n} machines exclues',
  '{n} macchine scelte':
    '{n} machines choisies',
  '{n} patch scelte, su {m} macchine':
    '{n} correctifs choisis, sur {m} machines',
  '{n} scelte. Le macchine non pronte si possono scegliere: il riepilogo dirà cosa manca.':
    '{n} choisies. Les machines pas prêtes peuvent être choisies : le récapitulatif dira ce qui manque.',
  '{n} software':
    '{n} logiciels',
  '{n} su {m}':
    '{n} sur {m}',
  '{n} su {m} senza patch mancanti':
    '{n} sur {m} sans correctif manquant',
  '{n} urgenti':
    '{n} urgents',
  '«Nuovo intervento» sceglie cosa installare, su quali macchine e quando.':
    '« Nouvelle intervention » choisit quoi installer, sur quelles machines et quand.',
  '1 macchina esclusa':
    '1 machine exclue',
  'Dopo l’installazione l’agente manda subito un nuovo inventario e CENSO rivaluta la macchina: «Verificata» vuol dire che le patch non risultano più mancanti, «Ancora mancante» le elenca. Una macchina «Da riavviare» si completa da sola quando riparte; dal dettaglio di un’installazione applicata c’è il «Rollback».':
    'Après l’installation, l’agent envoie aussitôt un nouvel inventaire et CENSO réévalue la machine : « Vérifiée » signifie que les correctifs ne manquent plus, « Toujours manquant » les énumère. Une machine « À redémarrer » se termine d’elle-même au redémarrage ; le détail d’une installation appliquée propose le « Rollback ».',
  'Installa le scelte':
    'Installer les choisis',
  'Per installare le patch: «Nuovo intervento» (in Patching, dalla riga di una patch o dalla scheda di una macchina) chiede cosa — gli aggiornamenti di sicurezza, tutti gli aggiornamenti, le patch scelte o solo un riavvio —, dove — macchine scelte o un tag come «ambiente:collaudo» —, quando — subito, in una finestra o a una data — e se riavviare, con quanti minuti di preavviso agli utenti. L’ultimo passo dice macchina per macchina cosa farà, e perché una macchina resterà fuori.':
    'Pour installer des correctifs : « Nouvelle intervention » (dans Patching, depuis la ligne d’un correctif ou depuis la fiche d’une machine) demande quoi — les mises à jour de sécurité, toutes les mises à jour, les correctifs choisis ou seulement un redémarrage —, où — des machines choisies ou un tag comme « ambiente:collaudo » —, quand — tout de suite, dans une fenêtre ou à une date — et s’il faut redémarrer, avec combien de minutes de préavis aux utilisateurs. La dernière étape indique machine par machine ce qui se passera, et pourquoi une machine restera en dehors.',
  'Su Windows gli aggiornamenti arrivano da Windows Update o dal WSUS dell’azienda, scaricati e installati dalla macchina stessa: nessun file passa da CENSO e nessun PowerShell viene avviato. Su Linux si usa il gestore della distribuzione (apt, dnf, yum, zypper, apk) senza domande interattive, dopo aver aggiornato gli elenchi. Le vulnerabilità di applicazioni e librerie non sono qui: stanno in SBOM/Security health e si chiudono aggiornando l’applicazione. Serve l’add-on «Patching» e l’agente sulla macchina.':
    'Sous Windows, les mises à jour viennent de Windows Update ou du WSUS de l’entreprise, téléchargées et installées par la machine elle-même : aucun fichier ne passe par CENSO et aucun PowerShell n’est lancé. Sous Linux, on utilise le gestionnaire de la distribution (apt, dnf, yum, zypper, apk) sans questions interactives, après avoir rafraîchi les listes. Les vulnérabilités des applications et bibliothèques ne sont pas ici : elles sont dans SBOM/Security health et se ferment en mettant à jour l’application. Il faut l’add-on « Patching » et l’agent sur la machine.',
  'Un amministratore approva («Crea e approva», o «Approva e avvia» sull’intervento); prima si può chiedere «Prova prima», che fa dire a ogni macchina cosa installerebbe senza toccare niente. Una macchina bloccata (tag mancante, agente assente) resta nell’intervento con il motivo: sistemato, «Riprova le bloccate» la fa partire; «Riprova le non riuscite» rilancia quelle andate male.':
    'Un administrateur approuve (« Créer et approuver », ou « Approuver et lancer » sur l’intervention) ; avant, « Essayer d’abord » fait dire à chaque machine ce qu’elle installerait sans rien toucher. Une machine bloquée (tag manquant, agent absent) reste dans l’intervention avec le motif : une fois réglé, « Relancer les bloquées » la démarre ; « Relancer les échouées » relance celles qui ont échoué.',
  'il gestore delle patch del parco, sull’agente CENSO di ogni macchina. «Panoramica»: quante macchine sono aggiornate ed entro i tempi (SLA: critiche entro 15 giorni, alte 30, medie 90, basse 180), per ambiente, le patch da installare per prime, gli interventi in corso e l’andamento giorno per giorno. «Macchine»: cosa manca a ogni macchina, da quanto, e se si può aggiornare adesso — senza agente, agente non in linea o da aggiornare, tag obbligatorio mancante, sistema non riconosciuto —, con il rimedio scritto. «Patch»: una riga per KB, pacchetto o programma installato, con le macchine a cui manca, la gravità, lo sfruttamento attivo (CISA KEV), l’età e una priorità che mette insieme tutto. «Interventi»: cosa è stato installato dove, macchina per macchina, con l’esito, cosa è cambiato (da quale versione a quale) e il log completo. «Finestre»: giorni e orari in cui un intervento programmato può partire.':
    'le gestionnaire de correctifs du parc, via l’agent CENSO de chaque machine. « Vue d’ensemble » : combien de machines sont à jour et dans les délais (SLA : critiques sous 15 jours, élevées 30, moyennes 90, faibles 180), par environnement, les correctifs à installer en premier, les interventions en cours et la tendance jour par jour. « Machines » : ce qui manque à chaque machine, depuis quand, et si elle peut être corrigée maintenant — sans agent, agent hors ligne ou à mettre à jour, tag obligatoire manquant, système non reconnu —, avec le remède écrit. « Correctifs » : une ligne par KB, paquet ou programme installé, avec les machines où il manque, la gravité, l’exploitation active (CISA KEV), l’âge et une priorité qui combine le tout. « Interventions » : ce qui a été installé où, machine par machine, avec le résultat, ce qui a changé (de quelle version à quelle autre) et le journal complet. « Fenêtres » : les jours et heures où une intervention planifiée peut démarrer.',
  'la più vecchia da {n} giorni':
    'le plus ancien depuis {n} jours',
  '{n} critiche':
    '{n} critiques',
  'Età delle patch mancanti':
    'Âge des correctifs manquants',
  'Installazioni mancanti':
    'Installations manquantes',
  'Installazioni negli ultimi {n} giorni':
    'Installations des {n} derniers jours',
  'Installazioni riuscite':
    'Installations réussies',
  'Le vulnerabilità delle librerie delle applicazioni ({n} componenti) non sono qui: sono nella sezione':
    'Les vulnérabilités des bibliothèques des applications ({n} composants) ne sont pas ici : elles sont dans la section',
  'Macchine da aggiornare':
    'Machines à corriger',
  'Macchine più esposte (patch mancanti)':
    'Machines les plus exposées (correctifs manquants)',
  'Nel periodo':
    'Sur la période',
  'Nessuna installazione nel periodo.':
    'Aucune installation sur la période.',
  'Nessuna macchina da aggiornare.':
    'Aucune machine à corriger.',
  'Nessuna patch li mette in sicurezza: va aggiornato il sistema operativo.':
    'Aucun correctif ne les sécurise : il faut mettre à niveau le système d’exploitation.',
  'Nessuna.':
    'Aucune.',
  'Nessuno.':
    'Aucun.',
  'Non aggiornabili ({n})':
    'Non corrigeables ({n})',
  'Oltre i tempi':
    'Hors délai',
  'Patch da installare per prime (macchine)':
    'Correctifs à installer en premier (machines)',
  'Patch mancanti per tipo':
    'Correctifs manquants par type',
  'Per gravità: entro e oltre i tempi':
    'Par gravité : dans et hors délai',
  'Per sistema':
    'Par système',
  'Report completo (Excel)':
    'Rapport complet (Excel)',
  'Report completo (PDF)':
    'Rapport complet (PDF)',
  'Report delle patch':
    'Rapport des correctifs',
  'Sintesi direzionale (PDF)':
    'Synthèse de direction (PDF)',
  'Sistemi fuori supporto ({n})':
    'Systèmes hors support ({n})',
  'Situazione oggi':
    'Aujourd’hui',
  'Tempo medio di installazione':
    'Durée moyenne d’installation',
  'entro SLA':
    'dans le SLA',
  'entro {n} giorni':
    'sous {n} jours',
  'età mediana {n} giorni':
    'âge médian {n} jours',
  'installazioni':
    'installations',
  'installazioni mancanti':
    'installations manquantes',
  'macchine da aggiornare':
    'machines à corriger',
  'nessuna mancante':
    'aucun manquant',
  'patch non più mancanti dopo l’inventario':
    'correctifs qui ne manquent plus après l’inventaire',
  'su {n} macchine':
    'sur {n} machines',
  '{e} fuori supporto, {r} da riavviare':
    '{e} hors support, {r} à redémarrer',
  '{n} non riuscite':
    '{n} échouées',
  '{n} patch diverse, {u} urgenti':
    '{n} correctifs différents, {u} urgents',
  '{n} riavvii':
    '{n} redémarrages',
  '«Sintesi direzionale»: poche pagine con i numeri, i grafici e la situazione scritta in frasi, per chi decide. «Report completo»: gli stessi grafici e poi tutte le tabelle — macchine, patch, patch per macchina, installazioni e interventi del periodo, macchine non aggiornabili, sistemi fuori supporto, rischi accettati —, anche in Excel.':
    '« Synthèse de direction » : quelques pages avec les chiffres, les graphiques et la situation écrite en phrases, pour ceux qui décident. « Rapport complet » : les mêmes graphiques puis tous les tableaux — machines, correctifs, correctifs par machine, installations et interventions de la période, machines non corrigeables, systèmes hors support, risques acceptés —, aussi en Excel.',
  'La sezione Sicurezza del CI non elenca le vulnerabilità delle librerie delle applicazioni: stanno nella sua sezione «Software (SBOM)», accanto al componente che le porta, e un rimando dice quante sono.':
    'La section Sécurité du CI ne liste pas les vulnérabilités des bibliothèques des applications : elles sont dans sa section « Logiciels (SBOM) », à côté du composant qui les porte, et un renvoi indique combien il y en a.',
  '«Report»: per 30, 90, 180 giorni o un anno, la situazione di oggi (macchine aggiornate ed entro i tempi, installazioni mancanti, sfruttate, oltre i tempi, non aggiornabili) e ciò che è stato fatto nel periodo (installazioni riuscite e non, percentuale di successo, aggiornamenti installati, verificate, tempo medio), con l’andamento, le installazioni giorno per giorno, la gravità entro e oltre i tempi, l’età delle patch mancanti, gli ambienti, i sistemi, le patch da installare per prime e le macchine più esposte. «Sintesi direzionale (PDF)» è il riassunto per chi decide, con i grafici e la situazione scritta in frasi; «Report completo» aggiunge tutte le tabelle (anche patch per macchina, installazioni e interventi del periodo, rischi accettati), in PDF o Excel.':
    '« Rapport » : sur 30, 90, 180 jours ou un an, la situation d’aujourd’hui (machines à jour et dans les délais, installations manquantes, exploitées, hors délai, non corrigeables) et ce qui a été fait sur la période (installations réussies et échouées, taux de réussite, mises à jour installées, vérifiées, durée moyenne), avec la tendance, les installations jour par jour, la gravité dans et hors délai, l’âge des correctifs manquants, les environnements, les systèmes, les correctifs à installer en premier et les machines les plus exposées. « Synthèse de direction (PDF) » est le résumé pour ceux qui décident, avec les graphiques et la situation écrite en phrases ; « Rapport complet » ajoute tous les tableaux (aussi les correctifs par machine, les installations et interventions de la période, les risques acceptés), en PDF ou Excel.',
  'Aggiorna tutti i programmi':
    'Mettre à jour tous les programmes',
  'Con cosa l’agente aggiorna i programmi di terze parti su questa macchina.':
    'Avec quoi l’agent met à jour les programmes tiers sur cette machine.',
  'I programmi di terze parti (Chrome, Firefox, Acrobat Reader, 7-Zip, Zoom…) si aggiornano dallo stesso posto: scegliendoli fra le patch, dalla scheda della macchina o con un intervento «Programmi di terze parti». Su Windows l’agente usa Chocolatey se il programma è suo, altrimenti winget (App Installer), e per Chrome ed Edge anche il loro aggiornatore; la scheda della macchina dice se winget o Chocolatey ci sono. Su Linux i programmi vengono dai repository e si aggiornano come pacchetti. Per i programmi non c’è rollback: winget e Chocolatey non tornano alla versione di prima.':
    'Les programmes tiers (Chrome, Firefox, Acrobat Reader, 7-Zip, Zoom…) se mettent à jour depuis le même endroit : en les choisissant parmi les correctifs, depuis la fiche de la machine ou avec une intervention « Programmes tiers ». Sous Windows, l’agent utilise Chocolatey si le programme est l’un de ses paquets, sinon winget (App Installer), et pour Chrome et Edge aussi leur propre outil de mise à jour ; la fiche de la machine indique si winget ou Chocolatey sont présents. Sous Linux, les programmes viennent des dépôts et se mettent à jour comme des paquets. Les programmes n’ont pas de rollback : winget et Chocolatey ne reviennent pas à la version précédente.',
  'Linux: con gli aggiornamenti del sistema':
    'Linux : avec les mises à jour du système',
  'Nessuna KB, pacchetto o programma mancante da scegliere.':
    'Aucune KB, aucun paquet ni programme manquant à choisir.',
  'Né winget né Chocolatey':
    'Ni winget ni Chocolatey',
  'Programmi con vulnerabilità note (browser, runtime, strumenti): su Windows si aggiornano con winget o Chocolatey della macchina, o con l’aggiornatore del produttore (Chrome, Edge); su Linux dal loro repository.':
    'Programmes avec des vulnérabilités connues (navigateurs, runtimes, outils) : sous Windows ils se mettent à jour avec winget ou Chocolatey de la machine, ou avec l’outil de mise à jour de l’éditeur (Chrome, Edge) ; sous Linux depuis leur dépôt.',
  'Programmi di terze parti':
    'Programmes tiers',
  'Programmi scelti':
    'Programmes choisis',
  'Si aggiornano solo Chrome ed Edge, con il loro aggiornatore: per gli altri programmi serve App Installer (winget) o Chocolatey sulla macchina.':
    'Seuls Chrome et Edge se mettent à jour, avec leur propre outil : pour les autres programmes il faut App Installer (winget) ou Chocolatey sur la machine.',
  'Solo le KB, i pacchetti o i programmi che scegli qui sotto: su ogni macchina si installa solo quello che le manca.':
    'Uniquement les KB, paquets ou programmes que vous choisissez ci-dessous : chaque machine n’installe que ce qui lui manque.',
  'Su Linux i programmi vengono dai repository: si aggiornano con «Tutti gli aggiornamenti» o scegliendo il pacchetto.':
    'Sous Linux, les programmes viennent des dépôts : ils se mettent à jour avec « Toutes les mises à jour » ou en choisissant le paquet.',
  'Su Windows tutti i programmi che hanno una versione nuova — Chrome, Firefox, Acrobat Reader, 7-Zip, Zoom… — con winget o Chocolatey della macchina, e Chrome ed Edge anche con il loro aggiornatore.':
    'Sous Windows, tous les programmes qui ont une nouvelle version — Chrome, Firefox, Acrobat Reader, 7-Zip, Zoom… — avec winget ou Chocolatey de la machine, et Chrome et Edge aussi avec leur propre outil de mise à jour.',
  'chiesto all’aggiornatore del produttore':
    'demandé à l’outil de mise à jour de l’éditeur',
  'non offerto da winget né da Chocolatey':
    'non proposé par winget ni par Chocolatey',
  'programmi con {m}':
    'programmes avec {m}',
  'programmi: né winget né Chocolatey (solo Chrome ed Edge)':
    'programmes : ni winget ni Chocolatey (seulement Chrome et Edge)',
  'È un programma installato: su Windows l’agente lo aggiorna con winget o Chocolatey della macchina (Chrome ed Edge anche con il loro aggiornatore), su Linux dal suo repository. Senza winget né Chocolatey la macchina lo dice nel riepilogo.':
    'C’est un programme installé : sous Windows, l’agent le met à jour avec winget ou Chocolatey de la machine (Chrome et Edge aussi avec leur propre outil), sous Linux depuis son dépôt. Sans winget ni Chocolatey, la machine l’indique dans le récapitulatif.',
  'Anche il singolo servizio si esporta, dalla sua pagina: il PDF ha la mappa della composizione disegnata a colonne — client, ingressi, poi ogni salto fino al database e sotto l’infrastruttura — con le porte sulle frecce, leggibile anche stampata, e dopo le tabelle dei componenti e di tutti i collegamenti con porte, traffico e flussi, nella finestra scelta in pagina; l’Excel ha le stesse tabelle.':
    'Un seul service s’exporte aussi, depuis sa page : le PDF contient la carte de la composition dessinée en colonnes — clients, entrées, puis chaque saut jusqu’à la base de données et en dessous l’infrastructure — avec les ports sur les flèches, lisible même imprimée, suivie des tableaux des composants et de toutes les connexions avec ports, trafic et flux, sur la fenêtre choisie dans la page ; l’Excel contient les mêmes tableaux.',
  'Dalla pagina di una Business App si esporta la sua mappa: i CI che ne eseguono gli elementi, con i programmi, il traffico fra loro nelle ultime 24 ore con le porte, e i Business Service che la usano; poi le tabelle di elementi, collegamenti, funzionalità e servizi.':
    'Depuis la page d’une Business App, on exporte sa carte : les CI qui en exécutent les éléments, avec les programmes, le trafic entre eux sur les dernières 24 heures avec les ports, et les Business Services qui l’utilisent ; puis les tableaux des éléments, connexions, fonctionnalités et services.',
  'Larghezza del menu':
    'Largeur du menu',
  'Mostra o nascondi il menu (tasto [)':
    'Afficher ou masquer le menu (touche [)',
  'Trascina per allargare o stringere il menu; doppio clic per la larghezza normale':
    'Faites glisser pour élargir ou rétrécir le menu ; double-clic pour la largeur normale',
  'Aggiungi ai preferiti':
    'Ajouter aux favoris',
  'Come mostrare il menu':
    'Comment afficher le menu',
  'Espandi il menu':
    'Déployer le menu',
  'Espandi il menu (tasto [)':
    'Déployer le menu (touche [)',
  'In cima al menu tre pulsanti scelgono come mostrarlo: esteso (fisso a sinistra, si allarga o si stringe trascinandone il bordo destro), a icone (una colonna stretta: passando su un’icona si aprono a fianco le pagine della sezione) o nascosto (la pagina usa tutta la larghezza e il menu si apre dal bordo sinistro o con ☰). Il tasto «[» passa da esteso a icone e ritorno. La stellina accanto a una voce la mette fra i Preferiti, in cima al menu e nella colonna a icone. ⌘K (Ctrl+K) apre la ricerca: trova anche le pagine del menu, e a campo vuoto propone preferiti e pagine recenti; ↑↓ e Invio per aprire. Le scelte restano per questo browser.':
    'En haut du menu, trois boutons choisissent comment l’afficher : complet (fixé à gauche, il s’élargit ou se rétrécit en faisant glisser son bord droit), en icônes (une colonne étroite : en survolant une icône, les pages de la section s’ouvrent à côté) ou masqué (la page utilise toute la largeur et le menu s’ouvre depuis le bord gauche ou avec ☰). La touche « [ » passe de complet à icônes et inversement. L’étoile à côté d’une entrée la place parmi les Favoris, en haut du menu et dans la colonne d’icônes. ⌘K (Ctrl+K) ouvre la recherche : elle trouve aussi les pages du menu et, champ vide, propose les favoris et les pages récentes ; ↑↓ et Entrée pour ouvrir. Les choix sont conservés pour ce navigateur.',
  'Menu a icone':
    'Menu en icônes',
  'Menu a icone: le voci di una sezione si aprono passandoci sopra':
    'Menu en icônes : les pages d’une section s’ouvrent en la survolant',
  'Menu esteso':
    'Menu complet',
  'Menu esteso, fisso a sinistra (tasto [ per passare alle icone)':
    'Menu complet, fixé à gauche (touche [ pour passer aux icônes)',
  'Menu nascosto':
    'Menu masqué',
  'Menu nascosto: la pagina usa tutta la larghezza, il menu si apre dal bordo sinistro o con ☰':
    'Menu masqué : la page utilise toute la largeur, le menu s’ouvre depuis le bord gauche ou avec ☰',
  'Pagine':
    'Pages',
  'Pagine recenti':
    'Pages récentes',
  'Preferiti':
    'Favoris',
  'Scrivi il nome di una pagina per andarci, o almeno due caratteri per cercare nell’inventario. ↑↓ per scegliere, Invio per aprire.':
    'Tapez le nom d’une page pour y aller, ou au moins deux caractères pour chercher dans l’inventaire. ↑↓ pour choisir, Entrée pour ouvrir.',
  'Togli dai preferiti':
    'Retirer des favoris',
  'Vai a una pagina, o cerca nomi, IP, MAC, porte, software, seriali…':
    'Aller à une page, ou chercher noms, IP, MAC, ports, logiciels, numéros de série…',
  'Negli hit si selezionano più righe per segnarle viste o archiviarle in una volta; «Dettagli» mostra il payload completo e ha gli stessi comandi per la riga.':
    'Dans les hits, on sélectionne plusieurs lignes pour les marquer comme vues ou les archiver d’un coup ; « Dettagli » affiche la charge utile complète et a les mêmes commandes pour la ligne.',
  'Scarica le righe filtrate, con le colonne mostrate, in CSV (si apre con Excel)':
    'Télécharger les lignes filtrées, avec les colonnes affichées, en CSV (s’ouvre avec Excel)',
  'Scegli le colonne da mostrare':
    'Choisir les colonnes à afficher',
  'Tutte le tabelle si usano allo stesso modo: sopra, «Cerca in tutte le colonne», quante righe ci sono (e quante passano i filtri), «Colonne» per scegliere quali vedere, «Esporta CSV» per scaricare le righe filtrate con le colonne mostrate (si apre con Excel) e «Righe» per quante righe per pagina (25 all’inizio). Sotto ogni titolo c’è il filtro della colonna, e cliccando il titolo si ordina (di nuovo per invertire). Colonne scelte e righe per pagina restano per questo browser, tabella per tabella.':
    'Tous les tableaux s’utilisent de la même façon : au-dessus, « Chercher dans toutes les colonnes », le nombre de lignes (et combien passent les filtres), « Colonnes » pour choisir celles à voir, « Exporter CSV » pour télécharger les lignes filtrées avec les colonnes affichées (s’ouvre avec Excel) et « Lignes » pour le nombre de lignes par page (25 au départ). Sous chaque titre se trouve le filtre de la colonne, et un clic sur le titre trie (à nouveau pour inverser). Les colonnes choisies et les lignes par page sont conservées pour ce navigateur, tableau par tableau.',
  'account':
    'comptes',
  'aggiornamenti':
    'mises à jour',
  'amministratori':
    'administrateurs',
  'apparati':
    'équipements',
  'attributi':
    'attributs',
  'avvisi':
    'avis',
  'azioni':
    'actions',
  'calendari':
    'calendriers',
  'campi':
    'champs',
  'classi':
    'classes',
  'collegamenti':
    'liens',
  'comunicazioni':
    'communications',
  'connettori':
    'connecteurs',
  'contatti':
    'contacts',
  'contratti':
    'contrats',
  'controlli':
    'contrôles',
  'datastore':
    'datastores',
  'dipendenze':
    'dépendances',
  'dispositivi':
    'appareils',
  'driver':
    'pilotes',
  'elementi':
    'éléments',
  'esecuzioni':
    'exécutions',
  'eventi':
    'événements',
  'finestre':
    'fenêtres',
  'firme':
    'signatures',
  'fonti':
    'sources',
  'fornitori':
    'fournisseurs',
  'funzionalità':
    'fonctionnalités',
  'gruppi':
    'groupes',
  'indirizzi':
    'adresses',
  'mappature':
    'correspondances',
  'modelli':
    'modèles',
  'modifiche':
    'modifications',
  'moduli':
    'modules',
  'parametri':
    'paramètres',
  'passi':
    'étapes',
  'piani':
    'plans',
  'pool':
    'pools',
  'prodotti':
    'produits',
  'proposte':
    'propositions',
  'provider':
    'fournisseurs d’identité',
  'registrazioni':
    'enregistrements',
  'regole':
    'règles',
  'richieste':
    'demandes',
  'rischi':
    'risques',
  'segnalazioni':
    'signalements',
  'servizi':
    'services',
  'tenant':
    'tenants',
  'tipi':
    'types',
  'utenti':
    'utilisateurs',
  'versioni':
    'versions',
  'vicini':
    'voisins',
  'voci':
    'entrées',
  '{n} hit selezionati':
    '{n} hits sélectionnés',
  '(nessuno)':
    '(aucun)',
  '+{n} altre':
    '+{n} autres',
  '1 problema':
    '1 problème',
  'A mano':
    'Manuellement',
  'Ad alto rischio':
    'À haut risque',
  'Adempimenti':
    'Obligations',
  'Adempimenti NIS2 a 30, 7 e 1 giorno dalla scadenza e quando scadono; per gli incidenti, prima della scadenza di pre-notifica, notifica e relazione finale. Gli avvisi vanno anche al responsabile e al punto di contatto NIS2.':
    'Obligations NIS2 à 30, 7 et 1 jour de l’échéance et lorsqu’elles arrivent à échéance ; pour les incidents, avant les échéances de l’alerte précoce, de la notification et du rapport final. Les alertes sont aussi envoyées au responsable et au point de contact NIS2.',
  'Adempimenti NIS2 da caricare':
    'Obligations NIS2 à charger',
  'Adempimenti scaduti':
    'Obligations en retard',
  'Adempimento':
    'Obligation',
  'Adempimento eliminato.':
    'Obligation supprimée.',
  'Adempimento previsto dalla norma: le date vengono dalle determinazioni ACN in vigore quando è stato caricato. Se una determinazione le sposta, correggile qui.':
    'Obligation prévue par la loi : les dates proviennent des déterminations de l’ACN en vigueur lors de son chargement. Si une détermination les déplace, corrigez-les ici.',
  'Adempimento salvato.':
    'Obligation enregistrée.',
  'Aggiorna da InternetDB':
    'Actualiser depuis InternetDB',
  'Aggiorna la pre-notifica: valutazione iniziale dell’incidente, gravità e impatto, indicatori di compromissione se disponibili.':
    'Met à jour l’alerte précoce : évaluation initiale de l’incident, gravité et impact, indicateurs de compromission si disponibles.',
  'Aggiornato da {chi} il {quando}':
    'Mis à jour par {chi} le {quando}',
  'Aggiungi al perimetro':
    'Ajouter au périmètre',
  'Aggiungi nota':
    'Ajouter une note',
  'Aggiungi un servizio…':
    'Ajouter un service…',
  'Annulla le {n} esclusioni a mano':
    'Annuler les {n} exclusions manuelles',
  'Annulla l’invio':
    'Annuler l’envoi',
  'Approvazione dell’organo di gestione':
    'Approbation de l’organe de direction',
  'Apri la scheda dell’IP pubblico':
    'Ouvrir la fiche de l’IP publique',
  'Apri le Impostazioni':
    'Ouvrir les Paramètres',
  'Art. 25: è significativo l’incidente che ha causato o può causare una grave perturbazione operativa dei servizi o perdite finanziarie per il soggetto, oppure danni materiali o immateriali considerevoli ad altre persone fisiche o giuridiche. Finché non è valutato gli orologi corrono comunque: meglio una pre-notifica non necessaria che una notifica in ritardo.':
    'Art. 25 : un incident est important s’il a causé ou peut causer une perturbation opérationnelle grave des services ou des pertes financières pour l’entité, ou des dommages matériels ou immatériels considérables à d’autres personnes physiques ou morales. Tant qu’il n’est pas évalué, les délais courent quand même : mieux vaut une alerte précoce inutile qu’une notification en retard.',
  'Avvisa sulle scadenze NIS2 e sugli incidenti':
    'Alerter sur les échéances NIS2 et les incidents',
  'Business Service':
    'Business Service',
  'CI coinvolti':
    'CI concernés',
  'CVE che InternetDB associa all’indirizzo':
    'CVE qu’InternetDB associe à l’adresse',
  'CVE note':
    'CVE connues',
  'Calcolato dal termine della notifica finché l’invio della notifica non è registrato.':
    'Calculé à partir de l’échéance de la notification tant que l’envoi de la notification n’est pas enregistré.',
  'Calcolato il {d}.':
    'Calculé le {d}.',
  'Carica gli adempimenti NIS2':
    'Charger les obligations NIS2',
  'Carica gli adempimenti NIS2 previsti dalla norma, o aggiungi quelli interni con «Nuovo adempimento».':
    'Chargez les obligations NIS2 prévues par la loi, ou ajoutez les obligations internes avec « Nouvelle obligation ».',
  'Caricati {n} adempimenti NIS2: controlla date e responsabili.':
    '{n} obligations NIS2 chargées : vérifiez les dates et les responsables.',
  'Cerca un CI per nome o indirizzo':
    'Rechercher un CI par nom ou adresse',
  'Chi ha i permessi di scrittura può caricare gli adempimenti NIS2 previsti dalla norma.':
    'Les utilisateurs disposant des droits d’écriture peuvent charger les obligations NIS2 prévues par la loi.',
  'Chiede di nuovo a InternetDB ciò che sa degli indirizzi pubblici (nessuna scansione)':
    'Redemande à InternetDB ce qu’il sait des adresses publiques (aucune analyse)',
  'Chiudendo l’incidente le notifiche non registrate restano «non inviate» nel registro.':
    'À la clôture de l’incident, les notifications non enregistrées restent « non envoyées » dans le registre.',
  'Chiusi negli ultimi 12 mesi':
    'Clôturés au cours des 12 derniers mois',
  'Ciò che dimostra l’adempimento in un’ispezione: il protocollo della comunicazione ad ACN, il verbale, il documento o il collegamento dove si trova.':
    'Ce qui démontre le respect de l’obligation lors d’une inspection : le numéro d’enregistrement de la communication à l’ACN, le procès-verbal, le document ou le lien vers l’endroit où il se trouve.',
  'Ciò che l’organizzazione espone a Internet: indirizzi, servizi raggiungibili e sistemi che ci stanno dietro, con il livello di rischio e il motivo. È la superficie d’attacco da conoscere e da dichiarare.':
    'Ce que l’organisation expose à Internet : adresses, services joignables et systèmes qui se trouvent derrière, avec le niveau de risque et la raison. C’est la surface d’attaque à connaître et à déclarer.',
  'Coinvolge altri Stati membri: da dichiarare già nella pre-notifica.':
    'Concerne d’autres États membres : à déclarer dès l’alerte précoce.',
  'Compila il profilo':
    'Compléter le profil',
  'Comunicazione ACN di inclusione':
    'Communication d’inclusion de l’ACN',
  'Consulta Shodan InternetDB per gli IP pubblici':
    'Consulter Shodan InternetDB pour les IP publiques',
  'Controlli misurati su tutto l’inventario.':
    'Contrôles mesurés sur tout l’inventaire.',
  'Controlli misurati sul perimetro NIS2: {n} sistemi.':
    'Contrôles mesurés sur le périmètre NIS2 : {n} systèmes.',
  'Crealo dalla pagina dei servizi':
    'Créez-le depuis la page des services',
  'Cronologia':
    'Chronologie',
  'Da comunicare ad ACN':
    'À communiquer à l’ACN',
  'Da dichiarare già nella pre-notifica.':
    'À déclarer dès l’alerte précoce.',
  'Da pianificare':
    'À planifier',
  'Da questa data decorrono i 9 mesi per la notifica degli incidenti e i 18 mesi per le misure di sicurezza di base.':
    'À compter de cette date courent les 9 mois pour la notification des incidents et les 18 mois pour les mesures de sécurité de base.',
  'Da qui partono gli orologi dell’art. 25: pre-notifica entro 24 h, notifica entro 72 h, relazione finale entro un mese dalla notifica.':
    'Les délais de l’art. 25 partent d’ici : alerte précoce sous 24 h, notification sous 72 h, rapport final dans un délai d’un mois après la notification.',
  'Data e ora dell’invio':
    'Date et heure de l’envoi',
  'Definisci il perimetro':
    'Définir le périmètre',
  'Descrizione dettagliata con gravità e impatto, tipo di minaccia o causa di fondo, misure di attenuazione adottate e in corso, impatto transfrontaliero.':
    'Description détaillée avec gravité et impact, type de menace ou cause profonde, mesures d’atténuation appliquées et en cours, impact transfrontière.',
  'E-mail del responsabile':
    'E-mail du responsable',
  'Elenco dei servizi non disponibile.':
    'Liste des services non disponible.',
  'Eliminare l’adempimento «{titolo}»? Per uno che non vi riguarda è meglio lo stato «non applicabile», che resta come scelta motivata.':
    'Supprimer l’obligation « {titolo} » ? Pour une obligation qui ne vous concerne pas, mieux vaut le statut « non applicable », qui reste comme un choix motivé.',
  'Eliminati, o arrivati con un aggiornamento di CENSO. Si caricano senza toccare quelli già presenti.':
    'Supprimées, ou arrivées avec une mise à jour de CENSO. Elles sont chargées sans toucher celles déjà présentes.',
  'Email del sostituto':
    'E-mail du suppléant',
  'Entrano i punti di ingresso e i componenti di ogni servizio scelto ({n} scelti).':
    'Inclut les points d’entrée et les composants de chaque service choisi ({n} choisis).',
  'Entro':
    'Échéance',
  'Esclude i sistemi dal perimetro: non saranno più proposti':
    'Exclut les systèmes du périmètre : ils ne seront plus proposés',
  'Escludo…':
    'Exclusion…',
  'Escono dalla piattaforma solo gli indirizzi pubblici del tenant, in sola lettura: nessuna scansione viene eseguita.':
    'Seules les adresses publiques du tenant sortent de la plateforme, en lecture seule : aucune analyse n’est effectuée.',
  'Esporta calendario (.ics)':
    'Exporter le calendrier (.ics)',
  'Esposti fuori perimetro':
    'Exposés hors périmètre',
  'Evidenza':
    'Preuve',
  'Fatti negli ultimi 12 mesi':
    'Effectuées au cours des 12 derniers mois',
  'Gli adempimenti aperti con una data, come eventi di un giorno con un promemoria una settimana prima: si importano in Outlook, Google Calendar o Apple Calendar.':
    'Les obligations ouvertes ayant une date, sous forme d’événements d’une journée avec un rappel une semaine avant : elles s’importent dans Outlook, Google Agenda ou Apple Calendrier.',
  'Gli indirizzi esposti arrivano da: gli IP pubblici dichiarati nella scheda di un CI (NAT, VIP) o rilevati sulle interfacce dei dispositivi; la discovery cloud (IP pubblici delle istanze); il traffico ricevuto da Internet (serve il filtro «Almeno uno interno»); InternetDB, se attivo nel profilo NIS2.':
    'Les adresses exposées proviennent : des IP publiques déclarées dans la fiche d’un CI (NAT, VIP) ou détectées sur les interfaces des équipements ; de la discovery cloud (IP publiques des instances) ; du trafic reçu d’Internet (nécessite le filtre « Au moins un interne ») ; d’InternetDB, s’il est activé dans le profil NIS2.',
  'Gli obblighi con una scadenza del D.Lgs. 138/2024 e delle determinazioni ACN: registrazione annuale sulla piattaforma ACN, aggiornamento delle informazioni, notifica degli incidenti e misure di base dalla comunicazione di inclusione, approvazione e formazione degli organi di amministrazione, formazione del personale, analisi dei rischi, test di continuità, audit, fornitori. Ognuno con il suo riferimento, tutti modificabili.':
    'Les obligations assorties d’une échéance du D.Lgs. 138/2024 et des déterminations de l’ACN : enregistrement annuel sur la plateforme ACN, mise à jour des informations, notification des incidents et mesures de base à compter de la communication d’inclusion, approbation et formation des organes de direction, formation du personnel, analyse des risques, tests de continuité, audits, fournisseurs. Chacune avec sa référence, toutes modifiables.',
  'Ha ricevuto connessioni da indirizzi Internet nei flussi':
    'A reçu des connexions d’adresses Internet dans les flux',
  'Hypervisor, storage e apparati di rete su cui poggiano i componenti dei servizi scelti.':
    'Hyperviseurs, stockage et équipements réseau sur lesquels reposent les composants des services choisis.',
  'I giorni di promemoria sono numeri interi fra 0 e 365, separati da virgola.':
    'Les jours de rappel sont des nombres entiers entre 0 et 365, séparés par des virgules.',
  'I promemoria via e-mail vanno al responsabile dell’incidente, al punto di contatto NIS2 e ai destinatari NIS2 del tenant: 6 h prima della pre-notifica, 12 h prima della notifica, 7 giorni prima della relazione finale e a ogni scadenza. Un incidente non ancora valutato fa correre gli orologi comunque.':
    'Les rappels par e-mail sont envoyés au responsable de l’incident, au point de contact NIS2 et aux destinataires NIS2 du tenant : 6 h avant l’alerte précoce, 12 h avant la notification, 7 jours avant le rapport final et à chaque échéance. Les délais courent même pour un incident pas encore évalué.',
  'I sistemi tornano nel perimetro se una regola li comprende, e tornano tra le proposte.':
    'Les systèmes reviennent dans le périmètre si une règle les inclut, et reviennent parmi les propositions.',
  'IP esposti ad alto rischio':
    'IP exposées à haut risque',
  'Il filtro del traffico è «Entrambi interni»: i flussi da e verso Internet vengono scartati all’arrivo, quindi manca la parte «raggiunto da Internet». Per vederla: Impostazioni → Traffico da conservare → «Almeno uno interno» (lo sceglie un amministratore del tenant). Gli IP pubblici dichiarati, il cloud e InternetDB funzionano comunque.':
    'Le filtre du trafic est « Les deux internes » : les flux depuis et vers Internet sont écartés à l’arrivée, il manque donc la partie « atteint depuis Internet ». Pour la voir : Paramètres → Trafic à conserver → « Au moins un interne » (choisi par un administrateur du tenant). Les IP publiques déclarées, le cloud et InternetDB fonctionnent quand même.',
  'Il numero che CSIRT Italia assegna alla segnalazione.':
    'Le numéro que CSIRT Italia attribue au signalement.',
  'Il perimetro NIS2 comprende i sistemi informativi e di rete usati per le attività e i servizi comunicati ad ACN. Si scrive con regole (Business Service, reti, tag), così segue l’inventario invece di diventare una lista da aggiornare a mano.':
    'Le périmètre NIS2 comprend les réseaux et systèmes d’information utilisés pour les activités et services communiqués à l’ACN. Il s’écrit avec des règles (Business Service, réseaux, tags) : il suit ainsi l’inventaire au lieu de devenir une liste à mettre à jour à la main.',
  'Il sistema non è nel perimetro NIS2':
    'Le système n’est pas dans le périmètre NIS2',
  'In liste di abuso':
    'Sur des listes d’abus',
  'In scadenza entro 30 giorni':
    'Échéance sous 30 jours',
  'Incidenti aperti':
    'Incidents ouverts',
  'Includi l’infrastruttura sotto i servizi':
    'Inclure l’infrastructure sous les services',
  'Indica data e ora del rilevamento e della presa di conoscenza.':
    'Indiquez la date et l’heure de la détection et de la prise de connaissance.',
  'Indirizzi IP pubblici':
    'Adresses IP publiques',
  'Indirizzi esposti':
    'Adresses exposées',
  'Indirizzo privato: InternetDB conosce solo gli indirizzi pubblici.':
    'Adresse privée : InternetDB ne connaît que les adresses publiques.',
  'Indirizzo pubblico di un’istanza cloud':
    'Adresse publique d’une instance cloud',
  'Indirizzo pubblico scritto su un CI (NAT, VIP) o rilevato sull’interfaccia di un dispositivo':
    'Adresse publique saisie sur un CI (NAT, VIP) ou détectée sur l’interface d’un équipement',
  'Inizio della finestra':
    'Début de la fenêtre',
  'InternetDB':
    'InternetDB',
  'InternetDB non è attivo. Si accende nel profilo NIS2 (sezione «Profilo e perimetro»): è una lettura passiva dei dati di Shodan, senza alcuna scansione, e dalla piattaforma escono solo gli indirizzi pubblici dell’organizzazione.':
    'InternetDB n’est pas activé. Il s’active dans le profil NIS2 (section « Profil et périmètre ») : c’est une lecture passive des données de Shodan, sans aucune analyse, et seules les adresses publiques de l’organisation sortent de la plateforme.',
  'InternetDB non è attivo: si accende nel profilo NIS2.':
    'InternetDB n’est pas activé : il s’active dans le profil NIS2.',
  'InternetDB è attivo: per gli indirizzi pubblici CENSO legge ciò che Shodan sa (porte aperte, CVE note, nomi host), senza scansioni. Si aggiorna da solo una volta al giorno.':
    'InternetDB est activé : pour les adresses publiques, CENSO lit ce que Shodan sait (ports ouverts, CVE connues, noms d’hôte), sans analyse. Il s’actualise tout seul une fois par jour.',
  'InternetDB: {n} indirizzi verificati, {m} non riusciti.':
    'InternetDB : {n} adresses vérifiées, {m} en échec.',
  'Intorno ai controlli c’è il programma NIS2. «Profilo e perimetro»: soggetto essenziale o importante, punto di contatto e sostituto, data della comunicazione ACN (da lì contano i 9 mesi per la notifica degli incidenti e i 18 per le misure di base); il perimetro si definisce con Business Service, reti, tag e singoli CI, e i controlli si misurano sui suoi sistemi. Le proposte per allargarlo dicono cosa resta fuori e perché: sistemi esposti su Internet, infrastruttura da cui dipendono, sistemi con cui parlano, controller di dominio.':
    'Autour des contrôles, il y a le programme NIS2. « Profil et périmètre » : entité essentielle ou importante, point de contact et suppléant, date de la communication de l’ACN (c’est à partir de là que courent les 9 mois pour la notification des incidents et les 18 pour les mesures de base) ; le périmètre se définit avec des Business Service, des réseaux, des tags et des CI individuels, et les contrôles sont mesurés sur ses systèmes. Les propositions pour l’élargir indiquent ce qui reste en dehors et pourquoi : systèmes exposés sur Internet, infrastructure dont ils dépendent, systèmes avec lesquels ils communiquent, contrôleurs de domaine.',
  'Inviata il {quando}':
    'Envoyée le {quando}',
  'La finestra serve agli adempimenti con un periodo, come la registrazione dal 1° gennaio al 28 febbraio. Per chiudere un adempimento usa «Fatto»: registra l’evidenza e, se è ricorrente, prepara la prossima occorrenza.':
    'La fenêtre sert aux obligations ayant une période, comme l’enregistrement du 1er janvier au 28 février. Pour clôturer une obligation, utilisez « Fait » : cela enregistre la preuve et, si elle est récurrente, prépare la prochaine occurrence.',
  'La piattaforma non vede sistemi fuori dal perimetro legati a quelli dentro.':
    'La plateforme ne voit aucun système hors du périmètre lié à ceux qui y sont inclus.',
  'La presa di conoscenza non può precedere il rilevamento.':
    'La prise de connaissance ne peut pas précéder la détection.',
  'Le date vengono dalla norma e dalle determinazioni ACN, che possono cambiare: verificale con le determinazioni in vigore. Quelli che contano dalla comunicazione di inclusione (9 e 18 mesi) prendono la data dal profilo NIS2; se manca, restano da pianificare.':
    'Les dates proviennent de la loi et des déterminations de l’ACN, qui peuvent changer : vérifiez-les avec les déterminations en vigueur. Celles qui courent à partir de la communication d’inclusion (9 et 18 mois) prennent la date du profil NIS2 ; si elle manque, elles restent à planifier.',
  'Le porte raggiunte da Internet vengono dai flussi degli ultimi {d} giorni: {n} coppie indirizzo/porta con sorgenti esterne.':
    'Les ports atteints depuis Internet proviennent des flux des {d} derniers jours : {n} paires adresse/port avec des sources externes.',
  'Le regole non comprendono ancora nessun sistema.':
    'Les règles n’incluent encore aucun système.',
  'Lette dai dati, non copiate: certificati dei sistemi del perimetro o esposti che scadono entro 60 giorni, contratti ICT che finiscono entro 90, dichiarazioni non riesaminate da un anno, passi di notifica degli incidenti aperti. Si gestiscono dove stanno: il certificato sul CI, il contratto in Contratti, la dichiarazione e l’incidente in questa pagina.':
    'Lues dans les données, non recopiées : certificats des systèmes du périmètre ou exposés qui expirent sous 60 jours, contrats TIC qui se terminent sous 90 jours, déclarations non réexaminées depuis un an, étapes de notification des incidents ouverts. Elles se gèrent là où elles se trouvent : le certificat sur le CI, le contrat dans Contrats, la déclaration et l’incident sur cette page.',
  'L’indirizzo e-mail del responsabile non è valido.':
    'L’adresse e-mail du responsable n’est pas valide.',
  'L’inizio della finestra non può essere dopo la scadenza.':
    'Le début de la fenêtre ne peut pas être postérieur à l’échéance.',
  'Mancano':
    'Temps restant',
  'Modifica i dati':
    'Modifier les données',
  'Modifica le regole':
    'Modifier les règles',
  'Modifica l’adempimento':
    'Modifier l’obligation',
  'Mostra anche quelli fatti':
    'Afficher aussi celles effectuées',
  'Mostra tutto l’inventario':
    'Afficher tout l’inventaire',
  'Mostrati solo: {f}.':
    'Affichage limité à : {f}.',
  'Motivazione':
    'Justification',
  'Nell’aggiornamento annuale delle informazioni (dal 15 aprile al 31 maggio) ACN chiede lo spazio di indirizzamento IP pubblico e i nomi di dominio del soggetto.':
    'Lors de la mise à jour annuelle des informations (du 15 avril au 31 mai), l’ACN demande l’espace d’adressage IP public et les noms de domaine de l’entité.',
  'Nessun Business Service definito.':
    'Aucun Business Service défini.',
  'Nessun adempimento aperto.':
    'Aucune obligation ouverte.',
  'Nessun adempimento in elenco':
    'Aucune obligation dans la liste',
  'Nessun adempimento nuovo da caricare; le date mancanti sono state riprese dal profilo NIS2, dove possibile.':
    'Aucune nouvelle obligation à charger ; les dates manquantes ont été reprises du profil NIS2, si possible.',
  'Nessun altro servizio':
    'Aucun autre service',
  'Nessun incidente registrato':
    'Aucun incident enregistré',
  'Nessun indirizzo esposto conosciuto':
    'Aucune adresse exposée connue',
  'Nessun nome di dominio noto: i nomi arrivano dagli host noti a InternetDB, se attivo. Aggiungi a mano i domini registrati dal soggetto.':
    'Aucun nom de domaine connu : les noms proviennent des hôtes connus d’InternetDB, s’il est activé. Ajoutez à la main les domaines enregistrés par l’entité.',
  'Nessun problema noto sui certificati dei sistemi esposti.':
    'Aucun problème connu sur les certificats des systèmes exposés.',
  'Nessun servizio corrisponde.':
    'Aucun service ne correspond.',
  'Nessun servizio rischioso, vulnerabilità o segnalazione nota.':
    'Aucun service à risque, vulnérabilité ou signalement connu.',
  'Nessun sistema collegato: dichiara l’IP pubblico nella scheda del CI che lo espone (NAT, VIP).':
    'Aucun système lié : déclarez l’IP publique dans la fiche du CI qui l’expose (NAT, VIP).',
  'Nessuna evidenza: segnarlo fatto comunque? In un’ispezione l’evidenza è ciò che dimostra l’adempimento.':
    'Aucune preuve : la marquer comme effectuée quand même ? Lors d’une inspection, la preuve est ce qui démontre le respect de l’obligation.',
  'Nessuna notifica in attesa':
    'Aucune notification en attente',
  'Nessuna porta nota: né i flussi da Internet né InternetDB ne indicano.':
    'Aucun port connu : ni les flux depuis Internet ni InternetDB n’en indiquent.',
  'Nessuna scadenza ricavata nei prossimi mesi.':
    'Aucune échéance déduite dans les prochains mois.',
  'Nessuna voce.':
    'Aucune entrée.',
  'Nomi di dominio':
    'Noms de domaine',
  'Nomi host':
    'Noms d’hôte',
  'Non ancora determinato':
    'Pas encore déterminé',
  'Non ancora verificata.':
    'Pas encore vérifiée.',
  'Non ancora verificato: l’aggiornamento è giornaliero, oppure subito con «Aggiorna da InternetDB».':
    'Pas encore vérifié : l’actualisation est quotidienne, ou immédiate avec « Actualiser depuis InternetDB ».',
  'Non proporre più':
    'Ne plus proposer',
  'Notifica':
    'Notification',
  'Notifiche a CSIRT Italia':
    'Notifications à CSIRT Italia',
  'Notifiche scadute':
    'Notifications en retard',
  'Nuovo adempimento':
    'Nouvelle obligation',
  'Passi non inviati a CSIRT Italia oltre il termine':
    'Étapes non envoyées à CSIRT Italia après l’échéance',
  'Perché proporlo':
    'Pourquoi le proposer',
  'Perché questo livello di rischio':
    'Pourquoi ce niveau de risque',
  'Perché è dentro':
    'Pourquoi il est inclus',
  'Perimetro NIS2':
    'Périmètre NIS2',
  'Perimetro NIS2 non definito: i controlli sono misurati su tutto l’inventario.':
    'Périmètre NIS2 non défini : les contrôles sont mesurés sur tout l’inventaire.',
  'Perimetro non definito.':
    'Périmètre non défini.',
  'Porta aperta secondo InternetDB (dati Shodan)':
    'Port ouvert selon InternetDB (données Shodan)',
  'Porte aperte':
    'Ports ouverts',
  'Possibile impatto transfrontaliero':
    'Impact transfrontière possible',
  'Pre-notifica':
    'Alerte précoce',
  'Prepara l’elenco':
    'Préparer la liste',
  'Presa di conoscenza':
    'Prise de connaissance',
  'Profilo NIS2':
    'Profil NIS2',
  'Profilo e perimetro':
    'Profil et périmètre',
  'Profilo non ancora compilato':
    'Profil pas encore complété',
  'Profilo salvato: gli obblighi NIS2 sono datati a partire dalle date del profilo.':
    'Profil enregistré : les obligations NIS2 sont datées à partir des dates du profil.',
  'Promemoria per e-mail a 30, 7 e 1 giorno (o ai giorni scelti), il giorno della scadenza e una volta a scadenza passata: al responsabile, al punto di contatto NIS2 e ai destinatari degli avvisi del tenant. Si spengono in':
    'Rappels par e-mail à 30, 7 et 1 jour (ou aux jours choisis), le jour de l’échéance et une fois l’échéance passée : au responsable, au point de contact NIS2 et aux destinataires des alertes du tenant. Ils se désactivent dans',
  'Proposte per allargare il perimetro':
    'Propositions pour élargir le périmètre',
  'Prossima scadenza':
    'Prochaine échéance',
  'Punto di contatto':
    'Point de contact',
  'Quando gli organi di amministrazione hanno approvato le misure di gestione del rischio.':
    'Quand les organes de direction ont approuvé les mesures de gestion des risques.',
  'Quando l’evento è stato rilevato (allarme, segnalazione, anomalia).':
    'Quand l’événement a été détecté (alarme, signalement, anomalie).',
  'Ragione sociale':
    'Raison sociale',
  'Registra incidente':
    'Enregistrer un incident',
  'Registra l’incidente appena se ne ha conoscenza: da quel momento corrono le 24 ore per la pre-notifica.':
    'Enregistrez l’incident dès que vous en avez connaissance : les 24 heures pour l’alerte précoce courent à partir de ce moment.',
  'Registra l’invio':
    'Enregistrer l’envoi',
  'Registrazione ACN':
    'Enregistrement ACN',
  'Registro degli incidenti':
    'Registre des incidents',
  'Regole aggiornate da {chi} il {quando}':
    'Règles mises à jour par {chi} le {quando}',
  'Relazione finale':
    'Rapport final',
  'Responsabile: {nome}':
    'Responsable : {nome}',
  'Reti e tag':
    'Réseaux et tags',
  'Ricalcola l’elenco':
    'Recalculer la liste',
  'Riceve i promemoria della scadenza.':
    'Reçoit les rappels de l’échéance.',
  'Riceve i promemoria delle scadenze insieme al punto di contatto NIS2.':
    'Reçoit les rappels des échéances avec le point de contact NIS2.',
  'Ricorrenza':
    'Récurrence',
  'Riferimento CSIRT':
    'Référence CSIRT',
  'Riferimento della registrazione ACN':
    'Référence de l’enregistrement ACN',
  'Riferimento normativo':
    'Référence réglementaire',
  'Rilevanza':
    'Pertinence',
  'Scadenze':
    'Échéances',
  'Scadenze NIS2':
    'Échéances NIS2',
  'Scadenze NIS2 non disponibili.':
    'Échéances NIS2 non disponibles.',
  'Scadenze dai dati della piattaforma':
    'Échéances issues des données de la plateforme',
  'Se si sospetta che l’incidente sia causato da atti illegittimi o malevoli e se può avere un impatto transfrontaliero.':
    'Si l’on soupçonne que l’incident est causé par des actes illicites ou malveillants et s’il peut avoir un impact transfrontière.',
  'Segna come fatto':
    'Marquer comme fait',
  'Segna come fatto: «{titolo}»':
    'Marquer comme fait : « {titolo} »',
  'Segna come inviata':
    'Marquer comme envoyée',
  'Senza regole il report misura l’intero inventario ({n} sistemi).':
    'Sans règles, le rapport porte sur tout l’inventaire ({n} systèmes).',
  'Separati da virgola. Vuoto = 30, 7 e 1 giorno prima.':
    'Séparés par des virgules. Vide = 30, 7 et 1 jour avant.',
  'Serve un titolo.':
    'Un titre est requis.',
  'Servizi coinvolti':
    'Services concernés',
  'Servizi rischiosi raggiungibili':
    'Services à risque accessibles',
  'Servizio a rischio {r} se raggiungibile da Internet':
    'Service à risque {r} s’il est accessible depuis Internet',
  'Settore':
    'Secteur',
  'Shodan InternetDB':
    'Shodan InternetDB',
  'Si verificano su InternetDB gli IP pubblici registrati come CI: questo indirizzo non lo è ancora.':
    'Les IP publiques enregistrées comme CI sont vérifiées sur InternetDB : cette adresse ne l’est pas encore.',
  'Significatività':
    'Importance',
  'Significatività da valutare: gli orologi corrono comunque.':
    'Importance à évaluer : les délais courent quand même.',
  'Sistemi aggiunti o esclusi a mano':
    'Systèmes ajoutés ou exclus manuellement',
  'Sistemi dietro':
    'Systèmes derrière',
  'Sistemi dietro l’indirizzo':
    'Systèmes derrière l’adresse',
  'Sistemi fuori dal perimetro che la piattaforma vede legati a quelli dentro: esposti su Internet, infrastruttura da cui dipendono, sistemi con cui parlano nel traffico degli ultimi 7 giorni, servizi comuni come controller di dominio e hypervisor.':
    'Systèmes hors du périmètre que la plateforme voit liés à ceux qui y sont : exposés sur Internet, infrastructure dont ils dépendent, systèmes avec lesquels ils communiquent dans le trafic des 7 derniers jours, services communs comme les contrôleurs de domaine et les hyperviseurs.',
  'Sistemi nel perimetro':
    'Systèmes dans le périmètre',
  'Sistemi nell’inventario':
    'Systèmes dans l’inventaire',
  'Situazione':
    'Situation',
  'Soggetto essenziale':
    'Entité essentielle',
  'Soggetto importante':
    'Entité importante',
  'Sorgenti Internet':
    'Sources Internet',
  'Sospetta azione illegittima o malevola':
    'Acte illicite ou malveillant suspecté',
  'Sostituto':
    'Suppléant',
  'Sottoreti pubbliche':
    'Sous-réseaux publics',
  'Sottosettore':
    'Sous-secteur',
  'Superficie esposta':
    'Surface exposée',
  'Tipo di soggetto':
    'Type d’entité',
  'Tipo di soggetto, punto di contatto e data della comunicazione ACN servono a datare gli obblighi NIS2.':
    'Le type d’entité, le point de contact et la date de la communication ACN servent à dater les obligations NIS2.',
  'Togli i {n} sistemi aggiunti a mano':
    'Retirer les {n} systèmes ajoutés manuellement',
  'Toglie il sistema dal perimetro anche se una regola lo comprende':
    'Retire le système du périmètre même si une règle l’inclut',
  'Torna al perimetro':
    'Retour au périmètre',
  'Ultimo visto':
    'Dernière vue',
  'Un tag per riga, nella forma «chiave:valore»: entra ogni sistema che ne ha almeno uno.':
    'Un tag par ligne, sous la forme « clé:valeur » : tout système qui en a au moins un est inclus.',
  'Una rete per riga, in notazione CIDR: entra ogni sistema con un indirizzo dentro.':
    'Un réseau par ligne, en notation CIDR : tout système ayant une adresse à l’intérieur est inclus.',
  'Valutato non significativo: nessuna notifica dovuta a CSIRT Italia.':
    'Évalué comme non important : aucune notification due au CSIRT Italia.',
  'Verificato il':
    'Vérifié le',
  'Vulnerabilità critiche sui sistemi dietro l’indirizzo':
    'Vulnérabilités critiques sur les systèmes derrière l’adresse',
  'Vulnerabilità sfruttate attivamente sui sistemi dietro l’indirizzo':
    'Vulnérabilités activement exploitées sur les systèmes derrière l’adresse',
  'adempimenti':
    'obligations',
  'adempimenti e scadenze ricavate':
    'obligations et échéances déduites',
  'amministrazione remota, condivisione file, database…':
    'administration à distance, partage de fichiers, bases de données…',
  'annuale':
    'annuelle',
  'con l’infrastruttura sotto i servizi':
    'avec l’infrastructure sous les services',
  'consultato':
    'consulté',
  'contenuto':
    'contenu',
  'contratto':
    'contrat',
  'cosa si è scoperto, cosa si è deciso, cosa si è comunicato':
    'ce qui a été découvert, ce qui a été décidé, ce qui a été communiqué',
  'cosa è successo, cosa si è visto, cosa si è fatto finora':
    'ce qui s’est passé, ce qui a été observé, ce qui a été fait jusqu’ici',
  'da 1 sorgente':
    'depuis 1 source',
  'da assegnare':
    'à attribuer',
  'da fare':
    'à faire',
  'da pianificare':
    'à planifier',
  'da valutare':
    'à évaluer',
  'da {n} sorgenti':
    'depuis {n} sources',
  'dal {inizio} al {fine}':
    'du {inizio} au {fine}',
  'dichiarazione':
    'déclaration',
  'dipendenza':
    'dépendance',
  'domani':
    'demain',
  'entro 24 h dalla presa di conoscenza':
    'dans les 24 h suivant la prise de connaissance',
  'entro 72 h dalla presa di conoscenza':
    'dans les 72 h suivant la prise de connaissance',
  'entro un mese dalla notifica':
    'dans un délai d’un mois après la notification',
  'entro un’ora':
    'dans l’heure',
  'es. Sanità':
    'ex. Santé',
  'es. ransomware sui file server, indisponibilità del portale':
    'ex. ransomware sur les serveurs de fichiers, indisponibilité du portail',
  'esposto su Internet':
    'exposé sur Internet',
  'fatto':
    'fait',
  'fra {n} h':
    'dans {n} h',
  'fra {n} min':
    'dans {n} min',
  'fra {n} ore':
    'dans {n} heures',
  'fuori perimetro':
    'hors périmètre',
  'il {data}':
    'le {data}',
  'in lista di abuso':
    'sur une liste d’abus',
  'incidente':
    'incident',
  'incidente registrato':
    'incident enregistré',
  'indirizzi ad alto rischio':
    'adresses à haut risque',
  'indirizzi con servizi rischiosi':
    'adresses avec des services à risque',
  'indirizzi con sistemi fuori perimetro':
    'adresses avec des systèmes hors périmètre',
  'indirizzi in liste di abuso':
    'adresses sur des listes d’abus',
  'inviata':
    'envoyée',
  'inviata a un’altra ora…':
    'envoyée à une autre heure…',
  'inviata in ritardo':
    'envoyée en retard',
  'inviata nei termini':
    'envoyée dans les délais',
  'mensile':
    'mensuelle',
  'misure di base entro il {d}':
    'mesures de base d’ici le {d}',
  'nel perimetro':
    'dans le périmètre',
  'nessuna notifica dovuta':
    'aucune notification due',
  'nessuna regola: conta tutto':
    'aucune règle : tout compte',
  'non consultato':
    'non consulté',
  'non dovuta':
    'non requise',
  'non inviata':
    'non envoyée',
  'non inviata: incidente chiuso senza registrarne l’invio':
    'non envoyée : incident clos sans en enregistrer l’envoi',
  'non registrata':
    'non enregistrée',
  'non significativo':
    'non important',
  'normativo':
    'réglementaire',
  'notifica degli incidenti dal {d}':
    'notification des incidents à partir du {d}',
  'notifica inviata':
    'notification envoyée',
  'notifica: invio annullato':
    'notification : envoi annulé',
  'notifiche, «Avvisa sulle scadenze NIS2 e sugli incidenti».':
    'notifications, « Alerter sur les échéances NIS2 et les incidents ».',
  'numero di protocollo, documento, collegamento…':
    'numéro d’enregistrement, document, lien…',
  'oggi':
    'aujourd’hui',
  'perché è o non è significativo':
    'pourquoi il est ou n’est pas important',
  'perimetro NIS2':
    'périmètre NIS2',
  'pianificato':
    'planifié',
  'pre-notifica inviata':
    'alerte précoce envoyée',
  'pre-notifica: invio annullato':
    'alerte précoce : envoi annulé',
  'privato, raggiunto da Internet':
    'privée, atteinte depuis Internet',
  'proposte perimetro NIS2':
    'propositions de périmètre NIS2',
  'relazione finale inviata':
    'rapport final envoyé',
  'relazione finale: invio annullato':
    'rapport final : envoi annulé',
  'scaduta da {n} giorni':
    'en retard de {n} jours',
  'scaduta da {n} h':
    'en retard de {n} h',
  'scaduta da {n} min':
    'en retard de {n} min',
  'scaduto da {n} ore':
    'expiré depuis {n} heures',
  'scaduto ieri':
    'expiré hier',
  'semestrale':
    'semestrielle',
  'senza l’infrastruttura sotto i servizi':
    'sans l’infrastructure sous les services',
  'senza una data di scadenza':
    'sans date d’échéance',
  'servizio comune':
    'service commun',
  'significativo':
    'important',
  'sistemi':
    'systèmes',
  'sistemi esposti non inclusi nel perimetro NIS2':
    'systèmes exposés non inclus dans le périmètre NIS2',
  'stato: {stato}':
    'statut : {stato}',
  'termine':
    'échéance',
  'traffico':
    'trafic',
  'trimestrale':
    'trimestrielle',
  'una tantum':
    'ponctuelle',
  '{a} aggiunti, {e} esclusi':
    '{a} ajoutés, {e} exclus',
  '{a} sistemi aggiunti a mano, {e} esclusi a mano. Un’esclusione vale sempre, anche se una regola comprende il sistema.':
    '{a} systèmes ajoutés manuellement, {e} exclus manuellement. Une exclusion s’applique toujours, même si une règle inclut le système.',
  '{n} CVE da InternetDB':
    '{n} CVE selon InternetDB',
  '{n} a rischio medio':
    '{n} à risque moyen',
  '{n} adempimenti previsti dalla norma non sono in elenco':
    '{n} obligations prévues par la réglementation ne figurent pas dans la liste',
  '{n} con significatività da valutare':
    '{n} dont l’importance reste à évaluer',
  '{n} in scadenza nei prossimi 30 giorni, {m} da pianificare':
    '{n} à échéance dans les 30 prochains jours, {m} à planifier',
  '{n} indirizzi esposti, {m} fuori dal perimetro':
    '{n} adresses exposées, {m} hors du périmètre',
  '{n} notifiche scadute':
    '{n} notifications en retard',
  '{n} problemi':
    '{n} problèmes',
  '{n} pubblici':
    '{n} publiques',
  '{n} selezionati':
    '{n} sélectionnés',
  '{n} sfruttate':
    '{n} exploitées',
  '{n} sistemi esposti su Internet sono fuori dal perimetro: è la lacuna più grave, valuta di includerli.':
    '{n} systèmes exposés sur Internet sont hors du périmètre : c’est la lacune la plus grave, envisagez de les inclure.',
  '{ref}: prossima notifica fra {h} h':
    '{ref} : prochaine notification dans {h} h',
  '«Scadenze»: gli adempimenti NIS2 precaricati con il riferimento (registrazione e aggiornamento annuale su ACN, misure di base, organi di amministrazione, formazione, rischi, continuità, audit, fornitori), modificabili, con responsabile, ricorrenza ed evidenza, più le scadenze ricavate dai dati (certificati, contratti ICT, dichiarazioni, incidenti) e il calendario .ics; i promemoria arrivano per email. «Incidenti»: il registro con gli orologi dell’art. 25 — pre-notifica entro 24 ore dalla presa di conoscenza, notifica entro 72, relazione finale entro un mese — e i promemoria prima di ogni scadenza.':
    '« Échéances » : les obligations NIS2 préchargées avec leur référence (enregistrement et mise à jour annuelle sur ACN, mesures de base, organes de direction, formation, risques, continuité, audits, fournisseurs), modifiables, avec responsable, récurrence et preuve, plus les échéances déduites des données (certificats, contrats TIC, déclarations, incidents) et le calendrier .ics ; les rappels arrivent par e-mail. « Incidents » : le registre avec les délais de l’art. 25 — alerte précoce dans les 24 heures suivant la prise de connaissance, notification dans les 72 heures, rapport final dans un délai d’un mois — et les rappels avant chaque échéance.',
  '«Superficie esposta»: gli IP pubblici dichiarati, quelli delle interfacce e del cloud, ciò che dai flussi risulta raggiunto da Internet e, se lo accendi nel profilo, ciò che sa Shodan InternetDB (sola lettura, nessuna scansione); per ogni indirizzo porte, servizi da non esporre, sistemi dietro, certificati, vulnerabilità, reputazione e il rischio con il motivo, più l’elenco di indirizzi e domini da comunicare ad ACN. Per vedere il traffico da Internet, in Impostazioni il traffico da conservare deve essere «Almeno uno interno».':
    '« Surface exposée » : les IP publiques déclarées, celles des interfaces et du cloud, ce que les flux montrent comme atteint depuis Internet et, si vous l’activez dans le profil, ce que sait Shodan InternetDB (lecture seule, aucun scan) ; pour chaque adresse : ports, services à ne pas exposer, systèmes derrière, certificats, vulnérabilités, réputation et le risque avec son motif, plus la liste des adresses et domaines à communiquer à l’ACN. Pour voir le trafic depuis Internet, dans Paramètres le trafic à conserver doit être « Au moins un interne ».',
  '«{titolo}» segnato come fatto.':
    '« {titolo} » marqué comme fait.',
  '«{titolo}» segnato come fatto. Creata la prossima occorrenza, in scadenza il {data}.':
    '« {titolo} » marqué comme fait. Prochaine occurrence créée, avec échéance le {data}.',
  'È ciò che CENSO conosce: confrontalo con le assegnazioni del provider prima di comunicarlo.':
    'C’est ce que CENSO connaît : comparez-le avec les attributions du fournisseur d’accès avant de le communiquer.',
  'È {ricorrenza}: alla conferma nasce la prossima occorrenza, in scadenza il {data}. Questa resta nello storico con la sua evidenza.':
    'Cette obligation est {ricorrenza} : à la confirmation, la prochaine occurrence est créée, avec échéance le {data}. Celle-ci reste dans l’historique avec sa preuve.',
  'D.Lgs. 138/2024, art. 24':
    'D.Lgs. 138/2024, art. 24',
  'nome@azienda.it':
    'nom@entreprise.fr',
  'Almeno {n} caratteri: il motivo resta nel registro delle letture e compare nell’e-mail di avviso.':
    'Au moins {n} caractères : le motif reste dans le journal des consultations et figure dans l’e-mail d’alerte.',
  'Annulla la rotazione':
    'Annuler la rotation',
  'Annullare la rotazione della chiave {id}?':
    'Annuler la rotation de la clé {id} ?',
  'Annullare la rotazione della chiave {id}? L’agente ha già aggiunto la nuova chiave: sul volume restano tutte e due.':
    'Annuler la rotation de la clé {id} ? L’agent a déjà ajouté la nouvelle clé : les deux restent sur le volume.',
  'Avvisa quando viene letta una chiave BitLocker':
    'Alerter lors de la consultation d’une clé BitLocker',
  'BitLocker':
    'BitLocker',
  'CENSO non custodisce chiavi di questo volume: con la raccolta accesa arrivano al prossimo inventario dell’agente.':
    'CENSO ne conserve aucune clé pour ce volume : avec la collecte activée, elles arrivent au prochain inventaire de l’agent.',
  'Chiave di ripristino BitLocker':
    'Clé de récupération BitLocker',
  'Chiave in CENSO':
    'Clé dans CENSO',
  'Chiavi custodite':
    'Clés conservées',
  'Cifrato %':
    'Chiffré %',
  'Cifratura in corso':
    'Chiffrement en cours',
  'Cifratura sospesa':
    'Chiffrement suspendu',
  'Con la raccolta spenta la rotazione dopo la lettura non parte: accendi anche la raccolta delle chiavi.':
    'Avec la collecte désactivée, la rotation après consultation ne démarre pas : activez aussi la collecte des clés.',
  'Controlla l’ID chiave sulla schermata di ripristino. Se la macchina è giusta ma la chiave manca, l’agente non l’ha ancora inviata: serve la raccolta accesa e un inventario dopo l’accensione.':
    'Vérifiez l’ID de clé sur l’écran de récupération. Si la machine est la bonne mais que la clé manque, l’agent ne l’a pas encore envoyée : il faut que la collecte soit activée et qu’un inventaire ait lieu après son activation.',
  'Copia non disponibile qui: seleziona il testo qui sotto e copialo a mano.':
    'Copie non disponible ici : sélectionnez le texte ci-dessous et copiez-le manuellement.',
  'C’è già una rotazione in corso su questo volume.':
    'Une rotation est déjà en cours sur ce volume.',
  'Decifratura in corso':
    'Déchiffrement en cours',
  'Decifratura sospesa':
    'Déchiffrement suspendu',
  'Due passi: l’agente aggiunge una nuova password di ripristino (e prova a copiarla in Active Directory o Entra ID), poi — quando CENSO l’ha custodita — toglie la vecchia. Si annullano le rotazioni in coda, in attesa della nuova chiave o non riuscite.':
    'Deux étapes : l’agent ajoute un nouveau mot de passe de récupération (et tente de le sauvegarder dans Active Directory ou Entra ID), puis — une fois que CENSO l’a conservé — supprime l’ancien. Les rotations en file d’attente, en attente de la nouvelle clé ou en échec peuvent être annulées.',
  'Filtro dei volumi':
    'Filtre des volumes',
  'Gli agenti Windows inviano anche le password di ripristino dei volumi. Viaggiano sigillate nella busta dell’agente e sono conservate cifrate con la chiave del tenant: mai sul CI, mai nelle e-mail. Le chiavi API del tenant non possono leggerle. Spenta, CENSO conosce solo lo stato dei volumi.':
    'Les agents Windows envoient aussi les mots de passe de récupération des volumes. Ils voyagent scellés dans l’enveloppe de l’agent et sont stockés chiffrés avec la clé du tenant : jamais sur le CI, jamais dans les e-mails. Les clés API du tenant ne peuvent pas les lire. Collecte désactivée, CENSO ne connaît que l’état des volumes.',
  'Hai la sola lettura del modulo BitLocker: puoi cercare le chiavi ma non mostrarle.':
    'Vous avez un accès en lecture seule au module BitLocker : vous pouvez rechercher les clés mais pas les afficher.',
  'I volumi arrivano con l’inventario dell’agente CENSO sulle macchine Windows. Le macchine Windows senza dati hanno un agente assente o più vecchio di questa versione.':
    'Les volumes arrivent avec l’inventaire de l’agent CENSO sur les machines Windows. Les machines Windows sans données n’ont pas d’agent ou un agent plus ancien que cette version.',
  'ID chiave':
    'ID de clé',
  'ID chiave (le prime 8 cifre mostrate nella schermata di ripristino BitLocker) o nome della macchina':
    'ID de clé (les 8 premiers chiffres affichés sur l’écran de récupération BitLocker) ou nom de la machine',
  'La chiave verrà sostituita dall’agente appena la macchina è in linea: prima aggiunge una nuova chiave di ripristino, poi — quando CENSO l’ha custodita — toglie questa.':
    'L’agent remplacera la clé dès que la machine sera en ligne : il ajoute d’abord une nouvelle clé de récupération, puis — une fois que CENSO l’a conservée — supprime celle-ci.',
  'La chiave è stata nascosta dopo 5 minuti. Per rivederla serve una nuova lettura, registrata come la prima.':
    'La clé a été masquée après 5 minutes. Pour la revoir, il faut une nouvelle consultation, enregistrée comme la première.',
  'La chiave è stata nascosta.':
    'La clé a été masquée.',
  'La cifratura BitLocker dei volumi Windows, letta dall’agente CENSO, e le chiavi di ripristino custodite cifrate. Ogni lettura di una chiave chiede un motivo, resta nel registro ed è notificata; dopo la lettura l’agente sostituisce la chiave.':
    'Le chiffrement BitLocker des volumes Windows, lu par l’agent CENSO, et les clés de récupération conservées chiffrées. Chaque consultation d’une clé demande un motif, reste dans le journal et fait l’objet d’une notification ; après la consultation, l’agent remplace la clé.',
  'La raccolta delle chiavi è spenta: CENSO conosce lo stato dei volumi ma non riceve nuove chiavi di ripristino. Un amministratore del tenant la accende in «Panoramica».':
    'La collecte des clés est désactivée : CENSO connaît l’état des volumes mais ne reçoit pas de nouvelles clés de récupération. Un administrateur du tenant l’active dans « Vue d’ensemble ».',
  'La rotazione dopo la lettura è spenta: la chiave resta quella di prima finché qualcuno non la sostituisce.':
    'La rotation après consultation est désactivée : la clé reste la même jusqu’à ce que quelqu’un la remplace.',
  'La schermata blu di ripristino mostra l’«ID chiave di ripristino» (in inglese «Recovery key ID»): bastano i primi caratteri. Si cerca anche per nome della macchina.':
    'L’écran bleu de récupération affiche l’« ID de clé de récupération » (en anglais « Recovery key ID ») : les premiers caractères suffisent. On peut aussi chercher par nom de machine.',
  'La sostituzione automatica non è partita.':
    'Le remplacement automatique n’a pas démarré.',
  'La sostituzione della chiave è già in corso: {stato}.':
    'Le remplacement de la clé est déjà en cours : {stato}.',
  'Le ultime 500 letture.':
    'Les 500 dernières consultations.',
  'Letto dall’agente':
    'Lu par l’agent',
  'Letture':
    'Consultations',
  'Letture negli ultimi 30 giorni':
    'Consultations des 30 derniers jours',
  'L’agente aggiunge una nuova password di ripristino e, appena CENSO l’ha custodita, toglie questa: la macchina non resta mai senza una chiave custodita.':
    'L’agent ajoute un nouveau mot de passe de récupération et, dès que CENSO l’a conservé, supprime celui-ci : la machine ne reste jamais sans clé conservée dans CENSO.',
  'Macchine con dati BitLocker':
    'Machines avec données BitLocker',
  'Mai modificate: raccolta spenta e rotazione dopo la lettura accesa, i valori predefiniti.':
    'Jamais modifiés : collecte désactivée et rotation après consultation activée, les valeurs par défaut.',
  'Metto in coda…':
    'Mise en file d’attente…',
  'Mostra la chiave':
    'Afficher la clé',
  'Motivo della lettura':
    'Motif de la consultation',
  'Motivo della rotazione':
    'Motif de la rotation',
  'Nessun volume BitLocker ricevuto':
    'Aucun volume BitLocker reçu',
  'Nessun volume per questo filtro.':
    'Aucun volume pour ce filtre.',
  'Nessuna chiave custodita per questo volume.':
    'Aucune clé conservée pour ce volume.',
  'Nessuna chiave trovata per «{q}»':
    'Aucune clé trouvée pour « {q} »',
  'Nessuna lettura':
    'Aucune consultation',
  'Nessuna rotazione':
    'Aucune rotation',
  'Nessuna voce nel registro della rotazione.':
    'Aucune entrée dans le journal des rotations.',
  'Non cifrato':
    'Non chiffré',
  'Ogni chiave mostrata dalla console compare qui: chi, quando, da dove e perché.':
    'Chaque clé affichée par la console apparaît ici : qui, quand, d’où et pourquoi.',
  'Ogni lettura di una chiave chiede un motivo, viene registrata (chi, quando, da dove e perché) e notificata per e-mail ai destinatari dell’evento «BitLocker» in Impostazioni. L’e-mail non contiene mai la chiave.':
    'Chaque consultation d’une clé demande un motif, est enregistrée (qui, quand, d’où et pourquoi) et notifiée par e-mail aux destinataires de l’événement « BitLocker » dans Paramètres. L’e-mail ne contient jamais la clé.',
  'Ogni lettura di una chiave di ripristino BitLocker: macchina, volume, chi l’ha letta, quando e perché. La chiave non è mai nella mail.':
    'Chaque consultation d’une clé de récupération BitLocker : machine, volume, qui l’a consultée, quand et pourquoi. La clé ne figure jamais dans l’e-mail.',
  'Password di ripristino':
    'Mot de passe de récupération',
  'Prima di leggere, controlla che l’ID chiave mostrato dalla schermata di ripristino BitLocker sia {id}. La lettura viene registrata (chi, quando, da dove e perché) e notificata per e-mail ai destinatari dell’evento BitLocker; di norma, dopo la lettura, l’agente sostituisce la chiave.':
    'Avant la consultation, vérifiez que l’ID de clé de récupération affiché par l’écran de récupération BitLocker est bien {id}. La consultation est enregistrée (qui, quand, d’où et pourquoi) et notifiée par e-mail aux destinataires de l’événement BitLocker ; en règle générale, après la consultation, l’agent remplace la clé.',
  'Protetti senza chiave in CENSO ({n})':
    'Protégés sans clé dans CENSO ({n})',
  'Protettori':
    'Protecteurs',
  'Questa chiave non è più segreta: chi l’ha vista o ascoltata può sbloccare il volume. Non scriverla nel ticket e non inviarla per e-mail.':
    'Cette clé n’est plus secrète : quiconque l’a vue ou entendue peut déverrouiller le volume. Ne l’écrivez pas dans le ticket et ne l’envoyez pas par e-mail.',
  'Questa chiave è già stata sostituita sul volume: non c’è niente da ruotare.':
    'Cette clé a déjà été remplacée sur le volume : il n’y a aucune rotation à effectuer.',
  'Raccogli le chiavi di ripristino':
    'Collecter les clés de récupération',
  'Raccolta delle chiavi':
    'Collecte des clés',
  'Richiesta da':
    'Demandée par',
  'Rimovibile':
    'Amovible',
  'Rotazione':
    'Rotation',
  'Rotazione della chiave {id} annullata.':
    'Rotation de la clé {id} annulée.',
  'Rotazione della chiave {id} messa in coda: l’agente la esegue appena la macchina è in linea.':
    'Rotation de la clé {id} mise en file d’attente : l’agent l’exécute dès que la machine est en ligne.',
  'Rotazione: {stato}.':
    'Rotation : {stato}.',
  'Rotazioni':
    'Rotations',
  'Rotazioni in corso':
    'Rotations en cours',
  'Ruota':
    'Rotation',
  'Ruota adesso':
    'Rotation immédiate',
  'Ruota la chiave di ripristino':
    'Rotation de la clé de récupération',
  'Ruota la chiave dopo ogni lettura':
    'Rotation de la clé après chaque consultation',
  'Scrivi almeno {n} caratteri.':
    'Saisissez au moins {n} caractères.',
  'Serve la raccolta delle chiavi accesa e l’agente CENSO sulla macchina; si ruotano i volumi con una lettera di unità.':
    'Nécessite la collecte des clés activée et l’agent CENSO sur la machine ; seuls les volumes dotés d’une lettre de lecteur font l’objet d’une rotation.',
  'Si nasconde da sola fra {tempo}':
    'Se masque automatiquement dans {tempo}',
  'Sistema operativo non protetto ({n})':
    'Système d’exploitation non protégé ({n})',
  'Solo un amministratore del tenant può cambiare queste impostazioni.':
    'Seul un administrateur du tenant peut modifier ces paramètres.',
  'Sono mostrate le prime 50: scrivi qualche carattere in più.':
    'Seules les 50 premières sont affichées : saisissez quelques caractères de plus.',
  'Trova la chiave di ripristino':
    'Trouver la clé de récupération',
  'Trova una chiave':
    'Trouver une clé',
  'Tutti ({n})':
    'Tous ({n})',
  'Ultima lettura':
    'Dernière consultation',
  'Ultima lettura: {quando}, {chi}':
    'Dernière consultation : {quando}, {chi}',
  'Ultima modifica: {quando}, da {chi}':
    'Dernière modification : {quando}, par {chi}',
  'Una chiave letta non è più segreta. L’agente aggiunge una nuova password di ripristino e, appena CENSO l’ha custodita, toglie la vecchia: la macchina non resta mai senza una chiave custodita. Senza la raccolta delle chiavi la rotazione non può funzionare, perché la nuova chiave non arriverebbe mai a CENSO.':
    'Une clé consultée n’est plus secrète. L’agent ajoute un nouveau mot de passe de récupération et, dès que CENSO l’a conservé, supprime l’ancien : la machine ne reste jamais sans clé conservée. Sans la collecte des clés, la rotation ne peut pas fonctionner, car la nouvelle clé n’arriverait jamais à CENSO.',
  'Una chiave letta non è più segreta: CENSO la fa ruotare dall’agente (si può spegnere), in due tempi — prima l’agente aggiunge una chiave nuova (e prova a copiarla in Active Directory o Entra ID), poi, quando la nuova è custodita in CENSO, toglie la vecchia: la macchina non resta mai senza una chiave di ripristino conservata. Serve l’agente aggiornato; le chiavi API del tenant non possono leggerle.':
    'Une clé consultée n’est plus secrète : CENSO en fait effectuer la rotation par l’agent (désactivable), en deux temps — l’agent ajoute d’abord une nouvelle clé (et tente de la copier dans Active Directory ou Entra ID), puis, lorsque la nouvelle est conservée dans CENSO, supprime l’ancienne : la machine ne reste jamais sans clé de récupération conservée. Nécessite un agent à jour ; les clés API du tenant ne peuvent pas les lire.',
  'Una rotazione parte dopo la lettura di una chiave (se l’impostazione è accesa) o con «Ruota» nella sezione Volumi.':
    'Une rotation démarre après la consultation d’une clé (si le paramètre est activé) ou avec « Rotation » dans la section Volumes.',
  'Volumi ({n})':
    'Volumes ({n})',
  'Volumi di sistema NON protetti':
    'Volumes système NON protégés',
  'Volumi di sistema protetti':
    'Volumes système protégés',
  'Volumi protetti senza chiave in CENSO':
    'Volumes protégés sans clé dans CENSO',
  'aggiunge la nuova chiave':
    'ajout de la nouvelle clé',
  'annullata':
    'annulée',
  'attende la nuova chiave':
    'en attente de la nouvelle clé',
  'chiave comunicata al telefono, rotazione periodica…':
    'clé communiquée par téléphone, rotation périodique…',
  'completata':
    'terminée',
  'copiata negli appunti':
    'copiée dans le presse-papiers',
  'in coda':
    'en file d’attente',
  'in esecuzione sull’agente':
    'en cours d’exécution sur l’agent',
  'la raccolta delle chiavi è spenta':
    'la collecte des clés est désactivée',
  'letture':
    'consultations',
  'lo stato BitLocker dei volumi delle macchine Windows con l’agente CENSO (protezione, cifratura, metodo, protettori) e, se un amministratore accende «Raccogli le chiavi di ripristino», le chiavi stesse: viaggiano nella busta cifrata dell’agente, sono conservate cifrate con la chiave del tenant e non stanno mai sulla scheda del CI né nelle mail. «Trova una chiave» cerca per l’ID chiave che la schermata di ripristino mostra (le prime 8 cifre) o per nome della macchina; «Mostra la chiave» chiede il motivo, e ogni lettura resta nel registro «Letture» con chi, quando, da dove e perché, e arriva per mail ai destinatari del tenant.':
    'l’état BitLocker des volumes des machines Windows dotées de l’agent CENSO (protection, chiffrement, méthode, protecteurs) et, si un administrateur active « Collecter les clés de récupération », les clés elles-mêmes : elles transitent dans l’enveloppe chiffrée de l’agent, sont conservées chiffrées avec la clé du tenant et ne figurent jamais sur la fiche du CI ni dans les e-mails. « Trouver une clé » recherche par l’ID de clé affiché par l’écran de récupération (les 8 premiers chiffres) ou par nom de machine ; « Afficher la clé » demande le motif, et chaque consultation reste dans le registre « Consultations » avec qui, quand, d’où et pourquoi, et est envoyée par e-mail aux destinataires du tenant.',
  'non messa in coda':
    'non mise en file d’attente',
  'non riuscita':
    'échouée',
  'passo: {passo}':
    'étape : {passo}',
  'richiesta da {chi}':
    'demandée par {chi}',
  'rotazioni':
    'rotations',
  'sostituita':
    'remplacée',
  'ticket 4711, utente bloccato alla schermata di ripristino':
    'ticket 4711, utilisateur bloqué sur l’écran de récupération',
  'toglie la vecchia chiave':
    'suppression de l’ancienne clé',
  'volumi':
    'volumes',
  'Apri Application Maintenance':
    'Ouvrir Application Maintenance',
  'Apri BitLocker':
    'Ouvrir BitLocker',
  'Apri Cifratura':
    'Ouvrir Chiffrement',
  'Apri Eagle':
    'Ouvrir Eagle',
  'Asset che sostengono funzioni critiche o importanti (dai Business Service) sotto il monitoraggio di CENSO Eagle.':
    'Actifs qui soutiennent des fonctions critiques ou importantes (d’après les Business Services) surveillés par CENSO Eagle.',
  'Certificati TLS letti dagli agenti CENSO sui servizi esposti e servizi che altre macchine chiamano in chiaro.':
    'Certificats TLS lus par les agents CENSO sur les services exposés, et services que d’autres machines appellent en clair.',
  'Chiedi l’inventario agli agenti':
    'Demander l’inventaire aux agents',
  'Chiedo…':
    'Demande…',
  'Cifratura dei dati in transito':
    'Chiffrement des données en transit',
  'Con l’agente CENSO, dati non ancora arrivati':
    'Avec l’agent CENSO, données pas encore reçues',
  'Inventario chiesto a {n} agenti: i dati arrivano entro qualche minuto dagli agenti già aggiornati.':
    'Inventaire demandé à {n} agents : les données arrivent en quelques minutes depuis les agents déjà mis à jour.',
  'Librerie delle applicazioni dalla distinta dei componenti (SBOM) confrontate con gli avvisi di vulnerabilità.':
    'Bibliothèques des applications issues de la nomenclature logicielle (SBOM) comparées aux avis de vulnérabilité.',
  'L’agente si aggiorna da solo e manda lo stato BitLocker (e, con la raccolta accesa, le chiavi) al prossimo inventario. Puoi chiederlo subito.':
    'L’agent se met à jour tout seul et envoie l’état BitLocker (et, avec la collecte activée, les clés) au prochain inventaire. Vous pouvez le demander tout de suite.',
  'Macchine Windows senza dettaglio BitLocker ({n})':
    'Machines Windows sans détail BitLocker ({n})',
  'Monitorato':
    'Surveillé',
  'Mostra gli asset':
    'Afficher les actifs',
  'Nessun certificato in questo elenco.':
    'Aucun certificat dans cette liste.',
  'Nessuna area chiede un intervento. Clicca un numero per vedere gli asset che lo compongono.':
    'Aucun domaine ne demande d’intervention. Cliquez sur un chiffre pour voir les actifs qui le composent.',
  'Nessuna informazione':
    'Aucune information',
  'Nome nel certificato':
    'Nom dans le certificat',
  'Né agente né scansione WinRM con credenziali: installa l’agente CENSO o aggiungi una credenziale Windows alla discovery.':
    'Ni agent ni scan WinRM avec identifiants : installez l’agent CENSO ou ajoutez un identifiant Windows à la découverte.',
  'Protezione BitLocker':
    'Protection BitLocker',
  'Senza agente, stato dalla scansione WinRM':
    'Sans agent, état issu du scan WinRM',
  'Sfruttate (KEV)':
    'Exploitées (KEV)',
  'Vedi le macchine non protette':
    'Voir les machines non protégées',
  'Volumi di sistema delle macchine Windows protetti da BitLocker: in dettaglio dove c’è l’agente CENSO, dalla scansione WinRM della sonda altrove.':
    'Volumes du système d’exploitation des machines Windows protégés par BitLocker : en détail là où l’agent CENSO est présent, d’après le scan WinRM de la sonde ailleurs.',
  'agente CENSO':
    'agent CENSO',
  'asset critici o importanti NON monitorati':
    'actifs critiques ou importants NON surveillés',
  'asset critici o importanti monitorati':
    'actifs critiques ou importants surveillés',
  'da sistemare':
    'à corriger',
  'in regola':
    'conforme',
  'macchine Windows senza informazioni':
    'machines Windows sans information',
  'macchine con il volume di sistema NON protetto':
    'machines dont le volume système n’est PAS protégé',
  'macchine con il volume di sistema protetto':
    'machines dont le volume système est protégé',
  'protetti senza chiave di ripristino in CENSO':
    'protégés sans clé de récupération dans CENSO',
  'scansione WinRM':
    'scan WinRM',
  '{n} aree su {tot} chiedono un intervento. Clicca un numero per vedere gli asset che lo compongono.':
    '{n} domaines sur {tot} demandent une intervention. Cliquez sur un chiffre pour voir les actifs qui le composent.',
  '{p} con BitLocker attivo, {n} senza. La scansione della sonda dice se un volume è protetto, non quali né le chiavi: per quelle serve l’agente.':
    '{p} avec BitLocker actif, {n} sans. Le scan de la sonde dit si un volume est protégé, pas lesquels ni les clés : pour cela il faut l’agent.',
  'La panoramica dice anche perché alcune macchine Windows non hanno dati: con l’agente che non li ha ancora mandati («Chiedi l’inventario agli agenti»), senza agente ma con lo stato BitLocker dalla scansione WinRM della sonda, o senza informazioni.':
    'La vue d’ensemble dit aussi pourquoi certaines machines Windows n’ont pas de données : avec l’agent qui ne les a pas encore envoyées (« Demander l’inventaire aux agents »), sans agent mais avec l’état BitLocker issu du scan WinRM de la sonde, ou sans information.',
  'Nella sezione «Evidenze» ogni area (cifratura in transito, dati a riposo, componenti di terze parti, monitoraggio) ha l’articolo e lo stato, e ogni numero si apre sull’elenco degli asset che lo compongono, con il collegamento alla pagina dove si interviene.':
    'Dans la section « Preuves », chaque domaine (chiffrement en transit, données au repos, composants tiers, supervision) a son article et son état, et chaque chiffre ouvre la liste des actifs qui le composent, avec le lien vers la page où intervenir.',
  'A ogni passata (ogni 15 minuti) si chiede il record PTR degli indirizzi con la risposta scaduta, al più 500, i visti più di recente per primi.':
    'À chaque passage (toutes les 15 minutes), on demande l’enregistrement PTR des adresses dont la réponse a expiré, 500 au maximum, les plus récemment vues en premier.',
  'Accendi “Consenti la scrittura” nella credenziale phpIPAM':
    'Activez «Autoriser l’écriture» dans l’identifiant phpIPAM',
  'Aggiunge l’indirizzo in phpIPAM, nella subnet che lo contiene, con il nome DNS e la descrizione':
    'Ajoute l’adresse dans phpIPAM, dans le sous-réseau qui la contient, avec le nom DNS et la description',
  'Apri nell’inventario indirizzi: scrivi cos’è':
    'Ouvrir dans l’inventaire des adresses : écrire ce que c’est',
  'Chiede di nuovo il nome DNS inverso, senza aspettare la scadenza della cache':
    'Redemande le nom DNS inverse, sans attendre l’expiration du cache',
  'Con un nome DNS':
    'Avec un nom DNS',
  'Cos’è':
    'Ce que c’est',
  'Cos’è {indirizzo}':
    'Qu’est-ce que {indirizzo}',
  'Cos’è: Office 365, VPN del fornitore X, stampante del reparto…':
    'Ce que c’est : Office 365, VPN du fournisseur X, imprimante du service…',
  'Descritti da una persona':
    'Décrites par une personne',
  'Documenta su IPAM':
    'Documenter dans l’IPAM',
  'Documentato in phpIPAM nella subnet {subnet}.':
    'Documentée dans phpIPAM dans le sous-réseau {subnet}.',
  'Documentato in phpIPAM.':
    'Documentée dans phpIPAM.',
  'Errori di risoluzione':
    'Erreurs de résolution',
  'Gli indirizzi visti nel traffico che non sono CI: quelli interni che nessuno ha inventariato e i servizi internet con cui parla la rete, con il loro nome DNS e, scritto da chi li conosce, che cosa sono.':
    'Les adresses vues dans le trafic qui ne sont pas des CI : les internes que personne n’a inventoriées et les services internet avec lesquels le réseau communique, avec leur nom DNS et, écrit par qui les connaît, ce qu’elles sont.',
  'Hai la sola lettura dell’inventario indirizzi: le impostazioni non si possono cambiare.':
    'Vous avez un accès en lecture seule à l’inventaire des adresses : les paramètres ne peuvent pas être modifiés.',
  'I nomi DNS li risolve una sonda con il DNS interno (o il server indicato nelle impostazioni della pagina), gli IP pubblici anche il Control Plane; ogni risposta resta in cache per il TTL che il DNS ha dato, fra 15 minuti e 7 giorni. «Documenta su IPAM» scrive l’indirizzo in phpIPAM con il nome e la descrizione, senza bisogno di un CI.':
    'Les noms DNS sont résolus par une sonde avec le DNS interne (ou le serveur indiqué dans les paramètres de la page), les IP publiques aussi par le Control Plane ; chaque réponse reste en cache pendant le TTL donné par le DNS, entre 15 minutes et 7 jours. «Documenter dans l’IPAM» écrit l’adresse dans phpIPAM avec le nom et la description, sans avoir besoin d’un CI.',
  'I nomi restano in cache per il TTL della risposta DNS (fra 15 minuti e 7 giorni). I nomi interni li chiede una sonda, perché solo lei raggiunge il DNS della rete; per gli indirizzi pubblici, se nessuna sonda risponde, li chiede il Control Plane. Cache e impostazioni sono di questo tenant.':
    'Les noms restent en cache pendant le TTL de la réponse DNS (entre 15 minutes et 7 jours). Les noms internes sont demandés par une sonde, car elle seule atteint le DNS du réseau ; pour les adresses publiques, si aucune sonde ne répond, c’est le Control Plane qui les demande. Le cache et les paramètres sont propres à ce tenant.',
  'I servizi internet con cui parla la rete. Spenta, si chiedono solo i nomi degli indirizzi interni.':
    'Les services internet avec lesquels le réseau communique. Désactivée, seuls les noms des adresses internes sont demandés.',
  'Il tuo ruolo non può scrivere nel modulo IPAM':
    'Votre rôle ne peut pas écrire dans le module IPAM',
  'Indirizzo IP, anche con la porta (10.0.0.53:5353).':
    'Adresse IP, éventuellement avec le port (10.0.0.53:5353).',
  'Interni':
    'Internes',
  'Inventario indirizzi':
    'Inventaire des adresses',
  'Le righe nascono dai flussi (NetFlow, IPFIX, sFlow o la cattura della sonda), ogni 15 minuti: ogni indirizzo delle conversazioni dell’ultimo giorno che non è un CI. Con il filtro del traffico «Entrambi interni» gli indirizzi di internet non vengono tenuti.':
    'Les lignes proviennent des flux (NetFlow, IPFIX, sFlow ou la capture de la sonde), toutes les 15 minutes : chaque adresse des conversations du dernier jour qui n’est pas un CI. Avec le filtre de trafic «Les deux internes», les adresses internet ne sont pas conservées.',
  'Legge subito i flussi, collega gli indirizzi diventati CI e chiede i nomi DNS scaduti, senza aspettare la passata dei 15 minuti':
    'Lit les flux tout de suite, relie les adresses devenues des CI et demande les noms DNS expirés, sans attendre le passage des 15 minutes',
  'Mostro solo: {filtro} ({n}).':
    'Affichage limité à : {filtro} ({n}).',
  'Multicast, broadcast e indirizzi riservati non hanno un nome DNS.':
    'Les adresses multicast, broadcast et réservées n’ont pas de nom DNS.',
  'Nessun indirizzo ancora':
    'Aucune adresse pour l’instant',
  'Nessun indirizzo per i filtri impostati.':
    'Aucune adresse pour les filtres définis.',
  'Nessuna sonda in linea: i nomi interni restano da risolvere.':
    'Aucune sonde en ligne : les noms internes restent à résoudre.',
  'Nessuno l’ha ancora descritto.':
    'Personne ne l’a encore décrite.',
  'Nome DNS inverso (PTR)':
    'Nom DNS inverse (PTR)',
  'Nomi DNS chiesti per {n} indirizzi.':
    'Noms DNS demandés pour {n} adresses.',
  'Nomi DNS chiesti per {n} indirizzi: {esito}.':
    'Noms DNS demandés pour {n} adresses : {esito}.',
  'Non documentato: {motivo}':
    'Non documentée : {motivo}',
  'Ora sono CI':
    'Désormais des CI',
  'Passata completata: niente di nuovo, i nomi in cache sono ancora validi.':
    'Passage terminé : rien de nouveau, les noms en cache sont encore valides.',
  'Passata completata: {esito}.':
    'Passage terminé : {esito}.',
  'Prima vista':
    'Première vue',
  'Pubblici':
    'Publiques',
  'Risoluzione accesa, anche per gli indirizzi pubblici':
    'Résolution activée, y compris pour les adresses publiques',
  'Risoluzione accesa, solo per gli indirizzi interni':
    'Résolution activée, uniquement pour les adresses internes',
  'Risoluzione dei nomi DNS':
    'Résolution des noms DNS',
  'Risoluzione spenta: i nomi DNS non vengono chiesti.':
    'Résolution désactivée : les noms DNS ne sont pas demandés.',
  'Risolvi i nomi DNS inversi':
    'Résoudre les noms DNS inverses',
  'Risolvi i selezionati':
    'Résoudre la sélection',
  'Risolvo…':
    'Résolution…',
  'Si risolvono i primi {max}.':
    'Les {max} premières sont résolues.',
  'Si vede accanto all’indirizzo nelle viste del traffico: chi lo incontra dopo non deve scoprirlo di nuovo.':
    'Affiché à côté de l’adresse dans les vues du trafic : qui la croise ensuite n’a pas à le redécouvrir.',
  'Sonda che chiede i nomi':
    'Sonde qui demande les noms',
  'TTL non indicato dal DNS':
    'TTL non indiqué par le DNS',
  'TTL {durata}':
    'TTL {durata}',
  'Ultima modifica di {chi}.':
    'Dernière modification par {chi}.',
  'Ultima richiesta non riuscita: {motivo}':
    'Dernière requête en échec : {motivo}',
  'anche per gli indirizzi pubblici':
    'aussi pour les adresses publiques',
  'che ora sono CI':
    'qui sont désormais des CI',
  'chi lo conosce: una persona, un reparto, un fornitore':
    'qui la connaît : une personne, un service, un fournisseur',
  'chiesto il {data}':
    'demandé le {data}',
  'con un errore di risoluzione':
    'avec une erreur de résolution',
  'con un nome DNS':
    'avec un nom DNS',
  'da risolvere':
    'à résoudre',
  'descritti da una persona':
    'décrites par une personne',
  'dispositivo':
    'équipement',
  'fonte: Control Plane':
    'source : Control Plane',
  'fonte: sonda':
    'source : sonde',
  'fornitore':
    'fournisseur',
  'il resolver della sonda':
    'le résolveur de la sonde',
  'indirizzi interni':
    'adresses internes',
  'indirizzi pubblici':
    'adresses publiques',
  'la più recente in linea':
    'la plus récente en ligne',
  'nessun record PTR':
    'aucun enregistrement PTR',
  'non inventariato':
    'non inventorié',
  'non risolto':
    'non résolu',
  'nuovo tentativo dopo il {data}':
    'nouvelle tentative après le {data}',
  'ogni indirizzo che compare nel traffico e non è un CI: gli interni che nessuno ha inventariato e i servizi su Internet con cui la rete parla, con prima e ultima volta visto, le porte e il nome DNS inverso. Scrivi cos’è, la categoria e il responsabile: compaiono accanto all’indirizzo nelle viste del traffico, e «Non inventariato» porta qui.':
    'chaque adresse qui apparaît dans le trafic et n’est pas un CI : les internes que personne n’a inventoriées et les services sur Internet avec lesquels le réseau communique, avec la première et la dernière observation, les ports et le nom DNS inverse. Indiquez ce que c’est, la catégorie et le responsable : ils apparaissent à côté de l’adresse dans les vues du trafic, et «Non inventorié» mène ici.',
  'phpIPAM non ha detto perché':
    'phpIPAM n’a pas dit pourquoi',
  'pubblico':
    'publique',
  'rete':
    'réseau',
  'server DNS: {server}':
    'serveur DNS : {server}',
  'servizio esterno':
    'service externe',
  'sonda non più presente':
    'sonde qui n’existe plus',
  'sonda: {nome}':
    'sonde : {nome}',
  'sospetto':
    'suspect',
  'speciale':
    'spéciale',
  'valido fino al {data}':
    'valide jusqu’au {data}',
  'vuoto: il resolver della sonda':
    'vide : le résolveur de la sonde',
  '{n} indirizzi nuovi':
    '{n} nouvelles adresses',
  '{n} indirizzi selezionati':
    '{n} adresses sélectionnées',
  '{n} nomi DNS trovati':
    '{n} noms DNS trouvés',
  '{n} non risolti':
    '{n} non résolus',
  '{n} ora sono CI':
    '{n} sont désormais des CI',
  '{n} senza record PTR':
    '{n} sans enregistrement PTR',
  '{n} tolti perché non visti da 90 giorni':
    '{n} retirées car non vues depuis 90 jours',
  'Risolvi il nome DNS':
    'Résoudre le nom DNS',
  'Ultima modifica di {chi} il {quando}.':
    'Dernière modification par {chi} le {quando}.',
  'Nessun destinatario: la regola non ha indirizzi e i destinatari generali sono vuoti.':
    'Aucun destinataire : la règle n’a pas d’adresses et les destinataires généraux sont vides.',
  'Invio non riuscito: controlla la posta in uscita in Impostazioni.':
    'Envoi en échec : vérifiez le courrier sortant dans Paramètres.',
  'Alcuni destinatari non hanno ricevuto l’avviso.':
    'Certains destinataires n’ont pas reçu l’alerte.',
  'Il registro dei certificati non si è potuto leggere.':
    'Le registre des certificats n’a pas pu être lu.',
  'quando ne compare uno (al primo controllo anche quelli già presenti)':
    'quand il en apparaît un (au premier contrôle, aussi ceux déjà présents)',
  'quando ne compare uno nuovo':
    'quand il en apparaît un nouveau',
  '{giorni} giorni prima':
    '{giorni} jours avant',
  'da scaduto, ogni {n} giorni':
    'après expiration, tous les {n} jours',
  'da scaduto, una volta':
    'après expiration, une fois',
  'raggiungibili da altre macchine':
    'accessibles depuis d’autres machines',
  'anche quelli solo in locale':
    'aussi ceux en local uniquement',
  'che contengono {parole}':
    'qui contiennent {parole}',
  'dei servizi {servizi}':
    'des services {servizi}',
  'criticità almeno {c}':
    'criticité au moins {c}',
  'i destinatari generali':
    'les destinataires généraux',
  '{n} giorni prima':
    '{n} jours avant',
  'Scadenze dei certificati':
    'Échéances des certificats',
  'Eliminare la regola «{nome}»? Lo storico dei suoi avvisi si perde con lei.':
    'Supprimer la règle « {nome} » ? L’historique de ses alertes disparaît avec elle.',
  'Nessuna regola: nessuno viene avvisato quando un certificato sta per scadere.':
    'Aucune règle : personne n’est alerté quand un certificat est bientôt à échéance.',
  'Autofirmati':
    'Auto-signés',
  'Quando avvisa':
    'Quand elle alerte',
  'Quali certificati':
    'Quels certificats',
  'Chi li riceve':
    'Qui les reçoit',
  'Ultimo avviso':
    'Dernière alerte',
  'Spegni':
    'Désactiver',
  'Accendi':
    'Activer',
  'Le regole guardano il registro una volta l’ora. Ogni soglia parte una volta sola per certificato (la più vicina, se ne sono passate più d’una insieme) e un certificato rinnovato ricomincia da capo. Ogni destinatario riceve una sola mail con tutti i suoi certificati di quel giro.':
    'Les règles consultent le registre une fois par heure. Chaque seuil se déclenche une seule fois par certificat (le plus proche, si plusieurs ont été franchis en même temps) et un certificat renouvelé repart de zéro. Chaque destinataire reçoit un seul e-mail avec tous ses certificats de ce passage.',
  'Nuova regola: scadenze':
    'Nouvelle règle : échéances',
  'Nuova regola: autofirmati':
    'Nouvelle règle : auto-signés',
  'Avvisi inviati':
    'Alertes envoyées',
  'Chi l’ha ricevuto':
    'Qui l’a reçu',
  'Nessun avviso inviato finora.':
    'Aucune alerte envoyée jusqu’ici.',
  'Prova mandata a {email} con {n} certificati.':
    'Test envoyé à {email} avec {n} certificats.',
  'Avvisa per':
    'Alerter pour',
  'Giorni prima della scadenza':
    'Jours avant l’échéance',
  'Altro numero di giorni':
    'Autre nombre de jours',
  'Una mail a ogni soglia. Se il certificato è già oltre più soglie quando la regola nasce, parte una mail sola, per la più vicina.':
    'Un e-mail par seuil. Si le certificat a déjà dépassé plusieurs seuils quand la règle naît, un seul e-mail est envoyé, pour le plus proche.',
  'Avvisa anche quando è scaduto ed è ancora installato':
    'Alerter aussi quand il est expiré et encore installé',
  'Un certificato scaduto che nessuno sostituisce: il caso peggiore.':
    'Un certificat expiré que personne ne remplace : le pire des cas.',
  'Ripeti l’avviso da scaduto ogni (giorni)':
    'Répéter l’alerte après expiration tous les (jours)',
  '0 = una volta sola.':
    '0 = une seule fois.',
  'Al primo controllo manda anche quelli già presenti, in un riepilogo':
    'Au premier contrôle, envoyer aussi ceux déjà présents, dans un récapitulatif',
  'Vale solo alla nascita della regola.':
    'Vaut seulement à la création de la règle.',
  'Spenta: si avvisa solo per quelli che compaiono da adesso; gli attuali sono nella scheda «Certificati autofirmati».':
    'Désactivée : les alertes ne sont envoyées que pour ceux qui apparaissent à partir de maintenant ; les actuels sont dans l’onglet «Certificats auto-signés».',
  'Solo quelli raggiungibili da altre macchine':
    'Seulement ceux accessibles depuis d’autres machines',
  'Lascia fuori i servizi in ascolto solo sulla macchina stessa (127.0.0.1).':
    'Exclut les services en écoute uniquement sur la machine elle-même (127.0.0.1).',
  'Nome, SAN, emittente o CI contengono':
    'Nom, SAN, émetteur ou CI contiennent',
  'vuoto: tutti':
    'vide : tous',
  'Più parole separate da virgola: basta una (ospedale.it, pacs).':
    'Plusieurs mots séparés par une virgule : un seul suffit (ospedale.it, pacs).',
  'Criticità del servizio almeno':
    'Criticité du service au moins',
  'qualsiasi':
    'indifférente',
  'Solo i certificati di questi business service':
    'Seulement les certificats de ces business services',
  'Nessuno scelto: tutti.':
    'Aucun choisi : tous.',
  'Chi le riceve':
    'Qui les reçoit',
  'Indirizzi email':
    'Adresses e-mail',
  'Togli {email}':
    'Retirer {email}',
  'Utenti del tenant o qualunque indirizzo (una lista di gruppo, il fornitore che gestisce il servizio).':
    'Utilisateurs du tenant ou n’importe quelle adresse (une liste de diffusion, le fournisseur qui gère le service).',
  'Anche i destinatari generali delle notifiche':
    'Également les destinataires généraux des notifications',
  'Nessuno impostato: si impostano in Impostazioni → Posta in uscita.':
    'Aucun défini : ils se définissent dans Paramètres → Courrier sortant.',
  'Nessun business service ha come responsabile un indirizzo email: si imposta nella scheda del servizio.':
    'Aucun business service n’a d’adresse e-mail comme responsable : cela se définit dans la fiche du service.',
  'Crea la regola':
    'Créer la règle',
  'Il tuo profilo non ha un indirizzo email':
    'Votre profil n’a pas d’adresse e-mail',
  'Manda una prova a me':
    'M’envoyer un test',
  'Hai la sola lettura della Cifratura: le regole non si possono cambiare.':
    'Vous avez un accès en lecture seule au Chiffrement : les règles ne peuvent pas être modifiées.',
  'Creata da {chi}; ultima modifica di {modifica}.':
    'Créée par {chi} ; dernière modification par {modifica}.',
  'Anteprima: {errore}':
    'Aperçu : {errore}',
  'Al prossimo controllo':
    'Au prochain contrôle',
  '{n} autofirmati già presenti vengono annotati senza mandare niente; da lì in poi si avvisa per i nuovi.':
    '{n} auto-signés déjà présents sont enregistrés sans rien envoyer ; les alertes sont envoyées pour les nouveaux à partir de là.',
  'Niente da mandare adesso: la regola copre {n} certificati del registro e nessuno ha passato una soglia.':
    'Rien à envoyer pour l’instant : la règle couvre {n} certificats du registre et aucun n’a franchi de seuil.',
  'Partirebbero {n} certificati, a {m} destinatari.':
    '{n} certificats partiraient, à {m} destinataires.',
  'Riceverebbero: {elenco}':
    'Recevraient : {elenco}',
  'Nessuno riceverebbe questi avvisi: aggiungi un destinatario.':
    'Personne ne recevrait ces alertes : ajoutez un destinataire.',
  'Nessun avviso inviato per questo certificato.':
    'Aucune alerte envoyée pour ce certificat.',
  'Imposta le notifiche':
    'Configurer les notifications',
  'La scheda «Notifiche» decide chi viene avvisato e quando: ogni regola sceglie i giorni prima della scadenza (60, 30, 14, 7, 1… e da scaduto, anche ripetuto) oppure i nuovi autofirmati, quali certificati (solo quelli raggiungibili da altre macchine, parole nel nome o nell’emittente, business service, criticità) e chi li riceve: indirizzi scritti a mano o scelti fra gli utenti, i destinatari generali del tenant, il responsabile di ogni business service per i soli suoi certificati. L’anteprima dice cosa partirebbe al prossimo controllo e a chi, «Manda una prova a me» mostra la mail senza registrarla, e il «Log notifiche» — come «Avvisi inviati» nel dettaglio di ogni certificato — dice chi è stato avvisato e quando. Le mail hanno la veste di quelle di Eagle, nella lingua scelta.':
    'L’onglet «Notifications» décide qui est alerté et quand : chaque règle choisit les jours avant l’échéance (60, 30, 14, 7, 1… et après expiration, même répété) ou les nouveaux auto-signés, quels certificats (seulement ceux accessibles depuis d’autres machines, des mots dans le nom ou dans l’émetteur, business service, criticité) et qui les reçoit : des adresses saisies à la main ou choisies parmi les utilisateurs, les destinataires généraux du tenant, le responsable de chaque business service pour ses seuls certificats. L’aperçu indique ce qui partirait au prochain contrôle et à qui, «M’envoyer un test» affiche l’e-mail sans l’enregistrer, et le «Journal des notifications» — comme «Alertes envoyées» dans le détail de chaque certificat — indique qui a été alerté et quand. Les e-mails ont la même apparence que ceux d’Eagle, dans la langue choisie.',
  'e del repository non usati ({tipi})':
    'et ceux du référentiel non utilisés ({tipi})',
  'i responsabili':
    'les responsables',
  'non usato · repository':
    'non utilisé · référentiel',
  'Anche i certificati del repository che nessuna macchina usa':
    'Aussi les certificats du référentiel qu’aucune machine n’utilise',
  'I certificati di Gestione certificati che nessuna macchina espone: nella mail sono segnati «non usato». Quelli già sostituiti da uno più recente con lo stesso nome non si segnalano; computer e utenti si rinnovano da soli con l’autoenrollment e sono spenti di default. Nessun tipo scelto: il repository resta fuori.':
    'Les certificats de la Gestion des certificats qu’aucune machine n’expose : le message les marque «non utilisé». Ceux déjà remplacés par un plus récent portant le même nom ne sont pas signalés ; les certificats d’ordinateur et d’utilisateur se renouvellent seuls par l’inscription automatique et sont désactivés par défaut. Aucun type choisi : le référentiel reste en dehors.',
  'Anche i responsabili, ciascuno solo per i suoi certificati':
    'Aussi les responsables, chacun seulement pour ses propres certificats',
  'Il responsabile del business service e, per i certificati del repository, quello scritto sul certificato, quando è un indirizzo email.':
    'Le responsable du business service et, pour les certificats du référentiel, celui indiqué sur le certificat, lorsqu’il s’agit d’une adresse e-mail.',
  'Servizi con un indirizzo email come responsabile: {elenco}':
    'Services dont le responsable est une adresse e-mail : {elenco}',
  'non usato':
    'non utilisé',
  'Le regole sulle scadenze guardano anche i certificati del repository di Gestione certificati che nessuna macchina espone: nella mail sono segnati «non usato» e li riceve anche il responsabile scritto sul certificato; quelli già sostituiti da uno più recente con lo stesso nome non si segnalano.':
    'Les règles d’échéance surveillent aussi les certificats du référentiel de la Gestion des certificats qu’aucune machine n’expose : le message les marque «non utilisé» et le responsable indiqué sur le certificat les reçoit aussi ; ceux déjà remplacés par un plus récent portant le même nom ne sont pas signalés.',
  'avvisi inviati':
    'alertes envoyées',
  'Regole attive':
    'Règles actives',
  'Regole con un problema':
    'Règles avec un problème',
  'Certificati segnalati negli ultimi 30 giorni':
    'Certificats signalés ces 30 derniers jours',
  'Log notifiche':
    'Journal des notifications',
  'Regole di notifica':
    'Règles de notification',
  'Crea una regola sulle scadenze o sugli autofirmati e scegli chi riceve gli avvisi.':
    'Créez une règle sur les échéances ou sur les auto-signés et choisissez qui reçoit les alertes.',
  'Ogni certificato di cui una regola ha avvisato qualcuno: quando, perché e chi ha ricevuto la mail. Gli avvisi non consegnati a nessuno non compaiono: la regola li riprova al giro dopo.':
    'Chaque certificat pour lequel une règle a alerté quelqu’un : quand, pourquoi et qui a reçu le message. Les alertes remises à personne n’apparaissent pas : la règle les retente au tour suivant.',
  'Chi viene avvisato prima che scadano si decide nella scheda «Notifiche».':
    'Qui est alerté avant leur échéance se décide dans l’onglet «Notifications».',
  'Chi viene avvisato quando ne compare uno nuovo si decide nella scheda «Notifiche».':
    'Qui est alerté quand un nouveau apparaît se décide dans l’onglet «Notifications».',
  'Scarica CycloneDX di tutto il CI':
    'Télécharger le CycloneDX de tout le CI',
  ', rallentato {m} volte dal sistema':
    ', ralenti {m} fois par le système',
  '2000':
    '2000',
  'A) Il token di lettura':
    'A) Le jeton de lecture',
  'A) L’utente e il token':
    'A) L’utilisateur et le jeton',
  "Accesa, CENSO può — sempre dopo un piano che mostra che cosa farà e con la conferma di un operatore — avviare, riprovare e annullare pipeline; aprire merge request che aggiungono alla pipeline il job che produce l'SBOM o il cancello di sicurezza, o la configurazione di Renovate; avviare il runner di Renovate su un progetto; scrivere le variabili CI del cancello. Non scrive mai sul ramo principale: ogni modifica arriva in una merge request da un ramo «censo/…», da approvare in GitLab.":
    'Activée, CENSO peut — toujours après un plan qui montre ce qu’il va faire et avec la confirmation d’un opérateur — démarrer, relancer et annuler des pipelines ; ouvrir des merge request qui ajoutent à la pipeline le job qui produit le SBOM ou la barrière de sécurité, ou la configuration de Renovate ; lancer le runner de Renovate sur un projet ; écrire les variables CI de la barrière. Il n’écrit jamais sur la branche principale : chaque modification arrive dans une merge request depuis une branche «censo/…», à approuver dans GitLab.',
  'Access token':
    'Jeton d’accès',
  'Aggiornamento in corso…':
    'Mise à jour en cours…',
  'Aggiungi una connessione':
    'Ajouter une connexion',
  'Apri in GitLab':
    'Ouvrir dans GitLab',
  'Apri nel tab di {fonte}':
    'Ouvrir dans l’onglet de {fonte}',
  'Artefatti':
    'Artefacts',
  'Artefatti nei registri':
    'Artefacts dans les registres',
  'Artefatti pubblicati':
    'Artefacts publiés',
  'Artefatti pubblicati e dove girano':
    'Artefacts publiés et où ils tournent',
  'Artefatto':
    'Artefact',
  'Artifactory':
    'Artifactory',
  'Auto DevOps è attivo.':
    'Auto DevOps est activé.',
  'Avviata da':
    'Démarrée par',
  'Avviso e componente':
    'Avis et composant',
  'B) Il tetto della Community Edition':
    'B) Le plafond de la Community Edition',
  'B) Il token di scrittura, solo se serve':
    'B) Le jeton d’écriture, seulement si nécessaire',
  'B) Quanto legge':
    'B) Le volume de lecture',
  'C) Da dove si parla':
    'C) D’où on interroge',
  'CENSO interroga i repository uno alla volta con AQL e una query per volta (Artifactory ne ammette poche in parallelo), ogni due ore.':
    'CENSO interroge les dépôts un par un avec AQL, une requête à la fois (Artifactory n’en admet que quelques-unes en parallèle), toutes les deux heures.',
  'CENSO legge progetti, pipeline e l’SBOM che le pipeline producono con un token di sola lettura. Le scritture (merge request, pipeline, variabili CI) usano un secondo token e solo se accendi «Consenti la scrittura».':
    'CENSO lit les projets, les pipelines et le SBOM que les pipelines produisent avec un jeton en lecture seule. Les écritures (merge request, pipeline, variables CI) utilisent un second jeton, et seulement si vous activez «Autoriser l’écriture».',
  'CENSO legge, in sola lettura, gli artefatti dei repository local, le immagini Docker con il loro digest e gli SBOM CycloneDX pubblicati accanto agli artefatti; se c’è Xray, anche i suoi risultati.':
    'CENSO lit, en lecture seule, les artefacts des dépôts locaux, les images Docker avec leur digest, et les SBOM CycloneDX publiés à côté des artefacts ; si Xray est présent, aussi ses résultats.',
  'CENSO legge, in sola lettura, i componenti dei repository hosted (quello che pubblicate), con i checksum, i digest delle immagini Docker e gli SBOM CycloneDX pubblicati accanto ai componenti.':
    'CENSO lit, en lecture seule, les composants des dépôts hébergés (ce que vous publiez), avec les checksums, les digests des images Docker et les SBOM CycloneDX publiés à côté des composants.',
  'CENSO non scrive mai sul ramo principale: ogni modifica arriva in una merge request da approvare. Ricorda però che un ramo nuovo fa partire la sua pipeline sui vostri runner.':
    'CENSO n’écrit jamais sur la branche principale : chaque modification arrive dans une merge request à approuver. Rappelez-vous toutefois qu’une nouvelle branche démarre sa pipeline sur vos runners.',
  'CENSO resta sotto il numero scritto in «Richieste al giorno» (2000 se vuoto) e legge i repository ogni sei ore.':
    'CENSO reste sous le nombre indiqué dans «Requêtes par jour» (2000 si vide) et lit les dépôts toutes les six heures.',
  'CVSS':
    'CVSS',
  'Chiavi dei repository local separate da virgola. Vuoto: tutti i repository local leggibili.':
    'Clés des dépôts locaux séparées par une virgule. Vide : tous les dépôts locaux lisibles.',
  'Codice del token':
    'Code du jeton',
  'Collega GitLab, Artifactory o Nexus dalla scheda «Connessioni»: CENSO legge in sottofondo progetti, pipeline e artefatti, e l’SBOM che le pipeline producono.':
    'Connectez GitLab, Artifactory ou Nexus depuis l’onglet «Connexions» : CENSO lit en arrière-plan les projets, les pipelines et les artefacts, et le SBOM que les pipelines produisent.',
  'Come preparo GitLab per CENSO?':
    'Comment préparer GitLab pour CENSO ?',
  'Come preparo JFrog Artifactory per CENSO?':
    'Comment préparer JFrog Artifactory pour CENSO ?',
  'Come preparo Sonatype Nexus Repository per CENSO?':
    'Comment préparer Sonatype Nexus Repository pour CENSO ?',
  'Commit e merge request portano «Requested-by: <utente> via CENSO»: in GitLab si vede chi l’ha chiesto.':
    'Les commits et les merge request portent «Requested-by: <utilisateur> via CENSO» : dans GitLab, on voit qui l’a demandé.',
  'Community/OSS: un utente dedicato con i privilegi nx-repository-view-*-*-browse e nx-repository-view-*-*-read sui repository da leggere.':
    'Community/OSS : un utilisateur dédié avec les privilèges nx-repository-view-*-*-browse et nx-repository-view-*-*-read sur les dépôts à lire.',
  'Componenti nell’SBOM':
    'Composants dans le SBOM',
  'Componenti non valutati':
    'Composants non évalués',
  'Con SBOM':
    'Avec SBOM',
  'Con SBOM dalla pipeline':
    'Avec SBOM depuis la pipeline',
  'Con librerie sfruttate attivamente':
    'Avec des bibliothèques activement exploitées',
  'Con librerie vulnerabili':
    'Avec des bibliothèques vulnérables',
  'Con l’edizione Pro usa un «User token» invece della password: si revoca da solo.':
    'Avec l’édition Pro, utilisez un «Jeton utilisateur» au lieu du mot de passe : il se révoque lui-même.',
  'Configurazione in':
    'Configuration dans',
  'Connessioni e giri in sottofondo':
    'Connexions et passages en arrière-plan',
  'Container in esecuzione':
    'Conteneurs en cours d’exécution',
  'Così come le riporta ciascuna fonte, senza ricalcoli.':
    'Telles que chaque source les rapporte, sans recalcul.',
  'Crea un ruolo con i privilegi «nx-repository-view-*-*-browse» e «nx-repository-view-*-*-read» (oppure gli stessi limitati ai repository da leggere) e assegnalo a un utente dedicato.':
    'Créez un rôle avec les privilèges «nx-repository-view-*-*-browse» et «nx-repository-view-*-*-read» (ou les mêmes limités aux dépôts à lire) et attribuez-le à un utilisateur dédié.',
  'Crea un token di gruppo (Impostazioni del gruppo → Token di accesso) con ruolo «Reporter» e scope «read_api» sui gruppi da leggere. Su GitLab.com i token di gruppo e di progetto richiedono Premium o Ultimate: altrimenti crea un utente bot dedicato, aggiungilo ai gruppi come Reporter e usa un suo token personale con lo stesso scope.':
    'Créez un jeton de groupe (Paramètres du groupe → Jetons d’accès) avec le rôle «Reporter» et le scope «read_api» sur les groupes à lire. Sur GitLab.com, les jetons de groupe et de projet demandent Premium ou Ultimate : sinon, créez un utilisateur bot dédié, ajoutez-le aux groupes comme Reporter et utilisez son jeton personnel avec le même scope.',
  'Crea un utente dedicato (o un gruppo) con permesso «Read» sui repository local da leggere; per collegare gli artefatti alle pipeline aggiungi «Read» sui build.':
    'Créez un utilisateur dédié (ou un groupe) avec la permission «Read» sur les dépôts locaux à lire ; pour relier les artefacts aux pipelines, ajoutez aussi «Read» sur les builds.',
  'D’accordo':
    'D’accord',
  'Edizione Pro: il token utente (nome e codice) creato in «User token», revocabile senza toccare la password.':
    'Édition Pro : le jeton utilisateur (nom et code) créé dans «Jeton utilisateur», révocable sans toucher au mot de passe.',
  'Elenco troncato: si mostrano i primi 20.000.':
    'Liste tronquée : les 20 000 premiers sont affichés.',
  'Facoltativo, con scope api: si usa solo per le scritture (merge request, pipeline, variabili CI) e solo con «Consenti la scrittura» accesa. Le letture usano sempre il token di lettura.':
    'Facultatif, avec le scope api : utilisé seulement pour les écritures (merge request, pipeline, variables CI) et seulement si «Autoriser l’écriture» est activée. Les lectures utilisent toujours le jeton de lecture.',
  'Facoltativo, se usate Nexus Lifecycle (IQ Server): letto con le stesse credenziali, i suoi risultati compaiono in un tab a sé.':
    'Facultatif, si vous utilisez Nexus Lifecycle (IQ Server) : lu avec les mêmes identifiants, ses résultats apparaissent dans un onglet à part.',
  'Fonte non disponibile':
    'Source non disponible',
  'Genera un access token per quell’utente (Administration → Identity and Access → Access Tokens) con una scadenza: è la modalità consigliata.':
    'Générez un jeton d’accès pour cet utilisateur (Administration → Identity and Access → Access Tokens) avec une échéance : c’est le mode recommandé.',
  'GitLab':
    'GitLab',
  'GitLab Registry':
    'GitLab Registry',
  'GitLab Ultimate':
    'GitLab Ultimate',
  'GitLab Ultimate non rilevato':
    'GitLab Ultimate non détecté',
  'GitLab si rilegge ogni 30 minuti (solo i progetti con attività), Artifactory ogni 2 ore, Nexus ogni 6 ore entro il tetto di richieste giornaliero. Le chiamate partono una alla volta, dalla sonda o dal Control Plane come scelto nella connessione.':
    'GitLab est relu toutes les 30 minutes (seulement les projets avec de l’activité), Artifactory toutes les 2 heures, Nexus toutes les 6 heures dans la limite du plafond de requêtes quotidien. Les appels partent un par un, depuis la sonde ou le Control Plane selon le choix fait dans la connexion.',
  'GitLab.com o un’istanza pubblica: dal Control Plane. Un’istanza interna: da una sonda con la capability «Software prodotto» che raggiunge l’indirizzo sulla 443.':
    'GitLab.com ou une instance publique : depuis le Control Plane. Une instance interne : depuis une sonde avec la capability «Logiciel produit» qui atteint l’adresse sur le port 443.',
  'Gruppi da leggere':
    'Groupes à lire',
  'I componenti come li dà {fonte}, senza unirli alle altre fonti: lo stesso componente visto da più fonti compare in ciascun tab, e nel «Confronto» una volta sola.':
    'Les composants tels que {fonte} les donne, sans les fusionner avec les autres sources : le même composant vu par plusieurs sources apparaît dans chaque onglet, et dans «Comparaison» une seule fois.',
  'Il double check: ogni riga è un elemento, ogni colonna una fonte. «In disaccordo» = le fonti lo vedono ma con gravità o versione che corregge diverse; «una sola fonte» = gli altri non lo riportano (spesso perché non guardano lo stesso build). Un clic su una cella apre la riga nel tab della sua fonte.':
    'Le double check : chaque ligne est un élément, chaque colonne une source. «En désaccord» = les sources le voient mais avec une gravité ou une version corrigée différente ; «une seule source» = les autres ne le rapportent pas (souvent parce qu’elles ne regardent pas le même build). Un clic sur une cellule ouvre la ligne dans l’onglet de sa source.',
  'Il file della pipeline è {f}.':
    'Le fichier de la pipeline est {f}.',
  'Il software che l’organizzazione costruisce e pubblica: progetti e pipeline di GitLab, artefatti di Artifactory e Nexus, l’SBOM di ogni build con le sue vulnerabilità e dove l’immagine gira. Ogni fonte ha il suo tab, così com’è; «Confronto» mette le fonti una accanto all’altra.':
    'Le logiciel que l’organisation construit et publie : projets et pipelines GitLab, artefacts Artifactory et Nexus, le SBOM de chaque build avec ses vulnérabilités et où l’image tourne. Chaque source a son propre onglet, telle qu’elle est ; «Comparaison» met les sources côte à côte.',
  'Immagini in esecuzione':
    'Images en cours d’exécution',
  'Impronta':
    'Empreinte',
  'In disaccordo':
    'En désaccord',
  'In esecuzione su':
    'En cours d’exécution sur',
  'Indirizzo di Artifactory':
    'Adresse d’Artifactory',
  'Indirizzo di GitLab':
    'Adresse de GitLab',
  'Indirizzo di Nexus':
    'Adresse de Nexus',
  'Indirizzo di Nexus IQ':
    'Adresse de Nexus IQ',
  'JFrog Artifactory':
    'JFrog Artifactory',
  'JFrog in cloud (*.jfrog.io): dal Control Plane. Un server interno: da una sonda con la capability «Software prodotto».':
    'JFrog dans le cloud (*.jfrog.io) : depuis le Control Plane. Un serveur interne : depuis une sonde avec la capability «Logiciel produit».',
  'La Community Edition ha un limite di 100.000 richieste al giorno per tutta l’istanza: superato, smette di accettare componenti nuovi e i vostri build si fermano.':
    'La Community Edition a une limite de 100 000 requêtes par jour pour toute l’instance : une fois dépassée, elle arrête d’accepter de nouveaux composants et vos builds s’arrêtent.',
  'Le immagini Docker si leggono dal manifest (anche multi-architettura): il digest le collega ai container che CENSO vede in esecuzione sui server.':
    'Les images Docker sont lues depuis le manifest (y compris multi-architecture) : le digest les relie aux conteneurs que CENSO voit en cours d’exécution sur les serveurs.',
  'Le pipeline non lasciano un SBOM CycloneDX: aggiungi alla pipeline il job che lo produce (censo-sbom.cdx.json, oppure un report cyclonedx).':
    'Les pipelines ne laissent pas de SBOM CycloneDX : ajoutez à la pipeline le job qui le produit (censo-sbom.cdx.json, ou un rapport cyclonedx).',
  'Le vulnerabilità che il motore di CENSO trova negli SBOM dei build (catalogo OSV, sfruttate attivamente da CISA KEV), con lo stesso confronto di versioni del software installato.':
    'Les vulnérabilités que le moteur de CENSO trouve dans les SBOM des builds (catalogue OSV, activement exploitées selon la CISA KEV), avec la même comparaison de versions que le logiciel installé.',
  'Le vulnerabilità come le riporta {fonte}, con le sue parole per la gravità: niente è ricalcolato da CENSO.':
    'Les vulnérabilités telles que {fonte} les rapporte, avec ses propres termes pour la gravité : rien n’est recalculé par CENSO.',
  'Letto':
    'Lu',
  "Lettura in sottofondo dei sistemi dove l'organizzazione costruisce e pubblica il suo software: progetti, pipeline e SBOM di GitLab, artefatti di Artifactory e Nexus. Non apre porte e non avvia job — le chiamate escono da questa sonda attraverso il relay. Abilitala dove la sonda raggiunge quei sistemi.":
    'Lecture en arrière-plan des systèmes où l’organisation construit et publie son logiciel : projets, pipelines et SBOM de GitLab, artefacts d’Artifactory et de Nexus. N’ouvre aucun port et ne lance aucun job — les appels sortent de cette sonde à travers le relais. Activez-la là où la sonde atteint ces systèmes.',
  'MR di sicurezza aperte':
    'MR de sécurité ouvertes',
  'MR di sicurezza di Renovate':
    'MR de sécurité de Renovate',
  'MR di sicurezza di Renovate aperte':
    'MR de sécurité de Renovate ouvertes',
  'Metti una scadenza al token e annotala: GitLab lo disattiva da solo alla scadenza.':
    'Mettez une échéance sur le jeton et notez-la : GitLab le désactive lui-même à l’échéance.',
  'Nessun SBOM per questo progetto':
    'Aucun SBOM pour ce projet',
  'Nessun artefatto.':
    'Aucun artefact.',
  'Nessun componente da questa fonte.':
    'Aucun composant de cette source.',
  'Nessun componente in questo SBOM.':
    'Aucun composant dans ce SBOM.',
  'Nessun giro ancora':
    'Aucun passage pour l’instant',
  'Nessun progetto in questo filtro.':
    'Aucun projet dans ce filtre.',
  'Nessuna connessione ancora':
    'Aucune connexion pour l’instant',
  'Nessuna merge request di Renovate aperta.':
    'Aucune merge request de Renovate ouverte.',
  'Nessuna pipeline letta ancora.':
    'Aucune pipeline lue pour l’instant.',
  'Nessuna pipeline letta.':
    'Aucune pipeline lue.',
  'Nessuna vulnerabilità da questa fonte.':
    'Aucune vulnérabilité de cette source.',
  'Nexus':
    'Nexus',
  'Nexus IQ':
    'Nexus IQ',
  'Niente in questo filtro.':
    'Rien dans ce filtre.',
  'Nome del token':
    'Nom du jeton',
  'Nomi dei repository hosted separati da virgola. Vuoto: tutti gli hosted leggibili.':
    'Noms des dépôts hébergés séparés par une virgule. Vide : tous les hébergés lisibles.',
  'Non si sa se «Pipelines must succeed» sia acceso.':
    'On ne sait pas si «Pipelines must succeed» est activé.',
  'Non valutati':
    'Non évalués',
  'Ogni fonte ha il suo tab, con i suoi risultati così come li dà, anche se si ripetono: per i componenti la pipeline di GitLab, Artifactory, Nexus e la Dependency List di GitLab Ultimate; per le vulnerabilità CENSO, Xray, Nexus IQ e GitLab. «Confronto» le mette una accanto all’altra — d’accordo, in disaccordo su gravità o versione che corregge, viste da una sola fonte — e un clic sulla cella apre la riga nella sua fonte. Per ogni progetto si vedono anche Renovate (configurazione, avvisi OSV, merge request di sicurezza aperte), i rilasci con il loro SBOM scaricabile e se «Pipelines must succeed» è acceso.':
    'Chaque source a son propre onglet, avec ses résultats tels qu’elle les donne, même s’ils se répètent : pour les composants, la pipeline GitLab, Artifactory, Nexus et la Dependency List de GitLab Ultimate ; pour les vulnérabilités, CENSO, Xray, Nexus IQ et GitLab. «Comparaison» les met côte à côte — d’accord, en désaccord sur la gravité ou la version corrigée, vues par une seule source — et un clic sur la cellule ouvre la ligne dans sa source. Pour chaque projet, on voit aussi Renovate (configuration, avis OSV, merge request de sécurité ouvertes), les versions publiées avec leur SBOM téléchargeable, et si «Pipelines must succeed» est activé.',
  'Ogni tag con il suo SBOM è conservato: è la documentazione del rilascio (per il CRA, dieci anni o il periodo di supporto se più lungo).':
    'Chaque tag avec son SBOM est conservé : c’est la documentation de la version publiée (pour le CRA, dix ans ou la période de support si plus longue).',
  'Percorsi dei gruppi separati da virgola, sottogruppi compresi. Vuoto: tutti i progetti a cui il token di lettura ha accesso.':
    'Chemins des groupes séparés par une virgule, sous-groupes compris. Vide : tous les projets auxquels le jeton de lecture a accès.',
  'Pipeline':
    'Pipeline',
  'Pipeline GitLab':
    'Pipeline GitLab',
  'Pipeline e merge':
    'Pipeline et merge',
  'Pipeline fallita':
    'Pipeline échouée',
  'Progetti':
    'Projets',
  'Progetto o artefatto':
    'Projet ou artefact',
  'Pubblicato':
    'Publié',
  "Quante richieste CENSO può fare al giorno. La Community Edition ha un tetto di 100.000 richieste al giorno per tutta l'istanza, oltre il quale smette di accettare componenti nuovi: CENSO resta sotto questo numero (vuoto: 2000).":
    'Combien de requêtes CENSO peut faire par jour. La Community Edition a un plafond de 100 000 requêtes par jour pour toute l’instance, au-delà duquel elle arrête d’accepter de nouveaux composants : CENSO reste sous ce nombre (vide : 2000).',
  'Ramo o tag':
    'Branche ou tag',
  'Ramo principale':
    'Branche principale',
  'Registri':
    'Registres',
  'Renovate':
    'Renovate',
  'Renovate non è configurato in questo progetto.':
    'Renovate n’est pas configuré dans ce projet.',
  'Repository da leggere':
    'Dépôts à lire',
  'Richieste al giorno':
    'Requêtes par jour',
  'Riferimento della fonte':
    'Référence de la source',
  'Rilasci (tag) con SBOM':
    'Versions publiées (tags) avec SBOM',
  'SBOM allegato':
    'SBOM joint',
  'SBOM letto':
    'SBOM lu',
  'Scarica il documento originale':
    'Télécharger le document d’origine',
  'Senza Renovate':
    'Sans Renovate',
  'Senza SBOM':
    'Sans SBOM',
  'Serve il «Token di scrittura» (scope api) con ruolo Developer sui progetti per merge request e pipeline, e Maintainer per le variabili CI e per avviare pipeline con variabili (GitLab 17.1 e successivi). Attenzione: un ramo nuovo fa partire la sua pipeline sui vostri runner, con le variabili non protette, prima della revisione.':
    'Il faut le «Jeton d’écriture» (scope api) avec le rôle Developer sur les projets pour les merge request et les pipelines, et Maintainer pour les variables CI et pour démarrer des pipelines avec variables (GitLab 17.1 et ultérieur). Attention : une nouvelle branche démarre sa pipeline sur vos runners, avec les variables non protégées, avant la revue.',
  'Software prodotto':
    'Logiciel produit',
  'Software prodotto (GitLab, Artifactory, Nexus)':
    'Logiciel produit (GitLab, Artifactory, Nexus)',
  'Solo le immagini in esecuzione sui server.':
    'Seulement les images en cours d’exécution sur les serveurs.',
  'Sonatype Nexus Repository':
    'Sonatype Nexus Repository',
  'Token di gruppo o di progetto (su GitLab.com richiede Premium o Ultimate), oppure il token personale di un utente bot dedicato: scope read_api e ruolo Reporter sui gruppi da leggere.':
    'Un jeton de groupe ou de projet (sur GitLab.com, cela demande Premium ou Ultimate), ou le jeton personnel d’un utilisateur bot dédié : scope read_api et rôle Reporter sur les groupes à lire.',
  'Token di lettura':
    'Jeton de lecture',
  'Token di scrittura':
    'Jeton d’écriture',
  "URL base dell'istanza, senza /api/v4: https://gitlab.com per GitLab.com.":
    'URL de base de l’instance, sans /api/v4 : https://gitlab.com pour GitLab.com.',
  "URL base dell'istanza, senza /service/rest.":
    'URL de base de l’instance, sans /service/rest.',
  'URL base della piattaforma, senza /artifactory: https://<nome>.jfrog.io o il server interno.':
    'URL de base de la plate-forme, sans /artifactory : https://<nom>.jfrog.io ou le serveur interne.',
  'Ultima lettura non riuscita: {e}':
    'Dernière lecture échouée : {e}',
  'Ultima pipeline':
    'Dernière pipeline',
  'Ultima pipeline fallita':
    'Dernière pipeline échouée',
  'Ultimo download':
    'Dernier téléchargement',
  'Ultimo giro {quando}: {n} richieste{r}':
    'Dernier passage {quando} : {n} requêtes{r}',
  "Un access token (Bearer) di un utente con permesso Read sui repository da leggere; per collegare gli artefatti ai build anche Read sui build. Se c'è Xray, lo stesso token ne legge i risultati.":
    'Un jeton d’accès (Bearer) d’un utilisateur avec la permission Read sur les dépôts à lire ; pour relier les artefacts aux builds, aussi Read sur les builds. Si Xray est présent, le même jeton lit aussi ses résultats.',
  'Un secondo token con scope «api»: ruolo «Developer» per aprire merge request e avviare pipeline, «Maintainer» per scrivere le variabili CI del cancello e per avviare pipeline con variabili (da GitLab 17.1 serve un ruolo minimo per le variabili di pipeline).':
    'Un second jeton avec le scope «api» : le rôle «Developer» pour ouvrir des merge request et démarrer des pipelines, «Maintainer» pour écrire les variables CI de la barrière et pour démarrer des pipelines avec variables (depuis GitLab 17.1, il faut un rôle minimum pour les variables de pipeline).',
  'Un utente dedicato in sola lettura: la password viaggia a ogni richiesta.':
    'Un utilisateur dédié en lecture seule : le mot de passe voyage à chaque requête.',
  'Una sola fonte':
    'Une seule source',
  'Un’istanza interna: da una sonda con la capability «Software prodotto». Un’istanza pubblica: anche dal Control Plane.':
    'Une instance interne : depuis une sonde avec la capability «Logiciel produit». Une instance publique : aussi depuis le Control Plane.',
  'User token':
    'Jeton utilisateur',
  'Vulnerabilità secondo le altre fonti':
    'Vulnérabilités selon les autres sources',
  'Xray':
    'Xray',
  'Xray non rilevato su Artifactory':
    'Xray non détecté sur Artifactory',
  'Xray {v}':
    'Xray {v}',
  'artefatti':
    'artefacts',
  'artefatto':
    'artefact',
  'avvisi OSV accesi':
    'avis OSV activés',
  'avvisi OSV non determinabili':
    'avis OSV indéterminables',
  'avvisi OSV non determinabili (preset o configurazione del runner)':
    'avis OSV indéterminables (preset ou configuration du runner)',
  'avvisi OSV spenti':
    'avis OSV désactivés',
  'avvisi OSV spenti: Renovate non apre MR per le vulnerabilità':
    'avis OSV désactivés : Renovate n’ouvre pas de MR pour les vulnérabilités',
  'connessione {nome}':
    'connexion {nome}',
  'creata':
    'créée',
  'd’accordo':
    'd’accord',
  'ecosistemi senza catalogo':
    'écosystèmes sans catalogue',
  'ecosistemi senza catalogo: non vuol dire «nessuna vulnerabilità»':
    'écosystèmes sans catalogue : ne veut pas dire «aucune vulnérabilité»',
  'giro in corso':
    'passage en cours',
  'giro richiesto':
    'passage demandé',
  'https://acme.jfrog.io':
    'https://acme.jfrog.io',
  'https://gitlab.example.com':
    'https://gitlab.example.com',
  'https://iq.example.com':
    'https://iq.example.com',
  'https://nexus.example.com':
    'https://nexus.example.com',
  'il software che l’organizzazione costruisce e pubblica. Collega GitLab (con un token di sola lettura), JFrog Artifactory e Sonatype Nexus dalla scheda «Connessioni»: CENSO legge in sottofondo progetti, pipeline e tag, l’SBOM CycloneDX che i job lasciano negli artefatti, quello pubblicato accanto agli artefatti nei registri, i digest delle immagini — e dice su quali server quell’immagine sta girando. Le vulnerabilità degli SBOM le valuta lo stesso motore del software installato; i componenti di ecosistemi senza catalogo sono contati come «non valutati», mai come sicuri.':
    'le logiciel que l’organisation construit et publie. Connectez GitLab (avec un jeton en lecture seule), JFrog Artifactory et Sonatype Nexus depuis l’onglet «Connexions» : CENSO lit en arrière-plan les projets, les pipelines et les tags, le SBOM CycloneDX que les jobs laissent dans les artefacts, celui publié à côté des artefacts dans les registres, les digests des images — et indique sur quels serveurs cette image est en train de tourner. Les vulnérabilités des SBOM sont évaluées par le même moteur que le logiciel installé ; les composants des écosystèmes sans catalogue sont comptés comme «non évalués», jamais comme sûrs.',
  'letto {quando}':
    'lu {quando}',
  'libs-release-local, docker-local':
    'libs-release-local, docker-local',
  'maven-releases, npm-internal, docker-hosted':
    'maven-releases, npm-internal, docker-hosted',
  'nessun SBOM da valutare':
    'aucun SBOM à évaluer',
  'nessun SBOM pubblicato accanto agli artefatti':
    'aucun SBOM publié à côté des artefacts',
  'nessun SBOM pubblicato accanto ai componenti':
    'aucun SBOM publié à côté des composants',
  'nessun catalogo per questo ecosistema':
    'aucun catalogue pour cet écosystème',
  'nessun indirizzo di Nexus IQ nella connessione Nexus':
    'aucune adresse Nexus IQ dans la connexion Nexus',
  'nessuna connessione Artifactory':
    'aucune connexion Artifactory',
  'nessuna connessione GitLab':
    'aucune connexion GitLab',
  'nessuna connessione Nexus':
    'aucune connexion Nexus',
  'nessuna pipeline ha ancora prodotto un SBOM':
    'aucune pipeline n’a encore produit de SBOM',
  'non configurato':
    'non configuré',
  'non valutato':
    'non évalué',
  'piattaforma, prodotti/pagamenti':
    'plateforme, produits/paiements',
  'pipeline':
    'pipeline',
  'progetti':
    'projets',
  'progetto':
    'projet',
  'prossimo {quando}':
    'prochain {quando}',
  'ramo principale':
    'branche principale',
  'righe':
    'lignes',
  'rilasci':
    'versions publiées',
  'rilascio':
    'version publiée',
  'saltata':
    'ignorée',
  'senza SBOM':
    'sans SBOM',
  'su {n} immagini pubblicate':
    'sur {n} images publiées',
  'ultimo giro non riuscito':
    'dernier passage échoué',
  'una sola fonte':
    'une seule source',
  '{c} componenti':
    '{c} composants',
  '{n} MR aperte':
    '{n} MR ouvertes',
  '{n} componenti di ecosistemi senza catalogo: non valutati.':
    '{n} composants d’écosystèmes sans catalogue : non évalués.',
  '{n} di sicurezza':
    '{n} de sécurité',
  '{n} non valutati':
    '{n} non évalués',
  '{n} progetti con Renovate':
    '{n} projets avec Renovate',
  '{n} richieste oggi':
    '{n} requêtes aujourd’hui',
  '«Pipelines must succeed» è acceso: una pipeline fallita blocca il merge.':
    '«Pipelines must succeed» est activé : une pipeline échouée bloque le merge.',
  '«Pipelines must succeed» è spento: una pipeline fallita non blocca il merge.':
    '«Pipelines must succeed» est désactivé : une pipeline échouée ne bloque pas le merge.',
  'Aggiorna il job SBOM':
    'Mettre à jour le job SBOM',
  'Aggiungi alla pipeline il job che produce l’SBOM':
    'Ajouter à la pipeline le job qui produit le SBOM',
  'Aggiungi il job SBOM':
    'Ajouter le job SBOM',
  'Annulla la pipeline':
    'Annuler la pipeline',
  'Annulla la pipeline #{id}':
    'Annuler la pipeline #{id}',
  'Apertura…':
    'Ouverture…',
  'Apri la merge request':
    'Ouvrir la merge request',
  'Avvia la pipeline':
    'Démarrer la pipeline',
  'Avvia una pipeline':
    'Démarrer une pipeline',
  'Azioni di CENSO in GitLab':
    'Actions de CENSO dans GitLab',
  'CI Lint di GitLab':
    'CI Lint de GitLab',
  'Chiesto da':
    'Demandé par',
  'Ciò che CENSO ha fatto in GitLab su richiesta: pipeline avviate, riprovate o annullate, merge request aperte (con il loro stato, aggiornato a ogni giro). Ogni azione è anche nell’audit del tenant.':
    'Ce que CENSO a fait dans GitLab sur demande : pipelines démarrées, relancées ou annulées, merge request ouvertes (avec leur statut, mis à jour à chaque passage). Chaque action est aussi dans l’audit du tenant.',
  'Con «Consenti la scrittura» e il token di scrittura nella connessione GitLab, dal dettaglio di un progetto si avvia, si riprova o si annulla una pipeline e si aggiunge il job che produce l’SBOM: prima un piano — che cosa partirà o si fermerà, la differenza del .gitlab-ci.yml, la verifica della CI Lint di GitLab, le conseguenze —, poi una merge request da un ramo di CENSO. Il ramo principale non si tocca mai, ogni azione resta nella scheda «Modifiche» e nell’audit.':
    'Avec «Autoriser l’écriture» et le jeton d’écriture dans la connexion GitLab, depuis le détail d’un projet on démarre, relance ou annule une pipeline et on ajoute le job qui produit le SBOM : d’abord un plan — ce qui va démarrer ou s’arrêter, la différence du .gitlab-ci.yml, la vérification de la CI Lint de GitLab, les conséquences —, puis une merge request depuis une branche de CENSO. La branche principale n’est jamais touchée, chaque action reste dans l’onglet «Modifications» et dans l’audit.',
  'Conseguenze':
    'Conséquences',
  'C’è già una merge request di CENSO aperta per questo:':
    'Il y a déjà une merge request de CENSO ouverte pour cela :',
  'Dichiaralo anche come report «cyclonedx» di GitLab':
    'Déclarez-le aussi comme rapport «cyclonedx» de GitLab',
  'Fai ripartire i job':
    'Relancer les jobs',
  'Fissata per versione e per impronta (@sha256:…). Con un registro interno metti qui il suo mirror.':
    'Fixée par version et par empreinte (@sha256:…). Avec un registre interne, indiquez ici son miroir.',
  'Il job censo-sbom genera a ogni pipeline censo-sbom.cdx.json (CycloneDX 1.6) con cdxgen e lo lascia negli artefatti, da dove CENSO lo legge da solo: nessun segreto nella pipeline.':
    'Le job censo-sbom génère censo-sbom.cdx.json (CycloneDX 1.6) avec cdxgen à chaque pipeline et le laisse dans les artefacts, d’où CENSO le lit lui-même : aucun secret dans la pipeline.',
  'Il progetto usa Auto DevOps e non ha un .gitlab-ci.yml: crearlo spegne Auto DevOps.':
    'Le projet utilise Auto DevOps et n’a pas de .gitlab-ci.yml : le créer désactive Auto DevOps.',
  'Il ramo nuovo fa partire la sua pipeline sui vostri runner, con le variabili non protette, prima di qualunque revisione.':
    'La nouvelle branche démarre sa pipeline sur vos runners, avec les variables non protégées, avant toute revue.',
  'Immagine di cdxgen':
    'Image de cdxgen',
  'Installa le dipendenze per risolverle':
    'Installer les dépendances pour les résoudre',
  'La modifica arriva in una merge request verso «{target}»: sul ramo principale non cambia niente finché non viene approvata.':
    'La modification arrive dans une merge request vers « {target} » : rien ne change sur la branche principale jusqu’à ce qu’elle soit approuvée.',
  'La pipeline ha «workflow:rules»: il job di CENSO gira solo nelle pipeline che quelle regole creano.':
    'La pipeline a des «workflow:rules» : le job de CENSO ne tourne que dans les pipelines que ces règles créent.',
  'La scrittura è spenta per questa connessione: la accende un amministratore con «Consenti la scrittura» nella connessione GitLab.':
    'L’écriture est désactivée pour cette connexion : un administrateur l’active avec «Autoriser l’écriture» dans la connexion GitLab.',
  'L’SBOM sarà anche un report «cyclonedx» di GitLab: su Ultimate cambiano la Dependency List e le politiche di sicurezza del progetto.':
    'Le SBOM sera aussi un rapport «cyclonedx» de GitLab : sur Ultimate, cela change la Dependency List et les politiques de sécurité du projet.',
  'MR aperta':
    'MR ouverte',
  'MR approvata':
    'MR approuvée',
  'MR chiusa':
    'MR fermée',
  'Merge request !{iid} aperta dal ramo {ramo}.':
    'Merge request !{iid} ouverte depuis la branche {ramo}.',
  'Modifiche':
    'Modifications',
  'Nessun job fallito da far ripartire.':
    'Aucun job échoué à relancer.',
  'Nessun job in corso da fermare.':
    'Aucun job en cours à arrêter.',
  'Nessuna azione di CENSO in GitLab finora.':
    'Aucune action de CENSO dans GitLab jusqu’ici.',
  'Nessuna variabile si può aggiungere da qui: una variabile scritta in console (come CI_DEBUG_TRACE) potrebbe stampare i segreti nei log dei job.':
    'Aucune variable ne peut être ajoutée depuis ici : une variable écrite dans la console (comme CI_DEBUG_TRACE) pourrait afficher les secrets dans les logs des jobs.',
  'Niente è ancora stato fatto.':
    'Rien n’a encore été fait.',
  'Niente è ancora stato scritto.':
    'Rien n’a encore été écrit.',
  'Parte una pipeline su «{ref}» con il .gitlab-ci.yml di quel ramo: tutti i job che le sue regole prevedono, sui vostri runner.':
    'Une pipeline démarre sur « {ref} » avec le .gitlab-ci.yml de cette branche : tous les jobs que ses règles prévoient, sur vos runners.',
  'Per agire da qui serve il «Token di scrittura» nella connessione GitLab (scope api).':
    'Pour agir depuis ici, il faut le «Jeton d’écriture» dans la connexion GitLab (scope api).',
  'Pipeline #{id} annullata.':
    'Pipeline #{id} annulée.',
  'Pipeline #{id} avviata su «{ref}».':
    'Pipeline #{id} démarrée sur « {ref} ».',
  'Pipeline #{id}: job falliti fatti ripartire.':
    'Pipeline #{id} : jobs échoués relancés.',
  'Prepara il piano':
    'Préparer le plan',
  'Rami':
    'Branches',
  'Renovate: avvio mirato':
    'Renovate : lancement ciblé',
  'Renovate: avvisi OSV':
    'Renovate : avis OSV',
  'Renovate: configurazione':
    'Renovate : configuration',
  'Renovate: runner':
    'Renovate : runner',
  'Ripartono i job falliti o annullati di questa pipeline:':
    'Les jobs échoués ou annulés de cette pipeline repartent :',
  'Riprova':
    'Relancer',
  'Riprova la pipeline #{id}':
    'Relancer la pipeline #{id}',
  'Si aggiorna il blocco di CENSO in {f}.':
    'Le bloc de CENSO dans {f} est mis à jour.',
  'Si aggiunge un blocco in fondo a {f}: il resto del file non cambia.':
    'Un bloc est ajouté à la fin de {f} : le reste du fichier ne change pas.',
  'Si crea {f}.':
    '{f} est créé.',
  'Si fermano i job in corso o in attesa di questa pipeline:':
    'Les jobs en cours ou en attente de cette pipeline s’arrêtent :',
  'Spenta (consigliato), cdxgen legge i file di blocco così come sono. Accesa, esegue i gestori di pacchetti: servono le credenziali dei registri privati nella pipeline.':
    'Désactivée (recommandé), cdxgen lit les fichiers lock tels quels. Activée, il exécute les gestionnaires de paquets : il faut les identifiants de vos registres privés dans la pipeline.',
  'Stage':
    'Stage',
  'Su GitLab Ultimate alimenta la Dependency List e le politiche di sicurezza del progetto: cambia ciò che GitLab vi mostra.':
    'Sur GitLab Ultimate, cela alimente la Dependency List et les politiques de sécurité du projet : cela change ce que GitLab vous montre.',
  'Tag dei runner':
    'Tags des runners',
  'cancello di sicurezza':
    'barrière de sécurité',
  'cdxgen installerà le dipendenze per risolverle: nella pipeline servono le credenziali dei vostri registri privati, altrimenti il job fallisce o l’SBOM è parziale.':
    'cdxgen installera les dépendances pour les résoudre : il faut les identifiants de vos registres privés dans la pipeline, sinon le job échoue ou le SBOM est partiel.',
  'configurazione valida':
    'configuration valide',
  'errori':
    'erreurs',
  'job SBOM':
    'job SBOM',
  'non eseguita':
    'non exécutée',
  'pipeline annullata':
    'pipeline annulée',
  'pipeline avviata':
    'pipeline démarrée',
  'pipeline riprovata':
    'pipeline relancée',
  'vuoto: qualsiasi runner':
    'vide : n’importe quel runner',
  '«Pipelines must succeed» è spento: un job fallito non blocca il merge.':
    '«Pipelines must succeed» est désactivé : un job échoué ne bloque pas le merge.',
  'Accendi gli avvisi OSV':
    'Activer les alertes OSV',
  'Accendi gli avvisi di sicurezza OSV di Renovate':
    'Activer les alertes de sécurité OSV de Renovate',
  'Aggiorna il runner di Renovate':
    'Mettre à jour le runner de Renovate',
  'Anche un giro pianificato sui gruppi della connessione':
    'Aussi un passage planifié sur les groupes de la connexion',
  'Avvia Renovate':
    'Démarrer Renovate',
  'Avvia Renovate adesso':
    'Démarrer Renovate maintenant',
  'Avviare una pipeline con una variabile richiede il ruolo Maintainer sul progetto del runner.':
    'Démarrer une pipeline avec une variable nécessite le rôle Maintainer sur le projet du runner.',
  'Il file viene riscritto con il rientro di due spazi: la differenza mostra anche le righe solo riformattate.':
    'Le fichier est réécrit avec une indentation de deux espaces : la différence montre aussi les lignes seulement reformatées.',
  'Il giro pianificato parte solo con una pianificazione di GitLab sul progetto del runner (CI/CD → Pianificazioni): la crei tu, con l’orario che preferisci.':
    'Le passage planifié ne démarre qu’avec une planification GitLab sur le projet du runner (CI/CD → Planifications) : vous la créez, à l’heure que vous préférez.',
  "Il progetto GitLab che esegue Renovate per gli altri. Vuoto: CENSO cerca un progetto con «renovate» nel percorso che usa l'immagine o il template di Renovate.":
    'Le projet GitLab qui exécute Renovate pour les autres. Vide : CENSO cherche un projet avec «renovate» dans le chemin qui utilise l’image ou le template de Renovate.',
  'Il runner ha bisogno della variabile CI RENOVATE_TOKEN (token del bot con scope api, read_user, write_repository): CENSO non crea token, la aggiunge un Maintainer.':
    'Le runner a besoin de la variable CI RENOVATE_TOKEN (le jeton du bot avec les scopes api, read_user, write_repository) : CENSO ne crée pas de jetons, un Maintainer l’ajoute.',
  'Immagine di Renovate':
    'Image de Renovate',
  'Le librerie vulnerabili citate nella merge request':
    'Les bibliothèques vulnérables citées dans la merge request',
  'Nel progetto del runner {r} parte una pipeline con CENSO_RENOVATE_REPOSITORY = {p}: Renovate tratta solo questo progetto.':
    'Dans le projet du runner {r}, une pipeline démarre avec CENSO_RENOVATE_REPOSITORY = {p} : Renovate ne traite que ce projet.',
  'Nessun progetto letto da questa connessione: aspetta il primo giro.':
    'Aucun projet lu depuis cette connexion : attendez le premier passage.',
  'Nessun runner di Renovate trovato.':
    'Aucun runner de Renovate trouvé.',
  'Non si sa se RENOVATE_TOKEN ci sia (può stare nel gruppo o nell’istanza): se manca, la pipeline fallisce.':
    'On ne sait pas si RENOVATE_TOKEN est présent (il peut se trouver dans le groupe ou l’instance) : s’il manque, la pipeline échoue.',
  'Prepara il runner di Renovate':
    'Préparer le runner de Renovate',
  'Progetto del runner':
    'Projet du runner',
  'Progetto del runner Renovate':
    'Projet du runner Renovate',
  'Proponi la configurazione di Renovate':
    'Proposer la configuration de Renovate',
  'RENOVATE_TOKEN assente':
    'RENOVATE_TOKEN absent',
  'RENOVATE_TOKEN non c’è nel runner: la pipeline fallirà finché un Maintainer non lo aggiunge.':
    'RENOVATE_TOKEN n’est pas dans le runner : la pipeline échouera jusqu’à ce qu’un Maintainer l’ajoute.',
  'RENOVATE_TOKEN non verificabile':
    'RENOVATE_TOKEN non vérifiable',
  'RENOVATE_TOKEN presente':
    'RENOVATE_TOKEN présent',
  'RENOVATE_TOKEN è impostato nel runner.':
    'RENOVATE_TOKEN est défini dans le runner.',
  'Renovate apre (o aggiorna) le sue merge request in {p}, con il suo account e le sue regole.':
    'Renovate ouvre (ou met à jour) ses merge request dans {p}, avec son propre compte et ses règles.',
  'Renovate apre merge request solo per correggere le vulnerabilità. Spenta, propone anche tutti gli altri aggiornamenti delle dipendenze.':
    'Renovate ouvre des merge request uniquement pour corriger les vulnérabilités. Désactivée, elle propose aussi toutes les autres mises à jour de dépendances.',
  'Renovate apre merge request solo quando il suo runner tratta questo progetto: dopo il merge, «Avvia Renovate adesso» o il giro pianificato del runner.':
    'Renovate ouvre des merge request uniquement quand son runner traite ce projet : après le merge, «Démarrer Renovate maintenant» ou le passage planifié du runner.',
  'Renovate avviato su {p}: pipeline #{id} nel runner.':
    'Renovate démarré sur {p} : pipeline #{id} dans le runner.',
  'Renovate lavora con l’account di quel token: le sue merge request portano il suo nome.':
    'Renovate travaille avec le compte de ce jeton : ses merge request portent son nom.',
  'Renovate, con lo stesso piano in due passi: «Proponi la configurazione di Renovate» apre una merge request con renovate.json e gli avvisi di sicurezza OSV accesi (raccomandato: solo aggiornamenti di sicurezza), che nella descrizione elenca le librerie vulnerabili dell’ultimo SBOM; «Accendi gli avvisi OSV» li accende in una configurazione esistente. Renovate gira nel runner dell’organizzazione: dalla scheda «Connessioni» «Prepara il runner di Renovate» aggiunge al progetto del runner il job di avvio su richiesta di CENSO, e dal progetto «Avvia Renovate adesso» lo fa girare su quel progetto solo. Il token di Renovate resta nel runner (variabile RENOVATE_TOKEN): CENSO non lo crea e non lo legge.':
    'Renovate, avec le même plan en deux étapes : «Proposer la configuration de Renovate» ouvre une merge request avec renovate.json et les alertes de sécurité OSV activées (recommandé : mises à jour de sécurité uniquement), qui liste dans sa description les bibliothèques vulnérables du dernier SBOM ; «Activer les alertes OSV» les active dans une configuration existante. Renovate tourne dans le runner de l’organisation : depuis l’onglet «Connexions», «Préparer le runner de Renovate» ajoute au projet du runner le job de démarrage à la demande de CENSO, et depuis le projet, «Démarrer Renovate maintenant» le fait tourner sur ce projet uniquement. Le jeton de Renovate reste dans le runner (variable RENOVATE_TOKEN) : CENSO ne le crée pas et ne le lit pas.',
  'Runner di Renovate':
    'Runner de Renovate',
  'Runner di Renovate indicato ma non trovato: controlla il percorso nella connessione.':
    'Runner de Renovate indiqué mais introuvable : vérifiez le chemin dans la connexion.',
  'Serve il runner con l’avvio su richiesta di CENSO':
    'Il faut le runner avec le démarrage à la demande de CENSO',
  'Si modifica {f}.':
    '{f} est modifié.',
  'Solo aggiornamenti di sicurezza (consigliato)':
    'Mises à jour de sécurité uniquement (recommandé)',
  'Solo aggiornamenti di sicurezza: le altre proposte di aggiornamento sono spente.':
    'Mises à jour de sécurité uniquement : les autres propositions de mise à jour sont désactivées.',
  'Tutti gli aggiornamenti: Renovate proporrà anche quelli che non correggono vulnerabilità.':
    'Toutes les mises à jour : Renovate proposera aussi celles qui ne corrigent pas de vulnérabilités.',
  'Un job di avvio su richiesta nel progetto che esegue Renovate: parte solo quando CENSO avvia una pipeline per un progetto preciso, e tratta quello solo. Il token di Renovate resta in quel progetto.':
    'Un job de démarrage à la demande dans le projet qui exécute Renovate : il ne démarre que lorsque CENSO démarre une pipeline pour un projet précis, et ne traite que celui-ci. Le jeton de Renovate reste dans ce projet.',
  'Un progetto dedicato, per esempio «renovate-runner»: il job gira lì con il token del bot. Indicalo anche nella connessione («Progetto del runner Renovate») perché CENSO lo usi.':
    'Un projet dédié, par exemple «renovate-runner» : le job y tourne avec le jeton du bot. Indiquez-le aussi dans la connexion («Projet du runner Renovate») pour que CENSO l’utilise.',
  'Un secondo job che gira quando una pianificazione di GitLab lo avvia (la pianificazione la crei tu in CI/CD → Pianificazioni) e tratta i progetti dei gruppi che hanno già una configurazione di Renovate.':
    'Un deuxième job qui tourne quand une planification GitLab le démarre (vous créez la planification dans CI/CD → Planifications) et traite les projets des groupes qui ont déjà une configuration Renovate.',
  'Una merge request che accende «osvVulnerabilityAlerts» nella configurazione di Renovate esistente: senza, Renovate non apre merge request per le vulnerabilità.':
    'Une merge request qui active «osvVulnerabilityAlerts» dans la configuration Renovate existante : sans cela, Renovate n’ouvre pas de merge request pour les vulnérabilités.',
  'Una merge request che aggiunge renovate.json: Renovate con gli avvisi di sicurezza OSV accesi, che apre merge request per correggere le librerie vulnerabili. La descrizione elenca quelle che CENSO trova nell’ultimo SBOM.':
    'Une merge request qui ajoute renovate.json : Renovate avec les alertes de sécurité OSV activées, qui ouvre des merge request pour corriger les bibliothèques vulnérables. La description liste celles que CENSO trouve dans le dernier SBOM.',
  'avvio su richiesta di CENSO pronto':
    'démarrage à la demande de CENSO prêt',
  'e altre {n}':
    'et {n} autres',
  'piattaforma/renovate-runner':
    'piattaforma/renovate-runner',
  'senza avvio su richiesta di CENSO':
    'sans démarrage à la demande de CENSO',
  'sfruttata':
    'exploitée',
  'Gli avvisi OSV di Renovate coprono le dipendenze dirette (npm, Maven, PyPI, Go, NuGet, Cargo, Packagist, RubyGems, Hex, Hackage): una libreria transitiva si corregge aggiornando quella che la porta.':
    'Les alertes OSV de Renovate couvrent les dépendances directes (npm, Maven, PyPI, Go, NuGet, Cargo, Packagist, RubyGems, Hex, Hackage) : une bibliothèque transitive se corrige en mettant à jour celle qui l’apporte.',
  'D) Renovate, se lo usate':
    'D) Renovate, si vous l’utilisez',
  'CENSO non esegue Renovate e non ne tiene il token: lo avvia nel runner dell’organizzazione, un progetto GitLab dedicato (per esempio «renovate-runner») che lo esegue per gli altri. Scrivi il suo percorso in «Progetto del runner Renovate»; vuoto, CENSO cerca da solo un progetto con «renovate» nel percorso.':
    'CENSO n’exécute pas Renovate et n’en garde pas le jeton : il le lance dans le runner de l’organisation, un projet GitLab dédié (par exemple «renovate-runner») qui l’exécute pour les autres. Indiquez son chemin dans «Projet du runner Renovate» ; vide, CENSO cherche lui-même un projet avec «renovate» dans son chemin.',
  'Nel runner serve la variabile CI RENOVATE_TOKEN: il token di un utente bot con scope «api», «read_user» e «write_repository», membro come Developer dei progetti da aggiornare. Le merge request di Renovate portano il nome di quel bot.':
    'Le runner a besoin de la variable CI RENOVATE_TOKEN : le jeton d’un utilisateur bot avec les scopes «api», «read_user» et «write_repository», membre Developer des projets à mettre à jour. Les merge requests de Renovate portent le nom de ce bot.',
  'Per «Avvia Renovate adesso» il token di scrittura deve essere Maintainer sul progetto del runner: avvia una pipeline con la variabile CENSO_RENOVATE_REPOSITORY. Per sapere se RENOVATE_TOKEN c’è, anche il token di lettura deve poter elencare le variabili del runner (Maintainer); altrimenti CENSO lo dice «non verificabile».':
    'Pour «Démarrer Renovate maintenant» le jeton d’écriture doit être Maintainer sur le projet du runner : il lance un pipeline avec la variable CENSO_RENOVATE_REPOSITORY. Pour savoir si RENOVATE_TOKEN est présent, le jeton de lecture doit aussi pouvoir lister les variables du runner (Maintainer) ; sinon CENSO l’indique «non vérifiable».',
  'A ogni pipeline il job censo-gate chiede a CENSO il verdetto sull’SBOM che quella pipeline ha prodotto. CENSO legge pipeline e SBOM da GitLab con il token di lettura, non si fida di quello che il job gli dice, e tiene conto delle valutazioni VEX in vigore.':
    'À chaque pipeline, le job censo-gate demande à CENSO le verdict sur le SBOM que cette pipeline a produit. CENSO lit la pipeline et le SBOM depuis GitLab avec le jeton de lecture, ne fait pas confiance à ce que le job lui dit, et tient compte des évaluations VEX en vigueur.',
  'Aggiorna la valutazione VEX':
    'Mettre à jour l’évaluation VEX',
  'Aggiungi alla pipeline il cancello di sicurezza':
    'Ajouter la barrière de sécurité à la pipeline',
  'Aggiungi il job del cancello':
    'Ajouter le job de la barrière',
  'Al massimo un anno.':
    'Un an au maximum.',
  'Attiva il cancello':
    'Activer la barrière',
  'Attiva il cancello di sicurezza':
    'Activer la barrière de sécurité',
  'Avvisa (consigliato)':
    'Avertir (recommandé)',
  'Avvisa su':
    'Avertir sur',
  'Blocca':
    'Bloquer',
  'Blocca su':
    'Bloquer sur',
  'Bloccano':
    'Bloquantes',
  'Bloccate':
    'Bloquées',
  'CENSO (OSV, KEV)':
    'CENSO (OSV, KEV)',
  'CENSO crea il token e lo scrive come variabile CI mascherata (e nascosta dove GitLab lo consente) CENSO_GATE_TOKEN del progetto: serve il ruolo Maintainer al token di scrittura.':
    'CENSO crée le jeton et l’écrit comme variable CI masquée (et cachée là où GitLab le permet) CENSO_GATE_TOKEN du projet : le jeton d’écriture nécessite le rôle Maintainer.',
  'CENSO non ha potuto scrivere la variabile CI: copiala tu adesso.':
    'CENSO n’a pas pu écrire la variable CI : copiez-la vous-même maintenant.',
  'Cambia la regola':
    'Changer la règle',
  'Cancello':
    'Barrière',
  'Cancello di sicurezza':
    'Barrière de sécurité',
  'Cancello di sicurezza e VEX (ultimi 7 giorni)':
    'Barrière de sécurité et VEX (7 derniers jours)',
  'Cancello spento, variabile CI tolta.':
    'Barrière désactivée, variable CI supprimée.',
  'Cancello spento. Togli tu la variabile CI CENSO_GATE_TOKEN dal progetto.':
    'Barrière désactivée. Supprimez vous-même la variable CI CENSO_GATE_TOKEN du projet.',
  'Che cosa fa il cancello':
    'Ce que fait la barrière',
  'Chi legge la valutazione — un collega, un cliente, un’autorità — deve poterla verificare.':
    'Qui lit l’évaluation — un collègue, un client, une autorité — doit pouvoir la vérifier.',
  'Con avviso':
    'Avec avertissement',
  'Contano i suoi risultati sui componenti di questa build, se la connessione li riporta per questo progetto o per i suoi artefatti.':
    'Ses résultats sur les composants de cette build comptent, si la connexion les signale pour ce projet ou ses artefacts.',
  'Da correggere':
    'À corriger',
  'Di chi':
    'Par',
  'Dopo, aggiungi il job del cancello alla pipeline con «Aggiungi il job del cancello»: fino ad allora nessuna pipeline lo chiama.':
    'Ensuite, ajoutez le job de la barrière à la pipeline avec «Ajouter le job de la barrière» : jusque-là, aucune pipeline ne l’appelle.',
  'Escluse da VEX':
    'Exclues par VEX',
  'Escluse da una valutazione VEX':
    'Exclues par une évaluation VEX',
  'Esporta CycloneDX VEX':
    'Exporter CycloneDX VEX',
  'Esporta OpenVEX':
    'Exporter OpenVEX',
  'GitLab non raggiungibile in quel momento':
    'GitLab inaccessible à ce moment-là',
  'I runner devono raggiungere CENSO all’indirizzo del cancello (HTTPS, porta 443): se non lo raggiungono, decide la regola «se CENSO non può decidere».':
    'Les runners doivent joindre CENSO à l’adresse de la barrière (HTTPS, port 443) : s’ils n’y arrivent pas, c’est la règle «si CENSO ne peut pas décider» qui décide.',
  'I verdetti del cancello di sicurezza, pipeline per pipeline: il job censo-gate chiede, CENSO legge pipeline e SBOM da GitLab e decide con la regola del progetto. Il cancello si attiva dal dettaglio di ogni progetto.':
    'Les verdicts de la barrière de sécurité, pipeline par pipeline : le job censo-gate demande, CENSO lit la pipeline et le SBOM depuis GitLab et décide avec la règle du projet. La barrière s’active depuis le détail de chaque projet.',
  'Il cancello continua a contarla: è un’annotazione.':
    'La barrière continue de la compter : ce n’est qu’une annotation.',
  'Il cancello di sicurezza, dal dettaglio del progetto: a ogni pipeline il job censo-gate chiede a CENSO un verdetto sull’SBOM di quella pipeline — superato, avviso (job arancione) o bloccato — secondo una regola: avvisa o blocca, su vulnerabilità sfruttate attivamente o anche critiche e alte, che cosa fare se CENSO non può decidere, quali fonti contano. CENSO legge da sé pipeline e SBOM da GitLab; il token del cancello vale solo per i verdetti di quel progetto e sta nella variabile CI mascherata CENSO_GATE_TOKEN. Il rapporto finisce nel log del job, con il collegamento al verdetto in CENSO.':
    'La barrière de sécurité, depuis le détail du projet : à chaque pipeline, le job censo-gate demande à CENSO un verdict sur le SBOM de cette pipeline — réussi, avertissement (job orange) ou bloqué — selon une règle : avertir ou bloquer, sur les vulnérabilités activement exploitées ou aussi critiques et élevées, que faire si CENSO ne peut pas décider, quelles sources comptent. CENSO lit lui-même la pipeline et le SBOM depuis GitLab ; le jeton de la barrière ne vaut que pour les verdicts de ce projet et se trouve dans la variable CI masquée CENSO_GATE_TOKEN. Le rapport finit dans le log du job, avec le lien vers le verdict dans CENSO.',
  'Il cancello non la conta finché la valutazione è in vigore.':
    'La barrière ne la compte pas tant que l’évaluation est en vigueur.',
  'Il cancello non è attivo. Acceso, ogni pipeline chiede a CENSO un verdetto sul proprio SBOM: le vulnerabilità sfruttate attivamente (o anche le critiche e le alte) diventano un avviso o un blocco, con il rapporto nel log del job.':
    'La barrière n’est pas active. Activée, chaque pipeline demande à CENSO un verdict sur son propre SBOM : les vulnérabilités activement exploitées (ou aussi les critiques et les élevées) deviennent un avertissement ou un blocage, avec le rapport dans le log du job.',
  'Il cancello si spegne e il token si revoca: il job censo-gate resta nel file ma non parte più senza la variabile. Continuare?':
    'La barrière se désactive et le jeton est révoqué : le job censo-gate reste dans le fichier mais ne démarre plus sans la variable. Continuer ?',
  'Il job censo-gate chiede a CENSO, dopo censo-sbom, il verdetto sull’SBOM di questa pipeline secondo la regola del cancello, e stampa il rapporto nel log. Il token resta nella variabile CI mascherata, mai nel file.':
    'Le job censo-gate demande à CENSO, après censo-sbom, le verdict sur le SBOM de cette pipeline selon la règle de la barrière, et affiche le rapport dans le log. Le jeton reste dans la variable CI masquée, jamais dans le fichier.',
  'Il job censo-gate parte dopo censo-sbom e chiede a CENSO il verdetto sull’SBOM di quella pipeline: esce con 0 se passa, 3 per un avviso (job arancione, la pipeline prosegue), 1 se blocca.':
    'Le job censo-gate démarre après censo-sbom et demande à CENSO le verdict sur le SBOM de cette pipeline : il se termine avec 0 s’il réussit, 3 pour un avertissement (job orange, la pipeline continue), 1 s’il bloque.',
  'Il job diventa arancione e la pipeline prosegue: il modo con cui cominciare.':
    'Le job devient orange et la pipeline continue : la façon de commencer.',
  'Il job fallisce; con «Pipelines must succeed» il merge si ferma.':
    'Le job échoue ; avec «Pipelines must succeed» le merge s’arrête.',
  'Il rapporto stampato nel log della pipeline':
    'Le rapport affiché dans le log de la pipeline',
  'Il token attuale smette subito di funzionare: le pipeline in corso prenderanno la regola «se CENSO non può decidere». Continuare?':
    'Le jeton actuel arrête immédiatement de fonctionner : les pipelines en cours suivront la règle «si CENSO ne peut pas décider». Continuer ?',
  'Il token del cancello':
    'Le jeton de la barrière',
  'Il token del cancello non è ancora nella variabile CI: senza, il job non parte. Attiva il cancello o rigenera il token.':
    'Le jeton de la barrière n’est pas encore dans la variable CI : sans lui, le job ne démarre pas. Activez la barrière ou régénérez le jeton.',
  'Immagine di curl':
    'Image de curl',
  'In GitLab: Impostazioni → CI/CD → Variabili → Aggiungi variabile. Chiave CENSO_GATE_TOKEN, visibilità «Mascherata» (o «Mascherata e nascosta»), «Proteggi la variabile» spento, «Espandi il riferimento della variabile» spento.':
    'Dans GitLab : Paramètres → CI/CD → Variables → Ajouter une variable. Clé CENSO_GATE_TOKEN, visibilité «Masquée» (ou «Masquée et cachée»), «Protéger la variable» désactivé, «Développer la référence de variable» désactivé.',
  'In scadenza':
    'Bientôt expirées',
  'Indirizzo che il job chiama':
    'Adresse que le job appelle',
  'La scrittura non è attiva su questa connessione: CENSO crea il token e lo mostra una volta sola, da copiare tu nella variabile CI CENSO_GATE_TOKEN (mascherata, non protetta).':
    'L’écriture n’est pas activée pour cette connexion : CENSO crée le jeton et l’affiche une seule fois, à copier vous-même dans la variable CI CENSO_GATE_TOKEN (masquée, non protégée).',
  'La valutazione si revoca e resta nello storico: il cancello torna a contare la vulnerabilità. Continuare?':
    'L’évaluation est révoquée et reste dans l’historique : la barrière recommence à compter la vulnérabilité. Continuer ?',
  'La variabile non è protetta, così vale anche per i rami e le merge request: chi può far girare una pipeline può leggerla, ma con quel token ottiene solo i verdetti di questo progetto.':
    'La variable n’est pas protégée, elle vaut donc aussi pour les branches et les merge request : qui peut faire tourner une pipeline peut la lire, mais avec ce jeton il n’obtient que les verdicts de ce projet.',
  'Lascia passare':
    'Laisser passer',
  'Le fonti che contano':
    'Les sources qui comptent',
  'Le pipeline delle fork non hanno la variabile CENSO_GATE_TOKEN: lì il job del cancello non parte.':
    'Les pipelines des forks n’ont pas la variable CENSO_GATE_TOKEN : là, le job de la barrière ne démarre pas.',
  'Le valutazioni VEX di tutti i progetti: cosa l’organizzazione dichiara su una vulnerabilità in un suo componente (stati e giustificazioni di CycloneDX). Scadono sempre; il cancello conta di nuovo quelle scadute o revocate. Si scrivono dal dettaglio del progetto o da un verdetto del cancello.':
    'Les évaluations VEX de tous les projets : ce que l’organisation déclare sur une vulnérabilité dans l’un de ses composants (états et justifications de CycloneDX). Elles expirent toujours ; la barrière compte à nouveau celles qui sont expirées ou révoquées. Elles s’écrivent depuis le détail du projet ou depuis un verdict de la barrière.',
  'Le valutazioni in vigore escono anche verso i clienti: CycloneDX VEX o OpenVEX, con gli stessi stati e le stesse spiegazioni.':
    'Les évaluations en vigueur sortent aussi vers les clients : CycloneDX VEX ou OpenVEX, avec les mêmes états et les mêmes explications.',
  'Manca il dominio della console (Amministrazione → Piattaforma → Dominio): il job non saprebbe dove chiamare CENSO.':
    'Le domaine de la console est manquant (Administration → Plateforme → Domaine) : le job ne saurait pas où appeler CENSO.',
  'Modo «avvisa»: quello che bloccherebbe diventa un job arancione, la pipeline prosegue.':
    'Mode «avertir» : ce qui bloquerait devient un job orange, la pipeline continue.',
  'Modo «blocca»: il job fallisce e, con «Pipelines must succeed», il merge si ferma finché non si corregge o non si scrive una valutazione VEX.':
    'Mode «bloquer» : le job échoue et, avec «Pipelines must succeed», le merge s’arrête jusqu’à ce que ce soit corrigé ou qu’une évaluation VEX soit écrite.',
  'Nella pipeline non c’è il job censo-sbom: la stessa merge request lo aggiunge, perché il cancello legge l’SBOM che produce.':
    'La pipeline n’a pas le job censo-sbom : la même merge request l’ajoute, car la barrière lit le SBOM qu’il produit.',
  'Nessun SBOM nella pipeline, GitLab o CENSO irraggiungibili: il verdetto dice sempre perché.':
    'Aucun SBOM dans la pipeline, GitLab ou CENSO inaccessibles : le verdict dit toujours pourquoi.',
  'Nessun progetto ha ancora il cancello attivo.':
    'Aucun projet n’a encore la barrière active.',
  'Nessun token: rigeneralo.':
    'Aucun jeton : régénérez-le.',
  'Nessun verdetto finora: arriva alla prima pipeline con il job censo-gate.':
    'Aucun verdict jusqu’ici : il arrive à la première pipeline avec le job censo-gate.',
  'Nessuna valutazione VEX.':
    'Aucune évaluation VEX.',
  'Non decise':
    'Non décidées',
  'Nuova valutazione VEX':
    'Nouvelle évaluation VEX',
  'Nuova valutazione su':
    'Nouvelle évaluation sur',
  'Per esempio un falso positivo del catalogo. Spenta, vale solo per questo progetto.':
    'Par exemple un faux positif du catalogue. Désactivée, elle ne s’applique qu’à ce projet.',
  'Per esempio: il lookup JNDI è disattivato e la classe JndiLookup è tolta dal jar (verificato nel build).':
    'Par exemple : le lookup JNDI est désactivé et la classe JndiLookup est retirée du jar (vérifié dans la build).',
  'Per tutti i progetti del tenant':
    'Pour tous les projets du tenant',
  'Perché non siamo interessati':
    'Pourquoi nous ne sommes pas concernés',
  'Pipeline bloccate':
    'Pipelines bloquées',
  'Pipeline con avviso':
    'Pipelines avec avertissement',
  'Pipeline superate':
    'Pipelines réussies',
  'Progetti con il cancello':
    'Projets avec la barrière',
  'Quello che l’organizzazione dichiara su questa vulnerabilità in questo componente, con gli stati e le giustificazioni di CycloneDX. Scade sempre: alla scadenza il cancello torna a contarla. Ogni modifica resta nello storico.':
    'Ce que l’organisation déclare sur cette vulnérabilité dans ce composant, avec les états et les justifications de CycloneDX. Elle expire toujours : à l’expiration, la barrière recommence à la compter. Chaque modification reste dans l’historique.',
  'Ramo o MR':
    'Branche ou MR',
  'Regola del cancello di sicurezza':
    'Règle de la barrière de sécurité',
  'Regola salvata.':
    'Règle enregistrée.',
  'Revocate':
    'Révoquées',
  'Rigenera il token':
    'Régénérer le jeton',
  'Risposta':
    'Réponse',
  'Salva la regola':
    'Enregistrer la règle',
  'Salva la valutazione':
    'Enregistrer l’évaluation',
  'Scade il':
    'Expire le',
  'Scadute':
    'Expirées',
  'Se CENSO non può decidere':
    'Si CENSO ne peut pas décider',
  'Sempre: il motore che valuta ogni SBOM.':
    'Toujours : le moteur qui évalue chaque SBOM.',
  'Sfruttate attivamente e critiche':
    'Activement exploitées et critiques',
  'Sfruttate attivamente, critiche e alte':
    'Activement exploitées, critiques et élevées',
  'Si vede solo adesso: CENSO ne conserva solo l’impronta. Se lo perdi, rigeneralo.':
    'Il ne se voit que maintenant : CENSO n’en conserve que l’empreinte. Si vous le perdez, régénérez-le.',
  'Solo per la versione {v}':
    'Seulement pour la version {v}',
  'Spegni il cancello':
    'Désactiver la barrière',
  'Spenta, vale per ogni versione del componente.':
    'Désactivée, elle s’applique à toutes les versions du composant.',
  'Spiegazione':
    'Explication',
  'Superate':
    'Réussies',
  'Token scritto nella variabile CI mascherata CENSO_GATE_TOKEN del progetto.':
    'Jeton écrit dans la variable CI masquée CENSO_GATE_TOKEN du projet.',
  'Token …{h} creato {quando}':
    'Jeton …{h} créé {quando}',
  'VEX':
    'VEX',
  'VEX in scadenza (30 giorni)':
    'VEX bientôt expirées (30 jours)',
  'VEX scadute':
    'VEX expirées',
  'Valuta (VEX)':
    'Évaluer (VEX)',
  'Valutazioni (VEX)':
    'Évaluations (VEX)',
  'Valutazioni VEX in vigore':
    'Évaluations VEX en vigueur',
  'Valutazioni VEX: per una vulnerabilità che non vi riguarda (codice non raggiungibile, configurazione non usata, falso positivo…) si scrive una valutazione con gli stati e le giustificazioni di CycloneDX, una spiegazione e una scadenza: finché è in vigore il cancello non la conta, e il rapporto lo dice. Si esportano per i clienti in CycloneDX VEX o OpenVEX; i tab «Cancello» e «VEX» raccolgono verdetti e valutazioni di tutti i progetti.':
    'Évaluations VEX : pour une vulnérabilité qui ne vous concerne pas (code inaccessible, configuration non utilisée, faux positif…) on écrit une évaluation avec les états et les justifications de CycloneDX, une explication et une expiration : tant qu’elle est en vigueur, la barrière ne la compte pas, et le rapport le dit. Elles s’exportent pour les clients en CycloneDX VEX ou OpenVEX ; les onglets «Barrière» et «VEX» regroupent les verdicts et les évaluations de tous les projets.',
  'Vulnerabilità sfruttate attivamente (CISA KEV)':
    'Vulnérabilités activement exploitées (CISA KEV)',
  'aggiornare':
    'mettre à jour',
  'avvisa':
    'avertir',
  'avviso':
    'avertissement',
  'blocca':
    'bloquer',
  'bloccato':
    'bloqué',
  'c’è un rimedio provvisorio':
    'il existe une solution de contournement provisoire',
  'da copiare a mano nella variabile CI':
    'à copier à la main dans la variable CI',
  'errore interno di CENSO':
    'erreur interne de CENSO',
  'falso positivo':
    'faux positif',
  'il cancello le conta di nuovo':
    'la barrière les compte à nouveau',
  'il codice vulnerabile non è presente':
    'le code vulnérable n’est pas présent',
  'il codice vulnerabile non è raggiungibile':
    'le code vulnérable n’est pas accessible',
  'il job censo-sbom non è riuscito':
    'le job censo-sbom n’a pas réussi',
  'in analisi':
    'en cours d’analyse',
  'in valutazione':
    'en cours d’évaluation',
  'la pipeline non è sul commit indicato dal job':
    'la pipeline n’est pas sur le commit indiqué par le job',
  'la valutazione non è finita in tempo':
    'l’évaluation ne s’est pas terminée à temps',
  'l’SBOM della pipeline non si legge':
    'le SBOM de la pipeline ne se lit pas',
  'nella variabile CI scritta da CENSO':
    'dans la variable CI écrite par CENSO',
  'nessun SBOM, GitLab non raggiungibile…':
    'aucun SBOM, GitLab inaccessible…',
  'nessun job della pipeline ha lasciato un SBOM CycloneDX':
    'aucun job de la pipeline n’a laissé de SBOM CycloneDX',
  'non deciso':
    'non décidé',
  'non interessato':
    'non concerné',
  'non si correggerà':
    'ne sera pas corrigée',
  'non si può correggere':
    'ne peut pas être corrigée',
  'ogni versione':
    'chaque version',
  'pipeline non trovata nel progetto':
    'pipeline introuvable dans le projet',
  'protetto al perimetro':
    'protégé au périmètre',
  'protetto da un controllo di mitigazione':
    'protégé par un contrôle d’atténuation',
  'protetto dal compilatore':
    'protégé par le compilateur',
  'protetto in esecuzione':
    'protégé à l’exécution',
  'risolta':
    'résolue',
  'risolta, con la provenienza (pedigree)':
    'résolue, avec la provenance (pedigree)',
  'scaduta il {d}':
    'expirée le {d}',
  'se CENSO non può decidere':
    'si CENSO ne peut pas décider',
  'serve un ambiente che non c’è':
    'il faut un environnement qui n’existe pas',
  'serve una configurazione che non usiamo':
    'il faut une configuration que nous n’utilisons pas',
  'serve una dipendenza che non c’è':
    'il faut une dépendance qui n’existe pas',
  'sfruttabile: siamo interessati':
    'exploitable : nous sommes concernés',
  'superato':
    'réussi',
  'tornare alla versione precedente':
    'revenir à la version précédente',
  'tutti i progetti':
    'tous les projets',
  'valutazioni':
    'évaluations',
  'verdetti':
    'verdicts',
  '{n} senza catalogo':
    '{n} sans catalogue',
  '{v} di {n} valutati':
    '{v} sur {n} évalués',
  '«Pipelines must succeed» è spento in questo progetto: il cancello fa fallire il job ma non ferma il merge.':
    '«Pipelines must succeed» est désactivé dans ce projet : la barrière fait échouer le job mais n’arrête pas le merge.',
  '— una vulnerabilità dell’SBOM —':
    '— une vulnérabilité du SBOM —',
  'Aggiorna la misura':
    'Mettre à jour la mesure',
  'Aggiornamenti di sicurezza separati da quelli funzionali':
    'Mises à jour de sécurité séparées des mises à jour fonctionnelles',
  'Aggiornamenti firmati o verificabili, canali protetti; dove serve, distribuiti in automatico.':
    'Mises à jour signées ou vérifiables, canaux protégés ; si nécessaire, distribuées automatiquement.',
  'Aggiornamenti senza ritardo, gratuiti, con avvisi':
    'Mises à jour sans délai, gratuites, avec avis',
  'Aggiornamento del fabbricante':
    'Mise à jour du fabricant',
  'Aggiungi come rilascio':
    'Ajouter comme version',
  'Aggiungi un rilascio':
    'Ajouter une version',
  'Al fabbricante, senza indebito ritardo: la vulnerabilità, il prodotto e le versioni interessate.':
    'Au fabricant, sans retard indu : la vulnérabilité, le produit et les versions concernées.',
  'Almeno cinque anni, salvo un uso previsto più breve (art. 13(8)).':
    'Au moins cinq ans, sauf si la durée d’utilisation prévue est plus courte (article 13(8)).',
  'Anche quelle risolte':
    'Même celles résolues',
  'Anche un rilascio già sul mercato prima del CRA: gli obblighi di segnalazione valgono anche per quelli (art. 69(3)).':
    'Même une version déjà sur le marché avant le CRA : les obligations de notification s’appliquent aussi à celles-ci (article 69(3)).',
  'Apri il prodotto':
    'Ouvrir le produit',
  'Apri la segnalazione':
    'Ouvrir la notification',
  'Avvisa sul registro CRA':
    'Alerter sur le registre CRA',
  'CENSO l’ha vista per la prima volta il {q}.':
    'CENSO l’a vue pour la première fois le {q}.',
  'CENSO l’ha vista per la prima volta il {q}: non è per forza il momento della presa di conoscenza, ma non può essere molto dopo.':
    'CENSO l’a vue pour la première fois le {q} : ce n’est pas forcément le moment de la prise de connaissance, mais cela ne peut pas être beaucoup plus tard.',
  'CISA KEV o ENISA EUVD, nei rilasci supportati':
    'CISA KEV ou ENISA EUVD, dans les versions prises en charge',
  'CRA':
    'CRA',
  'CRA Compliance':
    'CRA Compliance',
  'CSIRT coordinatore':
    'CSIRT coordinateur',
  'Cancello di sicurezza nelle pipeline':
    'Barrière de sécurité dans les pipelines',
  'Catalogo CISA delle vulnerabilità sfruttate':
    'Catalogue CISA des vulnérabilités exploitées',
  'Che cosa deve contenere':
    'Ce qu’elle doit contenir',
  'Che cosa fare':
    'Que faire',
  'Chiudi la segnalazione':
    'Fermer la notification',
  'Ciò che i dati non misurano (allegato I, parte II): lo dichiara l’organizzazione, con una nota e il documento che lo prova.':
    'Ce que les données ne mesurent pas (annexe I, partie II) : l’organisation le déclare, avec une note et le document qui le prouve.',
  'Codici di due lettere: la preallerta li indica.':
    'Codes à deux lettres : l’alerte précoce les indique.',
  'Come importatore o distributore: informare il fabbricante senza indebito ritardo e, se il rischio è significativo, le autorità di vigilanza del mercato.':
    'En tant qu’importateur ou distributeur : informer le fabricant sans retard indu et, si le risque est significatif, les autorités de surveillance du marché.',
  'Comincia dai prodotti: quelli nel campo del CRA, il ruolo dell’organizzazione, i progetti che li costruiscono. I rilasci arrivano dai tag con SBOM o si aggiungono a mano.':
    'Commencez par les produits : ceux qui sont dans le champ d’application du CRA, le rôle de l’organisation, les projets qui les construisent. Les versions viennent des tags avec SBOM ou s’ajoutent à la main.',
  'Comunicazioni':
    'Communications',
  'Conferma: partono i termini':
    'Confirmer : les délais démarrent',
  'Confermo adesso quando l’organizzazione ne è venuta a conoscenza':
    'Confirmer maintenant quand l’organisation en a eu connaissance',
  'Contatto del fabbricante per le vulnerabilità':
    'Contact du fabricant pour les vulnérabilités',
  'Controllo in corso…':
    'Vérification en cours…',
  'Critica (allegato IV)':
    'Critique (annexe IV)',
  'CycloneDX':
    'CycloneDX',
  'Da quel momento partono le 24 e le 72 ore. Si può confermare anche dopo, dalla segnalazione.':
    'À partir de ce moment, les 24 et 72 heures démarrent. On peut aussi confirmer plus tard, depuis la notification.',
  'Da valutare':
    'À évaluer',
  'Dagli SBOM dei rilasci supportati, valutati con lo stesso motore del resto di CENSO. «Sfruttata» vuol dire nel catalogo CISA KEV o nell’elenco ENISA EUVD: è ciò che obbliga alla segnalazione.':
    'À partir des SBOM des versions prises en charge, évalués avec le même moteur que le reste de CENSO. «Exploitée» veut dire dans le catalogue CISA KEV ou la liste ENISA EUVD : c’est ce qui déclenche l’obligation de notification.',
  'Dalla piattaforma unica di ENISA, al CSIRT coordinatore{c} e a ENISA. Registra qui ogni invio con il riferimento ricevuto.':
    'Depuis la plateforme unique de signalement de l’ENISA, vers le CSIRT coordinateur{c} et vers l’ENISA. Enregistrez ici chaque envoi avec la référence reçue.',
  'Descrizione della vulnerabilità con gravità e impatto, informazioni su chi la sfrutta se disponibili, dettagli dell’aggiornamento di sicurezza o delle altre misure correttive (art. 14(2)(c)).':
    'Description de la vulnérabilité avec gravité et impact, informations sur qui l’exploite si disponibles, détails de la mise à jour de sécurité ou des autres mesures correctives (article 14(2)(c)).',
  'Descrizione dettagliata dell’incidente con gravità e impatto, tipo di minaccia o causa probabile, misure di mitigazione applicate e in corso (art. 14(4)(c)).':
    'Description détaillée de l’incident avec gravité et impact, type de menace ou cause probable, mesures d’atténuation appliquées et en cours (article 14(4)(c)).',
  'Dichiarati dall’organizzazione':
    'Déclarés par l’organisation',
  'Dichiarato da {chi}':
    'Déclaré par {chi}',
  'Disponibile dal':
    'Disponible à partir du',
  'Distributore':
    'Distributeur',
  'Distribuzione sicura degli aggiornamenti':
    'Distribution sécurisée des mises à jour',
  'Documento di riferimento':
    'Document de référence',
  "Dopo l'aggiornamento: descrizione, prodotti interessati, impatto, gravità e come rimediare, in modo chiaro e accessibile.":
    'Après la mise à jour : description, produits concernés, impact, gravité et comment y remédier, de manière claire et accessible.',
  'Dove tecnicamente possibile, le correzioni di sicurezza escono separate dalle nuove funzioni.':
    'Lorsque c’est techniquement possible, les correctifs de sécurité sortent séparément des nouvelles fonctionnalités.',
  'Elenco ENISA delle vulnerabilità sfruttate':
    'Liste ENISA des vulnérabilités exploitées',
  'Fabbricante':
    'Fabricant',
  'Fabbricante da informare':
    'Fabricant à informer',
  'Facoltativo, ma senza SBOM CENSO non vede le vulnerabilità di questo rilascio.':
    'Facultatif, mais sans SBOM, CENSO ne voit pas les vulnérabilités de cette version.',
  'Gli Stati membri in cui il prodotto è stato reso disponibile, se noti (art. 14(2)(a)).':
    'Les États membres où le produit a été mis à disposition, si connus (article 14(2)(a)).',
  'Gli obblighi di segnalazione dell’art. 14 si applicano dall’11 settembre 2026 (art. 71(2)), anche ai prodotti già sul mercato (art. 69(3)).':
    'Les obligations de notification de l’article 14 s’appliquent à partir du 11 septembre 2026 (article 71(2)), y compris pour les produits déjà sur le marché (article 69(3)).',
  'Gli utenti interessati, e se serve tutti, sulla vulnerabilità e sulle misure per mitigarla, in formato strutturato e leggibile da macchina (art. 14(8)): l’avviso CSAF si scarica qui.':
    'Les utilisateurs concernés, et tous si nécessaire, sur la vulnérabilité et les mesures pour l’atténuer, dans un format structuré et lisible par machine (article 14(8)) : l’avis CSAF se télécharge ici.',
  'Ha delle segnalazioni: si mette fuori ambito, non si cancella':
    'Il a des notifications : il est mis hors champ, pas supprimé',
  'I rilasci con il loro SBOM: dai tag dei progetti di «Software prodotto» (ogni tag, o proposti) o aggiunti a mano, anche quelli già sul mercato prima del CRA, con l’SBOM caricato; si conservano per dieci anni o per il periodo di supporto, e si scaricano in CycloneDX con le vulnerabilità e le valutazioni VEX.':
    'Les versions avec leur SBOM : depuis les tags des projets «Logiciel produit» (chaque tag, ou proposés) ou ajoutées à la main, y compris celles déjà sur le marché avant le CRA, avec le SBOM chargé ; elles sont conservées dix ans ou pendant la période d’assistance, et se téléchargent en CycloneDX avec les vulnérabilités et les évaluations VEX.',
  'I tag sono proposti, li conferma una persona':
    'Les tags sont proposés, une personne les confirme',
  'I termini non sono ancora partiti: partono dal momento in cui l’organizzazione è venuta a conoscenza della vulnerabilità sfruttata o dell’incidente. Lo conferma una persona.':
    'Les délais n’ont pas encore démarré : ils démarrent à partir du moment où l’organisation a eu connaissance de la vulnérabilité exploitée ou de l’incident. Une personne le confirme.',
  'Identificativo (CVE…)':
    'Identifiant (CVE…)',
  'Il CSIRT chiede una relazione intermedia':
    'Le CSIRT demande un rapport intermédiaire',
  'Il dominio dell’editore negli avvisi CSAF.':
    'Le domaine de l’éditeur dans les avis CSAF.',
  'Il prodotto e i suoi rilasci si cancellano dal registro. Continuare?':
    'Le produit et ses versions seront supprimés du registre. Continuer ?',
  'Il rapporto finale segue la misura correttiva o di mitigazione: registrala prima.':
    'Le rapport final suit la mesure corrective ou d’atténuation : enregistrez-la d’abord.',
  'Il registro del Cyber Resilience Act (Reg. UE 2024/2847) per il software che l’organizzazione mette sul mercato: prodotti e rilasci con il loro SBOM, le vulnerabilità sfruttate attivamente da valutare, le segnalazioni dell’art. 14 con i loro termini, i requisiti dell’allegato I.':
    'Le registre du Cyber Resilience Act (règlement (UE) 2024/2847) pour les logiciels que l’organisation met sur le marché : produits et versions avec leur SBOM, les vulnérabilités activement exploitées à évaluer, les notifications de l’article 14 avec leurs délais, les exigences de l’annexe I.',
  'Importante, classe I (allegato III)':
    'Important, classe I (annexe III)',
  'Importante, classe II (allegato III)':
    'Important, classe II (annexe III)',
  'Importatore':
    'Importateur',
  'Incidente grave sulla sicurezza del prodotto (art. 14(4))':
    'Incident grave ayant un impact sur la sécurité du produit (article 14(4))',
  'Informazione agli utenti':
    'Information aux utilisateurs',
  'Informazione al fabbricante':
    'Information au fabricant',
  'Informazione alle autorità di vigilanza del mercato':
    'Information aux autorités de surveillance du marché',
  'Informazioni generali sul prodotto, la natura dello sfruttamento e della vulnerabilità, le misure correttive o di mitigazione prese e quelle che gli utenti possono prendere, la sensibilità delle informazioni (art. 14(2)(b)).':
    'Informations générales sur le produit, la nature de l’exploitation et de la vulnérabilité, les mesures correctives ou d’atténuation prises et celles que les utilisateurs peuvent prendre, la sensibilité des informations (article 14(2)(b)).',
  'Informazioni generali sulla natura dell’incidente, una prima valutazione, le misure correttive o di mitigazione prese e quelle che gli utenti possono prendere, la sensibilità delle informazioni (art. 14(4)(b)).':
    'Informations générales sur la nature de l’incident, une première évaluation, les mesures correctives ou d’atténuation prises et celles que les utilisateurs peuvent prendre, la sensibilité des informations (article 14(4)(b)).',
  'Inviata':
    'Envoyée',
  'Inviata il':
    'Envoyée le',
  'Le correzioni di sicurezza arrivano senza indebito ritardo e senza costi, con un avviso che dice cosa fare.':
    'Les correctifs de sécurité arrivent sans retard indu et sans frais, avec un avis qui indique quoi faire.',
  'Le misure prese e quelle che gli utenti possono prendere vanno nella notifica e nel rapporto finale.':
    'Les mesures prises et celles que les utilisateurs peuvent prendre figurent dans la notification et le rapport final.',
  'Le segnalazioni dell’art. 14 alla piattaforma unica di ENISA, verso il CSIRT coordinatore: i termini partono dalla presa di conoscenza confermata da una persona.':
    'Les notifications de l’article 14 à la plateforme unique de signalement de l’ENISA, vers le CSIRT coordinateur : les délais démarrent à partir de la prise de connaissance confirmée par une personne.',
  'Le vulnerabilità sfruttate attivamente (catalogo CISA KEV o elenco ENISA EUVD) nei rilasci supportati dei prodotti nel campo del CRA, non escluse da una valutazione VEX. Ognuna va valutata: se il prodotto è davvero interessato, si apre la segnalazione; se non lo è, si scrive la VEX dal prodotto.':
    'Les vulnérabilités activement exploitées (catalogue CISA KEV ou liste ENISA EUVD) dans les versions prises en charge des produits dans le champ d’application du CRA, non exclues par une évaluation VEX. Chacune doit être évaluée : si le produit est vraiment concerné, la notification s’ouvre ; si ce n’est pas le cas, le VEX s’écrit depuis le produit.',
  'Le vulnerabilità sfruttate attivamente trovate nei rilasci supportati dei prodotti in ambito, da valutare per la segnalazione; i termini delle segnalazioni (preallerta, notifica, relazione intermedia, rapporto finale) prima che scadano e quando scadono. Gli avvisi vanno anche al responsabile del prodotto.':
    'Les vulnérabilités activement exploitées trouvées dans les versions prises en charge des produits dans le champ d’application, à évaluer pour la notification ; les délais des notifications (alerte précoce, notification, rapport intermédiaire, rapport final) avant qu’ils n’expirent et quand ils expirent. Les alertes vont aussi au responsable du produit.',
  'Manca l’ultimo passo ({p}): per chiudere lo stesso, scrivi perché.':
    'Il manque la dernière étape ({p}) : pour fermer malgré tout, indiquez pourquoi.',
  'Mette il prodotto sul mercato col proprio nome: segnala al CSIRT coordinatore e a ENISA (art. 14).':
    'Met le produit sur le marché sous son propre nom : notifie le CSIRT coordinateur et l’ENISA (article 14).',
  'Mette sul mercato UE un prodotto di un fabbricante extra UE: informa il fabbricante e, se il rischio è significativo, le autorità (art. 19).':
    'Met sur le marché de l’UE un produit d’un fabricant hors UE : informe le fabricant et, si le risque est significatif, les autorités (article 19).',
  'Misura correttiva o di mitigazione':
    'Mesure corrective ou d’atténuation',
  'Mitigazione':
    'Atténuation',
  'Modifica la scheda':
    'Modifier la fiche',
  'Motivo o nota di chiusura':
    'Motif ou note de clôture',
  'Nel campo del CRA':
    'Dans le champ d’application du CRA',
  'Nessun prodotto ancora':
    'Aucun produit pour l’instant',
  'Nessun prodotto nel campo del CRA':
    'Aucun produit dans le champ d’application du CRA',
  'Nessun prodotto: aggiungi quelli che l’organizzazione mette sul mercato.':
    'Aucun produit : ajoutez ceux que l’organisation met sur le marché.',
  'Nessun progetto in Software prodotto: i rilasci si aggiungono a mano.':
    'Aucun projet dans Logiciel produit : les versions s’ajoutent à la main.',
  'Nessun rilascio ancora.':
    'Aucune version pour l’instant.',
  'Nessuna correzione prevista':
    'Aucun correctif prévu',
  'Nessuna misura disponibile':
    'Aucune mesure disponible',
  'Nessuna novità.':
    'Aucune nouveauté.',
  'Nessuna segnalazione.':
    'Aucune notification.',
  'Nessuna vulnerabilità nei rilasci supportati.':
    'Aucune vulnérabilité dans les versions prises en charge.',
  'Nessuna vulnerabilità sfruttata nei rilasci supportati.':
    'Aucune vulnérabilité exploitée dans les versions prises en charge.',
  'Niente da valutare.':
    'Rien à évaluer.',
  'Notifica (72 ore)':
    'Notification (72 heures)',
  'Nuova segnalazione':
    'Nouvelle notification',
  'Nuova segnalazione CRA':
    'Nouvelle notification CRA',
  'Ogni rilascio con il suo SBOM, conservato dieci anni o per il periodo di supporto se più lungo (art. 13(13)). Il CycloneDX scaricato qui ha anche le vulnerabilità e le valutazioni VEX; il documento originale resta quello pubblicato dalla pipeline.':
    'Chaque version avec son SBOM, conservé dix ans ou pendant la période d’assistance si plus longue (article 13(13)). Le CycloneDX téléchargé ici comporte aussi les vulnérabilités et les évaluations VEX ; le document d’origine reste celui publié par la pipeline.',
  'Ogni tag con SBOM diventa un rilascio':
    'Chaque tag avec SBOM devient une version',
  'Per esempio: aggiornare alla 1.0.1, che porta log4j-core 2.17.1; in alternativa togliere la classe JndiLookup.':
    'Par exemple : mettre à jour vers 1.0.1, qui apporte log4j-core 2.17.1 ; sinon, retirer la classe JndiLookup.',
  'Perché fuori dal CRA':
    'Pourquoi hors du CRA',
  'Perché questo periodo di supporto':
    'Pourquoi cette période d’assistance',
  'Perché è fuori dal CRA':
    'Pourquoi il est hors du CRA',
  'Periodo di supporto definito':
    'Période d’assistance définie',
  'Politica CVD pubblicata':
    'Politique CVD publiée',
  'Politica di divulgazione coordinata':
    'Politique de divulgation coordonnée',
  'Politica di divulgazione coordinata (URL)':
    'Politique de divulgation coordonnée (URL)',
  'Politica di divulgazione coordinata delle vulnerabilità':
    'Politique de divulgation coordonnée des vulnérabilités',
  'Preallerta (24 ore)':
    'Alerte précoce (24 heures)',
  'Prodotti':
    'Produits',
  'Prodotti nel CRA':
    'Produits dans le CRA',
  'Prodotti senza contatto':
    'Produits sans contact',
  'Prodotti senza periodo di supporto':
    'Produits sans période d’assistance',
  'Progetti che lo costruiscono':
    'Projets qui le construisent',
  'Prossimo passo':
    'Prochaine étape',
  'Prossimo termine':
    'Prochain délai',
  'Pubblicazione delle vulnerabilità corrette':
    'Publication des vulnérabilités corrigées',
  'Punto di contatto per le vulnerabilità':
    'Point de contact pour les vulnérabilités',
  'Punto di contatto unico per le vulnerabilità':
    'Point de contact unique pour les vulnérabilités',
  'Quando la misura è disponibile partono i 14 giorni del rapporto finale (art. 14(2)(c)); la versione corretta compare nell’avviso CSAF per gli utenti.':
    'Quand la mesure est disponible, les 14 jours du rapport final démarrent (article 14(2)(c)) ; la version corrigée apparaît dans l’avis CSAF pour les utilisateurs.',
  'Quello dello Stato membro dello stabilimento principale.':
    'Celui de l’État membre de l’établissement principal.',
  'Rapporto finale (14 giorni dalla misura correttiva)':
    'Rapport final (14 jours à partir de la mesure corrective)',
  'Rapporto finale (un mese dalla notifica)':
    'Rapport final (un mois à partir de la notification)',
  'Registra':
    'Enregistrer',
  'Registra la misura':
    'Enregistrer la mesure',
  'Registra la richiesta':
    'Enregistrer la demande',
  'Registrata il {q} da {chi}':
    'Enregistrée le {q} par {chi}',
  'Relazione intermedia (su richiesta del CSIRT)':
    'Rapport intermédiaire (à la demande du CSIRT)',
  'Rende disponibile un prodotto altrui: informa il fabbricante e, se il rischio è significativo, le autorità (art. 20).':
    'Met à disposition le produit d’un tiers : informe le fabricant et, si le risque est significatif, les autorités (article 20).',
  'Responsabile (email)':
    'Responsable (e-mail)',
  'Revisioni del codice, test di sicurezza, penetration test: con quale frequenza e su quali rilasci.':
    'Revues de code, tests de sécurité, tests d’intrusion : à quelle fréquence et sur quelles versions.',
  'Riceve gli avvisi del registro.':
    'Reçoit les alertes du registre.',
  'Ricontrolla adesso':
    'Revérifier maintenant',
  'Riferimento ricevuto':
    'Référence reçue',
  'Rilasci':
    'Versions',
  'Rilasci dai tag':
    'Versions depuis les tags',
  'Rilasci supportati':
    'Versions prises en charge',
  'Rimedio provvisorio':
    'Solution de contournement provisoire',
  'Ruolo dell’organizzazione':
    'Rôle de l’organisation',
  'SBOM del rilascio (CycloneDX o SPDX, JSON)':
    'SBOM de la version (CycloneDX ou SPDX, JSON)',
  'SBOM di ogni rilascio supportato':
    'SBOM de chaque version prise en charge',
  'Scarica l’avviso CSAF per gli utenti':
    'Télécharger l’avis CSAF pour les utilisateurs',
  'Scheda del prodotto':
    'Fiche du produit',
  'Se l’incidente è sospettato di essere causato da atti illeciti o malevoli e gli Stati membri in cui il prodotto è disponibile (art. 14(4)(a)).':
    'Si l’incident est suspecté d’être causé par des actes illicites ou malveillants, et les États membres où le produit est disponible (article 14(4)(a)).',
  'Segnalazione':
    'Notification',
  'Segnalazioni':
    'Notifications',
  'Segnalazioni nei termini':
    'Notifications dans les délais',
  'Senza presa di conoscenza':
    'Sans prise de connaissance',
  'Sfruttata secondo':
    'Exploitée selon',
  'Sfruttate aperte':
    'Exploitées, ouvertes',
  'Sfruttate da valutare':
    'Exploitées, à évaluer',
  'Sito del fabbricante (https)':
    'Site du fabricant (https)',
  'Solo le sfruttate attivamente ({n} di {m})':
    'Seulement les activement exploitées ({n} sur {m})',
  'Solo se il rischio di cibersicurezza è significativo: le autorità di vigilanza del mercato degli Stati membri in cui il prodotto è disponibile.':
    'Seulement si le risque de cybersécurité est significatif : les autorités de surveillance du marché des États membres où le produit est disponible.',
  'Sospetto di atti illeciti o malevoli':
    'Suspicion d’actes illicites ou malveillants',
  'Sostiene un software libero destinato ad attività commerciali: segnala nella misura in cui partecipa allo sviluppo (art. 24).':
    'Soutient un logiciel libre destiné à des activités commerciales : notifie dans la mesure où il participe au développement (article 24).',
  'Stati membri':
    'États membres',
  'Stati membri in cui il prodotto è disponibile':
    'États membres où le produit est disponible',
  'Stati membri in cui è disponibile':
    'États membres où il est disponible',
  'Stato del rilascio':
    'Statut de la version',
  'Steward open source':
    'Steward de logiciels open source',
  'Supportato fino al':
    'Pris en charge jusqu’au',
  'Supporto fino al':
    'Assistance jusqu’au',
  'Tag con SBOM non ancora nel registro:':
    'Tags avec SBOM pas encore dans le registre :',
  'Termini scaduti':
    'Délais expirés',
  'Test e riesami di sicurezza efficaci e regolari':
    'Tests et réexamens de sécurité efficaces et réguliers',
  'Un indirizzo email o una pagina per segnalare (art. 13(17)).':
    'Une adresse e-mail ou une page pour signaler (article 13(17)).',
  'Un prodotto con elementi digitali messo a disposizione sul mercato UE. Fuori: i servizi SaaS senza componenti installati dal cliente, il software usato solo internamente, i prodotti regolati da altre norme (dispositivi medici, veicoli…).':
    'Un produit comportant des éléments numériques mis à disposition sur le marché de l’UE. Hors champ : les services SaaS sans composants installés par le client, les logiciels utilisés uniquement en interne, les produits régis par d’autres réglementations (dispositifs médicaux, véhicules…).',
  'Una politica CVD adottata e applicata: chi riceve le segnalazioni, in quanto tempo risponde, come coordina la pubblicazione.':
    'Une politique CVD adoptée et appliquée : qui reçoit les notifications, en combien de temps elle répond, comment elle coordonne la publication.',
  'Uscito il':
    'Sortie le',
  'Vai ai prodotti':
    'Aller aux produits',
  'Versione corretta':
    'Version corrigée',
  'Vista da CENSO':
    'Vue par CENSO',
  'Vulnerabilità nei rilasci supportati':
    'Vulnérabilités dans les versions prises en charge',
  'Vulnerabilità sfruttata attivamente (art. 14(2))':
    'Vulnérabilité activement exploitée (article 14(2))',
  'Vulnerabilità sfruttate trattate senza ritardo':
    'Vulnérabilités exploitées traitées sans retard',
  'Vuoto: il periodo del prodotto.':
    'Vide : la période du produit.',
  'a mano, con SBOM':
    'à la main, avec SBOM',
  'a mano, senza SBOM':
    'à la main, sans SBOM',
  'assente':
    'absent',
  'chiusa':
    'fermée',
  'confermata da {chi}':
    'confirmée par {chi}',
  'da definire':
    'à définir',
  'da inviare':
    'à envoyer',
  'dalla piattaforma ENISA o dal CSIRT':
    'depuis la plateforme ENISA ou depuis le CSIRT',
  'dopo la misura correttiva':
    'après la mesure corrective',
  'entro {q}':
    'd’ici {q}',
  'esclusa da una VEX':
    'exclue par un VEX',
  'fuori dal CRA':
    'hors CRA',
  'i tag sono proposti':
    'les tags sont proposés',
  'i termini non sono ancora partiti':
    'les délais n’ont pas encore démarré',
  'il CSIRT chiede una relazione intermedia':
    'le CSIRT demande un rapport intermédiaire',
  'il registro del Cyber Resilience Act (Reg. UE 2024/2847) per il software che l’organizzazione mette sul mercato (add-on CENSO CRA). I prodotti, ciascuno con il perché è dentro o fuori dal CRA, la categoria, il ruolo dell’organizzazione — fabbricante, steward open source, importatore, distributore — il periodo di supporto, il punto di contatto per le vulnerabilità, la politica di divulgazione e il CSIRT coordinatore.':
    'le registre du Cyber Resilience Act (règlement (UE) 2024/2847) pour les logiciels que l’organisation met sur le marché (add-on CENSO CRA). Les produits, chacun avec la raison pour laquelle il est dans ou hors du CRA, la catégorie, le rôle de l’organisation — fabricant, steward de logiciels open source, importateur, distributeur — la période d’assistance, le point de contact pour les vulnérabilités, la politique de divulgation et le CSIRT coordinateur.',
  'in attesa della presa di conoscenza':
    'en attente de la prise de connaissance',
  'incidente grave':
    'incident grave',
  'inviata: {p}':
    'envoyée : {p}',
  'misura correttiva registrata':
    'mesure corrective enregistrée',
  'nel campo':
    'dans le champ',
  'nel campo del CRA':
    'dans le champ d’application du CRA',
  'nessun sospetto di atti malevoli':
    'aucune suspicion d’actes malveillants',
  'non più nei rilasci supportati':
    'plus dans les versions prises en charge',
  'ogni tag con SBOM diventa un rilascio':
    'chaque tag avec SBOM devient une version',
  'presa di conoscenza confermata':
    'prise de connaissance confirmée',
  'presa di conoscenza corretta':
    'prise de connaissance corrigée',
  'prodotto CRA':
    'produit CRA',
  'punto di contatto per le vulnerabilità':
    'point de contact pour les vulnérabilités',
  'ritirato':
    'retiré',
  'segnalata':
    'notifiée',
  'segnalazione aperta':
    'notification ouverte',
  'segnalazione chiusa':
    'notification fermée',
  'senza termine fisso':
    'sans délai fixe',
  'solo su richiesta':
    'seulement sur demande',
  'sospetto di atti illeciti o malevoli':
    'suspicion d’actes illicites ou malveillants',
  'supportato':
    'pris en charge',
  'supporto finito':
    'assistance terminée',
  'tag {r} di {p}':
    'tag {r} de {p}',
  'tutti con SBOM':
    'tous avec SBOM',
  'vulnerabilità sfruttata':
    'vulnérabilité exploitée',
  '{f}: si conserva com’è, per dieci anni o per il periodo di supporto.':
    '{f} : il est conservé tel quel, dix ans ou pendant la période d’assistance.',
  '{n} fuori ambito':
    '{n} hors champ',
  '{n} nuove vulnerabilità sfruttate da valutare.':
    '{n} nouvelles vulnérabilités exploitées à évaluer.',
  '{n} senza SBOM':
    '{n} sans SBOM',
  '«Da valutare»: ogni ora CENSO cerca nei rilasci supportati dei prodotti nel campo le vulnerabilità sfruttate attivamente — catalogo CISA KEV o elenco ENISA EUVD — non escluse da una VEX, e ne avvisa il responsabile. Da lì si apre la segnalazione dell’art. 14: i termini partono quando una persona conferma la presa di conoscenza (CENSO mostra a parte quando l’ha vista) — preallerta entro 24 ore, notifica entro 72, rapporto finale entro 14 giorni dalla misura correttiva o, per un incidente grave, entro un mese dalla notifica; la relazione intermedia quando la chiede il CSIRT. Ogni invio si registra con il riferimento ricevuto, ogni termine ha i suoi promemoria e la cronologia resta. Per gli utenti, l’avviso CSAF leggibile da macchina.':
    '«À évaluer» : chaque heure, CENSO recherche dans les versions prises en charge des produits dans le champ les vulnérabilités activement exploitées — catalogue CISA KEV ou liste ENISA EUVD — non exclues par un VEX, et en avertit le responsable. À partir de là, la notification de l’article 14 s’ouvre : les délais démarrent quand une personne confirme la prise de connaissance (CENSO indique à part quand il l’a vue) — alerte précoce dans les 24 heures, notification dans les 72, rapport final dans les 14 jours suivant la mesure corrective ou, pour un incident grave, dans le mois suivant la notification ; le rapport intermédiaire quand le CSIRT le demande. Chaque envoi s’enregistre avec la référence reçue, chaque délai a ses propres rappels et l’historique reste. Pour les utilisateurs, l’avis CSAF lisible par machine.',
  '«Requisiti»: l’allegato I, parte II, misurato prodotto per prodotto dove i dati lo dicono (SBOM dei rilasci, vulnerabilità trattate, segnalazioni nei termini, contatto, supporto, cancello nelle pipeline) e dichiarato dall’organizzazione dove non lo dicono (politica CVD, test, pubblicazione delle correzioni, distribuzione sicura degli aggiornamenti).':
    '«Exigences» : l’annexe I, partie II, mesurée produit par produit là où les données le disent (SBOM des versions, vulnérabilités traitées, notifications dans les délais, contact, assistance, barrière dans les pipelines) et déclarée par l’organisation là où elles ne le disent pas (politique CVD, tests, publication des correctifs, distribution sécurisée des mises à jour).',
  'Aree':
    'Espaces',
  'Aree della console':
    'Espaces de la console',
  'Cicli di vita e costi':
    'Cycles de vie et coûts',
  'Come stanno adesso i sistemi che contano: cruscotto, allarmi, notifiche.':
    'L’état actuel des systèmes qui comptent : tableau de bord, alarmes, notifications.',
  'Compliance':
    'Conformité',
  'Conformità':
    'Conformité',
  'Cosa c’è e come è collegato: raccolta, inventario, servizi, software, traffico, integrazioni.':
    'Ce qui existe et comment c’est relié : collecte, inventaire, services, logiciels, trafic, intégrations.',
  'Difese e sorgenti':
    'Défenses et sources',
  'Home':
    'Accueil',
  'I beni dell’organizzazione, le licenze del software e le anagrafiche.':
    'Les actifs de l’organisation, les licences logicielles et les référentiels.',
  'La console è divisa in aree — Discovery, Planning, Monitoring (con Eagle), Security, Asset, Contracts, Compliance, Settings: il pulsante con la griglia in alto a sinistra le mostra, e il menu di sinistra tiene solo le sezioni dell’area scelta. Si vedono le aree in cui il tuo ruolo apre almeno una pagina. Alcune pagine stanno in più aree (Patching in Security e Planning, Report in Planning e Compliance, Audit in Compliance e Settings, Licenze dei software in Asset e Contracts, Anagrafiche in Asset e Settings). Aprendo una pagina di un’altra area l’area cambia da sola, e tornando su un’area si riparte dall’ultima pagina aperta lì. La home mostra le aree e sotto la dashboard; Home e Preferiti restano in cima al menu in ogni area, e il filtro del menu e ⌘K cercano in tutte.':
    'La console est divisée en espaces — Discovery, Planning, Monitoring (avec Eagle), Security, Asset, Contracts, Compliance, Settings : le bouton en grille en haut à gauche les affiche, et le menu de gauche ne garde que les sections de l’espace choisi. Vous voyez les espaces dans lesquels votre rôle ouvre au moins une page. Certaines pages se trouvent dans plusieurs espaces (Patching dans Security et Planning, Rapports dans Planning et Compliance, Audit dans Compliance et Settings, Licences logicielles dans Asset et Contracts, Référentiels dans Asset et Settings). Ouvrir une page d’un autre espace change l’espace tout seul, et en revenant sur un espace on reprend à la dernière page ouverte. L’accueil affiche les espaces et, dessous, le tableau de bord ; Accueil et Favoris restent en haut du menu dans chaque espace, et le filtre du menu et ⌘K cherchent dans tous.',
  'Monitoring':
    'Supervision',
  'NIS2, DORA e CRA, con i registri e i report che servono a dimostrarlo.':
    'NIS2, DORA et CRA, avec les registres et les rapports qui le démontrent.',
  'Planning':
    'Planification',
  'Postura e difese: vulnerabilità, cifratura, certificati, patching, sorgenti di sicurezza.':
    'Posture et défenses : vulnérabilités, chiffrement, certificats, correctifs, sources de sécurité.',
  'Quanto margine resta, quanto costa, che cosa scade: capacity, costi cloud, cicli di vita, patching, report.':
    'La marge restante, ce que cela coûte, ce qui expire : capacité, coûts cloud, cycles de vie, correctifs, rapports.',
  'Registri e report':
    'Registres et rapports',
  'Security':
    'Sécurité',
  'Settings':
    'Paramètres',
  'Utenti e ruoli, impostazioni, chiavi API, riconoscimento, audit.':
    'Utilisateurs et rôles, paramètres, clés API, reconnaissance, audit.',
  'Predefiniti di CENSO':
    'Prédéfinis par CENSO',
  'Personalizzati':
    'Personnalisés',
  'Nessun ruolo personalizzato: duplica un ruolo predefinito e ritoccalo, o creane uno nuovo.':
    'Aucun rôle personnalisé : dupliquez un rôle prédéfini et ajustez-le, ou créez-en un nouveau.',
  'Predefinito':
    'Prédéfini',
  'Ruolo predefinito di CENSO: i permessi si aggiornano da soli con le nuove funzioni, ognuna col livello della sua area. Si assegna così com’è; per cambiarlo, duplicalo.':
    'Rôle prédéfini par CENSO : ses permissions se mettent à jour d’elles-mêmes avec les nouvelles fonctions, chacune avec le niveau de son domaine. Il s’attribue tel quel ; pour le modifier, dupliquez-le.',
  'Duplica per personalizzarlo':
    'Dupliquer pour le personnaliser',
  'Ruoli predefiniti di CENSO':
    'Rôles prédéfinis par CENSO',
  'Team sistemi':
    'Équipe systèmes',
  'Responsabile compliance':
    'Responsable conformité',
  'Auditor':
    'Auditeur',
  'NOC':
    'NOC',
  'Opera su sicurezza, traffico e conformità; consulta inventario e pianificazione. Niente credenziali né impostazioni.':
    'Agit sur la sécurité, le trafic et la conformité ; consulte l’inventaire et la planification. Ni identifiants ni paramètres.',
  'Opera su rete, raccolta, configurazioni degli apparati, DNS, IPAM e firewall; vede solo le credenziali di rete.':
    'Agit sur le réseau, la collecte, les configurations des équipements, le DNS, l’IPAM et les pare-feu ; ne voit que les identifiants réseau.',
  'Opera su server, virtualizzazione, cloud, backup, agenti, patching e certificati; consulta la rete.':
    'Agit sur les serveurs, la virtualisation, le cloud, les sauvegardes, les agents, le patching et les certificats ; consulte le réseau.',
  'Opera sul software prodotto (pipeline, SBOM, cancello, VEX) e sul registro CRA; consulta il software installato.':
    'Agit sur les logiciels produits (pipelines, SBOM, porte de sécurité, VEX) et sur le registre CRA ; consulte les logiciels installés.',
  'Opera su asset, contratti, licenze del software e anagrafiche; consulta inventario, scadenze e costi.':
    'Agit sur les actifs, les contrats, les licences logicielles et les référentiels ; consulte l’inventaire, les échéances et les coûts.',
  'Opera su NIS2, DORA e CRA e sui report; consulta tutto il resto tranne credenziali, chiavi BitLocker e impostazioni.':
    'Agit sur NIS2, DORA, CRA et les rapports ; consulte tout le reste sauf les identifiants, les clés BitLocker et les paramètres.',
  'Consulta tutto in sola lettura, registro di audit compreso; niente credenziali, chiavi BitLocker né impostazioni.':
    'Consulte tout en lecture seule, journal d’audit compris ; ni identifiants, ni clés BitLocker, ni paramètres.',
  'Consulta inventario, servizi, apparati, indirizzi, asset e stato dei sistemi; non modifica nulla.':
    'Consulte l’inventaire, les services, les équipements, les adresses, les actifs et l’état des systèmes ; ne modifie rien.',
  'Opera sul monitoraggio (cruscotto, allarmi, notifiche); consulta inventario, rete e capacity.':
    'Agit sur la supervision (tableau de bord, alarmes, notifications) ; consulte l’inventaire, le réseau et la capacité.',
  'Ruoli predefiniti: CENSO ne porta nove pronti da assegnare — Team sicurezza, Team rete, Team sistemi, DevSecOps, Asset e contratti, Responsabile compliance, Auditor, Help desk, NOC — in cima all’elenco dei ruoli e nel selettore degli utenti. Ognuno dà un livello per area del portale, con poche eccezioni (il team di rete vede solo le credenziali di rete, l’auditor non vede le chiavi BitLocker), e le funzioni nuove arrivano da sole col livello della loro area. Non si modificano: «Duplica per personalizzarlo» ne fa una copia da cambiare.':
    'Rôles prédéfinis : CENSO en fournit neuf prêts à attribuer — Équipe sécurité, Équipe réseau, Équipe systèmes, DevSecOps, Actifs et contrats, Responsable conformité, Auditeur, Help desk, NOC — en tête de la liste des rôles et dans le sélecteur des utilisateurs. Chacun donne un niveau par domaine du portail, avec quelques exceptions (l’équipe réseau ne voit que les identifiants réseau, l’auditeur ne voit pas les clés BitLocker), et les nouvelles fonctions arrivent d’elles-mêmes avec le niveau de leur domaine. Ils ne se modifient pas : «Dupliquer pour le personnaliser» en fait une copie à modifier.',
  'Artifactory: un access token con permesso Read sui repository local (e sui build, per collegare gli artefatti alle pipeline); Xray si rileva da solo. Nexus: un utente con i privilegi di browse e read sui repository hosted, o un user token; l’indirizzo di Nexus IQ è facoltativo; «Richieste al giorno» tiene CENSO sotto il tetto della Community Edition.':
    'Artifactory : un jeton d’accès avec la permission Read sur les dépôts locaux (et sur les builds, pour relier les artefacts aux pipelines) ; Xray se détecte automatiquement. Nexus : un utilisateur avec les privilèges browse et read sur les dépôts hébergés, ou un jeton utilisateur ; l’adresse de Nexus IQ est facultative ; «Requêtes par jour» maintient CENSO sous le plafond de la Community Edition.',
  'CENSO legge in sottofondo: GitLab ogni 30 minuti (solo i progetti con attività), Artifactory ogni 2 ore, Nexus ogni 6 ore; «Aggiorna» chiede un giro subito. Ogni connessione ha il riquadro «Come preparo … per CENSO?» con i passi.':
    'CENSO lit en arrière-plan : GitLab toutes les 30 minutes (seulement les projets avec de l’activité), Artifactory toutes les 2 heures, Nexus toutes les 6 heures ; «Actualiser» demande immédiatement un passage. Chaque connexion a l’encadré «Comment préparer … pour CENSO ?» avec les étapes.',
  'Collegare GitLab, Artifactory e Nexus':
    'Connecter GitLab, Artifactory et Nexus',
  'Da DevSecOps → Connessioni. Un’istanza su Internet si raggiunge dal Control Plane; una interna da una sonda con la capability «Software prodotto». Con un certificato di una CA interna si incolla la CA (o l’impronta SHA-256) nella connessione.':
    'Depuis DevSecOps → Connexions. Une instance sur Internet est atteinte depuis le Control Plane ; une instance interne depuis une sonde avec la capability «Logiciel produit». Avec un certificat d’une AC interne, collez l’AC (ou l’empreinte SHA-256) dans la connexion.',
  'DevSecOps':
    'DevSecOps',
  'GitLab: un token di sola lettura (scope read_api, ruolo Reporter sui gruppi da leggere) basta per leggere tutto. Il token di scrittura (scope api) è facoltativo e si usa solo con «Consenti la scrittura» accesa: Developer per merge request e pipeline, Maintainer per la variabile del cancello e per avviare Renovate nel runner.':
    'GitLab : un jeton en lecture seule (scope read_api, rôle Reporter sur les groupes à lire) suffit pour tout lire. Le jeton d’écriture (scope api) est facultatif et s’utilise seulement si «Autoriser l’écriture» est activée : Developer pour les merge request et les pipelines, Maintainer pour la variable de la barrière et pour démarrer Renovate dans le runner.',
  'Il job censo-gate dice «CENSO non ha risposto»: i runner non raggiungono l’indirizzo della console in HTTPS; risponde 401: il token è stato rigenerato o il cancello è spento.':
    'Le job censo-gate dit «CENSO n’a pas répondu» : les runners n’atteignent pas l’adresse de la console en HTTPS ; il répond 401 : le jeton a été régénéré ou la barrière est désactivée.',
  'Il software che l’organizzazione costruisce e pubblica — progetti e pipeline di GitLab, artefatti di Artifactory e Nexus, il cancello di sicurezza, Renovate — sta nell’area DevSecOps: vedi la sezione DevSecOps di questa guida.':
    'Le logiciel que l’organisation construit et publie — projets et pipelines GitLab, artefacts Artifactory et Nexus, la barrière de sécurité, Renovate — se trouve dans l’espace DevSecOps : voir la section DevSecOps de ce guide.',
  'Il software che l’organizzazione produce: pipeline e SBOM dei build, registri, vulnerabilità, cancello di sicurezza, Renovate, VEX.':
    'Le logiciel que l’organisation produit : pipelines et SBOM des builds, registres, vulnérabilités, la barrière de sécurité, Renovate, VEX.',
  'La guida operativa completa, con i permessi passo per passo e tutti i casi: docs/operations/devsecops.md.':
    'Le guide opérationnel complet, avec les permissions étape par étape et tous les cas : docs/operations/devsecops.md.',
  'Le fonti e il confronto':
    'Les sources et la comparaison',
  'Le voci del menu':
    'Les entrées du menu',
  'Modifiche in GitLab':
    'Modifications dans GitLab',
  'Panoramica (i numeri dell’area e le connessioni), Progetti, Pipeline, Registri (con i server su cui gira ogni immagine), Componenti e Vulnerabilità (un tab per fonte più «Confronto»), Cancello di sicurezza (i verdetti di tutte le pipeline), Valutazioni VEX, Modifiche in GitLab (ciò che CENSO ha fatto su richiesta), Connessioni, e il registro CRA, che sta anche in Compliance.':
    'Vue d’ensemble (les chiffres de l’espace et les connexions), Projets, Pipeline, Registres (avec les serveurs sur lesquels tourne chaque image), Composants et Vulnérabilités (un onglet par source plus «Comparaison»), Barrière de sécurité (les verdicts de toutes les pipelines), Évaluations VEX, Modifications dans GitLab (ce que CENSO a fait sur demande), Connexions, et le registre CRA, qui se trouve aussi dans Compliance.',
  'Pipeline e job SBOM':
    'Pipeline et job SBOM',
  'Problemi frequenti':
    'Problèmes fréquents',
  'Sicurezza della pipeline':
    'Sécurité de la pipeline',
  'Un progetto «senza SBOM»: nessun job lascia un CycloneDX; aggiungi il job SBOM dal progetto. Componenti «non valutati»: ecosistemi senza catalogo, detti e non nascosti.':
    'Un projet «sans SBOM» : aucun job ne laisse de CycloneDX ; ajoutez le job SBOM depuis le projet. Composants «non évalués» : écosystèmes sans catalogue, nommés ainsi et non masqués.',
  'Valutazioni VEX':
    'Évaluations VEX',
  '«Ultimo giro non riuscito (401)»: il token è scaduto o è stato revocato. «connection reset» o nessuna risposta da un’istanza interna: la connessione parte da una sonda senza la capability «Software prodotto», o che non raggiunge l’indirizzo.':
    '«Dernier passage échoué (401)» : le jeton a expiré ou a été révoqué. «connection reset» ou aucune réponse d’une instance interne : la connexion part d’une sonde sans la capability «Logiciel produit», ou qui n’atteint pas l’adresse.',
  '{nomi} si collegano dall’area DevSecOps:':
    '{nomi} se connectent depuis le domaine DevSecOps :',
  'DevSecOps → Connessioni':
    'DevSecOps → Connexions',
  'Ricompare ovunque nello stesso momento — elenchi, conteggi della lista CI, conformità, scadenze dei software, patching — e finché vale non conta in nessuna di queste viste: un fine supporto accettato non segna la macchina fuori supporto né fuori SLA.':
    'Il réapparaît partout au même moment — listes, compteurs de la liste des CI, conformité, échéances des logiciels, patching — et tant qu’il est valide il ne compte dans aucune de ces vues : une fin de support acceptée ne marque pas la machine hors support ni hors SLA.',
  'Aggiungi il software o il sistema che questo contratto mantiene supportato.':
    'Ajoutez le logiciel ou le système que ce contrat maintient supporté.',
  'Aggiungi un’estensione':
    'Ajouter une extension',
  'CI coperti oggi':
    'CI couverts aujourd’hui',
  'Calcolo…':
    'Calcul…',
  'Che cosa':
    'Quoi',
  'Copri con un contratto':
    'Couvrir par un contrat',
  'Coprirebbe {f} reperti su {n} CI, fino al {d}.':
    'Elle couvrirait {f} constats sur {n} CI, jusqu’au {d}.',
  'Dai reperti di fine supporto':
    'À partir des constats de fin de support',
  'Eliminare l’estensione «{nome}»? I reperti che copre tornano subito fuori supporto.':
    'Supprimer l’extension «{nome}» ? Les constats qu’elle couvre redeviennent aussitôt hors support.',
  'Finché vale, il fine supporto di questo CI non conta come rischio aperto: torna da solo alla fine dell’estensione o del contratto.':
    'Tant qu’elle est valide, la fin de support de ce CI ne compte pas comme un risque ouvert : elle revient d’elle-même à la fin de l’extension ou du contrat.',
  'Fino al':
    'Jusqu’au',
  'I beni coperti dal contratto':
    'Les biens couverts par le contrat',
  'I prodotti e i sistemi che oggi risultano fuori supporto o in scadenza, con quante macchine.':
    'Les produits et systèmes aujourd’hui hors support ou en fin de support proche, avec combien de machines.',
  'Il CI non è registrato come bene: i contratti coprono i beni, ma un’estensione del supporto può scegliere anche i CI.':
    'Le CI n’est pas enregistré comme bien : les contrats couvrent des biens, mais une extension de support peut aussi choisir des CI.',
  'Il produttore offre supporto esteso fino al {d}.':
    'Le fabricant propose un support étendu jusqu’au {d}.',
  'Modifica l’estensione':
    'Modifier l’extension',
  'Nessun contratto in vigore: registralo prima in Contratti (tipo «Supporto esteso»).':
    'Aucun contrat en vigueur : enregistrez-le d’abord dans Contrats (type «Support étendu»).',
  'Nessuna estensione':
    'Aucune extension',
  'Oggi non coprirebbe niente.':
    'Aujourd’hui elle ne couvrirait rien.',
  'Prima l’anteprima: dice quali reperti e quali macchine copre. Niente è scritto finché non confermi.':
    'D’abord l’aperçu : il indique quels constats et quelles machines elle couvre. Rien n’est écrit tant que vous ne confirmez pas.',
  'Prodotto (chiave)':
    'Produit (clé)',
  'Registra l’estensione':
    'Enregistrer l’extension',
  'Righe selezionate':
    'Lignes sélectionnées',
  'Salva l’estensione':
    'Enregistrer l’extension',
  'Scegli prima il prodotto dai reperti: le macchine sono quelle che lo hanno.':
    'Choisissez d’abord le produit parmi les constats : les machines sont celles qui l’ont.',
  'Scegli righe dello stesso prodotto e ciclo (o dello stesso sistema).':
    'Choisissez des lignes du même produit et cycle (ou du même système).',
  'Su quali macchine':
    'Sur quelles machines',
  'Supporto esteso':
    'Support étendu',
  'Supporto esteso da contratto':
    'Support étendu par contrat',
  'Supporto esteso fino al':
    'Support étendu jusqu’au',
  'Supporto esteso in scadenza':
    'Support étendu bientôt terminé',
  'Tutti i CI con questo prodotto':
    'Tous les CI avec ce produit',
  'Un contratto che estende il supporto oltre la data del produttore (ESU di Microsoft, ELS di Red Hat, Extended Support di Oracle…): finché vale, le macchine coperte non risultano fuori supporto ma «supporto esteso fino al …», con il contratto citato; alla fine dell’estensione, o del contratto, tornano fuori supporto da sole.':
    'Un contrat qui étend le support au-delà de la date du fabricant (ESU de Microsoft, ELS de Red Hat, Extended Support d’Oracle…) : tant qu’il est valide, les machines couvertes ne sont pas hors support mais en «support étendu jusqu’au …», avec le contrat cité ; à la fin de l’extension ou du contrat, elles redeviennent hors support d’elles-mêmes.',
  'Windows Server 2012 R2':
    'Windows Server 2012 R2',
  'anno di ESU, codice d’attivazione dove si trova, chi lo rinnova…':
    'année d’ESU, où se trouve la clé d’activation, qui la renouvelle…',
  'ciclo {c}':
    'cycle {c}',
  'coperto fino al {d}':
    'couvert jusqu’au {d}',
  'estensioni':
    'extensions',
  'fino al {d}':
    'jusqu’au {d}',
  'in vigore':
    'en vigueur',
  'le macchine dei beni del contratto, con le date di copertura di ogni bene':
    'les machines des biens du contrat, avec les dates de couverture de chaque bien',
  'non in vigore':
    'pas en vigueur',
  'per le macchine senza un bene registrato':
    'pour les machines sans bien enregistré',
  'per un accordo a volume che vale per tutto il parco':
    'pour un accord en volume qui vaut pour tout le parc',
  'scadenza del contratto (estensione al {d})':
    'fin du contrat (extension jusqu’au {d})',
  'scegli un contratto in vigore':
    'choisissez un contrat en vigueur',
  'scegli, oppure scrivi qui sotto':
    'choisissez, ou saisissez ci-dessous',
  'supporto esteso':
    'support étendu',
  'supporto esteso in scadenza':
    'support étendu bientôt terminé',
  '{n} CI':
    '{n} CI',
  '{n} di {tot} scelte':
    '{n} sur {tot} choisies',
  '{n} già coperti':
    '{n} déjà couverts',
  '{n} selezionate':
    '{n} sélectionnées',
  'Un contratto può anche estendere il supporto di un software o di un sistema oltre la data del produttore (ESU di Microsoft, ELS di Red Hat…): nella scheda «Supporto esteso» scegli che cosa, fino a quando e su quali macchine, e l’anteprima dice quali reperti copre. Finché vale, quelle macchine risultano «supporto esteso fino al …» e non fuori supporto — né in conformità, né nel rischio, né nel patching — e tornano fuori supporto da sole alla fine dell’estensione o del contratto. Il rinnovo porta con sé le estensioni.':
    'Un contrat peut aussi étendre le support d’un logiciel ou d’un système au-delà de la date du fabricant (ESU de Microsoft, ELS de Red Hat…) : dans l’onglet «Support étendu», choisissez quoi, jusqu’à quand et sur quelles machines, et l’aperçu indique quels constats il couvre. Tant qu’il est valide, ces machines apparaissent en «support étendu jusqu’au …» et non hors support — ni en conformité, ni dans le risque, ni dans le patching — et redeviennent hors support d’elles-mêmes à la fin de l’extension ou du contrat. Le renouvellement emporte les extensions.',
  'Le righe coperte da un contratto di supporto esteso compaiono come «supporto esteso» con il contratto; selezionando righe dello stesso prodotto, «Copri con un contratto» crea l’estensione.':
    'Les lignes couvertes par un contrat de support étendu apparaissent comme «support étendu» avec le contrat ; en sélectionnant des lignes du même produit, «Couvrir par un contrat» crée l’extension.',
  'Anagrafica certificati':
    'Registre des certificats',
  'L’anagrafica ha anche una voce di menu sua, «Anagrafica certificati», ed è diversa da «Gestione certificati», che riguarda i certificati richiesti alla CA dell’organizzazione.':
    'Le registre a aussi sa propre entrée de menu, «Registre des certificats», et il diffère de «Gestion des certificats», qui concerne les certificats demandés à l’AC de l’organisation.',
  'I certificati che le macchine espongono sono in Anagrafica certificati.':
    'Les certificats exposés par les machines sont dans Registre des certificats.',
  'Accetta come fornitori':
    'Accepter comme fournisseurs',
  'Asset forniti':
    'Actifs fournis',
  'Avvisi CSAF':
    'Avis CSAF',
  'Business App sostenute':
    'Business Apps soutenues',
  'CENSO propone i fornitori leggendo inventario, contratti e asset: premi «Aggiorna» per il primo catalogo, poi conferma le proposte in «Da catalogare».':
    'CENSO propose les fournisseurs en lisant l’inventaire, les contrats et les actifs : appuyez sur «Actualiser» pour le premier catalogue, puis confirmez les propositions dans «À cataloguer».',
  'CI critici dove è solo installato':
    'CI critiques où il est seulement installé',
  'CISA KEV o ENISA EUVD':
    'CISA KEV ou ENISA EUVD',
  'Calcolata dalle Business App e dai servizi che sostiene direttamente; scegline una solo per correggerla.':
    'Calculée à partir des Business Apps et des services qu’il soutient directement ; n’en choisissez une que pour la corriger.',
  'Cessati':
    'Cessés',
  'Che cosa fornisce':
    'Ce qu’il fournit',
  'Cloud ({n})':
    'Cloud ({n})',
  'Con prodotti fuori supporto':
    'Avec des produits hors support',
  'Con sfruttate':
    'Avec exploitées',
  'Con vulnerabilità sfruttate':
    'Avec des vulnérabilités exploitées',
  'Contatto di sicurezza':
    'Contact de sécurité',
  'Contratti e asset':
    'Contrats et actifs',
  'Contratti in vigore':
    'Contrats en vigueur',
  'Crea il fornitore':
    'Créer le fournisseur',
  'Critici':
    'Critiques',
  'Critici o importanti':
    'Critiques ou importants',
  'Da catalogare':
    'À cataloguer',
  'Da catalogare ({n})':
    'À cataloguer ({n})',
  'Dal registro fornitori':
    'Depuis le registre des fournisseurs',
  'Dove l’ha visto':
    'Où il a été vu',
  'Dove si segnala una vulnerabilità dei suoi prodotti (PSIRT).':
    'Où l’on signale une vulnérabilité de ses produits (PSIRT).',
  'Eliminare il fornitore «{nome}»? I suoi nomi tornano fra le proposte; contratti e asset perdono il collegamento, non il testo del fornitore.':
    'Supprimer le fournisseur «{nome}» ? Ses noms reviennent parmi les propositions ; contrats et actifs perdent le lien, pas le texte du fournisseur.',
  'Email del referente':
    'E-mail du référent',
  'Fornitori':
    'Fournisseurs',
  'Fornitori ICT':
    'Fournisseurs TIC',
  'Fornitori ICT e cloud':
    'Fournisseurs TIC et cloud',
  'Hardware ({n})':
    'Matériel ({n})',
  'Hardware, sistemi e cloud':
    'Matériel, systèmes et cloud',
  'I nomi che CENSO ha trovato e che non sono ancora un fornitore, con dove li ha visti. Nomi scritti in modi diversi («Microsoft Corporation», «Microsoft Corp.») sono già uniti; i pacchetti del sistema operativo sono della distribuzione, non di chi li ha impacchettati. Accetta per creare un fornitore per ciascuno, unisci a un fornitore esistente, o ignora: un nome ignorato non torna.':
    'Les noms que CENSO a trouvés et qui ne sont pas encore un fournisseur, avec l’endroit où il les a vus. Les noms écrits de façons différentes («Microsoft Corporation», «Microsoft Corp.») sont déjà fusionnés ; les paquets du système d’exploitation appartiennent à la distribution, pas à qui les a empaquetés. Acceptez pour créer un fournisseur pour chacun, fusionnez avec un fournisseur existant, ou ignorez : un nom ignoré ne revient pas.',
  'I nomi con cui CENSO riconosce questo fornitore nel software installato, nei contratti e negli asset, con le scritture viste. Stacca un nome che non è di questo fornitore: torna fra le proposte al prossimo catalogo.':
    'Les noms par lesquels CENSO reconnaît ce fournisseur dans les logiciels installés, les contrats et les actifs, avec les graphies vues. Détachez un nom qui n’est pas de ce fournisseur : il revient parmi les propositions au prochain catalogue.',
  'I primi {n} di {tot}.':
    'Les {n} premiers sur {tot}.',
  'I primi {n} di {tot}: usa la ricerca per gli altri.':
    'Les {n} premiers sur {tot} : utilisez la recherche pour les autres.',
  'I programmi si riconoscono dal produttore scritto nell’inventario software (agente, sonda, cloud).':
    'Les programmes sont reconnus par l’éditeur écrit dans l’inventaire logiciel (agent, sonde, cloud).',
  'I reperti aperti sui prodotti di questo fornitore installati qui: vulnerabilità dei pacchetti e dei programmi, fine supporto, aggiornamenti mancanti del sistema, firmware. Quelli coperti da un’eccezione (rischio accettato, supporto esteso da contratto) non compaiono.':
    'Les constats ouverts sur les produits de ce fournisseur installés ici : vulnérabilités des paquets et des programmes, fin de support, mises à jour système manquantes, firmware. Ceux couverts par une exception (risque accepté, support étendu par contrat) n’apparaissent pas.',
  'Ignora':
    'Ignorer',
  'Il collegamento al registro fornitori: CENSO lo fa da solo se il nome è già noto.':
    'Le lien vers le registre des fournisseurs : CENSO le fait de lui-même si le nom est déjà connu.',
  'Il registro dei fornitori con quello che gira di loro, i contratti, le scadenze e i rinnovi, le licenze del software.':
    'Le registre des fournisseurs avec ce qui tourne chez vous, les contrats, les échéances et renouvellements, les licences logicielles.',
  'Il registro è vuoto':
    'Le registre est vide',
  'Il tuo ruolo non vede i contratti.':
    'Votre rôle ne voit pas les contrats.',
  'LEI':
    'LEI',
  'La criticità viene da ciò che il fornitore sostiene direttamente: il suo software quando è un elemento di una Business App, il sistema operativo, l’hardware e il cloud dei CI che sono interi in una Business App o in un business service. Un programma solo installato su un server critico non rende critico chi lo pubblica.':
    'La criticité vient de ce que le fournisseur soutient directement : son logiciel quand il est un élément d’une Business App, le système d’exploitation, le matériel et le cloud des CI qui sont entiers dans une Business App ou un business service. Un programme seulement installé sur un serveur critique ne rend pas critique son éditeur.',
  'Le proposte da confermare sono in «Da catalogare».':
    'Les propositions à confirmer sont dans «À cataloguer».',
  'Legal Entity Identifier: la chiave del registro delle informazioni DORA.':
    'Legal Entity Identifier : la clé du registre d’informations DORA.',
  'Lingua delle mail':
    'Langue des e-mails',
  'Manutenzione':
    'Maintenance',
  'Modifica il fornitore':
    'Modifier le fournisseur',
  'Nessun contratto collegato a questo fornitore.':
    'Aucun contrat lié à ce fournisseur.',
  'Nessun fornitore qui':
    'Aucun fournisseur ici',
  'Nessun nome':
    'Aucun nom',
  'Nessun nome ignorato':
    'Aucun nom ignoré',
  'Nessun programma':
    'Aucun programme',
  'Nessun reperto aperto':
    'Aucun constat ouvert',
  'Niente da catalogare':
    'Rien à cataloguer',
  'Nomi ({n})':
    'Noms ({n})',
  'Nuovo fornitore':
    'Nouveau fournisseur',
  'Ogni nome trovato è già un fornitore o è stato ignorato.':
    'Chaque nom trouvé est déjà un fournisseur ou a été ignoré.',
  'Pagina degli avvisi di sicurezza':
    'Page des avis de sécurité',
  'Panoramica fornitori':
    'Vue d’ensemble des fournisseurs',
  'Partita IVA':
    'Numéro de TVA',
  'Prodotti CRA di cui è il fabbricante':
    'Produits CRA dont il est le fabricant',
  'Prodotti in uso':
    'Produits utilisés',
  'Proposti':
    'Proposés',
  'Referente interno':
    'Référent interne',
  'Reperti aperti':
    'Constats ouverts',
  'Reperto':
    'Constat',
  'Riempie nome e contatto se sono vuoti.':
    'Remplit le nom et le contact s’ils sont vides.',
  'Rimetti fra i proposti':
    'Remettre parmi les proposés',
  'Rivenditore':
    'Revendeur',
  'Senza contatto di sicurezza':
    'Sans contact de sécurité',
  'Servizi ICT':
    'Services TIC',
  'Sistemi operativi ({n})':
    'Systèmes d’exploitation ({n})',
  'Sito':
    'Site',
  'Somiglia a':
    'Ressemble à',
  'Stacca':
    'Détacher',
  'Suppliers & Contracts':
    'Fournisseurs & Contrats',
  'Ultimo catalogo: {quando}. CENSO lo rifà da solo ogni ora.':
    'Dernier catalogue : {quando}. CENSO le refait de lui-même toutes les heures.',
  'Un fornitore è ICT quando nella sua scheda ha il tipo «Servizi ICT» o «Cloud».':
    'Un fournisseur est TIC quand sa fiche a le type «Services TIC» ou «Cloud».',
  'Unisci':
    'Fusionner',
  'Unisci a':
    'Fusionner avec',
  'Volte':
    'Fois',
  'a chi si segnala una vulnerabilità?':
    'à qui signaler une vulnérabilité ?',
  'cessato':
    'cessé',
  'dai legami diretti':
    'depuis les liens directs',
  'dai legami diretti: {c}':
    'depuis les liens directs : {c}',
  'dove gira qualcosa di suo':
    'où quelque chose à eux tourne',
  'hardware':
    'matériel',
  'i fornitori di servizi ICT e cloud del registro, con i contratti, le funzioni che sostengono e la loro criticità: la base del registro delle informazioni DORA e della sicurezza della catena di fornitura NIS2.':
    'les fournisseurs de services TIC et cloud du registre, avec leurs contrats, les fonctions qu’ils soutiennent et leur criticité : la base du registre d’informations DORA et de la sécurité de la chaîne d’approvisionnement NIS2.',
  'il registro di tutte le terze parti: CENSO propone i nomi che trova (chi pubblica il software installato, chi produce l’hardware, i cloud, i fornitori scritti nei contratti e negli asset) e tu li confermi; per ogni fornitore, che cosa gira di suo, dove, con quali vulnerabilità e scadenze, e per quali funzioni dell’organizzazione.':
    'le registre de tous les tiers : CENSO propose les noms qu’il trouve (qui publie les logiciels installés, qui fabrique le matériel, les clouds, les fournisseurs écrits dans les contrats et les actifs) et vous les confirmez ; pour chaque fournisseur, ce qui tourne de lui, où, avec quelles vulnérabilités et échéances, et pour quelles fonctions de l’organisation.',
  'nei loro prodotti installati qui':
    'dans leurs produits installés ici',
  'nomi':
    'noms',
  'nomi trovati e non ancora confermati':
    'noms trouvés et pas encore confirmés',
  'programmi':
    'programmes',
  'reperti':
    'constats',
  'riconosciuto dal nome, o nessuno':
    'reconnu d’après le nom, ou aucun',
  'scheda':
    'fiche',
  'software installato':
    'logiciels installés',
  'sostengono funzioni critiche o alte':
    'soutiennent des fonctions critiques ou élevées',
  'tipo non indicato':
    'type non indiqué',
  'unisci a…':
    'fusionner avec…',
  '{nome} {versione}: dove è installato':
    '{nome} {versione} : où il est installé',
  '{n} fornitori creati':
    '{n} fournisseurs créés',
  '{n} nomi di nuovo proposti':
    '{n} noms proposés à nouveau',
  '{n} nomi ignorati':
    '{n} noms ignorés',
  '{n} nomi uniti':
    '{n} noms fusionnés',
  '{v} l’anno':
    '{v} par an',
  'il registro delle terze parti, nell’area Suppliers & Contracts. CENSO legge chi pubblica il software installato (i pacchetti del sistema operativo sono della distribuzione, non di chi li ha impacchettati), chi produce l’hardware che gestisce, i cloud, i fornitori scritti nei contratti, negli asset e nei prodotti CRA, unisce i nomi scritti in modi diversi e li propone in «Da catalogare»: accetti, unisci a un fornitore o ignori. La scheda di ogni fornitore dice che cosa gira di suo e dove, le vulnerabilità aperte dei suoi prodotti (le sfruttate per prime), i prodotti fuori supporto, l’hardware e il cloud, i contratti e gli asset; la criticità viene da ciò che sostiene direttamente nelle Business App e nei business service. Contratti, asset e prodotti CRA si collegano al fornitore da soli quando il nome è già noto, o con il selettore. I fornitori ICT e cloud sono anche in Compliance.':
    'le registre des tiers, dans le domaine Fournisseurs & Contrats. CENSO lit qui publie les logiciels installés (les paquets du système d’exploitation appartiennent à la distribution, pas à qui les a empaquetés), qui fabrique le matériel qu’il gère, les clouds, les fournisseurs écrits dans les contrats, les actifs et les produits CRA, fusionne les noms écrits de façons différentes et les propose dans «À cataloguer» : vous acceptez, fusionnez avec un fournisseur ou ignorez. La fiche de chaque fournisseur indique ce qui tourne de lui et où, les vulnérabilités ouvertes de ses produits (les exploitées d’abord), les produits hors support, le matériel et le cloud, les contrats et les actifs ; la criticité vient de ce qu’il soutient directement dans les Business Apps et les business services. Contrats, actifs et produits CRA se lient au fournisseur d’eux-mêmes quand le nom est déjà connu, ou avec le sélecteur. Les fournisseurs TIC et cloud sont aussi dans Compliance.',
  'Italiano':
    'Italien',
  'Inglese':
    'Anglais',
  'Francese':
    'Français',
  'Business App «{nome}»':
    'Business App «{nome}»',
  'Categoria di legge':
    'Catégorie légale',
  'Critici senza rilasci':
    'Critiques sans versions',
  'Criticità per l’organizzazione':
    'Criticité pour l’organisation',
  'Da qualificare':
    'À qualifier',
  'I prodotti nascono fuori dal CRA, «da qualificare»: una Business App è spesso software usato solo internamente, che il CRA non riguarda. Aprili e metti nel campo quelli che l’organizzazione mette sul mercato UE.':
    'Les produits naissent hors du CRA, «à qualifier» : une Business App est souvent un logiciel utilisé seulement en interne, que le CRA ne concerne pas. Ouvrez-les et mettez dans le champ ceux que l’organisation met sur le marché de l’UE.',
  'Il prodotto è questa applicazione: la sua criticità per l’organizzazione è quella della Business App (la più alta delle sue funzionalità).':
    'Le produit est cette application : sa criticité pour l’organisation est celle de la Business App (la plus élevée de ses fonctionnalités).',
  'Importa da Business App':
    'Importer depuis une Business App',
  'Importa {n} applicazioni':
    'Importer {n} applications',
  'Non è la categoria di legge (allegati III e IV): dice quanto il prodotto conta, per ordinare le cose da valutare.':
    'Ce n’est pas la catégorie légale (annexes III et IV) : elle dit combien le produit compte, pour ordonner ce qu’il faut évaluer.',
  'Ogni Business App è già collegata a un prodotto, o non ce ne sono.':
    'Chaque Business App est déjà liée à un produit, ou il n’y en a pas.',
  'Prodotti critici o importanti':
    'Produits critiques ou importants',
  'Un prodotto per ogni applicazione scelta, collegato: la criticità segue quella della Business App.':
    'Un produit par application choisie, lié : la criticité suit celle de la Business App.',
  'criticità da definire':
    'criticité à définir',
  'dalla Business App: {c}':
    'depuis la Business App : {c}',
  'importati dalle Business App: nel campo del CRA o no?':
    'importés depuis les Business Apps : dans le champ du CRA ou non ?',
  'per l’organizzazione: dalla Business App o scelta a mano':
    'pour l’organisation : depuis la Business App ou choisie à la main',
  'senza un rilascio con SBOM il registro non può valutarli':
    'sans version avec SBOM le registre ne peut pas les évaluer',
  'Ogni prodotto ha anche una criticità per l’organizzazione, distinta dalla categoria di legge: viene dalla Business App collegata (la più alta delle sue funzionalità) o si sceglie a mano, e ordina le vulnerabilità da valutare e le segnalazioni. «Importa da Business App» crea un prodotto per applicazione, fuori dal CRA finché non lo qualifichi.':
    'Chaque produit a aussi une criticité pour l’organisation, distincte de la catégorie légale : elle vient de la Business App liée (la plus élevée de ses fonctionnalités) ou se choisit à la main, et elle ordonne les vulnérabilités à évaluer et les notifications. «Importer depuis une Business App» crée un produit par application, hors du CRA tant que vous ne le qualifiez pas.',
  'Applica i «non interessato» ({n})':
    'Appliquer les «non concerné» ({n})',
  'Avvisa sulle richieste ai fornitori':
    'Avertir sur les demandes aux fournisseurs',
  'Che cosa chiedi':
    'Ce que vous demandez',
  'Chiedi al fornitore':
    'Demander au fournisseur',
  'Chiudi la richiesta':
    'Fermer la demande',
  'Dichiarazioni':
    'Déclarations',
  'Fine del supporto':
    'Fin du support',
  'Giustificazione':
    'Justification',
  'Il tuo messaggio, in testa alla mail':
    'Votre message, en tête de l’e-mail',
  'In copia':
    'En copie',
  'Invia al fornitore':
    'Envoyer au fournisseur',
  'La mail dice prodotti, versioni e quante installazioni: mai i nomi delle macchine.':
    'L’e-mail indique les produits, les versions et le nombre d’installations : jamais les noms des machines.',
  'Lascia in bozza':
    'Laisser en brouillon',
  'Le richieste ai fornitori: vulnerabilità dei loro prodotti trovate qui, fine supporto, SBOM, questionari. Si scrivono dalla scheda del fornitore («Chiedi al fornitore»); il sollecito parte da solo prima della scadenza e alla scadenza.':
    'Les demandes aux fournisseurs : vulnérabilités de leurs produits trouvées ici, fin de support, SBOM, questionnaires. Elles s’écrivent depuis la fiche du fournisseur («Demander au fournisseur») ; la relance part d’elle-même avant l’échéance et à l’échéance.',
  'Manca il contatto di sicurezza del fornitore: aggiungilo nella scheda, o scrivi il destinatario nella richiesta.':
    'Le contact de sécurité du fournisseur manque : ajoutez-le dans la fiche, ou écrivez le destinataire dans la demande.',
  'Nessuna dichiarazione: arrivano dalle risposte alle richieste.':
    'Aucune déclaration : elles viennent des réponses aux demandes.',
  'Nessuna richiesta.':
    'Aucune demande.',
  'Nessuna vulnerabilità aperta sui suoi prodotti: niente da chiedere.':
    'Aucune vulnérabilité ouverte sur ses produits : rien à demander.',
  'Niente è ancora stato inviato.':
    'Rien n’a encore été envoyé.',
  'Perché chiudi la richiesta?':
    'Pourquoi fermez-vous la demande ?',
  'Preparo…':
    'Préparation…',
  'Quello che il fornitore ha dichiarato sui suoi prodotti («non interessato»): finché vale, toglie dai rischi aperti le stesse vulnerabilità dello stesso prodotto installato qui. Non vale per il cancello delle pipeline né per il registro CRA, che riguardano il software dell’organizzazione.':
    'Ce que le fournisseur a déclaré sur ses produits («non concerné») : tant que c’est valide, cela retire des risques ouverts les mêmes vulnérabilités du même produit installé ici. Cela ne vaut ni pour la porte des pipelines ni pour le registre CRA, qui concernent le logiciel de l’organisation.',
  'Questionario di sicurezza':
    'Questionnaire de sécurité',
  'Registra le risposte':
    'Enregistrer les réponses',
  'Revocare la dichiarazione? I reperti che toglieva tornano subito aperti.':
    'Révoquer la déclaration ? Les constats qu’elle retirait redeviennent aussitôt ouverts.',
  'Richiesta {rif}: la mail che riceverà':
    'Demande {rif} : l’e-mail qu’il recevra',
  'Richieste ai fornitori':
    'Demandes aux fournisseurs',
  'Risposta entro (giorni)':
    'Réponse sous (jours)',
  'Risposte':
    'Réponses',
  'Risposte a':
    'Réponses à',
  'Risposte registrate':
    'Réponses enregistrées',
  'SBOM dei prodotti':
    'SBOM des produits',
  'Una richiesta a un fornitore (vulnerabilità, fine supporto, SBOM) rimasta senza risposta alla scadenza. Il sollecito al fornitore parte comunque, in copia al referente.':
    'Une demande à un fournisseur (vulnérabilités, fin de support, SBOM) restée sans réponse à l’échéance. La relance au fournisseur part quand même, en copie au référent.',
  'Valida fino al':
    'Valide jusqu’au',
  'Valide fino al':
    'Valides jusqu’au',
  'Vedi la mail':
    'Voir l’e-mail',
  'Vulnerabilità nei suoi prodotti':
    'Vulnérabilités dans ses produits',
  'corretto in una versione':
    'corrigé dans une version',
  'dichiarazione applicata':
    'déclaration appliquée',
  'dichiarazioni':
    'déclarations',
  'entro il {d}':
    'avant le {d}',
  'il contatto di sicurezza del fornitore':
    'le contact de sécurité du fournisseur',
  'interessato':
    'concerné',
  'inviata il {d}':
    'envoyée le {d}',
  'nessuna risposta':
    'pas de réponse',
  'note dalla risposta':
    'notes de la réponse',
  'perché?':
    'pourquoi ?',
  'rimedio provvisorio':
    'solution de contournement',
  'risposta':
    'répondue',
  'versione che corregge':
    'version qui corrige',
  'vuoto: il referente interno':
    'vide : le référent interne',
  '{k} di {n} CVE escluse dal fornitore':
    '{k} sur {n} CVE exclues par le fournisseur',
  '{n} dichiarazioni applicate: i reperti corrispondenti escono dai rischi aperti fino alla scadenza.':
    '{n} déclarations appliquées : les constats correspondants sortent des risques ouverts jusqu’à l’échéance.',
  '{n} installazioni':
    '{n} installations',
  'È ancora una bozza: inviala da «Chiedi al fornitore» o rifalla.':
    'C’est encore un brouillon : envoyez-le depuis «Demander au fournisseur» ou refaites-le.',
  'Dalla scheda di un fornitore, «Chiedi al fornitore» prepara una mail nella sua lingua con le vulnerabilità dei suoi prodotti trovate qui (prodotti, versioni, quante installazioni: mai i nomi delle macchine), la mostra prima di inviarla e la sollecita da sola prima della scadenza. Le risposte si registrano per voce; un «non interessato» diventa una dichiarazione del fornitore, con una scadenza, che toglie dai rischi aperti le stesse vulnerabilità di quel prodotto finché vale.':
    'Depuis la fiche d’un fournisseur, «Demander au fournisseur» prépare un e-mail dans sa langue avec les vulnérabilités de ses produits trouvées ici (produits, versions, nombre d’installations : jamais les noms des machines), le montre avant l’envoi et le relance de lui-même avant l’échéance. Les réponses s’enregistrent par élément ; un «non concerné» devient une déclaration du fournisseur, avec une échéance, qui retire des risques ouverts les mêmes vulnérabilités de ce produit tant qu’elle est valide.',
  'Aggiungi una certificazione':
    'Ajouter une certification',
  'Certificazione':
    'Certification',
  'Certificazioni':
    'Certifications',
  'Collegamento al certificato':
    'Lien vers le certificat',
  'DORA: registro delle informazioni':
    'DORA : registre d’informations',
  'Eliminare la certificazione?':
    'Supprimer la certification ?',
  'Eliminare la valutazione?':
    'Supprimer l’évaluation ?',
  'Emessa il':
    'Émise le',
  'Fornitore ICT (DORA)':
    'Prestataire TIC (DORA)',
  'Fornitore terzo di servizi ICT':
    'Prestataire tiers de services TIC',
  'I fornitori ICT del registro fornitori (dichiarati, o di tipo cloud e servizi ICT) e quelli con contratti attivi, con gli asset coperti e i provider cloud che ospitano l’inventario. La «concentrazione» è la quota di asset a supporto di funzioni critiche o importanti che dipende da ciascun fornitore. Per chi sostiene funzioni critiche o importanti il registro segnala LEI, sostituibilità e strategia di uscita mancanti. L’esportazione del registro delle informazioni è nell’area Fornitori.':
    'Les fournisseurs TIC du registre des fournisseurs (déclarés, ou de type cloud et services TIC) et ceux avec des contrats actifs, avec les actifs couverts et les fournisseurs cloud qui hébergent l’inventaire. La «concentration» est la part des actifs soutenant des fonctions critiques ou importantes qui dépend de chaque fournisseur. Pour ceux qui soutiennent des fonctions critiques ou importantes, le registre signale le LEI, la substituabilité et la stratégie de sortie manquants. L’export du registre d’informations est dans le domaine Fournisseurs.',
  'Il fornitore non è critico né importante: la verifica NIS2 riguarda quelli che lo sono, ma le valutazioni restano utili.':
    'Le fournisseur n’est ni critique ni important : la vérification NIS2 concerne ceux qui le sont, mais les évaluations restent utiles.',
  'La base del registro delle informazioni DORA: fornitori ICT, accordi contrattuali, funzioni sostenute. Una base per i modelli EBA, non la tassonomia completa.':
    'La base du registre d’informations DORA : prestataires TIC, accords contractuels, fonctions soutenues. Une base pour les modèles de l’ABE, pas la taxonomie complète.',
  'La strategia di uscita è stata provata':
    'La stratégie de sortie a été testée',
  'Misurata sui fornitori critici o importanti del registro fornitori (dalla criticità di ciò che sostengono): per ciascuno serve una valutazione in corso di validità, un contatto di sicurezza e nessuna certificazione scaduta.':
    'Mesurée sur les fournisseurs critiques ou importants du registre des fournisseurs (d’après la criticité de ce qu’ils soutiennent) : chacun a besoin d’une évaluation valide, d’un contact de sécurité et d’aucune certification expirée.',
  'Nessuna certificazione registrata.':
    'Aucune certification enregistrée.',
  'Nessuna valutazione registrata.':
    'Aucune évaluation enregistrée.',
  'Prossima entro':
    'Prochaine avant le',
  'Registra una valutazione':
    'Enregistrer une évaluation',
  'Sedi dei dati':
    'Localisation des données',
  'Sedi dei dati (paesi)':
    'Localisation des données (pays)',
  'Sicurezza della catena di fornitura (art. 21, c. 2, d)':
    'Sécurité de la chaîne d’approvisionnement (art. 21, § 2, d)',
  'Sostituibilità':
    'Substituabilité',
  'Strategia di uscita':
    'Stratégie de sortie',
  'Valutazione in corso di validità, contatto di sicurezza, nessuna certificazione scaduta.':
    'Évaluation valide, contact de sécurité, aucune certification expirée.',
  'Valutazioni':
    'Évaluations',
  'Valutazioni e certificazioni':
    'Évaluations et certifications',
  'Verifica della catena di fornitura (NIS2)':
    'Vérification de la chaîne d’approvisionnement (NIS2)',
  'a posto':
    'en ordre',
  'anche senza la spunta, i tipi «Cloud» e «Servizi ICT» lo sono':
    'même sans la case, les types «Cloud» et «Services TIC» le sont',
  'audit':
    'audit',
  'certificazioni':
    'certifications',
  'certificazioni in date':
    'certifications valides',
  'come si sostituisce, in quanto tempo, dove vanno i dati':
    'comment le remplacer, en combien de temps, où vont les données',
  'con condizioni':
    'avec conditions',
  'contatto di sicurezza':
    'contact de sécurité',
  'dal contratto, non ancora nel registro fornitori':
    'depuis le contrat, pas encore dans le registre des fournisseurs',
  'difficile':
    'difficile',
  'facile':
    'facile',
  'impossibile':
    'impossible',
  'negativa':
    'négative',
  'nessun fornitore critico':
    'aucun fournisseur critique',
  'non valutata':
    'non évaluée',
  'positiva':
    'positive',
  'provata':
    'testée',
  'questionario':
    'questionnaire',
  'riesame':
    'revue',
  'scritta':
    'écrite',
  'scritta e provata':
    'écrite et testée',
  'valutazione in corso di validità':
    'évaluation valide',
  '{ok} di {n} a posto':
    '{ok} sur {n} en ordre',
  'Nella scheda si registrano le valutazioni (con la prossima da fare) e le certificazioni (con la scadenza), con i promemoria; per DORA il LEI, la sostituibilità, la strategia di uscita e le sedi dei dati. «Fornitori ICT» esporta la base del registro delle informazioni DORA, e il rapporto NIS2 misura la sicurezza della catena di fornitura sui fornitori critici: valutazione in corso di validità, contatto di sicurezza, nessuna certificazione scaduta.':
    'Dans la fiche on enregistre les évaluations (avec la prochaine à faire) et les certifications (avec leur échéance), avec des rappels ; pour DORA le LEI, la substituabilité, la stratégie de sortie et la localisation des données. «Fournisseurs TIC» exporte la base du registre d’informations DORA, et le rapport NIS2 mesure la sécurité de la chaîne d’approvisionnement sur les fournisseurs critiques : évaluation valide, contact de sécurité, aucune certification expirée.',
  'In fascia critica':
    'En niveau critique',
  'Applica i «non interessato»':
    'Appliquer les «non concerné»',
  'Confronta':
    'Comparer',
  'Dichiarati e non trovati':
    'Déclarés et non trouvés',
  'Dichiarazioni del documento {f}':
    'Déclarations du document {f}',
  'Documenti del fornitore':
    'Documents du fournisseur',
  'Eliminare il documento? Le dichiarazioni già applicate restano.':
    'Supprimer le document ? Les déclarations déjà appliquées restent.',
  'File JSON':
    'Fichier JSON',
  'Installati e non dichiarati':
    'Installés et non déclarés',
  'Lettura…':
    'Lecture…',
  'Nessun documento del fornitore.':
    'Aucun document du fournisseur.',
  'Nessuna applicazione installata con questo nome: l’agente con l’SBOM acceso la troverebbe sulle macchine dove gira.':
    'Aucune application installée sous ce nom : l’agent avec le SBOM activé la trouverait sur les machines où elle tourne.',
  'Originale':
    'Original',
  'SBOM del fornitore e installato: {p}':
    'SBOM du fournisseur et installé : {p}',
  'Un SBOM (CycloneDX o SPDX) si confronta con quello che l’agente trova installato; una VEX (CycloneDX o OpenVEX) o un avviso CSAF porta le dichiarazioni del fornitore, che diventano tue quando le applichi.':
    'Un SBOM (CycloneDX ou SPDX) se compare avec ce que l’agent trouve installé ; une VEX (CycloneDX ou OpenVEX) ou un avis CSAF porte les déclarations du fournisseur, qui deviennent les vôtres quand vous les appliquez.',
  'Versioni diverse':
    'Versions différentes',
  'come si chiama installato':
    'son nom une fois installé',
  'dichiarata {d}, installata {i}':
    'déclarée {d}, installée {i}',
  'documenti':
    'documents',
  'manca il perché: non si applica':
    'le pourquoi manque : non appliquée',
  '{a} applicazioni installate · {d} componenti dichiarati · {i} trovati · {s} uguali':
    '{a} applications installées · {d} composants déclarés · {i} trouvés · {s} identiques',
  '{n} componenti, {v} vulnerabili':
    '{n} composants, {v} vulnérables',
  '{n} dichiarazioni applicate; {s} senza giustificazione non applicate.':
    '{n} déclarations appliquées ; {s} sans justification non appliquées.',
  '{n} dichiarazioni, {na} «non interessato»':
    '{n} déclarations, {na} «non concerné»',
  'Nella scheda «Documenti» si carica quello che il fornitore ti dà: uno SBOM si confronta con quello che l’agente trova installato (componenti in più, in meno, versioni diverse), una VEX o un avviso CSAF porta le sue dichiarazioni «non interessato», che applichi con una scadenza.':
    'Dans l’onglet «Documents» on charge ce que le fournisseur vous donne : un SBOM se compare avec ce que l’agent trouve installé (composants en plus, en moins, versions différentes), une VEX ou un avis CSAF porte ses déclarations «non concerné», que vous appliquez avec une échéance.',
  'Generata':
    'Générée',
  'Gestito da CENSO: è chi produce CENSO, la sua sonda e il suo agente. Ne tiene aggiornati SBOM e VEX a ogni versione (scheda Documenti); i dati della scheda, le valutazioni e i contratti sono tuoi.':
    'Géré par CENSO : c’est le fabricant de CENSO, de sa sonde et de son agent. CENSO tient à jour son SBOM et sa VEX à chaque version (onglet Documents) ; les données de cette fiche, les évaluations et les contrats sont les vôtres.',
  'Gli stessi documenti nel registro fornitori':
    'Les mêmes documents dans le registre des fournisseurs',
  'L’elenco dei componenti (CycloneDX) della versione installata qui, letto dai file distribuiti, con l’impronta SHA-256 di ciascun file; la VEX dice, per ogni vulnerabilità nota dei componenti, se il prodotto ne è interessato e perché. Produttore: DiscoveryGuard Ltd.':
    'La liste des composants (CycloneDX) de la version installée ici, lue dans les fichiers distribués, avec l’empreinte SHA-256 de chaque fichier ; la VEX indique, pour chaque vulnérabilité connue des composants, si le produit est concerné et pourquoi. Fabricant : DiscoveryGuard Ltd.',
  'Nessun documento.':
    'Aucun document.',
  'SBOM dell’agente':
    'SBOM de l’agent',
  'SBOM e VEX della sonda':
    'SBOM et VEX de la sonde',
  'SBOM e VEX dell’agente':
    'SBOM et VEX de l’agent',
  'SBOM e VEX di CENSO':
    'SBOM et VEX de CENSO',
  'Scarica SBOM':
    'Télécharger le SBOM',
  'Scarica VEX':
    'Télécharger la VEX',
  'gestito da CENSO':
    'géré par CENSO',
  'nessuna dichiarazione':
    'aucune déclaration',
  'non presente in questa installazione':
    'absent de cette installation',
  '{n} sfruttabili':
    '{n} exploitables',
  'In fondo alla pagina lo SBOM e la VEX della sonda di questa versione, da scaricare in CycloneDX.':
    'En bas de la page, le SBOM et la VEX de cette version de la sonde, à télécharger en CycloneDX.',
  'CENSO stesso è un fornitore: in ogni registro c’è DiscoveryGuard Ltd, che produce CENSO, la sonda e l’agente, «gestito da CENSO». Fra i suoi documenti ci sono lo SBOM e la VEX di CENSO, di CENSO Agent e di CENSO Probe della versione installata, aggiornati a ogni versione: si valutano, si confrontano con l’agente installato e si applicano come quelli di ogni fornitore. Non si elimina, e i nomi «CENSO» con cui l’agente compare fra i programmi installati sono suoi; i dati della scheda, le valutazioni e i contratti li gestisci tu.':
    'CENSO est lui-même un fournisseur : chaque registre contient DiscoveryGuard Ltd, le fabricant de CENSO, de la sonde et de l’agent, «géré par CENSO». Parmi ses documents figurent le SBOM et la VEX de CENSO, de CENSO Agent et de CENSO Probe pour la version installée, mis à jour à chaque version : ils s’évaluent, se comparent avec l’agent installé et s’appliquent comme ceux de tout fournisseur. Il ne se supprime pas, et les noms «CENSO» sous lesquels l’agent apparaît parmi les programmes installés sont les siens ; les données de la fiche, les évaluations et les contrats, c’est vous qui les gérez.',
  'La sezione «SBOM dell’agente» fa scaricare lo SBOM e la VEX dell’agente di questa versione, con l’impronta SHA-256 di ogni file distribuito.':
    'La section «SBOM de l’agent» permet de télécharger le SBOM et la VEX de cette version de l’agent, avec l’empreinte SHA-256 de chaque fichier distribué.',
  'Le macchine che hai scelto ({n}): togli la spunta per escluderne una.':
    'Les machines que vous avez choisies ({n}) : décochez-en une pour l’exclure.',
  'Mostra solo le scelte':
    'Afficher seulement celles choisies',
  'Scegli fra tutte le macchine':
    'Choisir parmi toutes les machines',
  'Sulle {n} macchine che hai scelto: le ritrovi già spuntate nel passo «Dove».':
    'Sur les {n} machines que vous avez choisies : vous les retrouverez déjà cochées à l’étape «Où».',
  'Scegliendo prima le macchine nella sezione «Macchine» («Nuovo intervento su queste») il passo «Dove» mostra solo quelle, già spuntate, e «Patch scelte» propone solo le patch che mancano a loro; «Scegli fra tutte le macchine» allarga la scelta. La colonna «Sistema» di «Macchine» e «Patch» divide Windows e Linux.':
    'En choisissant d’abord les machines dans la section «Machines» («Nouvelle intervention sur celles-ci»), l’étape «Où» n’affiche qu’elles, déjà cochées, et «Correctifs choisis» ne propose que les correctifs qui leur manquent ; «Choisir parmi toutes les machines» élargit le choix. La colonne «Système» de «Machines» et «Correctifs» sépare Windows et Linux.',
  'Gestione interna':
    'Gestion interne',
  'Sicurezza dei prodotti':
    'Sécurité des produits',
  'Sottoalberi da campionare':
    'Sous-arbres à échantillonner',
  'Vuoto: la sonda sceglie — la MIB del prodotto quando la conosce (su un Fabric Interconnect Cisco UCS telaio, blade, CPU e memoria), altrimenti il ramo del costruttore. Più OID separati da virgola.':
    'Vide : la sonde choisit — la MIB du produit quand elle la connaît (sur un Fabric Interconnect Cisco UCS : châssis, lames, CPU et mémoire), sinon la branche du constructeur. Plusieurs OID séparés par des virgules.',
  'Il campionamento cattura il ramo del costruttore, o i sottoalberi indicati nel campo «Sottoalberi da campionare»; su un Fabric Interconnect Cisco UCS prende da sé la MIB UCS (telaio, blade, IOM, alimentatori, CPU, memoria). Se una credenziale non riesce, il registro del job dice perché.':
    'L’échantillonnage capture la branche du constructeur, ou les sous-arbres indiqués dans le champ «Sous-arbres à échantillonner» ; sur un Fabric Interconnect Cisco UCS il prend de lui-même la MIB UCS (châssis, lames, IOM, alimentations, CPU, mémoire). Quand un identifiant ne fonctionne pas, le journal du job dit pourquoi.',
  'es. psirt@produttore.com':
    'ex. psirt@fabricant.com',
  'Gli RPM di questa installazione non sono firmati: un dnf o yum con gpgcheck=1 li rifiuta («is not signed»). La firma si configura sul server con la chiave privata di firma (docs/operations/firma-pacchetti-rpm.md); finché manca, si installano con «dnf install --nogpgcheck» dopo averne controllato la provenienza.':
    'Les RPM de cette installation ne sont pas signés : un dnf ou yum avec gpgcheck=1 les refuse («is not signed»). La signature se configure sur le serveur avec la clé privée de signature (docs/operations/firma-pacchetti-rpm.md) ; en attendant, on les installe avec «dnf install --nogpgcheck» après en avoir vérifié la provenance.',
  'Quando il server ha la chiave di firma, gli RPM sono firmati con GPG e la finestra offre la chiave pubblica da importare (rpm --import, gpgcheck=1); se non l’ha, la finestra dice che non sono firmati e un dnf con gpgcheck=1 li rifiuta.':
    'Quand le serveur a la clé de signature, les RPM sont signés avec GPG et la fenêtre propose la clé publique à importer (rpm --import, gpgcheck=1) ; sinon, la fenêtre indique qu’ils ne sont pas signés, et un dnf avec gpgcheck=1 les refuse.',
  'Deve essere un numero fra {min} e {max}, o vuoto per non toccarla.':
    'Doit être un nombre entre {min} et {max}, ou vide pour ne pas y toucher.',
  "MTU dell'interfaccia":
    "MTU de l'interface",
  'Non toccare':
    'Ne pas toucher',
  '9000 (jumbo)':
    '9000 (jumbo)',
  "Se nel mirror passano jumbo frame (iSCSI, NFS, vMotion, backup), a 1500 la scheda butta via ogni frame più lungo prima che la cattura lo veda, e nessun contatore della cattura lo conta. Su un'interfaccia d'ascolto senza indirizzo un MTU alto non costa nulla.":
    "Si des trames jumbo passent dans le miroir (iSCSI, NFS, vMotion, sauvegardes), à 1500 la carte jette toute trame plus longue avant que la capture ne la voie, et aucun compteur de la capture ne la compte. Sur une interface d'écoute sans adresse, un MTU élevé ne coûte rien.",
  'Disattiva GRO/LRO':
    'Désactiver GRO/LRO',
  'La scheda (LRO) o il kernel (GRO) uniscono segmenti consecutivi in un pacchetto solo prima che la cattura lo veda: conteggi, dimensioni e tempi non sono più quelli del filo. Su un mirror conviene spegnerli.':
    'La carte (LRO) ou le noyau (GRO) fusionnent des segments consécutifs en un seul paquet avant que la capture ne le voie : comptages, tailles et temps ne sont plus ceux du câble. Sur un miroir, mieux vaut les désactiver.',
  'La sonda li applica prima di mettersi in ascolto, e di nuovo a ogni riavvio della macchina. Gira senza privilegi di rete: li applica per lei un piccolo servizio di sistema ({servizio}), che l’aggiornatore installa da sé. In Docker la sonda va installata con {opzione}.':
    'La sonde les applique avant de se mettre à l’écoute, et à nouveau à chaque redémarrage de la machine. Elle tourne sans privilèges réseau : un petit service système ({servizio}) les applique pour elle, et le programme de mise à jour l’installe de lui-même. Sous Docker, la sonde doit être installée avec {opzione}.',
  'MTU {n}':
    'MTU {n}',
  'richiesta {n}':
    'demandée {n}',
  'acceso':
    'activé',
  'Interfaccia di cattura non preparata del tutto.':
    'Interface de capture pas entièrement préparée.',
  'Da quando la cattura è partita la scheda ha rifiutato {n} frame più lunghi del suo MTU ({mtu}): di norma jumbo frame nel mirror (iSCSI, NFS, vMotion, backup). Non arrivano alla cattura e nessun altro contatore li conta. Imposta qui sopra l’MTU dell’interfaccia a 9000 o 9216.':
    'Depuis le début de la capture, la carte a refusé {n} trames plus longues que son MTU ({mtu}) : en général des trames jumbo dans le miroir (iSCSI, NFS, vMotion, sauvegardes). Elles n’arrivent pas à la capture et aucun autre compteur ne les compte. Réglez ci-dessus le MTU de l’interface à 9000 ou 9216.',
  'Da quando la cattura è partita la scheda ha perso {n} frame perché il suo anello di ricezione era pieno, prima del kernel. Se crescono, ingrandisci l’anello della scheda (ethtool -G {interfaccia} rx 4096) o copia meno traffico nello SPAN.':
    'Depuis le début de la capture, la carte a perdu {n} trames parce que son anneau de réception était plein, avant le noyau. S’ils augmentent, agrandissez l’anneau de la carte (ethtool -G {interfaccia} rx 4096) ou copiez moins de trafic dans le SPAN.',
  'Interfaccia di cattura (MTU, GRO/LRO)':
    'Interface de capture (MTU, GRO/LRO)',
  'Le impostazioni scelte in «Sorgenti dei flussi» le applica un servizio di sistema a parte, perché la sonda gira senza privilegi di rete: parte quando la sonda le cambia e a ogni avvio. Il suo stato e il suo esito:':
    'Les réglages choisis dans «Sources des flux» sont appliqués par un service système à part, car la sonde tourne sans privilèges réseau : il démarre quand la sonde les modifie et à chaque démarrage. Son état et son résultat :',
  'In «Sorgenti dei flussi» della scheda si sceglie l’interfaccia della cattura dal filo e il campionamento; se nel mirror passano jumbo frame (iSCSI, NFS, vMotion, backup), anche l’MTU dell’interfaccia (9000 o 9216) e GRO/LRO spenti. La sonda li applica da sé, anche dopo un riavvio della macchina, e avvisa quando la scheda butta via frame più lunghi del suo MTU.':
    'Dans «Sources des flux» de la fiche, on choisit l’interface de la capture sur le câble et l’échantillonnage ; si des trames jumbo passent dans le miroir (iSCSI, NFS, vMotion, sauvegardes), aussi le MTU de l’interface (9000 ou 9216) et GRO/LRO désactivés. La sonde les applique d’elle-même, y compris après un redémarrage de la machine, et avertit quand la carte jette des trames plus longues que son MTU.',
  'Aggiornare l’aggiornatore':
    'Mettre à jour le programme de mise à jour',
  'Da ottobre 2026 l’aggiornatore si aggiorna da sé, una volta l’ora. Una sonda installata prima ha la copia vecchia, che non lo sa fare: va sostituita una volta con quella del Control Plane. Il comando la scarica e la esegue: installa timer e servizi mancanti e aggiorna la sonda se serve. Non riarruola la sonda: usa il suo certificato, nessun token.':
    'Depuis octobre 2026, le programme de mise à jour se met à jour de lui-même, une fois par heure. Une sonde installée avant a l’ancienne copie, qui ne sait pas le faire : il faut la remplacer une fois par celle du Control Plane. La commande la télécharge et l’exécute : elle installe le minuteur et les services manquants et met à jour la sonde si nécessaire. Elle ne réinscrit pas la sonde : elle utilise son certificat, sans jeton.',
  'Questa sonda è una Censo Appliance, senza shell: dal menu dell’appliance, con l’utente censoadmin, scegli «CENSO probe» → «Enroll / reinstall the probe» e incolla il comando qui sotto. Il menu ne prende solo l’indirizzo e l’impronta del certificato e lo esegue da root.':
    'Cette sonde est une Censo Appliance, sans shell : dans le menu de l’appliance, avec l’utilisateur censoadmin, choisissez «CENSO probe» → «Enroll / reinstall the probe» et collez la commande ci-dessous. Le menu n’en prend que l’adresse et l’empreinte du certificat et l’exécute en root.',
  'VLAN documentate':
    'VLAN documentés',
  'Leggo le VLAN da phpIPAM…':
    'Lecture des VLAN depuis phpIPAM…',
  'Nessuna VLAN':
    'Aucun VLAN',
  'phpIPAM non ha VLAN, oppure l’app non ha i permessi di lettura sulle VLAN.':
    'phpIPAM n’a pas de VLAN, ou l’application n’a pas le droit de les lire.',
  'Domini L2':
    'Domaines L2',
  'Senza subnet':
    'Sans sous-réseau',
  'Il tab VLAN elenca le VLAN di phpIPAM con numero, nome, dominio L2 (spesso la sede), descrizione e le subnet associate; una subnet si apre sul suo confronto con la CMDB.':
    'L’onglet VLAN liste les VLAN de phpIPAM avec numéro, nom, domaine L2 (souvent le site), description et les sous-réseaux associés ; un sous-réseau s’ouvre sur sa comparaison avec la CMDB.',
  'Scadenza dei nuovi firmware':
    'Expiration des nouveaux firmwares',
  'dopo {n} giorni':
    'après {n} jours',
  'Un firmware scaduto esce dal catalogo da solo e le sonde lo tolgono entro un minuto. Vale per i file caricati d’ora in poi; per quelli già nel catalogo si cambia riga per riga.':
    'Un firmware expiré sort du catalogue de lui-même et les sondes le retirent en moins d’une minute. Cela vaut pour les fichiers chargés désormais ; pour ceux déjà au catalogue, on le change ligne par ligne.',
  'Scadenza di «{nome}»':
    'Expiration de «{nome}»',
  'Scadenza…':
    'Expiration…',
  'non scade':
    'n’expire pas',
  'Ogni firmware ha una scadenza (30 giorni se non la cambi): scaduto, esce dal catalogo da solo e le sonde lo tolgono; nella pagina si cambia la scadenza predefinita e, riga per riga, si proroga o si toglie.':
    'Chaque firmware a une expiration (30 jours si vous ne la changez pas) : une fois expiré, il sort du catalogue de lui-même et les sondes le retirent ; la page règle l’expiration par défaut et, ligne par ligne, la prolonge ou la supprime.',
  'consegna al Control Plane non riuscita: {e}':
    'livraison au Control Plane échouée : {e}',
  '{n} avvistamenti persi':
    '{n} observations perdues',
  'Consegna al Control Plane':
    'Livraison au Control Plane',
  'non riuscita dal {q}':
    'en échec depuis {q}',
  'riuscita, l’ultima il {q}':
    'réussie, la dernière le {q}',
  'ancora nessuna consegna':
    'aucune livraison pour l’instant',
  '{n} in attesa':
    '{n} en attente',
  'Ciò che la sonda sente non arriva al Control Plane.':
    'Ce que la sonde entend n’arrive pas au Control Plane.',
  'Un lotto rifiutato si scarta e non blocca più gli altri; un Control Plane lento o irraggiungibile fa aspettare il resto al giro dopo.':
    'Un lot refusé est écarté et ne bloque plus les autres ; un Control Plane lent ou injoignable fait attendre le reste au tour suivant.',
  'Avvistamenti persi dall’avvio dell’ascolto: {a} oltre la memoria della sonda, {b} rifiutati dal Control Plane.':
    'Observations perdues depuis le début de l’écoute : {a} au-delà de la mémoire de la sonde, {b} refusées par le Control Plane.',
  'file mancante':
    'fichier manquant',
  'Il file non è più sul Control Plane: le sonde non possono scaricarlo. Eliminalo e caricalo di nuovo.':
    'Le fichier n’est plus sur le Control Plane : les sondes ne peuvent pas le télécharger. Supprimez-le et chargez-le à nouveau.',
  // CENSO MED (ADR-0027)
  '(non indicato)':
    '(non indiqué)',
  'Anche gli esclusi a mano':
    'Aussi ceux exclus à la main',
  'Anche i dismessi':
    'Aussi ceux mis au rebut',
  'Anche quelli non più elettromedicali':
    'Aussi ceux qui ne sont plus des dispositifs médicaux',
  'Classe di protezione':
    'Classe de protection',
  'Codice CIVAB':
    'Code CIVAB',
  'Codice CND':
    'Code CND',
  'Collaudo':
    'Réception',
  'Con avvisi di sicurezza':
    'Avec avis de sécurité',
  'Cosa vede CENSO':
    'Ce que CENSO voit',
  'Da registrare':
    'À enregistrer',
  'Di scorta':
    'De réserve',
  'Elenco troncato: sono mostrati i primi {n} dispositivi.':
    'Liste tronquée : les {n} premiers dispositifs sont affichés.',
  'Elettromedicale':
    'Dispositif médical',
  'Esclusi a mano':
    'Exclus à la main',
  'Fuori servizio':
    'Hors service',
  'Gli elettromedicali dell’ospedale: quanti sono, cosa resta da registrare, dove sono, cosa va controllato.':
    'Les dispositifs médicaux de l’hôpital : combien il y en a, ce qui reste à enregistrer, où ils sont, ce qu’il faut contrôler.',
  'Gli elettromedicali per l’Ingegneria clinica: dove sono, schede, cespiti e contratti, verifiche.':
    'Les dispositifs médicaux pour le génie biomédical : où ils sont, fiches, immobilisations et contrats, contrôles.',
  'Gli elettromedicali riconosciuti da CENSO, con la scheda dell’Ingegneria clinica.':
    'Les dispositifs médicaux reconnus par CENSO, avec la fiche du génie biomédical.',
  'I dispositivi compaiono qui quando CENSO li riconosce come elettromedicali (inventario passivo, riconoscimento, inventari di riferimento).':
    'Les dispositifs apparaissent ici quand CENSO les reconnaît comme dispositifs médicaux (inventaire passif, reconnaissance, inventaires de référence).',
  'Identificazione':
    'Identification',
  'Il catalogo degli elettromedicali si costruisce dagli inventari di riferimento: questo modello non c’è ancora.':
    'Le catalogue des dispositifs médicaux se construit à partir des inventaires de référence : ce modèle n’y est pas encore.',
  'Il dispositivo non è più nella CMDB.':
    'Le dispositif n’est plus dans la CMDB.',
  'Il modello nel catalogo':
    'Le modèle dans le catalogue',
  'In riparazione':
    'En réparation',
  'Ingegneria clinica':
    'Génie biomédical',
  'La scheda resta per la sua storia.':
    'La fiche reste pour son historique.',
  'Modello non ancora nel catalogo.':
    'Modèle pas encore dans le catalogue.',
  'Modulo MDS2':
    'Formulaire MDS2',
  'N. inventario':
    'N° d’inventaire',
  'Nessun avviso di sicurezza su questo dispositivo.':
    'Aucun avis de sécurité sur ce dispositif.',
  'Nessun elettromedicale in questo elenco.':
    'Aucun dispositif médical dans cette liste.',
  'Nessun elettromedicale riconosciuto finora.':
    'Aucun dispositif médical reconnu jusqu’ici.',
  'Opera sugli elettromedicali in CENSO MED (schede, reparti, cespiti, contratti, verifiche); non vede il resto della CMDB.':
    'Travaille sur les dispositifs médicaux dans CENSO MED (fiches, services, immobilisations, contrats, contrôles) ; ne voit pas le reste de la CMDB.',
  'Parte applicata':
    'Partie appliquée',
  'Per produttore':
    'Par fabricant',
  'Per reparto':
    'Par service',
  'Per stato':
    'Par état',
  'Prima volta visto':
    'Vu la première fois',
  'Reparto':
    'Service',
  'Riconosciuto da':
    'Reconnu par',
  'Rilevato con':
    'Découvert par',
  'Rilevazione':
    'Détection',
  'Scheda creata da CENSO il {quando}: nessuno l’ha ancora compilata.':
    'Fiche créée par CENSO le {quando} : personne ne l’a encore remplie.',
  'Senza numero d’inventario':
    'Sans numéro d’inventaire',
  'Senza reparto né sede':
    'Sans service ni site',
  'Sicurezza elettrica (CEI EN 62353)':
    'Sécurité électrique (CEI EN 62353)',
  'Stanza':
    'Chambre',
  'Stato e responsabile':
    'État et responsable',
  'Tipo di dispositivo':
    'Type de dispositif',
  'Togli il filtro della panoramica':
    'Retirer le filtre de la vue d’ensemble',
  'UDI-DI':
    'UDI-DI',
  'Ultima modifica il {quando} da {chi}.':
    'Dernière modification le {quando} par {chi}.',
  'Versione del sistema operativo':
    'Version du système d’exploitation',
  'Voce':
    'Entrée',
  'accettato':
    'accepté',
  'segnati «non è un elettromedicale»':
    'marqués « n’est pas un dispositif médical »',
  'CENSO crea la scheda quando un CI diventa elettromedicale e la tiene allineata ogni ora (nome, produttore, modello). Se il dispositivo smette di esserlo o sparisce dalla CMDB, la scheda che nessuno ha compilato si cancella; quella compilata resta, fuori dall’area, con la sua storia. Se due CI si fondono, vince la scheda compilata.':
    'CENSO crée la fiche quand un CI devient un dispositif médical et la tient alignée toutes les heures (nom, fabricant, modèle). Si le dispositif cesse de l’être ou quitte la CMDB, la fiche que personne n’a remplie est supprimée ; une fiche remplie reste, hors de l’espace, avec son historique. Quand deux CI fusionnent, la fiche remplie l’emporte.',
  'Dispositivi: l’elenco, con le spunte per vedere anche quelli non più elettromedicali, gli esclusi a mano e i dismessi. Ogni riga apre la scheda: dati dell’Ingegneria clinica, cosa vede CENSO, il modello nel catalogo degli elettromedicali e gli avvisi di sicurezza (CISA ICSMA).':
    'Dispositifs : la liste, avec des cases pour afficher aussi ceux qui ne sont plus des dispositifs médicaux, ceux exclus à la main et ceux mis au rebut. Chaque ligne ouvre la fiche : données du génie biomédical, ce que CENSO voit, le modèle dans le catalogue des dispositifs médicaux et les avis de sécurité (CISA ICSMA).',
  'Fra i ruoli predefiniti (Impostazioni → Utenti → Ruoli) c’è «Ingegneria clinica»: opera in CENSO MED e non vede il resto della CMDB, nemmeno dalla ricerca, dal riepilogo della Home o dalle notifiche. Entrando arriva direttamente alla Panoramica di CENSO MED. I ruoli Team sicurezza, Asset e contratti, Responsabile compliance e Auditor vedono l’area in sola lettura.':
    'Parmi les rôles prédéfinis (Paramètres → Utilisateurs → Rôles) il y a « Génie biomédical » : il travaille dans CENSO MED et ne voit pas le reste de la CMDB, pas même depuis la recherche, le résumé de l’accueil ou les notifications. À la connexion il arrive directement sur la vue d’ensemble de CENSO MED. Les rôles Équipe sécurité, Actifs et contrats, Responsable conformité et Auditeur voient l’espace en lecture seule.',
  'Il ruolo «Ingegneria clinica»':
    'Le rôle « Génie biomédical »',
  'La scheda segue il dispositivo':
    'La fiche suit le dispositif',
  'Panoramica: quanti sono, quanti senza numero d’inventario, senza reparto o con avvisi di sicurezza, e la ripartizione per stato, reparto, produttore e categoria. Ogni numero apre l’elenco filtrato.':
    'Vue d’ensemble : combien il y en a, combien sans numéro d’inventaire, sans service ou avec des avis de sécurité, et la répartition par état, service, fabricant et catégorie. Chaque nombre ouvre la liste filtrée.',
  'l’area degli elettromedicali per l’Ingegneria clinica, con la licenza CENSO MED. Mostra solo i dispositivi che CENSO ha riconosciuto come elettromedicali (classe «Dispositivo medico» o una categoria medicale dal riconoscimento), ognuno con la sua scheda: ciò che CENSO vede in rete accanto a ciò che l’Ingegneria clinica scrive (numero d’inventario, reparto, stanza, responsabile, classe elettrica).':
    'l’espace des dispositifs médicaux pour le génie biomédical, avec la licence CENSO MED. Il ne montre que les dispositifs que CENSO a reconnus comme dispositifs médicaux (classe « Dispositif médical » ou une catégorie médicale issue de la reconnaissance), chacun avec sa fiche : ce que CENSO voit sur le réseau à côté de ce que le génie biomédical écrit (numéro d’inventaire, service, chambre, responsable, classe électrique).',
  'CENSO riconosce la serie ma non ancora il modello. Lo prende dall’inventario di riferimento dell’ospedale (stesso MAC), dal nome con cui il dispositivo si presenta, o da chi lo scrive nella scheda.':
    'CENSO reconnaît la série mais pas encore le modèle. Il le prend dans l’inventaire de référence de l’hôpital (même MAC), dans le nom sous lequel le dispositif se présente, ou de qui l’écrit dans la fiche.',
  'Serie':
    'Série',
  'da determinare':
    'à déterminer',
  'dal CMMS':
    'depuis la GMAO',
  'dal nome del dispositivo, confrontato con il catalogo':
    'du nom du dispositif, comparé au catalogue',
  'dal riconoscimento':
    'de la reconnaissance',
  'dall’inventario di riferimento ({fonte})':
    'de l’inventaire de référence ({fonte})',
  'modello da determinare':
    'modèle à déterminer',
  'scritto a mano':
    'saisi à la main',
  'serie {s}':
    'série {s}',
  'Serie e modello':
    'Série et modèle',
  'Spesso CENSO riconosce la serie (IntelliVue, CARESCAPE, LOGIQ) e non il modello: la scheda mostra la serie e «modello da determinare». Il modello arriva dall’inventario di riferimento dell’ospedale per lo stesso MAC, dalla sigla del modello nel nome con cui il dispositivo si presenta (per esempio «MX450»), o da chi lo scrive. La scheda dice da dove viene. Nel CMDB e in Traffic Analysis il modello dell’inventario di riferimento non entra, perché è ciò con cui CENSO viene misurato.':
    'CENSO reconnaît souvent la série (IntelliVue, CARESCAPE, LOGIQ) et pas le modèle : la fiche montre la série et « modèle à déterminer ». Le modèle vient de l’inventaire de référence de l’hôpital pour le même MAC, du code du modèle dans le nom sous lequel le dispositif se présente (par exemple « MX450 »), ou de qui l’écrit. La fiche dit d’où il vient. Dans la CMDB et dans Traffic Analysis le modèle de l’inventaire de référence n’est pas utilisé, car c’est ce à quoi CENSO est comparé.',
  '(come ora)':
    '(comme maintenant)',
  '+ Nuova sede':
    '+ Nouveau site',
  '+ Nuovo reparto':
    '+ Nouveau service',
  'Alimentazione interna (a batteria)':
    'Alimentation interne (batterie)',
  'Applicati {n} di {m}…':
    'Appliqués {n} sur {m}…',
  'Azioni sui dispositivi scelti':
    'Actions sur les dispositifs sélectionnés',
  'B: nessun contatto diretto con il paziente':
    'B : aucun contact direct avec le patient',
  'BF: a contatto con il paziente, isolata':
    'BF : en contact avec le patient, flottante',
  'CF: per l’applicazione diretta al cuore':
    'CF : pour application cardiaque directe',
  'Catalogo modelli':
    'Catalogue des modèles',
  'Classe I: protezione con il conduttore di terra':
    'Classe I : protection par le conducteur de terre',
  'Classe II: doppio isolamento':
    'Classe II : double isolation',
  'Con avvisi':
    'Avec avis',
  'Cosa cambia':
    'Ce qui change',
  'Cosa cambia su {n} dispositivi':
    'Ce qui change sur {n} dispositifs',
  'Dopo':
    'Après',
  'Escludi dall’area':
    'Exclure de l’espace',
  'Escluso dall’area: «{motivo}».':
    'Exclu de l’espace : « {motivo} ».',
  'Fermi o in riparazione':
    'À l’arrêt ou en réparation',
  'I dispositivi di questo modello':
    'Les dispositifs de ce modèle',
  'I modelli degli elettromedicali dell’ospedale: quanti sono, dove, in che stato, con i dati del catalogo.':
    'Les modèles des dispositifs médicaux de l’hôpital : combien, où, dans quel état, avec les données du catalogue.',
  'Il CI non è più riconosciuto come elettromedicale: la scheda resta per la sua storia.':
    'Le CI n’est plus reconnu comme dispositif médical : la fiche reste pour son historique.',
  'Il catalogo degli elettromedicali non ha ancora questo modello: classe di rischio, fine vita e modulo MDS2 arriveranno da lì.':
    'Le catalogue des dispositifs médicaux n’a pas encore ce modèle : classe de risque, fin de vie et formulaire MDS2 viendront de là.',
  'Il dispositivo esce dall’area CENSO MED: dagli elenchi, dalla panoramica, dalla ricerca. La scheda resta (si rivede con «Anche gli esclusi a mano») e il CI nella CMDB non cambia.':
    'Le dispositif quitte l’espace CENSO MED : les listes, la vue d’ensemble, la recherche. La fiche reste (visible avec « Aussi ceux exclus à la main ») et le CI dans la CMDB ne change pas.',
  'Il dispositivo torna negli elenchi dell’area. Il motivo dell’esclusione si cancella.':
    'Le dispositif revient dans les listes de l’espace. Le motif d’exclusion est effacé.',
  'Il numero dell’Ingegneria clinica: unico nell’ospedale.':
    'Le numéro du génie biomédical : unique dans l’hôpital.',
  'Modello da determinare':
    'Modèle à déterminer',
  'Modello non indicato':
    'Modèle non indiqué',
  'Modifica in blocco':
    'Modification en masse',
  'Modifica in blocco…':
    'Modification en masse…',
  'Modificati {n} dispositivi.':
    '{n} dispositifs modifiés.',
  'Motivo dello stato':
    'Motif de l’état',
  'Nessun modello: i dispositivi non sono ancora stati riconosciuti.':
    'Aucun modèle : les dispositifs n’ont pas encore été reconnus.',
  'Nome del reparto':
    'Nom du service',
  'Nome della sede':
    'Nom du site',
  'Non è un elettromedicale':
    'Ce n’est pas un dispositif médical',
  'Per esempio: «è il PC del medico di guardia», «stampante di reparto». Resta nella scheda.':
    'Par exemple : « c’est le PC du médecin de garde », « imprimante du service ». Il reste dans la fiche.',
  'Per sede':
    'Par site',
  'Perché non è un elettromedicale':
    'Pourquoi ce n’est pas un dispositif médical',
  'Prima':
    'Avant',
  'Reparti':
    'Services',
  'Rimetti fra gli elettromedicali':
    'Remettre parmi les dispositifs médicaux',
  'Rimetti nell’area':
    'Remettre dans l’espace',
  'Rivedi le modifiche ({n})':
    'Revoir les modifications ({n})',
  'Senza n. inventario':
    'Sans n° d’inventaire',
  'Si conosce solo la serie: i dati del catalogo valgono per un modello preciso.':
    'Seule la série est connue : les données du catalogue valent pour un modèle précis.',
  'Spunta i campi da cambiare: gli altri restano come sono su ogni dispositivo.':
    'Cochez les champs à modifier : les autres restent tels quels sur chaque dispositif.',
  'Trovato da CENSO: scrivilo solo se è sbagliato.':
    'Trouvé par CENSO : ne l’écrivez que s’il est faux.',
  'Un dispositivo dismesso esce dagli elenchi dell’area (resta visibile con «Anche i dismessi»).':
    'Un dispositif mis au rebut quitte les listes de l’espace (visible avec « Aussi ceux mis au rebut »).',
  'Un modello scritto qui resta: la sincronizzazione oraria non lo cambia più. Svuotalo per lasciarlo cercare di nuovo a CENSO.':
    'Un modèle écrit ici reste : la synchronisation horaire ne le change plus. Videz-le pour que CENSO le recherche à nouveau.',
  'fermi o in riparazione {n}':
    'à l’arrêt ou en réparation {n}',
  'in uso {n}':
    'en service {n}',
  'non indicato':
    'non indiqué',
  'si conosce solo la serie':
    'seule la série est connue',
  '{n} dispositivi scelti':
    '{n} dispositifs sélectionnés',
  '{n} elettromedicali':
    '{n} dispositifs médicaux',
  '{s} (modello da determinare)':
    '{s} (modèle à déterminer)',
  'Catalogo modelli: i modelli dei dispositivi dell’ospedale, quanti sono, in quali reparti, quanti fermi o con avvisi, con classe di rischio e fine vita dal catalogo. Un modello apre l’elenco dei suoi dispositivi.':
    'Catalogue des modèles : les modèles des dispositifs de l’hôpital, combien, dans quels services, combien à l’arrêt ou avec des avis, avec classe de risque et fin de vie du catalogue. Un modèle ouvre la liste de ses dispositifs.',
  'Compilare le schede':
    'Remplir les fiches',
  '«Modifica la scheda» (dalla pagina del dispositivo): numero d’inventario (unico nell’ospedale), seriale, UDI-DI, CND, CIVAB, serie e modello, reparto, sede, centro di costo, stanza e letto, stato, responsabile, date di collaudo e installazione, classe di protezione e parte applicata (CEI EN 62353), note. Prima di salvare si rivede cosa cambia. Reparti e sedi nuovi si creano lì, senza passare dalle Anagrafiche.':
    '« Modifier la fiche » (depuis la page du dispositif) : numéro d’inventaire (unique dans l’hôpital), numéro de série, UDI-DI, CND, CIVAB, série et modèle, service, site, centre de coût, chambre et lit, état, responsable, dates de réception et d’installation, classe de protection et partie appliquée (CEI EN 62353), notes. Avant d’enregistrer on revoit ce qui change. Les nouveaux services et sites se créent là, sans passer par les Référentiels.',
  'Un modello scritto a mano resta: la sincronizzazione oraria non lo cambia più. Svuotato, CENSO torna a cercarlo.':
    'Un modèle saisi à la main reste : la synchronisation horaire ne le change plus. Une fois vidé, CENSO le recherche à nouveau.',
  'Modifica in blocco: nell’elenco dei dispositivi si spuntano le righe (anche tutte quelle filtrate) e si danno a tutte lo stesso reparto, sede, centro di costo, stato, responsabile o classe elettrica. I campi non spuntati restano come sono.':
    'Modification en masse : dans la liste des dispositifs on coche les lignes (même toutes celles filtrées) et on leur donne le même service, site, centre de coût, état, responsable ou classe électrique. Les champs non cochés restent tels quels.',
  '«Non è un elettromedicale»: toglie il dispositivo dall’area, con il motivo; il CI nella CMDB non cambia. Si rimette con lo stesso pulsante.':
    '« Ce n’est pas un dispositif médical » : retire le dispositif de l’espace, avec le motif ; le CI dans la CMDB ne change pas. On le remet avec le même bouton.',
  'Elenco dei dispositivi e catalogo dei modelli si esportano in Excel o PDF. Un reparto o una sede in uso dagli elettromedicali, nelle Anagrafiche, si disattiva invece di togliersi.':
    'La liste des dispositifs et le catalogue des modèles s’exportent en Excel ou PDF. Un service ou un site utilisé par des dispositifs médicaux se désactive dans les Référentiels au lieu d’être supprimé.',
  'Abbinata per':
    'Associée par',
  'Abbinate a una scheda':
    'Associées à une fiche',
  'Aggiornate {n} schede.':
    '{n} fiches mises à jour.',
  'Aggiornate {n} schede; create le voci: {v}.':
    '{n} fiches mises à jour ; entrées créées : {v}.',
  'Applica le proposte':
    'Appliquer les propositions',
  'Applico…':
    'Application…',
  'Chi indica ogni chiave':
    'Ce que désigne chaque clé',
  'Colonne riconosciute: {c}.':
    'Colonnes reconnues : {c}.',
  'Con qualcosa da cambiare':
    'Avec quelque chose à changer',
  'Confronto con le schede…':
    'Comparaison avec les fiches…',
  'Crea i reparti e le sedi che mancano nelle anagrafiche':
    'Créer les services et les sites absents des référentiels',
  'Dispositivi dell’elenco che CENSO non ha riconosciuto in rete, o che nessuna chiave lega a una scheda (nomi uguali su più dispositivi non bastano). Ne sono mostrati al più 500.':
    'Dispositifs de la liste que CENSO n’a pas reconnus sur le réseau, ou qu’aucune clé ne relie à une fiche (le même nom sur plusieurs dispositifs ne suffit pas). Au plus 500 sont affichés.',
  'Foglio':
    'Feuille',
  'Il file':
    'Le fichier',
  'Importa dal CMMS':
    'Importer depuis la GMAO',
  'In conflitto':
    'En conflit',
  'Le chiavi della riga indicano dispositivi diversi (per esempio il numero d’inventario uno, il MAC un altro): non si indovina, si corregge l’elenco o la scheda.':
    'Les clés de la ligne désignent des dispositifs différents (par exemple le numéro d’inventaire l’un, le MAC un autre) : on ne devine pas, on corrige la liste ou la fiche.',
  'Le proposte':
    'Les propositions',
  'L’elenco degli elettromedicali dell’Ingegneria clinica, esportato dal CMMS o da un foglio: Excel o CSV, con una riga di intestazioni. Le colonne si riconoscono dal nome (numero d’inventario, matricola, MAC, IP, nome, modello, codice CND, CIVAB, UDI, reparto, presidio, stanza, date di collaudo e installazione). Il file non si salva: serve solo a proporre le modifiche.':
    'La liste des dispositifs médicaux du génie biomédical, exportée de la GMAO ou d’un tableur : Excel ou CSV, avec une ligne d’en-têtes. Les colonnes sont reconnues par leur nom (numéro d’inventaire, numéro de série, MAC, IP, nom, modèle, code CND, CIVAB, UDI, service, site, chambre, dates de réception et d’installation). Le fichier n’est pas conservé : il sert seulement à proposer des modifications.',
  'L’elenco dell’Ingegneria clinica diventa una serie di proposte per le schede: si sceglie cosa applicare.':
    'La liste du génie biomédical devient une série de propositions pour les fiches : on choisit ce qu’on applique.',
  'Non abbinate':
    'Non associées',
  'Quali campi applicare':
    'Quels champs appliquer',
  'Riga':
    'Ligne',
  'Righe in conflitto':
    'Lignes en conflit',
  'Righe lette':
    'Lignes lues',
  'Righe senza una scheda':
    'Lignes sans fiche',
  'Rivedi e applica ({n} schede)':
    'Revoir et appliquer ({n} fiches)',
  'Scegli il file…':
    'Choisir le fichier…',
  'Schede non aggiornate':
    'Fiches non mises à jour',
  'Senza, i reparti e le sedi che l’elenco nomina e le anagrafiche non hanno restano fuori.':
    'Sans cela, les services et sites que la liste nomme et que les référentiels n’ont pas restent de côté.',
  'Si aggiornano {n} schede, con {m} modifiche in tutto. Ogni scheda passa dagli stessi controlli di una modifica a mano; una che non li supera resta com’è e lo si dice.':
    '{n} fiches sont mises à jour, avec {m} modifications en tout. Chaque fiche passe par les mêmes contrôles qu’une modification manuelle ; celle qui échoue reste telle quelle et c’est signalé.',
  'Si creano nelle anagrafiche: {v}.':
    'Créés dans les référentiels : {v}.',
  'Un modello preso dall’elenco resta come uno scritto a mano: la sincronizzazione oraria non lo cambia.':
    'Un modèle pris dans la liste reste comme un modèle saisi à la main : la synchronisation horaire ne le change pas.',
  'indirizzo IP':
    'adresse IP',
  'nome':
    'nom',
  'numero di serie':
    'numéro de série',
  'numero d’inventario':
    'numéro d’inventaire',
  'nuova voce':
    'nouvelle entrée',
  'schede':
    'fiches',
  '{nome} ({n} righe)':
    '{nome} ({n} lignes)',
  'L’elenco dell’Ingegneria clinica (export del CMMS o un foglio Excel o CSV) non sovrascrive niente: diventa proposte. Ogni riga si abbina a una scheda per numero d’inventario, MAC, numero di serie, IP o nome (il nome solo se un dispositivo solo ce l’ha); per ognuna CENSO mostra cosa l’elenco dice di diverso, e si sceglie quali schede e quali campi applicare, e se creare i reparti e le sedi che mancano. Una riga le cui chiavi indicano dispositivi diversi è un conflitto, non si indovina. Il file non si salva e non diventa l’inventario di riferimento di Traffic Analysis; un modello preso dall’elenco resta come uno scritto a mano.':
    'La liste du génie biomédical (export de la GMAO ou feuille Excel ou CSV) n’écrase rien : elle devient des propositions. Chaque ligne est associée à une fiche par numéro d’inventaire, MAC, numéro de série, IP ou nom (le nom seulement si un seul dispositif le porte) ; pour chacune CENSO montre ce que la liste dit de différent, et on choisit quelles fiches et quels champs appliquer, et s’il faut créer les services et sites manquants. Une ligne dont les clés désignent des dispositifs différents est un conflit et n’est pas devinée. Le fichier n’est pas conservé et ne devient pas l’inventaire de référence de Traffic Analysis ; un modèle pris dans la liste reste comme un modèle saisi à la main.',
  'AE title DICOM':
    'AE title DICOM',
  'Accetta i suggerimenti migliori':
    'Accepter les meilleures suggestions',
  'Accettare {n} suggerimenti su {m} dispositivi?':
    'Accepter {n} suggestions sur {m} dispositifs ?',
  'Accettati {n} suggerimenti.':
    '{n} suggestions acceptées.',
  'Affidabilità':
    'Fiabilité',
  'Aggiungi la regola':
    'Ajouter la règle',
  'Allora il reparto è':
    'Alors le service est',
  'Altro elettromedicale (centrale, gateway)':
    'Autre dispositif médical (centrale, passerelle)',
  'Attività di rete negli ultimi 30 giorni, non esami. Un’ora è attiva con almeno {soglia} di traffico; «fermo» = nessuna ora attiva da {n} giorni; «mai visto nei flussi» = il suo traffico non passa da un router che esporta i flussi, non che sia fermo.':
    'Activité réseau des 30 derniers jours, pas des examens. Une heure est active avec au moins {soglia} de trafic ; « à l’arrêt » = aucune heure active depuis {n} jours ; « jamais vu dans les flux » = son trafic ne passe pas par un routeur qui exporte les flux, pas qu’il soit à l’arrêt.',
  'CENSO la ricalcola ogni ora; «Ricalcola adesso» nella vista Dove sono la calcola subito.':
    'CENSO la recalcule toutes les heures ; « Recalculer maintenant » dans la vue Où sont-ils la calcule tout de suite.',
  'Calcolato il {quando}.':
    'Calculé le {quando}.',
  'Con chi':
    'Avec qui',
  'Con chi parlano gli elettromedicali negli ultimi 7 giorni, dai flussi (NetFlow/IPFIX). Il collegamento fisico è la porta dello switch, in «Dove sono».':
    'Avec qui les dispositifs médicaux ont parlé ces 7 derniers jours, d’après les flux (NetFlow/IPFIX). La connexion physique est le port du commutateur, dans « Où sont-ils ».',
  'Con chi parlano gli elettromedicali: PACS, integrazioni HL7, centrali, server, indirizzi esterni.':
    'Avec qui parlent les dispositifs médicaux : PACS, intégrations HL7, centrales, serveurs, adresses externes.',
  'Dati fino al {giorno}.':
    'Données jusqu’au {giorno}.',
  'Descrizione della porta':
    'Description du port',
  'Descrizione della porta contiene':
    'La description du port contient',
  'Dove la rete vede ogni elettromedicale (switch, porta, VLAN, cosa dice di sé) e i suggerimenti per reparto, sede, stanza e letto.':
    'Où le réseau voit chaque dispositif médical (commutateur, port, VLAN, ce qu’il dit de lui-même) et les suggestions de service, site, chambre et lit.',
  'Dove lo vede la rete':
    'Où le réseau le voit',
  'Dove sono':
    'Où sont-ils',
  'Fermi da {n} giorni':
    'À l’arrêt depuis {n} jours',
  'Fermo':
    'À l’arrêt',
  'Gli interlocutori':
    'Les interlocuteurs',
  'Indirizzo esterno sconosciuto':
    'Adresse externe inconnue',
  'Indirizzo interno senza CI':
    'Adresse interne sans CI',
  'Integrazione HL7':
    'Intégration HL7',
  'Inventario di riferimento':
    'Inventaire de référence',
  'Inventario di riferimento contiene':
    'L’inventaire de référence contient',
  'Mai visti nei flussi':
    'Jamais vus dans les flux',
  'Mai visto nei flussi':
    'Jamais vu dans les flux',
  'Nessun giorno con traffico negli ultimi 30 giorni.':
    'Aucun jour avec du trafic ces 30 derniers jours.',
  'Nessun suggerimento: la scheda dice già ciò che le fonti dicono, o le fonti non dicono niente.':
    'Aucune suggestion : la fiche dit déjà ce que disent les sources, ou les sources ne disent rien.',
  'Nessun traffico negli ultimi 7 giorni nei flussi (NetFlow/IPFIX): può parlare solo dentro la sua VLAN.':
    'Aucun trafic dans les flux (NetFlow/IPFIX) ces 7 derniers jours : il ne parle peut-être qu’à l’intérieur de son VLAN.',
  'Nessuna ora attiva negli ultimi 30 giorni.':
    'Aucune heure active ces 30 derniers jours.',
  'Nessuna regola.':
    'Aucune règle.',
  'Ore attive (30 g)':
    'Heures actives (30 j)',
  'Ore attive al giorno':
    'Heures actives par jour',
  'Ore attive in 30 giorni':
    'Heures actives sur 30 jours',
  'Ore con DICOM o HL7':
    'Heures avec DICOM ou HL7',
  'PACS (immagini DICOM)':
    'PACS (images DICOM)',
  'Porte dello switch che iniziano con':
    'Ports du commutateur commençant par',
  'Posizione non ancora calcolata.':
    'Position pas encore calculée.',
  'Quando si usa (ultimi 30 giorni)':
    'Quand il est utilisé (30 derniers jours)',
  'Quanto si usa ogni elettromedicale, dall’attività di rete degli ultimi 30 giorni.':
    'Combien chaque dispositif médical est utilisé, d’après l’activité réseau des 30 derniers jours.',
  'Regole di posizione':
    'Règles de position',
  'Ricalcola adesso':
    'Recalculer maintenant',
  'Ricalcolo…':
    'Recalcul…',
  'Riceve immagini DICOM':
    'Reçoit des images DICOM',
  'Salva la soglia':
    'Enregistrer le seuil',
  'Se':
    'Si',
  'Senza traffico nei flussi':
    'Sans trafic dans les flux',
  'Server o PC':
    'Serveur ou PC',
  'Servizi di rete':
    'Services réseau',
  'Soglia di un’ora attiva (KB)':
    'Seuil d’une heure active (Ko)',
  'Stanza e letto':
    'Chambre et lit',
  'Struttura HL7':
    'Établissement HL7',
  'Suggerimenti':
    'Suggestions',
  'Switch e porta':
    'Commutateur et port',
  'Traffico in 30 giorni':
    'Trafic sur 30 jours',
  'Ultima attività':
    'Dernière activité',
  'Una regola dice dove stanno i dispositivi che hanno qualcosa in comune: «la VLAN 210 è la Rianimazione», «le porte con BOX nella descrizione sono del Pronto soccorso». Diventa un suggerimento su ogni dispositivo a cui si applica, al prossimo calcolo; non scrive niente da sola.':
    'Une règle dit où se trouvent les dispositifs qui ont quelque chose en commun : « le VLAN 210 est la Réanimation », « les ports avec BOX dans la description sont aux Urgences ». Elle devient une suggestion sur chaque dispositif concerné, au prochain calcul ; elle n’écrit rien d’elle-même.',
  'chiama':
    'appelle',
  'descrizione della porta dello switch':
    'description du port du commutateur',
  'e la sede è':
    'et le site est',
  'giorni attivi':
    'jours actifs',
  'interlocutori':
    'interlocuteurs',
  'inventario di riferimento':
    'inventaire de référence',
  'nessuno switch ha imparato il suo MAC':
    'aucun commutateur n’a appris son MAC',
  'nome della VLAN':
    'nom du VLAN',
  'ore attive':
    'heures actives',
  'posizione HL7 (reparto^stanza^letto)':
    'position HL7 (service^chambre^lit)',
  'regola di posizione':
    'règle de position',
  'struttura HL7':
    'établissement HL7',
  'È attività di rete, non esami: un’ora è «attiva» con almeno {soglia} di traffico. Le ore con DICOM o HL7 sono quelle in cui il dispositivo ha scambiato immagini o messaggi clinici. «Mai visto nei flussi» non vuol dire fermo: il suo traffico può non passare da un router che esporta i flussi.':
    'C’est de l’activité réseau, pas des examens : une heure est « active » avec au moins {soglia} de trafic. Les heures avec DICOM ou HL7 sont celles où le dispositif a échangé des images ou des messages cliniques. « Jamais vu dans les flux » ne veut pas dire à l’arrêt : son trafic peut ne pas passer par un routeur qui exporte les flux.',
  'è chiamato':
    'est appelé',
  'Dove sono, a cosa sono collegati, quanto si usano':
    'Où ils sont, à quoi ils sont connectés, combien ils sont utilisés',
  'Dove sono: per ogni dispositivo lo switch e la porta su cui la rete ha imparato il suo MAC, la descrizione della porta, la VLAN (col nome dall’IPAM), la struttura HL7 e gli AE title DICOM, la posizione nell’inventario di riferimento (anche «REPARTO^STANZA^LETTO» di Medigate). Da qui CENSO suggerisce reparto, sede, stanza e letto; non scrive niente finché qualcuno non accetta, uno alla volta o per i dispositivi scelti. Le regole di posizione («la VLAN 210 è la Rianimazione») diventano suggerimenti su tutti i dispositivi a cui si applicano.':
    'Où sont-ils : pour chaque dispositif le commutateur et le port sur lequel le réseau a appris son MAC, la description du port, le VLAN (avec son nom depuis l’IPAM), l’établissement HL7 et les AE titles DICOM, la position dans l’inventaire de référence (aussi « SERVICE^CHAMBRE^LIT » de Medigate). À partir de là CENSO suggère service, site, chambre et lit ; il n’écrit rien tant que quelqu’un n’accepte pas, un par un ou pour les dispositifs sélectionnés. Les règles de position (« le VLAN 210 est la Réanimation ») deviennent des suggestions sur tous les dispositifs concernés.',
  'Collegamenti: con chi parla ogni dispositivo negli ultimi 7 giorni, dai flussi, con il ruolo dell’interlocutore: PACS, integrazione HL7, altro elettromedicale (centrale, gateway), servizi di rete, server, indirizzo esterno sconosciuto. Un elettromedicale che parla con un indirizzo pubblico sconosciuto è un segnale da guardare.':
    'Connexions : avec qui chaque dispositif a parlé ces 7 derniers jours, d’après les flux, avec le rôle de l’interlocuteur : PACS, intégration HL7, autre dispositif médical (centrale, passerelle), services réseau, serveur, adresse externe inconnue. Un dispositif médical qui parle à une adresse publique inconnue est un signal à examiner.',
  'Utilizzo: le ore di attività di rete negli ultimi 30 giorni, le ore con DICOM o HL7 e una mappa giorno × ora. Non sono esami. Un dispositivo senza ore attive da 14 giorni è «fermo»; uno mai visto nei flussi non è fermo, è invisibile ai flussi. La soglia di un’ora attiva (50 KB) si cambia dalla vista Utilizzo.':
    'Utilisation : les heures d’activité réseau des 30 derniers jours, les heures avec DICOM ou HL7 et une carte jour × heure. Ce ne sont pas des examens. Un dispositif sans heures actives depuis 14 jours est « à l’arrêt » ; un dispositif jamais vu dans les flux n’est pas à l’arrêt, il est invisible aux flux. Le seuil d’une heure active (50 Ko) se change depuis la vue Utilisation.',
  'Alienato':
    'Cédé',
  'Cespite':
    'Immobilisation',
  'Cespite e contratti':
    'Immobilisation et contrats',
  'Collega a un contratto':
    'Lier à un contrat',
  'Copri subito questo dispositivo':
    'Couvrir tout de suite ce dispositif',
  'Cosa scrivi tu':
    'Ce que vous écrivez',
  'Crea il cespite':
    'Créer l’immobilisation',
  'Crea il cespite…':
    'Créer l’immobilisation…',
  'Crea il contratto':
    'Créer le contrat',
  'Dalla scheda e dalla rete':
    'De la fiche et du réseau',
  'Il cespite entra nel registro degli asset legato a questo dispositivo: uno solo per dispositivo.':
    'L’immobilisation entre dans le registre des actifs liée à ce dispositif : une seule par dispositif.',
  'Il contratto entra nel registro dei contratti, visibile all’Ingegneria clinica.':
    'Le contrat entre dans le registre des contrats, visible par le génie biomédical.',
  'Il dispositivo non è ancora nel registro dei beni. Il cespite si crea dalla scheda: nome, seriale, produttore, modello, reparto e sede sono già qui.':
    'Le dispositif n’est pas encore dans le registre des biens. L’immobilisation se crée depuis la fiche : nom, numéro de série, fabricant, modèle, service et site sont déjà là.',
  'Il ruolo «Ingegneria clinica» lo vede in CENSO MED e ci collega gli elettromedicali (per esempio un contratto di manutenzione). Gli altri contratti non li vede.':
    'Le rôle « Génie biomédical » le voit dans CENSO MED et y lie les dispositifs médicaux (par exemple un contrat de maintenance). Il ne voit pas les autres contrats.',
  'In magazzino':
    'En stock',
  'In manutenzione':
    'En maintenance',
  'Nessun contratto copre questo dispositivo.':
    'Aucun contrat ne couvre ce dispositif.',
  'Non trovato':
    'Introuvable',
  'Numero di cespite':
    'Numéro d’immobilisation',
  'Nuovo contratto di manutenzione':
    'Nouveau contrat de maintenance',
  'Nuovo contratto di manutenzione…':
    'Nouveau contrat de maintenance…',
  'Ordine di acquisto':
    'Bon de commande',
  'Per collegare un contratto serve il cespite: il contratto copre il bene.':
    'Pour lier un contrat il faut l’immobilisation : le contrat couvre le bien.',
  'Prezzo di acquisto':
    'Prix d’achat',
  'Reparto, sede e centro di costo vengono dalla scheda.':
    'Service, site et centre de coût viennent de la fiche.',
  'Riservato':
    'Réservé',
  'Rivedi':
    'Revoir',
  'Togliere questo dispositivo dalla copertura di «{r}»?':
    'Retirer ce dispositif de la couverture de « {r} » ?',
  'Visibile all’Ingegneria clinica':
    'Visible par le génie biomédical',
  'nessun contratto visibile all’Ingegneria clinica':
    'aucun contrat visible par le génie biomédical',
  'per esempio: intervento entro 8 ore, 2 manutenzioni preventive l’anno':
    'par exemple : intervention sous 8 heures, 2 maintenances préventives par an',
  'Dalla scheda di un dispositivo, sezione «Cespite e contratti»: il cespite si crea da una bozza che ha già nome, seriale, produttore, modello, reparto e sede (uno solo per dispositivo, nel registro degli asset). Il dispositivo si collega ai contratti che l’Ingegneria clinica vede: quelli con «Visibile all’Ingegneria clinica» acceso nel registro dei contratti e quelli che coprono già un suo dispositivo; gli altri restano invisibili. Un contratto di manutenzione si può creare da lì, e nasce visibile.':
    'Depuis la page d’un dispositif, section « Immobilisation et contrats » : l’immobilisation se crée à partir d’un brouillon qui a déjà nom, numéro de série, fabricant, modèle, service et site (une seule par dispositif, dans le registre des actifs). Le dispositif se lie aux contrats que le génie biomédical voit : ceux avec « Visible par le génie biomédical » activé dans le registre des contrats et ceux qui couvrent déjà un de ses dispositifs ; les autres restent invisibles. Un contrat de maintenance peut être créé de là, et naît visible.',
  'Aggiungi PDF…':
    'Ajouter un PDF…',
  'Aggiungi foto del modello…':
    'Ajouter une photo du modèle…',
  'Aggiungi foto…':
    'Ajouter des photos…',
  'Apri a dimensione intera':
    'Ouvrir en taille réelle',
  'Caricato il':
    'Chargé le',
  'Didascalia':
    'Légende',
  'Foto del dispositivo':
    'Photos du dispositif',
  'Foto del modello':
    'Photos du modèle',
  'Foto e documenti':
    'Photos et documents',
  'Il browser non riesce a elaborare l’immagine.':
    'Le navigateur ne parvient pas à traiter l’image.',
  'Le foto non devono mostrare pazienti né dati personali. Il browser le ridisegna prima di inviarle: niente dati EXIF né posizione GPS. Foto fino a 4 MiB, PDF fino a 10 MiB; spazio usato {u} di {q}.':
    'Les photos ne doivent montrer ni patients ni données personnelles. Le navigateur les redessine avant l’envoi : ni données EXIF ni position GPS. Photos jusqu’à 4 Mio, PDF jusqu’à 10 Mio ; espace utilisé {u} sur {q}.',
  'Nessun documento: manuale, dichiarazione di conformità, rapporti.':
    'Aucun document : manuel, déclaration de conformité, rapports.',
  'Nessuna foto.':
    'Aucune photo.',
  'Togliere questa foto?':
    'Retirer cette photo ?',
  'Valgono per tutti i dispositivi dello stesso modello in questo ospedale.':
    'Elles valent pour tous les dispositifs du même modèle dans cet hôpital.',
  'documento':
    'document',
  'Foto e documenti: le foto del dispositivo (fino a 6) e del modello (fino a 4, valgono per tutti i dispositivi di quel modello nell’ospedale) e i PDF (manuale, dichiarazione di conformità, rapporti). Il browser ridisegna ogni foto prima di inviarla, quindi non partono né i dati EXIF né la posizione GPS; le foto non devono mostrare pazienti. Si accettano solo JPEG, PNG, WebP e PDF, riconosciuti dal contenuto e non dal nome.':
    'Photos et documents : les photos du dispositif (jusqu’à 6) et du modèle (jusqu’à 4, valables pour tous les dispositifs de ce modèle dans l’hôpital) et les PDF (manuel, déclaration de conformité, rapports). Le navigateur redessine chaque photo avant de l’envoyer, donc ni les données EXIF ni la position GPS ne partent ; les photos ne doivent pas montrer de patients. Seuls JPEG, PNG, WebP et PDF sont acceptés, reconnus par leur contenu et non par leur nom.',
  'Allega il rapporto (PDF)…':
    'Joindre le rapport (PDF)…',
  'Altra verifica':
    'Autre contrôle',
  'Applica i predefiniti del modello':
    'Appliquer les valeurs par défaut du modèle',
  'CENSO non giudica le misure: i limiti dipendono da classe, parte applicata e metodo, e l’esito è del tecnico.':
    'CENSO ne juge pas les mesures : les limites dépendent de la classe, de la partie appliquée et de la méthode, et le résultat appartient au technicien.',
  'Chi la fa':
    'Réalisé par',
  'Ciò che di solito serve a questo modello: si applica a un dispositivo dalla sua scheda, e riempie solo ciò che manca.':
    'Ce dont ce modèle a habituellement besoin : cela s’applique à un dispositif depuis sa fiche et ne complète que ce qui manque.',
  'Corrente di dispersione della parte applicata (µA)':
    'Courant de fuite de la partie appliquée (µA)',
  'Corrente di dispersione dell’apparecchio (µA)':
    'Courant de fuite de l’appareil (µA)',
  'Destinatari dell’area (separati da virgola)':
    'Destinataires de l’espace (séparés par des virgules)',
  'Entro 60 giorni':
    'Sous 60 jours',
  'Eseguita da':
    'Effectué par',
  'La prossima scadenza del piano dello stesso tipo si sposta dalla data di questa verifica.':
    'La prochaine échéance du plan du même type se calcule à partir de la date de ce contrôle.',
  'La verifica non è stata superata. Il dispositivo resta com’è finché non lo decidi tu: fuori servizio, compare così in tutte le viste e negli elenchi.':
    'Le contrôle n’a pas été réussi. Le dispositif reste tel quel jusqu’à votre décision : hors service, il apparaît ainsi dans toutes les vues et listes.',
  'Le scadenze delle manutenzioni e delle verifiche di sicurezza elettrica (CEI EN 62353) di tutti gli elettromedicali, e chi riceve i promemoria.':
    'Les échéances des maintenances et des contrôles de sécurité électrique (CEI EN 62353) de tous les dispositifs médicaux, et qui reçoit les rappels.',
  'L’evento è spento nelle Impostazioni: non parte nessuna mail.':
    'L’événement est désactivé dans les Paramètres : aucun e-mail n’est envoyé.',
  'Manutenzione preventiva':
    'Maintenance préventive',
  'Manutenzioni e verifiche':
    'Maintenances et contrôles',
  'Mettere il dispositivo fuori servizio?':
    'Mettre le dispositif hors service ?',
  'Metti fuori servizio':
    'Mettre hors service',
  'Misure (come le dà lo strumento)':
    'Mesures (telles que l’instrument les donne)',
  'Modifica il piano':
    'Modifier le plan',
  'Nessun piano di verifica: si creano dalla scheda di ogni dispositivo, o dai predefiniti del modello.':
    'Aucun plan de contrôle : ils se créent depuis la fiche de chaque dispositif ou à partir des valeurs par défaut du modèle.',
  'Nessun piano: quali verifiche, ogni quanto.':
    'Aucun plan : quels contrôles, à quelle fréquence.',
  'Nessuna verifica registrata.':
    'Aucun contrôle enregistré.',
  'Non ora':
    'Pas maintenant',
  'Non superata':
    'Échoué',
  'Non superate (90 giorni)':
    'Échoués (90 jours)',
  'Nuovo piano di verifica':
    'Nouveau plan de contrôle',
  'Nuovo piano…':
    'Nouveau plan…',
  'Ogni':
    'Tous les',
  'Ogni (mesi)':
    'Tous les (mois)',
  'Più avanti':
    'Plus tard',
  'Predefiniti del modello':
    'Valeurs par défaut du modèle',
  'Predefiniti del modello applicati: {n} piani nuovi.':
    'Valeurs par défaut du modèle appliquées : {n} nouveaux plans.',
  'Promemoria':
    'Rappels',
  'Rapporto e note':
    'Rapport et notes',
  'Registra una verifica':
    'Enregistrer un contrôle',
  'Registra una verifica…':
    'Enregistrer un contrôle…',
  'Resistenza del conduttore di protezione (Ω)':
    'Résistance du conducteur de protection (Ω)',
  'Resistenza di isolamento (MΩ)':
    'Résistance d’isolement (MΩ)',
  'Salva i predefiniti':
    'Enregistrer les valeurs par défaut',
  'Scaduta':
    'Échu',
  'Senza data':
    'Sans date',
  'Stato del dispositivo':
    'État du dispositif',
  'Superata':
    'Réussi',
  'Superata con riserva':
    'Réussi avec réserves',
  'Taratura':
    'Étalonnage',
  'Togliere il piano «{k}»?':
    'Retirer le plan « {k} » ?',
  'Togliere questa verifica e il suo rapporto?':
    'Retirer ce contrôle et son rapport ?',
  'Un piano sospeso non compare nelle scadenze e non manda promemoria.':
    'Un plan suspendu n’apparaît pas dans les échéances et n’envoie pas de rappels.',
  'Una mail al giorno con le verifiche a 60, 30, 7 giorni dalla scadenza e alla scadenza, e ogni settimana quelle scadute. Va ai destinatari delle notifiche del tenant (evento «manutenzioni e verifiche degli elettromedicali», in Impostazioni) e a quelli scritti qui.':
    'Un e-mail par jour avec les contrôles à 60, 30, 7 jours de l’échéance et à l’échéance, et chaque semaine ceux échus. Il va aux destinataires des notifications du tenant (événement « maintenances et contrôles des dispositifs médicaux », dans les Paramètres) et à ceux saisis ici.',
  'Verifica funzionale':
    'Contrôle fonctionnel',
  'Verifica non superata':
    'Contrôle échoué',
  'Verifiche fatte':
    'Contrôles effectués',
  'Verifiche non superate negli ultimi 90 giorni':
    'Contrôles échoués ces 90 derniers jours',
  'Vuota: oggi, o dall’ultima verifica dello stesso tipo. Poi la sposta ogni verifica registrata.':
    'Vide : aujourd’hui, ou depuis le dernier contrôle du même type. Ensuite chaque contrôle enregistré la déplace.',
  'alternativo':
    'alternative',
  'differenziale':
    'différentielle',
  'il fornitore o l’Ingegneria clinica':
    'le fournisseur ou le génie biomédical',
  'mesi':
    'mois',
  'metodo':
    'méthode',
  'rapporto':
    'rapport',
  'tecnico e ditta':
    'technicien et société',
  'verifiche':
    'contrôles',
  'nome@ospedale.it':
    'nom@hopital.fr',
  'Ogni dispositivo ha i suoi piani: quale verifica (manutenzione preventiva, sicurezza elettrica CEI EN 62353, taratura, funzionale), ogni quanti mesi, con quale contratto e chi la fa. Una verifica registrata (data, chi, esito, misure di sicurezza elettrica, rapporto PDF) sposta la prossima scadenza. CENSO non giudica le misure; se una verifica non è superata propone di mettere il dispositivo fuori servizio, e decide una persona. I predefiniti del modello (piani e classe elettrica), scritti nella scheda del modello, si applicano a un dispositivo e riempiono solo ciò che manca. La vista «Manutenzioni e verifiche» elenca le scadenze di tutta l’area; ogni giorno parte una mail con quelle a 60, 30, 7 giorni e alla scadenza, e ogni settimana quelle scadute, ai destinatari delle notifiche (evento acceso in Impostazioni) e a quelli dell’area.':
    'Chaque dispositif a ses plans : quel contrôle (maintenance préventive, sécurité électrique CEI EN 62353, étalonnage, fonctionnel), tous les combien de mois, avec quel contrat et qui le réalise. Un contrôle enregistré (date, qui, résultat, mesures de sécurité électrique, rapport PDF) déplace la prochaine échéance. CENSO ne juge pas les mesures ; si un contrôle échoue il propose de mettre le dispositif hors service, et une personne décide. Les valeurs par défaut du modèle (plans et classe électrique), saisies dans la fiche du modèle, s’appliquent à un dispositif et ne complètent que ce qui manque. La vue « Maintenances et contrôles » liste les échéances de tout l’espace ; chaque jour part un e-mail avec celles à 60, 30, 7 jours et à l’échéance, et chaque semaine celles échues, aux destinataires des notifications (événement activé dans les Paramètres) et à ceux de l’espace.',
  'Altri candidati ({n})':
    'Autres candidats ({n})',
  'CND':
    'CND',
  'Classificazione CND':
    'Classification CND',
  'Codice catalogo':
    'Code catalogue',
  'Codici CND':
    'Codes CND',
  'Confermate':
    'Confirmées',
  'Corrispondenza':
    'Correspondance',
  'Corrispondenza probabile, da controllare: più voci del registro portano il codice del modello.':
    'Correspondance probable, à vérifier : plusieurs entrées du registre portent le code du modèle.',
  'Corrispondenza probabile: il codice del modello compare nel registro una volta sola.':
    'Correspondance probable : le code du modèle n’apparaît qu’une fois dans le registre.',
  'Corrispondenza verificata dall’amministrazione della piattaforma.':
    'Correspondance vérifiée par l’administration de la plateforme.',
  'Corrispondenze dei modelli':
    'Correspondances des modèles',
  'Da confermare':
    'À confirmer',
  'Denominazione':
    'Dénomination',
  'Denominazione commerciale':
    'Dénomination commerciale',
  'Dispositivi del registro tenuti':
    'Dispositifs du registre conservés',
  'Fonti elettromedicali':
    'Sources des dispositifs médicaux',
  'Fuori commercio dal':
    'Hors commerce depuis',
  'Iscritto al Repertorio':
    'Inscrit au Repertorio',
  'Ministero':
    'Ministère',
  'Ministero della Salute (CND e registro dei dispositivi) e openFDA: aggiornamento e corrispondenze dei modelli da confermare':
    'Ministère italien de la Santé (CND et registre des dispositifs) et openFDA : mise à jour et correspondances des modèles à confirmer',
  'Ministero della Salute — Classificazione CND':
    'Ministère italien de la Santé — classification CND',
  'Ministero della Salute — Registro dei dispositivi medici':
    'Ministère italien de la Santé — registre des dispositifs médicaux',
  'Nessuna corrispondenza in questo stato.':
    'Aucune correspondance dans cet état.',
  'Nessuna corrispondenza nel registro dei dispositivi medici per questo modello.':
    'Aucune correspondance dans le registre des dispositifs médicaux pour ce modèle.',
  'Nessuna fonte letta finora: «Esegui adesso», o si aggiornano da sole una volta al mese di notte.':
    'Aucune source lue jusqu’ici : « Exécuter maintenant », ou elles se mettent à jour seules une fois par mois la nuit.',
  'Numero nel registro':
    'Numéro du registre',
  'Quali':
    'Lesquelles',
  'Registro del Ministero della Salute':
    'Registre du ministère italien de la Santé',
  'Rifiutate':
    'Rejetées',
  'Rivista da':
    'Revue par',
  'Scegli questa':
    'Choisir celle-ci',
  'Si conosce solo la serie: il registro si consulta per un modello preciso.':
    'Seule la série est connue : le registre se consulte pour un modèle précis.',
  'Usa questo codice CND':
    'Utiliser ce code CND',
  'apparecchiature (CND Z e W) dei produttori noti':
    'équipements (CND Z et W) des fabricants connus',
  'confermate':
    'confirmées',
  'dal numero di prodotto, nel registro del Ministero della Salute':
    'du numéro de produit, dans le registre du ministère italien de la Santé',
  'in commercio':
    'en commerce',
  'openFDA':
    'openFDA',
  'probabile':
    'probable',
  'rifiutate':
    'rejetées',
  'Registro del Ministero: per ogni modello CENSO cerca nel registro dei dispositivi medici del Ministero della Salute la voce con il suo codice (per esempio «INTELLIVUE MX450», codice 866062) e ne mostra classificazione CND, CIVAB, iscrizione al Repertorio e fuori commercio, come «verificata» o «probabile». «Usa questo codice CND» lo scrive nella scheda. Se un dispositivo dice in rete il suo numero di prodotto, il registro dà anche il modello esatto.':
    'Registre du ministère : pour chaque modèle CENSO cherche dans le registre des dispositifs médicaux du ministère italien de la Santé l’entrée avec son code (par exemple « INTELLIVUE MX450 », code 866062) et en montre la classification CND, le CIVAB, l’inscription au Repertorio et la fin de commercialisation, comme « vérifiée » ou « probable ». « Utiliser ce code CND » l’écrit dans la fiche. Si un dispositif annonce son numéro de produit sur le réseau, le registre donne aussi le modèle exact.',
  'Aperti':
    'Ouverts',
  'Apri il richiamo sul sito dell’autorità':
    'Ouvrir le rappel sur le site de l’autorité',
  'Attiva {fonte}':
    'Activer {fonte}',
  'Autorità':
    'Autorité',
  'Avviato il':
    'Lancé le',
  'Avvisi di sicurezza informatica (CISA ICSMA)':
    'Avis de cybersécurité (CISA ICSMA)',
  'Avvisi informatici aperti':
    'Avis cyber ouverts',
  'Azione richiesta dalla ditta':
    'Action demandée par le fabricant',
  'Basi dati pubbliche':
    'Bases de données publiques',
  'CISA ICSMA':
    'CISA ICSMA',
  'CISA — avvisi di sicurezza informatica dei dispositivi medici (ICSMA)':
    'CISA — avis de cybersécurité des dispositifs médicaux (ICSMA)',
  'CND / codice FDA':
    'CND / code FDA',
  'Causa':
    'Cause',
  'Chiamate openFDA oggi':
    'Appels openFDA aujourd’hui',
  'Classe FDA':
    'Classe FDA',
  'Codice prodotto FDA':
    'Code produit FDA',
  'Come lo gestite':
    'Comment vous le traitez',
  'Con la fonte openFDA attiva, CENSO cerca ogni modello nella banca dati GUDID della FDA e ne mostra nella scheda nome commerciale, codice catalogo, classe FDA, codice prodotto, sicurezza in risonanza magnetica e la definizione del termine GMDN, al posto della destinazione d’uso che la FDA non pubblica. Ogni giorno legge i richiami e i rapporti di enforcement dei produttori dei vostri dispositivi e li abbina ai modelli: un richiamo vale per un modello quando ne porta la sigla (per esempio «MX450», anche dentro «MX400/450») o il codice catalogo (866062); un richiamo che nomina solo la serie non si abbina a nessuno.':
    'Avec la source openFDA active, CENSO cherche chaque modèle dans la base GUDID de la FDA et affiche sur la fiche le nom commercial, la référence catalogue, la classe FDA, le code produit, la sécurité en IRM et la définition du terme GMDN, à la place de la destination d’usage que la FDA ne publie pas. Chaque jour il lit les rappels et les rapports d’enforcement des fabricants de vos dispositifs et les associe aux modèles : un rappel vaut pour un modèle quand il en porte le code (par exemple « MX450 », même dans « MX400/450 ») ou la référence catalogue (866062) ; un rappel qui ne nomme que la série ne s’associe à aucun.',
  'Corrispondenza probabile, da controllare: più modelli della FDA portano il codice del modello.':
    'Correspondance probable, à vérifier : plusieurs modèles de la FDA portent le code du modèle.',
  'Corrispondenza probabile: un solo modello della FDA porta il codice del modello.':
    'Correspondance probable : un seul modèle de la FDA porte le code du modèle.',
  'Cosa dice l’autorità':
    'Ce que dit l’autorité',
  'Cosa dà':
    'Ce qu’elle fournit',
  'Definizione del termine GMDN {codice} «{nome}»: la banca dati FDA non riporta la destinazione d’uso del fabbricante.':
    'Définition du terme GMDN {codice} « {nome} » : la base de la FDA ne donne pas la destination d’usage du fabricant.',
  'Destinazione d’uso':
    'Destination d’usage',
  'Di classe I':
    'De classe I',
  'Dispositivi interessati':
    'Dispositifs concernés',
  'Ditta':
    'Fabricant',
  'FDA (Stati Uniti)':
    'FDA (États-Unis)',
  'FDA e richiami':
    'FDA et rappels',
  'FDA — identificazione del dispositivo (GUDID)':
    'FDA — identification du dispositif (GUDID)',
  'Gestito':
    'Traité',
  'I richiami e gli avvisi di sicurezza delle autorità sui modelli dei vostri elettromedicali, e gli avvisi di sicurezza informatica sui vostri dispositivi: come li gestite.':
    'Les rappels et avis de sécurité des autorités sur les modèles de vos dispositifs médicaux, et les avis de cybersécurité sur vos dispositifs : comment vous les traitez.',
  'I testi sono quelli pubblicati dall’autorità, nella sua lingua.':
    'Les textes sont ceux publiés par l’autorité, dans sa langue.',
  'I vostri dispositivi interessati ({n})':
    'Vos dispositifs concernés ({n})',
  'Il Paese accende le basi dati che gli servono; ognuna si può poi accendere o spegnere a mano.':
    'Le pays active les bases de données qui lui servent ; chacune peut ensuite être activée ou désactivée à la main.',
  'Il Paese dell’ospedale accende le basi dati pubbliche che gli servono (registri dei dispositivi, richiami); ognuna si può accendere o spegnere a mano.':
    'Le pays de l’hôpital active les bases de données publiques qui lui servent (registres des dispositifs, rappels) ; chacune peut être activée ou désactivée à la main.',
  'Il Paese non è ancora stato scelto: CENSO assume l’Italia. Sceglietelo per attivare le basi dati giuste.':
    'Le pays n’a pas encore été choisi : CENSO suppose l’Italie. Choisissez-le pour activer les bonnes bases de données.',
  'Il richiamo riguarda il modello: verificate con il fornitore numero di serie e versione dei vostri esemplari.':
    'Le rappel concerne le modèle : vérifiez avec le fournisseur le numéro de série et la version de vos appareils.',
  'In gestione':
    'En cours',
  'In «Paese e basi dati» si sceglie il Paese dell’ospedale: il Paese accende le basi dati pubbliche che gli servono (per l’Italia il Ministero della Salute, per gli Stati Uniti la FDA) e ognuna si può poi accendere o spegnere a mano; un ospedale italiano, per esempio, può tenere anche i richiami della FDA, perché gli stessi modelli si vendono in entrambi i mercati. Le schede, il catalogo modelli e i richiami mostrano solo le fonti attive. Le fonti si leggono una volta per tutta la piattaforma e non si scaricano se nessun ospedale le usa. Gli avvisi di sicurezza informatica della CISA valgono ovunque e sono sempre attivi. Finché il Paese non è scelto, CENSO assume l’Italia.':
    'Dans « Pays et bases de données » on choisit le pays de l’hôpital : le pays active les bases de données publiques qui lui servent (pour l’Italie le Ministero della Salute, pour les États-Unis la FDA) et chacune peut ensuite être activée ou désactivée à la main ; un hôpital italien, par exemple, peut garder aussi les rappels de la FDA, car les mêmes modèles sont vendus sur les deux marchés. Les fiches, le catalogue des modèles et les rappels ne montrent que les sources actives. Les sources sont lues une fois pour toute la plateforme et ne sont pas téléchargées si aucun hôpital ne les utilise. Les avis de cybersécurité de la CISA valent partout et sont toujours actifs. Tant que le pays n’est pas choisi, CENSO suppose l’Italie.',
  'La vista «Richiami e avvisi» elenca i richiami sui vostri modelli con i dispositivi interessati, e accanto gli avvisi di sicurezza informatica della CISA sui vostri dispositivi. Per ogni richiamo si annota come lo si gestisce (da valutare, in gestione, gestito, non ci riguarda) con una nota: il richiamo riguarda il modello, il numero di serie e la versione si verificano con il fornitore. I richiami pubblicati negli ultimi 60 giorni arrivano una volta per mail ai destinatari delle notifiche (evento acceso in Impostazioni) e a quelli dell’area; quelli più vecchi si vedono solo nell’elenco. I testi sono quelli dell’autorità, nella sua lingua.':
    'La vue « Rappels et avis » liste les rappels sur vos modèles avec les dispositifs concernés, et à côté les avis de cybersécurité de la CISA sur vos dispositifs. Pour chaque rappel on note comment il est traité (à évaluer, en cours, traité, ne nous concerne pas) avec une note : le rappel concerne le modèle, le numéro de série et la version se vérifient avec le fournisseur. Les rappels publiés dans les 60 derniers jours sont envoyés une fois par e-mail aux destinataires des notifications (événement activé dans Paramètres) et à ceux de l’espace ; les plus anciens sont seulement listés. Les textes sont ceux de l’autorité, dans sa langue.',
  'Le basi dati pubbliche (Ministero della Salute, openFDA…), lette in sottofondo solo se un ospedale le usa (il suo Paese le accende), e le corrispondenze con i modelli del catalogo da confermare.':
    'Les bases de données publiques (Ministero della Salute, openFDA…), lues en arrière-plan seulement si un hôpital les utilise (son pays les active), et les correspondances avec les modèles du catalogue à confirmer.',
  'Le fonti si leggono una volta per tutta la piattaforma; ogni ospedale vede solo quelle attive per sé. Una fonte che nessun ospedale usa non viene scaricata.':
    'Les sources sont lues une fois pour toute la plateforme ; chaque hôpital ne voit que celles actives pour lui. Une source qu’aucun hôpital n’utilise n’est pas téléchargée.',
  'Ministero della Salute — Classificazione CND e Banca dati dei dispositivi medici':
    'Ministero della Salute (Italie) — Classification CND et base de données des dispositifs médicaux',
  'N. di serie':
    'N° de série',
  'Nessun avviso CISA sui vostri elettromedicali.':
    'Aucun avis CISA sur vos dispositifs médicaux.',
  'Nessun richiamo sui modelli dei vostri elettromedicali. Si cercano per modello esatto: i dispositivi di cui si conosce solo la serie non si abbinano.':
    'Aucun rappel sur les modèles de vos dispositifs médicaux. Ils sont cherchés par modèle exact : les dispositifs dont on ne connaît que la série ne sont pas associés.',
  'Nessun richiamo sul modello dalle fonti attive.':
    'Aucun rappel sur le modèle dans les sources actives.',
  'Nessuna corrispondenza nella banca dati GUDID della FDA per questo modello (o non ancora cercata).':
    'Aucune correspondance dans la base GUDID de la FDA pour ce modèle (ou pas encore cherchée).',
  'Nessuna fonte di richiami attiva per il vostro ospedale.':
    'Aucune source de rappels n’est active pour votre hôpital.',
  'Nome commerciale':
    'Nom commercial',
  'Non ci riguarda':
    'Ne nous concerne pas',
  'Ospedali che la usano':
    'Hôpitaux qui l’utilisent',
  'Paese della fonte':
    'Pays de la source',
  'Paese dell’ospedale':
    'Pays de l’hôpital',
  'Paese e basi dati':
    'Pays et bases de données',
  'Per il vostro Paese':
    'Pour votre pays',
  'Pubblicato il':
    'Publié le',
  'Regolamento':
    'Règlement',
  'Richiami da gestire':
    'Rappels à traiter',
  'Richiami e avvisi':
    'Rappels et avis',
  'Richiami e avvisi ({n})':
    'Rappels et avis ({n})',
  'Richiami e avvisi di sicurezza delle autorità':
    'Rappels et avis de sécurité des autorités',
  'Richiami letti da: {fonti}.':
    'Rappels lus depuis : {fonti}.',
  'Richiami sul modello':
    'Rappels sur le modèle',
  'Richiami sul modello ({n})':
    'Rappels sur le modèle ({n})',
  'Richiami tenuti':
    'Rappels conservés',
  'Richiamo':
    'Rappel',
  'Salvato: le schede e i richiami seguono le nuove fonti.':
    'Enregistré : les fiches et les rappels suivent les nouvelles sources.',
  'Si conosce solo la serie: i richiami si abbinano al modello preciso.':
    'On ne connaît que la série : les rappels s’associent au modèle précis.',
  'Si conosce solo la serie: la banca dati si consulta per un modello preciso.':
    'On ne connaît que la série : la base se consulte pour un modèle précis.',
  'Sicurezza in risonanza magnetica':
    'Sécurité en IRM',
  'Specialità':
    'Spécialité',
  'Stato presso l’autorità':
    'Statut auprès de l’autorité',
  'Tutti i richiami':
    'Tous les rappels',
  'UDI-DI primario':
    'UDI-DI principal',
  'Ultima modifica: {chi}, {quando}':
    'Dernière modification : {chi}, {quando}',
  'Unione europea':
    'Union européenne',
  'Visto dal':
    'Vu depuis',
  'classificazione':
    'classification',
  'con chiave API':
    'avec clé API',
  'identificazione dei modelli':
    'identification des modèles',
  'la classe più grave (FDA)':
    'la classe la plus grave (FDA)',
  'openFDA — Food and Drug Administration (Stati Uniti)':
    'openFDA — Food and Drug Administration (États-Unis)',
  'per esempio: sentito il fornitore, aggiornamento software pianificato il …':
    'par exemple : fournisseur contacté, mise à jour logicielle prévue le …',
  'richiami':
    'rappels',
  'sempre attiva':
    'toujours active',
  'senza chiave: CENSO_OPENFDA_API_KEY ne dà 120 mila':
    'sans clé : CENSO_OPENFDA_API_KEY en donne 120 mille',
  'sicurezza informatica':
    'cybersécurité',
  '{n} abbinati a un modello':
    '{n} associés à un modèle',
  '«Esegui adesso» legge la fonte anche se nessun ospedale la usa ancora; da sola si aggiorna solo quando serve a qualcuno.':
    '« Exécuter maintenant » lit la source même si aucun hôpital ne l’utilise encore ; seule, elle ne se met à jour que si quelqu’un en a besoin.',
  'Avvisa su manutenzioni, verifiche e richiami degli elettromedicali':
    'Avertir des maintenances, contrôles et rappels des dispositifs médicaux',
  'CENSO MED: le manutenzioni e le verifiche di sicurezza elettrica in scadenza (60, 30, 7 giorni prima e alla scadenza), ogni settimana quelle scadute, e i nuovi richiami delle autorità sui modelli dei vostri elettromedicali. Gli avvisi vanno anche ai destinatari scelti nell’area CENSO MED.':
    'CENSO MED : les maintenances et contrôles de sécurité électrique arrivant à échéance (60, 30, 7 jours avant et à l’échéance), chaque semaine ceux échus, et les nouveaux rappels des autorités sur les modèles de vos dispositifs médicaux. Les avis vont aussi aux destinataires choisis dans l’espace CENSO MED.',
  'EUDAMED':
    'EUDAMED',
  'Per gli ospedali dell’Unione europea (e di Norvegia, Islanda e Liechtenstein) è attiva EUDAMED, la banca dati europea dei dispositivi medici: per ogni modello CENSO trova il dispositivo registrato dal fabbricante e ne mostra il riferimento, la classe di rischio secondo il regolamento MDR, il codice della nomenclatura europea EMDN (gli stessi codici della CND italiana: «Usa questo codice EMDN» lo scrive nella scheda), se è ancora sul mercato e in quali Paesi dell’Unione è disponibile. La parte di EUDAMED sugli avvisi di sicurezza non è pubblica: i richiami arrivano dalle autorità nazionali.':
    'Pour les hôpitaux de l’Union européenne (et de Norvège, d’Islande et du Liechtenstein) EUDAMED, la base de données européenne des dispositifs médicaux, est active : pour chaque modèle CENSO trouve le dispositif enregistré par le fabricant et en affiche la référence, la classe de risque selon le règlement MDR, le code de la nomenclature européenne EMDN (les mêmes codes que la CND italienne : « Utiliser ce code EMDN » l’écrit sur la fiche), s’il est encore sur le marché et dans quels pays de l’Union il est disponible. La partie d’EUDAMED sur les avis de sécurité n’est pas publique : les rappels viennent des autorités nationales.',
  'EUDAMED — Banca dati europea dei dispositivi medici (Commissione europea)':
    'EUDAMED — Base de données européenne sur les dispositifs médicaux (Commission européenne)',
  'EUDAMED — banca dati europea':
    'EUDAMED — base de données européenne',
  'Nessuna corrispondenza in EUDAMED per questo modello (o non ancora cercata).':
    'Aucune correspondance dans EUDAMED pour ce modèle (ou pas encore cherchée).',
  'Usa questo codice EMDN':
    'Utiliser ce code EMDN',
  'Corrispondenza probabile: un solo dispositivo del fabbricante in EUDAMED porta il codice del modello.':
    'Correspondance probable : un seul dispositif du fabricant dans EUDAMED porte le code du modèle.',
  'Corrispondenza probabile, da controllare: più dispositivi del fabbricante in EUDAMED portano il codice del modello.':
    'Correspondance probable, à vérifier : plusieurs dispositifs du fabricant dans EUDAMED portent le code du modèle.',
  'Riferimento del fabbricante':
    'Référence du fabricant',
  'Classe di rischio (MDR)':
    'Classe de risque (MDR)',
  'Nomenclatura EMDN':
    'Nomenclature EMDN',
  'Sul mercato':
    'Sur le marché',
  'Paesi UE in cui è disponibile':
    'Pays de l’UE où il est disponible',
  'Descrizione del fabbricante':
    'Description du fabricant',
  'sul mercato':
    'sur le marché',
  'non più immesso sul mercato':
    'n’est plus mis sur le marché',
  'non destinato al mercato UE':
    'non destiné au marché de l’UE',
  'MHRA (Regno Unito)':
    'MHRA (Royaume-Uni)',
  'Health Canada (Canada)':
    'Santé Canada (Canada)',
  'Richiami delle autorità nazionali':
    'Rappels des autorités nationales',
  'Oltre alla FDA, CENSO legge i richiami e gli avvisi di sicurezza delle autorità nazionali, ognuno attivo per il suo Paese e accendibile a mano dagli altri: MHRA per il Regno Unito (le Field Safety Notice settimanali e gli avvisi dell’MHRA, con il modello indicato nella riga «Model»), Health Canada per il Canada (i richiami dei dispositivi medici, con la tabella dei prodotti interessati e i loro codici), BfArM per la Germania, ANSM per la Francia e Swissmedic per la Svizzera (gli avvisi di sicurezza dei fabbricanti). Si tengono solo i richiami dei produttori che CENSO conosce, e si abbinano ai modelli come quelli della FDA.':
    'Outre la FDA, CENSO lit les rappels et avis de sécurité des autorités nationales, chacune active pour son pays et activable à la main pour les autres : la MHRA pour le Royaume-Uni (les Field Safety Notices hebdomadaires et les alertes de la MHRA, avec le modèle indiqué à la ligne « Model »), Santé Canada pour le Canada (les rappels des dispositifs médicaux, avec le tableau des produits concernés et leurs codes), le BfArM pour l’Allemagne, l’ANSM pour la France et Swissmedic pour la Suisse (les avis de sécurité des fabricants). Seuls les rappels des fabricants que CENSO connaît sont gardés, et ils sont associés aux modèles comme ceux de la FDA.',
  'MHRA — avvisi di sicurezza e Field Safety Notice (Regno Unito)':
    'MHRA — alertes de sécurité et Field Safety Notices (Royaume-Uni)',
  'Health Canada — richiami dei dispositivi medici (Canada)':
    'Santé Canada — rappels des dispositifs médicaux (Canada)',
  'BfArM (Germania)':
    'BfArM (Allemagne)',
  'ANSM (Francia)':
    'ANSM (France)',
  'Swissmedic (Svizzera)':
    'Swissmedic (Suisse)',
  'Altri avvisi sui vostri produttori ({n})':
    'Autres avis sur vos fabricants ({n})',
  'Avvisi degli ultimi 180 giorni che non indicano un modello del catalogo ma vengono dai produttori dei vostri elettromedicali: spesso nominano solo il prodotto e i modelli stanno nella lettera del fabbricante. Da controllare; non arrivano per mail.':
    'Avis des 180 derniers jours qui n’indiquent aucun modèle du catalogue mais viennent des fabricants de vos dispositifs médicaux : souvent ils ne nomment que le produit et les modèles sont dans la lettre du fabricant. À vérifier ; ils ne sont pas envoyés par e-mail.',
  'Molti avvisi nazionali nominano solo il prodotto («Azurion») e lasciano i modelli alla lettera del fabbricante: quelli dei produttori dei vostri elettromedicali compaiono in «Altri avvisi sui vostri produttori», da controllare, senza mail.':
    'Beaucoup d’avis nationaux ne nomment que le produit (« Azurion ») et laissent les modèles à la lettre du fabricant : ceux des fabricants de vos dispositifs médicaux apparaissent dans « Autres avis sur vos fabricants », à vérifier, sans e-mail.',
  'BfArM — avvisi di sicurezza dei fabbricanti (Germania)':
    'BfArM — avis de sécurité des fabricants (Allemagne)',
  'ANSM — informazioni di sicurezza sui dispositivi medici (Francia)':
    'ANSM — informations de sécurité sur les dispositifs médicaux (France)',
  'Swissmedic — azioni correttive di sicurezza (Svizzera)':
    'Swissmedic — actions correctives de sécurité (Suisse)',
  'Ogni ospedale con inventario misurato solo con ciò che hanno insegnato gli altri: è ciò che CENSO farebbe in un ospedale senza riferimento. «Senza cattura» toglie i fatti del filo (DICOM, HL7, User-Agent, TLS, SSH, SMB, SIP), che senza porta mirror o TAP non arrivano. «Solo validate»: le regole viste in almeno due ospedali, quelle che entrano in uso da sole. In ogni cella: riconosciuti come modello · come elettromedicale.':
    'Chaque hôpital avec inventaire mesuré seulement avec ce que les autres ont appris : c’est ce que CENSO ferait dans un hôpital sans référence. « Sans capture » retire les faits du fil (DICOM, HL7, User-Agent, TLS, SSH, SMB, SIP), qui n’arrivent pas sans port miroir ni TAP. « Seulement validées » : les règles vues dans au moins deux hôpitaux, celles qui entrent en service seules. Dans chaque cellule : reconnus comme modèle · comme dispositif médical.',
  'Quanto si riconosce un ospedale nuovo':
    'Combien un nouvel hôpital est reconnu',
  'con il proprio inventario':
    'avec son propre inventaire',
  'dagli altri, senza cattura':
    'des autres, sans capture',
  'dagli altri, solo regole validate':
    'des autres, seulement règles validées',
  'imparando dagli altri ospedali':
    'en apprenant des autres hôpitaux',
  'modello · elettromedicale; {n} falsi positivi':
    'modèle · dispositif médical ; {n} faux positifs',
  'modello: {p}':
    'modèle : {p}',
  'ospedale nuovo, {scenario}: elettromedicale':
    'nouvel hôpital, {scenario} : dispositif médical',
  'senza cattura, solo validate':
    'sans capture, seulement validées',
  'sospesa da CENSO: {motivo}':
    'suspendue par CENSO : {motivo}',
  'Rete dei monitor':
    'Réseau des moniteurs',
  'modello dalla rete dei monitor':
    'modèle depuis le réseau des moniteurs',
  'modello {m}':
    'modèle {m}',
  'rete dei monitor (centrale o monitor)':
    'réseau des moniteurs (centrale ou moniteur)',
  'software {v}':
    'logiciel {v}',
  'tipo dalla rete dei monitor':
    'type depuis le réseau des moniteurs',
  'Se la sonda ha una gamba nella rete dei monitor, legge anche ciò che i monitor annunciano di sé: reparto e stanza configurati sulla centrale GE CARESCAPE, letto, modello, seriale e versione software dei monitor Philips IntelliVue quando li dichiarano. Diventano suggerimenti di confidenza alta. I dati dei pazienti che passano su quella rete non vengono letti né salvati.':
    'Si la sonde a une patte dans le réseau des moniteurs, elle lit aussi ce que les moniteurs annoncent d’eux-mêmes : l’unité et la chambre configurées sur la centrale GE CARESCAPE, le lit, le modèle, le numéro de série et la version logicielle des moniteurs Philips IntelliVue quand ils les déclarent. Ils deviennent des suggestions de confiance élevée. Les données des patients qui passent sur ce réseau ne sont ni lues ni enregistrées.',
  '{w} di questi sono noti solo per indirizzo.':
    '{w} d’entre eux ne sont connus que par leur adresse.',
  'Anche i sistemi che parlano DICOM o HL7 visti solo per indirizzo, dietro un router (PACS, RIS, motori HL7, analizzatori di laboratorio): un apparecchio riconosciuto dal prodotto diventa elettromedicale, gli altri server o postazione secondo il sistema che hanno dichiarato sul filo. I PC d’ufficio visti solo per indirizzo non si registrano.':
    'Également les systèmes qui parlent DICOM ou HL7 vus uniquement par leur adresse, derrière un routeur (PACS, RIS, moteurs HL7, analyseurs de laboratoire) : un appareil reconnu par son produit devient un dispositif médical, les autres un serveur ou un poste de travail selon le système qu’ils ont déclaré sur le fil. Les PC de bureau vus uniquement par leur adresse ne sont pas enregistrés.',
  'Registra anche i sistemi che CENSO conosce solo per indirizzo perché stanno dietro un router (la sonda vede il loro IP, non il MAC) e che parlano DICOM o HL7: PACS, RIS, motori di integrazione, analizzatori di laboratorio. Un apparecchio riconosciuto dal prodotto (un Alinity, un Luminos) diventa elettromedicale; un computer che serve un’applicazione clinica resta un computer, server o postazione secondo la versione di Windows o la distribuzione che ha dichiarato sul filo, con AE title, applicazioni HL7 e protocolli clinici fra gli attributi. Quando la versione di Windows vale per due edizioni (build 14393: Server 2016 o Windows 10) il CI è un server per convenzione, con le due possibilità scritte. Se poi una scansione o l’hypervisor trova lo stesso host, ritrova questo CI invece di crearne un secondo. I PC d’ufficio visti solo per indirizzo non si registrano: con un IP dinamico l’indirizzo non identifica niente.':
    'Il enregistre aussi les systèmes que CENSO ne connaît que par leur adresse parce qu’ils sont derrière un routeur (la sonde voit leur IP, pas leur MAC) et qui parlent DICOM ou HL7 : PACS, RIS, moteurs d’intégration, analyseurs de laboratoire. Un appareil reconnu par son produit (un Alinity, un Luminos) devient un dispositif médical ; un ordinateur qui sert une application clinique reste un ordinateur, serveur ou poste de travail selon la version de Windows ou la distribution qu’il a déclarée sur le fil, avec les AE title, les applications HL7 et les protocoles cliniques parmi ses attributs. Quand la version de Windows vaut pour deux éditions (build 14393 : Server 2016 ou Windows 10), le CI est un serveur par convention, avec les deux possibilités indiquées. Si un scan ou l’hyperviseur trouve ensuite le même hôte, il retrouve ce CI au lieu d’en créer un second. Les PC de bureau vus uniquement par leur adresse ne sont pas enregistrés : avec une IP dynamique, l’adresse n’identifie rien.',
  'AE title':
    'AE title',
  'Altro traffico':
    'Autre trafic',
  'Applicazione clinica':
    'Application clinique',
  'Applicazioni HL7':
    'Applications HL7',
  'Che cos’è':
    'Ce que c’est',
  'Cosa dice di sé':
    'Ce qu’il dit de lui-même',
  'Cosa fa':
    'Ce qu’il fait',
  'Elettromedicali collegati':
    'Dispositifs médicaux connectés',
  'Gli elettromedicali che gli parlano ({n})':
    'Les dispositifs médicaux qui lui parlent ({n})',
  'Gli manda immagini (DICOM)':
    'Lui envoie des images (DICOM)',
  'Gli manda immagini o lo interroga (DICOM)':
    'Lui envoie des images ou l’interroge (DICOM)',
  'I computer che parlano DICOM o HL7 e non sono elettromedicali: PACS, RIS, motori di integrazione, middleware di laboratorio, postazioni di refertazione. Li riconosce la sonda dal traffico; quanti elettromedicali gli parlano viene dai flussi degli ultimi 7 giorni.':
    'Les ordinateurs qui parlent DICOM ou HL7 et ne sont pas des dispositifs médicaux : PACS, RIS, moteurs d’intégration, middleware de laboratoire, postes de compte rendu. La sonde les reconnaît à partir du trafic ; le nombre de dispositifs médicaux qui leur parlent vient des flux des 7 derniers jours.',
  'I sistemi con cui lavorano gli elettromedicali: PACS, RIS, motori HL7, middleware di laboratorio, postazioni di refertazione. Sono computer, non elettromedicali, e non entrano nei conteggi dei dispositivi.':
    'Les systèmes avec lesquels travaillent les dispositifs médicaux : PACS, RIS, moteurs HL7, middleware de laboratoire, postes de compte rendu. Ce sont des ordinateurs, pas des dispositifs médicaux, et ils n’entrent pas dans le décompte des dispositifs.',
  'Implementazione':
    'Implémentation',
  'Messaggi HL7':
    'Messages HL7',
  'Nome sulla rete':
    'Nom sur le réseau',
  'Non in CMDB':
    'Pas dans la CMDB',
  'PACS, RIS, HL7: computer, non elettromedicali':
    'PACS, RIS, HL7 : ordinateurs, pas des dispositifs médicaux',
  'Server web':
    'Serveur web',
  'Sistema clinico':
    'Système clinique',
  'Sistemi clinici':
    'Systèmes cliniques',
  'Sistemi clinici: i computer con cui lavorano gli elettromedicali — PACS, RIS, motori di integrazione HL7, middleware di laboratorio, postazioni di refertazione. La sonda li riconosce dal traffico DICOM e HL7; non sono elettromedicali e non entrano nei conteggi dei dispositivi, ma l’Ingegneria clinica li vede con il sistema operativo, l’applicazione, gli AE title e le applicazioni HL7. Aprendone uno si vedono gli elettromedicali che gli parlano (dai flussi degli ultimi 7 giorni) e cosa ci fanno: gli mandano immagini, ne ricevono, scambiano messaggi HL7. «Non in CMDB» conta quelli visti sul filo e non ancora registrati.':
    'Systèmes cliniques : les ordinateurs avec lesquels travaillent les dispositifs médicaux — PACS, RIS, moteurs d’intégration HL7, middleware de laboratoire, postes de compte rendu. La sonde les reconnaît à partir du trafic DICOM et HL7 ; ce ne sont pas des dispositifs médicaux et ils n’entrent pas dans le décompte des dispositifs, mais l’ingénierie biomédicale les voit avec leur système d’exploitation, leur application, leurs AE title et leurs applications HL7. En ouvrir un montre les dispositifs médicaux qui lui parlent (d’après les flux des 7 derniers jours) et ce qu’ils en font : ils lui envoient des images, en reçoivent, échangent des messages HL7. « Pas dans la CMDB » compte ceux vus sur le fil et pas encore enregistrés.',
  'Struttura (facility)':
    'Établissement (facility)',
  'Ultima volta sul filo':
    'Dernière fois sur le fil',
  'può essere {edizioni}':
    'peut être {edizioni}',
  'visti sul filo, non ancora registrati':
    'vus sur le fil, pas encore enregistrés',
  'Alcuni apparati esportano i flussi verso un solo collector, come il distributed switch di VMware: con la sonda lì, gli altri strumenti (NMS, SIEM, ntopng) li perderebbero. La sonda manda a ogni destinazione una copia di ogni pacchetto che riceve, intatta e prima di qualunque campionamento, template compresi.':
    'Certains équipements n’exportent les flux que vers un seul collecteur, comme le distributed switch de VMware : avec la sonde à cette place, les autres outils (NMS, SIEM, ntopng) les perdraient. La sonde envoie à chaque destination une copie de chaque paquet qu’elle reçoit, intacte et avant tout échantillonnage, templates compris.',
  'Destinazioni (indirizzo:porta, una per riga, al più 8)':
    'Destinations (adresse:port, une par ligne, 8 au plus)',
  'Il collector di destinazione vede il vDS come se esportasse a lui, non la sonda: serve quando distingue gli apparati dall’indirizzo o ne riceve più d’uno. Richiede il permesso della cattura (CAP_NET_RAW) e solo IPv4; un router con il controllo anti-spoofing (uRPF) fra sonda e destinazione scarta questi pacchetti. Senza la spunta i pacchetti partono dalla sonda: il collector va configurato per accettarli dal suo indirizzo.':
    'Le collecteur de destination voit le vDS comme s’il exportait vers lui, et non la sonde : utile quand il distingue les équipements par leur adresse ou en reçoit plusieurs. Nécessite la permission de la capture (CAP_NET_RAW) et IPv4 uniquement ; un routeur avec le contrôle anti-usurpation (uRPF) entre la sonde et la destination rejette ces paquets. Sans la case, les paquets partent de la sonde : le collecteur doit être configuré pour les accepter depuis son adresse.',
  'Inoltro ad altri collector':
    'Retransmission vers d’autres collecteurs',
  'La sonda non può mantenere il mittente originale e invia dal proprio indirizzo: {motivo}':
    'La sonde ne peut pas conserver l’expéditeur d’origine et envoie depuis sa propre adresse : {motivo}',
  'Mantieni l’indirizzo dell’esportatore come mittente':
    'Conserver l’adresse de l’exportateur comme expéditeur',
  'Sempre lì, «Inoltro ad altri collector»: per gli apparati che esportano i flussi verso un solo collector (il distributed switch di VMware) la sonda manda una copia di ogni pacchetto ricevuto agli altri strumenti (NMS, SIEM, ntopng), fino a otto destinazioni indirizzo:porta. Con «Mantieni l’indirizzo dell’esportatore come mittente» il collector di destinazione vede il vDS e non la sonda (serve il permesso della cattura, solo IPv4). Sotto il campo, per ogni destinazione, quanti pacchetti sono partiti e gli eventuali errori.':
    'Au même endroit, « Retransmission vers d’autres collecteurs » : pour les équipements qui n’exportent les flux que vers un seul collecteur (le distributed switch de VMware), la sonde envoie une copie de chaque paquet reçu aux autres outils (NMS, SIEM, ntopng), jusqu’à huit destinations adresse:port. Avec « Conserver l’adresse de l’exportateur comme expéditeur », le collecteur de destination voit le vDS et non la sonde (il faut la permission de la capture, IPv4 uniquement). Sous le champ, pour chaque destination, combien de paquets sont partis et les éventuelles erreurs.',
  '{n} con il mittente originale':
    '{n} avec l’expéditeur d’origine',
  '{n} pacchetti inoltrati':
    '{n} paquets retransmis',
  'Altri interlocutori':
    'Autres interlocuteurs',
  'Altri {n} interlocutori meno attivi non sono disegnati.':
    '{n} autres interlocuteurs moins actifs ne sont pas dessinés.',
  'Apri il sistema clinico':
    'Ouvrir le système clinique',
  'Apri la scheda del dispositivo':
    'Ouvrir la fiche du dispositif',
  'Conversazioni dagli agenti CENSO sui sistemi clinici':
    'Conversations des agents CENSO sur les systèmes cliniques',
  'Conversazioni dagli agenti: dove sui sistemi clinici (PACS, RIS, motori HL7, centrali) c’è l’agente CENSO, ogni 30 secondi legge la tabella delle connessioni della macchina — con chi parla, su quale porta, con quale programma — e mai il contenuto: niente immagini, messaggi, parametri o dati dei pazienti. CENSO tiene solo le conversazioni con elettromedicali e sistemi clinici o sulle porte DICOM e HL7, per 30 giorni. Così si vedono anche i monitor che parlano con la centrale nella stessa VLAN, dove i flussi non arrivano, e le ore in cui un elettromedicale è collegato contano come utilizzo. Un sistema visto solo dal suo agente compare comunque fra i sistemi clinici, con il segno «agente». Si spegne in «Sistemi clinici».':
    'Conversations des agents : là où l’agent CENSO est installé sur les systèmes cliniques (PACS, RIS, moteurs HL7, centrales), il lit toutes les 30 secondes la table des connexions de la machine — avec qui elle parle, sur quel port, avec quel programme — et jamais le contenu : ni images, ni messages, ni paramètres, ni données des patients. CENSO ne garde que les conversations avec les dispositifs médicaux et les systèmes cliniques ou sur les ports DICOM et HL7, pendant 30 jours. On voit ainsi aussi les moniteurs qui parlent avec la centrale dans le même VLAN, là où les flux n’arrivent pas, et les heures où un dispositif médical est connecté comptent comme utilisation. Un système vu uniquement par son agent apparaît quand même parmi les systèmes cliniques, avec la mention « agent ». Se désactive dans « Systèmes cliniques ».',
  'Dove sui sistemi clinici c’è l’agente CENSO, ogni 30 secondi legge la tabella delle connessioni: con chi parla, su quale porta, quale programma. Mai il contenuto: niente immagini, messaggi o dati dei pazienti. Si tengono solo le conversazioni con elettromedicali e sistemi clinici o sulle porte DICOM e HL7, per 30 giorni; le ore in cui un elettromedicale è collegato contano come utilizzo. Vede i monitor che parlano con la centrale nella stessa VLAN, dove i flussi non arrivano.':
    'Là où l’agent CENSO est installé sur les systèmes cliniques, il lit toutes les 30 secondes la table des connexions : avec qui il parle, sur quel port, quel programme. Jamais le contenu : ni images, ni messages, ni données des patients. Seules les conversations avec les dispositifs médicaux et les systèmes cliniques ou sur les ports DICOM et HL7 sont conservées, pendant 30 jours ; les heures où un dispositif médical est connecté comptent comme utilisation. Il voit les moniteurs qui parlent avec la centrale dans le même VLAN, là où les flux n’arrivent pas.',
  'Elettromedicali e sistemi clinici, e chi parla con chi: dai flussi e dagli agenti CENSO sui sistemi clinici. Indirizzi, porte e programmi, mai il contenuto. Doppio clic su un nodo per aprirlo.':
    'Dispositifs médicaux et systèmes cliniques, et qui parle avec qui : d’après les flux et les agents CENSO sur les systèmes cliniques. Adresses, ports et programmes, jamais le contenu. Double-cliquez sur un nœud pour l’ouvrir.',
  'Le ore in cui l’elettromedicale è collegato a un sistema clinico con l’agente CENSO contano come attive anche senza flussi.':
    'Les heures où le dispositif médical est connecté à un système clinique doté de l’agent CENSO comptent comme actives même sans flux.',
  'L’agente CENSO su questo sistema riporta le sue conversazioni':
    'L’agent CENSO sur ce système rapporte ses conversations',
  'Mappa clinica':
    'Carte clinique',
  'Mappa clinica: elettromedicali, sistemi clinici e chi parla con chi, dai flussi e dagli agenti, nella stessa mappa della correlazione (viste gerarchica, radiale, organica). Il colore dice il protocollo (DICOM, HL7, altro), il tratteggio che il collegamento l’ha visto solo l’agente. Con molti elettromedicali la mappa dell’area li raggruppa per modello; doppio clic su un nodo apre la scheda del dispositivo o il sistema clinico. La stessa mappa, attorno al singolo oggetto, sta nei Collegamenti della scheda del dispositivo, nella finestra di ogni sistema clinico e nella scheda del CI («Mappa clinica»).':
    'Carte clinique : dispositifs médicaux, systèmes cliniques et qui parle avec qui, d’après les flux et les agents, dans la même carte que la corrélation (vues hiérarchique, radiale, organique). La couleur indique le protocole (DICOM, HL7, autre), le pointillé que seul l’agent a vu le lien. Avec beaucoup de dispositifs médicaux, la carte de l’espace les regroupe par modèle ; un double clic sur un nœud ouvre la fiche du dispositif ou le système clinique. La même carte, autour d’un seul objet, se trouve dans les Liens de la fiche du dispositif, dans la fenêtre de chaque système clinique et dans la fiche du CI (« Carte clinique »).',
  'Molti elettromedicali: sono raggruppati per modello. Aprendo un sistema si vedono uno per uno.':
    'Beaucoup de dispositifs médicaux : ils sont regroupés par modèle. En ouvrant un système, on les voit un par un.',
  'Nessun collegamento clinico ancora: servono i flussi (NetFlow/IPFIX) o l’agente CENSO sui sistemi clinici.':
    'Aucun lien clinique pour l’instant : il faut les flux (NetFlow/IPFIX) ou l’agent CENSO sur les systèmes cliniques.',
  'Nessun elettromedicale gli parla nei flussi degli ultimi 7 giorni né nelle conversazioni dell’agente CENSO: il traffico non passa da un router che esporta i flussi, e sul sistema non c’è l’agente.':
    'Aucun dispositif médical ne lui parle dans les flux des 7 derniers jours ni dans les conversations de l’agent CENSO : le trafic ne passe pas par un routeur qui exporte les flux, et le système n’a pas d’agent.',
  'flussi':
    'flux',
  'visto solo dall’agente CENSO':
    'vu uniquement par l’agent CENSO',
  '{n} letture':
    '{n} lectures',
  'In HL7 si legano anche i sistemi che usano lo stesso nome di applicazione o di struttura (per esempio il server «ALINITY» e gli analizzatori «ALINITY1», «ALINITY2»): linea a puntini, un’ipotesi dai nomi delle intestazioni, mai dal contenuto dei messaggi.':
    'En HL7, les systèmes qui utilisent le même nom d’application ou d’établissement sont aussi reliés (par exemple le serveur « ALINITY » et les analyseurs « ALINITY1 », « ALINITY2 ») : ligne pointillée, une hypothèse tirée des noms des en-têtes, jamais du contenu des messages.',
  'Tutti i protocolli':
    'Tous les protocoles',
  'stesso nome HL7':
    'même nom HL7',
  'stesso nome HL7 (ipotesi)':
    'même nom HL7 (hypothèse)',
  '{a} e {b} usano lo stesso nome HL7 «{nome}»: un’ipotesi dai nomi, non traffico osservato.':
    '{a} et {b} utilisent le même nom HL7 « {nome} » : une hypothèse tirée des noms, pas du trafic observé.',
  'Sopra la mappa si sceglie il protocollo: la mappa DICOM mostra le modalità e i PACS, la mappa HL7 gli analizzatori, i middleware e il LIS, e lega anche i sistemi che usano lo stesso nome di applicazione o di struttura nelle intestazioni HL7 (il server «ALINITY» e gli analizzatori «ALINITY1», «ALINITY2»), a puntini perché è un’ipotesi dai nomi.':
    'Au-dessus de la carte on choisit le protocole : la carte DICOM montre les modalités et les PACS, la carte HL7 les analyseurs, les middleware et le LIS, et relie aussi les systèmes qui utilisent le même nom d’application ou d’établissement dans les en-têtes HL7 (le serveur « ALINITY » et les analyseurs « ALINITY1 », « ALINITY2 »), en pointillé car c’est une hypothèse tirée des noms.',
  'Acceso, non collegato alla centrale':
    'Allumé, non connecté à la centrale',
  'Dispositivo medico collegato':
    'Dispositif médical connecté',
  'Dove si trova adesso':
    'Où il se trouve maintenant',
  'I dettagli degli elettromedicali sono riservati all’Ingegneria clinica e agli amministratori (CENSO MED).':
    'Les détails des dispositifs médicaux sont réservés à l’ingénierie biomédicale et aux administrateurs (CENSO MED).',
  'Nessun segnale':
    'Aucun signal',
  'Non visto da più di un giorno':
    'Non vu depuis plus d’un jour',
  'Non visto da qualche ora':
    'Non vu depuis quelques heures',
  'Per tipo di dispositivo':
    'Par type de dispositif',
  'Posizione dichiarata dal dispositivo':
    'Position déclarée par le dispositif',
  'Quali elettromedicali sono in uso o liberi adesso, e dove si trovano: per trovare un monitor o un ecografo libero, o raggiungere un dispositivo richiamato.':
    'Quels dispositifs médicaux sont utilisés ou libres maintenant, et où ils se trouvent : pour trouver un moniteur ou un échographe libre, ou atteindre un dispositif rappelé.',
  'Reparto registrato':
    'Service enregistré',
  'Segnali di rete, non certezze cliniche: «in uso» = negli ultimi {m} minuti collegato a un sistema clinico (agente CENSO) o nelle ultime {h} ore traffico clinico nei flussi; «acceso, non collegato alla centrale» = un monitor Philips IntelliVue che si annuncia (lo fa solo senza centrale); «libero» = in rete ma senza traffico clinico da almeno {l} ore. La posizione «dichiarata» è quella impostata sul dispositivo dal personale, con l’ora in cui il dispositivo l’ha detta.':
    'Des signaux réseau, pas des certitudes cliniques : « utilisé » = connecté à un système clinique (agent CENSO) dans les {m} dernières minutes ou trafic clinique dans les flux dans les {h} dernières heures ; « allumé, non connecté à la centrale » = un moniteur Philips IntelliVue qui s’annonce (il ne le fait que sans centrale) ; « libre » = sur le réseau mais sans trafic clinique depuis au moins {l} heures. La position « déclarée » est celle que le personnel a réglée sur le dispositif, avec l’heure à laquelle le dispositif l’a indiquée.',
  'Ultima attività clinica':
    'Dernière activité clinique',
  'Ultima volta in rete':
    'Dernière fois sur le réseau',
  'Usato di recente':
    'Utilisé récemment',
  'letto {b}':
    'lit {b}',
  'Disponibilità: quali elettromedicali sono in uso o liberi adesso, e dove si trovano, per trovare un monitor o un ecografo libero o raggiungere un dispositivo richiamato. «In uso» se negli ultimi minuti è collegato a un sistema clinico (agente CENSO) o nelle ultime ore ha traffico clinico nei flussi; «acceso, non collegato alla centrale» se è un monitor Philips IntelliVue che si annuncia (lo fa solo senza centrale); «libero» se è in rete senza traffico clinico da qualche ora. Sono segnali di rete, non certezze cliniche. La «posizione dichiarata dal dispositivo» è quella che il personale imposta sul monitor (letto, reparto, stanza), con l’ora in cui il dispositivo l’ha detta: sta accanto alla posizione registrata dall’Ingegneria clinica senza sostituirla, nella scheda, in «Dove sono» e, per ogni richiamo, nella colonna «Dove si trova adesso».':
    'Disponibilité : quels dispositifs médicaux sont utilisés ou libres maintenant, et où ils se trouvent, pour trouver un moniteur ou un échographe libre ou atteindre un dispositif rappelé. « Utilisé » s’il est connecté à un système clinique (agent CENSO) dans les dernières minutes ou s’il a du trafic clinique dans les flux dans les dernières heures ; « allumé, non connecté à la centrale » s’il s’agit d’un moniteur Philips IntelliVue qui s’annonce (il ne le fait que sans centrale) ; « libre » s’il est sur le réseau sans trafic clinique depuis quelques heures. Ce sont des signaux réseau, pas des certitudes cliniques. La « position déclarée par le dispositif » est celle que le personnel règle sur le moniteur (lit, service, chambre), avec l’heure à laquelle le dispositif l’a indiquée : elle figure à côté de la position enregistrée par l’ingénierie biomédicale sans la remplacer, dans la fiche, dans « Où ils sont » et, pour chaque rappel, dans la colonne « Où il se trouve maintenant ».',
  'Chi vede CENSO MED: solo gli amministratori del tenant e il ruolo «Ingegneria clinica» (o un ruolo personalizzato che lo concede). Gli altri ruoli e gli utenti operatore o di sola lettura non vedono l’area; nella finestra della porta di uno switch vedono soltanto che c’è un dispositivo medico collegato, con MAC e VLAN, senza modello, nome, indirizzo né collegamenti.':
    'Qui voit CENSO MED : uniquement les administrateurs du tenant et le rôle « Ingénierie biomédicale » (ou un rôle personnalisé qui l’accorde). Les autres rôles et les utilisateurs opérateurs ou en lecture seule ne voient pas l’espace ; dans la fenêtre du port d’un switch, ils voient seulement qu’un dispositif médical est connecté, avec MAC et VLAN, sans modèle, nom, adresse ni liens.',
  'Elettromedicale: scheda, cespite, contratti e verifiche li gestisce l’Ingegneria clinica in CENSO MED.':
    'Dispositif médical : fiche, actif, contrats et contrôles sont gérés par l’ingénierie biomédicale dans CENSO MED.',
  'Nel CMDB l’elettromedicale resta un CI per tutti (classe, indirizzi, porta), ma senza le informazioni dell’Ingegneria clinica: chi non ha CENSO MED non vede il cespite né i contratti di manutenzione legati al dispositivo e non può registrarlo come bene; al loro posto una riga dice che li gestisce l’Ingegneria clinica.':
    'Dans la CMDB, le dispositif médical reste un CI pour tous (classe, adresses, port), mais sans les informations de l’ingénierie biomédicale : qui n’a pas CENSO MED ne voit ni l’actif ni les contrats de maintenance liés au dispositif et ne peut pas l’enregistrer comme bien ; à leur place, une ligne indique que l’ingénierie biomédicale les gère.',
  'Cattura degli annunci (90s)':
    'Capture des annonces (90 s)',
  'Solo gli annunci degli apparati':
    'Uniquement les annonces des appareils',
  'Tiene solo ciò che gli apparati mandano a tutti (broadcast e multicast) per presentarsi in rete: nessuna conversazione fra due macchine, quindi nessun traffico clinico, e nessuna delle porte GE che portano il nome del paziente. Serve a scrivere il riconoscimento di un nuovo costruttore dai suoi annunci. Meglio farla con apparati non associati a un paziente (in laboratorio o in attesa), perché un costruttore che non conosciamo potrebbe mettere qualcosa di troppo anche negli annunci.':
    'Ne garde que ce que les appareils envoient à tous (broadcast et multicast) pour se présenter sur le réseau : aucune conversation entre deux machines, donc aucun trafic clinique, et aucun des ports GE qui portent le nom du patient. Sert à écrire la reconnaissance d’un nouveau fabricant à partir de ses annonces. Mieux vaut la faire avec des appareils non associés à un patient (en laboratoire ou en attente), car un fabricant que nous ne connaissons pas pourrait mettre quelque chose de trop dans ses annonces aussi.',
  'La cattura di prova ha l’opzione «Solo gli annunci degli apparati»: per 90 secondi tiene solo ciò che gli apparati mandano a tutti per presentarsi in rete, senza conversazioni fra macchine (quindi senza traffico clinico) e senza le porte GE con il nome del paziente. È il file da cui si scrive il riconoscimento di un nuovo costruttore; meglio farla con apparati non associati a un paziente.':
    'La capture de test a l’option « Uniquement les annonces des appareils » : pendant 90 secondes, elle ne garde que ce que les appareils envoient à tous pour se présenter sur le réseau, sans conversations entre machines (donc sans trafic clinique) et sans les ports GE avec le nom du patient. C’est le fichier à partir duquel on écrit la reconnaissance d’un nouveau fabricant ; mieux vaut la faire avec des appareils non associés à un patient.',
  'Identità dal filo':
    'Identité depuis le fil',
  'Apparecchi riconosciuti dal filo':
    'Appareils reconnus depuis le fil',
  'Indirizzi visti':
    'Adresses vues',
  'Stazione':
    'Station',
  'Ultima calibrazione':
    'Dernière calibration',
  'abbinato':
    'associé',
  'apparecchi':
    'appareils',
  'Leggi l’identità degli apparecchi da DICOM e HL7 sul filo':
    'Lire l’identité des appareils depuis DICOM et HL7 sur le fil',
  'Lettura spenta. Attivala qui sopra per riconoscere gli apparecchi dai loro messaggi.':
    'Lecture désactivée. Activez-la ci-dessus pour reconnaître les appareils à partir de leurs messages.',
  'Ancora nessuna identità letta: serve che la sonda veda il traffico DICOM/HL7 degli apparecchi.':
    'Aucune identité lue pour l’instant : la sonde doit voir le trafic DICOM/HL7 des appareils.',
  'Da attivare dopo averlo concordato e documentato con l’ospedale (DPIA). Richiede la licenza CENSO MED e che la sonda veda il traffico (porta mirror). Serve l’aggiornamento delle sonde.':
    'À activer après accord et documentation avec l’hôpital (AIPD). Nécessite la licence CENSO MED et que la sonde voie le trafic (port miroir). Les sondes doivent être mises à jour.',
  'Gli apparecchi riconosciuti dai messaggi DICOM e HL7 che la sonda vede sul filo: solo l’identità dell’apparato (costruttore, modello, numero di serie, UDI, software), mai dati del paziente. Da attivare per ospedale.':
    'Les appareils reconnus à partir des messages DICOM et HL7 que la sonde voit sur le fil : uniquement l’identité de l’appareil (fabricant, modèle, numéro de série, UDI, logiciel), jamais les données du patient. À activer par hôpital.',
  'Identità dal filo: dove gli apparecchi non hanno API — tanta roba vecchia e in chiaro — CENSO legge dai messaggi DICOM e HL7 che la sonda vede la sola identità dell’apparato (costruttore, modello, numero di serie, Device UID/UDI, software, modalità, stazione, struttura, reparto, date). Non legge mai dati del paziente: in DICOM salta il gruppo del paziente e si ferma prima dei pixel, in HL7 legge solo i segmenti dell’apparecchiatura e mai le misure cliniche. Gli apparecchi sono distinti per numero di serie o UDI, mai per solo indirizzo. La funzione c’è solo con licenza CENSO MED e si attiva per ospedale, da concordare e documentare (DPIA); serve che la sonda veda il traffico (porta mirror).':
    'Identité depuis le fil : là où les appareils n’ont pas d’API — beaucoup de matériel ancien et en clair — CENSO lit, à partir des messages DICOM et HL7 que la sonde voit, uniquement l’identité de l’appareil (fabricant, modèle, numéro de série, Device UID/UDI, logiciel, modalité, station, établissement, service, dates). Il ne lit jamais de données du patient : en DICOM il saute le groupe du patient et s’arrête avant les pixels, en HL7 il ne lit que les segments de l’équipement et jamais les mesures cliniques. Les appareils sont distingués par numéro de série ou UDI, jamais par la seule adresse. La fonction n’existe qu’avec la licence CENSO MED et s’active par hôpital, à convenir et documenter (AIPD) ; la sonde doit voir le trafic (port miroir).',
  'Ultima acquisizione':
    'Dernière acquisition',
  'abbinato (CI)':
    'associé (CI)',
  'non ancora':
    'pas encore',
  'dichiarato dal dispositivo sul filo (DICOM/HL7)':
    'déclaré par l’appareil sur le fil (DICOM/HL7)',
  'Attività dal filo (DICOM/HL7)':
    'Activité depuis le fil (DICOM/HL7)',
  'Fabbricazione':
    'Fabrication',
  'Nessuna lettura ancora.':
    'Aucune lecture pour l’instant.',
  'Quante volte al giorno l’apparecchio si è fatto riconoscere sul filo coi suoi messaggi d’identità: una traccia d’uso senza leggere nulla dei pazienti. In tutto {n} letture.':
    'Combien de fois par jour l’appareil s’est fait reconnaître sur le fil avec ses messages d’identité : une trace d’usage sans rien lire des patients. {n} lectures au total.',
  'Ultima acquisizione: {q}.':
    'Dernière acquisition : {q}.',
  'CENSO legge dai messaggi DICOM e HL7 che vede sul filo la sola identità degli apparecchi — costruttore, modello, numero di serie, Device UID/UDI, versione software, modalità, stazione, struttura e reparto, date di fabbricazione, installazione e calibrazione. Non legge mai dati del paziente: in DICOM salta il gruppo del paziente e si ferma prima dei pixel; in HL7 legge solo i segmenti dell’apparecchiatura, mai le misure cliniche. I dispositivi sono distinti per numero di serie o UDI, mai per solo indirizzo. «Letture» conta quante volte l’apparecchio si è fatto riconoscere sul filo, per una statistica d’uso; quando il numero di serie o l’UDI combacia con il suo indirizzo, l’identità arricchisce il dispositivo nel CMDB (modello e seriale esatti). Gli apparecchi visti solo attraverso un PACS/archivio (un unico indirizzo che riceve immagini da molte modalità, anche di altre strutture) sono segnati «solo in archivio» e non diventano dispositivi: sono studi conservati, non apparecchi locali.':
    "CENSO lit, dans les messages DICOM et HL7 qu'il voit sur le fil, uniquement l'identité des appareils — fabricant, modèle, numéro de série, Device UID/UDI, version logicielle, modalité, station, établissement et service, dates de fabrication, d'installation et d'étalonnage. Il ne lit jamais les données du patient : en DICOM il saute le groupe patient et s'arrête avant les pixels ; en HL7 il ne lit que les segments de l'équipement, jamais les mesures cliniques. Les dispositifs sont distingués par numéro de série ou UDI, jamais par la seule adresse. « Lectures » compte combien de fois l'appareil s'est fait reconnaître sur le fil, pour une statistique d'usage ; quand le numéro de série ou l'UDI correspond à son adresse, l'identité enrichit le dispositif dans la CMDB (modèle et numéro de série exacts). Les appareils vus seulement à travers un PACS/archive (une seule adresse qui reçoit des images de nombreuses modalités, y compris d'autres établissements) sont marqués « archive seulement » et ne deviennent pas des dispositifs : ce sont des études conservées, pas des appareils locaux.",
  'Dispositivi esterni':
    'Dispositifs externes',
  'Dispositivi identificati solo attraverso un PACS/archivio (un indirizzo che riceve immagini da molte modalità, spesso di altre strutture): sono studi conservati o referti arrivati da fuori, catalogati a parte e non contati fra gli elettromedicali dell’ospedale.':
    "Dispositifs identifiés uniquement à travers un PACS/archive (une adresse qui reçoit des images de nombreuses modalités, souvent d'autres établissements) : ce sont des études conservées ou des comptes rendus venus de l'extérieur, catalogués à part et non comptés parmi les dispositifs médicaux de l'hôpital.",
  'Dispositivo esterno: identificato solo attraverso un PACS/archivio.':
    'Dispositif externe : identifié uniquement à travers un PACS/archive.',
  'Identificato solo attraverso un PACS/archivio, spesso di un’altra struttura: non è un apparecchio dell’ospedale.':
    "Identifié uniquement à travers un PACS/archive, souvent d'un autre établissement : ce n'est pas un appareil de l'hôpital.",
  'Visto solo attraverso un PACS/archivio: è uno studio archiviato o inoltrato, spesso di un’altra struttura, non un apparecchio locale.':
    "Vu uniquement à travers un PACS/archive : c'est une étude archivée ou transférée, souvent d'un autre établissement, pas un appareil local.",
  'solo in archivio':
    'archive seulement',
  'visti solo via PACS/archivio, spesso di altre strutture':
    "vus uniquement via PACS/archive, souvent d'autres établissements",
  'Un apparecchio diventa un dispositivo dell’ospedale solo quando lo vediamo a un indirizzo suo; quelli visti solo attraverso un PACS/archivio (un indirizzo che riceve immagini da molte modalità, spesso di altre strutture) sono «Dispositivi esterni» — studi conservati o referti arrivati da fuori — catalogati a parte e fuori dai conteggi dell’area.':
    "Un appareil devient un dispositif de l'hôpital seulement quand on le voit à une adresse qui lui est propre ; ceux vus uniquement à travers un PACS/archive (une adresse qui reçoit des images de nombreuses modalités, souvent d'autres établissements) sont des « Dispositifs externes » — études conservées ou comptes rendus venus de l'extérieur — catalogués à part et exclus des comptes de l'espace.",
  'CI principali':
    'CI principaux',
  'CI secondari':
    'CI secondaires',
  'I CI meno disponibili nel periodo, con il traguardo dello SLA.':
    "Les CI les moins disponibles sur la période, avec l'objectif du SLA.",
  'I numeri che contano, l’andamento degli allarmi e i parametri per stato, in una riga.':
    "Les chiffres qui comptent, l'évolution des alarmes et les paramètres par état, sur une ligne.",
  'I tratti in cui un CI non rispondeva, sul filo del tempo.':
    "Les périodes pendant lesquelles un CI ne répondait pas, sur l'axe du temps.",
  'La classifica dei valori attuali con le soglie e l’andamento: CPU, memoria, volumi, interfacce…':
    'Le classement des valeurs actuelles avec les seuils et la tendance : CPU, mémoire, volumes, interfaces…',
  'Una tessera per CI, colorata dal suo stato peggiore, con i parametri per stato.':
    'Une tuile par CI, colorée selon son pire état, avec les paramètres par état.',
  'aggiornato alle {ora}':
    'mis à jour à {ora}',
  'andamento':
    'tendance',
  'attenzione da {v}':
    'attention à partir de {v}',
  'critico da {v}':
    'critique à partir de {v}',
  'nessun allarme nel periodo':
    'aucune alarme sur la période',
  'non rispettano':
    'ne le respectent pas',
  'parametri in allarme':
    'paramètres en alarme',
  'poche misure':
    'peu de mesures',
  'rispettano':
    'le respectent',
  'scala da {base} a 100 %; la tacca è il traguardo dello SLA':
    "échelle de {base} à 100 % ; la marque est l'objectif du SLA",
  'senza dati':
    'sans données',
  'su {max}':
    'sur {max}',
  'traguardo {v}':
    'objectif {v}',
  'traguardo {v} %':
    'objectif {v} %',
  'una dashboard a widget, ognuno con il suo grafico. In alto «Come stanno le cose»: i numeri che contano (gravi, attenzione, ok, in attesa, CI, sonde), l’andamento degli allarmi nella finestra e i parametri per stato; poi la parete dei CI — una tessera per CI, colorata dal suo stato peggiore, con i parametri per stato — i problemi aperti e l’andamento degli allarmi nel tempo. Nelle altre sezioni gli incidenti sul filo del tempo (un rigo per CI), la disponibilità più bassa su una scala da 90 a 100 % con la tacca del traguardo SLA, i parametri per stato a ruota, il rispetto degli SLA, le classifiche dei parametri più alti — per ogni riga il valore, la barra con le tacche delle soglie e la sparkline delle ultime ore — e le sonde con il loro carico.':
    "un tableau de bord fait de widgets, chacun avec son graphique. En haut « Où en sommes-nous » : les chiffres qui comptent (graves, attention, ok, en attente, CI, sondes), l'évolution des alarmes dans la fenêtre et les paramètres par état ; puis le mur des CI — une tuile par CI, colorée selon son pire état, avec les paramètres par état — les problèmes ouverts et l'évolution des alarmes dans le temps. Dans les autres sections, les incidents sur l'axe du temps (une ligne par CI), la disponibilité la plus basse sur une échelle de 90 à 100 % avec la marque de l'objectif SLA, les paramètres par état en anneau, le respect des SLA, les classements des paramètres les plus élevés — pour chaque ligne la valeur, la barre avec les marques des seuils et la sparkline des dernières heures — et les sondes avec leur charge.",
  'valore attuale e ultime {ore} ore':
    'valeur actuelle et {ore} dernières heures',
  '{nome}: ultime {ore} ore, minimo {min}, massimo {max}, ultimo {ultimo}':
    '{nome} : {ore} dernières heures, minimum {min}, maximum {max}, dernier {ultimo}',
  '{nome}: {n} incidenti':
    '{nome} : {n} incidents',
  '{n} incidenti · {d} in totale':
    '{n} incidents · {d} au total',
  '{n} parametri per stato':
    '{n} paramètres par état',
  '{n} parametri su {m} CI':
    '{n} paramètres sur {m} CI',
  '{n}% di letture in ritardo':
    '{n} % de lectures en retard',
  '{v} di disponibilità':
    '{v} de disponibilité',
  '{v} di disponibilità, traguardo {s} %':
    '{v} de disponibilité, objectif {s} %',
  '«Personalizza» cambia sezioni, widget, misure e finestre; la sezione aperta sta nell’indirizzo, così un collegamento porta a quella giusta. Si aggiorna da solo ogni minuto. I parametri in allarme compaiono anche nella campanella in alto, con una barra verde, gialla o rossa a seconda della gravità.':
    "« Personnaliser » change les sections, les widgets, les tailles et les fenêtres ; la section ouverte est dans l'adresse, un lien mène donc à la bonne. Il se met à jour tout seul chaque minute. Les paramètres en alarme apparaissent aussi dans la cloche en haut, avec une barre verte, jaune ou rouge selon la gravité.",
  'Aggiungi serie':
    'Ajouter une série',
  'Al massimo {n} serie qui: per averne altre aggiungi un secondo widget.':
    "Au maximum {n} séries ici : pour en avoir d'autres, ajoutez un second widget.",
  'Etichetta nella legenda':
    'Étiquette dans la légende',
  'Fascia minimo–massimo':
    'Bande minimum–maximum',
  'Grafico personalizzato':
    'Graphique personnalisé',
  'Il cruscotto si compone: ogni widget ha un titolo tuo («Titolo e opzioni…» in modifica; quello del catalogo resta come sottotitolo). «Grafico personalizzato» mette nello stesso grafico le serie che scegli, anche di CI diversi — linee, aree, barre o impilate (la somma) — con un pannello per ogni unità di misura; «Parete dei link» è una scheda per interfaccia, fino a sedici per widget (le WAN in uno, le porte fra i data center in un altro), con la descrizione della porta come titolo, lo stato, il traffico in e out, l’utilizzo con le soglie e il mini-grafico. Nella scelta di un’interfaccia ogni porta porta la sua descrizione, l’indirizzo e lo stato: non serve tenere aperta la scheda dello switch.':
    "Le tableau de bord se compose : chaque widget a un titre à vous (« Titre et options… » en modification ; celui du catalogue reste en sous-titre). « Graphique personnalisé » met dans un même graphique les séries que vous choisissez, même de CI différents — lignes, aires, barres ou empilées (la somme) — avec un panneau par unité de mesure ; « Mur des liens » est une fiche par interface, jusqu'à seize par widget (les WAN dans l'un, les ports entre data centers dans l'autre), avec la description du port comme titre, l'état, le trafic entrant et sortant, l'utilisation avec les seuils et le mini-graphique. Au choix d'une interface, chaque port porte sa description, son adresse et son état : inutile de garder la page du commutateur ouverte.",
  'Lascia vuoto per il titolo del catalogo; quello del catalogo resta come sottotitolo.':
    'Laissez vide pour le titre du catalogue ; celui du catalogue reste en sous-titre.',
  'Le serie che scegli — anche di CI diversi — a linee, aree, barre o impilate.':
    'Les séries que vous choisissez — même de CI différents — en lignes, aires, barres ou empilées.',
  'Le serie con unità diverse finiscono in pannelli separati, uno per unità: un asse solo per grafico.':
    "Les séries d'unités différentes vont dans des panneaux séparés, un par unité : un seul axe par graphique.",
  'Mini-grafico':
    'Mini-graphique',
  'Modifica il widget «{w}»':
    'Modifier le widget « {w} »',
  'Nell’elenco ogni porta porta la sua descrizione: è quella che diventa il titolo della scheda (si può cambiare).':
    "Dans la liste, chaque port porte sa description : c'est elle qui devient le titre de la fiche (modifiable).",
  'Nessun parametro acceso su questo CI.':
    'Aucun paramètre actif sur ce CI.',
  'Opzioni':
    'Options',
  'Parete dei link':
    'Mur des liens',
  'Scegli le interfacce in «Titolo e opzioni» (in modifica): ogni porta mostra la sua descrizione.':
    'Choisissez les interfaces dans « Titre et options » (en modification) : chaque port affiche sa description.',
  'Scegli le serie in «Titolo e opzioni» (in modifica).':
    'Choisissez les séries dans « Titre et options » (en modification).',
  'Serie {n}':
    'Série {n}',
  'Soglie di attenzione e critica':
    "Seuils d'attention et critique",
  'Tipo di grafico':
    'Type de graphique',
  'Titolo del widget':
    'Titre du widget',
  'Titolo e opzioni…':
    'Titre et options…',
  'Una scheda per interfaccia: descrizione della porta, stato, traffico in e out, utilizzo con le soglie e il mini-grafico.':
    'Une fiche par interface : description du port, état, trafic entrant et sortant, utilisation avec les seuils et le mini-graphique.',
  'aree':
    'aires',
  'barre':
    'barres',
  'cerca per nome, indirizzo o classe…':
    'rechercher par nom, adresse ou classe…',
  'impilato (la somma)':
    'empilé (la somme)',
  'linee':
    'lignes',
  'togli la serie':
    'retirer la série',
  'totale':
    'total',
  'traffico in e out':
    'trafic entrant et sortant',
  'utilizzo con le soglie':
    'utilisation avec les seuils',
  '{e} errori · {s} scarti nella finestra':
    '{e} erreurs · {s} rejets dans la fenêtre',
  '{n} CI su {m}':
    '{n} CI sur {m}',
  '{n} interfacce non sono più monitorate: {elenco}':
    '{n} interfaces ne sont plus surveillées : {elenco}',
  '{n} interfacce · {f}':
    '{n} interfaces · {f}',
  '{n} serie non sono più monitorate: {elenco}':
    '{n} séries ne sont plus surveillées : {elenco}',
  'A → B':
    'A → B',
  'Adiacenza trovata: {ci} porta {porta}, ma quella porta non è monitorata da Eagle. Attivala sul CI o scegli un’altra interfaccia.':
    "Adjacence trouvée : {ci} port {porta}, mais ce port n'est pas surveillé par Eagle. Activez-le sur le CI ou choisissez une autre interface.",
  'Adiacenze non leggibili al momento.':
    'Adjacences illisibles pour le moment.',
  'B → A':
    'B → A',
  'Capo A (il più vicino)':
    'Extrémité A (la plus proche)',
  'Capo B (l’altro capo)':
    "Extrémité B (l'autre bout)",
  'Dall’adiacenza {via}: {ci} · {porta}{stato}':
    "Depuis l'adjacence {via} : {ci} · {porta}{stato}",
  'I due capi':
    'Les deux extrémités',
  'Il capo B si propone dall’adiacenza LLDP/CDP della porta A, ma resta tuo: la descrizione della porta è quella che conta. Senza capo B il link è a un capo solo (una WAN verso il provider).':
    "L'extrémité B est proposée depuis l'adjacence LLDP/CDP du port A, mais elle reste la vôtre : la description du port est ce qui compte. Sans extrémité B, le lien n'a qu'un bout (un WAN vers le fournisseur).",
  'Link':
    'Lien',
  'Nessuna adiacenza LLDP/CDP su questa porta: scegli l’altro capo a mano.':
    "Aucune adjacence LLDP/CDP sur ce port : choisissez l'autre extrémité à la main.",
  'Nome del capo':
    "Nom de l'extrémité",
  'Proponi l’altro capo dall’adiacenza':
    "Proposer l'autre extrémité depuis l'adjacence",
  'Scegli i due capi in «Titolo e opzioni» (in modifica).':
    'Choisissez les deux extrémités dans « Titre et options » (en modification).',
  'Un capo non è più monitorato: controlla le interfacce in «Titolo e opzioni».':
    "Une extrémité n'est plus surveillée : vérifiez les interfaces dans « Titre et options ».",
  'Un collegamento fra due interfacce: i due versi in Mbit/s, l’utilizzo con le soglie a ogni capo, lo stato, il mini-grafico. Il capo B si propone dall’adiacenza.':
    "Un lien entre deux interfaces : les deux sens en Mbit/s, l'utilisation avec les seuils à chaque extrémité, l'état, le mini-graphique. L'extrémité B est proposée depuis l'adjacence.",
  'altro capo':
    'autre extrémité',
  'di utilizzo':
    "d'utilisation",
  'es. DC Roma':
    'ex. DC Rome',
  'es. Sede Milano':
    'ex. Site de Milan',
  'nessun altro capo (link a un solo capo)':
    "pas d'autre extrémité (lien à un seul bout)",
  'non monitorato da Eagle':
    'non surveillé par Eagle',
  'parametro spento':
    'paramètre désactivé',
  '{a} verso {b}: {ab}; {b} verso {a}: {ba}':
    '{a} vers {b} : {ab} ; {b} vers {a} : {ba}',
  '«Link» disegna un collegamento fra due interfacce: i due versi in Mbit/s (A→B è l’uscita di A, B→A la sua entrata), l’utilizzo con le soglie a ogni capo, lo stato peggiore sul tubo, il mini-grafico. Il capo B si propone dall’adiacenza LLDP/CDP della porta A — e resta modificabile; senza capo B il link è a un capo solo, come una WAN verso il provider. Ai due capi puoi dare un nome («Sede Milano», «DC Roma»).':
    "« Lien » dessine une connexion entre deux interfaces : les deux sens en Mbit/s (A→B est la sortie de A, B→A son entrée), l'utilisation avec les seuils à chaque extrémité, le pire état sur le tube, le mini-graphique. L'extrémité B est proposée depuis l'adjacence LLDP/CDP du port A — et reste modifiable ; sans extrémité B, le lien n'a qu'un bout, comme un WAN vers le fournisseur. Vous pouvez nommer les deux extrémités (« Site de Milan », « DC Rome »).",
  'Altezza della tela':
    'Hauteur de la toile',
  'Colora gli archi per utilizzo':
    "Colorer les arcs selon l'utilisation",
  'La vista non ha nodi con questi filtri.':
    "La vue n'a aucun nœud avec ces filtres.",
  'La vista salvata non esiste più: scegline un’altra in «Titolo e opzioni».':
    "La vue enregistrée n'existe plus : choisissez-en une autre dans « Titre et options ».",
  'Le viste si creano e si modificano in Rete → Mappa; qui si scelgono.':
    'Les vues se créent et se modifient dans Réseau → Carte ; ici on les choisit.',
  'Mappa con lo stato':
    "Carte avec l'état",
  'Mappa parziale: {n} collegamenti in tutto, qui i primi.':
    'Carte partielle : {n} liaisons au total, ici les premières.',
  'Mappa «{v}» con lo stato di Eagle':
    "Carte « {v} » avec l'état Eagle",
  'Nessuna vista salvata: aprila in Rete → Mappa, disponi i nodi e salva la vista.':
    'Aucune vue enregistrée : ouvrez Réseau → Carte, disposez les nœuds et enregistrez la vue.',
  'Ogni arco LLDP/CDP prende lo stato peggiore delle sue due interfacce e uno spessore in proporzione all’utilizzo; le porte si riconoscono dal nome (local_port, remote_port).':
    "Chaque arc LLDP/CDP prend le pire état de ses deux interfaces et une épaisseur proportionnelle à l'utilisation ; les ports se reconnaissent par leur nom (local_port, remote_port).",
  'Scegli una vista di topologia salvata in «Titolo e opzioni» (in modifica). Le viste si creano in Rete → Mappa.':
    'Choisissez une vue de topologie enregistrée dans « Titre et options » (en modification). Les vues se créent dans Réseau → Carte.',
  'Una vista di topologia salvata, colorata da Eagle: i nodi dallo stato, gli archi dall’utilizzo delle interfacce.':
    "Une vue de topologie enregistrée, colorée par Eagle : les nœuds selon l'état, les arcs selon l'utilisation des interfaces.",
  'Vista di topologia salvata':
    'Vue de topologie enregistrée',
  'alta (scorre nel riquadro)':
    'haute (défile dans le cadre)',
  'apri la mappa':
    'ouvrir la carte',
  'arco: stato peggiore dei due capi, spessore = utilizzo':
    'arc : pire état des deux extrémités, épaisseur = utilisation',
  'critico o non risponde':
    'critique ou ne répond pas',
  'interfacce non monitorate':
    'interfaces non surveillées',
  '{k} non monitorati':
    '{k} non surveillés',
  '{n} nodi fissati':
    '{n} nœuds fixés',
  '{v} · {n} nodi · {m} collegamenti{extra}':
    '{v} · {n} nœuds · {m} liaisons{extra}',
  '«Mappa con lo stato» prende una vista di topologia salvata in Rete → Mappa (filtri, fuoco e nodi fissati a mano) e la colora con Eagle: ogni nodo dallo stato peggiore dei suoi parametri (grigio se non è monitorato), ogni arco LLDP/CDP dallo stato peggiore delle sue due interfacce, con uno spessore in proporzione all’utilizzo; clic su un nodo apre la sua sezione Eagle, «schermo intero» la porta a parete. Le viste si creano e si sistemano in Rete → Mappa, qui si scelgono.':
    "« Carte avec l'état » prend une vue de topologie enregistrée dans Réseau → Carte (filtres, focus et nœuds fixés à la main) et la colore avec Eagle : chaque nœud selon le pire état de ses paramètres (gris s'il n'est pas surveillé), chaque arc LLDP/CDP selon le pire état de ses deux interfaces, avec une épaisseur proportionnelle à l'utilisation ; un clic sur un nœud ouvre sa section Eagle, « plein écran » l'affiche au mur. Les vues se créent et s'arrangent dans Réseau → Carte ; ici on les choisit.",
  '15 minuti':
    '15 minutes',
  '3 ore':
    '3 heures',
  '30 minuti':
    '30 minutes',
  'Dashboard importata: salvala come tua o per il tenant.':
    'Tableau de bord importé : enregistrez-le comme le vôtre ou pour le tenant.',
  'Dashboard importata: {n} riferimenti (CI o viste) non esistono in questo tenant — sistemali in «Titolo e opzioni», poi salva.':
    "Tableau de bord importé : {n} références (CI ou vues) n'existent pas dans ce tenant — corrigez-les dans « Titre et options », puis enregistrez.",
  'File della dashboard':
    'Fichier du tableau de bord',
  'Il file non è una dashboard esportata da CENSO.':
    "Le fichier n'est pas un tableau de bord exporté par CENSO.",
  'Importa…':
    'Importer…',
  'La dashboard importata non ha sezioni.':
    "Le tableau de bord importé n'a aucune section.",
  'Le finestre dei grafici vanno da 15 minuti a 7 giorni (le sonde aggregano a 5 minuti). In modifica, «Esporta» scarica la dashboard in un file e «Importa…» la ricostruisce, anche in un altro tenant: CI e viste di topologia si ritrovano per nome, e quelli che lì non esistono vengono contati perché tu li sistemi in «Titolo e opzioni» prima di salvare.':
    "Les fenêtres des graphiques vont de 15 minutes à 7 jours (les sondes agrègent toutes les 5 minutes). En modification, « Exporter » télécharge le tableau de bord dans un fichier et « Importer… » le reconstruit, même dans un autre tenant : les CI et les vues de topologie sont retrouvés par nom, et ceux qui n'y existent pas sont comptés pour que vous les corrigiez dans « Titre et options » avant d'enregistrer.",
  'Questa è una dashboard «{a}»: importala nella sua pagina.':
    'Ceci est un tableau de bord « {a} » : importez-le dans sa page.',
  'Scarica la dashboard in un file, da importare qui o in un altro tenant':
    'Télécharger le tableau de bord dans un fichier, à importer ici ou dans un autre tenant',
  'dietro {root}':
    'derrière {root}',
  'colpa della sonda {probe}':
    'la sonde {probe} est en cause',
  'non raggiunto da {probes}, {n} dietro':
    'injoignable depuis {probes}, {n} derrière',
  'non raggiunto da {probes}':
    'injoignable depuis {probes}',
  'trascina {n} oggetti':
    'entraîne {n} objets',
  'cieca: {down} su {total} non raggiunti':
    'aveugle : {down} sur {total} injoignables',
  'ferma: {n} oggetti senza letture':
    'muette : {n} objets sans lectures',
  'raggiungibile da {probes}':
    'joignable depuis {probes}',
  'La sonda non raggiunge più quasi nulla di ciò che legge: la causa è lei, non l’oggetto.':
    'La sonde n’atteint presque plus rien de ce qu’elle lit : la cause est la sonde, pas l’objet.',
  'sonda {name}':
    'sonde {name}',
  'cause':
    'causes',
  'Con più sonde la causa si cerca anche «da dove»: se un oggetto è giù da una sonda e su da un’altra è un percorso (la WAN, il firewall, la rotta), e la mail dice da quale sonda non si raggiunge, da quale sì e quanti oggetti stanno dietro di lui visti da quella stessa sonda — quelli si tacciono. Una sonda viva che non raggiunge più quasi nulla di ciò che legge, senza una dipendenza che lo spieghi, è «cieca»: la causa è lei, una sola mail sulla sonda e gli oggetti taciuti. Una sonda che non manda più il battito è «ferma»: gli oggetti che leggeva solo lei passano a «nessun dato» invece di restare fermi all’ultimo valore, una mail sulla sonda, e un «rientrata» quando torna. Nel cruscotto ogni problema porta il suo verdetto (dietro a chi, quanti trascina, da quale sonda non si raggiunge) e «Come stanno le cose» conta le cause, non gli oggetti.':
    'Avec plusieurs sondes, la cause se cherche aussi « d’où » : si un objet est injoignable depuis une sonde et joignable depuis une autre, c’est un chemin (le WAN, le pare-feu, la route), et le courriel dit depuis quelle sonde il n’est pas joignable, depuis laquelle il l’est, et combien d’objets se trouvent derrière lui vus depuis cette même sonde — ceux-là sont tus. Une sonde vivante qui n’atteint presque plus rien de ce qu’elle lit, sans dépendance qui l’explique, est « aveugle » : la cause, c’est elle, un seul courriel sur la sonde et les objets tus. Une sonde qui n’envoie plus son battement est « muette » : les objets qu’elle seule lisait passent à « aucune donnée » au lieu de rester figés sur la dernière valeur, un courriel sur la sonde, et un « rétablie » à son retour. Dans le tableau de bord, chaque problème porte son verdict (derrière qui, combien il entraîne, depuis quelle sonde il n’est pas joignable) et « Où en sont les choses » compte les causes, pas les objets.',
  'conteggi':
    'comptages',
  'Nei grafici ogni tacca dell’asse porta l’unità di misura («25 %», «400 Mbit/s»), con una scala sola per grafico che si adatta ai valori: oltre i 1000 Mbit/s si legge in Gbit/s, i millisecondi oltre il secondo in secondi; pillole, soglie e riquadro al passaggio del mouse usano la stessa scala.':
    'Dans les graphiques, chaque graduation de l’axe porte l’unité de mesure (« 25 % », « 400 Mbit/s »), avec une seule échelle par graphique qui s’adapte aux valeurs : au-delà de 1000 Mbit/s on lit en Gbit/s, les millisecondes au-delà de la seconde en secondes ; pastilles, seuils et encadré au survol utilisent la même échelle.',
  'Accendi o spegni':
    'Activer ou désactiver',
  'Applica a {n} CI':
    'Appliquer à {n} CI',
  'Applica adesso':
    'Appliquer maintenant',
  'Applica un profilo…':
    'Appliquer un profil…',
  'Gruppi di servizi':
    'Groupes de services',
  'Le regole valgono per tipo di parametro: ogni CI prende quelli che ha e sa leggere.':
    'Les règles valent par type de paramètre : chaque CI prend ceux qu’il a et sait lire.',
  'Nessun profilo (Eagle → Profili)':
    'Aucun profil (Eagle → Profils)',
  'Nessun profilo ancora: creane uno, poi applicalo dall’elenco dei CI o legalo a un tag.':
    'Aucun profil pour l’instant : créez-en un, puis appliquez-le depuis la liste des CI ou liez-le à un tag.',
  'Nessuna regola: aggiungine una.':
    'Aucune règle : ajoutez-en une.',
  'Nomi':
    'Noms',
  'Notifica · SLA':
    'Notification · SLA',
  'Nuovo profilo':
    'Nouveau profil',
  'Parametri di monitoraggio per {n} CI':
    'Paramètres de supervision pour {n} CI',
  'Parametri…':
    'Paramètres…',
  'Profili':
    'Profils',
  'Profili di monitoraggio ({n})':
    'Profils de supervision ({n})',
  'Profili di monitoraggio: regole per tipo di parametro da applicare a più CI insieme, o da soli ai CI con un tag.':
    'Profils de supervision : des règles par type de paramètre à appliquer à plusieurs CI à la fois, ou d’elles-mêmes aux CI portant un tag.',
  'Profilo di monitoraggio':
    'Profil de supervision',
  'Regole al volo sui CI selezionati: accendi o spegni dei tipi di parametro, cambia soglie e frequenze.':
    'Règles à la volée sur les CI sélectionnés : activer ou désactiver des types de paramètre, changer seuils et fréquences.',
  'Salute dei dischi':
    'Santé des disques',
  'Salva anche come profilo (nome, facoltativo)':
    'Enregistrer aussi comme profil (nom, facultatif)',
  'Servizi automatici fermi':
    'Services automatiques arrêtés',
  'Soglia di {s}':
    'Seuil de {s}',
  'Spegni ciò che il profilo non nomina (altrimenti il resto resta com’è)':
    'Désactiver ce que le profil ne nomme pas (sinon le reste est laissé tel quel)',
  'Spegni ciò che le regole non nominano':
    'Désactiver ce que les règles ne nomment pas',
  'Tag che lo applica da solo (chiave:valore, o solo chiave)':
    'Tag qui l’applique de lui-même (clé:valeur, ou clé seule)',
  'UPS: autonomia':
    'Onduleur : autonomie',
  'UPS: batteria':
    'Onduleur : batterie',
  'UPS: carico':
    'Onduleur : charge',
  'Ultima applicazione':
    'Dernière application',
  'Un profilo è un elenco di regole per tipo di parametro — ping, CPU, interfacce, servizi per nome… — con soglie e frequenza. Si applica a più CI insieme dall’elenco dei Configuration Item («Applica profilo…») o da solo ai CI che portano un tag, ogni dieci minuti.':
    'Un profil est une liste de règles par type de paramètre — ping, CPU, interfaces, services par nom… — avec seuils et fréquence. Il s’applique à plusieurs CI à la fois depuis la liste des Configuration Item (« Appliquer un profil… ») ou de lui-même aux CI portant un tag, toutes les dix minutes.',
  'Valore di {s}':
    'Valeur de {s}',
  'accendi':
    'activer',
  'credenziale da provare':
    'identifiant à essayer',
  'del profilo':
    'du profil de classe',
  'es. Server web':
    'ex. Serveurs web',
  'es. ruolo:core-switch':
    'ex. rôle:core-switch',
  'frequenza predefinita':
    'fréquence par défaut',
  'i profili di monitoraggio: regole per tipo di parametro — ping, CPU, memoria, interfacce (tutte, quelle del profilo della classe o per nome), servizi e processi per nome anche con *, porte TCP — con frequenza e soglie (un numero, nessuna, o la predefinita del CI). Un profilo si applica a più CI insieme dall’elenco dei Configuration Item («Applica un profilo…», oppure «Parametri…» per regole al volo, salvabili come profilo) o da solo ai CI che portano un tag (chiave:valore o solo chiave), ogni dieci minuti e con «Applica adesso»; con più tag sullo stesso CI vince la priorità più alta. Di norma tocca solo ciò che nomina; «Spegni ciò che il profilo non nomina» sostituisce tutto. L’esito dice quanti CI e parametri ha acceso e quanti parametri non erano leggibili e perché (per esempio «senza credenziale SNMP»: è il motivo per cui un apparato di rete prende solo il ping finché non ha una credenziale). Il profilo può anche assegnare gruppo di notifica e SLA.':
    'les profils de supervision : des règles par type de paramètre — ping, CPU, mémoire, interfaces (toutes, celles du profil de classe ou par nom), services et processus par nom, avec * aussi, ports TCP — avec fréquence et seuils (un nombre, aucun, ou celui par défaut du CI). Un profil s’applique à plusieurs CI à la fois depuis la liste des Configuration Item (« Appliquer un profil… », ou « Paramètres… » pour des règles à la volée, enregistrables comme profil) ou de lui-même aux CI portant un tag (clé:valeur ou clé seule), toutes les dix minutes et avec « Appliquer maintenant » ; avec plusieurs tags sur le même CI, la priorité la plus haute l’emporte. Par défaut il ne touche que ce qu’il nomme ; « Désactiver ce que le profil ne nomme pas » remplace tout. Le résultat dit combien de CI et de paramètres il a activés et combien de paramètres n’étaient pas lisibles et pourquoi (par exemple « sans identifiant SNMP » : c’est la raison pour laquelle un équipement réseau n’a que le ping tant qu’il n’a pas d’identifiant). Le profil peut aussi attribuer un groupe de notification et un SLA.',
  'metodo non ancora disponibile':
    'méthode pas encore disponible',
  'nessuna fonte che lo legga':
    'aucune source ne le lit',
  'non cambiare':
    'ne pas changer',
  'non leggibili: {elenco}':
    'illisibles : {elenco}',
  'non più in inventario':
    'plus dans l’inventaire',
  'per nome':
    'par nom',
  'predefinita':
    'par défaut',
  'profili':
    'profils',
  'profilo «{nome}»':
    'profil « {nome} »',
  'quelli del profilo della classe':
    'ceux du profil de classe',
  'senza credenziale SNMP':
    'sans identifiant SNMP',
  'spegne il resto':
    'désactive le reste',
  'spegni':
    'désactiver',
  '{n} CI col tag':
    '{n} CI avec le tag',
  '{n} CI impostati, {p} parametri accesi':
    '{n} CI configurés, {p} paramètres activés',
  '«Seleziona tutti i N CI del filtro» prende tutti quelli del filtro (anche un tag scelto dalla barra in alto), non solo la pagina; con Eagle attivo, «Metti in monitoraggio» accende sui selezionati il profilo della loro classe, «Applica un profilo…» uno dei profili di Eagle → Profili e «Parametri…» delle regole al volo (tipi di parametro da accendere o spegnere, soglie, frequenze).':
    '« Sélectionner les N CI du filtre » prend tous ceux du filtre (y compris un tag choisi dans la barre du haut), pas seulement la page ; avec Eagle actif, « Mettre sous supervision » active sur les CI sélectionnés le profil de leur classe, « Appliquer un profil… » l’un des profils d’Eagle → Profils et « Paramètres… » des règles à la volée (types de paramètre à activer ou désactiver, seuils, fréquences).',
  'La prima pagina è una dashboard a sezioni — Panoramica, Traffico, Sicurezza, Protezione e capacità, Eagle — e in ogni sezione una griglia di widget presi da un catalogo: numeri, classifiche (chi fa più traffico, servizi più usati), ruote, andamenti. «Personalizza» aggiunge sezioni e widget, li sposta trascinandoli, ne cambia la misura e le regolazioni; «Salva come mia» la salva sul server, così la ritrovi da qualsiasi computer. Un amministratore la salva «per il tenant»: è quella dei monitor a parete e di chi non ne ha una propria; se ne esiste già una con quel nome la aggiorna, non ne crea un doppione. Quando ne hai più d’una (la tua e quella del tenant) in alto le scegli da un menu, e la scelta resta per questo browser. In modifica, sotto la testata, c’è chi l’ha creata e quando, chi l’ha modificata per ultimo, e — per chi l’ha creata — «Blocca le modifiche»: una dashboard del tenant bloccata la cambia o la elimina solo chi l’ha creata (o un amministratore della piattaforma); gli altri la vedono e possono salvarne una copia come propria. «Sinottico» la mostra a tutto schermo, senza menu, con la rotazione fra le sezioni. Il menu a sinistra si filtra scrivendo, e le sezioni si aprono e chiudono dal titolo.':
    'La première page est un tableau de bord par sections — Vue d’ensemble, Trafic, Sécurité, Protection et capacité, Eagle — et dans chaque section une grille de widgets pris dans un catalogue : nombres, classements (qui fait le plus de trafic, services les plus utilisés), anneaux, tendances. « Personnaliser » ajoute sections et widgets, les déplace en les faisant glisser, en change la taille et les réglages ; « Enregistrer comme mien » l’enregistre sur le serveur, pour le retrouver depuis n’importe quel ordinateur. Un administrateur l’enregistre « pour le tenant » : c’est celui des écrans muraux et de ceux qui n’en ont pas ; s’il en existe déjà un de ce nom, il est mis à jour, pas dupliqué. Quand vous en avez plusieurs (le vôtre et celui du tenant), vous le choisissez dans un menu en haut, et le choix reste pour ce navigateur. En modification, sous l’en-tête, on lit qui l’a créé et quand, qui l’a modifié en dernier, et — pour son créateur — « Verrouiller les modifications » : un tableau de bord du tenant verrouillé n’est modifié ou supprimé que par son créateur (ou un administrateur de la plateforme) ; les autres le voient et peuvent en enregistrer une copie comme la leur. « Synoptique » l’affiche en plein écran, sans menu, en faisant tourner les sections. Le menu de gauche se filtre en écrivant, et les sections s’ouvrent et se ferment depuis leur titre.',
  'Blocca le modifiche: solo chi l’ha creata può modificarla (vale quando è salvata per il tenant)':
    'Verrouiller les modifications : seul son créateur peut la modifier (vaut quand elle est enregistrée pour le tenant)',
  'Bloccata da {chi}: solo chi l’ha creata può modificarla. Puoi salvarla come tua.':
    'Verrouillée par {chi} : seul son créateur peut la modifier. Vous pouvez l’enregistrer comme la vôtre.',
  'Dashboard del tenant «{n}»':
    'Tableau de bord du tenant « {n} »',
  'Del tenant':
    'Du tenant',
  'Elimina dal tenant':
    'Supprimer du tenant',
  'Eliminare la dashboard del tenant «{n}»? Chi la usa tornerà alla predefinita.':
    'Supprimer le tableau de bord du tenant « {n} » ? Ceux qui l’utilisent reviendront à celui par défaut.',
  'La mia':
    'Le mien',
  'La tua dashboard «{n}»':
    'Votre tableau de bord « {n} »',
  'Non ancora salvata: «Salva come mia» la fa tua, «Salva per il tenant» la dà a tutti (solo un amministratore).':
    'Pas encore enregistré : « Enregistrer comme mien » le rend vôtre, « Enregistrer pour le tenant » le donne à tous (administrateurs seulement).',
  'Quale dashboard':
    'Quel tableau de bord',
  'bloccata da {chi}: solo chi l’ha creata può modificarla':
    'verrouillée par {chi} : seul son créateur peut la modifier',
  'creata da {chi} il {quando}':
    'créée par {chi} le {quando}',
  'creata il {quando}':
    'créée le {quando}',
  'ultima modifica di {chi} il {quando}':
    'dernière modification par {chi} le {quando}',
  'ultima modifica il {quando}':
    'dernière modification le {quando}',
  'Aprendo un’interfaccia non c’è un numero solo: il traffico in entrata e in uscita in Mbit/s (due linee), i pacchetti al secondo nei due versi (se l’apparato espone i contatori), gli errori e gli scarti nell’intervallo, e sotto l’utilizzo con le soglie. I numeri in alto sono l’ultima lettura.':
    'En ouvrant une interface, il n’y a pas qu’un seul nombre : le trafic entrant et sortant en Mbit/s (deux lignes), les paquets par seconde dans les deux sens (si l’équipement expose les compteurs), les erreurs et les rejets dans l’intervalle, et en dessous l’utilisation avec ses seuils. Les nombres en haut sont la dernière lecture.',
  'Pacchetti in entrata':
    'Paquets entrants',
  'Pacchetti in uscita':
    'Paquets sortants',
  'Pacchetti al secondo':
    'Paquets par seconde',
  'in':
    'entrants',
  'out':
    'sortants',
  'nomi con * come jolly, separati da virgola (facoltativo)':
    'noms avec * comme joker, séparés par des virgules (facultatif)',
  'nome (es. Gi1/0/1)':
    'nom (ex. Gi1/0/1)',
  'come la regola':
    'comme la règle',
  'Togli la voce':
    'Retirer l’élément',
  'Prendi da un CI…':
    'Prendre depuis un CI…',
  'Nessuna voce: i nomi qui sopra (con *) valgono da soli; una voce ha le sue regolazioni.':
    'Aucun élément : les noms ci-dessus (avec *) valent seuls ; un élément porte ses propres réglages.',
  'Prendi le voci da un CI':
    'Prendre les éléments depuis un CI',
  'Un CI monitorato e i suoi {tipo}: le voci scelte entrano nella regola con il nome (e la descrizione) presi dal CI.':
    'Un CI supervisé et ses {tipo} : les éléments cochés entrent dans la règle avec le nom (et la description) pris du CI.',
  'Scegli un CI.':
    'Choisissez un CI.',
  'Questo CI non ha parametri di questo tipo.':
    'Ce CI n’a pas de paramètres de ce type.',
  'Aggiungi {n} voci':
    'Ajouter {n} éléments',
  'In una regola «per nome» ogni voce — un’interfaccia, un servizio, una porta — ha le sue regolazioni (accendi o spegni, frequenza, soglie); ciò che non dice lo prende dalla regola. «Prendi da un CI…» elenca i parametri di quel tipo di un CI monitorato, con la descrizione della porta: li spunti e diventano voci della regola, un template fatto da uno switch vero da applicare agli altri.':
    'Dans une règle « par nom », chaque élément — une interface, un service, un port — a ses propres réglages (activer ou désactiver, fréquence, seuils) ; ce qu’il ne dit pas, il le prend de la règle. « Prendre depuis un CI… » liste les paramètres de ce type d’un CI supervisé, avec la description du port : cochez-les et ils deviennent des éléments de la règle, un modèle fait à partir d’un vrai commutateur à appliquer aux autres.',
  'A) Il token (per il confronto)':
    'A) Le jeton (pour la comparaison)',
  'AWX':
    'AWX',
  'AWX prende gli host dalla CMDB: una sorgente d’inventario «da progetto» con lo script qui sotto e una chiave API del tenant con «Ansible AWX» in lettura. I tag di CENSO diventano i gruppi.':
    'AWX prend ses hôtes dans la CMDB : une source d’inventaire « depuis un projet » avec le script ci-dessous et une clé API du tenant avec « Ansible AWX » en lecture. Les tags de CENSO deviennent les groupes.',
  'Abilitato':
    'Activé',
  'Ansible AWX':
    'Ansible AWX',
  "Basic auth con un utente in sola lettura: funziona, ma un token si revoca senza toccare l'utente.":
    'Basic auth avec un utilisateur en lecture seule : cela fonctionne, mais un jeton se révoque sans toucher à l’utilisateur.',
  'C) L’inventario dinamico (AWX ← CENSO)':
    'C) L’inventaire dynamique (AWX ← CENSO)',
  'Classi':
    'Classes',
  'Come preparo AWX per CENSO?':
    'Comment préparer AWX pour CENSO ?',
  'Confronto con gli host di AWX':
    'Comparaison avec les hôtes d’AWX',
  'Confronto…':
    'Comparaison…',
  'Crea una chiave API del tenant (Impostazioni → Chiavi API) con il modulo «Ansible AWX» in lettura; in AWX un tipo di credenziale custom che inietta CENSO_URL e CENSO_API_KEY, e una sorgente d’inventario «da progetto» con lo script censo_inventory.py (scaricalo dalla scheda AWX in Sorgenti dati). I tag di CENSO diventano i gruppi di AWX.':
    'Créez une clé API du tenant (Paramètres → Clés API) avec le module « Ansible AWX » en lecture ; dans AWX un type d’identifiant personnalisé qui injecte CENSO_URL et CENSO_API_KEY, et une source d’inventaire « depuis un projet » avec le script censo_inventory.py (téléchargez-le depuis la fiche AWX dans Sources de données). Les tags de CENSO deviennent les groupes d’AWX.',
  'Di norma da una sonda che raggiunge AWX (abilitale la capability «Ansible AWX»); dal Control Plane solo se AWX è esposto su Internet.':
    'Normalement depuis une sonde qui atteint AWX (activez-lui la capacité « Ansible AWX ») ; depuis le Control Plane seulement si AWX est exposé sur Internet.',
  'Due cose, indipendenti: AWX può prendere i suoi host dalla CMDB di CENSO (inventario dinamico), e CENSO può leggere gli host di AWX per dirti quali macchine della CMDB non ci sono. Questa credenziale serve alla seconda.':
    'Deux choses indépendantes : AWX peut prendre ses hôtes dans la CMDB de CENSO (inventaire dynamique), et CENSO peut lire les hôtes d’AWX pour vous dire quelles machines de la CMDB n’y sont pas. Cet identifiant sert à la seconde.',
  'Host in AWX':
    'Hôte dans AWX',
  'In AWX, sconosciuti a CENSO ({n})':
    'Dans AWX, inconnus de CENSO ({n})',
  'In AWX: Users → l’utente → Tokens → Add: ambito «Read». Meglio un utente dedicato con il ruolo «Auditor» del sistema, o con «Read» sugli inventari da confrontare.':
    'Dans AWX : Users → l’utilisateur → Tokens → Add : portée « Read ». De préférence un utilisateur dédié avec le rôle système « Auditor », ou avec « Read » sur les inventaires à comparer.',
  'In CENSO, non in AWX ({n})':
    'Dans CENSO, pas dans AWX ({n})',
  'Indirizzo di AWX':
    'Adresse d’AWX',
  'Inventario da confrontare':
    'Inventaire à comparer',
  'Inventario di AWX':
    'Inventaire AWX',
  'Inventario dinamico (AWX ← CENSO)':
    'Inventaire dynamique (AWX ← CENSO)',
  'Lettura in tempo reale degli host di AWX / Automation Controller (REST API) per confrontarli con la CMDB. Non apre porte e non avvia job — la query esce da questa sonda attraverso il relay. Abilitala dove la sonda raggiunge AWX.':
    'Lecture en temps réel des hôtes d’AWX / Automation Controller (API REST) pour les comparer à la CMDB. N’ouvre aucun port et ne lance aucun job — la requête sort de cette sonde par le relais. Activez-la là où la sonde atteint AWX.',
  'Nessuno: tutti gli host della CMDB sono in AWX.':
    'Aucun : tous les hôtes de la CMDB sont dans AWX.',
  "Nome o id dell'inventario di AWX con cui confrontare la CMDB. Vuoto: tutti gli host di AWX.":
    'Nom ou id de l’inventaire AWX avec lequel comparer la CMDB. Vide : tous les hôtes d’AWX.',
  'Produzione':
    'Production',
  'Scarica lo script':
    'Télécharger le script',
  'Su Automation Controller il percorso è lo stesso; l’API sta sotto /api/controller/v2 e CENSO la trova da sola.':
    'Sur Automation Controller le chemin est le même ; l’API est sous /api/controller/v2 et CENSO la trouve seule.',
  'Token di accesso':
    'Jeton d’accès',
  'URL base di AWX o di Automation Controller, senza /api: il prefisso (/api/v2 oppure /api/controller/v2) lo trova CENSO da solo.':
    'URL de base d’AWX ou d’Automation Controller, sans /api : CENSO trouve le préfixe (/api/v2 ou /api/controller/v2) toute seule.',
  'Un token personale (Users → Tokens) con ambito «Read», di un utente che veda gli inventari da confrontare (ruolo Auditor, o «Read» sugli inventari). Viaggia come `Authorization: Bearer`.':
    'Un jeton personnel (Users → Tokens) avec la portée « Read », d’un utilisateur qui voit les inventaires à comparer (rôle Auditor, ou « Read » sur les inventaires). Il voyage en `Authorization: Bearer`.',
  'ansible_host':
    'ansible_host',
  'classi: server,switch':
    'classes : server,switch',
  'come si configura':
    'comment le configurer',
  'https://awx.example.com':
    'https://awx.example.com',
  'inventario della credenziale (o tutti)':
    'l’inventaire de l’identifiant (ou tous)',
  'leggo gli inventari…':
    'lecture des inventaires…',
  'tag: ruolo:web':
    'tag : rôle:web',
  'Accendi i {n} filtrati':
    'Activer les {n} filtrés',
  'Accendi tutti ({n})':
    'Tout activer ({n})',
  'Spegni i {n} filtrati':
    'Désactiver les {n} filtrés',
  'Spegni tutti ({n})':
    'Tout désactiver ({n})',
  'Spegni i {n} che non rispondono':
    'Désactiver les {n} qui ne répondent pas',
  'I pulsanti agiscono sulle {n} righe lasciate dai filtri della tabella.':
    'Les boutons agissent sur les {n} lignes laissées par les filtres du tableau.',
  'Filtra la tabella (per esempio Stato = «non risponde») e i pulsanti agiscono solo su quelle righe.':
    'Filtrez le tableau (par exemple État = « ne répond pas ») et les boutons n’agissent que sur ces lignes.',
  'In «Modifica», sopra ogni gruppo di parametri, «Accendi i N filtrati» e «Spegni i N filtrati» agiscono sulle righe lasciate dai filtri della tabella (per esempio Stato = «non risponde», o il nome delle porte di uplink), e «Spegni i N che non rispondono» è la scorciatoia: su uno switch con trenta porte giù non si tolgono trenta spunte.':
    'En « Modifier », au-dessus de chaque groupe de paramètres, « Activer les N filtrés » et « Désactiver les N filtrés » agissent sur les lignes laissées par les filtres du tableau (par exemple État = « ne répond pas », ou le nom des ports d’uplink), et « Désactiver les N qui ne répondent pas » est le raccourci : sur un commutateur avec trente ports en panne, on ne décoche pas trente cases.',
  'utilizzo (%)':
    'utilisation (%)',
  'traffico in entrata (Mbit/s)':
    'trafic entrant (Mbit/s)',
  'traffico in uscita (Mbit/s)':
    'trafic sortant (Mbit/s)',
  'pacchetti in entrata (pkt/s)':
    'paquets entrants (pkt/s)',
  'pacchetti in uscita (pkt/s)':
    'paquets sortants (pkt/s)',
  'errori nell’intervallo':
    'erreurs dans l’intervalle',
  'scarti nell’intervallo':
    'rejets dans l’intervalle',
  'entrata':
    'entrant',
  'pacchetti in entrata':
    'paquets entrants',
  'pacchetti in uscita':
    'paquets sortants',
  'scarti':
    'rejets',
  'Misura':
    'Mesure',
  'Misura della serie {n}':
    'Mesure de la série {n}',
  'traffico in entrata e in uscita (Mbit/s)':
    'trafic entrant et sortant (Mbit/s)',
  'pacchetti al secondo nei due versi':
    'paquets par seconde dans les deux sens',
  'errori e scarti nell’intervallo':
    'erreurs et rejets dans l’intervalle',
  'Errori e scarti':
    'Erreurs et rejets',
  'La sonda non ha ancora queste serie per l’interfaccia (arrivano con le finestre successive, o l’apparato non espone i contatori).':
    'La sonde n’a pas encore ces séries pour l’interface (elles arrivent avec les fenêtres suivantes, ou l’équipement n’expose pas les compteurs).',
  'L’andamento di un parametro di un CI a tua scelta; per un’interfaccia anche il traffico in Mbit/s.':
    'L’évolution d’un paramètre d’un CI de votre choix ; pour une interface, aussi le trafic en Mbit/s.',
  '«Grafico di un parametro» su un’interfaccia mostra, con «Misura», il traffico in entrata e in uscita in Mbit/s, i pacchetti al secondo o errori e scarti al posto dell’utilizzo; in «Grafico personalizzato» ogni serie di un’interfaccia ha la sua «Misura» (utilizzo, entrata, uscita, pacchetti, errori, scarti), così due WAN si confrontano in Mbit/s nello stesso grafico.':
    '« Graphique d’un paramètre » sur une interface montre, avec « Mesure », le trafic entrant et sortant en Mbit/s, les paquets par seconde ou les erreurs et rejets à la place de l’utilisation ; dans « Graphique personnalisé » chaque série d’une interface a sa « Mesure » (utilisation, entrant, sortant, paquets, erreurs, rejets), ainsi deux WAN se comparent en Mbit/s sur le même graphique.',
  '48 ore':
    '48 heures',
  'tutti gli episodi':
    'tous les épisodes',
  'solo critici e non risponde':
    'critiques et ne répond pas seulement',
  'solo chi non rispondeva':
    'seulement ce qui ne répondait pas',
  'Apri il grafico del parametro':
    'Ouvrir le graphique du paramètre',
  'Episodi di allarme per intervallo':
    'Épisodes d’alarme par intervalle',
  '{n} episodi':
    '{n} épisodes',
  'Storico degli allarmi':
    'Historique des alarmes',
  'Nessun allarme nel periodo.':
    'Aucune alarme sur la période.',
  'Nessun episodio con questo filtro.':
    'Aucun épisode avec ce filtre.',
  'e altri {n} episodi nel periodo':
    'et {n} autres épisodes sur la période',
  'Gli episodi di allarme del periodo, anche quelli già rientrati: su cosa, quando, per quanto. Un clic apre il grafico.':
    'Les épisodes d’alarme de la période, y compris ceux déjà terminés : sur quoi, quand, pendant combien de temps. Un clic ouvre le graphique.',
  'Il parametro non è più monitorato: restano le misure conservate.':
    'Le paramètre n’est plus surveillé : il reste les mesures conservées.',
  '«Storico degli allarmi» elenca gli episodi del periodo (24 ore, 48 ore, 7 giorni) anche se già rientrati — su quale CI e parametro, da quando a quando, per quanto, con le barre per ora o per giorno — così un «giù» di tre minuti alle quattro di notte non sfugge; un clic apre il grafico in una finestra, senza lasciare il cruscotto. Lo stesso vale per le tessere con un problema nella parete e per le righe dei problemi aperti: si aprono in una finestra, con il collegamento alla scheda del CI dentro. Il sinottico a parete ha il pannello «Ultimi allarmi» delle 24 ore.':
    '« Historique des alarmes » liste les épisodes de la période (24 heures, 48 heures, 7 jours) même déjà terminés — sur quel CI et paramètre, de quand à quand, pendant combien de temps, avec les barres par heure ou par jour — ainsi une panne de trois minutes à quatre heures du matin n’échappe pas ; un clic ouvre le graphique dans une fenêtre, sans quitter le tableau de bord. Il en va de même pour les tuiles avec un problème sur le mur et pour les lignes des problèmes ouverts : elles s’ouvrent dans une fenêtre, avec le lien vers la fiche du CI à l’intérieur. Le mur synoptique a le panneau « Dernières alarmes » des 24 heures.',
  'Ping rapido (latenza)':
    'Ping rapide (latence)',
  'Ping rapido':
    'Ping rapide',
  'latenza misurata ogni {s} secondi e riassunta al minuto (media, minimo, massimo, pacchetti persi): le fluttuazioni che un ping al minuto non vede':
    'latence mesurée toutes les {s} secondes et résumée à la minute (moyenne, minimum, maximum, paquets perdus) : les fluctuations qu’un ping par minute ne voit pas',
  'Ultimo minuto':
    'Dernière minute',
  'da {a} a {b}':
    'de {a} à {b}',
  'Persi':
    'Perdus',
  'Perdita nella finestra':
    'Perte dans la fenêtre',
  '{n} ping':
    '{n} pings',
  'Fra i parametri di disponibilità c’è anche il «Ping rapido (latenza)», spento di default: un pacchetto ogni 5 secondi e, ogni minuto, media, minimo, massimo e pacchetti persi — la fascia del grafico è la fluttuazione, che un ping al minuto non vede. Lo stato si decide sul minuto: attenzione con un pacchetto perso o la media oltre la soglia, critico con la metà persi, «non risponde» se non risponde nessuno. Accendilo sugli uplink e sui siti remoti che «ballano», non su tutto il parco: sono dodici pacchetti al minuto per oggetto.':
    'Parmi les paramètres de disponibilité il y a aussi le « Ping rapide (latence) », désactivé par défaut : un paquet toutes les 5 secondes et, chaque minute, moyenne, minimum, maximum et paquets perdus — la bande du graphique est la fluctuation, qu’un ping par minute ne voit pas. L’état se décide sur la minute : attention avec un paquet perdu ou la moyenne au-delà du seuil, critique avec la moitié perdue, « ne répond pas » si rien ne répond. Activez-le sur les liaisons montantes et les sites distants qui « vacillent », pas sur tout le parc : ce sont douze paquets par minute par objet.',
  'KMS':
    'KMS',
  'HashiCorp Vault (Transit)':
    'HashiCorp Vault (Transit)',
  'AWS KMS, Azure Key Vault e GCP KMS: con lo stesso contratto, quando servono.':
    'AWS KMS, Azure Key Vault et GCP KMS : même contrat, quand il le faut.',
  'Indirizzo di Vault':
    'Adresse de Vault',
  'Namespace (facoltativo)':
    'Namespace (facultatif)',
  'Motore Transit':
    'Moteur Transit',
  'Nome della chiave':
    'Nom de la clé',
  'Token di Vault':
    'Jeton Vault',
  'lascia vuoto per tenere quello salvato':
    'laisser vide pour garder celui enregistré',
  'Una policy con «encrypt» e «decrypt» su quella chiave, niente altro.':
    'Une policy avec « encrypt » et « decrypt » sur cette clé, rien d’autre.',
  'Da dove si chiama Vault':
    'D’où Vault est appelé',
  'dal Control Plane (Vault raggiungibile da Internet)':
    'depuis le Control Plane (Vault joignable depuis Internet)',
  'attraverso una sonda (Vault solo nella tua rete)':
    'via une sonde (Vault seulement sur votre réseau)',
  'Verifica il certificato TLS di Vault':
    'Vérifier le certificat TLS de Vault',
  'Prova la connessione':
    'Tester la connexion',
  'Salva e ri-avvolgi con questa chiave':
    'Enregistrer et ré-envelopper avec cette clé',
  'Adotta questa chiave':
    'Adopter cette clé',
  'Da ora le chiavi dei tuoi segreti sono avvolte dalla tua chiave: i segreti esistenti vengono ricifrati in background e le versioni che la piattaforma poteva aprire spariscono a fine ricifratura. Se la chiave non risponde, discovery e query live si fermano.':
    'Désormais les clés de vos secrets sont enveloppées par votre clé : les secrets existants sont rechiffrés en arrière-plan et les versions que la plateforme pouvait ouvrir disparaissent à la fin. Si la clé ne répond pas, la découverte et les requêtes en direct s’arrêtent.',
  'Un momento…':
    'Un instant…',
  'La tua chiave (BYOK)':
    'Votre clé (BYOK)',
  'in ritiro':
    'en retrait',
  'Stai tornando alla chiave della piattaforma: la tua chiave resta finché le versioni che ha avvolto non sono ricifrate.':
    'Vous revenez à la clé de la plateforme : la vôtre reste tant que les versions qu’elle a enveloppées ne sont pas rechiffrées.',
  '{n} versioni della chiave dati le può ancora aprire la piattaforma: spariscono a ricifratura finita.':
    '{n} versions de la clé de données peuvent encore être ouvertes par la plateforme : elles disparaissent à la fin du rechiffrement.',
  'Solo la tua chiave apre i segreti di questo tenant. Da {quando}.':
    'Seule votre clé ouvre les secrets de ce tenant. Depuis {quando}.',
  'Vault si chiama attraverso una tua sonda.':
    'Vault est appelé via l’une de vos sondes.',
  'Vault si chiama dal Control Plane.':
    'Vault est appelé depuis le Control Plane.',
  'Cambia impostazioni o token':
    'Modifier les réglages ou le jeton',
  'Torna alla chiave della piattaforma':
    'Revenir à la clé de la plateforme',
  'Le chiavi dei segreti tornano sotto la chiave della piattaforma; serve che Vault risponda ancora per ricifrare. Confermi?':
    'Les clés des secrets repassent sous la clé de la plateforme ; Vault doit encore répondre pour rechiffrer. Confirmer ?',
  'Vale per i segreti (credenziali, connettori, token), non per l’inventario del database condiviso; durante l’uso i segreti stanno in memoria del Control Plane. Se il KMS non risponde, discovery e query live di questo tenant si fermano con «chiave non disponibile».':
    'Cela couvre les secrets (identifiants, connecteurs, jetons), pas l’inventaire de la base partagée ; pendant l’usage les secrets sont en mémoire du Control Plane. Si le KMS ne répond pas, la découverte et les requêtes en direct de ce tenant s’arrêtent avec « clé indisponible ».',
  'Vault risponde: cifra e decifra con la chiave «{ref}».':
    'Vault répond : il chiffre et déchiffre avec la clé « {ref} ».',
  'Nel piano enterprise c’è «Porta la tua chiave» (BYOK): colleghi il tuo HashiCorp Vault (motore Transit), lo provi e lo adotti; da lì le chiavi dei tuoi segreti sono avvolte dalla tua chiave e aperte chiedendolo a Vault, dal Control Plane o attraverso una tua sonda se Vault sta solo nella tua rete. Finita la ricifratura, le versioni che la piattaforma poteva aprire spariscono. Revochi togliendo la policy al token: da quel momento discovery e query live del tenant si fermano con «chiave non disponibile», ed è voluto. Vale per i segreti, non per l’inventario del database condiviso.':
    'L’offre entreprise comprend « Apportez votre clé » (BYOK) : vous connectez votre HashiCorp Vault (moteur Transit), vous le testez et l’adoptez ; dès lors les clés de vos secrets sont enveloppées par votre clé et ouvertes en le demandant à Vault, depuis le Control Plane ou via l’une de vos sondes si Vault n’est que sur votre réseau. Le rechiffrement terminé, les versions que la plateforme pouvait ouvrir disparaissent. Vous révoquez en retirant la policy du jeton : dès lors la découverte et les requêtes en direct du tenant s’arrêtent avec « clé indisponible », à dessein. Cela couvre les secrets, pas l’inventaire de la base partagée.',
  'Parete':
    'Mur',
  'Sinottico di Eagle':
    'Synoptique Eagle',
  'Apri il sinottico':
    'Ouvrir le synoptique',
  'Scegli e ridimensiona i widget del sinottico':
    'Choisir et redimensionner les widgets du synoptique',
  'Il sinottico è vuoto: scegli i widget da «Personalizza».':
    'Le synoptique est vide : choisissez les widgets depuis « Personnaliser ».',
  'Il sinottico a parete si personalizza da Eagle → Sinottico (o da «Personalizza» sul monitor): è una dashboard come il cruscotto, con i widget di Eagle da scegliere, ridimensionare (quattro larghezze e «alto»), trascinare e dividere in sezioni che ruotano al ritmo scelto; si salva come propria o per il tenant. Sul monitor restano i numeri in alto e l’orologio, e la parete dei CI mostra tutti i CI.':
    'Le synoptique mural se personnalise depuis Eagle → Synoptique (ou depuis « Personnaliser » sur l’écran) : c’est un tableau de bord comme le principal, avec les widgets d’Eagle à choisir, redimensionner (quatre largeurs et « haut »), glisser et répartir en sections qui tournent au rythme choisi ; il s’enregistre comme le vôtre ou pour le tenant. Sur l’écran restent les chiffres en haut et l’horloge, et le mur des CI montre tous les CI.',
  'Sul sinottico: cambia pagina ogni':
    'Sur le synoptique : changer de page toutes les',
  'mai: la parete scorre':
    'jamais : le mur défile',
  '10 secondi':
    '10 secondes',
  '15 secondi':
    '15 secondes',
  '20 secondi':
    '20 secondes',
  '30 secondi':
    '30 secondes',
  '60 secondi':
    '60 secondes',
  'Vale sul sinottico a parete: le tessere che non entrano nello schermo si mostrano a pagine, in ordine di gravità (i problemi nella prima), senza che nessuno debba scorrere.':
    'Sur le synoptique mural : les tuiles qui ne tiennent pas à l’écran s’affichent par pages, par gravité (les problèmes dans la première), sans que personne n’ait à faire défiler.',
  'pagina {p} di {n}':
    'page {p} sur {n}',
  'Sul monitor niente lampeggia: i widget si aggiornano tenendo il disegno (la dissolvenza c’è solo al primo caricamento) e le sole tessere che pulsano sono quelle «non risponde». Le sezioni ruotano al tempo impostato in modifica («Sinottico: cambia sezione ogni N s», 0 = ferma), e la parete dei CI cambia pagina da sola al tempo scelto nelle sue opzioni, mostrando per prime le tessere con problemi.':
    'Rien ne clignote sur l’écran : les widgets se rafraîchissent en gardant leur dessin (le fondu n’existe qu’au premier chargement) et les seules tuiles qui pulsent sont celles « ne répond pas ». Les sections tournent au temps réglé en mode édition (« Synoptique : changer de section toutes les N s », 0 = fixe), et le mur des CI tourne ses pages tout seul au rythme choisi dans ses options, en montrant d’abord les tuiles avec des problèmes.',
  'Link per i monitor non valido, revocato o scaduto':
    'Lien pour les écrans non valide, révoqué ou expiré',
  'Questo monitor non può aprire il sinottico':
    'Cet écran ne peut pas ouvrir le synoptique',
  'Il sinottico è vuoto: si compone dalla console, in Eagle → Sinottico.':
    'Le synoptique est vide : il se compose depuis la console, dans Eagle → Synoptique.',
  'Revocare il link «{name}»? Il monitor che lo usa resta a schermo vuoto.':
    'Révoquer le lien « {name} » ? L’écran qui l’utilise reste vide.',
  'Titolo sul monitor':
    'Titre sur l’écran',
  'il nome della dashboard':
    'le nom du tableau de bord',
  'IP autorizzati':
    'IP autorisées',
  'qualsiasi indirizzo':
    'n’importe quelle adresse',
  'Link per i monitor':
    'Liens pour les écrans',
  'Nuovo link':
    'Nouveau lien',
  'Link creato: copialo adesso, non sarà più visibile.':
    'Lien créé : copiez-le maintenant, il ne sera plus affiché.',
  'Aprilo nel browser del monitor, in modalità chiosco o a schermo intero: il sinottico parte da solo e si aggiorna da sé.':
    'Ouvrez-le dans le navigateur de l’écran, en mode kiosque ou plein écran : le synoptique démarre tout seul et se met à jour de lui-même.',
  'es. NOC, corridoio piano 2':
    'ex. NOC, couloir 2e étage',
  'personale':
    'personnel',
  'IP autorizzati (uno per riga, anche reti come 192.168.10.0/24)':
    'IP autorisées (une par ligne, aussi des réseaux comme 192.168.10.0/24)',
  'Senza indirizzi il link vale da ovunque: chiunque lo abbia vede il monitoraggio. Meglio elencare gli IP dei monitor.':
    'Sans adresses, le lien fonctionne de partout : quiconque l’a voit la supervision. Mieux vaut lister les IP des écrans.',
  'Crea link':
    'Créer le lien',
  '«Nuovo link» ne crea uno: lo apri sul monitor e il sinottico parte senza accesso.':
    '« Nouveau lien » en crée un : ouvrez-le sur l’écran et le synoptique démarre sans connexion.',
  'link':
    'liens',
  'Il sinottico a parete ha un link apposta per i monitor: da Eagle → Sinottici pubblicati, «Link per i monitor» crea un indirizzo (/monitor/eagle/…) che apre il sinottico senza accesso, in sola lettura, dagli indirizzi IP che elenchi (anche reti), con la dashboard e il titolo che scegli, e si revoca con un clic; l’elenco dice da quale indirizzo e quando è stato usato l’ultima volta. In alto a sinistra il marchio CENSO · DiscoveryGuard, a destra «Eagle» con il titolo del sinottico (il nome della dashboard, o quello scritto sul link).':
    'Le synoptique mural a un lien prévu pour les écrans : depuis Eagle → Synoptiques publiés, « Liens pour les écrans » crée une adresse (/monitor/eagle/…) qui ouvre le synoptique sans connexion, en lecture seule, depuis les adresses IP que vous listez (réseaux compris), avec le tableau de bord et le titre de votre choix, et se révoque d’un clic ; la liste dit depuis quelle adresse et quand il a été utilisé pour la dernière fois. En haut à gauche la marque CENSO · DiscoveryGuard, à droite « Eagle » avec le titre du synoptique (le nom du tableau de bord, ou celui écrit sur le lien).',
  'Porta dello switch':
    'Port du commutateur',
  'Fra le colonne aggiuntive ci sono «Switch» e «Porta dello switch»: a quale apparato e porta è attaccato ogni CI, dalle relazioni lette dalla MAC table dello switch (e da LLDP/CDP), con il collegamento alla scheda dello switch; finiscono anche nell’Excel e nel PDF, così i monitor di un reparto si estraggono con la loro porta senza aprire ogni scheda.':
    'Parmi les colonnes supplémentaires il y a « Commutateur » et « Port du commutateur » : à quel équipement et quel port chaque CI est branché, d’après les relations lues dans la table MAC du commutateur (et par LLDP/CDP), avec le lien vers la fiche du commutateur ; elles passent aussi dans l’Excel et le PDF, ainsi les moniteurs d’un service s’exportent avec leur port sans ouvrir chaque fiche.',
  '¼ di riga':
    '¼ de ligne',
  '⅓ di riga':
    '⅓ de ligne',
  '½ riga':
    '½ ligne',
  '⅔ di riga':
    '⅔ de ligne',
  '¾ di riga':
    '¾ de ligne',
  'riga intera':
    'ligne entière',
  'Mostra a parete':
    'Afficher au mur',
  'Gestione cruscotti':
    'Gestion des tableaux de bord',
  'Il link si gestisce dalla console, in Eagle → Sinottici pubblicati → «Link per i monitor».':
    'Le lien se gère depuis la console, dans Eagle → Synoptiques publiés → « Liens pour les écrans ».',
  'Nuovo nome':
    'Nouveau nom',
  '{name} (copia)':
    '{name} (copie)',
  'Eliminare «{name}»? È del tenant: sparisce per tutti, anche dai monitor che la mostrano.':
    'Supprimer « {name} » ? Il est au tenant : il disparaît pour tous, y compris des écrans qui l’affichent.',
  'Eliminare «{name}»?':
    'Supprimer « {name} » ?',
  'del tenant':
    'du tenant',
  'mia':
    'à moi',
  'Widget':
    'Widgets',
  'Modificata':
    'Modifié',
  'Blocco':
    'Verrou',
  'bloccata':
    'verrouillé',
  'A parete':
    'Au mur',
  'Rendi mia':
    'Me l’attribuer',
  'Condividi con il tenant':
    'Partager avec le tenant',
  'Nuovo cruscotto':
    'Nouveau tableau de bord',
  'Nessun cruscotto salvato.':
    'Aucun tableau de bord enregistré.',
  'Il cruscotto predefinito si vede comunque: da «Personalizza» si salva come proprio o per il tenant, e compare qui.':
    'Le tableau de bord par défaut s’affiche quand même : depuis « Personnaliser » il s’enregistre comme le vôtre ou pour le tenant, et il apparaît ici.',
  'cruscotti':
    'tableaux de bord',
  'CI monitorati per classe':
    'CI supervisés par classe',
  'e altre {n} classi':
    'et {n} autres classes',
  'Indirizzo IP da raggiungere':
    'Adresse IP à atteindre',
  'es. Internet da Sesto':
    'ex. Internet depuis Sesto',
  'Sonda che misura':
    'Sonde qui mesure',
  'Collego…':
    'Liaison…',
  'Cambia bersaglio':
    'Changer la cible',
  'Collegato: {name} ({address}){probe}':
    'Lié : {name} ({address}){probe}',
  'misura {probe}':
    'mesuré par {probe}',
  '«Collega» crea (una volta) il CI per l’indirizzo con ping e ping rapido accesi dalla sonda scelta; la latenza arriva entro un minuto.':
    '« Lier » crée (une fois) le CI pour l’adresse avec le ping et le ping rapide activés depuis la sonde choisie ; la latence arrive en moins d’une minute.',
  'Indirizzo e sonda':
    'Adresse et sonde',
  'Latenza verso un indirizzo':
    'Latence vers une adresse',
  'Scegli l’indirizzo e la sonda in «Personalizza», poi «Collega».':
    'Choisissez l’adresse et la sonde dans « Personnaliser », puis « Lier ».',
  'da {probe}':
    'depuis {probe}',
  'Il tempo di risposta verso un IP pubblico (o un capo remoto), misurato da una sonda a scelta.':
    'Le temps de réponse vers une IP publique (ou une extrémité distante), mesuré par une sonde au choix.',
  '{n} di {tot} CI':
    '{n} sur {tot} CI',
  'Il widget «Latenza verso un indirizzo» disegna il tempo di risposta verso un IP pubblico (8.8.8.8, il capo remoto di una WAN) misurato da una sonda a scelta: in «Personalizza» scrivi l’indirizzo, un nome e la sonda, «Collega» crea una volta il CI per quell’indirizzo con ping e ping rapido accesi e la sonda come punto di osservazione, e il grafico è quello del ping rapido (media, minimo e massimo al minuto). Nella parete dei CI sul monitor le tessere cambiano pagina da sole (15 secondi se non scegli altro), e nel cruscotto il sottotitolo dice «40 di 159 CI» quando non entrano tutte. Il menu per scegliere quale dashboard sta a sinistra, sotto il titolo.':
    'Le widget « Latence vers une adresse » dessine le temps de réponse vers une IP publique (8.8.8.8, l’extrémité distante d’un WAN) mesuré par une sonde au choix : dans « Personnaliser » saisissez l’adresse, un nom et la sonde, « Lier » crée une fois le CI pour cette adresse avec le ping et le ping rapide activés et la sonde comme point d’observation, et le graphique est celui du ping rapide (moyenne, minimum et maximum par minute). Sur l’écran, le mur des CI tourne ses pages tout seul (15 secondes sauf autre choix), et dans le tableau de bord le sous-titre dit « 40 sur 159 CI » quand tout ne tient pas. Le menu pour choisir un tableau de bord est à gauche, sous le titre.',
  'fine dello schermo':
    'fin de l’écran',
  'Trascina per ridimensionare':
    'Glisser pour redimensionner',
  'Posizione e misura in celle (24 colonne × 12 righe = uno schermo)':
    'Position et taille en cellules (24 colonnes × 12 lignes = un écran)',
  'Scegli un’immagine in «Personalizza»: un file dal computer o un indirizzo.':
    'Choisissez une image dans « Personnaliser » : un fichier de l’ordinateur ou une adresse.',
  'Scrivi il testo in «Personalizza».':
    'Écrivez le texte dans « Personnaliser ».',
  'L’immagine resta troppo grande anche ridotta: usa un file più semplice o un indirizzo.':
    'L’image reste trop grande même réduite : utilisez un fichier plus simple ou une adresse.',
  'Cambia file…':
    'Changer de fichier…',
  'Scegli un file…':
    'Choisir un fichier…',
  'Usa l’indirizzo':
    'Utiliser l’adresse',
  'Togli l’immagine':
    'Retirer l’image',
  'Il file viene ridotto nel browser (lato lungo 1600 px) e salvato dentro la dashboard: {kb} kB.':
    'Le fichier est réduit dans le navigateur (grand côté 1600 px) et enregistré dans le tableau de bord : {kb} ko.',
  'Un file dal computer viene ridotto nel browser e salvato dentro la dashboard; un indirizzo deve essere raggiungibile dal monitor.':
    'Un fichier de l’ordinateur est réduit dans le navigateur et enregistré dans le tableau de bord ; une adresse doit être accessible depuis l’écran.',
  'Composizione':
    'Composition',
  'tutta dentro':
    'entière',
  'riempi, tagliando':
    'remplir, en rognant',
  'stira':
    'étirer',
  'Didascalia (facoltativa)':
    'Légende (facultative)',
  'Con cornice e titolo':
    'Avec cadre et titre',
  'piccolo':
    'petit',
  'grande':
    'grand',
  'titolo':
    'titre',
  'Allineamento':
    'Alignement',
  'a sinistra':
    'à gauche',
  'al centro':
    'centré',
  'a destra':
    'à droite',
  'Una planimetria, uno schema, un logo: un file dal computer o un indirizzo.':
    'Un plan, un schéma, un logo : un fichier de l’ordinateur ou une adresse.',
  'Un titolo, una didascalia, una legenda.':
    'Un titre, une légende, une clé.',
  'Una matrice di 24 colonne per 12 righe (uno schermo): ogni widget si sposta e si ridimensiona a mano, anche sopra un altro.':
    'Une matrice de 24 colonnes sur 12 lignes (un écran) : chaque widget se déplace et se redimensionne à la main, même par-dessus un autre.',
  'Disposizione libera':
    'Disposition libre',
  'Sinottici pubblicati':
    'Synoptiques publiés',
  'Con «Disposizione libera» una sezione diventa una matrice di 24 colonne per 12 righe (uno schermo del monitor): ogni widget si sposta trascinandolo dalla maniglia ⋮⋮ e si ridimensiona dall’angolo in basso a destra, in celle, anche sopra un altro widget (l’ultimo sta sopra); in modifica una linea tratteggiata segna dove finisce lo schermo. Nel catalogo, gruppo «Composizione», ci sono «Immagine» (una planimetria, uno schema, un logo: un file dal computer, ridotto nel browser e salvato dentro la dashboard, o un indirizzo; senza cornice è uno sfondo) e «Testo» (titoli, didascalie, legende, in quattro dimensioni). Così un sinottico si compone come si vuole: la pianta del reparto sotto, le tessere dei CI e le scritte sopra. Un sinottico pubblicato è un cruscotto assegnato a un monitor: la voce «Sinottici pubblicati» elenca i monitor, con il cruscotto che ognuno mostra e il link che lo apre senza accesso.':
    'Avec « Disposition libre », une section devient une matrice de 24 colonnes sur 12 lignes (un écran) : chaque widget se déplace en tirant sa poignée ⋮⋮ et se redimensionne depuis le coin inférieur droit, en cellules, même par-dessus un autre widget (le dernier est au-dessus) ; en mode édition, une ligne pointillée marque la fin de l’écran. Dans le catalogue, le groupe « Composition » offre « Image » (un plan, un schéma, un logo : un fichier de l’ordinateur, réduit dans le navigateur et enregistré dans le tableau de bord, ou une adresse ; sans cadre c’est un fond) et « Texte » (titres, légendes, clés, en quatre tailles). Un synoptique se compose ainsi comme on veut : le plan du service dessous, les tuiles des CI et les textes dessus. Un synoptique publié est un tableau de bord assigné à un écran : l’entrée « Synoptiques publiés » liste les écrans, avec le tableau de bord que chacun affiche et le lien qui l’ouvre sans connexion.',
  'la rete del primo uso':
    'le réseau de la première utilisation',
  'l’indirizzo del primo uso':
    'l’adresse de la première utilisation',
  'Indirizzi autorizzati':
    'Adresses autorisées',
  'quelli elencati qui sotto':
    'celles listées ci-dessous',
  'la rete /24 del primo uso (monitor in DHCP)':
    'le réseau /24 de la première utilisation (écran en DHCP)',
  'Il link vale da ovunque finché non viene aperto la prima volta: da allora solo dalla rete /24 di quel monitor, anche se il DHCP gli cambia indirizzo.':
    'Le lien fonctionne de partout jusqu’à sa première ouverture : ensuite seulement depuis le réseau /24 de cet écran, même si le DHCP change son adresse.',
  'Dal primo uso in poi vale solo da quell’indirizzo.':
    'À partir de la première utilisation, il ne fonctionne que depuis cette adresse.',
  'Un monitor in DHCP: indica la rete della sua subnet (es. 192.168.10.0/24) o scegli il blocco al primo uso.':
    'Un écran en DHCP : indiquez son sous-réseau (ex. 192.168.10.0/24) ou choisissez le verrouillage à la première utilisation.',
  'Un monitor in DHCP non ha un indirizzo da elencare: si indica la sua rete (es. 192.168.10.0/24), oppure il link si «blocca» da solo al primo uso, sull’indirizzo o sulla rete /24 del monitor che lo apre per primo; fino ad allora vale da ovunque, quindi aprilo subito sul monitor giusto.':
    'Un écran en DHCP n’a pas d’adresse à lister : indiquez son réseau (ex. 192.168.10.0/24), ou laissez le lien se « verrouiller » tout seul à la première utilisation, sur l’adresse ou le réseau /24 de l’écran qui l’ouvre en premier ; d’ici là il fonctionne de partout, ouvrez-le donc tout de suite sur le bon écran.',
  'Chiave multi agente':
    'Clé multi-agent',
  'è una chiave':
    'est une clé',
  'Il comando vale un’ora (fino alle {ora}) e contiene il segreto di questa chiave: è l’unica volta in cui compare. Passata la finestra si rigenera — rigenerare la chiave invalida il comando e il pacchetto vecchi (le macchine nuove non si registrano più con quelli), ma le macchine già registrate continuano a funzionare: ognuna ha un segreto suo.':
    'La commande vaut une heure (jusqu’à {ora}) et contient le secret de cette clé : la seule fois où il apparaît. Passée la fenêtre, elle se régénère — régénérer la clé invalide l’ancienne commande et l’ancien paquet (les nouvelles machines ne s’enregistrent plus avec eux), mais les machines déjà enregistrées continuent de fonctionner : chacune a son propre secret.',
  'Il comando vale un’ora e contiene il segreto di questa chiave: è l’unica volta in cui compare. Passata la finestra si rigenera — rigenerare la chiave invalida il comando e il pacchetto vecchi (le macchine nuove non si registrano più con quelli), ma le macchine già registrate continuano a funzionare: ognuna ha un segreto suo.':
    'La commande vaut une heure et contient le secret de cette clé : la seule fois où il apparaît. Passée la fenêtre, elle se régénère — régénérer la clé invalide l’ancienne commande et l’ancien paquet (les nouvelles machines ne s’enregistrent plus avec eux), mais les machines déjà enregistrées continuent de fonctionner : chacune a son propre secret.',
  'Altre azioni':
    'Autres actions',
  'Solo gli amministratori assegnano i cruscotti ai monitor.':
    'Seuls les administrateurs assignent les tableaux de bord aux écrans.',
  'Chiedi a un amministratore del tenant di creare il link per il monitor.':
    'Demandez à un administrateur du tenant de créer le lien pour l’écran.',
  'Tutti i cruscotti di Eagle: aprirli, mandarli a parete, duplicarli, rinominarli, condividerli con il tenant; i monitor si assegnano in «Sinottici pubblicati».':
    'Tous les tableaux de bord d’Eagle : les ouvrir, les envoyer au mur, les dupliquer, les renommer, les partager avec le tenant ; les écrans s’assignent dans « Synoptiques publiés ».',
  'Cruscotto mostrato':
    'Tableau de bord affiché',
  'quello del tenant':
    'celui du tenant',
  'Cruscotto da mostrare':
    'Tableau de bord à afficher',
  'quello del tenant (o la disposizione da parete predefinita)':
    'celui du tenant (ou la disposition murale par défaut)',
  'Un monitor a parete: un link che mostra il cruscotto scelto senza accesso, in sola lettura per Eagle (non apre la console), solo dagli indirizzi IP che autorizzi, revocabile con un clic. Il segreto si mostra una volta sola.':
    'Un écran mural : un lien qui affiche le tableau de bord choisi sans connexion, en lecture seule pour Eagle (il n’ouvre pas la console), uniquement depuis les adresses IP autorisées, révocable d’un clic. Le secret ne s’affiche qu’une fois.',
  'Cruscotti':
    'Tableaux de bord',
  'I monitor a cui assegnare un cruscotto, con il loro link senza accesso, stanno in':
    'Les écrans auxquels assigner un tableau de bord, avec leur lien sans connexion, sont dans',
  'Eliminare il link «{name}»? Sparisce dall’elenco, con il suo ultimo uso.':
    'Supprimer le lien « {name} » ? Il disparaît de la liste, avec sa dernière utilisation.',
  'In ogni riquadro il grafico del tempo di risposta del ping (ultima ora)':
    'Dans chaque tuile le graphique du temps de réponse du ping (dernière heure)',
  'Con il «Ping rapido (latenza)» acceso: media, minimo e massimo di dodici pacchetti al minuto; con il ping normale: il miglior tempo dei tre pacchetti al minuto (serve la sonda aggiornata).':
    'Avec le « Ping rapide (latence) » activé : moyenne, minimum et maximum de douze paquets par minute ; avec le ping normal : le meilleur temps des trois paquets par minute (sonde à jour requise).',
  'Misura (interfacce e ping)':
    'Mesure (interfaces et ping)',
  'il valore con le soglie':
    'la valeur avec ses seuils',
  'tempo di risposta del ping (ms)':
    'temps de réponse du ping (ms)',
  'Per un’interfaccia: le serie che la sonda tiene accanto all’utilizzo. Per il ping: il tempo di risposta accanto alla perdita. Per gli altri parametri si disegna il valore.':
    'Pour une interface : les séries que la sonde garde à côté de l’utilisation. Pour le ping : le temps de réponse à côté de la perte. Pour les autres paramètres, on dessine la valeur.',
  'Tempo di risposta':
    'Temps de réponse',
  'Nella parete dei CI la spunta «In ogni riquadro il grafico del tempo di risposta del ping» disegna dentro ogni tessera il tempo di risposta dell’ultima ora, letto per tutta la parete in una chiamata sola: con il ping rapido la media con la fascia minimo–massimo di dodici pacchetti al minuto, con il ping normale il miglior tempo dei tre pacchetti al minuto (la sonda lo manda come serie derivata «ping/rtt», senza un pacchetto in più); le tessere si allungano per farle posto. Lo stesso tempo di risposta si sceglie come «Misura» nel «Grafico di un parametro» sul ping.':
    'Dans le mur des CI, l’option « Dans chaque tuile le graphique du temps de réponse du ping » dessine dans chaque tuile le temps de réponse de la dernière heure, lu pour tout le mur en un seul appel : avec le ping rapide la moyenne avec la bande min–max de douze paquets par minute, avec le ping normal le meilleur temps des trois paquets par minute (la sonde l’envoie comme série dérivée « ping/rtt », sans paquet supplémentaire) ; les tuiles s’agrandissent pour lui faire place. Le même temps de réponse se choisit comme « Mesure » dans « Graphique d’un paramètre » sur le ping.',
  'Link nuovo':
    'Nouveau lien',
  'Riavvia il PC':
    'Redémarrer le PC',
  'Riavviare il PC del monitor? Il sinottico torna da solo all’accesso.':
    'Redémarrer le PC de l’écran ? Le synoptique revient tout seul à l’ouverture de session.',
  'Scollegare «{name}»? Sul suo schermo tornerà il codice di accoppiamento.':
    'Dissocier « {name} » ? Le code d’appairage reviendra sur son écran.',
  'con un problema':
    'avec un problème',
  'in linea, browser fermo':
    'en ligne, navigateur arrêté',
  'Schermo':
    'Écran',
  'non so':
    'inconnu',
  'Spegni schermo':
    'Éteindre l’écran',
  'Accendi schermo':
    'Allumer l’écran',
  'I PC dietro gli schermi con CENSO Monitor: un programma a sé, non l’agente, che mostra un cruscotto in un browser a chiosco e prende ordini da qui. Un PC diventa un monitor solo con l’accoppiamento: al primo avvio CENSO Monitor mostra un codice sullo schermo, tu lo scrivi qui sotto.':
    'Les PC derrière les écrans avec CENSO Monitor : un programme à part, pas l’agent, qui affiche un tableau de bord dans un navigateur en mode kiosque et prend ses ordres ici. Un PC ne devient un écran que par l’appairage : au premier démarrage CENSO Monitor affiche un code à l’écran, vous le saisissez ci-dessous.',
  'Accoppia un monitor':
    'Appairer un écran',
  'Codice sullo schermo':
    'Code à l’écran',
  'il nome del cruscotto':
    'le nom du tableau de bord',
  'Accoppio…':
    'Appairage…',
  'Accoppia':
    'Appairer',
  'Installare CENSO Monitor':
    'Installer CENSO Monitor',
  'Sul PC del monitor, con l’utente che accende lo schermo: scarica il programma, poi':
    'Sur le PC de l’écran, avec l’utilisateur qui allume l’écran : téléchargez le programme, puis',
  'La prima riga lo fa partire da solo a ogni accesso; la seconda lo avvia adesso: sullo schermo compare il codice. Serve un browser (Chrome, Chromium, Edge o Firefox).':
    'La première ligne le fait démarrer tout seul à chaque ouverture de session ; la seconde le lance maintenant : le code apparaît à l’écran. Il faut un navigateur (Chrome, Chromium, Edge ou Firefox).',
  'Scarica:':
    'Télécharger :',
  'I binari di CENSO Monitor non sono in questa installazione: serve l’immagine del Control Plane che li costruisce.':
    'Les binaires de CENSO Monitor ne sont pas dans cette installation : il faut l’image du Control Plane qui les construit.',
  'Nessun monitor accoppiato.':
    'Aucun écran appairé.',
  'Installa CENSO Monitor sul PC dello schermo e scrivi qui il codice che compare.':
    'Installez CENSO Monitor sur le PC de l’écran et saisissez ici le code qui apparaît.',
  'monitor':
    'écrans',
  'Questo schermo aspetta di essere accoppiato':
    'Cet écran attend d’être appairé',
  'Codice di accoppiamento':
    'Code d’appairage',
  'In CENSO, Eagle → Sinottici pubblicati → «Accoppia un monitor»: scrivi questo codice, dai un nome al monitor e scegli il cruscotto. Il codice vale quindici minuti.':
    'Dans CENSO, Eagle → Synoptiques publiés → « Appairer un écran » : saisissez ce code, nommez l’écran et choisissez le tableau de bord. Le code vaut quinze minutes.',
  'CENSO Monitor sta chiedendo un codice al Control Plane: se non compare, controlla l’indirizzo del server e la rete.':
    'CENSO Monitor demande un code au Control Plane : s’il n’apparaît pas, vérifiez l’adresse du serveur et le réseau.',
  'Macchina: {host}':
    'Machine : {host}',
  'I monitor a parete: ogni sinottico pubblicato è un cruscotto assegnato a un monitor. Con CENSO Monitor sul PC dello schermo lo accoppi con un codice e lo comandi da qui; in alternativa un link che si apre senza accesso. Il cruscotto si compone in «Cruscotto» e si manda a parete con «Mostra a parete».':
    'Les écrans muraux : chaque synoptique publié est un tableau de bord assigné à un écran. Avec CENSO Monitor sur le PC de l’écran, vous l’appairez avec un code et le commandez d’ici ; sinon un lien qui s’ouvre sans connexion. Le tableau de bord se compose dans « Tableau de bord » et s’envoie au mur avec « Afficher au mur ».',
  'Per comandare lo schermo da remoto c’è CENSO Monitor: un programma a sé (non l’agente), da installare solo sul PC del monitor con l’utente che accende lo schermo («censo-monitor --server … --install»). Al primo avvio mostra un codice a sei cifre: in Eagle → Sinottici pubblicati → «Accoppia un monitor» lo scrivi con un nome e il cruscotto, e da quel momento vedi lo stato del monitor (in linea, browser, schermo) e gli mandi i comandi — cruscotto, ricarica, schermo acceso o spento, riavvio del PC, link nuovo, scollega. Niente diventa un monitor senza il codice confermato dalla console.':
    'Pour commander l’écran à distance il y a CENSO Monitor : un programme à part (pas l’agent), à installer seulement sur le PC de l’écran avec l’utilisateur qui l’allume (« censo-monitor --server … --install »). Au premier démarrage il affiche un code à six chiffres : dans Eagle → Synoptiques publiés → « Appairer un écran » vous le saisissez avec un nom et le tableau de bord, et dès lors vous voyez l’état de l’écran (en ligne, navigateur, écran) et lui envoyez les commandes — tableau de bord, recharger, écran allumé ou éteint, redémarrage du PC, nouveau lien, dissocier. Rien ne devient un écran sans le code confirmé depuis la console.',
  'Accendi e spegni lo schermo a orario':
    'Allumer et éteindre l’écran selon un horaire',
  'Accensione':
    'Allumage',
  'Spegnimento':
    'Extinction',
  'Aggiorna CENSO Monitor':
    'Mettre à jour CENSO Monitor',
  'Aggiorna CENSO Monitor da solo quando il Control Plane ne ha una versione nuova':
    'Mettre à jour CENSO Monitor tout seul quand le Control Plane en a une version plus récente',
  'Aggiorna il sistema':
    'Mettre à jour le système',
  'Cosa mostra':
    'Ce qu’il affiche',
  'Fuso orario (es. Europe/Rome)':
    'Fuseau horaire (ex. Europe/Rome)',
  'Il monitor dice':
    'Le moniteur indique',
  'Impostazioni…':
    'Paramètres…',
  'Le voci spente non sono disponibili su questo monitor (lo dice lui, con le sue capacità). Gli orari seguono l’orologio del PC del monitor.':
    'Les champs grisés ne sont pas disponibles sur ce moniteur (il le dit lui-même, par ses capacités). Les horaires suivent l’horloge du PC du moniteur.',
  'Log del programma':
    'Journal du programme',
  'Luminosità (0–100, vuoto = non toccare)':
    'Luminosité (0–100, vide = ne pas toucher)',
  'Nessuno screenshot: chiedilo dal menu «⋯».':
    'Aucune capture d’écran : demandez-en une depuis le menu « ⋯ ».',
  'RAM libera':
    'RAM libre',
  'Riavvia il browser':
    'Redémarrer le navigateur',
  'Riavvio notturno del PC (facoltativo)':
    'Redémarrage nocturne du PC (facultatif)',
  'Ricarica il cruscotto ogni (ore, 0 = mai)':
    'Recharger le tableau de bord toutes les (heures, 0 = jamais)',
  'Schermo e risparmio energetico':
    'Écran et économie d’énergie',
  'Screenshot':
    'Capture d’écran',
  'Screenshot del monitor':
    'Capture d’écran du moniteur',
  'Spegnere il PC del monitor? Per riaccenderlo serve qualcuno sul posto (o Wake-on-LAN).':
    'Éteindre le PC du moniteur ? Il faudra quelqu’un sur place (ou Wake-on-LAN) pour le rallumer.',
  'Spegni il PC':
    'Éteindre le PC',
  'Ultimo screenshot: {q}':
    'Dernière capture d’écran : {q}',
  'Zoom (0,5–3)':
    'Zoom (0,5–3)',
  'acceso da {d}':
    'allumé depuis {d}',
  'aggiornato {q}':
    'mis à jour {q}',
  'disco libero':
    'disque libre',
  'mostra':
    'afficher',
  '{g} g {h} h':
    '{g} j {h} h',
  '{m} min':
    '{m} min',
  'Un PC dedicato: CENSO Monitor OS':
    'Un PC dédié : CENSO Monitor OS',
  'Per un PC che fa solo il monitor c’è la ISO installabile (x86): scrivila su una chiavetta (dd su Linux e macOS, Rufus in modalità DD su Windows), avvia il PC dalla chiavetta e segui l’installazione, che chiede la rete (cablata o Wi‑Fi) e l’indirizzo di questo Control Plane; al primo avvio lo schermo mostra il codice da scrivere qui accanto. Programma e sistema si aggiornano da soli e la riga del monitor ha tutte le voci, compreso «Aggiorna il sistema».':
    'Pour un PC qui ne sert que de moniteur, il y a l’ISO installable (x86) : écrivez-la sur une clé USB (dd sous Linux et macOS, Rufus en mode DD sous Windows), démarrez le PC sur la clé et suivez l’installation, qui demande le réseau (filaire ou Wi‑Fi) et l’adresse de ce Control Plane ; au premier démarrage l’écran affiche le code à saisir ici. Programme et système se mettent à jour tout seuls et la ligne du moniteur a toutes les options, y compris « Mettre à jour le système ».',
  'Scarica la ISO di installazione':
    'Télécharger l’ISO d’installation',
  '{n} MB':
    '{n} Mo',
  'servita da questa installazione':
    'servie par cette installation',
  'CENSO Monitor OS, la ISO dei monitor':
    'CENSO Monitor OS, l’ISO des moniteurs',
  'Sorgente: l’ultima release del repository {repo}{token}.':
    'Source : la dernière release du dépôt {repo}{token}.',
  'con token':
    'avec jeton',
  'Sorgente: l’indirizzo {url}.':
    'Source : l’adresse {url}.',
  'Ultimo controllo {q}: {esito}.':
    'Dernière vérification {q} : {esito}.',
  'scaricata':
    'téléchargée',
  'già aggiornata':
    'déjà à jour',
  'Scarica adesso':
    'Télécharger maintenant',
  'Per un PC che fa solo il monitor c’è CENSO Monitor OS, la ISO installabile (x86): nel riquadro «Installare CENSO Monitor» trovi il link con nome, dimensione e impronta SHA‑256; la scrivi su una chiavetta, avvii il PC da lì, l’installazione chiede rete (cablata o Wi‑Fi) e indirizzo del Control Plane, e al primo avvio lo schermo mostra il codice. La ISO è unica per tutti e sta sul sito di DiscoveryGuard: chi gestisce la piattaforma ne scrive l’indirizzo in Piattaforma → CENSO Monitor OS, e il Control Plane può anche tenerne una copia e servirla lui, verificata con l’impronta pubblicata; se non è ancora collegata, il riquadro lo dice.':
    'Pour un PC qui ne sert que de moniteur, il y a CENSO Monitor OS, l’ISO installable (x86) : l’encadré « Installer CENSO Monitor » contient le lien avec nom, taille et empreinte SHA‑256 ; vous l’écrivez sur une clé USB, démarrez le PC dessus, l’installation demande le réseau (filaire ou Wi‑Fi) et l’adresse du Control Plane, et au premier démarrage l’écran affiche le code. L’ISO est la même pour tous et se trouve sur le site DiscoveryGuard : la personne qui gère la plateforme en écrit l’adresse dans Plateforme → CENSO Monitor OS, et le Control Plane peut aussi en garder une copie et la servir lui-même, vérifiée avec l’empreinte publiée ; si elle n’est pas encore reliée, l’encadré le dit.',
  'La ISO non è ancora collegata: chi gestisce la piattaforma ne scrive l’indirizzo in Piattaforma → CENSO Monitor OS, e il link compare qui.':
    'L’ISO n’est pas encore reliée : la personne qui gère la plateforme en écrit l’adresse dans Plateforme → CENSO Monitor OS, et le lien apparaît ici.',
  'L’immagine installabile, unica per tutti, per un PC che fa solo il monitor a parete: chi la installa scrive l’indirizzo del Control Plane e poi accoppia lo schermo con il codice. Sta sul sito: scrivi qui il suo indirizzo e ogni tenant la trova in Eagle → Sinottici pubblicati → «Installare CENSO Monitor», con l’impronta SHA‑256 accanto.':
    'L’image installable, la même pour tous, pour un PC qui ne sert que de moniteur mural : la personne qui l’installe saisit l’adresse du Control Plane puis appaire l’écran avec le code. Elle se trouve sur le site : écrivez ici son adresse et chaque tenant la trouve dans Eagle → Synoptiques publiés → « Installer CENSO Monitor », avec l’empreinte SHA‑256 à côté.',
  'Indirizzo salvato.':
    'Adresse enregistrée.',
  'Indirizzo pubblico della ISO (https://…/file.iso)':
    'Adresse publique de l’ISO (https://…/fichier.iso)',
  'Impronta SHA-256 (se accanto al file non c’è il .sha256)':
    'Empreinte SHA-256 (s’il n’y a pas de .sha256 à côté du fichier)',
  'Valore preso dall’ambiente (CENSO_MONITOR_ISO_URL): salvandolo qui vince quello scritto qui.':
    'Valeur prise de l’environnement (CENSO_MONITOR_ISO_URL) : une fois enregistrée ici, c’est ce qui est écrit ici qui prime.',
  'Copia su questa installazione (facoltativa)':
    'Copie sur cette installation (facultative)',
  'Il Control Plane può tenere una copia della ISO e servirla lui ai tenant, utile dove i monitor non raggiungono il sito: la scarica dall’indirizzo qui sopra e la accetta solo se l’impronta corrisponde a quella pubblicata. Con CENSO_MONITOR_ISO_AUTO=true la rinnova da sola ogni giorno.':
    'Le Control Plane peut garder une copie de l’ISO et la servir lui-même aux tenants, utile là où les moniteurs n’atteignent pas le site : il la télécharge depuis l’adresse ci-dessus et ne l’accepte que si l’empreinte correspond à celle publiée. Avec CENSO_MONITOR_ISO_AUTO=true il la renouvelle tout seul chaque jour.',
  'Copia presente:':
    'Copie présente :',
  'Nessuna copia su questa installazione: i tenant scaricano dal sito.':
    'Aucune copie sur cette installation : les tenants téléchargent depuis le site.',
  'Nessuna sorgente: serve l’indirizzo qui sopra (o un repository GitHub da ambiente).':
    'Aucune source : il faut l’adresse ci-dessus (ou un dépôt GitHub depuis l’environnement).',
  'Rinnovo giornaliero acceso.':
    'Renouvellement quotidien activé.',
  'Rinnovo giornaliero spento.':
    'Renouvellement quotidien désactivé.',
  'Download avviato: questa pagina si aggiorna da sola.':
    'Téléchargement lancé : cette page se met à jour toute seule.',
  'Senza Internet: copia la ISO e il suo file .sha256 in {folder} sul volume dei firmware del Control Plane.':
    'Sans Internet : copiez l’ISO et son fichier .sha256 dans {folder} sur le volume des firmwares du Control Plane.',
  'Tema del sinottico':
    'Thème du synoptique',
  'come il browser':
    'comme le navigateur',
  'Annulla i comandi in attesa':
    'Annuler les commandes en attente',
  'Scala dell’asse Y':
    'Échelle de l’axe Y',
  'automatica, dallo zero (le percentuali fino a 100)':
    'automatique, depuis zéro (les pourcentages jusqu’à 100)',
  'adattata ai valori, anche senza lo zero':
    'ajustée aux valeurs, même sans le zéro',
  'fissa: i limiti qui sotto':
    'fixe : les limites ci-dessous',
  'Limite inferiore (scala fissa)':
    'Limite inférieure (échelle fixe)',
  'Limite superiore (scala fissa)':
    'Limite supérieure (échelle fixe)',
  'Nell’unità della misura; vuoto = zero.':
    'Dans l’unité de la mesure ; vide = zéro.',
  'Nell’unità della misura; vuoto = dal valore più alto.':
    'Dans l’unité de la mesure ; vide = d’après la valeur la plus haute.',
  'In «Titolo e opzioni» dei grafici («Grafico di un parametro», «Grafico personalizzato», «Latenza verso un indirizzo») si sceglie la scala dell’asse Y: automatica dallo zero (le percentuali fino a 100), adattata ai valori anche senza lo zero — una CPU al 2–5 % o un ping a 10–13 ms smettono di essere una linea piatta — oppure fissa con i limiti che scrivi, nell’unità della misura; i valori fuori dai limiti si fermano al bordo.':
    'Dans « Titre et options » des graphiques (« Graphique d’un paramètre », « Graphique personnalisé », « Latence vers une adresse ») on choisit l’échelle de l’axe Y : automatique depuis zéro (les pourcentages jusqu’à 100), ajustée aux valeurs même sans le zéro — un CPU à 2–5 % ou un ping à 10–13 ms cessent d’être une ligne plate — ou fixe avec les limites que vous écrivez, dans l’unité de la mesure ; les valeurs hors limites s’arrêtent au bord.',
  'Risoluzione dello schermo':
    'Résolution de l’écran',
  'quella del pannello':
    'celle du panneau',
  'Solo i CI con i tag':
    'Seulement les CI avec les tags',
  'chiave:valore oppure solo chiave (qualunque valore); più tag separati da virgola, tutti richiesti. Vuoto = tutti i CI.':
    'clé:valeur ou seulement clé (toute valeur) ; plusieurs tags séparés par des virgules, tous requis. Vide = tous les CI.',
  'il valore, nel colore dello stato':
    'la valeur, dans la couleur de l’état',
  'lo stato, con il valore sotto':
    'l’état, avec la valeur en dessous',
  'Il grafico dell’ultima ora sotto il valore':
    'Le graphique de la dernière heure sous la valeur',
  'Nessun CI con questi tag.':
    'Aucun CI avec ces tags.',
  'Valore di un parametro':
    'Valeur d’un paramètre',
  'letto {q}':
    'lu {q}',
  'da {q}':
    'depuis {q}',
  'Scegli CI e parametro in «Titolo e opzioni».':
    'Choisissez le CI et le paramètre dans « Titre et options ».',
  'Parametro non più presente sul CI.':
    'Paramètre plus présent sur le CI.',
  'Il valore attuale di un parametro di un CI, grande e nel colore dello stato, o solo lo stato; sotto, l’ultima ora.':
    'La valeur actuelle d’un paramètre d’un CI, en grand et dans la couleur de l’état, ou seulement l’état ; en dessous, la dernière heure.',
  'Sempre nella parete dei CI, «Solo i CI con i tag» restringe le tessere ai CI che portano certi tag: «sede:milano» per quel tag, «sede» per qualunque valore, più tag separati da virgola e tutti richiesti; il conteggio e le pagine seguono il filtro. Il widget «Valore di un parametro» mostra un parametro di un CI a tua scelta grande e nel colore dello stato — o solo lo stato con il valore sotto — con le soglie e l’ultima ora; è il riquadro da mettere a parete per un numero che conta (la temperatura di una sala, il carico di un UPS, la latenza di una WAN).':
    'Toujours dans le mur des CI, « Seulement les CI avec les tags » restreint les tuiles aux CI portant certains tags : « sede:milano » pour ce tag, « sede » pour toute valeur, plusieurs tags séparés par des virgules et tous requis ; le comptage et les pages suivent le filtre. Le widget « Valeur d’un paramètre » montre un paramètre d’un CI de votre choix, en grand et dans la couleur de l’état — ou seulement l’état avec la valeur en dessous — avec les seuils et la dernière heure ; c’est l’encadré à mettre au mur pour un chiffre qui compte (la température d’une salle, la charge d’un onduleur, la latence d’un WAN).',
  'Chi è':
    'Qui c’est',
  'Dettaglio (dov’è, a cosa serve: compare sotto il nome)':
    'Détail (où il est, à quoi il sert : affiché sous le nom)',
  'es. Rianimazione, parete nord, 55 pollici':
    'ex. Réanimation, mur nord, 55 pouces',
  'Commento (note per chi se ne occupa: non arriva al monitor)':
    'Commentaire (notes pour ceux qui s’en occupent : jamais envoyé au moniteur)',
  'Commento':
    'Commentaire',
  'Dettaglio (dov’è, a cosa serve: facoltativo)':
    'Détail (où il est, à quoi il sert : facultatif)',
  'Ogni monitor ha anche un dettaglio e un commento, per le persone e non per il monitor: il dettaglio (dov’è, a cosa serve, che schermo è) sta sotto il nome nell’elenco e si può scrivere già accoppiando; il commento (chi chiamare, dov’è il PC, cosa è stato fatto) sta nelle «Impostazioni…», sezione «Chi è», dove si cambia anche il nome, e nella colonna nascosta «Commento» dell’elenco.':
    'Chaque moniteur a aussi un détail et un commentaire, pour les personnes et non pour le moniteur : le détail (où il est, à quoi il sert, quel écran c’est) figure sous le nom dans la liste et peut être saisi dès l’appairage ; le commentaire (qui appeler, où est le PC, ce qui a été fait) figure dans « Paramètres… », section « Qui c’est », où l’on change aussi le nom, et dans la colonne masquée « Commentaire » de la liste.',
  'Testata del sinottico: marchio, titolo, numeri e orologio':
    'En-tête du synoptique : marque, titre, chiffres et horloge',
  'scala {p} %':
    'échelle {p} %',
  'La griglia si disegna alla misura di quel monitor, in scala: caratteri e tessere come li vedrai a parete.':
    'La grille se dessine à la taille de ce moniteur, à l’échelle : caractères et tuiles tels que vous les verrez au mur.',
  'Schermo di riferimento':
    'Écran de référence',
  'nessuno (questa finestra)':
    'aucun (cette fenêtre)',
  'Come un monitor accoppiato':
    'Comme un moniteur appairé',
  'altro…':
    'autre…',
  'Larghezza in pixel':
    'Largeur en pixels',
  'Altezza in pixel':
    'Hauteur en pixels',
  'verticale':
    'vertical',
  'zoom del monitor':
    'zoom du moniteur',
  'disegnato per {s}':
    'conçu pour {s}',
  'il monitor mostra {s}':
    'le moniteur affiche {s}',
  '«Schermo di riferimento», nella barra di modifica, dice per quale monitor stai disegnando: uno degli schermi usuali (1024×768, Full HD, 4K…), uno dei monitor accoppiati (con la sua risoluzione, lo zoom e la rotazione), o una misura tua, anche verticale e con lo zoom del monitor. La griglia si disegna a quella misura e si rimpicciolisce per stare nella pagina, con la testata del sinottico e la riga «fine dello schermo»: caratteri e tessere sono quelli che vedrai a parete, e un 4K senza zoom mostra subito i caratteri piccoli. Il riferimento resta salvato con la dashboard, e in «Sinottici pubblicati» la riga del monitor avvisa se mostra un cruscotto disegnato per un’altra misura.':
    '« Écran de référence », dans la barre de modification, indique pour quel moniteur vous dessinez : l’un des écrans usuels (1024×768, Full HD, 4K…), l’un des moniteurs appairés (avec sa résolution, son zoom et sa rotation), ou une taille à vous, verticale aussi et avec le zoom du moniteur. La grille se dessine à cette taille et se réduit pour tenir dans la page, avec l’en-tête du synoptique et la ligne « fin de l’écran » : caractères et tuiles sont ceux que vous verrez au mur, et un 4K sans zoom montre tout de suite ses petits caractères. La référence reste enregistrée avec le tableau de bord, et dans « Synoptiques publiés » la ligne du moniteur avertit s’il affiche un tableau conçu pour une autre taille.',
  'Indirizzo del monitor':
    'Adresse du moniteur',
  'Vale da':
    'Valable depuis',
  'come il Control Plane lo vede: dietro un NAT è l’indirizzo pubblico del sito':
    'tel que le Control Plane le voit : derrière un NAT c’est l’adresse publique du site',
  'qualsiasi indirizzo, fino al prossimo battito del monitor':
    'n’importe quelle adresse, jusqu’au prochain battement du moniteur',
  'Rinnovo':
    'Renouvellement',
  'da solo, prima del {d}':
    'tout seul, avant le {d}',
  'Nessun link creato a mano.':
    'Aucun lien créé à la main.',
  'I monitor con CENSO Monitor hanno il loro link, qui sotto. «Nuovo link» serve a uno schermo senza il programma.':
    'Les moniteurs avec CENSO Monitor ont leur propre lien, ci-dessous. « Nouveau lien » sert à un écran sans le programme.',
  '{n} link tenuti dai monitor accoppiati':
    '{n} liens détenus par les moniteurs appairés',
  'Li conia e li rinnova il Control Plane, uno per monitor, e non si modificano qui: valgono solo dall’indirizzo da cui il monitor batte (lo seguono se cambia) e si rifanno da soli prima della scadenza. Per cambiarne uno usa «Link nuovo» sulla riga del monitor; per fermarlo, «Scollega».':
    'Le Control Plane les frappe et les renouvelle, un par moniteur, et ils ne se modifient pas ici : ils ne valent que depuis l’adresse d’où le moniteur bat (et la suivent si elle change) et se refont tout seuls avant l’échéance. Pour en changer un, « Nouveau lien » sur la ligne du moniteur ; pour l’arrêter, « Dissocier ».',
  'Link del sinottico':
    'Lien du synoptique',
  'mai letto':
    'jamais lu',
  'vale da {ips}':
    'valable depuis {ips}',
  'si rinnova prima del {d}':
    'renouvelé avant le {d}',
  'il sinottico non legge dal suo link da {q}: se lo schermo dice che il link non vale, «Link nuovo»':
    'le synoptique ne lit plus par son lien depuis {q} : si l’écran dit que le lien ne vaut pas, « Nouveau lien »',
  'I monitor con CENSO Monitor non hanno bisogno di questi link: il loro lo conia il Control Plane all’accoppiamento e lo rinnova da solo prima della scadenza; vale soltanto dall’indirizzo da cui il monitor batte (dietro un NAT è l’indirizzo pubblico del sito, uguale per tutti i monitor di quella sede) e lo segue se cambia. Nella scheda stanno in un elenco a parte, in sola lettura, con l’indirizzo vero del monitor accanto a quello visto dal Control Plane; per rifarne uno c’è «Link nuovo» sulla riga del monitor. Se il browser del monitor gira ma da otto minuti nessuna lettura passa dal suo link, la riga lo dice: lo schermo è probabilmente su «link non valido», e «Link nuovo» lo rimette a posto; il chiosco riprova comunque da solo ogni minuto.':
    'Les moniteurs avec CENSO Monitor n’ont pas besoin de ces liens : le leur est frappé par le Control Plane à l’appairage et renouvelé tout seul avant l’échéance ; il ne vaut que depuis l’adresse d’où le moniteur bat (derrière un NAT c’est l’adresse publique du site, la même pour tous les moniteurs de ce site) et la suit si elle change. Dans l’onglet ils figurent dans une liste à part, en lecture seule, avec la vraie adresse du moniteur à côté de celle vue par le Control Plane ; pour en refaire un, « Nouveau lien » sur la ligne du moniteur. Si le navigateur du moniteur tourne mais que depuis huit minutes aucune lecture ne passe par son lien, la ligne le dit : l’écran est probablement sur « lien non valide », et « Nouveau lien » le remet d’aplomb ; le kiosque réessaie de toute façon tout seul chaque minute.',
  'Aprire un cruscotto nuovo e vuoto? Le modifiche non salvate di questo vanno perse.':
    'Ouvrir un nouveau tableau vide ? Les modifications non enregistrées de celui-ci seront perdues.',
  'Sezione 1':
    'Section 1',
  'Un cruscotto nuovo e vuoto, da comporre dal catalogo':
    'Un nouveau tableau vide, à composer depuis le catalogue',
  'Nuovo':
    'Nouveau',
  'Eagle → Gestione cruscotti elenca tutti i cruscotti (e le dashboard della home, per chi le vede): di chi sono, sezioni e widget, chi li ha modificati, e per ognuno «Apri» nell’editor, «A parete» (proprio quella riga a tutto schermo) e nel menu «⋯» «Duplica», «Rinomina», «Condividi con il tenant» o «Rendi mia», «Elimina». Dal cruscotto, «Mostra a parete» mette a parete il cruscotto che hai davanti, dalla sezione aperta, anche se non è ancora salvato. «Nuovo», accanto a «Personalizza» (e nella barra in modifica), apre un cruscotto vuoto con una sezione sola e il catalogo già aperto: gli dai un nome e lo componi da zero, senza toccare quello che avevi davanti; esiste solo quando lo salvi. Le misure dei widget sono frazioni della riga: ¼, ⅓, ½, ⅔, ¾, riga intera, più «alto»; si trascinano per disporli. In «Come stanno le cose» c’è anche che cosa è monitorato per classe (169 switch, 760 access point…), ogni pillola del colore dello stato peggiore della classe.':
    'Eagle → Gestion des tableaux de bord liste tous les tableaux de bord (et les tableaux de l’accueil, pour qui les voit) : à qui ils sont, sections et widgets, qui les a modifiés, et pour chacun « Ouvrir » dans l’éditeur, « Au mur » (exactement cette ligne en plein écran) et dans le menu « ⋯ » « Dupliquer », « Renommer », « Partager avec le tenant » ou « Me l’attribuer », « Supprimer ». Depuis le tableau de bord, « Afficher au mur » met au mur le tableau que vous avez sous les yeux, depuis la section ouverte, même s’il n’est pas encore enregistré. « Nouveau », à côté de « Personnaliser » (et dans la barre de modification), ouvre un tableau vide avec une seule section et le catalogue déjà ouvert : vous le nommez et le composez de zéro, sans toucher à celui que vous aviez sous les yeux ; il n’existe qu’une fois enregistré. Les tailles des widgets sont des fractions de la ligne : ¼, ⅓, ½, ⅔, ¾, ligne entière, plus « haut » ; on les fait glisser pour les disposer. « Comment ça va » dit aussi ce qui est supervisé par classe (169 commutateurs, 760 points d’accès…), chaque pastille de la couleur du pire état de la classe.',
  'Un cruscotto è la pagina di Eagle con i widget che scegli, anche su una matrice libera. «A parete» mostra a tutto schermo proprio quella riga; «Condividi con il tenant» la rende quella che vedono tutti e che i monitor mostrano se non ne hanno uno assegnato. Un cruscotto nuovo si crea dal cruscotto con «Nuovo» (vuoto, da comporre) o con «Personalizza» e «Salva come mio» (una copia di quello aperto); i monitor si assegnano in «Sinottici pubblicati».':
    'Un tableau de bord est la page d’Eagle avec les widgets de votre choix, aussi sur une matrice libre. « Au mur » affiche exactement cette ligne en plein écran ; « Partager avec le tenant » en fait celui que tout le monde voit et que les écrans affichent s’ils n’en ont pas d’assigné. Un nouveau tableau se crée depuis le tableau avec « Nouveau » (vide, à composer) ou avec « Personnaliser » et « Enregistrer comme le mien » (une copie de celui ouvert) ; les moniteurs s’assignent dans « Synoptiques publiés ».',
  'Screenshot (il monitor non sa farlo)':
    'Capture d’écran (le moniteur ne sait pas)',
  'Questo monitor non dichiara la capacità «screenshot»: non ha scrot e la sua versione di CENSO Monitor non legge lo schermo dal server X. «Aggiorna CENSO Monitor» risolve: la versione corrente lo fa senza strumenti.':
    'Ce moniteur ne déclare pas la capacité « screenshot » : il n’a pas scrot et sa version de CENSO Monitor ne lit pas l’écran depuis le serveur X. « Mettre à jour CENSO Monitor » corrige : la version actuelle le fait sans outil.',
  'Da accoppiato il monitor si governa per intero da «Impostazioni…» sulla sua riga: cosa mostra, lo schermo a orario (accensione, spegnimento, giorni della settimana), il riavvio notturno del PC, la ricarica periodica del cruscotto, il fuso orario, la risoluzione dello schermo (scelta fra quelle che il monitor dichiara), la rotazione, lo zoom, la luminosità, il tema chiaro o scuro del sinottico e l’aggiornamento automatico del programma (scarica il binario nuovo dal Control Plane e lo sostituisce solo se l’impronta SHA‑256 corrisponde). Ogni monitor dichiara le sue capacità e le voci che non sa fare restano spente: su CENSO Monitor OS c’è tutto, compreso «Aggiorna il sistema». Nel menu «⋯» ci sono anche Riavvia il browser, Screenshot (l’immagine compare sotto la riga, solo l’ultima; il programma la prende con scrot se c’è, altrimenti legge lo schermo direttamente dal server X, senza pacchetti in più), Log del programma, Aggiorna CENSO Monitor, Spegni il PC e, quando ce ne sono, Annulla i comandi in attesa; la riga riporta rete (indirizzo, Wi‑Fi e segnale), sistema (versione, temperatura, acceso da quanto) e versione del programma. Gli orari seguono l’orologio del PC del monitor.':
    'Une fois appairé, le moniteur se pilote entièrement depuis « Paramètres… » sur sa ligne : ce qu’il affiche, l’écran selon un horaire (allumage, extinction, jours de la semaine), le redémarrage nocturne du PC, le rechargement périodique du tableau de bord, le fuseau horaire, la résolution de l’écran (choisie parmi celles que le moniteur déclare), la rotation, le zoom, la luminosité, le thème clair ou sombre du synoptique et la mise à jour automatique du programme (il télécharge le nouveau binaire depuis le Control Plane et ne se remplace que si l’empreinte SHA‑256 correspond). Chaque moniteur déclare ses capacités et les champs qu’il ne sait pas gérer restent grisés : sur CENSO Monitor OS tout y est, y compris « Mettre à jour le système ». Le menu « ⋯ » propose aussi Redémarrer le navigateur, Capture d’écran (l’image apparaît sous la ligne, seulement la dernière ; le programme la prend avec scrot s’il existe, sinon il lit l’écran directement depuis le serveur X, sans paquet en plus), Journal du programme, Mettre à jour CENSO Monitor, Éteindre le PC et, quand il y en a, Annuler les commandes en attente ; la ligne indique le réseau (adresse, Wi‑Fi et signal), le système (version, température, allumé depuis) et la version du programme. Les horaires suivent l’horloge du PC du moniteur.',
  'In attesa del dispositivo…':
    'En attente de l’appareil…',
  'Richiedi di nuovo':
    'Redemander',
  'Richiedi i log':
    'Demander les journaux',
  'Filtra le righe…':
    'Filtrer les lignes…',
  'Filtra le righe del log':
    'Filtrer les lignes du journal',
  'Richiesto {q}: il dispositivo risponde al prossimo contatto.':
    'Demandé {q} : l’appareil répond à son prochain contact.',
  'Richiesto {q}, nessuna risposta: il dispositivo è spento, o la sua versione non conosce la richiesta.':
    'Demandé {q}, pas de réponse : l’appareil est éteint, ou sa version ne connaît pas la demande.',
  'Ricevuto il {d} · {n} kB{t}{s}':
    'Reçu le {d} · {n} ko{t}{s}',
  'solo la coda':
    'la fin seulement',
  'Nessun log ricevuto finora.':
    'Aucun journal reçu pour l’instant.',
  '{n} righe su {m}':
    '{n} lignes sur {m}',
  'La coda del registro dell’agente, letta dalla macchina al prossimo keep-alive: si legge qui e si scarica.':
    'La fin du journal de l’agent, lue sur la machine au prochain keep-alive : lisible ici, téléchargeable.',
  'Log dell’agente «{n}»':
    'Journal de l’agent « {n} »',
  'Su richiesta: l’agente lo consegna al prossimo keep-alive, entro un minuto.':
    'Sur demande : l’agent le livre à son prochain keep-alive, en moins d’une minute.',
  'Log della sonda':
    'Journal de la sonde',
  'Su richiesta: la sonda riceve la richiesta con il prossimo heartbeat e consegna la coda del suo registro (il journal dell’unità quando può leggerlo, altrimenti le ultime righe tenute in memoria dal processo). Si legge qui, si filtra e si scarica.':
    'Sur demande : la sonde reçoit la demande avec son prochain heartbeat et livre la fin de son journal (le journal de l’unité quand elle peut le lire, sinon les dernières lignes gardées en mémoire par le processus). Lisible ici, filtrable, téléchargeable.',
  'L’agente è residente: resta acceso e si fa sentire ogni minuto, così «Ultimo contatto» dice subito se è vivo; l’inventario lo fa all’intervallo scelto in console. «Inventario adesso» lo fa raccogliere entro un minuto. «Log» chiede alla macchina la coda del registro dell’agente: arriva al prossimo keep-alive, si legge nella finestra con il filtro per riga e si scarica come file; una istantanea per agente, la richiesta seguente la sostituisce. Gli agenti installati prima diventano residenti da soli con l’aggiornamento automatico: non c’è niente da reinstallare.':
    'L’agent est résident : il reste actif et se manifeste chaque minute, donc « Dernier contact » indique tout de suite s’il est vivant ; il fait l’inventaire à l’intervalle choisi dans la console. « Inventaire maintenant » le fait collecter en moins d’une minute. « Journal » demande à la machine la fin du journal de l’agent : elle arrive au prochain keep-alive, se lit dans la fenêtre avec le filtre par ligne et se télécharge comme fichier ; un instantané par agent, la demande suivante le remplace. Les agents installés auparavant deviennent résidents tout seuls avec la mise à jour automatique : il n’y a rien à réinstaller.',
  'Nella scheda della sonda, «Log della sonda» chiede alla sonda la coda del suo registro (il journal dell’unità quando può leggerlo, altrimenti le ultime righe tenute in memoria): arriva con il prossimo heartbeat, si legge con il filtro e si scarica. Se la sonda chiede di aggiornare l’aggiornatore, il comando è nella sua scheda (Manutenzione della sonda); su una Censo Appliance, che non ha shell, si incolla nel menu dell’appliance in «CENSO probe» → «Enroll / reinstall the probe».':
    'Dans la fiche de la sonde, « Journal de la sonde » demande à la sonde la fin de son journal (le journal de l’unité quand elle peut le lire, sinon les dernières lignes gardées en mémoire) : il arrive avec le prochain heartbeat, se lit avec le filtre et se télécharge. Si la sonde demande de mettre à jour son programme de mise à jour, la commande est sur sa fiche (Maintenance de la sonde) ; sur une Censo Appliance, qui n’a pas de shell, on la colle dans le menu de l’appliance sous «CENSO probe» → «Enroll / reinstall the probe».',
  '(non privilegiato)':
    '(non privilégié)',
  'Accessi delle ultime 24 ore per ora':
    'Accès des dernières 24 heures par heure',
  'Accessi falliti (24 ore)':
    'Accès échoués (24 heures)',
  'Accessi privilegiati (24 ore)':
    'Accès privilégiés (24 heures)',
  'Accesso fallito':
    'Accès échoué',
  'Account condiviso: postazioni diverse nello stesso momento':
    'Compte partagé : postes différents au même moment',
  'Account non privilegiato: con gli utenti non privilegiati spenti si conserva senza il nome.':
    'Compte non privilégié : avec les utilisateurs non privilégiés désactivés, il est conservé sans le nom.',
  'Apparati di rete':
    'Équipements réseau',
  'Austria':
    'Autriche',
  'Azure':
    'Azure',
  'Base giuridica (obbligatoria)':
    'Base juridique (obligatoire)',
  'Belgio':
    'Belgique',
  'CENSO ACCESS':
    'CENSO ACCESS',
  'Carica altri':
    'Charger plus',
  'Catena di integrità':
    'Chaîne d’intégrité',
  'Cerca nel registro':
    'Rechercher dans le registre',
  'Chi ha accesso a quest’area':
    'Qui a accès à cette zone',
  'Chi ha consultato il registro':
    'Qui a consulté le registre',
  'Chi riceve i rilevamenti per posta (un indirizzo per riga)':
    'Qui reçoit les détections par courriel (une adresse par ligne)',
  'Chi è amministratore di che cosa, da quando, e le variazioni.':
    'Qui est administrateur de quoi, depuis quand, et les variations.',
  'Ciò che le correlazioni hanno trovato: fuori orario, forza bruta, movimento laterale, nuovi privilegi.':
    'Ce que les corrélations ont trouvé : hors horaires, force brute, mouvement latéral, nouveaux privilèges.',
  'Collegato':
    'Lié',
  'Come':
    'Comment',
  'Con l’account':
    'Avec le compte',
  'Conservazione':
    'Conservation',
  'Credenziali esplicite':
    'Identifiants explicites',
  'Cronologia (30 giorni)':
    'Chronologie (30 jours)',
  'Da dove arrivano gli eventi e come stanno le fonti.':
    'D’où viennent les événements et comment vont les sources.',
  'Dichiarata da {chi} il {quando}: «{base}»':
    'Déclarée par {chi} le {quando} : « {base} »',
  'Domain controller':
    'Contrôleur de domaine',
  'Entra ID':
    'Entra ID',
  'Eventi consegnati':
    'Événements livrés',
  'Eventi conservati':
    'Événements conservés',
  'Eventi nel registro':
    'Événements dans le registre',
  'Festività del Paese':
    'Jours fériés du pays',
  'Fonti del registro':
    'Sources du registre',
  'Fonti silenziose':
    'Sources silencieuses',
  'Forza bruta: in minuti':
    'Force brute : en minutes',
  'Forza bruta: tentativi falliti':
    'Force brute : tentatives échouées',
  'Francia':
    'France',
  'Fuori da queste fasce, nelle festività del Paese e nei giorni aggiunti, un accesso è «fuori orario». Le fasce si scrivono come 08:00-13:00, separate da virgola; un giorno vuoto è tutto fuori orario. I reperibili si segnano sulla scheda della persona.':
    'En dehors de ces plages, les jours fériés du pays et les jours ajoutés, un accès est « hors horaires ». Les plages s’écrivent 08:00-13:00, séparées par des virgules ; un jour vide est entièrement hors horaires. Les personnes d’astreinte se marquent sur la fiche de la personne.',
  'Germania':
    'Allemagne',
  'Giorni aggiunti (AAAA-MM-GG, uno per riga; con «+» davanti un giorno lavorativo, es. +2026-12-24)':
    'Jours ajoutés (AAAA-MM-JJ, un par ligne ; avec « + » devant un jour ouvré, ex. +2026-12-24)',
  'Giorni di conservazione (minimo {n})':
    'Jours de conservation (minimum {n})',
  'Gli eventi arrivano dalle fonti accese (agenti, domain controller, sonde, Entra ID). Senza la dichiarazione per gli utenti non privilegiati si registrano solo gli accessi privilegiati e i tentativi falliti.':
    'Les événements viennent des sources actives (agents, contrôleurs de domaine, sondes, Entra ID). Sans la déclaration pour les utilisateurs non privilégiés, seuls les accès privilégiés et les tentatives échouées sont enregistrés.',
  'Gli eventi più vecchi escono ogni notte, lasciando un’ancora nella catena di integrità. Sotto i sei mesi non si scende: è il minimo del Garante per gli amministratori di sistema.':
    'Les événements plus anciens sortent chaque nuit, en laissant une ancre dans la chaîne d’intégrité. On ne descend jamais sous six mois : le minimum du Garante italien pour les administrateurs système.',
  'Governa CENSO ACCESS: fonti, orari di lavoro, conservazione, rilevamenti e report del registro degli accessi; non vede il resto della CMDB.':
    'Gouverne CENSO ACCESS : sources, horaires de travail, conservation, détections et rapports du registre des accès ; ne voit pas le reste de la CMDB.',
  'Gruppi aggiunti':
    'Groupes ajoutés',
  'Gruppi e ruoli privilegiati':
    'Groupes et rôles privilégiés',
  'I report per il Garante, NIS2, DORA, PCI DSS, ISO 27001.':
    'Les rapports pour le Garante, NIS2, DORA, PCI DSS, ISO 27001.',
  'I report per quadro normativo arrivano con una delle prossime consegne di CENSO ACCESS.':
    'Les rapports par cadre réglementaire arrivent avec l’une des prochaines livraisons de CENSO ACCESS.',
  'Il registro':
    'Le registre',
  'Il registro degli accessi di amministratori e utenti, legato all’inventario: inalterabile, conservato, consultabile solo da chi ne ha il ruolo.':
    'Le registre des accès des administrateurs et des utilisateurs, lié à l’inventaire : inaltérable, conservé, consultable uniquement par ceux qui en ont le rôle.',
  'Il registro degli accessi di amministratori e utenti: inalterabile, legato all’inventario, consultabile solo da chi ne ha il ruolo.':
    'Le registre des accès des administrateurs et des utilisateurs : inaltérable, lié à l’inventaire, consultable uniquement par ceux qui en ont le rôle.',
  'Il registro: chi è entrato in quale sistema, quando, da dove, con quali privilegi.':
    'Le registre : qui est entré dans quel système, quand, d’où, avec quels privilèges.',
  'Impostazioni del registro':
    'Paramètres du registre',
  'In preparazione.':
    'En préparation.',
  'Integrità':
    'Intégrité',
  'Irlanda':
    'Irlande',
  'Italia':
    'Italie',
  'Le fonti si accendono con gli agenti aggiornati (Windows, Linux, domain controller), con la funzione syslog di una sonda per apparati di rete e Wi‑Fi, e con una credenziale Azure per Entra ID.':
    'Les sources s’activent avec les agents à jour (Windows, Linux, contrôleurs de domaine), avec la fonction syslog d’une sonde pour les équipements réseau et le Wi‑Fi, et avec un identifiant Azure pour Entra ID.',
  'Le persone compaiono con i primi eventi delle fonti e con i privilegi letti dall’inventario.':
    'Les personnes apparaissent avec les premiers événements des sources et avec les privilèges lus dans l’inventaire.',
  'Le persone dietro gli account: una riga per persona, unita fra dominio, account locali, Linux, Entra ID e apparati.':
    'Les personnes derrière les comptes : une ligne par personne, unie entre domaine, comptes locaux, Linux, Entra ID et équipements.',
  'L’integrità della catena, chi ha accesso all’area e chi ha consultato il registro.':
    'L’intégrité de la chaîne, qui a accès à la zone et qui a consulté le registre.',
  'Modifica della configurazione':
    'Modification de la configuration',
  'Modifica della politica di audit':
    'Modification de la stratégie d’audit',
  'Modifica di un account':
    'Modification d’un compte',
  'Modifica di un gruppo':
    'Modification d’un groupe',
  'Modifica di un ruolo':
    'Modification d’un rôle',
  'Modifiche di utenti e ruoli (dal registro di audit)':
    'Modifications des utilisateurs et des rôles (depuis le journal d’audit)',
  'Movimento laterale: in minuti':
    'Mouvement latéral : en minutes',
  'Movimento laterale: sistemi diversi':
    'Mouvement latéral : systèmes différents',
  'N.':
    'N°',
  'Nessun evento con questi filtri.':
    'Aucun événement avec ces filtres.',
  'Nessun evento nelle ultime 24 ore.':
    'Aucun événement dans les dernières 24 heures.',
  'Nessuna fonte ha ancora consegnato eventi.':
    'Aucune source n’a encore livré d’événements.',
  'Nessuna persona nel registro, finora.':
    'Personne dans le registre, pour l’instant.',
  'Ogni agente, domain controller, sonda e credenziale di Entra ID che consegna eventi compare qui, con l’ultima consegna e gli eventi portati. Una fonte silenziosa da più di due ore è segnalata nella panoramica: un registro con un buco non dimostra niente per quel periodo.':
    'Chaque agent, contrôleur de domaine, sonde et identifiant Entra ID qui livre des événements apparaît ici, avec la dernière livraison et les événements apportés. Une source silencieuse depuis plus de deux heures est signalée dans la vue d’ensemble : un registre avec un trou ne prouve rien pour cette période.',
  'Orario di lavoro':
    'Horaires de travail',
  'Orario di lavoro, conservazione, utenti non privilegiati, gruppi privilegiati, soglie dei rilevamenti.':
    'Horaires de travail, conservation, utilisateurs non privilégiés, groupes privilégiés, seuils des détections.',
  'Paesi Bassi':
    'Pays-Bas',
  'Password spray: account diversi':
    'Password spray : comptes différents',
  'Password spray: in minuti':
    'Password spray : en minutes',
  'Persone':
    'Personnes',
  'Persone con privilegi':
    'Personnes avec privilèges',
  'Persone e account':
    'Personnes et comptes',
  'Portogallo':
    'Portugal',
  'Primo accesso a un sistema: giorni di storia':
    'Premier accès à un système : jours d’historique',
  'Privilegi':
    'Privilèges',
  'Privilegiati fuori orario (24 ore)':
    'Privilégiés hors horaires (24 heures)',
  'Privilegiato dormiente: giorni senza accessi':
    'Privilégié dormant : jours sans accès',
  'Problema':
    'Problème',
  'Registra anche gli accessi degli utenti non privilegiati':
    'Enregistrer aussi les accès des utilisateurs non privilégiés',
  'Registro cancellato':
    'Journal effacé',
  'Registro degli accessi':
    'Registre des accès',
  'Registro dell’area':
    'Registre de la zone',
  'Regno Unito':
    'Royaume-Uni',
  'Reperibile':
    'D’astreinte',
  'Reperibile: i suoi accessi fuori orario non sono un rilevamento':
    'D’astreinte : ses accès hors horaires ne sont pas une détection',
  'Responsabile degli accessi':
    'Responsable des accès',
  'Revisore degli accessi':
    'Réviseur des accès',
  'Rilevamenti':
    'Détections',
  'Rilevamenti aperti':
    'Détections ouvertes',
  'SID di Windows':
    'SID Windows',
  'Salvato: la modifica è nel registro.':
    'Enregistré : la modification est dans le registre.',
  'Separare «{k}» in una nuova persona? Gli eventi di quell’account la seguiranno.':
    'Séparer « {k} » dans une nouvelle personne ? Les événements de ce compte la suivront.',
  'Sistemi raggiunti (30 giorni)':
    'Systèmes atteints (30 jours)',
  'Sola lettura: le impostazioni le cambia il Responsabile degli accessi.':
    'Lecture seule : les paramètres sont modifiés par le Responsable des accès.',
  'Spagna':
    'Espagne',
  'Spenti, il registro tiene gli accessi degli account privilegiati, le modifiche amministrative e i tentativi falliti di tutti; quelli degli account non privilegiati senza il nome. Accenderli significa registrare l’attività dei dipendenti: serve una base giuridica (in Italia l’accordo sindacale o l’autorizzazione dell’Ispettorato, art. 4 dello Statuto dei lavoratori), che resta scritta qui con chi l’ha dichiarata.':
    'Désactivés, le registre garde les accès des comptes privilégiés, les modifications administratives et les tentatives échouées de tous ; celles des comptes non privilégiés sans le nom. Les activer signifie enregistrer l’activité des salariés : il faut une base juridique (en Italie l’accord syndical ou l’autorisation de l’Inspection du travail, art. 4 du Statut des travailleurs), qui reste écrite ici avec qui l’a déclarée.',
  'Stati Uniti':
    'États-Unis',
  'Su che cosa':
    'Sur quoi',
  'Successo dopo fallimenti: in minuti':
    'Succès après échecs : en minutes',
  'Successo dopo fallimenti: quanti fallimenti':
    'Succès après échecs : combien d’échecs',
  'Svizzera':
    'Suisse',
  'Tipo di chiave':
    'Type de clé',
  'Tutti i suoi eventi':
    'Tous ses événements',
  'UPN':
    'UPN',
  'Ultima modifica di {chi} il {quando}':
    'Dernière modification par {chi} le {quando}',
  'Ultima verifica':
    'Dernière vérification',
  'Ultimo accesso privilegiato':
    'Dernier accès privilégié',
  'Ultimo evento':
    'Dernier événement',
  'Una riga per persona: gli account con cui compare nelle fonti (dominio, account locali, Linux, Entra ID, apparati) sono uniti dalle loro chiavi — SID, UPN, nome di dominio — e, per i nomi semplici, dal nome stesso. Un’unione sbagliata si separa dalla scheda della persona; due righe che sono la stessa persona si uniscono da lì.':
    'Une ligne par personne : les comptes avec lesquels elle apparaît dans les sources (domaine, comptes locaux, Linux, Entra ID, équipements) sont unis par leurs clés — SID, UPN, nom de domaine — et, pour les noms simples, par le nom lui-même. Une union erronée se sépare depuis la fiche de la personne ; deux lignes qui sont la même personne s’unissent depuis là.',
  'Unire questa persona a quella scelta? Account, privilegi e rilevamenti passano a lei.':
    'Unir cette personne à celle choisie ? Comptes, privilèges et détections passent à elle.',
  'Unisci a un’altra persona':
    'Unir à une autre personne',
  'Uso di privilegi':
    'Usage de privilèges',
  'Utenti non privilegiati':
    'Utilisateurs non privilégiés',
  'Variazione di un privilegio':
    'Variation d’un privilège',
  'Verifica adesso':
    'Vérifier maintenant',
  'Verifico…':
    'Vérification…',
  'Wi‑Fi':
    'Wi‑Fi',
  'account condiviso':
    'compte partagé',
  'account di dominio':
    'compte de domaine',
  'account di servizio':
    'compte de service',
  'account locale':
    'compte local',
  'account predefinito':
    'compte intégré',
  'account, sistema, indirizzo…':
    'compte, système, adresse…',
  'attività pianificata':
    'tâche planifiée',
  'conservazione':
    'conservation',
  'conservazione {n} giorni':
    'conservation {n} jours',
  'console':
    'console',
  'consulta':
    'consulte',
  'consultazioni':
    'consultations',
  'credenziali in cache':
    'identifiants en cache',
  'da Entra ID':
    'depuis Entra ID',
  'dagli eventi':
    'depuis les événements',
  'dall’inventario':
    'depuis l’inventaire',
  'desktop remoto':
    'bureau à distance',
  'di rete':
    'réseau',
  'domenica':
    'dimanche',
  'es. Accordo sindacale del 12/09/2026, art. 4 L. 300/1970':
    'ex. Accord syndical du 12/09/2026, art. 4 L. 300/1970',
  'es. GG-Server-Admin':
    'ex. GG-Server-Admin',
  'esportazione':
    'exportation',
  'fuori orario':
    'hors horaires',
  'giovedì':
    'jeudi',
  'governa':
    'gouverne',
  'idoneo':
    'éligible',
  'impostazioni':
    'paramètres',
  'in orario e fuori orario':
    'dans et hors horaires',
  'integra ({n} eventi)':
    'intègre ({n} événements)',
  'integra · {n} eventi controllati':
    'intègre · {n} événements contrôlés',
  'interattivo':
    'interactif',
  'lettura':
    'lecture',
  'lunedì':
    'lundi',
  'martedì':
    'mardi',
  'mercoledì':
    'mercredi',
  'non registrati: solo i tentativi falliti, senza il nome':
    'non enregistrés : seulement les tentatives échouées, sans le nom',
  'oggetto di Entra ID':
    'objet Entra ID',
  'persona':
    'personne',
  'persone':
    'personnes',
  'privilegi':
    'privilèges',
  'privilegiata':
    'privilégiée',
  'privilegiati e non':
    'privilégiés et non',
  'privilegiato':
    'privilégié',
  'registrati, sulla base giuridica dichiarata':
    'enregistrés, sur la base juridique déclarée',
  'reperibile':
    'd’astreinte',
  'ricerca':
    'recherche',
  'rilevamenti':
    'détections',
  'riusciti e falliti':
    'réussis et échoués',
  'rotta all’evento {seq}: {motivo}':
    'cassée à l’événement {seq} : {motivo}',
  'sabato':
    'samedi',
  'sblocco':
    'déverrouillage',
  'senza MFA':
    'sans MFA',
  'separa':
    'séparer',
  'solo chi ha privilegi':
    'seulement qui a des privilèges',
  'solo falliti':
    'échoués seulement',
  'solo fuori orario':
    'hors horaires seulement',
  'solo in orario':
    'dans les horaires seulement',
  'solo non privilegiati':
    'non privilégiés seulement',
  'solo privilegiati':
    'privilégiés seulement',
  'solo riusciti':
    'réussis seulement',
  'sonda (syslog)':
    'sonde (syslog)',
  'su {n} persone nel registro':
    'sur {n} personnes dans le registre',
  'sudo':
    'sudo',
  'togli il filtro su persona o sistema':
    'retirer le filtre sur la personne ou le système',
  'tutte le fonti':
    'toutes les sources',
  'tutto il registro':
    'tout le registre',
  'ultimi 90 giorni':
    '90 derniers jours',
  'ultimo evento {q}':
    'dernier événement {q}',
  'venerdì':
    'vendredi',
  'verifica':
    'vérifier',
  '{n} eventi rimossi fino al {seq}':
    '{n} événements supprimés jusqu’au {seq}',
  '{n} privilegi':
    '{n} privilèges',
  '{n} riusciti':
    '{n} réussis',
  'Consulta in sola lettura il registro degli accessi, ne verifica l’integrità e produce i report (DPO, auditor); non vede il resto della CMDB.':
    'Consulte en lecture seule le registre des accès, en vérifie l’intégrité et produit les rapports (DPO, auditeur) ; ne voit pas le reste de la CMDB.',
  'Accessi: il registro, dal più recente, con i filtri per periodo, privilegiati, fuori orario, esito, fonte e testo; «Carica altri» chiede la pagina dopo, «Esporta CSV» scarica gli eventi filtrati con l’impronta di ciascuno, per verificarli contro il registro.':
    'Accès : le registre, du plus récent, avec les filtres par période, privilégiés, hors horaires, résultat, source et texte ; « Charger plus » demande la page suivante, « Exporter CSV » télécharge les événements filtrés avec l’empreinte de chacun, pour les vérifier contre le registre.',
  'Chi lo apre':
    'Qui l’ouvre',
  'Fonti: agenti, domain controller, sonde e credenziali di Entra ID che consegnano eventi, con l’ultima consegna; una fonte silenziosa è un buco nel registro e la panoramica lo dice.':
    'Sources : agents, contrôleurs de domaine, sondes et identifiants Entra ID qui livrent des événements, avec la dernière livraison ; une source silencieuse est un trou dans le registre et la vue d’ensemble le signale.',
  'Il database rifiuta ogni modifica e ogni cancellazione degli eventi, tranne la conservazione e l’eliminazione del tenant. Ogni evento porta l’impronta del precedente: «Verifica adesso» ricalcola la catena e dice da quale evento, se mai, si rompe.':
    'La base de données refuse toute modification et toute suppression des événements, sauf la conservation et la suppression du tenant. Chaque événement porte l’empreinte du précédent : « Vérifier maintenant » recalcule la chaîne et indique à partir de quel événement, le cas échéant, elle casse.',
  'In «Registro dell’area» si vede chi ha un ruolo che apre l’area, le modifiche di utenti e ruoli dal registro di audit e chi ha consultato il registro: ogni lettura, ricerca, esportazione e verifica resta scritta.':
    'Dans « Registre de la zone » on voit qui a un rôle qui ouvre la zone, les modifications des utilisateurs et des rôles depuis le journal d’audit et qui a consulté le registre : chaque lecture, recherche, exportation et vérification reste écrite.',
  'Inalterabile e conservato':
    'Inaltérable et conservé',
  'La conservazione si sceglie in «Impostazioni» e non scende sotto i sei mesi, il minimo del Garante per gli amministratori di sistema. Ogni notte escono gli eventi più vecchi, lasciando un’ancora da cui la verifica riparte.':
    'La conservation se choisit dans « Paramètres » et ne descend pas sous six mois, le minimum du Garante italien pour les administrateurs système. Chaque nuit les événements les plus anciens sortent, en laissant une ancre d’où la vérification repart.',
  'Lo aprono i ruoli «Responsabile degli accessi» (fonti, orari, conservazione, rilevamenti, report) e «Revisore degli accessi» (sola lettura, verifica e report: il DPO, l’auditor), o un ruolo personalizzato che nomina l’area. Chi ha uno di questi ruoli e non vede la CMDB entra direttamente nell’area.':
    'Les rôles « Responsable des accès » (sources, horaires, conservation, détections, rapports) et « Réviseur des accès » (lecture seule, vérification et rapports : le DPO, l’auditeur) l’ouvrent, ou un rôle personnalisé qui nomme la zone. Qui a l’un de ces rôles et ne voit pas la CMDB arrive directement dans la zone.',
  'Ogni cambio delle impostazioni e delle persone (unioni, separazioni, reperibilità) è a sua volta un evento del registro, con chi l’ha fatto.':
    'Chaque changement des paramètres et des personnes (unions, séparations, astreinte) est lui-même un événement du registre, avec qui l’a fait.',
  'Panoramica: i numeri delle ultime 24 ore (accessi privilegiati, privilegiati fuori orario, falliti), i rilevamenti aperti, le persone con privilegi, le fonti silenziose; ogni numero apre l’elenco filtrato. Sotto, il grafico per ora e lo stato della catena.':
    'Vue d’ensemble : les chiffres des dernières 24 heures (accès privilégiés, privilégiés hors horaires, échoués), les détections ouvertes, les personnes avec privilèges, les sources silencieuses ; chaque chiffre ouvre la liste filtrée. En dessous, le graphique par heure et l’état de la chaîne.',
  'Per difetto si registrano gli accessi degli account privilegiati, le modifiche amministrative e i tentativi falliti; quelli degli account non privilegiati senza il nome, e senza creare una scheda per la persona. Registrare anche gli utenti significa registrare l’attività dei dipendenti: si accende solo scrivendo la base giuridica (in Italia l’accordo sindacale o l’autorizzazione dell’Ispettorato), che resta con chi l’ha dichiarata.':
    'Par défaut on enregistre les accès des comptes privilégiés, les modifications administratives et les tentatives échouées ; celles des comptes non privilégiés sans le nom, et sans créer de fiche pour la personne. Enregistrer aussi les utilisateurs signifie enregistrer l’activité des salariés : cela ne s’active qu’en écrivant la base juridique (en Italie l’accord syndical ou l’autorisation de l’Inspection du travail), qui reste avec qui l’a déclarée.',
  'Persone: una riga per persona, con gli account uniti per SID, UPN, nome di dominio o, per i nomi semplici, per nome. La scheda mostra come sono stati collegati, i sistemi raggiunti nei 30 giorni con gli accessi fuori orario e falliti, privilegi, rilevamenti e cronologia; da lì si separa un account unito per errore o si uniscono due righe che sono la stessa persona.':
    'Personnes : une ligne par personne, avec les comptes unis par SID, UPN, nom de domaine ou, pour les noms simples, par nom. La fiche montre comment ils ont été liés, les systèmes atteints en 30 jours avec les accès hors horaires et échoués, privilèges, détections et chronologie ; de là on sépare un compte uni par erreur ou on unit deux lignes qui sont la même personne.',
  'Utenti non privilegiati e fuori orario':
    'Utilisateurs non privilégiés et hors horaires',
  'il registro degli accessi di amministratori e utenti, con la licenza CENSO ACCESS. Chi è entrato in quale sistema, quando, da dove, con quali privilegi: un evento per accesso, legato al CI del sistema e alla persona, che è una sola anche quando compare con nomi diversi nel dominio, negli account locali, su Linux, in Entra ID e sugli apparati.':
    'le registre des accès des administrateurs et des utilisateurs, avec la licence CENSO ACCESS. Qui est entré dans quel système, quand, d’où, avec quels privilèges : un événement par accès, lié au CI du système et à la personne, qui est une seule même quand elle apparaît sous des noms différents dans le domaine, les comptes locaux, sur Linux, dans Entra ID et sur les équipements.',
  '«Fuori orario» vuol dire fuori dalle fasce di ogni giorno della settimana, nelle festività nazionali del Paese scelto e nei giorni aggiunti a mano (con «+» davanti, un giorno che si lavora comunque). Una persona reperibile si segna sulla sua scheda.':
    '« Hors horaires » signifie en dehors des plages de chaque jour de la semaine, les jours fériés nationaux du pays choisi et les jours ajoutés à la main (avec « + » devant, un jour travaillé quand même). Une personne d’astreinte se marque sur sa fiche.',
  'Account o gruppo':
    'Compte ou groupe',
  'Amministratori di sistema':
    'Administrateurs système',
  'Fino a':
    'Jusqu’à',
  'Gli amministratori locali arrivano dall’inventario dei sistemi (SSH, WinRM, agente) entro un’ora; i gruppi di dominio dai domain controller, i ruoli da Entra ID.':
    'Les administrateurs locaux viennent de l’inventaire des systèmes (SSH, WinRM, agent) en moins d’une heure ; les groupes de domaine des contrôleurs de domaine, les rôles d’Entra ID.',
  'Nessun amministratore, finora.':
    'Aucun administrateur, pour l’instant.',
  'Nessun privilegio letto finora.':
    'Aucun privilège lu pour l’instant.',
  'Persona':
    'Personne',
  'Privilegi per sistema':
    'Privilèges par système',
  'Sistema o ambito':
    'Système ou périmètre',
  'Sistemi':
    'Systèmes',
  'Un gruppo: i suoi membri arrivano dai domain controller.':
    'Un groupe : ses membres viennent des contrôleurs de domaine.',
  'Una riga per persona con almeno un privilegio attivo: su quanti sistemi, con quali tipi di privilegio, da quando, l’ultimo accesso privilegiato. «Dormiente» vuol dire nessun accesso privilegiato oltre la soglia delle impostazioni: un privilegio che nessuno usa è un privilegio da togliere.':
    'Une ligne par personne avec au moins un privilège actif : sur combien de systèmes, avec quels types de privilège, depuis quand, le dernier accès privilégié. « Dormant » signifie aucun accès privilégié au-delà du seuil des paramètres : un privilège que personne n’utilise est un privilège à retirer.',
  'amministratore di apparato':
    'administrateur d’équipement',
  'amministratore locale':
    'administrateur local',
  'anche quelli cessati':
    'aussi ceux terminés',
  'domain controller':
    'contrôleur de domaine',
  'dormiente':
    'dormant',
  'gruppo':
    'groupe',
  'gruppo privilegiato di dominio':
    'groupe privilégié de domaine',
  'inventario':
    'inventaire',
  'ruolo di Entra ID':
    'rôle Entra ID',
  'solo idoneo':
    'éligible seulement',
  'syslog':
    'syslog',
  'Privilegi: l’elenco degli amministratori di sistema chiesto dal Garante, una riga per persona con i sistemi che amministra, da quando e l’ultimo accesso privilegiato («dormiente» se non lo usa da troppo), e sotto i privilegi sistema per sistema. Gli amministratori locali arrivano dall’inventario ogni ora; la prima lettura di un sistema fa da base, poi ogni amministratore aggiunto o tolto è un evento del registro.':
    'Privilèges : la liste des administrateurs système demandée par le Garante, une ligne par personne avec les systèmes qu’elle administre, depuis quand et le dernier accès privilégié (« dormant » s’il n’est plus utilisé depuis trop longtemps), et en dessous les privilèges système par système. Les administrateurs locaux viennent de l’inventaire chaque heure ; la première lecture d’un système sert de base, puis chaque administrateur ajouté ou retiré est un événement du registre.',
  'journald':
    'journald',
  'registro Security':
    'journal Sécurité',
  'registro Security (domain controller)':
    'journal Sécurité (contrôleur de domaine)',
  'in coda sull’agente: {n}':
    'en file d’attente sur l’agent : {n}',
  'scartati per coda piena: {n}':
    'écartés, file pleine : {n}',
  'attiva · sospendi':
    'active · suspendre',
  'sospesa · riprendi':
    'suspendue · reprendre',
  'Gli agenti leggono gli accessi delle loro macchine (Windows, Linux, domain controller)':
    'Les agents lisent les accès de leurs machines (Windows, Linux, contrôleurs de domaine)',
  'Con gli agenti aggiornati e questa voce accesa, ogni agente legge il registro Security (Windows) o journald e auth.log (Linux) e consegna gli accessi col suo keep-alive; un domain controller anche i tentativi Kerberos e NTLM falliti e i membri dei gruppi privilegiati di dominio. Una singola fonte si sospende dalla vista Fonti.':
    'Avec des agents à jour et cette option activée, chaque agent lit le journal Sécurité (Windows) ou journald et auth.log (Linux) et livre les accès avec son keep-alive ; un contrôleur de domaine aussi les tentatives Kerberos et NTLM échouées et les membres des groupes privilégiés du domaine. Une source isolée se suspend depuis la vue Sources.',
  'Gli accessi dagli agenti':
    'Les accès depuis les agents',
  'Con la licenza e gli agenti aggiornati, ogni agente residente legge gli accessi della sua macchina e li consegna col keep-alive, sullo stesso canale sigillato dell’inventario (anche attraverso una sonda). Si spegne per tutti in «Impostazioni», per un solo agente sospendendo la sua fonte in «Fonti».':
    'Avec la licence et des agents à jour, chaque agent résident lit les accès de sa machine et les livre avec le keep-alive, sur le même canal scellé que l’inventaire (aussi à travers une sonde). On l’éteint pour tous dans « Paramètres », pour un seul agent en suspendant sa source dans « Sources ».',
  'Windows: dal registro Security gli accessi interattivi, da desktop remoto e quelli con privilegi speciali, l’uso di credenziali esplicite, gli accessi falliti, la gestione di account e gruppi, il registro cancellato e la politica di audit cambiata. Gli accessi di servizio, quelli delle macchine e, con gli utenti spenti, gli accessi di rete non privilegiati restano sulla macchina.':
    'Windows : depuis le journal Sécurité les ouvertures de session interactives, Bureau à distance et avec privilèges spéciaux, l’usage d’identifiants explicites, les échecs, la gestion des comptes et des groupes, le journal effacé et la stratégie d’audit modifiée. Les sessions de service, les comptes machine et, utilisateurs éteints, les sessions réseau non privilégiées restent sur la machine.',
  'Domain controller: in più i tentativi Kerberos e NTLM falliti, i ticket degli account privilegiati noti e, ogni ora, i membri dei gruppi privilegiati di dominio (Domain Admins, Enterprise Admins, Schema Admins, Administrators e gli operatori), riconosciuti dal SID e quindi in qualunque lingua. Ogni membro aggiunto o tolto è un evento del registro.':
    'Contrôleur de domaine : en plus les tentatives Kerberos et NTLM échouées, les tickets des comptes privilégiés connus et, chaque heure, les membres des groupes privilégiés du domaine (Domain Admins, Enterprise Admins, Schema Admins, Administrators et les opérateurs), reconnus par leur SID et donc dans n’importe quelle langue. Chaque membre ajouté ou retiré est un événement du registre.',
  'Linux: da journald, o da auth.log e secure dove journald non c’è, gli accessi SSH riusciti e falliti, sudo, su e gli accessi da console. Di sudo si registra l’utente di destinazione, mai il comando.':
    'Linux : depuis journald, ou depuis auth.log et secure là où journald manque, les connexions SSH réussies et échouées, sudo, su et les connexions console. De sudo on enregistre l’utilisateur cible, jamais la commande.',
  'Un evento esce dalla coda dell’agente solo quando il Control Plane lo ha scritto nel registro: con il Control Plane irraggiungibile o un errore, gli eventi aspettano sull’agente e ripartono dal punto in cui erano anche dopo un riavvio.':
    'Un événement ne quitte la file de l’agent qu’une fois écrit dans le registre par le Control Plane : Control Plane injoignable ou en erreur, les événements attendent sur l’agent et reprennent là où ils en étaient, même après un redémarrage.',
  'Gli amministratori del tenant e della piattaforma, con lettura e scrittura. Un ruolo personalizzato che vede «tutto», un operatore o un lettore senza ruolo personalizzato non la aprono: l’area va concessa per nome.':
    'Les administrateurs du tenant et de la plateforme, en lecture et écriture. Un rôle personnalisé qui voit « tout », un opérateur ou un lecteur sans rôle personnalisé ne l’ouvrent pas : la zone doit être accordée par son nom.',
  'Amministratore del tenant':
    'Administrateur du tenant',
  'Sigilli':
    'Sceaux',
  'Ogni ora la testa della catena è firmata con la chiave del tenant, che non sta nel database: chi avesse solo il database e riscrivesse eventi e impronte non potrebbe rifare la firma, e «Verifica adesso» lo direbbe. Una volta al giorno, se è impostata una TSA, il sigillo riceve la marca temporale RFC 3161: una data certa data da terzi.':
    'Chaque heure, la tête de la chaîne est signée avec la clé du tenant, qui n’est pas dans la base de données : qui n’aurait que la base et réécrirait événements et empreintes ne pourrait pas refaire la signature, et « Vérifier maintenant » le dirait. Une fois par jour, si une TSA est configurée, le sceau reçoit un horodatage RFC 3161 : une date certaine donnée par un tiers.',
  'Chiave del tenant':
    'Clé du tenant',
  'versione {n}':
    'version {n}',
  'Chiave pubblica':
    'Clé publique',
  'Ultimo sigillo':
    'Dernier sceau',
  'fino all’evento {seq}':
    'jusqu’à l’événement {seq}',
  'Marca temporale':
    'Horodatage',
  'nessuna TSA impostata (Impostazioni)':
    'aucune TSA configurée (Paramètres)',
  'alla prossima occasione':
    'à la prochaine occasion',
  'Sigilla adesso':
    'Sceller maintenant',
  'Esporta i sigilli':
    'Exporter les sceaux',
  'I sigilli già fatti restano verificabili con la loro versione; da adesso si firma con la nuova.':
    'Les sceaux déjà faits restent vérifiables avec leur version ; désormais la nouvelle signe.',
  'sigilli':
    'sceaux',
  'Fino all’evento':
    'Jusqu’à l’événement',
  'non ottenuta':
    'non obtenu',
  'Copia sulla sonda d’archivio':
    'Copie sur la sonde d’archive',
  'Ogni giorno la parte nuova del registro va alla sonda d’archivio del tenant come segmento firmato: la sonda controlla firma e impronta, lo conserva in sola lettura (immutabile dove il file system lo permette) fino alla fine della conservazione, e ogni giorno lo rilegge. Un registro cancellato o riscritto nel Control Plane resta lì, e la rilettura lo dice.':
    'Chaque jour, la nouvelle partie du registre part vers la sonde d’archive du tenant sous forme de segment signé : la sonde vérifie signature et empreinte, le conserve en lecture seule (immuable là où le système de fichiers le permet) jusqu’à la fin de la conservation, et le relit chaque jour. Un registre supprimé ou réécrit dans le Control Plane reste là, et la relecture le dit.',
  'Nessuna sonda d’archivio.':
    'Aucune sonde d’archive.',
  'Si sceglie in Impostazioni → Copia d’archivio, fra le sonde del tenant.':
    'Elle se choisit dans Paramètres → Copie d’archive, parmi les sondes du tenant.',
  'Segmenti conservati':
    'Segments conservés',
  'Ultima rilettura':
    'Dernière relecture',
  '{n} segmenti con problemi':
    '{n} segments avec problèmes',
  '{n} segmenti non presi dalla sonda prima della fine della conservazione':
    '{n} segments non récupérés par la sonde avant la fin de la conservation',
  'segmenti':
    'segments',
  'Tagliato':
    'Découpé',
  'Sulla sonda':
    'Sur la sonde',
  'perso':
    'perdu',
  'Rilettura':
    'Relecture',
  'integro':
    'intact',
  'problema':
    'problème',
  'Facoltativa. Una volta al giorno il sigillo del registro riceve una marca temporale RFC 3161 dall’autorità indicata qui: una data certa data da terzi. Per l’opponibilità in Italia serve una TSA qualificata eIDAS (Aruba, InfoCert, Namirial…), con le sue credenziali; per provare basta un servizio pubblico come https://freetsa.org/tsr. La chiamata parte dal Control Plane.':
    'Facultatif. Une fois par jour, le sceau du registre reçoit un horodatage RFC 3161 de l’autorité indiquée ici : une date certaine donnée par un tiers. Pour l’opposabilité, il faut une TSA qualifiée eIDAS (Aruba, InfoCert, Namirial…), avec ses identifiants ; pour essayer, un service public comme https://freetsa.org/tsr suffit. L’appel part du Control Plane.',
  'Indirizzo della TSA':
    'Adresse de la TSA',
  'Utente (se la TSA lo chiede)':
    'Utilisateur (si la TSA le demande)',
  'Password (impostata: scrivi per cambiarla)':
    'Mot de passe (défini : saisissez pour le changer)',
  'Prova la TSA (impostazioni salvate)':
    'Essayer la TSA (paramètres enregistrés)',
  'Marca ottenuta: {quando}, numero {serie}, firmata da {chi}{verificata}':
    'Horodatage obtenu : {quando}, numéro {serie}, signé par {chi}{verificata}',
  ' (firma da verificare con openssl)':
    ' (signature à vérifier avec openssl)',
  'Copia d’archivio':
    'Copie d’archive',
  'Una sonda del tenant tiene una copia del registro: ogni giorno riceve la parte nuova firmata con la chiave del tenant, la controlla, la conserva in sola lettura (immutabile dove il file system lo permette) fino alla fine della conservazione e la rilegge. È un testimone che il database del Control Plane non controlla. Meglio una sonda dedicata, in un luogo diverso dal Control Plane.':
    'Une sonde du tenant garde une copie du registre : chaque jour elle reçoit la nouvelle partie signée avec la clé du tenant, la vérifie, la conserve en lecture seule (immuable là où le système de fichiers le permet) jusqu’à la fin de la conservation et la relit. C’est un témoin que la base de données du Control Plane ne contrôle pas. Mieux vaut une sonde dédiée, dans un lieu différent du Control Plane.',
  'Sonda d’archivio':
    'Sonde d’archive',
  '{n} sigilli validi, {m} con marca temporale':
    '{n} sceaux valides, {m} horodatés',
  'Ogni evento porta l’impronta SHA-256 del precedente: togliere, cambiare o inserire un evento rompe la catena da quel punto in poi. Il database rifiuta modifiche, svuotamenti e cancellazioni prima della fine della conservazione. La verifica ricalcola tutta la catena, controlla i sigilli e chiede alla sonda d’archivio di rileggere la sua copia.':
    'Chaque événement porte l’empreinte SHA-256 du précédent : retirer, modifier ou insérer un événement rompt la chaîne à partir de ce point. La base de données refuse modifications, vidages et suppressions avant la fin de la conservation. La vérification recalcule toute la chaîne, contrôle les sceaux et demande à la sonde d’archive de relire sa copie.',
  'Il registro lo aprono gli amministratori del tenant e della piattaforma e i ruoli che lo nominano; un ruolo che vede «tutto» no. Chi gestisce gli utenti può assegnarsi uno di questi ruoli: per questo l’elenco e le modifiche dei ruoli sono qui, sotto gli occhi del revisore.':
    'Le registre est ouvert par les administrateurs du tenant et de la plateforme et par les rôles qui le nomment ; un rôle qui voit « tout » non. Qui gère les utilisateurs peut s’attribuer un de ces rôles : c’est pourquoi la liste et les changements de rôles sont ici, sous les yeux du réviseur.',
  'Sigilli: ogni ora la testa della catena è firmata con la chiave del tenant, che non sta nel database. Chi riscrivesse eventi e impronte direttamente nel database non potrebbe rifare la firma, e la verifica lo direbbe; così anche per un sigillo falso o mancante. In «Registro dell’area» ci sono l’impronta della chiave, «Sigilla adesso», «Ruota la chiave» ed «Esporta i sigilli» per verificarli fuori da CENSO.':
    'Sceaux : chaque heure la tête de la chaîne est signée avec la clé du tenant, qui n’est pas dans la base de données. Qui réécrirait événements et empreintes directement dans la base ne pourrait pas refaire la signature, et la vérification le dirait ; de même pour un sceau faux ou manquant. « Registre de la zone » montre l’empreinte de la clé, « Sceller maintenant », « Faire tourner la clé » et « Exporter les sceaux » pour les vérifier hors de CENSO.',
  'Marca temporale (facoltativa): con l’indirizzo di una TSA in «Impostazioni», una volta al giorno il sigillo riceve una marca RFC 3161, una data certa data da terzi. Per l’opponibilità in Italia va scelta una TSA qualificata eIDAS; «Prova la TSA» verifica le impostazioni.':
    'Horodatage (facultatif) : avec l’adresse d’une TSA dans « Paramètres », une fois par jour le sceau reçoit un horodatage RFC 3161, une date certaine donnée par un tiers. Pour l’opposabilité, choisissez une TSA qualifiée eIDAS ; « Essayer la TSA » vérifie les paramètres.',
  'Copia d’archivio (facoltativa): una sonda del tenant, meglio dedicata e lontana dal Control Plane, riceve ogni giorno la parte nuova del registro firmata, la conserva in sola lettura e immutabile fino alla fine della conservazione e la rilegge ogni giorno e a ogni «Verifica adesso». Un registro cancellato nel Control Plane resta sulla sonda.':
    'Copie d’archive (facultative) : une sonde du tenant, de préférence dédiée et loin du Control Plane, reçoit chaque jour la nouvelle partie du registre signée, la conserve en lecture seule et immuable jusqu’à la fin de la conservation et la relit chaque jour et à chaque « Vérifier maintenant ». Un registre supprimé dans le Control Plane reste sur la sonde.',
  'Nell’installazione, con la password del ruolo applicativo del database (CENSO_DB_APP_PASSWORD) il Control Plane non è più proprietario delle tabelle del registro: nemmeno chi lo controllasse potrebbe modificarle o spegnerne la protezione.':
    'Dans l’installation, avec le mot de passe du rôle applicatif de la base (CENSO_DB_APP_PASSWORD), le Control Plane n’est plus propriétaire des tables du registre : même qui le contrôlerait ne pourrait ni les modifier ni en désactiver la protection.',
  'CENSO li riconosce da solo: i gruppi privilegiati per difetto (riconosciuti dal SID, in ogni lingua), i gruppi di dominio che trova fra gli amministratori locali delle macchine, i gruppi annidati in un gruppo privilegiato e, su Linux, i gruppi che sudoers abilita a tutto. I loro membri li legge l’agente del domain controller. Qui sotto si aggiungono solo quelli che CENSO non può vedere: uno per riga, senza il dominio.':
    'CENSO les reconnaît seul : les groupes privilégiés par défaut (reconnus par leur SID, dans toutes les langues), les groupes de domaine trouvés parmi les administrateurs locaux des machines, les groupes imbriqués dans un groupe privilégié et, sous Linux, les groupes que sudoers autorise à tout. Leurs membres sont lus par l’agent du contrôleur de domaine. Ci-dessous, n’ajoutez que ceux que CENSO ne peut pas voir : un par ligne, sans le domaine.',
  'dentro {gruppo}':
    'dans {gruppo}',
  'Membri':
    'Membres',
  'Nessun domain controller l’ha ancora descritto: serve l’agente aggiornato su un domain controller.':
    'Aucun contrôleur de domaine ne l’a encore décrit : il faut l’agent à jour sur un contrôleur de domaine.',
  'da leggere':
    'à lire',
  'Amministra':
    'Administre',
  '{n} sistemi':
    '{n} systèmes',
  'per difetto (dal SID)':
    'par défaut (par le SID)',
  'aggiunto qui':
    'ajouté ici',
  'fra gli amministratori locali':
    'parmi les administrateurs locaux',
  'annidato':
    'imbriqué',
  'attraverso: {gruppi}':
    'via : {gruppi}',
  '{n} tramite gruppo':
    '{n} via un groupe',
  'I gruppi privilegiati li riconosce CENSO: quelli per difetto dal SID, i gruppi di dominio trovati fra gli amministratori locali delle macchine (il domain controller dice che sono gruppi e ne legge i membri), i gruppi annidati in un gruppo privilegiato, e su Linux i gruppi e gli utenti che sudoers abilita a tutto. Chi è in un gruppo che amministra una macchina risulta amministratore di quella macchina; «Impostazioni» mostra l’elenco dei gruppi riconosciuti e come.':
    'CENSO reconnaît les groupes privilégiés : ceux par défaut par leur SID, les groupes de domaine trouvés parmi les administrateurs locaux des machines (le contrôleur de domaine dit que ce sont des groupes et lit leurs membres), les groupes imbriqués dans un groupe privilégié, et sous Linux les groupes et utilisateurs que sudoers autorise à tout. Qui est dans un groupe qui administre une machine est administrateur de cette machine ; « Paramètres » liste les groupes reconnus et comment.',
  'Accesso privilegiato fuori orario':
    'Accès privilégié hors horaires',
  'Forza bruta':
    'Force brute',
  'Password spray':
    'Password spray',
  'Accesso riuscito dopo una serie di fallimenti':
    'Accès réussi après une série d’échecs',
  'Movimento laterale':
    'Mouvement latéral',
  'Account condiviso':
    'Compte partagé',
  'Primo accesso a un sistema':
    'Premier accès à un système',
  'Account privilegiato dormiente di nuovo in uso':
    'Compte privilégié dormant à nouveau utilisé',
  'Account privilegiato dormiente':
    'Compte privilégié dormant',
  'Accesso da un Paese nuovo':
    'Accès depuis un nouveau pays',
  'Accesso amministrativo senza MFA':
    'Accès administratif sans MFA',
  'Nuovo privilegio':
    'Nouveau privilège',
  'Account creato e reso privilegiato':
    'Compte créé et rendu privilégié',
  'Registro di sicurezza cancellato':
    'Journal de sécurité effacé',
  'Politica di audit modificata':
    'Stratégie d’audit modifiée',
  'Tentativi su un account disabilitato':
    'Tentatives sur un compte désactivé',
  'preso in carico':
    'pris en charge',
  'Rilevamento':
    'Détection',
  '{n} eventi':
    '{n} événements',
  'Nota (resta nel registro)':
    'Note (reste dans le registre)',
  'Prendi in carico':
    'Prendre en charge',
  'Chiudi il rilevamento':
    'Clore la détection',
  'Riapri':
    'Rouvrir',
  'Gli eventi':
    'Les événements',
  'Nessun evento: è proprio l’assenza di accessi a contare.':
    'Aucun événement : c’est justement l’absence d’accès qui compte.',
  'Gli eventi sono usciti dalla conservazione.':
    'Les événements sont sortis de la conservation.',
  '{n} eventi non ci sono più: usciti dalla conservazione.':
    '{n} événements ne sont plus là : sortis de la conservation.',
  'Le correlazioni leggono il registro in ordine e confrontano ogni evento con quelli appena prima e con la storia dello stesso account, con le soglie delle Impostazioni. Un rilevamento è uno per regola e soggetto (l’account, il giorno): cresce finché il fatto continua e si riapre se torna dopo essere stato chiuso. I nuovi, di gravità media o più, vanno per posta ai destinatari delle Impostazioni.':
    'Les corrélations lisent le registre dans l’ordre et comparent chaque événement à ceux juste avant et à l’historique du même compte, avec les seuils des Paramètres. Une détection est unique par règle et sujet (le compte, le jour) : elle grandit tant que le fait continue et se rouvre s’il revient après avoir été close. Les nouvelles, de gravité moyenne ou plus, partent par courriel aux destinataires des Paramètres.',
  'di una persona':
    'd’une personne',
  'togli il filtro':
    'retirer le filtre',
  'Nessun rilevamento aperto.':
    'Aucune détection ouverte.',
  'Nessun rilevamento.':
    'Aucune détection.',
  'Le correlazioni girano da sole sugli eventi che arrivano dalle fonti.':
    'Les corrélations tournent seules sur les événements qui arrivent des sources.',
  'Rilevamenti: ciò che le correlazioni trovano da sole sul registro — accesso privilegiato fuori orario, forza bruta, password spray, accesso riuscito dopo una serie di fallimenti, movimento laterale, account condiviso, primo accesso a un sistema, account privilegiati dormienti o di nuovo in uso, Paese nuovo, accesso amministrativo senza MFA, nuovi privilegi, account creato e reso privilegiato, registro cancellato, politica di audit modificata, tentativi su account disabilitati. Ognuno si apre con gli eventi che lo provano, si prende in carico o si chiude con una nota (che resta nel registro) e si riapre da solo se il fatto torna. I nuovi di gravità media o più arrivano per posta ai destinatari delle Impostazioni, e solo a loro.':
    'Détections : ce que les corrélations trouvent seules dans le registre — accès privilégié hors horaires, force brute, password spray, accès réussi après une série d’échecs, mouvement latéral, compte partagé, premier accès à un système, comptes privilégiés dormants ou à nouveau utilisés, nouveau pays, accès administratif sans MFA, nouveaux privilèges, compte créé et rendu privilégié, journal effacé, stratégie d’audit modifiée, tentatives sur des comptes désactivés. Chacune s’ouvre avec les événements qui la prouvent, se prend en charge ou se clôt avec une note (qui reste dans le registre) et se rouvre seule si le fait revient. Les nouvelles de gravité moyenne ou plus arrivent par courriel aux destinataires des Paramètres, et à eux seuls.',
  'Con gli utenti non privilegiati spenti, un tentativo fallito non ha il nome ma uno pseudonimo che CENSO calcola con un segreto fuori dal database: la forza bruta su un account e il password spray su molti si vedono lo stesso, senza nominare nessuno.':
    'Avec les utilisateurs non privilégiés éteints, une tentative échouée n’a pas de nom mais un pseudonyme que CENSO calcule avec un secret hors de la base : la force brute sur un compte et le password spray sur plusieurs se voient quand même, sans nommer personne.',
  'abilitata':
    'activé',
  'cancellata':
    'supprimé',
  'modificata':
    'modifié',
  'password reimpostata':
    'mot de passe réinitialisé',
  'password cambiata dal titolare':
    'mot de passe changé par son titulaire',
  'bloccata per tentativi':
    'verrouillé après des tentatives',
  'sbloccata':
    'déverrouillé',
  'aggiunta a un gruppo':
    'ajouté à un groupe',
  'tolta da un gruppo':
    'retiré d’un groupe',
  'gruppo creato':
    'groupe créé',
  'gruppo cancellato':
    'groupe supprimé',
  'privilegio concesso':
    'privilège accordé',
  'privilegio tolto':
    'privilège retiré',
  'Gestione utenze':
    'Gestion des comptes',
  'Chi ha creato, modificato, abilitato, disabilitato, sbloccato o cancellato un’utenza, chi ha reimpostato una password, chi ha aggiunto o tolto qualcuno da un gruppo e chi ha concesso o tolto un privilegio: su Windows e sui domain controller dal registro Security, su Linux da useradd, usermod, userdel, passwd e gpasswd con l’utente del login originale anche dietro sudo, e dall’inventario. Chi l’ha fatto è sempre registrato, anche con gli utenti non privilegiati spenti: gestire le utenze è un atto da amministratore.':
    'Qui a créé, modifié, activé, désactivé, déverrouillé ou supprimé un compte, qui a réinitialisé un mot de passe, qui a ajouté ou retiré quelqu’un d’un groupe et qui a accordé ou retiré un privilège : sous Windows et sur les contrôleurs de domaine depuis le journal Sécurité, sous Linux depuis useradd, usermod, userdel, passwd et gpasswd avec l’utilisateur de la connexion d’origine même derrière sudo, et depuis l’inventaire. Qui l’a fait est toujours enregistré, même avec les utilisateurs non privilégiés éteints : gérer les comptes est un acte d’administrateur.',
  'utenza, gruppo, chi l’ha fatto, sistema…':
    'compte, groupe, qui l’a fait, système…',
  'Nessuna modifica di utenze nel periodo.':
    'Aucune modification de compte sur la période.',
  'Le modifiche arrivano dagli agenti (Windows, Linux, domain controller) e dall’inventario.':
    'Les modifications viennent des agents (Windows, Linux, contrôleurs de domaine) et de l’inventaire.',
  'Chi l’ha fatto':
    'Qui l’a fait',
  'CENSO (inventario)':
    'CENSO (inventaire)',
  'rilevato da CENSO':
    'détecté par CENSO',
  'Utenza':
    'Compte',
  'Gruppo o ambito':
    'Groupe ou périmètre',
  'Lo stato lo dice il sistema dell’account: il domain controller per il dominio, la macchina per gli account locali (agente aggiornato).':
    'L’état vient du système du compte : le contrôleur de domaine pour le domaine, la machine pour les comptes locaux (agent à jour).',
  'Ultimo accesso':
    'Dernière connexion',
  'Password che non scade':
    'Mot de passe qui n’expire pas',
  'scade':
    'expire',
  'Ultimo cambio password':
    'Dernier changement de mot de passe',
  'IP del sistema':
    'IP du système',
  'Chi crea, modifica, abilita, disabilita e cancella le utenze, chi cambia le password e i gruppi.':
    'Qui crée, modifie, active, désactive et supprime les comptes, qui change les mots de passe et les groupes.',
  'Gestione utenze: chi ha creato, modificato, abilitato, disabilitato, sbloccato o cancellato un’utenza, chi ha reimpostato una password, chi ha messo o tolto qualcuno da un gruppo e chi ha concesso o tolto un privilegio, con quando e dove; si cerca per utenza, gruppo o autore. Su Linux chi l’ha fatto è l’utente del login originale, anche dietro sudo.':
    'Gestion des comptes : qui a créé, modifié, activé, désactivé, déverrouillé ou supprimé un compte, qui a réinitialisé un mot de passe, qui a mis ou retiré quelqu’un d’un groupe et qui a accordé ou retiré un privilège, avec quand et où ; on cherche par compte, groupe ou auteur. Sous Linux, l’auteur est l’utilisateur de la connexion d’origine, même derrière sudo.',
  'Persone e Privilegi mostrano anche lo stato degli account come lo dice il loro sistema: attivo o disattivato (o bloccato), ultimo accesso, password che non scade, ultimo cambio della password. Per gli account di dominio lo legge il domain controller, per quelli locali ogni macchina.':
    'Personnes et Privilèges montrent aussi l’état des comptes tel que leur système le dit : actif ou désactivé (ou verrouillé), dernière connexion, mot de passe qui n’expire pas, dernier changement du mot de passe. Le contrôleur de domaine le lit pour les comptes de domaine, chaque machine pour ses comptes locaux.',
  'Entra ID e Azure:':
    'Entra ID et Azure :',
  'serve una credenziale Microsoft Azure (Credenziali), con i permessi descritti nella sua guida':
    'il faut un identifiant Microsoft Azure (Identifiants), avec les autorisations décrites dans son guide',
  'tutte le credenziali Azure sono già fonti':
    'tous les identifiants Azure sont déjà des sources',
  'scegli la credenziale Azure':
    'choisir l’identifiant Azure',
  'Aggiungi Entra ID':
    'Ajouter Entra ID',
  'Microsoft Graph':
    'Microsoft Graph',
  'Microsoft Graph e activity log di Azure':
    'Microsoft Graph et journal d’activité Azure',
  'Entra ID e Azure: in «Fonti» si aggiunge una credenziale Microsoft Azure (con i permessi della sua guida, sezione C). Ogni cinque minuti CENSO legge gli accessi di Entra ID (con P1 o P2: app, IP, Paese, MFA, esito), l’audit della directory (utenti creati, disabilitati, password reimpostate, membri di gruppi e ruoli), i ruoli di amministrazione con quelli idonei di PIM e lo stato di quegli account, e l’activity log della sottoscrizione (assegnazioni di ruolo di Azure). Un account sincronizzato da Active Directory si unisce alla stessa persona.':
    'Entra ID et Azure : dans « Sources », ajoutez un identifiant Microsoft Azure (avec les autorisations de son guide, section C). Toutes les cinq minutes CENSO lit les connexions d’Entra ID (avec P1 ou P2 : application, IP, pays, MFA, résultat), l’audit de l’annuaire (utilisateurs créés, désactivés, mots de passe réinitialisés, membres de groupes et de rôles), les rôles d’administration avec ceux éligibles de PIM et l’état de ces comptes, et le journal d’activité de l’abonnement (attributions de rôles Azure). Un compte synchronisé depuis Active Directory rejoint la même personne.',
  'C) Per CENSO ACCESS (accessi, audit e ruoli di Entra ID)':
    'C) Pour CENSO ACCESS (connexions, audit et rôles d’Entra ID)',
  'Autorizzazioni API → Aggiungi → Microsoft Graph → Autorizzazioni dell’applicazione: «AuditLog.Read.All», «Directory.Read.All» e, per i ruoli idonei di PIM, «RoleManagement.Read.Directory»; poi «Concedi il consenso amministratore».':
    'Autorisations d’API → Ajouter → Microsoft Graph → Autorisations d’application : « AuditLog.Read.All », « Directory.Read.All » et, pour les rôles éligibles de PIM, « RoleManagement.Read.Directory » ; puis « Accorder le consentement administrateur ».',
  'Gli accessi (sign-in) di Entra ID si leggono solo con una licenza Entra ID P1 o P2 nel tenant: senza, CENSO legge comunque audit della directory, ruoli e activity log, e la fonte lo dice.':
    'Les connexions d’Entra ID ne se lisent qu’avec une licence Entra ID P1 ou P2 dans le tenant : sans, CENSO lit quand même l’audit de l’annuaire, les rôles et le journal d’activité, et la source le dit.',
  'L’activity log della sottoscrizione (assegnazioni di ruolo di Azure) usa lo stesso ruolo «Reader» della sezione B.':
    'Le journal d’activité de l’abonnement (attributions de rôles Azure) utilise le même rôle « Reader » que la section B.',
  'In CENSO ACCESS → Fonti, «Aggiungi Entra ID» con questa credenziale: la lettura parte da sola ogni cinque minuti.':
    'Dans CENSO ACCESS → Sources, « Ajouter Entra ID » avec cet identifiant : la lecture démarre seule toutes les cinq minutes.',
  'Syslog delle sonde':
    'Syslog des sondes',
  'Una sonda con la funzione «Syslog per CENSO ACCESS» riceve il syslog di apparati di rete, firewall, controller Wi‑Fi e server RADIUS e ne conserva tutto il grezzo, in segmenti orari compressi, in sola lettura e immutabili, con l’impronta registrata qui e riletta ogni giorno. Al registro arrivano solo gli accessi riconosciuti (Cisco, Huawei, FortiGate, Palo Alto, Juniper, Aruba, WatchGuard, FreeRADIUS, Cisco ISE). Il resto si cerca qui: la sonda guarda nei suoi segmenti e manda solo le righe trovate.':
    'Une sonde avec la fonction « Syslog pour CENSO ACCESS » reçoit le syslog des équipements réseau, pare-feu, contrôleurs Wi‑Fi et serveurs RADIUS et en conserve tout le brut, en segments horaires compressés, en lecture seule et immuables, avec l’empreinte enregistrée ici et relue chaque jour. Seuls les accès reconnus arrivent au registre (Cisco, Huawei, FortiGate, Palo Alto, Juniper, Aruba, WatchGuard, FreeRADIUS, Cisco ISE). Le reste se cherche ici : la sonde regarde dans ses segments et n’envoie que les lignes trouvées.',
  'Nessuna sonda riceve il syslog.':
    'Aucune sonde ne reçoit le syslog.',
  'Si abilita la funzione «Syslog per CENSO ACCESS» nella scheda della sonda, poi si puntano gli apparati alla sonda (porta 514, UDP o TCP).':
    'Activez la fonction « Syslog pour CENSO ACCESS » sur la fiche de la sonde, puis pointez les équipements vers la sonde (port 514, UDP ou TCP).',
  'Ricezione':
    'Réception',
  '{n} scartate':
    '{n} écartées',
  'Grezzo conservato':
    'Brut conservé',
  '{n} segmenti':
    '{n} segments',
  'Cerca nel grezzo':
    'Chercher dans le brut',
  'es. admin, LOGIN_FAILED, 203.0.113.9':
    'ex. admin, LOGIN_FAILED, 203.0.113.9',
  'Apparato (indirizzo)':
    'Équipement (adresse)',
  'La sonda sta cercando: risponde al prossimo contatto (entro un minuto).':
    'La sonde cherche : elle répond au prochain contact (en moins d’une minute).',
  'La sonda non ha risposto entro mezz’ora: è online?':
    'La sonde n’a pas répondu en une demi-heure : est-elle en ligne ?',
  'Nessuna riga trovata.':
    'Aucune ligne trouvée.',
  'Mostrate le prime righe: restringi il periodo o il testo per vederle tutte.':
    'Premières lignes affichées : réduisez la période ou le texte pour toutes les voir.',
  'Le sonde con la funzione «Syslog per CENSO ACCESS» ricevono il syslog degli apparati':
    'Les sondes avec la fonction « Syslog pour CENSO ACCESS » reçoivent le syslog des équipements',
  'Porta syslog (UDP e TCP)':
    'Port syslog (UDP et TCP)',
  'Apparati ammessi (indirizzi o reti, uno per riga; vuoto = tutti)':
    'Équipements admis (adresses ou réseaux, un par ligne ; vide = tous)',
  'Syslog per CENSO ACCESS':
    'Syslog pour CENSO ACCESS',
  'La sonda riceve il syslog degli apparati di rete, dei firewall, dei controller Wi‑Fi e dei server RADIUS (UDP e TCP, porta 514), conserva tutto il grezzo in segmenti compressi e immutabili con l’impronta registrata nel Control Plane, e manda al registro degli accessi solo gli accessi che riconosce. Apre una porta in ascolto. Richiede CENSO ACCESS.':
    'La sonde reçoit le syslog des équipements réseau, des pare-feu, des contrôleurs Wi‑Fi et des serveurs RADIUS (UDP et TCP, port 514), conserve tout le brut en segments compressés et immuables avec l\'empreinte enregistrée dans le Control Plane, et n\'envoie au registre des accès que les accès qu\'elle reconnaît. Ouvre un port en écoute. Requiert CENSO ACCESS.',
  'Syslog di apparati e Wi‑Fi: una sonda con la funzione «Syslog per CENSO ACCESS» riceve il syslog di switch, router, firewall, controller Wi‑Fi e server RADIUS, ne conserva tutto il grezzo (segmenti orari compressi, immutabili, con l’impronta registrata e riletta ogni giorno, per tutta la conservazione) e manda al registro solo gli accessi riconosciuti: amministrazione degli apparati, VPN, Wi‑Fi. Chi amministra un apparato compare fra i privilegi; il resto del grezzo si cerca da «Fonti», e ogni ricerca resta nel registro delle viste.':
    'Syslog des équipements et du Wi‑Fi : une sonde avec la fonction « Syslog pour CENSO ACCESS » reçoit le syslog des commutateurs, routeurs, pare-feu, contrôleurs Wi‑Fi et serveurs RADIUS, en conserve tout le brut (segments horaires compressés, immuables, avec l’empreinte enregistrée et relue chaque jour, pendant toute la conservation) et n’envoie au registre que les accès reconnus : administration des équipements, VPN, Wi‑Fi. Qui administre un équipement apparaît parmi les privilèges ; le reste du brut se cherche depuis « Sources », et chaque recherche reste dans le registre des consultations.',
  'Evento di prova affidato alla sonda: parte al prossimo contatto.':
    'Événement de test confié à la sonde : il part au prochain contact.',
  'Evento di prova inviato.':
    'Événement de test envoyé.',
  'Non inviato.':
    'Non envoyé.',
  'Inoltro a un SIEM':
    'Transfert vers un SIEM',
  'Il registro (e, se vuoi, i rilevamenti) va al SIEM del tenant, in ordine e senza buchi: un lotto si considera consegnato solo dopo l’invio, quindi un SIEM che non risponde non perde nulla. Parte dal Control Plane se il SIEM è raggiungibile da Internet, da una sonda se sta nella rete del cliente. Ciò che il registro non nomina (utenti non privilegiati spenti) non viene nominato nemmeno al SIEM.':
    'Le registre (et, si vous voulez, les détections) part vers le SIEM du tenant, dans l’ordre et sans trous : un lot ne compte comme livré qu’une fois envoyé, donc un SIEM qui ne répond pas ne perd rien. Il part du Control Plane si le SIEM est joignable depuis Internet, d’une sonde s’il est dans le réseau du client. Ce que le registre ne nomme pas (utilisateurs non privilégiés éteints) n’est pas nommé au SIEM non plus.',
  'Inoltra gli eventi al SIEM':
    'Transférer les événements au SIEM',
  'dal Control Plane':
    'depuis le Control Plane',
  'da una sonda':
    'depuis une sonde',
  'scegli la sonda':
    'choisir la sonde',
  'syslog su TCP':
    'syslog sur TCP',
  'syslog su TLS':
    'syslog sur TLS',
  'syslog su UDP':
    'syslog sur UDP',
  'Indirizzo del collettore':
    'Adresse du collecteur',
  'webhook JSON':
    'webhook JSON',
  'Intestazione del token':
    'En-tête du jeton',
  'Token (impostato: scrivi per cambiarlo)':
    'Jeton (défini : saisissez pour le changer)',
  'Indirizzo del SIEM':
    'Adresse du SIEM',
  'Cosa inoltrare':
    'Quoi transférer',
  'tutti gli eventi':
    'tous les événements',
  'solo i privilegiati':
    'privilégiés seulement',
  'privilegiati e falliti':
    'privilégiés et échecs',
  'anche i rilevamenti':
    'les détections aussi',
  'verifica il certificato':
    'vérifier le certificat',
  'Inviati {n} messaggi':
    '{n} messages envoyés',
  'ultimo invio {quando}':
    'dernier envoi {quando}',
  '{n} eventi da inviare':
    '{n} événements à envoyer',
  'Invia un evento di prova':
    'Envoyer un événement de test',
  'Inoltro a un SIEM: in Impostazioni si sceglie da dove (Control Plane o una sonda della rete), come (syslog su UDP, TCP o TLS, oppure HTTPS verso Splunk HEC o un webhook), in che formato (CEF o JSON) e cosa (tutto, solo i privilegiati, privilegiati e falliti, anche i rilevamenti). Gli eventi partono in ordine e un lotto conta come inviato solo dopo l’invio: un SIEM fermo non perde nulla, e «Invia un evento di prova» verifica la strada.':
    'Transfert vers un SIEM : dans Paramètres on choisit d’où (Control Plane ou une sonde du réseau), comment (syslog sur UDP, TCP ou TLS, ou HTTPS vers Splunk HEC ou un webhook), dans quel format (CEF ou JSON) et quoi (tout, privilégiés seulement, privilégiés et échecs, les détections aussi). Les événements partent dans l’ordre et un lot ne compte comme envoyé qu’une fois envoyé : un SIEM arrêté ne perd rien, et « Envoyer un événement de test » vérifie le chemin.',
  'Splunk HEC':
    'Splunk HEC',
  'siem.esempio.local':
    'siem.exemple.local',
  'Per la continuità si aggiungono una seconda copia e una terza per il disaster recovery, su sonde diverse e meglio in sedi diverse: ognuna tiene tutto il registro per conto suo, lo rilegge e ne risponde. Una sonda aggiunta dopo riceve tutto ciò che il registro conserva ancora.':
    'Pour la continuité, ajoutez une deuxième copie et une troisième pour la reprise après sinistre, sur des sondes différentes et de préférence sur des sites différents : chacune garde tout le registre de son côté, le relit et en répond. Une sonde ajoutée plus tard reçoit tout ce que le registre conserve encore.',
  'Seconda copia':
    'Deuxième copie',
  'Terza copia (disaster recovery)':
    'Troisième copie (reprise après sinistre)',
  'seconda copia':
    'deuxième copie',
  'disaster recovery':
    'reprise après sinistre',
  '{n} persi':
    '{n} perdus',
  'Rilevamenti con un ID: ogni rilevamento ha un numero progressivo (RIL-000123), lo stesso nell’elenco, nella sua scheda, nella mail e nel SIEM, per citarlo senza ambiguità.':
    'Détections avec un ID : chaque détection a un numéro progressif (RIL-000123), le même dans la liste, sur sa fiche, dans le courriel et dans le SIEM, pour la citer sans ambiguïté.',
  'Gli accessi arrivano al registro pochi secondi dopo essere avvenuti: l’agente li legge ogni cinque secondi e li manda subito, la sonda syslog li consegna ogni tre. L’ora registrata è quella dell’accesso, scritta dal sistema o dall’apparato; l’ora di arrivo resta a parte.':
    'Les accès arrivent au registre quelques secondes après avoir eu lieu : l’agent les lit toutes les cinq secondes et les envoie aussitôt, la sonde syslog les livre toutes les trois. L’heure enregistrée est celle de l’accès, écrite par le système ou l’équipement ; l’heure d’arrivée est gardée à part.',
  'Copia del syslog grezzo su altre sonde':
    'Copie du syslog brut sur d’autres sondes',
  'nessuna: il grezzo resta sulla sonda che lo riceve':
    'aucune : le brut reste sur la sonde qui le reçoit',
  'CENSO copia ogni segmento sulle sonde d’archivio (seconda copia, DR)':
    'CENSO copie chaque segment sur les sondes d’archive (deuxième copie, PRA)',
  'gli apparati mandano a più sonde; CENSO registra ogni messaggio una volta':
    'les équipements envoient à plusieurs sondes ; CENSO enregistre chaque message une fois',
  'La sonda che riceve manda ogni segmento chiuso (un’ora di grezzo, compresso) al Control Plane, che lo tiene solo finché le sonde d’archivio diverse da lei non l’hanno conservato e verificato. Traffico in più verso il Control Plane: il grezzo compresso di ogni ora, una volta.':
    'La sonde qui reçoit envoie chaque segment fermé (une heure de brut, compressée) au Control Plane, qui le garde seulement jusqu’à ce que les sondes d’archive autres qu’elle l’aient conservé et vérifié. Trafic en plus vers le Control Plane : le brut compressé de chaque heure, une fois.',
  'Si configurano gli apparati per mandare il syslog a due o tre sonde con la funzione «Syslog per CENSO ACCESS»: ognuna conserva il suo grezzo, e il registro prende ogni messaggio una volta sola, riconoscendolo dall’impronta del testo originale. Nessun traffico in più verso il Control Plane.':
    'On configure les équipements pour envoyer le syslog à deux ou trois sondes avec la fonction « Syslog pour CENSO ACCESS » : chacune conserve son brut, et le registre ne prend chaque message qu’une fois, en le reconnaissant à l’empreinte du texte d’origine. Aucun trafic en plus vers le Control Plane.',
  'Copie':
    'Copies',
  'Il syslog grezzo anche su altre sonde, a scelta: CENSO copia ogni segmento chiuso sulle sonde d’archivio (seconda copia, DR), che lo verificano e lo conservano immutabile; oppure gli apparati mandano il syslog a più sonde e il registro prende ogni messaggio una volta sola.':
    'Le syslog brut aussi sur d’autres sondes, au choix : CENSO copie chaque segment fermé sur les sondes d’archive (deuxième copie, PRA), qui le vérifient et le conservent immuable ; ou les équipements envoient leur syslog à plusieurs sondes et le registre ne prend chaque message qu’une fois.',
  'Nella mail di ogni rilevamento: Utente, IP sorgente e Sistema. L’IP sorgente c’è sempre: l’indirizzo di provenienza, il nome della postazione se la fonte non dà l’indirizzo, «accesso locale» per console, sudo e su, oppure «non indicato dalla fonte».':
    'Dans le mail de chaque détection : Utilisateur, IP source et Système. L’IP source est toujours présente : l’adresse d’origine, le nom du poste si la source ne donne pas d’adresse, « accès local » pour la console, sudo et su, ou « non indiquée par la source ».',
  'AWX / Automation Controller accanto alla CMDB: quali macchine non sono in AWX e nessun playbook toccherà, quali host di AWX CENSO non conosce, e l’inventario dinamico con cui AWX prende i suoi host da CENSO.':
    'AWX / Automation Controller à côté de la CMDB : quelles machines ne sont pas dans AWX et qu’aucun playbook ne touchera, quels hôtes d’AWX CENSO ne connaît pas, et l’inventaire dynamique par lequel AWX prend ses hôtes dans CENSO.',
  'Inventario dinamico':
    'Inventaire dynamique',
  'Nessun AWX collegato':
    'Aucun AWX connecté',
  'Aggiungi una connessione AWX (token, da una sonda o dal Control Plane) nella sezione Connessioni: il confronto legge gli host di AWX in tempo reale.':
    'Ajoutez une connexion AWX (jeton, depuis une sonde ou depuis le Control Plane) dans la section Connexions : la comparaison lit les hôtes d’AWX en temps réel.',
  'Gli host si abbinano per nome, nome breve o ansible_host. Classi e tag restringono la CMDB a ciò che AWX dovrebbe avere.':
    'Les hôtes sont associés par nom, nom court ou ansible_host. Classes et tags limitent la CMDB à ce qu’AWX devrait avoir.',
  'Host in CENSO':
    'Hôtes dans CENSO',
  'Abbinati':
    'Associés',
  'In CENSO, non in AWX':
    'Dans CENSO, pas dans AWX',
  'In AWX, sconosciuti a CENSO':
    'Dans AWX, inconnus de CENSO',
  'Inventario: {inv} · letto alle {ora}':
    'Inventaire : {inv} · lu à {ora}',
  'tutti gli host':
    'tous les hôtes',
  'Abbinati ({n})':
    'Associés ({n})',
  'Abilitato in AWX':
    'Activé dans AWX',
  'Crea una chiave API del tenant con «Ansible AWX» in lettura (Settings → Amministrazione → Chiavi API).':
    'Créez une clé API du tenant avec « Ansible AWX » en lecture (Settings → Administration → Clés API).',
  'Scarica lo script e mettilo nel progetto di AWX (Git).':
    'Téléchargez le script et placez-le dans le projet AWX (Git).',
  'In AWX, una sorgente d’inventario «Sourced from a Project» che punta allo script, con l’indirizzo di CENSO e la chiave nelle variabili d’ambiente.':
    'Dans AWX, une source d’inventaire « Sourced from a Project » qui pointe vers le script, avec l’adresse de CENSO et la clé dans les variables d’environnement.',
  'Variabili d’ambiente della sorgente in AWX':
    'Variables d’environnement de la source dans AWX',
  'una sezione a sé nel menu Integrazioni, con tre schede: Confronto, Inventario dinamico e Connessioni. AWX può prendere i suoi host dalla CMDB: una chiave API del tenant con «Ansible AWX» in lettura, lo script d’inventario scaricato da «Inventario dinamico» nel progetto di AWX (la scheda scrive anche le variabili d’ambiente della sorgente, con i filtri scelti), e una sorgente «da progetto» — gli host arrivano con l’indirizzo, le proprietà (classe, OS, modello, seriale, tag, business service) e i gruppi presi da ciò che CENSO sa: i tag diventano i gruppi dei playbook. Con una credenziale AWX (token, da una sonda o dal Control Plane) «Confronta» legge gli host di AWX e dice quali macchine della CMDB non ci sono — nessun playbook le toccherà — e quali host di AWX CENSO non conosce, oltre agli abbinati; classi e tag restringono il confronto a ciò che AWX dovrebbe avere.':
    'une section à part dans le menu Intégrations, avec trois onglets : Comparaison, Inventaire dynamique et Connexions. AWX peut prendre ses hôtes dans la CMDB : une clé API du tenant avec « Ansible AWX » en lecture, le script d’inventaire téléchargé depuis « Inventaire dynamique » dans le projet AWX (l’onglet écrit aussi les variables d’environnement de la source, avec les filtres choisis), et une source « depuis un projet » — les hôtes arrivent avec leur adresse, leurs propriétés (classe, OS, modèle, numéro de série, tags, business service) et des groupes tirés de ce que CENSO sait : les tags deviennent les groupes des playbooks. Avec une credential AWX (jeton, depuis une sonde ou depuis le Control Plane) « Comparer » lit les hôtes d’AWX et indique quelles machines de la CMDB manquent — aucun playbook ne les touchera — et quels hôtes d’AWX CENSO ne connaît pas, en plus des associés ; classes et tags limitent la comparaison à ce qu’AWX devrait avoir.',
  'Annullare i comandi in attesa per questo monitor? Andranno dati di nuovo.':
    'Annuler les commandes en attente pour cet écran ? Il faudra les redonner.',
  'Cancellare il record {tipo} «{nome}» dal DNS? La modifica va subito sul server DNS e non si può annullare.':
    'Supprimer l’enregistrement {tipo} « {nome} » du DNS ? La modification part tout de suite sur le serveur DNS et ne peut pas être annulée.',
  'Eliminare il gruppo di credenziali «{nome}»? Le credenziali restano; i job che usano il gruppo non lo troveranno più. Non si può annullare.':
    'Supprimer le groupe de credentials « {nome} » ? Les credentials restent ; les jobs qui utilisent le groupe ne le trouveront plus. Action irréversible.',
  'Eliminare la vista «{nome}»? Non si può annullare.':
    'Supprimer la vue « {nome} » ? Action irréversible.',
  'Eliminare l’utente {email} da questo tenant? Perde subito l’accesso. Non si può annullare.':
    'Supprimer l’utilisateur {email} de ce tenant ? Il perd l’accès immédiatement. Action irréversible.',
  'Eliminare questa applicazione e il suo SBOM? Non si può annullare.':
    'Supprimer cette application et son SBOM ? Action irréversible.',
  'Eliminare questa credenziale? Si toglie anche dai gruppi, e i job e le sorgenti che la usano smettono di funzionare. Il segreto non si recupera: andrà riscritto.':
    'Supprimer cette credential ? Elle est aussi retirée des groupes, et les jobs et sources qui l’utilisent cessent de fonctionner. Le secret ne se récupère pas : il faudra le saisir à nouveau.',
  'Eliminare questa mappatura del connettore? La sincronizzazione si ferma. Non si può annullare.':
    'Supprimer ce mappage du connecteur ? La synchronisation s’arrête. Action irréversible.',
  'Eliminare questa pianificazione? I job non partiranno più da soli. Non si può annullare.':
    'Supprimer cette planification ? Les jobs ne démarreront plus d’eux-mêmes. Action irréversible.',
  'Eliminare questa regola di classificazione? Non si può annullare.':
    'Supprimer cette règle de classification ? Action irréversible.',
  'Eliminare questo servizio IA dal catalogo? Non si può annullare.':
    'Supprimer ce service d’IA du catalogue ? Action irréversible.',
  'Eliminare questo SKU? Non si può annullare.':
    'Supprimer ce SKU ? Action irréversible.',
  'Revocare l’agente «{nome}»? Smette subito di consegnare: ciò che manderà verrà rifiutato finché non lo riattivi.':
    'Révoquer l’agent « {nome} » ? Il cesse immédiatement de livrer : ce qu’il enverra sera refusé jusqu’à sa réactivation.',
  'Revocare questo agente esca? Smette subito di comunicare con CENSO; per riaverlo va installato di nuovo con una configurazione nuova. Non si può annullare.':
    'Révoquer cet agent leurre ? Il cesse immédiatement de communiquer avec CENSO ; pour le récupérer il faut le réinstaller avec une nouvelle configuration. Action irréversible.',
  'Ruotare adesso la chiave di ripristino? La chiave di prima smette di funzionare appena l’agente la sostituisce. Non si può annullare.':
    'Faire tourner la clé de récupération maintenant ? L’ancienne clé cesse de fonctionner dès que l’agent la remplace. Action irréversible.',
  'Spegnere il monitoraggio di questo CI? Non si può annullare: i parametri andranno riaccesi.':
    'Désactiver la surveillance de ce CI ? Action irréversible : les paramètres devront être réactivés.',
  'Togliere {email} dal tenant «{tenant}»? Perde subito l’accesso a quel tenant.':
    'Retirer {email} du tenant « {tenant} » ? Il perd immédiatement l’accès à ce tenant.',
  'Togliere {n} utenti da questo tenant? Perdono subito l’accesso.':
    'Retirer {n} utilisateurs de ce tenant ? Ils perdent l’accès immédiatement.',
  'Togliere il cespite dalla copertura di questo contratto? Non si può annullare.':
    'Retirer l’actif de la couverture de ce contrat ? Action irréversible.',
  'Togliere il profilo di monitoraggio «{nome}»? Non si può annullare.':
    'Retirer le profil de surveillance « {nome} » ? Action irréversible.',
  'Togliere l’indirizzo dedicato {host} e i suoi alias? Il tenant torna sull’indirizzo della piattaforma.':
    'Retirer l’adresse dédiée {host} et ses alias ? Le tenant revient sur l’adresse de la plateforme.',
  'Togliere questa regola di posizione? Non si può annullare.':
    'Retirer cette règle d’emplacement ? Action irréversible.',
  'Togliere questa sorveglianza? Smette subito di avvisare. Non si può annullare.':
    'Retirer cette surveillance ? Elle cesse immédiatement d’alerter. Action irréversible.',
  'Togliere questo elemento dalla Business App? Non si può annullare.':
    'Retirer cet élément de la Business App ? Action irréversible.',
  'Togliere questo indirizzo dal CI? Non si può annullare: andrà aggiunto di nuovo.':
    'Retirer cette adresse du CI ? Action irréversible : il faudra l’ajouter à nouveau.',
  'Togliere questo nome dal CI? Non si può annullare: andrà aggiunto di nuovo.':
    'Retirer ce nom du CI ? Action irréversible : il faudra l’ajouter à nouveau.',
  'Togliere questo parametro dal monitoraggio del CI? Il suo storico non si legge più. Non si può annullare.':
    'Retirer ce paramètre de la surveillance du CI ? Son historique n’est plus lisible. Action irréversible.',
  'Ogni azione che non si può annullare chiede conferma prima di partire: revocare un agente o una sonda, eliminare utenti, credenziali, pianificazioni, regole o viste, togliere un record dal DNS, ruotare una chiave. Il messaggio dice cosa succede e se si potrà tornare indietro.':
    'Toute action irréversible demande une confirmation avant de partir : révoquer un agent ou une sonde, supprimer des utilisateurs, des credentials, des planifications, des règles ou des vues, retirer un enregistrement DNS, faire tourner une clé. Le message dit ce qui se passe et s’il sera possible de revenir en arrière.',
  'per esempio: account del servizio SQL Server, gestito dal team database':
    'par exemple : compte de service SQL Server, géré par l’équipe base de données',
  'Annulla le modifiche':
    'Annuler les modifications',
  'Modifiche non salvate.':
    'Modifications non enregistrées.',
  'Le modifiche a tipo, reperibilità e nota si salvano con «Salva»; la nota compare sotto il nome della persona.':
    'Les modifications du type, de l’astreinte et de la note s’enregistrent avec « Enregistrer » ; la note apparaît sous le nom de la personne.',
  'Applica alle selezionate':
    'Appliquer à la sélection',
  'La prende la prima sonda libera che sa farla: con più sedi può essere quella di un’altra rete. Scegli la sonda o il gruppo della sede.':
    'La première sonde libre capable de l’exécuter la prend : avec plusieurs sites, ce peut être celle d’un autre réseau. Choisissez la sonde ou le groupe du site.',
  'Ogni esecuzione la fa solo questa sonda; se non è disponibile il job aspetta. È anche la sonda che poi legge l’apparato nel monitoraggio, perché è quella che le sue ACL lasciano passare.':
    'Chaque exécution est faite uniquement par cette sonde ; si elle n’est pas disponible, le job attend. C’est aussi la sonde qui lit ensuite l’équipement dans la supervision, car c’est celle que ses ACL laissent passer.',
  'Ogni esecuzione la fa una sonda di questo gruppo.':
    'Chaque exécution est faite par une sonde de ce groupe.',
  'Questo CI si legge con una credenziale (SNMP, SSH, WinRM): i parametri li legge «{s}», la sonda del job di discovery che l’ha letto con quella credenziale, perché è quella che l’apparato lascia passare; le sonde scelte qui leggono ping e porte, e l’oggetto risulta giù solo se non risponde a nessuna. Per cambiarla, fai girare la discovery con credenziali dalla sonda giusta (in Pianificazioni, «Esegui su»).':
    'Ce CI est lu avec une credential (SNMP, SSH, WinRM) : ses paramètres sont lus par « {s} », la sonde du job de découverte qui l’a lu avec cette credential, car c’est celle que l’équipement laisse passer ; les sondes choisies ici lisent ping et ports, et l’objet n’est en panne que s’il ne répond à aucune. Pour la changer, lancez la découverte avec credentials depuis la bonne sonde (dans Planifications, « Exécuter sur »).',
  'Un oggetto letto con una credenziale (SNMP, SSH, WinRM) fa eccezione: i suoi parametri li legge sempre la sonda del job di discovery, quella che l’apparato lascia passare dalle sue ACL, qualunque sia l’ordine delle sonde scelte e il loro carico; le altre leggono ping e porte. La sezione lo dice: «principale: la sonda che legge con la credenziale».':
    'Un objet lu avec une credential (SNMP, SSH, WinRM) fait exception : ses paramètres sont toujours lus par la sonde du job de découverte, celle que les ACL de l’équipement laissent passer, quels que soient l’ordre des sondes choisies et leur charge ; les autres lisent ping et ports. La section l’indique : « principale : la sonde qui lit avec la credential ».',
  'lascia com’è':
    'laisser tel quel',
  'principale: la sonda che legge con la credenziale':
    'principale : la sonde qui lit avec la credential',
  'qualunque sonda idonea':
    'toute sonde éligible',
  'scelta attuale (non idonea per questo tipo)':
    'choix actuel (non éligible pour ce type)',
  '{n} pianificazioni aggiornate.':
    '{n} planifications mises à jour.',
  '{n} pianificazioni aggiornate; lasciate com’erano perché la sonda non sa eseguirle: {nomi}.':
    '{n} planifications mises à jour ; laissées telles quelles car la sonde ne sait pas les exécuter : {nomi}.',
  '{n} pianificazioni selezionate':
    '{n} planifications sélectionnées',
  '«Esegui su» sceglie la sonda o il gruppo di sonde che la esegue: con più sedi, quella della rete da scansionare. Selezionando più pianificazioni si cambia insieme, per tutte, la sonda o il gruppo e lo stato.':
    '« Exécuter sur » choisit la sonde ou le groupe de sondes qui l’exécute : avec plusieurs sites, celle du réseau à analyser. En sélectionnant plusieurs planifications, on change d’un coup pour toutes la sonde ou le groupe et l’état.',
  'È la sonda del job che ha letto l’apparato con la credenziale, non l’ultima che l’ha visto: un ping sweep da un’altra sede non la sposta.':
    'C’est la sonde du job qui a lu l’équipement avec la credential, pas la dernière qui l’a vu : un ping sweep depuis un autre site ne la déplace pas.',
  'Aggiorna l’agente: le versioni nuove ripiegano da sole su una query più semplice quando il domain controller rifiuta quella di sempre.':
    'Mettez à jour l’agent : les nouvelles versions se rabattent d’elles-mêmes sur une requête plus simple quand le contrôleur de domaine refuse celle habituelle.',
  'Installazione sostituita: un’altra fonte con lo stesso nome consegna, questa è ferma. Se l’agente è stato reinstallato, sospendila.':
    'Installation remplacée : une autre source du même nom livre, celle-ci est arrêtée. Si l’agent a été réinstallé, suspendez-la.',
  'Registro Security grande: con l’agente aggiornato gli eventi si consegnano in più giri, senza errore.':
    'Journal Security volumineux : avec l’agent mis à jour, les événements sont livrés en plusieurs passages, sans erreur.',
  'installazione sostituita':
    'installation remplacée',
  'non più presente':
    'plus présent',
  'In «Fonti» la colonna Agente dice la versione dell’agente di ogni fonte; una riga ferma accanto a un’altra con lo stesso nome che consegna è un’installazione sostituita (agente reinstallato) e si può sospendere. Su un domain controller con un registro Security grande gli eventi arrivano in più giri, senza errore; se il domain controller rifiuta la query, l’agente aggiornato ripiega da solo su una più semplice.':
    'Dans « Sources », la colonne Agent indique la version de l’agent de chaque source ; une ligne arrêtée à côté d’une autre du même nom qui livre est une installation remplacée (agent réinstallé) et peut être suspendue. Sur un contrôleur de domaine avec un gros journal Security, les événements arrivent en plusieurs passages, sans erreur ; si le contrôleur de domaine refuse la requête, l’agent mis à jour se rabat de lui-même sur une requête plus simple.',
  '180–365 giorni':
    '180–365 jours',
  '30–90 giorni':
    '30–90 jours',
  '90–180 giorni':
    '90–180 jours',
  'Chiedi al responsabile di ciascuna se serve ancora; senza risposta, disattivala.':
    'Demandez au responsable de chacun s’il sert encore ; sans réponse, désactivez-le.',
  'Chiedi il cambio password a queste utenze.':
    'Demandez à ces comptes de changer leur mot de passe.',
  'Come migliorare':
    'Comment améliorer',
  'Con MFA e password lunghe la scadenza può essere lunga, ma non assente: imposta un massimo nella politica del dominio.':
    'Avec MFA et des mots de passe longs, l’expiration peut être longue, mais pas absente : fixez un maximum dans la stratégie du domaine.',
  'Controlla che le password non compaiano in elenchi di credenziali trafugate (per esempio con la protezione password di Entra ID).':
    'Vérifiez que les mots de passe n’apparaissent pas dans des listes d’identifiants dérobés (par exemple avec la protection par mot de passe d’Entra ID).',
  'Da dove arrivano le utenze':
    'D’où viennent les comptes',
  'Disattiva subito, cancella dopo un periodo di attesa (per esempio 30 giorni): così un errore si recupera.':
    'Désactivez tout de suite, supprimez après une période d’attente (par exemple 30 jours) : ainsi une erreur se rattrape.',
  'Disattivala finché non serve; crea le utenze quando la persona arriva.':
    'Désactivez-le tant qu’il ne sert pas ; créez les comptes à l’arrivée de la personne.',
  'Disattivate ma privilegiate':
    'Désactivés mais privilégiés',
  'Dove proprio deve restare, password lunga (almeno 25 caratteri), accesso limitato ai sistemi che servono e nessun privilegio in più.':
    'Là où il doit vraiment rester : mot de passe long (au moins 25 caractères), accès limité aux systèmes nécessaires et aucun privilège en plus.',
  'Età della password delle utenze attive':
    'Âge du mot de passe des comptes actifs',
  'Gruppi privilegiati':
    'Groupes privilégiés',
  'Guarda gli accessi falliti dell’utenza e i Rilevamenti (forza bruta, password spray) prima di sbloccarla.':
    'Regardez les connexions échouées du compte et les Détections (force brute, password spray) avant de le déverrouiller.',
  'Imposta «cambio password al primo accesso» per le utenze nuove.':
    'Activez « changer le mot de passe à la première connexion » pour les nouveaux comptes.',
  'Inattiva da':
    'Inactif depuis',
  'Le utenze nei gruppi che amministrano il dominio o le macchine, anche attraverso un gruppo annidato: un problema qui pesa il doppio. Tienile poche, nominali, con MFA, e separate dalle utenze di tutti i giorni.':
    'Les comptes des groupes qui administrent le domaine ou les machines, y compris via un groupe imbriqué : un problème ici pèse double. Gardez-les peu nombreux, nominatifs, avec MFA, et séparés des comptes du quotidien.',
  'Leggo le utenze…':
    'Lecture des comptes…',
  'Letto alle {ora}.':
    'Lu à {ora}.',
  'Lo stato delle utenze lo mandano gli agenti aggiornati: il domain controller per il dominio, ogni macchina per i suoi amministratori locali, Entra ID per i ruoli.':
    'L’état des comptes est envoyé par les agents à jour : le contrôleur de domaine pour le domaine, chaque machine pour ses administrateurs locaux, Entra ID pour les rôles.',
  'Mai usate':
    'Jamais utilisés',
  'Metti la disattivazione nella procedura di uscita del personale e di fine contratto dei fornitori.':
    'Intégrez la désactivation dans la procédure de départ du personnel et de fin de contrat des fournisseurs.',
  'Nessun gruppo descritto. I gruppi delle utenze di dominio li manda l’agente del domain controller (aggiornato): per tutte le utenze con gli utenti non privilegiati accesi, altrimenti per le privilegiate.':
    'Aucun groupe décrit. Les groupes des comptes du domaine sont envoyés par l’agent (à jour) du contrôleur de domaine : pour tous les comptes avec les utilisateurs non privilégiés activés, sinon pour les privilégiés.',
  'Nessun problema: ottimo.':
    'Aucun problème : parfait.',
  'Nessuna utenza descritta dai sistemi.':
    'Aucun compte décrit par les systèmes.',
  'Nessuna utenza.':
    'Aucun compte.',
  'Nota: l’ultimo accesso è quello visto dal domain controller su cui gira l’agente, incrociato con il registro di CENSO.':
    'Remarque : la dernière connexion est celle vue par le contrôleur de domaine où tourne l’agent, croisée avec le registre de CENSO.',
  'Oltre {n} giorni senza accessi un’utenza attiva è uno zombie (soglia delle Impostazioni).':
    'Au-delà de {n} jours sans connexion, un compte actif est un zombie (seuil des Paramètres).',
  'Password vecchie':
    'Mots de passe anciens',
  'Per i servizi usa account di servizio gestiti (gMSA) invece di utenze personali lasciate attive.':
    'Pour les services, utilisez des comptes de service gérés (gMSA) plutôt que des comptes personnels laissés actifs.',
  'Per i servizi usa gMSA (password ruotata da Active Directory) o una rotazione programmata con un gestore di segreti.':
    'Pour les services, utilisez gMSA (mot de passe renouvelé par Active Directory) ou une rotation planifiée avec un gestionnaire de secrets.',
  'Per le persone togli «La password non scade mai» e lascia lavorare la politica delle password del dominio.':
    'Pour les personnes, retirez « Le mot de passe n’expire jamais » et laissez agir la stratégie de mots de passe du domaine.',
  'Perché conta':
    'Pourquoi c’est important',
  'Postura delle utenze':
    'Posture des comptes',
  'Privilegiate ({n})':
    'Privilégiés ({n})',
  'Privilegiate a rischio':
    'Privilégiés à risque',
  'Privilegiato':
    'Privilégié',
  'Problemi':
    'Problèmes',
  'Problemi trovati':
    'Problèmes trouvés',
  'Quando disattivi un’utenza, toglila anche dai gruppi privilegiati (Domain Admins, Administrators, gli Operators).':
    'Quand vous désactivez un compte, retirez-le aussi des groupes privilégiés (Domain Admins, Administrators, les Operators).',
  'Quanto sono in ordine le utenze: zombie, mai usate, password che non scadono o vecchie, privilegiate a rischio, e come migliorare.':
    'À quel point les comptes sont en ordre : zombies, jamais utilisés, mots de passe qui n’expirent pas ou anciens, privilégiés à risque, et comment améliorer.',
  'Rivedi i membri dei gruppi privilegiati almeno ogni trimestre: CENSO ACCESS li elenca in «Privilegi».':
    'Revoyez les membres des groupes privilégiés au moins chaque trimestre : CENSO ACCESS les liste dans « Privilèges ».',
  'Se è un account di servizio, documentalo come tale nella scheda della persona (Tipo: account di servizio).':
    'S’il s’agit d’un compte de service, documentez-le comme tel sur la fiche de la personne (Type : compte de service).',
  'Se è un servizio, aggiorna la password dove è salvata.':
    'S’il s’agit d’un service, mettez à jour le mot de passe là où il est enregistré.',
  'Stato delle utenze':
    'État des comptes',
  'Tutte le utenze':
    'Tous les comptes',
  'Tutte le utenze ({n})':
    'Tous les comptes ({n})',
  'Ultimo accesso delle utenze attive':
    'Dernière connexion des comptes actifs',
  'Una password che non scade resta valida per anni: se è stata vista, scritta o riusata altrove, vale ancora. È il primo bersaglio di chi ha rubato un elenco di credenziali.':
    'Un mot de passe qui n’expire pas reste valide des années : s’il a été vu, noté ou réutilisé ailleurs, il fonctionne toujours. C’est la première cible de quiconque a volé une liste d’identifiants.',
  'Una password invariata da oltre {n} giorni è probabilmente nota a più persone di quante dovrebbero, o riusata altrove.':
    'Un mot de passe inchangé depuis plus de {n} jours est probablement connu de plus de personnes qu’il ne faudrait, ou réutilisé ailleurs.',
  'Un’utenza attiva che nessuno usa da oltre {n} giorni è una porta lasciata aperta: se la sua password è debole, riusata o rubata, nessuno se ne accorge, perché nessuno si aspetta di vederla entrare. Sono spesso ex dipendenti, consulenti a fine incarico, account di prova.':
    'Un compte actif que personne n’utilise depuis plus de {n} jours est une porte laissée ouverte : si son mot de passe est faible, réutilisé ou volé, personne ne s’en aperçoit, car personne ne s’attend à le voir se connecter. Ce sont souvent d’anciens employés, des consultants en fin de mission, des comptes de test.',
  'Un’utenza attiva che non ha mai fatto un accesso è stata creata in anticipo o è rimasta da una prova: ha spesso la password iniziale, nota a chi l’ha creata.':
    'Un compte actif qui ne s’est jamais connecté a été créé à l’avance ou est resté d’un test : il a souvent le mot de passe initial, connu de qui l’a créé.',
  'Un’utenza bloccata ha superato i tentativi di password sbagliata: una password vecchia rimasta in un servizio o su un telefono, oppure qualcuno che prova a indovinarla.':
    'Un compte verrouillé a dépassé les tentatives de mot de passe erroné : un ancien mot de passe resté dans un service ou sur un téléphone, ou quelqu’un qui essaie de le deviner.',
  'Un’utenza disattivata ma ancora in un gruppo privilegiato torna amministratore nell’istante in cui qualcuno la riattiva, per errore o di proposito.':
    'Un compte désactivé mais encore dans un groupe privilégié redevient administrateur dès que quelqu’un le réactive, par erreur ou délibérément.',
  'Utenti non privilegiati spenti: qui ci sono solo le utenze privilegiate. Accendili nelle Impostazioni per avere tutte le utenze del dominio e trovare gli account zombie.':
    'Utilisateurs non privilégiés désactivés : seuls les comptes privilégiés sont ici. Activez-les dans les Paramètres pour avoir tous les comptes du domaine et trouver les comptes zombies.',
  'Utenze attive':
    'Comptes actifs',
  'Utenze con questo problema':
    'Comptes avec ce problème',
  'Utenze privilegiate':
    'Comptes privilégiés',
  'Utenze zombie':
    'Comptes zombies',
  'account locali':
    'comptes locaux',
  'attive con problemi':
    'actifs avec problèmes',
  'attive senza problemi':
    'actifs sans problème',
  'disattivate':
    'désactivés',
  'dominio (domain controller)':
    'domaine (contrôleur de domaine)',
  'meno di 30 giorni':
    'moins de 30 jours',
  'meno di 90 giorni':
    'moins de 90 jours',
  'non nota':
    'inconnue',
  'oltre un anno':
    'plus d’un an',
  'su {n} privilegiate attive':
    'sur {n} privilégiés actifs',
  'su {n} · {d} disattivate':
    'sur {n} · {d} désactivés',
  'tramite un altro gruppo':
    'via un autre groupe',
  'utenze':
    'comptes',
  'utenze attive senza problemi, le privilegiate contano doppio':
    'comptes actifs sans problème, les privilégiés comptent double',
  '{n} utenze':
    '{n} comptes',
  '{n} utenze attive hanno una password che non scade.':
    '{n} comptes actifs ont un mot de passe qui n’expire pas.',
  'Postura delle utenze: un punteggio (le utenze attive senza problemi, le privilegiate contano doppio), i grafici di stato, ultimo accesso ed età della password, e una scheda per ogni problema — utenze zombie (attive ma senza accessi oltre la soglia delle Impostazioni), mai usate, password che non scade, password vecchie, disattivate ma ancora in un gruppo privilegiato, bloccate — con perché conta, come migliorare e l’elenco delle utenze da sistemare. Con gli utenti non privilegiati accesi l’agente del domain controller manda ogni ora tutte le utenze del dominio con i loro gruppi, altrimenti solo le privilegiate.':
    'Posture des comptes : un score (les comptes actifs sans problème, les privilégiés comptent double), les graphiques d’état, de dernière connexion et d’âge du mot de passe, et un onglet par problème — comptes zombies (actifs mais sans connexion au-delà du seuil des Paramètres), jamais utilisés, mot de passe qui n’expire pas, mots de passe anciens, désactivés mais encore dans un groupe privilégié, verrouillés — avec pourquoi c’est important, comment améliorer et la liste des comptes à corriger. Avec les utilisateurs non privilégiés activés, l’agent du contrôleur de domaine envoie chaque heure tous les comptes du domaine avec leurs groupes, sinon seulement les privilégiés.',
  'Nella scheda di una persona la sezione Gruppi elenca i gruppi delle sue utenze, diretti o tramite un altro gruppo, con quelli privilegiati in evidenza.':
    'Sur la fiche d’une personne, la section Groupes liste les groupes de ses comptes, directs ou via un autre groupe, avec les privilégiés mis en évidence.',
  'Non compreso nella licenza':
    'Non inclus dans la licence',
  'non compreso nella licenza':
    'non inclus dans la licence',
  '{sistema} — non compreso nella licenza':
    '{sistema} — non inclus dans la licence',
  'Pacchetti nei container ({n})':
    'Paquets dans les conteneurs ({n})',
  'Pacchetti vulnerabili dentro le immagini dei container che girano su questa macchina: il gestore dei pacchetti della macchina non li tocca. Si correggono ricostruendo l’immagine da una base aggiornata e ridistribuendo i container.':
    'Paquets vulnérables dans les images des conteneurs qui tournent sur cette machine : le gestionnaire de paquets de la machine ne les touche pas. On les corrige en reconstruisant l’image à partir d’une base à jour et en redéployant les conteneurs.',
  'nel container':
    'dans le conteneur',
  'corretto in {v}':
    'corrigé en {v}',
  'Nella scheda di una macchina i «Pacchetti nei container» sono a parte: vulnerabilità vere, ma dentro le immagini dei container che ci girano; il gestore dei pacchetti della macchina non le tocca, si correggono ricostruendo l’immagine. Non sono fra le patch di sistema né nei job.':
    'Sur la fiche d’une machine, les « Paquets dans les conteneurs » sont à part : de vraies vulnérabilités, mais dans les images des conteneurs qui y tournent ; le gestionnaire de paquets de la machine ne les touche pas, on les corrige en reconstruisant l’image. Ils ne font pas partie des correctifs système ni des jobs.',
  'Automazione':
    'Automatisation',
  'Credenziali e sonda':
    'Credentials et sonde',
  'EDR/XDR':
    'EDR/XDR',
  'IPAM':
    'IPAM',
  'SIEM':
    'SIEM',
  'la prima idonea':
    'la première éligible',
  'sorgenti':
    'sources',
}
